function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
            return;
        }
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6pwND", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>(parcelRequire("77FPb")).default);
    var $77FPb;
});
parcelRegister("77FPb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a41f1d4e1ad9317c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $gEFwt;
    var $39xOx;
    var $ew1Lk;
    var $koVbs;
    var $dAfqg;
    var $g5X3G;
    var $giP9y;
    var $caivO;
    var $9dbF6;
    var $d31Su;
    var $9NiTW;
    var $3RV1W;
    var $9OXo1;
    var $doZTA;
    var $2O3HP;
    var $fGFTb;
    var $8Gk6V;
    const $a41f1d4e1ad9317c$var$DeploymentFrequencyReportSpa = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const projectKey = match.params.projectKey ?? '';
        const boardId = match.params.boardId ?? '';
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const onViewDeploymentFrequencyReportExperienceFail = (0, (0, parcelRequire("caivO")).useViewDeploymentFrequencyReportExperienceFail)();
        const hasSoftwareLicense = (0, (0, parcelRequire("3RV1W")).checkLicense)(tenantContext, 'software');
        const reportsUrl = projectContext?.simplified ? `${tenantContext.baseUrl}/jira/software/projects/${projectKey}/boards/${boardId}/reports` : `${tenantContext.baseUrl}/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caivO")).ViewDeploymentFrequencyReportExperienceStart), {
            experienceId: projectKey
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, hasSoftwareLicense ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "pageContent",
            packageName: "jiraSpaAppsSoftwareReportsDeploymentFrequencyReport",
            teamName: "fusion-solaris",
            extraEventData: {
                isSimplifiedProject: projectContext?.simplified ?? false
            },
            onError: (location, error)=>{
                onViewDeploymentFrequencyReportExperienceFail(location, error, {
                    isNetworkError: (0, (0, parcelRequire("8Gk6V")).isNetworkError)(error)
                });
            },
            attributes: (error)=>({
                    isNetworkError: (0, (0, parcelRequire("8Gk6V")).isNetworkError)(error),
                    isSimplifiedProject: projectContext?.simplified ?? false
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "software"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
            baseUrl: tenantContext.baseUrl,
            projectKey: projectKey,
            projectName: projectContext?.projectName ?? ''
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                text: formatMessage((0, (0, parcelRequire("2O3HP")).default).reports),
                href: reportsUrl
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fGFTb")).PreconditionCheck), {
            projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(projectKey)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("2O3HP")).default).browserTitle)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("giP9y")).default), null)))))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d31Su")).AsyncNoSoftwareLicense), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caivO")).ViewDeploymentFrequencyReportExpectedErrorExperienceSuccessTracker), {
            reason: "No Jira Software license"
        }))));
    };
    var $a41f1d4e1ad9317c$export$2e2bcd8739ae039 = $a41f1d4e1ad9317c$var$DeploymentFrequencyReportSpa;
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("giP9y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e21cee832c458e31$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jZs4b;
    var $auW2i;
    var $ilLj2;
    var $l7in8;
    var $6UHF0;
    const $e21cee832c458e31$var$DeploymentFrequencyReport = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZs4b")).RelayMigrationProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ilLj2")).ProjectIdProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("auW2i")).DeploymentProviderServiceQueryResultProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l7in8")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6UHF0")).default), null)))));
    var $e21cee832c458e31$export$2e2bcd8739ae039 = $e21cee832c458e31$var$DeploymentFrequencyReport;
});
parcelRegister("jZs4b", function(module, exports) {
    $parcel$export(module.exports, "RelayMigrationProvider", ()=>$93ac221a9aae18c4$export$234eaa9a198021f7);
    $parcel$export(module.exports, "useQuery", ()=>$93ac221a9aae18c4$export$dd0a697e1782aedd);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $8Uumt = parcelRequire("8Uumt");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $bGCOz;
    var $eWq1m;
    var $cXWJp;
    var $i4e0f;
    const $93ac221a9aae18c4$var$QueryRenderer = ({ id: id })=>{
        const [queryConfig] = (0, (0, parcelRequire("cXWJp")).useGetQueryById)(id);
        if (queryConfig === undefined) throw new Error(`Query config not found for id=${id}`);
        const { skip: skip } = queryConfig;
        if (skip) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i4e0f")).Suspense), {
            id: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGCOz")).ErrorBoundary), {
            id: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eWq1m")).Query), {
            id: id
        })));
    };
    const $93ac221a9aae18c4$var$Queries = ()=>{
        const [queries] = (0, (0, parcelRequire("cXWJp")).useGetQueries)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, queries.map(({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement($93ac221a9aae18c4$var$QueryRenderer, {
                key: id,
                id: id
            })));
    };
    const $93ac221a9aae18c4$var$RelayMigrationContext = (0, $5uXOq.createContext)();
    const $93ac221a9aae18c4$export$234eaa9a198021f7 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cXWJp")).QueriesContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($93ac221a9aae18c4$var$RelayMigrationContext.Provider, {
            value: true
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($93ac221a9aae18c4$var$Queries, null)));
    const $93ac221a9aae18c4$export$dd0a697e1782aedd = (query, options = {})=>{
        const { skip: skip = false, variables: variables = {}, fetchPolicy: fetchPolicy } = options;
        const isProviderInitialized = (0, $5uXOq.useContext)($93ac221a9aae18c4$var$RelayMigrationContext);
        if (isProviderInitialized !== true) throw new Error(`Look like you forgot to wrap package root component with 

            import { RelayMigrationProvider } from '@atlassian/jira-relay-apollo-migration-utils';

            <RelayMigrationProvider>
                <MyApp>
            </RelayMigrationProvider>`);
        const env = (0, $8Uumt.useRelayEnvironment)();
        const id = (0, $5uXOq.useRef)(`query-key-${(0, ($parcel$interopDefault($7Jxgt)))()}`).current;
        const [queryConfig, { registerOrUpdateQuery: registerOrUpdateQuery, removeQuery: removeQuery, forceCacheRecheck: forceCacheRecheck }] = (0, (0, parcelRequire("cXWJp")).useGetQueryById)(id);
        const prevProps = (0, $5uXOq.useRef)();
        const refetch = (0, $5uXOq.useCallback)((newVariables)=>{
            const vars = newVariables || variables;
            const promise = (0, $8Uumt.fetchQuery)(env, query, vars, {
                fetchPolicy: 'network-only'
            }).toPromise();
            forceCacheRecheck({
                query: query,
                variables: vars
            });
            return promise;
        }, [
            env,
            query,
            variables,
            forceCacheRecheck
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if ((0, ($parcel$interopDefault($ajpes)))(prevProps.current, {
                skip: skip,
                query: query,
                variables: variables,
                fetchPolicy: fetchPolicy
            })) return;
            prevProps.current = {
                skip: skip,
                query: query,
                variables: variables,
                fetchPolicy: fetchPolicy
            };
            registerOrUpdateQuery({
                id: id,
                query: query,
                variables: variables,
                fetchPolicy: fetchPolicy,
                skip: skip
            });
        }, [
            id,
            registerOrUpdateQuery,
            removeQuery,
            skip,
            query,
            variables,
            fetchPolicy
        ]);
        (0, $5uXOq.useEffect)(()=>()=>removeQuery(id), [
            removeQuery,
            id
        ]);
        const result = queryConfig ? {
            ...queryConfig.result,
            refetch: refetch
        } : {
            loading: true,
            data: null,
            error: undefined,
            refetch: ()=>Promise.resolve()
        };
        return result;
    };
});
parcelRegister("bGCOz", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$ddcb6cd87ff4cf07$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $cXWJp;
    class $ddcb6cd87ff4cf07$var$RelayMigrationUtilsErrorBoundary extends (0, $5uXOq.Component) {
        componentDidUpdate(prevProps) {
            const { variables: variables, fetchKey: fetchKey } = this.props;
            const { variables: prevVariables, fetchKey: prevFetchKey } = prevProps;
            if (!(0, ($parcel$interopDefault($ajpes)))(variables, prevVariables) || fetchKey !== prevFetchKey) this.setState({
                error: undefined
            });
        }
        componentDidCatch(error) {
            this.setState({
                error: error
            });
            this.props.onError(error);
        }
        render() {
            const { error: error } = this.state;
            if (error) return null;
            return this.props.children;
        }
        constructor(...args){
            super(...args);
            this.state = {
                error: undefined
            };
        }
    }
    const $ddcb6cd87ff4cf07$export$e926676385687eaf = ({ id: id, children: children })=>{
        const [queryConfig, { setQueryError: setQueryError }] = (0, (0, parcelRequire("cXWJp")).useGetQueryById)(id);
        if (!queryConfig) throw new Error(`Query config not found for id=${id}`);
        const { variables: variables, fetchKey: fetchKey } = queryConfig;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ddcb6cd87ff4cf07$var$RelayMigrationUtilsErrorBoundary, {
            variables: variables,
            fetchKey: fetchKey,
            onError: (error)=>setQueryError(id, error)
        }, children);
    };
});
parcelRegister("cXWJp", function(module, exports) {
    $parcel$export(module.exports, "useGetQueries", ()=>$ad1c5b05d6b542cb$export$d6811137951eda62);
    $parcel$export(module.exports, "useGetQueryById", ()=>$ad1c5b05d6b542cb$export$6d96567132090f48);
    $parcel$export(module.exports, "QueriesContainer", ()=>$ad1c5b05d6b542cb$export$ecb4f76d577c3dc5);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $dDxBh;
    const $ad1c5b05d6b542cb$var$storeId = 'RELAY_APOLLO_MIGRATION_STORE';
    const $ad1c5b05d6b542cb$var$initialState = {
        queries: []
    };
    const $ad1c5b05d6b542cb$var$QueriesStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $ad1c5b05d6b542cb$var$storeId,
        initialState: $ad1c5b05d6b542cb$var$initialState,
        actions: (0, parcelRequire("dDxBh")).actions
    });
    const $ad1c5b05d6b542cb$export$d6811137951eda62 = (0, (0, parcelRequire("3sQ5x")).createHook)($ad1c5b05d6b542cb$var$QueriesStore, {
        selector: (state)=>state.queries
    });
    const $ad1c5b05d6b542cb$export$6d96567132090f48 = (0, (0, parcelRequire("3sQ5x")).createHook)($ad1c5b05d6b542cb$var$QueriesStore, {
        selector: (state, id)=>state.queries.find((q)=>q.id === id)
    });
    const $ad1c5b05d6b542cb$export$ecb4f76d577c3dc5 = (0, (0, parcelRequire("gg7kZ")).createContainer)($ad1c5b05d6b542cb$var$QueriesStore);
});
parcelRegister("dDxBh", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$8d50d363b184069d$export$e324594224ef24da);
    var $ajpes = parcelRequire("ajpes");
    var $7Jxgt = parcelRequire("7Jxgt");
    const $8d50d363b184069d$export$4c8508db433a86f5 = (config)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const existingQueryConfig = state.queries.find((q)=>q.id === config.id);
            if (existingQueryConfig) setState({
                queries: state.queries.map((q)=>{
                    if (q.id === config.id) return {
                        ...q,
                        ...config
                    };
                    return q;
                })
            });
            else setState({
                queries: state.queries.concat({
                    ...config,
                    fetchKey: config.id,
                    result: {
                        data: null,
                        error: undefined,
                        loading: true
                    }
                })
            });
        };
    const $8d50d363b184069d$export$f58ce67e5a1edf5 = (id, data)=>({ getState: getState, setState: setState })=>{
            const { queries: queries } = getState();
            setState({
                queries: queries.map((item)=>item.id === id ? {
                        ...item,
                        result: {
                            loading: false,
                            error: undefined,
                            data: data
                        }
                    } : item)
            });
        };
    const $8d50d363b184069d$export$636198fd10e804fd = (id)=>({ getState: getState, setState: setState })=>{
            const { queries: queries } = getState();
            setState({
                queries: queries.map((item)=>item.id === id ? {
                        ...item,
                        result: {
                            loading: true,
                            error: undefined,
                            data: null
                        }
                    } : item)
            });
        };
    const $8d50d363b184069d$export$71ca895ec712e8ca = (id, error)=>({ getState: getState, setState: setState })=>{
            const { queries: queries } = getState();
            setState({
                queries: queries.map((item)=>item.id === id ? {
                        ...item,
                        result: {
                            loading: false,
                            error: error,
                            data: null
                        }
                    } : item)
            });
        };
    const $8d50d363b184069d$export$d9584b9a625da95f = (id)=>({ getState: getState, setState: setState })=>{
            const { queries: queries } = getState();
            setState({
                queries: queries.filter((item)=>item.id !== id)
            });
        };
    const $8d50d363b184069d$var$updateQuery = (id, props)=>({ getState: getState, setState: setState })=>{
            const { queries: queries } = getState();
            setState({
                queries: queries.map((item)=>item.id === id ? {
                        ...item,
                        ...props
                    } : item)
            });
        };
    const $8d50d363b184069d$var$forceCacheRecheck = ({ query: query, variables: variables })=>({ getState: getState, setState: setState })=>{
            const { queries: queries } = getState();
            setState({
                queries: queries.map((item)=>item.query === query && (0, ($parcel$interopDefault($ajpes)))(item.variables, variables) ? {
                        ...item,
                        fetchKey: `query-key-${(0, ($parcel$interopDefault($7Jxgt)))()}`
                    } : item)
            });
        };
    const $8d50d363b184069d$export$e324594224ef24da = {
        registerOrUpdateQuery: $8d50d363b184069d$export$4c8508db433a86f5,
        setQueryData: $8d50d363b184069d$export$f58ce67e5a1edf5,
        setQueryLoading: $8d50d363b184069d$export$636198fd10e804fd,
        setQueryError: $8d50d363b184069d$export$71ca895ec712e8ca,
        removeQuery: $8d50d363b184069d$export$d9584b9a625da95f,
        updateQuery: $8d50d363b184069d$var$updateQuery,
        forceCacheRecheck: $8d50d363b184069d$var$forceCacheRecheck
    };
});
parcelRegister("eWq1m", function(module, exports) {
    $parcel$export(module.exports, "Query", ()=>$0336126d6c7b21af$export$62297b13309008b2);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $cXWJp;
    const $0336126d6c7b21af$export$62297b13309008b2 = ({ id: id })=>{
        const [queryConfig, { setQueryData: setQueryData }] = (0, (0, parcelRequire("cXWJp")).useGetQueryById)(id);
        if (queryConfig === undefined) throw new Error(`Query config not found for id=${id}`);
        const { query: query, variables: variables, fetchKey: fetchKey, fetchPolicy: fetchPolicy } = queryConfig;
        const data = (0, $8Uumt.useLazyLoadQuery)(query, variables, {
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy
        });
        (0, $5uXOq.useEffect)(()=>{
            setQueryData(id, data);
        }, [
            id,
            data,
            setQueryData
        ]);
        return null;
    };
});
parcelRegister("i4e0f", function(module, exports) {
    $parcel$export(module.exports, "Suspense", ()=>$b12830c4bd104661$export$74bf444e3cd11ea5);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $cXWJp;
    const $b12830c4bd104661$var$PlaceholderFallback = ({ id: id })=>{
        const [, { setQueryLoading: setQueryLoading }] = (0, (0, parcelRequire("cXWJp")).useGetQueryById)(id);
        (0, $5uXOq.useEffect)(()=>{
            setQueryLoading(id);
        }, [
            id,
            setQueryLoading
        ]);
        return null;
    };
    const $b12830c4bd104661$export$74bf444e3cd11ea5 = ({ id: id, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "query-renderer",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($b12830c4bd104661$var$PlaceholderFallback, {
                id: id
            })
        }, children);
});
parcelRegister("auW2i", function(module, exports) {
    $parcel$export(module.exports, "DeploymentProviderServiceQueryResultProvider", ()=>$3212eaa12d9cc8e3$export$9bd326d4dbb7068d);
    $parcel$export(module.exports, "useDeploymentProviders", ()=>$3212eaa12d9cc8e3$export$29125d17c01d4dd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $fMtXj;
    const $3212eaa12d9cc8e3$var$DeploymentProviderContext = (0, $5uXOq.createContext)(null);
    const $3212eaa12d9cc8e3$export$9bd326d4dbb7068d = ({ children: children })=>{
        const deploymentProvidersResult = (0, (0, parcelRequire("fMtXj")).useDeploymentProviders)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3212eaa12d9cc8e3$var$DeploymentProviderContext.Provider, {
            value: deploymentProvidersResult
        }, children);
    };
    const $3212eaa12d9cc8e3$export$29125d17c01d4dd4 = ()=>{
        const result = (0, $5uXOq.useContext)($3212eaa12d9cc8e3$var$DeploymentProviderContext);
        if (result === null) throw new Error('Missing DeploymentProviderContext');
        return result;
    };
});
parcelRegister("fMtXj", function(module, exports) {
    $parcel$export(module.exports, "useDeploymentProviders", ()=>$6ce04b9aa6eb61a7$export$29125d17c01d4dd4);
    $parcel$export(module.exports, "DeploymentProvidersInfoProvider", ()=>$6ce04b9aa6eb61a7$export$a516226a9640cf25);
    $parcel$export(module.exports, "useDeploymentProvidersInfoContext", ()=>$6ce04b9aa6eb61a7$export$6251344ce2dc3a61);
    $parcel$export(module.exports, "useVCSProviders", ()=>$6ce04b9aa6eb61a7$export$29eeae32fa3976ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $ld2hZ;
    var $7f4tk;
    var $fPB66;
    const $6ce04b9aa6eb61a7$export$67c00945e310134c = ()=>{
        const baseUrl = '';
        const request = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("7f4tk")).default)(`${baseUrl}/rest/dev-status/1.0/provider/capabilities`), [
            baseUrl
        ]);
        const { loading: loading, error: error, data: data, fetch: fetch } = (0, (0, parcelRequire("ld2hZ")).useService)(request);
        (0, $5uXOq.useEffect)(()=>{
            fetch();
        }, [
            fetch
        ]);
        return {
            loading: loading,
            error: error,
            data: data,
            fetch: fetch
        };
    };
    const $6ce04b9aa6eb61a7$var$useMemoByProviderId = (value)=>{
        const ref = (0, $5uXOq.useRef)(value);
        if (ref.current.length !== value.length || !ref.current.every((x, i)=>x.providerId === value[i].providerId)) ref.current = value;
        return ref.current;
    };
    const $6ce04b9aa6eb61a7$export$20e408ba77735d66 = (devOpsProviders)=>{
        const isBitbucketConnectedToJira = devOpsProviders.some((0, (0, parcelRequire("fPB66")).isBitbucketSCMProvider));
        const isBitbucketPipelineFound = devOpsProviders.some((0, (0, parcelRequire("fPB66")).isBitbucketPipelineProvider));
        if (!isBitbucketConnectedToJira && isBitbucketPipelineFound) return devOpsProviders.filter((x)=>!(0, (0, parcelRequire("fPB66")).isBitbucketProvider)(x));
        return devOpsProviders;
    };
    const $6ce04b9aa6eb61a7$var$useMemoizedDeploymentProviders = (devOpsProviderResult)=>{
        const data = devOpsProviderResult.data ? $6ce04b9aa6eb61a7$export$20e408ba77735d66(devOpsProviderResult.data).filter((x)=>x.capabilities.includes('DEPLOYMENT')) : [];
        return $6ce04b9aa6eb61a7$var$useMemoByProviderId(data);
    };
    const $6ce04b9aa6eb61a7$export$29125d17c01d4dd4 = ()=>{
        const devOpsProviderResult = $6ce04b9aa6eb61a7$export$67c00945e310134c();
        const memoizedProviders = $6ce04b9aa6eb61a7$var$useMemoizedDeploymentProviders(devOpsProviderResult);
        return devOpsProviderResult.data ? {
            ...devOpsProviderResult,
            data: memoizedProviders
        } : devOpsProviderResult;
    };
    const $6ce04b9aa6eb61a7$export$f96e97389b7d3d58 = ()=>{
        const devOpsProviderResult = $6ce04b9aa6eb61a7$export$67c00945e310134c();
        const memoizedProviders = $6ce04b9aa6eb61a7$var$useMemoizedDeploymentProviders(devOpsProviderResult);
        return devOpsProviderResult.data ? {
            ...devOpsProviderResult,
            data: {
                deploymentProviders: memoizedProviders,
                isBitbucketDvcsConnectedToJira: devOpsProviderResult.data.some((0, (0, parcelRequire("fPB66")).isBitbucketSCMProvider))
            }
        } : {
            ...devOpsProviderResult,
            data: undefined
        };
    };
    const $6ce04b9aa6eb61a7$export$77e6c6311405f4e8 = (0, $5uXOq.createContext)();
    const $6ce04b9aa6eb61a7$export$a516226a9640cf25 = ({ children: children })=>{
        const deploymentProvidersState = $6ce04b9aa6eb61a7$export$f96e97389b7d3d58();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6ce04b9aa6eb61a7$export$77e6c6311405f4e8.Provider, {
            value: deploymentProvidersState
        }, children);
    };
    const $6ce04b9aa6eb61a7$export$6251344ce2dc3a61 = ()=>{
        const result = (0, $5uXOq.useContext)($6ce04b9aa6eb61a7$export$77e6c6311405f4e8);
        if (result === undefined) throw new Error('Missing service provider');
        return result;
    };
    const $6ce04b9aa6eb61a7$export$29eeae32fa3976ef = ()=>{
        const devOpsProviderResult = $6ce04b9aa6eb61a7$export$67c00945e310134c();
        const data = devOpsProviderResult.data ? devOpsProviderResult.data.filter((x)=>x.capabilities.includes('COMMIT')) : [];
        const memoizedData = $6ce04b9aa6eb61a7$var$useMemoByProviderId(data);
        return devOpsProviderResult.data ? {
            ...devOpsProviderResult,
            data: memoizedData
        } : devOpsProviderResult;
    };
});
parcelRegister("ld2hZ", function(module, exports) {
    $parcel$export(module.exports, "useService", ()=>$b3ad55f76ff82cb6$export$6de4685a6c88b4e9);
    $parcel$export(module.exports, "useLoadingStatusService", ()=>$b3ad55f76ff82cb6$export$c963713a27525aaf);
    var $5uXOq = parcelRequire("5uXOq");
    const $b3ad55f76ff82cb6$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
        const [state, setState] = (0, $5uXOq.useState)({
            loading: false,
            data: undefined,
            error: undefined,
            ...initialState
        });
        const fetch = (0, $5uXOq.useCallback)(async (requestData)=>{
            setState({
                loading: true,
                error: undefined,
                data: undefined
            });
            try {
                const data = await request(requestData);
                setState({
                    loading: false,
                    error: undefined,
                    data: data
                });
                return data;
            } catch (error) {
                setState({
                    loading: false,
                    error: error,
                    data: undefined
                });
                return undefined;
            }
        }, [
            request
        ]);
        return {
            ...state,
            fetch: fetch
        };
    };
    const $b3ad55f76ff82cb6$export$c963713a27525aaf = (request, initialState = {})=>{
        const [loadingStatus, setLoadingStatus] = (0, $5uXOq.useState)('idle');
        const { data: data, loading: loading, error: error, fetch: fetch } = $b3ad55f76ff82cb6$export$6de4685a6c88b4e9(request, initialState);
        (0, $5uXOq.useEffect)(()=>{
            if (loading) setLoadingStatus('started');
            else if (error) setLoadingStatus('error');
            else if (data) setLoadingStatus('success');
        }, [
            data,
            loading,
            error
        ]);
        return {
            data: data,
            loadingStatus: loadingStatus,
            error: error,
            fetch: fetch
        };
    };
});
parcelRegister("fPB66", function(module, exports) {
    $parcel$export(module.exports, "isBitbucketPipelineProvider", ()=>$9d57478229acd603$export$e945008be2be190e);
    $parcel$export(module.exports, "isBitbucketSCMProvider", ()=>$9d57478229acd603$export$43d8b667cc725f05);
    $parcel$export(module.exports, "isBitbucketProvider", ()=>$9d57478229acd603$export$1f508885be28c4e);
    $parcel$export(module.exports, "hideUGCProviderName", ()=>$9d57478229acd603$export$6159c89b7d198212);
    const $9d57478229acd603$export$e945008be2be190e = (provider)=>provider.providerId === (0, $40fb154f860edb01$export$832d1d859726f915) || provider.providerId === (0, $40fb154f860edb01$export$5007979ef33118fc);
    const $9d57478229acd603$export$43d8b667cc725f05 = (provider)=>provider.providerId === (0, $40fb154f860edb01$export$d7f081d6dd0e72fc);
    const $9d57478229acd603$export$4deeacd9e5868b0b = (provider)=>{
        if (provider.iconUrl !== undefined && provider.iconUrl !== '' && provider.iconUrl.toLowerCase().includes('jenkins')) return true;
        if (provider.name.toLowerCase().includes('jenkins')) return true;
        return false;
    };
    const $9d57478229acd603$export$1f508885be28c4e = (provider)=>$9d57478229acd603$export$43d8b667cc725f05(provider) || $9d57478229acd603$export$e945008be2be190e(provider);
    const $9d57478229acd603$export$b77d18aa396395e0 = (provider)=>provider.providerNamespace === 'oauth';
    const $9d57478229acd603$export$6159c89b7d198212 = (providers)=>providers.map((provider)=>$9d57478229acd603$export$b77d18aa396395e0(provider) ? {
                ...provider,
                name: 'UGC provider name hidden'
            } : provider);
});
const $40fb154f860edb01$export$d7f081d6dd0e72fc = 'bitbucket';
const $40fb154f860edb01$export$6c3cd1b276cbaf84 = 'Bitbucket';
const $40fb154f860edb01$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $40fb154f860edb01$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';
const $40fb154f860edb01$export$bcf99e811ad95bcc = 'Bitbucket Pipelines';
const $40fb154f860edb01$export$e6fc9659354ecbb5 = 'jenkins';
const $40fb154f860edb01$export$4510fd9cc92926bb = 'Jenkins';
parcelRegister("ilLj2", function(module, exports) {
    $parcel$export(module.exports, "ProjectIdProvider", ()=>$f5450870e2107699$export$681f6276e993f4e8);
    $parcel$export(module.exports, "useProjectId", ()=>$f5450870e2107699$export$16d1475ed6c26568);
    $parcel$export(module.exports, "useProjectSimplified", ()=>$f5450870e2107699$export$9f0c70b531288073);
    $parcel$export(module.exports, "useProjectAnalyticsAttributes", ()=>$f5450870e2107699$export$b6a91b2d78273787);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAfqg;
    var $g5X3G;
    var $bmKPg;
    const $f5450870e2107699$export$f87be37f8e8be65 = ()=>{
        const [projectKey] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        if (projectKey == null) throw new Error('Project key missing');
        return (0, (0, parcelRequire("g5X3G")).toProjectKey)(projectKey);
    };
    const $f5450870e2107699$var$ProjectIdContext = (0, $5uXOq.createContext)(null);
    const $f5450870e2107699$export$681f6276e993f4e8 = ({ children: children })=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const projectId = data === null ? null : (0, (0, parcelRequire("g5X3G")).toProjectId)(`${data.projectId}`);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f5450870e2107699$var$ProjectIdContext.Provider, {
            value: projectId
        }, projectId === null ? null : children);
    };
    const $f5450870e2107699$export$16d1475ed6c26568 = ()=>{
        const projectId = (0, $5uXOq.useContext)($f5450870e2107699$var$ProjectIdContext);
        if (projectId === null) throw new Error('Project ID provider missing');
        return projectId;
    };
    const $f5450870e2107699$export$4d975d76445a6650 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        if (data === null) return null;
        const { isProjectAdmin: isProjectAdmin } = data;
        return isProjectAdmin === undefined ? null : isProjectAdmin;
    };
    const $f5450870e2107699$export$9f0c70b531288073 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        return data === null ? null : data.simplified;
    };
    const $f5450870e2107699$export$b6a91b2d78273787 = ()=>{
        const projectId = $f5450870e2107699$export$16d1475ed6c26568();
        const isProjectAdmin = $f5450870e2107699$export$4d975d76445a6650();
        const isProjectSimplified = $f5450870e2107699$export$9f0c70b531288073();
        if (projectId === null || isProjectAdmin === null || isProjectSimplified === null) return null;
        return {
            isSimplified: isProjectSimplified,
            isProjectAdmin: isProjectAdmin,
            projectId: projectId
        };
    };
});
parcelRegister("l7in8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dbde8377ad119f06$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $8zOmE;
    var $2NMNM;
    var $3Ws3s;
    var $claG0;
    var $ilLj2;
    const $dbde8377ad119f06$var$DeploymentFrequencyDataAnalytics = ()=>{
        const { data: data, loading: loading } = (0, (0, parcelRequire("3Ws3s")).useReportCoreData)();
        const hasFiredRef = (0, $5uXOq.useRef)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (hasFiredRef.current) return;
            if (!loading && data) {
                const attributes = {
                    hasSufficientData: !(0, (0, parcelRequire("claG0")).isDataAbsolutelyEmpty)(data),
                    hasDeploymentProvider: data.hasDeploymentProvider
                };
                (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics)(createAnalyticsEvent({}), attributes);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'report viewed', 'deploymentFrequency', attributes);
                hasFiredRef.current = true;
            }
        }, [
            createAnalyticsEvent,
            data,
            loading
        ]);
        return null;
    };
    const $dbde8377ad119f06$var$DeploymentFrequencyDataAnalyticsWrapper = ({ children: children })=>{
        const projectInfo = (0, (0, parcelRequire("ilLj2")).useProjectAnalyticsAttributes)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "deploymentFrequencyReportPage",
            attributes: {
                ...projectInfo
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($dbde8377ad119f06$var$DeploymentFrequencyDataAnalytics, null), children);
    };
    var $dbde8377ad119f06$export$2e2bcd8739ae039 = $dbde8377ad119f06$var$DeploymentFrequencyDataAnalyticsWrapper;
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("3Ws3s", function(module, exports) {
    $parcel$export(module.exports, "useReportCoreData", ()=>$9b970ddda9736e13$export$446065eeb0323d4c);
    var $26qIQ;
    var $jZs4b;
    var $koeKL;
    var $kBSee;
    var $auW2i;
    var $ilLj2;
    var $claG0;
    const $9b970ddda9736e13$export$446065eeb0323d4c = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectId = (0, (0, parcelRequire("ilLj2")).useProjectId)();
        const deploymentProvidersResult = (0, (0, parcelRequire("auW2i")).useDeploymentProviders)();
        const variables = (0, (0, parcelRequire("claG0")).buildQueryVariables)(cloudId, projectId, (0, (0, parcelRequire("kBSee")).calculateDateRangeFor12Weeks)((0, (0, parcelRequire("kBSee")).getCurrentDate)()));
        const queryResult = (0, (0, parcelRequire("jZs4b")).useQuery)((0, (0, parcelRequire("26qIQ")).default), {
            variables: {
                ...variables
            },
            errorPolicy: 'all'
        });
        return (0, (0, parcelRequire("claG0")).mergeResult)((0, (0, parcelRequire("claG0")).transformResult)(queryResult), deploymentProvidersResult);
    };
});
parcelRegister("26qIQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa8d5cd38990dbab$export$2e2bcd8739ae039);
    const $fa8d5cd38990dbab$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deploymentFrequencyRollupType"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deploymentSizeRollupType"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v3 = {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }, v4 = {
            "kind": "Variable",
            "name": "rollupType",
            "variableName": "deploymentFrequencyRollupType"
        }, v5 = {
            "kind": "ScalarField",
            "name": "dateTime"
        }, v6 = {
            "concreteType": "DevOpsMetricsDeploymentFrequencyData",
            "kind": "LinkedField",
            "name": "data",
            "plural": true,
            "selections": [
                v5,
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        }, v7 = [
            v6
        ], v8 = {
            "alias": "deploymentFrequencyDev",
            "args": [
                {
                    "kind": "Literal",
                    "name": "environmentCategory",
                    "value": "DEVELOPMENT"
                },
                v3,
                v4
            ],
            "concreteType": "DevOpsMetricsDeploymentFrequency",
            "kind": "LinkedField",
            "name": "deploymentFrequency",
            "plural": false,
            "selections": v7
        }, v9 = {
            "alias": "deploymentFrequencyTesting",
            "args": [
                {
                    "kind": "Literal",
                    "name": "environmentCategory",
                    "value": "TESTING"
                },
                v3,
                v4
            ],
            "concreteType": "DevOpsMetricsDeploymentFrequency",
            "kind": "LinkedField",
            "name": "deploymentFrequency",
            "plural": false,
            "selections": v7
        }, v10 = {
            "alias": "deploymentFrequencyStg",
            "args": [
                {
                    "kind": "Literal",
                    "name": "environmentCategory",
                    "value": "STAGING"
                },
                v3,
                v4
            ],
            "concreteType": "DevOpsMetricsDeploymentFrequency",
            "kind": "LinkedField",
            "name": "deploymentFrequency",
            "plural": false,
            "selections": v7
        }, v11 = {
            "kind": "Literal",
            "name": "environmentCategory",
            "value": "PRODUCTION"
        }, v12 = {
            "kind": "ScalarField",
            "name": "aggregateData"
        }, v13 = {
            "alias": "deploymentFrequencyProd",
            "args": [
                v11,
                v3,
                v4
            ],
            "concreteType": "DevOpsMetricsDeploymentFrequency",
            "kind": "LinkedField",
            "name": "deploymentFrequency",
            "plural": false,
            "selections": [
                v6,
                v12
            ]
        }, v14 = {
            "alias": "deploymentFrequencyUnmapped",
            "args": [
                {
                    "kind": "Literal",
                    "name": "environmentCategory",
                    "value": "UNMAPPED"
                },
                v3,
                v4
            ],
            "concreteType": "DevOpsMetricsDeploymentFrequency",
            "kind": "LinkedField",
            "name": "deploymentFrequency",
            "plural": false,
            "selections": v7
        }, v15 = {
            "alias": "deploymentSizeProd",
            "args": [
                v11,
                v3,
                {
                    "kind": "Variable",
                    "name": "rollupType",
                    "variableName": "deploymentSizeRollupType"
                }
            ],
            "concreteType": "DevOpsMetricsDeploymentSize",
            "kind": "LinkedField",
            "name": "deploymentSize",
            "plural": false,
            "selections": [
                {
                    "concreteType": "DevOpsMetricsDeploymentSizeData",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                        v5,
                        {
                            "kind": "ScalarField",
                            "name": "deploymentSize"
                        }
                    ]
                },
                v12
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "deploymentFrequencyCoreRelayQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOpsMetrics",
                            "kind": "LinkedField",
                            "name": "devOpsMetrics",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v8,
                                    "action": "THROW",
                                    "path": "devOpsMetrics.deploymentFrequencyDev"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v9,
                                    "action": "THROW",
                                    "path": "devOpsMetrics.deploymentFrequencyTesting"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v10,
                                    "action": "THROW",
                                    "path": "devOpsMetrics.deploymentFrequencyStg"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v13,
                                    "action": "THROW",
                                    "path": "devOpsMetrics.deploymentFrequencyProd"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v14,
                                    "action": "THROW",
                                    "path": "devOpsMetrics.deploymentFrequencyUnmapped"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v15,
                                    "action": "THROW",
                                    "path": "devOpsMetrics.deploymentSizeProd"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "devOpsMetrics"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v0,
                    v1
                ],
                "kind": "Operation",
                "name": "deploymentFrequencyCoreRelayQuery",
                "selections": [
                    {
                        "concreteType": "DevOpsMetrics",
                        "kind": "LinkedField",
                        "name": "devOpsMetrics",
                        "plural": false,
                        "selections": [
                            v8,
                            v9,
                            v10,
                            v13,
                            v14,
                            v15
                        ]
                    }
                ]
            },
            "params": {
                "id": "4d022230a6ccb1bba619a35fbd2eaf7a54075e73cab018187129e8a9f21a7060",
                "metadata": {},
                "name": "deploymentFrequencyCoreRelayQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $fa8d5cd38990dbab$var$node.hash = "420efc85afb618301c4c9a412536d149";
    var $fa8d5cd38990dbab$export$2e2bcd8739ae039 = $fa8d5cd38990dbab$var$node;
});
parcelRegister("kBSee", function(module, exports) {
    $parcel$export(module.exports, "getCurrentDate", ()=>$2dda53ea2598d8a8$export$adaf307e533580e2);
    $parcel$export(module.exports, "calculateDateRangeFor12Weeks", ()=>$2dda53ea2598d8a8$export$319acc87c1d29925);
    $parcel$export(module.exports, "getWeekRangeFromWeekStartDate", ()=>$2dda53ea2598d8a8$export$9838cd554c042ac9);
    var $16v6W;
    var $it1wb;
    var $1GF3c;
    var $4PxOH;
    const $2dda53ea2598d8a8$export$c8fd889aef2b0b63 = (dateRange1, dateRange2)=>dateRange1.startDateInclusive.getTime() === dateRange2.startDateInclusive.getTime() && dateRange1.endDateExclusive.getTime() === dateRange2.endDateExclusive.getTime();
    const $2dda53ea2598d8a8$export$9be2719b3e491366 = (obj)=>({
            startDateInclusive: obj.startDateInclusive,
            endDateExclusive: obj.endDateExclusive
        });
    const $2dda53ea2598d8a8$export$adaf307e533580e2 = ()=>new Date();
    const $2dda53ea2598d8a8$export$319acc87c1d29925 = (date)=>{
        const thisWeekStart = (0, (0, parcelRequire("it1wb")).default)((0, (0, parcelRequire("1GF3c")).default)(date, {
            weekStartsOn: 1
        }));
        const elevenWeeksAgo = (0, (0, parcelRequire("it1wb")).default)((0, (0, parcelRequire("4PxOH")).default)(thisWeekStart, 11));
        return {
            startDateInclusive: elevenWeeksAgo,
            endDateExclusive: (0, (0, parcelRequire("16v6W")).default)(elevenWeeksAgo, 12)
        };
    };
    const $2dda53ea2598d8a8$export$9838cd554c042ac9 = (weekStartDate)=>({
            startDateInclusive: weekStartDate,
            endDateExclusive: (0, (0, parcelRequire("16v6W")).default)(weekStartDate, 1)
        });
});
parcelRegister("claG0", function(module, exports) {
    $parcel$export(module.exports, "isProdDataEmpty", ()=>$fa671eb55a55e204$export$266eb13541cd3eab);
    $parcel$export(module.exports, "isDevelopmentDataEmpty", ()=>$fa671eb55a55e204$export$b88cee3a59d3a9c9);
    $parcel$export(module.exports, "isTestingDataEmpty", ()=>$fa671eb55a55e204$export$58fe9f6a33beae3d);
    $parcel$export(module.exports, "isStagingDataEmpty", ()=>$fa671eb55a55e204$export$fa52222c4dc654e5);
    $parcel$export(module.exports, "isUnmappedDataEmpty", ()=>$fa671eb55a55e204$export$e62c68dd54f311bc);
    $parcel$export(module.exports, "isDataAbsolutelyEmpty", ()=>$fa671eb55a55e204$export$c5f9ba67a5398ea);
    $parcel$export(module.exports, "isDataAllUnmapped", ()=>$fa671eb55a55e204$export$5b3a91170be2499e);
    $parcel$export(module.exports, "isDataUnmappedFoundWithMissingPreProdButWithProd", ()=>$fa671eb55a55e204$export$87ccc9f0ac24397f);
    $parcel$export(module.exports, "isDataUnmappedFoundWithMissingProd", ()=>$fa671eb55a55e204$export$e4bdaf3ee11b5671);
    $parcel$export(module.exports, "getProdDataState", ()=>$fa671eb55a55e204$export$24ea9186e4611e22);
    $parcel$export(module.exports, "buildQueryVariables", ()=>$fa671eb55a55e204$export$9a3cee82e7cc08ff);
    $parcel$export(module.exports, "transformResult", ()=>$fa671eb55a55e204$export$f13b29f9ed0c5a03);
    $parcel$export(module.exports, "mergeResult", ()=>$fa671eb55a55e204$export$5fc0e802d3b9fa36);
    var $iASWI = parcelRequire("iASWI");
    var $gamDR = parcelRequire("gamDR");
    var $ecd0S;
    var $hEs3t;
    var $hfmv8;
    const $fa671eb55a55e204$export$266eb13541cd3eab = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.prod === 0);
    const $fa671eb55a55e204$export$b88cee3a59d3a9c9 = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.development === 0);
    const $fa671eb55a55e204$export$58fe9f6a33beae3d = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.testing === 0);
    const $fa671eb55a55e204$export$fa52222c4dc654e5 = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.staging === 0);
    const $fa671eb55a55e204$export$e62c68dd54f311bc = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.unmapped === 0);
    const $fa671eb55a55e204$export$c5f9ba67a5398ea = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.development === 0 && weekData.deploymentCount.testing === 0 && weekData.deploymentCount.staging === 0 && weekData.deploymentCount.prod === 0 && weekData.deploymentCount.unmapped === 0 && weekData.medianIssuesPerDeployment.prod === null);
    const $fa671eb55a55e204$export$48ed69e2270961d9 = (data)=>data.weeksData.filter((weekData)=>weekData.deploymentCount.prod > 0).length <= 3;
    const $fa671eb55a55e204$export$5b3a91170be2499e = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.development === 0 && weekData.deploymentCount.testing === 0 && weekData.deploymentCount.staging === 0 && weekData.deploymentCount.prod === 0 && weekData.medianIssuesPerDeployment.prod === 0) && data.weeksData.some((weekData)=>weekData.deploymentCount.unmapped > 0);
    const $fa671eb55a55e204$export$87ccc9f0ac24397f = (data)=>data.weeksData.some((weekData)=>weekData.deploymentCount.unmapped > 0) && ($fa671eb55a55e204$export$b88cee3a59d3a9c9(data) || $fa671eb55a55e204$export$58fe9f6a33beae3d(data) || $fa671eb55a55e204$export$fa52222c4dc654e5(data)) && !$fa671eb55a55e204$export$266eb13541cd3eab(data);
    const $fa671eb55a55e204$export$e4bdaf3ee11b5671 = (data)=>data.weeksData.some((weekData)=>weekData.deploymentCount.unmapped > 0) && $fa671eb55a55e204$export$266eb13541cd3eab(data);
    const $fa671eb55a55e204$export$24ea9186e4611e22 = (data)=>{
        if ($fa671eb55a55e204$export$c5f9ba67a5398ea(data)) return 'COMPLETELY_EMPTY';
        if ($fa671eb55a55e204$export$266eb13541cd3eab(data)) return 'NO_PROD_BUT_OTHER_ENV';
        if ($fa671eb55a55e204$export$48ed69e2270961d9(data)) return 'INSUFFICIENT_FOR_TREND';
        return 'SUFFICIENT_FOR_TREND';
    };
    const $fa671eb55a55e204$export$9a3cee82e7cc08ff = (cloudId, projectId, dateRange)=>{
        const { startDateInclusive: startDateInclusive, endDateExclusive: endDateExclusive } = dateRange;
        return {
            filter: {
                cloudId: cloudId,
                startFromInclusive: startDateInclusive.toISOString(),
                endAtExclusive: endDateExclusive.toISOString(),
                timezoneId: (0, (0, parcelRequire("hfmv8")).getUserTimezone)(),
                resolution: {
                    unit: 'WEEK',
                    value: 1
                },
                jiraProjectIds: [
                    projectId
                ]
            },
            deploymentFrequencyRollupType: {
                type: 'MEAN'
            },
            deploymentSizeRollupType: {
                type: 'PERCENTILE',
                percentile: 50
            }
        };
    };
    const $fa671eb55a55e204$var$getQueryErrorMessageIfExist = (error)=>error ? ` QueryErrorMessage: ${error.message}` : '';
    const $fa671eb55a55e204$var$getValidatedData = (queryResult)=>{
        const deploymentFrequencyDevData = queryResult.data?.devOpsMetrics?.deploymentFrequencyDev?.data;
        const deploymentFrequencyTestingData = queryResult.data?.devOpsMetrics?.deploymentFrequencyTesting?.data;
        const deploymentFrequencyStgData = queryResult.data?.devOpsMetrics?.deploymentFrequencyStg?.data;
        const deploymentFrequencyProdData = queryResult.data?.devOpsMetrics?.deploymentFrequencyProd?.data;
        const deploymentFrequencyProdAverage = queryResult.data?.devOpsMetrics?.deploymentFrequencyProd?.aggregateData;
        const deploymentFrequencyUnmappedData = queryResult.data?.devOpsMetrics?.deploymentFrequencyUnmapped?.data;
        const deploymentSizeProdData = queryResult.data?.devOpsMetrics?.deploymentSizeProd?.data;
        const deploymentSizeProdMedian = queryResult.data?.devOpsMetrics?.deploymentSizeProd?.aggregateData;
        const { error: apolloError } = queryResult;
        const apolloErrorMessage = $fa671eb55a55e204$var$getQueryErrorMessageIfExist(apolloError);
        if (deploymentFrequencyDevData == null || deploymentFrequencyTestingData == null || deploymentFrequencyStgData == null || deploymentFrequencyProdData == null || deploymentFrequencyProdAverage == null || deploymentFrequencyUnmappedData == null || deploymentSizeProdData == null || deploymentSizeProdMedian === undefined) throw Error(`Deployment frequency report: queryResult has missing fields. ${apolloErrorMessage}. Stringified queryResult: ${JSON.stringify({
            deploymentFrequencyDevData: deploymentFrequencyDevData,
            deploymentFrequencyTestingData: deploymentFrequencyTestingData,
            deploymentFrequencyStgData: deploymentFrequencyStgData,
            deploymentFrequencyProdData: deploymentFrequencyProdData,
            deploymentFrequencyProdAverage: deploymentFrequencyProdAverage,
            deploymentFrequencyUnmappedData: deploymentFrequencyUnmappedData,
            deploymentSizeProdData: deploymentSizeProdData,
            deploymentSizeProdMedian: deploymentSizeProdMedian
        })}`);
        return {
            data: (0, ($parcel$interopDefault($iASWI)))((0, (0, parcelRequire("ecd0S")).WEEKS_IN_REPORT)).map((i)=>{
                if (deploymentFrequencyDevData?.[i]?.count == null || deploymentFrequencyDevData?.[i]?.dateTime == null || deploymentFrequencyTestingData?.[i]?.count == null || deploymentFrequencyTestingData?.[i]?.dateTime == null || deploymentFrequencyStgData?.[i]?.count == null || deploymentFrequencyStgData?.[i]?.dateTime == null || deploymentFrequencyProdData?.[i]?.count == null || deploymentFrequencyProdData?.[i]?.dateTime == null || deploymentFrequencyUnmappedData?.[i]?.count == null || deploymentFrequencyUnmappedData?.[i]?.dateTime == null || deploymentSizeProdData?.[i]?.deploymentSize === undefined || deploymentSizeProdData?.[i]?.dateTime == null) throw new Error(`Deployment frequency report: some data is missing. ${apolloErrorMessage}. Stringified data: ${JSON.stringify({
                    frequencyDevData: deploymentFrequencyDevData[i],
                    frequencyTestingData: deploymentFrequencyTestingData[i],
                    frequencyStgData: deploymentFrequencyStgData[i],
                    frequencyProdData: deploymentFrequencyProdData[i],
                    frequencyUnmappedData: deploymentFrequencyUnmappedData[i],
                    sizeProdData: deploymentSizeProdData[i]
                })}`);
                return {
                    frequencyDevData: {
                        count: deploymentFrequencyDevData?.[i]?.count,
                        dateTime: deploymentFrequencyDevData?.[i]?.dateTime
                    },
                    frequencyTestingData: {
                        count: deploymentFrequencyTestingData?.[i]?.count,
                        dateTime: deploymentFrequencyTestingData?.[i]?.dateTime
                    },
                    frequencyStgData: {
                        count: deploymentFrequencyStgData?.[i]?.count,
                        dateTime: deploymentFrequencyStgData?.[i]?.dateTime
                    },
                    frequencyProdData: {
                        count: deploymentFrequencyProdData?.[i]?.count,
                        dateTime: deploymentFrequencyProdData?.[i]?.dateTime
                    },
                    frequencyUnmappedData: {
                        count: deploymentFrequencyUnmappedData?.[i]?.count,
                        dateTime: deploymentFrequencyUnmappedData?.[i]?.dateTime
                    },
                    sizeProdData: {
                        deploymentSize: deploymentSizeProdData?.[i]?.deploymentSize,
                        dateTime: deploymentSizeProdData?.[i]?.dateTime
                    }
                };
            }),
            frequencyProdAverage: deploymentFrequencyProdAverage,
            sizeProdMedian: deploymentSizeProdMedian
        };
    };
    const $fa671eb55a55e204$export$f13b29f9ed0c5a03 = (queryResult)=>{
        const resultBase = {
            loading: queryResult.loading,
            error: queryResult.error,
            fetch: queryResult.refetch
        };
        if (queryResult.loading) return resultBase;
        try {
            const { data: data, frequencyProdAverage: frequencyProdAverage, sizeProdMedian: sizeProdMedian } = $fa671eb55a55e204$var$getValidatedData(queryResult);
            return {
                ...resultBase,
                data: {
                    averageDeploymentCount: (0, ($parcel$interopDefault($gamDR)))(frequencyProdAverage, 1),
                    medianIssuesPerDeployment: sizeProdMedian === null ? null : (0, ($parcel$interopDefault($gamDR)))(sizeProdMedian, 1),
                    weeksData: data.map(({ frequencyDevData: frequencyDevData, frequencyTestingData: frequencyTestingData, frequencyStgData: frequencyStgData, frequencyProdData: frequencyProdData, frequencyUnmappedData: frequencyUnmappedData, sizeProdData: sizeProdData })=>({
                            startDateInclusive: new Date(frequencyDevData.dateTime),
                            deploymentCount: {
                                development: frequencyDevData.count,
                                testing: frequencyTestingData.count,
                                staging: frequencyStgData.count,
                                prod: frequencyProdData.count,
                                unmapped: frequencyUnmappedData.count
                            },
                            medianIssuesPerDeployment: {
                                prod: sizeProdData.deploymentSize
                            }
                        }))
                }
            };
        } catch (error) {
            return {
                ...resultBase,
                error: (0, (0, parcelRequire("hEs3t")).getMaybeCombinedError)([
                    queryResult.error,
                    error
                ])
            };
        }
    };
    const $fa671eb55a55e204$export$5fc0e802d3b9fa36 = ({ data: reportData, loading: reportLoading, error: reportError, fetch: reportFetch }, { data: providerData, loading: providerLoading, error: providerError, fetch: providerFetch })=>{
        const loading = reportLoading || providerLoading;
        const error = (0, (0, parcelRequire("hEs3t")).getMaybeCombinedError)([
            reportError,
            providerError
        ]);
        const fetch = async ()=>{
            if (reportError && reportData == null) reportFetch();
            if (providerError && providerData == null) providerFetch();
        };
        const data = providerData && reportData ? {
            ...reportData,
            hasDeploymentProvider: providerData.length > 0
        } : undefined;
        return {
            loading: loading,
            error: error,
            data: data,
            fetch: fetch
        };
    };
});
parcelRegister("iASWI", function(module, exports) {
    var $irTmi = parcelRequire("irTmi");
    var $d89635f071f7433a$var$range = $irTmi();
    module.exports = $d89635f071f7433a$var$range;
});
parcelRegister("irTmi", function(module, exports) {
    var $7DMj9 = parcelRequire("7DMj9");
    var $4rDUz = parcelRequire("4rDUz");
    var $kJ0Lf = parcelRequire("kJ0Lf");
    function $d6e5b0af0cc26ead$var$createRange(fromRight) {
        return function(start, end, step) {
            if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
            start = $kJ0Lf(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = $kJ0Lf(end);
            step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
            return $7DMj9(start, end, step, fromRight);
        };
    }
    module.exports = $d6e5b0af0cc26ead$var$createRange;
});
parcelRegister("7DMj9", function(module, exports) {
    var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
    function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
        var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
        while(length--){
            result[fromRight ? length : ++index] = start;
            start += step;
        }
        return result;
    }
    module.exports = $5901a5dd7694a169$var$baseRange;
});
parcelRegister("gamDR", function(module, exports) {
    var $aza9E = parcelRequire("aza9E");
    var $bc4f24b4027c5e7d$var$round = $aza9E('round');
    module.exports = $bc4f24b4027c5e7d$var$round;
});
parcelRegister("aza9E", function(module, exports) {
    var $1V15E = parcelRequire("1V15E");
    var $kPZpS = parcelRequire("kPZpS");
    var $1sXeC = parcelRequire("1sXeC");
    var $jJVtR = parcelRequire("jJVtR");
    var $7b150cc928607d87$var$nativeIsFinite = $1V15E.isFinite, $7b150cc928607d87$var$nativeMin = Math.min;
    function $7b150cc928607d87$var$createRound(methodName) {
        var func = Math[methodName];
        return function(number, precision) {
            number = $1sXeC(number);
            precision = precision == null ? 0 : $7b150cc928607d87$var$nativeMin($kPZpS(precision), 292);
            if (precision && $7b150cc928607d87$var$nativeIsFinite(number)) {
                var pair = ($jJVtR(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                pair = ($jJVtR(value) + 'e').split('e');
                return +(pair[0] + 'e' + (+pair[1] - precision));
            }
            return func(number);
        };
    }
    module.exports = $7b150cc928607d87$var$createRound;
});
parcelRegister("ecd0S", function(module, exports) {
    $parcel$export(module.exports, "WEEKS_IN_REPORT", ()=>$baa9a527b86d4579$export$93be8d2f61c0fe4b);
    $parcel$export(module.exports, "DEPLOYMENT_FREQUENCY_LEARN_MORE_COMPANY_MANAGED", ()=>$baa9a527b86d4579$export$3ae97b4999104334);
    $parcel$export(module.exports, "DEPLOYMENT_FREQUENCY_LEARN_MORE_TEAM_MANAGED", ()=>$baa9a527b86d4579$export$2784a2e49249b82e);
    $parcel$export(module.exports, "IN_PRODUCT_HELP_ARTICLE_ID", ()=>$baa9a527b86d4579$export$7b8e0bca5a218b);
    var $gwIPs;
    const $baa9a527b86d4579$export$93be8d2f61c0fe4b = 12;
    const $baa9a527b86d4579$export$3ae97b4999104334 = 'https://support.atlassian.com/jira-software-cloud/docs/plan-effectively-with-your-deployment-frequency-report';
    const $baa9a527b86d4579$export$2784a2e49249b82e = 'https://support.atlassian.com/jira-software-cloud/docs/view-and-understand-your-deployment-frequency-report';
    const $baa9a527b86d4579$export$7b8e0bca5a218b = '6DubDW8hmIQv9hwhu2cMQU';
    const $baa9a527b86d4579$export$1c17101eae0d04af = (0, (0, parcelRequire("gwIPs")).gridSize) * 28;
    const $baa9a527b86d4579$export$26c4fbba49422cc3 = (0, (0, parcelRequire("gwIPs")).gridSize) * 5;
    const $baa9a527b86d4579$export$41ffe6e6fada2471 = (0, (0, parcelRequire("gwIPs")).gridSize) * 4;
});
parcelRegister("hEs3t", function(module, exports) {
    $parcel$export(module.exports, "getMaybeCombinedError", ()=>$6fe769d4d58dfef3$export$b0ef34dfd385a8a7);
    const $6fe769d4d58dfef3$export$b0ef34dfd385a8a7 = (errors)=>{
        let firstErrorDetected = false;
        const combinedErrorMessages = errors.reduce((acc, maybeError)=>{
            if (maybeError == null) return acc;
            const accumulatedMessage = `${acc}${firstErrorDetected ? ', ' : ''}Error: ${maybeError.message}`;
            firstErrorDetected = true;
            return accumulatedMessage;
        }, '');
        if (!firstErrorDetected) return undefined;
        return new Error(combinedErrorMessages);
    };
});
parcelRegister("hfmv8", function(module, exports) {
    $parcel$export(module.exports, "getUserTimezone", ()=>$e720a860c461686c$export$96bb40b6f4974acf);
    const $e720a860c461686c$var$USER_TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone !== 'Etc/Unknown' ? Intl.DateTimeFormat().resolvedOptions().timeZone : null;
    const $e720a860c461686c$export$96bb40b6f4974acf = ()=>$e720a860c461686c$var$USER_TIME_ZONE;
});
parcelRegister("6UHF0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0241365af9a98913$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $j1sSt;
    var $3Ws3s;
    var $iY22e;
    var $gxsp4;
    var $6vgP1;
    var $lVXtL;
    var $ufiFS;
    var $awynr;
    var $1kopK;
    var $3MLtm;
    var $2e0gq;
    const $0241365af9a98913$var$DeploymentFrequencyReport = ()=>{
        const { data: data } = (0, (0, parcelRequire("3Ws3s")).useReportCoreData)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$DeploymentFrequencyReportContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j1sSt")).NonCriticalErrorBoundary), {
            fallback: "unmount",
            eventLocation: "welcomeMessage"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2e0gq")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lVXtL")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MLtm")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$CoreChartContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxsp4")).DeploymentFrequencyBarChart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("awynr")).LineChartByEnvironment), null)), !(data && data.hasDeploymentProvider === false) && (0, ($parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$DetailChartContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ufiFS")).IssuesPerDeploymentChart), null), (0, ($parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$WeekBreakDownContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iY22e")).BatchSizeChart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kopK")).PerDeploymentDetailTable), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6vgP1")).DeploymentModal), null));
    };
    var $0241365af9a98913$export$2e2bcd8739ae039 = $0241365af9a98913$var$DeploymentFrequencyReport;
    const $0241365af9a98913$var$DeploymentFrequencyReportContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4fkly",
                __cmplp.className
            ])
        });
    });
    const $0241365af9a98913$var$CoreChartContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko7vkz _bfhk198v _1yt4cgb5 _19pkpxbi",
                __cmplp.className
            ])
        });
    });
    const $0241365af9a98913$var$DetailChartContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko7vkz _bfhk198v _1yt4cgb5 _19pkpxbi",
                __cmplp.className
            ])
        });
    });
    const $0241365af9a98913$var$WeekBreakDownContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi _bfhkvuon _16qs1aby _2rko1y44 _18s8119w",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("j1sSt", function(module, exports) {
    $parcel$export(module.exports, "NonCriticalErrorBoundary", ()=>$98b7296fd77e9435$export$1625b7ea4c7a5a23);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    const $98b7296fd77e9435$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: fallback,
            packageName: "jiraSoftwareReportsDeploymentFrequencyReport",
            teamName: "fusion-solaris",
            id: eventLocation
        }, children);
});
parcelRegister("iY22e", function(module, exports) {
    $parcel$export(module.exports, "BatchSizeChart", ()=>$19e90c23be3ab6c2$export$e721189aad43c708);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $8sgpE;
    var $eJS47;
    var $lj8SI;
    var $dC5iT;
    var $f5TWP;
    var $cgL5K;
    var $8CUq3;
    var $3bDjY;
    var $jcw0u;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $44gpy;
    var $l8FNQ;
    var $6RYAp;
    var $kBSee;
    var $gilhC;
    var $mEdYv;
    var $3Ws3s;
    var $caivO;
    var $jKTxB;
    var $1y9Id;
    var $17PUx;
    var $kkZmj;
    var $HHUOQ;
    const $19e90c23be3ab6c2$var$ChartTitle = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall",
            as: "h3"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $19e90c23be3ab6c2$var$WeekBreakDownTitleComponent
        }, formatMessage((0, (0, parcelRequire("HHUOQ")).default).weekBreakDownTitle), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("HHUOQ")).default).weekBreakDownTitleTooltip),
            position: "right"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $19e90c23be3ab6c2$var$questionIconStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
            size: "small",
            label: ""
        })))));
    };
    const $19e90c23be3ab6c2$export$e721189aad43c708 = ()=>{
        const onViewDeploymentFrequencyReportExperienceFail = (0, (0, parcelRequire("caivO")).useViewDeploymentFrequencyReportExperienceFail)();
        const { formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ selectedWeekStart: selectedWeekStart }] = (0, (0, parcelRequire("gilhC")).useSelectedWeekStore)();
        const selectedDateRange = selectedWeekStart ? (0, (0, parcelRequire("kBSee")).getWeekRangeFromWeekStartDate)(selectedWeekStart) : null;
        const { data: coreData, error: coreError, fetch: coreFetch } = (0, (0, parcelRequire("3Ws3s")).useReportCoreData)();
        const { loading: loading, error: error, data: data, fetch: fetch } = (0, (0, parcelRequire("jKTxB")).usePeriodBreakdownMetrics)(selectedDateRange);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setSelectedDeploymentId: setSelectedDeploymentId }] = (0, (0, parcelRequire("mEdYv")).useSelectedDeploymentActions)();
        const onChartClicked = (0, $5uXOq.useCallback)(({ data: eventData })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'batchSizeChartDeployment'
            }));
            setSelectedDeploymentId(eventData.name);
        }, [
            createAnalyticsEvent,
            setSelectedDeploymentId
        ]);
        const events = (0, $5uXOq.useMemo)(()=>({
                click: onChartClicked
            }), [
            onChartClicked
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error && data == null) {
                onViewDeploymentFrequencyReportExperienceFail('BatchSizeChart', error);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'BatchSizeChartDataFailed',
                        packageName: 'jiraSoftwareDeploymentFrequencyReport',
                        teamName: 'fusion-solaris'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            data,
            error,
            onViewDeploymentFrequencyReportExperienceFail
        ]);
        if (error && data == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($19e90c23be3ab6c2$var$ChartTitle, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $19e90c23be3ab6c2$var$errorUIWrapperStyles,
            testId: "software-deployment-frequency-report.ui.batch-size-chart.error-ui"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("44gpy")).default), {
            onRetry: coreError && coreData == null ? coreFetch : fetch
        })));
        if (loading || data == null || selectedWeekStart == null || selectedDateRange === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkZmj")).LoadingSkeleton), null);
        const isEmptyState = data.perDeploymentMetrics.length === 0;
        const dataPoints = (0, (0, parcelRequire("17PUx")).convertToDataPoints)(data.perDeploymentMetrics);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $19e90c23be3ab6c2$var$chartWrapperBaseStyles,
            "data-test-id": "software-deployment-frequency-report.ui.batch-size-chart"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($19e90c23be3ab6c2$var$ChartTitle, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xxsmall",
            as: "h3"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $19e90c23be3ab6c2$var$periodDateComponentStyles
        }, formatMessage((0, (0, parcelRequire("HHUOQ")).default).weekTitle, {
            date: formatDate(selectedWeekStart, {
                month: 'short',
                day: 'numeric'
            })
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $19e90c23be3ab6c2$var$titleContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "medium",
            as: "h3"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $19e90c23be3ab6c2$var$titleComponentStyles
        }, formatMessage((0, (0, parcelRequire("HHUOQ")).default).issuesPerDeployment, {
            periodProdIssuesPerDeployment: formatNumber(data.periodProdIssuesPerDeployment ?? 0)
        }))), data.periodProdDeployments > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $19e90c23be3ab6c2$var$trendSummaryContainerStyles
        }, data.prodDataState === 'SUFFICIENT_FOR_TREND' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $19e90c23be3ab6c2$var$trendLozengeContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8FNQ")).TrendLozenge), {
            current: data.periodProdIssuesPerDeployment ?? 0,
            median: data.medianIssuesPerDeployment ?? 0,
            colorScheme: "UP_IS_BAD"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6RYAp")).IssuesTrendSummary), {
            weekCount: data.periodProdIssuesPerDeployment ?? 0,
            wholePeriodStatistic: data.medianIssuesPerDeployment ?? 0,
            prodDataState: data.prodDataState
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $19e90c23be3ab6c2$var$descriptionAndLegendContainerStyles
        }, isEmptyState ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "new"
        }, formatMessage((0, (0, parcelRequire("HHUOQ")).default).moreDataRequired)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $19e90c23be3ab6c2$var$descriptionStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8sgpE"))))), {
            size: "small",
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "span",
            size: "small"
        }, formatMessage((0, (0, parcelRequire("HHUOQ")).default).weeklyProdDeployments, {
            weeklyProdDeployments: data.periodProdDeployments
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $19e90c23be3ab6c2$var$legendContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $19e90c23be3ab6c2$var$legendEntityStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $19e90c23be3ab6c2$var$chartSymbolStyles
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "span",
            size: "small"
        }, formatMessage((0, (0, parcelRequire("HHUOQ")).default).deployment))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $19e90c23be3ab6c2$var$legendEntityStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small"
        }, "--"), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "span",
            size: "small"
        }, formatMessage((0, (0, parcelRequire("HHUOQ")).default).twelveWeekMedian)))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $19e90c23be3ab6c2$var$graphBaseStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1y9Id")).default), {
            dataPoints: dataPoints,
            median: data.medianIssuesPerDeployment,
            dateRange: selectedDateRange,
            onEvents: events
        })));
    };
    const $19e90c23be3ab6c2$var$titleContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.050',
        alignItems: 'center'
    });
    const $19e90c23be3ab6c2$var$descriptionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtle',
        alignItems: 'center',
        gap: 'space.050'
    });
    const $19e90c23be3ab6c2$var$descriptionAndLegendContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 'space.100'
    });
    const $19e90c23be3ab6c2$var$legendContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignItems: 'center',
        paddingRight: 'space.250'
    });
    const $19e90c23be3ab6c2$var$legendEntityStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignItems: 'center',
        paddingLeft: 'space.100',
        lineHeight: '8px',
        gap: 'space.050'
    });
    const $19e90c23be3ab6c2$var$trendSummaryContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.150',
        alignItems: 'center'
    });
    const $19e90c23be3ab6c2$var$errorUIWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '272px',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $19e90c23be3ab6c2$var$questionIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.050',
        fill: 'color.icon.inverse',
        color: 'color.text',
        cursor: 'pointer',
        paddingTop: 'space.025'
    });
    const $19e90c23be3ab6c2$var$trendLozengeContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.050'
    });
    const $19e90c23be3ab6c2$var$chartSymbolStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: "var(--ds-space-100, 8px)",
        height: "var(--ds-space-100, 8px)",
        borderRadius: '100%',
        backgroundColor: 'color.background.accent.blue.subtle',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: 'color.border.accent.blue'
    });
    const $19e90c23be3ab6c2$var$titleComponentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text'
    });
    const $19e90c23be3ab6c2$var$periodDateComponentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.0',
        color: 'color.text',
        textTransform: 'uppercase'
    });
    const $19e90c23be3ab6c2$var$WeekBreakDownTitleComponent = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '24px',
        alignItems: 'center',
        marginBottom: 'space.200'
    });
    const $19e90c23be3ab6c2$var$graphBaseStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '272px'
    });
    const $19e90c23be3ab6c2$var$chartWrapperBaseStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0'
    });
});
parcelRegister("44gpy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13288df9599e2e10$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $75Jbm;
    var $gtreQ;
    var $koVbs;
    var $awRUj;
    var $7UZk8;
    const $13288df9599e2e10$var$ErrorRetry = ({ onRetry: onRetry })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7UZk8")).Wrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7UZk8")).WarnIconWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            label: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7UZk8")).BottomWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7UZk8")).Message), null, formatMessage((0, (0, parcelRequire("awRUj")).default).unableToLoadData)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7UZk8")).RetryIconWrapper), {
            role: "button",
            "data-test-id": "software-devops-report-common-error-retry.retry-icon-wrapper",
            onClick: ()=>onRetry()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("75Jbm"))))), {
            label: formatMessage((0, (0, parcelRequire("awRUj")).default).retry),
            size: "small"
        }))));
    };
    var $13288df9599e2e10$export$2e2bcd8739ae039 = $13288df9599e2e10$var$ErrorRetry;
});
parcelRegister("75Jbm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
    function $529c0c456318696f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $529c0c456318696f$var$RefreshIcon = (props)=>$529c0c456318696f$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
        }, props, {
            newIcon: $529c0c456318696f$var$_refresh.default
        }));
    $529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
    var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;
});
parcelRegister("gPelT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c3fc8ad083e2745c$var$_UNSAFE_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>$c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
        }, props));
    $c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
    var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;
});
parcelRegister("awRUj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90433303028aa6a0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $90433303028aa6a0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unableToLoadData: {
            "id": "software-devops-report-common-error-retry.unable-to-load-data",
            "defaultMessage": "Unable to load data."
        },
        retry: {
            "id": "software-devops-report-common-error-retry.retry",
            "defaultMessage": "Retry"
        }
    });
});
parcelRegister("7UZk8", function(module, exports) {
    $parcel$export(module.exports, "Wrapper", ()=>$f75895865604a355$export$e6dfd72ab29f8598);
    $parcel$export(module.exports, "WarnIconWrapper", ()=>$f75895865604a355$export$de223a2382abc40c);
    $parcel$export(module.exports, "BottomWrapper", ()=>$f75895865604a355$export$193005078f73716a);
    $parcel$export(module.exports, "Message", ()=>$f75895865604a355$export$f69c19e57285b83a);
    $parcel$export(module.exports, "RetryIconWrapper", ()=>$f75895865604a355$export$ab08481c85de6240);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $f75895865604a355$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1ul91lit",
                __cmplp.className
            ])
        });
    });
    const $f75895865604a355$export$de223a2382abc40c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyrv77o",
                __cmplp.className
            ])
        });
    });
    const $f75895865604a355$export$193005078f73716a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $f75895865604a355$export$f69c19e57285b83a = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1 _2hwx1b66",
                __cmplp.className
            ])
        });
    });
    const $f75895865604a355$export$ab08481c85de6240 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyr1i6y _80omtlke",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("l8FNQ", function(module, exports) {
    $parcel$export(module.exports, "TrendLozenge", ()=>$745e2f564054d8b0$export$c51784fbfb667bc5);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $aWse0;
    var $hnhKv;
    var $fQr4I;
    const $745e2f564054d8b0$export$9b5cec634eb288f8 = (current, median, colorScheme)=>{
        const trend = (0, (0, parcelRequire("fQr4I")).compareStatistics)(current, median);
        switch(trend){
            case 'over':
                return {
                    message: (0, (0, parcelRequire("hnhKv")).default).over,
                    appearance: colorScheme === 'UP_IS_GOOD' ? 'success' : 'moved'
                };
            case 'under':
                return {
                    message: (0, (0, parcelRequire("hnhKv")).default).under,
                    appearance: colorScheme === 'UP_IS_GOOD' ? 'moved' : 'success'
                };
            case 'equal':
                return {
                    message: (0, (0, parcelRequire("hnhKv")).default).equal,
                    appearance: 'success'
                };
            default:
                trend;
                throw new Error('Unknown trend is given to getLozengeProps');
        }
    };
    const $745e2f564054d8b0$export$c51784fbfb667bc5 = ({ current: current, median: median, colorScheme: colorScheme })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const lozengeProps = $745e2f564054d8b0$export$9b5cec634eb288f8(current, median, colorScheme);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: lozengeProps.appearance
        }, formatMessage(lozengeProps.message));
    };
});
parcelRegister("hnhKv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7de8507053bf4d8f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7de8507053bf4d8f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        over: {
            "id": "software-deployment-frequency-report.common.trend-lozenge.over",
            "defaultMessage": "over"
        },
        under: {
            "id": "software-deployment-frequency-report.common.trend-lozenge.under",
            "defaultMessage": "under"
        },
        equal: {
            "id": "software-deployment-frequency-report.common.trend-lozenge.equal",
            "defaultMessage": "equal"
        }
    });
});
parcelRegister("fQr4I", function(module, exports) {
    $parcel$export(module.exports, "compareStatistics", ()=>$ef49c556861ec43f$export$154b4dc7335209d7);
    const $ef49c556861ec43f$export$154b4dc7335209d7 = (current, median)=>{
        if (current > median) return 'over';
        if (current < median) return 'under';
        return 'equal';
    };
});
parcelRegister("6RYAp", function(module, exports) {
    $parcel$export(module.exports, "DeploymentsTrendSummary", ()=>$8e9c3c0d81e798e3$export$ab32c8bdd4c685bb);
    $parcel$export(module.exports, "IssuesTrendSummary", ()=>$8e9c3c0d81e798e3$export$8776d2775946890f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2hXfb;
    var $29lcr;
    var $dW099;
    var $8VSnu;
    const $8e9c3c0d81e798e3$var$TrendIcon = ({ prodDataState: prodDataState, trend: trend, colorScheme: colorScheme })=>{
        if (prodDataState === 'SUFFICIENT_FOR_TREND') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dW099")).TrendIcon), {
            trend: trend,
            colorScheme: colorScheme
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2hXfb"))))), {
            label: "",
            primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N100})`,
            size: "small"
        });
    };
    const $8e9c3c0d81e798e3$var$TrendSummary = ({ comparisonMessage: comparisonMessage, weekCount: weekCount, wholePeriodStatistic: wholePeriodStatistic, prodDataState: prodDataState, colorScheme: colorScheme = 'UP_IS_GOOD' })=>{
        const trend = (0, (0, parcelRequire("29lcr")).getTrend)(weekCount, wholePeriodStatistic);
        const noTrendIcon = trend === 'equal' && prodDataState === 'SUFFICIENT_FOR_TREND';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$Comparison, null, (0, ($parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$IconWrapper, {
            noMargin: noTrendIcon
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$TrendIcon, {
            prodDataState: prodDataState,
            trend: trend,
            colorScheme: colorScheme
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$ComparisonText, null, comparisonMessage));
    };
    const $8e9c3c0d81e798e3$export$ab32c8bdd4c685bb = ({ weekCount: weekCount, wholePeriodStatistic: wholePeriodStatistic, prodDataState: prodDataState })=>{
        const comparisonMessage = (0, (0, parcelRequire("8VSnu")).useDeploymentsComparisonMessageTranslated)(weekCount, wholePeriodStatistic, prodDataState);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$TrendSummary, {
            comparisonMessage: comparisonMessage,
            weekCount: weekCount,
            wholePeriodStatistic: wholePeriodStatistic,
            prodDataState: prodDataState,
            colorScheme: "UP_IS_GOOD"
        });
    };
    const $8e9c3c0d81e798e3$export$8776d2775946890f = ({ weekCount: weekCount, wholePeriodStatistic: wholePeriodStatistic, prodDataState: prodDataState })=>{
        const comparisonMessage = (0, (0, parcelRequire("8VSnu")).useIssuesComparisonMessageTranslated)(weekCount, wholePeriodStatistic, prodDataState);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$TrendSummary, {
            comparisonMessage: comparisonMessage,
            weekCount: weekCount,
            wholePeriodStatistic: wholePeriodStatistic,
            prodDataState: prodDataState,
            colorScheme: "UP_IS_BAD"
        });
    };
    const $8e9c3c0d81e798e3$var$Comparison = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $8e9c3c0d81e798e3$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { noMargin: noMargin, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                !__cmplp.noMargin && "_2hwx1y44",
                __cmplp.className
            ])
        });
    });
    const $8e9c3c0d81e798e3$var$ComparisonText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81vlj _syaznoz8",
                __cmplp.className
            ])
        });
    });
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("29lcr", function(module, exports) {
    $parcel$export(module.exports, "getTrend", ()=>$f1a672b10d7c8925$export$a95d8fe605e5806d);
    $parcel$export(module.exports, "getTrendIconBackgroundColor", ()=>$f1a672b10d7c8925$export$8fffc3abc634e8a7);
    const $f1a672b10d7c8925$export$a95d8fe605e5806d = (currentCount, wholePeriodCount)=>{
        if (currentCount < wholePeriodCount) return 'under';
        if (currentCount > wholePeriodCount) return 'over';
        return 'equal';
    };
    const $f1a672b10d7c8925$export$8fffc3abc634e8a7 = (trend, colorScheme)=>{
        if (colorScheme === 'NEUTRAL' || trend === 'equal') return `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N200})`;
        if (colorScheme === 'UP_IS_GOOD' && trend === 'over' || colorScheme === 'UP_IS_BAD' && trend === 'under') return `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`;
        if (colorScheme === 'UP_IS_GOOD' && trend === 'under' || colorScheme === 'UP_IS_BAD' && trend === 'over') return `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y500})`;
        return `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N200})`;
    };
});
parcelRegister("dW099", function(module, exports) {
    $parcel$export(module.exports, "TrendIcon", ()=>$b1e1971ad3bd92e8$export$fba4b680946eab5);
    var $5uXOq = parcelRequire("5uXOq");
    var $7e6cy;
    var $Jy8W0;
    var $29lcr;
    const $b1e1971ad3bd92e8$export$fba4b680946eab5 = ({ trend: trend, colorScheme: colorScheme = 'UP_IS_GOOD' })=>{
        const size = 'small';
        switch(trend){
            case 'over':
                return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("Jy8W0"))))), {
                    size: size,
                    primaryColor: (0, (0, parcelRequire("29lcr")).getTrendIconBackgroundColor)('over', colorScheme),
                    label: ""
                }));
            case 'under':
                return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7e6cy"))))), {
                    size: size,
                    primaryColor: (0, (0, parcelRequire("29lcr")).getTrendIconBackgroundColor)('under', colorScheme),
                    label: ""
                }));
            case 'equal':
                return null;
            default:
                trend;
                throw new Error('Unknown trend is given to TrendIcon component');
        }
    };
});
parcelRegister("7e6cy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $542ea6b72fb41deb$var$_react = $542ea6b72fb41deb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $542ea6b72fb41deb$var$_arrowDown = $542ea6b72fb41deb$var$_interopRequireDefault((parcelRequire("cC5ib")));
    function $542ea6b72fb41deb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $542ea6b72fb41deb$var$ArrowDownCircleIcon = (props)=>$542ea6b72fb41deb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M10.994 8v5.586l-1.279-1.272a1.01 1.01 0 0 0-1.421 0 1 1 0 0 0 0 1.416l2.994 2.977a1.01 1.01 0 0 0 1.423 0l2.994-2.977a1 1 0 0 0 0-1.416 1.01 1.01 0 0 0-1.421 0l-1.279 1.272V8c0-.552-.45-1-1.005-1s-1.006.448-1.006 1"/></g></svg>`
        }, props, {
            newIcon: $542ea6b72fb41deb$var$_arrowDown.default
        }));
    $542ea6b72fb41deb$var$ArrowDownCircleIcon.displayName = 'ArrowDownCircleIcon';
    var $542ea6b72fb41deb$var$_default = module.exports.default = $542ea6b72fb41deb$var$ArrowDownCircleIcon;
});
parcelRegister("cC5ib", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $92ed238f23140736$var$_UNSAFE_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $92ed238f23140736$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $92ed238f23140736$var$ArrowDownIcon = (props)=>$92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1v12.75m-5-4.5 5 5 5-5"/>`
        }, props));
    $92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
    var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;
});
parcelRegister("Jy8W0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $088eb0319e79be2c$var$_react = $088eb0319e79be2c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $088eb0319e79be2c$var$_arrowUp = $088eb0319e79be2c$var$_interopRequireDefault((parcelRequire("kcHZS")));
    function $088eb0319e79be2c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $088eb0319e79be2c$var$ArrowUpCircleIcon = (props)=>$088eb0319e79be2c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M11.288 7.293 8.294 10.27a1 1 0 0 0 0 1.416 1.01 1.01 0 0 0 1.421 0l1.279-1.272V16c0 .552.451 1 1.006 1s1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 0 0 1.421 0 1 1 0 0 0 0-1.416l-2.994-2.977a1.01 1.01 0 0 0-1.423 0"/></g></svg>`
        }, props, {
            newIcon: $088eb0319e79be2c$var$_arrowUp.default
        }));
    $088eb0319e79be2c$var$ArrowUpCircleIcon.displayName = 'ArrowUpCircleIcon';
    var $088eb0319e79be2c$var$_default = module.exports.default = $088eb0319e79be2c$var$ArrowUpCircleIcon;
});
parcelRegister("kcHZS", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb570e807ab2e210$var$_UNSAFE_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eb570e807ab2e210$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>$eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
        }, props));
    $eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
    var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;
});
parcelRegister("8VSnu", function(module, exports) {
    $parcel$export(module.exports, "useDeploymentsComparisonMessageTranslated", ()=>$03a569651b8916b7$export$11affc69c81e2e0b);
    $parcel$export(module.exports, "useIssuesComparisonMessageTranslated", ()=>$03a569651b8916b7$export$8d6bc349d3292310);
    var $gamDR = parcelRequire("gamDR");
    var $aWse0;
    var $29lcr;
    var $fCgqT;
    const $03a569651b8916b7$export$11affc69c81e2e0b = (selectedWeekDeploymentProdCount, averageDeploymentCountWholePeriod, prodDataState)=>{
        const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        if (prodDataState === 'COMPLETELY_EMPTY') return formatMessage((0, (0, parcelRequire("fCgqT")).default).noDataFound);
        if (prodDataState === 'INSUFFICIENT_FOR_TREND') return formatMessage((0, (0, parcelRequire("fCgqT")).default).insufficientData);
        if (prodDataState === 'NO_PROD_BUT_OTHER_ENV') return formatMessage((0, (0, parcelRequire("fCgqT")).default).noProdButOtherEnv);
        const trend = (0, (0, parcelRequire("29lcr")).getTrend)(selectedWeekDeploymentProdCount, averageDeploymentCountWholePeriod);
        const numDeploymentsDiff = (0, ($parcel$interopDefault($gamDR)))(Math.abs(selectedWeekDeploymentProdCount - averageDeploymentCountWholePeriod), 1);
        if (trend === 'over') return formatMessage((0, (0, parcelRequire("fCgqT")).default).deploymentsComparisonTextOver, {
            numDeploymentsDiff: formatNumber(numDeploymentsDiff)
        });
        if (trend === 'under') return formatMessage((0, (0, parcelRequire("fCgqT")).default).deploymentsComparisonTextUnder, {
            numDeploymentsDiff: formatNumber(numDeploymentsDiff)
        });
        return formatMessage((0, (0, parcelRequire("fCgqT")).default).deploymentsComparisonTextEqual);
    };
    const $03a569651b8916b7$export$8d6bc349d3292310 = (selectedWeekMedianIssuesProdCount, medianIssuesCountWholePeriod, prodDataState)=>{
        const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        if (prodDataState === 'COMPLETELY_EMPTY') return formatMessage((0, (0, parcelRequire("fCgqT")).default).noDataFound);
        if (prodDataState === 'INSUFFICIENT_FOR_TREND') return formatMessage((0, (0, parcelRequire("fCgqT")).default).insufficientData);
        if (prodDataState === 'NO_PROD_BUT_OTHER_ENV') return formatMessage((0, (0, parcelRequire("fCgqT")).default).noProdButOtherEnv);
        const trend = (0, (0, parcelRequire("29lcr")).getTrend)(selectedWeekMedianIssuesProdCount, medianIssuesCountWholePeriod);
        const numIssuesDiff = (0, ($parcel$interopDefault($gamDR)))(Math.abs(selectedWeekMedianIssuesProdCount - medianIssuesCountWholePeriod), 1);
        if (trend === 'over') return formatMessage((0, (0, parcelRequire("fCgqT")).default).issuesComparisonTextOver, {
            numIssuesDiff: formatNumber(numIssuesDiff)
        });
        if (trend === 'under') return formatMessage((0, (0, parcelRequire("fCgqT")).default).issuesComparisonTextUnder, {
            numIssuesDiff: formatNumber(numIssuesDiff)
        });
        return formatMessage((0, (0, parcelRequire("fCgqT")).default).issuesComparisonTextEqual);
    };
});
parcelRegister("fCgqT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7499acd5154c1f43$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7499acd5154c1f43$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deploymentsComparisonTextOver: {
            "id": "software-deployment-frequency-report.common.trend-summary.deployments-comparison-text-over",
            "defaultMessage": "{numDeploymentsDiff} {numDeploymentsDiff, plural, one {deployment} other {deployments}} over 12-week average"
        },
        deploymentsComparisonTextUnder: {
            "id": "software-deployment-frequency-report.common.trend-summary.deployments-comparison-text-under",
            "defaultMessage": "{numDeploymentsDiff} {numDeploymentsDiff, plural, one {deployment} other {deployments}} under 12-week average"
        },
        deploymentsComparisonTextEqual: {
            "id": "software-deployment-frequency-report.common.trend-summary.deployments-comparison-text-equal",
            "defaultMessage": "Equal to 12-week average"
        },
        issuesComparisonTextOver: {
            "id": "software-deployment-frequency-report.common.trend-summary.issues-comparison-text-over",
            "defaultMessage": "{numIssuesDiff} {numIssuesDiff, plural, one {issue} other {issues}} over 12-week median"
        },
        issuesComparisonTextUnder: {
            "id": "software-deployment-frequency-report.common.trend-summary.issues-comparison-text-under",
            "defaultMessage": "{numIssuesDiff} {numIssuesDiff, plural, one {issue} other {issues}} under 12-week median"
        },
        issuesComparisonTextEqual: {
            "id": "software-deployment-frequency-report.common.trend-summary.issues-comparison-text-equal",
            "defaultMessage": "Equal to 12-week median"
        },
        noDataFound: {
            "id": "software-deployment-frequency-report.common.trend-summary.no-data-found",
            "defaultMessage": "No data found"
        },
        insufficientData: {
            "id": "software-deployment-frequency-report.common.trend-summary.insufficient-data",
            "defaultMessage": "Not enough data to establish a 12-week median"
        },
        noProdButOtherEnv: {
            "id": "software-deployment-frequency-report.common.trend-summary.no-prod-but-other-env",
            "defaultMessage": "No production deployment data"
        }
    });
});
parcelRegister("gilhC", function(module, exports) {
    $parcel$export(module.exports, "useSelectedWeekStore", ()=>$e53e3374bc08839b$export$face41c30bd4f22c);
    var $3sQ5x;
    var $iXqE5;
    const $e53e3374bc08839b$export$d4c72bab9d6cc13a = {
        selectedWeekStart: null
    };
    const $e53e3374bc08839b$export$e324594224ef24da = {
        setSelectedWeekStart: (newWeekStartDate)=>({ getState: getState, setState: setState })=>{
                const { selectedWeekStart: previousWeekStart } = getState();
                if (previousWeekStart === null || previousWeekStart.getTime() !== newWeekStartDate.getTime()) setState({
                    selectedWeekStart: newWeekStartDate
                });
            }
    };
    const $e53e3374bc08839b$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'depFreqSelectedWeekStore',
        initialState: $e53e3374bc08839b$export$d4c72bab9d6cc13a,
        actions: $e53e3374bc08839b$export$e324594224ef24da
    });
    const $e53e3374bc08839b$export$face41c30bd4f22c = (0, (0, parcelRequire("3sQ5x")).createHook)($e53e3374bc08839b$var$Store);
});
parcelRegister("mEdYv", function(module, exports) {
    $parcel$export(module.exports, "useSelectedDeploymentId", ()=>$18b962388f56fd77$export$ce7d4303c8a70f4);
    $parcel$export(module.exports, "useSelectedDeploymentActions", ()=>$18b962388f56fd77$export$22e665e7c579f44c);
    var $3sQ5x;
    var $iXqE5;
    const $18b962388f56fd77$export$d4c72bab9d6cc13a = {
        selectedDeploymentId: null
    };
    const $18b962388f56fd77$export$e324594224ef24da = {
        setSelectedDeploymentId: (deploymentId)=>({ setState: setState })=>setState({
                    selectedDeploymentId: deploymentId
                })
    };
    const $18b962388f56fd77$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'selectedDeploymentId',
        initialState: $18b962388f56fd77$export$d4c72bab9d6cc13a,
        actions: $18b962388f56fd77$export$e324594224ef24da
    });
    const $18b962388f56fd77$export$ce7d4303c8a70f4 = (0, (0, parcelRequire("3sQ5x")).createHook)($18b962388f56fd77$var$Store, {
        selector: (state)=>state.selectedDeploymentId
    });
    const $18b962388f56fd77$export$22e665e7c579f44c = (0, (0, parcelRequire("3sQ5x")).createHook)($18b962388f56fd77$var$Store, {
        selector: ()=>null
    });
});
parcelRegister("caivO", function(module, exports) {
    $parcel$export(module.exports, "ViewDeploymentFrequencyReportExperienceStart", ()=>$1cc4ea7fea040619$export$dab28c629d19e62);
    $parcel$export(module.exports, "useViewDeploymentFrequencyReportExperienceFail", ()=>$1cc4ea7fea040619$export$a304fe6bb76746c4);
    $parcel$export(module.exports, "ViewDeploymentFrequencyReportExpectedErrorExperienceSuccessTracker", ()=>$1cc4ea7fea040619$export$ac1ea60836686d1f);
    $parcel$export(module.exports, "ViewDeploymentFrequencyReportExperienceSuccessTracker", ()=>$1cc4ea7fea040619$export$c93aada635a947bf);
    var $5uXOq = parcelRequire("5uXOq");
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    var $j1sSt;
    var $ilLj2;
    const $1cc4ea7fea040619$var$viewDeploymentFrequencyReportExperienceName = 'viewDeploymentFrequencyReport';
    const $1cc4ea7fea040619$export$dab28c629d19e62 = ({ experienceId: experienceId })=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experienceId: experienceId,
            experience: $1cc4ea7fea040619$var$viewDeploymentFrequencyReportExperienceName,
            analyticsSource: "deploymentFrequencyReport",
            edition: appEditions.software,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE)
        });
    };
    const $1cc4ea7fea040619$export$a304fe6bb76746c4 = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $1cc4ea7fea040619$var$viewDeploymentFrequencyReportExperienceName
        });
    const $1cc4ea7fea040619$export$ac1ea60836686d1f = ({ reason: reason })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $1cc4ea7fea040619$var$viewDeploymentFrequencyReportExperienceName,
            attributes: {
                reason: reason
            }
        });
    const $1cc4ea7fea040619$export$c93aada635a947bf = ()=>{
        const projectInfo = (0, (0, parcelRequire("ilLj2")).useProjectAnalyticsAttributes)();
        if (projectInfo == null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j1sSt")).NonCriticalErrorBoundary), {
            fallback: "unmount",
            eventLocation: "viewDeploymentFrequencyReportExperienceSuccessTracker"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $1cc4ea7fea040619$var$viewDeploymentFrequencyReportExperienceName,
            attributes: {
                ...projectInfo
            }
        }));
    };
});
parcelRegister("jKTxB", function(module, exports) {
    $parcel$export(module.exports, "usePeriodBreakdownMetrics", ()=>$4224bd69e1d83db8$export$9f571b42ec4fbca5);
    var $hEs3t;
    var $3Ws3s;
    var $i42Pk;
    var $gyB2f;
    const $4224bd69e1d83db8$export$9f571b42ec4fbca5 = (selectedDateRange)=>{
        const perDeploymentMetricsResult = (0, (0, parcelRequire("i42Pk")).usePerDeploymentMetrics)(selectedDateRange);
        const reportCoreDataResult = (0, (0, parcelRequire("3Ws3s")).useReportCoreData)();
        const isLoading = perDeploymentMetricsResult.loading || reportCoreDataResult.loading;
        const resultBase = {
            loading: isLoading,
            error: (0, (0, parcelRequire("hEs3t")).getMaybeCombinedError)([
                perDeploymentMetricsResult.error,
                reportCoreDataResult.error
            ]),
            fetch: perDeploymentMetricsResult.fetch
        };
        return {
            ...resultBase,
            data: reportCoreDataResult.data == null || perDeploymentMetricsResult.data == null || selectedDateRange == null ? undefined : (0, (0, parcelRequire("gyB2f")).transformData)(perDeploymentMetricsResult.data, reportCoreDataResult.data, selectedDateRange)
        };
    };
});
parcelRegister("i42Pk", function(module, exports) {
    $parcel$export(module.exports, "usePerDeploymentMetrics", ()=>$2bca86cc1afb07fa$export$8bd2fd3e33a2a847);
    var $jSzUb;
    var $jZs4b;
    var $koeKL;
    var $ilLj2;
    var $fcVN3;
    const $2bca86cc1afb07fa$export$8bd2fd3e33a2a847 = (dateRange)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectId = (0, (0, parcelRequire("ilLj2")).useProjectId)();
        const variables = dateRange ? (0, (0, parcelRequire("fcVN3")).buildQueryVariables)(cloudId, projectId, dateRange) : null;
        const skip = dateRange === null;
        const queryResult = (0, (0, parcelRequire("jZs4b")).useQuery)((0, (0, parcelRequire("jSzUb")).default), {
            ...variables === null ? {} : {
                variables: {
                    ...variables
                }
            },
            errorPolicy: 'all',
            skip: skip
        });
        return (0, (0, parcelRequire("fcVN3")).transformResult)(queryResult);
    };
});
parcelRegister("jSzUb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e5c1a5ac9502ab44$export$2e2bcd8739ae039);
    const $e5c1a5ac9502ab44$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filter"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "filter",
                "variableName": "filter"
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 400
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "deploymentSize"
        }, v3 = {
            "kind": "ScalarField",
            "name": "id"
        }, v4 = {
            "kind": "ScalarField",
            "name": "issueIds"
        }, v5 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v6 = {
            "kind": "ScalarField",
            "name": "url"
        }, v7 = {
            "kind": "ScalarField",
            "name": "lastUpdated"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "perDeploymentMetricsRelayQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOpsMetrics",
                            "kind": "LinkedField",
                            "name": "devOpsMetrics",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "concreteType": "DevOpsMetricsPerDeploymentMetricsConnection",
                                        "kind": "LinkedField",
                                        "name": "perDeploymentMetrics",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "DevOpsMetricsDeploymentMetrics",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v2,
                                                            "action": "THROW",
                                                            "path": "devOpsMetrics.perDeploymentMetrics.nodes.deploymentSize"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "DeploymentSummary",
                                                                "kind": "LinkedField",
                                                                "name": "deployment",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v3,
                                                                        "action": "THROW",
                                                                        "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.id"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v4,
                                                                        "action": "THROW",
                                                                        "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.issueIds"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v5,
                                                                        "action": "THROW",
                                                                        "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.displayName"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v6,
                                                                        "action": "THROW",
                                                                        "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.url"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v7,
                                                                        "action": "THROW",
                                                                        "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.lastUpdated"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "DevOpsEnvironment",
                                                                            "kind": "LinkedField",
                                                                            "name": "environment",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v5,
                                                                                    "action": "THROW",
                                                                                    "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.environment.displayName"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.environment"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "DeploymentPipeline",
                                                                            "kind": "LinkedField",
                                                                            "name": "pipeline",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v6,
                                                                                    "action": "THROW",
                                                                                    "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.pipeline.url"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v5,
                                                                                    "action": "THROW",
                                                                                    "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.pipeline.displayName"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.pipeline"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "devOpsMetrics.perDeploymentMetrics.nodes"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "devOpsMetrics.perDeploymentMetrics"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "devOpsMetrics"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "perDeploymentMetricsRelayQuery",
                "selections": [
                    {
                        "concreteType": "DevOpsMetrics",
                        "kind": "LinkedField",
                        "name": "devOpsMetrics",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "DevOpsMetricsPerDeploymentMetricsConnection",
                                "kind": "LinkedField",
                                "name": "perDeploymentMetrics",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "DevOpsMetricsDeploymentMetrics",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v2,
                                            {
                                                "concreteType": "DeploymentSummary",
                                                "kind": "LinkedField",
                                                "name": "deployment",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    v4,
                                                    v5,
                                                    v6,
                                                    v7,
                                                    {
                                                        "concreteType": "DevOpsEnvironment",
                                                        "kind": "LinkedField",
                                                        "name": "environment",
                                                        "plural": false,
                                                        "selections": [
                                                            v5
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "DeploymentPipeline",
                                                        "kind": "LinkedField",
                                                        "name": "pipeline",
                                                        "plural": false,
                                                        "selections": [
                                                            v6,
                                                            v5
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "69272838933688029bd3af75ee71f457c3de45b2f1a60918fa4cd89a11f6eec5",
                "metadata": {},
                "name": "perDeploymentMetricsRelayQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e5c1a5ac9502ab44$var$node.hash = "a444cbdff40b5c591f2bfdb2909358a7";
    var $e5c1a5ac9502ab44$export$2e2bcd8739ae039 = $e5c1a5ac9502ab44$var$node;
});
parcelRegister("fcVN3", function(module, exports) {
    $parcel$export(module.exports, "buildQueryVariables", ()=>$a4c3d849efa0d850$export$9a3cee82e7cc08ff);
    $parcel$export(module.exports, "transformResult", ()=>$a4c3d849efa0d850$export$f13b29f9ed0c5a03);
    var $dXq4S;
    var $g5X3G;
    const $a4c3d849efa0d850$export$9a3cee82e7cc08ff = (cloudId, projectId, { startDateInclusive: startDateInclusive, endDateExclusive: endDateExclusive })=>({
            filter: {
                cloudId: cloudId,
                startFromInclusive: startDateInclusive.toISOString(),
                endAtExclusive: endDateExclusive.toISOString(),
                jiraProjectIds: [
                    projectId
                ],
                environmentCategories: [
                    'PRODUCTION'
                ]
            }
        });
    const $a4c3d849efa0d850$export$8aa413923a6a0c63 = (ariLikeString)=>{
        const ari = (0, (0, parcelRequire("dXq4S")).toAri)(ariLikeString);
        if (ari === undefined) throw Error('Invalid ARI');
        return (0, (0, parcelRequire("dXq4S")).getAriConfig)(ari).resourceId;
    };
    const $a4c3d849efa0d850$var$transformNode = (node)=>{
        if (node == null || node.deployment == null || node.deploymentSize == null) throw Error('Incomplete deployment node');
        const { deployment: deployment, deploymentSize: deploymentSize } = node;
        const { id: id, displayName: displayName, url: url, lastUpdated: lastUpdated, issueIds: issueIds, environment: environment, pipeline: pipeline } = deployment;
        if (id == null || displayName == null || url == null || lastUpdated == null || issueIds == null || environment == null || pipeline == null) throw Error('Incomplete deployment node');
        const { displayName: environmentDisplayName } = environment;
        const { displayName: pipelineDisplayName, url: pipelineUrl } = pipeline;
        if (environmentDisplayName == null || pipelineDisplayName == null || pipelineUrl == null) throw Error('Incomplete deployment node');
        return {
            id: id,
            issueCount: deploymentSize,
            issueIds: issueIds.map((issueId)=>(0, (0, parcelRequire("g5X3G")).toIssueId)($a4c3d849efa0d850$export$8aa413923a6a0c63(issueId))),
            displayName: displayName,
            url: url,
            lastUpdated: new Date(lastUpdated),
            environment: {
                displayName: environmentDisplayName
            },
            pipeline: {
                url: pipelineUrl,
                displayName: pipelineDisplayName
            }
        };
    };
    const $a4c3d849efa0d850$export$f13b29f9ed0c5a03 = (queryResult)=>{
        const resultBase = {
            loading: queryResult.loading,
            error: queryResult.error,
            fetch: queryResult.refetch
        };
        const nodes = queryResult.data?.devOpsMetrics?.perDeploymentMetrics?.nodes;
        if (queryResult.loading || nodes == null) return resultBase;
        try {
            return {
                ...resultBase,
                data: nodes.map($a4c3d849efa0d850$var$transformNode)
            };
        } catch (error) {
            return {
                ...resultBase,
                error: queryResult.error ?? error
            };
        }
    };
});
parcelRegister("gyB2f", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$958435368c5ac310$export$3ceb62baab058c6b);
    var $claG0;
    const $958435368c5ac310$export$3ceb62baab058c6b = (perDeploymentMetrics, coreReportData, selectedDateRange)=>{
        const selectedPeriod = coreReportData.weeksData.find((week)=>week.startDateInclusive.getTime() === selectedDateRange.startDateInclusive.getTime());
        if (!selectedPeriod) throw new Error('cannot find selected period in period breakdown');
        return {
            periodProdDeployments: selectedPeriod.deploymentCount.prod,
            periodProdIssuesPerDeployment: selectedPeriod.medianIssuesPerDeployment.prod,
            medianProdDeployments: coreReportData.averageDeploymentCount,
            medianIssuesPerDeployment: coreReportData.medianIssuesPerDeployment,
            prodDataState: (0, (0, parcelRequire("claG0")).getProdDataState)(coreReportData),
            perDeploymentMetrics: perDeploymentMetrics,
            hasDeploymentProvider: coreReportData.hasDeploymentProvider
        };
    };
});
parcelRegister("1y9Id", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c25f55e36105bdee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3QJ5u;
    var $lXVui = parcelRequire("lXVui");
    var $5QGgH;
    var $47isN;
    var $Np0DX;
    var $48mDj;
    var $gLj36;
    var $ixV1I;
    var $lWgYs;
    var $dWt6p;
    var $k5uoT;
    var $gwIPs;
    var $aWse0;
    var $fNWkd;
    var $d5cn8;
    var $gFaMO;
    var $ayFdV;
    (0, parcelRequire("ixV1I")).use([
        (0, (0, parcelRequire("47isN")).install),
        (0, (0, parcelRequire("Np0DX")).install),
        (0, (0, parcelRequire("5QGgH")).install),
        (0, (0, parcelRequire("48mDj")).install),
        (0, (0, parcelRequire("gLj36")).install),
        (0, (0, parcelRequire("lWgYs")).install)
    ]);
    const $c25f55e36105bdee$var$getAxisCommonConfig = ()=>({
            nameGap: (0, (0, parcelRequire("gwIPs")).gridSize) * 4,
            nameLocation: 'middle',
            nameTextStyle: {
                color: (0, $829f609a65d26a98$exports).N400,
                fontSize: (0, (0, parcelRequire("k5uoT")).fontSizeSmall)()
            }
        });
    const $c25f55e36105bdee$var$useXAxisConfig = (dateRange)=>{
        const { formatDate: formatDate } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const xAxisData = (0, (0, parcelRequire("3QJ5u")).default)({
            start: dateRange.startDateInclusive,
            end: dateRange.endDateExclusive
        }).map((x)=>x.getTime());
        return {
            ...$c25f55e36105bdee$var$getAxisCommonConfig(),
            data: xAxisData,
            min: xAxisData[0],
            max: xAxisData[xAxisData.length - 1],
            splitNumber: xAxisData.length,
            axisLabel: {
                formatter: (x)=>formatDate(new Date(parseInt(x, 10)), {
                        month: 'short',
                        day: 'numeric'
                    }),
                showMaxLabel: true
            },
            splitLine: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: (0, $829f609a65d26a98$exports).N40,
                    width: 2
                }
            },
            axisTick: {
                alignWithLabel: true
            },
            offset: 10,
            scale: true,
            type: 'time',
            axisPointer: {
                show: true,
                lineStyle: {
                    type: 'dashed',
                    color: (0, $829f609a65d26a98$exports).B100,
                    width: 0.5
                },
                label: {
                    show: false
                },
                triggerTooltip: false
            }
        };
    };
    const $c25f55e36105bdee$var$Chart = ({ onEvents: onEvents, dataPoints: dataPoints, median: median, dateRange: dateRange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const tooltipFormatter = (0, (0, parcelRequire("ayFdV")).useTooltipFormatter)();
        const xAxisConfig = $c25f55e36105bdee$var$useXAxisConfig(dateRange);
        const echartsRef = (0, $5uXOq.useRef)();
        const [hoveredDeployment] = (0, (0, parcelRequire("d5cn8")).useHoveredDeployment)();
        const prefersReducedMotion = (0, (0, parcelRequire("dWt6p")).useIsReducedMotion)();
        (0, $5uXOq.useEffect)(()=>{
            const echartsInstance = echartsRef?.current?.getEchartsInstance();
            if (echartsInstance === undefined || hoveredDeployment === null) return ()=>{};
            echartsInstance.dispatchAction({
                type: 'highlight',
                name: hoveredDeployment
            });
            return ()=>{
                echartsInstance.dispatchAction({
                    type: 'downplay',
                    name: hoveredDeployment
                });
            };
        }, [
            hoveredDeployment
        ]);
        const scatterConfig = {
            type: 'effectScatter',
            data: dataPoints,
            showEffectOn: 'emphasis',
            rippleEffect: {
                brushType: 'fill',
                color: (0, $829f609a65d26a98$exports).B300,
                scale: 5
            },
            hoverAnimation: true,
            color: (0, $829f609a65d26a98$exports).B75,
            symbolSize: 8,
            itemStyle: {
                borderColor: (0, $829f609a65d26a98$exports).B100,
                borderWidth: 1
            },
            emphasis: {
                itemStyle: {
                    color: (0, $829f609a65d26a98$exports).N0,
                    borderColor: (0, $829f609a65d26a98$exports).B300,
                    borderWidth: 2,
                    borderType: 'solid',
                    opacity: 1
                }
            },
            lineStyle: {
                color: (0, $829f609a65d26a98$exports).B200
            }
        };
        const chartOptions = {
            animation: !prefersReducedMotion,
            tooltip: {
                backgroundColor: (0, $829f609a65d26a98$exports).N900,
                formatter: tooltipFormatter,
                confine: true,
                transitionDuration: 0,
                enterable: true
            },
            grid: {
                left: `${(0, (0, parcelRequire("fNWkd")).CHART_SPACE_LEFT)}px`,
                right: '20px',
                bottom: `${(0, (0, parcelRequire("fNWkd")).CHART_SPACE_BOTTOM)}px`
            },
            xAxis: xAxisConfig,
            yAxis: {
                ...$c25f55e36105bdee$var$getAxisCommonConfig(),
                name: formatMessage((0, (0, parcelRequire("gFaMO")).default).yAxis),
                nameGap: 40,
                nameLocation: 'middle',
                minInterval: 1,
                offset: 0,
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    lineStyle: {
                        color: (0, $829f609a65d26a98$exports).N30
                    }
                }
            },
            textStyle: {
                color: (0, $829f609a65d26a98$exports).N400
            },
            series: [
                {
                    ...scatterConfig,
                    ...median === null ? {} : {
                        markLine: {
                            data: [
                                {
                                    yAxis: median
                                }
                            ],
                            silent: true,
                            lineStyle: {
                                color: (0, $829f609a65d26a98$exports).N300,
                                width: 1,
                                opacity: 0.6
                            },
                            symbol: 'none',
                            label: {
                                show: false
                            }
                        }
                    }
                }
            ]
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($lXVui))), {
            ref: echartsRef,
            echarts: (0, parcelRequire("ixV1I")),
            option: chartOptions,
            onEvents: onEvents,
            style: {
                height: '100%'
            }
        });
    };
    var $c25f55e36105bdee$export$2e2bcd8739ae039 = $c25f55e36105bdee$var$Chart;
});
parcelRegister("lXVui", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3VFsf;
    var $ffdbb37eea52750b$var$react_1 = (0, (0, parcelRequire("3VFsf")).__importStar)((parcelRequire("5uXOq")));
    var $grS0X = parcelRequire("grS0X");
    var $6gLUT = parcelRequire("6gLUT");
    var $eBzeD = parcelRequire("eBzeD");
    var $lj6jE = parcelRequire("lj6jE");
    var $1pywT = parcelRequire("1pywT");
    var $ffdbb37eea52750b$var$EChartsReactCore = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(EChartsReactCore, _super);
        function EChartsReactCore(props) {
            var _this = _super.call(this, props) || this;
            _this.echarts = props.echarts;
            _this.ele = null;
            _this.isInitialResize = true;
            return _this;
        }
        EChartsReactCore.prototype.componentDidMount = function() {
            this.renderNewEcharts();
        };
        EChartsReactCore.prototype.componentDidUpdate = function(prevProps) {
            var shouldSetOption = this.props.shouldSetOption;
            if ((0, $eBzeD.isFunction)(shouldSetOption) && !shouldSetOption(prevProps, this.props)) return;
            if (!(0, $1pywT.isEqual)(prevProps.theme, this.props.theme) || !(0, $1pywT.isEqual)(prevProps.opts, this.props.opts) || !(0, $1pywT.isEqual)(prevProps.onEvents, this.props.onEvents)) {
                this.dispose();
                this.renderNewEcharts();
                return;
            }
            var pickKeys = [
                'option',
                'notMerge',
                'lazyUpdate',
                'showLoading',
                'loadingOption'
            ];
            if (!(0, $1pywT.isEqual)((0, $6gLUT.pick)(this.props, pickKeys), (0, $6gLUT.pick)(prevProps, pickKeys))) this.updateEChartsOption();
            if (!(0, $1pywT.isEqual)(prevProps.style, this.props.style) || !(0, $1pywT.isEqual)(prevProps.className, this.props.className)) this.resize();
        };
        EChartsReactCore.prototype.componentWillUnmount = function() {
            this.dispose();
        };
        EChartsReactCore.prototype.getEchartsInstance = function() {
            return this.echarts.getInstanceByDom(this.ele) || this.echarts.init(this.ele, this.props.theme, this.props.opts);
        };
        EChartsReactCore.prototype.dispose = function() {
            if (this.ele) {
                try {
                    (0, $grS0X.clear)(this.ele);
                } catch (e) {
                    console.warn(e);
                }
                this.echarts.dispose(this.ele);
            }
        };
        EChartsReactCore.prototype.renderNewEcharts = function() {
            var _this = this;
            var _a = this.props, onEvents = _a.onEvents, onChartReady = _a.onChartReady;
            var echartsInstance = this.updateEChartsOption();
            this.bindEvents(echartsInstance, onEvents || {});
            if ((0, $eBzeD.isFunction)(onChartReady)) onChartReady(echartsInstance);
            if (this.ele) (0, $grS0X.bind)(this.ele, function() {
                _this.resize();
            });
        };
        EChartsReactCore.prototype.bindEvents = function(instance, events) {
            function _bindEvent(eventName, func) {
                if ((0, $lj6jE.isString)(eventName) && (0, $eBzeD.isFunction)(func)) instance.on(eventName, function(param) {
                    func(param, instance);
                });
            }
            for(var eventName in events)if (Object.prototype.hasOwnProperty.call(events, eventName)) _bindEvent(eventName, events[eventName]);
        };
        EChartsReactCore.prototype.updateEChartsOption = function() {
            var _a = this.props, option = _a.option, _b = _a.notMerge, notMerge = _b === void 0 ? false : _b, _c = _a.lazyUpdate, lazyUpdate = _c === void 0 ? false : _c, showLoading = _a.showLoading, _d = _a.loadingOption, loadingOption = _d === void 0 ? null : _d;
            var echartInstance = this.getEchartsInstance();
            echartInstance.setOption(option, notMerge, lazyUpdate);
            if (showLoading) echartInstance.showLoading(loadingOption);
            else echartInstance.hideLoading();
            return echartInstance;
        };
        EChartsReactCore.prototype.resize = function() {
            var echartsInstance = this.getEchartsInstance();
            if (!this.isInitialResize) try {
                echartsInstance.resize();
            } catch (e) {
                console.warn(e);
            }
            this.isInitialResize = false;
        };
        EChartsReactCore.prototype.render = function() {
            var _this = this;
            var _a = this.props, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b;
            var newStyle = (0, (0, parcelRequire("3VFsf")).__assign)({
                height: 300
            }, style);
            return $ffdbb37eea52750b$var$react_1.default.createElement("div", {
                ref: function(e) {
                    _this.ele = e;
                },
                style: newStyle,
                className: "echarts-for-react " + className
            });
        };
        return EChartsReactCore;
    }($ffdbb37eea52750b$var$react_1.PureComponent);
    module.exports.default = $ffdbb37eea52750b$var$EChartsReactCore;
});
parcelRegister("grS0X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ver = module.exports.clear = module.exports.bind = void 0;
    var $8x2zG = parcelRequire("8x2zG");
    var $bf9911179e98088f$var$bind = function bind(element, cb) {
        var sensor = (0, $8x2zG.getSensor)(element);
        sensor.bind(cb);
        return function() {
            sensor.unbind(cb);
        };
    };
    module.exports.bind = $bf9911179e98088f$var$bind;
    var $bf9911179e98088f$var$clear = function clear(element) {
        var sensor = (0, $8x2zG.getSensor)(element);
        (0, $8x2zG.removeSensor)(sensor);
    };
    module.exports.clear = $bf9911179e98088f$var$clear;
    var $bf9911179e98088f$var$ver = "1.0.1";
    module.exports.ver = $bf9911179e98088f$var$ver;
});
parcelRegister("8x2zG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.removeSensor = module.exports.getSensor = void 0;
    var $6363670a61880ddf$var$_id = $6363670a61880ddf$var$_interopRequireDefault((parcelRequire("fiP6o")));
    var $gWzBv = parcelRequire("gWzBv");
    var $cdrHo = parcelRequire("cdrHo");
    function $6363670a61880ddf$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var $6363670a61880ddf$var$Sensors = {};
    var $6363670a61880ddf$var$getSensor = function getSensor(element) {
        var sensorId = element.getAttribute($cdrHo.SizeSensorId);
        if (sensorId && $6363670a61880ddf$var$Sensors[sensorId]) return $6363670a61880ddf$var$Sensors[sensorId];
        var newId = (0, $6363670a61880ddf$var$_id["default"])();
        element.setAttribute($cdrHo.SizeSensorId, newId);
        var sensor = (0, $gWzBv.createSensor)(element);
        $6363670a61880ddf$var$Sensors[newId] = sensor;
        return sensor;
    };
    module.exports.getSensor = $6363670a61880ddf$var$getSensor;
    var $6363670a61880ddf$var$removeSensor = function removeSensor(sensor) {
        var sensorId = sensor.element.getAttribute($cdrHo.SizeSensorId);
        sensor.element.removeAttribute($cdrHo.SizeSensorId);
        sensor.destroy();
        if (sensorId && $6363670a61880ddf$var$Sensors[sensorId]) delete $6363670a61880ddf$var$Sensors[sensorId];
    };
    module.exports.removeSensor = $6363670a61880ddf$var$removeSensor;
});
parcelRegister("fiP6o", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports["default"] = void 0;
    var $b2402d3f57c74659$var$id = 1;
    var $b2402d3f57c74659$var$_default = function _default() {
        return "".concat($b2402d3f57c74659$var$id++);
    };
    module.exports["default"] = $b2402d3f57c74659$var$_default;
});
parcelRegister("gWzBv", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.createSensor = void 0;
    var $1oYX1 = parcelRequire("1oYX1");
    var $gxB4H = parcelRequire("gxB4H");
    var $c55dae5359197dfc$var$createSensor = typeof ResizeObserver !== 'undefined' ? $gxB4H.createSensor : $1oYX1.createSensor;
    module.exports.createSensor = $c55dae5359197dfc$var$createSensor;
});
parcelRegister("1oYX1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.createSensor = void 0;
    var $10574fe90a26a00a$var$_debounce = $10574fe90a26a00a$var$_interopRequireDefault((parcelRequire("hwNQ2")));
    var $cdrHo = parcelRequire("cdrHo");
    function $10574fe90a26a00a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var $10574fe90a26a00a$var$createSensor = function createSensor(element) {
        var sensor = undefined;
        var listeners = [];
        var newSensor = function newSensor() {
            if (getComputedStyle(element).position === 'static') element.style.position = 'relative';
            var obj = document.createElement('object');
            obj.onload = function() {
                obj.contentDocument.defaultView.addEventListener('resize', resizeListener);
                resizeListener();
            };
            obj.style.display = 'block';
            obj.style.position = 'absolute';
            obj.style.top = '0';
            obj.style.left = '0';
            obj.style.height = '100%';
            obj.style.width = '100%';
            obj.style.overflow = 'hidden';
            obj.style.pointerEvents = 'none';
            obj.style.zIndex = '-1';
            obj.style.opacity = '0';
            obj.setAttribute('class', $cdrHo.SensorClassName);
            obj.setAttribute('tabindex', $cdrHo.SensorTabIndex);
            obj.type = 'text/html';
            element.appendChild(obj);
            obj.data = 'about:blank';
            return obj;
        };
        var resizeListener = (0, $10574fe90a26a00a$var$_debounce["default"])(function() {
            listeners.forEach(function(listener) {
                listener(element);
            });
        });
        var bind = function bind(cb) {
            if (!sensor) sensor = newSensor();
            if (listeners.indexOf(cb) === -1) listeners.push(cb);
        };
        var destroy = function destroy() {
            if (sensor && sensor.parentNode) {
                if (sensor.contentDocument) sensor.contentDocument.defaultView.removeEventListener('resize', resizeListener);
                sensor.parentNode.removeChild(sensor);
                sensor = undefined;
                listeners = [];
            }
        };
        var unbind = function unbind(cb) {
            var idx = listeners.indexOf(cb);
            if (idx !== -1) listeners.splice(idx, 1);
            if (listeners.length === 0 && sensor) destroy();
        };
        return {
            element: element,
            bind: bind,
            destroy: destroy,
            unbind: unbind
        };
    };
    module.exports.createSensor = $10574fe90a26a00a$var$createSensor;
});
parcelRegister("hwNQ2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports["default"] = void 0;
    var $cc2c15b4a43e3633$var$_default = function _default(fn) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
        var timer = null;
        return function() {
            var _this = this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            clearTimeout(timer);
            timer = setTimeout(function() {
                fn.apply(_this, args);
            }, delay);
        };
    };
    module.exports["default"] = $cc2c15b4a43e3633$var$_default;
});
parcelRegister("cdrHo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SensorTabIndex = module.exports.SensorClassName = module.exports.SizeSensorId = void 0;
    var $8e4c2f559be5b9b7$var$SizeSensorId = 'size-sensor-id';
    module.exports.SizeSensorId = $8e4c2f559be5b9b7$var$SizeSensorId;
    var $8e4c2f559be5b9b7$var$SensorClassName = 'size-sensor-object';
    module.exports.SensorClassName = $8e4c2f559be5b9b7$var$SensorClassName;
    var $8e4c2f559be5b9b7$var$SensorTabIndex = '-1';
    module.exports.SensorTabIndex = $8e4c2f559be5b9b7$var$SensorTabIndex;
});
parcelRegister("gxB4H", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.createSensor = void 0;
    var $c0ac7cab0e8dcc43$var$_debounce = $c0ac7cab0e8dcc43$var$_interopRequireDefault((parcelRequire("hwNQ2")));
    function $c0ac7cab0e8dcc43$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var $c0ac7cab0e8dcc43$var$createSensor = function createSensor(element) {
        var sensor = undefined;
        var listeners = [];
        var resizeListener = (0, $c0ac7cab0e8dcc43$var$_debounce["default"])(function() {
            listeners.forEach(function(listener) {
                listener(element);
            });
        });
        var newSensor = function newSensor() {
            var s = new ResizeObserver(resizeListener);
            s.observe(element);
            resizeListener();
            return s;
        };
        var bind = function bind(cb) {
            if (!sensor) sensor = newSensor();
            if (listeners.indexOf(cb) === -1) listeners.push(cb);
        };
        var destroy = function destroy() {
            sensor.disconnect();
            listeners = [];
            sensor = undefined;
        };
        var unbind = function unbind(cb) {
            var idx = listeners.indexOf(cb);
            if (idx !== -1) listeners.splice(idx, 1);
            if (listeners.length === 0 && sensor) destroy();
        };
        return {
            element: element,
            bind: bind,
            destroy: destroy,
            unbind: unbind
        };
    };
    module.exports.createSensor = $c0ac7cab0e8dcc43$var$createSensor;
});
parcelRegister("6gLUT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.pick = void 0;
    function $490967eff7da5641$var$pick(obj, keys) {
        var r = {};
        keys.forEach(function(key) {
            r[key] = obj[key];
        });
        return r;
    }
    module.exports.pick = $490967eff7da5641$var$pick;
});
parcelRegister("eBzeD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isFunction = void 0;
    function $aa1fda532dd852be$var$isFunction(v) {
        return typeof v === 'function';
    }
    module.exports.isFunction = $aa1fda532dd852be$var$isFunction;
});
parcelRegister("lj6jE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isString = void 0;
    function $f83045889662a498$var$isString(v) {
        return typeof v === 'string';
    }
    module.exports.isString = $f83045889662a498$var$isString;
});
parcelRegister("1pywT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isEqual = void 0;
    var $3VFsf;
    var $1072e91c08f205e9$var$fast_deep_equal_1 = (0, (0, parcelRequire("3VFsf")).__importDefault)((parcelRequire("1SBaA")));
    module.exports.isEqual = $1072e91c08f205e9$var$fast_deep_equal_1.default;
});
parcelRegister("1SBaA", function(module, exports) {
    'use strict';
    module.exports = function equal(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == 'object' && typeof b == 'object') {
            if (a.constructor !== b.constructor) return false;
            var length, i, keys;
            if (Array.isArray(a)) {
                length = a.length;
                if (length != b.length) return false;
                for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
                return true;
            }
            if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
            if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
            if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
            keys = Object.keys(a);
            length = keys.length;
            if (length !== Object.keys(b).length) return false;
            for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
            for(i = length; i-- !== 0;){
                var key = keys[i];
                if (!equal(a[key], b[key])) return false;
            }
            return true;
        }
        return a !== a && b !== b;
    };
});
parcelRegister("5QGgH", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$442298b05d2dae48$export$4b3e715f166fdd78);
    var $8MyDE;
    var $9UN8r;
    var $5xgWc;
    function $442298b05d2dae48$export$4b3e715f166fdd78(registers) {
        registers.registerChartView((0, (0, parcelRequire("8MyDE")).default));
        registers.registerSeriesModel((0, (0, parcelRequire("9UN8r")).default));
        registers.registerLayout((0, (0, parcelRequire("5xgWc")).default)('effectScatter'));
    }
});
parcelRegister("8MyDE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$664dace6b77f6f66$export$2e2bcd8739ae039);
    var $3VFsf;
    var $5DXGq;
    var $8Jx6o;
    var $izqgC;
    var $5xgWc;
    var $loerw;
    var $664dace6b77f6f66$var$EffectScatterView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(EffectScatterView, _super);
        function EffectScatterView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = EffectScatterView.type;
            return _this;
        }
        EffectScatterView.prototype.init = function() {
            this._symbolDraw = new (0, (0, parcelRequire("5DXGq")).default)((0, (0, parcelRequire("8Jx6o")).default));
        };
        EffectScatterView.prototype.render = function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var effectSymbolDraw = this._symbolDraw;
            effectSymbolDraw.updateData(data, {
                clipShape: this._getClipShape(seriesModel)
            });
            this.group.add(effectSymbolDraw.group);
        };
        EffectScatterView.prototype._getClipShape = function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
            return seriesModel.get('clip', true) ? clipArea : null;
        };
        EffectScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            this.group.dirty();
            var res = (0, (0, parcelRequire("5xgWc")).default)('').reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            this._symbolDraw.updateLayout();
        };
        EffectScatterView.prototype._updateGroupTransform = function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys && coordSys.getRoamTransform) {
                this.group.transform = (0, parcelRequire("izqgC")).clone(coordSys.getRoamTransform());
                this.group.decomposeTransform();
            }
        };
        EffectScatterView.prototype.remove = function(ecModel, api) {
            this._symbolDraw && this._symbolDraw.remove(true);
        };
        EffectScatterView.type = 'effectScatter';
        return EffectScatterView;
    }((0, (0, parcelRequire("loerw")).default));
    var $664dace6b77f6f66$export$2e2bcd8739ae039 = $664dace6b77f6f66$var$EffectScatterView;
});
parcelRegister("5DXGq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41bee41b01adf88e$export$2e2bcd8739ae039);
    var $4KVOr;
    parcelRequire("fHITF");
    var $eYgMC;
    var $lUzII;
    var $bahqM;
    var $gvLUt;
    function $41bee41b01adf88e$var$symbolNeedsDraw(data, point, idx, opt) {
        return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
    }
    function $41bee41b01adf88e$var$normalizeUpdateOpt(opt) {
        if (opt != null && !(0, (0, parcelRequire("bahqM")).isObject)(opt)) opt = {
            isIgnore: opt
        };
        return opt || {};
    }
    function $41bee41b01adf88e$var$makeSeriesScope(data) {
        var seriesModel = data.hostModel;
        var emphasisModel = seriesModel.getModel('emphasis');
        return {
            emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
            blurItemStyle: seriesModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle(),
            selectItemStyle: seriesModel.getModel([
                'select',
                'itemStyle'
            ]).getItemStyle(),
            focus: emphasisModel.get('focus'),
            blurScope: emphasisModel.get('blurScope'),
            hoverScale: emphasisModel.get('scale'),
            labelStatesModels: (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(seriesModel),
            cursorStyle: seriesModel.get('cursor')
        };
    }
    var $41bee41b01adf88e$var$SymbolDraw = function() {
        function SymbolDraw(SymbolCtor) {
            this.group = new (0, parcelRequire("4KVOr")).default();
            this._SymbolCtor = SymbolCtor || (0, (0, parcelRequire("lUzII")).default);
        }
        SymbolDraw.prototype.updateData = function(data, opt) {
            opt = $41bee41b01adf88e$var$normalizeUpdateOpt(opt);
            var group = this.group;
            var seriesModel = data.hostModel;
            var oldData = this._data;
            var SymbolCtor = this._SymbolCtor;
            var disableAnimation = opt.disableAnimation;
            var seriesScope = $41bee41b01adf88e$var$makeSeriesScope(data);
            var symbolUpdateOpt = {
                disableAnimation: disableAnimation
            };
            var getSymbolPoint = opt.getSymbolPoint || function(idx) {
                return data.getItemLayout(idx);
            };
            if (!oldData) group.removeAll();
            data.diff(oldData).add(function(newIdx) {
                var point = getSymbolPoint(newIdx);
                if ($41bee41b01adf88e$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                    var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                    symbolEl.setPosition(point);
                    data.setItemGraphicEl(newIdx, symbolEl);
                    group.add(symbolEl);
                }
            }).update(function(newIdx, oldIdx) {
                var symbolEl = oldData.getItemGraphicEl(oldIdx);
                var point = getSymbolPoint(newIdx);
                if (!$41bee41b01adf88e$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                    group.remove(symbolEl);
                    return;
                }
                var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
                var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
                if (!symbolEl || oldSymbolType && oldSymbolType !== newSymbolType) {
                    group.remove(symbolEl);
                    symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                    symbolEl.setPosition(point);
                } else {
                    symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                    var target = {
                        x: point[0],
                        y: point[1]
                    };
                    disableAnimation ? symbolEl.attr(target) : (0, parcelRequire("eYgMC")).updateProps(symbolEl, target, seriesModel);
                }
                group.add(symbolEl);
                data.setItemGraphicEl(newIdx, symbolEl);
            }).remove(function(oldIdx) {
                var el = oldData.getItemGraphicEl(oldIdx);
                el && el.fadeOut(function() {
                    group.remove(el);
                });
            }).execute();
            this._getSymbolPoint = getSymbolPoint;
            this._data = data;
        };
        SymbolDraw.prototype.isPersistent = function() {
            return true;
        };
        SymbolDraw.prototype.updateLayout = function() {
            var _this = this;
            var data = this._data;
            if (data) data.eachItemGraphicEl(function(el, idx) {
                var point = _this._getSymbolPoint(idx);
                el.setPosition(point);
                el.markRedraw();
            });
        };
        SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
            this._seriesScope = $41bee41b01adf88e$var$makeSeriesScope(data);
            this._data = null;
            this.group.removeAll();
        };
        SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
            opt = $41bee41b01adf88e$var$normalizeUpdateOpt(opt);
            function updateIncrementalAndHover(el) {
                if (!el.isGroup) {
                    el.incremental = true;
                    el.ensureState('emphasis').hoverLayer = true;
                }
            }
            for(var idx = taskParams.start; idx < taskParams.end; idx++){
                var point = data.getItemLayout(idx);
                if ($41bee41b01adf88e$var$symbolNeedsDraw(data, point, idx, opt)) {
                    var el = new this._SymbolCtor(data, idx, this._seriesScope);
                    el.traverse(updateIncrementalAndHover);
                    el.setPosition(point);
                    this.group.add(el);
                    data.setItemGraphicEl(idx, el);
                }
            }
        };
        SymbolDraw.prototype.remove = function(enableAnimation) {
            var group = this.group;
            var data = this._data;
            if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
                el.fadeOut(function() {
                    group.remove(el);
                });
            });
            else group.removeAll();
        };
        return SymbolDraw;
    }();
    var $41bee41b01adf88e$export$2e2bcd8739ae039 = $41bee41b01adf88e$var$SymbolDraw;
});
parcelRegister("4KVOr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37684daaaf15bf3f$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $7KVc5;
    var $1E3E8;
    var $37684daaaf15bf3f$var$Group = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Group, _super);
        function Group(opts) {
            var _this = _super.call(this) || this;
            _this.isGroup = true;
            _this._children = [];
            _this.attr(opts);
            return _this;
        }
        Group.prototype.childrenRef = function() {
            return this._children;
        };
        Group.prototype.children = function() {
            return this._children.slice();
        };
        Group.prototype.childAt = function(idx) {
            return this._children[idx];
        };
        Group.prototype.childOfName = function(name) {
            var children = this._children;
            for(var i = 0; i < children.length; i++){
                if (children[i].name === name) return children[i];
            }
        };
        Group.prototype.childCount = function() {
            return this._children.length;
        };
        Group.prototype.add = function(child) {
            if (child) {
                if (child !== this && child.parent !== this) {
                    this._children.push(child);
                    this._doAdd(child);
                }
                if (child.__hostTarget) throw 'This elemenet has been used as an attachment';
            }
            return this;
        };
        Group.prototype.addBefore = function(child, nextSibling) {
            if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
                var children = this._children;
                var idx = children.indexOf(nextSibling);
                if (idx >= 0) {
                    children.splice(idx, 0, child);
                    this._doAdd(child);
                }
            }
            return this;
        };
        Group.prototype.replace = function(oldChild, newChild) {
            var idx = (0, parcelRequire("bahqM")).indexOf(this._children, oldChild);
            if (idx >= 0) this.replaceAt(newChild, idx);
            return this;
        };
        Group.prototype.replaceAt = function(child, index) {
            var children = this._children;
            var old = children[index];
            if (child && child !== this && child.parent !== this && child !== old) {
                children[index] = child;
                old.parent = null;
                var zr = this.__zr;
                if (zr) old.removeSelfFromZr(zr);
                this._doAdd(child);
            }
            return this;
        };
        Group.prototype._doAdd = function(child) {
            if (child.parent) child.parent.remove(child);
            child.parent = this;
            var zr = this.__zr;
            if (zr && zr !== child.__zr) child.addSelfToZr(zr);
            zr && zr.refresh();
        };
        Group.prototype.remove = function(child) {
            var zr = this.__zr;
            var children = this._children;
            var idx = (0, parcelRequire("bahqM")).indexOf(children, child);
            if (idx < 0) return this;
            children.splice(idx, 1);
            child.parent = null;
            if (zr) child.removeSelfFromZr(zr);
            zr && zr.refresh();
            return this;
        };
        Group.prototype.removeAll = function() {
            var children = this._children;
            var zr = this.__zr;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (zr) child.removeSelfFromZr(zr);
                child.parent = null;
            }
            children.length = 0;
            return this;
        };
        Group.prototype.eachChild = function(cb, context) {
            var children = this._children;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                cb.call(context, child, i);
            }
            return this;
        };
        Group.prototype.traverse = function(cb, context) {
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                var stopped = cb.call(context, child);
                if (child.isGroup && !stopped) child.traverse(cb, context);
            }
            return this;
        };
        Group.prototype.addSelfToZr = function(zr) {
            _super.prototype.addSelfToZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                child.addSelfToZr(zr);
            }
        };
        Group.prototype.removeSelfFromZr = function(zr) {
            _super.prototype.removeSelfFromZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                child.removeSelfFromZr(zr);
            }
        };
        Group.prototype.getBoundingRect = function(includeChildren) {
            var tmpRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
            var children = includeChildren || this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child.ignore || child.invisible) continue;
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    (0, (0, parcelRequire("1E3E8")).default).applyTransform(tmpRect, childRect, transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            return rect || tmpRect;
        };
        return Group;
    }((0, (0, parcelRequire("7KVc5")).default));
    $37684daaaf15bf3f$var$Group.prototype.type = 'group';
    var $37684daaaf15bf3f$export$2e2bcd8739ae039 = $37684daaaf15bf3f$var$Group;
});
parcelRegister("bahqM", function(module, exports) {
    $parcel$export(module.exports, "$override", ()=>$820e264882d7264f$export$d35a04b83ea6803e);
    $parcel$export(module.exports, "guid", ()=>$820e264882d7264f$export$46e8f25c7328f77e);
    $parcel$export(module.exports, "logError", ()=>$820e264882d7264f$export$58da9968c3170cb1);
    $parcel$export(module.exports, "clone", ()=>$820e264882d7264f$export$9cd59f9826255e47);
    $parcel$export(module.exports, "isPrimitive", ()=>$820e264882d7264f$export$c3825b437cbdea5c);
    $parcel$export(module.exports, "isDom", ()=>$820e264882d7264f$export$9f57505b7bd8dae);
    $parcel$export(module.exports, "merge", ()=>$820e264882d7264f$export$4950aa0f605343fb);
    $parcel$export(module.exports, "isObject", ()=>$820e264882d7264f$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "isArray", ()=>$820e264882d7264f$export$43bee75e5e14138e);
    $parcel$export(module.exports, "isBuiltInObject", ()=>$820e264882d7264f$export$fa523b2c4941fd4f);
    $parcel$export(module.exports, "mergeAll", ()=>$820e264882d7264f$export$18aef43295bbe906);
    $parcel$export(module.exports, "extend", ()=>$820e264882d7264f$export$8b58be045bf06082);
    $parcel$export(module.exports, "defaults", ()=>$820e264882d7264f$export$ebe90cb607ad99e);
    $parcel$export(module.exports, "keys", ()=>$820e264882d7264f$export$ed97f33186d4b816);
    $parcel$export(module.exports, "createCanvas", ()=>$820e264882d7264f$export$cd3d1f114b139967);
    $parcel$export(module.exports, "indexOf", ()=>$820e264882d7264f$export$305f7d4e9d4624f2);
    $parcel$export(module.exports, "inherits", ()=>$820e264882d7264f$export$69f1b2dcda23c5f8);
    $parcel$export(module.exports, "mixin", ()=>$820e264882d7264f$export$e36fc9d62a853069);
    $parcel$export(module.exports, "isArrayLike", ()=>$820e264882d7264f$export$1e2f57719e155213);
    $parcel$export(module.exports, "each", ()=>$820e264882d7264f$export$79b2f7037acddd43);
    $parcel$export(module.exports, "map", ()=>$820e264882d7264f$export$871de8747c9eaa88);
    $parcel$export(module.exports, "slice", ()=>$820e264882d7264f$export$58adb3bec8346d0f);
    $parcel$export(module.exports, "reduce", ()=>$820e264882d7264f$export$533b26079ad0b4b);
    $parcel$export(module.exports, "filter", ()=>$820e264882d7264f$export$3dea766d36a8935f);
    $parcel$export(module.exports, "find", ()=>$820e264882d7264f$export$71aa6c912b956294);
    $parcel$export(module.exports, "bind", ()=>$820e264882d7264f$export$2385a24977818dd0);
    $parcel$export(module.exports, "isFunction", ()=>$820e264882d7264f$export$f6e2535fb5126e54);
    $parcel$export(module.exports, "curry", ()=>$820e264882d7264f$export$c3095a23b368d1f2);
    $parcel$export(module.exports, "isString", ()=>$820e264882d7264f$export$844ec244b1367d54);
    $parcel$export(module.exports, "isStringSafe", ()=>$820e264882d7264f$export$29d0bb2a4e07b252);
    $parcel$export(module.exports, "isNumber", ()=>$820e264882d7264f$export$7e4aa119212bc614);
    $parcel$export(module.exports, "isTypedArray", ()=>$820e264882d7264f$export$b119cc7e1840e59c);
    $parcel$export(module.exports, "isGradientObject", ()=>$820e264882d7264f$export$fa2c283003ed971c);
    $parcel$export(module.exports, "isImagePatternObject", ()=>$820e264882d7264f$export$a49bbf3a55dcef7b);
    $parcel$export(module.exports, "isRegExp", ()=>$820e264882d7264f$export$49841c62b9eff15);
    $parcel$export(module.exports, "eqNaN", ()=>$820e264882d7264f$export$7d667b9a0c48c975);
    $parcel$export(module.exports, "retrieve", ()=>$820e264882d7264f$export$8a4d17b6e8486e66);
    $parcel$export(module.exports, "retrieve2", ()=>$820e264882d7264f$export$995e01f2f5c9d030);
    $parcel$export(module.exports, "retrieve3", ()=>$820e264882d7264f$export$2e94551289abb95b);
    $parcel$export(module.exports, "normalizeCssArray", ()=>$820e264882d7264f$export$f3a38102c49f4268);
    $parcel$export(module.exports, "assert", ()=>$820e264882d7264f$export$a7a9523472993e97);
    $parcel$export(module.exports, "trim", ()=>$820e264882d7264f$export$87c2784dc9fc4ab);
    $parcel$export(module.exports, "setAsPrimitive", ()=>$820e264882d7264f$export$112e66431016387b);
    $parcel$export(module.exports, "HashMap", ()=>$820e264882d7264f$export$60ef0b43d585640a);
    $parcel$export(module.exports, "createHashMap", ()=>$820e264882d7264f$export$55f8aa7ef875b0a4);
    $parcel$export(module.exports, "concatArray", ()=>$820e264882d7264f$export$4fd8af2c48c43416);
    $parcel$export(module.exports, "createObject", ()=>$820e264882d7264f$export$79c7e160a7743efd);
    $parcel$export(module.exports, "hasOwn", ()=>$820e264882d7264f$export$b5a638e9b3fff9f3);
    $parcel$export(module.exports, "noop", ()=>$820e264882d7264f$export$8793edee2d425525);
    var $820e264882d7264f$var$BUILTIN_OBJECT = {
        '[object Function]': true,
        '[object RegExp]': true,
        '[object Date]': true,
        '[object Error]': true,
        '[object CanvasGradient]': true,
        '[object CanvasPattern]': true,
        '[object Image]': true,
        '[object Canvas]': true
    };
    var $820e264882d7264f$var$TYPED_ARRAY = {
        '[object Int8Array]': true,
        '[object Uint8Array]': true,
        '[object Uint8ClampedArray]': true,
        '[object Int16Array]': true,
        '[object Uint16Array]': true,
        '[object Int32Array]': true,
        '[object Uint32Array]': true,
        '[object Float32Array]': true,
        '[object Float64Array]': true
    };
    var $820e264882d7264f$var$objToString = Object.prototype.toString;
    var $820e264882d7264f$var$arrayProto = Array.prototype;
    var $820e264882d7264f$var$nativeForEach = $820e264882d7264f$var$arrayProto.forEach;
    var $820e264882d7264f$var$nativeFilter = $820e264882d7264f$var$arrayProto.filter;
    var $820e264882d7264f$var$nativeSlice = $820e264882d7264f$var$arrayProto.slice;
    var $820e264882d7264f$var$nativeMap = $820e264882d7264f$var$arrayProto.map;
    var $820e264882d7264f$var$ctorFunction = (function() {}).constructor;
    var $820e264882d7264f$var$protoFunction = $820e264882d7264f$var$ctorFunction ? $820e264882d7264f$var$ctorFunction.prototype : null;
    var $820e264882d7264f$var$protoKey = '__proto__';
    var $820e264882d7264f$var$methods = {};
    function $820e264882d7264f$export$d35a04b83ea6803e(name, fn) {
        $820e264882d7264f$var$methods[name] = fn;
    }
    var $820e264882d7264f$var$idStart = 0x0907;
    function $820e264882d7264f$export$46e8f25c7328f77e() {
        return $820e264882d7264f$var$idStart++;
    }
    function $820e264882d7264f$export$58da9968c3170cb1() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (typeof console !== 'undefined') console.error.apply(console, args);
    }
    function $820e264882d7264f$export$9cd59f9826255e47(source) {
        if (source == null || typeof source !== 'object') return source;
        var result = source;
        var typeStr = $820e264882d7264f$var$objToString.call(source);
        if (typeStr === '[object Array]') {
            if (!$820e264882d7264f$export$c3825b437cbdea5c(source)) {
                result = [];
                for(var i = 0, len = source.length; i < len; i++)result[i] = $820e264882d7264f$export$9cd59f9826255e47(source[i]);
            }
        } else if ($820e264882d7264f$var$TYPED_ARRAY[typeStr]) {
            if (!$820e264882d7264f$export$c3825b437cbdea5c(source)) {
                var Ctor = source.constructor;
                if (Ctor.from) result = Ctor.from(source);
                else {
                    result = new Ctor(source.length);
                    for(var i = 0, len = source.length; i < len; i++)result[i] = $820e264882d7264f$export$9cd59f9826255e47(source[i]);
                }
            }
        } else if (!$820e264882d7264f$var$BUILTIN_OBJECT[typeStr] && !$820e264882d7264f$export$c3825b437cbdea5c(source) && !$820e264882d7264f$export$9f57505b7bd8dae(source)) {
            result = {};
            for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) result[key] = $820e264882d7264f$export$9cd59f9826255e47(source[key]);
        }
        return result;
    }
    function $820e264882d7264f$export$4950aa0f605343fb(target, source, overwrite) {
        if (!$820e264882d7264f$export$a6cdc56e425d0d0a(source) || !$820e264882d7264f$export$a6cdc56e425d0d0a(target)) return overwrite ? $820e264882d7264f$export$9cd59f9826255e47(source) : target;
        for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) {
            var targetProp = target[key];
            var sourceProp = source[key];
            if ($820e264882d7264f$export$a6cdc56e425d0d0a(sourceProp) && $820e264882d7264f$export$a6cdc56e425d0d0a(targetProp) && !$820e264882d7264f$export$43bee75e5e14138e(sourceProp) && !$820e264882d7264f$export$43bee75e5e14138e(targetProp) && !$820e264882d7264f$export$9f57505b7bd8dae(sourceProp) && !$820e264882d7264f$export$9f57505b7bd8dae(targetProp) && !$820e264882d7264f$export$fa523b2c4941fd4f(sourceProp) && !$820e264882d7264f$export$fa523b2c4941fd4f(targetProp) && !$820e264882d7264f$export$c3825b437cbdea5c(sourceProp) && !$820e264882d7264f$export$c3825b437cbdea5c(targetProp)) $820e264882d7264f$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
            else if (overwrite || !(key in target)) target[key] = $820e264882d7264f$export$9cd59f9826255e47(source[key]);
        }
        return target;
    }
    function $820e264882d7264f$export$18aef43295bbe906(targetAndSources, overwrite) {
        var result = targetAndSources[0];
        for(var i = 1, len = targetAndSources.length; i < len; i++)result = $820e264882d7264f$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
        return result;
    }
    function $820e264882d7264f$export$8b58be045bf06082(target, source) {
        if (Object.assign) Object.assign(target, source);
        else {
            for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) target[key] = source[key];
        }
        return target;
    }
    function $820e264882d7264f$export$ebe90cb607ad99e(target, source, overlay) {
        var keysArr = $820e264882d7264f$export$ed97f33186d4b816(source);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
        }
        return target;
    }
    var $820e264882d7264f$export$cd3d1f114b139967 = function() {
        return $820e264882d7264f$var$methods.createCanvas();
    };
    $820e264882d7264f$var$methods.createCanvas = function() {
        return document.createElement('canvas');
    };
    function $820e264882d7264f$export$305f7d4e9d4624f2(array, value) {
        if (array) {
            if (array.indexOf) return array.indexOf(value);
            for(var i = 0, len = array.length; i < len; i++){
                if (array[i] === value) return i;
            }
        }
        return -1;
    }
    function $820e264882d7264f$export$69f1b2dcda23c5f8(clazz, baseClazz) {
        var clazzPrototype = clazz.prototype;
        function F() {}
        F.prototype = baseClazz.prototype;
        clazz.prototype = new F();
        for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
        clazz.prototype.constructor = clazz;
        clazz.superClass = baseClazz;
    }
    function $820e264882d7264f$export$e36fc9d62a853069(target, source, override) {
        target = 'prototype' in target ? target.prototype : target;
        source = 'prototype' in source ? source.prototype : source;
        if (Object.getOwnPropertyNames) {
            var keyList = Object.getOwnPropertyNames(source);
            for(var i = 0; i < keyList.length; i++){
                var key = keyList[i];
                if (key !== 'constructor') {
                    if (override ? source[key] != null : target[key] == null) target[key] = source[key];
                }
            }
        } else $820e264882d7264f$export$ebe90cb607ad99e(target, source, override);
    }
    function $820e264882d7264f$export$1e2f57719e155213(data) {
        if (!data) return false;
        if (typeof data === 'string') return false;
        return typeof data.length === 'number';
    }
    function $820e264882d7264f$export$79b2f7037acddd43(arr, cb, context) {
        if (!(arr && cb)) return;
        if (arr.forEach && arr.forEach === $820e264882d7264f$var$nativeForEach) arr.forEach(cb, context);
        else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
        else {
            for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
        }
    }
    function $820e264882d7264f$export$871de8747c9eaa88(arr, cb, context) {
        if (!arr) return [];
        if (!cb) return $820e264882d7264f$export$58adb3bec8346d0f(arr);
        if (arr.map && arr.map === $820e264882d7264f$var$nativeMap) return arr.map(cb, context);
        else {
            var result = [];
            for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
            return result;
        }
    }
    function $820e264882d7264f$export$533b26079ad0b4b(arr, cb, memo, context) {
        if (!(arr && cb)) return;
        for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
        return memo;
    }
    function $820e264882d7264f$export$3dea766d36a8935f(arr, cb, context) {
        if (!arr) return [];
        if (!cb) return $820e264882d7264f$export$58adb3bec8346d0f(arr);
        if (arr.filter && arr.filter === $820e264882d7264f$var$nativeFilter) return arr.filter(cb, context);
        else {
            var result = [];
            for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
            return result;
        }
    }
    function $820e264882d7264f$export$71aa6c912b956294(arr, cb, context) {
        if (!(arr && cb)) return;
        for(var i = 0, len = arr.length; i < len; i++){
            if (cb.call(context, arr[i], i, arr)) return arr[i];
        }
    }
    function $820e264882d7264f$export$ed97f33186d4b816(obj) {
        if (!obj) return [];
        if (Object.keys) return Object.keys(obj);
        var keyList = [];
        for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
        return keyList;
    }
    function $820e264882d7264f$var$bindPolyfill(func, context) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        return function() {
            return func.apply(context, args.concat($820e264882d7264f$var$nativeSlice.call(arguments)));
        };
    }
    var $820e264882d7264f$export$2385a24977818dd0 = $820e264882d7264f$var$protoFunction && $820e264882d7264f$export$f6e2535fb5126e54($820e264882d7264f$var$protoFunction.bind) ? $820e264882d7264f$var$protoFunction.call.bind($820e264882d7264f$var$protoFunction.bind) : $820e264882d7264f$var$bindPolyfill;
    function $820e264882d7264f$export$c3095a23b368d1f2(func) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return function() {
            return func.apply(this, args.concat($820e264882d7264f$var$nativeSlice.call(arguments)));
        };
    }
    function $820e264882d7264f$export$43bee75e5e14138e(value) {
        if (Array.isArray) return Array.isArray(value);
        return $820e264882d7264f$var$objToString.call(value) === '[object Array]';
    }
    function $820e264882d7264f$export$f6e2535fb5126e54(value) {
        return typeof value === 'function';
    }
    function $820e264882d7264f$export$844ec244b1367d54(value) {
        return typeof value === 'string';
    }
    function $820e264882d7264f$export$29d0bb2a4e07b252(value) {
        return $820e264882d7264f$var$objToString.call(value) === '[object String]';
    }
    function $820e264882d7264f$export$7e4aa119212bc614(value) {
        return typeof value === 'number';
    }
    function $820e264882d7264f$export$a6cdc56e425d0d0a(value) {
        var type = typeof value;
        return type === 'function' || !!value && type === 'object';
    }
    function $820e264882d7264f$export$fa523b2c4941fd4f(value) {
        return !!$820e264882d7264f$var$BUILTIN_OBJECT[$820e264882d7264f$var$objToString.call(value)];
    }
    function $820e264882d7264f$export$b119cc7e1840e59c(value) {
        return !!$820e264882d7264f$var$TYPED_ARRAY[$820e264882d7264f$var$objToString.call(value)];
    }
    function $820e264882d7264f$export$9f57505b7bd8dae(value) {
        return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
    }
    function $820e264882d7264f$export$fa2c283003ed971c(value) {
        return value.colorStops != null;
    }
    function $820e264882d7264f$export$a49bbf3a55dcef7b(value) {
        return value.image != null;
    }
    function $820e264882d7264f$export$49841c62b9eff15(value) {
        return $820e264882d7264f$var$objToString.call(value) === '[object RegExp]';
    }
    function $820e264882d7264f$export$7d667b9a0c48c975(value) {
        return value !== value;
    }
    function $820e264882d7264f$export$8a4d17b6e8486e66() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        for(var i = 0, len = args.length; i < len; i++){
            if (args[i] != null) return args[i];
        }
    }
    function $820e264882d7264f$export$995e01f2f5c9d030(value0, value1) {
        return value0 != null ? value0 : value1;
    }
    function $820e264882d7264f$export$2e94551289abb95b(value0, value1, value2) {
        return value0 != null ? value0 : value1 != null ? value1 : value2;
    }
    function $820e264882d7264f$export$58adb3bec8346d0f(arr) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return $820e264882d7264f$var$nativeSlice.apply(arr, args);
    }
    function $820e264882d7264f$export$f3a38102c49f4268(val) {
        if (typeof val === 'number') return [
            val,
            val,
            val,
            val
        ];
        var len = val.length;
        if (len === 2) return [
            val[0],
            val[1],
            val[0],
            val[1]
        ];
        else if (len === 3) return [
            val[0],
            val[1],
            val[2],
            val[1]
        ];
        return val;
    }
    function $820e264882d7264f$export$a7a9523472993e97(condition, message) {
        if (!condition) throw new Error(message);
    }
    function $820e264882d7264f$export$87c2784dc9fc4ab(str) {
        if (str == null) return null;
        else if (typeof str.trim === 'function') return str.trim();
        else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
    var $820e264882d7264f$var$primitiveKey = '__ec_primitive__';
    function $820e264882d7264f$export$112e66431016387b(obj) {
        obj[$820e264882d7264f$var$primitiveKey] = true;
    }
    function $820e264882d7264f$export$c3825b437cbdea5c(obj) {
        return obj[$820e264882d7264f$var$primitiveKey];
    }
    var $820e264882d7264f$export$60ef0b43d585640a = function() {
        function HashMap(obj) {
            this.data = {};
            var isArr = $820e264882d7264f$export$43bee75e5e14138e(obj);
            this.data = {};
            var thisMap = this;
            obj instanceof HashMap ? obj.each(visit) : obj && $820e264882d7264f$export$79b2f7037acddd43(obj, visit);
            function visit(value, key) {
                isArr ? thisMap.set(value, key) : thisMap.set(key, value);
            }
        }
        HashMap.prototype.get = function(key) {
            return this.data.hasOwnProperty(key) ? this.data[key] : null;
        };
        HashMap.prototype.set = function(key, value) {
            return this.data[key] = value;
        };
        HashMap.prototype.each = function(cb, context) {
            for(var key in this.data)if (this.data.hasOwnProperty(key)) cb.call(context, this.data[key], key);
        };
        HashMap.prototype.keys = function() {
            return $820e264882d7264f$export$ed97f33186d4b816(this.data);
        };
        HashMap.prototype.removeKey = function(key) {
            delete this.data[key];
        };
        return HashMap;
    }();
    function $820e264882d7264f$export$55f8aa7ef875b0a4(obj) {
        return new $820e264882d7264f$export$60ef0b43d585640a(obj);
    }
    function $820e264882d7264f$export$4fd8af2c48c43416(a, b) {
        var newArray = new a.constructor(a.length + b.length);
        for(var i = 0; i < a.length; i++)newArray[i] = a[i];
        var offset = a.length;
        for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
        return newArray;
    }
    function $820e264882d7264f$export$79c7e160a7743efd(proto, properties) {
        var obj;
        if (Object.create) obj = Object.create(proto);
        else {
            var StyleCtor = function() {};
            StyleCtor.prototype = proto;
            obj = new StyleCtor();
        }
        if (properties) $820e264882d7264f$export$8b58be045bf06082(obj, properties);
        return obj;
    }
    function $820e264882d7264f$export$b5a638e9b3fff9f3(own, prop) {
        return own.hasOwnProperty(prop);
    }
    function $820e264882d7264f$export$8793edee2d425525() {}
});
parcelRegister("7KVc5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a5931cff6ff005a$export$2e2bcd8739ae039);
    var $e6gef;
    var $hb2y5;
    var $1E3E8;
    var $bRKv5;
    var $b7ZX8;
    var $bahqM;
    var $7y1my;
    var $d6udH;
    var $hZfwb;
    var $aVawM;
    var $5a5931cff6ff005a$export$97b5e845c7286801 = '__zr_normal__';
    var $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS = [
        'x',
        'y',
        'scaleX',
        'scaleY',
        'originX',
        'originY',
        'rotation',
        'ignore'
    ];
    var $5a5931cff6ff005a$var$DEFAULT_ANIMATABLE_MAP = {
        x: true,
        y: true,
        scaleX: true,
        scaleY: true,
        originX: true,
        originY: true,
        rotation: true,
        ignore: false
    };
    var $5a5931cff6ff005a$var$tmpTextPosCalcRes = {};
    var $5a5931cff6ff005a$var$tmpBoundingRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
    var $5a5931cff6ff005a$var$Element = function() {
        function Element(props) {
            this.id = (0, (0, parcelRequire("bahqM")).guid)();
            this.animators = [];
            this.currentStates = [];
            this.states = {};
            this._init(props);
        }
        Element.prototype._init = function(props) {
            this.attr(props);
        };
        Element.prototype.drift = function(dx, dy, e) {
            switch(this.draggable){
                case 'horizontal':
                    dy = 0;
                    break;
                case 'vertical':
                    dx = 0;
                    break;
            }
            var m = this.transform;
            if (!m) m = this.transform = [
                1,
                0,
                0,
                1,
                0,
                0
            ];
            m[4] += dx;
            m[5] += dy;
            this.decomposeTransform();
            this.markRedraw();
        };
        Element.prototype.beforeUpdate = function() {};
        Element.prototype.afterUpdate = function() {};
        Element.prototype.update = function() {
            this.updateTransform();
            if (this.__dirty) this.updateInnerText();
        };
        Element.prototype.updateInnerText = function(forceUpdate) {
            var textEl = this._textContent;
            if (textEl && (!textEl.ignore || forceUpdate)) {
                if (!this.textConfig) this.textConfig = {};
                var textConfig = this.textConfig;
                var isLocal = textConfig.local;
                var innerTransformable = textEl.innerTransformable;
                var textAlign = void 0;
                var textVerticalAlign = void 0;
                var textStyleChanged = false;
                innerTransformable.parent = isLocal ? this : null;
                var innerOrigin = false;
                innerTransformable.copyTransform(textEl);
                if (textConfig.position != null) {
                    var layoutRect = $5a5931cff6ff005a$var$tmpBoundingRect;
                    if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                    else layoutRect.copy(this.getBoundingRect());
                    if (!isLocal) layoutRect.applyTransform(this.transform);
                    if (this.calculateTextPosition) this.calculateTextPosition($5a5931cff6ff005a$var$tmpTextPosCalcRes, textConfig, layoutRect);
                    else (0, (0, parcelRequire("b7ZX8")).calculateTextPosition)($5a5931cff6ff005a$var$tmpTextPosCalcRes, textConfig, layoutRect);
                    innerTransformable.x = $5a5931cff6ff005a$var$tmpTextPosCalcRes.x;
                    innerTransformable.y = $5a5931cff6ff005a$var$tmpTextPosCalcRes.y;
                    textAlign = $5a5931cff6ff005a$var$tmpTextPosCalcRes.align;
                    textVerticalAlign = $5a5931cff6ff005a$var$tmpTextPosCalcRes.verticalAlign;
                    var textOrigin = textConfig.origin;
                    if (textOrigin && textConfig.rotation != null) {
                        var relOriginX = void 0;
                        var relOriginY = void 0;
                        if (textOrigin === 'center') {
                            relOriginX = layoutRect.width * 0.5;
                            relOriginY = layoutRect.height * 0.5;
                        } else {
                            relOriginX = (0, (0, parcelRequire("b7ZX8")).parsePercent)(textOrigin[0], layoutRect.width);
                            relOriginY = (0, (0, parcelRequire("b7ZX8")).parsePercent)(textOrigin[1], layoutRect.height);
                        }
                        innerOrigin = true;
                        innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                        innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                    }
                }
                if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
                var textOffset = textConfig.offset;
                if (textOffset) {
                    innerTransformable.x += textOffset[0];
                    innerTransformable.y += textOffset[1];
                    if (!innerOrigin) {
                        innerTransformable.originX = -textOffset[0];
                        innerTransformable.originY = -textOffset[1];
                    }
                }
                var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
                var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
                var textFill = void 0;
                var textStroke = void 0;
                var autoStroke = void 0;
                if (isInside && this.canBeInsideText()) {
                    textFill = textConfig.insideFill;
                    textStroke = textConfig.insideStroke;
                    if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                    if (textStroke == null || textStroke === 'auto') {
                        textStroke = this.getInsideTextStroke(textFill);
                        autoStroke = true;
                    }
                } else {
                    textFill = textConfig.outsideFill;
                    textStroke = textConfig.outsideStroke;
                    if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                    if (textStroke == null || textStroke === 'auto') {
                        textStroke = this.getOutsideStroke(textFill);
                        autoStroke = true;
                    }
                }
                textFill = textFill || '#000';
                if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                    textStyleChanged = true;
                    innerTextDefaultStyle.fill = textFill;
                    innerTextDefaultStyle.stroke = textStroke;
                    innerTextDefaultStyle.autoStroke = autoStroke;
                    innerTextDefaultStyle.align = textAlign;
                    innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                    textEl.setDefaultTextStyle(innerTextDefaultStyle);
                }
                textEl.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
                if (textStyleChanged) textEl.dirtyStyle(true);
            }
        };
        Element.prototype.canBeInsideText = function() {
            return true;
        };
        Element.prototype.getInsideTextFill = function() {
            return '#fff';
        };
        Element.prototype.getInsideTextStroke = function(textFill) {
            return '#000';
        };
        Element.prototype.getOutsideFill = function() {
            return this.__zr && this.__zr.isDarkMode() ? (0, (0, parcelRequire("7y1my")).LIGHT_LABEL_COLOR) : (0, (0, parcelRequire("7y1my")).DARK_LABEL_COLOR);
        };
        Element.prototype.getOutsideStroke = function(textFill) {
            var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
            var colorArr = typeof backgroundColor === 'string' && (0, (0, parcelRequire("d6udH")).parse)(backgroundColor);
            if (!colorArr) colorArr = [
                255,
                255,
                255,
                1
            ];
            var alpha = colorArr[3];
            var isDark = this.__zr.isDarkMode();
            for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
            colorArr[3] = 1;
            return (0, (0, parcelRequire("d6udH")).stringify)(colorArr, 'rgba');
        };
        Element.prototype.traverse = function(cb, context) {};
        Element.prototype.attrKV = function(key, value) {
            if (key === 'textConfig') this.setTextConfig(value);
            else if (key === 'textContent') this.setTextContent(value);
            else if (key === 'clipPath') this.setClipPath(value);
            else if (key === 'extra') {
                this.extra = this.extra || {};
                (0, (0, parcelRequire("bahqM")).extend)(this.extra, value);
            } else this[key] = value;
        };
        Element.prototype.hide = function() {
            this.ignore = true;
            this.markRedraw();
        };
        Element.prototype.show = function() {
            this.ignore = false;
            this.markRedraw();
        };
        Element.prototype.attr = function(keyOrObj, value) {
            if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
            else if ((0, (0, parcelRequire("bahqM")).isObject)(keyOrObj)) {
                var obj = keyOrObj;
                var keysArr = (0, (0, parcelRequire("bahqM")).keys)(obj);
                for(var i = 0; i < keysArr.length; i++){
                    var key = keysArr[i];
                    this.attrKV(key, keyOrObj[key]);
                }
            }
            this.markRedraw();
            return this;
        };
        Element.prototype.saveCurrentToNormalState = function(toState) {
            this._innerSaveToNormal(toState);
            var normalState = this._normalState;
            for(var i = 0; i < this.animators.length; i++){
                var animator = this.animators[i];
                var fromStateTransition = animator.__fromStateTransition;
                if (fromStateTransition && fromStateTransition !== $5a5931cff6ff005a$export$97b5e845c7286801) continue;
                var targetName = animator.targetName;
                var target = targetName ? normalState[targetName] : normalState;
                animator.saveFinalToTarget(target);
            }
        };
        Element.prototype._innerSaveToNormal = function(toState) {
            var normalState = this._normalState;
            if (!normalState) normalState = this._normalState = {};
            if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
            this._savePrimaryToNormal(toState, normalState, $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS);
        };
        Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
            for(var i = 0; i < primaryKeys.length; i++){
                var key = primaryKeys[i];
                if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
            }
        };
        Element.prototype.hasState = function() {
            return this.currentStates.length > 0;
        };
        Element.prototype.getState = function(name) {
            return this.states[name];
        };
        Element.prototype.ensureState = function(name) {
            var states = this.states;
            if (!states[name]) states[name] = {};
            return states[name];
        };
        Element.prototype.clearStates = function(noAnimation) {
            this.useState($5a5931cff6ff005a$export$97b5e845c7286801, false, noAnimation);
        };
        Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
            var toNormalState = stateName === $5a5931cff6ff005a$export$97b5e845c7286801;
            var hasStates = this.hasState();
            if (!hasStates && toNormalState) return;
            var currentStates = this.currentStates;
            var animationCfg = this.stateTransition;
            if ((0, (0, parcelRequire("bahqM")).indexOf)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
            var state;
            if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
            if (!state) state = this.states && this.states[stateName];
            if (!state && !toNormalState) {
                (0, (0, parcelRequire("bahqM")).logError)("State " + stateName + " not exists.");
                return;
            }
            if (!toNormalState) this.saveCurrentToNormalState(state);
            var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
            if (toNormalState) {
                this.currentStates = [];
                this._normalState = {};
            } else if (!keepCurrentStates) this.currentStates = [
                stateName
            ];
            else this.currentStates.push(stateName);
            this._updateAnimationTargets();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            }
            return state;
        };
        Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
            if (!states.length) this.clearStates();
            else {
                var stateObjects = [];
                var currentStates = this.currentStates;
                var len = states.length;
                var notChange = len === currentStates.length;
                if (notChange) {
                    for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                        notChange = false;
                        break;
                    }
                }
                if (notChange) return;
                for(var i = 0; i < len; i++){
                    var stateName = states[i];
                    var stateObj = void 0;
                    if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                    if (!stateObj) stateObj = this.states[stateName];
                    if (stateObj) stateObjects.push(stateObj);
                }
                var lastStateObj = stateObjects[len - 1];
                var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
                if (useHoverLayer) this._toggleHoverLayerFlag(true);
                var mergedState = this._mergeStates(stateObjects);
                var animationCfg = this.stateTransition;
                this.saveCurrentToNormalState(mergedState);
                this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
                var textContent = this._textContent;
                var textGuide = this._textGuide;
                if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
                if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
                this._updateAnimationTargets();
                this.currentStates = states.slice();
                this.markRedraw();
                if (!useHoverLayer && this.__inHover) {
                    this._toggleHoverLayerFlag(false);
                    this.__dirty &= ~(0, (0, parcelRequire("aVawM")).REDRAW_BIT);
                }
            }
        };
        Element.prototype._updateAnimationTargets = function() {
            for(var i = 0; i < this.animators.length; i++){
                var animator = this.animators[i];
                if (animator.targetName) animator.changeTarget(this[animator.targetName]);
            }
        };
        Element.prototype.removeState = function(state) {
            var idx = (0, (0, parcelRequire("bahqM")).indexOf)(this.currentStates, state);
            if (idx >= 0) {
                var currentStates = this.currentStates.slice();
                currentStates.splice(idx, 1);
                this.useStates(currentStates);
            }
        };
        Element.prototype.replaceState = function(oldState, newState, forceAdd) {
            var currentStates = this.currentStates.slice();
            var idx = (0, (0, parcelRequire("bahqM")).indexOf)(currentStates, oldState);
            var newStateExists = (0, (0, parcelRequire("bahqM")).indexOf)(currentStates, newState) >= 0;
            if (idx >= 0) {
                if (!newStateExists) currentStates[idx] = newState;
                else currentStates.splice(idx, 1);
            } else if (forceAdd && !newStateExists) currentStates.push(newState);
            this.useStates(currentStates);
        };
        Element.prototype.toggleState = function(state, enable) {
            if (enable) this.useState(state, true);
            else this.removeState(state);
        };
        Element.prototype._mergeStates = function(states) {
            var mergedState = {};
            var mergedTextConfig;
            for(var i = 0; i < states.length; i++){
                var state = states[i];
                (0, (0, parcelRequire("bahqM")).extend)(mergedState, state);
                if (state.textConfig) {
                    mergedTextConfig = mergedTextConfig || {};
                    (0, (0, parcelRequire("bahqM")).extend)(mergedTextConfig, state.textConfig);
                }
            }
            if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
            return mergedState;
        };
        Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
            var needsRestoreToNormal = !(state && keepCurrentStates);
            if (state && state.textConfig) {
                this.textConfig = (0, (0, parcelRequire("bahqM")).extend)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
                (0, (0, parcelRequire("bahqM")).extend)(this.textConfig, state.textConfig);
            } else if (needsRestoreToNormal) {
                if (normalState.textConfig) this.textConfig = normalState.textConfig;
            }
            var transitionTarget = {};
            var hasTransition = false;
            for(var i = 0; i < $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS.length; i++){
                var key = $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS[i];
                var propNeedsTransition = transition && $5a5931cff6ff005a$var$DEFAULT_ANIMATABLE_MAP[key];
                if (state && state[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = state[key];
                    } else this[key] = state[key];
                } else if (needsRestoreToNormal) {
                    if (normalState[key] != null) {
                        if (propNeedsTransition) {
                            hasTransition = true;
                            transitionTarget[key] = normalState[key];
                        } else this[key] = normalState[key];
                    }
                }
            }
            if (!transition) for(var i = 0; i < this.animators.length; i++){
                var animator = this.animators[i];
                var targetName = animator.targetName;
                animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
            }
            if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
        };
        Element.prototype._attachComponent = function(componentEl) {
            if (componentEl.__zr && !componentEl.__hostTarget) throw new Error('Text element has been added to zrender.');
            if (componentEl === this) throw new Error('Recursive component attachment.');
            var zr = this.__zr;
            if (zr) componentEl.addSelfToZr(zr);
            componentEl.__zr = zr;
            componentEl.__hostTarget = this;
        };
        Element.prototype._detachComponent = function(componentEl) {
            if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
            componentEl.__zr = null;
            componentEl.__hostTarget = null;
        };
        Element.prototype.getClipPath = function() {
            return this._clipPath;
        };
        Element.prototype.setClipPath = function(clipPath) {
            if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
            this._attachComponent(clipPath);
            this._clipPath = clipPath;
            this.markRedraw();
        };
        Element.prototype.removeClipPath = function() {
            var clipPath = this._clipPath;
            if (clipPath) {
                this._detachComponent(clipPath);
                this._clipPath = null;
                this.markRedraw();
            }
        };
        Element.prototype.getTextContent = function() {
            return this._textContent;
        };
        Element.prototype.setTextContent = function(textEl) {
            var previousTextContent = this._textContent;
            if (previousTextContent === textEl) return;
            if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
            if (textEl.__zr && !textEl.__hostTarget) throw new Error('Text element has been added to zrender.');
            textEl.innerTransformable = new (0, (0, parcelRequire("e6gef")).default)();
            this._attachComponent(textEl);
            this._textContent = textEl;
            this.markRedraw();
        };
        Element.prototype.setTextConfig = function(cfg) {
            if (!this.textConfig) this.textConfig = {};
            (0, (0, parcelRequire("bahqM")).extend)(this.textConfig, cfg);
            this.markRedraw();
        };
        Element.prototype.removeTextConfig = function() {
            this.textConfig = null;
            this.markRedraw();
        };
        Element.prototype.removeTextContent = function() {
            var textEl = this._textContent;
            if (textEl) {
                textEl.innerTransformable = null;
                this._detachComponent(textEl);
                this._textContent = null;
                this._innerTextDefaultStyle = null;
                this.markRedraw();
            }
        };
        Element.prototype.getTextGuideLine = function() {
            return this._textGuide;
        };
        Element.prototype.setTextGuideLine = function(guideLine) {
            if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
            this._attachComponent(guideLine);
            this._textGuide = guideLine;
            this.markRedraw();
        };
        Element.prototype.removeTextGuideLine = function() {
            var textGuide = this._textGuide;
            if (textGuide) {
                this._detachComponent(textGuide);
                this._textGuide = null;
                this.markRedraw();
            }
        };
        Element.prototype.markRedraw = function() {
            this.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            var zr = this.__zr;
            if (zr) {
                if (this.__inHover) zr.refreshHover();
                else zr.refresh();
            }
            if (this.__hostTarget) this.__hostTarget.markRedraw();
        };
        Element.prototype.dirty = function() {
            this.markRedraw();
        };
        Element.prototype._toggleHoverLayerFlag = function(inHover) {
            this.__inHover = inHover;
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.__inHover = inHover;
            if (textGuide) textGuide.__inHover = inHover;
        };
        Element.prototype.addSelfToZr = function(zr) {
            if (this.__zr === zr) return;
            this.__zr = zr;
            var animators = this.animators;
            if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
            if (this._clipPath) this._clipPath.addSelfToZr(zr);
            if (this._textContent) this._textContent.addSelfToZr(zr);
            if (this._textGuide) this._textGuide.addSelfToZr(zr);
        };
        Element.prototype.removeSelfFromZr = function(zr) {
            if (!this.__zr) return;
            this.__zr = null;
            var animators = this.animators;
            if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
            if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
            if (this._textContent) this._textContent.removeSelfFromZr(zr);
            if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
        };
        Element.prototype.animate = function(key, loop) {
            var target = key ? this[key] : this;
            if (!target) {
                (0, (0, parcelRequire("bahqM")).logError)('Property "' + key + '" is not existed in element ' + this.id);
                return;
            }
            var animator = new (0, (0, parcelRequire("hb2y5")).default)(target, loop);
            this.addAnimator(animator, key);
            return animator;
        };
        Element.prototype.addAnimator = function(animator, key) {
            var zr = this.__zr;
            var el = this;
            animator.during(function() {
                el.updateDuringAnimation(key);
            }).done(function() {
                var animators = el.animators;
                var idx = (0, (0, parcelRequire("bahqM")).indexOf)(animators, animator);
                if (idx >= 0) animators.splice(idx, 1);
            });
            this.animators.push(animator);
            if (zr) zr.animation.addAnimator(animator);
            zr && zr.wakeUp();
        };
        Element.prototype.updateDuringAnimation = function(key) {
            this.markRedraw();
        };
        Element.prototype.stopAnimation = function(scope, forwardToLast) {
            var animators = this.animators;
            var len = animators.length;
            var leftAnimators = [];
            for(var i = 0; i < len; i++){
                var animator = animators[i];
                if (!scope || scope === animator.scope) animator.stop(forwardToLast);
                else leftAnimators.push(animator);
            }
            this.animators = leftAnimators;
            return this;
        };
        Element.prototype.animateTo = function(target, cfg, animationProps) {
            $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps);
        };
        Element.prototype.animateFrom = function(target, cfg, animationProps) {
            $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps, true);
        };
        Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
            var animators = $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps);
            for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
        };
        Element.prototype.getBoundingRect = function() {
            return null;
        };
        Element.prototype.getPaintRect = function() {
            return null;
        };
        Element.initDefaultProps = function() {
            var elProto = Element.prototype;
            elProto.type = 'element';
            elProto.name = '';
            elProto.ignore = false;
            elProto.silent = false;
            elProto.isGroup = false;
            elProto.draggable = false;
            elProto.dragging = false;
            elProto.ignoreClip = false;
            elProto.__inHover = false;
            elProto.__dirty = (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            var logs = {};
            function logDeprecatedError(key, xKey, yKey) {
                if (!logs[key + xKey + yKey]) {
                    console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                    logs[key + xKey + yKey] = true;
                }
            }
            function createLegacyProperty(key, privateKey, xKey, yKey) {
                Object.defineProperty(elProto, key, {
                    get: function() {
                        logDeprecatedError(key, xKey, yKey);
                        if (!this[privateKey]) {
                            var pos = this[privateKey] = [];
                            enhanceArray(this, pos);
                        }
                        return this[privateKey];
                    },
                    set: function(pos) {
                        logDeprecatedError(key, xKey, yKey);
                        this[xKey] = pos[0];
                        this[yKey] = pos[1];
                        this[privateKey] = pos;
                        enhanceArray(this, pos);
                    }
                });
                function enhanceArray(self, pos) {
                    Object.defineProperty(pos, 0, {
                        get: function() {
                            return self[xKey];
                        },
                        set: function(val) {
                            self[xKey] = val;
                        }
                    });
                    Object.defineProperty(pos, 1, {
                        get: function() {
                            return self[yKey];
                        },
                        set: function(val) {
                            self[yKey] = val;
                        }
                    });
                }
            }
            if (Object.defineProperty && (!(0, (0, parcelRequire("hZfwb")).default).browser.ie || (0, (0, parcelRequire("hZfwb")).default).browser.version > 8)) {
                createLegacyProperty('position', '_legacyPos', 'x', 'y');
                createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
                createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
            }
        }();
        return Element;
    }();
    (0, (0, parcelRequire("bahqM")).mixin)($5a5931cff6ff005a$var$Element, (0, (0, parcelRequire("bRKv5")).default));
    (0, (0, parcelRequire("bahqM")).mixin)($5a5931cff6ff005a$var$Element, (0, (0, parcelRequire("e6gef")).default));
    function $5a5931cff6ff005a$var$animateTo(animatable, target, cfg, animationProps, reverse) {
        cfg = cfg || {};
        var animators = [];
        $5a5931cff6ff005a$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
        var finishCount = animators.length;
        var doneHappened = false;
        var cfgDone = cfg.done;
        var cfgAborted = cfg.aborted;
        var doneCb = function() {
            doneHappened = true;
            finishCount--;
            if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
        };
        var abortedCb = function() {
            finishCount--;
            if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
        };
        if (!finishCount) cfgDone && cfgDone();
        if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
            cfg.during(percent);
        });
        for(var i = 0; i < animators.length; i++){
            var animator = animators[i];
            if (doneCb) animator.done(doneCb);
            if (abortedCb) animator.aborted(abortedCb);
            animator.start(cfg.easing, cfg.force);
        }
        return animators;
    }
    function $5a5931cff6ff005a$var$copyArrShallow(source, target, len) {
        for(var i = 0; i < len; i++)source[i] = target[i];
    }
    function $5a5931cff6ff005a$var$is2DArray(value) {
        return (0, (0, parcelRequire("bahqM")).isArrayLike)(value[0]);
    }
    function $5a5931cff6ff005a$var$copyValue(target, source, key) {
        if ((0, (0, parcelRequire("bahqM")).isArrayLike)(source[key])) {
            if (!(0, (0, parcelRequire("bahqM")).isArrayLike)(target[key])) target[key] = [];
            if ((0, (0, parcelRequire("bahqM")).isTypedArray)(source[key])) {
                var len = source[key].length;
                if (target[key].length !== len) {
                    target[key] = new source[key].constructor(len);
                    $5a5931cff6ff005a$var$copyArrShallow(target[key], source[key], len);
                }
            } else {
                var sourceArr = source[key];
                var targetArr = target[key];
                var len0 = sourceArr.length;
                if ($5a5931cff6ff005a$var$is2DArray(sourceArr)) {
                    var len1 = sourceArr[0].length;
                    for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                    else $5a5931cff6ff005a$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
                } else $5a5931cff6ff005a$var$copyArrShallow(targetArr, sourceArr, len0);
                targetArr.length = sourceArr.length;
            }
        } else target[key] = source[key];
    }
    function $5a5931cff6ff005a$var$animateToShallow(animatable, topKey, source, target, cfg, animationProps, animators, reverse) {
        var animatableKeys = [];
        var changedKeys = [];
        var targetKeys = (0, (0, parcelRequire("bahqM")).keys)(target);
        var duration = cfg.duration;
        var delay = cfg.delay;
        var additive = cfg.additive;
        var setToFinal = cfg.setToFinal;
        var animateAll = !(0, (0, parcelRequire("bahqM")).isObject)(animationProps);
        for(var k = 0; k < targetKeys.length; k++){
            var innerKey = targetKeys[k];
            if (source[innerKey] != null && target[innerKey] != null && (animateAll || animationProps[innerKey])) {
                if ((0, (0, parcelRequire("bahqM")).isObject)(target[innerKey]) && !(0, (0, parcelRequire("bahqM")).isArrayLike)(target[innerKey])) {
                    if (topKey) {
                        if (!reverse) {
                            source[innerKey] = target[innerKey];
                            animatable.updateDuringAnimation(topKey);
                        }
                        continue;
                    }
                    $5a5931cff6ff005a$var$animateToShallow(animatable, innerKey, source[innerKey], target[innerKey], cfg, animationProps && animationProps[innerKey], animators, reverse);
                } else {
                    animatableKeys.push(innerKey);
                    changedKeys.push(innerKey);
                }
            } else if (!reverse) {
                source[innerKey] = target[innerKey];
                animatable.updateDuringAnimation(topKey);
                changedKeys.push(innerKey);
            }
        }
        var keyLen = animatableKeys.length;
        if (keyLen > 0 || cfg.force && !animators.length) {
            var existsAnimators = animatable.animators;
            var existsAnimatorsOnSameTarget = [];
            for(var i = 0; i < existsAnimators.length; i++)if (existsAnimators[i].targetName === topKey) existsAnimatorsOnSameTarget.push(existsAnimators[i]);
            if (!additive && existsAnimatorsOnSameTarget.length) for(var i = 0; i < existsAnimatorsOnSameTarget.length; i++){
                var allAborted = existsAnimatorsOnSameTarget[i].stopTracks(changedKeys);
                if (allAborted) {
                    var idx = (0, (0, parcelRequire("bahqM")).indexOf)(existsAnimators, existsAnimatorsOnSameTarget[i]);
                    existsAnimators.splice(idx, 1);
                }
            }
            var revertedSource = void 0;
            var reversedTarget = void 0;
            var sourceClone = void 0;
            if (reverse) {
                reversedTarget = {};
                if (setToFinal) revertedSource = {};
                for(var i = 0; i < keyLen; i++){
                    var innerKey = animatableKeys[i];
                    reversedTarget[innerKey] = source[innerKey];
                    if (setToFinal) revertedSource[innerKey] = target[innerKey];
                    else source[innerKey] = target[innerKey];
                }
            } else if (setToFinal) {
                sourceClone = {};
                for(var i = 0; i < keyLen; i++){
                    var innerKey = animatableKeys[i];
                    sourceClone[innerKey] = (0, (0, parcelRequire("hb2y5")).cloneValue)(source[innerKey]);
                    $5a5931cff6ff005a$var$copyValue(source, target, innerKey);
                }
            }
            var animator = new (0, (0, parcelRequire("hb2y5")).default)(source, false, additive ? existsAnimatorsOnSameTarget : null);
            animator.targetName = topKey;
            if (cfg.scope) animator.scope = cfg.scope;
            if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animatableKeys);
            if (sourceClone) animator.whenWithKeys(0, sourceClone, animatableKeys);
            animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animatableKeys).delay(delay || 0);
            animatable.addAnimator(animator, topKey);
            animators.push(animator);
        }
    }
    var $5a5931cff6ff005a$export$2e2bcd8739ae039 = $5a5931cff6ff005a$var$Element;
});
parcelRegister("e6gef", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a43e36ee3f294c25$export$2e2bcd8739ae039);
    var $izqgC;
    var $eLEew;
    var $a43e36ee3f294c25$var$mIdentity = (0, parcelRequire("izqgC")).identity;
    var $a43e36ee3f294c25$var$EPSILON = 5e-5;
    function $a43e36ee3f294c25$var$isNotAroundZero(val) {
        return val > $a43e36ee3f294c25$var$EPSILON || val < -$a43e36ee3f294c25$var$EPSILON;
    }
    var $a43e36ee3f294c25$var$scaleTmp = [];
    var $a43e36ee3f294c25$var$tmpTransform = [];
    var $a43e36ee3f294c25$var$originTransform = (0, parcelRequire("izqgC")).create();
    var $a43e36ee3f294c25$var$abs = Math.abs;
    var $a43e36ee3f294c25$var$Transformable = function() {
        function Transformable() {}
        Transformable.prototype.getLocalTransform = function(m) {
            return Transformable.getLocalTransform(this, m);
        };
        Transformable.prototype.setPosition = function(arr) {
            this.x = arr[0];
            this.y = arr[1];
        };
        Transformable.prototype.setScale = function(arr) {
            this.scaleX = arr[0];
            this.scaleY = arr[1];
        };
        Transformable.prototype.setSkew = function(arr) {
            this.skewX = arr[0];
            this.skewY = arr[1];
        };
        Transformable.prototype.setOrigin = function(arr) {
            this.originX = arr[0];
            this.originY = arr[1];
        };
        Transformable.prototype.needLocalTransform = function() {
            return $a43e36ee3f294c25$var$isNotAroundZero(this.rotation) || $a43e36ee3f294c25$var$isNotAroundZero(this.x) || $a43e36ee3f294c25$var$isNotAroundZero(this.y) || $a43e36ee3f294c25$var$isNotAroundZero(this.scaleX - 1) || $a43e36ee3f294c25$var$isNotAroundZero(this.scaleY - 1);
        };
        Transformable.prototype.updateTransform = function() {
            var parentTransform = this.parent && this.parent.transform;
            var needLocalTransform = this.needLocalTransform();
            var m = this.transform;
            if (!(needLocalTransform || parentTransform)) {
                m && $a43e36ee3f294c25$var$mIdentity(m);
                return;
            }
            m = m || (0, parcelRequire("izqgC")).create();
            if (needLocalTransform) this.getLocalTransform(m);
            else $a43e36ee3f294c25$var$mIdentity(m);
            if (parentTransform) {
                if (needLocalTransform) (0, parcelRequire("izqgC")).mul(m, parentTransform, m);
                else (0, parcelRequire("izqgC")).copy(m, parentTransform);
            }
            this.transform = m;
            this._resolveGlobalScaleRatio(m);
        };
        Transformable.prototype._resolveGlobalScaleRatio = function(m) {
            var globalScaleRatio = this.globalScaleRatio;
            if (globalScaleRatio != null && globalScaleRatio !== 1) {
                this.getGlobalScale($a43e36ee3f294c25$var$scaleTmp);
                var relX = $a43e36ee3f294c25$var$scaleTmp[0] < 0 ? -1 : 1;
                var relY = $a43e36ee3f294c25$var$scaleTmp[1] < 0 ? -1 : 1;
                var sx = (($a43e36ee3f294c25$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $a43e36ee3f294c25$var$scaleTmp[0] || 0;
                var sy = (($a43e36ee3f294c25$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $a43e36ee3f294c25$var$scaleTmp[1] || 0;
                m[0] *= sx;
                m[1] *= sx;
                m[2] *= sy;
                m[3] *= sy;
            }
            this.invTransform = this.invTransform || (0, parcelRequire("izqgC")).create();
            (0, parcelRequire("izqgC")).invert(this.invTransform, m);
        };
        Transformable.prototype.getComputedTransform = function() {
            var transformNode = this;
            var ancestors = [];
            while(transformNode){
                ancestors.push(transformNode);
                transformNode = transformNode.parent;
            }
            while(transformNode = ancestors.pop())transformNode.updateTransform();
            return this.transform;
        };
        Transformable.prototype.setLocalTransform = function(m) {
            if (!m) return;
            var sx = m[0] * m[0] + m[1] * m[1];
            var sy = m[2] * m[2] + m[3] * m[3];
            var rotation = Math.atan2(m[1], m[0]);
            var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
            sy = Math.sqrt(sy) * Math.cos(shearX);
            sx = Math.sqrt(sx);
            this.skewX = shearX;
            this.skewY = 0;
            this.rotation = -rotation;
            this.x = +m[4];
            this.y = +m[5];
            this.scaleX = sx;
            this.scaleY = sy;
            this.originX = 0;
            this.originY = 0;
        };
        Transformable.prototype.decomposeTransform = function() {
            if (!this.transform) return;
            var parent = this.parent;
            var m = this.transform;
            if (parent && parent.transform) {
                (0, parcelRequire("izqgC")).mul($a43e36ee3f294c25$var$tmpTransform, parent.invTransform, m);
                m = $a43e36ee3f294c25$var$tmpTransform;
            }
            var ox = this.originX;
            var oy = this.originY;
            if (ox || oy) {
                $a43e36ee3f294c25$var$originTransform[4] = ox;
                $a43e36ee3f294c25$var$originTransform[5] = oy;
                (0, parcelRequire("izqgC")).mul($a43e36ee3f294c25$var$tmpTransform, m, $a43e36ee3f294c25$var$originTransform);
                $a43e36ee3f294c25$var$tmpTransform[4] -= ox;
                $a43e36ee3f294c25$var$tmpTransform[5] -= oy;
                m = $a43e36ee3f294c25$var$tmpTransform;
            }
            this.setLocalTransform(m);
        };
        Transformable.prototype.getGlobalScale = function(out) {
            var m = this.transform;
            out = out || [];
            if (!m) {
                out[0] = 1;
                out[1] = 1;
                return out;
            }
            out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
            out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
            if (m[0] < 0) out[0] = -out[0];
            if (m[3] < 0) out[1] = -out[1];
            return out;
        };
        Transformable.prototype.transformCoordToLocal = function(x, y) {
            var v2 = [
                x,
                y
            ];
            var invTransform = this.invTransform;
            if (invTransform) (0, parcelRequire("eLEew")).applyTransform(v2, v2, invTransform);
            return v2;
        };
        Transformable.prototype.transformCoordToGlobal = function(x, y) {
            var v2 = [
                x,
                y
            ];
            var transform = this.transform;
            if (transform) (0, parcelRequire("eLEew")).applyTransform(v2, v2, transform);
            return v2;
        };
        Transformable.prototype.getLineScale = function() {
            var m = this.transform;
            return m && $a43e36ee3f294c25$var$abs(m[0] - 1) > 1e-10 && $a43e36ee3f294c25$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($a43e36ee3f294c25$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
        };
        Transformable.prototype.copyTransform = function(source) {
            var target = this;
            for(var i = 0; i < $a43e36ee3f294c25$export$98ab6203ec3396e2.length; i++){
                var propName = $a43e36ee3f294c25$export$98ab6203ec3396e2[i];
                target[propName] = source[propName];
            }
        };
        Transformable.getLocalTransform = function(target, m) {
            m = m || [];
            var ox = target.originX || 0;
            var oy = target.originY || 0;
            var sx = target.scaleX;
            var sy = target.scaleY;
            var rotation = target.rotation || 0;
            var x = target.x;
            var y = target.y;
            var skewX = target.skewX ? Math.tan(target.skewX) : 0;
            var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
            if (ox || oy) {
                m[4] = -ox * sx - skewX * oy * sy;
                m[5] = -oy * sy - skewY * ox * sx;
            } else m[4] = m[5] = 0;
            m[0] = sx;
            m[3] = sy;
            m[1] = skewY * sx;
            m[2] = skewX * sy;
            rotation && (0, parcelRequire("izqgC")).rotate(m, m, rotation);
            m[4] += ox + x;
            m[5] += oy + y;
            return m;
        };
        Transformable.initDefaultProps = function() {
            var proto = Transformable.prototype;
            proto.x = 0;
            proto.y = 0;
            proto.scaleX = 1;
            proto.scaleY = 1;
            proto.originX = 0;
            proto.originY = 0;
            proto.skewX = 0;
            proto.skewY = 0;
            proto.rotation = 0;
            proto.globalScaleRatio = 1;
        }();
        return Transformable;
    }();
    var $a43e36ee3f294c25$export$98ab6203ec3396e2 = [
        'x',
        'y',
        'originX',
        'originY',
        'rotation',
        'scaleX',
        'scaleY',
        'skewX',
        'skewY'
    ];
    var $a43e36ee3f294c25$export$2e2bcd8739ae039 = $a43e36ee3f294c25$var$Transformable;
});
parcelRegister("izqgC", function(module, exports) {
    $parcel$export(module.exports, "create", ()=>$d84fdef7d2e904e1$export$185802fd694ee1f5);
    $parcel$export(module.exports, "identity", ()=>$d84fdef7d2e904e1$export$f0954fd7d5368655);
    $parcel$export(module.exports, "copy", ()=>$d84fdef7d2e904e1$export$784d13d8ee351f07);
    $parcel$export(module.exports, "mul", ()=>$d84fdef7d2e904e1$export$6e3a27864ab166fe);
    $parcel$export(module.exports, "translate", ()=>$d84fdef7d2e904e1$export$d73ee8ef04f5226a);
    $parcel$export(module.exports, "rotate", ()=>$d84fdef7d2e904e1$export$bb628a54ab399bc9);
    $parcel$export(module.exports, "scale", ()=>$d84fdef7d2e904e1$export$dcdf75081b88279d);
    $parcel$export(module.exports, "invert", ()=>$d84fdef7d2e904e1$export$6897c284b6f9f4dc);
    $parcel$export(module.exports, "clone", ()=>$d84fdef7d2e904e1$export$9cd59f9826255e47);
    function $d84fdef7d2e904e1$export$185802fd694ee1f5() {
        return [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    function $d84fdef7d2e904e1$export$f0954fd7d5368655(out) {
        out[0] = 1;
        out[1] = 0;
        out[2] = 0;
        out[3] = 1;
        out[4] = 0;
        out[5] = 0;
        return out;
    }
    function $d84fdef7d2e904e1$export$784d13d8ee351f07(out, m) {
        out[0] = m[0];
        out[1] = m[1];
        out[2] = m[2];
        out[3] = m[3];
        out[4] = m[4];
        out[5] = m[5];
        return out;
    }
    function $d84fdef7d2e904e1$export$6e3a27864ab166fe(out, m1, m2) {
        var out0 = m1[0] * m2[0] + m1[2] * m2[1];
        var out1 = m1[1] * m2[0] + m1[3] * m2[1];
        var out2 = m1[0] * m2[2] + m1[2] * m2[3];
        var out3 = m1[1] * m2[2] + m1[3] * m2[3];
        var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
        var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
        out[0] = out0;
        out[1] = out1;
        out[2] = out2;
        out[3] = out3;
        out[4] = out4;
        out[5] = out5;
        return out;
    }
    function $d84fdef7d2e904e1$export$d73ee8ef04f5226a(out, a, v) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[4] = a[4] + v[0];
        out[5] = a[5] + v[1];
        return out;
    }
    function $d84fdef7d2e904e1$export$bb628a54ab399bc9(out, a, rad) {
        var aa = a[0];
        var ac = a[2];
        var atx = a[4];
        var ab = a[1];
        var ad = a[3];
        var aty = a[5];
        var st = Math.sin(rad);
        var ct = Math.cos(rad);
        out[0] = aa * ct + ab * st;
        out[1] = -aa * st + ab * ct;
        out[2] = ac * ct + ad * st;
        out[3] = -ac * st + ct * ad;
        out[4] = ct * atx + st * aty;
        out[5] = ct * aty - st * atx;
        return out;
    }
    function $d84fdef7d2e904e1$export$dcdf75081b88279d(out, a, v) {
        var vx = v[0];
        var vy = v[1];
        out[0] = a[0] * vx;
        out[1] = a[1] * vy;
        out[2] = a[2] * vx;
        out[3] = a[3] * vy;
        out[4] = a[4] * vx;
        out[5] = a[5] * vy;
        return out;
    }
    function $d84fdef7d2e904e1$export$6897c284b6f9f4dc(out, a) {
        var aa = a[0];
        var ac = a[2];
        var atx = a[4];
        var ab = a[1];
        var ad = a[3];
        var aty = a[5];
        var det = aa * ad - ab * ac;
        if (!det) return null;
        det = 1.0 / det;
        out[0] = ad * det;
        out[1] = -ab * det;
        out[2] = -ac * det;
        out[3] = aa * det;
        out[4] = (ac * aty - ad * atx) * det;
        out[5] = (ab * atx - aa * aty) * det;
        return out;
    }
    function $d84fdef7d2e904e1$export$9cd59f9826255e47(a) {
        var b = $d84fdef7d2e904e1$export$185802fd694ee1f5();
        $d84fdef7d2e904e1$export$784d13d8ee351f07(b, a);
        return b;
    }
});
parcelRegister("eLEew", function(module, exports) {
    $parcel$export(module.exports, "create", ()=>$ac04a9f644701697$export$185802fd694ee1f5);
    $parcel$export(module.exports, "copy", ()=>$ac04a9f644701697$export$784d13d8ee351f07);
    $parcel$export(module.exports, "clone", ()=>$ac04a9f644701697$export$9cd59f9826255e47);
    $parcel$export(module.exports, "set", ()=>$ac04a9f644701697$export$adaa4cf7ef1b65be);
    $parcel$export(module.exports, "add", ()=>$ac04a9f644701697$export$e16d8520af44a096);
    $parcel$export(module.exports, "scaleAndAdd", ()=>$ac04a9f644701697$export$19cedf1da84ba854);
    $parcel$export(module.exports, "sub", ()=>$ac04a9f644701697$export$f93b5905241a7cca);
    $parcel$export(module.exports, "len", ()=>$ac04a9f644701697$export$fc1400facf92c78);
    $parcel$export(module.exports, "lenSquare", ()=>$ac04a9f644701697$export$48e33bc611e4c25a);
    $parcel$export(module.exports, "length", ()=>$ac04a9f644701697$export$f24224f1c91d8156);
    $parcel$export(module.exports, "lengthSquare", ()=>$ac04a9f644701697$export$2f106540dd9a5136);
    $parcel$export(module.exports, "mul", ()=>$ac04a9f644701697$export$6e3a27864ab166fe);
    $parcel$export(module.exports, "div", ()=>$ac04a9f644701697$export$159d9494db57879b);
    $parcel$export(module.exports, "dot", ()=>$ac04a9f644701697$export$94132a0e348806d4);
    $parcel$export(module.exports, "scale", ()=>$ac04a9f644701697$export$dcdf75081b88279d);
    $parcel$export(module.exports, "normalize", ()=>$ac04a9f644701697$export$a3295358bff77e);
    $parcel$export(module.exports, "distance", ()=>$ac04a9f644701697$export$9f17032d917177de);
    $parcel$export(module.exports, "dist", ()=>$ac04a9f644701697$export$6c4a311cc157c764);
    $parcel$export(module.exports, "distanceSquare", ()=>$ac04a9f644701697$export$137c0a69d1ff4a79);
    $parcel$export(module.exports, "distSquare", ()=>$ac04a9f644701697$export$c68db45a034c13b0);
    $parcel$export(module.exports, "negate", ()=>$ac04a9f644701697$export$aef51622e549b8b0);
    $parcel$export(module.exports, "lerp", ()=>$ac04a9f644701697$export$3a89f8d6f6bf6c9f);
    $parcel$export(module.exports, "applyTransform", ()=>$ac04a9f644701697$export$9f9dcb98c894b623);
    $parcel$export(module.exports, "min", ()=>$ac04a9f644701697$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$ac04a9f644701697$export$8960430cfd85939f);
    function $ac04a9f644701697$export$185802fd694ee1f5(x, y) {
        if (x == null) x = 0;
        if (y == null) y = 0;
        return [
            x,
            y
        ];
    }
    function $ac04a9f644701697$export$784d13d8ee351f07(out, v) {
        out[0] = v[0];
        out[1] = v[1];
        return out;
    }
    function $ac04a9f644701697$export$9cd59f9826255e47(v) {
        return [
            v[0],
            v[1]
        ];
    }
    function $ac04a9f644701697$export$adaa4cf7ef1b65be(out, a, b) {
        out[0] = a;
        out[1] = b;
        return out;
    }
    function $ac04a9f644701697$export$e16d8520af44a096(out, v1, v2) {
        out[0] = v1[0] + v2[0];
        out[1] = v1[1] + v2[1];
        return out;
    }
    function $ac04a9f644701697$export$19cedf1da84ba854(out, v1, v2, a) {
        out[0] = v1[0] + v2[0] * a;
        out[1] = v1[1] + v2[1] * a;
        return out;
    }
    function $ac04a9f644701697$export$f93b5905241a7cca(out, v1, v2) {
        out[0] = v1[0] - v2[0];
        out[1] = v1[1] - v2[1];
        return out;
    }
    function $ac04a9f644701697$export$fc1400facf92c78(v) {
        return Math.sqrt($ac04a9f644701697$export$48e33bc611e4c25a(v));
    }
    var $ac04a9f644701697$export$f24224f1c91d8156 = $ac04a9f644701697$export$fc1400facf92c78;
    function $ac04a9f644701697$export$48e33bc611e4c25a(v) {
        return v[0] * v[0] + v[1] * v[1];
    }
    var $ac04a9f644701697$export$2f106540dd9a5136 = $ac04a9f644701697$export$48e33bc611e4c25a;
    function $ac04a9f644701697$export$6e3a27864ab166fe(out, v1, v2) {
        out[0] = v1[0] * v2[0];
        out[1] = v1[1] * v2[1];
        return out;
    }
    function $ac04a9f644701697$export$159d9494db57879b(out, v1, v2) {
        out[0] = v1[0] / v2[0];
        out[1] = v1[1] / v2[1];
        return out;
    }
    function $ac04a9f644701697$export$94132a0e348806d4(v1, v2) {
        return v1[0] * v2[0] + v1[1] * v2[1];
    }
    function $ac04a9f644701697$export$dcdf75081b88279d(out, v, s) {
        out[0] = v[0] * s;
        out[1] = v[1] * s;
        return out;
    }
    function $ac04a9f644701697$export$a3295358bff77e(out, v) {
        var d = $ac04a9f644701697$export$fc1400facf92c78(v);
        if (d === 0) {
            out[0] = 0;
            out[1] = 0;
        } else {
            out[0] = v[0] / d;
            out[1] = v[1] / d;
        }
        return out;
    }
    function $ac04a9f644701697$export$9f17032d917177de(v1, v2) {
        return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
    }
    var $ac04a9f644701697$export$6c4a311cc157c764 = $ac04a9f644701697$export$9f17032d917177de;
    function $ac04a9f644701697$export$137c0a69d1ff4a79(v1, v2) {
        return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
    }
    var $ac04a9f644701697$export$c68db45a034c13b0 = $ac04a9f644701697$export$137c0a69d1ff4a79;
    function $ac04a9f644701697$export$aef51622e549b8b0(out, v) {
        out[0] = -v[0];
        out[1] = -v[1];
        return out;
    }
    function $ac04a9f644701697$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
        out[0] = v1[0] + t * (v2[0] - v1[0]);
        out[1] = v1[1] + t * (v2[1] - v1[1]);
        return out;
    }
    function $ac04a9f644701697$export$9f9dcb98c894b623(out, v, m) {
        var x = v[0];
        var y = v[1];
        out[0] = m[0] * x + m[2] * y + m[4];
        out[1] = m[1] * x + m[3] * y + m[5];
        return out;
    }
    function $ac04a9f644701697$export$96ec731ed4dcb222(out, v1, v2) {
        out[0] = Math.min(v1[0], v2[0]);
        out[1] = Math.min(v1[1], v2[1]);
        return out;
    }
    function $ac04a9f644701697$export$8960430cfd85939f(out, v1, v2) {
        out[0] = Math.max(v1[0], v2[0]);
        out[1] = Math.max(v1[1], v2[1]);
        return out;
    }
});
parcelRegister("hb2y5", function(module, exports) {
    $parcel$export(module.exports, "interpolateNumber", ()=>$c81570e1f313cc39$export$d871d53bd7eeb390);
    $parcel$export(module.exports, "cloneValue", ()=>$c81570e1f313cc39$export$c5e92b7f105af84e);
    $parcel$export(module.exports, "default", ()=>$c81570e1f313cc39$export$2e2bcd8739ae039);
    var $kj9w6;
    var $d6udH;
    var $bahqM;
    var $c81570e1f313cc39$var$arraySlice = Array.prototype.slice;
    function $c81570e1f313cc39$export$d871d53bd7eeb390(p0, p1, percent) {
        return (p1 - p0) * percent + p0;
    }
    function $c81570e1f313cc39$export$35d34bc0ed591a92(p0, p1, percent) {
        return percent > 0.5 ? p1 : p0;
    }
    function $c81570e1f313cc39$export$f8938d924b05a6eb(out, p0, p1, percent) {
        var len = p0.length;
        for(var i = 0; i < len; i++)out[i] = $c81570e1f313cc39$export$d871d53bd7eeb390(p0[i], p1[i], percent);
    }
    function $c81570e1f313cc39$export$3297a85eaaa37024(out, p0, p1, percent) {
        var len = p0.length;
        var len2 = len && p0[0].length;
        for(var i = 0; i < len; i++){
            if (!out[i]) out[i] = [];
            for(var j = 0; j < len2; j++)out[i][j] = $c81570e1f313cc39$export$d871d53bd7eeb390(p0[i][j], p1[i][j], percent);
        }
    }
    function $c81570e1f313cc39$var$add1DArray(out, p0, p1, sign) {
        var len = p0.length;
        for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
        return out;
    }
    function $c81570e1f313cc39$var$add2DArray(out, p0, p1, sign) {
        var len = p0.length;
        var len2 = len && p0[0].length;
        for(var i = 0; i < len; i++){
            if (!out[i]) out[i] = [];
            for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
        }
        return out;
    }
    function $c81570e1f313cc39$var$fillArray(val0, val1, arrDim) {
        var arr0 = val0;
        var arr1 = val1;
        if (!arr0.push || !arr1.push) return;
        var arr0Len = arr0.length;
        var arr1Len = arr1.length;
        if (arr0Len !== arr1Len) {
            var isPreviousLarger = arr0Len > arr1Len;
            if (isPreviousLarger) arr0.length = arr1Len;
            else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $c81570e1f313cc39$var$arraySlice.call(arr1[i]));
        }
        var len2 = arr0[0] && arr0[0].length;
        for(var i = 0; i < arr0.length; i++){
            if (arrDim === 1) {
                if (isNaN(arr0[i])) arr0[i] = arr1[i];
            } else {
                for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
            }
        }
    }
    function $c81570e1f313cc39$var$is1DArraySame(arr0, arr1) {
        var len = arr0.length;
        if (len !== arr1.length) return false;
        for(var i = 0; i < len; i++){
            if (arr0[i] !== arr1[i]) return false;
        }
        return true;
    }
    function $c81570e1f313cc39$var$catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
        var v0 = (p2 - p0) * 0.5;
        var v1 = (p3 - p1) * 0.5;
        return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
    }
    function $c81570e1f313cc39$var$catmullRomInterpolate1DArray(out, p0, p1, p2, p3, t, t2, t3) {
        var len = p0.length;
        for(var i = 0; i < len; i++)out[i] = $c81570e1f313cc39$var$catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
    }
    function $c81570e1f313cc39$var$catmullRomInterpolate2DArray(out, p0, p1, p2, p3, t, t2, t3) {
        var len = p0.length;
        var len2 = p0[0].length;
        for(var i = 0; i < len; i++){
            if (!out[i]) out[1] = [];
            for(var j = 0; j < len2; j++)out[i][j] = $c81570e1f313cc39$var$catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
        }
    }
    function $c81570e1f313cc39$export$c5e92b7f105af84e(value) {
        if ((0, (0, parcelRequire("bahqM")).isArrayLike)(value)) {
            var len = value.length;
            if ((0, (0, parcelRequire("bahqM")).isArrayLike)(value[0])) {
                var ret = [];
                for(var i = 0; i < len; i++)ret.push($c81570e1f313cc39$var$arraySlice.call(value[i]));
                return ret;
            }
            return $c81570e1f313cc39$var$arraySlice.call(value);
        }
        return value;
    }
    function $c81570e1f313cc39$var$rgba2String(rgba) {
        rgba[0] = Math.floor(rgba[0]);
        rgba[1] = Math.floor(rgba[1]);
        rgba[2] = Math.floor(rgba[2]);
        return 'rgba(' + rgba.join(',') + ')';
    }
    function $c81570e1f313cc39$var$guessArrayDim(value) {
        return (0, (0, parcelRequire("bahqM")).isArrayLike)(value && value[0]) ? 2 : 1;
    }
    var $c81570e1f313cc39$var$tmpRgba = [
        0,
        0,
        0,
        0
    ];
    var $c81570e1f313cc39$var$Track = function() {
        function Track(propName) {
            this.keyframes = [];
            this.maxTime = 0;
            this.arrDim = 0;
            this.interpolable = true;
            this._needsSort = false;
            this._isAllValueEqual = true;
            this._lastFrame = 0;
            this._lastFramePercent = 0;
            this.propName = propName;
        }
        Track.prototype.isFinished = function() {
            return this._finished;
        };
        Track.prototype.setFinished = function() {
            this._finished = true;
            if (this._additiveTrack) this._additiveTrack.setFinished();
        };
        Track.prototype.needsAnimate = function() {
            return !this._isAllValueEqual && this.keyframes.length >= 2 && this.interpolable && this.maxTime > 0;
        };
        Track.prototype.getAdditiveTrack = function() {
            return this._additiveTrack;
        };
        Track.prototype.addKeyframe = function(time, value) {
            if (time >= this.maxTime) this.maxTime = time;
            else this._needsSort = true;
            var keyframes = this.keyframes;
            var len = keyframes.length;
            if (this.interpolable) {
                if ((0, (0, parcelRequire("bahqM")).isArrayLike)(value)) {
                    var arrayDim = $c81570e1f313cc39$var$guessArrayDim(value);
                    if (len > 0 && this.arrDim !== arrayDim) {
                        this.interpolable = false;
                        return;
                    }
                    if (arrayDim === 1 && typeof value[0] !== 'number' || arrayDim === 2 && typeof value[0][0] !== 'number') {
                        this.interpolable = false;
                        return;
                    }
                    if (len > 0) {
                        var lastFrame = keyframes[len - 1];
                        if (this._isAllValueEqual) {
                            if (arrayDim === 1) {
                                if (!$c81570e1f313cc39$var$is1DArraySame(value, lastFrame.value)) this._isAllValueEqual = false;
                            } else this._isAllValueEqual = false;
                        }
                    }
                    this.arrDim = arrayDim;
                } else {
                    if (this.arrDim > 0) {
                        this.interpolable = false;
                        return;
                    }
                    if (typeof value === 'string') {
                        var colorArray = (0, parcelRequire("d6udH")).parse(value);
                        if (colorArray) {
                            value = colorArray;
                            this.isValueColor = true;
                        } else this.interpolable = false;
                    } else if (typeof value !== 'number' || isNaN(value)) {
                        this.interpolable = false;
                        return;
                    }
                    if (this._isAllValueEqual && len > 0) {
                        var lastFrame = keyframes[len - 1];
                        if (this.isValueColor && !$c81570e1f313cc39$var$is1DArraySame(lastFrame.value, value)) this._isAllValueEqual = false;
                        else if (lastFrame.value !== value) this._isAllValueEqual = false;
                    }
                }
            }
            var kf = {
                time: time,
                value: value,
                percent: 0
            };
            this.keyframes.push(kf);
            return kf;
        };
        Track.prototype.prepare = function(additiveTrack) {
            var kfs = this.keyframes;
            if (this._needsSort) kfs.sort(function(a, b) {
                return a.time - b.time;
            });
            var arrDim = this.arrDim;
            var kfsLen = kfs.length;
            var lastKf = kfs[kfsLen - 1];
            for(var i = 0; i < kfsLen; i++){
                kfs[i].percent = kfs[i].time / this.maxTime;
                if (arrDim > 0 && i !== kfsLen - 1) $c81570e1f313cc39$var$fillArray(kfs[i].value, lastKf.value, arrDim);
            }
            if (additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && arrDim === additiveTrack.arrDim && this.isValueColor === additiveTrack.isValueColor && !additiveTrack._finished) {
                this._additiveTrack = additiveTrack;
                var startValue = kfs[0].value;
                for(var i = 0; i < kfsLen; i++){
                    if (arrDim === 0) {
                        if (this.isValueColor) kfs[i].additiveValue = $c81570e1f313cc39$var$add1DArray([], kfs[i].value, startValue, -1);
                        else kfs[i].additiveValue = kfs[i].value - startValue;
                    } else if (arrDim === 1) kfs[i].additiveValue = $c81570e1f313cc39$var$add1DArray([], kfs[i].value, startValue, -1);
                    else if (arrDim === 2) kfs[i].additiveValue = $c81570e1f313cc39$var$add2DArray([], kfs[i].value, startValue, -1);
                }
            }
        };
        Track.prototype.step = function(target, percent) {
            if (this._finished) return;
            if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
            var isAdditive = this._additiveTrack != null;
            var valueKey = isAdditive ? 'additiveValue' : 'value';
            var keyframes = this.keyframes;
            var kfsNum = this.keyframes.length;
            var propName = this.propName;
            var arrDim = this.arrDim;
            var isValueColor = this.isValueColor;
            var frameIdx;
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFramePercent) {
                var start = Math.min(this._lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = Math.min(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = this._lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = Math.min(frameIdx - 1, kfsNum - 2);
            }
            var nextFrame = keyframes[frameIdx + 1];
            var frame = keyframes[frameIdx];
            if (!(frame && nextFrame)) return;
            this._lastFrame = frameIdx;
            this._lastFramePercent = percent;
            var range = nextFrame.percent - frame.percent;
            if (range === 0) return;
            var w = (percent - frame.percent) / range;
            var targetArr = isAdditive ? this._additiveValue : isValueColor ? $c81570e1f313cc39$var$tmpRgba : target[propName];
            if ((arrDim > 0 || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
            if (this.useSpline) {
                var p1 = keyframes[frameIdx][valueKey];
                var p0 = keyframes[frameIdx === 0 ? frameIdx : frameIdx - 1][valueKey];
                var p2 = keyframes[frameIdx > kfsNum - 2 ? kfsNum - 1 : frameIdx + 1][valueKey];
                var p3 = keyframes[frameIdx > kfsNum - 3 ? kfsNum - 1 : frameIdx + 2][valueKey];
                if (arrDim > 0) arrDim === 1 ? $c81570e1f313cc39$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w) : $c81570e1f313cc39$var$catmullRomInterpolate2DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
                else if (isValueColor) {
                    $c81570e1f313cc39$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
                    if (!isAdditive) target[propName] = $c81570e1f313cc39$var$rgba2String(targetArr);
                } else {
                    var value = void 0;
                    if (!this.interpolable) value = p2;
                    else value = $c81570e1f313cc39$var$catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
                    if (isAdditive) this._additiveValue = value;
                    else target[propName] = value;
                }
            } else {
                if (arrDim > 0) arrDim === 1 ? $c81570e1f313cc39$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w) : $c81570e1f313cc39$export$3297a85eaaa37024(targetArr, frame[valueKey], nextFrame[valueKey], w);
                else if (isValueColor) {
                    $c81570e1f313cc39$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w);
                    if (!isAdditive) target[propName] = $c81570e1f313cc39$var$rgba2String(targetArr);
                } else {
                    var value = void 0;
                    if (!this.interpolable) value = $c81570e1f313cc39$export$35d34bc0ed591a92(frame[valueKey], nextFrame[valueKey], w);
                    else value = $c81570e1f313cc39$export$d871d53bd7eeb390(frame[valueKey], nextFrame[valueKey], w);
                    if (isAdditive) this._additiveValue = value;
                    else target[propName] = value;
                }
            }
            if (isAdditive) this._addToTarget(target);
        };
        Track.prototype._addToTarget = function(target) {
            var arrDim = this.arrDim;
            var propName = this.propName;
            var additiveValue = this._additiveValue;
            if (arrDim === 0) {
                if (this.isValueColor) {
                    (0, parcelRequire("d6udH")).parse(target[propName], $c81570e1f313cc39$var$tmpRgba);
                    $c81570e1f313cc39$var$add1DArray($c81570e1f313cc39$var$tmpRgba, $c81570e1f313cc39$var$tmpRgba, additiveValue, 1);
                    target[propName] = $c81570e1f313cc39$var$rgba2String($c81570e1f313cc39$var$tmpRgba);
                } else target[propName] = target[propName] + additiveValue;
            } else if (arrDim === 1) $c81570e1f313cc39$var$add1DArray(target[propName], target[propName], additiveValue, 1);
            else if (arrDim === 2) $c81570e1f313cc39$var$add2DArray(target[propName], target[propName], additiveValue, 1);
        };
        return Track;
    }();
    var $c81570e1f313cc39$var$Animator = function() {
        function Animator(target, loop, additiveTo) {
            this._tracks = {};
            this._trackKeys = [];
            this._delay = 0;
            this._maxTime = 0;
            this._paused = false;
            this._started = 0;
            this._clip = null;
            this._target = target;
            this._loop = loop;
            if (loop && additiveTo) {
                (0, (0, parcelRequire("bahqM")).logError)('Can\' use additive animation on looped animation.');
                return;
            }
            this._additiveAnimators = additiveTo;
        }
        Animator.prototype.getTarget = function() {
            return this._target;
        };
        Animator.prototype.changeTarget = function(target) {
            this._target = target;
        };
        Animator.prototype.when = function(time, props) {
            return this.whenWithKeys(time, props, (0, (0, parcelRequire("bahqM")).keys)(props));
        };
        Animator.prototype.whenWithKeys = function(time, props, propNames) {
            var tracks = this._tracks;
            for(var i = 0; i < propNames.length; i++){
                var propName = propNames[i];
                var track = tracks[propName];
                if (!track) {
                    track = tracks[propName] = new $c81570e1f313cc39$var$Track(propName);
                    var initialValue = void 0;
                    var additiveTrack = this._getAdditiveTrack(propName);
                    if (additiveTrack) {
                        var lastFinalKf = additiveTrack.keyframes[additiveTrack.keyframes.length - 1];
                        initialValue = lastFinalKf && lastFinalKf.value;
                        if (additiveTrack.isValueColor && initialValue) initialValue = $c81570e1f313cc39$var$rgba2String(initialValue);
                    } else initialValue = this._target[propName];
                    if (initialValue == null) continue;
                    if (time !== 0) track.addKeyframe(0, $c81570e1f313cc39$export$c5e92b7f105af84e(initialValue));
                    this._trackKeys.push(propName);
                }
                track.addKeyframe(time, $c81570e1f313cc39$export$c5e92b7f105af84e(props[propName]));
            }
            this._maxTime = Math.max(this._maxTime, time);
            return this;
        };
        Animator.prototype.pause = function() {
            this._clip.pause();
            this._paused = true;
        };
        Animator.prototype.resume = function() {
            this._clip.resume();
            this._paused = false;
        };
        Animator.prototype.isPaused = function() {
            return !!this._paused;
        };
        Animator.prototype._doneCallback = function() {
            this._setTracksFinished();
            this._clip = null;
            var doneList = this._doneCbs;
            if (doneList) {
                var len = doneList.length;
                for(var i = 0; i < len; i++)doneList[i].call(this);
            }
        };
        Animator.prototype._abortedCallback = function() {
            this._setTracksFinished();
            var animation = this.animation;
            var abortedList = this._abortedCbs;
            if (animation) animation.removeClip(this._clip);
            this._clip = null;
            if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
        };
        Animator.prototype._setTracksFinished = function() {
            var tracks = this._tracks;
            var tracksKeys = this._trackKeys;
            for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
        };
        Animator.prototype._getAdditiveTrack = function(trackName) {
            var additiveTrack;
            var additiveAnimators = this._additiveAnimators;
            if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
                var track = additiveAnimators[i].getTrack(trackName);
                if (track) additiveTrack = track;
            }
            return additiveTrack;
        };
        Animator.prototype.start = function(easing, forceAnimate) {
            if (this._started > 0) return;
            this._started = 1;
            var self = this;
            var tracks = [];
            for(var i = 0; i < this._trackKeys.length; i++){
                var propName = this._trackKeys[i];
                var track = this._tracks[propName];
                var additiveTrack = this._getAdditiveTrack(propName);
                var kfs = track.keyframes;
                track.prepare(additiveTrack);
                if (track.needsAnimate()) tracks.push(track);
                else if (!track.interpolable) {
                    var lastKf = kfs[kfs.length - 1];
                    if (lastKf) self._target[track.propName] = lastKf.value;
                }
            }
            if (tracks.length || forceAnimate) {
                var clip = new (0, (0, parcelRequire("kj9w6")).default)({
                    life: this._maxTime,
                    loop: this._loop,
                    delay: this._delay,
                    onframe: function(percent) {
                        self._started = 2;
                        var additiveAnimators = self._additiveAnimators;
                        if (additiveAnimators) {
                            var stillHasAdditiveAnimator = false;
                            for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                                stillHasAdditiveAnimator = true;
                                break;
                            }
                            if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                        }
                        for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                        var onframeList = self._onframeCbs;
                        if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                    },
                    ondestroy: function() {
                        self._doneCallback();
                    }
                });
                this._clip = clip;
                if (this.animation) this.animation.addClip(clip);
                if (easing && easing !== 'spline') clip.easing = easing;
            } else this._doneCallback();
            return this;
        };
        Animator.prototype.stop = function(forwardToLast) {
            if (!this._clip) return;
            var clip = this._clip;
            if (forwardToLast) clip.onframe(1);
            this._abortedCallback();
        };
        Animator.prototype.delay = function(time) {
            this._delay = time;
            return this;
        };
        Animator.prototype.during = function(cb) {
            if (cb) {
                if (!this._onframeCbs) this._onframeCbs = [];
                this._onframeCbs.push(cb);
            }
            return this;
        };
        Animator.prototype.done = function(cb) {
            if (cb) {
                if (!this._doneCbs) this._doneCbs = [];
                this._doneCbs.push(cb);
            }
            return this;
        };
        Animator.prototype.aborted = function(cb) {
            if (cb) {
                if (!this._abortedCbs) this._abortedCbs = [];
                this._abortedCbs.push(cb);
            }
            return this;
        };
        Animator.prototype.getClip = function() {
            return this._clip;
        };
        Animator.prototype.getTrack = function(propName) {
            return this._tracks[propName];
        };
        Animator.prototype.stopTracks = function(propNames, forwardToLast) {
            if (!propNames.length || !this._clip) return true;
            var tracks = this._tracks;
            var tracksKeys = this._trackKeys;
            for(var i = 0; i < propNames.length; i++){
                var track = tracks[propNames[i]];
                if (track) {
                    if (forwardToLast) track.step(this._target, 1);
                    else if (this._started === 1) track.step(this._target, 0);
                    track.setFinished();
                }
            }
            var allAborted = true;
            for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
                allAborted = false;
                break;
            }
            if (allAborted) this._abortedCallback();
            return allAborted;
        };
        Animator.prototype.saveFinalToTarget = function(target, trackKeys) {
            if (!target) return;
            trackKeys = trackKeys || this._trackKeys;
            for(var i = 0; i < trackKeys.length; i++){
                var propName = trackKeys[i];
                var track = this._tracks[propName];
                if (!track || track.isFinished()) continue;
                var kfs = track.keyframes;
                var lastKf = kfs[kfs.length - 1];
                if (lastKf) {
                    var val = $c81570e1f313cc39$export$c5e92b7f105af84e(lastKf.value);
                    if (track.isValueColor) val = $c81570e1f313cc39$var$rgba2String(val);
                    target[propName] = val;
                }
            }
        };
        Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
            trackKeys = trackKeys || (0, (0, parcelRequire("bahqM")).keys)(finalProps);
            for(var i = 0; i < trackKeys.length; i++){
                var propName = trackKeys[i];
                var track = this._tracks[propName];
                if (!track) continue;
                var kfs = track.keyframes;
                if (kfs.length > 1) {
                    var lastKf = kfs.pop();
                    track.addKeyframe(lastKf.time, finalProps[propName]);
                    track.prepare(track.getAdditiveTrack());
                }
            }
        };
        return Animator;
    }();
    var $c81570e1f313cc39$export$2e2bcd8739ae039 = $c81570e1f313cc39$var$Animator;
});
parcelRegister("kj9w6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec8cf6d19967f888$export$2e2bcd8739ae039);
    var $2yJbE;
    var $ec8cf6d19967f888$var$Clip = function() {
        function Clip(opts) {
            this._initialized = false;
            this._startTime = 0;
            this._pausedTime = 0;
            this._paused = false;
            this._life = opts.life || 1000;
            this._delay = opts.delay || 0;
            this.loop = opts.loop == null ? false : opts.loop;
            this.gap = opts.gap || 0;
            this.easing = opts.easing || 'linear';
            this.onframe = opts.onframe;
            this.ondestroy = opts.ondestroy;
            this.onrestart = opts.onrestart;
        }
        Clip.prototype.step = function(globalTime, deltaTime) {
            if (!this._initialized) {
                this._startTime = globalTime + this._delay;
                this._initialized = true;
            }
            if (this._paused) {
                this._pausedTime += deltaTime;
                return;
            }
            var percent = (globalTime - this._startTime - this._pausedTime) / this._life;
            if (percent < 0) percent = 0;
            percent = Math.min(percent, 1);
            var easing = this.easing;
            var easingFunc = typeof easing === 'string' ? (0, (0, parcelRequire("2yJbE")).default)[easing] : easing;
            var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
            this.onframe && this.onframe(schedule);
            if (percent === 1) {
                if (this.loop) {
                    this._restart(globalTime);
                    this.onrestart && this.onrestart();
                } else return true;
            }
            return false;
        };
        Clip.prototype._restart = function(globalTime) {
            var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
            this._startTime = globalTime - remainder + this.gap;
            this._pausedTime = 0;
        };
        Clip.prototype.pause = function() {
            this._paused = true;
        };
        Clip.prototype.resume = function() {
            this._paused = false;
        };
        return Clip;
    }();
    var $ec8cf6d19967f888$export$2e2bcd8739ae039 = $ec8cf6d19967f888$var$Clip;
});
parcelRegister("2yJbE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1dd1cef375de2720$export$2e2bcd8739ae039);
    var $1dd1cef375de2720$var$easing = {
        linear: function(k) {
            return k;
        },
        quadraticIn: function(k) {
            return k * k;
        },
        quadraticOut: function(k) {
            return k * (2 - k);
        },
        quadraticInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k;
            return -0.5 * (--k * (k - 2) - 1);
        },
        cubicIn: function(k) {
            return k * k * k;
        },
        cubicOut: function(k) {
            return --k * k * k + 1;
        },
        cubicInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k * k;
            return 0.5 * ((k -= 2) * k * k + 2);
        },
        quarticIn: function(k) {
            return k * k * k * k;
        },
        quarticOut: function(k) {
            return 1 - --k * k * k * k;
        },
        quarticInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k * k * k;
            return -0.5 * ((k -= 2) * k * k * k - 2);
        },
        quinticIn: function(k) {
            return k * k * k * k * k;
        },
        quinticOut: function(k) {
            return --k * k * k * k * k + 1;
        },
        quinticInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
            return 0.5 * ((k -= 2) * k * k * k * k + 2);
        },
        sinusoidalIn: function(k) {
            return 1 - Math.cos(k * Math.PI / 2);
        },
        sinusoidalOut: function(k) {
            return Math.sin(k * Math.PI / 2);
        },
        sinusoidalInOut: function(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        },
        exponentialIn: function(k) {
            return k === 0 ? 0 : Math.pow(1024, k - 1);
        },
        exponentialOut: function(k) {
            return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
        },
        exponentialInOut: function(k) {
            if (k === 0) return 0;
            if (k === 1) return 1;
            if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
            return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
        },
        circularIn: function(k) {
            return 1 - Math.sqrt(1 - k * k);
        },
        circularOut: function(k) {
            return Math.sqrt(1 - --k * k);
        },
        circularInOut: function(k) {
            if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
            return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
        },
        elasticIn: function(k) {
            var s;
            var a = 0.1;
            var p = 0.4;
            if (k === 0) return 0;
            if (k === 1) return 1;
            if (!a || a < 1) {
                a = 1;
                s = p / 4;
            } else s = p * Math.asin(1 / a) / (2 * Math.PI);
            return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        },
        elasticOut: function(k) {
            var s;
            var a = 0.1;
            var p = 0.4;
            if (k === 0) return 0;
            if (k === 1) return 1;
            if (!a || a < 1) {
                a = 1;
                s = p / 4;
            } else s = p * Math.asin(1 / a) / (2 * Math.PI);
            return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
        },
        elasticInOut: function(k) {
            var s;
            var a = 0.1;
            var p = 0.4;
            if (k === 0) return 0;
            if (k === 1) return 1;
            if (!a || a < 1) {
                a = 1;
                s = p / 4;
            } else s = p * Math.asin(1 / a) / (2 * Math.PI);
            if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        backIn: function(k) {
            var s = 1.70158;
            return k * k * ((s + 1) * k - s);
        },
        backOut: function(k) {
            var s = 1.70158;
            return --k * k * ((s + 1) * k + s) + 1;
        },
        backInOut: function(k) {
            var s = 2.5949095;
            if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
            return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
        },
        bounceIn: function(k) {
            return 1 - $1dd1cef375de2720$var$easing.bounceOut(1 - k);
        },
        bounceOut: function(k) {
            if (k < 1 / 2.75) return 7.5625 * k * k;
            else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
            else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
            else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
        },
        bounceInOut: function(k) {
            if (k < 0.5) return $1dd1cef375de2720$var$easing.bounceIn(k * 2) * 0.5;
            return $1dd1cef375de2720$var$easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
        }
    };
    var $1dd1cef375de2720$export$2e2bcd8739ae039 = $1dd1cef375de2720$var$easing;
});
parcelRegister("d6udH", function(module, exports) {
    $parcel$export(module.exports, "parse", ()=>$98a346fa71cc3009$export$98e6a39c04603d36);
    $parcel$export(module.exports, "lift", ()=>$98a346fa71cc3009$export$590e8b2c435046d9);
    $parcel$export(module.exports, "stringify", ()=>$98a346fa71cc3009$export$fac44ee5b035f737);
    $parcel$export(module.exports, "toHex", ()=>$98a346fa71cc3009$export$7ea66e3774a60b67);
    $parcel$export(module.exports, "fastLerp", ()=>$98a346fa71cc3009$export$66cb3c0e9efc61c8);
    $parcel$export(module.exports, "fastMapToColor", ()=>$98a346fa71cc3009$export$daa5a65daad5df58);
    $parcel$export(module.exports, "lerp", ()=>$98a346fa71cc3009$export$3a89f8d6f6bf6c9f);
    $parcel$export(module.exports, "mapToColor", ()=>$98a346fa71cc3009$export$296e08242b78a3ec);
    $parcel$export(module.exports, "modifyHSL", ()=>$98a346fa71cc3009$export$d898ae866e27bf18);
    $parcel$export(module.exports, "modifyAlpha", ()=>$98a346fa71cc3009$export$ab4754bf42583a26);
    $parcel$export(module.exports, "lum", ()=>$98a346fa71cc3009$export$16c0ec21a6f9ef95);
    $parcel$export(module.exports, "random", ()=>$98a346fa71cc3009$export$4385e60b38654f68);
    var $h4RuA;
    var $98a346fa71cc3009$var$kCSSColorTable = {
        'transparent': [
            0,
            0,
            0,
            0
        ],
        'aliceblue': [
            240,
            248,
            255,
            1
        ],
        'antiquewhite': [
            250,
            235,
            215,
            1
        ],
        'aqua': [
            0,
            255,
            255,
            1
        ],
        'aquamarine': [
            127,
            255,
            212,
            1
        ],
        'azure': [
            240,
            255,
            255,
            1
        ],
        'beige': [
            245,
            245,
            220,
            1
        ],
        'bisque': [
            255,
            228,
            196,
            1
        ],
        'black': [
            0,
            0,
            0,
            1
        ],
        'blanchedalmond': [
            255,
            235,
            205,
            1
        ],
        'blue': [
            0,
            0,
            255,
            1
        ],
        'blueviolet': [
            138,
            43,
            226,
            1
        ],
        'brown': [
            165,
            42,
            42,
            1
        ],
        'burlywood': [
            222,
            184,
            135,
            1
        ],
        'cadetblue': [
            95,
            158,
            160,
            1
        ],
        'chartreuse': [
            127,
            255,
            0,
            1
        ],
        'chocolate': [
            210,
            105,
            30,
            1
        ],
        'coral': [
            255,
            127,
            80,
            1
        ],
        'cornflowerblue': [
            100,
            149,
            237,
            1
        ],
        'cornsilk': [
            255,
            248,
            220,
            1
        ],
        'crimson': [
            220,
            20,
            60,
            1
        ],
        'cyan': [
            0,
            255,
            255,
            1
        ],
        'darkblue': [
            0,
            0,
            139,
            1
        ],
        'darkcyan': [
            0,
            139,
            139,
            1
        ],
        'darkgoldenrod': [
            184,
            134,
            11,
            1
        ],
        'darkgray': [
            169,
            169,
            169,
            1
        ],
        'darkgreen': [
            0,
            100,
            0,
            1
        ],
        'darkgrey': [
            169,
            169,
            169,
            1
        ],
        'darkkhaki': [
            189,
            183,
            107,
            1
        ],
        'darkmagenta': [
            139,
            0,
            139,
            1
        ],
        'darkolivegreen': [
            85,
            107,
            47,
            1
        ],
        'darkorange': [
            255,
            140,
            0,
            1
        ],
        'darkorchid': [
            153,
            50,
            204,
            1
        ],
        'darkred': [
            139,
            0,
            0,
            1
        ],
        'darksalmon': [
            233,
            150,
            122,
            1
        ],
        'darkseagreen': [
            143,
            188,
            143,
            1
        ],
        'darkslateblue': [
            72,
            61,
            139,
            1
        ],
        'darkslategray': [
            47,
            79,
            79,
            1
        ],
        'darkslategrey': [
            47,
            79,
            79,
            1
        ],
        'darkturquoise': [
            0,
            206,
            209,
            1
        ],
        'darkviolet': [
            148,
            0,
            211,
            1
        ],
        'deeppink': [
            255,
            20,
            147,
            1
        ],
        'deepskyblue': [
            0,
            191,
            255,
            1
        ],
        'dimgray': [
            105,
            105,
            105,
            1
        ],
        'dimgrey': [
            105,
            105,
            105,
            1
        ],
        'dodgerblue': [
            30,
            144,
            255,
            1
        ],
        'firebrick': [
            178,
            34,
            34,
            1
        ],
        'floralwhite': [
            255,
            250,
            240,
            1
        ],
        'forestgreen': [
            34,
            139,
            34,
            1
        ],
        'fuchsia': [
            255,
            0,
            255,
            1
        ],
        'gainsboro': [
            220,
            220,
            220,
            1
        ],
        'ghostwhite': [
            248,
            248,
            255,
            1
        ],
        'gold': [
            255,
            215,
            0,
            1
        ],
        'goldenrod': [
            218,
            165,
            32,
            1
        ],
        'gray': [
            128,
            128,
            128,
            1
        ],
        'green': [
            0,
            128,
            0,
            1
        ],
        'greenyellow': [
            173,
            255,
            47,
            1
        ],
        'grey': [
            128,
            128,
            128,
            1
        ],
        'honeydew': [
            240,
            255,
            240,
            1
        ],
        'hotpink': [
            255,
            105,
            180,
            1
        ],
        'indianred': [
            205,
            92,
            92,
            1
        ],
        'indigo': [
            75,
            0,
            130,
            1
        ],
        'ivory': [
            255,
            255,
            240,
            1
        ],
        'khaki': [
            240,
            230,
            140,
            1
        ],
        'lavender': [
            230,
            230,
            250,
            1
        ],
        'lavenderblush': [
            255,
            240,
            245,
            1
        ],
        'lawngreen': [
            124,
            252,
            0,
            1
        ],
        'lemonchiffon': [
            255,
            250,
            205,
            1
        ],
        'lightblue': [
            173,
            216,
            230,
            1
        ],
        'lightcoral': [
            240,
            128,
            128,
            1
        ],
        'lightcyan': [
            224,
            255,
            255,
            1
        ],
        'lightgoldenrodyellow': [
            250,
            250,
            210,
            1
        ],
        'lightgray': [
            211,
            211,
            211,
            1
        ],
        'lightgreen': [
            144,
            238,
            144,
            1
        ],
        'lightgrey': [
            211,
            211,
            211,
            1
        ],
        'lightpink': [
            255,
            182,
            193,
            1
        ],
        'lightsalmon': [
            255,
            160,
            122,
            1
        ],
        'lightseagreen': [
            32,
            178,
            170,
            1
        ],
        'lightskyblue': [
            135,
            206,
            250,
            1
        ],
        'lightslategray': [
            119,
            136,
            153,
            1
        ],
        'lightslategrey': [
            119,
            136,
            153,
            1
        ],
        'lightsteelblue': [
            176,
            196,
            222,
            1
        ],
        'lightyellow': [
            255,
            255,
            224,
            1
        ],
        'lime': [
            0,
            255,
            0,
            1
        ],
        'limegreen': [
            50,
            205,
            50,
            1
        ],
        'linen': [
            250,
            240,
            230,
            1
        ],
        'magenta': [
            255,
            0,
            255,
            1
        ],
        'maroon': [
            128,
            0,
            0,
            1
        ],
        'mediumaquamarine': [
            102,
            205,
            170,
            1
        ],
        'mediumblue': [
            0,
            0,
            205,
            1
        ],
        'mediumorchid': [
            186,
            85,
            211,
            1
        ],
        'mediumpurple': [
            147,
            112,
            219,
            1
        ],
        'mediumseagreen': [
            60,
            179,
            113,
            1
        ],
        'mediumslateblue': [
            123,
            104,
            238,
            1
        ],
        'mediumspringgreen': [
            0,
            250,
            154,
            1
        ],
        'mediumturquoise': [
            72,
            209,
            204,
            1
        ],
        'mediumvioletred': [
            199,
            21,
            133,
            1
        ],
        'midnightblue': [
            25,
            25,
            112,
            1
        ],
        'mintcream': [
            245,
            255,
            250,
            1
        ],
        'mistyrose': [
            255,
            228,
            225,
            1
        ],
        'moccasin': [
            255,
            228,
            181,
            1
        ],
        'navajowhite': [
            255,
            222,
            173,
            1
        ],
        'navy': [
            0,
            0,
            128,
            1
        ],
        'oldlace': [
            253,
            245,
            230,
            1
        ],
        'olive': [
            128,
            128,
            0,
            1
        ],
        'olivedrab': [
            107,
            142,
            35,
            1
        ],
        'orange': [
            255,
            165,
            0,
            1
        ],
        'orangered': [
            255,
            69,
            0,
            1
        ],
        'orchid': [
            218,
            112,
            214,
            1
        ],
        'palegoldenrod': [
            238,
            232,
            170,
            1
        ],
        'palegreen': [
            152,
            251,
            152,
            1
        ],
        'paleturquoise': [
            175,
            238,
            238,
            1
        ],
        'palevioletred': [
            219,
            112,
            147,
            1
        ],
        'papayawhip': [
            255,
            239,
            213,
            1
        ],
        'peachpuff': [
            255,
            218,
            185,
            1
        ],
        'peru': [
            205,
            133,
            63,
            1
        ],
        'pink': [
            255,
            192,
            203,
            1
        ],
        'plum': [
            221,
            160,
            221,
            1
        ],
        'powderblue': [
            176,
            224,
            230,
            1
        ],
        'purple': [
            128,
            0,
            128,
            1
        ],
        'red': [
            255,
            0,
            0,
            1
        ],
        'rosybrown': [
            188,
            143,
            143,
            1
        ],
        'royalblue': [
            65,
            105,
            225,
            1
        ],
        'saddlebrown': [
            139,
            69,
            19,
            1
        ],
        'salmon': [
            250,
            128,
            114,
            1
        ],
        'sandybrown': [
            244,
            164,
            96,
            1
        ],
        'seagreen': [
            46,
            139,
            87,
            1
        ],
        'seashell': [
            255,
            245,
            238,
            1
        ],
        'sienna': [
            160,
            82,
            45,
            1
        ],
        'silver': [
            192,
            192,
            192,
            1
        ],
        'skyblue': [
            135,
            206,
            235,
            1
        ],
        'slateblue': [
            106,
            90,
            205,
            1
        ],
        'slategray': [
            112,
            128,
            144,
            1
        ],
        'slategrey': [
            112,
            128,
            144,
            1
        ],
        'snow': [
            255,
            250,
            250,
            1
        ],
        'springgreen': [
            0,
            255,
            127,
            1
        ],
        'steelblue': [
            70,
            130,
            180,
            1
        ],
        'tan': [
            210,
            180,
            140,
            1
        ],
        'teal': [
            0,
            128,
            128,
            1
        ],
        'thistle': [
            216,
            191,
            216,
            1
        ],
        'tomato': [
            255,
            99,
            71,
            1
        ],
        'turquoise': [
            64,
            224,
            208,
            1
        ],
        'violet': [
            238,
            130,
            238,
            1
        ],
        'wheat': [
            245,
            222,
            179,
            1
        ],
        'white': [
            255,
            255,
            255,
            1
        ],
        'whitesmoke': [
            245,
            245,
            245,
            1
        ],
        'yellow': [
            255,
            255,
            0,
            1
        ],
        'yellowgreen': [
            154,
            205,
            50,
            1
        ]
    };
    function $98a346fa71cc3009$var$clampCssByte(i) {
        i = Math.round(i);
        return i < 0 ? 0 : i > 255 ? 255 : i;
    }
    function $98a346fa71cc3009$var$clampCssAngle(i) {
        i = Math.round(i);
        return i < 0 ? 0 : i > 360 ? 360 : i;
    }
    function $98a346fa71cc3009$var$clampCssFloat(f) {
        return f < 0 ? 0 : f > 1 ? 1 : f;
    }
    function $98a346fa71cc3009$var$parseCssInt(val) {
        var str = val;
        if (str.length && str.charAt(str.length - 1) === '%') return $98a346fa71cc3009$var$clampCssByte(parseFloat(str) / 100 * 255);
        return $98a346fa71cc3009$var$clampCssByte(parseInt(str, 10));
    }
    function $98a346fa71cc3009$var$parseCssFloat(val) {
        var str = val;
        if (str.length && str.charAt(str.length - 1) === '%') return $98a346fa71cc3009$var$clampCssFloat(parseFloat(str) / 100);
        return $98a346fa71cc3009$var$clampCssFloat(parseFloat(str));
    }
    function $98a346fa71cc3009$var$cssHueToRgb(m1, m2, h) {
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
        if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
        if (h * 2 < 1) return m2;
        if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
        return m1;
    }
    function $98a346fa71cc3009$var$lerpNumber(a, b, p) {
        return a + (b - a) * p;
    }
    function $98a346fa71cc3009$var$setRgba(out, r, g, b, a) {
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    function $98a346fa71cc3009$var$copyRgba(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        return out;
    }
    var $98a346fa71cc3009$var$colorCache = new (0, (0, parcelRequire("h4RuA")).default)(20);
    var $98a346fa71cc3009$var$lastRemovedArr = null;
    function $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr) {
        if ($98a346fa71cc3009$var$lastRemovedArr) $98a346fa71cc3009$var$copyRgba($98a346fa71cc3009$var$lastRemovedArr, rgbaArr);
        $98a346fa71cc3009$var$lastRemovedArr = $98a346fa71cc3009$var$colorCache.put(colorStr, $98a346fa71cc3009$var$lastRemovedArr || rgbaArr.slice());
    }
    function $98a346fa71cc3009$export$98e6a39c04603d36(colorStr, rgbaArr) {
        if (!colorStr) return;
        rgbaArr = rgbaArr || [];
        var cached = $98a346fa71cc3009$var$colorCache.get(colorStr);
        if (cached) return $98a346fa71cc3009$var$copyRgba(rgbaArr, cached);
        colorStr = colorStr + '';
        var str = colorStr.replace(/ /g, '').toLowerCase();
        if (str in $98a346fa71cc3009$var$kCSSColorTable) {
            $98a346fa71cc3009$var$copyRgba(rgbaArr, $98a346fa71cc3009$var$kCSSColorTable[str]);
            $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        var strLen = str.length;
        if (str.charAt(0) === '#') {
            if (strLen === 4 || strLen === 5) {
                var iv = parseInt(str.slice(1, 4), 16);
                if (!(iv >= 0 && iv <= 0xfff)) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $98a346fa71cc3009$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            } else if (strLen === 7 || strLen === 9) {
                var iv = parseInt(str.slice(1, 7), 16);
                if (!(iv >= 0 && iv <= 0xffffff)) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $98a346fa71cc3009$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            }
            return;
        }
        var op = str.indexOf('(');
        var ep = str.indexOf(')');
        if (op !== -1 && ep + 1 === strLen) {
            var fname = str.substr(0, op);
            var params = str.substr(op + 1, ep - (op + 1)).split(',');
            var alpha = 1;
            switch(fname){
                case 'rgba':
                    if (params.length !== 4) return params.length === 3 ? $98a346fa71cc3009$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    alpha = $98a346fa71cc3009$var$parseCssFloat(params.pop());
                case 'rgb':
                    if (params.length !== 3) {
                        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                        return;
                    }
                    $98a346fa71cc3009$var$setRgba(rgbaArr, $98a346fa71cc3009$var$parseCssInt(params[0]), $98a346fa71cc3009$var$parseCssInt(params[1]), $98a346fa71cc3009$var$parseCssInt(params[2]), alpha);
                    $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                case 'hsla':
                    if (params.length !== 4) {
                        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                        return;
                    }
                    params[3] = $98a346fa71cc3009$var$parseCssFloat(params[3]);
                    $98a346fa71cc3009$var$hsla2rgba(params, rgbaArr);
                    $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                case 'hsl':
                    if (params.length !== 3) {
                        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                        return;
                    }
                    $98a346fa71cc3009$var$hsla2rgba(params, rgbaArr);
                    $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                default:
                    return;
            }
        }
        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
        return;
    }
    function $98a346fa71cc3009$var$hsla2rgba(hsla, rgba) {
        var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
        var s = $98a346fa71cc3009$var$parseCssFloat(hsla[1]);
        var l = $98a346fa71cc3009$var$parseCssFloat(hsla[2]);
        var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var m1 = l * 2 - m2;
        rgba = rgba || [];
        $98a346fa71cc3009$var$setRgba(rgba, $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h) * 255), $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
        if (hsla.length === 4) rgba[3] = hsla[3];
        return rgba;
    }
    function $98a346fa71cc3009$var$rgba2hsla(rgba) {
        if (!rgba) return;
        var R = rgba[0] / 255;
        var G = rgba[1] / 255;
        var B = rgba[2] / 255;
        var vMin = Math.min(R, G, B);
        var vMax = Math.max(R, G, B);
        var delta = vMax - vMin;
        var L = (vMax + vMin) / 2;
        var H;
        var S;
        if (delta === 0) {
            H = 0;
            S = 0;
        } else {
            if (L < 0.5) S = delta / (vMax + vMin);
            else S = delta / (2 - vMax - vMin);
            var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
            var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
            var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
            if (R === vMax) H = deltaB - deltaG;
            else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
            else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
            if (H < 0) H += 1;
            if (H > 1) H -= 1;
        }
        var hsla = [
            H * 360,
            S,
            L
        ];
        if (rgba[3] != null) hsla.push(rgba[3]);
        return hsla;
    }
    function $98a346fa71cc3009$export$590e8b2c435046d9(color, level) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (colorArr) {
            for(var i = 0; i < 3; i++){
                if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
                else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
                if (colorArr[i] > 255) colorArr[i] = 255;
                else if (colorArr[i] < 0) colorArr[i] = 0;
            }
            return $98a346fa71cc3009$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
        }
    }
    function $98a346fa71cc3009$export$7ea66e3774a60b67(color) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
    }
    function $98a346fa71cc3009$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
        if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
        out = out || [];
        var value = normalizedValue * (colors.length - 1);
        var leftIndex = Math.floor(value);
        var rightIndex = Math.ceil(value);
        var leftColor = colors[leftIndex];
        var rightColor = colors[rightIndex];
        var dv = value - leftIndex;
        out[0] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[0], rightColor[0], dv));
        out[1] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[1], rightColor[1], dv));
        out[2] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[2], rightColor[2], dv));
        out[3] = $98a346fa71cc3009$var$clampCssFloat($98a346fa71cc3009$var$lerpNumber(leftColor[3], rightColor[3], dv));
        return out;
    }
    var $98a346fa71cc3009$export$daa5a65daad5df58 = $98a346fa71cc3009$export$66cb3c0e9efc61c8;
    function $98a346fa71cc3009$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
        if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
        var value = normalizedValue * (colors.length - 1);
        var leftIndex = Math.floor(value);
        var rightIndex = Math.ceil(value);
        var leftColor = $98a346fa71cc3009$export$98e6a39c04603d36(colors[leftIndex]);
        var rightColor = $98a346fa71cc3009$export$98e6a39c04603d36(colors[rightIndex]);
        var dv = value - leftIndex;
        var color = $98a346fa71cc3009$export$fac44ee5b035f737([
            $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[0], rightColor[0], dv)),
            $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[1], rightColor[1], dv)),
            $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[2], rightColor[2], dv)),
            $98a346fa71cc3009$var$clampCssFloat($98a346fa71cc3009$var$lerpNumber(leftColor[3], rightColor[3], dv))
        ], 'rgba');
        return fullOutput ? {
            color: color,
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            value: value
        } : color;
    }
    var $98a346fa71cc3009$export$296e08242b78a3ec = $98a346fa71cc3009$export$3a89f8d6f6bf6c9f;
    function $98a346fa71cc3009$export$d898ae866e27bf18(color, h, s, l) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (color) {
            colorArr = $98a346fa71cc3009$var$rgba2hsla(colorArr);
            h != null && (colorArr[0] = $98a346fa71cc3009$var$clampCssAngle(h));
            s != null && (colorArr[1] = $98a346fa71cc3009$var$parseCssFloat(s));
            l != null && (colorArr[2] = $98a346fa71cc3009$var$parseCssFloat(l));
            return $98a346fa71cc3009$export$fac44ee5b035f737($98a346fa71cc3009$var$hsla2rgba(colorArr), 'rgba');
        }
    }
    function $98a346fa71cc3009$export$ab4754bf42583a26(color, alpha) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (colorArr && alpha != null) {
            colorArr[3] = $98a346fa71cc3009$var$clampCssFloat(alpha);
            return $98a346fa71cc3009$export$fac44ee5b035f737(colorArr, 'rgba');
        }
    }
    function $98a346fa71cc3009$export$fac44ee5b035f737(arrColor, type) {
        if (!arrColor || !arrColor.length) return;
        var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
        if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
        return type + '(' + colorStr + ')';
    }
    function $98a346fa71cc3009$export$16c0ec21a6f9ef95(color, backgroundLum) {
        var arr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
    }
    function $98a346fa71cc3009$export$4385e60b38654f68() {
        var r = Math.round(Math.random() * 255);
        var g = Math.round(Math.random() * 255);
        var b = Math.round(Math.random() * 255);
        return 'rgb(' + r + ',' + g + ',' + b + ')';
    }
});
parcelRegister("h4RuA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6ec4ddc95ccc3f1$export$2e2bcd8739ae039);
    var $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59 = function() {
        function Entry(val) {
            this.value = val;
        }
        return Entry;
    }();
    var $c6ec4ddc95ccc3f1$export$f0ef28713f767754 = function() {
        function LinkedList() {
            this._len = 0;
        }
        LinkedList.prototype.insert = function(val) {
            var entry = new $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59(val);
            this.insertEntry(entry);
            return entry;
        };
        LinkedList.prototype.insertEntry = function(entry) {
            if (!this.head) this.head = this.tail = entry;
            else {
                this.tail.next = entry;
                entry.prev = this.tail;
                entry.next = null;
                this.tail = entry;
            }
            this._len++;
        };
        LinkedList.prototype.remove = function(entry) {
            var prev = entry.prev;
            var next = entry.next;
            if (prev) prev.next = next;
            else this.head = next;
            if (next) next.prev = prev;
            else this.tail = prev;
            entry.next = entry.prev = null;
            this._len--;
        };
        LinkedList.prototype.len = function() {
            return this._len;
        };
        LinkedList.prototype.clear = function() {
            this.head = this.tail = null;
            this._len = 0;
        };
        return LinkedList;
    }();
    var $c6ec4ddc95ccc3f1$var$LRU = function() {
        function LRU(maxSize) {
            this._list = new $c6ec4ddc95ccc3f1$export$f0ef28713f767754();
            this._maxSize = 10;
            this._map = {};
            this._maxSize = maxSize;
        }
        LRU.prototype.put = function(key, value) {
            var list = this._list;
            var map = this._map;
            var removed = null;
            if (map[key] == null) {
                var len = list.len();
                var entry = this._lastRemovedEntry;
                if (len >= this._maxSize && len > 0) {
                    var leastUsedEntry = list.head;
                    list.remove(leastUsedEntry);
                    delete map[leastUsedEntry.key];
                    removed = leastUsedEntry.value;
                    this._lastRemovedEntry = leastUsedEntry;
                }
                if (entry) entry.value = value;
                else entry = new $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59(value);
                entry.key = key;
                list.insertEntry(entry);
                map[key] = entry;
            }
            return removed;
        };
        LRU.prototype.get = function(key) {
            var entry = this._map[key];
            var list = this._list;
            if (entry != null) {
                if (entry !== list.tail) {
                    list.remove(entry);
                    list.insertEntry(entry);
                }
                return entry.value;
            }
        };
        LRU.prototype.clear = function() {
            this._list.clear();
            this._map = {};
        };
        LRU.prototype.len = function() {
            return this._list.len();
        };
        return LRU;
    }();
    var $c6ec4ddc95ccc3f1$export$2e2bcd8739ae039 = $c6ec4ddc95ccc3f1$var$LRU;
});
parcelRegister("1E3E8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$132c5af5562dffd4$export$2e2bcd8739ae039);
    var $izqgC;
    var $bMDnR;
    var $132c5af5562dffd4$var$mathMin = Math.min;
    var $132c5af5562dffd4$var$mathMax = Math.max;
    var $132c5af5562dffd4$var$lt = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$rb = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$lb = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$rt = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$minTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$maxTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$BoundingRect = function() {
        function BoundingRect(x, y, width, height) {
            if (width < 0) {
                x = x + width;
                width = -width;
            }
            if (height < 0) {
                y = y + height;
                height = -height;
            }
            this.x = x;
            this.y = y;
            this.width = width;
            this.height = height;
        }
        BoundingRect.prototype.union = function(other) {
            var x = $132c5af5562dffd4$var$mathMin(other.x, this.x);
            var y = $132c5af5562dffd4$var$mathMin(other.y, this.y);
            if (isFinite(this.x) && isFinite(this.width)) this.width = $132c5af5562dffd4$var$mathMax(other.x + other.width, this.x + this.width) - x;
            else this.width = other.width;
            if (isFinite(this.y) && isFinite(this.height)) this.height = $132c5af5562dffd4$var$mathMax(other.y + other.height, this.y + this.height) - y;
            else this.height = other.height;
            this.x = x;
            this.y = y;
        };
        BoundingRect.prototype.applyTransform = function(m) {
            BoundingRect.applyTransform(this, this, m);
        };
        BoundingRect.prototype.calculateTransform = function(b) {
            var a = this;
            var sx = b.width / a.width;
            var sy = b.height / a.height;
            var m = (0, parcelRequire("izqgC")).create();
            (0, parcelRequire("izqgC")).translate(m, m, [
                -a.x,
                -a.y
            ]);
            (0, parcelRequire("izqgC")).scale(m, m, [
                sx,
                sy
            ]);
            (0, parcelRequire("izqgC")).translate(m, m, [
                b.x,
                b.y
            ]);
            return m;
        };
        BoundingRect.prototype.intersect = function(b, mtv) {
            if (!b) return false;
            if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
            var a = this;
            var ax0 = a.x;
            var ax1 = a.x + a.width;
            var ay0 = a.y;
            var ay1 = a.y + a.height;
            var bx0 = b.x;
            var bx1 = b.x + b.width;
            var by0 = b.y;
            var by1 = b.y + b.height;
            var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
            if (mtv) {
                var dMin = Infinity;
                var dMax = 0;
                var d0 = Math.abs(ax1 - bx0);
                var d1 = Math.abs(bx1 - ax0);
                var d2 = Math.abs(ay1 - by0);
                var d3 = Math.abs(by1 - ay0);
                var dx = Math.min(d0, d1);
                var dy = Math.min(d2, d3);
                if (ax1 < bx0 || bx1 < ax0) {
                    if (dx > dMax) {
                        dMax = dx;
                        if (d0 < d1) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, -d0, 0);
                        else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, d1, 0);
                    }
                } else if (dx < dMin) {
                    dMin = dx;
                    if (d0 < d1) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, d0, 0);
                    else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, -d1, 0);
                }
                if (ay1 < by0 || by1 < ay0) {
                    if (dy > dMax) {
                        dMax = dy;
                        if (d2 < d3) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, 0, -d2);
                        else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, 0, d3);
                    }
                } else if (dx < dMin) {
                    dMin = dx;
                    if (d2 < d3) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, 0, d2);
                    else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, 0, -d3);
                }
            }
            if (mtv) (0, (0, parcelRequire("bMDnR")).default).copy(mtv, overlap ? $132c5af5562dffd4$var$minTv : $132c5af5562dffd4$var$maxTv);
            return overlap;
        };
        BoundingRect.prototype.contain = function(x, y) {
            var rect = this;
            return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
        };
        BoundingRect.prototype.clone = function() {
            return new BoundingRect(this.x, this.y, this.width, this.height);
        };
        BoundingRect.prototype.copy = function(other) {
            BoundingRect.copy(this, other);
        };
        BoundingRect.prototype.plain = function() {
            return {
                x: this.x,
                y: this.y,
                width: this.width,
                height: this.height
            };
        };
        BoundingRect.prototype.isFinite = function() {
            return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
        };
        BoundingRect.prototype.isZero = function() {
            return this.width === 0 || this.height === 0;
        };
        BoundingRect.create = function(rect) {
            return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
        };
        BoundingRect.copy = function(target, source) {
            target.x = source.x;
            target.y = source.y;
            target.width = source.width;
            target.height = source.height;
        };
        BoundingRect.applyTransform = function(target, source, m) {
            if (!m) {
                if (target !== source) BoundingRect.copy(target, source);
                return;
            }
            if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
                var sx = m[0];
                var sy = m[3];
                var tx = m[4];
                var ty = m[5];
                target.x = source.x * sx + tx;
                target.y = source.y * sy + ty;
                target.width = source.width * sx;
                target.height = source.height * sy;
                if (target.width < 0) {
                    target.x += target.width;
                    target.width = -target.width;
                }
                if (target.height < 0) {
                    target.y += target.height;
                    target.height = -target.height;
                }
                return;
            }
            $132c5af5562dffd4$var$lt.x = $132c5af5562dffd4$var$lb.x = source.x;
            $132c5af5562dffd4$var$lt.y = $132c5af5562dffd4$var$rt.y = source.y;
            $132c5af5562dffd4$var$rb.x = $132c5af5562dffd4$var$rt.x = source.x + source.width;
            $132c5af5562dffd4$var$rb.y = $132c5af5562dffd4$var$lb.y = source.y + source.height;
            $132c5af5562dffd4$var$lt.transform(m);
            $132c5af5562dffd4$var$rt.transform(m);
            $132c5af5562dffd4$var$rb.transform(m);
            $132c5af5562dffd4$var$lb.transform(m);
            target.x = $132c5af5562dffd4$var$mathMin($132c5af5562dffd4$var$lt.x, $132c5af5562dffd4$var$rb.x, $132c5af5562dffd4$var$lb.x, $132c5af5562dffd4$var$rt.x);
            target.y = $132c5af5562dffd4$var$mathMin($132c5af5562dffd4$var$lt.y, $132c5af5562dffd4$var$rb.y, $132c5af5562dffd4$var$lb.y, $132c5af5562dffd4$var$rt.y);
            var maxX = $132c5af5562dffd4$var$mathMax($132c5af5562dffd4$var$lt.x, $132c5af5562dffd4$var$rb.x, $132c5af5562dffd4$var$lb.x, $132c5af5562dffd4$var$rt.x);
            var maxY = $132c5af5562dffd4$var$mathMax($132c5af5562dffd4$var$lt.y, $132c5af5562dffd4$var$rb.y, $132c5af5562dffd4$var$lb.y, $132c5af5562dffd4$var$rt.y);
            target.width = maxX - target.x;
            target.height = maxY - target.y;
        };
        return BoundingRect;
    }();
    var $132c5af5562dffd4$export$2e2bcd8739ae039 = $132c5af5562dffd4$var$BoundingRect;
});
parcelRegister("bMDnR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8942ba3a66d599f1$export$2e2bcd8739ae039);
    var $8942ba3a66d599f1$var$Point = function() {
        function Point(x, y) {
            this.x = x || 0;
            this.y = y || 0;
        }
        Point.prototype.copy = function(other) {
            this.x = other.x;
            this.y = other.y;
            return this;
        };
        Point.prototype.clone = function() {
            return new Point(this.x, this.y);
        };
        Point.prototype.set = function(x, y) {
            this.x = x;
            this.y = y;
            return this;
        };
        Point.prototype.equal = function(other) {
            return other.x === this.x && other.y === this.y;
        };
        Point.prototype.add = function(other) {
            this.x += other.x;
            this.y += other.y;
            return this;
        };
        Point.prototype.scale = function(scalar) {
            this.x *= scalar;
            this.y *= scalar;
        };
        Point.prototype.scaleAndAdd = function(other, scalar) {
            this.x += other.x * scalar;
            this.y += other.y * scalar;
        };
        Point.prototype.sub = function(other) {
            this.x -= other.x;
            this.y -= other.y;
            return this;
        };
        Point.prototype.dot = function(other) {
            return this.x * other.x + this.y * other.y;
        };
        Point.prototype.len = function() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
        };
        Point.prototype.lenSquare = function() {
            return this.x * this.x + this.y * this.y;
        };
        Point.prototype.normalize = function() {
            var len = this.len();
            this.x /= len;
            this.y /= len;
            return this;
        };
        Point.prototype.distance = function(other) {
            var dx = this.x - other.x;
            var dy = this.y - other.y;
            return Math.sqrt(dx * dx + dy * dy);
        };
        Point.prototype.distanceSquare = function(other) {
            var dx = this.x - other.x;
            var dy = this.y - other.y;
            return dx * dx + dy * dy;
        };
        Point.prototype.negate = function() {
            this.x = -this.x;
            this.y = -this.y;
            return this;
        };
        Point.prototype.transform = function(m) {
            if (!m) return;
            var x = this.x;
            var y = this.y;
            this.x = m[0] * x + m[2] * y + m[4];
            this.y = m[1] * x + m[3] * y + m[5];
            return this;
        };
        Point.prototype.toArray = function(out) {
            out[0] = this.x;
            out[1] = this.y;
            return out;
        };
        Point.prototype.fromArray = function(input) {
            this.x = input[0];
            this.y = input[1];
        };
        Point.set = function(p, x, y) {
            p.x = x;
            p.y = y;
        };
        Point.copy = function(p, p2) {
            p.x = p2.x;
            p.y = p2.y;
        };
        Point.len = function(p) {
            return Math.sqrt(p.x * p.x + p.y * p.y);
        };
        Point.lenSquare = function(p) {
            return p.x * p.x + p.y * p.y;
        };
        Point.dot = function(p0, p1) {
            return p0.x * p1.x + p0.y * p1.y;
        };
        Point.add = function(out, p0, p1) {
            out.x = p0.x + p1.x;
            out.y = p0.y + p1.y;
        };
        Point.sub = function(out, p0, p1) {
            out.x = p0.x - p1.x;
            out.y = p0.y - p1.y;
        };
        Point.scale = function(out, p0, scalar) {
            out.x = p0.x * scalar;
            out.y = p0.y * scalar;
        };
        Point.scaleAndAdd = function(out, p0, p1, scalar) {
            out.x = p0.x + p1.x * scalar;
            out.y = p0.y + p1.y * scalar;
        };
        Point.lerp = function(out, p0, p1, t) {
            var onet = 1 - t;
            out.x = onet * p0.x + t * p1.x;
            out.y = onet * p0.y + t * p1.y;
        };
        return Point;
    }();
    var $8942ba3a66d599f1$export$2e2bcd8739ae039 = $8942ba3a66d599f1$var$Point;
});
parcelRegister("bRKv5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a38b6f95cbd6cc6$export$2e2bcd8739ae039);
    var $8a38b6f95cbd6cc6$var$Eventful = function() {
        function Eventful(eventProcessors) {
            if (eventProcessors) this._$eventProcessor = eventProcessors;
        }
        Eventful.prototype.on = function(event, query, handler, context) {
            if (!this._$handlers) this._$handlers = {};
            var _h = this._$handlers;
            if (typeof query === 'function') {
                context = handler;
                handler = query;
                query = null;
            }
            if (!handler || !event) return this;
            var eventProcessor = this._$eventProcessor;
            if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
            if (!_h[event]) _h[event] = [];
            for(var i = 0; i < _h[event].length; i++){
                if (_h[event][i].h === handler) return this;
            }
            var wrap = {
                h: handler,
                query: query,
                ctx: context || this,
                callAtLast: handler.zrEventfulCallAtLast
            };
            var lastIndex = _h[event].length - 1;
            var lastWrap = _h[event][lastIndex];
            lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
            return this;
        };
        Eventful.prototype.isSilent = function(eventName) {
            var _h = this._$handlers;
            return !_h || !_h[eventName] || !_h[eventName].length;
        };
        Eventful.prototype.off = function(eventType, handler) {
            var _h = this._$handlers;
            if (!_h) return this;
            if (!eventType) {
                this._$handlers = {};
                return this;
            }
            if (handler) {
                if (_h[eventType]) {
                    var newList = [];
                    for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                    _h[eventType] = newList;
                }
                if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
            } else delete _h[eventType];
            return this;
        };
        Eventful.prototype.trigger = function(eventType) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            if (!this._$handlers) return this;
            var _h = this._$handlers[eventType];
            var eventProcessor = this._$eventProcessor;
            if (_h) {
                var argLen = args.length;
                var len = _h.length;
                for(var i = 0; i < len; i++){
                    var hItem = _h[i];
                    if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                    switch(argLen){
                        case 0:
                            hItem.h.call(hItem.ctx);
                            break;
                        case 1:
                            hItem.h.call(hItem.ctx, args[0]);
                            break;
                        case 2:
                            hItem.h.call(hItem.ctx, args[0], args[1]);
                            break;
                        default:
                            hItem.h.apply(hItem.ctx, args);
                            break;
                    }
                }
            }
            eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
            return this;
        };
        Eventful.prototype.triggerWithContext = function(type) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            if (!this._$handlers) return this;
            var _h = this._$handlers[type];
            var eventProcessor = this._$eventProcessor;
            if (_h) {
                var argLen = args.length;
                var ctx = args[argLen - 1];
                var len = _h.length;
                for(var i = 0; i < len; i++){
                    var hItem = _h[i];
                    if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                    switch(argLen){
                        case 0:
                            hItem.h.call(ctx);
                            break;
                        case 1:
                            hItem.h.call(ctx, args[0]);
                            break;
                        case 2:
                            hItem.h.call(ctx, args[0], args[1]);
                            break;
                        default:
                            hItem.h.apply(ctx, args.slice(1, argLen - 1));
                            break;
                    }
                }
            }
            eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
            return this;
        };
        return Eventful;
    }();
    var $8a38b6f95cbd6cc6$export$2e2bcd8739ae039 = $8a38b6f95cbd6cc6$var$Eventful;
});
parcelRegister("b7ZX8", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_FONT", ()=>$81a067b5a1d9459c$export$7d7a232b6d2cc80c);
    $parcel$export(module.exports, "getWidth", ()=>$81a067b5a1d9459c$export$3c49c185de0c2bfc);
    $parcel$export(module.exports, "getLineHeight", ()=>$81a067b5a1d9459c$export$56204a27a2958a55);
    $parcel$export(module.exports, "adjustTextX", ()=>$81a067b5a1d9459c$export$eb5a525ef00ef9a4);
    $parcel$export(module.exports, "adjustTextY", ()=>$81a067b5a1d9459c$export$bf7d6802d2badd9);
    $parcel$export(module.exports, "getBoundingRect", ()=>$81a067b5a1d9459c$export$c381147bfed79d9f);
    $parcel$export(module.exports, "parsePercent", ()=>$81a067b5a1d9459c$export$e8514cb5a5e2b40f);
    $parcel$export(module.exports, "calculateTextPosition", ()=>$81a067b5a1d9459c$export$eee3603b512feab7);
    var $1E3E8;
    var $bahqM;
    var $h4RuA;
    var $81a067b5a1d9459c$var$textWidthCache = {};
    var $81a067b5a1d9459c$export$7d7a232b6d2cc80c = '12px sans-serif';
    var $81a067b5a1d9459c$var$_ctx;
    var $81a067b5a1d9459c$var$_cachedFont;
    function $81a067b5a1d9459c$var$defaultMeasureText(text, font) {
        if (!$81a067b5a1d9459c$var$_ctx) $81a067b5a1d9459c$var$_ctx = (0, (0, parcelRequire("bahqM")).createCanvas)().getContext('2d');
        if ($81a067b5a1d9459c$var$_cachedFont !== font) $81a067b5a1d9459c$var$_cachedFont = $81a067b5a1d9459c$var$_ctx.font = font || $81a067b5a1d9459c$export$7d7a232b6d2cc80c;
        return $81a067b5a1d9459c$var$_ctx.measureText(text);
    }
    var $81a067b5a1d9459c$var$methods = {
        measureText: $81a067b5a1d9459c$var$defaultMeasureText
    };
    function $81a067b5a1d9459c$export$d35a04b83ea6803e(name, fn) {
        $81a067b5a1d9459c$var$methods[name] = fn;
    }
    function $81a067b5a1d9459c$export$3c49c185de0c2bfc(text, font) {
        font = font || $81a067b5a1d9459c$export$7d7a232b6d2cc80c;
        var cacheOfFont = $81a067b5a1d9459c$var$textWidthCache[font];
        if (!cacheOfFont) cacheOfFont = $81a067b5a1d9459c$var$textWidthCache[font] = new (0, (0, parcelRequire("h4RuA")).default)(500);
        var width = cacheOfFont.get(text);
        if (width == null) {
            width = $81a067b5a1d9459c$var$methods.measureText(text, font).width;
            cacheOfFont.put(text, width);
        }
        return width;
    }
    function $81a067b5a1d9459c$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
        var width = $81a067b5a1d9459c$export$3c49c185de0c2bfc(text, font);
        var height = $81a067b5a1d9459c$export$56204a27a2958a55(font);
        var x = $81a067b5a1d9459c$export$eb5a525ef00ef9a4(0, width, textAlign);
        var y = $81a067b5a1d9459c$export$bf7d6802d2badd9(0, height, textBaseline);
        var rect = new (0, (0, parcelRequire("1E3E8")).default)(x, y, width, height);
        return rect;
    }
    function $81a067b5a1d9459c$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
        var textLines = ((text || '') + '').split('\n');
        var len = textLines.length;
        if (len === 1) return $81a067b5a1d9459c$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
        else {
            var uniondRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
            for(var i = 0; i < textLines.length; i++){
                var rect = $81a067b5a1d9459c$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
                i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
            }
            return uniondRect;
        }
    }
    function $81a067b5a1d9459c$export$eb5a525ef00ef9a4(x, width, textAlign) {
        if (textAlign === 'right') x -= width;
        else if (textAlign === 'center') x -= width / 2;
        return x;
    }
    function $81a067b5a1d9459c$export$bf7d6802d2badd9(y, height, verticalAlign) {
        if (verticalAlign === 'middle') y -= height / 2;
        else if (verticalAlign === 'bottom') y -= height;
        return y;
    }
    function $81a067b5a1d9459c$export$56204a27a2958a55(font) {
        return $81a067b5a1d9459c$export$3c49c185de0c2bfc("\u56FD", font);
    }
    function $81a067b5a1d9459c$export$866cc30a33805630(text, font) {
        return $81a067b5a1d9459c$var$methods.measureText(text, font);
    }
    function $81a067b5a1d9459c$export$e8514cb5a5e2b40f(value, maxValue) {
        if (typeof value === 'string') {
            if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
            return parseFloat(value);
        }
        return value;
    }
    function $81a067b5a1d9459c$export$eee3603b512feab7(out, opts, rect) {
        var textPosition = opts.position || 'inside';
        var distance = opts.distance != null ? opts.distance : 5;
        var height = rect.height;
        var width = rect.width;
        var halfHeight = height / 2;
        var x = rect.x;
        var y = rect.y;
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        if (textPosition instanceof Array) {
            x += $81a067b5a1d9459c$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
            y += $81a067b5a1d9459c$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
            textAlign = null;
            textVerticalAlign = null;
        } else switch(textPosition){
            case 'left':
                x -= distance;
                y += halfHeight;
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'right':
                x += distance + width;
                y += halfHeight;
                textVerticalAlign = 'middle';
                break;
            case 'top':
                x += width / 2;
                y -= distance;
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'bottom':
                x += width / 2;
                y += height + distance;
                textAlign = 'center';
                break;
            case 'inside':
                x += width / 2;
                y += halfHeight;
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'insideLeft':
                x += distance;
                y += halfHeight;
                textVerticalAlign = 'middle';
                break;
            case 'insideRight':
                x += width - distance;
                y += halfHeight;
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideTop':
                x += width / 2;
                y += distance;
                textAlign = 'center';
                break;
            case 'insideBottom':
                x += width / 2;
                y += height - distance;
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideTopLeft':
                x += distance;
                y += distance;
                break;
            case 'insideTopRight':
                x += width - distance;
                y += distance;
                textAlign = 'right';
                break;
            case 'insideBottomLeft':
                x += distance;
                y += height - distance;
                textVerticalAlign = 'bottom';
                break;
            case 'insideBottomRight':
                x += width - distance;
                y += height - distance;
                textAlign = 'right';
                textVerticalAlign = 'bottom';
                break;
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    }
});
parcelRegister("7y1my", function(module, exports) {
    $parcel$export(module.exports, "devicePixelRatio", ()=>$57ecc3ffeb61d50b$export$508f096bfcdaac40);
    $parcel$export(module.exports, "DARK_MODE_THRESHOLD", ()=>$57ecc3ffeb61d50b$export$fd81e7ebc7dae256);
    $parcel$export(module.exports, "DARK_LABEL_COLOR", ()=>$57ecc3ffeb61d50b$export$f8ce94761f39398d);
    $parcel$export(module.exports, "LIGHT_LABEL_COLOR", ()=>$57ecc3ffeb61d50b$export$3c6e95f318c8369b);
    $parcel$export(module.exports, "LIGHTER_LABEL_COLOR", ()=>$57ecc3ffeb61d50b$export$27682248795c3c6b);
    var $57ecc3ffeb61d50b$var$dpr = 1;
    if (typeof window !== 'undefined') $57ecc3ffeb61d50b$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
    var $57ecc3ffeb61d50b$export$7cdcde344c85339c = 0;
    var $57ecc3ffeb61d50b$export$508f096bfcdaac40 = $57ecc3ffeb61d50b$var$dpr;
    var $57ecc3ffeb61d50b$export$fd81e7ebc7dae256 = 0.4;
    var $57ecc3ffeb61d50b$export$f8ce94761f39398d = '#333';
    var $57ecc3ffeb61d50b$export$3c6e95f318c8369b = '#ccc';
    var $57ecc3ffeb61d50b$export$27682248795c3c6b = '#eee';
});
parcelRegister("hZfwb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1842bbf4a5e2f15$export$2e2bcd8739ae039);
    var $d1842bbf4a5e2f15$var$Browser = function() {
        function Browser() {
            this.firefox = false;
            this.ie = false;
            this.edge = false;
            this.newEdge = false;
            this.weChat = false;
        }
        return Browser;
    }();
    var $d1842bbf4a5e2f15$var$Env = function() {
        function Env() {
            this.browser = new $d1842bbf4a5e2f15$var$Browser();
            this.node = false;
            this.wxa = false;
            this.worker = false;
            this.canvasSupported = false;
            this.svgSupported = false;
            this.touchEventsSupported = false;
            this.pointerEventsSupported = false;
            this.domSupported = false;
            this.transformSupported = false;
            this.transform3dSupported = false;
        }
        return Env;
    }();
    var $d1842bbf4a5e2f15$var$env = new $d1842bbf4a5e2f15$var$Env();
    if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
        $d1842bbf4a5e2f15$var$env.wxa = true;
        $d1842bbf4a5e2f15$var$env.canvasSupported = true;
        $d1842bbf4a5e2f15$var$env.touchEventsSupported = true;
    } else if (typeof document === 'undefined' && typeof self !== 'undefined') {
        $d1842bbf4a5e2f15$var$env.worker = true;
        $d1842bbf4a5e2f15$var$env.canvasSupported = true;
    } else if (typeof navigator === 'undefined') {
        $d1842bbf4a5e2f15$var$env.node = true;
        $d1842bbf4a5e2f15$var$env.canvasSupported = true;
        $d1842bbf4a5e2f15$var$env.svgSupported = true;
    } else $d1842bbf4a5e2f15$var$detect(navigator.userAgent, $d1842bbf4a5e2f15$var$env);
    function $d1842bbf4a5e2f15$var$detect(ua, env) {
        var browser = env.browser;
        var firefox = ua.match(/Firefox\/([\d.]+)/);
        var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
        var edge = ua.match(/Edge?\/([\d.]+)/);
        var weChat = /micromessenger/i.test(ua);
        if (firefox) {
            browser.firefox = true;
            browser.version = firefox[1];
        }
        if (ie) {
            browser.ie = true;
            browser.version = ie[1];
        }
        if (edge) {
            browser.edge = true;
            browser.version = edge[1];
            browser.newEdge = +edge[1].split('.')[0] > 18;
        }
        if (weChat) browser.weChat = true;
        env.canvasSupported = !!document.createElement('canvas').getContext;
        env.svgSupported = typeof SVGRect !== 'undefined';
        env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
        env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
        env.domSupported = typeof document !== 'undefined';
        var style = document.documentElement.style;
        env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
        env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
    }
    var $d1842bbf4a5e2f15$export$2e2bcd8739ae039 = $d1842bbf4a5e2f15$var$env;
});
parcelRegister("aVawM", function(module, exports) {
    $parcel$export(module.exports, "REDRAW_BIT", ()=>$7f3764d4456adf3b$export$a7b6db622c6c7dbd);
    $parcel$export(module.exports, "STYLE_CHANGED_BIT", ()=>$7f3764d4456adf3b$export$ada8b2beb3d76671);
    $parcel$export(module.exports, "SHAPE_CHANGED_BIT", ()=>$7f3764d4456adf3b$export$f75fe89a33ebe115);
    var $7f3764d4456adf3b$export$a7b6db622c6c7dbd = 1;
    var $7f3764d4456adf3b$export$ada8b2beb3d76671 = 2;
    var $7f3764d4456adf3b$export$f75fe89a33ebe115 = 4;
});
parcelRegister("fHITF", function(module, exports) {
    $parcel$export(module.exports, "extendShape", ()=>$b6edb2bb66445620$export$d0d5398c9d612037);
    $parcel$export(module.exports, "extendPath", ()=>$b6edb2bb66445620$export$53b54a3137026af0);
    $parcel$export(module.exports, "registerShape", ()=>$b6edb2bb66445620$export$2b95b62e3aaf6fdd);
    $parcel$export(module.exports, "getShapeClass", ()=>$b6edb2bb66445620$export$51df4b5565a58189);
    $parcel$export(module.exports, "makePath", ()=>$b6edb2bb66445620$export$aa9bab72412f5613);
    $parcel$export(module.exports, "resizePath", ()=>$b6edb2bb66445620$export$566dbf1c62b04fc7);
    $parcel$export(module.exports, "makeImage", ()=>$b6edb2bb66445620$export$7a2bdede98851ac5);
    $parcel$export(module.exports, "mergePath", ()=>$b6edb2bb66445620$export$7b1dd269fbc4e903);
    $parcel$export(module.exports, "subPixelOptimizeLine", ()=>$b6edb2bb66445620$export$8b4b620d7f4aad1b);
    $parcel$export(module.exports, "subPixelOptimizeRect", ()=>$b6edb2bb66445620$export$60e2aa74957d0b9d);
    $parcel$export(module.exports, "subPixelOptimize", ()=>$b6edb2bb66445620$export$72c4fd4c1b8fcb10);
    $parcel$export(module.exports, "getTransform", ()=>$b6edb2bb66445620$export$fce0c6cfca85ed96);
    $parcel$export(module.exports, "applyTransform", ()=>$b6edb2bb66445620$export$9f9dcb98c894b623);
    $parcel$export(module.exports, "transformDirection", ()=>$b6edb2bb66445620$export$fff94e9792354cfa);
    $parcel$export(module.exports, "groupTransition", ()=>$b6edb2bb66445620$export$64fcab7860c216ae);
    $parcel$export(module.exports, "clipPointsByRect", ()=>$b6edb2bb66445620$export$e2f409471bbbc1dc);
    $parcel$export(module.exports, "clipRectByRect", ()=>$b6edb2bb66445620$export$d0d3709202b8b2a);
    $parcel$export(module.exports, "createIcon", ()=>$b6edb2bb66445620$export$274edc73af1ae9c8);
    $parcel$export(module.exports, "linePolygonIntersect", ()=>$b6edb2bb66445620$export$4f47c855a5e9ae9);
    $parcel$export(module.exports, "lineLineIntersect", ()=>$b6edb2bb66445620$export$6c0a70ea1d8d158b);
    $parcel$export(module.exports, "setTooltipConfig", ()=>$b6edb2bb66445620$export$fc6410d97fab306c);
    $parcel$export(module.exports, "updateProps", ()=>(parcelRequire("eYgMC")).updateProps);
    $parcel$export(module.exports, "initProps", ()=>(parcelRequire("eYgMC")).initProps);
    $parcel$export(module.exports, "removeElement", ()=>(parcelRequire("eYgMC")).removeElement);
    $parcel$export(module.exports, "removeElementWithFadeOut", ()=>(parcelRequire("eYgMC")).removeElementWithFadeOut);
    $parcel$export(module.exports, "isElementRemoved", ()=>(parcelRequire("eYgMC")).isElementRemoved);
    $parcel$export(module.exports, "Group", ()=>(parcelRequire("4KVOr")).default);
    $parcel$export(module.exports, "Image", ()=>(parcelRequire("gcbBH")).default);
    $parcel$export(module.exports, "Text", ()=>(parcelRequire("4gEFv")).default);
    $parcel$export(module.exports, "Circle", ()=>(parcelRequire("jjfok")).default);
    $parcel$export(module.exports, "Ellipse", ()=>(parcelRequire("kVeV8")).default);
    $parcel$export(module.exports, "Sector", ()=>(parcelRequire("elGBV")).default);
    $parcel$export(module.exports, "Ring", ()=>(parcelRequire("LCHOw")).default);
    $parcel$export(module.exports, "Polygon", ()=>(parcelRequire("lQwBc")).default);
    $parcel$export(module.exports, "Polyline", ()=>(parcelRequire("32bXc")).default);
    $parcel$export(module.exports, "Rect", ()=>(parcelRequire("7Tw7u")).default);
    $parcel$export(module.exports, "Line", ()=>(parcelRequire("cZb1F")).default);
    $parcel$export(module.exports, "BezierCurve", ()=>(parcelRequire("04gw0")).default);
    $parcel$export(module.exports, "Arc", ()=>(parcelRequire("ixXaU")).default);
    $parcel$export(module.exports, "IncrementalDisplayable", ()=>(parcelRequire("6sllV")).default);
    $parcel$export(module.exports, "CompoundPath", ()=>(parcelRequire("eGltS")).default);
    $parcel$export(module.exports, "LinearGradient", ()=>(parcelRequire("9J7f8")).default);
    $parcel$export(module.exports, "RadialGradient", ()=>(parcelRequire("faICo")).default);
    $parcel$export(module.exports, "BoundingRect", ()=>(parcelRequire("1E3E8")).default);
    $parcel$export(module.exports, "OrientedBoundingRect", ()=>(parcelRequire("lM5Gp")).default);
    $parcel$export(module.exports, "Point", ()=>(parcelRequire("bMDnR")).default);
    $parcel$export(module.exports, "Path", ()=>(parcelRequire("ghQ8v")).default);
    var $id1Rd;
    var $izqgC;
    var $eLEew;
    var $ghQ8v;
    var $e6gef;
    var $gcbBH;
    var $4KVOr;
    var $4gEFv;
    var $jjfok;
    var $kVeV8;
    var $elGBV;
    var $LCHOw;
    var $lQwBc;
    var $32bXc;
    var $7Tw7u;
    var $cZb1F;
    var $04gw0;
    var $ixXaU;
    var $eGltS;
    var $9J7f8;
    var $faICo;
    var $1E3E8;
    var $lM5Gp;
    var $bMDnR;
    var $6sllV;
    var $2az2p;
    var $bahqM;
    var $7QjoM;
    var $eYgMC;
    var $b6edb2bb66445620$var$mathMax = Math.max;
    var $b6edb2bb66445620$var$mathMin = Math.min;
    var $b6edb2bb66445620$var$_customShapeMap = {};
    function $b6edb2bb66445620$export$d0d5398c9d612037(opts) {
        return (0, (0, parcelRequire("ghQ8v")).default).extend(opts);
    }
    var $b6edb2bb66445620$var$extendPathFromString = (0, parcelRequire("id1Rd")).extendFromString;
    function $b6edb2bb66445620$export$53b54a3137026af0(pathData, opts) {
        return $b6edb2bb66445620$var$extendPathFromString(pathData, opts);
    }
    function $b6edb2bb66445620$export$2b95b62e3aaf6fdd(name, ShapeClass) {
        $b6edb2bb66445620$var$_customShapeMap[name] = ShapeClass;
    }
    function $b6edb2bb66445620$export$51df4b5565a58189(name) {
        if ($b6edb2bb66445620$var$_customShapeMap.hasOwnProperty(name)) return $b6edb2bb66445620$var$_customShapeMap[name];
    }
    function $b6edb2bb66445620$export$aa9bab72412f5613(pathData, opts, rect, layout) {
        var path = (0, parcelRequire("id1Rd")).createFromString(pathData, opts);
        if (rect) {
            if (layout === 'center') rect = $b6edb2bb66445620$var$centerGraphic(rect, path.getBoundingRect());
            $b6edb2bb66445620$export$566dbf1c62b04fc7(path, rect);
        }
        return path;
    }
    function $b6edb2bb66445620$export$7a2bdede98851ac5(imageUrl, rect, layout) {
        var zrImg = new (0, (0, parcelRequire("gcbBH")).default)({
            style: {
                image: imageUrl,
                x: rect.x,
                y: rect.y,
                width: rect.width,
                height: rect.height
            },
            onload: function(img) {
                if (layout === 'center') {
                    var boundingRect = {
                        width: img.width,
                        height: img.height
                    };
                    zrImg.setStyle($b6edb2bb66445620$var$centerGraphic(rect, boundingRect));
                }
            }
        });
        return zrImg;
    }
    function $b6edb2bb66445620$var$centerGraphic(rect, boundingRect) {
        var aspect = boundingRect.width / boundingRect.height;
        var width = rect.height * aspect;
        var height;
        if (width <= rect.width) height = rect.height;
        else {
            width = rect.width;
            height = width / aspect;
        }
        var cx = rect.x + rect.width / 2;
        var cy = rect.y + rect.height / 2;
        return {
            x: cx - width / 2,
            y: cy - height / 2,
            width: width,
            height: height
        };
    }
    var $b6edb2bb66445620$export$7b1dd269fbc4e903 = (0, parcelRequire("id1Rd")).mergePath;
    function $b6edb2bb66445620$export$566dbf1c62b04fc7(path, rect) {
        if (!path.applyTransform) return;
        var pathRect = path.getBoundingRect();
        var m = pathRect.calculateTransform(rect);
        path.applyTransform(m);
    }
    function $b6edb2bb66445620$export$8b4b620d7f4aad1b(param) {
        (0, parcelRequire("2az2p")).subPixelOptimizeLine(param.shape, param.shape, param.style);
        return param;
    }
    function $b6edb2bb66445620$export$60e2aa74957d0b9d(param) {
        (0, parcelRequire("2az2p")).subPixelOptimizeRect(param.shape, param.shape, param.style);
        return param;
    }
    var $b6edb2bb66445620$export$72c4fd4c1b8fcb10 = (0, parcelRequire("2az2p")).subPixelOptimize;
    function $b6edb2bb66445620$export$fce0c6cfca85ed96(target, ancestor) {
        var mat = (0, parcelRequire("izqgC")).identity([]);
        while(target && target !== ancestor){
            (0, parcelRequire("izqgC")).mul(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        return mat;
    }
    function $b6edb2bb66445620$export$9f9dcb98c894b623(target, transform, invert) {
        if (transform && !(0, (0, parcelRequire("bahqM")).isArrayLike)(transform)) transform = (0, (0, parcelRequire("e6gef")).default).getLocalTransform(transform);
        if (invert) transform = (0, parcelRequire("izqgC")).invert([], transform);
        return (0, parcelRequire("eLEew")).applyTransform([], target, transform);
    }
    function $b6edb2bb66445620$export$fff94e9792354cfa(direction, transform, invert) {
        var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
        var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
        var vertex = [
            direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
            direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
        ];
        vertex = $b6edb2bb66445620$export$9f9dcb98c894b623(vertex, transform, invert);
        return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
    }
    function $b6edb2bb66445620$var$isNotGroup(el) {
        return !el.isGroup;
    }
    function $b6edb2bb66445620$var$isPath(el) {
        return el.shape != null;
    }
    function $b6edb2bb66445620$export$64fcab7860c216ae(g1, g2, animatableModel) {
        if (!g1 || !g2) return;
        function getElMap(g) {
            var elMap = {};
            g.traverse(function(el) {
                if ($b6edb2bb66445620$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
            });
            return elMap;
        }
        function getAnimatableProps(el) {
            var obj = {
                x: el.x,
                y: el.y,
                rotation: el.rotation
            };
            if ($b6edb2bb66445620$var$isPath(el)) obj.shape = (0, (0, parcelRequire("bahqM")).extend)({}, el.shape);
            return obj;
        }
        var elMap1 = getElMap(g1);
        g2.traverse(function(el) {
            if ($b6edb2bb66445620$var$isNotGroup(el) && el.anid) {
                var oldEl = elMap1[el.anid];
                if (oldEl) {
                    var newProp = getAnimatableProps(el);
                    el.attr(getAnimatableProps(oldEl));
                    (0, (0, parcelRequire("eYgMC")).updateProps)(el, newProp, animatableModel, (0, (0, parcelRequire("7QjoM")).getECData)(el).dataIndex);
                }
            }
        });
    }
    function $b6edb2bb66445620$export$e2f409471bbbc1dc(points, rect) {
        return (0, (0, parcelRequire("bahqM")).map)(points, function(point) {
            var x = point[0];
            x = $b6edb2bb66445620$var$mathMax(x, rect.x);
            x = $b6edb2bb66445620$var$mathMin(x, rect.x + rect.width);
            var y = point[1];
            y = $b6edb2bb66445620$var$mathMax(y, rect.y);
            y = $b6edb2bb66445620$var$mathMin(y, rect.y + rect.height);
            return [
                x,
                y
            ];
        });
    }
    function $b6edb2bb66445620$export$d0d3709202b8b2a(targetRect, rect) {
        var x = $b6edb2bb66445620$var$mathMax(targetRect.x, rect.x);
        var x2 = $b6edb2bb66445620$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
        var y = $b6edb2bb66445620$var$mathMax(targetRect.y, rect.y);
        var y2 = $b6edb2bb66445620$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height);
        if (x2 >= x && y2 >= y) return {
            x: x,
            y: y,
            width: x2 - x,
            height: y2 - y
        };
    }
    function $b6edb2bb66445620$export$274edc73af1ae9c8(iconStr, opt, rect) {
        var innerOpts = (0, (0, parcelRequire("bahqM")).extend)({
            rectHover: true
        }, opt);
        var style = innerOpts.style = {
            strokeNoScale: true
        };
        rect = rect || {
            x: -1,
            y: -1,
            width: 2,
            height: 2
        };
        if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, (0, parcelRequire("bahqM")).defaults)(style, rect), new (0, (0, parcelRequire("gcbBH")).default)(innerOpts)) : $b6edb2bb66445620$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
    }
    function $b6edb2bb66445620$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
        for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
            var p = points[i];
            if ($b6edb2bb66445620$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
            p2 = p;
        }
    }
    function $b6edb2bb66445620$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
        var mx = a2x - a1x;
        var my = a2y - a1y;
        var nx = b2x - b1x;
        var ny = b2y - b1y;
        var nmCrossProduct = $b6edb2bb66445620$var$crossProduct2d(nx, ny, mx, my);
        if ($b6edb2bb66445620$var$nearZero(nmCrossProduct)) return false;
        var b1a1x = a1x - b1x;
        var b1a1y = a1y - b1y;
        var q = $b6edb2bb66445620$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
        if (q < 0 || q > 1) return false;
        var p = $b6edb2bb66445620$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
        if (p < 0 || p > 1) return false;
        return true;
    }
    function $b6edb2bb66445620$var$crossProduct2d(x1, y1, x2, y2) {
        return x1 * y2 - x2 * y1;
    }
    function $b6edb2bb66445620$var$nearZero(val) {
        return val <= 1e-6 && val >= -0.000001;
    }
    function $b6edb2bb66445620$export$fc6410d97fab306c(opt) {
        var itemTooltipOption = opt.itemTooltipOption;
        var componentModel = opt.componentModel;
        var itemName = opt.itemName;
        var itemTooltipOptionObj = (0, (0, parcelRequire("bahqM")).isString)(itemTooltipOption) ? {
            formatter: itemTooltipOption
        } : itemTooltipOption;
        var mainType = componentModel.mainType;
        var componentIndex = componentModel.componentIndex;
        var formatterParams = {
            componentType: mainType,
            name: itemName,
            $vars: [
                'name'
            ]
        };
        formatterParams[mainType + 'Index'] = componentIndex;
        var formatterParamsExtra = opt.formatterParamsExtra;
        if (formatterParamsExtra) (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("bahqM")).keys)(formatterParamsExtra), function(key) {
            if (!(0, (0, parcelRequire("bahqM")).hasOwn)(formatterParams, key)) {
                formatterParams[key] = formatterParamsExtra[key];
                formatterParams.$vars.push(key);
            }
        });
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(opt.el);
        ecData.componentMainType = mainType;
        ecData.componentIndex = componentIndex;
        ecData.tooltipConfig = {
            name: itemName,
            option: (0, (0, parcelRequire("bahqM")).defaults)({
                content: itemName,
                formatterParams: formatterParams
            }, itemTooltipOptionObj)
        };
    }
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('circle', (0, (0, parcelRequire("jjfok")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('ellipse', (0, (0, parcelRequire("kVeV8")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('sector', (0, (0, parcelRequire("elGBV")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('ring', (0, (0, parcelRequire("LCHOw")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('polygon', (0, (0, parcelRequire("lQwBc")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('polyline', (0, (0, parcelRequire("32bXc")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('rect', (0, (0, parcelRequire("7Tw7u")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('line', (0, (0, parcelRequire("cZb1F")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('bezierCurve', (0, (0, parcelRequire("04gw0")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('arc', (0, (0, parcelRequire("ixXaU")).default));
});
parcelRegister("id1Rd", function(module, exports) {
    $parcel$export(module.exports, "createFromString", ()=>$d41ae1bdee61ce18$export$ae5b259626f00aeb);
    $parcel$export(module.exports, "extendFromString", ()=>$d41ae1bdee61ce18$export$68e3a51ba2ed417c);
    $parcel$export(module.exports, "mergePath", ()=>$d41ae1bdee61ce18$export$7b1dd269fbc4e903);
    $parcel$export(module.exports, "clonePath", ()=>$d41ae1bdee61ce18$export$18711d956bf1c3eb);
    var $3VFsf;
    var $ghQ8v;
    var $aA4Ws;
    var $cTDbe;
    var $bahqM;
    var $d41ae1bdee61ce18$var$mathSqrt = Math.sqrt;
    var $d41ae1bdee61ce18$var$mathSin = Math.sin;
    var $d41ae1bdee61ce18$var$mathCos = Math.cos;
    var $d41ae1bdee61ce18$var$PI = Math.PI;
    function $d41ae1bdee61ce18$var$vMag(v) {
        return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
    }
    function $d41ae1bdee61ce18$var$vRatio(u, v) {
        return (u[0] * v[0] + u[1] * v[1]) / ($d41ae1bdee61ce18$var$vMag(u) * $d41ae1bdee61ce18$var$vMag(v));
    }
    function $d41ae1bdee61ce18$var$vAngle(u, v) {
        return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($d41ae1bdee61ce18$var$vRatio(u, v));
    }
    function $d41ae1bdee61ce18$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
        var psi = psiDeg * ($d41ae1bdee61ce18$var$PI / 180.0);
        var xp = $d41ae1bdee61ce18$var$mathCos(psi) * (x1 - x2) / 2.0 + $d41ae1bdee61ce18$var$mathSin(psi) * (y1 - y2) / 2.0;
        var yp = -1 * $d41ae1bdee61ce18$var$mathSin(psi) * (x1 - x2) / 2.0 + $d41ae1bdee61ce18$var$mathCos(psi) * (y1 - y2) / 2.0;
        var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= $d41ae1bdee61ce18$var$mathSqrt(lambda);
            ry *= $d41ae1bdee61ce18$var$mathSqrt(lambda);
        }
        var f = (fa === fs ? -1 : 1) * $d41ae1bdee61ce18$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
        var cxp = f * rx * yp / ry;
        var cyp = f * -ry * xp / rx;
        var cx = (x1 + x2) / 2.0 + $d41ae1bdee61ce18$var$mathCos(psi) * cxp - $d41ae1bdee61ce18$var$mathSin(psi) * cyp;
        var cy = (y1 + y2) / 2.0 + $d41ae1bdee61ce18$var$mathSin(psi) * cxp + $d41ae1bdee61ce18$var$mathCos(psi) * cyp;
        var theta = $d41ae1bdee61ce18$var$vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        var u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        var v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        var dTheta = $d41ae1bdee61ce18$var$vAngle(u, v);
        if ($d41ae1bdee61ce18$var$vRatio(u, v) <= -1) dTheta = $d41ae1bdee61ce18$var$PI;
        if ($d41ae1bdee61ce18$var$vRatio(u, v) >= 1) dTheta = 0;
        if (dTheta < 0) {
            var n = Math.round(dTheta / $d41ae1bdee61ce18$var$PI * 1e6) / 1e6;
            dTheta = $d41ae1bdee61ce18$var$PI * 2 + n % 2 * $d41ae1bdee61ce18$var$PI;
        }
        path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
    }
    var $d41ae1bdee61ce18$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
    var $d41ae1bdee61ce18$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
    function $d41ae1bdee61ce18$var$createPathProxyFromString(data) {
        var path = new (0, (0, parcelRequire("aA4Ws")).default)();
        if (!data) return path;
        var cpx = 0;
        var cpy = 0;
        var subpathX = cpx;
        var subpathY = cpy;
        var prevCmd;
        var CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
        var cmdList = data.match($d41ae1bdee61ce18$var$commandReg);
        if (!cmdList) return path;
        for(var l = 0; l < cmdList.length; l++){
            var cmdText = cmdList[l];
            var cmdStr = cmdText.charAt(0);
            var cmd = void 0;
            var p = cmdText.match($d41ae1bdee61ce18$var$numberReg) || [];
            var pLen = p.length;
            for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
            var off = 0;
            while(off < pLen){
                var ctlPtx = void 0;
                var ctlPty = void 0;
                var rx = void 0;
                var ry = void 0;
                var psi = void 0;
                var fa = void 0;
                var fs = void 0;
                var x1 = cpx;
                var y1 = cpy;
                var len = void 0;
                var pathData = void 0;
                switch(cmdStr){
                    case 'l':
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'L':
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'm':
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.M;
                        path.addData(cmd, cpx, cpy);
                        subpathX = cpx;
                        subpathY = cpy;
                        cmdStr = 'l';
                        break;
                    case 'M':
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.M;
                        path.addData(cmd, cpx, cpy);
                        subpathX = cpx;
                        subpathY = cpy;
                        cmdStr = 'L';
                        break;
                    case 'h':
                        cpx += p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'H':
                        cpx = p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'v':
                        cpy += p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'V':
                        cpy = p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'C':
                        cmd = CMD.C;
                        path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                        cpx = p[off - 2];
                        cpy = p[off - 1];
                        break;
                    case 'c':
                        cmd = CMD.C;
                        path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                        cpx += p[off - 2];
                        cpy += p[off - 1];
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.C) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cmd = CMD.C;
                        x1 = p[off++];
                        y1 = p[off++];
                        cpx = p[off++];
                        cpy = p[off++];
                        path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.C) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cmd = CMD.C;
                        x1 = cpx + p[off++];
                        y1 = cpy + p[off++];
                        cpx += p[off++];
                        cpy += p[off++];
                        path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                        break;
                    case 'Q':
                        x1 = p[off++];
                        y1 = p[off++];
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, x1, y1, cpx, cpy);
                        break;
                    case 'q':
                        x1 = p[off++] + cpx;
                        y1 = p[off++] + cpy;
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, x1, y1, cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.Q) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.Q) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p[off++];
                        ry = p[off++];
                        psi = p[off++];
                        fa = p[off++];
                        fs = p[off++];
                        x1 = cpx, y1 = cpy;
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.A;
                        $d41ae1bdee61ce18$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                        break;
                    case 'a':
                        rx = p[off++];
                        ry = p[off++];
                        psi = p[off++];
                        fa = p[off++];
                        fs = p[off++];
                        x1 = cpx, y1 = cpy;
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.A;
                        $d41ae1bdee61ce18$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                        break;
                }
            }
            if (cmdStr === 'z' || cmdStr === 'Z') {
                cmd = CMD.Z;
                path.addData(cmd);
                cpx = subpathX;
                cpy = subpathY;
            }
            prevCmd = cmd;
        }
        path.toStatic();
        return path;
    }
    var $d41ae1bdee61ce18$var$SVGPath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SVGPath, _super);
        function SVGPath() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SVGPath.prototype.applyTransform = function(m) {};
        return SVGPath;
    }((0, (0, parcelRequire("ghQ8v")).default));
    function $d41ae1bdee61ce18$var$isPathProxy(path) {
        return path.setData != null;
    }
    function $d41ae1bdee61ce18$var$createPathOptions(str, opts) {
        var pathProxy = $d41ae1bdee61ce18$var$createPathProxyFromString(str);
        var innerOpts = (0, (0, parcelRequire("bahqM")).extend)({}, opts);
        innerOpts.buildPath = function(path) {
            if ($d41ae1bdee61ce18$var$isPathProxy(path)) {
                path.setData(pathProxy.data);
                var ctx = path.getContext();
                if (ctx) path.rebuildPath(ctx, 1);
            } else {
                var ctx = path;
                pathProxy.rebuildPath(ctx, 1);
            }
        };
        innerOpts.applyTransform = function(m) {
            (0, (0, parcelRequire("cTDbe")).default)(pathProxy, m);
            this.dirtyShape();
        };
        return innerOpts;
    }
    function $d41ae1bdee61ce18$export$ae5b259626f00aeb(str, opts) {
        return new $d41ae1bdee61ce18$var$SVGPath($d41ae1bdee61ce18$var$createPathOptions(str, opts));
    }
    function $d41ae1bdee61ce18$export$68e3a51ba2ed417c(str, defaultOpts) {
        var innerOpts = $d41ae1bdee61ce18$var$createPathOptions(str, defaultOpts);
        var Sub = function(_super) {
            (0, (0, parcelRequire("3VFsf")).__extends)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                _this.applyTransform = innerOpts.applyTransform;
                _this.buildPath = innerOpts.buildPath;
                return _this;
            }
            return Sub;
        }($d41ae1bdee61ce18$var$SVGPath);
        return Sub;
    }
    function $d41ae1bdee61ce18$export$7b1dd269fbc4e903(pathEls, opts) {
        var pathList = [];
        var len = pathEls.length;
        for(var i = 0; i < len; i++){
            var pathEl = pathEls[i];
            pathList.push(pathEl.getUpdatedPathProxy(true));
        }
        var pathBundle = new (0, (0, parcelRequire("ghQ8v")).default)(opts);
        pathBundle.createPathProxy();
        pathBundle.buildPath = function(path) {
            if ($d41ae1bdee61ce18$var$isPathProxy(path)) {
                path.appendPath(pathList);
                var ctx = path.getContext();
                if (ctx) path.rebuildPath(ctx, 1);
            }
        };
        return pathBundle;
    }
    function $d41ae1bdee61ce18$export$18711d956bf1c3eb(sourcePath, opts) {
        opts = opts || {};
        var path = new (0, (0, parcelRequire("ghQ8v")).default)();
        if (sourcePath.shape) path.setShape(sourcePath.shape);
        path.setStyle(sourcePath.style);
        if (opts.bakeTransform) (0, (0, parcelRequire("cTDbe")).default)(path.path, sourcePath.getComputedTransform());
        else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
        else path.copyTransform(sourcePath);
        path.buildPath = sourcePath.buildPath;
        path.applyTransform = path.applyTransform;
        path.z = sourcePath.z;
        path.z2 = sourcePath.z2;
        path.zlevel = sourcePath.zlevel;
        return path;
    }
});
parcelRegister("ghQ8v", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_PATH_STYLE", ()=>$bdb6ad049d5f8c6b$export$deade517576e293a);
    $parcel$export(module.exports, "default", ()=>$bdb6ad049d5f8c6b$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $aA4Ws;
    var $k3yEY;
    var $bahqM;
    var $d6udH;
    var $7y1my;
    var $aVawM;
    var $bdb6ad049d5f8c6b$export$deade517576e293a = (0, (0, parcelRequire("bahqM")).defaults)({
        fill: '#000',
        stroke: null,
        strokePercent: 1,
        fillOpacity: 1,
        strokeOpacity: 1,
        lineDashOffset: 0,
        lineWidth: 1,
        lineCap: 'butt',
        miterLimit: 10,
        strokeNoScale: false,
        strokeFirst: false
    }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE));
    var $bdb6ad049d5f8c6b$export$71bb6c3c6862c6a5 = {
        style: (0, (0, parcelRequire("bahqM")).defaults)({
            fill: true,
            stroke: true,
            strokePercent: true,
            fillOpacity: true,
            strokeOpacity: true,
            lineDashOffset: true,
            lineWidth: true,
            miterLimit: true
        }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_ANIMATION_PROPS).style)
    };
    var $bdb6ad049d5f8c6b$var$pathCopyParams = [
        'x',
        'y',
        'rotation',
        'scaleX',
        'scaleY',
        'originX',
        'originY',
        'invisible',
        'culling',
        'z',
        'z2',
        'zlevel',
        'parent'
    ];
    var $bdb6ad049d5f8c6b$var$Path = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Path, _super);
        function Path(opts) {
            return _super.call(this, opts) || this;
        }
        Path.prototype.update = function() {
            var _this = this;
            _super.prototype.update.call(this);
            var style = this.style;
            if (style.decal) {
                var decalEl = this._decalEl = this._decalEl || new Path();
                if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                    _this.buildPath(ctx, _this.shape);
                };
                decalEl.silent = true;
                var decalElStyle = decalEl.style;
                for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
                decalElStyle.fill = style.fill ? style.decal : null;
                decalElStyle.decal = null;
                decalElStyle.shadowColor = null;
                style.strokeFirst && (decalElStyle.stroke = null);
                for(var i = 0; i < $bdb6ad049d5f8c6b$var$pathCopyParams.length; ++i)decalEl[$bdb6ad049d5f8c6b$var$pathCopyParams[i]] = this[$bdb6ad049d5f8c6b$var$pathCopyParams[i]];
                decalEl.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            } else if (this._decalEl) this._decalEl = null;
        };
        Path.prototype.getDecalElement = function() {
            return this._decalEl;
        };
        Path.prototype._init = function(props) {
            var keysArr = (0, (0, parcelRequire("bahqM")).keys)(props);
            this.shape = this.getDefaultShape();
            var defaultStyle = this.getDefaultStyle();
            if (defaultStyle) this.useStyle(defaultStyle);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                var value = props[key];
                if (key === 'style') {
                    if (!this.style) this.useStyle(value);
                    else (0, (0, parcelRequire("bahqM")).extend)(this.style, value);
                } else if (key === 'shape') (0, (0, parcelRequire("bahqM")).extend)(this.shape, value);
                else _super.prototype.attrKV.call(this, key, value);
            }
            if (!this.style) this.useStyle({});
        };
        Path.prototype.getDefaultStyle = function() {
            return null;
        };
        Path.prototype.getDefaultShape = function() {
            return {};
        };
        Path.prototype.canBeInsideText = function() {
            return this.hasFill();
        };
        Path.prototype.getInsideTextFill = function() {
            var pathFill = this.style.fill;
            if (pathFill !== 'none') {
                if ((0, (0, parcelRequire("bahqM")).isString)(pathFill)) {
                    var fillLum = (0, (0, parcelRequire("d6udH")).lum)(pathFill, 0);
                    if (fillLum > 0.5) return 0, (0, parcelRequire("7y1my")).DARK_LABEL_COLOR;
                    else if (fillLum > 0.2) return 0, (0, parcelRequire("7y1my")).LIGHTER_LABEL_COLOR;
                    return 0, (0, parcelRequire("7y1my")).LIGHT_LABEL_COLOR;
                } else if (pathFill) return 0, (0, parcelRequire("7y1my")).LIGHT_LABEL_COLOR;
            }
            return 0, (0, parcelRequire("7y1my")).DARK_LABEL_COLOR;
        };
        Path.prototype.getInsideTextStroke = function(textFill) {
            var pathFill = this.style.fill;
            if ((0, (0, parcelRequire("bahqM")).isString)(pathFill)) {
                var zr = this.__zr;
                var isDarkMode = !!(zr && zr.isDarkMode());
                var isDarkLabel = (0, (0, parcelRequire("d6udH")).lum)(textFill, 0) < (0, (0, parcelRequire("7y1my")).DARK_MODE_THRESHOLD);
                if (isDarkMode === isDarkLabel) return pathFill;
            }
        };
        Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
        Path.prototype.pathUpdated = function() {
            this.__dirty &= ~(0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT);
        };
        Path.prototype.getUpdatedPathProxy = function(inBatch) {
            !this.path && this.createPathProxy();
            this.path.beginPath();
            this.buildPath(this.path, this.shape, inBatch);
            return this.path;
        };
        Path.prototype.createPathProxy = function() {
            this.path = new (0, (0, parcelRequire("aA4Ws")).default)(false);
        };
        Path.prototype.hasStroke = function() {
            var style = this.style;
            var stroke = style.stroke;
            return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
        };
        Path.prototype.hasFill = function() {
            var style = this.style;
            var fill = style.fill;
            return fill != null && fill !== 'none';
        };
        Path.prototype.getBoundingRect = function() {
            var rect = this._rect;
            var style = this.style;
            var needsUpdateRect = !rect;
            if (needsUpdateRect) {
                var firstInvoke = false;
                if (!this.path) {
                    firstInvoke = true;
                    this.createPathProxy();
                }
                var path = this.path;
                if (firstInvoke || this.__dirty & (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT)) {
                    path.beginPath();
                    this.buildPath(path, this.shape, false);
                    this.pathUpdated();
                }
                rect = path.getBoundingRect();
            }
            this._rect = rect;
            if (this.hasStroke() && this.path && this.path.len() > 0) {
                var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
                if (this.__dirty || needsUpdateRect) {
                    rectWithStroke.copy(rect);
                    var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                    var w = style.lineWidth;
                    if (!this.hasFill()) {
                        var strokeContainThreshold = this.strokeContainThreshold;
                        w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                    }
                    if (lineScale > 1e-10) {
                        rectWithStroke.width += w / lineScale;
                        rectWithStroke.height += w / lineScale;
                        rectWithStroke.x -= w / lineScale / 2;
                        rectWithStroke.y -= w / lineScale / 2;
                    }
                }
                return rectWithStroke;
            }
            return rect;
        };
        Path.prototype.contain = function(x, y) {
            var localPos = this.transformCoordToLocal(x, y);
            var rect = this.getBoundingRect();
            var style = this.style;
            x = localPos[0];
            y = localPos[1];
            if (rect.contain(x, y)) {
                var pathProxy = this.path;
                if (this.hasStroke()) {
                    var lineWidth = style.lineWidth;
                    var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                    if (lineScale > 1e-10) {
                        if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                        if ((0, parcelRequire("k3yEY")).containStroke(pathProxy, lineWidth / lineScale, x, y)) return true;
                    }
                }
                if (this.hasFill()) return (0, parcelRequire("k3yEY")).contain(pathProxy, x, y);
            }
            return false;
        };
        Path.prototype.dirtyShape = function() {
            this.__dirty |= (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT);
            if (this._rect) this._rect = null;
            if (this._decalEl) this._decalEl.dirtyShape();
            this.markRedraw();
        };
        Path.prototype.dirty = function() {
            this.dirtyStyle();
            this.dirtyShape();
        };
        Path.prototype.animateShape = function(loop) {
            return this.animate('shape', loop);
        };
        Path.prototype.updateDuringAnimation = function(targetKey) {
            if (targetKey === 'style') this.dirtyStyle();
            else if (targetKey === 'shape') this.dirtyShape();
            else this.markRedraw();
        };
        Path.prototype.attrKV = function(key, value) {
            if (key === 'shape') this.setShape(value);
            else _super.prototype.attrKV.call(this, key, value);
        };
        Path.prototype.setShape = function(keyOrObj, value) {
            var shape = this.shape;
            if (!shape) shape = this.shape = {};
            if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
            else (0, (0, parcelRequire("bahqM")).extend)(shape, keyOrObj);
            this.dirtyShape();
            return this;
        };
        Path.prototype.shapeChanged = function() {
            return !!(this.__dirty & (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT));
        };
        Path.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($bdb6ad049d5f8c6b$export$deade517576e293a, obj);
        };
        Path.prototype._innerSaveToNormal = function(toState) {
            _super.prototype._innerSaveToNormal.call(this, toState);
            var normalState = this._normalState;
            if (toState.shape && !normalState.shape) normalState.shape = (0, (0, parcelRequire("bahqM")).extend)({}, this.shape);
        };
        Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
            _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
            var needsRestoreToNormal = !(state && keepCurrentStates);
            var targetShape;
            if (state && state.shape) {
                if (transition) {
                    if (keepCurrentStates) targetShape = state.shape;
                    else {
                        targetShape = (0, (0, parcelRequire("bahqM")).extend)({}, normalState.shape);
                        (0, (0, parcelRequire("bahqM")).extend)(targetShape, state.shape);
                    }
                } else {
                    targetShape = (0, (0, parcelRequire("bahqM")).extend)({}, keepCurrentStates ? this.shape : normalState.shape);
                    (0, (0, parcelRequire("bahqM")).extend)(targetShape, state.shape);
                }
            } else if (needsRestoreToNormal) targetShape = normalState.shape;
            if (targetShape) {
                if (transition) {
                    this.shape = (0, (0, parcelRequire("bahqM")).extend)({}, this.shape);
                    var targetShapePrimaryProps = {};
                    var shapeKeys = (0, (0, parcelRequire("bahqM")).keys)(targetShape);
                    for(var i = 0; i < shapeKeys.length; i++){
                        var key = shapeKeys[i];
                        if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                        else targetShapePrimaryProps[key] = targetShape[key];
                    }
                    this._transitionState(stateName, {
                        shape: targetShapePrimaryProps
                    }, animationCfg);
                } else {
                    this.shape = targetShape;
                    this.dirtyShape();
                }
            }
        };
        Path.prototype._mergeStates = function(states) {
            var mergedState = _super.prototype._mergeStates.call(this, states);
            var mergedShape;
            for(var i = 0; i < states.length; i++){
                var state = states[i];
                if (state.shape) {
                    mergedShape = mergedShape || {};
                    this._mergeStyle(mergedShape, state.shape);
                }
            }
            if (mergedShape) mergedState.shape = mergedShape;
            return mergedState;
        };
        Path.prototype.getAnimationStyleProps = function() {
            return $bdb6ad049d5f8c6b$export$71bb6c3c6862c6a5;
        };
        Path.prototype.isZeroArea = function() {
            return false;
        };
        Path.extend = function(defaultProps) {
            var Sub = function(_super) {
                (0, (0, parcelRequire("3VFsf")).__extends)(Sub, _super);
                function Sub(opts) {
                    var _this = _super.call(this, opts) || this;
                    defaultProps.init && defaultProps.init.call(_this, opts);
                    return _this;
                }
                Sub.prototype.getDefaultStyle = function() {
                    return (0, (0, parcelRequire("bahqM")).clone)(defaultProps.style);
                };
                Sub.prototype.getDefaultShape = function() {
                    return (0, (0, parcelRequire("bahqM")).clone)(defaultProps.shape);
                };
                return Sub;
            }(Path);
            for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
            return Sub;
        };
        Path.initDefaultProps = function() {
            var pathProto = Path.prototype;
            pathProto.type = 'path';
            pathProto.strokeContainThreshold = 5;
            pathProto.segmentIgnoreThreshold = 0;
            pathProto.subPixelOptimize = false;
            pathProto.autoBatch = false;
            pathProto.__dirty = (0, (0, parcelRequire("aVawM")).REDRAW_BIT) | (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT) | (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT);
        }();
        return Path;
    }((0, (0, parcelRequire("lBQ88")).default));
    var $bdb6ad049d5f8c6b$export$2e2bcd8739ae039 = $bdb6ad049d5f8c6b$var$Path;
});
parcelRegister("lBQ88", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_COMMON_STYLE", ()=>$fbb57da3b649c75e$export$737672163db00fe3);
    $parcel$export(module.exports, "DEFAULT_COMMON_ANIMATION_PROPS", ()=>$fbb57da3b649c75e$export$9908943fb57fbe51);
    $parcel$export(module.exports, "default", ()=>$fbb57da3b649c75e$export$2e2bcd8739ae039);
    var $3VFsf;
    var $7KVc5;
    var $1E3E8;
    var $bahqM;
    var $aVawM;
    var $fbb57da3b649c75e$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
    var $fbb57da3b649c75e$export$737672163db00fe3 = {
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: '#000',
        opacity: 1,
        blend: 'source-over'
    };
    var $fbb57da3b649c75e$export$9908943fb57fbe51 = {
        style: {
            shadowBlur: true,
            shadowOffsetX: true,
            shadowOffsetY: true,
            shadowColor: true,
            opacity: true
        }
    };
    $fbb57da3b649c75e$export$737672163db00fe3[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY] = true;
    var $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS = [
        'z',
        'z2',
        'invisible'
    ];
    var $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
        'invisible'
    ];
    var $fbb57da3b649c75e$var$Displayable = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Displayable, _super);
        function Displayable(props) {
            return _super.call(this, props) || this;
        }
        Displayable.prototype._init = function(props) {
            var keysArr = (0, (0, parcelRequire("bahqM")).keys)(props);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                if (key === 'style') this.useStyle(props[key]);
                else _super.prototype.attrKV.call(this, key, props[key]);
            }
            if (!this.style) this.useStyle({});
        };
        Displayable.prototype.beforeBrush = function() {};
        Displayable.prototype.afterBrush = function() {};
        Displayable.prototype.innerBeforeBrush = function() {};
        Displayable.prototype.innerAfterBrush = function() {};
        Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
            var m = this.transform;
            if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $fbb57da3b649c75e$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
            if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
                if (this.__clipPaths[i].isZeroArea()) return false;
            }
            if (considerAncestors && this.parent) {
                var parent_1 = this.parent;
                while(parent_1){
                    if (parent_1.ignore) return false;
                    parent_1 = parent_1.parent;
                }
            }
            return true;
        };
        Displayable.prototype.contain = function(x, y) {
            return this.rectContain(x, y);
        };
        Displayable.prototype.traverse = function(cb, context) {
            cb.call(context, this);
        };
        Displayable.prototype.rectContain = function(x, y) {
            var coord = this.transformCoordToLocal(x, y);
            var rect = this.getBoundingRect();
            return rect.contain(coord[0], coord[1]);
        };
        Displayable.prototype.getPaintRect = function() {
            var rect = this._paintRect;
            if (!this._paintRect || this.__dirty) {
                var transform = this.transform;
                var elRect = this.getBoundingRect();
                var style = this.style;
                var shadowSize = style.shadowBlur || 0;
                var shadowOffsetX = style.shadowOffsetX || 0;
                var shadowOffsetY = style.shadowOffsetY || 0;
                rect = this._paintRect || (this._paintRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0));
                if (transform) (0, (0, parcelRequire("1E3E8")).default).applyTransform(rect, elRect, transform);
                else rect.copy(elRect);
                if (shadowSize || shadowOffsetX || shadowOffsetY) {
                    rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                    rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                    rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                    rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
                }
                var tolerance = this.dirtyRectTolerance;
                if (!rect.isZero()) {
                    rect.x = Math.floor(rect.x - tolerance);
                    rect.y = Math.floor(rect.y - tolerance);
                    rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                    rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
                }
            }
            return rect;
        };
        Displayable.prototype.setPrevPaintRect = function(paintRect) {
            if (paintRect) {
                this._prevPaintRect = this._prevPaintRect || new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
                this._prevPaintRect.copy(paintRect);
            } else this._prevPaintRect = null;
        };
        Displayable.prototype.getPrevPaintRect = function() {
            return this._prevPaintRect;
        };
        Displayable.prototype.animateStyle = function(loop) {
            return this.animate('style', loop);
        };
        Displayable.prototype.updateDuringAnimation = function(targetKey) {
            if (targetKey === 'style') this.dirtyStyle();
            else this.markRedraw();
        };
        Displayable.prototype.attrKV = function(key, value) {
            if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
            else if (!this.style) this.useStyle(value);
            else this.setStyle(value);
        };
        Displayable.prototype.setStyle = function(keyOrObj, value) {
            if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
            else (0, (0, parcelRequire("bahqM")).extend)(this.style, keyOrObj);
            this.dirtyStyle();
            return this;
        };
        Displayable.prototype.dirtyStyle = function(notRedraw) {
            if (!notRedraw) this.markRedraw();
            this.__dirty |= (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT);
            if (this._rect) this._rect = null;
        };
        Displayable.prototype.dirty = function() {
            this.dirtyStyle();
        };
        Displayable.prototype.styleChanged = function() {
            return !!(this.__dirty & (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT));
        };
        Displayable.prototype.styleUpdated = function() {
            this.__dirty &= ~(0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT);
        };
        Displayable.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($fbb57da3b649c75e$export$737672163db00fe3, obj);
        };
        Displayable.prototype.useStyle = function(obj) {
            if (!obj[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
            if (this.__inHover) this.__hoverStyle = obj;
            else this.style = obj;
            this.dirtyStyle();
        };
        Displayable.prototype.isStyleObject = function(obj) {
            return obj[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY];
        };
        Displayable.prototype._innerSaveToNormal = function(toState) {
            _super.prototype._innerSaveToNormal.call(this, toState);
            var normalState = this._normalState;
            if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
            this._savePrimaryToNormal(toState, normalState, $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS);
        };
        Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
            _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
            var needsRestoreToNormal = !(state && keepCurrentStates);
            var targetStyle;
            if (state && state.style) {
                if (transition) {
                    if (keepCurrentStates) targetStyle = state.style;
                    else {
                        targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                        this._mergeStyle(targetStyle, state.style);
                    }
                } else {
                    targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else if (needsRestoreToNormal) targetStyle = normalState.style;
            if (targetStyle) {
                if (transition) {
                    var sourceStyle = this.style;
                    this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                    if (needsRestoreToNormal) {
                        var changedKeys = (0, (0, parcelRequire("bahqM")).keys)(sourceStyle);
                        for(var i = 0; i < changedKeys.length; i++){
                            var key = changedKeys[i];
                            if (key in targetStyle) {
                                targetStyle[key] = targetStyle[key];
                                this.style[key] = sourceStyle[key];
                            }
                        }
                    }
                    var targetKeys = (0, (0, parcelRequire("bahqM")).keys)(targetStyle);
                    for(var i = 0; i < targetKeys.length; i++){
                        var key = targetKeys[i];
                        this.style[key] = this.style[key];
                    }
                    this._transitionState(stateName, {
                        style: targetStyle
                    }, animationCfg, this.getAnimationStyleProps());
                } else this.useStyle(targetStyle);
            }
            var statesKeys = this.__inHover ? $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS;
            for(var i = 0; i < statesKeys.length; i++){
                var key = statesKeys[i];
                if (state && state[key] != null) this[key] = state[key];
                else if (needsRestoreToNormal) {
                    if (normalState[key] != null) this[key] = normalState[key];
                }
            }
        };
        Displayable.prototype._mergeStates = function(states) {
            var mergedState = _super.prototype._mergeStates.call(this, states);
            var mergedStyle;
            for(var i = 0; i < states.length; i++){
                var state = states[i];
                if (state.style) {
                    mergedStyle = mergedStyle || {};
                    this._mergeStyle(mergedStyle, state.style);
                }
            }
            if (mergedStyle) mergedState.style = mergedStyle;
            return mergedState;
        };
        Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
            (0, (0, parcelRequire("bahqM")).extend)(targetStyle, sourceStyle);
            return targetStyle;
        };
        Displayable.prototype.getAnimationStyleProps = function() {
            return $fbb57da3b649c75e$export$9908943fb57fbe51;
        };
        Displayable.initDefaultProps = function() {
            var dispProto = Displayable.prototype;
            dispProto.type = 'displayable';
            dispProto.invisible = false;
            dispProto.z = 0;
            dispProto.z2 = 0;
            dispProto.zlevel = 0;
            dispProto.culling = false;
            dispProto.cursor = 'pointer';
            dispProto.rectHover = false;
            dispProto.incremental = false;
            dispProto._rect = null;
            dispProto.dirtyRectTolerance = 0;
            dispProto.__dirty = (0, (0, parcelRequire("aVawM")).REDRAW_BIT) | (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT);
        }();
        return Displayable;
    }((0, (0, parcelRequire("7KVc5")).default));
    var $fbb57da3b649c75e$var$tmpRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
    var $fbb57da3b649c75e$var$viewRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
    function $fbb57da3b649c75e$var$isDisplayableCulled(el, width, height) {
        $fbb57da3b649c75e$var$tmpRect.copy(el.getBoundingRect());
        if (el.transform) $fbb57da3b649c75e$var$tmpRect.applyTransform(el.transform);
        $fbb57da3b649c75e$var$viewRect.width = width;
        $fbb57da3b649c75e$var$viewRect.height = height;
        return !$fbb57da3b649c75e$var$tmpRect.intersect($fbb57da3b649c75e$var$viewRect);
    }
    var $fbb57da3b649c75e$export$2e2bcd8739ae039 = $fbb57da3b649c75e$var$Displayable;
});
parcelRegister("aA4Ws", function(module, exports) {
    $parcel$export(module.exports, "normalizeArcAngles", ()=>$7b4119855d2b5b91$export$bc668021e937022a);
    $parcel$export(module.exports, "default", ()=>$7b4119855d2b5b91$export$2e2bcd8739ae039);
    var $eLEew;
    var $1E3E8;
    var $7y1my;
    var $13I82;
    var $dr1jo;
    var $7b4119855d2b5b91$var$CMD = {
        M: 1,
        L: 2,
        C: 3,
        Q: 4,
        A: 5,
        Z: 6,
        R: 7
    };
    var $7b4119855d2b5b91$var$tmpOutX = [];
    var $7b4119855d2b5b91$var$tmpOutY = [];
    var $7b4119855d2b5b91$var$min = [];
    var $7b4119855d2b5b91$var$max = [];
    var $7b4119855d2b5b91$var$min2 = [];
    var $7b4119855d2b5b91$var$max2 = [];
    var $7b4119855d2b5b91$var$mathMin = Math.min;
    var $7b4119855d2b5b91$var$mathMax = Math.max;
    var $7b4119855d2b5b91$var$mathCos = Math.cos;
    var $7b4119855d2b5b91$var$mathSin = Math.sin;
    var $7b4119855d2b5b91$var$mathSqrt = Math.sqrt;
    var $7b4119855d2b5b91$var$mathAbs = Math.abs;
    var $7b4119855d2b5b91$var$PI = Math.PI;
    var $7b4119855d2b5b91$var$PI2 = $7b4119855d2b5b91$var$PI * 2;
    var $7b4119855d2b5b91$var$hasTypedArray = typeof Float32Array !== 'undefined';
    var $7b4119855d2b5b91$var$tmpAngles = [];
    function $7b4119855d2b5b91$var$modPI2(radian) {
        var n = Math.round(radian / $7b4119855d2b5b91$var$PI * 1e8) / 1e8;
        return n % 2 * $7b4119855d2b5b91$var$PI;
    }
    function $7b4119855d2b5b91$export$bc668021e937022a(angles, anticlockwise) {
        var newStartAngle = $7b4119855d2b5b91$var$modPI2(angles[0]);
        if (newStartAngle < 0) newStartAngle += $7b4119855d2b5b91$var$PI2;
        var delta = newStartAngle - angles[0];
        var newEndAngle = angles[1];
        newEndAngle += delta;
        if (!anticlockwise && newEndAngle - newStartAngle >= $7b4119855d2b5b91$var$PI2) newEndAngle = newStartAngle + $7b4119855d2b5b91$var$PI2;
        else if (anticlockwise && newStartAngle - newEndAngle >= $7b4119855d2b5b91$var$PI2) newEndAngle = newStartAngle - $7b4119855d2b5b91$var$PI2;
        else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($7b4119855d2b5b91$var$PI2 - $7b4119855d2b5b91$var$modPI2(newStartAngle - newEndAngle));
        else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($7b4119855d2b5b91$var$PI2 - $7b4119855d2b5b91$var$modPI2(newEndAngle - newStartAngle));
        angles[0] = newStartAngle;
        angles[1] = newEndAngle;
    }
    var $7b4119855d2b5b91$var$PathProxy = function() {
        function PathProxy(notSaveData) {
            this.dpr = 1;
            this._xi = 0;
            this._yi = 0;
            this._x0 = 0;
            this._y0 = 0;
            this._len = 0;
            if (notSaveData) this._saveData = false;
            if (this._saveData) this.data = [];
        }
        PathProxy.prototype.increaseVersion = function() {
            this._version++;
        };
        PathProxy.prototype.getVersion = function() {
            return this._version;
        };
        PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
            segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
            if (segmentIgnoreThreshold > 0) {
                this._ux = $7b4119855d2b5b91$var$mathAbs(segmentIgnoreThreshold / (0, (0, parcelRequire("7y1my")).devicePixelRatio) / sx) || 0;
                this._uy = $7b4119855d2b5b91$var$mathAbs(segmentIgnoreThreshold / (0, (0, parcelRequire("7y1my")).devicePixelRatio) / sy) || 0;
            }
        };
        PathProxy.prototype.setDPR = function(dpr) {
            this.dpr = dpr;
        };
        PathProxy.prototype.setContext = function(ctx) {
            this._ctx = ctx;
        };
        PathProxy.prototype.getContext = function() {
            return this._ctx;
        };
        PathProxy.prototype.beginPath = function() {
            this._ctx && this._ctx.beginPath();
            this.reset();
            return this;
        };
        PathProxy.prototype.reset = function() {
            if (this._saveData) this._len = 0;
            if (this._lineDash) {
                this._lineDash = null;
                this._dashOffset = 0;
            }
            if (this._pathSegLen) {
                this._pathSegLen = null;
                this._pathLen = 0;
            }
            this._version++;
        };
        PathProxy.prototype.moveTo = function(x, y) {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.M, x, y);
            this._ctx && this._ctx.moveTo(x, y);
            this._x0 = x;
            this._y0 = y;
            this._xi = x;
            this._yi = y;
            return this;
        };
        PathProxy.prototype.lineTo = function(x, y) {
            var dx = $7b4119855d2b5b91$var$mathAbs(x - this._xi);
            var dy = $7b4119855d2b5b91$var$mathAbs(y - this._yi);
            var exceedUnit = dx > this._ux || dy > this._uy;
            this.addData($7b4119855d2b5b91$var$CMD.L, x, y);
            if (this._ctx && exceedUnit) this._needsDash ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
            if (exceedUnit) {
                this._xi = x;
                this._yi = y;
                this._pendingPtDist = 0;
            } else {
                var d2 = dx * dx + dy * dy;
                if (d2 > this._pendingPtDist) {
                    this._pendingPtX = x;
                    this._pendingPtY = y;
                    this._pendingPtDist = d2;
                }
            }
            return this;
        };
        PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.C, x1, y1, x2, y2, x3, y3);
            if (this._ctx) this._needsDash ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
            this._xi = x3;
            this._yi = y3;
            return this;
        };
        PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.Q, x1, y1, x2, y2);
            if (this._ctx) this._needsDash ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
            this._xi = x2;
            this._yi = y2;
            return this;
        };
        PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
            this._drawPendingPt();
            $7b4119855d2b5b91$var$tmpAngles[0] = startAngle;
            $7b4119855d2b5b91$var$tmpAngles[1] = endAngle;
            $7b4119855d2b5b91$export$bc668021e937022a($7b4119855d2b5b91$var$tmpAngles, anticlockwise);
            startAngle = $7b4119855d2b5b91$var$tmpAngles[0];
            endAngle = $7b4119855d2b5b91$var$tmpAngles[1];
            var delta = endAngle - startAngle;
            this.addData($7b4119855d2b5b91$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
            this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
            this._xi = $7b4119855d2b5b91$var$mathCos(endAngle) * r + cx;
            this._yi = $7b4119855d2b5b91$var$mathSin(endAngle) * r + cy;
            return this;
        };
        PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
            this._drawPendingPt();
            if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
            return this;
        };
        PathProxy.prototype.rect = function(x, y, w, h) {
            this._drawPendingPt();
            this._ctx && this._ctx.rect(x, y, w, h);
            this.addData($7b4119855d2b5b91$var$CMD.R, x, y, w, h);
            return this;
        };
        PathProxy.prototype.closePath = function() {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.Z);
            var ctx = this._ctx;
            var x0 = this._x0;
            var y0 = this._y0;
            if (ctx) {
                this._needsDash && this._dashedLineTo(x0, y0);
                ctx.closePath();
            }
            this._xi = x0;
            this._yi = y0;
            return this;
        };
        PathProxy.prototype.fill = function(ctx) {
            ctx && ctx.fill();
            this.toStatic();
        };
        PathProxy.prototype.stroke = function(ctx) {
            ctx && ctx.stroke();
            this.toStatic();
        };
        PathProxy.prototype.setLineDash = function(lineDash) {
            if (lineDash instanceof Array) {
                this._lineDash = lineDash;
                this._dashIdx = 0;
                var lineDashSum = 0;
                for(var i = 0; i < lineDash.length; i++)lineDashSum += lineDash[i];
                this._dashSum = lineDashSum;
                this._needsDash = true;
            } else {
                this._lineDash = null;
                this._needsDash = false;
            }
            return this;
        };
        PathProxy.prototype.setLineDashOffset = function(offset) {
            this._dashOffset = offset;
            return this;
        };
        PathProxy.prototype.len = function() {
            return this._len;
        };
        PathProxy.prototype.setData = function(data) {
            var len = data.length;
            if (!(this.data && this.data.length === len) && $7b4119855d2b5b91$var$hasTypedArray) this.data = new Float32Array(len);
            for(var i = 0; i < len; i++)this.data[i] = data[i];
            this._len = len;
        };
        PathProxy.prototype.appendPath = function(path) {
            if (!(path instanceof Array)) path = [
                path
            ];
            var len = path.length;
            var appendSize = 0;
            var offset = this._len;
            for(var i = 0; i < len; i++)appendSize += path[i].len();
            if ($7b4119855d2b5b91$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
            for(var i = 0; i < len; i++){
                var appendPathData = path[i].data;
                for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
            }
            this._len = offset;
        };
        PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
            if (!this._saveData) return;
            var data = this.data;
            if (this._len + arguments.length > data.length) {
                this._expandData();
                data = this.data;
            }
            for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
        };
        PathProxy.prototype._drawPendingPt = function() {
            if (this._pendingPtDist > 0) {
                this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
                this._pendingPtDist = 0;
            }
        };
        PathProxy.prototype._expandData = function() {
            if (!(this.data instanceof Array)) {
                var newData = [];
                for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
                this.data = newData;
            }
        };
        PathProxy.prototype._dashedLineTo = function(x1, y1) {
            var dashSum = this._dashSum;
            var lineDash = this._lineDash;
            var ctx = this._ctx;
            var offset = this._dashOffset;
            var x0 = this._xi;
            var y0 = this._yi;
            var dx = x1 - x0;
            var dy = y1 - y0;
            var dist = $7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
            var x = x0;
            var y = y0;
            var nDash = lineDash.length;
            var dash;
            var idx;
            dx /= dist;
            dy /= dist;
            if (offset < 0) offset = dashSum + offset;
            offset %= dashSum;
            x -= offset * dx;
            y -= offset * dy;
            while(dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)){
                idx = this._dashIdx;
                dash = lineDash[idx];
                x += dx * dash;
                y += dy * dash;
                this._dashIdx = (idx + 1) % nDash;
                if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) continue;
                ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? $7b4119855d2b5b91$var$mathMin(x, x1) : $7b4119855d2b5b91$var$mathMax(x, x1), dy >= 0 ? $7b4119855d2b5b91$var$mathMin(y, y1) : $7b4119855d2b5b91$var$mathMax(y, y1));
            }
            dx = x - x1;
            dy = y - y1;
            this._dashOffset = -$7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
        };
        PathProxy.prototype._dashedBezierTo = function(x1, y1, x2, y2, x3, y3) {
            var ctx = this._ctx;
            var dashSum = this._dashSum;
            var offset = this._dashOffset;
            var lineDash = this._lineDash;
            var x0 = this._xi;
            var y0 = this._yi;
            var bezierLen = 0;
            var idx = this._dashIdx;
            var nDash = lineDash.length;
            var t;
            var dx;
            var dy;
            var x;
            var y;
            var tmpLen = 0;
            if (offset < 0) offset = dashSum + offset;
            offset %= dashSum;
            for(t = 0; t < 1; t += 0.1){
                dx = (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x1, x2, x3, t + 0.1) - (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x1, x2, x3, t);
                dy = (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y1, y2, y3, t + 0.1) - (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y1, y2, y3, t);
                bezierLen += $7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
            }
            for(; idx < nDash; idx++){
                tmpLen += lineDash[idx];
                if (tmpLen > offset) break;
            }
            t = (tmpLen - offset) / bezierLen;
            while(t <= 1){
                x = (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x1, x2, x3, t);
                y = (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y1, y2, y3, t);
                idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
                t += lineDash[idx] / bezierLen;
                idx = (idx + 1) % nDash;
            }
            idx % 2 !== 0 && ctx.lineTo(x3, y3);
            dx = x3 - x;
            dy = y3 - y;
            this._dashOffset = -$7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
        };
        PathProxy.prototype._dashedQuadraticTo = function(x1, y1, x2, y2) {
            var x3 = x2;
            var y3 = y2;
            x2 = (x2 + 2 * x1) / 3;
            y2 = (y2 + 2 * y1) / 3;
            x1 = (this._xi + 2 * x1) / 3;
            y1 = (this._yi + 2 * y1) / 3;
            this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
        };
        PathProxy.prototype.toStatic = function() {
            if (!this._saveData) return;
            this._drawPendingPt();
            var data = this.data;
            if (data instanceof Array) {
                data.length = this._len;
                if ($7b4119855d2b5b91$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
            }
        };
        PathProxy.prototype.getBoundingRect = function() {
            $7b4119855d2b5b91$var$min[0] = $7b4119855d2b5b91$var$min[1] = $7b4119855d2b5b91$var$min2[0] = $7b4119855d2b5b91$var$min2[1] = Number.MAX_VALUE;
            $7b4119855d2b5b91$var$max[0] = $7b4119855d2b5b91$var$max[1] = $7b4119855d2b5b91$var$max2[0] = $7b4119855d2b5b91$var$max2[1] = -Number.MAX_VALUE;
            var data = this.data;
            var xi = 0;
            var yi = 0;
            var x0 = 0;
            var y0 = 0;
            var i;
            for(i = 0; i < this._len;){
                var cmd = data[i++];
                var isFirst = i === 1;
                if (isFirst) {
                    xi = data[i];
                    yi = data[i + 1];
                    x0 = xi;
                    y0 = yi;
                }
                switch(cmd){
                    case $7b4119855d2b5b91$var$CMD.M:
                        xi = x0 = data[i++];
                        yi = y0 = data[i++];
                        $7b4119855d2b5b91$var$min2[0] = x0;
                        $7b4119855d2b5b91$var$min2[1] = y0;
                        $7b4119855d2b5b91$var$max2[0] = x0;
                        $7b4119855d2b5b91$var$max2[1] = y0;
                        break;
                    case $7b4119855d2b5b91$var$CMD.L:
                        (0, (0, parcelRequire("13I82")).fromLine)(xi, yi, data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = data[i++];
                        yi = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.C:
                        (0, (0, parcelRequire("13I82")).fromCubic)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = data[i++];
                        yi = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.Q:
                        (0, (0, parcelRequire("13I82")).fromQuadratic)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = data[i++];
                        yi = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.A:
                        var cx = data[i++];
                        var cy = data[i++];
                        var rx = data[i++];
                        var ry = data[i++];
                        var startAngle = data[i++];
                        var endAngle = data[i++] + startAngle;
                        i += 1;
                        var anticlockwise = !data[i++];
                        if (isFirst) {
                            x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                            y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                        }
                        (0, (0, parcelRequire("13I82")).fromArc)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                        yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                        break;
                    case $7b4119855d2b5b91$var$CMD.R:
                        x0 = xi = data[i++];
                        y0 = yi = data[i++];
                        var width = data[i++];
                        var height = data[i++];
                        (0, (0, parcelRequire("13I82")).fromLine)(x0, y0, x0 + width, y0 + height, $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        break;
                    case $7b4119855d2b5b91$var$CMD.Z:
                        xi = x0;
                        yi = y0;
                        break;
                }
                (0, parcelRequire("eLEew")).min($7b4119855d2b5b91$var$min, $7b4119855d2b5b91$var$min, $7b4119855d2b5b91$var$min2);
                (0, parcelRequire("eLEew")).max($7b4119855d2b5b91$var$max, $7b4119855d2b5b91$var$max, $7b4119855d2b5b91$var$max2);
            }
            if (i === 0) $7b4119855d2b5b91$var$min[0] = $7b4119855d2b5b91$var$min[1] = $7b4119855d2b5b91$var$max[0] = $7b4119855d2b5b91$var$max[1] = 0;
            return new (0, (0, parcelRequire("1E3E8")).default)($7b4119855d2b5b91$var$min[0], $7b4119855d2b5b91$var$min[1], $7b4119855d2b5b91$var$max[0] - $7b4119855d2b5b91$var$min[0], $7b4119855d2b5b91$var$max[1] - $7b4119855d2b5b91$var$min[1]);
        };
        PathProxy.prototype._calculateLength = function() {
            var data = this.data;
            var len = this._len;
            var ux = this._ux;
            var uy = this._uy;
            var xi = 0;
            var yi = 0;
            var x0 = 0;
            var y0 = 0;
            if (!this._pathSegLen) this._pathSegLen = [];
            var pathSegLen = this._pathSegLen;
            var pathTotalLen = 0;
            var segCount = 0;
            for(var i = 0; i < len;){
                var cmd = data[i++];
                var isFirst = i === 1;
                if (isFirst) {
                    xi = data[i];
                    yi = data[i + 1];
                    x0 = xi;
                    y0 = yi;
                }
                var l = -1;
                switch(cmd){
                    case $7b4119855d2b5b91$var$CMD.M:
                        xi = x0 = data[i++];
                        yi = y0 = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.L:
                        var x2 = data[i++];
                        var y2 = data[i++];
                        var dx = x2 - xi;
                        var dy = y2 - yi;
                        if ($7b4119855d2b5b91$var$mathAbs(dx) > ux || $7b4119855d2b5b91$var$mathAbs(dy) > uy || i === len - 1) {
                            l = Math.sqrt(dx * dx + dy * dy);
                            xi = x2;
                            yi = y2;
                        }
                        break;
                    case $7b4119855d2b5b91$var$CMD.C:
                        var x1 = data[i++];
                        var y1 = data[i++];
                        var x2 = data[i++];
                        var y2 = data[i++];
                        var x3 = data[i++];
                        var y3 = data[i++];
                        l = (0, (0, parcelRequire("dr1jo")).cubicLength)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                        xi = x3;
                        yi = y3;
                        break;
                    case $7b4119855d2b5b91$var$CMD.Q:
                        var x1 = data[i++];
                        var y1 = data[i++];
                        var x2 = data[i++];
                        var y2 = data[i++];
                        l = (0, (0, parcelRequire("dr1jo")).quadraticLength)(xi, yi, x1, y1, x2, y2, 10);
                        xi = x2;
                        yi = y2;
                        break;
                    case $7b4119855d2b5b91$var$CMD.A:
                        var cx = data[i++];
                        var cy = data[i++];
                        var rx = data[i++];
                        var ry = data[i++];
                        var startAngle = data[i++];
                        var delta = data[i++];
                        var endAngle = delta + startAngle;
                        i += 1;
                        var anticlockwise = !data[i++];
                        if (isFirst) {
                            x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                            y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                        }
                        l = $7b4119855d2b5b91$var$mathMax(rx, ry) * $7b4119855d2b5b91$var$mathMin($7b4119855d2b5b91$var$PI2, Math.abs(delta));
                        xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                        yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                        break;
                    case $7b4119855d2b5b91$var$CMD.R:
                        x0 = xi = data[i++];
                        y0 = yi = data[i++];
                        var width = data[i++];
                        var height = data[i++];
                        l = width * 2 + height * 2;
                        break;
                    case $7b4119855d2b5b91$var$CMD.Z:
                        var dx = x0 - xi;
                        var dy = y0 - yi;
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x0;
                        yi = y0;
                        break;
                }
                if (l >= 0) {
                    pathSegLen[segCount++] = l;
                    pathTotalLen += l;
                }
            }
            this._pathLen = pathTotalLen;
            return pathTotalLen;
        };
        PathProxy.prototype.rebuildPath = function(ctx, percent) {
            var d = this.data;
            var ux = this._ux;
            var uy = this._uy;
            var len = this._len;
            var x0;
            var y0;
            var xi;
            var yi;
            var x;
            var y;
            var drawPart = percent < 1;
            var pathSegLen;
            var pathTotalLen;
            var accumLength = 0;
            var segCount = 0;
            var displayedLength;
            var pendingPtDist = 0;
            var pendingPtX;
            var pendingPtY;
            if (drawPart) {
                if (!this._pathSegLen) this._calculateLength();
                pathSegLen = this._pathSegLen;
                pathTotalLen = this._pathLen;
                displayedLength = percent * pathTotalLen;
                if (!displayedLength) return;
            }
            lo: for(var i = 0; i < len;){
                var cmd = d[i++];
                var isFirst = i === 1;
                if (isFirst) {
                    xi = d[i];
                    yi = d[i + 1];
                    x0 = xi;
                    y0 = yi;
                }
                if (cmd !== $7b4119855d2b5b91$var$CMD.L && pendingPtDist > 0) {
                    ctx.lineTo(pendingPtX, pendingPtY);
                    pendingPtDist = 0;
                }
                switch(cmd){
                    case $7b4119855d2b5b91$var$CMD.M:
                        x0 = xi = d[i++];
                        y0 = yi = d[i++];
                        ctx.moveTo(xi, yi);
                        break;
                    case $7b4119855d2b5b91$var$CMD.L:
                        x = d[i++];
                        y = d[i++];
                        var dx = $7b4119855d2b5b91$var$mathAbs(x - xi);
                        var dy = $7b4119855d2b5b91$var$mathAbs(y - yi);
                        if (dx > ux || dy > uy) {
                            if (drawPart) {
                                var l = pathSegLen[segCount++];
                                if (accumLength + l > displayedLength) {
                                    var t = (displayedLength - accumLength) / l;
                                    ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                    break lo;
                                }
                                accumLength += l;
                            }
                            ctx.lineTo(x, y);
                            xi = x;
                            yi = y;
                            pendingPtDist = 0;
                        } else {
                            var d2 = dx * dx + dy * dy;
                            if (d2 > pendingPtDist) {
                                pendingPtX = x;
                                pendingPtY = y;
                                pendingPtDist = d2;
                            }
                        }
                        break;
                    case $7b4119855d2b5b91$var$CMD.C:
                        var x1 = d[i++];
                        var y1 = d[i++];
                        var x2 = d[i++];
                        var y2 = d[i++];
                        var x3 = d[i++];
                        var y3 = d[i++];
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(xi, x1, x2, x3, t, $7b4119855d2b5b91$var$tmpOutX);
                                (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(yi, y1, y2, y3, t, $7b4119855d2b5b91$var$tmpOutY);
                                ctx.bezierCurveTo($7b4119855d2b5b91$var$tmpOutX[1], $7b4119855d2b5b91$var$tmpOutY[1], $7b4119855d2b5b91$var$tmpOutX[2], $7b4119855d2b5b91$var$tmpOutY[2], $7b4119855d2b5b91$var$tmpOutX[3], $7b4119855d2b5b91$var$tmpOutY[3]);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                        xi = x3;
                        yi = y3;
                        break;
                    case $7b4119855d2b5b91$var$CMD.Q:
                        var x1 = d[i++];
                        var y1 = d[i++];
                        var x2 = d[i++];
                        var y2 = d[i++];
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(xi, x1, x2, t, $7b4119855d2b5b91$var$tmpOutX);
                                (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(yi, y1, y2, t, $7b4119855d2b5b91$var$tmpOutY);
                                ctx.quadraticCurveTo($7b4119855d2b5b91$var$tmpOutX[1], $7b4119855d2b5b91$var$tmpOutY[1], $7b4119855d2b5b91$var$tmpOutX[2], $7b4119855d2b5b91$var$tmpOutY[2]);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.quadraticCurveTo(x1, y1, x2, y2);
                        xi = x2;
                        yi = y2;
                        break;
                    case $7b4119855d2b5b91$var$CMD.A:
                        var cx = d[i++];
                        var cy = d[i++];
                        var rx = d[i++];
                        var ry = d[i++];
                        var startAngle = d[i++];
                        var delta = d[i++];
                        var psi = d[i++];
                        var anticlockwise = !d[i++];
                        var r = rx > ry ? rx : ry;
                        var isEllipse = $7b4119855d2b5b91$var$mathAbs(rx - ry) > 1e-3;
                        var endAngle = startAngle + delta;
                        var breakBuild = false;
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                                breakBuild = true;
                            }
                            accumLength += l;
                        }
                        if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                        else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                        if (breakBuild) break lo;
                        if (isFirst) {
                            x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                            y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                        }
                        xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                        yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                        break;
                    case $7b4119855d2b5b91$var$CMD.R:
                        x0 = xi = d[i];
                        y0 = yi = d[i + 1];
                        x = d[i++];
                        y = d[i++];
                        var width = d[i++];
                        var height = d[i++];
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var d_1 = displayedLength - accumLength;
                                ctx.moveTo(x, y);
                                ctx.lineTo(x + $7b4119855d2b5b91$var$mathMin(d_1, width), y);
                                d_1 -= width;
                                if (d_1 > 0) ctx.lineTo(x + width, y + $7b4119855d2b5b91$var$mathMin(d_1, height));
                                d_1 -= height;
                                if (d_1 > 0) ctx.lineTo(x + $7b4119855d2b5b91$var$mathMax(width - d_1, 0), y + height);
                                d_1 -= width;
                                if (d_1 > 0) ctx.lineTo(x, y + $7b4119855d2b5b91$var$mathMax(height - d_1, 0));
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.rect(x, y, width, height);
                        break;
                    case $7b4119855d2b5b91$var$CMD.Z:
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.closePath();
                        xi = x0;
                        yi = y0;
                }
            }
        };
        PathProxy.prototype.clone = function() {
            var newProxy = new PathProxy();
            var data = this.data;
            newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
            newProxy._len = this._len;
            return newProxy;
        };
        PathProxy.CMD = $7b4119855d2b5b91$var$CMD;
        PathProxy.initDefaultProps = function() {
            var proto = PathProxy.prototype;
            proto._saveData = true;
            proto._needsDash = false;
            proto._dashOffset = 0;
            proto._dashIdx = 0;
            proto._dashSum = 0;
            proto._ux = 0;
            proto._uy = 0;
            proto._pendingPtDist = 0;
            proto._version = 0;
        }();
        return PathProxy;
    }();
    var $7b4119855d2b5b91$export$2e2bcd8739ae039 = $7b4119855d2b5b91$var$PathProxy;
});
parcelRegister("13I82", function(module, exports) {
    $parcel$export(module.exports, "fromPoints", ()=>$0c584d4e3f9e2fa0$export$188c3cd07b4129dd);
    $parcel$export(module.exports, "fromLine", ()=>$0c584d4e3f9e2fa0$export$d2b1491e4450bf2c);
    $parcel$export(module.exports, "fromCubic", ()=>$0c584d4e3f9e2fa0$export$c1bc6be456bb6609);
    $parcel$export(module.exports, "fromQuadratic", ()=>$0c584d4e3f9e2fa0$export$16fbe795323a1f4c);
    $parcel$export(module.exports, "fromArc", ()=>$0c584d4e3f9e2fa0$export$161c8bb0e1d9ef49);
    var $eLEew;
    var $dr1jo;
    var $0c584d4e3f9e2fa0$var$mathMin = Math.min;
    var $0c584d4e3f9e2fa0$var$mathMax = Math.max;
    var $0c584d4e3f9e2fa0$var$mathSin = Math.sin;
    var $0c584d4e3f9e2fa0$var$mathCos = Math.cos;
    var $0c584d4e3f9e2fa0$var$PI2 = Math.PI * 2;
    var $0c584d4e3f9e2fa0$var$start = (0, parcelRequire("eLEew")).create();
    var $0c584d4e3f9e2fa0$var$end = (0, parcelRequire("eLEew")).create();
    var $0c584d4e3f9e2fa0$var$extremity = (0, parcelRequire("eLEew")).create();
    function $0c584d4e3f9e2fa0$export$188c3cd07b4129dd(points, min, max) {
        if (points.length === 0) return;
        var p = points[0];
        var left = p[0];
        var right = p[0];
        var top = p[1];
        var bottom = p[1];
        for(var i = 1; i < points.length; i++){
            p = points[i];
            left = $0c584d4e3f9e2fa0$var$mathMin(left, p[0]);
            right = $0c584d4e3f9e2fa0$var$mathMax(right, p[0]);
            top = $0c584d4e3f9e2fa0$var$mathMin(top, p[1]);
            bottom = $0c584d4e3f9e2fa0$var$mathMax(bottom, p[1]);
        }
        min[0] = left;
        min[1] = top;
        max[0] = right;
        max[1] = bottom;
    }
    function $0c584d4e3f9e2fa0$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, x1);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, y1);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, x1);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, y1);
    }
    var $0c584d4e3f9e2fa0$var$xDim = [];
    var $0c584d4e3f9e2fa0$var$yDim = [];
    function $0c584d4e3f9e2fa0$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
        var cubicExtrema = (0, parcelRequire("dr1jo")).cubicExtrema;
        var cubicAt = (0, parcelRequire("dr1jo")).cubicAt;
        var n = cubicExtrema(x0, x1, x2, x3, $0c584d4e3f9e2fa0$var$xDim);
        min[0] = Infinity;
        min[1] = Infinity;
        max[0] = -Infinity;
        max[1] = -Infinity;
        for(var i = 0; i < n; i++){
            var x = cubicAt(x0, x1, x2, x3, $0c584d4e3f9e2fa0$var$xDim[i]);
            min[0] = $0c584d4e3f9e2fa0$var$mathMin(x, min[0]);
            max[0] = $0c584d4e3f9e2fa0$var$mathMax(x, max[0]);
        }
        n = cubicExtrema(y0, y1, y2, y3, $0c584d4e3f9e2fa0$var$yDim);
        for(var i = 0; i < n; i++){
            var y = cubicAt(y0, y1, y2, y3, $0c584d4e3f9e2fa0$var$yDim[i]);
            min[1] = $0c584d4e3f9e2fa0$var$mathMin(y, min[1]);
            max[1] = $0c584d4e3f9e2fa0$var$mathMax(y, max[1]);
        }
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, min[0]);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, max[0]);
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x3, min[0]);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x3, max[0]);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, min[1]);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, max[1]);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y3, min[1]);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y3, max[1]);
    }
    function $0c584d4e3f9e2fa0$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
        var quadraticExtremum = (0, parcelRequire("dr1jo")).quadraticExtremum;
        var quadraticAt = (0, parcelRequire("dr1jo")).quadraticAt;
        var tx = $0c584d4e3f9e2fa0$var$mathMax($0c584d4e3f9e2fa0$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
        var ty = $0c584d4e3f9e2fa0$var$mathMax($0c584d4e3f9e2fa0$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
        var x = quadraticAt(x0, x1, x2, tx);
        var y = quadraticAt(y0, y1, y2, ty);
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, x2, x);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, y2, y);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, x2, x);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, y2, y);
    }
    function $0c584d4e3f9e2fa0$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
        var vec2Min = (0, parcelRequire("eLEew")).min;
        var vec2Max = (0, parcelRequire("eLEew")).max;
        var diff = Math.abs(startAngle - endAngle);
        if (diff % $0c584d4e3f9e2fa0$var$PI2 < 1e-4 && diff > 1e-4) {
            min[0] = x - rx;
            min[1] = y - ry;
            max[0] = x + rx;
            max[1] = y + ry;
            return;
        }
        $0c584d4e3f9e2fa0$var$start[0] = $0c584d4e3f9e2fa0$var$mathCos(startAngle) * rx + x;
        $0c584d4e3f9e2fa0$var$start[1] = $0c584d4e3f9e2fa0$var$mathSin(startAngle) * ry + y;
        $0c584d4e3f9e2fa0$var$end[0] = $0c584d4e3f9e2fa0$var$mathCos(endAngle) * rx + x;
        $0c584d4e3f9e2fa0$var$end[1] = $0c584d4e3f9e2fa0$var$mathSin(endAngle) * ry + y;
        vec2Min(min, $0c584d4e3f9e2fa0$var$start, $0c584d4e3f9e2fa0$var$end);
        vec2Max(max, $0c584d4e3f9e2fa0$var$start, $0c584d4e3f9e2fa0$var$end);
        startAngle = startAngle % $0c584d4e3f9e2fa0$var$PI2;
        if (startAngle < 0) startAngle = startAngle + $0c584d4e3f9e2fa0$var$PI2;
        endAngle = endAngle % $0c584d4e3f9e2fa0$var$PI2;
        if (endAngle < 0) endAngle = endAngle + $0c584d4e3f9e2fa0$var$PI2;
        if (startAngle > endAngle && !anticlockwise) endAngle += $0c584d4e3f9e2fa0$var$PI2;
        else if (startAngle < endAngle && anticlockwise) startAngle += $0c584d4e3f9e2fa0$var$PI2;
        if (anticlockwise) {
            var tmp = endAngle;
            endAngle = startAngle;
            startAngle = tmp;
        }
        for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
            $0c584d4e3f9e2fa0$var$extremity[0] = $0c584d4e3f9e2fa0$var$mathCos(angle) * rx + x;
            $0c584d4e3f9e2fa0$var$extremity[1] = $0c584d4e3f9e2fa0$var$mathSin(angle) * ry + y;
            vec2Min(min, $0c584d4e3f9e2fa0$var$extremity, min);
            vec2Max(max, $0c584d4e3f9e2fa0$var$extremity, max);
        }
    }
});
parcelRegister("dr1jo", function(module, exports) {
    $parcel$export(module.exports, "cubicAt", ()=>$9c7ed07589dafe64$export$547c21de482bbcb2);
    $parcel$export(module.exports, "cubicDerivativeAt", ()=>$9c7ed07589dafe64$export$55fce925c60b6271);
    $parcel$export(module.exports, "cubicRootAt", ()=>$9c7ed07589dafe64$export$ca5d13faa10b167e);
    $parcel$export(module.exports, "cubicExtrema", ()=>$9c7ed07589dafe64$export$df1a172f100d0457);
    $parcel$export(module.exports, "cubicSubdivide", ()=>$9c7ed07589dafe64$export$a2ee23a0567039da);
    $parcel$export(module.exports, "cubicProjectPoint", ()=>$9c7ed07589dafe64$export$dbaa3801d1284367);
    $parcel$export(module.exports, "cubicLength", ()=>$9c7ed07589dafe64$export$af1875d576f60d7c);
    $parcel$export(module.exports, "quadraticAt", ()=>$9c7ed07589dafe64$export$af17094a950f5073);
    $parcel$export(module.exports, "quadraticDerivativeAt", ()=>$9c7ed07589dafe64$export$7e161e77e6fff8cb);
    $parcel$export(module.exports, "quadraticRootAt", ()=>$9c7ed07589dafe64$export$fd895ac7ee764967);
    $parcel$export(module.exports, "quadraticExtremum", ()=>$9c7ed07589dafe64$export$752e1f8c6e7f7e11);
    $parcel$export(module.exports, "quadraticSubdivide", ()=>$9c7ed07589dafe64$export$117c659e21a7a060);
    $parcel$export(module.exports, "quadraticProjectPoint", ()=>$9c7ed07589dafe64$export$81915a594fe10dee);
    $parcel$export(module.exports, "quadraticLength", ()=>$9c7ed07589dafe64$export$8a68adee46f3cf55);
    var $eLEew;
    var $9c7ed07589dafe64$var$mathPow = Math.pow;
    var $9c7ed07589dafe64$var$mathSqrt = Math.sqrt;
    var $9c7ed07589dafe64$var$EPSILON = 1e-8;
    var $9c7ed07589dafe64$var$EPSILON_NUMERIC = 1e-4;
    var $9c7ed07589dafe64$var$THREE_SQRT = $9c7ed07589dafe64$var$mathSqrt(3);
    var $9c7ed07589dafe64$var$ONE_THIRD = 1 / 3;
    var $9c7ed07589dafe64$var$_v0 = (0, (0, parcelRequire("eLEew")).create)();
    var $9c7ed07589dafe64$var$_v1 = (0, (0, parcelRequire("eLEew")).create)();
    var $9c7ed07589dafe64$var$_v2 = (0, (0, parcelRequire("eLEew")).create)();
    function $9c7ed07589dafe64$var$isAroundZero(val) {
        return val > -$9c7ed07589dafe64$var$EPSILON && val < $9c7ed07589dafe64$var$EPSILON;
    }
    function $9c7ed07589dafe64$var$isNotAroundZero(val) {
        return val > $9c7ed07589dafe64$var$EPSILON || val < -$9c7ed07589dafe64$var$EPSILON;
    }
    function $9c7ed07589dafe64$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
        var onet = 1 - t;
        return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
    }
    function $9c7ed07589dafe64$export$55fce925c60b6271(p0, p1, p2, p3, t) {
        var onet = 1 - t;
        return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
    }
    function $9c7ed07589dafe64$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
        var a = p3 + 3 * (p1 - p2) - p0;
        var b = 3 * (p2 - p1 * 2 + p0);
        var c = 3 * (p1 - p0);
        var d = p0 - val;
        var A = b * b - 3 * a * c;
        var B = b * c - 9 * a * d;
        var C = c * c - 3 * b * d;
        var n = 0;
        if ($9c7ed07589dafe64$var$isAroundZero(A) && $9c7ed07589dafe64$var$isAroundZero(B)) {
            if ($9c7ed07589dafe64$var$isAroundZero(b)) roots[0] = 0;
            else {
                var t1 = -c / b;
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            }
        } else {
            var disc = B * B - 4 * A * C;
            if ($9c7ed07589dafe64$var$isAroundZero(disc)) {
                var K = B / A;
                var t1 = -b / a + K;
                var t2 = -K / 2;
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
                if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            } else if (disc > 0) {
                var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
                var Y1 = A * b + 1.5 * a * (-B + discSqrt);
                var Y2 = A * b + 1.5 * a * (-B - discSqrt);
                if (Y1 < 0) Y1 = -$9c7ed07589dafe64$var$mathPow(-Y1, $9c7ed07589dafe64$var$ONE_THIRD);
                else Y1 = $9c7ed07589dafe64$var$mathPow(Y1, $9c7ed07589dafe64$var$ONE_THIRD);
                if (Y2 < 0) Y2 = -$9c7ed07589dafe64$var$mathPow(-Y2, $9c7ed07589dafe64$var$ONE_THIRD);
                else Y2 = $9c7ed07589dafe64$var$mathPow(Y2, $9c7ed07589dafe64$var$ONE_THIRD);
                var t1 = (-b - (Y1 + Y2)) / (3 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            } else {
                var T = (2 * A * b - 3 * a * B) / (2 * $9c7ed07589dafe64$var$mathSqrt(A * A * A));
                var theta = Math.acos(T) / 3;
                var ASqrt = $9c7ed07589dafe64$var$mathSqrt(A);
                var tmp = Math.cos(theta);
                var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
                var t2 = (-b + ASqrt * (tmp + $9c7ed07589dafe64$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
                var t3 = (-b + ASqrt * (tmp - $9c7ed07589dafe64$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
                if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
                if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
            }
        }
        return n;
    }
    function $9c7ed07589dafe64$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
        var b = 6 * p2 - 12 * p1 + 6 * p0;
        var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
        var c = 3 * p1 - 3 * p0;
        var n = 0;
        if ($9c7ed07589dafe64$var$isAroundZero(a)) {
            if ($9c7ed07589dafe64$var$isNotAroundZero(b)) {
                var t1 = -c / b;
                if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            }
        } else {
            var disc = b * b - 4 * a * c;
            if ($9c7ed07589dafe64$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
            else if (disc > 0) {
                var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
                var t1 = (-b + discSqrt) / (2 * a);
                var t2 = (-b - discSqrt) / (2 * a);
                if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
                if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
            }
        }
        return n;
    }
    function $9c7ed07589dafe64$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
        var p01 = (p1 - p0) * t + p0;
        var p12 = (p2 - p1) * t + p1;
        var p23 = (p3 - p2) * t + p2;
        var p012 = (p12 - p01) * t + p01;
        var p123 = (p23 - p12) * t + p12;
        var p0123 = (p123 - p012) * t + p012;
        out[0] = p0;
        out[1] = p01;
        out[2] = p012;
        out[3] = p0123;
        out[4] = p0123;
        out[5] = p123;
        out[6] = p23;
        out[7] = p3;
    }
    function $9c7ed07589dafe64$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
        var t;
        var interval = 0.005;
        var d = Infinity;
        var prev;
        var next;
        var d1;
        var d2;
        $9c7ed07589dafe64$var$_v0[0] = x;
        $9c7ed07589dafe64$var$_v0[1] = y;
        for(var _t = 0; _t < 1; _t += 0.05){
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
            d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v0, $9c7ed07589dafe64$var$_v1);
            if (d1 < d) {
                t = _t;
                d = d1;
            }
        }
        d = Infinity;
        for(var i = 0; i < 32; i++){
            if (interval < $9c7ed07589dafe64$var$EPSILON_NUMERIC) break;
            prev = t - interval;
            next = t + interval;
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
            d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v1, $9c7ed07589dafe64$var$_v0);
            if (prev >= 0 && d1 < d) {
                t = prev;
                d = d1;
            } else {
                $9c7ed07589dafe64$var$_v2[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, next);
                $9c7ed07589dafe64$var$_v2[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, next);
                d2 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v2, $9c7ed07589dafe64$var$_v0);
                if (next <= 1 && d2 < d) {
                    t = next;
                    d = d2;
                } else interval *= 0.5;
            }
        }
        if (out) {
            out[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            out[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        }
        return $9c7ed07589dafe64$var$mathSqrt(d);
    }
    function $9c7ed07589dafe64$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
        var px = x0;
        var py = y0;
        var d = 0;
        var step = 1 / iteration;
        for(var i = 1; i <= iteration; i++){
            var t = i * step;
            var x = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            var y = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, t);
            var dx = x - px;
            var dy = y - py;
            d += Math.sqrt(dx * dx + dy * dy);
            px = x;
            py = y;
        }
        return d;
    }
    function $9c7ed07589dafe64$export$af17094a950f5073(p0, p1, p2, t) {
        var onet = 1 - t;
        return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
    }
    function $9c7ed07589dafe64$export$7e161e77e6fff8cb(p0, p1, p2, t) {
        return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
    }
    function $9c7ed07589dafe64$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
        var a = p0 - 2 * p1 + p2;
        var b = 2 * (p1 - p0);
        var c = p0 - val;
        var n = 0;
        if ($9c7ed07589dafe64$var$isAroundZero(a)) {
            if ($9c7ed07589dafe64$var$isNotAroundZero(b)) {
                var t1 = -c / b;
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            }
        } else {
            var disc = b * b - 4 * a * c;
            if ($9c7ed07589dafe64$var$isAroundZero(disc)) {
                var t1 = -b / (2 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            } else if (disc > 0) {
                var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
                var t1 = (-b + discSqrt) / (2 * a);
                var t2 = (-b - discSqrt) / (2 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
                if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            }
        }
        return n;
    }
    function $9c7ed07589dafe64$export$752e1f8c6e7f7e11(p0, p1, p2) {
        var divider = p0 + p2 - 2 * p1;
        if (divider === 0) return 0.5;
        else return (p0 - p1) / divider;
    }
    function $9c7ed07589dafe64$export$117c659e21a7a060(p0, p1, p2, t, out) {
        var p01 = (p1 - p0) * t + p0;
        var p12 = (p2 - p1) * t + p1;
        var p012 = (p12 - p01) * t + p01;
        out[0] = p0;
        out[1] = p01;
        out[2] = p012;
        out[3] = p012;
        out[4] = p12;
        out[5] = p2;
    }
    function $9c7ed07589dafe64$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
        var t;
        var interval = 0.005;
        var d = Infinity;
        $9c7ed07589dafe64$var$_v0[0] = x;
        $9c7ed07589dafe64$var$_v0[1] = y;
        for(var _t = 0; _t < 1; _t += 0.05){
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, _t);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, _t);
            var d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v0, $9c7ed07589dafe64$var$_v1);
            if (d1 < d) {
                t = _t;
                d = d1;
            }
        }
        d = Infinity;
        for(var i = 0; i < 32; i++){
            if (interval < $9c7ed07589dafe64$var$EPSILON_NUMERIC) break;
            var prev = t - interval;
            var next = t + interval;
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, prev);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, prev);
            var d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v1, $9c7ed07589dafe64$var$_v0);
            if (prev >= 0 && d1 < d) {
                t = prev;
                d = d1;
            } else {
                $9c7ed07589dafe64$var$_v2[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, next);
                $9c7ed07589dafe64$var$_v2[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, next);
                var d2 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v2, $9c7ed07589dafe64$var$_v0);
                if (next <= 1 && d2 < d) {
                    t = next;
                    d = d2;
                } else interval *= 0.5;
            }
        }
        if (out) {
            out[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, t);
            out[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, t);
        }
        return $9c7ed07589dafe64$var$mathSqrt(d);
    }
    function $9c7ed07589dafe64$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
        var px = x0;
        var py = y0;
        var d = 0;
        var step = 1 / iteration;
        for(var i = 1; i <= iteration; i++){
            var t = i * step;
            var x = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, t);
            var y = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, t);
            var dx = x - px;
            var dy = y - py;
            d += Math.sqrt(dx * dx + dy * dy);
            px = x;
            py = y;
        }
        return d;
    }
});
parcelRegister("k3yEY", function(module, exports) {
    $parcel$export(module.exports, "contain", ()=>$e99ef93372091697$export$8893e2b90ba10d92);
    $parcel$export(module.exports, "containStroke", ()=>$e99ef93372091697$export$8d36b1b5d19157c5);
    var $aA4Ws;
    var $1oALq;
    var $bTFCK;
    var $1nzVA;
    var $69jpm;
    var $dr1jo;
    var $3Ytji;
    var $e99ef93372091697$var$CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
    var $e99ef93372091697$var$PI2 = Math.PI * 2;
    var $e99ef93372091697$var$EPSILON = 1e-4;
    function $e99ef93372091697$var$isAroundEqual(a, b) {
        return Math.abs(a - b) < $e99ef93372091697$var$EPSILON;
    }
    var $e99ef93372091697$var$roots = [
        -1,
        -1,
        -1
    ];
    var $e99ef93372091697$var$extrema = [
        -1,
        -1
    ];
    function $e99ef93372091697$var$swapExtrema() {
        var tmp = $e99ef93372091697$var$extrema[0];
        $e99ef93372091697$var$extrema[0] = $e99ef93372091697$var$extrema[1];
        $e99ef93372091697$var$extrema[1] = tmp;
    }
    function $e99ef93372091697$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
        if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
        var nRoots = (0, parcelRequire("dr1jo")).cubicRootAt(y0, y1, y2, y3, y, $e99ef93372091697$var$roots);
        if (nRoots === 0) return 0;
        else {
            var w = 0;
            var nExtrema = -1;
            var y0_ = void 0;
            var y1_ = void 0;
            for(var i = 0; i < nRoots; i++){
                var t = $e99ef93372091697$var$roots[i];
                var unit = t === 0 || t === 1 ? 0.5 : 1;
                var x_ = (0, parcelRequire("dr1jo")).cubicAt(x0, x1, x2, x3, t);
                if (x_ < x) continue;
                if (nExtrema < 0) {
                    nExtrema = (0, parcelRequire("dr1jo")).cubicExtrema(y0, y1, y2, y3, $e99ef93372091697$var$extrema);
                    if ($e99ef93372091697$var$extrema[1] < $e99ef93372091697$var$extrema[0] && nExtrema > 1) $e99ef93372091697$var$swapExtrema();
                    y0_ = (0, parcelRequire("dr1jo")).cubicAt(y0, y1, y2, y3, $e99ef93372091697$var$extrema[0]);
                    if (nExtrema > 1) y1_ = (0, parcelRequire("dr1jo")).cubicAt(y0, y1, y2, y3, $e99ef93372091697$var$extrema[1]);
                }
                if (nExtrema === 2) {
                    if (t < $e99ef93372091697$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                    else if (t < $e99ef93372091697$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                    else w += y3 < y1_ ? unit : -unit;
                } else if (t < $e99ef93372091697$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else w += y3 < y0_ ? unit : -unit;
            }
            return w;
        }
    }
    function $e99ef93372091697$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
        if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
        var nRoots = (0, parcelRequire("dr1jo")).quadraticRootAt(y0, y1, y2, y, $e99ef93372091697$var$roots);
        if (nRoots === 0) return 0;
        else {
            var t = (0, parcelRequire("dr1jo")).quadraticExtremum(y0, y1, y2);
            if (t >= 0 && t <= 1) {
                var w = 0;
                var y_ = (0, parcelRequire("dr1jo")).quadraticAt(y0, y1, y2, t);
                for(var i = 0; i < nRoots; i++){
                    var unit = $e99ef93372091697$var$roots[i] === 0 || $e99ef93372091697$var$roots[i] === 1 ? 0.5 : 1;
                    var x_ = (0, parcelRequire("dr1jo")).quadraticAt(x0, x1, x2, $e99ef93372091697$var$roots[i]);
                    if (x_ < x) continue;
                    if ($e99ef93372091697$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                    else w += y2 < y_ ? unit : -unit;
                }
                return w;
            } else {
                var unit = $e99ef93372091697$var$roots[0] === 0 || $e99ef93372091697$var$roots[0] === 1 ? 0.5 : 1;
                var x_ = (0, parcelRequire("dr1jo")).quadraticAt(x0, x1, x2, $e99ef93372091697$var$roots[0]);
                if (x_ < x) return 0;
                return y2 < y0 ? unit : -unit;
            }
        }
    }
    function $e99ef93372091697$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
        y -= cy;
        if (y > r || y < -r) return 0;
        var tmp = Math.sqrt(r * r - y * y);
        $e99ef93372091697$var$roots[0] = -tmp;
        $e99ef93372091697$var$roots[1] = tmp;
        var dTheta = Math.abs(startAngle - endAngle);
        if (dTheta < 1e-4) return 0;
        if (dTheta >= $e99ef93372091697$var$PI2 - 1e-4) {
            startAngle = 0;
            endAngle = $e99ef93372091697$var$PI2;
            var dir = anticlockwise ? 1 : -1;
            if (x >= $e99ef93372091697$var$roots[0] + cx && x <= $e99ef93372091697$var$roots[1] + cx) return dir;
            else return 0;
        }
        if (startAngle > endAngle) {
            var tmp_1 = startAngle;
            startAngle = endAngle;
            endAngle = tmp_1;
        }
        if (startAngle < 0) {
            startAngle += $e99ef93372091697$var$PI2;
            endAngle += $e99ef93372091697$var$PI2;
        }
        var w = 0;
        for(var i = 0; i < 2; i++){
            var x_ = $e99ef93372091697$var$roots[i];
            if (x_ + cx > x) {
                var angle = Math.atan2(y, x_);
                var dir = anticlockwise ? 1 : -1;
                if (angle < 0) angle = $e99ef93372091697$var$PI2 + angle;
                if (angle >= startAngle && angle <= endAngle || angle + $e99ef93372091697$var$PI2 >= startAngle && angle + $e99ef93372091697$var$PI2 <= endAngle) {
                    if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                    w += dir;
                }
            }
        }
        return w;
    }
    function $e99ef93372091697$var$containPath(path, lineWidth, isStroke, x, y) {
        var data = path.data;
        var len = path.len();
        var w = 0;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var x1;
        var y1;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (cmd === $e99ef93372091697$var$CMD.M && i > 1) {
                if (!isStroke) w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x0, y0, x, y);
            }
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $e99ef93372091697$var$CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    xi = x0;
                    yi = y0;
                    break;
                case $e99ef93372091697$var$CMD.L:
                    if (isStroke) {
                        if ((0, parcelRequire("1oALq")).containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                    } else w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, data[i], data[i + 1], x, y) || 0;
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e99ef93372091697$var$CMD.C:
                    if (isStroke) {
                        if ((0, parcelRequire("bTFCK")).containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                    } else w += $e99ef93372091697$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e99ef93372091697$var$CMD.Q:
                    if (isStroke) {
                        if ((0, parcelRequire("1nzVA")).containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                    } else w += $e99ef93372091697$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e99ef93372091697$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var theta = data[i++];
                    var dTheta = data[i++];
                    i += 1;
                    var anticlockwise = !!(1 - data[i++]);
                    x1 = Math.cos(theta) * rx + cx;
                    y1 = Math.sin(theta) * ry + cy;
                    if (!isFirst) w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x1, y1, x, y);
                    else {
                        x0 = x1;
                        y0 = y1;
                    }
                    var _x = (x - cx) * ry / rx + cx;
                    if (isStroke) {
                        if ((0, parcelRequire("69jpm")).containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                    } else w += $e99ef93372091697$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                    xi = Math.cos(theta + dTheta) * rx + cx;
                    yi = Math.sin(theta + dTheta) * ry + cy;
                    break;
                case $e99ef93372091697$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    x1 = x0 + width;
                    y1 = y0 + height;
                    if (isStroke) {
                        if ((0, parcelRequire("1oALq")).containStroke(x0, y0, x1, y0, lineWidth, x, y) || (0, parcelRequire("1oALq")).containStroke(x1, y0, x1, y1, lineWidth, x, y) || (0, parcelRequire("1oALq")).containStroke(x1, y1, x0, y1, lineWidth, x, y) || (0, parcelRequire("1oALq")).containStroke(x0, y1, x0, y0, lineWidth, x, y)) return true;
                    } else {
                        w += (0, (0, parcelRequire("3Ytji")).default)(x1, y0, x1, y1, x, y);
                        w += (0, (0, parcelRequire("3Ytji")).default)(x0, y1, x0, y0, x, y);
                    }
                    break;
                case $e99ef93372091697$var$CMD.Z:
                    if (isStroke) {
                        if ((0, parcelRequire("1oALq")).containStroke(xi, yi, x0, y0, lineWidth, x, y)) return true;
                    } else w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x0, y0, x, y);
                    xi = x0;
                    yi = y0;
                    break;
            }
        }
        if (!isStroke && !$e99ef93372091697$var$isAroundEqual(yi, y0)) w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x0, y0, x, y) || 0;
        return w !== 0;
    }
    function $e99ef93372091697$export$8893e2b90ba10d92(pathProxy, x, y) {
        return $e99ef93372091697$var$containPath(pathProxy, 0, false, x, y);
    }
    function $e99ef93372091697$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
        return $e99ef93372091697$var$containPath(pathProxy, lineWidth, true, x, y);
    }
});
parcelRegister("1oALq", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$10448ce251a929f8$export$8d36b1b5d19157c5);
    function $10448ce251a929f8$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        var _a = 0;
        var _b = x0;
        if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
        if (x0 !== x1) {
            _a = (y0 - y1) / (x0 - x1);
            _b = (x0 * y1 - x1 * y0) / (x0 - x1);
        } else return Math.abs(x - x0) <= _l / 2;
        var tmp = _a * x - y + _b;
        var _s = tmp * tmp / (_a * _a + 1);
        return _s <= _l / 2 * _l / 2;
    }
});
parcelRegister("bTFCK", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$8a951e6f66d6987a$export$8d36b1b5d19157c5);
    var $dr1jo;
    function $8a951e6f66d6987a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
        var d = (0, parcelRequire("dr1jo")).cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
        return d <= _l / 2;
    }
});
parcelRegister("1nzVA", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$1013ceeba79e2375$export$8d36b1b5d19157c5);
    var $dr1jo;
    function $1013ceeba79e2375$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
        var d = (0, (0, parcelRequire("dr1jo")).quadraticProjectPoint)(x0, y0, x1, y1, x2, y2, x, y, null);
        return d <= _l / 2;
    }
});
parcelRegister("69jpm", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$47a2a3596d9bac74$export$8d36b1b5d19157c5);
    var $kvt3T;
    var $47a2a3596d9bac74$var$PI2 = Math.PI * 2;
    function $47a2a3596d9bac74$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        x -= cx;
        y -= cy;
        var d = Math.sqrt(x * x + y * y);
        if (d - _l > r || d + _l < r) return false;
        if (Math.abs(startAngle - endAngle) % $47a2a3596d9bac74$var$PI2 < 1e-4) return true;
        if (anticlockwise) {
            var tmp = startAngle;
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(tmp);
        } else {
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(startAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
        }
        if (startAngle > endAngle) endAngle += $47a2a3596d9bac74$var$PI2;
        var angle = Math.atan2(y, x);
        if (angle < 0) angle += $47a2a3596d9bac74$var$PI2;
        return angle >= startAngle && angle <= endAngle || angle + $47a2a3596d9bac74$var$PI2 >= startAngle && angle + $47a2a3596d9bac74$var$PI2 <= endAngle;
    }
});
parcelRegister("kvt3T", function(module, exports) {
    $parcel$export(module.exports, "normalizeRadian", ()=>$eedd3ef967ea7890$export$d44861331f213635);
    var $eedd3ef967ea7890$var$PI2 = Math.PI * 2;
    function $eedd3ef967ea7890$export$d44861331f213635(angle) {
        angle %= $eedd3ef967ea7890$var$PI2;
        if (angle < 0) angle += $eedd3ef967ea7890$var$PI2;
        return angle;
    }
});
parcelRegister("3Ytji", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4db612d32f7532$export$2e2bcd8739ae039);
    function $2e4db612d32f7532$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
        if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
        if (y1 === y0) return 0;
        var t = (y - y0) / (y1 - y0);
        var dir = y1 < y0 ? 1 : -1;
        if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
        var x_ = t * (x1 - x0) + x0;
        return x_ === x ? Infinity : x_ > x ? dir : 0;
    }
});
parcelRegister("cTDbe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96390378868b6806$export$2e2bcd8739ae039);
    var $aA4Ws;
    var $eLEew;
    var $96390378868b6806$var$CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
    var $96390378868b6806$var$points = [
        [],
        [],
        []
    ];
    var $96390378868b6806$var$mathSqrt = Math.sqrt;
    var $96390378868b6806$var$mathAtan2 = Math.atan2;
    function $96390378868b6806$export$2e2bcd8739ae039(path, m) {
        if (!m) return;
        var data = path.data;
        var len = path.len();
        var cmd;
        var nPoint;
        var i;
        var j;
        var k;
        var p;
        var M = $96390378868b6806$var$CMD.M;
        var C = $96390378868b6806$var$CMD.C;
        var L = $96390378868b6806$var$CMD.L;
        var R = $96390378868b6806$var$CMD.R;
        var A = $96390378868b6806$var$CMD.A;
        var Q = $96390378868b6806$var$CMD.Q;
        for(i = 0, j = 0; i < len;){
            cmd = data[i++];
            j = i;
            nPoint = 0;
            switch(cmd){
                case M:
                    nPoint = 1;
                    break;
                case L:
                    nPoint = 1;
                    break;
                case C:
                    nPoint = 3;
                    break;
                case Q:
                    nPoint = 2;
                    break;
                case A:
                    var x = m[4];
                    var y = m[5];
                    var sx = $96390378868b6806$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                    var sy = $96390378868b6806$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                    var angle = $96390378868b6806$var$mathAtan2(-m[1] / sy, m[0] / sx);
                    data[i] *= sx;
                    data[i++] += x;
                    data[i] *= sy;
                    data[i++] += y;
                    data[i++] *= sx;
                    data[i++] *= sy;
                    data[i++] += angle;
                    data[i++] += angle;
                    i += 2;
                    j = i;
                    break;
                case R:
                    p[0] = data[i++];
                    p[1] = data[i++];
                    (0, (0, parcelRequire("eLEew")).applyTransform)(p, p, m);
                    data[j++] = p[0];
                    data[j++] = p[1];
                    p[0] += data[i++];
                    p[1] += data[i++];
                    (0, (0, parcelRequire("eLEew")).applyTransform)(p, p, m);
                    data[j++] = p[0];
                    data[j++] = p[1];
            }
            for(k = 0; k < nPoint; k++){
                var p_1 = $96390378868b6806$var$points[k];
                p_1[0] = data[i++];
                p_1[1] = data[i++];
                (0, (0, parcelRequire("eLEew")).applyTransform)(p_1, p_1, m);
                data[j++] = p_1[0];
                data[j++] = p_1[1];
            }
        }
        path.increaseVersion();
    }
});
parcelRegister("gcbBH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bca6c53e2dabf533$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $1E3E8;
    var $bahqM;
    var $bca6c53e2dabf533$export$8993f922aeeac642 = (0, (0, parcelRequire("bahqM")).defaults)({
        x: 0,
        y: 0
    }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE));
    var $bca6c53e2dabf533$export$4aba8ad70847a488 = {
        style: (0, (0, parcelRequire("bahqM")).defaults)({
            x: true,
            y: true,
            width: true,
            height: true,
            sx: true,
            sy: true,
            sWidth: true,
            sHeight: true
        }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_ANIMATION_PROPS).style)
    };
    function $bca6c53e2dabf533$var$isImageLike(source) {
        return !!(source && typeof source !== 'string' && source.width && source.height);
    }
    var $bca6c53e2dabf533$var$ZRImage = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ZRImage, _super);
        function ZRImage() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ZRImage.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($bca6c53e2dabf533$export$8993f922aeeac642, obj);
        };
        ZRImage.prototype._getSize = function(dim) {
            var style = this.style;
            var size = style[dim];
            if (size != null) return size;
            var imageSource = $bca6c53e2dabf533$var$isImageLike(style.image) ? style.image : this.__image;
            if (!imageSource) return 0;
            var otherDim = dim === 'width' ? 'height' : 'width';
            var otherDimSize = style[otherDim];
            if (otherDimSize == null) return imageSource[dim];
            else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
        };
        ZRImage.prototype.getWidth = function() {
            return this._getSize('width');
        };
        ZRImage.prototype.getHeight = function() {
            return this._getSize('height');
        };
        ZRImage.prototype.getAnimationStyleProps = function() {
            return $bca6c53e2dabf533$export$4aba8ad70847a488;
        };
        ZRImage.prototype.getBoundingRect = function() {
            var style = this.style;
            if (!this._rect) this._rect = new (0, (0, parcelRequire("1E3E8")).default)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
            return this._rect;
        };
        return ZRImage;
    }((0, (0, parcelRequire("lBQ88")).default));
    $bca6c53e2dabf533$var$ZRImage.prototype.type = 'image';
    var $bca6c53e2dabf533$export$2e2bcd8739ae039 = $bca6c53e2dabf533$var$ZRImage;
});
parcelRegister("4gEFv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31b833f429060f54$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h6fMM;
    var $45jlh;
    var $bahqM;
    var $b7ZX8;
    var $gcbBH;
    var $7Tw7u;
    var $1E3E8;
    var $lBQ88;
    var $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR = {
        fill: '#000'
    };
    var $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH = 2;
    var $31b833f429060f54$export$21aaaa0607ee0e2b = {
        style: (0, (0, parcelRequire("bahqM")).defaults)({
            fill: true,
            stroke: true,
            fillOpacity: true,
            strokeOpacity: true,
            lineWidth: true,
            fontSize: true,
            lineHeight: true,
            width: true,
            height: true,
            textShadowColor: true,
            textShadowBlur: true,
            textShadowOffsetX: true,
            textShadowOffsetY: true,
            backgroundColor: true,
            padding: true,
            borderColor: true,
            borderWidth: true,
            borderRadius: true
        }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_ANIMATION_PROPS).style)
    };
    var $31b833f429060f54$var$ZRText = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ZRText, _super);
        function ZRText(opts) {
            var _this = _super.call(this) || this;
            _this.type = 'text';
            _this._children = [];
            _this._defaultStyle = $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR;
            _this.attr(opts);
            return _this;
        }
        ZRText.prototype.childrenRef = function() {
            return this._children;
        };
        ZRText.prototype.update = function() {
            _super.prototype.update.call(this);
            if (this.styleChanged()) this._updateSubTexts();
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                child.zlevel = this.zlevel;
                child.z = this.z;
                child.z2 = this.z2;
                child.culling = this.culling;
                child.cursor = this.cursor;
                child.invisible = this.invisible;
            }
        };
        ZRText.prototype.updateTransform = function() {
            var innerTransformable = this.innerTransformable;
            if (innerTransformable) {
                innerTransformable.updateTransform();
                if (innerTransformable.transform) this.transform = innerTransformable.transform;
            } else _super.prototype.updateTransform.call(this);
        };
        ZRText.prototype.getLocalTransform = function(m) {
            var innerTransformable = this.innerTransformable;
            return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
        };
        ZRText.prototype.getComputedTransform = function() {
            if (this.__hostTarget) {
                this.__hostTarget.getComputedTransform();
                this.__hostTarget.updateInnerText(true);
            }
            return _super.prototype.getComputedTransform.call(this);
        };
        ZRText.prototype._updateSubTexts = function() {
            this._childCursor = 0;
            $31b833f429060f54$export$176336068cc5371f(this.style);
            this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
            this._children.length = this._childCursor;
            this.styleUpdated();
        };
        ZRText.prototype.addSelfToZr = function(zr) {
            _super.prototype.addSelfToZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
        };
        ZRText.prototype.removeSelfFromZr = function(zr) {
            _super.prototype.removeSelfFromZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
        };
        ZRText.prototype.getBoundingRect = function() {
            if (this.styleChanged()) this._updateSubTexts();
            if (!this._rect) {
                var tmpRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
                var children = this._children;
                var tmpMat = [];
                var rect = null;
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    var childRect = child.getBoundingRect();
                    var transform = child.getLocalTransform(tmpMat);
                    if (transform) {
                        tmpRect.copy(childRect);
                        tmpRect.applyTransform(transform);
                        rect = rect || tmpRect.clone();
                        rect.union(tmpRect);
                    } else {
                        rect = rect || childRect.clone();
                        rect.union(childRect);
                    }
                }
                this._rect = rect || tmpRect;
            }
            return this._rect;
        };
        ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
            this._defaultStyle = defaultTextStyle || $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR;
        };
        ZRText.prototype.setTextContent = function(textContent) {
            throw new Error('Can\'t attach text on another text');
        };
        ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
            if (!sourceStyle) return targetStyle;
            var sourceRich = sourceStyle.rich;
            var targetRich = targetStyle.rich || sourceRich && {};
            (0, (0, parcelRequire("bahqM")).extend)(targetStyle, sourceStyle);
            if (sourceRich && targetRich) {
                this._mergeRich(targetRich, sourceRich);
                targetStyle.rich = targetRich;
            } else if (targetRich) targetStyle.rich = targetRich;
            return targetStyle;
        };
        ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
            var richNames = (0, (0, parcelRequire("bahqM")).keys)(sourceRich);
            for(var i = 0; i < richNames.length; i++){
                var richName = richNames[i];
                targetRich[richName] = targetRich[richName] || {};
                (0, (0, parcelRequire("bahqM")).extend)(targetRich[richName], sourceRich[richName]);
            }
        };
        ZRText.prototype.getAnimationStyleProps = function() {
            return $31b833f429060f54$export$21aaaa0607ee0e2b;
        };
        ZRText.prototype._getOrCreateChild = function(Ctor) {
            var child = this._children[this._childCursor];
            if (!child || !(child instanceof Ctor)) child = new Ctor();
            this._children[this._childCursor++] = child;
            child.__zr = this.__zr;
            child.parent = this;
            return child;
        };
        ZRText.prototype._updatePlainTexts = function() {
            var style = this.style;
            var textFont = style.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            var textPadding = style.padding;
            var text = $31b833f429060f54$var$getStyleText(style);
            var contentBlock = (0, (0, parcelRequire("h6fMM")).parsePlainText)(text, style);
            var needDrawBg = $31b833f429060f54$var$needDrawBackground(style);
            var bgColorDrawn = !!style.backgroundColor;
            var outerHeight = contentBlock.outerHeight;
            var textLines = contentBlock.lines;
            var lineHeight = contentBlock.lineHeight;
            var defaultStyle = this._defaultStyle;
            var baseX = style.x || 0;
            var baseY = style.y || 0;
            var textAlign = style.align || defaultStyle.align || 'left';
            var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
            var textX = baseX;
            var textY = (0, (0, parcelRequire("b7ZX8")).adjustTextY)(baseY, contentBlock.contentHeight, verticalAlign);
            if (needDrawBg || textPadding) {
                var outerWidth_1 = contentBlock.width;
                textPadding && (outerWidth_1 += textPadding[1] + textPadding[3]);
                var boxX = (0, (0, parcelRequire("b7ZX8")).adjustTextX)(baseX, outerWidth_1, textAlign);
                var boxY = (0, (0, parcelRequire("b7ZX8")).adjustTextY)(baseY, outerHeight, verticalAlign);
                needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth_1, outerHeight);
            }
            textY += lineHeight / 2;
            if (textPadding) {
                textX = $31b833f429060f54$var$getTextXForPadding(baseX, textAlign, textPadding);
                if (verticalAlign === 'top') textY += textPadding[0];
                else if (verticalAlign === 'bottom') textY -= textPadding[2];
            }
            var defaultLineWidth = 0;
            var useDefaultFill = false;
            var textFill = $31b833f429060f54$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
            var textStroke = $31b833f429060f54$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
            var hasShadow = style.textShadowBlur > 0;
            var fixedBoundingRect = style.width != null && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
            var calculatedLineHeight = contentBlock.calculatedLineHeight;
            for(var i = 0; i < textLines.length; i++){
                var el = this._getOrCreateChild((0, (0, parcelRequire("45jlh")).default));
                var subElStyle = el.createStyle();
                el.useStyle(subElStyle);
                subElStyle.text = textLines[i];
                subElStyle.x = textX;
                subElStyle.y = textY;
                if (textAlign) subElStyle.textAlign = textAlign;
                subElStyle.textBaseline = 'middle';
                subElStyle.opacity = style.opacity;
                subElStyle.strokeFirst = true;
                if (hasShadow) {
                    subElStyle.shadowBlur = style.textShadowBlur || 0;
                    subElStyle.shadowColor = style.textShadowColor || 'transparent';
                    subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                    subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
                }
                if (textStroke) {
                    subElStyle.stroke = textStroke;
                    subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                    subElStyle.lineDash = style.lineDash;
                    subElStyle.lineDashOffset = style.lineDashOffset || 0;
                }
                if (textFill) subElStyle.fill = textFill;
                subElStyle.font = textFont;
                textY += lineHeight;
                if (fixedBoundingRect) el.setBoundingRect(new (0, (0, parcelRequire("1E3E8")).default)((0, (0, parcelRequire("b7ZX8")).adjustTextX)(subElStyle.x, style.width, subElStyle.textAlign), (0, (0, parcelRequire("b7ZX8")).adjustTextY)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), style.width, calculatedLineHeight));
            }
        };
        ZRText.prototype._updateRichTexts = function() {
            var style = this.style;
            var text = $31b833f429060f54$var$getStyleText(style);
            var contentBlock = (0, (0, parcelRequire("h6fMM")).parseRichText)(text, style);
            var contentWidth = contentBlock.width;
            var outerWidth = contentBlock.outerWidth;
            var outerHeight = contentBlock.outerHeight;
            var textPadding = style.padding;
            var baseX = style.x || 0;
            var baseY = style.y || 0;
            var defaultStyle = this._defaultStyle;
            var textAlign = style.align || defaultStyle.align;
            var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
            var boxX = (0, (0, parcelRequire("b7ZX8")).adjustTextX)(baseX, outerWidth, textAlign);
            var boxY = (0, (0, parcelRequire("b7ZX8")).adjustTextY)(baseY, outerHeight, verticalAlign);
            var xLeft = boxX;
            var lineTop = boxY;
            if (textPadding) {
                xLeft += textPadding[3];
                lineTop += textPadding[0];
            }
            var xRight = xLeft + contentWidth;
            if ($31b833f429060f54$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
            var bgColorDrawn = !!style.backgroundColor;
            for(var i = 0; i < contentBlock.lines.length; i++){
                var line = contentBlock.lines[i];
                var tokens = line.tokens;
                var tokenCount = tokens.length;
                var lineHeight = line.lineHeight;
                var remainedWidth = line.width;
                var leftIndex = 0;
                var lineXLeft = xLeft;
                var lineXRight = xRight;
                var rightIndex = tokenCount - 1;
                var token = void 0;
                while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                    this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                    remainedWidth -= token.width;
                    lineXLeft += token.width;
                    leftIndex++;
                }
                while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                    this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                    remainedWidth -= token.width;
                    lineXRight -= token.width;
                    rightIndex--;
                }
                lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
                while(leftIndex <= rightIndex){
                    token = tokens[leftIndex];
                    this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                    lineXLeft += token.width;
                    leftIndex++;
                }
                lineTop += lineHeight;
            }
        };
        ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
            var tokenStyle = style.rich[token.styleName] || {};
            tokenStyle.text = token.text;
            var verticalAlign = token.verticalAlign;
            var y = lineTop + lineHeight / 2;
            if (verticalAlign === 'top') y = lineTop + token.height / 2;
            else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
            var needDrawBg = !token.isLineHolder && $31b833f429060f54$var$needDrawBackground(tokenStyle);
            needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
            var bgColorDrawn = !!tokenStyle.backgroundColor;
            var textPadding = token.textPadding;
            if (textPadding) {
                x = $31b833f429060f54$var$getTextXForPadding(x, textAlign, textPadding);
                y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
            }
            var el = this._getOrCreateChild((0, (0, parcelRequire("45jlh")).default));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            var defaultStyle = this._defaultStyle;
            var useDefaultFill = false;
            var defaultLineWidth = 0;
            var textFill = $31b833f429060f54$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
            var textStroke = $31b833f429060f54$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
            var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
            subElStyle.text = token.text;
            subElStyle.x = x;
            subElStyle.y = y;
            if (hasShadow) {
                subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
                subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
            }
            subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.font = token.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            subElStyle.opacity = (0, (0, parcelRequire("bahqM")).retrieve3)(tokenStyle.opacity, style.opacity, 1);
            if (textStroke) {
                subElStyle.lineWidth = (0, (0, parcelRequire("bahqM")).retrieve3)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
                subElStyle.lineDash = (0, (0, parcelRequire("bahqM")).retrieve2)(tokenStyle.lineDash, style.lineDash);
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
                subElStyle.stroke = textStroke;
            }
            if (textFill) subElStyle.fill = textFill;
            var textWidth = token.contentWidth;
            var textHeight = token.contentHeight;
            el.setBoundingRect(new (0, (0, parcelRequire("1E3E8")).default)((0, (0, parcelRequire("b7ZX8")).adjustTextX)(subElStyle.x, textWidth, subElStyle.textAlign), (0, (0, parcelRequire("b7ZX8")).adjustTextY)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
        };
        ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
            var textBackgroundColor = style.backgroundColor;
            var textBorderWidth = style.borderWidth;
            var textBorderColor = style.borderColor;
            var isImageBg = textBackgroundColor && textBackgroundColor.image;
            var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
            var textBorderRadius = style.borderRadius;
            var self = this;
            var rectEl;
            var imgEl;
            if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
                rectEl = this._getOrCreateChild((0, (0, parcelRequire("7Tw7u")).default));
                rectEl.useStyle(rectEl.createStyle());
                rectEl.style.fill = null;
                var rectShape = rectEl.shape;
                rectShape.x = x;
                rectShape.y = y;
                rectShape.width = width;
                rectShape.height = height;
                rectShape.r = textBorderRadius;
                rectEl.dirtyShape();
            }
            if (isPlainOrGradientBg) {
                var rectStyle = rectEl.style;
                rectStyle.fill = textBackgroundColor || null;
                rectStyle.fillOpacity = (0, (0, parcelRequire("bahqM")).retrieve2)(style.fillOpacity, 1);
            } else if (isImageBg) {
                imgEl = this._getOrCreateChild((0, (0, parcelRequire("gcbBH")).default));
                imgEl.onload = function() {
                    self.dirtyStyle();
                };
                var imgStyle = imgEl.style;
                imgStyle.image = textBackgroundColor.image;
                imgStyle.x = x;
                imgStyle.y = y;
                imgStyle.width = width;
                imgStyle.height = height;
            }
            if (textBorderWidth && textBorderColor) {
                var rectStyle = rectEl.style;
                rectStyle.lineWidth = textBorderWidth;
                rectStyle.stroke = textBorderColor;
                rectStyle.strokeOpacity = (0, (0, parcelRequire("bahqM")).retrieve2)(style.strokeOpacity, 1);
                rectStyle.lineDash = style.borderDash;
                rectStyle.lineDashOffset = style.borderDashOffset || 0;
                rectEl.strokeContainThreshold = 0;
                if (rectEl.hasFill() && rectEl.hasStroke()) {
                    rectStyle.strokeFirst = true;
                    rectStyle.lineWidth *= 2;
                }
            }
            var commonStyle = (rectEl || imgEl).style;
            commonStyle.shadowBlur = style.shadowBlur || 0;
            commonStyle.shadowColor = style.shadowColor || 'transparent';
            commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
            commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
            commonStyle.opacity = (0, (0, parcelRequire("bahqM")).retrieve3)(style.opacity, topStyle.opacity, 1);
        };
        ZRText.makeFont = function(style) {
            var font = '';
            if (style.fontSize || style.fontFamily || style.fontWeight) {
                var fontSize = '';
                if (typeof style.fontSize === 'string' && (style.fontSize.indexOf('px') !== -1 || style.fontSize.indexOf('rem') !== -1 || style.fontSize.indexOf('em') !== -1)) fontSize = style.fontSize;
                else if (!isNaN(+style.fontSize)) fontSize = style.fontSize + 'px';
                else fontSize = '12px';
                font = [
                    style.fontStyle,
                    style.fontWeight,
                    fontSize,
                    style.fontFamily || 'sans-serif'
                ].join(' ');
            }
            return font && (0, (0, parcelRequire("bahqM")).trim)(font) || style.textFont || style.font;
        };
        return ZRText;
    }((0, (0, parcelRequire("lBQ88")).default));
    var $31b833f429060f54$var$VALID_TEXT_ALIGN = {
        left: true,
        right: 1,
        center: 1
    };
    var $31b833f429060f54$var$VALID_TEXT_VERTICAL_ALIGN = {
        top: 1,
        bottom: 1,
        middle: 1
    };
    function $31b833f429060f54$export$176336068cc5371f(style) {
        $31b833f429060f54$var$normalizeStyle(style);
        (0, (0, parcelRequire("bahqM")).each)(style.rich, $31b833f429060f54$var$normalizeStyle);
        return style;
    }
    function $31b833f429060f54$var$normalizeStyle(style) {
        if (style) {
            style.font = $31b833f429060f54$var$ZRText.makeFont(style);
            var textAlign = style.align;
            textAlign === 'middle' && (textAlign = 'center');
            style.align = textAlign == null || $31b833f429060f54$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
            var verticalAlign = style.verticalAlign;
            verticalAlign === 'center' && (verticalAlign = 'middle');
            style.verticalAlign = verticalAlign == null || $31b833f429060f54$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
            var textPadding = style.padding;
            if (textPadding) style.padding = (0, (0, parcelRequire("bahqM")).normalizeCssArray)(style.padding);
        }
    }
    function $31b833f429060f54$var$getStroke(stroke, lineWidth) {
        return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
    }
    function $31b833f429060f54$var$getFill(fill) {
        return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
    }
    function $31b833f429060f54$var$getTextXForPadding(x, textAlign, textPadding) {
        return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
    }
    function $31b833f429060f54$var$getStyleText(style) {
        var text = style.text;
        text != null && (text += '');
        return text;
    }
    function $31b833f429060f54$var$needDrawBackground(style) {
        return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
    }
    var $31b833f429060f54$export$2e2bcd8739ae039 = $31b833f429060f54$var$ZRText;
});
parcelRegister("h6fMM", function(module, exports) {
    $parcel$export(module.exports, "truncateText", ()=>$c72f3dec0993863b$export$59a943b34a82e690);
    $parcel$export(module.exports, "parsePlainText", ()=>$c72f3dec0993863b$export$5772575e34ef80f9);
    $parcel$export(module.exports, "parseRichText", ()=>$c72f3dec0993863b$export$15ec9472ff2d721);
    var $63nvx;
    var $bahqM;
    var $b7ZX8;
    var $c72f3dec0993863b$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
    function $c72f3dec0993863b$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
        if (!containerWidth) return '';
        var textLines = (text + '').split('\n');
        options = $c72f3dec0993863b$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
        for(var i = 0, len = textLines.length; i < len; i++)textLines[i] = $c72f3dec0993863b$var$truncateSingleLine(textLines[i], options);
        return textLines.join('\n');
    }
    function $c72f3dec0993863b$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
        options = options || {};
        var preparedOpts = (0, (0, parcelRequire("bahqM")).extend)({}, options);
        preparedOpts.font = font;
        ellipsis = (0, (0, parcelRequire("bahqM")).retrieve2)(ellipsis, '...');
        preparedOpts.maxIterations = (0, (0, parcelRequire("bahqM")).retrieve2)(options.maxIterations, 2);
        var minChar = preparedOpts.minChar = (0, (0, parcelRequire("bahqM")).retrieve2)(options.minChar, 0);
        preparedOpts.cnCharWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)("\u56FD", font);
        var ascCharWidth = preparedOpts.ascCharWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)('a', font);
        preparedOpts.placeholder = (0, (0, parcelRequire("bahqM")).retrieve2)(options.placeholder, '');
        var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
        for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
        var ellipsisWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(ellipsis, font);
        if (ellipsisWidth > contentWidth) {
            ellipsis = '';
            ellipsisWidth = 0;
        }
        contentWidth = containerWidth - ellipsisWidth;
        preparedOpts.ellipsis = ellipsis;
        preparedOpts.ellipsisWidth = ellipsisWidth;
        preparedOpts.contentWidth = contentWidth;
        preparedOpts.containerWidth = containerWidth;
        return preparedOpts;
    }
    function $c72f3dec0993863b$var$truncateSingleLine(textLine, options) {
        var containerWidth = options.containerWidth;
        var font = options.font;
        var contentWidth = options.contentWidth;
        if (!containerWidth) return '';
        var lineWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(textLine, font);
        if (lineWidth <= containerWidth) return textLine;
        for(var j = 0;; j++){
            if (lineWidth <= contentWidth || j >= options.maxIterations) {
                textLine += options.ellipsis;
                break;
            }
            var subLength = j === 0 ? $c72f3dec0993863b$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
            textLine = textLine.substr(0, subLength);
            lineWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(textLine, font);
        }
        if (textLine === '') textLine = options.placeholder;
        return textLine;
    }
    function $c72f3dec0993863b$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
        var width = 0;
        var i = 0;
        for(var len = text.length; i < len && width < contentWidth; i++){
            var charCode = text.charCodeAt(i);
            width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
        }
        return i;
    }
    function $c72f3dec0993863b$export$5772575e34ef80f9(text, style) {
        text != null && (text += '');
        var overflow = style.overflow;
        var padding = style.padding;
        var font = style.font;
        var truncate = overflow === 'truncate';
        var calculatedLineHeight = (0, (0, parcelRequire("b7ZX8")).getLineHeight)(font);
        var lineHeight = (0, (0, parcelRequire("bahqM")).retrieve2)(style.lineHeight, calculatedLineHeight);
        var truncateLineOverflow = style.lineOverflow === 'truncate';
        var width = style.width;
        var lines;
        if (width != null && overflow === 'break' || overflow === 'breakAll') lines = text ? $c72f3dec0993863b$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
        else lines = text ? text.split('\n') : [];
        var contentHeight = lines.length * lineHeight;
        var height = (0, (0, parcelRequire("bahqM")).retrieve2)(style.height, contentHeight);
        if (contentHeight > height && truncateLineOverflow) {
            var lineCount = Math.floor(height / lineHeight);
            lines = lines.slice(0, lineCount);
        }
        var outerHeight = height;
        var outerWidth = width;
        if (padding) {
            outerHeight += padding[0] + padding[2];
            if (outerWidth != null) outerWidth += padding[1] + padding[3];
        }
        if (text && truncate && outerWidth != null) {
            var options = $c72f3dec0993863b$var$prepareTruncateOptions(width, font, style.ellipsis, {
                minChar: style.truncateMinChar,
                placeholder: style.placeholder
            });
            for(var i = 0; i < lines.length; i++)lines[i] = $c72f3dec0993863b$var$truncateSingleLine(lines[i], options);
        }
        if (width == null) {
            var maxWidth = 0;
            for(var i = 0; i < lines.length; i++)maxWidth = Math.max((0, (0, parcelRequire("b7ZX8")).getWidth)(lines[i], font), maxWidth);
            width = maxWidth;
        }
        return {
            lines: lines,
            height: height,
            outerHeight: outerHeight,
            lineHeight: lineHeight,
            calculatedLineHeight: calculatedLineHeight,
            contentHeight: contentHeight,
            width: width
        };
    }
    var $c72f3dec0993863b$var$RichTextToken = function() {
        function RichTextToken() {}
        return RichTextToken;
    }();
    var $c72f3dec0993863b$var$RichTextLine = function() {
        function RichTextLine(tokens) {
            this.tokens = [];
            if (tokens) this.tokens = tokens;
        }
        return RichTextLine;
    }();
    var $c72f3dec0993863b$export$ca607d3c98caaf7e = function() {
        function RichTextContentBlock() {
            this.width = 0;
            this.height = 0;
            this.contentWidth = 0;
            this.contentHeight = 0;
            this.outerWidth = 0;
            this.outerHeight = 0;
            this.lines = [];
        }
        return RichTextContentBlock;
    }();
    function $c72f3dec0993863b$export$15ec9472ff2d721(text, style) {
        var contentBlock = new $c72f3dec0993863b$export$ca607d3c98caaf7e();
        text != null && (text += '');
        if (!text) return contentBlock;
        var topWidth = style.width;
        var topHeight = style.height;
        var overflow = style.overflow;
        var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
            width: topWidth,
            accumWidth: 0,
            breakAll: overflow === 'breakAll'
        } : null;
        var lastIndex = $c72f3dec0993863b$var$STYLE_REG.lastIndex = 0;
        var result;
        while((result = $c72f3dec0993863b$var$STYLE_REG.exec(text)) != null){
            var matchedIndex = result.index;
            if (matchedIndex > lastIndex) $c72f3dec0993863b$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
            $c72f3dec0993863b$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
            lastIndex = $c72f3dec0993863b$var$STYLE_REG.lastIndex;
        }
        if (lastIndex < text.length) $c72f3dec0993863b$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
        var pendingList = [];
        var calculatedHeight = 0;
        var calculatedWidth = 0;
        var stlPadding = style.padding;
        var truncate = overflow === 'truncate';
        var truncateLine = style.lineOverflow === 'truncate';
        function finishLine(line, lineWidth, lineHeight) {
            line.width = lineWidth;
            line.lineHeight = lineHeight;
            calculatedHeight += lineHeight;
            calculatedWidth = Math.max(calculatedWidth, lineWidth);
        }
        outer: for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var lineHeight = 0;
            var lineWidth = 0;
            for(var j = 0; j < line.tokens.length; j++){
                var token = line.tokens[j];
                var tokenStyle = token.styleName && style.rich[token.styleName] || {};
                var textPadding = token.textPadding = tokenStyle.padding;
                var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
                var font = token.font = tokenStyle.font || style.font;
                token.contentHeight = (0, (0, parcelRequire("b7ZX8")).getLineHeight)(font);
                var tokenHeight = (0, (0, parcelRequire("bahqM")).retrieve2)(tokenStyle.height, token.contentHeight);
                token.innerHeight = tokenHeight;
                textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
                token.height = tokenHeight;
                token.lineHeight = (0, (0, parcelRequire("bahqM")).retrieve3)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
                token.align = tokenStyle && tokenStyle.align || style.align;
                token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
                if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                    if (j > 0) {
                        line.tokens = line.tokens.slice(0, j);
                        finishLine(line, lineWidth, lineHeight);
                        contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                    } else contentBlock.lines = contentBlock.lines.slice(0, i);
                    break outer;
                }
                var styleTokenWidth = tokenStyle.width;
                var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
                if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                    token.percentWidth = styleTokenWidth;
                    pendingList.push(token);
                    token.contentWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(token.text, font);
                } else {
                    if (tokenWidthNotSpecified) {
                        var textBackgroundColor = tokenStyle.backgroundColor;
                        var bgImg = textBackgroundColor && textBackgroundColor.image;
                        if (bgImg) {
                            bgImg = (0, parcelRequire("63nvx")).findExistImage(bgImg);
                            if ((0, parcelRequire("63nvx")).isImageReady(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                        }
                    }
                    var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                    if (remainTruncWidth != null && remainTruncWidth < token.width) {
                        if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                            token.text = '';
                            token.width = token.contentWidth = 0;
                        } else {
                            token.text = $c72f3dec0993863b$export$59a943b34a82e690(token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                                minChar: style.truncateMinChar
                            });
                            token.width = token.contentWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(token.text, font);
                        }
                    } else token.contentWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(token.text, font);
                }
                token.width += paddingH;
                lineWidth += token.width;
                tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
            }
            finishLine(line, lineWidth, lineHeight);
        }
        contentBlock.outerWidth = contentBlock.width = (0, (0, parcelRequire("bahqM")).retrieve2)(topWidth, calculatedWidth);
        contentBlock.outerHeight = contentBlock.height = (0, (0, parcelRequire("bahqM")).retrieve2)(topHeight, calculatedHeight);
        contentBlock.contentHeight = calculatedHeight;
        contentBlock.contentWidth = calculatedWidth;
        if (stlPadding) {
            contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
            contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
        }
        for(var i = 0; i < pendingList.length; i++){
            var token = pendingList[i];
            var percentWidth = token.percentWidth;
            token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
        }
        return contentBlock;
    }
    function $c72f3dec0993863b$var$pushTokens(block, str, style, wrapInfo, styleName) {
        var isEmptyStr = str === '';
        var tokenStyle = styleName && style.rich[styleName] || {};
        var lines = block.lines;
        var font = tokenStyle.font || style.font;
        var newLine = false;
        var strLines;
        var linesWidths;
        if (wrapInfo) {
            var tokenPadding = tokenStyle.padding;
            var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
            if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
                var outerWidth_1 = (0, (0, parcelRequire("b7ZX8")).parsePercent)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
                if (lines.length > 0) {
                    if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                        strLines = str.split('\n');
                        newLine = true;
                    }
                }
                wrapInfo.accumWidth = outerWidth_1;
            } else {
                var res = $c72f3dec0993863b$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
                wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
                linesWidths = res.linesWidths;
                strLines = res.lines;
            }
        } else strLines = str.split('\n');
        for(var i = 0; i < strLines.length; i++){
            var text = strLines[i];
            var token = new $c72f3dec0993863b$var$RichTextToken();
            token.styleName = styleName;
            token.text = text;
            token.isLineHolder = !text && !isEmptyStr;
            if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
            else token.width = linesWidths ? linesWidths[i] : (0, (0, parcelRequire("b7ZX8")).getWidth)(text, font);
            if (!i && !newLine) {
                var tokens = (lines[lines.length - 1] || (lines[0] = new $c72f3dec0993863b$var$RichTextLine())).tokens;
                var tokensLen = tokens.length;
                tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
            } else lines.push(new $c72f3dec0993863b$var$RichTextLine([
                token
            ]));
        }
    }
    function $c72f3dec0993863b$var$isLatin(ch) {
        var code = ch.charCodeAt(0);
        return code >= 0x21 && code <= 0xFF;
    }
    var $c72f3dec0993863b$var$breakCharMap = (0, (0, parcelRequire("bahqM")).reduce)(',&?/;] '.split(''), function(obj, ch) {
        obj[ch] = true;
        return obj;
    }, {});
    function $c72f3dec0993863b$var$isWordBreakChar(ch) {
        if ($c72f3dec0993863b$var$isLatin(ch)) {
            if ($c72f3dec0993863b$var$breakCharMap[ch]) return true;
            return false;
        }
        return true;
    }
    function $c72f3dec0993863b$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
        var lines = [];
        var linesWidths = [];
        var line = '';
        var currentWord = '';
        var currentWordWidth = 0;
        var accumWidth = 0;
        for(var i = 0; i < text.length; i++){
            var ch = text.charAt(i);
            if (ch === '\n') {
                if (currentWord) {
                    line += currentWord;
                    accumWidth += currentWordWidth;
                }
                lines.push(line);
                linesWidths.push(accumWidth);
                line = '';
                currentWord = '';
                currentWordWidth = 0;
                accumWidth = 0;
                continue;
            }
            var chWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(ch, font);
            var inWord = isBreakAll ? false : !$c72f3dec0993863b$var$isWordBreakChar(ch);
            if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
                if (!accumWidth) {
                    if (inWord) {
                        lines.push(currentWord);
                        linesWidths.push(currentWordWidth);
                        currentWord = ch;
                        currentWordWidth = chWidth;
                    } else {
                        lines.push(ch);
                        linesWidths.push(chWidth);
                    }
                } else if (line || currentWord) {
                    if (inWord) {
                        if (!line) {
                            line = currentWord;
                            currentWord = '';
                            currentWordWidth = 0;
                            accumWidth = currentWordWidth;
                        }
                        lines.push(line);
                        linesWidths.push(accumWidth - currentWordWidth);
                        currentWord += ch;
                        currentWordWidth += chWidth;
                        line = '';
                        accumWidth = currentWordWidth;
                    } else {
                        if (currentWord) {
                            line += currentWord;
                            accumWidth += currentWordWidth;
                            currentWord = '';
                            currentWordWidth = 0;
                        }
                        lines.push(line);
                        linesWidths.push(accumWidth);
                        line = ch;
                        accumWidth = chWidth;
                    }
                }
                continue;
            }
            accumWidth += chWidth;
            if (inWord) {
                currentWord += ch;
                currentWordWidth += chWidth;
            } else {
                if (currentWord) {
                    line += currentWord;
                    currentWord = '';
                    currentWordWidth = 0;
                }
                line += ch;
            }
        }
        if (!lines.length && !line) {
            line = text;
            currentWord = '';
            currentWordWidth = 0;
        }
        if (currentWord) line += currentWord;
        if (line) {
            lines.push(line);
            linesWidths.push(accumWidth);
        }
        if (lines.length === 1) accumWidth += lastAccumWidth;
        return {
            accumWidth: accumWidth,
            lines: lines,
            linesWidths: linesWidths
        };
    }
});
parcelRegister("63nvx", function(module, exports) {
    $parcel$export(module.exports, "findExistImage", ()=>$468542031e7bbc2a$export$1b614f30ac2c8867);
    $parcel$export(module.exports, "createOrUpdateImage", ()=>$468542031e7bbc2a$export$46c791b69ff9a0f);
    $parcel$export(module.exports, "isImageReady", ()=>$468542031e7bbc2a$export$37ca7dd901d0236d);
    var $h4RuA;
    var $468542031e7bbc2a$var$globalImageCache = new (0, (0, parcelRequire("h4RuA")).default)(50);
    function $468542031e7bbc2a$export$1b614f30ac2c8867(newImageOrSrc) {
        if (typeof newImageOrSrc === 'string') {
            var cachedImgObj = $468542031e7bbc2a$var$globalImageCache.get(newImageOrSrc);
            return cachedImgObj && cachedImgObj.image;
        } else return newImageOrSrc;
    }
    function $468542031e7bbc2a$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
        if (!newImageOrSrc) return image;
        else if (typeof newImageOrSrc === 'string') {
            if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
            var cachedImgObj = $468542031e7bbc2a$var$globalImageCache.get(newImageOrSrc);
            var pendingWrap = {
                hostEl: hostEl,
                cb: onload,
                cbPayload: cbPayload
            };
            if (cachedImgObj) {
                image = cachedImgObj.image;
                !$468542031e7bbc2a$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
            } else {
                image = new Image();
                image.onload = image.onerror = $468542031e7bbc2a$var$imageOnLoad;
                $468542031e7bbc2a$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                    image: image,
                    pending: [
                        pendingWrap
                    ]
                });
                image.src = image.__zrImageSrc = newImageOrSrc;
            }
            return image;
        } else return newImageOrSrc;
    }
    function $468542031e7bbc2a$var$imageOnLoad() {
        var cachedImgObj = this.__cachedImgObj;
        this.onload = this.onerror = this.__cachedImgObj = null;
        for(var i = 0; i < cachedImgObj.pending.length; i++){
            var pendingWrap = cachedImgObj.pending[i];
            var cb = pendingWrap.cb;
            cb && cb(this, pendingWrap.cbPayload);
            pendingWrap.hostEl.dirty();
        }
        cachedImgObj.pending.length = 0;
    }
    function $468542031e7bbc2a$export$37ca7dd901d0236d(image) {
        return image && image.width && image.height;
    }
});
parcelRegister("45jlh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f96a200e6d0cf38$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $b7ZX8;
    var $ghQ8v;
    var $bahqM;
    var $2f96a200e6d0cf38$export$5fbb6d98091bcb56 = (0, (0, parcelRequire("bahqM")).defaults)({
        strokeFirst: true,
        font: (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT),
        x: 0,
        y: 0,
        textAlign: 'left',
        textBaseline: 'top',
        miterLimit: 2
    }, (0, (0, parcelRequire("ghQ8v")).DEFAULT_PATH_STYLE));
    var $2f96a200e6d0cf38$var$TSpan = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(TSpan, _super);
        function TSpan() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        TSpan.prototype.hasStroke = function() {
            var style = this.style;
            var stroke = style.stroke;
            return stroke != null && stroke !== 'none' && style.lineWidth > 0;
        };
        TSpan.prototype.hasFill = function() {
            var style = this.style;
            var fill = style.fill;
            return fill != null && fill !== 'none';
        };
        TSpan.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($2f96a200e6d0cf38$export$5fbb6d98091bcb56, obj);
        };
        TSpan.prototype.setBoundingRect = function(rect) {
            this._rect = rect;
        };
        TSpan.prototype.getBoundingRect = function() {
            var style = this.style;
            if (!this._rect) {
                var text = style.text;
                text != null ? text += '' : text = '';
                var rect = (0, (0, parcelRequire("b7ZX8")).getBoundingRect)(text, style.font, style.textAlign, style.textBaseline);
                rect.x += style.x || 0;
                rect.y += style.y || 0;
                if (this.hasStroke()) {
                    var w = style.lineWidth;
                    rect.x -= w / 2;
                    rect.y -= w / 2;
                    rect.width += w;
                    rect.height += w;
                }
                this._rect = rect;
            }
            return this._rect;
        };
        TSpan.initDefaultProps = function() {
            var tspanProto = TSpan.prototype;
            tspanProto.dirtyRectTolerance = 10;
        }();
        return TSpan;
    }((0, (0, parcelRequire("lBQ88")).default));
    $2f96a200e6d0cf38$var$TSpan.prototype.type = 'tspan';
    var $2f96a200e6d0cf38$export$2e2bcd8739ae039 = $2f96a200e6d0cf38$var$TSpan;
});
parcelRegister("7Tw7u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5bf695c646bd738a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $7AySl;
    var $2az2p;
    var $5bf695c646bd738a$export$51140d6b71bb4ed5 = function() {
        function RectShape() {
            this.x = 0;
            this.y = 0;
            this.width = 0;
            this.height = 0;
        }
        return RectShape;
    }();
    var $5bf695c646bd738a$var$subPixelOptimizeOutputShape = {};
    var $5bf695c646bd738a$var$Rect = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Rect, _super);
        function Rect(opts) {
            return _super.call(this, opts) || this;
        }
        Rect.prototype.getDefaultShape = function() {
            return new $5bf695c646bd738a$export$51140d6b71bb4ed5();
        };
        Rect.prototype.buildPath = function(ctx, shape) {
            var x;
            var y;
            var width;
            var height;
            if (this.subPixelOptimize) {
                var optimizedShape = (0, (0, parcelRequire("2az2p")).subPixelOptimizeRect)($5bf695c646bd738a$var$subPixelOptimizeOutputShape, shape, this.style);
                x = optimizedShape.x;
                y = optimizedShape.y;
                width = optimizedShape.width;
                height = optimizedShape.height;
                optimizedShape.r = shape.r;
                shape = optimizedShape;
            } else {
                x = shape.x;
                y = shape.y;
                width = shape.width;
                height = shape.height;
            }
            if (!shape.r) ctx.rect(x, y, width, height);
            else (0, parcelRequire("7AySl")).buildPath(ctx, shape);
        };
        Rect.prototype.isZeroArea = function() {
            return !this.shape.width || !this.shape.height;
        };
        return Rect;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $5bf695c646bd738a$var$Rect.prototype.type = 'rect';
    var $5bf695c646bd738a$export$2e2bcd8739ae039 = $5bf695c646bd738a$var$Rect;
});
parcelRegister("7AySl", function(module, exports) {
    $parcel$export(module.exports, "buildPath", ()=>$5866f2ba314594b2$export$5cc7f731b5937e99);
    function $5866f2ba314594b2$export$5cc7f731b5937e99(ctx, shape) {
        var x = shape.x;
        var y = shape.y;
        var width = shape.width;
        var height = shape.height;
        var r = shape.r;
        var r1;
        var r2;
        var r3;
        var r4;
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
        else if (r instanceof Array) {
            if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
            else if (r.length === 2) {
                r1 = r3 = r[0];
                r2 = r4 = r[1];
            } else if (r.length === 3) {
                r1 = r[0];
                r2 = r4 = r[1];
                r3 = r[2];
            } else {
                r1 = r[0];
                r2 = r[1];
                r3 = r[2];
                r4 = r[3];
            }
        } else r1 = r2 = r3 = r4 = 0;
        var total;
        if (r1 + r2 > width) {
            total = r1 + r2;
            r1 *= width / total;
            r2 *= width / total;
        }
        if (r3 + r4 > width) {
            total = r3 + r4;
            r3 *= width / total;
            r4 *= width / total;
        }
        if (r2 + r3 > height) {
            total = r2 + r3;
            r2 *= height / total;
            r3 *= height / total;
        }
        if (r1 + r4 > height) {
            total = r1 + r4;
            r1 *= height / total;
            r4 *= height / total;
        }
        ctx.moveTo(x + r1, y);
        ctx.lineTo(x + width - r2, y);
        r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
        ctx.lineTo(x + width, y + height - r3);
        r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
        ctx.lineTo(x + r4, y + height);
        r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
        ctx.lineTo(x, y + r1);
        r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
    }
});
parcelRegister("2az2p", function(module, exports) {
    $parcel$export(module.exports, "subPixelOptimizeLine", ()=>$1947b1c1b6b500f1$export$8b4b620d7f4aad1b);
    $parcel$export(module.exports, "subPixelOptimize", ()=>$1947b1c1b6b500f1$export$72c4fd4c1b8fcb10);
    $parcel$export(module.exports, "subPixelOptimizeRect", ()=>$1947b1c1b6b500f1$export$60e2aa74957d0b9d);
    var $1947b1c1b6b500f1$var$round = Math.round;
    function $1947b1c1b6b500f1$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
        if (!inputShape) return;
        var x1 = inputShape.x1;
        var x2 = inputShape.x2;
        var y1 = inputShape.y1;
        var y2 = inputShape.y2;
        outputShape.x1 = x1;
        outputShape.x2 = x2;
        outputShape.y1 = y1;
        outputShape.y2 = y2;
        var lineWidth = style && style.lineWidth;
        if (!lineWidth) return outputShape;
        if ($1947b1c1b6b500f1$var$round(x1 * 2) === $1947b1c1b6b500f1$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
        if ($1947b1c1b6b500f1$var$round(y1 * 2) === $1947b1c1b6b500f1$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
        return outputShape;
    }
    function $1947b1c1b6b500f1$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
        if (!inputShape) return;
        var originX = inputShape.x;
        var originY = inputShape.y;
        var originWidth = inputShape.width;
        var originHeight = inputShape.height;
        outputShape.x = originX;
        outputShape.y = originY;
        outputShape.width = originWidth;
        outputShape.height = originHeight;
        var lineWidth = style && style.lineWidth;
        if (!lineWidth) return outputShape;
        outputShape.x = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
        outputShape.y = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
        outputShape.width = Math.max($1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
        outputShape.height = Math.max($1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
        return outputShape;
    }
    function $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
        if (!lineWidth) return position;
        var doubledPosition = $1947b1c1b6b500f1$var$round(position * 2);
        return (doubledPosition + $1947b1c1b6b500f1$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
    }
});
parcelRegister("jjfok", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0ebbb12e4687e45$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $e0ebbb12e4687e45$export$2c0b65c9c7b57845 = function() {
        function CircleShape() {
            this.cx = 0;
            this.cy = 0;
            this.r = 0;
        }
        return CircleShape;
    }();
    var $e0ebbb12e4687e45$var$Circle = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Circle, _super);
        function Circle(opts) {
            return _super.call(this, opts) || this;
        }
        Circle.prototype.getDefaultShape = function() {
            return new $e0ebbb12e4687e45$export$2c0b65c9c7b57845();
        };
        Circle.prototype.buildPath = function(ctx, shape, inBundle) {
            if (inBundle) ctx.moveTo(shape.cx + shape.r, shape.cy);
            ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
        };
        return Circle;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $e0ebbb12e4687e45$var$Circle.prototype.type = 'circle';
    var $e0ebbb12e4687e45$export$2e2bcd8739ae039 = $e0ebbb12e4687e45$var$Circle;
});
parcelRegister("kVeV8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3b4b46f050115c8$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $f3b4b46f050115c8$export$817919dfe2806d31 = function() {
        function EllipseShape() {
            this.cx = 0;
            this.cy = 0;
            this.rx = 0;
            this.ry = 0;
        }
        return EllipseShape;
    }();
    var $f3b4b46f050115c8$var$Ellipse = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Ellipse, _super);
        function Ellipse(opts) {
            return _super.call(this, opts) || this;
        }
        Ellipse.prototype.getDefaultShape = function() {
            return new $f3b4b46f050115c8$export$817919dfe2806d31();
        };
        Ellipse.prototype.buildPath = function(ctx, shape) {
            var k = 0.5522848;
            var x = shape.cx;
            var y = shape.cy;
            var a = shape.rx;
            var b = shape.ry;
            var ox = a * k;
            var oy = b * k;
            ctx.moveTo(x - a, y);
            ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
            ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
            ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
            ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
            ctx.closePath();
        };
        return Ellipse;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $f3b4b46f050115c8$var$Ellipse.prototype.type = 'ellipse';
    var $f3b4b46f050115c8$export$2e2bcd8739ae039 = $f3b4b46f050115c8$var$Ellipse;
});
parcelRegister("elGBV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a724147a13426864$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $3kXtf;
    var $a724147a13426864$export$98af62de8a972c99 = function() {
        function SectorShape() {
            this.cx = 0;
            this.cy = 0;
            this.r0 = 0;
            this.r = 0;
            this.startAngle = 0;
            this.endAngle = Math.PI * 2;
            this.clockwise = true;
            this.cornerRadius = 0;
            this.innerCornerRadius = 0;
        }
        return SectorShape;
    }();
    var $a724147a13426864$var$Sector = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Sector, _super);
        function Sector(opts) {
            return _super.call(this, opts) || this;
        }
        Sector.prototype.getDefaultShape = function() {
            return new $a724147a13426864$export$98af62de8a972c99();
        };
        Sector.prototype.buildPath = function(ctx, shape) {
            (0, parcelRequire("3kXtf")).buildPath(ctx, shape);
        };
        Sector.prototype.isZeroArea = function() {
            return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
        };
        return Sector;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $a724147a13426864$var$Sector.prototype.type = 'sector';
    var $a724147a13426864$export$2e2bcd8739ae039 = $a724147a13426864$var$Sector;
});
parcelRegister("3kXtf", function(module, exports) {
    $parcel$export(module.exports, "buildPath", ()=>$26e15f024d5166f6$export$5cc7f731b5937e99);
    var $aA4Ws;
    var $26e15f024d5166f6$var$PI = Math.PI;
    var $26e15f024d5166f6$var$PI2 = $26e15f024d5166f6$var$PI * 2;
    var $26e15f024d5166f6$var$mathSin = Math.sin;
    var $26e15f024d5166f6$var$mathCos = Math.cos;
    var $26e15f024d5166f6$var$mathACos = Math.acos;
    var $26e15f024d5166f6$var$mathATan2 = Math.atan2;
    var $26e15f024d5166f6$var$mathAbs = Math.abs;
    var $26e15f024d5166f6$var$mathSqrt = Math.sqrt;
    var $26e15f024d5166f6$var$mathMax = Math.max;
    var $26e15f024d5166f6$var$mathMin = Math.min;
    var $26e15f024d5166f6$var$e = 1e-4;
    function $26e15f024d5166f6$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
        var x10 = x1 - x0;
        var y10 = y1 - y0;
        var x32 = x3 - x2;
        var y32 = y3 - y2;
        var t = y32 * x10 - x32 * y10;
        if (t * t < $26e15f024d5166f6$var$e) return;
        t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
        return [
            x0 + t * x10,
            y0 + t * y10
        ];
    }
    function $26e15f024d5166f6$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
        var x01 = x0 - x1;
        var y01 = y0 - y1;
        var lo = (clockwise ? cr : -cr) / $26e15f024d5166f6$var$mathSqrt(x01 * x01 + y01 * y01);
        var ox = lo * y01;
        var oy = -lo * x01;
        var x11 = x0 + ox;
        var y11 = y0 + oy;
        var x10 = x1 + ox;
        var y10 = y1 + oy;
        var x00 = (x11 + x10) / 2;
        var y00 = (y11 + y10) / 2;
        var dx = x10 - x11;
        var dy = y10 - y11;
        var d2 = dx * dx + dy * dy;
        var r = radius - cr;
        var s = x11 * y10 - x10 * y11;
        var d = (dy < 0 ? -1 : 1) * $26e15f024d5166f6$var$mathSqrt($26e15f024d5166f6$var$mathMax(0, r * r * d2 - s * s));
        var cx0 = (s * dy - dx * d) / d2;
        var cy0 = (-s * dx - dy * d) / d2;
        var cx1 = (s * dy + dx * d) / d2;
        var cy1 = (-s * dx + dy * d) / d2;
        var dx0 = cx0 - x00;
        var dy0 = cy0 - y00;
        var dx1 = cx1 - x00;
        var dy1 = cy1 - y00;
        if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
            cx0 = cx1;
            cy0 = cy1;
        }
        return {
            cx: cx0,
            cy: cy0,
            x01: -ox,
            y01: -oy,
            x11: cx0 * (radius / r - 1),
            y11: cy0 * (radius / r - 1)
        };
    }
    function $26e15f024d5166f6$export$5cc7f731b5937e99(ctx, shape) {
        var radius = $26e15f024d5166f6$var$mathMax(shape.r, 0);
        var innerRadius = $26e15f024d5166f6$var$mathMax(shape.r0 || 0, 0);
        var hasRadius = radius > 0;
        var hasInnerRadius = innerRadius > 0;
        if (!hasRadius && !hasInnerRadius) return;
        if (!hasRadius) {
            radius = innerRadius;
            innerRadius = 0;
        }
        if (innerRadius > radius) {
            var tmp = radius;
            radius = innerRadius;
            innerRadius = tmp;
        }
        var clockwise = !!shape.clockwise;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var arc;
        if (startAngle === endAngle) arc = 0;
        else {
            var tmpAngles = [
                startAngle,
                endAngle
            ];
            (0, (0, parcelRequire("aA4Ws")).normalizeArcAngles)(tmpAngles, !clockwise);
            arc = $26e15f024d5166f6$var$mathAbs(tmpAngles[0] - tmpAngles[1]);
        }
        var x = shape.cx;
        var y = shape.cy;
        var cornerRadius = shape.cornerRadius || 0;
        var innerCornerRadius = shape.innerCornerRadius || 0;
        if (!(radius > $26e15f024d5166f6$var$e)) ctx.moveTo(x, y);
        else if (arc > $26e15f024d5166f6$var$PI2 - $26e15f024d5166f6$var$e) {
            ctx.moveTo(x + radius * $26e15f024d5166f6$var$mathCos(startAngle), y + radius * $26e15f024d5166f6$var$mathSin(startAngle));
            ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
            if (innerRadius > $26e15f024d5166f6$var$e) {
                ctx.moveTo(x + innerRadius * $26e15f024d5166f6$var$mathCos(endAngle), y + innerRadius * $26e15f024d5166f6$var$mathSin(endAngle));
                ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
            }
        } else {
            var halfRd = $26e15f024d5166f6$var$mathAbs(radius - innerRadius) / 2;
            var cr = $26e15f024d5166f6$var$mathMin(halfRd, cornerRadius);
            var icr = $26e15f024d5166f6$var$mathMin(halfRd, innerCornerRadius);
            var cr0 = icr;
            var cr1 = cr;
            var xrs = radius * $26e15f024d5166f6$var$mathCos(startAngle);
            var yrs = radius * $26e15f024d5166f6$var$mathSin(startAngle);
            var xire = innerRadius * $26e15f024d5166f6$var$mathCos(endAngle);
            var yire = innerRadius * $26e15f024d5166f6$var$mathSin(endAngle);
            var xre = void 0;
            var yre = void 0;
            var xirs = void 0;
            var yirs = void 0;
            if (cr > $26e15f024d5166f6$var$e || icr > $26e15f024d5166f6$var$e) {
                xre = radius * $26e15f024d5166f6$var$mathCos(endAngle);
                yre = radius * $26e15f024d5166f6$var$mathSin(endAngle);
                xirs = innerRadius * $26e15f024d5166f6$var$mathCos(startAngle);
                yirs = innerRadius * $26e15f024d5166f6$var$mathSin(startAngle);
                if (arc < $26e15f024d5166f6$var$PI) {
                    var it_1 = $26e15f024d5166f6$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $26e15f024d5166f6$var$mathSin($26e15f024d5166f6$var$mathACos((x0 * x1 + y0 * y1) / ($26e15f024d5166f6$var$mathSqrt(x0 * x0 + y0 * y0) * $26e15f024d5166f6$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $26e15f024d5166f6$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        cr0 = $26e15f024d5166f6$var$mathMin(icr, (innerRadius - b) / (a - 1));
                        cr1 = $26e15f024d5166f6$var$mathMin(cr, (radius - b) / (a + 1));
                    }
                }
            }
            if (!(arc > $26e15f024d5166f6$var$e)) ctx.moveTo(x + xrs, y + yrs);
            else if (cr1 > $26e15f024d5166f6$var$e) {
                var ct0 = $26e15f024d5166f6$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, cr1, clockwise);
                var ct1 = $26e15f024d5166f6$var$computeCornerTangents(xre, yre, xire, yire, radius, cr1, clockwise);
                ctx.moveTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
                if (cr1 < cr) ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                else {
                    ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                    ctx.arc(x, y, radius, $26e15f024d5166f6$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $26e15f024d5166f6$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), !clockwise);
                    ctx.arc(x + ct1.cx, y + ct1.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct1.y11, ct1.x11), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                }
            } else {
                ctx.moveTo(x + xrs, y + yrs);
                ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
            }
            if (!(innerRadius > $26e15f024d5166f6$var$e) || !(arc > $26e15f024d5166f6$var$e)) ctx.lineTo(x + xire, y + yire);
            else if (cr0 > $26e15f024d5166f6$var$e) {
                var ct0 = $26e15f024d5166f6$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -cr0, clockwise);
                var ct1 = $26e15f024d5166f6$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -cr0, clockwise);
                ctx.lineTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
                if (cr0 < icr) ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                else {
                    ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                    ctx.arc(x, y, innerRadius, $26e15f024d5166f6$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $26e15f024d5166f6$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), clockwise);
                    ctx.arc(x + ct1.cx, y + ct1.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct1.y11, ct1.x11), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                }
            } else {
                ctx.lineTo(x + xire, y + yire);
                ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
            }
        }
        ctx.closePath();
    }
});
parcelRegister("LCHOw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08f26a0aa2f0a2fd$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $08f26a0aa2f0a2fd$export$4a506b3cd4ea73db = function() {
        function RingShape() {
            this.cx = 0;
            this.cy = 0;
            this.r = 0;
            this.r0 = 0;
        }
        return RingShape;
    }();
    var $08f26a0aa2f0a2fd$var$Ring = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Ring, _super);
        function Ring(opts) {
            return _super.call(this, opts) || this;
        }
        Ring.prototype.getDefaultShape = function() {
            return new $08f26a0aa2f0a2fd$export$4a506b3cd4ea73db();
        };
        Ring.prototype.buildPath = function(ctx, shape) {
            var x = shape.cx;
            var y = shape.cy;
            var PI2 = Math.PI * 2;
            ctx.moveTo(x + shape.r, y);
            ctx.arc(x, y, shape.r, 0, PI2, false);
            ctx.moveTo(x + shape.r0, y);
            ctx.arc(x, y, shape.r0, 0, PI2, true);
        };
        return Ring;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $08f26a0aa2f0a2fd$var$Ring.prototype.type = 'ring';
    var $08f26a0aa2f0a2fd$export$2e2bcd8739ae039 = $08f26a0aa2f0a2fd$var$Ring;
});
parcelRegister("lQwBc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe77bdccf816487a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $gLMXf;
    var $fe77bdccf816487a$export$a34d87b9aaeedd46 = function() {
        function PolygonShape() {
            this.points = null;
            this.smooth = 0;
            this.smoothConstraint = null;
        }
        return PolygonShape;
    }();
    var $fe77bdccf816487a$var$Polygon = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Polygon, _super);
        function Polygon(opts) {
            return _super.call(this, opts) || this;
        }
        Polygon.prototype.getDefaultShape = function() {
            return new $fe77bdccf816487a$export$a34d87b9aaeedd46();
        };
        Polygon.prototype.buildPath = function(ctx, shape) {
            (0, parcelRequire("gLMXf")).buildPath(ctx, shape, true);
        };
        return Polygon;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $fe77bdccf816487a$var$Polygon.prototype.type = 'polygon';
    var $fe77bdccf816487a$export$2e2bcd8739ae039 = $fe77bdccf816487a$var$Polygon;
});
parcelRegister("gLMXf", function(module, exports) {
    $parcel$export(module.exports, "buildPath", ()=>$c357027dbb0e6a00$export$5cc7f731b5937e99);
    var $bEkQR;
    var $4Fmqi;
    function $c357027dbb0e6a00$export$5cc7f731b5937e99(ctx, shape, closePath) {
        var smooth = shape.smooth;
        var points = shape.points;
        if (points && points.length >= 2) {
            if (smooth && smooth !== 'spline') {
                var controlPoints = (0, (0, parcelRequire("4Fmqi")).default)(points, smooth, closePath, shape.smoothConstraint);
                ctx.moveTo(points[0][0], points[0][1]);
                var len = points.length;
                for(var i = 0; i < (closePath ? len : len - 1); i++){
                    var cp1 = controlPoints[i * 2];
                    var cp2 = controlPoints[i * 2 + 1];
                    var p = points[(i + 1) % len];
                    ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
                }
            } else {
                if (smooth === 'spline') points = (0, (0, parcelRequire("bEkQR")).default)(points, closePath);
                ctx.moveTo(points[0][0], points[0][1]);
                for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
            }
            closePath && ctx.closePath();
        }
    }
});
parcelRegister("bEkQR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87b39ad613612da7$export$2e2bcd8739ae039);
    var $eLEew;
    function $87b39ad613612da7$var$interpolate(p0, p1, p2, p3, t, t2, t3) {
        var v0 = (p2 - p0) * 0.5;
        var v1 = (p3 - p1) * 0.5;
        return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
    }
    function $87b39ad613612da7$export$2e2bcd8739ae039(points, isLoop) {
        var len = points.length;
        var ret = [];
        var distance = 0;
        for(var i = 1; i < len; i++)distance += (0, (0, parcelRequire("eLEew")).distance)(points[i - 1], points[i]);
        var segs = distance / 2;
        segs = segs < len ? len : segs;
        for(var i = 0; i < segs; i++){
            var pos = i / (segs - 1) * (isLoop ? len : len - 1);
            var idx = Math.floor(pos);
            var w = pos - idx;
            var p0 = void 0;
            var p1 = points[idx % len];
            var p2 = void 0;
            var p3 = void 0;
            if (!isLoop) {
                p0 = points[idx === 0 ? idx : idx - 1];
                p2 = points[idx > len - 2 ? len - 1 : idx + 1];
                p3 = points[idx > len - 3 ? len - 1 : idx + 2];
            } else {
                p0 = points[(idx - 1 + len) % len];
                p2 = points[(idx + 1) % len];
                p3 = points[(idx + 2) % len];
            }
            var w2 = w * w;
            var w3 = w * w2;
            ret.push([
                $87b39ad613612da7$var$interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3),
                $87b39ad613612da7$var$interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)
            ]);
        }
        return ret;
    }
});
parcelRegister("4Fmqi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$365c6287f8cf6aea$export$2e2bcd8739ae039);
    var $eLEew;
    function $365c6287f8cf6aea$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
        var cps = [];
        var v = [];
        var v1 = [];
        var v2 = [];
        var prevPoint;
        var nextPoint;
        var min;
        var max;
        if (constraint) {
            min = [
                Infinity,
                Infinity
            ];
            max = [
                -Infinity,
                -Infinity
            ];
            for(var i = 0, len = points.length; i < len; i++){
                (0, (0, parcelRequire("eLEew")).min)(min, min, points[i]);
                (0, (0, parcelRequire("eLEew")).max)(max, max, points[i]);
            }
            (0, (0, parcelRequire("eLEew")).min)(min, min, constraint[0]);
            (0, (0, parcelRequire("eLEew")).max)(max, max, constraint[1]);
        }
        for(var i = 0, len = points.length; i < len; i++){
            var point = points[i];
            if (isLoop) {
                prevPoint = points[i ? i - 1 : len - 1];
                nextPoint = points[(i + 1) % len];
            } else if (i === 0 || i === len - 1) {
                cps.push((0, (0, parcelRequire("eLEew")).clone)(points[i]));
                continue;
            } else {
                prevPoint = points[i - 1];
                nextPoint = points[i + 1];
            }
            (0, (0, parcelRequire("eLEew")).sub)(v, nextPoint, prevPoint);
            (0, (0, parcelRequire("eLEew")).scale)(v, v, smooth);
            var d0 = (0, (0, parcelRequire("eLEew")).distance)(point, prevPoint);
            var d1 = (0, (0, parcelRequire("eLEew")).distance)(point, nextPoint);
            var sum = d0 + d1;
            if (sum !== 0) {
                d0 /= sum;
                d1 /= sum;
            }
            (0, (0, parcelRequire("eLEew")).scale)(v1, v, -d0);
            (0, (0, parcelRequire("eLEew")).scale)(v2, v, d1);
            var cp0 = (0, (0, parcelRequire("eLEew")).add)([], point, v1);
            var cp1 = (0, (0, parcelRequire("eLEew")).add)([], point, v2);
            if (constraint) {
                (0, (0, parcelRequire("eLEew")).max)(cp0, cp0, min);
                (0, (0, parcelRequire("eLEew")).min)(cp0, cp0, max);
                (0, (0, parcelRequire("eLEew")).max)(cp1, cp1, min);
                (0, (0, parcelRequire("eLEew")).min)(cp1, cp1, max);
            }
            cps.push(cp0);
            cps.push(cp1);
        }
        if (isLoop) cps.push(cps.shift());
        return cps;
    }
});
parcelRegister("32bXc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$235ad4ce0d26a4ed$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $gLMXf;
    var $235ad4ce0d26a4ed$export$e9e5cc3985e19d11 = function() {
        function PolylineShape() {
            this.points = null;
            this.percent = 1;
            this.smooth = 0;
            this.smoothConstraint = null;
        }
        return PolylineShape;
    }();
    var $235ad4ce0d26a4ed$var$Polyline = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Polyline, _super);
        function Polyline(opts) {
            return _super.call(this, opts) || this;
        }
        Polyline.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        Polyline.prototype.getDefaultShape = function() {
            return new $235ad4ce0d26a4ed$export$e9e5cc3985e19d11();
        };
        Polyline.prototype.buildPath = function(ctx, shape) {
            (0, parcelRequire("gLMXf")).buildPath(ctx, shape, false);
        };
        return Polyline;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $235ad4ce0d26a4ed$var$Polyline.prototype.type = 'polyline';
    var $235ad4ce0d26a4ed$export$2e2bcd8739ae039 = $235ad4ce0d26a4ed$var$Polyline;
});
parcelRegister("cZb1F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9743bc0ad02b6789$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $2az2p;
    var $9743bc0ad02b6789$var$subPixelOptimizeOutputShape = {};
    var $9743bc0ad02b6789$export$64b674d0815308 = function() {
        function LineShape() {
            this.x1 = 0;
            this.y1 = 0;
            this.x2 = 0;
            this.y2 = 0;
            this.percent = 1;
        }
        return LineShape;
    }();
    var $9743bc0ad02b6789$var$Line = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Line, _super);
        function Line(opts) {
            return _super.call(this, opts) || this;
        }
        Line.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        Line.prototype.getDefaultShape = function() {
            return new $9743bc0ad02b6789$export$64b674d0815308();
        };
        Line.prototype.buildPath = function(ctx, shape) {
            var x1;
            var y1;
            var x2;
            var y2;
            if (this.subPixelOptimize) {
                var optimizedShape = (0, (0, parcelRequire("2az2p")).subPixelOptimizeLine)($9743bc0ad02b6789$var$subPixelOptimizeOutputShape, shape, this.style);
                x1 = optimizedShape.x1;
                y1 = optimizedShape.y1;
                x2 = optimizedShape.x2;
                y2 = optimizedShape.y2;
            } else {
                x1 = shape.x1;
                y1 = shape.y1;
                x2 = shape.x2;
                y2 = shape.y2;
            }
            var percent = shape.percent;
            if (percent === 0) return;
            ctx.moveTo(x1, y1);
            if (percent < 1) {
                x2 = x1 * (1 - percent) + x2 * percent;
                y2 = y1 * (1 - percent) + y2 * percent;
            }
            ctx.lineTo(x2, y2);
        };
        Line.prototype.pointAt = function(p) {
            var shape = this.shape;
            return [
                shape.x1 * (1 - p) + shape.x2 * p,
                shape.y1 * (1 - p) + shape.y2 * p
            ];
        };
        return Line;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $9743bc0ad02b6789$var$Line.prototype.type = 'line';
    var $9743bc0ad02b6789$export$2e2bcd8739ae039 = $9743bc0ad02b6789$var$Line;
});
parcelRegister("04gw0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00cd2f675f351e5a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $eLEew;
    var $dr1jo;
    var $00cd2f675f351e5a$var$out = [];
    var $00cd2f675f351e5a$export$e10089729fef29aa = function() {
        function BezierCurveShape() {
            this.x1 = 0;
            this.y1 = 0;
            this.x2 = 0;
            this.y2 = 0;
            this.cpx1 = 0;
            this.cpy1 = 0;
            this.percent = 1;
        }
        return BezierCurveShape;
    }();
    function $00cd2f675f351e5a$var$someVectorAt(shape, t, isTangent) {
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        if (cpx2 === null || cpy2 === null) return [
            (isTangent ? (0, (0, parcelRequire("dr1jo")).cubicDerivativeAt) : (0, (0, parcelRequire("dr1jo")).cubicAt))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
            (isTangent ? (0, (0, parcelRequire("dr1jo")).cubicDerivativeAt) : (0, (0, parcelRequire("dr1jo")).cubicAt))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
        ];
        else return [
            (isTangent ? (0, (0, parcelRequire("dr1jo")).quadraticDerivativeAt) : (0, (0, parcelRequire("dr1jo")).quadraticAt))(shape.x1, shape.cpx1, shape.x2, t),
            (isTangent ? (0, (0, parcelRequire("dr1jo")).quadraticDerivativeAt) : (0, (0, parcelRequire("dr1jo")).quadraticAt))(shape.y1, shape.cpy1, shape.y2, t)
        ];
    }
    var $00cd2f675f351e5a$var$BezierCurve = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BezierCurve, _super);
        function BezierCurve(opts) {
            return _super.call(this, opts) || this;
        }
        BezierCurve.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        BezierCurve.prototype.getDefaultShape = function() {
            return new $00cd2f675f351e5a$export$e10089729fef29aa();
        };
        BezierCurve.prototype.buildPath = function(ctx, shape) {
            var x1 = shape.x1;
            var y1 = shape.y1;
            var x2 = shape.x2;
            var y2 = shape.y2;
            var cpx1 = shape.cpx1;
            var cpy1 = shape.cpy1;
            var cpx2 = shape.cpx2;
            var cpy2 = shape.cpy2;
            var percent = shape.percent;
            if (percent === 0) return;
            ctx.moveTo(x1, y1);
            if (cpx2 == null || cpy2 == null) {
                if (percent < 1) {
                    (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(x1, cpx1, x2, percent, $00cd2f675f351e5a$var$out);
                    cpx1 = $00cd2f675f351e5a$var$out[1];
                    x2 = $00cd2f675f351e5a$var$out[2];
                    (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(y1, cpy1, y2, percent, $00cd2f675f351e5a$var$out);
                    cpy1 = $00cd2f675f351e5a$var$out[1];
                    y2 = $00cd2f675f351e5a$var$out[2];
                }
                ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
            } else {
                if (percent < 1) {
                    (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(x1, cpx1, cpx2, x2, percent, $00cd2f675f351e5a$var$out);
                    cpx1 = $00cd2f675f351e5a$var$out[1];
                    cpx2 = $00cd2f675f351e5a$var$out[2];
                    x2 = $00cd2f675f351e5a$var$out[3];
                    (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(y1, cpy1, cpy2, y2, percent, $00cd2f675f351e5a$var$out);
                    cpy1 = $00cd2f675f351e5a$var$out[1];
                    cpy2 = $00cd2f675f351e5a$var$out[2];
                    y2 = $00cd2f675f351e5a$var$out[3];
                }
                ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
            }
        };
        BezierCurve.prototype.pointAt = function(t) {
            return $00cd2f675f351e5a$var$someVectorAt(this.shape, t, false);
        };
        BezierCurve.prototype.tangentAt = function(t) {
            var p = $00cd2f675f351e5a$var$someVectorAt(this.shape, t, true);
            return (0, parcelRequire("eLEew")).normalize(p, p);
        };
        return BezierCurve;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $00cd2f675f351e5a$var$BezierCurve.prototype.type = 'bezier-curve';
    var $00cd2f675f351e5a$export$2e2bcd8739ae039 = $00cd2f675f351e5a$var$BezierCurve;
});
parcelRegister("ixXaU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d80935fda1e22f1c$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $d80935fda1e22f1c$export$a259dbdc51948277 = function() {
        function ArcShape() {
            this.cx = 0;
            this.cy = 0;
            this.r = 0;
            this.startAngle = 0;
            this.endAngle = Math.PI * 2;
            this.clockwise = true;
        }
        return ArcShape;
    }();
    var $d80935fda1e22f1c$var$Arc = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Arc, _super);
        function Arc(opts) {
            return _super.call(this, opts) || this;
        }
        Arc.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        Arc.prototype.getDefaultShape = function() {
            return new $d80935fda1e22f1c$export$a259dbdc51948277();
        };
        Arc.prototype.buildPath = function(ctx, shape) {
            var x = shape.cx;
            var y = shape.cy;
            var r = Math.max(shape.r, 0);
            var startAngle = shape.startAngle;
            var endAngle = shape.endAngle;
            var clockwise = shape.clockwise;
            var unitX = Math.cos(startAngle);
            var unitY = Math.sin(startAngle);
            ctx.moveTo(unitX * r + x, unitY * r + y);
            ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
        };
        return Arc;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $d80935fda1e22f1c$var$Arc.prototype.type = 'arc';
    var $d80935fda1e22f1c$export$2e2bcd8739ae039 = $d80935fda1e22f1c$var$Arc;
});
parcelRegister("eGltS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab05a69c83088c4b$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $ab05a69c83088c4b$var$CompoundPath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CompoundPath, _super);
        function CompoundPath() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'compound';
            return _this;
        }
        CompoundPath.prototype._updatePathDirty = function() {
            var paths = this.shape.paths;
            var dirtyPath = this.shapeChanged();
            for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
            if (dirtyPath) this.dirtyShape();
        };
        CompoundPath.prototype.beforeBrush = function() {
            this._updatePathDirty();
            var paths = this.shape.paths || [];
            var scale = this.getGlobalScale();
            for(var i = 0; i < paths.length; i++){
                if (!paths[i].path) paths[i].createPathProxy();
                paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
            }
        };
        CompoundPath.prototype.buildPath = function(ctx, shape) {
            var paths = shape.paths || [];
            for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
        };
        CompoundPath.prototype.afterBrush = function() {
            var paths = this.shape.paths || [];
            for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
        };
        CompoundPath.prototype.getBoundingRect = function() {
            this._updatePathDirty.call(this);
            return (0, (0, parcelRequire("ghQ8v")).default).prototype.getBoundingRect.call(this);
        };
        return CompoundPath;
    }((0, (0, parcelRequire("ghQ8v")).default));
    var $ab05a69c83088c4b$export$2e2bcd8739ae039 = $ab05a69c83088c4b$var$CompoundPath;
});
parcelRegister("9J7f8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$714def5c08e9d5ff$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jnhEE;
    var $714def5c08e9d5ff$var$LinearGradient = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LinearGradient, _super);
        function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
            var _this = _super.call(this, colorStops) || this;
            _this.x = x == null ? 0 : x;
            _this.y = y == null ? 0 : y;
            _this.x2 = x2 == null ? 1 : x2;
            _this.y2 = y2 == null ? 0 : y2;
            _this.type = 'linear';
            _this.global = globalCoord || false;
            return _this;
        }
        return LinearGradient;
    }((0, (0, parcelRequire("jnhEE")).default));
    var $714def5c08e9d5ff$export$2e2bcd8739ae039 = $714def5c08e9d5ff$var$LinearGradient;
});
parcelRegister("jnhEE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1addc27dbc63739$export$2e2bcd8739ae039);
    var $e1addc27dbc63739$var$Gradient = function() {
        function Gradient(colorStops) {
            this.colorStops = colorStops || [];
        }
        Gradient.prototype.addColorStop = function(offset, color) {
            this.colorStops.push({
                offset: offset,
                color: color
            });
        };
        return Gradient;
    }();
    var $e1addc27dbc63739$export$2e2bcd8739ae039 = $e1addc27dbc63739$var$Gradient;
});
parcelRegister("faICo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0ba666d3a488180$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jnhEE;
    var $b0ba666d3a488180$var$RadialGradient = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(RadialGradient, _super);
        function RadialGradient(x, y, r, colorStops, globalCoord) {
            var _this = _super.call(this, colorStops) || this;
            _this.x = x == null ? 0.5 : x;
            _this.y = y == null ? 0.5 : y;
            _this.r = r == null ? 0.5 : r;
            _this.type = 'radial';
            _this.global = globalCoord || false;
            return _this;
        }
        return RadialGradient;
    }((0, (0, parcelRequire("jnhEE")).default));
    var $b0ba666d3a488180$export$2e2bcd8739ae039 = $b0ba666d3a488180$var$RadialGradient;
});
parcelRegister("lM5Gp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fda27d30e90880c7$export$2e2bcd8739ae039);
    var $bMDnR;
    var $fda27d30e90880c7$var$extent = [
        0,
        0
    ];
    var $fda27d30e90880c7$var$extent2 = [
        0,
        0
    ];
    var $fda27d30e90880c7$var$minTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $fda27d30e90880c7$var$maxTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $fda27d30e90880c7$var$OrientedBoundingRect = function() {
        function OrientedBoundingRect(rect, transform) {
            this._corners = [];
            this._axes = [];
            this._origin = [
                0,
                0
            ];
            for(var i = 0; i < 4; i++)this._corners[i] = new (0, (0, parcelRequire("bMDnR")).default)();
            for(var i = 0; i < 2; i++)this._axes[i] = new (0, (0, parcelRequire("bMDnR")).default)();
            if (rect) this.fromBoundingRect(rect, transform);
        }
        OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
            var corners = this._corners;
            var axes = this._axes;
            var x = rect.x;
            var y = rect.y;
            var x2 = x + rect.width;
            var y2 = y + rect.height;
            corners[0].set(x, y);
            corners[1].set(x2, y);
            corners[2].set(x2, y2);
            corners[3].set(x, y2);
            if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
            (0, (0, parcelRequire("bMDnR")).default).sub(axes[0], corners[1], corners[0]);
            (0, (0, parcelRequire("bMDnR")).default).sub(axes[1], corners[3], corners[0]);
            axes[0].normalize();
            axes[1].normalize();
            for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
        };
        OrientedBoundingRect.prototype.intersect = function(other, mtv) {
            var overlapped = true;
            var noMtv = !mtv;
            $fda27d30e90880c7$var$minTv.set(Infinity, Infinity);
            $fda27d30e90880c7$var$maxTv.set(0, 0);
            if (!this._intersectCheckOneSide(this, other, $fda27d30e90880c7$var$minTv, $fda27d30e90880c7$var$maxTv, noMtv, 1)) {
                overlapped = false;
                if (noMtv) return overlapped;
            }
            if (!this._intersectCheckOneSide(other, this, $fda27d30e90880c7$var$minTv, $fda27d30e90880c7$var$maxTv, noMtv, -1)) {
                overlapped = false;
                if (noMtv) return overlapped;
            }
            if (!noMtv) (0, (0, parcelRequire("bMDnR")).default).copy(mtv, overlapped ? $fda27d30e90880c7$var$minTv : $fda27d30e90880c7$var$maxTv);
            return overlapped;
        };
        OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
            var overlapped = true;
            for(var i = 0; i < 2; i++){
                var axis = this._axes[i];
                this._getProjMinMaxOnAxis(i, self._corners, $fda27d30e90880c7$var$extent);
                this._getProjMinMaxOnAxis(i, other._corners, $fda27d30e90880c7$var$extent2);
                if ($fda27d30e90880c7$var$extent[1] < $fda27d30e90880c7$var$extent2[0] || $fda27d30e90880c7$var$extent[0] > $fda27d30e90880c7$var$extent2[1]) {
                    overlapped = false;
                    if (noMtv) return overlapped;
                    var dist0 = Math.abs($fda27d30e90880c7$var$extent2[0] - $fda27d30e90880c7$var$extent[1]);
                    var dist1 = Math.abs($fda27d30e90880c7$var$extent[0] - $fda27d30e90880c7$var$extent2[1]);
                    if (Math.min(dist0, dist1) > maxTv.len()) {
                        if (dist0 < dist1) (0, (0, parcelRequire("bMDnR")).default).scale(maxTv, axis, -dist0 * inverse);
                        else (0, (0, parcelRequire("bMDnR")).default).scale(maxTv, axis, dist1 * inverse);
                    }
                } else if (minTv) {
                    var dist0 = Math.abs($fda27d30e90880c7$var$extent2[0] - $fda27d30e90880c7$var$extent[1]);
                    var dist1 = Math.abs($fda27d30e90880c7$var$extent[0] - $fda27d30e90880c7$var$extent2[1]);
                    if (Math.min(dist0, dist1) < minTv.len()) {
                        if (dist0 < dist1) (0, (0, parcelRequire("bMDnR")).default).scale(minTv, axis, dist0 * inverse);
                        else (0, (0, parcelRequire("bMDnR")).default).scale(minTv, axis, -dist1 * inverse);
                    }
                }
            }
            return overlapped;
        };
        OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
            var axis = this._axes[dim];
            var origin = this._origin;
            var proj = corners[0].dot(axis) + origin[dim];
            var min = proj;
            var max = proj;
            for(var i = 1; i < corners.length; i++){
                var proj_1 = corners[i].dot(axis) + origin[dim];
                min = Math.min(proj_1, min);
                max = Math.max(proj_1, max);
            }
            out[0] = min;
            out[1] = max;
        };
        return OrientedBoundingRect;
    }();
    var $fda27d30e90880c7$export$2e2bcd8739ae039 = $fda27d30e90880c7$var$OrientedBoundingRect;
});
parcelRegister("6sllV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b35ebcb0b796fce$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $1E3E8;
    var $4b35ebcb0b796fce$var$m = [];
    var $4b35ebcb0b796fce$var$IncrementalDisplayable = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(IncrementalDisplayable, _super);
        function IncrementalDisplayable() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.notClear = true;
            _this.incremental = true;
            _this._displayables = [];
            _this._temporaryDisplayables = [];
            _this._cursor = 0;
            return _this;
        }
        IncrementalDisplayable.prototype.traverse = function(cb, context) {
            cb.call(context, this);
        };
        IncrementalDisplayable.prototype.useStyle = function() {
            this.style = {};
        };
        IncrementalDisplayable.prototype.getCursor = function() {
            return this._cursor;
        };
        IncrementalDisplayable.prototype.innerAfterBrush = function() {
            this._cursor = this._displayables.length;
        };
        IncrementalDisplayable.prototype.clearDisplaybles = function() {
            this._displayables = [];
            this._temporaryDisplayables = [];
            this._cursor = 0;
            this.markRedraw();
            this.notClear = false;
        };
        IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
            this._temporaryDisplayables = [];
        };
        IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
            if (notPersistent) this._temporaryDisplayables.push(displayable);
            else this._displayables.push(displayable);
            this.markRedraw();
        };
        IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
            notPersistent = notPersistent || false;
            for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
        };
        IncrementalDisplayable.prototype.getDisplayables = function() {
            return this._displayables;
        };
        IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
            return this._temporaryDisplayables;
        };
        IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
            for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
            for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
        };
        IncrementalDisplayable.prototype.update = function() {
            this.updateTransform();
            for(var i = this._cursor; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                displayable.parent = this;
                displayable.update();
                displayable.parent = null;
            }
            for(var i = 0; i < this._temporaryDisplayables.length; i++){
                var displayable = this._temporaryDisplayables[i];
                displayable.parent = this;
                displayable.update();
                displayable.parent = null;
            }
        };
        IncrementalDisplayable.prototype.getBoundingRect = function() {
            if (!this._rect) {
                var rect = new (0, (0, parcelRequire("1E3E8")).default)(Infinity, Infinity, -Infinity, -Infinity);
                for(var i = 0; i < this._displayables.length; i++){
                    var displayable = this._displayables[i];
                    var childRect = displayable.getBoundingRect().clone();
                    if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($4b35ebcb0b796fce$var$m));
                    rect.union(childRect);
                }
                this._rect = rect;
            }
            return this._rect;
        };
        IncrementalDisplayable.prototype.contain = function(x, y) {
            var localPos = this.transformCoordToLocal(x, y);
            var rect = this.getBoundingRect();
            if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                if (displayable.contain(x, y)) return true;
            }
            return false;
        };
        return IncrementalDisplayable;
    }((0, (0, parcelRequire("lBQ88")).default));
    var $4b35ebcb0b796fce$export$2e2bcd8739ae039 = $4b35ebcb0b796fce$var$IncrementalDisplayable;
});
parcelRegister("7QjoM", function(module, exports) {
    $parcel$export(module.exports, "getECData", ()=>$5b5c6fe297852166$export$b1c39b2bacd1ddc2);
    $parcel$export(module.exports, "setCommonECData", ()=>$5b5c6fe297852166$export$30d6736ebb8e18d5);
    var $eaKsF;
    var $5b5c6fe297852166$export$b1c39b2bacd1ddc2 = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $5b5c6fe297852166$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
        if (el) {
            var ecData = $5b5c6fe297852166$export$b1c39b2bacd1ddc2(el);
            ecData.dataIndex = dataIdx;
            ecData.dataType = dataType;
            ecData.seriesIndex = seriesIndex;
            if (el.type === 'group') el.traverse(function(child) {
                var childECData = $5b5c6fe297852166$export$b1c39b2bacd1ddc2(child);
                childECData.seriesIndex = seriesIndex;
                childECData.dataIndex = dataIdx;
                childECData.dataType = dataType;
            });
        }
    };
});
parcelRegister("eaKsF", function(module, exports) {
    $parcel$export(module.exports, "normalizeToArray", ()=>$a5160a25a687d9b6$export$4f07b212a02c8051);
    $parcel$export(module.exports, "defaultEmphasis", ()=>$a5160a25a687d9b6$export$abdcc6a26372f94b);
    $parcel$export(module.exports, "TEXT_STYLE_OPTIONS", ()=>$a5160a25a687d9b6$export$df45610347a602ad);
    $parcel$export(module.exports, "getDataItemValue", ()=>$a5160a25a687d9b6$export$2c944e12edb48d4b);
    $parcel$export(module.exports, "isDataItemOption", ()=>$a5160a25a687d9b6$export$3e1a543f33ef6883);
    $parcel$export(module.exports, "mappingToExists", ()=>$a5160a25a687d9b6$export$574f818966e4da87);
    $parcel$export(module.exports, "isComponentIdInternal", ()=>$a5160a25a687d9b6$export$feece3e7d52a102b);
    $parcel$export(module.exports, "convertOptionIdName", ()=>$a5160a25a687d9b6$export$fb1a222ba5dd6e51);
    $parcel$export(module.exports, "isNameSpecified", ()=>$a5160a25a687d9b6$export$beae19a2652b3368);
    $parcel$export(module.exports, "makeInternalComponentId", ()=>$a5160a25a687d9b6$export$1753133c42e665e8);
    $parcel$export(module.exports, "setComponentTypeToKeyInfo", ()=>$a5160a25a687d9b6$export$5ac61aca2ba0282d);
    $parcel$export(module.exports, "compressBatches", ()=>$a5160a25a687d9b6$export$6d12cabb0c9bf8e3);
    $parcel$export(module.exports, "queryDataIndex", ()=>$a5160a25a687d9b6$export$42b26cae8b8d10);
    $parcel$export(module.exports, "makeInner", ()=>$a5160a25a687d9b6$export$64df9f8d92ae083f);
    $parcel$export(module.exports, "parseFinder", ()=>$a5160a25a687d9b6$export$95de80076abac814);
    $parcel$export(module.exports, "preParseFinder", ()=>$a5160a25a687d9b6$export$fe600815775d9400);
    $parcel$export(module.exports, "queryReferringComponents", ()=>$a5160a25a687d9b6$export$dc741340f7e5f186);
    $parcel$export(module.exports, "SINGLE_REFERRING", ()=>$a5160a25a687d9b6$export$f076738ec84e693c);
    $parcel$export(module.exports, "MULTIPLE_REFERRING", ()=>$a5160a25a687d9b6$export$48d598924ce4892c);
    $parcel$export(module.exports, "setAttribute", ()=>$a5160a25a687d9b6$export$9fec4d97f1922e0b);
    $parcel$export(module.exports, "getAttribute", ()=>$a5160a25a687d9b6$export$735ee1799fd02602);
    $parcel$export(module.exports, "getTooltipRenderMode", ()=>$a5160a25a687d9b6$export$cc0a17a5d27b4e17);
    $parcel$export(module.exports, "groupData", ()=>$a5160a25a687d9b6$export$7ab5bda43e13168f);
    $parcel$export(module.exports, "interpolateRawValues", ()=>$a5160a25a687d9b6$export$bd0439821a1869f3);
    var $bahqM;
    var $hZfwb;
    var $jmSNG;
    var $hb2y5;
    var $a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
    var $a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
    function $a5160a25a687d9b6$export$4f07b212a02c8051(value) {
        return value instanceof Array ? value : value == null ? [] : [
            value
        ];
    }
    function $a5160a25a687d9b6$export$abdcc6a26372f94b(opt, key, subOpts) {
        if (opt) {
            opt[key] = opt[key] || {};
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[key] = opt.emphasis[key] || {};
            for(var i = 0, len = subOpts.length; i < len; i++){
                var subOptName = subOpts[i];
                if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
            }
        }
    }
    var $a5160a25a687d9b6$export$df45610347a602ad = [
        'fontStyle',
        'fontWeight',
        'fontSize',
        'fontFamily',
        'rich',
        'tag',
        'color',
        'textBorderColor',
        'textBorderWidth',
        'width',
        'height',
        'lineHeight',
        'align',
        'verticalAlign',
        'baseline',
        'shadowColor',
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY',
        'textShadowColor',
        'textShadowBlur',
        'textShadowOffsetX',
        'textShadowOffsetY',
        'backgroundColor',
        'borderColor',
        'borderWidth',
        'borderRadius',
        'padding'
    ];
    function $a5160a25a687d9b6$export$2c944e12edb48d4b(dataItem) {
        return (0, (0, parcelRequire("bahqM")).isObject)(dataItem) && !(0, (0, parcelRequire("bahqM")).isArray)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
    }
    function $a5160a25a687d9b6$export$3e1a543f33ef6883(dataItem) {
        return (0, (0, parcelRequire("bahqM")).isObject)(dataItem) && !(dataItem instanceof Array);
    }
    function $a5160a25a687d9b6$export$574f818966e4da87(existings, newCmptOptions, mode) {
        var isNormalMergeMode = mode === 'normalMerge';
        var isReplaceMergeMode = mode === 'replaceMerge';
        var isReplaceAllMode = mode === 'replaceAll';
        existings = existings || [];
        newCmptOptions = (newCmptOptions || []).slice();
        var existingIdIdxMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption, index) {
            if (!(0, (0, parcelRequire("bahqM")).isObject)(cmptOption)) {
                newCmptOptions[index] = null;
                return;
            }
        });
        var result = $a5160a25a687d9b6$var$prepareResult(existings, existingIdIdxMap, mode);
        if (isNormalMergeMode || isReplaceMergeMode) $a5160a25a687d9b6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
        if (isNormalMergeMode) $a5160a25a687d9b6$var$mappingByName(result, newCmptOptions);
        if (isNormalMergeMode || isReplaceMergeMode) $a5160a25a687d9b6$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
        else if (isReplaceAllMode) $a5160a25a687d9b6$var$mappingInReplaceAllMode(result, newCmptOptions);
        $a5160a25a687d9b6$var$makeIdAndName(result);
        return result;
    }
    function $a5160a25a687d9b6$var$prepareResult(existings, existingIdIdxMap, mode) {
        var result = [];
        if (mode === 'replaceAll') return result;
        for(var index = 0; index < existings.length; index++){
            var existing = existings[index];
            if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
            result.push({
                existing: mode === 'replaceMerge' || $a5160a25a687d9b6$export$feece3e7d52a102b(existing) ? null : existing,
                newOption: null,
                keyInfo: null,
                brandNew: null
            });
        }
        return result;
    }
    function $a5160a25a687d9b6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption, index) {
            if (!cmptOption || cmptOption.id == null) return;
            var optionId = $a5160a25a687d9b6$var$makeComparableKey(cmptOption.id);
            var existingIdx = existingIdIdxMap.get(optionId);
            if (existingIdx != null) {
                var resultItem = result[existingIdx];
                (0, (0, parcelRequire("bahqM")).assert)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
                resultItem.newOption = cmptOption;
                resultItem.existing = existings[existingIdx];
                newCmptOptions[index] = null;
            }
        });
    }
    function $a5160a25a687d9b6$var$mappingByName(result, newCmptOptions) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption, index) {
            if (!cmptOption || cmptOption.name == null) return;
            for(var i = 0; i < result.length; i++){
                var existing = result[i].existing;
                if (!result[i].newOption && existing && (existing.id == null || cmptOption.id == null) && !$a5160a25a687d9b6$export$feece3e7d52a102b(cmptOption) && !$a5160a25a687d9b6$export$feece3e7d52a102b(existing) && $a5160a25a687d9b6$var$keyExistAndEqual('name', existing, cmptOption)) {
                    result[i].newOption = cmptOption;
                    newCmptOptions[index] = null;
                    return;
                }
            }
        });
    }
    function $a5160a25a687d9b6$var$mappingByIndex(result, newCmptOptions, brandNew) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption) {
            if (!cmptOption) return;
            var resultItem;
            var nextIdx = 0;
            while((resultItem = result[nextIdx]) && (resultItem.newOption || $a5160a25a687d9b6$export$feece3e7d52a102b(resultItem.existing) || resultItem.existing && cmptOption.id != null && !$a5160a25a687d9b6$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
            if (resultItem) {
                resultItem.newOption = cmptOption;
                resultItem.brandNew = brandNew;
            } else result.push({
                newOption: cmptOption,
                brandNew: brandNew,
                existing: null,
                keyInfo: null
            });
            nextIdx++;
        });
    }
    function $a5160a25a687d9b6$var$mappingInReplaceAllMode(result, newCmptOptions) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption) {
            result.push({
                newOption: cmptOption,
                brandNew: true,
                existing: null,
                keyInfo: null
            });
        });
    }
    function $a5160a25a687d9b6$var$makeIdAndName(mapResult) {
        var idMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        (0, (0, parcelRequire("bahqM")).each)(mapResult, function(item) {
            var existing = item.existing;
            existing && idMap.set(existing.id, item);
        });
        (0, (0, parcelRequire("bahqM")).each)(mapResult, function(item) {
            var opt = item.newOption;
            (0, (0, parcelRequire("bahqM")).assert)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
            opt && opt.id != null && idMap.set(opt.id, item);
            !item.keyInfo && (item.keyInfo = {});
        });
        (0, (0, parcelRequire("bahqM")).each)(mapResult, function(item, index) {
            var existing = item.existing;
            var opt = item.newOption;
            var keyInfo = item.keyInfo;
            if (!(0, (0, parcelRequire("bahqM")).isObject)(opt)) return;
            keyInfo.name = opt.name != null ? $a5160a25a687d9b6$var$makeComparableKey(opt.name) : existing ? existing.name : $a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX + index;
            if (existing) keyInfo.id = $a5160a25a687d9b6$var$makeComparableKey(existing.id);
            else if (opt.id != null) keyInfo.id = $a5160a25a687d9b6$var$makeComparableKey(opt.id);
            else {
                var idNum = 0;
                do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
                while (idMap.get(keyInfo.id))
            }
            idMap.set(keyInfo.id, item);
        });
    }
    function $a5160a25a687d9b6$var$keyExistAndEqual(attr, obj1, obj2) {
        var key1 = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(obj1[attr], null);
        var key2 = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(obj2[attr], null);
        return key1 != null && key2 != null && key1 === key2;
    }
    function $a5160a25a687d9b6$var$makeComparableKey(val) {
        return $a5160a25a687d9b6$export$fb1a222ba5dd6e51(val, '');
    }
    function $a5160a25a687d9b6$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
        if (idOrName == null) return defaultValue;
        var type = typeof idOrName;
        return type === 'string' ? idOrName : type === 'number' || (0, (0, parcelRequire("bahqM")).isStringSafe)(idOrName) ? idOrName + '' : defaultValue;
    }
    function $a5160a25a687d9b6$var$warnInvalidateIdOrName(idOrName) {}
    function $a5160a25a687d9b6$var$isValidIdOrName(idOrName) {
        return (0, (0, parcelRequire("bahqM")).isStringSafe)(idOrName) || (0, (0, parcelRequire("jmSNG")).isNumeric)(idOrName);
    }
    function $a5160a25a687d9b6$export$beae19a2652b3368(componentModel) {
        var name = componentModel.name;
        return !!(name && name.indexOf($a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX));
    }
    function $a5160a25a687d9b6$export$feece3e7d52a102b(cmptOption) {
        return cmptOption && cmptOption.id != null && $a5160a25a687d9b6$var$makeComparableKey(cmptOption.id).indexOf($a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
    }
    function $a5160a25a687d9b6$export$1753133c42e665e8(idSuffix) {
        return $a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
    }
    function $a5160a25a687d9b6$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
        (0, (0, parcelRequire("bahqM")).each)(mappingResult, function(item) {
            var newOption = item.newOption;
            if ((0, (0, parcelRequire("bahqM")).isObject)(newOption)) {
                item.keyInfo.mainType = mainType;
                item.keyInfo.subType = $a5160a25a687d9b6$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
            }
        });
    }
    function $a5160a25a687d9b6$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
        var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
        return subType;
    }
    function $a5160a25a687d9b6$export$6d12cabb0c9bf8e3(batchA, batchB) {
        var mapA = {};
        var mapB = {};
        makeMap(batchA || [], mapA);
        makeMap(batchB || [], mapB, mapA);
        return [
            mapToArray(mapA),
            mapToArray(mapB)
        ];
        function makeMap(sourceBatch, map, otherMap) {
            for(var i = 0, len = sourceBatch.length; i < len; i++){
                var seriesId = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
                if (seriesId == null) return;
                var dataIndices = $a5160a25a687d9b6$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
                var otherDataIndices = otherMap && otherMap[seriesId];
                for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                    var dataIndex = dataIndices[j];
                    if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                    else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
                }
            }
        }
        function mapToArray(map, isData) {
            var result = [];
            for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
                if (isData) result.push(+i);
                else {
                    var dataIndices = mapToArray(map[i], true);
                    dataIndices.length && result.push({
                        seriesId: i,
                        dataIndex: dataIndices
                    });
                }
            }
            return result;
        }
    }
    function $a5160a25a687d9b6$export$42b26cae8b8d10(data, payload) {
        if (payload.dataIndexInside != null) return payload.dataIndexInside;
        else if (payload.dataIndex != null) return (0, (0, parcelRequire("bahqM")).isArray)(payload.dataIndex) ? (0, (0, parcelRequire("bahqM")).map)(payload.dataIndex, function(value) {
            return data.indexOfRawIndex(value);
        }) : data.indexOfRawIndex(payload.dataIndex);
        else if (payload.name != null) return (0, (0, parcelRequire("bahqM")).isArray)(payload.name) ? (0, (0, parcelRequire("bahqM")).map)(payload.name, function(value) {
            return data.indexOfName(value);
        }) : data.indexOfName(payload.name);
    }
    function $a5160a25a687d9b6$export$64df9f8d92ae083f() {
        var key = '__ec_inner_' + $a5160a25a687d9b6$var$innerUniqueIndex++;
        return function(hostObj) {
            return hostObj[key] || (hostObj[key] = {});
        };
    }
    var $a5160a25a687d9b6$var$innerUniqueIndex = (0, (0, parcelRequire("jmSNG")).getRandomIdBase)();
    function $a5160a25a687d9b6$export$95de80076abac814(ecModel, finderInput, opt) {
        var _a = $a5160a25a687d9b6$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
        var result = others;
        var defaultMainType = opt ? opt.defaultMainType : null;
        if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
        queryOptionMap.each(function(queryOption, mainType) {
            var queryResult = $a5160a25a687d9b6$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
                useDefault: defaultMainType === mainType,
                enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
                enableNone: opt && opt.enableNone != null ? opt.enableNone : true
            });
            result[mainType + 'Models'] = queryResult.models;
            result[mainType + 'Model'] = queryResult.models[0];
        });
        return result;
    }
    function $a5160a25a687d9b6$export$fe600815775d9400(finderInput, opt) {
        var finder;
        if ((0, (0, parcelRequire("bahqM")).isString)(finderInput)) {
            var obj = {};
            obj[finderInput + 'Index'] = 0;
            finder = obj;
        } else finder = finderInput;
        var queryOptionMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var others = {};
        var mainTypeSpecified = false;
        (0, (0, parcelRequire("bahqM")).each)(finder, function(value, key) {
            if (key === 'dataIndex' || key === 'dataIndexInside') {
                others[key] = value;
                return;
            }
            var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
            var mainType = parsedKey[1];
            var queryType = (parsedKey[2] || '').toLowerCase();
            if (!mainType || !queryType || opt && opt.includeMainTypes && (0, (0, parcelRequire("bahqM")).indexOf)(opt.includeMainTypes, mainType) < 0) return;
            mainTypeSpecified = mainTypeSpecified || !!mainType;
            var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
            queryOption[queryType] = value;
        });
        return {
            mainTypeSpecified: mainTypeSpecified,
            queryOptionMap: queryOptionMap,
            others: others
        };
    }
    var $a5160a25a687d9b6$export$f076738ec84e693c = {
        useDefault: true,
        enableAll: false,
        enableNone: false
    };
    var $a5160a25a687d9b6$export$48d598924ce4892c = {
        useDefault: false,
        enableAll: true,
        enableNone: true
    };
    function $a5160a25a687d9b6$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
        opt = opt || $a5160a25a687d9b6$export$f076738ec84e693c;
        var indexOption = userOption.index;
        var idOption = userOption.id;
        var nameOption = userOption.name;
        var result = {
            models: null,
            specified: indexOption != null || idOption != null || nameOption != null
        };
        if (!result.specified) {
            var firstCmpt = void 0;
            result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
                firstCmpt
            ] : [];
            return result;
        }
        if (indexOption === 'none' || indexOption === false) {
            (0, (0, parcelRequire("bahqM")).assert)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
            result.models = [];
            return result;
        }
        if (indexOption === 'all') {
            (0, (0, parcelRequire("bahqM")).assert)(opt.enableAll, '`"all"` is not a valid value on index option.');
            indexOption = idOption = nameOption = null;
        }
        result.models = ecModel.queryComponents({
            mainType: mainType,
            index: indexOption,
            id: idOption,
            name: nameOption
        });
        return result;
    }
    function $a5160a25a687d9b6$export$9fec4d97f1922e0b(dom, key, value) {
        dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
    }
    function $a5160a25a687d9b6$export$735ee1799fd02602(dom, key) {
        return dom.getAttribute ? dom.getAttribute(key) : dom[key];
    }
    function $a5160a25a687d9b6$export$cc0a17a5d27b4e17(renderModeOption) {
        if (renderModeOption === 'auto') return (0, (0, parcelRequire("hZfwb")).default).domSupported ? 'html' : 'richText';
        else return renderModeOption || 'html';
    }
    function $a5160a25a687d9b6$export$7ab5bda43e13168f(array, getKey) {
        var buckets = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var keys = [];
        (0, (0, parcelRequire("bahqM")).each)(array, function(item) {
            var key = getKey(item);
            (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
        });
        return {
            keys: keys,
            buckets: buckets
        };
    }
    function $a5160a25a687d9b6$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
        var isAutoPrecision = precision == null || precision === 'auto';
        if (targetValue == null) return targetValue;
        if (typeof targetValue === 'number') {
            var value = (0, (0, parcelRequire("hb2y5")).interpolateNumber)(sourceValue || 0, targetValue, percent);
            return (0, (0, parcelRequire("jmSNG")).round)(value, isAutoPrecision ? Math.max((0, (0, parcelRequire("jmSNG")).getPrecision)(sourceValue || 0), (0, (0, parcelRequire("jmSNG")).getPrecision)(targetValue)) : precision);
        } else if (typeof targetValue === 'string') return percent < 1 ? sourceValue : targetValue;
        else {
            var interpolated = [];
            var leftArr = sourceValue;
            var rightArr = targetValue;
            var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
            for(var i = 0; i < length_1; ++i){
                var info = data.getDimensionInfo(i);
                if (info && info.type === 'ordinal') interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
                else {
                    var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                    var rightVal = rightArr[i];
                    var value = (0, (0, parcelRequire("hb2y5")).interpolateNumber)(leftVal, rightVal, percent);
                    interpolated[i] = (0, (0, parcelRequire("jmSNG")).round)(value, isAutoPrecision ? Math.max((0, (0, parcelRequire("jmSNG")).getPrecision)(leftVal), (0, (0, parcelRequire("jmSNG")).getPrecision)(rightVal)) : precision);
                }
            }
            return interpolated;
        }
    }
});
parcelRegister("jmSNG", function(module, exports) {
    $parcel$export(module.exports, "linearMap", ()=>$e19a9495965944b5$export$d3f68fbaa670562);
    $parcel$export(module.exports, "parsePercent", ()=>$e19a9495965944b5$export$e8514cb5a5e2b40f);
    $parcel$export(module.exports, "round", ()=>$e19a9495965944b5$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "asc", ()=>$e19a9495965944b5$export$debe6e778e0a6d32);
    $parcel$export(module.exports, "getPrecision", ()=>$e19a9495965944b5$export$e0c74b50bbd10f68);
    $parcel$export(module.exports, "getPrecisionSafe", ()=>$e19a9495965944b5$export$6d86ba4ca4984d31);
    $parcel$export(module.exports, "getPixelPrecision", ()=>$e19a9495965944b5$export$666260d9a2dda8a7);
    $parcel$export(module.exports, "getPercentWithPrecision", ()=>$e19a9495965944b5$export$70cc11b075afeb90);
    $parcel$export(module.exports, "addSafe", ()=>$e19a9495965944b5$export$d3389a301c3a5706);
    $parcel$export(module.exports, "MAX_SAFE_INTEGER", ()=>$e19a9495965944b5$export$18510406f204a1b9);
    $parcel$export(module.exports, "remRadian", ()=>$e19a9495965944b5$export$2ca6dd70a288b1c3);
    $parcel$export(module.exports, "isRadianAroundZero", ()=>$e19a9495965944b5$export$d1df570aea2868f);
    $parcel$export(module.exports, "parseDate", ()=>$e19a9495965944b5$export$6b862160d295c8e);
    $parcel$export(module.exports, "quantity", ()=>$e19a9495965944b5$export$82dd68b83a44b253);
    $parcel$export(module.exports, "quantityExponent", ()=>$e19a9495965944b5$export$97256a17b20a0c24);
    $parcel$export(module.exports, "nice", ()=>$e19a9495965944b5$export$7a695fe44258210b);
    $parcel$export(module.exports, "quantile", ()=>$e19a9495965944b5$export$651fb4afdb6caa4b);
    $parcel$export(module.exports, "reformIntervals", ()=>$e19a9495965944b5$export$12f7386070bc380a);
    $parcel$export(module.exports, "numericToNumber", ()=>$e19a9495965944b5$export$8b4007b942b45a96);
    $parcel$export(module.exports, "isNumeric", ()=>$e19a9495965944b5$export$e90fb89750dba83f);
    $parcel$export(module.exports, "getRandomIdBase", ()=>$e19a9495965944b5$export$474d2ec9aa44a22);
    $parcel$export(module.exports, "getLeastCommonMultiple", ()=>$e19a9495965944b5$export$680a45b749323f49);
    var $bahqM;
    var $e19a9495965944b5$var$RADIAN_EPSILON = 1e-4;
    var $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
    function $e19a9495965944b5$var$_trim(str) {
        return str.replace(/^\s+|\s+$/g, '');
    }
    function $e19a9495965944b5$export$d3f68fbaa670562(val, domain, range, clamp) {
        var d0 = domain[0];
        var d1 = domain[1];
        var r0 = range[0];
        var r1 = range[1];
        var subDomain = d1 - d0;
        var subRange = r1 - r0;
        if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
        if (clamp) {
            if (subDomain > 0) {
                if (val <= d0) return r0;
                else if (val >= d1) return r1;
            } else {
                if (val >= d0) return r0;
                else if (val <= d1) return r1;
            }
        } else {
            if (val === d0) return r0;
            if (val === d1) return r1;
        }
        return (val - d0) / subDomain * subRange + r0;
    }
    function $e19a9495965944b5$export$e8514cb5a5e2b40f(percent, all) {
        switch(percent){
            case 'center':
            case 'middle':
                percent = '50%';
                break;
            case 'left':
            case 'top':
                percent = '0%';
                break;
            case 'right':
            case 'bottom':
                percent = '100%';
                break;
        }
        if (typeof percent === 'string') {
            if ($e19a9495965944b5$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
            return parseFloat(percent);
        }
        return percent == null ? NaN : +percent;
    }
    function $e19a9495965944b5$export$2077e0241d6afd3c(x, precision, returnStr) {
        if (precision == null) precision = 10;
        precision = Math.min(Math.max(0, precision), $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX);
        x = (+x).toFixed(precision);
        return returnStr ? x : +x;
    }
    function $e19a9495965944b5$export$debe6e778e0a6d32(arr) {
        arr.sort(function(a, b) {
            return a - b;
        });
        return arr;
    }
    function $e19a9495965944b5$export$e0c74b50bbd10f68(val) {
        val = +val;
        if (isNaN(val)) return 0;
        if (val > 1e-14) {
            var e = 1;
            for(var i = 0; i < 15; i++, e *= 10){
                if (Math.round(val * e) / e === val) return i;
            }
        }
        return $e19a9495965944b5$export$6d86ba4ca4984d31(val);
    }
    function $e19a9495965944b5$export$6d86ba4ca4984d31(val) {
        var str = val.toString().toLowerCase();
        var eIndex = str.indexOf('e');
        var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
        var significandPartLen = eIndex > 0 ? eIndex : str.length;
        var dotIndex = str.indexOf('.');
        var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
        return Math.max(0, decimalPartLen - exp);
    }
    function $e19a9495965944b5$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
        var log = Math.log;
        var LN10 = Math.LN10;
        var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
        var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10);
        var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
        return !isFinite(precision) ? 20 : precision;
    }
    function $e19a9495965944b5$export$70cc11b075afeb90(valueList, idx, precision) {
        if (!valueList[idx]) return 0;
        var sum = (0, parcelRequire("bahqM")).reduce(valueList, function(acc, val) {
            return acc + (isNaN(val) ? 0 : val);
        }, 0);
        if (sum === 0) return 0;
        var digits = Math.pow(10, precision);
        var votesPerQuota = (0, parcelRequire("bahqM")).map(valueList, function(val) {
            return (isNaN(val) ? 0 : val) / sum * digits * 100;
        });
        var targetSeats = digits * 100;
        var seats = (0, parcelRequire("bahqM")).map(votesPerQuota, function(votes) {
            return Math.floor(votes);
        });
        var currentSum = (0, parcelRequire("bahqM")).reduce(seats, function(acc, val) {
            return acc + val;
        }, 0);
        var remainder = (0, parcelRequire("bahqM")).map(votesPerQuota, function(votes, idx) {
            return votes - seats[idx];
        });
        while(currentSum < targetSeats){
            var max = Number.NEGATIVE_INFINITY;
            var maxId = null;
            for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
                max = remainder[i];
                maxId = i;
            }
            ++seats[maxId];
            remainder[maxId] = 0;
            ++currentSum;
        }
        return seats[idx] / digits;
    }
    function $e19a9495965944b5$export$d3389a301c3a5706(val0, val1) {
        var maxPrecision = Math.max($e19a9495965944b5$export$e0c74b50bbd10f68(val0), $e19a9495965944b5$export$e0c74b50bbd10f68(val1));
        var sum = val0 + val1;
        return maxPrecision > $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $e19a9495965944b5$export$2077e0241d6afd3c(sum, maxPrecision);
    }
    var $e19a9495965944b5$export$18510406f204a1b9 = 9007199254740991;
    function $e19a9495965944b5$export$2ca6dd70a288b1c3(radian) {
        var pi2 = Math.PI * 2;
        return (radian % pi2 + pi2) % pi2;
    }
    function $e19a9495965944b5$export$d1df570aea2868f(val) {
        return val > -$e19a9495965944b5$var$RADIAN_EPSILON && val < $e19a9495965944b5$var$RADIAN_EPSILON;
    }
    var $e19a9495965944b5$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/;
    function $e19a9495965944b5$export$6b862160d295c8e(value) {
        if (value instanceof Date) return value;
        else if (typeof value === 'string') {
            var match = $e19a9495965944b5$var$TIME_REG.exec(value);
            if (!match) return new Date(NaN);
            if (!match[8]) return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
            else {
                var hour = +match[4] || 0;
                if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
                return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
            }
        } else if (value == null) return new Date(NaN);
        return new Date(Math.round(value));
    }
    function $e19a9495965944b5$export$82dd68b83a44b253(val) {
        return Math.pow(10, $e19a9495965944b5$export$97256a17b20a0c24(val));
    }
    function $e19a9495965944b5$export$97256a17b20a0c24(val) {
        if (val === 0) return 0;
        var exp = Math.floor(Math.log(val) / Math.LN10);
        if (val / Math.pow(10, exp) >= 10) exp++;
        return exp;
    }
    function $e19a9495965944b5$export$7a695fe44258210b(val, round) {
        var exponent = $e19a9495965944b5$export$97256a17b20a0c24(val);
        var exp10 = Math.pow(10, exponent);
        var f = val / exp10;
        var nf;
        if (round) {
            if (f < 1.5) nf = 1;
            else if (f < 2.5) nf = 2;
            else if (f < 4) nf = 3;
            else if (f < 7) nf = 5;
            else nf = 10;
        } else {
            if (f < 1) nf = 1;
            else if (f < 2) nf = 2;
            else if (f < 3) nf = 3;
            else if (f < 5) nf = 5;
            else nf = 10;
        }
        val = nf * exp10;
        return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
    }
    function $e19a9495965944b5$export$651fb4afdb6caa4b(ascArr, p) {
        var H = (ascArr.length - 1) * p + 1;
        var h = Math.floor(H);
        var v = +ascArr[h - 1];
        var e = H - h;
        return e ? v + e * (ascArr[h] - v) : v;
    }
    function $e19a9495965944b5$export$12f7386070bc380a(list) {
        list.sort(function(a, b) {
            return littleThan(a, b, 0) ? -1 : 1;
        });
        var curr = -Infinity;
        var currClose = 1;
        for(var i = 0; i < list.length;){
            var interval = list[i].interval;
            var close_1 = list[i].close;
            for(var lg = 0; lg < 2; lg++){
                if (interval[lg] <= curr) {
                    interval[lg] = curr;
                    close_1[lg] = !lg ? 1 - currClose : 1;
                }
                curr = interval[lg];
                currClose = close_1[lg];
            }
            if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
            else i++;
        }
        return list;
        function littleThan(a, b, lg) {
            return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
        }
    }
    function $e19a9495965944b5$export$8b4007b942b45a96(val) {
        var valFloat = parseFloat(val);
        return valFloat == val && (valFloat !== 0 || typeof val !== 'string' || val.indexOf('x') <= 0) ? valFloat : NaN;
    }
    function $e19a9495965944b5$export$e90fb89750dba83f(val) {
        return !isNaN($e19a9495965944b5$export$8b4007b942b45a96(val));
    }
    function $e19a9495965944b5$export$474d2ec9aa44a22() {
        return Math.round(Math.random() * 9);
    }
    function $e19a9495965944b5$export$a368fd580c0d0fe4(a, b) {
        if (b === 0) return a;
        return $e19a9495965944b5$export$a368fd580c0d0fe4(b, a % b);
    }
    function $e19a9495965944b5$export$680a45b749323f49(a, b) {
        if (a == null) return b;
        if (b == null) return a;
        return a * b / $e19a9495965944b5$export$a368fd580c0d0fe4(a, b);
    }
});
parcelRegister("eYgMC", function(module, exports) {
    $parcel$export(module.exports, "getAnimationConfig", ()=>$ae63b016ce1bd907$export$5cc7add7ab591d0a);
    $parcel$export(module.exports, "updateProps", ()=>$ae63b016ce1bd907$export$c8dce3c08436e91e);
    $parcel$export(module.exports, "initProps", ()=>$ae63b016ce1bd907$export$a121566aadcfe021);
    $parcel$export(module.exports, "isElementRemoved", ()=>$ae63b016ce1bd907$export$5b89d4b643713034);
    $parcel$export(module.exports, "removeElement", ()=>$ae63b016ce1bd907$export$f883456a56996078);
    $parcel$export(module.exports, "removeElementWithFadeOut", ()=>$ae63b016ce1bd907$export$6d0fd725cb4aee8a);
    $parcel$export(module.exports, "saveOldStyle", ()=>$ae63b016ce1bd907$export$bca7290a9faf0ec9);
    $parcel$export(module.exports, "getOldStyle", ()=>$ae63b016ce1bd907$export$ccb1f1e4d2fa86ac);
    var $bahqM;
    var $eaKsF;
    var $ae63b016ce1bd907$export$ae7433df314f6ec3 = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $ae63b016ce1bd907$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, extraOpts, extraDelayParams) {
        var animationPayload;
        if (animatableModel && animatableModel.ecModel) {
            var updatePayload = animatableModel.ecModel.getUpdatePayload();
            animationPayload = updatePayload && updatePayload.animation;
        }
        var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
        var isUpdate = animationType === 'update';
        if (animationEnabled) {
            var duration = void 0;
            var easing = void 0;
            var delay = void 0;
            if (extraOpts) {
                duration = (0, (0, parcelRequire("bahqM")).retrieve2)(extraOpts.duration, 200);
                easing = (0, (0, parcelRequire("bahqM")).retrieve2)(extraOpts.easing, 'cubicOut');
                delay = 0;
            } else {
                duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
                easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
                delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
            }
            if (animationPayload) {
                animationPayload.duration != null && (duration = animationPayload.duration);
                animationPayload.easing != null && (easing = animationPayload.easing);
                animationPayload.delay != null && (delay = animationPayload.delay);
            }
            if (typeof delay === 'function') delay = delay(dataIndex, extraDelayParams);
            if (typeof duration === 'function') duration = duration(dataIndex);
            var config = {
                duration: duration || 0,
                delay: delay,
                easing: easing
            };
            return config;
        } else return null;
    }
    function $ae63b016ce1bd907$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
        var isFrom = false;
        var removeOpt;
        if (typeof dataIndex === 'function') {
            during = cb;
            cb = dataIndex;
            dataIndex = null;
        } else if ((0, (0, parcelRequire("bahqM")).isObject)(dataIndex)) {
            cb = dataIndex.cb;
            during = dataIndex.during;
            isFrom = dataIndex.isFrom;
            removeOpt = dataIndex.removeOpt;
            dataIndex = dataIndex.dataIndex;
        }
        var isRemove = animationType === 'remove';
        if (!isRemove) el.stopAnimation('remove');
        var animationConfig = $ae63b016ce1bd907$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
        if (animationConfig && animationConfig.duration > 0) {
            var duration = animationConfig.duration;
            var animationDelay = animationConfig.delay;
            var animationEasing = animationConfig.easing;
            var animateConfig = {
                duration: duration,
                delay: animationDelay || 0,
                easing: animationEasing,
                done: cb,
                force: !!cb || !!during,
                setToFinal: !isRemove,
                scope: animationType,
                during: during
            };
            isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
        } else {
            el.stopAnimation();
            !isFrom && el.attr(props);
            during && during(1);
            cb && cb();
        }
    }
    function $ae63b016ce1bd907$export$c8dce3c08436e91e(el, props, animatableModel, dataIndex, cb, during) {
        $ae63b016ce1bd907$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
    }
    function $ae63b016ce1bd907$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
        $ae63b016ce1bd907$var$animateOrSetProps('init', el, props, animatableModel, dataIndex, cb, during);
    }
    function $ae63b016ce1bd907$export$5b89d4b643713034(el) {
        if (!el.__zr) return true;
        for(var i = 0; i < el.animators.length; i++){
            var animator = el.animators[i];
            if (animator.scope === 'remove') return true;
        }
        return false;
    }
    function $ae63b016ce1bd907$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
        if ($ae63b016ce1bd907$export$5b89d4b643713034(el)) return;
        $ae63b016ce1bd907$var$animateOrSetProps('remove', el, props, animatableModel, dataIndex, cb, during);
    }
    function $ae63b016ce1bd907$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
        el.removeTextContent();
        el.removeTextGuideLine();
        $ae63b016ce1bd907$export$f883456a56996078(el, {
            style: {
                opacity: 0
            }
        }, animatableModel, dataIndex, done);
    }
    function $ae63b016ce1bd907$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
        function doRemove() {
            el.parent && el.parent.remove(el);
        }
        if (!el.isGroup) $ae63b016ce1bd907$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
        else el.traverse(function(disp) {
            if (!disp.isGroup) $ae63b016ce1bd907$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
        });
    }
    function $ae63b016ce1bd907$export$bca7290a9faf0ec9(el) {
        $ae63b016ce1bd907$export$ae7433df314f6ec3(el).oldStyle = el.style;
    }
    function $ae63b016ce1bd907$export$ccb1f1e4d2fa86ac(el) {
        return $ae63b016ce1bd907$export$ae7433df314f6ec3(el).oldStyle;
    }
});
parcelRegister("lUzII", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff3a893c22158f47$export$2e2bcd8739ae039);
    var $3VFsf;
    var $7yklO;
    var $4KVOr;
    var $eYgMC;
    parcelRequire("fHITF");
    var $eYgMC;
    var $7QjoM;
    var $fIXXx;
    var $5MLZz;
    var $bahqM;
    var $gvLUt;
    var $gcbBH;
    var $eYgMC;
    var $ff3a893c22158f47$var$Symbol = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Symbol, _super);
        function Symbol(data, idx, seriesScope, opts) {
            var _this = _super.call(this) || this;
            _this.updateData(data, idx, seriesScope, opts);
            return _this;
        }
        Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, keepAspect) {
            this.removeAll();
            var symbolPath = (0, (0, parcelRequire("7yklO")).createSymbol)(symbolType, -1, -1, 2, 2, null, keepAspect);
            symbolPath.attr({
                z2: 100,
                culling: true,
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            });
            symbolPath.drift = $ff3a893c22158f47$var$driftSymbol;
            this._symbolType = symbolType;
            this.add(symbolPath);
        };
        Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
            this.childAt(0).stopAnimation(null, toLastFrame);
        };
        Symbol.prototype.getSymbolType = function() {
            return this._symbolType;
        };
        Symbol.prototype.getSymbolPath = function() {
            return this.childAt(0);
        };
        Symbol.prototype.highlight = function() {
            (0, (0, parcelRequire("fIXXx")).enterEmphasis)(this.childAt(0));
        };
        Symbol.prototype.downplay = function() {
            (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(this.childAt(0));
        };
        Symbol.prototype.setZ = function(zlevel, z) {
            var symbolPath = this.childAt(0);
            symbolPath.zlevel = zlevel;
            symbolPath.z = z;
        };
        Symbol.prototype.setDraggable = function(draggable) {
            var symbolPath = this.childAt(0);
            symbolPath.draggable = draggable;
            symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
        };
        Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
            this.silent = false;
            var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
            var seriesModel = data.hostModel;
            var symbolSize = Symbol.getSymbolSize(data, idx);
            var isInit = symbolType !== this._symbolType;
            var disableAnimation = opts && opts.disableAnimation;
            if (isInit) {
                var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
                this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
            } else {
                var symbolPath = this.childAt(0);
                symbolPath.silent = false;
                var target = {
                    scaleX: symbolSize[0] / 2,
                    scaleY: symbolSize[1] / 2
                };
                disableAnimation ? symbolPath.attr(target) : (0, parcelRequire("eYgMC")).updateProps(symbolPath, target, seriesModel, idx);
                (0, (0, parcelRequire("eYgMC")).saveOldStyle)(symbolPath);
            }
            this._updateCommon(data, idx, symbolSize, seriesScope, opts);
            if (isInit) {
                var symbolPath = this.childAt(0);
                if (!disableAnimation) {
                    var target = {
                        scaleX: this._sizeX,
                        scaleY: this._sizeY,
                        style: {
                            opacity: symbolPath.style.opacity
                        }
                    };
                    symbolPath.scaleX = symbolPath.scaleY = 0;
                    symbolPath.style.opacity = 0;
                    (0, parcelRequire("eYgMC")).initProps(symbolPath, target, seriesModel, idx);
                }
            }
            if (disableAnimation) this.childAt(0).stopAnimation('remove');
            this._seriesModel = seriesModel;
        };
        Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
            var symbolPath = this.childAt(0);
            var seriesModel = data.hostModel;
            var emphasisItemStyle;
            var blurItemStyle;
            var selectItemStyle;
            var focus;
            var blurScope;
            var labelStatesModels;
            var hoverScale;
            var cursorStyle;
            if (seriesScope) {
                emphasisItemStyle = seriesScope.emphasisItemStyle;
                blurItemStyle = seriesScope.blurItemStyle;
                selectItemStyle = seriesScope.selectItemStyle;
                focus = seriesScope.focus;
                blurScope = seriesScope.blurScope;
                labelStatesModels = seriesScope.labelStatesModels;
                hoverScale = seriesScope.hoverScale;
                cursorStyle = seriesScope.cursorStyle;
            }
            if (!seriesScope || data.hasItemOption) {
                var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
                var emphasisModel = itemModel.getModel('emphasis');
                emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
                selectItemStyle = itemModel.getModel([
                    'select',
                    'itemStyle'
                ]).getItemStyle();
                blurItemStyle = itemModel.getModel([
                    'blur',
                    'itemStyle'
                ]).getItemStyle();
                focus = emphasisModel.get('focus');
                blurScope = emphasisModel.get('blurScope');
                labelStatesModels = (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(itemModel);
                hoverScale = emphasisModel.getShallow('scale');
                cursorStyle = itemModel.getShallow('cursor');
            }
            var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
            symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
            var symbolOffset = (0, (0, parcelRequire("7yklO")).normalizeSymbolOffset)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
            if (symbolOffset) {
                symbolPath.x = symbolOffset[0];
                symbolPath.y = symbolOffset[1];
            }
            cursorStyle && symbolPath.attr('cursor', cursorStyle);
            var symbolStyle = data.getItemVisual(idx, 'style');
            var visualColor = symbolStyle.fill;
            if (symbolPath instanceof (0, (0, parcelRequire("gcbBH")).default)) {
                var pathStyle = symbolPath.style;
                symbolPath.useStyle((0, (0, parcelRequire("bahqM")).extend)({
                    image: pathStyle.image,
                    x: pathStyle.x,
                    y: pathStyle.y,
                    width: pathStyle.width,
                    height: pathStyle.height
                }, symbolStyle));
            } else {
                if (symbolPath.__isEmptyBrush) symbolPath.useStyle((0, (0, parcelRequire("bahqM")).extend)({}, symbolStyle));
                else symbolPath.useStyle(symbolStyle);
                symbolPath.style.decal = null;
                symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
                symbolPath.style.strokeNoScale = true;
            }
            var liftZ = data.getItemVisual(idx, 'liftZ');
            var z2Origin = this._z2;
            if (liftZ != null) {
                if (z2Origin == null) {
                    this._z2 = symbolPath.z2;
                    symbolPath.z2 += liftZ;
                }
            } else if (z2Origin != null) {
                symbolPath.z2 = z2Origin;
                this._z2 = null;
            }
            var useNameLabel = opts && opts.useNameLabel;
            (0, (0, parcelRequire("gvLUt")).setLabelStyle)(symbolPath, labelStatesModels, {
                labelFetcher: seriesModel,
                labelDataIndex: idx,
                defaultText: getLabelDefaultText,
                inheritColor: visualColor,
                defaultOpacity: symbolStyle.opacity
            });
            function getLabelDefaultText(idx) {
                return useNameLabel ? data.getName(idx) : (0, (0, parcelRequire("5MLZz")).getDefaultLabel)(data, idx);
            }
            this._sizeX = symbolSize[0] / 2;
            this._sizeY = symbolSize[1] / 2;
            var emphasisState = symbolPath.ensureState('emphasis');
            emphasisState.style = emphasisItemStyle;
            symbolPath.ensureState('select').style = selectItemStyle;
            symbolPath.ensureState('blur').style = blurItemStyle;
            if (hoverScale) {
                var scaleRatio = Math.max(1.1, 3 / this._sizeY);
                emphasisState.scaleX = this._sizeX * scaleRatio;
                emphasisState.scaleY = this._sizeY * scaleRatio;
            }
            this.setSymbolScale(1);
            (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(this, focus, blurScope);
        };
        Symbol.prototype.setSymbolScale = function(scale) {
            this.scaleX = this.scaleY = scale;
        };
        Symbol.prototype.fadeOut = function(cb, opt) {
            var symbolPath = this.childAt(0);
            var seriesModel = this._seriesModel;
            var dataIndex = (0, (0, parcelRequire("7QjoM")).getECData)(this).dataIndex;
            var animationOpt = opt && opt.animation;
            this.silent = symbolPath.silent = true;
            if (opt && opt.fadeLabel) {
                var textContent = symbolPath.getTextContent();
                if (textContent) (0, parcelRequire("eYgMC")).removeElement(textContent, {
                    style: {
                        opacity: 0
                    }
                }, seriesModel, {
                    dataIndex: dataIndex,
                    removeOpt: animationOpt,
                    cb: function() {
                        symbolPath.removeTextContent();
                    }
                });
            } else symbolPath.removeTextContent();
            (0, parcelRequire("eYgMC")).removeElement(symbolPath, {
                style: {
                    opacity: 0
                },
                scaleX: 0,
                scaleY: 0
            }, seriesModel, {
                dataIndex: dataIndex,
                cb: cb,
                removeOpt: animationOpt
            });
        };
        Symbol.getSymbolSize = function(data, idx) {
            return (0, (0, parcelRequire("7yklO")).normalizeSymbolSize)(data.getItemVisual(idx, 'symbolSize'));
        };
        return Symbol;
    }((0, parcelRequire("4KVOr")).default);
    function $ff3a893c22158f47$var$driftSymbol(dx, dy) {
        this.parent.drift(dx, dy);
    }
    var $ff3a893c22158f47$export$2e2bcd8739ae039 = $ff3a893c22158f47$var$Symbol;
});
parcelRegister("7yklO", function(module, exports) {
    $parcel$export(module.exports, "symbolBuildProxies", ()=>$57fb7e9c020cd915$export$33fc3b478d332725);
    $parcel$export(module.exports, "createSymbol", ()=>$57fb7e9c020cd915$export$af050e04da3a02e8);
    $parcel$export(module.exports, "normalizeSymbolSize", ()=>$57fb7e9c020cd915$export$a84524f03e8e8dfb);
    $parcel$export(module.exports, "normalizeSymbolOffset", ()=>$57fb7e9c020cd915$export$e3e292895c033f6d);
    var $bahqM;
    parcelRequire("fHITF");
    var $jjfok;
    var $cZb1F;
    var $fHITF;
    var $ghQ8v;
    var $7Tw7u;
    var $1E3E8;
    var $b7ZX8;
    var $jmSNG;
    var $57fb7e9c020cd915$var$Triangle = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'triangle',
        shape: {
            cx: 0,
            cy: 0,
            width: 0,
            height: 0
        },
        buildPath: function(path, shape) {
            var cx = shape.cx;
            var cy = shape.cy;
            var width = shape.width / 2;
            var height = shape.height / 2;
            path.moveTo(cx, cy - height);
            path.lineTo(cx + width, cy + height);
            path.lineTo(cx - width, cy + height);
            path.closePath();
        }
    });
    var $57fb7e9c020cd915$var$Diamond = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'diamond',
        shape: {
            cx: 0,
            cy: 0,
            width: 0,
            height: 0
        },
        buildPath: function(path, shape) {
            var cx = shape.cx;
            var cy = shape.cy;
            var width = shape.width / 2;
            var height = shape.height / 2;
            path.moveTo(cx, cy - height);
            path.lineTo(cx + width, cy);
            path.lineTo(cx, cy + height);
            path.lineTo(cx - width, cy);
            path.closePath();
        }
    });
    var $57fb7e9c020cd915$var$Pin = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'pin',
        shape: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        buildPath: function(path, shape) {
            var x = shape.x;
            var y = shape.y;
            var w = shape.width / 5 * 3;
            var h = Math.max(w, shape.height);
            var r = w / 2;
            var dy = r * r / (h - r);
            var cy = y - h + r + dy;
            var angle = Math.asin(dy / r);
            var dx = Math.cos(angle) * r;
            var tanX = Math.sin(angle);
            var tanY = Math.cos(angle);
            var cpLen = r * 0.6;
            var cpLen2 = r * 0.7;
            path.moveTo(x - dx, cy + dy);
            path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
            path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
            path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
            path.closePath();
        }
    });
    var $57fb7e9c020cd915$var$Arrow = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'arrow',
        shape: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        buildPath: function(ctx, shape) {
            var height = shape.height;
            var width = shape.width;
            var x = shape.x;
            var y = shape.y;
            var dx = width / 3 * 2;
            ctx.moveTo(x, y);
            ctx.lineTo(x + dx, y + height);
            ctx.lineTo(x, y + height / 4 * 3);
            ctx.lineTo(x - dx, y + height);
            ctx.lineTo(x, y);
            ctx.closePath();
        }
    });
    var $57fb7e9c020cd915$var$symbolCtors = {
        line: (0, parcelRequire("cZb1F")).default,
        rect: (0, parcelRequire("7Tw7u")).default,
        roundRect: (0, parcelRequire("7Tw7u")).default,
        square: (0, parcelRequire("7Tw7u")).default,
        circle: (0, parcelRequire("jjfok")).default,
        diamond: $57fb7e9c020cd915$var$Diamond,
        pin: $57fb7e9c020cd915$var$Pin,
        arrow: $57fb7e9c020cd915$var$Arrow,
        triangle: $57fb7e9c020cd915$var$Triangle
    };
    var $57fb7e9c020cd915$var$symbolShapeMakers = {
        line: function(x, y, w, h, shape) {
            shape.x1 = x;
            shape.y1 = y + h / 2;
            shape.x2 = x + w;
            shape.y2 = y + h / 2;
        },
        rect: function(x, y, w, h, shape) {
            shape.x = x;
            shape.y = y;
            shape.width = w;
            shape.height = h;
        },
        roundRect: function(x, y, w, h, shape) {
            shape.x = x;
            shape.y = y;
            shape.width = w;
            shape.height = h;
            shape.r = Math.min(w, h) / 4;
        },
        square: function(x, y, w, h, shape) {
            var size = Math.min(w, h);
            shape.x = x;
            shape.y = y;
            shape.width = size;
            shape.height = size;
        },
        circle: function(x, y, w, h, shape) {
            shape.cx = x + w / 2;
            shape.cy = y + h / 2;
            shape.r = Math.min(w, h) / 2;
        },
        diamond: function(x, y, w, h, shape) {
            shape.cx = x + w / 2;
            shape.cy = y + h / 2;
            shape.width = w;
            shape.height = h;
        },
        pin: function(x, y, w, h, shape) {
            shape.x = x + w / 2;
            shape.y = y + h / 2;
            shape.width = w;
            shape.height = h;
        },
        arrow: function(x, y, w, h, shape) {
            shape.x = x + w / 2;
            shape.y = y + h / 2;
            shape.width = w;
            shape.height = h;
        },
        triangle: function(x, y, w, h, shape) {
            shape.cx = x + w / 2;
            shape.cy = y + h / 2;
            shape.width = w;
            shape.height = h;
        }
    };
    var $57fb7e9c020cd915$export$33fc3b478d332725 = {};
    (0, (0, parcelRequire("bahqM")).each)($57fb7e9c020cd915$var$symbolCtors, function(Ctor, name) {
        $57fb7e9c020cd915$export$33fc3b478d332725[name] = new Ctor();
    });
    var $57fb7e9c020cd915$var$SymbolClz = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'symbol',
        shape: {
            symbolType: '',
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        calculateTextPosition: function(out, config, rect) {
            var res = (0, (0, parcelRequire("b7ZX8")).calculateTextPosition)(out, config, rect);
            var shape = this.shape;
            if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
            return res;
        },
        buildPath: function(ctx, shape, inBundle) {
            var symbolType = shape.symbolType;
            if (symbolType !== 'none') {
                var proxySymbol = $57fb7e9c020cd915$export$33fc3b478d332725[symbolType];
                if (!proxySymbol) {
                    symbolType = 'rect';
                    proxySymbol = $57fb7e9c020cd915$export$33fc3b478d332725[symbolType];
                }
                $57fb7e9c020cd915$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
                proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
            }
        }
    });
    function $57fb7e9c020cd915$var$symbolPathSetColor(color, innerColor) {
        if (this.type !== 'image') {
            var symbolStyle = this.style;
            if (this.__isEmptyBrush) {
                symbolStyle.stroke = color;
                symbolStyle.fill = innerColor || '#fff';
                symbolStyle.lineWidth = 2;
            } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
            else symbolStyle.fill = color;
            this.markRedraw();
        }
    }
    function $57fb7e9c020cd915$export$af050e04da3a02e8(symbolType, x, y, w, h, color, keepAspect) {
        var isEmpty = symbolType.indexOf('empty') === 0;
        if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
        var symbolPath;
        if (symbolType.indexOf('image://') === 0) symbolPath = (0, parcelRequire("fHITF")).makeImage(symbolType.slice(8), new (0, (0, parcelRequire("1E3E8")).default)(x, y, w, h), keepAspect ? 'center' : 'cover');
        else if (symbolType.indexOf('path://') === 0) symbolPath = (0, parcelRequire("fHITF")).makePath(symbolType.slice(7), {}, new (0, (0, parcelRequire("1E3E8")).default)(x, y, w, h), keepAspect ? 'center' : 'cover');
        else symbolPath = new $57fb7e9c020cd915$var$SymbolClz({
            shape: {
                symbolType: symbolType,
                x: x,
                y: y,
                width: w,
                height: h
            }
        });
        symbolPath.__isEmptyBrush = isEmpty;
        symbolPath.setColor = $57fb7e9c020cd915$var$symbolPathSetColor;
        if (color) symbolPath.setColor(color);
        return symbolPath;
    }
    function $57fb7e9c020cd915$export$a84524f03e8e8dfb(symbolSize) {
        if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolSize)) symbolSize = [
            +symbolSize,
            +symbolSize
        ];
        return [
            symbolSize[0] || 0,
            symbolSize[1] || 0
        ];
    }
    function $57fb7e9c020cd915$export$e3e292895c033f6d(symbolOffset, symbolSize) {
        if (symbolOffset == null) return;
        if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
        return [
            (0, (0, parcelRequire("jmSNG")).parsePercent)(symbolOffset[0], symbolSize[0]) || 0,
            (0, (0, parcelRequire("jmSNG")).parsePercent)((0, (0, parcelRequire("bahqM")).retrieve2)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
        ];
    }
});
parcelRegister("fIXXx", function(module, exports) {
    $parcel$export(module.exports, "HOVER_STATE_BLUR", ()=>$b72979b7cd946cce$export$1307d6a87d56baa);
    $parcel$export(module.exports, "HOVER_STATE_EMPHASIS", ()=>$b72979b7cd946cce$export$f0f2bee145debb31);
    $parcel$export(module.exports, "SPECIAL_STATES", ()=>$b72979b7cd946cce$export$151308dceb52d5b);
    $parcel$export(module.exports, "DISPLAY_STATES", ()=>$b72979b7cd946cce$export$57ee5306b85ad7d5);
    $parcel$export(module.exports, "Z2_EMPHASIS_LIFT", ()=>$b72979b7cd946cce$export$1cb9fc6ed5b9836c);
    $parcel$export(module.exports, "HIGHLIGHT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$df035d873a9de64f);
    $parcel$export(module.exports, "DOWNPLAY_ACTION_TYPE", ()=>$b72979b7cd946cce$export$f8a2f7807cc185ea);
    $parcel$export(module.exports, "SELECT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$89616263e7d38fe9);
    $parcel$export(module.exports, "UNSELECT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$7636ad95c0f68a79);
    $parcel$export(module.exports, "TOGGLE_SELECT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$1e90ed8a25542516);
    $parcel$export(module.exports, "setStatesFlag", ()=>$b72979b7cd946cce$export$868ba38adffa9e39);
    $parcel$export(module.exports, "setDefaultStateProxy", ()=>$b72979b7cd946cce$export$20f39bbe322fb9ab);
    $parcel$export(module.exports, "enterEmphasis", ()=>$b72979b7cd946cce$export$b2d02638cc34c042);
    $parcel$export(module.exports, "leaveEmphasis", ()=>$b72979b7cd946cce$export$11be6f716239ac55);
    $parcel$export(module.exports, "enterBlur", ()=>$b72979b7cd946cce$export$207f9cb3e1099375);
    $parcel$export(module.exports, "leaveBlur", ()=>$b72979b7cd946cce$export$fd4a9ec75456d3c1);
    $parcel$export(module.exports, "enterSelect", ()=>$b72979b7cd946cce$export$252d028dda8ef765);
    $parcel$export(module.exports, "leaveSelect", ()=>$b72979b7cd946cce$export$ea9a904bd6e32bd3);
    $parcel$export(module.exports, "allLeaveBlur", ()=>$b72979b7cd946cce$export$b2a593c7b5243584);
    $parcel$export(module.exports, "blurComponent", ()=>$b72979b7cd946cce$export$569da03256c8a55f);
    $parcel$export(module.exports, "blurSeriesFromHighlightPayload", ()=>$b72979b7cd946cce$export$64f1fd4daefef21b);
    $parcel$export(module.exports, "findComponentHighDownDispatchers", ()=>$b72979b7cd946cce$export$f31a644ccca0ef23);
    $parcel$export(module.exports, "handleGlobalMouseOverForHighDown", ()=>$b72979b7cd946cce$export$416765b6198234ff);
    $parcel$export(module.exports, "handleGlboalMouseOutForHighDown", ()=>$b72979b7cd946cce$export$2cbc9e6f4b583c84);
    $parcel$export(module.exports, "toggleSelectionFromPayload", ()=>$b72979b7cd946cce$export$1c7d489f62372d73);
    $parcel$export(module.exports, "isSelectChangePayload", ()=>$b72979b7cd946cce$export$72aea10e60e45351);
    $parcel$export(module.exports, "updateSeriesElementSelection", ()=>$b72979b7cd946cce$export$e4ea08ef52e0a73);
    $parcel$export(module.exports, "getAllSelectedIndices", ()=>$b72979b7cd946cce$export$c529643b619af6b3);
    $parcel$export(module.exports, "enableHoverEmphasis", ()=>$b72979b7cd946cce$export$5f393df0b5aee2e7);
    $parcel$export(module.exports, "setAsHighDownDispatcher", ()=>$b72979b7cd946cce$export$9ba15aea1e048d48);
    $parcel$export(module.exports, "enableHoverFocus", ()=>$b72979b7cd946cce$export$24972466b2b62ac2);
    $parcel$export(module.exports, "setStatesStylesFromModel", ()=>$b72979b7cd946cce$export$48b68047d330bbc9);
    $parcel$export(module.exports, "isHighDownDispatcher", ()=>$b72979b7cd946cce$export$77d1445f699c58b5);
    $parcel$export(module.exports, "enableComponentHighDownFeatures", ()=>$b72979b7cd946cce$export$4da05a9639f01954);
    $parcel$export(module.exports, "getHighlightDigit", ()=>$b72979b7cd946cce$export$824af40eb714530d);
    $parcel$export(module.exports, "isHighDownPayload", ()=>$b72979b7cd946cce$export$aebe71265c1b77bf);
    $parcel$export(module.exports, "savePathStates", ()=>$b72979b7cd946cce$export$9fe78019e6f395b6);
    var $h4RuA;
    var $bahqM;
    var $7QjoM;
    var $d6udH;
    var $eaKsF;
    var $ghQ8v;
    var $b72979b7cd946cce$var$_highlightNextDigit = 1;
    var $b72979b7cd946cce$var$_highlightKeyMap = {};
    var $b72979b7cd946cce$var$getSavedStates = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $b72979b7cd946cce$export$5542daa30722333e = 0;
    var $b72979b7cd946cce$export$1307d6a87d56baa = 1;
    var $b72979b7cd946cce$export$f0f2bee145debb31 = 2;
    var $b72979b7cd946cce$export$151308dceb52d5b = [
        'emphasis',
        'blur',
        'select'
    ];
    var $b72979b7cd946cce$export$57ee5306b85ad7d5 = [
        'normal',
        'emphasis',
        'blur',
        'select'
    ];
    var $b72979b7cd946cce$export$1cb9fc6ed5b9836c = 10;
    var $b72979b7cd946cce$export$3a2f97d39514bbc = 9;
    var $b72979b7cd946cce$export$df035d873a9de64f = 'highlight';
    var $b72979b7cd946cce$export$f8a2f7807cc185ea = 'downplay';
    var $b72979b7cd946cce$export$89616263e7d38fe9 = 'select';
    var $b72979b7cd946cce$export$7636ad95c0f68a79 = 'unselect';
    var $b72979b7cd946cce$export$1e90ed8a25542516 = 'toggleSelect';
    function $b72979b7cd946cce$var$hasFillOrStroke(fillOrStroke) {
        return fillOrStroke != null && fillOrStroke !== 'none';
    }
    var $b72979b7cd946cce$var$liftedColorCache = new (0, (0, parcelRequire("h4RuA")).default)(100);
    function $b72979b7cd946cce$var$liftColor(color) {
        if (typeof color !== 'string') return color;
        var liftedColor = $b72979b7cd946cce$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = (0, parcelRequire("d6udH")).lift(color, -0.1);
            $b72979b7cd946cce$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    }
    function $b72979b7cd946cce$var$doChangeHoverState(el, stateName, hoverStateEnum) {
        if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
        el.hoverState = hoverStateEnum;
    }
    function $b72979b7cd946cce$var$singleEnterEmphasis(el) {
        $b72979b7cd946cce$var$doChangeHoverState(el, 'emphasis', $b72979b7cd946cce$export$f0f2bee145debb31);
    }
    function $b72979b7cd946cce$var$singleLeaveEmphasis(el) {
        if (el.hoverState === $b72979b7cd946cce$export$f0f2bee145debb31) $b72979b7cd946cce$var$doChangeHoverState(el, 'normal', $b72979b7cd946cce$export$5542daa30722333e);
    }
    function $b72979b7cd946cce$var$singleEnterBlur(el) {
        $b72979b7cd946cce$var$doChangeHoverState(el, 'blur', $b72979b7cd946cce$export$1307d6a87d56baa);
    }
    function $b72979b7cd946cce$var$singleLeaveBlur(el) {
        if (el.hoverState === $b72979b7cd946cce$export$1307d6a87d56baa) $b72979b7cd946cce$var$doChangeHoverState(el, 'normal', $b72979b7cd946cce$export$5542daa30722333e);
    }
    function $b72979b7cd946cce$var$singleEnterSelect(el) {
        el.selected = true;
    }
    function $b72979b7cd946cce$var$singleLeaveSelect(el) {
        el.selected = false;
    }
    function $b72979b7cd946cce$var$updateElementState(el, updater, commonParam) {
        updater(el, commonParam);
    }
    function $b72979b7cd946cce$var$traverseUpdateState(el, updater, commonParam) {
        $b72979b7cd946cce$var$updateElementState(el, updater, commonParam);
        el.isGroup && el.traverse(function(child) {
            $b72979b7cd946cce$var$updateElementState(child, updater, commonParam);
        });
    }
    function $b72979b7cd946cce$export$868ba38adffa9e39(el, stateName) {
        switch(stateName){
            case 'emphasis':
                el.hoverState = $b72979b7cd946cce$export$f0f2bee145debb31;
                break;
            case 'normal':
                el.hoverState = $b72979b7cd946cce$export$5542daa30722333e;
                break;
            case 'blur':
                el.hoverState = $b72979b7cd946cce$export$1307d6a87d56baa;
                break;
            case 'select':
                el.selected = true;
        }
    }
    function $b72979b7cd946cce$export$35330f949342a669(el) {
        if (el.isGroup) el.traverse(function(child) {
            child.clearStates();
        });
        else el.clearStates();
    }
    function $b72979b7cd946cce$var$getFromStateStyle(el, props, toStateName, defaultValue) {
        var style = el.style;
        var fromState = {};
        for(var i = 0; i < props.length; i++){
            var propName = props[i];
            var val = style[propName];
            fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
        }
        for(var i = 0; i < el.animators.length; i++){
            var animator = el.animators[i];
            if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveFinalToTarget(fromState, props);
        }
        return fromState;
    }
    function $b72979b7cd946cce$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
        var hasSelect = targetStates && (0, (0, parcelRequire("bahqM")).indexOf)(targetStates, 'select') >= 0;
        var cloned = false;
        if (el instanceof (0, (0, parcelRequire("ghQ8v")).default)) {
            var store = $b72979b7cd946cce$var$getSavedStates(el);
            var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
            var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
            if ($b72979b7cd946cce$var$hasFillOrStroke(fromFill) || $b72979b7cd946cce$var$hasFillOrStroke(fromStroke)) {
                state = state || {};
                var emphasisStyle = state.style || {};
                if (emphasisStyle.fill === 'inherit') {
                    cloned = true;
                    state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                    emphasisStyle = (0, (0, parcelRequire("bahqM")).extend)({}, emphasisStyle);
                    emphasisStyle.fill = fromFill;
                } else if (!$b72979b7cd946cce$var$hasFillOrStroke(emphasisStyle.fill) && $b72979b7cd946cce$var$hasFillOrStroke(fromFill)) {
                    cloned = true;
                    state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                    emphasisStyle = (0, (0, parcelRequire("bahqM")).extend)({}, emphasisStyle);
                    emphasisStyle.fill = $b72979b7cd946cce$var$liftColor(fromFill);
                } else if (!$b72979b7cd946cce$var$hasFillOrStroke(emphasisStyle.stroke) && $b72979b7cd946cce$var$hasFillOrStroke(fromStroke)) {
                    if (!cloned) {
                        state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                        emphasisStyle = (0, (0, parcelRequire("bahqM")).extend)({}, emphasisStyle);
                    }
                    emphasisStyle.stroke = $b72979b7cd946cce$var$liftColor(fromStroke);
                }
                state.style = emphasisStyle;
            }
        }
        if (state) {
            if (state.z2 == null) {
                if (!cloned) state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                var z2EmphasisLift = el.z2EmphasisLift;
                state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $b72979b7cd946cce$export$1cb9fc6ed5b9836c);
            }
        }
        return state;
    }
    function $b72979b7cd946cce$var$createSelectDefaultState(el, stateName, state) {
        if (state) {
            if (state.z2 == null) {
                state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                var z2SelectLift = el.z2SelectLift;
                state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $b72979b7cd946cce$export$3a2f97d39514bbc);
            }
        }
        return state;
    }
    function $b72979b7cd946cce$var$createBlurDefaultState(el, stateName, state) {
        var hasBlur = (0, (0, parcelRequire("bahqM")).indexOf)(el.currentStates, stateName) >= 0;
        var currentOpacity = el.style.opacity;
        var fromState = !hasBlur ? $b72979b7cd946cce$var$getFromStateStyle(el, [
            'opacity'
        ], stateName, {
            opacity: 1
        }) : null;
        state = state || {};
        var blurStyle = state.style || {};
        if (blurStyle.opacity == null) {
            state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
            blurStyle = (0, (0, parcelRequire("bahqM")).extend)({
                opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
            }, blurStyle);
            state.style = blurStyle;
        }
        return state;
    }
    function $b72979b7cd946cce$var$elementStateProxy(stateName, targetStates) {
        var state = this.states[stateName];
        if (this.style) {
            if (stateName === 'emphasis') return $b72979b7cd946cce$var$createEmphasisDefaultState(this, stateName, targetStates, state);
            else if (stateName === 'blur') return $b72979b7cd946cce$var$createBlurDefaultState(this, stateName, state);
            else if (stateName === 'select') return $b72979b7cd946cce$var$createSelectDefaultState(this, stateName, state);
        }
        return state;
    }
    function $b72979b7cd946cce$export$20f39bbe322fb9ab(el) {
        el.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
        var textContent = el.getTextContent();
        var textGuide = el.getTextGuideLine();
        if (textContent) textContent.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
        if (textGuide) textGuide.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
    }
    function $b72979b7cd946cce$export$d899507e2598e4ae(el, e) {
        !$b72979b7cd946cce$var$shouldSilent(el, e) && !el.__highByOuter && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterEmphasis);
    }
    function $b72979b7cd946cce$export$784cba1f7fe58cca(el, e) {
        !$b72979b7cd946cce$var$shouldSilent(el, e) && !el.__highByOuter && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveEmphasis);
    }
    function $b72979b7cd946cce$export$b2d02638cc34c042(el, highlightDigit) {
        el.__highByOuter |= 1 << (highlightDigit || 0);
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterEmphasis);
    }
    function $b72979b7cd946cce$export$11be6f716239ac55(el, highlightDigit) {
        !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveEmphasis);
    }
    function $b72979b7cd946cce$export$207f9cb3e1099375(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterBlur);
    }
    function $b72979b7cd946cce$export$fd4a9ec75456d3c1(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveBlur);
    }
    function $b72979b7cd946cce$export$252d028dda8ef765(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterSelect);
    }
    function $b72979b7cd946cce$export$ea9a904bd6e32bd3(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveSelect);
    }
    function $b72979b7cd946cce$var$shouldSilent(el, e) {
        return el.__highDownSilentOnTouch && e.zrByTouch;
    }
    function $b72979b7cd946cce$export$b2a593c7b5243584(api) {
        var model = api.getModel();
        model.eachComponent(function(componentType, componentModel) {
            var view = componentType === 'series' ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
            view.group.traverse(function(child) {
                $b72979b7cd946cce$var$singleLeaveBlur(child);
            });
        });
    }
    function $b72979b7cd946cce$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
        var ecModel = api.getModel();
        blurScope = blurScope || 'coordinateSystem';
        function leaveBlurOfIndices(data, dataIndices) {
            for(var i = 0; i < dataIndices.length; i++){
                var itemEl = data.getItemGraphicEl(dataIndices[i]);
                itemEl && $b72979b7cd946cce$export$fd4a9ec75456d3c1(itemEl);
            }
        }
        if (targetSeriesIndex == null) return;
        if (!focus || focus === 'none') return;
        var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
        var targetCoordSys = targetSeriesModel.coordinateSystem;
        if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
        var blurredSeries = [];
        ecModel.eachSeries(function(seriesModel) {
            var sameSeries = targetSeriesModel === seriesModel;
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys && coordSys.master) coordSys = coordSys.master;
            var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries;
            if (!(blurScope === 'series' && !sameSeries || blurScope === 'coordinateSystem' && !sameCoordSys || focus === 'series' && sameSeries)) {
                var view = api.getViewOfSeriesModel(seriesModel);
                view.group.traverse(function(child) {
                    $b72979b7cd946cce$var$singleEnterBlur(child);
                });
                if ((0, (0, parcelRequire("bahqM")).isArrayLike)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
                else if ((0, (0, parcelRequire("bahqM")).isObject)(focus)) {
                    var dataTypes = (0, (0, parcelRequire("bahqM")).keys)(focus);
                    for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
                }
                blurredSeries.push(seriesModel);
            }
        });
        ecModel.eachComponent(function(componentType, componentModel) {
            if (componentType === 'series') return;
            var view = api.getViewOfComponentModel(componentModel);
            if (view && view.blurSeries) view.blurSeries(blurredSeries, ecModel);
        });
    }
    function $b72979b7cd946cce$export$569da03256c8a55f(componentMainType, componentIndex, api) {
        if (componentMainType == null || componentIndex == null) return;
        var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
        if (!componentModel) return;
        var view = api.getViewOfComponentModel(componentModel);
        if (!view || !view.focusBlurEnabled) return;
        view.group.traverse(function(child) {
            $b72979b7cd946cce$var$singleEnterBlur(child);
        });
    }
    function $b72979b7cd946cce$export$64f1fd4daefef21b(seriesModel, payload, api) {
        var seriesIndex = seriesModel.seriesIndex;
        var data = seriesModel.getData(payload.dataType);
        var dataIndex = (0, (0, parcelRequire("eaKsF")).queryDataIndex)(data, payload);
        dataIndex = ((0, (0, parcelRequire("bahqM")).isArray)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
        var el = data.getItemGraphicEl(dataIndex);
        if (!el) {
            var count = data.count();
            var current = 0;
            while(!el && current < count)el = data.getItemGraphicEl(current++);
        }
        if (el) {
            var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
            $b72979b7cd946cce$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
        } else {
            var focus_1 = seriesModel.get([
                'emphasis',
                'focus'
            ]);
            var blurScope = seriesModel.get([
                'emphasis',
                'blurScope'
            ]);
            if (focus_1 != null) $b72979b7cd946cce$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
        }
    }
    function $b72979b7cd946cce$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
        var ret = {
            focusSelf: false,
            dispatchers: null
        };
        if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
        var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
        if (!componentModel) return ret;
        var view = api.getViewOfComponentModel(componentModel);
        if (!view || !view.findHighDownDispatchers) return ret;
        var dispatchers = view.findHighDownDispatchers(name);
        var focusSelf;
        for(var i = 0; i < dispatchers.length; i++)if ((0, (0, parcelRequire("7QjoM")).getECData)(dispatchers[i]).focus === 'self') {
            focusSelf = true;
            break;
        }
        return {
            focusSelf: focusSelf,
            dispatchers: dispatchers
        };
    }
    function $b72979b7cd946cce$export$416765b6198234ff(dispatcher, e, api) {
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
        var _a = $b72979b7cd946cce$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
        if (dispatchers) {
            if (focusSelf) $b72979b7cd946cce$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
            (0, (0, parcelRequire("bahqM")).each)(dispatchers, function(dispatcher) {
                return $b72979b7cd946cce$export$d899507e2598e4ae(dispatcher, e);
            });
        } else {
            $b72979b7cd946cce$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
            if (ecData.focus === 'self') $b72979b7cd946cce$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
            $b72979b7cd946cce$export$d899507e2598e4ae(dispatcher, e);
        }
    }
    function $b72979b7cd946cce$export$2cbc9e6f4b583c84(dispatcher, e, api) {
        $b72979b7cd946cce$export$b2a593c7b5243584(api);
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
        var dispatchers = $b72979b7cd946cce$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
        if (dispatchers) (0, (0, parcelRequire("bahqM")).each)(dispatchers, function(dispatcher) {
            return $b72979b7cd946cce$export$784cba1f7fe58cca(dispatcher, e);
        });
        else $b72979b7cd946cce$export$784cba1f7fe58cca(dispatcher, e);
    }
    function $b72979b7cd946cce$export$1c7d489f62372d73(seriesModel, payload, api) {
        if (!$b72979b7cd946cce$export$72aea10e60e45351(payload)) return;
        var dataType = payload.dataType;
        var data = seriesModel.getData(dataType);
        var dataIndex = (0, (0, parcelRequire("eaKsF")).queryDataIndex)(data, payload);
        if (!(0, (0, parcelRequire("bahqM")).isArray)(dataIndex)) dataIndex = [
            dataIndex
        ];
        seriesModel[payload.type === $b72979b7cd946cce$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $b72979b7cd946cce$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
    }
    function $b72979b7cd946cce$export$e4ea08ef52e0a73(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, (0, parcelRequire("bahqM")).each)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            data.eachItemGraphicEl(function(el, idx) {
                seriesModel.isSelected(idx, type) ? $b72979b7cd946cce$export$252d028dda8ef765(el) : $b72979b7cd946cce$export$ea9a904bd6e32bd3(el);
            });
        });
    }
    function $b72979b7cd946cce$export$c529643b619af6b3(ecModel) {
        var ret = [];
        ecModel.eachSeries(function(seriesModel) {
            var allData = seriesModel.getAllData();
            (0, (0, parcelRequire("bahqM")).each)(allData, function(_a) {
                var data = _a.data, type = _a.type;
                var dataIndices = seriesModel.getSelectedDataIndices();
                if (dataIndices.length > 0) {
                    var item = {
                        dataIndex: dataIndices,
                        seriesIndex: seriesModel.seriesIndex
                    };
                    if (type != null) item.dataType = type;
                    ret.push(item);
                }
            });
        });
        return ret;
    }
    function $b72979b7cd946cce$export$5f393df0b5aee2e7(el, focus, blurScope) {
        $b72979b7cd946cce$export$9ba15aea1e048d48(el, true);
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$export$20f39bbe322fb9ab);
        $b72979b7cd946cce$export$24972466b2b62ac2(el, focus, blurScope);
    }
    function $b72979b7cd946cce$export$24972466b2b62ac2(el, focus, blurScope) {
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
        if (focus != null) {
            ecData.focus = focus;
            ecData.blurScope = blurScope;
        } else if (ecData.focus) ecData.focus = null;
    }
    var $b72979b7cd946cce$var$OTHER_STATES = [
        'emphasis',
        'blur',
        'select'
    ];
    var $b72979b7cd946cce$var$defaultStyleGetterMap = {
        itemStyle: 'getItemStyle',
        lineStyle: 'getLineStyle',
        areaStyle: 'getAreaStyle'
    };
    function $b72979b7cd946cce$export$48b68047d330bbc9(el, itemModel, styleType, getter) {
        styleType = styleType || 'itemStyle';
        for(var i = 0; i < $b72979b7cd946cce$var$OTHER_STATES.length; i++){
            var stateName = $b72979b7cd946cce$var$OTHER_STATES[i];
            var model = itemModel.getModel([
                stateName,
                styleType
            ]);
            var state = el.ensureState(stateName);
            state.style = getter ? getter(model) : model[$b72979b7cd946cce$var$defaultStyleGetterMap[styleType]]();
        }
    }
    function $b72979b7cd946cce$export$9ba15aea1e048d48(el, asDispatcher) {
        var disable = asDispatcher === false;
        var extendedEl = el;
        if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
        if (!disable || extendedEl.__highDownDispatcher) {
            extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
            extendedEl.__highDownDispatcher = !disable;
        }
    }
    function $b72979b7cd946cce$export$77d1445f699c58b5(el) {
        return !!(el && el.__highDownDispatcher);
    }
    function $b72979b7cd946cce$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
        ecData.componentMainType = componentModel.mainType;
        ecData.componentIndex = componentModel.componentIndex;
        ecData.componentHighDownName = componentHighDownName;
    }
    function $b72979b7cd946cce$export$824af40eb714530d(highlightKey) {
        var highlightDigit = $b72979b7cd946cce$var$_highlightKeyMap[highlightKey];
        if (highlightDigit == null && $b72979b7cd946cce$var$_highlightNextDigit <= 32) highlightDigit = $b72979b7cd946cce$var$_highlightKeyMap[highlightKey] = $b72979b7cd946cce$var$_highlightNextDigit++;
        return highlightDigit;
    }
    function $b72979b7cd946cce$export$72aea10e60e45351(payload) {
        var payloadType = payload.type;
        return payloadType === $b72979b7cd946cce$export$89616263e7d38fe9 || payloadType === $b72979b7cd946cce$export$7636ad95c0f68a79 || payloadType === $b72979b7cd946cce$export$1e90ed8a25542516;
    }
    function $b72979b7cd946cce$export$aebe71265c1b77bf(payload) {
        var payloadType = payload.type;
        return payloadType === $b72979b7cd946cce$export$df035d873a9de64f || payloadType === $b72979b7cd946cce$export$f8a2f7807cc185ea;
    }
    function $b72979b7cd946cce$export$9fe78019e6f395b6(el) {
        var store = $b72979b7cd946cce$var$getSavedStates(el);
        store.normalFill = el.style.fill;
        store.normalStroke = el.style.stroke;
        var selectState = el.states.select || {};
        store.selectFill = selectState.style && selectState.style.fill || null;
        store.selectStroke = selectState.style && selectState.style.stroke || null;
    }
});
parcelRegister("5MLZz", function(module, exports) {
    $parcel$export(module.exports, "getDefaultLabel", ()=>$4366a9b1a430c1e7$export$5ff20667590927ed);
    $parcel$export(module.exports, "getDefaultInterpolatedLabel", ()=>$4366a9b1a430c1e7$export$5f84815e91ca6775);
    var $9OHWG;
    var $bahqM;
    function $4366a9b1a430c1e7$export$5ff20667590927ed(data, dataIndex) {
        var labelDims = data.mapDimensionsAll('defaultedLabel');
        var len = labelDims.length;
        if (len === 1) {
            var rawVal = (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, labelDims[0]);
            return rawVal != null ? rawVal + '' : null;
        } else if (len) {
            var vals = [];
            for(var i = 0; i < labelDims.length; i++)vals.push((0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, labelDims[i]));
            return vals.join(' ');
        }
    }
    function $4366a9b1a430c1e7$export$5f84815e91ca6775(data, interpolatedValue) {
        var labelDims = data.mapDimensionsAll('defaultedLabel');
        if (!(0, (0, parcelRequire("bahqM")).isArray)(interpolatedValue)) return interpolatedValue + '';
        var vals = [];
        for(var i = 0; i < labelDims.length; i++){
            var dimIndex = data.getDimensionIndex(labelDims[i]);
            if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
        }
        return vals.join(' ');
    }
});
parcelRegister("9OHWG", function(module, exports) {
    $parcel$export(module.exports, "DefaultDataProvider", ()=>$725adf3ea01375e6$export$b900d7c4c3952a40);
    $parcel$export(module.exports, "getRawSourceItemGetter", ()=>$725adf3ea01375e6$export$92c8ea8642b3957d);
    $parcel$export(module.exports, "getRawSourceDataCounter", ()=>$725adf3ea01375e6$export$803742e832f4b52c);
    $parcel$export(module.exports, "getRawSourceValueGetter", ()=>$725adf3ea01375e6$export$1752de8084789a14);
    $parcel$export(module.exports, "retrieveRawValue", ()=>$725adf3ea01375e6$export$cde9373da9aad801);
    var $bahqM;
    var $eaKsF;
    var $20liu;
    var $2Rbm1;
    var $725adf3ea01375e6$var$_a, $725adf3ea01375e6$var$_b, $725adf3ea01375e6$var$_c;
    var $725adf3ea01375e6$var$providerMethods;
    var $725adf3ea01375e6$var$mountMethods;
    var $725adf3ea01375e6$export$b900d7c4c3952a40 = function() {
        function DefaultDataProvider(sourceParam, dimSize) {
            var source = !(0, (0, parcelRequire("20liu")).isSourceInstance)(sourceParam) ? (0, (0, parcelRequire("20liu")).createSourceFromSeriesDataOption)(sourceParam) : sourceParam;
            this._source = source;
            var data = this._data = source.data;
            if (source.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY)) {
                this._offset = 0;
                this._dimSize = dimSize;
                this._data = data;
            }
            $725adf3ea01375e6$var$mountMethods(this, data, source);
        }
        DefaultDataProvider.prototype.getSource = function() {
            return this._source;
        };
        DefaultDataProvider.prototype.count = function() {
            return 0;
        };
        DefaultDataProvider.prototype.getItem = function(idx, out) {
            return;
        };
        DefaultDataProvider.prototype.appendData = function(newData) {};
        DefaultDataProvider.prototype.clean = function() {};
        DefaultDataProvider.protoInitialize = function() {
            var proto = DefaultDataProvider.prototype;
            proto.pure = false;
            proto.persistent = true;
        }();
        DefaultDataProvider.internalField = function() {
            var _a;
            $725adf3ea01375e6$var$mountMethods = function(provider, data, source) {
                var sourceFormat = source.sourceFormat;
                var seriesLayoutBy = source.seriesLayoutBy;
                var startIndex = source.startIndex;
                var dimsDef = source.dimensionsDefine;
                var methods = $725adf3ea01375e6$var$providerMethods[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
                (0, (0, parcelRequire("bahqM")).extend)(provider, methods);
                if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY)) {
                    provider.getItem = getItemForTypedArray;
                    provider.count = countForTypedArray;
                    provider.fillStorage = fillStorageForTypedArray;
                } else {
                    var rawItemGetter = $725adf3ea01375e6$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                    provider.getItem = (0, (0, parcelRequire("bahqM")).bind)(rawItemGetter, null, data, startIndex, dimsDef);
                    var rawCounter = $725adf3ea01375e6$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                    provider.count = (0, (0, parcelRequire("bahqM")).bind)(rawCounter, null, data, startIndex, dimsDef);
                }
            };
            var getItemForTypedArray = function(idx, out) {
                idx = idx - this._offset;
                out = out || [];
                var data = this._data;
                var dimSize = this._dimSize;
                var offset = dimSize * idx;
                for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
                return out;
            };
            var fillStorageForTypedArray = function(start, end, storage, extent) {
                var data = this._data;
                var dimSize = this._dimSize;
                for(var dim = 0; dim < dimSize; dim++){
                    var dimExtent = extent[dim];
                    var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                    var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                    var count = end - start;
                    var arr = storage[dim];
                    for(var i = 0; i < count; i++){
                        var val = data[i * dimSize + dim];
                        arr[start + i] = val;
                        val < min && (min = val);
                        val > max && (max = val);
                    }
                    dimExtent[0] = min;
                    dimExtent[1] = max;
                }
            };
            var countForTypedArray = function() {
                return this._data ? this._data.length / this._dimSize : 0;
            };
            $725adf3ea01375e6$var$providerMethods = (_a = {}, _a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)] = {
                pure: true,
                appendData: appendDataSimply
            }, _a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)] = {
                pure: true,
                appendData: function() {
                    throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
                }
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = {
                pure: true,
                appendData: appendDataSimply
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = {
                pure: true,
                appendData: function(newData) {
                    var data = this._data;
                    (0, (0, parcelRequire("bahqM")).each)(newData, function(newCol, key) {
                        var oldCol = data[key] || (data[key] = []);
                        for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                    });
                }
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = {
                appendData: appendDataSimply
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY] = {
                persistent: false,
                pure: true,
                appendData: function(newData) {
                    this._data = newData;
                },
                clean: function() {
                    this._offset += this.count();
                    this._data = null;
                }
            }, _a);
            function appendDataSimply(newData) {
                for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
            }
        }();
        return DefaultDataProvider;
    }();
    var $725adf3ea01375e6$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
        return rawData[idx];
    };
    var $725adf3ea01375e6$var$rawSourceItemGetterMap = ($725adf3ea01375e6$var$_a = {}, $725adf3ea01375e6$var$_a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef, idx) {
        return rawData[idx + startIndex];
    }, $725adf3ea01375e6$var$_a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef, idx, out) {
        idx += startIndex;
        var item = out || [];
        var data = rawData;
        for(var i = 0; i < data.length; i++){
            var row = data[i];
            item[i] = row ? row[idx] : null;
        }
        return item;
    }, $725adf3ea01375e6$var$_a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = $725adf3ea01375e6$var$getItemSimply, $725adf3ea01375e6$var$_a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef, idx, out) {
        var item = out || [];
        for(var i = 0; i < dimsDef.length; i++){
            var dimName = dimsDef[i].name;
            var col = rawData[dimName];
            item[i] = col ? col[idx] : null;
        }
        return item;
    }, $725adf3ea01375e6$var$_a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = $725adf3ea01375e6$var$getItemSimply, $725adf3ea01375e6$var$_a);
    function $725adf3ea01375e6$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
        var method = $725adf3ea01375e6$var$rawSourceItemGetterMap[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
        return method;
    }
    var $725adf3ea01375e6$var$countSimply = function(rawData, startIndex, dimsDef) {
        return rawData.length;
    };
    var $725adf3ea01375e6$var$rawSourceDataCounterMap = ($725adf3ea01375e6$var$_b = {}, $725adf3ea01375e6$var$_b[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef) {
        return Math.max(0, rawData.length - startIndex);
    }, $725adf3ea01375e6$var$_b[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef) {
        var row = rawData[0];
        return row ? Math.max(0, row.length - startIndex) : 0;
    }, $725adf3ea01375e6$var$_b[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = $725adf3ea01375e6$var$countSimply, $725adf3ea01375e6$var$_b[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef) {
        var dimName = dimsDef[0].name;
        var col = rawData[dimName];
        return col ? col.length : 0;
    }, $725adf3ea01375e6$var$_b[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = $725adf3ea01375e6$var$countSimply, $725adf3ea01375e6$var$_b);
    function $725adf3ea01375e6$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
        var method = $725adf3ea01375e6$var$rawSourceDataCounterMap[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
        return method;
    }
    var $725adf3ea01375e6$var$getRawValueSimply = function(dataItem, dimIndex, property) {
        return dataItem[dimIndex];
    };
    var $725adf3ea01375e6$var$rawSourceValueGetterMap = ($725adf3ea01375e6$var$_c = {}, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = function(dataItem, dimIndex, property) {
        return dataItem[property];
    }, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = function(dataItem, dimIndex, property) {
        var value = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(dataItem);
        return !(value instanceof Array) ? value : value[dimIndex];
    }, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c);
    function $725adf3ea01375e6$export$1752de8084789a14(sourceFormat) {
        var method = $725adf3ea01375e6$var$rawSourceValueGetterMap[sourceFormat];
        return method;
    }
    function $725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
        return sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
    }
    function $725adf3ea01375e6$export$cde9373da9aad801(data, dataIndex, dim) {
        if (!data) return;
        var dataItem = data.getRawDataItem(dataIndex);
        if (dataItem == null) return;
        var store = data.getStore();
        var sourceFormat = store.getSource().sourceFormat;
        if (dim != null) {
            var dimIndex = data.getDimensionIndex(dim);
            var property = store.getDimensionProperty(dimIndex);
            return $725adf3ea01375e6$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
        } else {
            var result = dataItem;
            if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) result = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(dataItem);
            return result;
        }
    }
    function $725adf3ea01375e6$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
        if (!data) return;
        var sourceFormat = data.getStore().getSource().sourceFormat;
        if (sourceFormat !== (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL) && sourceFormat !== (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) return;
        var dataItem = data.getRawDataItem(dataIndex);
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL) && !(0, (0, parcelRequire("bahqM")).isObject)(dataItem)) dataItem = null;
        if (dataItem) return dataItem[attr];
    }
});
parcelRegister("20liu", function(module, exports) {
    $parcel$export(module.exports, "isSourceInstance", ()=>$175c1a118c738be0$export$22b808bc02a60488);
    $parcel$export(module.exports, "createSource", ()=>$175c1a118c738be0$export$1921362e86c73c88);
    $parcel$export(module.exports, "detectSourceFormat", ()=>$175c1a118c738be0$export$52a469afa4653e57);
    $parcel$export(module.exports, "createSourceFromSeriesDataOption", ()=>$175c1a118c738be0$export$75aef3f97c0a5edf);
    $parcel$export(module.exports, "cloneSourceShallow", ()=>$175c1a118c738be0$export$e0365e7e3555ddd4);
    $parcel$export(module.exports, "shouldRetrieveDataByName", ()=>$175c1a118c738be0$export$8911336b527f8517);
    var $bahqM;
    var $2Rbm1;
    var $eaKsF;
    var $cNGs8;
    var $175c1a118c738be0$var$SourceImpl = function() {
        function SourceImpl(fields) {
            this.data = fields.data || (fields.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS) ? {} : []);
            this.sourceFormat = fields.sourceFormat || (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_UNKNOWN);
            this.seriesLayoutBy = fields.seriesLayoutBy || (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN);
            this.startIndex = fields.startIndex || 0;
            this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
            this.metaRawOption = fields.metaRawOption;
            var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
            if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
                var dim = dimensionsDefine[i];
                if (dim.type == null) {
                    if ((0, (0, parcelRequire("cNGs8")).guessOrdinal)(this, i) === (0, (0, parcelRequire("cNGs8")).BE_ORDINAL).Must) dim.type = 'ordinal';
                }
            }
        }
        return SourceImpl;
    }();
    function $175c1a118c738be0$export$22b808bc02a60488(val) {
        return val instanceof $175c1a118c738be0$var$SourceImpl;
    }
    function $175c1a118c738be0$export$1921362e86c73c88(sourceData, thisMetaRawOption, sourceFormat) {
        sourceFormat = sourceFormat || $175c1a118c738be0$export$52a469afa4653e57(sourceData);
        var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
        var determined = $175c1a118c738be0$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
        var source = new $175c1a118c738be0$var$SourceImpl({
            data: sourceData,
            sourceFormat: sourceFormat,
            seriesLayoutBy: seriesLayoutBy,
            dimensionsDefine: determined.dimensionsDefine,
            startIndex: determined.startIndex,
            dimensionsDetectedCount: determined.dimensionsDetectedCount,
            metaRawOption: (0, (0, parcelRequire("bahqM")).clone)(thisMetaRawOption)
        });
        return source;
    }
    function $175c1a118c738be0$export$75aef3f97c0a5edf(data) {
        return new $175c1a118c738be0$var$SourceImpl({
            data: data,
            sourceFormat: (0, (0, parcelRequire("bahqM")).isTypedArray)(data) ? (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY) : (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)
        });
    }
    function $175c1a118c738be0$export$e0365e7e3555ddd4(source) {
        return new $175c1a118c738be0$var$SourceImpl({
            data: source.data,
            sourceFormat: source.sourceFormat,
            seriesLayoutBy: source.seriesLayoutBy,
            dimensionsDefine: (0, (0, parcelRequire("bahqM")).clone)(source.dimensionsDefine),
            startIndex: source.startIndex,
            dimensionsDetectedCount: source.dimensionsDetectedCount
        });
    }
    function $175c1a118c738be0$export$52a469afa4653e57(data) {
        var sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_UNKNOWN);
        if ((0, (0, parcelRequire("bahqM")).isTypedArray)(data)) sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY);
        else if ((0, (0, parcelRequire("bahqM")).isArray)(data)) {
            if (data.length === 0) sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS);
            for(var i = 0, len = data.length; i < len; i++){
                var item = data[i];
                if (item == null) continue;
                else if ((0, (0, parcelRequire("bahqM")).isArray)(item)) {
                    sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS);
                    break;
                } else if ((0, (0, parcelRequire("bahqM")).isObject)(item)) {
                    sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS);
                    break;
                }
            }
        } else if ((0, (0, parcelRequire("bahqM")).isObject)(data)) {
            for(var key in data)if ((0, (0, parcelRequire("bahqM")).hasOwn)(data, key) && (0, (0, parcelRequire("bahqM")).isArrayLike)(data[key])) {
                sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS);
                break;
            }
        }
        return sourceFormat;
    }
    function $175c1a118c738be0$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
        var dimensionsDetectedCount;
        var startIndex;
        if (!data) return {
            dimensionsDefine: $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine),
            startIndex: startIndex,
            dimensionsDetectedCount: dimensionsDetectedCount
        };
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS)) {
            var dataArrayRows = data;
            if (sourceHeader === 'auto' || sourceHeader == null) $175c1a118c738be0$var$arrayRowsTravelFirst(function(val) {
                if (val != null && val !== '-') {
                    if ((0, (0, parcelRequire("bahqM")).isString)(val)) startIndex == null && (startIndex = 1);
                    else startIndex = 0;
                }
            }, seriesLayoutBy, dataArrayRows, 10);
            else startIndex = (0, (0, parcelRequire("bahqM")).isNumber)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
            if (!dimensionsDefine && startIndex === 1) {
                dimensionsDefine = [];
                $175c1a118c738be0$var$arrayRowsTravelFirst(function(val, index) {
                    dimensionsDefine[index] = val != null ? val + '' : '';
                }, seriesLayoutBy, dataArrayRows, Infinity);
            }
            dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) {
            if (!dimensionsDefine) dimensionsDefine = $175c1a118c738be0$var$objectRowsCollectDimensions(data);
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS)) {
            if (!dimensionsDefine) {
                dimensionsDefine = [];
                (0, (0, parcelRequire("bahqM")).each)(data, function(colArr, key) {
                    dimensionsDefine.push(key);
                });
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) {
            var value0 = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(data[0]);
            dimensionsDetectedCount = (0, (0, parcelRequire("bahqM")).isArray)(value0) && value0.length || 1;
        }
        return {
            startIndex: startIndex,
            dimensionsDefine: $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine),
            dimensionsDetectedCount: dimensionsDetectedCount
        };
    }
    function $175c1a118c738be0$var$objectRowsCollectDimensions(data) {
        var firstIndex = 0;
        var obj;
        while(firstIndex < data.length && !(obj = data[firstIndex++]));
        if (obj) {
            var dimensions_1 = [];
            (0, (0, parcelRequire("bahqM")).each)(obj, function(value, key) {
                dimensions_1.push(key);
            });
            return dimensions_1;
        }
    }
    function $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine) {
        if (!dimensionsDefine) return;
        var nameMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        return (0, (0, parcelRequire("bahqM")).map)(dimensionsDefine, function(rawItem, index) {
            rawItem = (0, (0, parcelRequire("bahqM")).isObject)(rawItem) ? rawItem : {
                name: rawItem
            };
            var item = {
                name: rawItem.name,
                displayName: rawItem.displayName,
                type: rawItem.type
            };
            if (item.name == null) return item;
            item.name += '';
            if (item.displayName == null) item.displayName = item.name;
            var exist = nameMap.get(item.name);
            if (!exist) nameMap.set(item.name, {
                count: 1
            });
            else item.name += '-' + exist.count++;
            return item;
        });
    }
    function $175c1a118c738be0$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
        if (seriesLayoutBy === (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
        else {
            var value0 = data[0] || [];
            for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
        }
    }
    function $175c1a118c738be0$export$8911336b527f8517(source) {
        var sourceFormat = source.sourceFormat;
        return sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS);
    }
});
parcelRegister("2Rbm1", function(module, exports) {
    $parcel$export(module.exports, "VISUAL_DIMENSIONS", ()=>$214956bc17bbe3d3$export$cd51b5ca77f6f0e4);
    $parcel$export(module.exports, "SOURCE_FORMAT_ORIGINAL", ()=>$214956bc17bbe3d3$export$2823037fb9d8f0c6);
    $parcel$export(module.exports, "SOURCE_FORMAT_ARRAY_ROWS", ()=>$214956bc17bbe3d3$export$fcd62ebf51387903);
    $parcel$export(module.exports, "SOURCE_FORMAT_OBJECT_ROWS", ()=>$214956bc17bbe3d3$export$703ae8a2d83f441);
    $parcel$export(module.exports, "SOURCE_FORMAT_KEYED_COLUMNS", ()=>$214956bc17bbe3d3$export$6a32b42c754a3cb8);
    $parcel$export(module.exports, "SOURCE_FORMAT_TYPED_ARRAY", ()=>$214956bc17bbe3d3$export$a918cb016a382d45);
    $parcel$export(module.exports, "SOURCE_FORMAT_UNKNOWN", ()=>$214956bc17bbe3d3$export$c78f1330778d30d);
    $parcel$export(module.exports, "SERIES_LAYOUT_BY_COLUMN", ()=>$214956bc17bbe3d3$export$7b3f3c6551b4949b);
    $parcel$export(module.exports, "SERIES_LAYOUT_BY_ROW", ()=>$214956bc17bbe3d3$export$d55da1467cdf7804);
    var $bahqM;
    var $214956bc17bbe3d3$export$cd51b5ca77f6f0e4 = (0, (0, parcelRequire("bahqM")).createHashMap)([
        'tooltip',
        'label',
        'itemName',
        'itemId',
        'itemGroupId',
        'seriesName'
    ]);
    var $214956bc17bbe3d3$export$2823037fb9d8f0c6 = 'original';
    var $214956bc17bbe3d3$export$fcd62ebf51387903 = 'arrayRows';
    var $214956bc17bbe3d3$export$703ae8a2d83f441 = 'objectRows';
    var $214956bc17bbe3d3$export$6a32b42c754a3cb8 = 'keyedColumns';
    var $214956bc17bbe3d3$export$a918cb016a382d45 = 'typedArray';
    var $214956bc17bbe3d3$export$c78f1330778d30d = 'unknown';
    var $214956bc17bbe3d3$export$7b3f3c6551b4949b = 'column';
    var $214956bc17bbe3d3$export$d55da1467cdf7804 = 'row';
});
parcelRegister("cNGs8", function(module, exports) {
    $parcel$export(module.exports, "BE_ORDINAL", ()=>$951afdda7935b9af$export$328749e9c5b40760);
    $parcel$export(module.exports, "resetSourceDefaulter", ()=>$951afdda7935b9af$export$b30cdea50aa00e6);
    $parcel$export(module.exports, "makeSeriesEncodeForAxisCoordSys", ()=>$951afdda7935b9af$export$37682b8fdd2e83d);
    $parcel$export(module.exports, "querySeriesUpstreamDatasetModel", ()=>$951afdda7935b9af$export$8da66f73a1eda454);
    $parcel$export(module.exports, "makeSeriesEncodeForNameBased", ()=>$951afdda7935b9af$export$60b8a57d1f2fed26);
    $parcel$export(module.exports, "queryDatasetUpstreamDatasetModels", ()=>$951afdda7935b9af$export$397ba553479711e7);
    $parcel$export(module.exports, "guessOrdinal", ()=>$951afdda7935b9af$export$c51adf1a2be01b9c);
    var $eaKsF;
    var $bahqM;
    var $2Rbm1;
    var $951afdda7935b9af$export$328749e9c5b40760 = {
        Must: 1,
        Might: 2,
        Not: 3
    };
    var $951afdda7935b9af$var$innerGlobalModel = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $951afdda7935b9af$export$b30cdea50aa00e6(ecModel) {
        $951afdda7935b9af$var$innerGlobalModel(ecModel).datasetMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
    }
    function $951afdda7935b9af$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
        var encode = {};
        var datasetModel = $951afdda7935b9af$export$8da66f73a1eda454(seriesModel);
        if (!datasetModel || !coordDimensions) return encode;
        var encodeItemName = [];
        var encodeSeriesName = [];
        var ecModel = seriesModel.ecModel;
        var datasetMap = $951afdda7935b9af$var$innerGlobalModel(ecModel).datasetMap;
        var key = datasetModel.uid + '_' + source.seriesLayoutBy;
        var baseCategoryDimIndex;
        var categoryWayValueDimStart;
        coordDimensions = coordDimensions.slice();
        (0, (0, parcelRequire("bahqM")).each)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
            var coordDimInfo = (0, (0, parcelRequire("bahqM")).isObject)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
                name: coordDimInfoLoose
            };
            if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
                baseCategoryDimIndex = coordDimIdx;
                categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
            }
            encode[coordDimInfo.name] = [];
        });
        var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
            categoryWayDim: categoryWayValueDimStart,
            valueWayDim: 0
        });
        (0, (0, parcelRequire("bahqM")).each)(coordDimensions, function(coordDimInfo, coordDimIdx) {
            var coordDimName = coordDimInfo.name;
            var count = getDataDimCountOnCoordDim(coordDimInfo);
            if (baseCategoryDimIndex == null) {
                var start = datasetRecord.valueWayDim;
                pushDim(encode[coordDimName], start, count);
                pushDim(encodeSeriesName, start, count);
                datasetRecord.valueWayDim += count;
            } else if (baseCategoryDimIndex === coordDimIdx) {
                pushDim(encode[coordDimName], 0, count);
                pushDim(encodeItemName, 0, count);
            } else {
                var start = datasetRecord.categoryWayDim;
                pushDim(encode[coordDimName], start, count);
                pushDim(encodeSeriesName, start, count);
                datasetRecord.categoryWayDim += count;
            }
        });
        function pushDim(dimIdxArr, idxFrom, idxCount) {
            for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
        }
        function getDataDimCountOnCoordDim(coordDimInfo) {
            var dimsDef = coordDimInfo.dimsDef;
            return dimsDef ? dimsDef.length : 1;
        }
        encodeItemName.length && (encode.itemName = encodeItemName);
        encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
        return encode;
    }
    function $951afdda7935b9af$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
        var encode = {};
        var datasetModel = $951afdda7935b9af$export$8da66f73a1eda454(seriesModel);
        if (!datasetModel) return encode;
        var sourceFormat = source.sourceFormat;
        var dimensionsDefine = source.dimensionsDefine;
        var potentialNameDimIndex;
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS)) (0, (0, parcelRequire("bahqM")).each)(dimensionsDefine, function(dim, idx) {
            if (((0, (0, parcelRequire("bahqM")).isObject)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
        });
        var idxResult = function() {
            var idxRes0 = {};
            var idxRes1 = {};
            var guessRecords = [];
            for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
                var guessResult = $951afdda7935b9af$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
                guessRecords.push(guessResult);
                var isPureNumber = guessResult === $951afdda7935b9af$export$328749e9c5b40760.Not;
                if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
                if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $951afdda7935b9af$export$328749e9c5b40760.Not) idxRes0.n = i;
                if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $951afdda7935b9af$export$328749e9c5b40760.Not) return idxRes0;
                if (!isPureNumber) {
                    if (guessResult === $951afdda7935b9af$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                    if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
                }
            }
            function fulfilled(idxResult) {
                return idxResult.v != null && idxResult.n != null;
            }
            return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
        }();
        if (idxResult) {
            encode.value = [
                idxResult.v
            ];
            var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
            encode.itemName = [
                nameDimIndex
            ];
            encode.seriesName = [
                nameDimIndex
            ];
        }
        return encode;
    }
    function $951afdda7935b9af$export$8da66f73a1eda454(seriesModel) {
        var thisData = seriesModel.get('data', true);
        if (!thisData) return (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(seriesModel.ecModel, 'dataset', {
            index: seriesModel.get('datasetIndex', true),
            id: seriesModel.get('datasetId', true)
        }, (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
    }
    function $951afdda7935b9af$export$397ba553479711e7(datasetModel) {
        if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
        return (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(datasetModel.ecModel, 'dataset', {
            index: datasetModel.get('fromDatasetIndex', true),
            id: datasetModel.get('fromDatasetId', true)
        }, (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models;
    }
    function $951afdda7935b9af$export$c51adf1a2be01b9c(source, dimIndex) {
        return $951afdda7935b9af$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
    }
    function $951afdda7935b9af$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
        var result;
        var maxLoop = 5;
        if ((0, (0, parcelRequire("bahqM")).isTypedArray)(data)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
        var dimName;
        var dimType;
        if (dimensionsDefine) {
            var dimDefItem = dimensionsDefine[dimIndex];
            if ((0, (0, parcelRequire("bahqM")).isObject)(dimDefItem)) {
                dimName = dimDefItem.name;
                dimType = dimDefItem.type;
            } else if ((0, (0, parcelRequire("bahqM")).isString)(dimDefItem)) dimName = dimDefItem;
        }
        if (dimType != null) return dimType === 'ordinal' ? $951afdda7935b9af$export$328749e9c5b40760.Must : $951afdda7935b9af$export$328749e9c5b40760.Not;
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS)) {
            var dataArrayRows = data;
            if (seriesLayoutBy === (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)) {
                var sample = dataArrayRows[dimIndex];
                for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                    if ((result = detectValue(sample[startIndex + i])) != null) return result;
                }
            } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
                var row = dataArrayRows[startIndex + i];
                if (row && (result = detectValue(row[dimIndex])) != null) return result;
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) {
            var dataObjectRows = data;
            if (!dimName) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
                var item = dataObjectRows[i];
                if (item && (result = detectValue(item[dimName])) != null) return result;
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS)) {
            var dataKeyedColumns = data;
            if (!dimName) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            var sample = dataKeyedColumns[dimName];
            if (!sample || (0, (0, parcelRequire("bahqM")).isTypedArray)(sample)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            for(var i = 0; i < sample.length && i < maxLoop; i++){
                if ((result = detectValue(sample[i])) != null) return result;
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) {
            var dataOriginal = data;
            for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
                var item = dataOriginal[i];
                var val = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(item);
                if (!(0, (0, parcelRequire("bahqM")).isArray)(val)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
                if ((result = detectValue(val[dimIndex])) != null) return result;
            }
        }
        function detectValue(val) {
            var beStr = (0, (0, parcelRequire("bahqM")).isString)(val);
            if (val != null && isFinite(val) && val !== '') return beStr ? $951afdda7935b9af$export$328749e9c5b40760.Might : $951afdda7935b9af$export$328749e9c5b40760.Not;
            else if (beStr && val !== '-') return $951afdda7935b9af$export$328749e9c5b40760.Must;
        }
        return $951afdda7935b9af$export$328749e9c5b40760.Not;
    }
});
parcelRegister("gvLUt", function(module, exports) {
    $parcel$export(module.exports, "setLabelStyle", ()=>$c054b479467e8395$export$9a13992917966657);
    $parcel$export(module.exports, "createTextStyle", ()=>$c054b479467e8395$export$f8998c3d0a13de59);
    $parcel$export(module.exports, "createTextConfig", ()=>$c054b479467e8395$export$e149afab8df6e053);
    $parcel$export(module.exports, "labelInner", ()=>$c054b479467e8395$export$f62786d3261ab0f4);
    $parcel$export(module.exports, "getLabelStatesModels", ()=>$c054b479467e8395$export$9739a32674be5893);
    $parcel$export(module.exports, "getFont", ()=>$c054b479467e8395$export$155316a870a9d61e);
    $parcel$export(module.exports, "setLabelValueAnimation", ()=>$c054b479467e8395$export$7bdbceaf9ab378f2);
    $parcel$export(module.exports, "animateLabelValue", ()=>$c054b479467e8395$export$dd6101605f5c186);
    var $4gEFv;
    var $bahqM;
    var $fIXXx;
    var $eaKsF;
    var $eYgMC;
    parcelRequire("fHITF");
    var $eYgMC;
    var $c054b479467e8395$var$EMPTY_OBJ = {};
    function $c054b479467e8395$export$b533918394a58529(label, labelTexts) {
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            var text = labelTexts[stateName];
            var state = label.ensureState(stateName);
            state.style = state.style || {};
            state.style.text = text;
        }
        var oldStates = label.currentStates.slice();
        label.clearStates(true);
        label.setStyle({
            text: labelTexts.normal
        });
        label.useStates(oldStates, true);
    }
    function $c054b479467e8395$var$getLabelText(opt, stateModels, interpolatedValue) {
        var labelFetcher = opt.labelFetcher;
        var labelDataIndex = opt.labelDataIndex;
        var labelDimIndex = opt.labelDimIndex;
        var normalModel = stateModels.normal;
        var baseText;
        if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
            interpolatedValue: interpolatedValue
        } : null);
        if (baseText == null) baseText = (0, (0, parcelRequire("bahqM")).isFunction)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
        var statesText = {
            normal: baseText
        };
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            var stateModel = stateModels[stateName];
            statesText[stateName] = (0, (0, parcelRequire("bahqM")).retrieve2)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
        }
        return statesText;
    }
    function $c054b479467e8395$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
        opt = opt || $c054b479467e8395$var$EMPTY_OBJ;
        var isSetOnText = targetEl instanceof (0, (0, parcelRequire("4gEFv")).default);
        var needsCreateText = false;
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).DISPLAY_STATES).length; i++){
            var stateModel = labelStatesModels[(0, (0, parcelRequire("fIXXx")).DISPLAY_STATES)[i]];
            if (stateModel && stateModel.getShallow('show')) {
                needsCreateText = true;
                break;
            }
        }
        var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
        if (needsCreateText) {
            if (!isSetOnText) {
                if (!textContent) {
                    textContent = new (0, (0, parcelRequire("4gEFv")).default)();
                    targetEl.setTextContent(textContent);
                }
                if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
            }
            var labelStatesTexts = $c054b479467e8395$var$getLabelText(opt, labelStatesModels);
            var normalModel = labelStatesModels.normal;
            var showNormal = !!normalModel.getShallow('show');
            var normalStyle = $c054b479467e8395$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
            normalStyle.text = labelStatesTexts.normal;
            if (!isSetOnText) targetEl.setTextConfig($c054b479467e8395$export$e149afab8df6e053(normalModel, opt, false));
            for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
                var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
                var stateModel = labelStatesModels[stateName];
                if (stateModel) {
                    var stateObj = textContent.ensureState(stateName);
                    var stateShow = !!(0, (0, parcelRequire("bahqM")).retrieve2)(stateModel.getShallow('show'), showNormal);
                    if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                    stateObj.style = $c054b479467e8395$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                    stateObj.style.text = labelStatesTexts[stateName];
                    if (!isSetOnText) {
                        var targetElEmphasisState = targetEl.ensureState(stateName);
                        targetElEmphasisState.textConfig = $c054b479467e8395$export$e149afab8df6e053(stateModel, opt, true);
                    }
                }
            }
            textContent.silent = !!normalModel.getShallow('silent');
            if (textContent.style.x != null) normalStyle.x = textContent.style.x;
            if (textContent.style.y != null) normalStyle.y = textContent.style.y;
            textContent.ignore = !showNormal;
            textContent.useStyle(normalStyle);
            textContent.dirty();
            if (opt.enableTextSetter) $c054b479467e8395$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
                var labelStatesTexts = $c054b479467e8395$var$getLabelText(opt, labelStatesModels, interpolatedValue);
                $c054b479467e8395$export$b533918394a58529(textContent, labelStatesTexts);
            };
        } else if (textContent) textContent.ignore = true;
        targetEl.dirty();
    }
    function $c054b479467e8395$export$9739a32674be5893(itemModel, labelName) {
        labelName = labelName || 'label';
        var statesModels = {
            normal: itemModel.getModel(labelName)
        };
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            statesModels[stateName] = itemModel.getModel([
                stateName,
                labelName
            ]);
        }
        return statesModels;
    }
    function $c054b479467e8395$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, opt, isNotNormal, isAttached) {
        var textStyle = {};
        $c054b479467e8395$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
        specifiedTextStyle && (0, (0, parcelRequire("bahqM")).extend)(textStyle, specifiedTextStyle);
        return textStyle;
    }
    function $c054b479467e8395$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
        opt = opt || {};
        var textConfig = {};
        var labelPosition;
        var labelRotate = textStyleModel.getShallow('rotate');
        var labelDistance = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
        var labelOffset = textStyleModel.getShallow('offset');
        labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside');
        labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
        if (labelPosition != null) textConfig.position = labelPosition;
        if (labelOffset != null) textConfig.offset = labelOffset;
        if (labelRotate != null) {
            labelRotate *= Math.PI / 180;
            textConfig.rotation = labelRotate;
        }
        if (labelDistance != null) textConfig.distance = labelDistance;
        textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
        return textConfig;
    }
    function $c054b479467e8395$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
        opt = opt || $c054b479467e8395$var$EMPTY_OBJ;
        var ecModel = textStyleModel.ecModel;
        var globalTextStyle = ecModel && ecModel.option.textStyle;
        var richItemNames = $c054b479467e8395$var$getRichItemNames(textStyleModel);
        var richResult;
        if (richItemNames) {
            richResult = {};
            for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
                var richTextStyle = textStyleModel.getModel([
                    'rich',
                    name_1
                ]);
                $c054b479467e8395$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
            }
        }
        if (richResult) textStyle.rich = richResult;
        var overflow = textStyleModel.get('overflow');
        if (overflow) textStyle.overflow = overflow;
        var margin = textStyleModel.get('minMargin');
        if (margin != null) textStyle.margin = margin;
        $c054b479467e8395$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
    }
    function $c054b479467e8395$var$getRichItemNames(textStyleModel) {
        var richItemNameMap;
        while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
            var rich = (textStyleModel.option || $c054b479467e8395$var$EMPTY_OBJ).rich;
            if (rich) {
                richItemNameMap = richItemNameMap || {};
                var richKeys = (0, (0, parcelRequire("bahqM")).keys)(rich);
                for(var i = 0; i < richKeys.length; i++){
                    var richKey = richKeys[i];
                    richItemNameMap[richKey] = 1;
                }
            }
            textStyleModel = textStyleModel.parentModel;
        }
        return richItemNameMap;
    }
    var $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL = [
        'fontStyle',
        'fontWeight',
        'fontSize',
        'fontFamily',
        'textShadowColor',
        'textShadowBlur',
        'textShadowOffsetX',
        'textShadowOffsetY'
    ];
    var $c054b479467e8395$var$TEXT_PROPS_SELF = [
        'align',
        'lineHeight',
        'width',
        'height',
        'tag',
        'verticalAlign'
    ];
    var $c054b479467e8395$var$TEXT_PROPS_BOX = [
        'padding',
        'borderWidth',
        'borderRadius',
        'borderDashOffset',
        'backgroundColor',
        'borderColor',
        'shadowColor',
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY'
    ];
    function $c054b479467e8395$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
        globalTextStyle = !isNotNormal && globalTextStyle || $c054b479467e8395$var$EMPTY_OBJ;
        var inheritColor = opt && opt.inheritColor;
        var fillColor = textStyleModel.getShallow('color');
        var strokeColor = textStyleModel.getShallow('textBorderColor');
        var opacity = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
        if (fillColor === 'inherit' || fillColor === 'auto') {
            if (inheritColor) fillColor = inheritColor;
            else fillColor = null;
        }
        if (strokeColor === 'inherit' || strokeColor === 'auto') {
            if (inheritColor) strokeColor = inheritColor;
            else strokeColor = null;
        }
        if (!isAttached) {
            fillColor = fillColor || globalTextStyle.color;
            strokeColor = strokeColor || globalTextStyle.textBorderColor;
        }
        if (fillColor != null) textStyle.fill = fillColor;
        if (strokeColor != null) textStyle.stroke = strokeColor;
        var textBorderWidth = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
        if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
        var textBorderType = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
        if (textBorderType != null) textStyle.lineDash = textBorderType;
        var textBorderDashOffset = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
        if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
        if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
        if (opacity != null) textStyle.opacity = opacity;
        if (!isNotNormal && !isAttached) {
            if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
        }
        for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
            var key = $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL[i];
            var val = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow(key), globalTextStyle[key]);
            if (val != null) textStyle[key] = val;
        }
        for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_SELF.length; i++){
            var key = $c054b479467e8395$var$TEXT_PROPS_SELF[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        if (textStyle.verticalAlign == null) {
            var baseline = textStyleModel.getShallow('baseline');
            if (baseline != null) textStyle.verticalAlign = baseline;
        }
        if (!isBlock || !opt.disableBox) {
            for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_BOX.length; i++){
                var key = $c054b479467e8395$var$TEXT_PROPS_BOX[i];
                var val = textStyleModel.getShallow(key);
                if (val != null) textStyle[key] = val;
            }
            var borderType = textStyleModel.getShallow('borderType');
            if (borderType != null) textStyle.borderDash = borderType;
            if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
            if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
        }
    }
    function $c054b479467e8395$export$155316a870a9d61e(opt, ecModel) {
        var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
        return (0, (0, parcelRequire("bahqM")).trim)([
            opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
            opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
            (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
            opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
        ].join(' '));
    }
    var $c054b479467e8395$export$f62786d3261ab0f4 = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $c054b479467e8395$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
        if (!label) return;
        var obj = $c054b479467e8395$export$f62786d3261ab0f4(label);
        obj.prevValue = obj.value;
        obj.value = value;
        var normalLabelModel = labelStatesModels.normal;
        obj.valueAnimation = normalLabelModel.get('valueAnimation');
        if (obj.valueAnimation) {
            obj.precision = normalLabelModel.get('precision');
            obj.defaultInterpolatedText = getDefaultText;
            obj.statesModels = labelStatesModels;
        }
    }
    function $c054b479467e8395$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
        var labelInnerStore = $c054b479467e8395$export$f62786d3261ab0f4(textEl);
        if (!labelInnerStore.valueAnimation) return;
        var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
        var currValue = (0, (0, parcelRequire("bahqM")).retrieve2)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
        var targetValue = labelInnerStore.value;
        function during(percent) {
            var interpolated = (0, (0, parcelRequire("eaKsF")).interpolateRawValues)(data, labelInnerStore.precision, currValue, targetValue, percent);
            labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
            var labelText = $c054b479467e8395$var$getLabelText({
                labelDataIndex: dataIndex,
                labelFetcher: labelFetcher,
                defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
            }, labelInnerStore.statesModels, interpolated);
            $c054b479467e8395$export$b533918394a58529(textEl, labelText);
        }
        (labelInnerStore.prevValue == null ? (0, (0, parcelRequire("eYgMC")).initProps) : (0, (0, parcelRequire("eYgMC")).updateProps))(textEl, {}, animatableModel, dataIndex, null, during);
    }
});
parcelRegister("8Jx6o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65bc34119bfa351f$export$2e2bcd8739ae039);
    var $3VFsf;
    var $7yklO;
    var $4KVOr;
    var $fIXXx;
    var $lUzII;
    function $65bc34119bfa351f$var$updateRipplePath(rippleGroup, effectCfg) {
        var color = effectCfg.rippleEffectColor || effectCfg.color;
        rippleGroup.eachChild(function(ripplePath) {
            ripplePath.attr({
                z: effectCfg.z,
                zlevel: effectCfg.zlevel,
                style: {
                    stroke: effectCfg.brushType === 'stroke' ? color : null,
                    fill: effectCfg.brushType === 'fill' ? color : null
                }
            });
        });
    }
    var $65bc34119bfa351f$var$EffectSymbol = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(EffectSymbol, _super);
        function EffectSymbol(data, idx) {
            var _this = _super.call(this) || this;
            var symbol = new (0, (0, parcelRequire("lUzII")).default)(data, idx);
            var rippleGroup = new (0, (0, parcelRequire("4KVOr")).default)();
            _this.add(symbol);
            _this.add(rippleGroup);
            _this.updateData(data, idx);
            return _this;
        }
        EffectSymbol.prototype.stopEffectAnimation = function() {
            this.childAt(1).removeAll();
        };
        EffectSymbol.prototype.startEffectAnimation = function(effectCfg) {
            var symbolType = effectCfg.symbolType;
            var color = effectCfg.color;
            var rippleNumber = effectCfg.rippleNumber;
            var rippleGroup = this.childAt(1);
            for(var i = 0; i < rippleNumber; i++){
                var ripplePath = (0, (0, parcelRequire("7yklO")).createSymbol)(symbolType, -1, -1, 2, 2, color);
                ripplePath.attr({
                    style: {
                        strokeNoScale: true
                    },
                    z2: 99,
                    silent: true,
                    scaleX: 0.5,
                    scaleY: 0.5
                });
                var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
                ripplePath.animate('', true).when(effectCfg.period, {
                    scaleX: effectCfg.rippleScale / 2,
                    scaleY: effectCfg.rippleScale / 2
                }).delay(delay).start();
                ripplePath.animateStyle(true).when(effectCfg.period, {
                    opacity: 0
                }).delay(delay).start();
                rippleGroup.add(ripplePath);
            }
            $65bc34119bfa351f$var$updateRipplePath(rippleGroup, effectCfg);
        };
        EffectSymbol.prototype.updateEffectAnimation = function(effectCfg) {
            var oldEffectCfg = this._effectCfg;
            var rippleGroup = this.childAt(1);
            var DIFFICULT_PROPS = [
                'symbolType',
                'period',
                'rippleScale',
                'rippleNumber'
            ];
            for(var i = 0; i < DIFFICULT_PROPS.length; i++){
                var propName = DIFFICULT_PROPS[i];
                if (oldEffectCfg[propName] !== effectCfg[propName]) {
                    this.stopEffectAnimation();
                    this.startEffectAnimation(effectCfg);
                    return;
                }
            }
            $65bc34119bfa351f$var$updateRipplePath(rippleGroup, effectCfg);
        };
        EffectSymbol.prototype.highlight = function() {
            (0, (0, parcelRequire("fIXXx")).enterEmphasis)(this);
        };
        EffectSymbol.prototype.downplay = function() {
            (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(this);
        };
        EffectSymbol.prototype.getSymbolType = function() {
            var symbol = this.childAt(0);
            return symbol && symbol.getSymbolType();
        };
        EffectSymbol.prototype.updateData = function(data, idx) {
            var _this = this;
            var seriesModel = data.hostModel;
            this.childAt(0).updateData(data, idx);
            var rippleGroup = this.childAt(1);
            var itemModel = data.getItemModel(idx);
            var symbolType = data.getItemVisual(idx, 'symbol');
            var symbolSize = (0, (0, parcelRequire("7yklO")).normalizeSymbolSize)(data.getItemVisual(idx, 'symbolSize'));
            var symbolStyle = data.getItemVisual(idx, 'style');
            var color = symbolStyle && symbolStyle.fill;
            rippleGroup.setScale(symbolSize);
            rippleGroup.traverse(function(ripplePath) {
                ripplePath.setStyle('fill', color);
            });
            var symbolOffset = (0, (0, parcelRequire("7yklO")).normalizeSymbolOffset)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
            if (symbolOffset) {
                rippleGroup.x = symbolOffset[0];
                rippleGroup.y = symbolOffset[1];
            }
            var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
            rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
            var effectCfg = {};
            effectCfg.showEffectOn = seriesModel.get('showEffectOn');
            effectCfg.rippleScale = itemModel.get([
                'rippleEffect',
                'scale'
            ]);
            effectCfg.brushType = itemModel.get([
                'rippleEffect',
                'brushType'
            ]);
            effectCfg.period = itemModel.get([
                'rippleEffect',
                'period'
            ]) * 1000;
            effectCfg.effectOffset = idx / data.count();
            effectCfg.z = seriesModel.getShallow('z') || 0;
            effectCfg.zlevel = seriesModel.getShallow('zlevel') || 0;
            effectCfg.symbolType = symbolType;
            effectCfg.color = color;
            effectCfg.rippleEffectColor = itemModel.get([
                'rippleEffect',
                'color'
            ]);
            effectCfg.rippleNumber = itemModel.get([
                'rippleEffect',
                'number'
            ]);
            this.off('mouseover').off('mouseout').off('emphasis').off('normal');
            if (effectCfg.showEffectOn === 'render') {
                this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
                this._effectCfg = effectCfg;
            } else {
                this._effectCfg = null;
                this.stopEffectAnimation();
                this.onHoverStateChange = function(toState) {
                    if (toState === 'emphasis') {
                        if (effectCfg.showEffectOn !== 'render') _this.startEffectAnimation(effectCfg);
                    } else if (toState === 'normal') {
                        if (effectCfg.showEffectOn !== 'render') _this.stopEffectAnimation();
                    }
                };
            }
            this._effectCfg = effectCfg;
            (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(this);
        };
        EffectSymbol.prototype.fadeOut = function(cb) {
            this.off('mouseover').off('mouseout');
            cb && cb();
        };
        return EffectSymbol;
    }((0, (0, parcelRequire("4KVOr")).default));
    var $65bc34119bfa351f$export$2e2bcd8739ae039 = $65bc34119bfa351f$var$EffectSymbol;
});
parcelRegister("5xgWc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$407d2c4ef7fb34bc$export$2e2bcd8739ae039);
    var $bahqM;
    var $9irlK;
    var $5R8Hi;
    var $8fK8Y;
    function $407d2c4ef7fb34bc$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
        return {
            seriesType: seriesType,
            plan: (0, (0, parcelRequire("9irlK")).default)(),
            reset: function(seriesModel) {
                var data = seriesModel.getData();
                var coordSys = seriesModel.coordinateSystem;
                var pipelineContext = seriesModel.pipelineContext;
                var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
                if (!coordSys) return;
                var dims = (0, (0, parcelRequire("bahqM")).map)(coordSys.dimensions, function(dim) {
                    return data.mapDimension(dim);
                }).slice(0, 2);
                var dimLen = dims.length;
                var stackResultDim = data.getCalculationInfo('stackResultDimension');
                if ((0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, dims[0])) dims[0] = stackResultDim;
                if ((0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, dims[1])) dims[1] = stackResultDim;
                var store = data.getStore();
                var dimIdx0 = data.getDimensionIndex(dims[0]);
                var dimIdx1 = data.getDimensionIndex(dims[1]);
                return dimLen && {
                    progress: function(params, data) {
                        var segCount = params.end - params.start;
                        var points = useTypedArray && (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(segCount * dimLen);
                        var tmpIn = [];
                        var tmpOut = [];
                        for(var i = params.start, offset = 0; i < params.end; i++){
                            var point = void 0;
                            if (dimLen === 1) {
                                var x = store.get(dimIdx0, i);
                                point = coordSys.dataToPoint(x, null, tmpOut);
                            } else {
                                tmpIn[0] = store.get(dimIdx0, i);
                                tmpIn[1] = store.get(dimIdx1, i);
                                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                            }
                            if (useTypedArray) {
                                points[offset++] = point[0];
                                points[offset++] = point[1];
                            } else data.setItemLayout(i, point.slice());
                        }
                        useTypedArray && data.setLayout('points', points);
                    }
                };
            }
        };
    }
});
parcelRegister("9irlK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c4b0292c57cf773$export$2e2bcd8739ae039);
    var $eaKsF;
    function $6c4b0292c57cf773$export$2e2bcd8739ae039() {
        var inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
        return function(seriesModel) {
            var fields = inner(seriesModel);
            var pipelineContext = seriesModel.pipelineContext;
            var originalLarge = !!fields.large;
            var originalProgressive = !!fields.progressiveRender;
            var large = fields.large = !!(pipelineContext && pipelineContext.large);
            var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
            return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
        };
    }
});
parcelRegister("5R8Hi", function(module, exports) {
    $parcel$export(module.exports, "enableDataStack", ()=>$4438a61210f14409$export$f2165f9e8499b278);
    $parcel$export(module.exports, "isDimensionStacked", ()=>$4438a61210f14409$export$1dedc39359ae35c);
    $parcel$export(module.exports, "getStackedDimension", ()=>$4438a61210f14409$export$909db2be4938fbdf);
    var $bahqM;
    var $2Om11;
    function $4438a61210f14409$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
        opt = opt || {};
        var byIndex = opt.byIndex;
        var stackedCoordDimension = opt.stackedCoordDimension;
        var dimensionDefineList;
        var schema;
        var store;
        if ($4438a61210f14409$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
        else {
            schema = dimensionsInput.schema;
            dimensionDefineList = schema.dimensions;
            store = dimensionsInput.store;
        }
        var mayStack = !!(seriesModel && seriesModel.get('stack'));
        var stackedByDimInfo;
        var stackedDimInfo;
        var stackResultDimension;
        var stackedOverDimension;
        (0, (0, parcelRequire("bahqM")).each)(dimensionDefineList, function(dimensionInfo, index) {
            if ((0, (0, parcelRequire("bahqM")).isString)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
                name: dimensionInfo
            };
            if (mayStack && !dimensionInfo.isExtraCoord) {
                if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
                if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
            }
        });
        if (stackedDimInfo && !byIndex && !stackedByDimInfo) byIndex = true;
        if (stackedDimInfo) {
            stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
            stackedOverDimension = '__\0ecstackedover_' + seriesModel.id;
            if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
            var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
            var stackedDimType = stackedDimInfo.type;
            var stackedDimCoordIndex_1 = 0;
            (0, (0, parcelRequire("bahqM")).each)(dimensionDefineList, function(dimensionInfo) {
                if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
            });
            var stackedOverDimensionDefine = {
                name: stackResultDimension,
                coordDim: stackedDimCoordDim_1,
                coordDimIndex: stackedDimCoordIndex_1,
                type: stackedDimType,
                isExtraCoord: true,
                isCalculationCoord: true,
                storeDimIndex: dimensionDefineList.length
            };
            var stackResultDimensionDefine = {
                name: stackedOverDimension,
                coordDim: stackedOverDimension,
                coordDimIndex: stackedDimCoordIndex_1 + 1,
                type: stackedDimType,
                isExtraCoord: true,
                isCalculationCoord: true,
                storeDimIndex: dimensionDefineList.length + 1
            };
            if (schema) {
                if (store) {
                    stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                    stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
                }
                schema.appendCalculationDimension(stackedOverDimensionDefine);
                schema.appendCalculationDimension(stackResultDimensionDefine);
            } else {
                dimensionDefineList.push(stackedOverDimensionDefine);
                dimensionDefineList.push(stackResultDimensionDefine);
            }
        }
        return {
            stackedDimension: stackedDimInfo && stackedDimInfo.name,
            stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
            isStackedByIndex: byIndex,
            stackedOverDimension: stackedOverDimension,
            stackResultDimension: stackResultDimension
        };
    }
    function $4438a61210f14409$var$isLegacyDimensionsInput(dimensionsInput) {
        return !(0, (0, parcelRequire("2Om11")).isSeriesDataSchema)(dimensionsInput.schema);
    }
    function $4438a61210f14409$export$1dedc39359ae35c(data, stackedDim) {
        return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
    }
    function $4438a61210f14409$export$909db2be4938fbdf(data, targetDim) {
        return $4438a61210f14409$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
    }
});
parcelRegister("2Om11", function(module, exports) {
    $parcel$export(module.exports, "SeriesDataSchema", ()=>$20c1541ff90227ce$export$a1ef064685775f3e);
    $parcel$export(module.exports, "ensureSourceDimNameMap", ()=>$20c1541ff90227ce$export$be39ae17310c33f7);
    $parcel$export(module.exports, "shouldOmitUnusedDimensions", ()=>$20c1541ff90227ce$export$238b87930d825d87);
    $parcel$export(module.exports, "isSeriesDataSchema", ()=>$20c1541ff90227ce$export$fafbc856132a3a0e);
    $parcel$export(module.exports, "createDimNameMap", ()=>$20c1541ff90227ce$export$a477f5bebfd07944);
    var $bahqM;
    var $eaKsF;
    var $20liu;
    var $20c1541ff90227ce$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $20c1541ff90227ce$var$dimTypeShort = {
        float: 'f',
        int: 'i',
        ordinal: 'o',
        number: 'n',
        time: 't'
    };
    var $20c1541ff90227ce$export$a1ef064685775f3e = function() {
        function SeriesDataSchema(opt) {
            this.dimensions = opt.dimensions;
            this._dimOmitted = opt.dimensionOmitted;
            this.source = opt.source;
            this._fullDimCount = opt.fullDimensionCount;
            this._updateDimOmitted(opt.dimensionOmitted);
        }
        SeriesDataSchema.prototype.isDimensionOmitted = function() {
            return this._dimOmitted;
        };
        SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
            this._dimOmitted = dimensionOmitted;
            if (!dimensionOmitted) return;
            if (!this._dimNameMap) this._dimNameMap = $20c1541ff90227ce$export$be39ae17310c33f7(this.source);
        };
        SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
            return (0, (0, parcelRequire("bahqM")).retrieve2)(this._dimNameMap.get(dimName), -1);
        };
        SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
            var dimensionsDefine = this.source.dimensionsDefine;
            if (dimensionsDefine) return dimensionsDefine[dimIndex];
        };
        SeriesDataSchema.prototype.makeStoreSchema = function() {
            var dimCount = this._fullDimCount;
            var willRetrieveDataByName = (0, (0, parcelRequire("20liu")).shouldRetrieveDataByName)(this.source);
            var makeHashStrict = !$20c1541ff90227ce$export$238b87930d825d87(dimCount);
            var dimHash = '';
            var dims = [];
            for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
                var property = void 0;
                var type = void 0;
                var ordinalMeta = void 0;
                var seriesDimDef = this.dimensions[seriesDimIdx];
                if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                    property = willRetrieveDataByName ? seriesDimDef.name : null;
                    type = seriesDimDef.type;
                    ordinalMeta = seriesDimDef.ordinalMeta;
                    seriesDimIdx++;
                } else {
                    var sourceDimDef = this.getSourceDimension(fullDimIdx);
                    if (sourceDimDef) {
                        property = willRetrieveDataByName ? sourceDimDef.name : null;
                        type = sourceDimDef.type;
                    }
                }
                dims.push({
                    property: property,
                    type: type,
                    ordinalMeta: ordinalMeta
                });
                if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') : property;
                dimHash += '$';
                dimHash += $20c1541ff90227ce$var$dimTypeShort[type] || 'f';
                if (ordinalMeta) dimHash += ordinalMeta.uid;
                dimHash += '$';
            }
            var source = this.source;
            var hash = [
                source.seriesLayoutBy,
                source.startIndex,
                dimHash
            ].join('$$');
            return {
                dimensions: dims,
                hash: hash
            };
        };
        SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
            var result = [];
            for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
                var name_1 = void 0;
                var seriesDimDef = this.dimensions[seriesDimIdx];
                if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                    if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                    seriesDimIdx++;
                } else {
                    var sourceDimDef = this.getSourceDimension(fullDimIdx);
                    if (sourceDimDef) name_1 = sourceDimDef.name;
                }
                result.push(name_1);
            }
            return result;
        };
        SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
            this.dimensions.push(dimDef);
            dimDef.isCalculationCoord = true;
            this._fullDimCount++;
            this._updateDimOmitted(true);
        };
        return SeriesDataSchema;
    }();
    function $20c1541ff90227ce$export$fafbc856132a3a0e(schema) {
        return schema instanceof $20c1541ff90227ce$export$a1ef064685775f3e;
    }
    function $20c1541ff90227ce$export$a477f5bebfd07944(dimsDef) {
        var dataDimNameMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        for(var i = 0; i < (dimsDef || []).length; i++){
            var dimDefItemRaw = dimsDef[i];
            var userDimName = (0, (0, parcelRequire("bahqM")).isObject)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
            if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
        }
        return dataDimNameMap;
    }
    function $20c1541ff90227ce$export$be39ae17310c33f7(source) {
        var innerSource = $20c1541ff90227ce$var$inner(source);
        return innerSource.dimNameMap || (innerSource.dimNameMap = $20c1541ff90227ce$export$a477f5bebfd07944(source.dimensionsDefine));
    }
    function $20c1541ff90227ce$export$238b87930d825d87(dimCount) {
        return dimCount > 30;
    }
});
parcelRegister("8fK8Y", function(module, exports) {
    $parcel$export(module.exports, "createFloat32Array", ()=>$602384a5ad582433$export$21d2298f3f56bbaf);
    var $bahqM;
    var $602384a5ad582433$var$supportFloat32Array = typeof Float32Array !== 'undefined';
    var $602384a5ad582433$var$Float32ArrayCtor = !$602384a5ad582433$var$supportFloat32Array ? Array : Float32Array;
    function $602384a5ad582433$export$21d2298f3f56bbaf(arg) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(arg)) return $602384a5ad582433$var$supportFloat32Array ? new Float32Array(arg) : arg;
        return new $602384a5ad582433$var$Float32ArrayCtor(arg);
    }
});
parcelRegister("loerw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9270aeb44680e6f$export$2e2bcd8739ae039);
    var $bahqM;
    var $4KVOr;
    var $jvo6O;
    var $aLwh0;
    var $eaKsF;
    var $fIXXx;
    var $92IK1;
    var $9irlK;
    var $f9270aeb44680e6f$var$inner = (0, parcelRequire("eaKsF")).makeInner();
    var $f9270aeb44680e6f$var$renderPlanner = (0, (0, parcelRequire("9irlK")).default)();
    var $f9270aeb44680e6f$var$ChartView = function() {
        function ChartView() {
            this.group = new (0, (0, parcelRequire("4KVOr")).default)();
            this.uid = (0, parcelRequire("jvo6O")).getUID('viewChart');
            this.renderTask = (0, (0, parcelRequire("92IK1")).createTask)({
                plan: $f9270aeb44680e6f$var$renderTaskPlan,
                reset: $f9270aeb44680e6f$var$renderTaskReset
            });
            this.renderTask.context = {
                view: this
            };
        }
        ChartView.prototype.init = function(ecModel, api) {};
        ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
        ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
            $f9270aeb44680e6f$var$toggleHighlight(seriesModel.getData(), payload, 'emphasis');
        };
        ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
            $f9270aeb44680e6f$var$toggleHighlight(seriesModel.getData(), payload, 'normal');
        };
        ChartView.prototype.remove = function(ecModel, api) {
            this.group.removeAll();
        };
        ChartView.prototype.dispose = function(ecModel, api) {};
        ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
            this.render(seriesModel, ecModel, api, payload);
        };
        ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
            this.render(seriesModel, ecModel, api, payload);
        };
        ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
            this.render(seriesModel, ecModel, api, payload);
        };
        ChartView.markUpdateMethod = function(payload, methodName) {
            $f9270aeb44680e6f$var$inner(payload).updateMethod = methodName;
        };
        ChartView.protoInitialize = function() {
            var proto = ChartView.prototype;
            proto.type = 'chart';
        }();
        return ChartView;
    }();
    function $f9270aeb44680e6f$var$elSetState(el, state, highlightDigit) {
        if (el) (state === 'emphasis' ? (0, (0, parcelRequire("fIXXx")).enterEmphasis) : (0, (0, parcelRequire("fIXXx")).leaveEmphasis))(el, highlightDigit);
    }
    function $f9270aeb44680e6f$var$toggleHighlight(data, payload, state) {
        var dataIndex = (0, parcelRequire("eaKsF")).queryDataIndex(data, payload);
        var highlightDigit = payload && payload.highlightKey != null ? (0, (0, parcelRequire("fIXXx")).getHighlightDigit)(payload.highlightKey) : null;
        if (dataIndex != null) (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(dataIndex), function(dataIdx) {
            $f9270aeb44680e6f$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
        });
        else data.eachItemGraphicEl(function(el) {
            $f9270aeb44680e6f$var$elSetState(el, state, highlightDigit);
        });
    }
    (0, parcelRequire("aLwh0")).enableClassExtend($f9270aeb44680e6f$var$ChartView, [
        'dispose'
    ]);
    (0, parcelRequire("aLwh0")).enableClassManagement($f9270aeb44680e6f$var$ChartView);
    function $f9270aeb44680e6f$var$renderTaskPlan(context) {
        return $f9270aeb44680e6f$var$renderPlanner(context.model);
    }
    function $f9270aeb44680e6f$var$renderTaskReset(context) {
        var seriesModel = context.model;
        var ecModel = context.ecModel;
        var api = context.api;
        var payload = context.payload;
        var progressiveRender = seriesModel.pipelineContext.progressiveRender;
        var view = context.view;
        var updateMethod = payload && $f9270aeb44680e6f$var$inner(payload).updateMethod;
        var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod : 'render';
        if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
        return $f9270aeb44680e6f$var$progressMethodMap[methodName];
    }
    var $f9270aeb44680e6f$var$progressMethodMap = {
        incrementalPrepareRender: {
            progress: function(params, context) {
                context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
            }
        },
        render: {
            forceFirstProgress: true,
            progress: function(params, context) {
                context.view.render(context.model, context.ecModel, context.api, context.payload);
            }
        }
    };
    var $f9270aeb44680e6f$export$2e2bcd8739ae039 = $f9270aeb44680e6f$var$ChartView;
});
parcelRegister("jvo6O", function(module, exports) {
    $parcel$export(module.exports, "getUID", ()=>$e3339d183aa6ce79$export$6d2b3473b0986646);
    $parcel$export(module.exports, "enableSubTypeDefaulter", ()=>$e3339d183aa6ce79$export$b9faf30b7d655a6f);
    $parcel$export(module.exports, "enableTopologicalTravel", ()=>$e3339d183aa6ce79$export$ce592d345a3ec040);
    $parcel$export(module.exports, "inheritDefaultOption", ()=>$e3339d183aa6ce79$export$68acc510e46fef2);
    var $bahqM;
    var $aLwh0;
    var $e3339d183aa6ce79$var$base = Math.round(Math.random() * 10);
    function $e3339d183aa6ce79$export$6d2b3473b0986646(type) {
        return [
            type || '',
            $e3339d183aa6ce79$var$base++
        ].join('_');
    }
    function $e3339d183aa6ce79$export$b9faf30b7d655a6f(target) {
        var subTypeDefaulters = {};
        target.registerSubTypeDefaulter = function(componentType, defaulter) {
            var componentTypeInfo = (0, (0, parcelRequire("aLwh0")).parseClassType)(componentType);
            subTypeDefaulters[componentTypeInfo.main] = defaulter;
        };
        target.determineSubType = function(componentType, option) {
            var type = option.type;
            if (!type) {
                var componentTypeMain = (0, (0, parcelRequire("aLwh0")).parseClassType)(componentType).main;
                if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
            }
            return type;
        };
    }
    function $e3339d183aa6ce79$export$ce592d345a3ec040(entity, dependencyGetter) {
        entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
            if (!targetNameList.length) return;
            var result = makeDepndencyGraph(fullNameList);
            var graph = result.graph;
            var noEntryList = result.noEntryList;
            var targetNameSet = {};
            (0, parcelRequire("bahqM")).each(targetNameList, function(name) {
                targetNameSet[name] = true;
            });
            while(noEntryList.length){
                var currComponentType = noEntryList.pop();
                var currVertex = graph[currComponentType];
                var isInTargetNameSet = !!targetNameSet[currComponentType];
                if (isInTargetNameSet) {
                    callback.call(context, currComponentType, currVertex.originalDeps.slice());
                    delete targetNameSet[currComponentType];
                }
                (0, parcelRequire("bahqM")).each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
            }
            (0, parcelRequire("bahqM")).each(targetNameSet, function() {
                var errMsg = '';
                throw new Error(errMsg);
            });
            function removeEdge(succComponentType) {
                graph[succComponentType].entryCount--;
                if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
            }
            function removeEdgeAndAdd(succComponentType) {
                targetNameSet[succComponentType] = true;
                removeEdge(succComponentType);
            }
        };
        function makeDepndencyGraph(fullNameList) {
            var graph = {};
            var noEntryList = [];
            (0, parcelRequire("bahqM")).each(fullNameList, function(name) {
                var thisItem = createDependencyGraphItem(graph, name);
                var originalDeps = thisItem.originalDeps = dependencyGetter(name);
                var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
                thisItem.entryCount = availableDeps.length;
                if (thisItem.entryCount === 0) noEntryList.push(name);
                (0, parcelRequire("bahqM")).each(availableDeps, function(dependentName) {
                    if ((0, parcelRequire("bahqM")).indexOf(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                    var thatItem = createDependencyGraphItem(graph, dependentName);
                    if ((0, parcelRequire("bahqM")).indexOf(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
                });
            });
            return {
                graph: graph,
                noEntryList: noEntryList
            };
        }
        function createDependencyGraphItem(graph, name) {
            if (!graph[name]) graph[name] = {
                predecessor: [],
                successor: []
            };
            return graph[name];
        }
        function getAvailableDependencies(originalDeps, fullNameList) {
            var availableDeps = [];
            (0, parcelRequire("bahqM")).each(originalDeps, function(dep) {
                (0, parcelRequire("bahqM")).indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
            });
            return availableDeps;
        }
    }
    function $e3339d183aa6ce79$export$68acc510e46fef2(superOption, subOption) {
        return (0, parcelRequire("bahqM")).merge((0, parcelRequire("bahqM")).merge({}, superOption, true), subOption, true);
    }
});
parcelRegister("aLwh0", function(module, exports) {
    $parcel$export(module.exports, "parseClassType", ()=>$7d6753f3a830ddbc$export$fbe18865d303bf01);
    $parcel$export(module.exports, "isExtendedClass", ()=>$7d6753f3a830ddbc$export$4f3b818f3dd2d182);
    $parcel$export(module.exports, "enableClassExtend", ()=>$7d6753f3a830ddbc$export$cd4c3a4dca301c70);
    $parcel$export(module.exports, "mountExtend", ()=>$7d6753f3a830ddbc$export$c9c2d87774f1275d);
    $parcel$export(module.exports, "enableClassCheck", ()=>$7d6753f3a830ddbc$export$e1aac4552ae82081);
    $parcel$export(module.exports, "enableClassManagement", ()=>$7d6753f3a830ddbc$export$241315e45585454d);
    var $3VFsf;
    var $bahqM;
    var $7d6753f3a830ddbc$var$TYPE_DELIMITER = '.';
    var $7d6753f3a830ddbc$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
    var $7d6753f3a830ddbc$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
    function $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType) {
        var ret = {
            main: '',
            sub: ''
        };
        if (componentType) {
            var typeArr = componentType.split($7d6753f3a830ddbc$var$TYPE_DELIMITER);
            ret.main = typeArr[0] || '';
            ret.sub = typeArr[1] || '';
        }
        return ret;
    }
    function $7d6753f3a830ddbc$var$checkClassType(componentType) {
        (0, parcelRequire("bahqM")).assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
    }
    function $7d6753f3a830ddbc$export$4f3b818f3dd2d182(clz) {
        return !!(clz && clz[$7d6753f3a830ddbc$var$IS_EXTENDED_CLASS]);
    }
    function $7d6753f3a830ddbc$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
        rootClz.$constructor = rootClz;
        rootClz.extend = function(proto) {
            var superClass = this;
            function ExtendedClass() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                if (!proto.$constructor) {
                    if (!$7d6753f3a830ddbc$var$isESClass(superClass)) superClass.apply(this, arguments);
                    else {
                        var ins = (0, parcelRequire("bahqM")).createObject(ExtendedClass.prototype, new (superClass.bind.apply(superClass, (0, (0, parcelRequire("3VFsf")).__spreadArray)([
                            void 0
                        ], args)))());
                        return ins;
                    }
                } else proto.$constructor.apply(this, arguments);
            }
            ExtendedClass[$7d6753f3a830ddbc$var$IS_EXTENDED_CLASS] = true;
            (0, parcelRequire("bahqM")).extend(ExtendedClass.prototype, proto);
            ExtendedClass.extend = this.extend;
            ExtendedClass.superCall = $7d6753f3a830ddbc$var$superCall;
            ExtendedClass.superApply = $7d6753f3a830ddbc$var$superApply;
            (0, parcelRequire("bahqM")).inherits(ExtendedClass, this);
            ExtendedClass.superClass = superClass;
            return ExtendedClass;
        };
    }
    function $7d6753f3a830ddbc$var$isESClass(fn) {
        return typeof fn === 'function' && /^class\s/.test(Function.prototype.toString.call(fn));
    }
    function $7d6753f3a830ddbc$export$c9c2d87774f1275d(SubClz, SupperClz) {
        SubClz.extend = SupperClz.extend;
    }
    var $7d6753f3a830ddbc$var$classBase = Math.round(Math.random() * 10);
    function $7d6753f3a830ddbc$export$e1aac4552ae82081(target) {
        var classAttr = [
            '__\0is_clz',
            $7d6753f3a830ddbc$var$classBase++
        ].join('_');
        target.prototype[classAttr] = true;
        target.isInstance = function(obj) {
            return !!(obj && obj[classAttr]);
        };
    }
    function $7d6753f3a830ddbc$var$superCall(context, methodName) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        return this.superClass.prototype[methodName].apply(context, args);
    }
    function $7d6753f3a830ddbc$var$superApply(context, methodName, args) {
        return this.superClass.prototype[methodName].apply(context, args);
    }
    function $7d6753f3a830ddbc$export$241315e45585454d(target) {
        var storage = {};
        target.registerClass = function(clz) {
            var componentFullType = clz.type || clz.prototype.type;
            if (componentFullType) {
                $7d6753f3a830ddbc$var$checkClassType(componentFullType);
                clz.prototype.type = componentFullType;
                var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentFullType);
                if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
                else if (componentTypeInfo.sub !== $7d6753f3a830ddbc$var$IS_CONTAINER) {
                    var container = makeContainer(componentTypeInfo);
                    container[componentTypeInfo.sub] = clz;
                }
            }
            return clz;
        };
        target.getClass = function(mainType, subType, throwWhenNotFound) {
            var clz = storage[mainType];
            if (clz && clz[$7d6753f3a830ddbc$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
            if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
            return clz;
        };
        target.getClassesByMainType = function(componentType) {
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
            var result = [];
            var obj = storage[componentTypeInfo.main];
            if (obj && obj[$7d6753f3a830ddbc$var$IS_CONTAINER]) (0, parcelRequire("bahqM")).each(obj, function(o, type) {
                type !== $7d6753f3a830ddbc$var$IS_CONTAINER && result.push(o);
            });
            else result.push(obj);
            return result;
        };
        target.hasClass = function(componentType) {
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
            return !!storage[componentTypeInfo.main];
        };
        target.getAllClassMainTypes = function() {
            var types = [];
            (0, parcelRequire("bahqM")).each(storage, function(obj, type) {
                types.push(type);
            });
            return types;
        };
        target.hasSubTypes = function(componentType) {
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
            var obj = storage[componentTypeInfo.main];
            return obj && obj[$7d6753f3a830ddbc$var$IS_CONTAINER];
        };
        function makeContainer(componentTypeInfo) {
            var container = storage[componentTypeInfo.main];
            if (!container || !container[$7d6753f3a830ddbc$var$IS_CONTAINER]) {
                container = storage[componentTypeInfo.main] = {};
                container[$7d6753f3a830ddbc$var$IS_CONTAINER] = true;
            }
            return container;
        }
    }
});
parcelRegister("92IK1", function(module, exports) {
    $parcel$export(module.exports, "createTask", ()=>$6957019fc0d13ee5$export$f7292ab7796be73c);
    var $bahqM;
    function $6957019fc0d13ee5$export$f7292ab7796be73c(define) {
        return new $6957019fc0d13ee5$export$2dea7024bcdd7731(define);
    }
    var $6957019fc0d13ee5$export$2dea7024bcdd7731 = function() {
        function Task(define) {
            define = define || {};
            this._reset = define.reset;
            this._plan = define.plan;
            this._count = define.count;
            this._onDirty = define.onDirty;
            this._dirty = true;
        }
        Task.prototype.perform = function(performArgs) {
            var upTask = this._upstream;
            var skip = performArgs && performArgs.skip;
            if (this._dirty && upTask) {
                var context = this.context;
                context.data = context.outputData = upTask.context.outputData;
            }
            if (this.__pipeline) this.__pipeline.currentTask = this;
            var planResult;
            if (this._plan && !skip) planResult = this._plan(this.context);
            var lastModBy = normalizeModBy(this._modBy);
            var lastModDataCount = this._modDataCount || 0;
            var modBy = normalizeModBy(performArgs && performArgs.modBy);
            var modDataCount = performArgs && performArgs.modDataCount || 0;
            if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
            function normalizeModBy(val) {
                !(val >= 1) && (val = 1);
                return val;
            }
            var forceFirstProgress;
            if (this._dirty || planResult === 'reset') {
                this._dirty = false;
                forceFirstProgress = this._doReset(skip);
            }
            this._modBy = modBy;
            this._modDataCount = modDataCount;
            var step = performArgs && performArgs.step;
            if (upTask) this._dueEnd = upTask._outputDueEnd;
            else this._dueEnd = this._count ? this._count(this.context) : Infinity;
            if (this._progress) {
                var start = this._dueIndex;
                var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
                if (!skip && (forceFirstProgress || start < end)) {
                    var progress = this._progress;
                    if ((0, (0, parcelRequire("bahqM")).isArray)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                    else this._doProgress(progress, start, end, modBy, modDataCount);
                }
                this._dueIndex = end;
                var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
                this._outputDueEnd = outputDueEnd;
            } else this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
            return this.unfinished();
        };
        Task.prototype.dirty = function() {
            this._dirty = true;
            this._onDirty && this._onDirty(this.context);
        };
        Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
            $6957019fc0d13ee5$var$iterator.reset(start, end, modBy, modDataCount);
            this._callingProgress = progress;
            this._callingProgress({
                start: start,
                end: end,
                count: end - start,
                next: $6957019fc0d13ee5$var$iterator.next
            }, this.context);
        };
        Task.prototype._doReset = function(skip) {
            this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
            this._settedOutputEnd = null;
            var progress;
            var forceFirstProgress;
            if (!skip && this._reset) {
                progress = this._reset(this.context);
                if (progress && progress.progress) {
                    forceFirstProgress = progress.forceFirstProgress;
                    progress = progress.progress;
                }
                if ((0, (0, parcelRequire("bahqM")).isArray)(progress) && !progress.length) progress = null;
            }
            this._progress = progress;
            this._modBy = this._modDataCount = null;
            var downstream = this._downstream;
            downstream && downstream.dirty();
            return forceFirstProgress;
        };
        Task.prototype.unfinished = function() {
            return this._progress && this._dueIndex < this._dueEnd;
        };
        Task.prototype.pipe = function(downTask) {
            if (this._downstream !== downTask || this._dirty) {
                this._downstream = downTask;
                downTask._upstream = this;
                downTask.dirty();
            }
        };
        Task.prototype.dispose = function() {
            if (this._disposed) return;
            this._upstream && (this._upstream._downstream = null);
            this._downstream && (this._downstream._upstream = null);
            this._dirty = false;
            this._disposed = true;
        };
        Task.prototype.getUpstream = function() {
            return this._upstream;
        };
        Task.prototype.getDownstream = function() {
            return this._downstream;
        };
        Task.prototype.setOutputEnd = function(end) {
            this._outputDueEnd = this._settedOutputEnd = end;
        };
        return Task;
    }();
    var $6957019fc0d13ee5$var$iterator = function() {
        var end;
        var current;
        var modBy;
        var modDataCount;
        var winCount;
        var it = {
            reset: function(s, e, sStep, sCount) {
                current = s;
                end = e;
                modBy = sStep;
                modDataCount = sCount;
                winCount = Math.ceil(modDataCount / modBy);
                it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
            }
        };
        return it;
        function sequentialNext() {
            return current < end ? current++ : null;
        }
        function modNext() {
            var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
            var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
            current++;
            return result;
        }
    }();
});
parcelRegister("9UN8r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$737f753c775d35e6$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bAY5l;
    var $1O7Ua;
    var $737f753c775d35e6$var$EffectScatterSeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(EffectScatterSeriesModel, _super);
        function EffectScatterSeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = EffectScatterSeriesModel.type;
            _this.hasSymbolVisual = true;
            return _this;
        }
        EffectScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
            return (0, (0, parcelRequire("bAY5l")).default)(null, this, {
                useEncodeDefaulter: true
            });
        };
        EffectScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
            return selectors.point(data.getItemLayout(dataIndex));
        };
        EffectScatterSeriesModel.type = 'series.effectScatter';
        EffectScatterSeriesModel.dependencies = [
            'grid',
            'polar'
        ];
        EffectScatterSeriesModel.defaultOption = {
            coordinateSystem: 'cartesian2d',
            zlevel: 0,
            z: 2,
            legendHoverLink: true,
            effectType: 'ripple',
            progressive: 0,
            showEffectOn: 'render',
            clip: true,
            rippleEffect: {
                period: 4,
                scale: 2.5,
                brushType: 'fill',
                number: 3
            },
            universalTransition: {
                divideShape: 'clone'
            },
            symbolSize: 10
        };
        return EffectScatterSeriesModel;
    }((0, (0, parcelRequire("1O7Ua")).default));
    var $737f753c775d35e6$export$2e2bcd8739ae039 = $737f753c775d35e6$var$EffectScatterSeriesModel;
});
parcelRegister("bAY5l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8711aa3240a9c687$export$2e2bcd8739ae039);
    var $bahqM;
    var $liBXN;
    var $h9jiS;
    var $bnVGB;
    var $eaKsF;
    var $gyhNQ;
    var $lhMGv;
    var $20liu;
    var $5R8Hi;
    var $cNGs8;
    var $2Rbm1;
    function $8711aa3240a9c687$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
        var coordSysName = seriesModel.get('coordinateSystem');
        var registeredCoordSys = (0, (0, parcelRequire("gyhNQ")).default).get(coordSysName);
        var coordSysDimDefs;
        if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = (0, parcelRequire("bahqM")).map(coordSysInfo.coordSysDims, function(dim) {
            var dimInfo = {
                name: dim
            };
            var axisModel = coordSysInfo.axisMap.get(dim);
            if (axisModel) {
                var axisType = axisModel.get('type');
                dimInfo.type = (0, (0, parcelRequire("bnVGB")).getDimensionTypeByAxis)(axisType);
            }
            return dimInfo;
        });
        if (!coordSysDimDefs) coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
            'x',
            'y'
        ];
        return coordSysDimDefs;
    }
    function $8711aa3240a9c687$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
        var firstCategoryDimIndex;
        var hasNameEncode;
        coordSysInfo && (0, parcelRequire("bahqM")).each(dimInfoList, function(dimInfo, dimIndex) {
            var coordDim = dimInfo.coordDim;
            var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
            if (categoryAxisModel) {
                if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
                dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
                if (createInvertedIndices) dimInfo.createInvertedIndices = true;
            }
            if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
        });
        if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
        return firstCategoryDimIndex;
    }
    function $8711aa3240a9c687$var$createSeriesData(sourceRaw, seriesModel, opt) {
        opt = opt || {};
        var sourceManager = seriesModel.getSourceManager();
        var source;
        var isOriginalSource = false;
        if (sourceRaw) {
            isOriginalSource = true;
            source = (0, (0, parcelRequire("20liu")).createSourceFromSeriesDataOption)(sourceRaw);
        } else {
            source = sourceManager.getSource();
            isOriginalSource = source.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL);
        }
        var coordSysInfo = (0, (0, parcelRequire("lhMGv")).getCoordSysInfoBySeries)(seriesModel);
        var coordSysDimDefs = $8711aa3240a9c687$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
        var useEncodeDefaulter = opt.useEncodeDefaulter;
        var encodeDefaulter = (0, parcelRequire("bahqM")).isFunction(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? (0, parcelRequire("bahqM")).curry((0, (0, parcelRequire("cNGs8")).makeSeriesEncodeForAxisCoordSys), coordSysDimDefs, seriesModel) : null;
        var createDimensionOptions = {
            coordDimensions: coordSysDimDefs,
            generateCoord: opt.generateCoord,
            encodeDefine: seriesModel.getEncode(),
            encodeDefaulter: encodeDefaulter,
            canOmitUnusedDimensions: !isOriginalSource
        };
        var schema = (0, (0, parcelRequire("h9jiS")).default)(source, createDimensionOptions);
        var firstCategoryDimIndex = $8711aa3240a9c687$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
        var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
        var stackCalculationInfo = (0, (0, parcelRequire("5R8Hi")).enableDataStack)(seriesModel, {
            schema: schema,
            store: store
        });
        var data = new (0, (0, parcelRequire("liBXN")).default)(schema, seriesModel);
        data.setCalculationInfo(stackCalculationInfo);
        var dimValueGetter = firstCategoryDimIndex != null && $8711aa3240a9c687$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
            return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
        } : null;
        data.hasItemOption = false;
        data.initData(isOriginalSource ? source : store, null, dimValueGetter);
        return data;
    }
    function $8711aa3240a9c687$var$isNeedCompleteOrdinalData(source) {
        if (source.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) {
            var sampleItem = $8711aa3240a9c687$var$firstDataNotNull(source.data || []);
            return sampleItem != null && !(0, parcelRequire("bahqM")).isArray((0, (0, parcelRequire("eaKsF")).getDataItemValue)(sampleItem));
        }
    }
    function $8711aa3240a9c687$var$firstDataNotNull(arr) {
        var i = 0;
        while(i < arr.length && arr[i] == null)i++;
        return arr[i];
    }
    var $8711aa3240a9c687$export$2e2bcd8739ae039 = $8711aa3240a9c687$var$createSeriesData;
});
parcelRegister("liBXN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f818ba28c897a2f2$export$2e2bcd8739ae039);
    var $bahqM;
    var $gaMkj;
    var $4wWkb;
    var $9OHWG;
    var $bnVGB;
    var $dhxbO;
    var $2Rbm1;
    var $eaKsF;
    var $7QjoM;
    var $20liu;
    var $8c3gC;
    var $2Om11;
    var $f818ba28c897a2f2$var$isObject = (0, parcelRequire("bahqM")).isObject;
    var $f818ba28c897a2f2$var$map = (0, parcelRequire("bahqM")).map;
    var $f818ba28c897a2f2$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array;
    var $f818ba28c897a2f2$var$ID_PREFIX = 'e\0\0';
    var $f818ba28c897a2f2$var$INDEX_NOT_FOUND = -1;
    var $f818ba28c897a2f2$var$TRANSFERABLE_PROPERTIES = [
        'hasItemOption',
        '_nameList',
        '_idList',
        '_invertedIndicesMap',
        '_dimSummary',
        'userOutput',
        '_rawData',
        '_dimValueGetter',
        '_nameDimIdx',
        '_idDimIdx',
        '_nameRepeatCount'
    ];
    var $f818ba28c897a2f2$var$CLONE_PROPERTIES = [
        '_approximateExtent'
    ];
    var $f818ba28c897a2f2$var$prepareInvertedIndex;
    var $f818ba28c897a2f2$var$getId;
    var $f818ba28c897a2f2$var$getIdNameFromStore;
    var $f818ba28c897a2f2$var$normalizeDimensions;
    var $f818ba28c897a2f2$var$transferProperties;
    var $f818ba28c897a2f2$var$cloneListForMapAndSample;
    var $f818ba28c897a2f2$var$makeIdFromName;
    var $f818ba28c897a2f2$var$SeriesData = function() {
        function SeriesData(dimensionsInput, hostModel) {
            this.type = 'list';
            this._dimOmitted = false;
            this._nameList = [];
            this._idList = [];
            this._visual = {};
            this._layout = {};
            this._itemVisuals = [];
            this._itemLayouts = [];
            this._graphicEls = [];
            this._approximateExtent = {};
            this._calculationInfo = {};
            this.hasItemOption = false;
            this.TRANSFERABLE_METHODS = [
                'cloneShallow',
                'downSample',
                'lttbDownSample',
                'map'
            ];
            this.CHANGABLE_METHODS = [
                'filterSelf',
                'selectRange'
            ];
            this.DOWNSAMPLE_METHODS = [
                'downSample',
                'lttbDownSample'
            ];
            var dimensions;
            var assignStoreDimIdx = false;
            if ((0, (0, parcelRequire("2Om11")).isSeriesDataSchema)(dimensionsInput)) {
                dimensions = dimensionsInput.dimensions;
                this._dimOmitted = dimensionsInput.isDimensionOmitted();
                this._schema = dimensionsInput;
            } else {
                assignStoreDimIdx = true;
                dimensions = dimensionsInput;
            }
            dimensions = dimensions || [
                'x',
                'y'
            ];
            var dimensionInfos = {};
            var dimensionNames = [];
            var invertedIndicesMap = {};
            var needsHasOwn = false;
            var emptyObj = {};
            for(var i = 0; i < dimensions.length; i++){
                var dimInfoInput = dimensions[i];
                var dimensionInfo = (0, parcelRequire("bahqM")).isString(dimInfoInput) ? new (0, (0, parcelRequire("dhxbO")).default)({
                    name: dimInfoInput
                }) : !(dimInfoInput instanceof (0, (0, parcelRequire("dhxbO")).default)) ? new (0, (0, parcelRequire("dhxbO")).default)(dimInfoInput) : dimInfoInput;
                var dimensionName = dimensionInfo.name;
                dimensionInfo.type = dimensionInfo.type || 'float';
                if (!dimensionInfo.coordDim) {
                    dimensionInfo.coordDim = dimensionName;
                    dimensionInfo.coordDimIndex = 0;
                }
                var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
                dimensionNames.push(dimensionName);
                dimensionInfos[dimensionName] = dimensionInfo;
                if (emptyObj[dimensionName] != null) needsHasOwn = true;
                if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
                if (otherDims.itemName === 0) this._nameDimIdx = i;
                if (otherDims.itemId === 0) this._idDimIdx = i;
                if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
            }
            this.dimensions = dimensionNames;
            this._dimInfos = dimensionInfos;
            this._initGetDimensionInfo(needsHasOwn);
            this.hostModel = hostModel;
            this._invertedIndicesMap = invertedIndicesMap;
            if (this._dimOmitted) {
                var dimIdxToName_1 = this._dimIdxToName = (0, parcelRequire("bahqM")).createHashMap();
                (0, parcelRequire("bahqM")).each(dimensionNames, function(dimName) {
                    dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
                });
            }
        }
        SeriesData.prototype.getDimension = function(dim) {
            var dimIdx = this._recognizeDimIndex(dim);
            if (dimIdx == null) return dim;
            dimIdx = dim;
            if (!this._dimOmitted) return this.dimensions[dimIdx];
            var dimName = this._dimIdxToName.get(dimIdx);
            if (dimName != null) return dimName;
            var sourceDimDef = this._schema.getSourceDimension(dimIdx);
            if (sourceDimDef) return sourceDimDef.name;
        };
        SeriesData.prototype.getDimensionIndex = function(dim) {
            var dimIdx = this._recognizeDimIndex(dim);
            if (dimIdx != null) return dimIdx;
            if (dim == null) return -1;
            var dimInfo = this._getDimInfo(dim);
            return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
        };
        SeriesData.prototype._recognizeDimIndex = function(dim) {
            if (typeof dim === 'number' || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
        };
        SeriesData.prototype._getStoreDimIndex = function(dim) {
            var dimIdx = this.getDimensionIndex(dim);
            return dimIdx;
        };
        SeriesData.prototype.getDimensionInfo = function(dim) {
            return this._getDimInfo(this.getDimension(dim));
        };
        SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
            var dimensionInfos = this._dimInfos;
            this._getDimInfo = needsHasOwn ? function(dimName) {
                return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
            } : function(dimName) {
                return dimensionInfos[dimName];
            };
        };
        SeriesData.prototype.getDimensionsOnCoord = function() {
            return this._dimSummary.dataDimsOnCoord.slice();
        };
        SeriesData.prototype.mapDimension = function(coordDim, idx) {
            var dimensionsSummary = this._dimSummary;
            if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
            var dims = dimensionsSummary.encode[coordDim];
            return dims ? dims[idx] : null;
        };
        SeriesData.prototype.mapDimensionsAll = function(coordDim) {
            var dimensionsSummary = this._dimSummary;
            var dims = dimensionsSummary.encode[coordDim];
            return (dims || []).slice();
        };
        SeriesData.prototype.getStore = function() {
            return this._store;
        };
        SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
            var _this = this;
            var store;
            if (data instanceof (0, (0, parcelRequire("8c3gC")).default)) store = data;
            if (!store) {
                var dimensions = this.dimensions;
                var provider = (0, (0, parcelRequire("20liu")).isSourceInstance)(data) || (0, parcelRequire("bahqM")).isArrayLike(data) ? new (0, (0, parcelRequire("9OHWG")).DefaultDataProvider)(data, dimensions.length) : data;
                store = new (0, (0, parcelRequire("8c3gC")).default)();
                var dimensionInfos = $f818ba28c897a2f2$var$map(dimensions, function(dimName) {
                    return {
                        type: _this._dimInfos[dimName].type,
                        property: dimName
                    };
                });
                store.initData(provider, dimensionInfos, dimValueGetter);
            }
            this._store = store;
            this._nameList = (nameList || []).slice();
            this._idList = [];
            this._nameRepeatCount = {};
            this._doInit(0, store.count());
            this._dimSummary = (0, (0, parcelRequire("bnVGB")).summarizeDimensions)(this, this._schema);
            this.userOutput = this._dimSummary.userOutput;
        };
        SeriesData.prototype.appendData = function(data) {
            var range = this._store.appendData(data);
            this._doInit(range[0], range[1]);
        };
        SeriesData.prototype.appendValues = function(values, names) {
            var _a = this._store.appendValues(values, names.length), start = _a.start, end = _a.end;
            var shouldMakeIdFromName = this._shouldMakeIdFromName();
            this._updateOrdinalMeta();
            if (names) for(var idx = start; idx < end; idx++){
                var sourceIdx = idx - start;
                this._nameList[idx] = names[sourceIdx];
                if (shouldMakeIdFromName) $f818ba28c897a2f2$var$makeIdFromName(this, idx);
            }
        };
        SeriesData.prototype._updateOrdinalMeta = function() {
            var store = this._store;
            var dimensions = this.dimensions;
            for(var i = 0; i < dimensions.length; i++){
                var dimInfo = this._dimInfos[dimensions[i]];
                if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
            }
        };
        SeriesData.prototype._shouldMakeIdFromName = function() {
            var provider = this._store.getProvider();
            return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY) && !provider.fillStorage;
        };
        SeriesData.prototype._doInit = function(start, end) {
            if (start >= end) return;
            var store = this._store;
            var provider = store.getProvider();
            this._updateOrdinalMeta();
            var nameList = this._nameList;
            var idList = this._idList;
            var sourceFormat = provider.getSource().sourceFormat;
            var isFormatOriginal = sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL);
            if (isFormatOriginal && !provider.pure) {
                var sharedDataItem = [];
                for(var idx = start; idx < end; idx++){
                    var dataItem = provider.getItem(idx, sharedDataItem);
                    if (!this.hasItemOption && (0, (0, parcelRequire("eaKsF")).isDataItemOption)(dataItem)) this.hasItemOption = true;
                    if (dataItem) {
                        var itemName = dataItem.name;
                        if (nameList[idx] == null && itemName != null) nameList[idx] = (0, (0, parcelRequire("eaKsF")).convertOptionIdName)(itemName, null);
                        var itemId = dataItem.id;
                        if (idList[idx] == null && itemId != null) idList[idx] = (0, (0, parcelRequire("eaKsF")).convertOptionIdName)(itemId, null);
                    }
                }
            }
            if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$f818ba28c897a2f2$var$makeIdFromName(this, idx);
            $f818ba28c897a2f2$var$prepareInvertedIndex(this);
        };
        SeriesData.prototype.getApproximateExtent = function(dim) {
            return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.setApproximateExtent = function(extent, dim) {
            dim = this.getDimension(dim);
            this._approximateExtent[dim] = extent.slice();
        };
        SeriesData.prototype.getCalculationInfo = function(key) {
            return this._calculationInfo[key];
        };
        SeriesData.prototype.setCalculationInfo = function(key, value) {
            $f818ba28c897a2f2$var$isObject(key) ? (0, parcelRequire("bahqM")).extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
        };
        SeriesData.prototype.getName = function(idx) {
            var rawIndex = this.getRawIndex(idx);
            var name = this._nameList[rawIndex];
            if (name == null && this._nameDimIdx != null) name = $f818ba28c897a2f2$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
            if (name == null) name = '';
            return name;
        };
        SeriesData.prototype._getCategory = function(dimIdx, idx) {
            var ordinal = this._store.get(dimIdx, idx);
            var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
            if (ordinalMeta) return ordinalMeta.categories[ordinal];
            return ordinal;
        };
        SeriesData.prototype.getId = function(idx) {
            return $f818ba28c897a2f2$var$getId(this, this.getRawIndex(idx));
        };
        SeriesData.prototype.count = function() {
            return this._store.count();
        };
        SeriesData.prototype.get = function(dim, idx) {
            var store = this._store;
            var dimInfo = this._dimInfos[dim];
            if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
        };
        SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
            var store = this._store;
            var dimInfo = this._dimInfos[dim];
            if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
        };
        SeriesData.prototype.getIndices = function() {
            return this._store.getIndices();
        };
        SeriesData.prototype.getDataExtent = function(dim) {
            return this._store.getDataExtent(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.getSum = function(dim) {
            return this._store.getSum(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.getMedian = function(dim) {
            return this._store.getMedian(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.getValues = function(dimensions, idx) {
            var _this = this;
            var store = this._store;
            return (0, parcelRequire("bahqM")).isArray(dimensions) ? store.getValues($f818ba28c897a2f2$var$map(dimensions, function(dim) {
                return _this._getStoreDimIndex(dim);
            }), idx) : store.getValues(dimensions);
        };
        SeriesData.prototype.hasValue = function(idx) {
            var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
            for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
                if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
            }
            return true;
        };
        SeriesData.prototype.indexOfName = function(name) {
            for(var i = 0, len = this._store.count(); i < len; i++){
                if (this.getName(i) === name) return i;
            }
            return -1;
        };
        SeriesData.prototype.getRawIndex = function(idx) {
            return this._store.getRawIndex(idx);
        };
        SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
            return this._store.indexOfRawIndex(rawIndex);
        };
        SeriesData.prototype.rawIndexOf = function(dim, value) {
            var invertedIndices = dim && this._invertedIndicesMap[dim];
            var rawIndex = invertedIndices[value];
            if (rawIndex == null || isNaN(rawIndex)) return $f818ba28c897a2f2$var$INDEX_NOT_FOUND;
            return rawIndex;
        };
        SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
            return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
        };
        SeriesData.prototype.each = function(dims, cb, ctx) {
            'use strict';
            if (typeof dims === 'function') {
                ctx = cb;
                cb = dims;
                dims = [];
            }
            var fCtx = ctx || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            this._store.each(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
        };
        SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
            'use strict';
            if (typeof dims === 'function') {
                ctx = cb;
                cb = dims;
                dims = [];
            }
            var fCtx = ctx || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            this._store = this._store.filter(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
            return this;
        };
        SeriesData.prototype.selectRange = function(range) {
            'use strict';
            var _this = this;
            var innerRange = {};
            var dims = (0, parcelRequire("bahqM")).keys(range);
            var dimIndices = [];
            (0, parcelRequire("bahqM")).each(dims, function(dim) {
                var dimIdx = _this._getStoreDimIndex(dim);
                innerRange[dimIdx] = range[dim];
                dimIndices.push(dimIdx);
            });
            this._store = this._store.selectRange(innerRange);
            return this;
        };
        SeriesData.prototype.mapArray = function(dims, cb, ctx) {
            'use strict';
            if (typeof dims === 'function') {
                ctx = cb;
                cb = dims;
                dims = [];
            }
            ctx = ctx || this;
            var result = [];
            this.each(dims, function() {
                result.push(cb && cb.apply(this, arguments));
            }, ctx);
            return result;
        };
        SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
            'use strict';
            var fCtx = ctx || ctxCompat || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
            list._store = this._store.map(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
            return list;
        };
        SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
            var _this = this;
            var fCtx = ctx || ctxCompat || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            this._store.modify(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
        };
        SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
            var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
            list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
            return list;
        };
        SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
            var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
            list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
            return list;
        };
        SeriesData.prototype.getRawDataItem = function(idx) {
            return this._store.getRawDataItem(idx);
        };
        SeriesData.prototype.getItemModel = function(idx) {
            var hostModel = this.hostModel;
            var dataItem = this.getRawDataItem(idx);
            return new (0, (0, parcelRequire("gaMkj")).default)(dataItem, hostModel, hostModel && hostModel.ecModel);
        };
        SeriesData.prototype.diff = function(otherList) {
            var thisList = this;
            return new (0, (0, parcelRequire("4wWkb")).default)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
                return $f818ba28c897a2f2$var$getId(otherList, idx);
            }, function(idx) {
                return $f818ba28c897a2f2$var$getId(thisList, idx);
            });
        };
        SeriesData.prototype.getVisual = function(key) {
            var visual = this._visual;
            return visual && visual[key];
        };
        SeriesData.prototype.setVisual = function(kvObj, val) {
            this._visual = this._visual || {};
            if ($f818ba28c897a2f2$var$isObject(kvObj)) (0, parcelRequire("bahqM")).extend(this._visual, kvObj);
            else this._visual[kvObj] = val;
        };
        SeriesData.prototype.getItemVisual = function(idx, key) {
            var itemVisual = this._itemVisuals[idx];
            var val = itemVisual && itemVisual[key];
            if (val == null) return this.getVisual(key);
            return val;
        };
        SeriesData.prototype.hasItemVisual = function() {
            return this._itemVisuals.length > 0;
        };
        SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
            var itemVisuals = this._itemVisuals;
            var itemVisual = itemVisuals[idx];
            if (!itemVisual) itemVisual = itemVisuals[idx] = {};
            var val = itemVisual[key];
            if (val == null) {
                val = this.getVisual(key);
                if ((0, parcelRequire("bahqM")).isArray(val)) val = val.slice();
                else if ($f818ba28c897a2f2$var$isObject(val)) val = (0, parcelRequire("bahqM")).extend({}, val);
                itemVisual[key] = val;
            }
            return val;
        };
        SeriesData.prototype.setItemVisual = function(idx, key, value) {
            var itemVisual = this._itemVisuals[idx] || {};
            this._itemVisuals[idx] = itemVisual;
            if ($f818ba28c897a2f2$var$isObject(key)) (0, parcelRequire("bahqM")).extend(itemVisual, key);
            else itemVisual[key] = value;
        };
        SeriesData.prototype.clearAllVisual = function() {
            this._visual = {};
            this._itemVisuals = [];
        };
        SeriesData.prototype.setLayout = function(key, val) {
            if ($f818ba28c897a2f2$var$isObject(key)) {
                for(var name_1 in key)if (key.hasOwnProperty(name_1)) this.setLayout(name_1, key[name_1]);
                return;
            }
            this._layout[key] = val;
        };
        SeriesData.prototype.getLayout = function(key) {
            return this._layout[key];
        };
        SeriesData.prototype.getItemLayout = function(idx) {
            return this._itemLayouts[idx];
        };
        SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
            this._itemLayouts[idx] = merge ? (0, parcelRequire("bahqM")).extend(this._itemLayouts[idx] || {}, layout) : layout;
        };
        SeriesData.prototype.clearItemLayouts = function() {
            this._itemLayouts.length = 0;
        };
        SeriesData.prototype.setItemGraphicEl = function(idx, el) {
            var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
            (0, (0, parcelRequire("7QjoM")).setCommonECData)(seriesIndex, this.dataType, idx, el);
            this._graphicEls[idx] = el;
        };
        SeriesData.prototype.getItemGraphicEl = function(idx) {
            return this._graphicEls[idx];
        };
        SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
            (0, parcelRequire("bahqM")).each(this._graphicEls, function(el, idx) {
                if (el) cb && cb.call(context, el, idx);
            });
        };
        SeriesData.prototype.cloneShallow = function(list) {
            if (!list) list = new SeriesData(this._schema ? this._schema : $f818ba28c897a2f2$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
            $f818ba28c897a2f2$var$transferProperties(list, this);
            list._store = this._store;
            return list;
        };
        SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
            var originalMethod = this[methodName];
            if (typeof originalMethod !== 'function') return;
            this.__wrappedMethods = this.__wrappedMethods || [];
            this.__wrappedMethods.push(methodName);
            this[methodName] = function() {
                var res = originalMethod.apply(this, arguments);
                return injectFunction.apply(this, [
                    res
                ].concat((0, parcelRequire("bahqM")).slice(arguments)));
            };
        };
        SeriesData.internalField = function() {
            $f818ba28c897a2f2$var$prepareInvertedIndex = function(data) {
                var invertedIndicesMap = data._invertedIndicesMap;
                (0, parcelRequire("bahqM")).each(invertedIndicesMap, function(invertedIndices, dim) {
                    var dimInfo = data._dimInfos[dim];
                    var ordinalMeta = dimInfo.ordinalMeta;
                    var store = data._store;
                    if (ordinalMeta) {
                        invertedIndices = invertedIndicesMap[dim] = new $f818ba28c897a2f2$var$CtorInt32Array(ordinalMeta.categories.length);
                        for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $f818ba28c897a2f2$var$INDEX_NOT_FOUND;
                        for(var i = 0; i < store.count(); i++)invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                    }
                });
            };
            $f818ba28c897a2f2$var$getIdNameFromStore = function(data, dimIdx, idx) {
                return (0, (0, parcelRequire("eaKsF")).convertOptionIdName)(data._getCategory(dimIdx, idx), null);
            };
            $f818ba28c897a2f2$var$getId = function(data, rawIndex) {
                var id = data._idList[rawIndex];
                if (id == null && data._idDimIdx != null) id = $f818ba28c897a2f2$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
                if (id == null) id = $f818ba28c897a2f2$var$ID_PREFIX + rawIndex;
                return id;
            };
            $f818ba28c897a2f2$var$normalizeDimensions = function(dimensions) {
                if (!(0, parcelRequire("bahqM")).isArray(dimensions)) dimensions = dimensions != null ? [
                    dimensions
                ] : [];
                return dimensions;
            };
            $f818ba28c897a2f2$var$cloneListForMapAndSample = function(original) {
                var list = new SeriesData(original._schema ? original._schema : $f818ba28c897a2f2$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
                $f818ba28c897a2f2$var$transferProperties(list, original);
                return list;
            };
            $f818ba28c897a2f2$var$transferProperties = function(target, source) {
                (0, parcelRequire("bahqM")).each($f818ba28c897a2f2$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                    if (source.hasOwnProperty(propName)) target[propName] = source[propName];
                });
                target.__wrappedMethods = source.__wrappedMethods;
                (0, parcelRequire("bahqM")).each($f818ba28c897a2f2$var$CLONE_PROPERTIES, function(propName) {
                    target[propName] = (0, parcelRequire("bahqM")).clone(source[propName]);
                });
                target._calculationInfo = (0, parcelRequire("bahqM")).extend({}, source._calculationInfo);
            };
            $f818ba28c897a2f2$var$makeIdFromName = function(data, idx) {
                var nameList = data._nameList;
                var idList = data._idList;
                var nameDimIdx = data._nameDimIdx;
                var idDimIdx = data._idDimIdx;
                var name = nameList[idx];
                var id = idList[idx];
                if (name == null && nameDimIdx != null) nameList[idx] = name = $f818ba28c897a2f2$var$getIdNameFromStore(data, nameDimIdx, idx);
                if (id == null && idDimIdx != null) idList[idx] = id = $f818ba28c897a2f2$var$getIdNameFromStore(data, idDimIdx, idx);
                if (id == null && name != null) {
                    var nameRepeatCount = data._nameRepeatCount;
                    var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                    id = name;
                    if (nmCnt > 1) id += '__ec__' + nmCnt;
                    idList[idx] = id;
                }
            };
        }();
        return SeriesData;
    }();
    var $f818ba28c897a2f2$export$2e2bcd8739ae039 = $f818ba28c897a2f2$var$SeriesData;
});
parcelRegister("gaMkj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc63113067804ddc$export$2e2bcd8739ae039);
    var $hZfwb;
    var $aLwh0;
    var $8P3Or;
    var $hyGik;
    var $46U6E;
    var $4rldO;
    var $bahqM;
    var $bc63113067804ddc$var$Model = function() {
        function Model(option, parentModel, ecModel) {
            this.parentModel = parentModel;
            this.ecModel = ecModel;
            this.option = option;
        }
        Model.prototype.init = function(option, parentModel, ecModel) {
            var rest = [];
            for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
        };
        Model.prototype.mergeOption = function(option, ecModel) {
            (0, (0, parcelRequire("bahqM")).merge)(this.option, option, true);
        };
        Model.prototype.get = function(path, ignoreParent) {
            if (path == null) return this.option;
            return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
        };
        Model.prototype.getShallow = function(key, ignoreParent) {
            var option = this.option;
            var val = option == null ? option : option[key];
            if (val == null && !ignoreParent) {
                var parentModel = this.parentModel;
                if (parentModel) val = parentModel.getShallow(key);
            }
            return val;
        };
        Model.prototype.getModel = function(path, parentModel) {
            var hasPath = path != null;
            var pathFinal = hasPath ? this.parsePath(path) : null;
            var obj = hasPath ? this._doGet(pathFinal) : this.option;
            parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
            return new Model(obj, parentModel, this.ecModel);
        };
        Model.prototype.isEmpty = function() {
            return this.option == null;
        };
        Model.prototype.restoreData = function() {};
        Model.prototype.clone = function() {
            var Ctor = this.constructor;
            return new Ctor((0, (0, parcelRequire("bahqM")).clone)(this.option));
        };
        Model.prototype.parsePath = function(path) {
            if (typeof path === 'string') return path.split('.');
            return path;
        };
        Model.prototype.resolveParentPath = function(path) {
            return path;
        };
        Model.prototype.isAnimationEnabled = function() {
            if (!(0, (0, parcelRequire("hZfwb")).default).node && this.option) {
                if (this.option.animation != null) return !!this.option.animation;
                else if (this.parentModel) return this.parentModel.isAnimationEnabled();
            }
        };
        Model.prototype._doGet = function(pathArr, parentModel) {
            var obj = this.option;
            if (!pathArr) return obj;
            for(var i = 0; i < pathArr.length; i++){
                if (!pathArr[i]) continue;
                obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
                if (obj == null) break;
            }
            if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
            return obj;
        };
        return Model;
    }();
    (0, (0, parcelRequire("aLwh0")).enableClassExtend)($bc63113067804ddc$var$Model);
    (0, (0, parcelRequire("aLwh0")).enableClassCheck)($bc63113067804ddc$var$Model);
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("46U6E")).LineStyleMixin));
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("4rldO")).ItemStyleMixin));
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("8P3Or")).AreaStyleMixin));
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("hyGik")).default));
    var $bc63113067804ddc$export$2e2bcd8739ae039 = $bc63113067804ddc$var$Model;
});
parcelRegister("8P3Or", function(module, exports) {
    $parcel$export(module.exports, "AreaStyleMixin", ()=>$66c60b4522f41760$export$a3a0ed7e2dd84c9e);
    var $1BJbl;
    var $66c60b4522f41760$export$52de6e304d934d85 = [
        [
            'fill',
            'color'
        ],
        [
            'shadowBlur'
        ],
        [
            'shadowOffsetX'
        ],
        [
            'shadowOffsetY'
        ],
        [
            'opacity'
        ],
        [
            'shadowColor'
        ]
    ];
    var $66c60b4522f41760$var$getAreaStyle = (0, (0, parcelRequire("1BJbl")).default)($66c60b4522f41760$export$52de6e304d934d85);
    var $66c60b4522f41760$export$a3a0ed7e2dd84c9e = function() {
        function AreaStyleMixin() {}
        AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
            return $66c60b4522f41760$var$getAreaStyle(this, excludes, includes);
        };
        return AreaStyleMixin;
    }();
});
parcelRegister("1BJbl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12bc4b5222290b4b$export$2e2bcd8739ae039);
    var $bahqM;
    function $12bc4b5222290b4b$export$2e2bcd8739ae039(properties, ignoreParent) {
        for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
        ignoreParent = ignoreParent || false;
        return function(model, excludes, includes) {
            var style = {};
            for(var i = 0; i < properties.length; i++){
                var propName = properties[i][1];
                if (excludes && (0, parcelRequire("bahqM")).indexOf(excludes, propName) >= 0 || includes && (0, parcelRequire("bahqM")).indexOf(includes, propName) < 0) continue;
                var val = model.getShallow(propName, ignoreParent);
                if (val != null) style[properties[i][0]] = val;
            }
            return style;
        };
    }
});
parcelRegister("hyGik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc866b770f3f8e08$export$2e2bcd8739ae039);
    var $gvLUt;
    var $4gEFv;
    var $cc866b770f3f8e08$var$PATH_COLOR = [
        'textStyle',
        'color'
    ];
    var $cc866b770f3f8e08$var$tmpRichText = new (0, (0, parcelRequire("4gEFv")).default)();
    var $cc866b770f3f8e08$var$TextStyleMixin = function() {
        function TextStyleMixin() {}
        TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
            var ecModel = this.ecModel;
            return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($cc866b770f3f8e08$var$PATH_COLOR) : null);
        };
        TextStyleMixin.prototype.getFont = function() {
            return (0, (0, parcelRequire("gvLUt")).getFont)({
                fontStyle: this.getShallow('fontStyle'),
                fontWeight: this.getShallow('fontWeight'),
                fontSize: this.getShallow('fontSize'),
                fontFamily: this.getShallow('fontFamily')
            }, this.ecModel);
        };
        TextStyleMixin.prototype.getTextRect = function(text) {
            $cc866b770f3f8e08$var$tmpRichText.useStyle({
                text: text,
                fontStyle: this.getShallow('fontStyle'),
                fontWeight: this.getShallow('fontWeight'),
                fontSize: this.getShallow('fontSize'),
                fontFamily: this.getShallow('fontFamily'),
                verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline'),
                padding: this.getShallow('padding'),
                lineHeight: this.getShallow('lineHeight'),
                rich: this.getShallow('rich')
            });
            $cc866b770f3f8e08$var$tmpRichText.update();
            return $cc866b770f3f8e08$var$tmpRichText.getBoundingRect();
        };
        return TextStyleMixin;
    }();
    var $cc866b770f3f8e08$export$2e2bcd8739ae039 = $cc866b770f3f8e08$var$TextStyleMixin;
});
parcelRegister("46U6E", function(module, exports) {
    $parcel$export(module.exports, "LINE_STYLE_KEY_MAP", ()=>$2fe33e7a8dd518cd$export$9f34de5b59222949);
    $parcel$export(module.exports, "LineStyleMixin", ()=>$2fe33e7a8dd518cd$export$91eeeeed4a69a7e7);
    var $1BJbl;
    var $2fe33e7a8dd518cd$export$9f34de5b59222949 = [
        [
            'lineWidth',
            'width'
        ],
        [
            'stroke',
            'color'
        ],
        [
            'opacity'
        ],
        [
            'shadowBlur'
        ],
        [
            'shadowOffsetX'
        ],
        [
            'shadowOffsetY'
        ],
        [
            'shadowColor'
        ],
        [
            'lineDash',
            'type'
        ],
        [
            'lineDashOffset',
            'dashOffset'
        ],
        [
            'lineCap',
            'cap'
        ],
        [
            'lineJoin',
            'join'
        ],
        [
            'miterLimit'
        ]
    ];
    var $2fe33e7a8dd518cd$var$getLineStyle = (0, (0, parcelRequire("1BJbl")).default)($2fe33e7a8dd518cd$export$9f34de5b59222949);
    var $2fe33e7a8dd518cd$export$91eeeeed4a69a7e7 = function() {
        function LineStyleMixin() {}
        LineStyleMixin.prototype.getLineStyle = function(excludes) {
            return $2fe33e7a8dd518cd$var$getLineStyle(this, excludes);
        };
        return LineStyleMixin;
    }();
});
parcelRegister("4rldO", function(module, exports) {
    $parcel$export(module.exports, "ITEM_STYLE_KEY_MAP", ()=>$33ba2539bbc4d618$export$ffb0bba5dde0130b);
    $parcel$export(module.exports, "ItemStyleMixin", ()=>$33ba2539bbc4d618$export$e4f01e48d6fda412);
    var $1BJbl;
    var $33ba2539bbc4d618$export$ffb0bba5dde0130b = [
        [
            'fill',
            'color'
        ],
        [
            'stroke',
            'borderColor'
        ],
        [
            'lineWidth',
            'borderWidth'
        ],
        [
            'opacity'
        ],
        [
            'shadowBlur'
        ],
        [
            'shadowOffsetX'
        ],
        [
            'shadowOffsetY'
        ],
        [
            'shadowColor'
        ],
        [
            'lineDash',
            'borderType'
        ],
        [
            'lineDashOffset',
            'borderDashOffset'
        ],
        [
            'lineCap',
            'borderCap'
        ],
        [
            'lineJoin',
            'borderJoin'
        ],
        [
            'miterLimit',
            'borderMiterLimit'
        ]
    ];
    var $33ba2539bbc4d618$var$getItemStyle = (0, (0, parcelRequire("1BJbl")).default)($33ba2539bbc4d618$export$ffb0bba5dde0130b);
    var $33ba2539bbc4d618$export$e4f01e48d6fda412 = function() {
        function ItemStyleMixin() {}
        ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
            return $33ba2539bbc4d618$var$getItemStyle(this, excludes, includes);
        };
        return ItemStyleMixin;
    }();
});
parcelRegister("4wWkb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34c7649bb9fc460b$export$2e2bcd8739ae039);
    function $34c7649bb9fc460b$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
        return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
    }
    function $34c7649bb9fc460b$var$defaultKeyGetter(item) {
        return item;
    }
    var $34c7649bb9fc460b$var$DataDiffer = function() {
        function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, diffMode) {
            this._old = oldArr;
            this._new = newArr;
            this._oldKeyGetter = oldKeyGetter || $34c7649bb9fc460b$var$defaultKeyGetter;
            this._newKeyGetter = newKeyGetter || $34c7649bb9fc460b$var$defaultKeyGetter;
            this.context = context;
            this._diffModeMultiple = diffMode === 'multiple';
        }
        DataDiffer.prototype.add = function(func) {
            this._add = func;
            return this;
        };
        DataDiffer.prototype.update = function(func) {
            this._update = func;
            return this;
        };
        DataDiffer.prototype.updateManyToOne = function(func) {
            this._updateManyToOne = func;
            return this;
        };
        DataDiffer.prototype.updateOneToMany = function(func) {
            this._updateOneToMany = func;
            return this;
        };
        DataDiffer.prototype.updateManyToMany = function(func) {
            this._updateManyToMany = func;
            return this;
        };
        DataDiffer.prototype.remove = function(func) {
            this._remove = func;
            return this;
        };
        DataDiffer.prototype.execute = function() {
            this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
        };
        DataDiffer.prototype._executeOneToOne = function() {
            var oldArr = this._old;
            var newArr = this._new;
            var newDataIndexMap = {};
            var oldDataKeyArr = new Array(oldArr.length);
            var newDataKeyArr = new Array(newArr.length);
            this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
            this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
            for(var i = 0; i < oldArr.length; i++){
                var oldKey = oldDataKeyArr[i];
                var newIdxMapVal = newDataIndexMap[oldKey];
                var newIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
                if (newIdxMapValLen > 1) {
                    var newIdx = newIdxMapVal.shift();
                    if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                    this._update && this._update(newIdx, i);
                } else if (newIdxMapValLen === 1) {
                    newDataIndexMap[oldKey] = null;
                    this._update && this._update(newIdxMapVal, i);
                } else this._remove && this._remove(i);
            }
            this._performRestAdd(newDataKeyArr, newDataIndexMap);
        };
        DataDiffer.prototype._executeMultiple = function() {
            var oldArr = this._old;
            var newArr = this._new;
            var oldDataIndexMap = {};
            var newDataIndexMap = {};
            var oldDataKeyArr = [];
            var newDataKeyArr = [];
            this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
            this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
            for(var i = 0; i < oldDataKeyArr.length; i++){
                var oldKey = oldDataKeyArr[i];
                var oldIdxMapVal = oldDataIndexMap[oldKey];
                var newIdxMapVal = newDataIndexMap[oldKey];
                var oldIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(oldIdxMapVal);
                var newIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
                if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                    this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                    this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                    this._update && this._update(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                    this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
                else this._remove && this._remove(oldIdxMapVal);
            }
            this._performRestAdd(newDataKeyArr, newDataIndexMap);
        };
        DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
            for(var i = 0; i < newDataKeyArr.length; i++){
                var newKey = newDataKeyArr[i];
                var newIdxMapVal = newDataIndexMap[newKey];
                var idxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
                if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
                else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
                newDataIndexMap[newKey] = null;
            }
        };
        DataDiffer.prototype._initIndexMap = function(arr, map, keyArr, keyGetterName) {
            var cbModeMultiple = this._diffModeMultiple;
            for(var i = 0; i < arr.length; i++){
                var key = '_ec_' + this[keyGetterName](arr[i], i);
                if (!cbModeMultiple) keyArr[i] = key;
                if (!map) continue;
                var idxMapVal = map[key];
                var idxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(idxMapVal);
                if (idxMapValLen === 0) {
                    map[key] = i;
                    if (cbModeMultiple) keyArr.push(key);
                } else if (idxMapValLen === 1) map[key] = [
                    idxMapVal,
                    i
                ];
                else idxMapVal.push(i);
            }
        };
        return DataDiffer;
    }();
    var $34c7649bb9fc460b$export$2e2bcd8739ae039 = $34c7649bb9fc460b$var$DataDiffer;
});
parcelRegister("bnVGB", function(module, exports) {
    $parcel$export(module.exports, "summarizeDimensions", ()=>$849e96f8af2f129f$export$505a22c3734846f1);
    $parcel$export(module.exports, "getDimensionTypeByAxis", ()=>$849e96f8af2f129f$export$af1622903e71278e);
    var $bahqM;
    var $2Rbm1;
    var $849e96f8af2f129f$var$DimensionUserOuput = function() {
        function DimensionUserOuput(encode, dimRequest) {
            this._encode = encode;
            this._schema = dimRequest;
        }
        DimensionUserOuput.prototype.get = function() {
            return {
                fullDimensions: this._getFullDimensionNames(),
                encode: this._encode
            };
        };
        DimensionUserOuput.prototype._getFullDimensionNames = function() {
            if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
            return this._cachedDimNames;
        };
        return DimensionUserOuput;
    }();
    function $849e96f8af2f129f$export$505a22c3734846f1(data, schema) {
        var summary = {};
        var encode = summary.encode = {};
        var notExtraCoordDimMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var defaultedLabel = [];
        var defaultedTooltip = [];
        var userOutputEncode = {};
        (0, (0, parcelRequire("bahqM")).each)(data.dimensions, function(dimName) {
            var dimItem = data.getDimensionInfo(dimName);
            var coordDim = dimItem.coordDim;
            if (coordDim) {
                var coordDimIndex = dimItem.coordDimIndex;
                $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
                if (!dimItem.isExtraCoord) {
                    notExtraCoordDimMap.set(coordDim, 1);
                    if ($849e96f8af2f129f$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                    $849e96f8af2f129f$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
                }
                if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
            }
            (0, (0, parcelRequire("2Rbm1")).VISUAL_DIMENSIONS).each(function(v, otherDim) {
                var encodeArr = $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, otherDim);
                var dimIndex = dimItem.otherDims[otherDim];
                if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
            });
        });
        var dataDimsOnCoord = [];
        var encodeFirstDimNotExtra = {};
        notExtraCoordDimMap.each(function(v, coordDim) {
            var dimArr = encode[coordDim];
            encodeFirstDimNotExtra[coordDim] = dimArr[0];
            dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
        });
        summary.dataDimsOnCoord = dataDimsOnCoord;
        summary.dataDimIndicesOnCoord = (0, (0, parcelRequire("bahqM")).map)(dataDimsOnCoord, function(dimName) {
            return data.getDimensionInfo(dimName).storeDimIndex;
        });
        summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
        var encodeLabel = encode.label;
        if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
        var encodeTooltip = encode.tooltip;
        if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
        else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
        encode.defaultedLabel = defaultedLabel;
        encode.defaultedTooltip = defaultedTooltip;
        summary.userOutput = new $849e96f8af2f129f$var$DimensionUserOuput(userOutputEncode, schema);
        return summary;
    }
    function $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, dim) {
        if (!encode.hasOwnProperty(dim)) encode[dim] = [];
        return encode[dim];
    }
    function $849e96f8af2f129f$export$af1622903e71278e(axisType) {
        return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
    }
    function $849e96f8af2f129f$var$mayLabelDimType(dimType) {
        return !(dimType === 'ordinal' || dimType === 'time');
    }
});
parcelRegister("dhxbO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ab69ba7880d9dc2$export$2e2bcd8739ae039);
    var $bahqM;
    var $9ab69ba7880d9dc2$var$SeriesDimensionDefine = function() {
        function SeriesDimensionDefine(opt) {
            this.otherDims = {};
            if (opt != null) (0, parcelRequire("bahqM")).extend(this, opt);
        }
        return SeriesDimensionDefine;
    }();
    var $9ab69ba7880d9dc2$export$2e2bcd8739ae039 = $9ab69ba7880d9dc2$var$SeriesDimensionDefine;
});
parcelRegister("8c3gC", function(module, exports) {
    $parcel$export(module.exports, "CtorInt32Array", ()=>$5f71fa7e68f8e2cf$export$b60d945128546f53);
    $parcel$export(module.exports, "default", ()=>$5f71fa7e68f8e2cf$export$2e2bcd8739ae039);
    var $bahqM;
    var $2G90t;
    var $20liu;
    var $5f71fa7e68f8e2cf$var$UNDEFINED = 'undefined';
    var $5f71fa7e68f8e2cf$export$859a1fa4f1106aa0 = typeof Uint32Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Uint32Array;
    var $5f71fa7e68f8e2cf$export$78cf73566f32c185 = typeof Uint16Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Uint16Array;
    var $5f71fa7e68f8e2cf$export$b60d945128546f53 = typeof Int32Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Int32Array;
    var $5f71fa7e68f8e2cf$export$365b104db51a490a = typeof Float64Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Float64Array;
    var $5f71fa7e68f8e2cf$var$dataCtors = {
        'float': $5f71fa7e68f8e2cf$export$365b104db51a490a,
        'int': $5f71fa7e68f8e2cf$export$b60d945128546f53,
        'ordinal': Array,
        'number': Array,
        'time': $5f71fa7e68f8e2cf$export$365b104db51a490a
    };
    var $5f71fa7e68f8e2cf$var$defaultDimValueGetters;
    function $5f71fa7e68f8e2cf$var$getIndicesCtor(rawCount) {
        return rawCount > 65535 ? $5f71fa7e68f8e2cf$export$859a1fa4f1106aa0 : $5f71fa7e68f8e2cf$export$78cf73566f32c185;
    }
    function $5f71fa7e68f8e2cf$var$getInitialExtent() {
        return [
            Infinity,
            -Infinity
        ];
    }
    function $5f71fa7e68f8e2cf$var$cloneChunk(originalChunk) {
        var Ctor = originalChunk.constructor;
        return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
    }
    function $5f71fa7e68f8e2cf$var$prepareStore(store, dimIdx, dimType, end, append) {
        var DataCtor = $5f71fa7e68f8e2cf$var$dataCtors[dimType || 'float'];
        if (append) {
            var oldStore = store[dimIdx];
            var oldLen = oldStore && oldStore.length;
            if (!(oldLen === end)) {
                var newStore = new DataCtor(end);
                for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
                store[dimIdx] = newStore;
            }
        } else store[dimIdx] = new DataCtor(end);
    }
    var $5f71fa7e68f8e2cf$var$DataStore = function() {
        function DataStore() {
            this._chunks = [];
            this._rawExtent = [];
            this._extent = [];
            this._count = 0;
            this._rawCount = 0;
            this._calcDimNameToIdx = (0, (0, parcelRequire("bahqM")).createHashMap)();
        }
        DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
            this._provider = provider;
            this._chunks = [];
            this._indices = null;
            this.getRawIndex = this._getRawIdxIdentity;
            var source = provider.getSource();
            var defaultGetter = this.defaultDimValueGetter = $5f71fa7e68f8e2cf$var$defaultDimValueGetters[source.sourceFormat];
            this._dimValueGetter = dimValueGetter || defaultGetter;
            this._rawExtent = [];
            var willRetrieveDataByName = (0, (0, parcelRequire("20liu")).shouldRetrieveDataByName)(source);
            this._dimensions = (0, (0, parcelRequire("bahqM")).map)(inputDimensions, function(dim) {
                return {
                    type: dim.type,
                    property: dim.property
                };
            });
            this._initDataFromProvider(0, provider.count());
        };
        DataStore.prototype.getProvider = function() {
            return this._provider;
        };
        DataStore.prototype.getSource = function() {
            return this._provider.getSource();
        };
        DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
            var calcDimNameToIdx = this._calcDimNameToIdx;
            var dimensions = this._dimensions;
            var calcDimIdx = calcDimNameToIdx.get(dimName);
            if (calcDimIdx != null) {
                if (dimensions[calcDimIdx].type === type) return calcDimIdx;
            } else calcDimIdx = dimensions.length;
            dimensions[calcDimIdx] = {
                type: type
            };
            calcDimNameToIdx.set(dimName, calcDimIdx);
            this._chunks[calcDimIdx] = new $5f71fa7e68f8e2cf$var$dataCtors[type || 'float'](this._rawCount);
            this._rawExtent[calcDimIdx] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            return calcDimIdx;
        };
        DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
            var chunk = this._chunks[dimIdx];
            var dim = this._dimensions[dimIdx];
            var rawExtents = this._rawExtent;
            var offset = dim.ordinalOffset || 0;
            var len = chunk.length;
            if (offset === 0) rawExtents[dimIdx] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            var dimRawExtent = rawExtents[dimIdx];
            for(var i = offset; i < len; i++){
                var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
            dim.ordinalMeta = ordinalMeta;
            dim.ordinalOffset = len;
            dim.type = 'ordinal';
        };
        DataStore.prototype.getOrdinalMeta = function(dimIdx) {
            var dimInfo = this._dimensions[dimIdx];
            var ordinalMeta = dimInfo.ordinalMeta;
            return ordinalMeta;
        };
        DataStore.prototype.getDimensionProperty = function(dimIndex) {
            var item = this._dimensions[dimIndex];
            return item && item.property;
        };
        DataStore.prototype.appendData = function(data) {
            var provider = this._provider;
            var start = this.count();
            provider.appendData(data);
            var end = provider.count();
            if (!provider.persistent) end += start;
            if (start < end) this._initDataFromProvider(start, end, true);
            return [
                start,
                end
            ];
        };
        DataStore.prototype.appendValues = function(values, minFillLen) {
            var chunks = this._chunks;
            var dimensions = this._dimensions;
            var dimLen = dimensions.length;
            var rawExtent = this._rawExtent;
            var start = this.count();
            var end = start + Math.max(values.length, minFillLen || 0);
            for(var i = 0; i < dimLen; i++){
                var dim = dimensions[i];
                $5f71fa7e68f8e2cf$var$prepareStore(chunks, i, dim.type, end, true);
            }
            var emptyDataItem = [];
            for(var idx = start; idx < end; idx++){
                var sourceIdx = idx - start;
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dim = dimensions[dimIdx];
                    var val = $5f71fa7e68f8e2cf$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                    chunks[dimIdx][idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
            this._rawCount = this._count = end;
            return {
                start: start,
                end: end
            };
        };
        DataStore.prototype._initDataFromProvider = function(start, end, append) {
            var provider = this._provider;
            var chunks = this._chunks;
            var dimensions = this._dimensions;
            var dimLen = dimensions.length;
            var rawExtent = this._rawExtent;
            var dimNames = (0, (0, parcelRequire("bahqM")).map)(dimensions, function(dim) {
                return dim.property;
            });
            for(var i = 0; i < dimLen; i++){
                var dim = dimensions[i];
                if (!rawExtent[i]) rawExtent[i] = $5f71fa7e68f8e2cf$var$getInitialExtent();
                $5f71fa7e68f8e2cf$var$prepareStore(chunks, i, dim.type, end, append);
            }
            if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
            else {
                var dataItem = [];
                for(var idx = start; idx < end; idx++){
                    dataItem = provider.getItem(idx, dataItem);
                    for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                        var dimStorage = chunks[dimIdx];
                        var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                        dimStorage[idx] = val;
                        var dimRawExtent = rawExtent[dimIdx];
                        val < dimRawExtent[0] && (dimRawExtent[0] = val);
                        val > dimRawExtent[1] && (dimRawExtent[1] = val);
                    }
                }
            }
            if (!provider.persistent && provider.clean) provider.clean();
            this._rawCount = this._count = end;
            this._extent = [];
        };
        DataStore.prototype.count = function() {
            return this._count;
        };
        DataStore.prototype.get = function(dim, idx) {
            if (!(idx >= 0 && idx < this._count)) return NaN;
            var dimStore = this._chunks[dim];
            return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
        };
        DataStore.prototype.getValues = function(dimensions, idx) {
            var values = [];
            var dimArr = [];
            if (idx == null) {
                idx = dimensions;
                dimensions = [];
                for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
            } else dimArr = dimensions;
            for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
            return values;
        };
        DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
            if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
            var dimStore = this._chunks[dim];
            return dimStore ? dimStore[rawIdx] : NaN;
        };
        DataStore.prototype.getSum = function(dim) {
            var dimData = this._chunks[dim];
            var sum = 0;
            if (dimData) for(var i = 0, len = this.count(); i < len; i++){
                var value = this.get(dim, i);
                if (!isNaN(value)) sum += value;
            }
            return sum;
        };
        DataStore.prototype.getMedian = function(dim) {
            var dimDataArray = [];
            this.each([
                dim
            ], function(val) {
                if (!isNaN(val)) dimDataArray.push(val);
            });
            var sortedDimDataArray = dimDataArray.sort(function(a, b) {
                return a - b;
            });
            var len = this.count();
            return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
        };
        DataStore.prototype.indexOfRawIndex = function(rawIndex) {
            if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
            if (!this._indices) return rawIndex;
            var indices = this._indices;
            var rawDataIndex = indices[rawIndex];
            if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
            var left = 0;
            var right = this._count - 1;
            while(left <= right){
                var mid = (left + right) / 2 | 0;
                if (indices[mid] < rawIndex) left = mid + 1;
                else if (indices[mid] > rawIndex) right = mid - 1;
                else return mid;
            }
            return -1;
        };
        DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
            var chunks = this._chunks;
            var dimData = chunks[dim];
            var nearestIndices = [];
            if (!dimData) return nearestIndices;
            if (maxDistance == null) maxDistance = Infinity;
            var minDist = Infinity;
            var minDiff = -1;
            var nearestIndicesLen = 0;
            for(var i = 0, len = this.count(); i < len; i++){
                var dataIndex = this.getRawIndex(i);
                var diff = value - dimData[dataIndex];
                var dist = Math.abs(diff);
                if (dist <= maxDistance) {
                    if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                        minDist = dist;
                        minDiff = diff;
                        nearestIndicesLen = 0;
                    }
                    if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
                }
            }
            nearestIndices.length = nearestIndicesLen;
            return nearestIndices;
        };
        DataStore.prototype.getIndices = function() {
            var newIndices;
            var indices = this._indices;
            if (indices) {
                var Ctor = indices.constructor;
                var thisCount = this._count;
                if (Ctor === Array) {
                    newIndices = new Ctor(thisCount);
                    for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
                } else newIndices = new Ctor(indices.buffer, 0, thisCount);
            } else {
                var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount);
                newIndices = new Ctor(this.count());
                for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
            }
            return newIndices;
        };
        DataStore.prototype.filter = function(dims, cb) {
            if (!this._count) return this;
            var newStore = this.clone();
            var count = newStore.count();
            var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(newStore._rawCount);
            var newIndices = new Ctor(count);
            var value = [];
            var dimSize = dims.length;
            var offset = 0;
            var dim0 = dims[0];
            var chunks = newStore._chunks;
            for(var i = 0; i < count; i++){
                var keep = void 0;
                var rawIdx = newStore.getRawIndex(i);
                if (dimSize === 0) keep = cb(i);
                else if (dimSize === 1) {
                    var val = chunks[dim0][rawIdx];
                    keep = cb(val, i);
                } else {
                    var k = 0;
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    value[k] = i;
                    keep = cb.apply(null, value);
                }
                if (keep) newIndices[offset++] = rawIdx;
            }
            if (offset < count) newStore._indices = newIndices;
            newStore._count = offset;
            newStore._extent = [];
            newStore._updateGetRawIdx();
            return newStore;
        };
        DataStore.prototype.selectRange = function(range) {
            var newStore = this.clone();
            var len = newStore._count;
            if (!len) return this;
            var dims = (0, (0, parcelRequire("bahqM")).keys)(range);
            var dimSize = dims.length;
            if (!dimSize) return this;
            var originalCount = newStore.count();
            var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(newStore._rawCount);
            var newIndices = new Ctor(originalCount);
            var offset = 0;
            var dim0 = dims[0];
            var min = range[dim0][0];
            var max = range[dim0][1];
            var storeArr = newStore._chunks;
            var quickFinished = false;
            if (!newStore._indices) {
                var idx = 0;
                if (dimSize === 1) {
                    var dimStorage = storeArr[dims[0]];
                    for(var i = 0; i < len; i++){
                        var val = dimStorage[i];
                        if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                        idx++;
                    }
                    quickFinished = true;
                } else if (dimSize === 2) {
                    var dimStorage = storeArr[dims[0]];
                    var dimStorage2 = storeArr[dims[1]];
                    var min2 = range[dims[1]][0];
                    var max2 = range[dims[1]][1];
                    for(var i = 0; i < len; i++){
                        var val = dimStorage[i];
                        var val2 = dimStorage2[i];
                        if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                        idx++;
                    }
                    quickFinished = true;
                }
            }
            if (!quickFinished) {
                if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                    var rawIndex = newStore.getRawIndex(i);
                    var val = storeArr[dims[0]][rawIndex];
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
                }
                else for(var i = 0; i < originalCount; i++){
                    var keep = true;
                    var rawIndex = newStore.getRawIndex(i);
                    for(var k = 0; k < dimSize; k++){
                        var dimk = dims[k];
                        var val = storeArr[dimk][rawIndex];
                        if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                    }
                    if (keep) newIndices[offset++] = newStore.getRawIndex(i);
                }
            }
            if (offset < originalCount) newStore._indices = newIndices;
            newStore._count = offset;
            newStore._extent = [];
            newStore._updateGetRawIdx();
            return newStore;
        };
        DataStore.prototype.map = function(dims, cb) {
            var target = this.clone(dims);
            this._updateDims(target, dims, cb);
            return target;
        };
        DataStore.prototype.modify = function(dims, cb) {
            this._updateDims(this, dims, cb);
        };
        DataStore.prototype._updateDims = function(target, dims, cb) {
            var targetChunks = target._chunks;
            var tmpRetValue = [];
            var dimSize = dims.length;
            var dataCount = target.count();
            var values = [];
            var rawExtent = target._rawExtent;
            for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
                var rawIndex = target.getRawIndex(dataIndex);
                for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
                values[dimSize] = dataIndex;
                var retValue = cb && cb.apply(null, values);
                if (retValue != null) {
                    if (typeof retValue !== 'object') {
                        tmpRetValue[0] = retValue;
                        retValue = tmpRetValue;
                    }
                    for(var i = 0; i < retValue.length; i++){
                        var dim = dims[i];
                        var val = retValue[i];
                        var rawExtentOnDim = rawExtent[dim];
                        var dimStore = targetChunks[dim];
                        if (dimStore) dimStore[rawIndex] = val;
                        if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                        if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                    }
                }
            }
        };
        DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
            var target = this.clone([
                valueDimension
            ], true);
            var targetStorage = target._chunks;
            var dimStore = targetStorage[valueDimension];
            var len = this.count();
            var sampledIndex = 0;
            var frameSize = Math.floor(1 / rate);
            var currentRawIndex = this.getRawIndex(0);
            var maxArea;
            var area;
            var nextRawIndex;
            var newIndices = new ($5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) + 2);
            newIndices[sampledIndex++] = currentRawIndex;
            for(var i = 1; i < len - 1; i += frameSize){
                var nextFrameStart = Math.min(i + frameSize, len - 1);
                var nextFrameEnd = Math.min(i + frameSize * 2, len);
                var avgX = (nextFrameEnd + nextFrameStart) / 2;
                var avgY = 0;
                for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                    var rawIndex = this.getRawIndex(idx);
                    var y = dimStore[rawIndex];
                    if (isNaN(y)) continue;
                    avgY += y;
                }
                avgY /= nextFrameEnd - nextFrameStart;
                var frameStart = i;
                var frameEnd = Math.min(i + frameSize, len);
                var pointAX = i - 1;
                var pointAY = dimStore[currentRawIndex];
                maxArea = -1;
                nextRawIndex = frameStart;
                for(var idx = frameStart; idx < frameEnd; idx++){
                    var rawIndex = this.getRawIndex(idx);
                    var y = dimStore[rawIndex];
                    if (isNaN(y)) continue;
                    area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                    if (area > maxArea) {
                        maxArea = area;
                        nextRawIndex = rawIndex;
                    }
                }
                newIndices[sampledIndex++] = nextRawIndex;
                currentRawIndex = nextRawIndex;
            }
            newIndices[sampledIndex++] = this.getRawIndex(len - 1);
            target._count = sampledIndex;
            target._indices = newIndices;
            target.getRawIndex = this._getRawIdx;
            return target;
        };
        DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
            var target = this.clone([
                dimension
            ], true);
            var targetStorage = target._chunks;
            var frameValues = [];
            var frameSize = Math.floor(1 / rate);
            var dimStore = targetStorage[dimension];
            var len = this.count();
            var rawExtentOnDim = target._rawExtent[dimension] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            var newIndices = new ($5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
            var offset = 0;
            for(var i = 0; i < len; i += frameSize){
                if (frameSize > len - i) {
                    frameSize = len - i;
                    frameValues.length = frameSize;
                }
                for(var k = 0; k < frameSize; k++){
                    var dataIdx = this.getRawIndex(i + k);
                    frameValues[k] = dimStore[dataIdx];
                }
                var value = sampleValue(frameValues);
                var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
                dimStore[sampleFrameIdx] = value;
                if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
                if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
                newIndices[offset++] = sampleFrameIdx;
            }
            target._count = offset;
            target._indices = newIndices;
            target._updateGetRawIdx();
            return target;
        };
        DataStore.prototype.each = function(dims, cb) {
            if (!this._count) return;
            var dimSize = dims.length;
            var chunks = this._chunks;
            for(var i = 0, len = this.count(); i < len; i++){
                var rawIdx = this.getRawIndex(i);
                switch(dimSize){
                    case 0:
                        cb(i);
                        break;
                    case 1:
                        cb(chunks[dims[0]][rawIdx], i);
                        break;
                    case 2:
                        cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                        break;
                    default:
                        var k = 0;
                        var value = [];
                        for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                        value[k] = i;
                        cb.apply(null, value);
                }
            }
        };
        DataStore.prototype.getDataExtent = function(dim) {
            var dimData = this._chunks[dim];
            var initialExtent = $5f71fa7e68f8e2cf$var$getInitialExtent();
            if (!dimData) return initialExtent;
            var currEnd = this.count();
            var useRaw = !this._indices;
            var dimExtent;
            if (useRaw) return this._rawExtent[dim].slice();
            dimExtent = this._extent[dim];
            if (dimExtent) return dimExtent.slice();
            dimExtent = initialExtent;
            var min = dimExtent[0];
            var max = dimExtent[1];
            for(var i = 0; i < currEnd; i++){
                var rawIdx = this.getRawIndex(i);
                var value = dimData[rawIdx];
                value < min && (min = value);
                value > max && (max = value);
            }
            dimExtent = [
                min,
                max
            ];
            this._extent[dim] = dimExtent;
            return dimExtent;
        };
        DataStore.prototype.getRawDataItem = function(idx) {
            var rawIdx = this.getRawIndex(idx);
            if (!this._provider.persistent) {
                var val = [];
                var chunks = this._chunks;
                for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
                return val;
            } else return this._provider.getItem(rawIdx);
        };
        DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
            var target = new DataStore();
            var chunks = this._chunks;
            var clonedDimsMap = clonedDims && (0, (0, parcelRequire("bahqM")).reduce)(clonedDims, function(obj, dimIdx) {
                obj[dimIdx] = true;
                return obj;
            }, {});
            if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $5f71fa7e68f8e2cf$var$cloneChunk(chunks[i]);
            else target._chunks = chunks;
            this._copyCommonProps(target);
            if (!ignoreIndices) target._indices = this._cloneIndices();
            target._updateGetRawIdx();
            return target;
        };
        DataStore.prototype._copyCommonProps = function(target) {
            target._count = this._count;
            target._rawCount = this._rawCount;
            target._provider = this._provider;
            target._dimensions = this._dimensions;
            target._extent = (0, (0, parcelRequire("bahqM")).clone)(this._extent);
            target._rawExtent = (0, (0, parcelRequire("bahqM")).clone)(this._rawExtent);
        };
        DataStore.prototype._cloneIndices = function() {
            if (this._indices) {
                var Ctor = this._indices.constructor;
                var indices = void 0;
                if (Ctor === Array) {
                    var thisCount = this._indices.length;
                    indices = new Ctor(thisCount);
                    for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
                } else indices = new Ctor(this._indices);
                return indices;
            }
            return null;
        };
        DataStore.prototype._getRawIdxIdentity = function(idx) {
            return idx;
        };
        DataStore.prototype._getRawIdx = function(idx) {
            if (idx < this._count && idx >= 0) return this._indices[idx];
            return -1;
        };
        DataStore.prototype._updateGetRawIdx = function() {
            this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
        };
        DataStore.internalField = function() {
            function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
                return (0, (0, parcelRequire("2G90t")).parseDataValue)(dataItem[dimIndex], this._dimensions[dimIndex]);
            }
            $5f71fa7e68f8e2cf$var$defaultDimValueGetters = {
                arrayRows: getDimValueSimply,
                objectRows: function(dataItem, property, dataIndex, dimIndex) {
                    return (0, (0, parcelRequire("2G90t")).parseDataValue)(dataItem[property], this._dimensions[dimIndex]);
                },
                keyedColumns: getDimValueSimply,
                original: function(dataItem, property, dataIndex, dimIndex) {
                    var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                    return (0, (0, parcelRequire("2G90t")).parseDataValue)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
                },
                typedArray: function(dataItem, property, dataIndex, dimIndex) {
                    return dataItem[dimIndex];
                }
            };
        }();
        return DataStore;
    }();
    var $5f71fa7e68f8e2cf$export$2e2bcd8739ae039 = $5f71fa7e68f8e2cf$var$DataStore;
});
parcelRegister("2G90t", function(module, exports) {
    $parcel$export(module.exports, "parseDataValue", ()=>$1f367d921e7af2c3$export$cc7175145baad076);
    $parcel$export(module.exports, "getRawValueParser", ()=>$1f367d921e7af2c3$export$c88237b7c265b36b);
    $parcel$export(module.exports, "SortOrderComparator", ()=>$1f367d921e7af2c3$export$ed75a5d7b0144167);
    $parcel$export(module.exports, "createFilterComparator", ()=>$1f367d921e7af2c3$export$f2644c3485f94c4e);
    var $jmSNG;
    var $bahqM;
    var $2cFRc;
    function $1f367d921e7af2c3$export$cc7175145baad076(value, opt) {
        var dimType = opt && opt.type;
        if (dimType === 'ordinal') return value;
        if (dimType === 'time' && typeof value !== 'number' && value != null && value !== '-') value = +(0, (0, parcelRequire("jmSNG")).parseDate)(value);
        return value == null || value === '' ? NaN : +value;
    }
    var $1f367d921e7af2c3$var$valueParserMap = (0, (0, parcelRequire("bahqM")).createHashMap)({
        'number': function(val) {
            return parseFloat(val);
        },
        'time': function(val) {
            return +(0, (0, parcelRequire("jmSNG")).parseDate)(val);
        },
        'trim': function(val) {
            return typeof val === 'string' ? (0, (0, parcelRequire("bahqM")).trim)(val) : val;
        }
    });
    function $1f367d921e7af2c3$export$c88237b7c265b36b(type) {
        return $1f367d921e7af2c3$var$valueParserMap.get(type);
    }
    var $1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP = {
        lt: function(lval, rval) {
            return lval < rval;
        },
        lte: function(lval, rval) {
            return lval <= rval;
        },
        gt: function(lval, rval) {
            return lval > rval;
        },
        gte: function(lval, rval) {
            return lval >= rval;
        }
    };
    var $1f367d921e7af2c3$var$FilterOrderComparator = function() {
        function FilterOrderComparator(op, rval) {
            if (typeof rval !== 'number') {
                var errMsg = '';
                (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            }
            this._opFn = $1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP[op];
            this._rvalFloat = (0, (0, parcelRequire("jmSNG")).numericToNumber)(rval);
        }
        FilterOrderComparator.prototype.evaluate = function(lval) {
            return typeof lval === 'number' ? this._opFn(lval, this._rvalFloat) : this._opFn((0, (0, parcelRequire("jmSNG")).numericToNumber)(lval), this._rvalFloat);
        };
        return FilterOrderComparator;
    }();
    var $1f367d921e7af2c3$export$ed75a5d7b0144167 = function() {
        function SortOrderComparator(order, incomparable) {
            var isDesc = order === 'desc';
            this._resultLT = isDesc ? 1 : -1;
            if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
            this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
        }
        SortOrderComparator.prototype.evaluate = function(lval, rval) {
            var lvalTypeof = typeof lval;
            var rvalTypeof = typeof rval;
            var lvalFloat = lvalTypeof === 'number' ? lval : (0, (0, parcelRequire("jmSNG")).numericToNumber)(lval);
            var rvalFloat = rvalTypeof === 'number' ? rval : (0, (0, parcelRequire("jmSNG")).numericToNumber)(rval);
            var lvalNotNumeric = isNaN(lvalFloat);
            var rvalNotNumeric = isNaN(rvalFloat);
            if (lvalNotNumeric) lvalFloat = this._incomparable;
            if (rvalNotNumeric) rvalFloat = this._incomparable;
            if (lvalNotNumeric && rvalNotNumeric) {
                var lvalIsStr = lvalTypeof === 'string';
                var rvalIsStr = rvalTypeof === 'string';
                if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
                if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
            }
            return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
        };
        return SortOrderComparator;
    }();
    var $1f367d921e7af2c3$var$FilterEqualityComparator = function() {
        function FilterEqualityComparator(isEq, rval) {
            this._rval = rval;
            this._isEQ = isEq;
            this._rvalTypeof = typeof rval;
            this._rvalFloat = (0, (0, parcelRequire("jmSNG")).numericToNumber)(rval);
        }
        FilterEqualityComparator.prototype.evaluate = function(lval) {
            var eqResult = lval === this._rval;
            if (!eqResult) {
                var lvalTypeof = typeof lval;
                if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, (0, parcelRequire("jmSNG")).numericToNumber)(lval) === this._rvalFloat;
            }
            return this._isEQ ? eqResult : !eqResult;
        };
        return FilterEqualityComparator;
    }();
    function $1f367d921e7af2c3$export$f2644c3485f94c4e(op, rval) {
        return op === 'eq' || op === 'ne' ? new $1f367d921e7af2c3$var$FilterEqualityComparator(op === 'eq', rval) : (0, (0, parcelRequire("bahqM")).hasOwn)($1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP, op) ? new $1f367d921e7af2c3$var$FilterOrderComparator(op, rval) : null;
    }
});
parcelRegister("2cFRc", function(module, exports) {
    $parcel$export(module.exports, "warn", ()=>$19ad2baf23da1928$export$c106dd0671a0fc2d);
    $parcel$export(module.exports, "error", ()=>$19ad2baf23da1928$export$a3bc9b8ed74fc);
    $parcel$export(module.exports, "deprecateLog", ()=>$19ad2baf23da1928$export$4a9c0b74eb885aa1);
    $parcel$export(module.exports, "throwError", ()=>$19ad2baf23da1928$export$8bf7aba4a9e09055);
    var $19ad2baf23da1928$var$ECHARTS_PREFIX = '[ECharts] ';
    var $19ad2baf23da1928$var$storedLogs = {};
    var $19ad2baf23da1928$var$hasConsole = typeof console !== 'undefined' && console.warn && console.log;
    function $19ad2baf23da1928$export$bef1f36f5486a6a3(str) {
        if ($19ad2baf23da1928$var$hasConsole) console.log($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
    }
    function $19ad2baf23da1928$export$c106dd0671a0fc2d(str) {
        if ($19ad2baf23da1928$var$hasConsole) console.warn($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
    }
    function $19ad2baf23da1928$export$a3bc9b8ed74fc(str) {
        if ($19ad2baf23da1928$var$hasConsole) console.error($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
    }
    function $19ad2baf23da1928$export$4a9c0b74eb885aa1(str) {}
    function $19ad2baf23da1928$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
    function $19ad2baf23da1928$export$c3747c611a35af25() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    }
    function $19ad2baf23da1928$export$a68bb8b222a6bd43() {
        var hintInfo = [];
        for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
        var msg = '';
        var makePrintableStringIfPossible_1;
        return msg;
    }
    function $19ad2baf23da1928$export$8bf7aba4a9e09055(msg) {
        throw new Error(msg);
    }
});
parcelRegister("h9jiS", function(module, exports) {
    $parcel$export(module.exports, "createDimensions", ()=>$c7c240344387234c$export$8066c1b52b2e9504);
    $parcel$export(module.exports, "default", ()=>$c7c240344387234c$export$2e2bcd8739ae039);
    var $2Rbm1;
    var $dhxbO;
    var $bahqM;
    var $20liu;
    var $8c3gC;
    var $eaKsF;
    var $cNGs8;
    var $2Om11;
    function $c7c240344387234c$export$8066c1b52b2e9504(source, opt) {
        return $c7c240344387234c$export$2e2bcd8739ae039(source, opt).dimensions;
    }
    function $c7c240344387234c$export$2e2bcd8739ae039(source, opt) {
        if (!(0, (0, parcelRequire("20liu")).isSourceInstance)(source)) source = (0, (0, parcelRequire("20liu")).createSourceFromSeriesDataOption)(source);
        opt = opt || {};
        var sysDims = opt.coordDimensions || [];
        var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
        var coordDimNameMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var resultList = [];
        var dimCount = $c7c240344387234c$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
        var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, (0, parcelRequire("2Om11")).shouldOmitUnusedDimensions)(dimCount);
        var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
        var dataDimNameMap = isUsingSourceDimensionsDef ? (0, (0, parcelRequire("2Om11")).ensureSourceDimNameMap)(source) : (0, (0, parcelRequire("2Om11")).createDimNameMap)(dimsDef);
        var encodeDef = opt.encodeDefine;
        if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
        var encodeDefMap = (0, (0, parcelRequire("bahqM")).createHashMap)(encodeDef);
        var indicesMap = new (0, (0, parcelRequire("8c3gC")).CtorInt32Array)(dimCount);
        for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
        function getResultItem(dimIdx) {
            var idx = indicesMap[dimIdx];
            if (idx < 0) {
                var dimDefItemRaw = dimsDef[dimIdx];
                var dimDefItem = (0, (0, parcelRequire("bahqM")).isObject)(dimDefItemRaw) ? dimDefItemRaw : {
                    name: dimDefItemRaw
                };
                var resultItem = new (0, (0, parcelRequire("dhxbO")).default)();
                var userDimName = dimDefItem.name;
                if (userDimName != null && dataDimNameMap.get(userDimName) != null) resultItem.name = resultItem.displayName = userDimName;
                dimDefItem.type != null && (resultItem.type = dimDefItem.type);
                dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
                var newIdx = resultList.length;
                indicesMap[dimIdx] = newIdx;
                resultItem.storeDimIndex = dimIdx;
                resultList.push(resultItem);
                return resultItem;
            }
            return resultList[idx];
        }
        if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
        encodeDefMap.each(function(dataDimsRaw, coordDim) {
            var dataDims = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(dataDimsRaw).slice();
            if (dataDims.length === 1 && !(0, (0, parcelRequire("bahqM")).isString)(dataDims[0]) && dataDims[0] < 0) {
                encodeDefMap.set(coordDim, false);
                return;
            }
            var validDataDims = encodeDefMap.set(coordDim, []);
            (0, (0, parcelRequire("bahqM")).each)(dataDims, function(resultDimIdxOrName, idx) {
                var resultDimIdx = (0, (0, parcelRequire("bahqM")).isString)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
                if (resultDimIdx != null && resultDimIdx < dimCount) {
                    validDataDims[idx] = resultDimIdx;
                    applyDim(getResultItem(resultDimIdx), coordDim, idx);
                }
            });
        });
        var availDimIdx = 0;
        (0, (0, parcelRequire("bahqM")).each)(sysDims, function(sysDimItemRaw) {
            var coordDim;
            var sysDimItemDimsDef;
            var sysDimItemOtherDims;
            var sysDimItem;
            if ((0, (0, parcelRequire("bahqM")).isString)(sysDimItemRaw)) {
                coordDim = sysDimItemRaw;
                sysDimItem = {};
            } else {
                sysDimItem = sysDimItemRaw;
                coordDim = sysDimItem.name;
                var ordinalMeta = sysDimItem.ordinalMeta;
                sysDimItem.ordinalMeta = null;
                sysDimItem = (0, (0, parcelRequire("bahqM")).extend)({}, sysDimItem);
                sysDimItem.ordinalMeta = ordinalMeta;
                sysDimItemDimsDef = sysDimItem.dimsDef;
                sysDimItemOtherDims = sysDimItem.otherDims;
                sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
            }
            var dataDims = encodeDefMap.get(coordDim);
            if (dataDims === false) return;
            dataDims = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(dataDims);
            if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
                while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
                availDimIdx < dimCount && dataDims.push(availDimIdx++);
            }
            (0, (0, parcelRequire("bahqM")).each)(dataDims, function(resultDimIdx, coordDimIndex) {
                var resultItem = getResultItem(resultDimIdx);
                if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
                applyDim((0, (0, parcelRequire("bahqM")).defaults)(resultItem, sysDimItem), coordDim, coordDimIndex);
                if (resultItem.name == null && sysDimItemDimsDef) {
                    var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                    !(0, (0, parcelRequire("bahqM")).isObject)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                        name: sysDimItemDimsDefItem
                    });
                    resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                    resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
                }
                sysDimItemOtherDims && (0, (0, parcelRequire("bahqM")).defaults)(resultItem.otherDims, sysDimItemOtherDims);
            });
        });
        function applyDim(resultItem, coordDim, coordDimIndex) {
            if ((0, (0, parcelRequire("2Rbm1")).VISUAL_DIMENSIONS).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
            else {
                resultItem.coordDim = coordDim;
                resultItem.coordDimIndex = coordDimIndex;
                coordDimNameMap.set(coordDim, true);
            }
        }
        var generateCoord = opt.generateCoord;
        var generateCoordCount = opt.generateCoordCount;
        var fromZero = generateCoordCount != null;
        generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
        var extra = generateCoord || 'value';
        function ifNoNameFillWithCoordName(resultItem) {
            if (resultItem.name == null) resultItem.name = resultItem.coordDim;
        }
        if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
            var resultItem = getResultItem(resultDimIdx);
            var coordDim = resultItem.coordDim;
            if (coordDim == null) {
                resultItem.coordDim = $c7c240344387234c$var$genCoordDimName(extra, coordDimNameMap, fromZero);
                resultItem.coordDimIndex = 0;
                if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
                generateCoordCount--;
            }
            ifNoNameFillWithCoordName(resultItem);
            if (resultItem.type == null && ((0, (0, parcelRequire("cNGs8")).guessOrdinal)(source, resultDimIdx) === (0, (0, parcelRequire("cNGs8")).BE_ORDINAL).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
        }
        else {
            (0, (0, parcelRequire("bahqM")).each)(resultList, function(resultItem) {
                ifNoNameFillWithCoordName(resultItem);
            });
            resultList.sort(function(item0, item1) {
                return item0.storeDimIndex - item1.storeDimIndex;
            });
        }
        $c7c240344387234c$var$removeDuplication(resultList);
        return new (0, (0, parcelRequire("2Om11")).SeriesDataSchema)({
            source: source,
            dimensions: resultList,
            fullDimensionCount: dimCount,
            dimensionOmitted: omitUnusedDimensions
        });
    }
    function $c7c240344387234c$var$removeDuplication(result) {
        var duplicationMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        for(var i = 0; i < result.length; i++){
            var dim = result[i];
            var dimOriginalName = dim.name;
            var count = duplicationMap.get(dimOriginalName) || 0;
            if (count > 0) dim.name = dimOriginalName + (count - 1);
            count++;
            duplicationMap.set(dimOriginalName, count);
        }
    }
    function $c7c240344387234c$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
        var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
        (0, (0, parcelRequire("bahqM")).each)(sysDims, function(sysDimItem) {
            var sysDimItemDimsDef;
            if ((0, (0, parcelRequire("bahqM")).isObject)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
        });
        return dimCount;
    }
    function $c7c240344387234c$var$genCoordDimName(name, map, fromZero) {
        var mapData = map.data;
        if (fromZero || mapData.hasOwnProperty(name)) {
            var i = 0;
            while(mapData.hasOwnProperty(name + i))i++;
            name += i;
        }
        map.set(name, true);
        return name;
    }
});
parcelRegister("gyhNQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0cda1a15c9ef40a$export$2e2bcd8739ae039);
    var $bahqM;
    var $c0cda1a15c9ef40a$var$coordinateSystemCreators = {};
    var $c0cda1a15c9ef40a$var$CoordinateSystemManager = function() {
        function CoordinateSystemManager() {
            this._coordinateSystems = [];
        }
        CoordinateSystemManager.prototype.create = function(ecModel, api) {
            var coordinateSystems = [];
            (0, parcelRequire("bahqM")).each($c0cda1a15c9ef40a$var$coordinateSystemCreators, function(creater, type) {
                var list = creater.create(ecModel, api);
                coordinateSystems = coordinateSystems.concat(list || []);
            });
            this._coordinateSystems = coordinateSystems;
        };
        CoordinateSystemManager.prototype.update = function(ecModel, api) {
            (0, parcelRequire("bahqM")).each(this._coordinateSystems, function(coordSys) {
                coordSys.update && coordSys.update(ecModel, api);
            });
        };
        CoordinateSystemManager.prototype.getCoordinateSystems = function() {
            return this._coordinateSystems.slice();
        };
        CoordinateSystemManager.register = function(type, creator) {
            $c0cda1a15c9ef40a$var$coordinateSystemCreators[type] = creator;
        };
        CoordinateSystemManager.get = function(type) {
            return $c0cda1a15c9ef40a$var$coordinateSystemCreators[type];
        };
        return CoordinateSystemManager;
    }();
    var $c0cda1a15c9ef40a$export$2e2bcd8739ae039 = $c0cda1a15c9ef40a$var$CoordinateSystemManager;
});
parcelRegister("lhMGv", function(module, exports) {
    $parcel$export(module.exports, "getCoordSysInfoBySeries", ()=>$f7f0f3461c4b4907$export$f2befeb2f4933656);
    var $bahqM;
    var $eaKsF;
    var $f7f0f3461c4b4907$var$CoordSysInfo = function() {
        function CoordSysInfo(coordSysName) {
            this.coordSysDims = [];
            this.axisMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this.categoryAxisMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this.coordSysName = coordSysName;
        }
        return CoordSysInfo;
    }();
    function $f7f0f3461c4b4907$export$f2befeb2f4933656(seriesModel) {
        var coordSysName = seriesModel.get('coordinateSystem');
        var result = new $f7f0f3461c4b4907$var$CoordSysInfo(coordSysName);
        var fetch = $f7f0f3461c4b4907$var$fetchers[coordSysName];
        if (fetch) {
            fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
            return result;
        }
    }
    var $f7f0f3461c4b4907$var$fetchers = {
        cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
            var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            result.coordSysDims = [
                'x',
                'y'
            ];
            axisMap.set('x', xAxisModel);
            axisMap.set('y', yAxisModel);
            if ($f7f0f3461c4b4907$var$isCategory(xAxisModel)) {
                categoryAxisMap.set('x', xAxisModel);
                result.firstCategoryDimIndex = 0;
            }
            if ($f7f0f3461c4b4907$var$isCategory(yAxisModel)) {
                categoryAxisMap.set('y', yAxisModel);
                result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
            }
        },
        singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
            var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            result.coordSysDims = [
                'single'
            ];
            axisMap.set('single', singleAxisModel);
            if ($f7f0f3461c4b4907$var$isCategory(singleAxisModel)) {
                categoryAxisMap.set('single', singleAxisModel);
                result.firstCategoryDimIndex = 0;
            }
        },
        polar: function(seriesModel, result, axisMap, categoryAxisMap) {
            var polarModel = seriesModel.getReferringComponents('polar', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
            var angleAxisModel = polarModel.findAxisModel('angleAxis');
            result.coordSysDims = [
                'radius',
                'angle'
            ];
            axisMap.set('radius', radiusAxisModel);
            axisMap.set('angle', angleAxisModel);
            if ($f7f0f3461c4b4907$var$isCategory(radiusAxisModel)) {
                categoryAxisMap.set('radius', radiusAxisModel);
                result.firstCategoryDimIndex = 0;
            }
            if ($f7f0f3461c4b4907$var$isCategory(angleAxisModel)) {
                categoryAxisMap.set('angle', angleAxisModel);
                result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
            }
        },
        geo: function(seriesModel, result, axisMap, categoryAxisMap) {
            result.coordSysDims = [
                'lng',
                'lat'
            ];
        },
        parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
            var ecModel = seriesModel.ecModel;
            var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
            var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
            (0, (0, parcelRequire("bahqM")).each)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
                var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
                var axisDim = coordSysDims[index];
                axisMap.set(axisDim, axisModel);
                if ($f7f0f3461c4b4907$var$isCategory(axisModel)) {
                    categoryAxisMap.set(axisDim, axisModel);
                    if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
                }
            });
        }
    };
    function $f7f0f3461c4b4907$var$isCategory(axisModel) {
        return axisModel.get('type') === 'category';
    }
});
parcelRegister("1O7Ua", function(module, exports) {
    $parcel$export(module.exports, "SERIES_UNIVERSAL_TRANSITION_PROP", ()=>$151097b3612ce5ca$export$e960441116ae2799);
    $parcel$export(module.exports, "default", ()=>$151097b3612ce5ca$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $hZfwb;
    var $eaKsF;
    var $h4UlH;
    var $aCu4v;
    var $guzSc;
    var $65MS1;
    var $92IK1;
    var $aLwh0;
    var $jTNWo;
    var $d88IV;
    var $151097b3612ce5ca$var$inner = (0, parcelRequire("eaKsF")).makeInner();
    function $151097b3612ce5ca$var$getSelectionKey(data, dataIndex) {
        return data.getName(dataIndex) || data.getId(dataIndex);
    }
    var $151097b3612ce5ca$export$e960441116ae2799 = '__universalTransitionEnabled';
    var $151097b3612ce5ca$var$SeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SeriesModel, _super);
        function SeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._selectedDataIndicesMap = {};
            return _this;
        }
        SeriesModel.prototype.init = function(option, parentModel, ecModel) {
            this.seriesIndex = this.componentIndex;
            this.dataTask = (0, (0, parcelRequire("92IK1")).createTask)({
                count: $151097b3612ce5ca$var$dataTaskCount,
                reset: $151097b3612ce5ca$var$dataTaskReset
            });
            this.dataTask.context = {
                model: this
            };
            this.mergeDefaultAndTheme(option, ecModel);
            var sourceManager = $151097b3612ce5ca$var$inner(this).sourceManager = new (0, (0, parcelRequire("jTNWo")).SourceManager)(this);
            sourceManager.prepareSource();
            var data = this.getInitialData(option, ecModel);
            $151097b3612ce5ca$var$wrapData(data, this);
            this.dataTask.context.data = data;
            $151097b3612ce5ca$var$inner(this).dataBeforeProcessed = data;
            $151097b3612ce5ca$var$autoSeriesName(this);
            this._initSelectedMapFromData(data);
        };
        SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
            var layoutMode = (0, (0, parcelRequire("65MS1")).fetchLayoutMode)(this);
            var inputPositionParams = layoutMode ? (0, (0, parcelRequire("65MS1")).getLayoutParams)(option) : {};
            var themeSubType = this.subType;
            if ((0, (0, parcelRequire("h4UlH")).default).hasClass(themeSubType)) themeSubType += 'Series';
            (0, parcelRequire("bahqM")).merge(option, ecModel.getTheme().get(this.subType));
            (0, parcelRequire("bahqM")).merge(option, this.getDefaultOption());
            (0, parcelRequire("eaKsF")).defaultEmphasis(option, 'label', [
                'show'
            ]);
            this.fillDataTextStyle(option.data);
            if (layoutMode) (0, (0, parcelRequire("65MS1")).mergeLayoutParam)(option, inputPositionParams, layoutMode);
        };
        SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
            newSeriesOption = (0, parcelRequire("bahqM")).merge(this.option, newSeriesOption, true);
            this.fillDataTextStyle(newSeriesOption.data);
            var layoutMode = (0, (0, parcelRequire("65MS1")).fetchLayoutMode)(this);
            if (layoutMode) (0, (0, parcelRequire("65MS1")).mergeLayoutParam)(this.option, newSeriesOption, layoutMode);
            var sourceManager = $151097b3612ce5ca$var$inner(this).sourceManager;
            sourceManager.dirty();
            sourceManager.prepareSource();
            var data = this.getInitialData(newSeriesOption, ecModel);
            $151097b3612ce5ca$var$wrapData(data, this);
            this.dataTask.dirty();
            this.dataTask.context.data = data;
            $151097b3612ce5ca$var$inner(this).dataBeforeProcessed = data;
            $151097b3612ce5ca$var$autoSeriesName(this);
            this._initSelectedMapFromData(data);
        };
        SeriesModel.prototype.fillDataTextStyle = function(data) {
            if (data && !(0, parcelRequire("bahqM")).isTypedArray(data)) {
                var props = [
                    'show'
                ];
                for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) (0, parcelRequire("eaKsF")).defaultEmphasis(data[i], 'label', props);
            }
        };
        SeriesModel.prototype.getInitialData = function(option, ecModel) {
            return;
        };
        SeriesModel.prototype.appendData = function(params) {
            var data = this.getRawData();
            data.appendData(params.data);
        };
        SeriesModel.prototype.getData = function(dataType) {
            var task = $151097b3612ce5ca$var$getCurrentTask(this);
            if (task) {
                var data = task.context.data;
                return dataType == null ? data : data.getLinkedData(dataType);
            } else return $151097b3612ce5ca$var$inner(this).data;
        };
        SeriesModel.prototype.getAllData = function() {
            var mainData = this.getData();
            return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
                {
                    data: mainData
                }
            ];
        };
        SeriesModel.prototype.setData = function(data) {
            var task = $151097b3612ce5ca$var$getCurrentTask(this);
            if (task) {
                var context = task.context;
                context.outputData = data;
                if (task !== this.dataTask) context.data = data;
            }
            $151097b3612ce5ca$var$inner(this).data = data;
        };
        SeriesModel.prototype.getEncode = function() {
            var encode = this.get('encode', true);
            if (encode) return (0, parcelRequire("bahqM")).createHashMap(encode);
        };
        SeriesModel.prototype.getSourceManager = function() {
            return $151097b3612ce5ca$var$inner(this).sourceManager;
        };
        SeriesModel.prototype.getSource = function() {
            return this.getSourceManager().getSource();
        };
        SeriesModel.prototype.getRawData = function() {
            return $151097b3612ce5ca$var$inner(this).dataBeforeProcessed;
        };
        SeriesModel.prototype.getColorBy = function() {
            var colorBy = this.get('colorBy');
            return colorBy || 'series';
        };
        SeriesModel.prototype.isColorBySeries = function() {
            return this.getColorBy() === 'series';
        };
        SeriesModel.prototype.getBaseAxis = function() {
            var coordSys = this.coordinateSystem;
            return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
        };
        SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
            return (0, (0, parcelRequire("d88IV")).defaultSeriesFormatTooltip)({
                series: this,
                dataIndex: dataIndex,
                multipleSeries: multipleSeries
            });
        };
        SeriesModel.prototype.isAnimationEnabled = function() {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return false;
            var animationEnabled = this.getShallow('animation');
            if (animationEnabled) {
                if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
            }
            return !!animationEnabled;
        };
        SeriesModel.prototype.restoreData = function() {
            this.dataTask.dirty();
        };
        SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
            var ecModel = this.ecModel;
            var color = (0, (0, parcelRequire("aCu4v")).PaletteMixin).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
            if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
            return color;
        };
        SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
            return this.getRawData().mapDimensionsAll(coordDim);
        };
        SeriesModel.prototype.getProgressive = function() {
            return this.get('progressive');
        };
        SeriesModel.prototype.getProgressiveThreshold = function() {
            return this.get('progressiveThreshold');
        };
        SeriesModel.prototype.select = function(innerDataIndices, dataType) {
            this._innerSelect(this.getData(dataType), innerDataIndices);
        };
        SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
            var selectedMap = this.option.selectedMap;
            if (!selectedMap) return;
            var data = this.getData(dataType);
            for(var i = 0; i < innerDataIndices.length; i++){
                var dataIndex = innerDataIndices[i];
                var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = false;
                this._selectedDataIndicesMap[nameOrId] = -1;
            }
        };
        SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
            var tmpArr = [];
            for(var i = 0; i < innerDataIndices.length; i++){
                tmpArr[0] = innerDataIndices[i];
                this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
            }
        };
        SeriesModel.prototype.getSelectedDataIndices = function() {
            var selectedDataIndicesMap = this._selectedDataIndicesMap;
            var nameOrIds = (0, parcelRequire("bahqM")).keys(selectedDataIndicesMap);
            var dataIndices = [];
            for(var i = 0; i < nameOrIds.length; i++){
                var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
                if (dataIndex >= 0) dataIndices.push(dataIndex);
            }
            return dataIndices;
        };
        SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
            var selectedMap = this.option.selectedMap;
            if (!selectedMap) return false;
            var data = this.getData(dataType);
            var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
            return selectedMap[nameOrId] || false;
        };
        SeriesModel.prototype.isUniversalTransitionEnabled = function() {
            if (this[$151097b3612ce5ca$export$e960441116ae2799]) return true;
            var universalTransitionOpt = this.option.universalTransition;
            if (!universalTransitionOpt) return false;
            if (universalTransitionOpt === true) return true;
            return universalTransitionOpt && universalTransitionOpt.enabled;
        };
        SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
            var _a, _b;
            var selectedMode = this.option.selectedMode;
            var len = innerDataIndices.length;
            if (!selectedMode || !len) return;
            if (selectedMode === 'multiple') {
                var selectedMap = this.option.selectedMap || (this.option.selectedMap = {});
                for(var i = 0; i < len; i++){
                    var dataIndex = innerDataIndices[i];
                    var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
                    selectedMap[nameOrId] = true;
                    this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
                }
            } else if (selectedMode === 'single' || selectedMode === true) {
                var lastDataIndex = innerDataIndices[len - 1];
                var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, lastDataIndex);
                this.option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
                this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
            }
        };
        SeriesModel.prototype._initSelectedMapFromData = function(data) {
            if (this.option.selectedMap) return;
            var dataIndices = [];
            if (data.hasItemOption) data.each(function(idx) {
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem.selected) dataIndices.push(idx);
            });
            if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
        };
        SeriesModel.registerClass = function(clz) {
            return (0, (0, parcelRequire("h4UlH")).default).registerClass(clz);
        };
        SeriesModel.protoInitialize = function() {
            var proto = SeriesModel.prototype;
            proto.type = 'series.__base__';
            proto.seriesIndex = 0;
            proto.ignoreStyleOnData = false;
            proto.hasSymbolVisual = false;
            proto.defaultSymbol = 'circle';
            proto.visualStyleAccessPath = 'itemStyle';
            proto.visualDrawType = 'fill';
        }();
        return SeriesModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    (0, parcelRequire("bahqM")).mixin($151097b3612ce5ca$var$SeriesModel, (0, (0, parcelRequire("guzSc")).DataFormatMixin));
    (0, parcelRequire("bahqM")).mixin($151097b3612ce5ca$var$SeriesModel, (0, (0, parcelRequire("aCu4v")).PaletteMixin));
    (0, (0, parcelRequire("aLwh0")).mountExtend)($151097b3612ce5ca$var$SeriesModel, (0, (0, parcelRequire("h4UlH")).default));
    function $151097b3612ce5ca$var$autoSeriesName(seriesModel) {
        var name = seriesModel.name;
        if (!(0, parcelRequire("eaKsF")).isNameSpecified(seriesModel)) seriesModel.name = $151097b3612ce5ca$var$getSeriesAutoName(seriesModel) || name;
    }
    function $151097b3612ce5ca$var$getSeriesAutoName(seriesModel) {
        var data = seriesModel.getRawData();
        var dataDims = data.mapDimensionsAll('seriesName');
        var nameArr = [];
        (0, parcelRequire("bahqM")).each(dataDims, function(dataDim) {
            var dimInfo = data.getDimensionInfo(dataDim);
            dimInfo.displayName && nameArr.push(dimInfo.displayName);
        });
        return nameArr.join(' ');
    }
    function $151097b3612ce5ca$var$dataTaskCount(context) {
        return context.model.getRawData().count();
    }
    function $151097b3612ce5ca$var$dataTaskReset(context) {
        var seriesModel = context.model;
        seriesModel.setData(seriesModel.getRawData().cloneShallow());
        return $151097b3612ce5ca$var$dataTaskProgress;
    }
    function $151097b3612ce5ca$var$dataTaskProgress(param, context) {
        if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
    }
    function $151097b3612ce5ca$var$wrapData(data, seriesModel) {
        (0, parcelRequire("bahqM")).each((0, parcelRequire("bahqM")).concatArray(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
            data.wrapMethod(methodName, (0, parcelRequire("bahqM")).curry($151097b3612ce5ca$var$onDataChange, seriesModel));
        });
    }
    function $151097b3612ce5ca$var$onDataChange(seriesModel, newList) {
        var task = $151097b3612ce5ca$var$getCurrentTask(seriesModel);
        if (task) task.setOutputEnd((newList || this).count());
        return newList;
    }
    function $151097b3612ce5ca$var$getCurrentTask(seriesModel) {
        var scheduler = (seriesModel.ecModel || {}).scheduler;
        var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
        if (pipeline) {
            var task = pipeline.currentTask;
            if (task) {
                var agentStubMap = task.agentStubMap;
                if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
            }
            return task;
        }
    }
    var $151097b3612ce5ca$export$2e2bcd8739ae039 = $151097b3612ce5ca$var$SeriesModel;
});
parcelRegister("h4UlH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6ee8520f4778ed8$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $gaMkj;
    var $jvo6O;
    var $aLwh0;
    var $eaKsF;
    var $65MS1;
    var $c6ee8520f4778ed8$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $c6ee8520f4778ed8$var$ComponentModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ComponentModel, _super);
        function ComponentModel(option, parentModel, ecModel) {
            var _this = _super.call(this, option, parentModel, ecModel) || this;
            _this.uid = (0, parcelRequire("jvo6O")).getUID('ec_cpt_model');
            return _this;
        }
        ComponentModel.prototype.init = function(option, parentModel, ecModel) {
            this.mergeDefaultAndTheme(option, ecModel);
        };
        ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
            var layoutMode = (0, parcelRequire("65MS1")).fetchLayoutMode(this);
            var inputPositionParams = layoutMode ? (0, parcelRequire("65MS1")).getLayoutParams(option) : {};
            var themeModel = ecModel.getTheme();
            (0, parcelRequire("bahqM")).merge(option, themeModel.get(this.mainType));
            (0, parcelRequire("bahqM")).merge(option, this.getDefaultOption());
            if (layoutMode) (0, parcelRequire("65MS1")).mergeLayoutParam(option, inputPositionParams, layoutMode);
        };
        ComponentModel.prototype.mergeOption = function(option, ecModel) {
            (0, parcelRequire("bahqM")).merge(this.option, option, true);
            var layoutMode = (0, parcelRequire("65MS1")).fetchLayoutMode(this);
            if (layoutMode) (0, parcelRequire("65MS1")).mergeLayoutParam(this.option, option, layoutMode);
        };
        ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
        ComponentModel.prototype.getDefaultOption = function() {
            var ctor = this.constructor;
            if (!(0, (0, parcelRequire("aLwh0")).isExtendedClass)(ctor)) return ctor.defaultOption;
            var fields = $c6ee8520f4778ed8$var$inner(this);
            if (!fields.defaultOption) {
                var optList = [];
                var clz = ctor;
                while(clz){
                    var opt = clz.prototype.defaultOption;
                    opt && optList.push(opt);
                    clz = clz.superClass;
                }
                var defaultOption = {};
                for(var i = optList.length - 1; i >= 0; i--)defaultOption = (0, parcelRequire("bahqM")).merge(defaultOption, optList[i], true);
                fields.defaultOption = defaultOption;
            }
            return fields.defaultOption;
        };
        ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
            var indexKey = mainType + 'Index';
            var idKey = mainType + 'Id';
            return (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(this.ecModel, mainType, {
                index: this.get(indexKey, true),
                id: this.get(idKey, true)
            }, opt);
        };
        ComponentModel.prototype.getBoxLayoutParams = function() {
            var boxLayoutModel = this;
            return {
                left: boxLayoutModel.get('left'),
                top: boxLayoutModel.get('top'),
                right: boxLayoutModel.get('right'),
                bottom: boxLayoutModel.get('bottom'),
                width: boxLayoutModel.get('width'),
                height: boxLayoutModel.get('height')
            };
        };
        ComponentModel.protoInitialize = function() {
            var proto = ComponentModel.prototype;
            proto.type = 'component';
            proto.id = '';
            proto.name = '';
            proto.mainType = '';
            proto.subType = '';
            proto.componentIndex = 0;
        }();
        return ComponentModel;
    }((0, (0, parcelRequire("gaMkj")).default));
    (0, (0, parcelRequire("aLwh0")).mountExtend)($c6ee8520f4778ed8$var$ComponentModel, (0, (0, parcelRequire("gaMkj")).default));
    (0, (0, parcelRequire("aLwh0")).enableClassManagement)($c6ee8520f4778ed8$var$ComponentModel);
    (0, parcelRequire("jvo6O")).enableSubTypeDefaulter($c6ee8520f4778ed8$var$ComponentModel);
    (0, parcelRequire("jvo6O")).enableTopologicalTravel($c6ee8520f4778ed8$var$ComponentModel, $c6ee8520f4778ed8$var$getDependencies);
    function $c6ee8520f4778ed8$var$getDependencies(componentType) {
        var deps = [];
        (0, parcelRequire("bahqM")).each($c6ee8520f4778ed8$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
            deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
        });
        deps = (0, parcelRequire("bahqM")).map(deps, function(type) {
            return (0, (0, parcelRequire("aLwh0")).parseClassType)(type).main;
        });
        if (componentType !== 'dataset' && (0, parcelRequire("bahqM")).indexOf(deps, 'dataset') <= 0) deps.unshift('dataset');
        return deps;
    }
    var $c6ee8520f4778ed8$export$2e2bcd8739ae039 = $c6ee8520f4778ed8$var$ComponentModel;
});
parcelRegister("65MS1", function(module, exports) {
    $parcel$export(module.exports, "LOCATION_PARAMS", ()=>$46f91e567ea0ce35$export$a9aa2cc018afbed);
    $parcel$export(module.exports, "box", ()=>$46f91e567ea0ce35$export$827f4ee28efc37);
    $parcel$export(module.exports, "getAvailableSize", ()=>$46f91e567ea0ce35$export$145a8938a85a22b1);
    $parcel$export(module.exports, "getLayoutRect", ()=>$46f91e567ea0ce35$export$4517a5ca639a7293);
    $parcel$export(module.exports, "positionElement", ()=>$46f91e567ea0ce35$export$74054bd96b5eeef1);
    $parcel$export(module.exports, "sizeCalculable", ()=>$46f91e567ea0ce35$export$7ede609e8ebc9650);
    $parcel$export(module.exports, "fetchLayoutMode", ()=>$46f91e567ea0ce35$export$3968a28a7cbd6063);
    $parcel$export(module.exports, "mergeLayoutParam", ()=>$46f91e567ea0ce35$export$1754cb91f16ca028);
    $parcel$export(module.exports, "getLayoutParams", ()=>$46f91e567ea0ce35$export$4b0d20af19c9875e);
    $parcel$export(module.exports, "copyLayoutParams", ()=>$46f91e567ea0ce35$export$7438999faea9b6cc);
    var $bahqM;
    var $1E3E8;
    var $jmSNG;
    var $dCJrM;
    var $46f91e567ea0ce35$var$each = (0, parcelRequire("bahqM")).each;
    var $46f91e567ea0ce35$export$a9aa2cc018afbed = [
        'left',
        'right',
        'top',
        'bottom',
        'width',
        'height'
    ];
    var $46f91e567ea0ce35$export$d7fd4338c7b20804 = [
        [
            'width',
            'left',
            'right'
        ],
        [
            'height',
            'top',
            'bottom'
        ]
    ];
    function $46f91e567ea0ce35$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
        var x = 0;
        var y = 0;
        if (maxWidth == null) maxWidth = Infinity;
        if (maxHeight == null) maxHeight = Infinity;
        var currentLineMaxSize = 0;
        group.eachChild(function(child, idx) {
            var rect = child.getBoundingRect();
            var nextChild = group.childAt(idx + 1);
            var nextChildRect = nextChild && nextChild.getBoundingRect();
            var nextX;
            var nextY;
            if (orient === 'horizontal') {
                var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
                nextX = x + moveX;
                if (nextX > maxWidth || child.newline) {
                    x = 0;
                    nextX = moveX;
                    y += currentLineMaxSize + gap;
                    currentLineMaxSize = rect.height;
                } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
            } else {
                var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
                nextY = y + moveY;
                if (nextY > maxHeight || child.newline) {
                    x += currentLineMaxSize + gap;
                    y = 0;
                    nextY = moveY;
                    currentLineMaxSize = rect.width;
                } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
            }
            if (child.newline) return;
            child.x = x;
            child.y = y;
            child.markRedraw();
            orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
        });
    }
    var $46f91e567ea0ce35$export$827f4ee28efc37 = $46f91e567ea0ce35$var$boxLayout;
    var $46f91e567ea0ce35$export$be20d9158c17374c = (0, parcelRequire("bahqM")).curry($46f91e567ea0ce35$var$boxLayout, 'vertical');
    var $46f91e567ea0ce35$export$ae65a483d943e7a7 = (0, parcelRequire("bahqM")).curry($46f91e567ea0ce35$var$boxLayout, 'horizontal');
    function $46f91e567ea0ce35$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
        var containerWidth = containerRect.width;
        var containerHeight = containerRect.height;
        var x = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.left, containerWidth);
        var y = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.top, containerHeight);
        var x2 = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.right, containerWidth);
        var y2 = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.bottom, containerHeight);
        (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
        (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
        (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
        (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
        margin = (0, parcelRequire("dCJrM")).normalizeCssArray(margin || 0);
        return {
            width: Math.max(x2 - x - margin[1] - margin[3], 0),
            height: Math.max(y2 - y - margin[0] - margin[2], 0)
        };
    }
    function $46f91e567ea0ce35$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
        margin = (0, parcelRequire("dCJrM")).normalizeCssArray(margin || 0);
        var containerWidth = containerRect.width;
        var containerHeight = containerRect.height;
        var left = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.left, containerWidth);
        var top = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.top, containerHeight);
        var right = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.right, containerWidth);
        var bottom = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.bottom, containerHeight);
        var width = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.width, containerWidth);
        var height = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.height, containerHeight);
        var verticalMargin = margin[2] + margin[0];
        var horizontalMargin = margin[1] + margin[3];
        var aspect = positionInfo.aspect;
        if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
        if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
        if (aspect != null) {
            if (isNaN(width) && isNaN(height)) {
                if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
                else height = containerHeight * 0.8;
            }
            if (isNaN(width)) width = aspect * height;
            if (isNaN(height)) height = width / aspect;
        }
        if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
        if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
        switch(positionInfo.left || positionInfo.right){
            case 'center':
                left = containerWidth / 2 - width / 2 - margin[3];
                break;
            case 'right':
                left = containerWidth - width - horizontalMargin;
                break;
        }
        switch(positionInfo.top || positionInfo.bottom){
            case 'middle':
            case 'center':
                top = containerHeight / 2 - height / 2 - margin[0];
                break;
            case 'bottom':
                top = containerHeight - height - verticalMargin;
                break;
        }
        left = left || 0;
        top = top || 0;
        if (isNaN(width)) width = containerWidth - horizontalMargin - left - (right || 0);
        if (isNaN(height)) height = containerHeight - verticalMargin - top - (bottom || 0);
        var rect = new (0, (0, parcelRequire("1E3E8")).default)(left + margin[3], top + margin[0], width, height);
        rect.margin = margin;
        return rect;
    }
    function $46f91e567ea0ce35$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt) {
        var h = !opt || !opt.hv || opt.hv[0];
        var v = !opt || !opt.hv || opt.hv[1];
        var boundingMode = opt && opt.boundingMode || 'all';
        if (!h && !v) return;
        var rect;
        if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, (0, parcelRequire("1E3E8")).default)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
        else {
            rect = el.getBoundingRect();
            if (el.needLocalTransform()) {
                var transform = el.getLocalTransform();
                rect = rect.clone();
                rect.applyTransform(transform);
            }
        }
        var layoutRect = $46f91e567ea0ce35$export$4517a5ca639a7293((0, parcelRequire("bahqM")).defaults({
            width: rect.width,
            height: rect.height
        }, positionInfo), containerRect, margin);
        var dx = h ? layoutRect.x - rect.x : 0;
        var dy = v ? layoutRect.y - rect.y : 0;
        if (boundingMode === 'raw') {
            el.x = dx;
            el.y = dy;
        } else {
            el.x += dx;
            el.y += dy;
        }
        el.markRedraw();
    }
    function $46f91e567ea0ce35$export$7ede609e8ebc9650(option, hvIdx) {
        return option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][2]] != null;
    }
    function $46f91e567ea0ce35$export$3968a28a7cbd6063(ins) {
        var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
        return (0, parcelRequire("bahqM")).isObject(layoutMode) ? layoutMode : layoutMode ? {
            type: layoutMode
        } : null;
    }
    function $46f91e567ea0ce35$export$1754cb91f16ca028(targetOption, newOption, opt) {
        var ignoreSize = opt && opt.ignoreSize;
        !(0, parcelRequire("bahqM")).isArray(ignoreSize) && (ignoreSize = [
            ignoreSize,
            ignoreSize
        ]);
        var hResult = merge($46f91e567ea0ce35$export$d7fd4338c7b20804[0], 0);
        var vResult = merge($46f91e567ea0ce35$export$d7fd4338c7b20804[1], 1);
        copy($46f91e567ea0ce35$export$d7fd4338c7b20804[0], targetOption, hResult);
        copy($46f91e567ea0ce35$export$d7fd4338c7b20804[1], targetOption, vResult);
        function merge(names, hvIdx) {
            var newParams = {};
            var newValueCount = 0;
            var merged = {};
            var mergedValueCount = 0;
            var enoughParamNumber = 2;
            $46f91e567ea0ce35$var$each(names, function(name) {
                merged[name] = targetOption[name];
            });
            $46f91e567ea0ce35$var$each(names, function(name) {
                hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
                hasValue(newParams, name) && newValueCount++;
                hasValue(merged, name) && mergedValueCount++;
            });
            if (ignoreSize[hvIdx]) {
                if (hasValue(newOption, names[1])) merged[names[2]] = null;
                else if (hasValue(newOption, names[2])) merged[names[1]] = null;
                return merged;
            }
            if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
            else if (newValueCount >= enoughParamNumber) return newParams;
            else {
                for(var i = 0; i < names.length; i++){
                    var name_1 = names[i];
                    if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                        newParams[name_1] = targetOption[name_1];
                        break;
                    }
                }
                return newParams;
            }
        }
        function hasProp(obj, name) {
            return obj.hasOwnProperty(name);
        }
        function hasValue(obj, name) {
            return obj[name] != null && obj[name] !== 'auto';
        }
        function copy(names, target, source) {
            $46f91e567ea0ce35$var$each(names, function(name) {
                target[name] = source[name];
            });
        }
    }
    function $46f91e567ea0ce35$export$4b0d20af19c9875e(source) {
        return $46f91e567ea0ce35$export$7438999faea9b6cc({}, source);
    }
    function $46f91e567ea0ce35$export$7438999faea9b6cc(target, source) {
        source && target && $46f91e567ea0ce35$var$each($46f91e567ea0ce35$export$a9aa2cc018afbed, function(name) {
            source.hasOwnProperty(name) && (target[name] = source[name]);
        });
        return target;
    }
});
parcelRegister("dCJrM", function(module, exports) {
    $parcel$export(module.exports, "addCommas", ()=>$9eb213cc0c822e32$export$b6fe44657ce35c42);
    $parcel$export(module.exports, "toCamelCase", ()=>$9eb213cc0c822e32$export$86f54f62aa7a7514);
    $parcel$export(module.exports, "normalizeCssArray", ()=>$9eb213cc0c822e32$export$f3a38102c49f4268);
    $parcel$export(module.exports, "encodeHTML", ()=>$9eb213cc0c822e32$export$f9d6449b9af28dc1);
    $parcel$export(module.exports, "makeValueReadable", ()=>$9eb213cc0c822e32$export$3cd8db88714decfc);
    $parcel$export(module.exports, "formatTpl", ()=>$9eb213cc0c822e32$export$2028496a35766e41);
    $parcel$export(module.exports, "formatTplSimple", ()=>$9eb213cc0c822e32$export$2fa08233ee42f8e1);
    $parcel$export(module.exports, "getTooltipMarker", ()=>$9eb213cc0c822e32$export$1987a3dbdf3c45ca);
    $parcel$export(module.exports, "formatTime", ()=>$9eb213cc0c822e32$export$3203edd9e5edd663);
    $parcel$export(module.exports, "capitalFirst", ()=>$9eb213cc0c822e32$export$38a1e7552f497c0e);
    $parcel$export(module.exports, "convertToColorString", ()=>$9eb213cc0c822e32$export$cda04d03233e5555);
    $parcel$export(module.exports, "windowOpen", ()=>$9eb213cc0c822e32$export$13e13f9b96dbe8fa);
    var $bahqM;
    var $jmSNG;
    var $bc1Ad;
    var $h6fMM;
    var $2emZ2;
    function $9eb213cc0c822e32$export$b6fe44657ce35c42(x) {
        if (!(0, (0, parcelRequire("jmSNG")).isNumeric)(x)) return (0, parcelRequire("bahqM")).isString(x) ? x : '-';
        var parts = (x + '').split('.');
        return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
    }
    function $9eb213cc0c822e32$export$86f54f62aa7a7514(str, upperCaseFirst) {
        str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
            return group1.toUpperCase();
        });
        if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
        return str;
    }
    var $9eb213cc0c822e32$export$f3a38102c49f4268 = (0, parcelRequire("bahqM")).normalizeCssArray;
    var $9eb213cc0c822e32$var$replaceReg = /([&<>"'])/g;
    var $9eb213cc0c822e32$var$replaceMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '\'': '&#39;'
    };
    function $9eb213cc0c822e32$export$f9d6449b9af28dc1(source) {
        return source == null ? '' : (source + '').replace($9eb213cc0c822e32$var$replaceReg, function(str, c) {
            return $9eb213cc0c822e32$var$replaceMap[c];
        });
    }
    function $9eb213cc0c822e32$export$3cd8db88714decfc(value, valueType, useUTC) {
        var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss}';
        function stringToUserReadable(str) {
            return str && (0, parcelRequire("bahqM")).trim(str) ? str : '-';
        }
        function isNumberUserReadable(num) {
            return !!(num != null && !isNaN(num) && isFinite(num));
        }
        var isTypeTime = valueType === 'time';
        var isValueDate = value instanceof Date;
        if (isTypeTime || isValueDate) {
            var date = isTypeTime ? (0, (0, parcelRequire("jmSNG")).parseDate)(value) : value;
            if (!isNaN(+date)) return (0, (0, parcelRequire("bc1Ad")).format)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
            else if (isValueDate) return '-';
        }
        if (valueType === 'ordinal') return (0, parcelRequire("bahqM")).isStringSafe(value) ? stringToUserReadable(value) : (0, parcelRequire("bahqM")).isNumber(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
        var numericResult = (0, (0, parcelRequire("jmSNG")).numericToNumber)(value);
        return isNumberUserReadable(numericResult) ? $9eb213cc0c822e32$export$b6fe44657ce35c42(numericResult) : (0, parcelRequire("bahqM")).isStringSafe(value) ? stringToUserReadable(value) : '-';
    }
    var $9eb213cc0c822e32$var$TPL_VAR_ALIAS = [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g'
    ];
    var $9eb213cc0c822e32$var$wrapVar = function(varName, seriesIdx) {
        return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
    };
    function $9eb213cc0c822e32$export$2028496a35766e41(tpl, paramsList, encode) {
        if (!(0, parcelRequire("bahqM")).isArray(paramsList)) paramsList = [
            paramsList
        ];
        var seriesLen = paramsList.length;
        if (!seriesLen) return '';
        var $vars = paramsList[0].$vars || [];
        for(var i = 0; i < $vars.length; i++){
            var alias = $9eb213cc0c822e32$var$TPL_VAR_ALIAS[i];
            tpl = tpl.replace($9eb213cc0c822e32$var$wrapVar(alias), $9eb213cc0c822e32$var$wrapVar(alias, 0));
        }
        for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
            var val = paramsList[seriesIdx][$vars[k]];
            tpl = tpl.replace($9eb213cc0c822e32$var$wrapVar($9eb213cc0c822e32$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? $9eb213cc0c822e32$export$f9d6449b9af28dc1(val) : val);
        }
        return tpl;
    }
    function $9eb213cc0c822e32$export$2fa08233ee42f8e1(tpl, param, encode) {
        (0, parcelRequire("bahqM")).each(param, function(value, key) {
            tpl = tpl.replace('{' + key + '}', encode ? $9eb213cc0c822e32$export$f9d6449b9af28dc1(value) : value);
        });
        return tpl;
    }
    function $9eb213cc0c822e32$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
        var opt = (0, parcelRequire("bahqM")).isString(inOpt) ? {
            color: inOpt,
            extraCssText: extraCssText
        } : inOpt || {};
        var color = opt.color;
        var type = opt.type;
        extraCssText = opt.extraCssText;
        var renderMode = opt.renderMode || 'html';
        if (!color) return '';
        if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + $9eb213cc0c822e32$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + $9eb213cc0c822e32$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>';
        else {
            var markerId = opt.markerId || 'markerX';
            return {
                renderMode: renderMode,
                content: '{' + markerId + '|}  ',
                style: type === 'subItem' ? {
                    width: 4,
                    height: 4,
                    borderRadius: 2,
                    backgroundColor: color
                } : {
                    width: 10,
                    height: 10,
                    borderRadius: 5,
                    backgroundColor: color
                }
            };
        }
    }
    function $9eb213cc0c822e32$export$3203edd9e5edd663(tpl, value, isUTC) {
        if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
        var date = (0, (0, parcelRequire("jmSNG")).parseDate)(value);
        var utc = isUTC ? 'UTC' : '';
        var y = date['get' + utc + 'FullYear']();
        var M = date['get' + utc + 'Month']() + 1;
        var d = date['get' + utc + 'Date']();
        var h = date['get' + utc + 'Hours']();
        var m = date['get' + utc + 'Minutes']();
        var s = date['get' + utc + 'Seconds']();
        var S = date['get' + utc + 'Milliseconds']();
        tpl = tpl.replace('MM', (0, (0, parcelRequire("bc1Ad")).pad)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100 + '').replace('dd', (0, (0, parcelRequire("bc1Ad")).pad)(d, 2)).replace('d', d).replace('hh', (0, (0, parcelRequire("bc1Ad")).pad)(h, 2)).replace('h', h).replace('mm', (0, (0, parcelRequire("bc1Ad")).pad)(m, 2)).replace('m', m).replace('ss', (0, (0, parcelRequire("bc1Ad")).pad)(s, 2)).replace('s', s).replace('SSS', (0, (0, parcelRequire("bc1Ad")).pad)(S, 3));
        return tpl;
    }
    function $9eb213cc0c822e32$export$38a1e7552f497c0e(str) {
        return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
    }
    function $9eb213cc0c822e32$export$cda04d03233e5555(color, defaultColor) {
        defaultColor = defaultColor || 'transparent';
        return (0, parcelRequire("bahqM")).isString(color) ? color : (0, parcelRequire("bahqM")).isObject(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
    }
    function $9eb213cc0c822e32$export$13e13f9b96dbe8fa(link, target) {
        if (target === '_blank' || target === 'blank') {
            var blank = window.open();
            blank.opener = null;
            blank.location.href = link;
        } else window.open(link, target);
    }
});
parcelRegister("bc1Ad", function(module, exports) {
    $parcel$export(module.exports, "ONE_SECOND", ()=>$82620b17ee17a85a$export$32c0454ceff7f92d);
    $parcel$export(module.exports, "ONE_MINUTE", ()=>$82620b17ee17a85a$export$35acaebf644db34e);
    $parcel$export(module.exports, "ONE_HOUR", ()=>$82620b17ee17a85a$export$82541edf19e5e3b0);
    $parcel$export(module.exports, "ONE_DAY", ()=>$82620b17ee17a85a$export$a97a1358cbb650ab);
    $parcel$export(module.exports, "ONE_YEAR", ()=>$82620b17ee17a85a$export$99cafda57477293d);
    $parcel$export(module.exports, "fullLeveledFormatter", ()=>$82620b17ee17a85a$export$445bdbd8d2334e40);
    $parcel$export(module.exports, "timeUnits", ()=>$82620b17ee17a85a$export$833c398a55654bb7);
    $parcel$export(module.exports, "pad", ()=>$82620b17ee17a85a$export$5d04458e2a6c373e);
    $parcel$export(module.exports, "getPrimaryTimeUnit", ()=>$82620b17ee17a85a$export$1da4b91a25d7e1c8);
    $parcel$export(module.exports, "isPrimaryTimeUnit", ()=>$82620b17ee17a85a$export$beb5920b69c13da);
    $parcel$export(module.exports, "getDefaultFormatPrecisionOfInterval", ()=>$82620b17ee17a85a$export$124c820721c4f66b);
    $parcel$export(module.exports, "format", ()=>$82620b17ee17a85a$export$d9468344d3651243);
    $parcel$export(module.exports, "fullYearGetterName", ()=>$82620b17ee17a85a$export$8d046fefed9a548e);
    $parcel$export(module.exports, "monthGetterName", ()=>$82620b17ee17a85a$export$5c242a801a23eec7);
    $parcel$export(module.exports, "dateGetterName", ()=>$82620b17ee17a85a$export$4189e6cbc9753260);
    $parcel$export(module.exports, "hoursGetterName", ()=>$82620b17ee17a85a$export$8b40b55b3c06cbe2);
    $parcel$export(module.exports, "minutesGetterName", ()=>$82620b17ee17a85a$export$8807847c5c71eded);
    $parcel$export(module.exports, "secondsGetterName", ()=>$82620b17ee17a85a$export$8f49e73e2eebd168);
    $parcel$export(module.exports, "millisecondsGetterName", ()=>$82620b17ee17a85a$export$312207a92d041116);
    $parcel$export(module.exports, "leveledFormat", ()=>$82620b17ee17a85a$export$fe777b6293828b5d);
    $parcel$export(module.exports, "getUnitValue", ()=>$82620b17ee17a85a$export$e04e41a1e24ffd3f);
    $parcel$export(module.exports, "fullYearSetterName", ()=>$82620b17ee17a85a$export$43fbeac90913b151);
    $parcel$export(module.exports, "monthSetterName", ()=>$82620b17ee17a85a$export$233f59998ed71c09);
    $parcel$export(module.exports, "dateSetterName", ()=>$82620b17ee17a85a$export$82fd379a67f37fa0);
    $parcel$export(module.exports, "hoursSetterName", ()=>$82620b17ee17a85a$export$b6f943e8d23c15bb);
    $parcel$export(module.exports, "minutesSetterName", ()=>$82620b17ee17a85a$export$50303078793fc7d);
    $parcel$export(module.exports, "secondsSetterName", ()=>$82620b17ee17a85a$export$a4a908acda9c3118);
    $parcel$export(module.exports, "millisecondsSetterName", ()=>$82620b17ee17a85a$export$c047afab75f6d84);
    var $bahqM;
    var $jmSNG;
    var $3OMoQ;
    var $gaMkj;
    var $82620b17ee17a85a$export$32c0454ceff7f92d = 1000;
    var $82620b17ee17a85a$export$35acaebf644db34e = $82620b17ee17a85a$export$32c0454ceff7f92d * 60;
    var $82620b17ee17a85a$export$82541edf19e5e3b0 = $82620b17ee17a85a$export$35acaebf644db34e * 60;
    var $82620b17ee17a85a$export$a97a1358cbb650ab = $82620b17ee17a85a$export$82541edf19e5e3b0 * 24;
    var $82620b17ee17a85a$export$99cafda57477293d = $82620b17ee17a85a$export$a97a1358cbb650ab * 365;
    var $82620b17ee17a85a$export$f7854271ddbda64e = {
        year: '{yyyy}',
        month: '{MMM}',
        day: '{d}',
        hour: '{HH}:{mm}',
        minute: '{HH}:{mm}',
        second: '{HH}:{mm}:{ss}',
        millisecond: '{HH}:{mm}:{ss} {SSS}',
        none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
    };
    var $82620b17ee17a85a$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
    var $82620b17ee17a85a$export$445bdbd8d2334e40 = {
        year: '{yyyy}',
        month: '{yyyy}-{MM}',
        day: $82620b17ee17a85a$var$fullDayFormatter,
        hour: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.hour,
        minute: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.minute,
        second: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.second,
        millisecond: $82620b17ee17a85a$export$f7854271ddbda64e.none
    };
    var $82620b17ee17a85a$export$87100da04d711986 = [
        'year',
        'month',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    var $82620b17ee17a85a$export$833c398a55654bb7 = [
        'year',
        'half-year',
        'quarter',
        'month',
        'week',
        'half-week',
        'day',
        'half-day',
        'quarter-day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function $82620b17ee17a85a$export$5d04458e2a6c373e(str, len) {
        str += '';
        return '0000'.substr(0, len - str.length) + str;
    }
    function $82620b17ee17a85a$export$1da4b91a25d7e1c8(timeUnit) {
        switch(timeUnit){
            case 'half-year':
            case 'quarter':
                return 'month';
            case 'week':
            case 'half-week':
                return 'day';
            case 'half-day':
            case 'quarter-day':
                return 'hour';
            default:
                return timeUnit;
        }
    }
    function $82620b17ee17a85a$export$beb5920b69c13da(timeUnit) {
        return timeUnit === $82620b17ee17a85a$export$1da4b91a25d7e1c8(timeUnit);
    }
    function $82620b17ee17a85a$export$124c820721c4f66b(timeUnit) {
        switch(timeUnit){
            case 'year':
            case 'month':
                return 'day';
            case 'millisecond':
                return 'millisecond';
            default:
                return 'second';
        }
    }
    function $82620b17ee17a85a$export$d9468344d3651243(time, template, isUTC, lang) {
        var date = (0, parcelRequire("jmSNG")).parseDate(time);
        var y = date[$82620b17ee17a85a$export$8d046fefed9a548e(isUTC)]();
        var M = date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1;
        var q = Math.floor((M - 1) / 4) + 1;
        var d = date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
        var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
        var H = date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
        var h = (H - 1) % 12 + 1;
        var m = date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
        var s = date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
        var S = date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
        var localeModel = lang instanceof (0, (0, parcelRequire("gaMkj")).default) ? lang : (0, (0, parcelRequire("3OMoQ")).getLocaleModel)(lang || (0, (0, parcelRequire("3OMoQ")).SYSTEM_LANG)) || (0, (0, parcelRequire("3OMoQ")).getDefaultLocaleModel)();
        var timeModel = localeModel.getModel('time');
        var month = timeModel.get('month');
        var monthAbbr = timeModel.get('monthAbbr');
        var dayOfWeek = timeModel.get('dayOfWeek');
        var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
        return (template || '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, y % 100 + '').replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
    }
    function $82620b17ee17a85a$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
        var template = null;
        if (typeof formatter === 'string') template = formatter;
        else if (typeof formatter === 'function') template = formatter(tick.value, idx, {
            level: tick.level
        });
        else {
            var defaults = (0, parcelRequire("bahqM")).extend({}, $82620b17ee17a85a$export$f7854271ddbda64e);
            if (tick.level > 0) for(var i = 0; i < $82620b17ee17a85a$export$87100da04d711986.length; ++i)defaults[$82620b17ee17a85a$export$87100da04d711986[i]] = "{primary|" + defaults[$82620b17ee17a85a$export$87100da04d711986[i]] + "}";
            var mergedFormatter = formatter ? formatter.inherit === false ? formatter : (0, parcelRequire("bahqM")).defaults(formatter, defaults) : defaults;
            var unit = $82620b17ee17a85a$export$4dfb0417ad6555b7(tick.value, isUTC);
            if (mergedFormatter[unit]) template = mergedFormatter[unit];
            else if (mergedFormatter.inherit) {
                var targetId = $82620b17ee17a85a$export$833c398a55654bb7.indexOf(unit);
                for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                    template = mergedFormatter[unit];
                    break;
                }
                template = template || defaults.none;
            }
            if ((0, parcelRequire("bahqM")).isArray(template)) {
                var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
                levelId = Math.min(levelId, template.length - 1);
                template = template[levelId];
            }
        }
        return $82620b17ee17a85a$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
    }
    function $82620b17ee17a85a$export$4dfb0417ad6555b7(value, isUTC) {
        var date = (0, parcelRequire("jmSNG")).parseDate(value);
        var M = date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1;
        var d = date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
        var h = date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
        var m = date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
        var s = date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
        var S = date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
        var isSecond = S === 0;
        var isMinute = isSecond && s === 0;
        var isHour = isMinute && m === 0;
        var isDay = isHour && h === 0;
        var isMonth = isDay && d === 1;
        var isYear = isMonth && M === 1;
        if (isYear) return 'year';
        else if (isMonth) return 'month';
        else if (isDay) return 'day';
        else if (isHour) return 'hour';
        else if (isMinute) return 'minute';
        else if (isSecond) return 'second';
        else return 'millisecond';
    }
    function $82620b17ee17a85a$export$e04e41a1e24ffd3f(value, unit, isUTC) {
        var date = typeof value === 'number' ? (0, parcelRequire("jmSNG")).parseDate(value) : value;
        unit = unit || $82620b17ee17a85a$export$4dfb0417ad6555b7(value, isUTC);
        switch(unit){
            case 'year':
                return date[$82620b17ee17a85a$export$8d046fefed9a548e(isUTC)]();
            case 'half-year':
                return date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
            case 'quarter':
                return Math.floor((date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
            case 'month':
                return date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]();
            case 'day':
                return date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
            case 'half-day':
                return date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]() / 24;
            case 'hour':
                return date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
            case 'minute':
                return date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
            case 'second':
                return date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
            case 'millisecond':
                return date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
        }
    }
    function $82620b17ee17a85a$export$8d046fefed9a548e(isUTC) {
        return isUTC ? 'getUTCFullYear' : 'getFullYear';
    }
    function $82620b17ee17a85a$export$5c242a801a23eec7(isUTC) {
        return isUTC ? 'getUTCMonth' : 'getMonth';
    }
    function $82620b17ee17a85a$export$4189e6cbc9753260(isUTC) {
        return isUTC ? 'getUTCDate' : 'getDate';
    }
    function $82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC) {
        return isUTC ? 'getUTCHours' : 'getHours';
    }
    function $82620b17ee17a85a$export$8807847c5c71eded(isUTC) {
        return isUTC ? 'getUTCMinutes' : 'getMinutes';
    }
    function $82620b17ee17a85a$export$8f49e73e2eebd168(isUTC) {
        return isUTC ? 'getUTCSeconds' : 'getSeconds';
    }
    function $82620b17ee17a85a$export$312207a92d041116(isUTC) {
        return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
    }
    function $82620b17ee17a85a$export$43fbeac90913b151(isUTC) {
        return isUTC ? 'setUTCFullYear' : 'setFullYear';
    }
    function $82620b17ee17a85a$export$233f59998ed71c09(isUTC) {
        return isUTC ? 'setUTCMonth' : 'setMonth';
    }
    function $82620b17ee17a85a$export$82fd379a67f37fa0(isUTC) {
        return isUTC ? 'setUTCDate' : 'setDate';
    }
    function $82620b17ee17a85a$export$b6f943e8d23c15bb(isUTC) {
        return isUTC ? 'setUTCHours' : 'setHours';
    }
    function $82620b17ee17a85a$export$50303078793fc7d(isUTC) {
        return isUTC ? 'setUTCMinutes' : 'setMinutes';
    }
    function $82620b17ee17a85a$export$a4a908acda9c3118(isUTC) {
        return isUTC ? 'setUTCSeconds' : 'setSeconds';
    }
    function $82620b17ee17a85a$export$c047afab75f6d84(isUTC) {
        return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
    }
});
parcelRegister("3OMoQ", function(module, exports) {
    $parcel$export(module.exports, "SYSTEM_LANG", ()=>$2c7b95ca3b098ed0$export$9a2147b3808d4c6b);
    $parcel$export(module.exports, "registerLocale", ()=>$2c7b95ca3b098ed0$export$bab6a7822cc1e2cd);
    $parcel$export(module.exports, "createLocaleObject", ()=>$2c7b95ca3b098ed0$export$ddc371781a6af754);
    $parcel$export(module.exports, "getLocaleModel", ()=>$2c7b95ca3b098ed0$export$37cc638e0e11865f);
    $parcel$export(module.exports, "getDefaultLocaleModel", ()=>$2c7b95ca3b098ed0$export$1188f179b2597821);
    var $gaMkj;
    var $hZfwb;
    var $dHSx1;
    var $1VLoR;
    var $bahqM;
    var $2c7b95ca3b098ed0$var$LOCALE_ZH = 'ZH';
    var $2c7b95ca3b098ed0$var$LOCALE_EN = 'EN';
    var $2c7b95ca3b098ed0$var$DEFAULT_LOCALE = $2c7b95ca3b098ed0$var$LOCALE_EN;
    var $2c7b95ca3b098ed0$var$localeStorage = {};
    var $2c7b95ca3b098ed0$var$localeModels = {};
    var $2c7b95ca3b098ed0$export$9a2147b3808d4c6b = !(0, (0, parcelRequire("hZfwb")).default).domSupported ? $2c7b95ca3b098ed0$var$DEFAULT_LOCALE : function() {
        var langStr = (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
        return langStr.indexOf($2c7b95ca3b098ed0$var$LOCALE_ZH) > -1 ? $2c7b95ca3b098ed0$var$LOCALE_ZH : $2c7b95ca3b098ed0$var$DEFAULT_LOCALE;
    }();
    function $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd(locale, localeObj) {
        locale = locale.toUpperCase();
        $2c7b95ca3b098ed0$var$localeModels[locale] = new (0, (0, parcelRequire("gaMkj")).default)(localeObj);
        $2c7b95ca3b098ed0$var$localeStorage[locale] = localeObj;
    }
    function $2c7b95ca3b098ed0$export$ddc371781a6af754(locale) {
        if ((0, (0, parcelRequire("bahqM")).isString)(locale)) {
            var localeObj = $2c7b95ca3b098ed0$var$localeStorage[locale.toUpperCase()] || {};
            if (locale === $2c7b95ca3b098ed0$var$LOCALE_ZH || locale === $2c7b95ca3b098ed0$var$LOCALE_EN) return (0, (0, parcelRequire("bahqM")).clone)(localeObj);
            else return (0, (0, parcelRequire("bahqM")).merge)((0, (0, parcelRequire("bahqM")).clone)(localeObj), (0, (0, parcelRequire("bahqM")).clone)($2c7b95ca3b098ed0$var$localeStorage[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE]), false);
        } else return (0, (0, parcelRequire("bahqM")).merge)((0, (0, parcelRequire("bahqM")).clone)(locale), (0, (0, parcelRequire("bahqM")).clone)($2c7b95ca3b098ed0$var$localeStorage[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE]), false);
    }
    function $2c7b95ca3b098ed0$export$37cc638e0e11865f(lang) {
        return $2c7b95ca3b098ed0$var$localeModels[lang];
    }
    function $2c7b95ca3b098ed0$export$1188f179b2597821() {
        return $2c7b95ca3b098ed0$var$localeModels[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE];
    }
    $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd($2c7b95ca3b098ed0$var$LOCALE_EN, (0, (0, parcelRequire("dHSx1")).default));
    $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd($2c7b95ca3b098ed0$var$LOCALE_ZH, (0, (0, parcelRequire("1VLoR")).default));
});
parcelRegister("dHSx1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fa9975bdbfffeb9$export$2e2bcd8739ae039);
    var $9fa9975bdbfffeb9$export$2e2bcd8739ae039 = {
        time: {
            month: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            monthAbbr: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            dayOfWeek: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ],
            dayOfWeekAbbr: [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat'
            ]
        },
        legend: {
            selector: {
                all: 'All',
                inverse: 'Inv'
            }
        },
        toolbox: {
            brush: {
                title: {
                    rect: 'Box Select',
                    polygon: 'Lasso Select',
                    lineX: 'Horizontally Select',
                    lineY: 'Vertically Select',
                    keep: 'Keep Selections',
                    clear: 'Clear Selections'
                }
            },
            dataView: {
                title: 'Data View',
                lang: [
                    'Data View',
                    'Close',
                    'Refresh'
                ]
            },
            dataZoom: {
                title: {
                    zoom: 'Zoom',
                    back: 'Zoom Reset'
                }
            },
            magicType: {
                title: {
                    line: 'Switch to Line Chart',
                    bar: 'Switch to Bar Chart',
                    stack: 'Stack',
                    tiled: 'Tile'
                }
            },
            restore: {
                title: 'Restore'
            },
            saveAsImage: {
                title: 'Save as Image',
                lang: [
                    'Right Click to Save Image'
                ]
            }
        },
        series: {
            typeNames: {
                pie: 'Pie chart',
                bar: 'Bar chart',
                line: 'Line chart',
                scatter: 'Scatter plot',
                effectScatter: 'Ripple scatter plot',
                radar: 'Radar chart',
                tree: 'Tree',
                treemap: 'Treemap',
                boxplot: 'Boxplot',
                candlestick: 'Candlestick',
                k: 'K line chart',
                heatmap: 'Heat map',
                map: 'Map',
                parallel: 'Parallel coordinate map',
                lines: 'Line graph',
                graph: 'Relationship graph',
                sankey: 'Sankey diagram',
                funnel: 'Funnel chart',
                gauge: 'Gauge',
                pictorialBar: 'Pictorial bar',
                themeRiver: 'Theme River Map',
                sunburst: 'Sunburst'
            }
        },
        aria: {
            general: {
                withTitle: 'This is a chart about "{title}"',
                withoutTitle: 'This is a chart'
            },
            series: {
                single: {
                    prefix: '',
                    withName: ' with type {seriesType} named {seriesName}.',
                    withoutName: ' with type {seriesType}.'
                },
                multiple: {
                    prefix: '. It consists of {seriesCount} series count.',
                    withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                    withoutName: ' The {seriesId} series is a {seriesType}.',
                    separator: {
                        middle: '',
                        end: ''
                    }
                }
            },
            data: {
                allData: 'The data is as follows: ',
                partialData: 'The first {displayCnt} items are: ',
                withName: 'the data for {name} is {value}',
                withoutName: '{value}',
                separator: {
                    middle: ', ',
                    end: '. '
                }
            }
        }
    };
});
parcelRegister("1VLoR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$167fe1fc3be0ec4c$export$2e2bcd8739ae039);
    var $167fe1fc3be0ec4c$export$2e2bcd8739ae039 = {
        time: {
            month: [
                "\u4E00\u6708",
                "\u4E8C\u6708",
                "\u4E09\u6708",
                "\u56DB\u6708",
                "\u4E94\u6708",
                "\u516D\u6708",
                "\u4E03\u6708",
                "\u516B\u6708",
                "\u4E5D\u6708",
                "\u5341\u6708",
                "\u5341\u4E00\u6708",
                "\u5341\u4E8C\u6708"
            ],
            monthAbbr: [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ],
            dayOfWeek: [
                "\u661F\u671F\u65E5",
                "\u661F\u671F\u4E00",
                "\u661F\u671F\u4E8C",
                "\u661F\u671F\u4E09",
                "\u661F\u671F\u56DB",
                "\u661F\u671F\u4E94",
                "\u661F\u671F\u516D"
            ],
            dayOfWeekAbbr: [
                "\u65E5",
                "\u4E00",
                "\u4E8C",
                "\u4E09",
                "\u56DB",
                "\u4E94",
                "\u516D"
            ]
        },
        legend: {
            selector: {
                all: "\u5168\u9009",
                inverse: "\u53CD\u9009"
            }
        },
        toolbox: {
            brush: {
                title: {
                    rect: "\u77E9\u5F62\u9009\u62E9",
                    polygon: "\u5708\u9009",
                    lineX: "\u6A2A\u5411\u9009\u62E9",
                    lineY: "\u7EB5\u5411\u9009\u62E9",
                    keep: "\u4FDD\u6301\u9009\u62E9",
                    clear: "\u6E05\u9664\u9009\u62E9"
                }
            },
            dataView: {
                title: "\u6570\u636E\u89C6\u56FE",
                lang: [
                    "\u6570\u636E\u89C6\u56FE",
                    "\u5173\u95ED",
                    "\u5237\u65B0"
                ]
            },
            dataZoom: {
                title: {
                    zoom: "\u533A\u57DF\u7F29\u653E",
                    back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
                }
            },
            magicType: {
                title: {
                    line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                    bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                    stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                    tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
                }
            },
            restore: {
                title: "\u8FD8\u539F"
            },
            saveAsImage: {
                title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
                lang: [
                    "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
                ]
            }
        },
        series: {
            typeNames: {
                pie: "\u997C\u56FE",
                bar: "\u67F1\u72B6\u56FE",
                line: "\u6298\u7EBF\u56FE",
                scatter: "\u6563\u70B9\u56FE",
                effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
                radar: "\u96F7\u8FBE\u56FE",
                tree: "\u6811\u56FE",
                treemap: "\u77E9\u5F62\u6811\u56FE",
                boxplot: "\u7BB1\u578B\u56FE",
                candlestick: "K\u7EBF\u56FE",
                k: "K\u7EBF\u56FE",
                heatmap: "\u70ED\u529B\u56FE",
                map: "\u5730\u56FE",
                parallel: "\u5E73\u884C\u5750\u6807\u56FE",
                lines: "\u7EBF\u56FE",
                graph: "\u5173\u7CFB\u56FE",
                sankey: "\u6851\u57FA\u56FE",
                funnel: "\u6F0F\u6597\u56FE",
                gauge: "\u4EEA\u8868\u76D8\u56FE",
                pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
                themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
                sunburst: "\u65ED\u65E5\u56FE"
            }
        },
        aria: {
            general: {
                withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
                withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
            },
            series: {
                single: {
                    prefix: '',
                    withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                    withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
                },
                multiple: {
                    prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                    withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                    withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                    separator: {
                        middle: "\uFF1B",
                        end: "\u3002"
                    }
                }
            },
            data: {
                allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
                partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
                withName: "{name}\u7684\u6570\u636E\u662F{value}",
                withoutName: '{value}',
                separator: {
                    middle: "\uFF0C",
                    end: ''
                }
            }
        }
    };
});
parcelRegister("2emZ2", function(module, exports) {
    $parcel$export(module.exports, "getTextRect", ()=>$19feb79b579d02ba$export$372ffda650a6e70d);
    var $4gEFv;
    var $2cFRc;
    function $19feb79b579d02ba$export$372ffda650a6e70d(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
        (0, (0, parcelRequire("2cFRc")).deprecateLog)('getTextRect is deprecated.');
        var textEl = new (0, (0, parcelRequire("4gEFv")).default)({
            style: {
                text: text,
                font: font,
                align: align,
                verticalAlign: verticalAlign,
                padding: padding,
                rich: rich,
                overflow: truncate ? 'truncate' : null,
                lineHeight: lineHeight
            }
        });
        return textEl.getBoundingRect();
    }
});
parcelRegister("aCu4v", function(module, exports) {
    $parcel$export(module.exports, "PaletteMixin", ()=>$7bb4c79f78d718b0$export$55a3c39e852b90f4);
    $parcel$export(module.exports, "getDecalFromPalette", ()=>$7bb4c79f78d718b0$export$e4d892222945a227);
    var $eaKsF;
    var $7bb4c79f78d718b0$var$innerColor = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $7bb4c79f78d718b0$var$innerDecal = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $7bb4c79f78d718b0$export$55a3c39e852b90f4 = function() {
        function PaletteMixin() {}
        PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
            var defaultPalette = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(this.get('color', true));
            var layeredPalette = this.get('colorLayer', true);
            return $7bb4c79f78d718b0$var$getFromPalette(this, $7bb4c79f78d718b0$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
        };
        PaletteMixin.prototype.clearColorPalette = function() {
            $7bb4c79f78d718b0$var$clearPalette(this, $7bb4c79f78d718b0$var$innerColor);
        };
        return PaletteMixin;
    }();
    function $7bb4c79f78d718b0$export$e4d892222945a227(ecModel, name, scope, requestNum) {
        var defaultDecals = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(ecModel.get([
            'aria',
            'decal',
            'decals'
        ]));
        return $7bb4c79f78d718b0$var$getFromPalette(ecModel, $7bb4c79f78d718b0$var$innerDecal, defaultDecals, null, name, scope, requestNum);
    }
    function $7bb4c79f78d718b0$var$getNearestPalette(palettes, requestColorNum) {
        var paletteNum = palettes.length;
        for(var i = 0; i < paletteNum; i++){
            if (palettes[i].length > requestColorNum) return palettes[i];
        }
        return palettes[paletteNum - 1];
    }
    function $7bb4c79f78d718b0$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
        scope = scope || that;
        var scopeFields = inner(scope);
        var paletteIdx = scopeFields.paletteIdx || 0;
        var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
        if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
        var palette = requestNum == null || !layeredPalette ? defaultPalette : $7bb4c79f78d718b0$var$getNearestPalette(layeredPalette, requestNum);
        palette = palette || defaultPalette;
        if (!palette || !palette.length) return;
        var pickedPaletteItem = palette[paletteIdx];
        if (name) paletteNameMap[name] = pickedPaletteItem;
        scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
        return pickedPaletteItem;
    }
    function $7bb4c79f78d718b0$var$clearPalette(that, inner) {
        inner(that).paletteIdx = 0;
        inner(that).paletteNameMap = {};
    }
});
parcelRegister("guzSc", function(module, exports) {
    $parcel$export(module.exports, "DataFormatMixin", ()=>$c01b465ef25e12c0$export$f23396ae04ea95a7);
    $parcel$export(module.exports, "normalizeTooltipFormatResult", ()=>$c01b465ef25e12c0$export$2d16fa82a50c4741);
    var $bahqM;
    var $9OHWG;
    var $dCJrM;
    var $c01b465ef25e12c0$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
    var $c01b465ef25e12c0$export$f23396ae04ea95a7 = function() {
        function DataFormatMixin() {}
        DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
            var data = this.getData(dataType);
            var rawValue = this.getRawValue(dataIndex, dataType);
            var rawDataIndex = data.getRawIndex(dataIndex);
            var name = data.getName(dataIndex);
            var itemOpt = data.getRawDataItem(dataIndex);
            var style = data.getItemVisual(dataIndex, 'style');
            var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
            var borderColor = style && style.stroke;
            var mainType = this.mainType;
            var isSeries = mainType === 'series';
            var userOutput = data.userOutput && data.userOutput.get();
            return {
                componentType: mainType,
                componentSubType: this.subType,
                componentIndex: this.componentIndex,
                seriesType: isSeries ? this.subType : null,
                seriesIndex: this.seriesIndex,
                seriesId: isSeries ? this.id : null,
                seriesName: isSeries ? this.name : null,
                name: name,
                dataIndex: rawDataIndex,
                data: itemOpt,
                dataType: dataType,
                value: rawValue,
                color: color,
                borderColor: borderColor,
                dimensionNames: userOutput ? userOutput.fullDimensions : null,
                encode: userOutput ? userOutput.encode : null,
                $vars: [
                    'seriesName',
                    'name',
                    'value'
                ]
            };
        };
        DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
            status = status || 'normal';
            var data = this.getData(dataType);
            var params = this.getDataParams(dataIndex, dataType);
            if (extendParams) params.value = extendParams.interpolatedValue;
            if (labelDimIndex != null && (0, parcelRequire("bahqM")).isArray(params.value)) params.value = params.value[labelDimIndex];
            if (!formatter) {
                var itemModel = data.getItemModel(dataIndex);
                formatter = itemModel.get(status === 'normal' ? [
                    'label',
                    'formatter'
                ] : [
                    status,
                    'label',
                    'formatter'
                ]);
            }
            if (typeof formatter === 'function') {
                params.status = status;
                params.dimensionIndex = labelDimIndex;
                return formatter(params);
            } else if (typeof formatter === 'string') {
                var str = (0, (0, parcelRequire("dCJrM")).formatTpl)(formatter, params);
                return str.replace($c01b465ef25e12c0$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                    var len = dimStr.length;
                    var dimLoose = dimStr;
                    if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1);
                    var val = (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, dimLoose);
                    if (extendParams && (0, parcelRequire("bahqM")).isArray(extendParams.interpolatedValue)) {
                        var dimIndex = data.getDimensionIndex(dimLoose);
                        if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                    }
                    return val != null ? val + '' : '';
                });
            }
        };
        DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
            return (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(this.getData(dataType), idx);
        };
        DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
            return;
        };
        return DataFormatMixin;
    }();
    function $c01b465ef25e12c0$export$2d16fa82a50c4741(result) {
        var markupText;
        var markupFragment;
        if ((0, parcelRequire("bahqM")).isObject(result)) {
            if (result.type) markupFragment = result;
        } else markupText = result;
        return {
            markupText: markupText,
            markupFragment: markupFragment
        };
    }
});
parcelRegister("jTNWo", function(module, exports) {
    $parcel$export(module.exports, "SourceManager", ()=>$e7c9e4985e212cda$export$af4db9ec7e200ea2);
    $parcel$export(module.exports, "disableTransformOptionMerge", ()=>$e7c9e4985e212cda$export$9451f4e9047441ec);
    var $bahqM;
    var $20liu;
    var $2Rbm1;
    var $cNGs8;
    var $05ab4;
    var $8c3gC;
    var $9OHWG;
    var $e7c9e4985e212cda$export$af4db9ec7e200ea2 = function() {
        function SourceManager(sourceHost) {
            this._sourceList = [];
            this._storeList = [];
            this._upstreamSignList = [];
            this._versionSignBase = 0;
            this._dirty = true;
            this._sourceHost = sourceHost;
        }
        SourceManager.prototype.dirty = function() {
            this._setLocalSource([], []);
            this._storeList = [];
            this._dirty = true;
        };
        SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
            this._sourceList = sourceList;
            this._upstreamSignList = upstreamSignList;
            this._versionSignBase++;
            if (this._versionSignBase > 9e10) this._versionSignBase = 0;
        };
        SourceManager.prototype._getVersionSign = function() {
            return this._sourceHost.uid + '_' + this._versionSignBase;
        };
        SourceManager.prototype.prepareSource = function() {
            if (this._isDirty()) {
                this._createSource();
                this._dirty = false;
            }
        };
        SourceManager.prototype._createSource = function() {
            this._setLocalSource([], []);
            var sourceHost = this._sourceHost;
            var upSourceMgrList = this._getUpstreamSourceManagers();
            var hasUpstream = !!upSourceMgrList.length;
            var resultSourceList;
            var upstreamSignList;
            if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
                var seriesModel = sourceHost;
                var data = void 0;
                var sourceFormat = void 0;
                var upSource = void 0;
                if (hasUpstream) {
                    var upSourceMgr = upSourceMgrList[0];
                    upSourceMgr.prepareSource();
                    upSource = upSourceMgr.getSource();
                    data = upSource.data;
                    sourceFormat = upSource.sourceFormat;
                    upstreamSignList = [
                        upSourceMgr._getVersionSign()
                    ];
                } else {
                    data = seriesModel.get('data', true);
                    sourceFormat = (0, (0, parcelRequire("bahqM")).isTypedArray)(data) ? (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY) : (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL);
                    upstreamSignList = [];
                }
                var newMetaRawOption = this._getSourceMetaRawOption() || {};
                var upMetaRawOption = upSource && upSource.metaRawOption || {};
                var seriesLayoutBy = (0, (0, parcelRequire("bahqM")).retrieve2)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
                var sourceHeader = (0, (0, parcelRequire("bahqM")).retrieve2)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader) || null;
                var dimensions = (0, (0, parcelRequire("bahqM")).retrieve2)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
                var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
                resultSourceList = needsCreateSource ? [
                    (0, (0, parcelRequire("20liu")).createSource)(data, {
                        seriesLayoutBy: seriesLayoutBy,
                        sourceHeader: sourceHeader,
                        dimensions: dimensions
                    }, sourceFormat)
                ] : [];
            } else {
                var datasetModel = sourceHost;
                if (hasUpstream) {
                    var result = this._applyTransform(upSourceMgrList);
                    resultSourceList = result.sourceList;
                    upstreamSignList = result.upstreamSignList;
                } else {
                    var sourceData = datasetModel.get('source', true);
                    resultSourceList = [
                        (0, (0, parcelRequire("20liu")).createSource)(sourceData, this._getSourceMetaRawOption(), null)
                    ];
                    upstreamSignList = [];
                }
            }
            this._setLocalSource(resultSourceList, upstreamSignList);
        };
        SourceManager.prototype._applyTransform = function(upMgrList) {
            var datasetModel = this._sourceHost;
            var transformOption = datasetModel.get('transform', true);
            var fromTransformResult = datasetModel.get('fromTransformResult', true);
            if (fromTransformResult != null) {
                var errMsg = '';
                if (upMgrList.length !== 1) $e7c9e4985e212cda$var$doThrow(errMsg);
            }
            var sourceList;
            var upSourceList = [];
            var upstreamSignList = [];
            (0, (0, parcelRequire("bahqM")).each)(upMgrList, function(upMgr) {
                upMgr.prepareSource();
                var upSource = upMgr.getSource(fromTransformResult || 0);
                var errMsg = '';
                if (fromTransformResult != null && !upSource) $e7c9e4985e212cda$var$doThrow(errMsg);
                upSourceList.push(upSource);
                upstreamSignList.push(upMgr._getVersionSign());
            });
            if (transformOption) sourceList = (0, (0, parcelRequire("05ab4")).applyDataTransform)(transformOption, upSourceList, {
                datasetIndex: datasetModel.componentIndex
            });
            else if (fromTransformResult != null) sourceList = [
                (0, (0, parcelRequire("20liu")).cloneSourceShallow)(upSourceList[0])
            ];
            return {
                sourceList: sourceList,
                upstreamSignList: upstreamSignList
            };
        };
        SourceManager.prototype._isDirty = function() {
            if (this._dirty) return true;
            var upSourceMgrList = this._getUpstreamSourceManagers();
            for(var i = 0; i < upSourceMgrList.length; i++){
                var upSrcMgr = upSourceMgrList[i];
                if (upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
            }
        };
        SourceManager.prototype.getSource = function(sourceIndex) {
            sourceIndex = sourceIndex || 0;
            var source = this._sourceList[sourceIndex];
            if (!source) {
                var upSourceMgrList = this._getUpstreamSourceManagers();
                return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
            }
            return source;
        };
        SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
            var schema = seriesDimRequest.makeStoreSchema();
            return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
        };
        SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
            var sourceIndex = 0;
            var storeList = this._storeList;
            var cachedStoreMap = storeList[sourceIndex];
            if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
            var cachedStore = cachedStoreMap[sourceReadKey];
            if (!cachedStore) {
                var upSourceMgr = this._getUpstreamSourceManagers()[0];
                if ($e7c9e4985e212cda$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
                else {
                    cachedStore = new (0, (0, parcelRequire("8c3gC")).default)();
                    cachedStore.initData(new (0, (0, parcelRequire("9OHWG")).DefaultDataProvider)(seriesSource, storeDims.length), storeDims);
                }
                cachedStoreMap[sourceReadKey] = cachedStore;
            }
            return cachedStore;
        };
        SourceManager.prototype._getUpstreamSourceManagers = function() {
            var sourceHost = this._sourceHost;
            if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
                var datasetModel = (0, (0, parcelRequire("cNGs8")).querySeriesUpstreamDatasetModel)(sourceHost);
                return !datasetModel ? [] : [
                    datasetModel.getSourceManager()
                ];
            } else return (0, (0, parcelRequire("bahqM")).map)((0, (0, parcelRequire("cNGs8")).queryDatasetUpstreamDatasetModels)(sourceHost), function(datasetModel) {
                return datasetModel.getSourceManager();
            });
        };
        SourceManager.prototype._getSourceMetaRawOption = function() {
            var sourceHost = this._sourceHost;
            var seriesLayoutBy;
            var sourceHeader;
            var dimensions;
            if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
                seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
                sourceHeader = sourceHost.get('sourceHeader', true);
                dimensions = sourceHost.get('dimensions', true);
            } else if (!this._getUpstreamSourceManagers().length) {
                var model = sourceHost;
                seriesLayoutBy = model.get('seriesLayoutBy', true);
                sourceHeader = model.get('sourceHeader', true);
                dimensions = model.get('dimensions', true);
            }
            return {
                seriesLayoutBy: seriesLayoutBy,
                sourceHeader: sourceHeader,
                dimensions: dimensions
            };
        };
        return SourceManager;
    }();
    function $e7c9e4985e212cda$export$9451f4e9047441ec(datasetModel) {
        var transformOption = datasetModel.option.transform;
        transformOption && (0, (0, parcelRequire("bahqM")).setAsPrimitive)(datasetModel.option.transform);
    }
    function $e7c9e4985e212cda$var$isSeries(sourceHost) {
        return sourceHost.mainType === 'series';
    }
    function $e7c9e4985e212cda$var$doThrow(errMsg) {
        throw new Error(errMsg);
    }
});
parcelRegister("05ab4", function(module, exports) {
    $parcel$export(module.exports, "registerExternalTransform", ()=>$00f85ccb3288f539$export$92c96c6d8b255b7d);
    $parcel$export(module.exports, "applyDataTransform", ()=>$00f85ccb3288f539$export$42a68f09db16803f);
    var $2Rbm1;
    var $eaKsF;
    var $bahqM;
    var $9OHWG;
    var $2G90t;
    var $2cFRc;
    var $20liu;
    var $00f85ccb3288f539$export$ffc19e40a21f08eb = function() {
        function ExternalSource() {}
        ExternalSource.prototype.getRawData = function() {
            throw new Error('not supported');
        };
        ExternalSource.prototype.getRawDataItem = function(dataIndex) {
            throw new Error('not supported');
        };
        ExternalSource.prototype.cloneRawData = function() {
            return;
        };
        ExternalSource.prototype.getDimensionInfo = function(dim) {
            return;
        };
        ExternalSource.prototype.cloneAllDimensionInfo = function() {
            return;
        };
        ExternalSource.prototype.count = function() {
            return;
        };
        ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
            return;
        };
        ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
            return;
        };
        ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
            return (0, (0, parcelRequire("2G90t")).parseDataValue)(rawVal, dimInfo);
        };
        return ExternalSource;
    }();
    function $00f85ccb3288f539$var$createExternalSource(internalSource, externalTransform) {
        var extSource = new $00f85ccb3288f539$export$ffc19e40a21f08eb();
        var data = internalSource.data;
        var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
        var sourceHeaderCount = internalSource.startIndex;
        var errMsg = '';
        if (internalSource.seriesLayoutBy !== (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var dimensions = [];
        var dimsByName = {};
        var dimsDef = internalSource.dimensionsDefine;
        if (dimsDef) (0, (0, parcelRequire("bahqM")).each)(dimsDef, function(dimDef, idx) {
            var name = dimDef.name;
            var dimDefExt = {
                index: idx,
                name: name,
                displayName: dimDef.displayName
            };
            dimensions.push(dimDefExt);
            if (name != null) {
                var errMsg_1 = '';
                if ((0, (0, parcelRequire("bahqM")).hasOwn)(dimsByName, name)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg_1);
                dimsByName[name] = dimDefExt;
            }
        });
        else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)dimensions.push({
            index: i
        });
        var rawItemGetter = (0, (0, parcelRequire("9OHWG")).getRawSourceItemGetter)(sourceFormat, (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN));
        if (externalTransform.__isBuiltIn) {
            extSource.getRawDataItem = function(dataIndex) {
                return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
            };
            extSource.getRawData = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$getRawData, null, internalSource);
        }
        extSource.cloneRawData = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$cloneRawData, null, internalSource);
        var rawCounter = (0, (0, parcelRequire("9OHWG")).getRawSourceDataCounter)(sourceFormat, (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN));
        extSource.count = (0, (0, parcelRequire("bahqM")).bind)(rawCounter, null, data, sourceHeaderCount, dimensions);
        var rawValueGetter = (0, (0, parcelRequire("9OHWG")).getRawSourceValueGetter)(sourceFormat);
        extSource.retrieveValue = function(dataIndex, dimIndex) {
            var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
            return retrieveValueFromItem(rawItem, dimIndex);
        };
        var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
            if (dataItem == null) return;
            var dimDef = dimensions[dimIndex];
            if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
        };
        extSource.getDimensionInfo = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$getDimensionInfo, null, dimensions, dimsByName);
        extSource.cloneAllDimensionInfo = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$cloneAllDimensionInfo, null, dimensions);
        return extSource;
    }
    function $00f85ccb3288f539$var$getRawData(upstream) {
        var sourceFormat = upstream.sourceFormat;
        if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) {
            var errMsg = '';
            (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        }
        return upstream.data;
    }
    function $00f85ccb3288f539$var$cloneRawData(upstream) {
        var sourceFormat = upstream.sourceFormat;
        var data = upstream.data;
        if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) {
            var errMsg = '';
            (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        }
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS)) {
            var result = [];
            for(var i = 0, len = data.length; i < len; i++)result.push(data[i].slice());
            return result;
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) {
            var result = [];
            for(var i = 0, len = data.length; i < len; i++)result.push((0, (0, parcelRequire("bahqM")).extend)({}, data[i]));
            return result;
        }
    }
    function $00f85ccb3288f539$var$getDimensionInfo(dimensions, dimsByName, dim) {
        if (dim == null) return;
        if (typeof dim === 'number' || !isNaN(dim) && !(0, (0, parcelRequire("bahqM")).hasOwn)(dimsByName, dim)) return dimensions[dim];
        else if ((0, (0, parcelRequire("bahqM")).hasOwn)(dimsByName, dim)) return dimsByName[dim];
    }
    function $00f85ccb3288f539$var$cloneAllDimensionInfo(dimensions) {
        return (0, (0, parcelRequire("bahqM")).clone)(dimensions);
    }
    var $00f85ccb3288f539$var$externalTransformMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
    function $00f85ccb3288f539$export$92c96c6d8b255b7d(externalTransform) {
        externalTransform = (0, (0, parcelRequire("bahqM")).clone)(externalTransform);
        var type = externalTransform.type;
        var errMsg = '';
        if (!type) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var typeParsed = type.split(':');
        if (typeParsed.length !== 2) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var isBuiltIn = false;
        if (typeParsed[0] === 'echarts') {
            type = typeParsed[1];
            isBuiltIn = true;
        }
        externalTransform.__isBuiltIn = isBuiltIn;
        $00f85ccb3288f539$var$externalTransformMap.set(type, externalTransform);
    }
    function $00f85ccb3288f539$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
        var pipedTransOption = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(rawTransOption);
        var pipeLen = pipedTransOption.length;
        var errMsg = '';
        if (!pipeLen) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        for(var i = 0, len = pipeLen; i < len; i++){
            var transOption = pipedTransOption[i];
            sourceList = $00f85ccb3288f539$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
            if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
        }
        return sourceList;
    }
    function $00f85ccb3288f539$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, pipeIndex) {
        var errMsg = '';
        if (!upSourceList.length) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        if (!(0, (0, parcelRequire("bahqM")).isObject)(transOption)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var transType = transOption.type;
        var externalTransform = $00f85ccb3288f539$var$externalTransformMap.get(transType);
        if (!externalTransform) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var extUpSourceList = (0, (0, parcelRequire("bahqM")).map)(upSourceList, function(upSource) {
            return $00f85ccb3288f539$var$createExternalSource(upSource, externalTransform);
        });
        var resultList = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(externalTransform.transform({
            upstream: extUpSourceList[0],
            upstreamList: extUpSourceList,
            config: (0, (0, parcelRequire("bahqM")).clone)(transOption.config)
        }));
        var printStrArr;
        return (0, (0, parcelRequire("bahqM")).map)(resultList, function(result, resultIndex) {
            var errMsg = '';
            if (!(0, (0, parcelRequire("bahqM")).isObject)(result)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            if (!result.data) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            var sourceFormat = (0, (0, parcelRequire("20liu")).detectSourceFormat)(result.data);
            if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            var resultMetaRawOption;
            var firstUpSource = upSourceList[0];
            if (firstUpSource && resultIndex === 0 && !result.dimensions) {
                var startIndex = firstUpSource.startIndex;
                if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
                resultMetaRawOption = {
                    seriesLayoutBy: (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN),
                    sourceHeader: startIndex,
                    dimensions: firstUpSource.metaRawOption.dimensions
                };
            } else resultMetaRawOption = {
                seriesLayoutBy: (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN),
                sourceHeader: 0,
                dimensions: result.dimensions
            };
            return (0, (0, parcelRequire("20liu")).createSource)(result.data, resultMetaRawOption, null);
        });
    }
    function $00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat) {
        return sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) || sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS);
    }
});
parcelRegister("d88IV", function(module, exports) {
    $parcel$export(module.exports, "defaultSeriesFormatTooltip", ()=>$98f2ca07d9209b02$export$3a110b9fb5c88b34);
    var $bahqM;
    var $j5lKL;
    var $9OHWG;
    var $eaKsF;
    function $98f2ca07d9209b02$export$3a110b9fb5c88b34(opt) {
        var series = opt.series;
        var dataIndex = opt.dataIndex;
        var multipleSeries = opt.multipleSeries;
        var data = series.getData();
        var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
        var tooltipDimLen = tooltipDims.length;
        var value = series.getRawValue(dataIndex);
        var isValueArr = (0, (0, parcelRequire("bahqM")).isArray)(value);
        var markerColor = (0, (0, parcelRequire("j5lKL")).retrieveVisualColorForTooltipMarker)(series, dataIndex);
        var inlineValue;
        var inlineValueType;
        var subBlocks;
        var sortParam;
        if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
            var formatArrResult = $98f2ca07d9209b02$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
            inlineValue = formatArrResult.inlineValues;
            inlineValueType = formatArrResult.inlineValueTypes;
            subBlocks = formatArrResult.blocks;
            sortParam = formatArrResult.inlineValues[0];
        } else if (tooltipDimLen) {
            var dimInfo = data.getDimensionInfo(tooltipDims[0]);
            sortParam = inlineValue = (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, tooltipDims[0]);
            inlineValueType = dimInfo.type;
        } else sortParam = inlineValue = isValueArr ? value[0] : value;
        var seriesNameSpecified = (0, (0, parcelRequire("eaKsF")).isNameSpecified)(series);
        var seriesName = seriesNameSpecified && series.name || '';
        var itemName = data.getName(dataIndex);
        var inlineName = multipleSeries ? seriesName : itemName;
        return (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('section', {
            header: seriesName,
            noHeader: multipleSeries || !seriesNameSpecified,
            sortParam: sortParam,
            blocks: [
                (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('nameValue', {
                    markerType: 'item',
                    markerColor: markerColor,
                    name: inlineName,
                    noName: !(0, (0, parcelRequire("bahqM")).trim)(inlineName),
                    value: inlineValue,
                    valueType: inlineValueType
                })
            ].concat(subBlocks || [])
        });
    }
    function $98f2ca07d9209b02$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
        var data = series.getData();
        var isValueMultipleLine = (0, (0, parcelRequire("bahqM")).reduce)(value, function(isValueMultipleLine, val, idx) {
            var dimItem = data.getDimensionInfo(idx);
            return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
        }, false);
        var inlineValues = [];
        var inlineValueTypes = [];
        var blocks = [];
        tooltipDims.length ? (0, (0, parcelRequire("bahqM")).each)(tooltipDims, function(dim) {
            setEachItem((0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, dim), dim);
        }) : (0, (0, parcelRequire("bahqM")).each)(value, setEachItem);
        function setEachItem(val, dim) {
            var dimInfo = data.getDimensionInfo(dim);
            if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
            if (isValueMultipleLine) blocks.push((0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('nameValue', {
                markerType: 'subItem',
                markerColor: colorStr,
                name: dimInfo.displayName,
                value: val,
                valueType: dimInfo.type
            }));
            else {
                inlineValues.push(val);
                inlineValueTypes.push(dimInfo.type);
            }
        }
        return {
            inlineValues: inlineValues,
            inlineValueTypes: inlineValueTypes,
            blocks: blocks
        };
    }
});
parcelRegister("j5lKL", function(module, exports) {
    $parcel$export(module.exports, "createTooltipMarkup", ()=>$de4f5bb7bbbcf45e$export$cf63b23ce77d1921);
    $parcel$export(module.exports, "buildTooltipMarkup", ()=>$de4f5bb7bbbcf45e$export$6969ffb02c1cb49a);
    $parcel$export(module.exports, "retrieveVisualColorForTooltipMarker", ()=>$de4f5bb7bbbcf45e$export$ea15628039c0fa93);
    $parcel$export(module.exports, "getPaddingFromTooltipModel", ()=>$de4f5bb7bbbcf45e$export$3048212c802df496);
    $parcel$export(module.exports, "TooltipMarkupStyleCreator", ()=>$de4f5bb7bbbcf45e$export$2fba3afbcdcf3e18);
    var $dCJrM;
    var $bahqM;
    var $2G90t;
    var $jmSNG;
    var $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1';
    function $de4f5bb7bbbcf45e$var$getTooltipTextStyle(textStyle, renderMode) {
        var nameFontColor = textStyle.color || '#6e7079';
        var nameFontSize = textStyle.fontSize || 12;
        var nameFontWeight = textStyle.fontWeight || '400';
        var valueFontColor = textStyle.color || '#464646';
        var valueFontSize = textStyle.fontSize || 14;
        var valueFontWeight = textStyle.fontWeight || '900';
        if (renderMode === 'html') return {
            nameStyle: "font-size:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(nameFontSize + '') + "px;color:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(nameFontColor) + ";font-weight:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(nameFontWeight + ''),
            valueStyle: "font-size:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(valueFontSize + '') + "px;color:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(valueFontColor) + ";font-weight:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(valueFontWeight + '')
        };
        else return {
            nameStyle: {
                fontSize: nameFontSize,
                fill: nameFontColor,
                fontWeight: nameFontWeight
            },
            valueStyle: {
                fontSize: valueFontSize,
                fill: valueFontColor,
                fontWeight: valueFontWeight
            }
        };
    }
    var $de4f5bb7bbbcf45e$var$HTML_GAPS = [
        0,
        10,
        20,
        30
    ];
    var $de4f5bb7bbbcf45e$var$RICH_TEXT_GAPS = [
        '',
        '\n',
        '\n\n',
        '\n\n\n'
    ];
    function $de4f5bb7bbbcf45e$export$cf63b23ce77d1921(type, option) {
        option.type = type;
        return option;
    }
    function $de4f5bb7bbbcf45e$var$getBuilder(fragment) {
        return (0, (0, parcelRequire("bahqM")).hasOwn)($de4f5bb7bbbcf45e$var$builderMap, fragment.type) && $de4f5bb7bbbcf45e$var$builderMap[fragment.type];
    }
    var $de4f5bb7bbbcf45e$var$builderMap = {
        section: {
            planLayout: function(fragment) {
                var subBlockLen = fragment.blocks.length;
                var thisBlockHasInnerGap = subBlockLen > 1 || subBlockLen > 0 && !fragment.noHeader;
                var thisGapLevelBetweenSubBlocks = 0;
                (0, (0, parcelRequire("bahqM")).each)(fragment.blocks, function(subBlock) {
                    $de4f5bb7bbbcf45e$var$getBuilder(subBlock).planLayout(subBlock);
                    var subGapLevel = subBlock.__gapLevelBetweenSubBlocks;
                    if (subGapLevel >= thisGapLevelBetweenSubBlocks) thisGapLevelBetweenSubBlocks = subGapLevel + (thisBlockHasInnerGap && (!subGapLevel || subBlock.type === 'section' && !subBlock.noHeader) ? 1 : 0);
                });
                fragment.__gapLevelBetweenSubBlocks = thisGapLevelBetweenSubBlocks;
            },
            build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
                var noHeader = fragment.noHeader;
                var gaps = $de4f5bb7bbbcf45e$var$getGap(fragment);
                var subMarkupText = $de4f5bb7bbbcf45e$var$buildSubBlocks(ctx, fragment, noHeader ? topMarginForOuterGap : gaps.html, toolTipTextStyle);
                if (noHeader) return subMarkupText;
                var displayableHeader = (0, (0, parcelRequire("dCJrM")).makeValueReadable)(fragment.header, 'ordinal', ctx.useUTC);
                var nameStyle = $de4f5bb7bbbcf45e$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
                if (ctx.renderMode === 'richText') return $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
                else return $de4f5bb7bbbcf45e$var$wrapBlockHTML("<div style=\"" + nameStyle + ";" + $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
            }
        },
        nameValue: {
            planLayout: function(fragment) {
                fragment.__gapLevelBetweenSubBlocks = 0;
            },
            build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
                var renderMode = ctx.renderMode;
                var noName = fragment.noName;
                var noValue = fragment.noValue;
                var noMarker = !fragment.markerType;
                var name = fragment.name;
                var value = fragment.value;
                var useUTC = ctx.useUTC;
                if (noName && noValue) return;
                var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
                var readableName = noName ? '' : (0, (0, parcelRequire("dCJrM")).makeValueReadable)(name, 'ordinal', useUTC);
                var valueTypeOption = fragment.valueType;
                var readableValueList = noValue ? [] : (0, (0, parcelRequire("bahqM")).isArray)(value) ? (0, (0, parcelRequire("bahqM")).map)(value, function(val, idx) {
                    return (0, (0, parcelRequire("dCJrM")).makeValueReadable)(val, (0, (0, parcelRequire("bahqM")).isArray)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
                }) : [
                    (0, (0, parcelRequire("dCJrM")).makeValueReadable)(value, (0, (0, parcelRequire("bahqM")).isArray)(valueTypeOption) ? valueTypeOption[0] : valueTypeOption, useUTC)
                ];
                var valueAlignRight = !noMarker || !noName;
                var valueCloseToMarker = !noMarker && noName;
                var _a = $de4f5bb7bbbcf45e$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
                return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? '' : $de4f5bb7bbbcf45e$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $de4f5bb7bbbcf45e$var$wrapBlockHTML((noMarker ? '' : markerStr) + (noName ? '' : $de4f5bb7bbbcf45e$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $de4f5bb7bbbcf45e$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
            }
        }
    };
    function $de4f5bb7bbbcf45e$var$buildSubBlocks(ctx, fragment, topMarginForOuterGap, tooltipTextStyle) {
        var subMarkupTextList = [];
        var subBlocks = fragment.blocks || [];
        (0, (0, parcelRequire("bahqM")).assert)(!subBlocks || (0, (0, parcelRequire("bahqM")).isArray)(subBlocks));
        subBlocks = subBlocks || [];
        var orderMode = ctx.orderMode;
        if (fragment.sortBlocks && orderMode) {
            subBlocks = subBlocks.slice();
            var orderMap = {
                valueAsc: 'asc',
                valueDesc: 'desc'
            };
            if ((0, (0, parcelRequire("bahqM")).hasOwn)(orderMap, orderMode)) {
                var comparator_1 = new (0, (0, parcelRequire("2G90t")).SortOrderComparator)(orderMap[orderMode], null);
                subBlocks.sort(function(a, b) {
                    return comparator_1.evaluate(a.sortParam, b.sortParam);
                });
            } else if (orderMode === 'seriesDesc') subBlocks.reverse();
        }
        var gaps = $de4f5bb7bbbcf45e$var$getGap(fragment);
        (0, (0, parcelRequire("bahqM")).each)(subBlocks, function(subBlock, idx) {
            var subMarkupText = $de4f5bb7bbbcf45e$var$getBuilder(subBlock).build(ctx, subBlock, idx > 0 ? gaps.html : 0, tooltipTextStyle);
            subMarkupText != null && subMarkupTextList.push(subMarkupText);
        });
        if (!subMarkupTextList.length) return;
        return ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $de4f5bb7bbbcf45e$var$wrapBlockHTML(subMarkupTextList.join(''), topMarginForOuterGap);
    }
    function $de4f5bb7bbbcf45e$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
        if (!fragment) return;
        var builder = $de4f5bb7bbbcf45e$var$getBuilder(fragment);
        builder.planLayout(fragment);
        var ctx = {
            useUTC: useUTC,
            renderMode: renderMode,
            orderMode: orderMode,
            markupStyleCreator: markupStyleCreator
        };
        return builder.build(ctx, fragment, 0, toolTipTextStyle);
    }
    function $de4f5bb7bbbcf45e$var$getGap(fragment) {
        var gapLevelBetweenSubBlocks = fragment.__gapLevelBetweenSubBlocks;
        return {
            html: $de4f5bb7bbbcf45e$var$HTML_GAPS[gapLevelBetweenSubBlocks],
            richText: $de4f5bb7bbbcf45e$var$RICH_TEXT_GAPS[gapLevelBetweenSubBlocks]
        };
    }
    function $de4f5bb7bbbcf45e$var$wrapBlockHTML(encodedContent, topGap) {
        var clearfix = '<div style="clear:both"></div>';
        var marginCSS = "margin: " + topGap + "px 0 0";
        return "<div style=\"" + marginCSS + ";" + $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodedContent + clearfix + '</div>';
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineNameHTML(name, leftHasMarker, style) {
        var marginCss = leftHasMarker ? 'margin-left:2px' : '';
        return "<span style=\"" + style + ";" + marginCss + "\">" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(name) + '</span>';
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
        var paddingStr = valueCloseToMarker ? '10px' : '20px';
        var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
        return "<span style=\"" + alignCSS + ";" + style + "\">" + (0, (0, parcelRequire("bahqM")).map)(valueList, function(value) {
            return (0, (0, parcelRequire("dCJrM")).encodeHTML)(value);
        }).join('&nbsp;&nbsp;') + '</span>';
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, name, style) {
        return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineValueRichText(ctx, valueList, alignRight, valueCloseToMarker, style) {
        var styles = [
            style
        ];
        var paddingLeft = valueCloseToMarker ? 10 : 20;
        alignRight && styles.push({
            padding: [
                0,
                0,
                0,
                paddingLeft
            ],
            align: 'right'
        });
        return ctx.markupStyleCreator.wrapRichTextStyle(valueList.join('  '), styles);
    }
    function $de4f5bb7bbbcf45e$export$ea15628039c0fa93(series, dataIndex) {
        var style = series.getData().getItemVisual(dataIndex, 'style');
        var color = style[series.visualDrawType];
        return (0, (0, parcelRequire("dCJrM")).convertToColorString)(color);
    }
    function $de4f5bb7bbbcf45e$export$3048212c802df496(model, renderMode) {
        var padding = model.get('padding');
        return padding != null ? padding : renderMode === 'richText' ? [
            8,
            10
        ] : 10;
    }
    var $de4f5bb7bbbcf45e$export$2fba3afbcdcf3e18 = function() {
        function TooltipMarkupStyleCreator() {
            this.richTextStyles = {};
            this._nextStyleNameId = (0, (0, parcelRequire("jmSNG")).getRandomIdBase)();
        }
        TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
            return '__EC_aUTo_' + this._nextStyleNameId++;
        };
        TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
            var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
            var marker = (0, (0, parcelRequire("dCJrM")).getTooltipMarker)({
                color: colorStr,
                type: markerType,
                renderMode: renderMode,
                markerId: markerId
            });
            if ((0, (0, parcelRequire("bahqM")).isString)(marker)) return marker;
            else {
                this.richTextStyles[markerId] = marker.style;
                return marker.content;
            }
        };
        TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
            var finalStl = {};
            if ((0, (0, parcelRequire("bahqM")).isArray)(styles)) (0, (0, parcelRequire("bahqM")).each)(styles, function(stl) {
                return (0, (0, parcelRequire("bahqM")).extend)(finalStl, stl);
            });
            else (0, (0, parcelRequire("bahqM")).extend)(finalStl, styles);
            var styleName = this._generateStyleName();
            this.richTextStyles[styleName] = finalStl;
            return "{" + styleName + "|" + text + "}";
        };
        return TooltipMarkupStyleCreator;
    }();
});
parcelRegister("47isN", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$2ff6234e7db26f51$export$4b3e715f166fdd78);
    var $jvYs5;
    var $cDBtZ;
    var $5xgWc;
    var $7jcIW;
    function $2ff6234e7db26f51$export$4b3e715f166fdd78(registers) {
        registers.registerChartView((0, (0, parcelRequire("cDBtZ")).default));
        registers.registerSeriesModel((0, (0, parcelRequire("jvYs5")).default));
        registers.registerLayout((0, (0, parcelRequire("5xgWc")).default)('line', true));
        registers.registerVisual({
            seriesType: 'line',
            reset: function(seriesModel) {
                var data = seriesModel.getData();
                var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
                if (lineStyle && !lineStyle.stroke) lineStyle.stroke = data.getVisual('style').fill;
                data.setVisual('legendLineStyle', lineStyle);
            }
        });
        registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, (0, parcelRequire("7jcIW")).default)('line'));
    }
});
parcelRegister("jvYs5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e34fce1556fedd5e$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bAY5l;
    var $1O7Ua;
    var $7yklO;
    var $4KVOr;
    var $e34fce1556fedd5e$var$LineSeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LineSeriesModel, _super);
        function LineSeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = LineSeriesModel.type;
            _this.hasSymbolVisual = true;
            return _this;
        }
        LineSeriesModel.prototype.getInitialData = function(option) {
            var coordSys;
            return (0, (0, parcelRequire("bAY5l")).default)(null, this, {
                useEncodeDefaulter: true
            });
        };
        LineSeriesModel.prototype.getLegendIcon = function(opt) {
            var group = new (0, (0, parcelRequire("4KVOr")).default)();
            var line = (0, (0, parcelRequire("7yklO")).createSymbol)('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
            group.add(line);
            line.setStyle(opt.lineStyle);
            var visualType = this.getData().getVisual('symbol');
            var visualRotate = this.getData().getVisual('symbolRotate');
            var symbolType = visualType === 'none' ? 'circle' : visualType;
            var size = opt.itemHeight * 0.8;
            var symbol = (0, (0, parcelRequire("7yklO")).createSymbol)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
            group.add(symbol);
            symbol.setStyle(opt.itemStyle);
            var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
            symbol.rotation = symbolRotate * Math.PI / 180;
            symbol.setOrigin([
                opt.itemWidth / 2,
                opt.itemHeight / 2
            ]);
            if (symbolType.indexOf('empty') > -1) {
                symbol.style.stroke = symbol.style.fill;
                symbol.style.fill = '#fff';
                symbol.style.lineWidth = 2;
            }
            return group;
        };
        LineSeriesModel.type = 'series.line';
        LineSeriesModel.dependencies = [
            'grid',
            'polar'
        ];
        LineSeriesModel.defaultOption = {
            zlevel: 0,
            z: 3,
            coordinateSystem: 'cartesian2d',
            legendHoverLink: true,
            clip: true,
            label: {
                position: 'top'
            },
            endLabel: {
                show: false,
                valueAnimation: true,
                distance: 8
            },
            lineStyle: {
                width: 2,
                type: 'solid'
            },
            emphasis: {
                scale: true,
                lineStyle: {
                    width: 'bolder'
                }
            },
            step: false,
            smooth: false,
            smoothMonotone: null,
            symbol: 'emptyCircle',
            symbolSize: 4,
            symbolRotate: null,
            showSymbol: true,
            showAllSymbol: 'auto',
            connectNulls: false,
            sampling: 'none',
            animationEasing: 'linear',
            progressive: 0,
            hoverLayerThreshold: Infinity,
            universalTransition: {
                divideShape: 'clone'
            }
        };
        return LineSeriesModel;
    }((0, (0, parcelRequire("1O7Ua")).default));
    var $e34fce1556fedd5e$export$2e2bcd8739ae039 = $e34fce1556fedd5e$var$LineSeriesModel;
});
parcelRegister("cDBtZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$933633d411d7f701$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $5DXGq;
    var $lUzII;
    var $7HTYE;
    var $4KVOr;
    var $eYgMC;
    var $9J7f8;
    var $4gEFv;
    parcelRequire("fHITF");
    var $eYgMC;
    var $eaKsF;
    var $jconq;
    var $loerw;
    var $JBb7Y;
    var $5fMzf;
    var $40dMe;
    var $fIXXx;
    var $gvLUt;
    var $5MLZz;
    var $7QjoM;
    var $8fK8Y;
    var $dCJrM;
    var $d6udH;
    function $933633d411d7f701$var$isPointsSame(points1, points2) {
        if (points1.length !== points2.length) return;
        for(var i = 0; i < points1.length; i++){
            if (points1[i] !== points2[i]) return;
        }
        return true;
    }
    function $933633d411d7f701$var$bboxFromPoints(points) {
        var minX = Infinity;
        var minY = Infinity;
        var maxX = -Infinity;
        var maxY = -Infinity;
        for(var i = 0; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (!isNaN(x)) {
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
            }
            if (!isNaN(y)) {
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
        }
        return [
            [
                minX,
                minY
            ],
            [
                maxX,
                maxY
            ]
        ];
    }
    function $933633d411d7f701$var$getBoundingDiff(points1, points2) {
        var _a = $933633d411d7f701$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
        var _b = $933633d411d7f701$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1];
        return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
    }
    function $933633d411d7f701$var$getSmooth(smooth) {
        return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
    }
    function $933633d411d7f701$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
        if (!dataCoordInfo.valueDim) return [];
        var len = data.count();
        var points = (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(len * 2);
        for(var idx = 0; idx < len; idx++){
            var pt = (0, (0, parcelRequire("JBb7Y")).getStackedOnPoint)(dataCoordInfo, coordSys, data, idx);
            points[idx * 2] = pt[0];
            points[idx * 2 + 1] = pt[1];
        }
        return points;
    }
    function $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, stepTurnAt) {
        var baseAxis = coordSys.getBaseAxis();
        var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
        var stepPoints = [];
        var i = 0;
        var stepPt = [];
        var pt = [];
        var nextPt = [];
        for(; i < points.length - 2; i += 2){
            nextPt[0] = points[i + 2];
            nextPt[1] = points[i + 3];
            pt[0] = points[i];
            pt[1] = points[i + 1];
            stepPoints.push(pt[0], pt[1]);
            switch(stepTurnAt){
                case 'end':
                    stepPt[baseIndex] = nextPt[baseIndex];
                    stepPt[1 - baseIndex] = pt[1 - baseIndex];
                    stepPoints.push(stepPt[0], stepPt[1]);
                    break;
                case 'middle':
                    var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                    var stepPt2 = [];
                    stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                    stepPt[1 - baseIndex] = pt[1 - baseIndex];
                    stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                    stepPoints.push(stepPt[0], stepPt[1]);
                    stepPoints.push(stepPt2[0], stepPt2[1]);
                    break;
                default:
                    stepPt[baseIndex] = pt[baseIndex];
                    stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                    stepPoints.push(stepPt[0], stepPt[1]);
            }
        }
        stepPoints.push(points[i++], points[i++]);
        return stepPoints;
    }
    function $933633d411d7f701$var$clipColorStops(colorStops, maxSize) {
        var newColorStops = [];
        var len = colorStops.length;
        var prevOutOfRangeColorStop;
        var prevInRangeColorStop;
        function lerpStop(stop0, stop1, clippedCoord) {
            var coord0 = stop0.coord;
            var p = (clippedCoord - coord0) / (stop1.coord - coord0);
            var color = (0, (0, parcelRequire("d6udH")).lerp)(p, [
                stop0.color,
                stop1.color
            ]);
            return {
                coord: clippedCoord,
                color: color
            };
        }
        for(var i = 0; i < len; i++){
            var stop_1 = colorStops[i];
            var coord = stop_1.coord;
            if (coord < 0) prevOutOfRangeColorStop = stop_1;
            else if (coord > maxSize) {
                if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
                break;
            } else {
                if (prevOutOfRangeColorStop) {
                    newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0));
                    prevOutOfRangeColorStop = null;
                }
                newColorStops.push(stop_1);
                prevInRangeColorStop = stop_1;
            }
        }
        return newColorStops;
    }
    function $933633d411d7f701$var$getVisualGradient(data, coordSys, api) {
        var visualMetaList = data.getVisual('visualMeta');
        if (!visualMetaList || !visualMetaList.length || !data.count()) return;
        if (coordSys.type !== 'cartesian2d') return;
        var coordDim;
        var visualMeta;
        for(var i = visualMetaList.length - 1; i >= 0; i--){
            var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
            coordDim = dimInfo && dimInfo.coordDim;
            if (coordDim === 'x' || coordDim === 'y') {
                visualMeta = visualMetaList[i];
                break;
            }
        }
        if (!visualMeta) return;
        var axis = coordSys.getAxis(coordDim);
        var colorStops = (0, parcelRequire("bahqM")).map(visualMeta.stops, function(stop) {
            return {
                coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
                color: stop.color
            };
        });
        var stopLen = colorStops.length;
        var outerColors = visualMeta.outerColors.slice();
        if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
            colorStops.reverse();
            outerColors.reverse();
        }
        var colorStopsInRange = $933633d411d7f701$var$clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
        var inRangeStopLen = colorStopsInRange.length;
        if (!inRangeStopLen && stopLen) return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
        var tinyExtent = 0;
        var minCoord = colorStopsInRange[0].coord - tinyExtent;
        var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
        var coordSpan = maxCoord - minCoord;
        if (coordSpan < 1e-3) return 'transparent';
        (0, parcelRequire("bahqM")).each(colorStopsInRange, function(stop) {
            stop.offset = (stop.coord - minCoord) / coordSpan;
        });
        colorStopsInRange.push({
            offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
            color: outerColors[1] || 'transparent'
        });
        colorStopsInRange.unshift({
            offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
            color: outerColors[0] || 'transparent'
        });
        var gradient = new (0, parcelRequire("9J7f8")).default(0, 0, 0, 0, colorStopsInRange, true);
        gradient[coordDim] = minCoord;
        gradient[coordDim + '2'] = maxCoord;
        return gradient;
    }
    function $933633d411d7f701$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
        var showAllSymbol = seriesModel.get('showAllSymbol');
        var isAuto = showAllSymbol === 'auto';
        if (showAllSymbol && !isAuto) return;
        var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
        if (!categoryAxis) return;
        if (isAuto && $933633d411d7f701$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
        var categoryDataDim = data.mapDimension(categoryAxis.dim);
        var labelMap = {};
        (0, parcelRequire("bahqM")).each(categoryAxis.getViewLabels(), function(labelItem) {
            var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
            labelMap[ordinalNumber] = 1;
        });
        return function(dataIndex) {
            return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
        };
    }
    function $933633d411d7f701$var$canShowAllSymbolForCategory(categoryAxis, data) {
        var axisExtent = categoryAxis.getExtent();
        var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
        isNaN(availSize) && (availSize = 0);
        var dataLen = data.count();
        var step = Math.max(1, Math.round(dataLen / 5));
        for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
            if ((0, (0, parcelRequire("lUzII")).default).getSymbolSize(data, dataIndex)[categoryAxis.isHorizontal() ? 1 : 0] * 1.5 > availSize) return false;
        }
        return true;
    }
    function $933633d411d7f701$var$isPointNull(x, y) {
        return isNaN(x) || isNaN(y);
    }
    function $933633d411d7f701$var$getLastIndexNotNull(points) {
        var len = points.length / 2;
        for(; len > 0; len--){
            if (!$933633d411d7f701$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
        }
        return len - 1;
    }
    function $933633d411d7f701$var$getPointAtIndex(points, idx) {
        return [
            points[idx * 2],
            points[idx * 2 + 1]
        ];
    }
    function $933633d411d7f701$var$getIndexRange(points, xOrY, dim) {
        var len = points.length / 2;
        var dimIdx = dim === 'x' ? 0 : 1;
        var a;
        var b;
        var prevIndex = 0;
        var nextIndex = -1;
        for(var i = 0; i < len; i++){
            b = points[i * 2 + dimIdx];
            if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
            if (i === 0) {
                a = b;
                continue;
            }
            if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
                nextIndex = i;
                break;
            }
            prevIndex = i;
            a = b;
        }
        return {
            range: [
                prevIndex,
                nextIndex
            ],
            t: (xOrY - a) / (b - a)
        };
    }
    function $933633d411d7f701$var$anyStateShowEndLabel(seriesModel) {
        if (seriesModel.get([
            'endLabel',
            'show'
        ])) return true;
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            if (seriesModel.get([
                (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i],
                'endLabel',
                'show'
            ])) return true;
        }
        return false;
    }
    function $933633d411d7f701$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
        if ((0, (0, parcelRequire("40dMe")).isCoordinateSystemType)(coordSys, 'cartesian2d')) {
            var endLabelModel_1 = seriesModel.getModel('endLabel');
            var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
            var data_1 = seriesModel.getData();
            var labelAnimationRecord_1 = {
                lastFrameIndex: 0
            };
            var during = $933633d411d7f701$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
                lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
            } : null;
            var isHorizontal = coordSys.getBaseAxis().isHorizontal();
            var clipPath = (0, (0, parcelRequire("5fMzf")).createGridClipPath)(coordSys, hasAnimation, seriesModel, function() {
                var endLabel = lineView._endLabel;
                if (endLabel && hasAnimation) {
                    if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                        x: labelAnimationRecord_1.originalX,
                        y: labelAnimationRecord_1.originalY
                    });
                }
            }, during);
            if (!seriesModel.get('clip', true)) {
                var rectShape = clipPath.shape;
                var expandSize = Math.max(rectShape.width, rectShape.height);
                if (isHorizontal) {
                    rectShape.y -= expandSize;
                    rectShape.height += expandSize * 2;
                } else {
                    rectShape.x -= expandSize;
                    rectShape.width += expandSize * 2;
                }
            }
            if (during) during(1, clipPath);
            return clipPath;
        } else return (0, (0, parcelRequire("5fMzf")).createPolarClipPath)(coordSys, hasAnimation, seriesModel);
    }
    function $933633d411d7f701$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
        var baseAxis = coordSys.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isBaseInversed = baseAxis.inverse;
        var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
        var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
        return {
            normal: {
                align: endLabelModel.get('align') || align,
                verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
            }
        };
    }
    var $933633d411d7f701$var$LineView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LineView, _super);
        function LineView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        LineView.prototype.init = function() {
            var lineGroup = new (0, parcelRequire("4KVOr")).default();
            var symbolDraw = new (0, (0, parcelRequire("5DXGq")).default)();
            this.group.add(symbolDraw.group);
            this._symbolDraw = symbolDraw;
            this._lineGroup = lineGroup;
        };
        LineView.prototype.render = function(seriesModel, ecModel, api) {
            var _this = this;
            var coordSys = seriesModel.coordinateSystem;
            var group = this.group;
            var data = seriesModel.getData();
            var lineStyleModel = seriesModel.getModel('lineStyle');
            var areaStyleModel = seriesModel.getModel('areaStyle');
            var points = data.getLayout('points') || [];
            var isCoordSysPolar = coordSys.type === 'polar';
            var prevCoordSys = this._coordSys;
            var symbolDraw = this._symbolDraw;
            var polyline = this._polyline;
            var polygon = this._polygon;
            var lineGroup = this._lineGroup;
            var hasAnimation = seriesModel.get('animation');
            var isAreaChart = !areaStyleModel.isEmpty();
            var valueOrigin = areaStyleModel.get('origin');
            var dataCoordInfo = (0, (0, parcelRequire("JBb7Y")).prepareDataCoordInfo)(coordSys, data, valueOrigin);
            var stackedOnPoints = isAreaChart && $933633d411d7f701$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
            var showSymbol = seriesModel.get('showSymbol');
            var isIgnoreFunc = showSymbol && !isCoordSysPolar && $933633d411d7f701$var$getIsIgnoreFunc(seriesModel, data, coordSys);
            var oldData = this._data;
            oldData && oldData.eachItemGraphicEl(function(el, idx) {
                if (el.__temp) {
                    group.remove(el);
                    oldData.setItemGraphicEl(idx, null);
                }
            });
            if (!showSymbol) symbolDraw.remove();
            group.add(lineGroup);
            var step = !isCoordSysPolar ? seriesModel.get('step') : false;
            var clipShapeForSymbol;
            if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
                clipShapeForSymbol = coordSys.getArea();
                if (clipShapeForSymbol.width != null) {
                    clipShapeForSymbol.x -= 0.1;
                    clipShapeForSymbol.y -= 0.1;
                    clipShapeForSymbol.width += 0.2;
                    clipShapeForSymbol.height += 0.2;
                } else if (clipShapeForSymbol.r0) {
                    clipShapeForSymbol.r0 -= 0.5;
                    clipShapeForSymbol.r += 0.5;
                }
            }
            this._clipShapeForSymbol = clipShapeForSymbol;
            var visualColor = $933633d411d7f701$var$getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')];
            if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
                showSymbol && symbolDraw.updateData(data, {
                    isIgnore: isIgnoreFunc,
                    clipShape: clipShapeForSymbol,
                    disableAnimation: true,
                    getSymbolPoint: function(idx) {
                        return [
                            points[idx * 2],
                            points[idx * 2 + 1]
                        ];
                    }
                });
                hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
                if (step) {
                    points = $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, step);
                    if (stackedOnPoints) stackedOnPoints = $933633d411d7f701$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
                }
                polyline = this._newPolyline(points);
                if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
                if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, (0, parcelRequire("dCJrM")).convertToColorString)(visualColor));
                lineGroup.setClipPath($933633d411d7f701$var$createLineClipPath(this, coordSys, true, seriesModel));
            } else {
                if (isAreaChart && !polygon) polygon = this._newPolygon(points, stackedOnPoints);
                else if (polygon && !isAreaChart) {
                    lineGroup.remove(polygon);
                    polygon = this._polygon = null;
                }
                if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, (0, parcelRequire("dCJrM")).convertToColorString)(visualColor));
                var oldClipPath = lineGroup.getClipPath();
                if (oldClipPath) {
                    var newClipPath = $933633d411d7f701$var$createLineClipPath(this, coordSys, false, seriesModel);
                    (0, parcelRequire("eYgMC")).initProps(oldClipPath, {
                        shape: newClipPath.shape
                    }, seriesModel);
                } else lineGroup.setClipPath($933633d411d7f701$var$createLineClipPath(this, coordSys, true, seriesModel));
                showSymbol && symbolDraw.updateData(data, {
                    isIgnore: isIgnoreFunc,
                    clipShape: clipShapeForSymbol,
                    disableAnimation: true,
                    getSymbolPoint: function(idx) {
                        return [
                            points[idx * 2],
                            points[idx * 2 + 1]
                        ];
                    }
                });
                if (!$933633d411d7f701$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$933633d411d7f701$var$isPointsSame(this._points, points)) {
                    if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
                    else {
                        if (step) {
                            points = $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, step);
                            if (stackedOnPoints) stackedOnPoints = $933633d411d7f701$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
                        }
                        polyline.setShape({
                            points: points
                        });
                        polygon && polygon.setShape({
                            points: points,
                            stackedOnPoints: stackedOnPoints
                        });
                    }
                }
            }
            var focus = seriesModel.get([
                'emphasis',
                'focus'
            ]);
            var blurScope = seriesModel.get([
                'emphasis',
                'blurScope'
            ]);
            polyline.useStyle((0, parcelRequire("bahqM")).defaults(lineStyleModel.getLineStyle(), {
                fill: 'none',
                stroke: visualColor,
                lineJoin: 'bevel'
            }));
            (0, (0, parcelRequire("fIXXx")).setStatesStylesFromModel)(polyline, seriesModel, 'lineStyle');
            if (polyline.style.lineWidth > 0 && seriesModel.get([
                'emphasis',
                'lineStyle',
                'width'
            ]) === 'bolder') {
                var emphasisLineStyle = polyline.getState('emphasis').style;
                emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
            }
            (0, (0, parcelRequire("7QjoM")).getECData)(polyline).seriesIndex = seriesModel.seriesIndex;
            (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(polyline, focus, blurScope);
            var smooth = $933633d411d7f701$var$getSmooth(seriesModel.get('smooth'));
            var smoothMonotone = seriesModel.get('smoothMonotone');
            var connectNulls = seriesModel.get('connectNulls');
            polyline.setShape({
                smooth: smooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            if (polygon) {
                var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
                var stackedOnSmooth = 0;
                polygon.useStyle((0, parcelRequire("bahqM")).defaults(areaStyleModel.getAreaStyle(), {
                    fill: visualColor,
                    opacity: 0.7,
                    lineJoin: 'bevel',
                    decal: data.getVisual('style').decal
                }));
                if (stackedOnSeries) stackedOnSmooth = $933633d411d7f701$var$getSmooth(stackedOnSeries.get('smooth'));
                polygon.setShape({
                    smooth: smooth,
                    stackedOnSmooth: stackedOnSmooth,
                    smoothMonotone: smoothMonotone,
                    connectNulls: connectNulls
                });
                (0, (0, parcelRequire("fIXXx")).setStatesStylesFromModel)(polygon, seriesModel, 'areaStyle');
                (0, (0, parcelRequire("7QjoM")).getECData)(polygon).seriesIndex = seriesModel.seriesIndex;
                (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(polygon, focus, blurScope);
            }
            var changePolyState = function(toState) {
                _this._changePolyState(toState);
            };
            data.eachItemGraphicEl(function(el) {
                el && (el.onHoverStateChange = changePolyState);
            });
            this._polyline.onHoverStateChange = changePolyState;
            this._data = data;
            this._coordSys = coordSys;
            this._stackedOnPoints = stackedOnPoints;
            this._points = points;
            this._step = step;
            this._valueOrigin = valueOrigin;
        };
        LineView.prototype.dispose = function() {};
        LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
            var data = seriesModel.getData();
            var dataIndex = (0, parcelRequire("eaKsF")).queryDataIndex(data, payload);
            this._changePolyState('emphasis');
            if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
                var points = data.getLayout('points');
                var symbol = data.getItemGraphicEl(dataIndex);
                if (!symbol) {
                    var x = points[dataIndex * 2];
                    var y = points[dataIndex * 2 + 1];
                    if (isNaN(x) || isNaN(y)) return;
                    if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                    var zlevel = seriesModel.get('zlevel');
                    var z = seriesModel.get('z');
                    symbol = new (0, (0, parcelRequire("lUzII")).default)(data, dataIndex);
                    symbol.x = x;
                    symbol.y = y;
                    symbol.setZ(zlevel, z);
                    var symbolLabel = symbol.getSymbolPath().getTextContent();
                    if (symbolLabel) {
                        symbolLabel.zlevel = zlevel;
                        symbolLabel.z = z;
                        symbolLabel.z2 = this._polyline.z2 + 1;
                    }
                    symbol.__temp = true;
                    data.setItemGraphicEl(dataIndex, symbol);
                    symbol.stopSymbolAnimation(true);
                    this.group.add(symbol);
                }
                symbol.highlight();
            } else (0, (0, parcelRequire("loerw")).default).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
        };
        LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
            var data = seriesModel.getData();
            var dataIndex = (0, parcelRequire("eaKsF")).queryDataIndex(data, payload);
            this._changePolyState('normal');
            if (dataIndex != null && dataIndex >= 0) {
                var symbol = data.getItemGraphicEl(dataIndex);
                if (symbol) {
                    if (symbol.__temp) {
                        data.setItemGraphicEl(dataIndex, null);
                        this.group.remove(symbol);
                    } else symbol.downplay();
                }
            } else (0, (0, parcelRequire("loerw")).default).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
        };
        LineView.prototype._changePolyState = function(toState) {
            var polygon = this._polygon;
            (0, (0, parcelRequire("fIXXx")).setStatesFlag)(this._polyline, toState);
            polygon && (0, (0, parcelRequire("fIXXx")).setStatesFlag)(polygon, toState);
        };
        LineView.prototype._newPolyline = function(points) {
            var polyline = this._polyline;
            if (polyline) this._lineGroup.remove(polyline);
            polyline = new (0, (0, parcelRequire("jconq")).ECPolyline)({
                shape: {
                    points: points
                },
                segmentIgnoreThreshold: 2,
                z2: 10
            });
            this._lineGroup.add(polyline);
            this._polyline = polyline;
            return polyline;
        };
        LineView.prototype._newPolygon = function(points, stackedOnPoints) {
            var polygon = this._polygon;
            if (polygon) this._lineGroup.remove(polygon);
            polygon = new (0, (0, parcelRequire("jconq")).ECPolygon)({
                shape: {
                    points: points,
                    stackedOnPoints: stackedOnPoints
                },
                segmentIgnoreThreshold: 2
            });
            this._lineGroup.add(polygon);
            this._polygon = polygon;
            return polygon;
        };
        LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
            var isHorizontalOrRadial;
            var isCoordSysPolar;
            var baseAxis = coordSys.getBaseAxis();
            var isAxisInverse = baseAxis.inverse;
            if (coordSys.type === 'cartesian2d') {
                isHorizontalOrRadial = baseAxis.isHorizontal();
                isCoordSysPolar = false;
            } else if (coordSys.type === 'polar') {
                isHorizontalOrRadial = baseAxis.dim === 'angle';
                isCoordSysPolar = true;
            }
            var seriesModel = data.hostModel;
            var seriesDuration = seriesModel.get('animationDuration');
            if (typeof seriesDuration === 'function') seriesDuration = seriesDuration(null);
            var seriesDalay = seriesModel.get('animationDelay') || 0;
            var seriesDalayValue = typeof seriesDalay === 'function' ? seriesDalay(null) : seriesDalay;
            data.eachItemGraphicEl(function(symbol, idx) {
                var el = symbol;
                if (el) {
                    var point = [
                        symbol.x,
                        symbol.y
                    ];
                    var start = void 0;
                    var end = void 0;
                    var current = void 0;
                    if (clipShape) {
                        if (isCoordSysPolar) {
                            var polarClip = clipShape;
                            var coord = coordSys.pointToCoord(point);
                            if (isHorizontalOrRadial) {
                                start = polarClip.startAngle;
                                end = polarClip.endAngle;
                                current = -coord[1] / 180 * Math.PI;
                            } else {
                                start = polarClip.r0;
                                end = polarClip.r;
                                current = coord[0];
                            }
                        } else {
                            var gridClip = clipShape;
                            if (isHorizontalOrRadial) {
                                start = gridClip.x;
                                end = gridClip.x + gridClip.width;
                                current = symbol.x;
                            } else {
                                start = gridClip.y + gridClip.height;
                                end = gridClip.y;
                                current = symbol.y;
                            }
                        }
                    }
                    var ratio = end === start ? 0 : (current - start) / (end - start);
                    if (isAxisInverse) ratio = 1 - ratio;
                    var delay = typeof seriesDalay === 'function' ? seriesDalay(idx) : seriesDuration * ratio + seriesDalayValue;
                    var symbolPath = el.getSymbolPath();
                    var text = symbolPath.getTextContent();
                    el.attr({
                        scaleX: 0,
                        scaleY: 0
                    });
                    el.animateTo({
                        scaleX: 1,
                        scaleY: 1
                    }, {
                        duration: 200,
                        setToFinal: true,
                        delay: delay
                    });
                    if (text) text.animateFrom({
                        style: {
                            opacity: 0
                        }
                    }, {
                        duration: 300,
                        delay: delay
                    });
                    symbolPath.disableLabelAnimation = true;
                }
            });
        };
        LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
            var endLabelModel = seriesModel.getModel('endLabel');
            if ($933633d411d7f701$var$anyStateShowEndLabel(seriesModel)) {
                var data_2 = seriesModel.getData();
                var polyline = this._polyline;
                var endLabel = this._endLabel;
                if (!endLabel) {
                    endLabel = this._endLabel = new (0, parcelRequire("4gEFv")).default({
                        z2: 200
                    });
                    endLabel.ignoreClip = true;
                    polyline.setTextContent(this._endLabel);
                    polyline.disableLabelAnimation = true;
                }
                var dataIndex = $933633d411d7f701$var$getLastIndexNotNull(data_2.getLayout('points'));
                if (dataIndex >= 0) {
                    (0, (0, parcelRequire("gvLUt")).setLabelStyle)(polyline, (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(seriesModel, 'endLabel'), {
                        inheritColor: inheritColor,
                        labelFetcher: seriesModel,
                        labelDataIndex: dataIndex,
                        defaultText: function(dataIndex, opt, interpolatedValue) {
                            return interpolatedValue != null ? (0, (0, parcelRequire("5MLZz")).getDefaultInterpolatedLabel)(data_2, interpolatedValue) : (0, (0, parcelRequire("5MLZz")).getDefaultLabel)(data_2, dataIndex);
                        },
                        enableTextSetter: true
                    }, $933633d411d7f701$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                    polyline.textConfig.position = null;
                }
            } else if (this._endLabel) {
                this._polyline.removeTextContent();
                this._endLabel = null;
            }
        };
        LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
            var endLabel = this._endLabel;
            var polyline = this._polyline;
            if (endLabel) {
                if (percent < 1 && animationRecord.originalX == null) {
                    animationRecord.originalX = endLabel.x;
                    animationRecord.originalY = endLabel.y;
                }
                var points = data.getLayout('points');
                var seriesModel = data.hostModel;
                var connectNulls = seriesModel.get('connectNulls');
                var precision = endLabelModel.get('precision');
                var distance = endLabelModel.get('distance') || 0;
                var baseAxis = coordSys.getBaseAxis();
                var isHorizontal = baseAxis.isHorizontal();
                var isBaseInversed = baseAxis.inverse;
                var clipShape = clipRect.shape;
                var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
                var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
                var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
                var dim = isHorizontal ? 'x' : 'y';
                var dataIndexRange = $933633d411d7f701$var$getIndexRange(points, xOrY, dim);
                var indices = dataIndexRange.range;
                var diff = indices[1] - indices[0];
                var value = void 0;
                if (diff >= 1) {
                    if (diff > 1 && !connectNulls) {
                        var pt = $933633d411d7f701$var$getPointAtIndex(points, indices[0]);
                        endLabel.attr({
                            x: pt[0] + distanceX,
                            y: pt[1] + distanceY
                        });
                        valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                    } else {
                        var pt = polyline.getPointOn(xOrY, dim);
                        pt && endLabel.attr({
                            x: pt[0] + distanceX,
                            y: pt[1] + distanceY
                        });
                        var startValue = seriesModel.getRawValue(indices[0]);
                        var endValue = seriesModel.getRawValue(indices[1]);
                        valueAnimation && (value = (0, parcelRequire("eaKsF")).interpolateRawValues(data, precision, startValue, endValue, dataIndexRange.t));
                    }
                    animationRecord.lastFrameIndex = indices[0];
                } else {
                    var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                    var pt = $933633d411d7f701$var$getPointAtIndex(points, idx);
                    valueAnimation && (value = seriesModel.getRawValue(idx));
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                }
                if (valueAnimation) (0, (0, parcelRequire("gvLUt")).labelInner)(endLabel).setLabelText(value);
            }
        };
        LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin) {
            var polyline = this._polyline;
            var polygon = this._polygon;
            var seriesModel = data.hostModel;
            var diff = (0, (0, parcelRequire("7HTYE")).default)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
            var current = diff.current;
            var stackedOnCurrent = diff.stackedOnCurrent;
            var next = diff.next;
            var stackedOnNext = diff.stackedOnNext;
            if (step) {
                current = $933633d411d7f701$var$turnPointsIntoStep(diff.current, coordSys, step);
                stackedOnCurrent = $933633d411d7f701$var$turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
                next = $933633d411d7f701$var$turnPointsIntoStep(diff.next, coordSys, step);
                stackedOnNext = $933633d411d7f701$var$turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
            }
            if ($933633d411d7f701$var$getBoundingDiff(current, next) > 3000 || polygon && $933633d411d7f701$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
                polyline.stopAnimation();
                polyline.setShape({
                    points: next
                });
                if (polygon) {
                    polygon.stopAnimation();
                    polygon.setShape({
                        points: next,
                        stackedOnPoints: stackedOnNext
                    });
                }
                return;
            }
            polyline.shape.__points = diff.current;
            polyline.shape.points = current;
            var target = {
                shape: {
                    points: next
                }
            };
            if (diff.current !== current) target.shape.__points = diff.next;
            polyline.stopAnimation();
            (0, parcelRequire("eYgMC")).updateProps(polyline, target, seriesModel);
            if (polygon) {
                polygon.setShape({
                    points: current,
                    stackedOnPoints: stackedOnCurrent
                });
                polygon.stopAnimation();
                (0, parcelRequire("eYgMC")).updateProps(polygon, {
                    shape: {
                        stackedOnPoints: stackedOnNext
                    }
                }, seriesModel);
                if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
            }
            var updatedDataInfo = [];
            var diffStatus = diff.status;
            for(var i = 0; i < diffStatus.length; i++){
                var cmd = diffStatus[i].cmd;
                if (cmd === '=') {
                    var el = data.getItemGraphicEl(diffStatus[i].idx1);
                    if (el) updatedDataInfo.push({
                        el: el,
                        ptIdx: i
                    });
                }
            }
            if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
                polygon && polygon.dirtyShape();
                var points = polyline.shape.__points;
                for(var i = 0; i < updatedDataInfo.length; i++){
                    var el = updatedDataInfo[i].el;
                    var offset = updatedDataInfo[i].ptIdx * 2;
                    el.x = points[offset];
                    el.y = points[offset + 1];
                    el.markRedraw();
                }
            });
        };
        LineView.prototype.remove = function(ecModel) {
            var group = this.group;
            var oldData = this._data;
            this._lineGroup.removeAll();
            this._symbolDraw.remove(true);
            oldData && oldData.eachItemGraphicEl(function(el, idx) {
                if (el.__temp) {
                    group.remove(el);
                    oldData.setItemGraphicEl(idx, null);
                }
            });
            this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
        };
        LineView.type = 'line';
        return LineView;
    }((0, (0, parcelRequire("loerw")).default));
    var $933633d411d7f701$export$2e2bcd8739ae039 = $933633d411d7f701$var$LineView;
});
parcelRegister("7HTYE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59c7f87717a036e4$export$2e2bcd8739ae039);
    var $JBb7Y;
    var $8fK8Y;
    function $59c7f87717a036e4$var$diffData(oldData, newData) {
        var diffResult = [];
        newData.diff(oldData).add(function(idx) {
            diffResult.push({
                cmd: '+',
                idx: idx
            });
        }).update(function(newIdx, oldIdx) {
            diffResult.push({
                cmd: '=',
                idx: oldIdx,
                idx1: newIdx
            });
        }).remove(function(idx) {
            diffResult.push({
                cmd: '-',
                idx: idx
            });
        }).execute();
        return diffResult;
    }
    function $59c7f87717a036e4$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
        var diff = $59c7f87717a036e4$var$diffData(oldData, newData);
        var currPoints = [];
        var nextPoints = [];
        var currStackedPoints = [];
        var nextStackedPoints = [];
        var status = [];
        var sortedIndices = [];
        var rawIndices = [];
        var newDataOldCoordInfo = (0, (0, parcelRequire("JBb7Y")).prepareDataCoordInfo)(oldCoordSys, newData, oldValueOrigin);
        var oldPoints = oldData.getLayout('points') || [];
        var newPoints = newData.getLayout('points') || [];
        for(var i = 0; i < diff.length; i++){
            var diffItem = diff[i];
            var pointAdded = true;
            var oldIdx2 = void 0;
            var newIdx2 = void 0;
            switch(diffItem.cmd){
                case '=':
                    oldIdx2 = diffItem.idx * 2;
                    newIdx2 = diffItem.idx1 * 2;
                    var currentX = oldPoints[oldIdx2];
                    var currentY = oldPoints[oldIdx2 + 1];
                    var nextX = newPoints[newIdx2];
                    var nextY = newPoints[newIdx2 + 1];
                    if (isNaN(currentX) || isNaN(currentY)) {
                        currentX = nextX;
                        currentY = nextY;
                    }
                    currPoints.push(currentX, currentY);
                    nextPoints.push(nextX, nextY);
                    currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                    nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                    rawIndices.push(newData.getRawIndex(diffItem.idx1));
                    break;
                case '+':
                    var newIdx = diffItem.idx;
                    var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                    var oldPt = oldCoordSys.dataToPoint([
                        newData.get(newDataDimsForPoint[0], newIdx),
                        newData.get(newDataDimsForPoint[1], newIdx)
                    ]);
                    newIdx2 = newIdx * 2;
                    currPoints.push(oldPt[0], oldPt[1]);
                    nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                    var stackedOnPoint = (0, (0, parcelRequire("JBb7Y")).getStackedOnPoint)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                    currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                    nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                    rawIndices.push(newData.getRawIndex(newIdx));
                    break;
                case '-':
                    pointAdded = false;
            }
            if (pointAdded) {
                status.push(diffItem);
                sortedIndices.push(sortedIndices.length);
            }
        }
        sortedIndices.sort(function(a, b) {
            return rawIndices[a] - rawIndices[b];
        });
        var len = currPoints.length;
        var sortedCurrPoints = (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(len);
        var sortedNextPoints = (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(len);
        var sortedCurrStackedPoints = (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(len);
        var sortedNextStackedPoints = (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(len);
        var sortedStatus = [];
        for(var i = 0; i < sortedIndices.length; i++){
            var idx = sortedIndices[i];
            var i2 = i * 2;
            var idx2 = idx * 2;
            sortedCurrPoints[i2] = currPoints[idx2];
            sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
            sortedNextPoints[i2] = nextPoints[idx2];
            sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
            sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
            sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
            sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
            sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
            sortedStatus[i] = status[idx];
        }
        return {
            current: sortedCurrPoints,
            next: sortedNextPoints,
            stackedOnCurrent: sortedCurrStackedPoints,
            stackedOnNext: sortedNextStackedPoints,
            status: sortedStatus
        };
    }
});
parcelRegister("JBb7Y", function(module, exports) {
    $parcel$export(module.exports, "prepareDataCoordInfo", ()=>$08910af48116f194$export$b488a529581b37e);
    $parcel$export(module.exports, "getStackedOnPoint", ()=>$08910af48116f194$export$c1601aa630e7b5f8);
    var $5R8Hi;
    var $bahqM;
    function $08910af48116f194$export$b488a529581b37e(coordSys, data, valueOrigin) {
        var baseAxis = coordSys.getBaseAxis();
        var valueAxis = coordSys.getOtherAxis(baseAxis);
        var valueStart = $08910af48116f194$var$getValueStart(valueAxis, valueOrigin);
        var baseAxisDim = baseAxis.dim;
        var valueAxisDim = valueAxis.dim;
        var valueDim = data.mapDimension(valueAxisDim);
        var baseDim = data.mapDimension(baseAxisDim);
        var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
        var dims = (0, (0, parcelRequire("bahqM")).map)(coordSys.dimensions, function(coordDim) {
            return data.mapDimension(coordDim);
        });
        var stacked = false;
        var stackResultDim = data.getCalculationInfo('stackResultDimension');
        if ((0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, dims[0])) {
            stacked = true;
            dims[0] = stackResultDim;
        }
        if ((0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, dims[1])) {
            stacked = true;
            dims[1] = stackResultDim;
        }
        return {
            dataDimsForPoint: dims,
            valueStart: valueStart,
            valueAxisDim: valueAxisDim,
            baseAxisDim: baseAxisDim,
            stacked: !!stacked,
            valueDim: valueDim,
            baseDim: baseDim,
            baseDataOffset: baseDataOffset,
            stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
        };
    }
    function $08910af48116f194$var$getValueStart(valueAxis, valueOrigin) {
        var valueStart = 0;
        var extent = valueAxis.scale.getExtent();
        if (valueOrigin === 'start') valueStart = extent[0];
        else if (valueOrigin === 'end') valueStart = extent[1];
        else {
            if (extent[0] > 0) valueStart = extent[0];
            else if (extent[1] < 0) valueStart = extent[1];
        }
        return valueStart;
    }
    function $08910af48116f194$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
        var value = NaN;
        if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
        if (isNaN(value)) value = dataCoordInfo.valueStart;
        var baseDataOffset = dataCoordInfo.baseDataOffset;
        var stackedData = [];
        stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
        stackedData[1 - baseDataOffset] = value;
        return coordSys.dataToPoint(stackedData);
    }
});
parcelRegister("jconq", function(module, exports) {
    $parcel$export(module.exports, "ECPolyline", ()=>$dfa20c0939f7b781$export$bf7c0585b8f7d00f);
    $parcel$export(module.exports, "ECPolygon", ()=>$dfa20c0939f7b781$export$6042a400d113f2bd);
    var $3VFsf;
    var $ghQ8v;
    var $aA4Ws;
    var $dr1jo;
    var $dfa20c0939f7b781$var$mathMin = Math.min;
    var $dfa20c0939f7b781$var$mathMax = Math.max;
    function $dfa20c0939f7b781$var$isPointNull(x, y) {
        return isNaN(x) || isNaN(y);
    }
    function $dfa20c0939f7b781$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
        var prevX;
        var prevY;
        var cpx0;
        var cpy0;
        var cpx1;
        var cpy1;
        var idx = start;
        var k = 0;
        for(; k < segLen; k++){
            var x = points[idx * 2];
            var y = points[idx * 2 + 1];
            if (idx >= allLen || idx < 0) break;
            if ($dfa20c0939f7b781$var$isPointNull(x, y)) {
                if (connectNulls) {
                    idx += dir;
                    continue;
                }
                break;
            }
            if (idx === start) {
                ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
                cpx0 = x;
                cpy0 = y;
            } else {
                var dx = x - prevX;
                var dy = y - prevY;
                if (dx * dx + dy * dy < 0.5) {
                    idx += dir;
                    continue;
                }
                if (smooth > 0) {
                    var nextIdx = idx + dir;
                    var nextX = points[nextIdx * 2];
                    var nextY = points[nextIdx * 2 + 1];
                    var tmpK = k + 1;
                    if (connectNulls) while($dfa20c0939f7b781$var$isPointNull(nextX, nextY) && tmpK < segLen){
                        tmpK++;
                        nextIdx += dir;
                        nextX = points[nextIdx * 2];
                        nextY = points[nextIdx * 2 + 1];
                    }
                    var ratioNextSeg = 0.5;
                    var vx = 0;
                    var vy = 0;
                    var nextCpx0 = void 0;
                    var nextCpy0 = void 0;
                    if (tmpK >= segLen || $dfa20c0939f7b781$var$isPointNull(nextX, nextY)) {
                        cpx1 = x;
                        cpy1 = y;
                    } else {
                        vx = nextX - prevX;
                        vy = nextY - prevY;
                        var dx0 = x - prevX;
                        var dx1 = nextX - x;
                        var dy0 = y - prevY;
                        var dy1 = nextY - y;
                        var lenPrevSeg = void 0;
                        var lenNextSeg = void 0;
                        if (smoothMonotone === 'x') {
                            lenPrevSeg = Math.abs(dx0);
                            lenNextSeg = Math.abs(dx1);
                            cpx1 = x - lenPrevSeg * smooth;
                            cpy1 = y;
                            nextCpx0 = x + lenPrevSeg * smooth;
                            nextCpy0 = y;
                        } else if (smoothMonotone === 'y') {
                            lenPrevSeg = Math.abs(dy0);
                            lenNextSeg = Math.abs(dy1);
                            cpx1 = x;
                            cpy1 = y - lenPrevSeg * smooth;
                            nextCpx0 = x;
                            nextCpy0 = y + lenPrevSeg * smooth;
                        } else {
                            lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                            lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                            ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                            cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                            cpy1 = y - vy * smooth * (1 - ratioNextSeg);
                            nextCpx0 = x + vx * smooth * ratioNextSeg;
                            nextCpy0 = y + vy * smooth * ratioNextSeg;
                            nextCpx0 = $dfa20c0939f7b781$var$mathMin(nextCpx0, $dfa20c0939f7b781$var$mathMax(nextX, x));
                            nextCpy0 = $dfa20c0939f7b781$var$mathMin(nextCpy0, $dfa20c0939f7b781$var$mathMax(nextY, y));
                            nextCpx0 = $dfa20c0939f7b781$var$mathMax(nextCpx0, $dfa20c0939f7b781$var$mathMin(nextX, x));
                            nextCpy0 = $dfa20c0939f7b781$var$mathMax(nextCpy0, $dfa20c0939f7b781$var$mathMin(nextY, y));
                            vx = nextCpx0 - x;
                            vy = nextCpy0 - y;
                            cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                            cpy1 = y - vy * lenPrevSeg / lenNextSeg;
                            cpx1 = $dfa20c0939f7b781$var$mathMin(cpx1, $dfa20c0939f7b781$var$mathMax(prevX, x));
                            cpy1 = $dfa20c0939f7b781$var$mathMin(cpy1, $dfa20c0939f7b781$var$mathMax(prevY, y));
                            cpx1 = $dfa20c0939f7b781$var$mathMax(cpx1, $dfa20c0939f7b781$var$mathMin(prevX, x));
                            cpy1 = $dfa20c0939f7b781$var$mathMax(cpy1, $dfa20c0939f7b781$var$mathMin(prevY, y));
                            vx = x - cpx1;
                            vy = y - cpy1;
                            nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                            nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                        }
                    }
                    ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                    cpx0 = nextCpx0;
                    cpy0 = nextCpy0;
                } else ctx.lineTo(x, y);
            }
            prevX = x;
            prevY = y;
            idx += dir;
        }
        return k;
    }
    var $dfa20c0939f7b781$var$ECPolylineShape = function() {
        function ECPolylineShape() {
            this.smooth = 0;
            this.smoothConstraint = true;
        }
        return ECPolylineShape;
    }();
    var $dfa20c0939f7b781$export$bf7c0585b8f7d00f = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECPolyline, _super);
        function ECPolyline(opts) {
            var _this = _super.call(this, opts) || this;
            _this.type = 'ec-polyline';
            return _this;
        }
        ECPolyline.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        ECPolyline.prototype.getDefaultShape = function() {
            return new $dfa20c0939f7b781$var$ECPolylineShape();
        };
        ECPolyline.prototype.buildPath = function(ctx, shape) {
            var points = shape.points;
            var i = 0;
            var len = points.length / 2;
            if (shape.connectNulls) {
                for(; len > 0; len--){
                    if (!$dfa20c0939f7b781$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
                }
                for(; i < len; i++){
                    if (!$dfa20c0939f7b781$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
                }
            }
            while(i < len)i += $dfa20c0939f7b781$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
        };
        ECPolyline.prototype.getPointOn = function(xOrY, dim) {
            if (!this.path) {
                this.createPathProxy();
                this.buildPath(this.path, this.shape);
            }
            var path = this.path;
            var data = path.data;
            var CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
            var x0;
            var y0;
            var isDimX = dim === 'x';
            var roots = [];
            for(var i = 0; i < data.length;){
                var cmd = data[i++];
                var x = void 0;
                var y = void 0;
                var x2 = void 0;
                var y2 = void 0;
                var x3 = void 0;
                var y3 = void 0;
                var t = void 0;
                switch(cmd){
                    case CMD.M:
                        x0 = data[i++];
                        y0 = data[i++];
                        break;
                    case CMD.L:
                        x = data[i++];
                        y = data[i++];
                        t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                        if (t <= 1 && t >= 0) {
                            var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                        x0 = x;
                        y0 = y;
                        break;
                    case CMD.C:
                        x = data[i++];
                        y = data[i++];
                        x2 = data[i++];
                        y2 = data[i++];
                        x3 = data[i++];
                        y3 = data[i++];
                        var nRoot = isDimX ? (0, (0, parcelRequire("dr1jo")).cubicRootAt)(x0, x, x2, x3, xOrY, roots) : (0, (0, parcelRequire("dr1jo")).cubicRootAt)(y0, y, y2, y3, xOrY, roots);
                        if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                            var t_1 = roots[i_1];
                            if (t_1 <= 1 && t_1 >= 0) {
                                var val = isDimX ? (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y, y2, y3, t_1) : (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x, x2, x3, t_1);
                                return isDimX ? [
                                    xOrY,
                                    val
                                ] : [
                                    val,
                                    xOrY
                                ];
                            }
                        }
                        x0 = x3;
                        y0 = y3;
                        break;
                }
            }
        };
        return ECPolyline;
    }((0, (0, parcelRequire("ghQ8v")).default));
    var $dfa20c0939f7b781$var$ECPolygonShape = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECPolygonShape, _super);
        function ECPolygonShape() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return ECPolygonShape;
    }($dfa20c0939f7b781$var$ECPolylineShape);
    var $dfa20c0939f7b781$export$6042a400d113f2bd = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECPolygon, _super);
        function ECPolygon(opts) {
            var _this = _super.call(this, opts) || this;
            _this.type = 'ec-polygon';
            return _this;
        }
        ECPolygon.prototype.getDefaultShape = function() {
            return new $dfa20c0939f7b781$var$ECPolygonShape();
        };
        ECPolygon.prototype.buildPath = function(ctx, shape) {
            var points = shape.points;
            var stackedOnPoints = shape.stackedOnPoints;
            var i = 0;
            var len = points.length / 2;
            var smoothMonotone = shape.smoothMonotone;
            if (shape.connectNulls) {
                for(; len > 0; len--){
                    if (!$dfa20c0939f7b781$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
                }
                for(; i < len; i++){
                    if (!$dfa20c0939f7b781$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
                }
            }
            while(i < len){
                var k = $dfa20c0939f7b781$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
                $dfa20c0939f7b781$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
                i += k + 1;
                ctx.closePath();
            }
        };
        return ECPolygon;
    }((0, (0, parcelRequire("ghQ8v")).default));
});
parcelRegister("5fMzf", function(module, exports) {
    $parcel$export(module.exports, "createGridClipPath", ()=>$3d3406f7f3673e0b$export$83958787eb658d14);
    $parcel$export(module.exports, "createPolarClipPath", ()=>$3d3406f7f3673e0b$export$13dc2b2230df3cb5);
    $parcel$export(module.exports, "createClipPath", ()=>$3d3406f7f3673e0b$export$e0fe5081209d01c9);
    var $eYgMC;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $elGBV;
    var $jmSNG;
    function $3d3406f7f3673e0b$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
        var rect = cartesian.getArea();
        var x = rect.x;
        var y = rect.y;
        var width = rect.width;
        var height = rect.height;
        var lineWidth = seriesModel.get([
            'lineStyle',
            'width'
        ]) || 2;
        x -= lineWidth / 2;
        y -= lineWidth / 2;
        width += lineWidth;
        height += lineWidth;
        x = Math.floor(x);
        width = Math.round(width);
        var clipPath = new (0, parcelRequire("7Tw7u")).default({
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            }
        });
        if (hasAnimation) {
            var baseAxis = cartesian.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isAxisInversed = baseAxis.inverse;
            if (isHorizontal) {
                if (isAxisInversed) clipPath.shape.x += width;
                clipPath.shape.width = 0;
            } else {
                if (!isAxisInversed) clipPath.shape.y += height;
                clipPath.shape.height = 0;
            }
            var duringCb = typeof during === 'function' ? function(percent) {
                during(percent, clipPath);
            } : null;
            (0, parcelRequire("eYgMC")).initProps(clipPath, {
                shape: {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                }
            }, seriesModel, null, done, duringCb);
        }
        return clipPath;
    }
    function $3d3406f7f3673e0b$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
        var sectorArea = polar.getArea();
        var r0 = (0, (0, parcelRequire("jmSNG")).round)(sectorArea.r0, 1);
        var r = (0, (0, parcelRequire("jmSNG")).round)(sectorArea.r, 1);
        var clipPath = new (0, parcelRequire("elGBV")).default({
            shape: {
                cx: (0, (0, parcelRequire("jmSNG")).round)(polar.cx, 1),
                cy: (0, (0, parcelRequire("jmSNG")).round)(polar.cy, 1),
                r0: r0,
                r: r,
                startAngle: sectorArea.startAngle,
                endAngle: sectorArea.endAngle,
                clockwise: sectorArea.clockwise
            }
        });
        if (hasAnimation) {
            var isRadial = polar.getBaseAxis().dim === 'angle';
            if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
            else clipPath.shape.r = r0;
            (0, parcelRequire("eYgMC")).initProps(clipPath, {
                shape: {
                    endAngle: sectorArea.endAngle,
                    r: r
                }
            }, seriesModel);
        }
        return clipPath;
    }
    function $3d3406f7f3673e0b$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
        if (!coordSys) return null;
        else if (coordSys.type === 'polar') return $3d3406f7f3673e0b$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
        else if (coordSys.type === 'cartesian2d') return $3d3406f7f3673e0b$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
        return null;
    }
});
parcelRegister("40dMe", function(module, exports) {
    $parcel$export(module.exports, "isCoordinateSystemType", ()=>$2ea1d953c3a29c60$export$8567506e6336616);
    function $2ea1d953c3a29c60$export$8567506e6336616(coordSys, type) {
        return coordSys.type === type;
    }
});
parcelRegister("7jcIW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55242d779d1fe9b5$export$2e2bcd8739ae039);
    var $55242d779d1fe9b5$var$samplers = {
        average: function(frame) {
            var sum = 0;
            var count = 0;
            for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
                sum += frame[i];
                count++;
            }
            return count === 0 ? NaN : sum / count;
        },
        sum: function(frame) {
            var sum = 0;
            for(var i = 0; i < frame.length; i++)sum += frame[i] || 0;
            return sum;
        },
        max: function(frame) {
            var max = -Infinity;
            for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
            return isFinite(max) ? max : NaN;
        },
        min: function(frame) {
            var min = Infinity;
            for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
            return isFinite(min) ? min : NaN;
        },
        nearest: function(frame) {
            return frame[0];
        }
    };
    var $55242d779d1fe9b5$var$indexSampler = function(frame) {
        return Math.round(frame.length / 2);
    };
    function $55242d779d1fe9b5$export$2e2bcd8739ae039(seriesType) {
        return {
            seriesType: seriesType,
            reset: function(seriesModel, ecModel, api) {
                var data = seriesModel.getData();
                var sampling = seriesModel.get('sampling');
                var coordSys = seriesModel.coordinateSystem;
                var count = data.count();
                if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                    var baseAxis = coordSys.getBaseAxis();
                    var valueAxis = coordSys.getOtherAxis(baseAxis);
                    var extent = baseAxis.getExtent();
                    var dpr = api.getDevicePixelRatio();
                    var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                    var rate = Math.round(count / size);
                    if (rate > 1) {
                        if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                        var sampler = void 0;
                        if (typeof sampling === 'string') sampler = $55242d779d1fe9b5$var$samplers[sampling];
                        else if (typeof sampling === 'function') sampler = sampling;
                        if (sampler) seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $55242d779d1fe9b5$var$indexSampler));
                    }
                }
            }
        };
    }
});
parcelRegister("Np0DX", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$0947fa0f3730af30$export$4b3e715f166fdd78);
    var $alpND;
    var $eQgZJ;
    var $jBLJn;
    var $iWOYl;
    var $5xgWc;
    function $0947fa0f3730af30$export$4b3e715f166fdd78(registers) {
        (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("iWOYl")).install));
        registers.registerSeriesModel((0, (0, parcelRequire("eQgZJ")).default));
        registers.registerChartView((0, (0, parcelRequire("jBLJn")).default));
        registers.registerLayout((0, (0, parcelRequire("5xgWc")).default)('scatter'));
    }
});
parcelRegister("alpND", function(module, exports) {
    $parcel$export(module.exports, "use", ()=>$787fe0d1b8504a01$export$1f96ae73734a86cc);
    var $8pqpA;
    var $fkskt;
    var $loerw;
    var $h4UlH;
    var $1O7Ua;
    var $bahqM;
    var $9Y5KT;
    var $787fe0d1b8504a01$var$extensions = [];
    var $787fe0d1b8504a01$var$extensionRegisters = {
        registerPreprocessor: (0, (0, parcelRequire("8pqpA")).registerPreprocessor),
        registerProcessor: (0, (0, parcelRequire("8pqpA")).registerProcessor),
        registerPostInit: (0, (0, parcelRequire("8pqpA")).registerPostInit),
        registerPostUpdate: (0, (0, parcelRequire("8pqpA")).registerPostUpdate),
        registerUpdateLifecycle: (0, (0, parcelRequire("8pqpA")).registerUpdateLifecycle),
        registerAction: (0, (0, parcelRequire("8pqpA")).registerAction),
        registerCoordinateSystem: (0, (0, parcelRequire("8pqpA")).registerCoordinateSystem),
        registerLayout: (0, (0, parcelRequire("8pqpA")).registerLayout),
        registerVisual: (0, (0, parcelRequire("8pqpA")).registerVisual),
        registerTransform: (0, (0, parcelRequire("8pqpA")).registerTransform),
        registerLoading: (0, (0, parcelRequire("8pqpA")).registerLoading),
        registerMap: (0, (0, parcelRequire("8pqpA")).registerMap),
        PRIORITY: (0, (0, parcelRequire("8pqpA")).PRIORITY),
        ComponentModel: (0, (0, parcelRequire("h4UlH")).default),
        ComponentView: (0, (0, parcelRequire("fkskt")).default),
        SeriesModel: (0, (0, parcelRequire("1O7Ua")).default),
        ChartView: (0, (0, parcelRequire("loerw")).default),
        registerComponentModel: function(ComponentModelClass) {
            (0, (0, parcelRequire("h4UlH")).default).registerClass(ComponentModelClass);
        },
        registerComponentView: function(ComponentViewClass) {
            (0, (0, parcelRequire("fkskt")).default).registerClass(ComponentViewClass);
        },
        registerSeriesModel: function(SeriesModelClass) {
            (0, (0, parcelRequire("1O7Ua")).default).registerClass(SeriesModelClass);
        },
        registerChartView: function(ChartViewClass) {
            (0, (0, parcelRequire("loerw")).default).registerClass(ChartViewClass);
        },
        registerSubTypeDefaulter: function(componentType, defaulter) {
            (0, (0, parcelRequire("h4UlH")).default).registerSubTypeDefaulter(componentType, defaulter);
        },
        registerPainter: function(painterType, PainterCtor) {
            (0, (0, parcelRequire("9Y5KT")).registerPainter)(painterType, PainterCtor);
        }
    };
    function $787fe0d1b8504a01$export$1f96ae73734a86cc(ext) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(ext)) {
            (0, (0, parcelRequire("bahqM")).each)(ext, function(singleExt) {
                $787fe0d1b8504a01$export$1f96ae73734a86cc(singleExt);
            });
            return;
        }
        if ((0, (0, parcelRequire("bahqM")).indexOf)($787fe0d1b8504a01$var$extensions, ext) >= 0) return;
        $787fe0d1b8504a01$var$extensions.push(ext);
        if ((0, (0, parcelRequire("bahqM")).isFunction)(ext)) ext = {
            install: ext
        };
        ext.install($787fe0d1b8504a01$var$extensionRegisters);
    }
});
parcelRegister("8pqpA", function(module, exports) {
    $parcel$export(module.exports, "version", ()=>$61f525521022d020$export$83d89fbfd8236492);
    $parcel$export(module.exports, "dependencies", ()=>$61f525521022d020$export$b74ff737e0e298b5);
    $parcel$export(module.exports, "PRIORITY", ()=>$61f525521022d020$export$bb34f3538ba26c7e);
    $parcel$export(module.exports, "init", ()=>$61f525521022d020$export$2cd8252107eb640b);
    $parcel$export(module.exports, "getInstanceByDom", ()=>$61f525521022d020$export$33b6fbccd4f643f8);
    $parcel$export(module.exports, "connect", ()=>$61f525521022d020$export$64605811ab45167f);
    $parcel$export(module.exports, "disConnect", ()=>$61f525521022d020$export$87cd6834112ecb52);
    $parcel$export(module.exports, "disconnect", ()=>$61f525521022d020$export$37dfea93db2e14ed);
    $parcel$export(module.exports, "dispose", ()=>$61f525521022d020$export$fcfbbcec2cb820d5);
    $parcel$export(module.exports, "getInstanceById", ()=>$61f525521022d020$export$89b4be35062c4a3f);
    $parcel$export(module.exports, "registerTheme", ()=>$61f525521022d020$export$f9c59eed5de5ff80);
    $parcel$export(module.exports, "registerPreprocessor", ()=>$61f525521022d020$export$77095792a057b768);
    $parcel$export(module.exports, "registerProcessor", ()=>$61f525521022d020$export$d575e6557ac1729f);
    $parcel$export(module.exports, "registerPostInit", ()=>$61f525521022d020$export$c8c249911ee8c1ed);
    $parcel$export(module.exports, "registerUpdateLifecycle", ()=>$61f525521022d020$export$c9ec4b5faef04865);
    $parcel$export(module.exports, "registerPostUpdate", ()=>$61f525521022d020$export$99560909c18c76bb);
    $parcel$export(module.exports, "registerAction", ()=>$61f525521022d020$export$408c24786cd729c6);
    $parcel$export(module.exports, "registerCoordinateSystem", ()=>$61f525521022d020$export$1dd5e025a8a37dd);
    $parcel$export(module.exports, "getCoordinateSystemDimensions", ()=>$61f525521022d020$export$fc2638719e4159b9);
    $parcel$export(module.exports, "registerLayout", ()=>$61f525521022d020$export$d768f97700ca6bea);
    $parcel$export(module.exports, "registerVisual", ()=>$61f525521022d020$export$5f32c1eb94c381bb);
    $parcel$export(module.exports, "registerLoading", ()=>$61f525521022d020$export$e06b68a82007c015);
    $parcel$export(module.exports, "setCanvasCreator", ()=>$61f525521022d020$export$10425ea7a243b114);
    $parcel$export(module.exports, "registerMap", ()=>$61f525521022d020$export$d456de060be2dba1);
    $parcel$export(module.exports, "getMap", ()=>$61f525521022d020$export$b8586192aead8a7e);
    $parcel$export(module.exports, "registerTransform", ()=>$61f525521022d020$export$f01d71dd0389d7e4);
    $parcel$export(module.exports, "dataTool", ()=>$61f525521022d020$export$73cae5e090579589);
    $parcel$export(module.exports, "registerLocale", ()=>(parcelRequire("3OMoQ")).registerLocale);
    var $3VFsf;
    var $9Y5KT;
    var $bahqM;
    var $d6udH;
    var $hZfwb;
    var $aVBu2;
    var $bRKv5;
    var $74g78;
    var $iEvqc;
    var $gyhNQ;
    var $6LzFt;
    var $driCQ;
    var $iMppY;
    var $1O7Ua;
    var $fkskt;
    var $loerw;
    parcelRequire("fHITF");
    var $gcbBH;
    var $ghQ8v;
    var $7Tw7u;
    var $eYgMC;
    var $7QjoM;
    var $fIXXx;
    var $eaKsF;
    var $ljaBy;
    var $cvEVp;
    var $4G956;
    var $14WFd;
    var $31FQc;
    var $dMJCs;
    var $aLwh0;
    var $cbv5T;
    var $7wiHx;
    var $fk5Gm;
    var $2cFRc;
    var $1nKsD;
    var $05ab4;
    var $3OMoQ;
    var $6IsbX;
    var $g2DhS;
    var $fEzwg;
    var $8cCW2;
    var $61f525521022d020$var$hasWindow = typeof window !== 'undefined';
    var $61f525521022d020$export$83d89fbfd8236492 = '5.2.1';
    var $61f525521022d020$export$b74ff737e0e298b5 = {
        zrender: '5.2.1'
    };
    var $61f525521022d020$var$TEST_FRAME_REMAIN_TIME = 1;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_DATASTACK = 900;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_FILTER = 1000;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
    var $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT = 1000;
    var $61f525521022d020$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
    var $61f525521022d020$var$PRIORITY_VISUAL_GLOBAL = 2000;
    var $61f525521022d020$var$PRIORITY_VISUAL_CHART = 3000;
    var $61f525521022d020$var$PRIORITY_VISUAL_COMPONENT = 4000;
    var $61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
    var $61f525521022d020$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
    var $61f525521022d020$var$PRIORITY_VISUAL_BRUSH = 5000;
    var $61f525521022d020$var$PRIORITY_VISUAL_ARIA = 6000;
    var $61f525521022d020$var$PRIORITY_VISUAL_DECAL = 7000;
    var $61f525521022d020$export$bb34f3538ba26c7e = {
        PROCESSOR: {
            FILTER: $61f525521022d020$var$PRIORITY_PROCESSOR_FILTER,
            SERIES_FILTER: $61f525521022d020$var$PRIORITY_PROCESSOR_SERIES_FILTER,
            STATISTIC: $61f525521022d020$var$PRIORITY_PROCESSOR_STATISTIC
        },
        VISUAL: {
            LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT,
            PROGRESSIVE_LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
            GLOBAL: $61f525521022d020$var$PRIORITY_VISUAL_GLOBAL,
            CHART: $61f525521022d020$var$PRIORITY_VISUAL_CHART,
            POST_CHART_LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
            COMPONENT: $61f525521022d020$var$PRIORITY_VISUAL_COMPONENT,
            BRUSH: $61f525521022d020$var$PRIORITY_VISUAL_BRUSH,
            CHART_ITEM: $61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
            ARIA: $61f525521022d020$var$PRIORITY_VISUAL_ARIA,
            DECAL: $61f525521022d020$var$PRIORITY_VISUAL_DECAL
        }
    };
    var $61f525521022d020$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
    var $61f525521022d020$var$PENDING_UPDATE = '__pendingUpdate';
    var $61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
    var $61f525521022d020$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
    var $61f525521022d020$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
    var $61f525521022d020$var$CONNECT_STATUS_PENDING = 0;
    var $61f525521022d020$var$CONNECT_STATUS_UPDATING = 1;
    var $61f525521022d020$var$CONNECT_STATUS_UPDATED = 2;
    function $61f525521022d020$var$createRegisterEventWithLowercaseECharts(method) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.isDisposed()) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            return $61f525521022d020$var$toLowercaseNameAndCallEventful(this, method, args);
        };
    }
    function $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter(method) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return $61f525521022d020$var$toLowercaseNameAndCallEventful(this, method, args);
        };
    }
    function $61f525521022d020$var$toLowercaseNameAndCallEventful(host, method, args) {
        args[0] = args[0] && args[0].toLowerCase();
        return (0, (0, parcelRequire("bRKv5")).default).prototype[method].apply(host, args);
    }
    var $61f525521022d020$var$MessageCenter = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MessageCenter, _super);
        function MessageCenter() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return MessageCenter;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $61f525521022d020$var$messageCenterProto = $61f525521022d020$var$MessageCenter.prototype;
    $61f525521022d020$var$messageCenterProto.on = $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter('on');
    $61f525521022d020$var$messageCenterProto.off = $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter('off');
    var $61f525521022d020$var$prepare;
    var $61f525521022d020$var$prepareView;
    var $61f525521022d020$var$updateDirectly;
    var $61f525521022d020$var$updateMethods;
    var $61f525521022d020$var$doConvertPixel;
    var $61f525521022d020$var$updateStreamModes;
    var $61f525521022d020$var$doDispatchAction;
    var $61f525521022d020$var$flushPendingActions;
    var $61f525521022d020$var$triggerUpdatedEvent;
    var $61f525521022d020$var$bindRenderedEvent;
    var $61f525521022d020$var$bindMouseEvent;
    var $61f525521022d020$var$clearColorPalette;
    var $61f525521022d020$var$render;
    var $61f525521022d020$var$renderComponents;
    var $61f525521022d020$var$renderSeries;
    var $61f525521022d020$var$createExtensionAPI;
    var $61f525521022d020$var$enableConnect;
    var $61f525521022d020$var$markStatusToUpdate;
    var $61f525521022d020$var$applyChangedStates;
    var $61f525521022d020$var$ECharts = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECharts, _super);
        function ECharts(dom, theme, opts) {
            var _this = _super.call(this, new (0, (0, parcelRequire("cbv5T")).ECEventProcessor)()) || this;
            _this._chartsViews = [];
            _this._chartsMap = {};
            _this._componentsViews = [];
            _this._componentsMap = {};
            _this._pendingActions = [];
            opts = opts || {};
            if (typeof theme === 'string') theme = $61f525521022d020$var$themeStorage[theme];
            _this._dom = dom;
            var defaultRenderer = 'canvas';
            var defaultUseDirtyRect = false;
            var root, devUseDirtyRect;
            var zr = _this._zr = (0, parcelRequire("9Y5KT")).init(dom, {
                renderer: opts.renderer || defaultRenderer,
                devicePixelRatio: opts.devicePixelRatio,
                width: opts.width,
                height: opts.height,
                useDirtyRect: opts.useDirtyRect == null ? defaultUseDirtyRect : opts.useDirtyRect
            });
            _this._throttledZrFlush = (0, (0, parcelRequire("ljaBy")).throttle)((0, (0, parcelRequire("bahqM")).bind)(zr.flush, zr), 17);
            theme = (0, (0, parcelRequire("bahqM")).clone)(theme);
            theme && (0, (0, parcelRequire("driCQ")).default)(theme, true);
            _this._theme = theme;
            _this._locale = (0, (0, parcelRequire("3OMoQ")).createLocaleObject)(opts.locale || (0, (0, parcelRequire("3OMoQ")).SYSTEM_LANG));
            _this._coordSysMgr = new (0, (0, parcelRequire("gyhNQ")).default)();
            var api = _this._api = $61f525521022d020$var$createExtensionAPI(_this);
            function prioritySortFunc(a, b) {
                return a.__prio - b.__prio;
            }
            (0, (0, parcelRequire("aVBu2")).default)($61f525521022d020$var$visualFuncs, prioritySortFunc);
            (0, (0, parcelRequire("aVBu2")).default)($61f525521022d020$var$dataProcessorFuncs, prioritySortFunc);
            _this._scheduler = new (0, (0, parcelRequire("14WFd")).default)(_this, api, $61f525521022d020$var$dataProcessorFuncs, $61f525521022d020$var$visualFuncs);
            _this._messageCenter = new $61f525521022d020$var$MessageCenter();
            _this._initEvents();
            _this.resize = (0, (0, parcelRequire("bahqM")).bind)(_this.resize, _this);
            zr.animation.on('frame', _this._onframe, _this);
            $61f525521022d020$var$bindRenderedEvent(zr, _this);
            $61f525521022d020$var$bindMouseEvent(zr, _this);
            (0, (0, parcelRequire("bahqM")).setAsPrimitive)(_this);
            return _this;
        }
        ECharts.prototype._onframe = function() {
            if (this._disposed) return;
            $61f525521022d020$var$applyChangedStates(this);
            var scheduler = this._scheduler;
            if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                var silent = this[$61f525521022d020$var$PENDING_UPDATE].silent;
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
                $61f525521022d020$var$prepare(this);
                $61f525521022d020$var$updateMethods.update.call(this, null, this[$61f525521022d020$var$PENDING_UPDATE].updateParams);
                this._zr.flush();
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                this[$61f525521022d020$var$PENDING_UPDATE] = null;
                $61f525521022d020$var$flushPendingActions.call(this, silent);
                $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
            } else if (scheduler.unfinished) {
                var remainTime = $61f525521022d020$var$TEST_FRAME_REMAIN_TIME;
                var ecModel = this._model;
                var api = this._api;
                scheduler.unfinished = false;
                do {
                    var startTime = +new Date();
                    scheduler.performSeriesTasks(ecModel);
                    scheduler.performDataProcessorTasks(ecModel);
                    $61f525521022d020$var$updateStreamModes(this, ecModel);
                    scheduler.performVisualTasks(ecModel);
                    $61f525521022d020$var$renderSeries(this, this._model, api, 'remain', {});
                    remainTime -= +new Date() - startTime;
                }while (remainTime > 0 && scheduler.unfinished)
                if (!scheduler.unfinished) this._zr.flush();
            }
        };
        ECharts.prototype.getDom = function() {
            return this._dom;
        };
        ECharts.prototype.getId = function() {
            return this.id;
        };
        ECharts.prototype.getZr = function() {
            return this._zr;
        };
        ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            var silent;
            var replaceMerge;
            var transitionOpt;
            if ((0, (0, parcelRequire("bahqM")).isObject)(notMerge)) {
                lazyUpdate = notMerge.lazyUpdate;
                silent = notMerge.silent;
                replaceMerge = notMerge.replaceMerge;
                transitionOpt = notMerge.transition;
                notMerge = notMerge.notMerge;
            }
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
            if (!this._model || notMerge) {
                var optionManager = new (0, (0, parcelRequire("6LzFt")).default)(this._api);
                var theme = this._theme;
                var ecModel = this._model = new (0, (0, parcelRequire("74g78")).default)();
                ecModel.scheduler = this._scheduler;
                ecModel.init(null, null, null, theme, this._locale, optionManager);
            }
            this._model.setOption(option, {
                replaceMerge: replaceMerge
            }, $61f525521022d020$var$optionPreprocessorFuncs);
            var updateParams = {
                seriesTransition: transitionOpt,
                optionChanged: true
            };
            if (lazyUpdate) {
                this[$61f525521022d020$var$PENDING_UPDATE] = {
                    silent: silent,
                    updateParams: updateParams
                };
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                this.getZr().wakeUp();
            } else {
                $61f525521022d020$var$prepare(this);
                $61f525521022d020$var$updateMethods.update.call(this, null, updateParams);
                this._zr.flush();
                this[$61f525521022d020$var$PENDING_UPDATE] = null;
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                $61f525521022d020$var$flushPendingActions.call(this, silent);
                $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
            }
        };
        ECharts.prototype.setTheme = function() {
            console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
        };
        ECharts.prototype.getModel = function() {
            return this._model;
        };
        ECharts.prototype.getOption = function() {
            return this._model && this._model.getOption();
        };
        ECharts.prototype.getWidth = function() {
            return this._zr.getWidth();
        };
        ECharts.prototype.getHeight = function() {
            return this._zr.getHeight();
        };
        ECharts.prototype.getDevicePixelRatio = function() {
            return this._zr.painter.dpr || $61f525521022d020$var$hasWindow && window.devicePixelRatio || 1;
        };
        ECharts.prototype.getRenderedCanvas = function(opts) {
            if (!(0, (0, parcelRequire("hZfwb")).default).canvasSupported) return;
            opts = opts || {};
            return this._zr.painter.getRenderedCanvas({
                backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
                pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
            });
        };
        ECharts.prototype.getSvgDataURL = function() {
            if (!(0, (0, parcelRequire("hZfwb")).default).svgSupported) return;
            var zr = this._zr;
            var list = zr.storage.getDisplayList();
            (0, (0, parcelRequire("bahqM")).each)(list, function(el) {
                el.stopAnimation(null, true);
            });
            return zr.painter.toDataURL();
        };
        ECharts.prototype.getDataURL = function(opts) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            opts = opts || {};
            var excludeComponents = opts.excludeComponents;
            var ecModel = this._model;
            var excludesComponentViews = [];
            var self = this;
            (0, (0, parcelRequire("bahqM")).each)(excludeComponents, function(componentType) {
                ecModel.eachComponent({
                    mainType: componentType
                }, function(component) {
                    var view = self._componentsMap[component.__viewId];
                    if (!view.group.ignore) {
                        excludesComponentViews.push(view);
                        view.group.ignore = true;
                    }
                });
            });
            var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
            (0, (0, parcelRequire("bahqM")).each)(excludesComponentViews, function(view) {
                view.group.ignore = false;
            });
            return url;
        };
        ECharts.prototype.getConnectedDataURL = function(opts) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            if (!(0, (0, parcelRequire("hZfwb")).default).canvasSupported) return;
            var isSvg = opts.type === 'svg';
            var groupId = this.group;
            var mathMin = Math.min;
            var mathMax = Math.max;
            var MAX_NUMBER = Infinity;
            if ($61f525521022d020$var$connectedGroups[groupId]) {
                var left_1 = MAX_NUMBER;
                var top_1 = MAX_NUMBER;
                var right_1 = -MAX_NUMBER;
                var bottom_1 = -MAX_NUMBER;
                var canvasList_1 = [];
                var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
                (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$instances, function(chart, id) {
                    if (chart.group === groupId) {
                        var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas((0, (0, parcelRequire("bahqM")).clone)(opts));
                        var boundingRect = chart.getDom().getBoundingClientRect();
                        left_1 = mathMin(boundingRect.left, left_1);
                        top_1 = mathMin(boundingRect.top, top_1);
                        right_1 = mathMax(boundingRect.right, right_1);
                        bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                        canvasList_1.push({
                            dom: canvas,
                            left: boundingRect.left,
                            top: boundingRect.top
                        });
                    }
                });
                left_1 *= dpr_1;
                top_1 *= dpr_1;
                right_1 *= dpr_1;
                bottom_1 *= dpr_1;
                var width = right_1 - left_1;
                var height = bottom_1 - top_1;
                var targetCanvas = (0, (0, parcelRequire("bahqM")).createCanvas)();
                var zr_1 = (0, parcelRequire("9Y5KT")).init(targetCanvas, {
                    renderer: isSvg ? 'svg' : 'canvas'
                });
                zr_1.resize({
                    width: width,
                    height: height
                });
                if (isSvg) {
                    var content_1 = '';
                    (0, (0, parcelRequire("bahqM")).each)(canvasList_1, function(item) {
                        var x = item.left - left_1;
                        var y = item.top - top_1;
                        content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                    });
                    zr_1.painter.getSvgRoot().innerHTML = content_1;
                    if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                    zr_1.refreshImmediately();
                    return zr_1.painter.toDataURL();
                } else {
                    if (opts.connectedBackgroundColor) zr_1.add(new (0, parcelRequire("7Tw7u")).default({
                        shape: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        style: {
                            fill: opts.connectedBackgroundColor
                        }
                    }));
                    (0, (0, parcelRequire("bahqM")).each)(canvasList_1, function(item) {
                        var img = new (0, parcelRequire("gcbBH")).default({
                            style: {
                                x: item.left * dpr_1 - left_1,
                                y: item.top * dpr_1 - top_1,
                                image: item.dom
                            }
                        });
                        zr_1.add(img);
                    });
                    zr_1.refreshImmediately();
                    return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
                }
            } else return this.getDataURL(opts);
        };
        ECharts.prototype.convertToPixel = function(finder, value) {
            return $61f525521022d020$var$doConvertPixel(this, 'convertToPixel', finder, value);
        };
        ECharts.prototype.convertFromPixel = function(finder, value) {
            return $61f525521022d020$var$doConvertPixel(this, 'convertFromPixel', finder, value);
        };
        ECharts.prototype.containPixel = function(finder, value) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            var ecModel = this._model;
            var result;
            var findResult = (0, parcelRequire("eaKsF")).parseFinder(ecModel, finder);
            (0, (0, parcelRequire("bahqM")).each)(findResult, function(models, key) {
                key.indexOf('Models') >= 0 && (0, (0, parcelRequire("bahqM")).each)(models, function(model) {
                    var coordSys = model.coordinateSystem;
                    if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                    else if (key === 'seriesModels') {
                        var view = this._chartsMap[model.__viewId];
                        if (view && view.containPoint) result = result || view.containPoint(value, model);
                    }
                }, this);
            }, this);
            return !!result;
        };
        ECharts.prototype.getVisual = function(finder, visualType) {
            var ecModel = this._model;
            var parsedFinder = (0, parcelRequire("eaKsF")).parseFinder(ecModel, finder, {
                defaultMainType: 'series'
            });
            var seriesModel = parsedFinder.seriesModel;
            var data = seriesModel.getData();
            var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
            return dataIndexInside != null ? (0, (0, parcelRequire("fk5Gm")).getItemVisualFromData)(data, dataIndexInside, visualType) : (0, (0, parcelRequire("fk5Gm")).getVisualFromData)(data, visualType);
        };
        ECharts.prototype.getViewOfComponentModel = function(componentModel) {
            return this._componentsMap[componentModel.__viewId];
        };
        ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
            return this._chartsMap[seriesModel.__viewId];
        };
        ECharts.prototype._initEvents = function() {
            var _this = this;
            (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$MOUSE_EVENT_NAMES, function(eveName) {
                var handler = function(e) {
                    var ecModel = _this.getModel();
                    var el = e.target;
                    var params;
                    var isGlobalOut = eveName === 'globalout';
                    if (isGlobalOut) params = {};
                    else el && (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, function(parent) {
                        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(parent);
                        if (ecData && ecData.dataIndex != null) {
                            var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                            params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType) || {};
                            return true;
                        } else if (ecData.eventData) {
                            params = (0, (0, parcelRequire("bahqM")).extend)({}, ecData.eventData);
                            return true;
                        }
                    }, true);
                    if (params) {
                        var componentType = params.componentType;
                        var componentIndex = params.componentIndex;
                        if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                            componentType = 'series';
                            componentIndex = params.seriesIndex;
                        }
                        var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                        var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                        params.event = e;
                        params.type = eveName;
                        _this._$eventProcessor.eventInfo = {
                            targetEl: el,
                            packedEvent: params,
                            model: model,
                            view: view
                        };
                        _this.trigger(eveName, params);
                    }
                };
                handler.zrEventfulCallAtLast = true;
                _this._zr.on(eveName, handler, _this);
            });
            (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$eventActionMap, function(actionType, eventType) {
                _this._messageCenter.on(eventType, function(event) {
                    this.trigger(eventType, event);
                }, _this);
            });
            (0, (0, parcelRequire("bahqM")).each)([
                'selectchanged'
            ], function(eventType) {
                _this._messageCenter.on(eventType, function(event) {
                    this.trigger(eventType, event);
                }, _this);
            });
            (0, (0, parcelRequire("1nKsD")).handleLegacySelectEvents)(this._messageCenter, this, this._api);
        };
        ECharts.prototype.isDisposed = function() {
            return this._disposed;
        };
        ECharts.prototype.clear = function() {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this.setOption({
                series: []
            }, true);
        };
        ECharts.prototype.dispose = function() {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this._disposed = true;
            (0, parcelRequire("eaKsF")).setAttribute(this.getDom(), $61f525521022d020$var$DOM_ATTRIBUTE_KEY, '');
            var chart = this;
            var api = chart._api;
            var ecModel = chart._model;
            (0, (0, parcelRequire("bahqM")).each)(chart._componentsViews, function(component) {
                component.dispose(ecModel, api);
            });
            (0, (0, parcelRequire("bahqM")).each)(chart._chartsViews, function(chart) {
                chart.dispose(ecModel, api);
            });
            chart._zr.dispose();
            chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
            delete $61f525521022d020$var$instances[chart.id];
        };
        ECharts.prototype.resize = function(opts) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this._zr.resize(opts);
            var ecModel = this._model;
            this._loadingFX && this._loadingFX.resize();
            if (!ecModel) return;
            var needPrepare = ecModel.resetOption('media');
            var silent = opts && opts.silent;
            if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                if (silent == null) silent = this[$61f525521022d020$var$PENDING_UPDATE].silent;
                needPrepare = true;
                this[$61f525521022d020$var$PENDING_UPDATE] = null;
            }
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
            needPrepare && $61f525521022d020$var$prepare(this);
            $61f525521022d020$var$updateMethods.update.call(this, {
                type: 'resize',
                animation: (0, (0, parcelRequire("bahqM")).extend)({
                    duration: 0
                }, opts && opts.animation)
            });
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
            $61f525521022d020$var$flushPendingActions.call(this, silent);
            $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
        };
        ECharts.prototype.showLoading = function(name, cfg) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            if ((0, (0, parcelRequire("bahqM")).isObject)(name)) {
                cfg = name;
                name = '';
            }
            name = name || 'default';
            this.hideLoading();
            if (!$61f525521022d020$var$loadingEffects[name]) return;
            var el = $61f525521022d020$var$loadingEffects[name](this._api, cfg);
            var zr = this._zr;
            this._loadingFX = el;
            zr.add(el);
        };
        ECharts.prototype.hideLoading = function() {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this._loadingFX && this._zr.remove(this._loadingFX);
            this._loadingFX = null;
        };
        ECharts.prototype.makeActionFromEvent = function(eventObj) {
            var payload = (0, (0, parcelRequire("bahqM")).extend)({}, eventObj);
            payload.type = $61f525521022d020$var$eventActionMap[eventObj.type];
            return payload;
        };
        ECharts.prototype.dispatchAction = function(payload, opt) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            if (!(0, (0, parcelRequire("bahqM")).isObject)(opt)) opt = {
                silent: !!opt
            };
            if (!$61f525521022d020$var$actions[payload.type]) return;
            if (!this._model) return;
            if (this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY]) {
                this._pendingActions.push(payload);
                return;
            }
            var silent = opt.silent;
            $61f525521022d020$var$doDispatchAction.call(this, payload, silent);
            var flush = opt.flush;
            if (flush) this._zr.flush();
            else if (flush !== false && (0, (0, parcelRequire("hZfwb")).default).browser.weChat) this._throttledZrFlush();
            $61f525521022d020$var$flushPendingActions.call(this, silent);
            $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
        };
        ECharts.prototype.updateLabelLayout = function() {
            (0, (0, parcelRequire("8cCW2")).default).trigger('series:layoutlabels', this._model, this._api, {
                updatedSeries: []
            });
        };
        ECharts.prototype.appendData = function(params) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            var seriesIndex = params.seriesIndex;
            var ecModel = this.getModel();
            var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
            seriesModel.appendData(params);
            this._scheduler.unfinished = true;
            this.getZr().wakeUp();
        };
        ECharts.internalField = function() {
            $61f525521022d020$var$prepare = function(ecIns) {
                var scheduler = ecIns._scheduler;
                scheduler.restorePipelines(ecIns._model);
                scheduler.prepareStageTasks();
                $61f525521022d020$var$prepareView(ecIns, true);
                $61f525521022d020$var$prepareView(ecIns, false);
                scheduler.plan();
            };
            $61f525521022d020$var$prepareView = function(ecIns, isComponent) {
                var ecModel = ecIns._model;
                var scheduler = ecIns._scheduler;
                var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
                var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
                var zr = ecIns._zr;
                var api = ecIns._api;
                for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
                isComponent ? ecModel.eachComponent(function(componentType, model) {
                    componentType !== 'series' && doPrepare(model);
                }) : ecModel.eachSeries(doPrepare);
                function doPrepare(model) {
                    var requireNewView = model.__requireNewView;
                    model.__requireNewView = false;
                    var viewId = '_ec_' + model.id + '_' + model.type;
                    var view = !requireNewView && viewMap[viewId];
                    if (!view) {
                        var classType = (0, (0, parcelRequire("aLwh0")).parseClassType)(model.type);
                        var Clazz = isComponent ? (0, (0, parcelRequire("fkskt")).default).getClass(classType.main, classType.sub) : (0, (0, parcelRequire("loerw")).default).getClass(classType.sub);
                        view = new Clazz();
                        view.init(ecModel, api);
                        viewMap[viewId] = view;
                        viewList.push(view);
                        zr.add(view.group);
                    }
                    model.__viewId = view.__id = viewId;
                    view.__alive = true;
                    view.__model = model;
                    view.group.__ecComponentInfo = {
                        mainType: model.mainType,
                        index: model.componentIndex
                    };
                    !isComponent && scheduler.prepareView(view, model, ecModel, api);
                }
                for(var i = 0; i < viewList.length;){
                    var view = viewList[i];
                    if (!view.__alive) {
                        !isComponent && view.renderTask.dispose();
                        zr.remove(view.group);
                        view.dispose(ecModel, api);
                        viewList.splice(i, 1);
                        if (viewMap[view.__id] === view) delete viewMap[view.__id];
                        view.__id = view.group.__ecComponentInfo = null;
                    } else i++;
                }
            };
            $61f525521022d020$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
                var ecModel = ecIns._model;
                ecModel.setUpdatePayload(payload);
                if (!mainType) {
                    (0, (0, parcelRequire("bahqM")).each)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                    return;
                }
                var query = {};
                query[mainType + 'Id'] = payload[mainType + 'Id'];
                query[mainType + 'Index'] = payload[mainType + 'Index'];
                query[mainType + 'Name'] = payload[mainType + 'Name'];
                var condition = {
                    mainType: mainType,
                    query: query
                };
                subType && (condition.subType = subType);
                var excludeSeriesId = payload.excludeSeriesId;
                var excludeSeriesIdMap;
                if (excludeSeriesId != null) {
                    excludeSeriesIdMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
                    (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(excludeSeriesId), function(id) {
                        var modelId = (0, parcelRequire("eaKsF")).convertOptionIdName(id, null);
                        if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                    });
                }
                if ((0, (0, parcelRequire("fIXXx")).isHighDownPayload)(payload)) (0, (0, parcelRequire("fIXXx")).allLeaveBlur)(ecIns._api);
                ecModel && ecModel.eachComponent(condition, function(model) {
                    var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                    if (isExcluded) return;
                    if ((0, (0, parcelRequire("fIXXx")).isHighDownPayload)(payload)) {
                        if (model instanceof (0, (0, parcelRequire("1O7Ua")).default)) {
                            if (payload.type === (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE) && !payload.notBlur) (0, (0, parcelRequire("fIXXx")).blurSeriesFromHighlightPayload)(model, payload, ecIns._api);
                        } else {
                            var _a = (0, (0, parcelRequire("fIXXx")).findComponentHighDownDispatchers)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                            if (payload.type === (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE) && focusSelf && !payload.notBlur) (0, (0, parcelRequire("fIXXx")).blurComponent)(model.mainType, model.componentIndex, ecIns._api);
                            if (dispatchers) (0, (0, parcelRequire("bahqM")).each)(dispatchers, function(dispatcher) {
                                payload.type === (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE) ? (0, (0, parcelRequire("fIXXx")).enterEmphasis)(dispatcher) : (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(dispatcher);
                            });
                        }
                    } else if ((0, (0, parcelRequire("fIXXx")).isSelectChangePayload)(payload)) {
                        if (model instanceof (0, (0, parcelRequire("1O7Ua")).default)) {
                            (0, (0, parcelRequire("fIXXx")).toggleSelectionFromPayload)(model, payload, ecIns._api);
                            (0, (0, parcelRequire("fIXXx")).updateSeriesElementSelection)(model);
                            $61f525521022d020$var$markStatusToUpdate(ecIns);
                        }
                    }
                }, ecIns);
                ecModel && ecModel.eachComponent(condition, function(model) {
                    var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                    if (isExcluded) return;
                    callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
                }, ecIns);
                function callView(view) {
                    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
                }
            };
            $61f525521022d020$var$updateMethods = {
                prepareAndUpdate: function(payload) {
                    $61f525521022d020$var$prepare(this);
                    $61f525521022d020$var$updateMethods.update.call(this, payload, {
                        optionChanged: payload.newOption != null
                    });
                },
                update: function(payload, updateParams) {
                    var ecModel = this._model;
                    var api = this._api;
                    var zr = this._zr;
                    var coordSysMgr = this._coordSysMgr;
                    var scheduler = this._scheduler;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    scheduler.restoreData(ecModel, payload);
                    scheduler.performSeriesTasks(ecModel);
                    coordSysMgr.create(ecModel, api);
                    scheduler.performDataProcessorTasks(ecModel, payload);
                    $61f525521022d020$var$updateStreamModes(this, ecModel);
                    coordSysMgr.update(ecModel, api);
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    scheduler.performVisualTasks(ecModel, payload);
                    $61f525521022d020$var$render(this, ecModel, api, payload, updateParams);
                    var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                    var darkMode = ecModel.get('darkMode');
                    if (!(0, (0, parcelRequire("hZfwb")).default).canvasSupported) {
                        var colorArr = (0, parcelRequire("d6udH")).parse(backgroundColor);
                        backgroundColor = (0, parcelRequire("d6udH")).stringify(colorArr, 'rgb');
                        if (colorArr[3] === 0) backgroundColor = 'transparent';
                    } else {
                        zr.setBackgroundColor(backgroundColor);
                        if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                    }
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, api);
                },
                updateTransform: function(payload) {
                    var _this = this;
                    var ecModel = this._model;
                    var api = this._api;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    var componentDirtyList = [];
                    ecModel.eachComponent(function(componentType, componentModel) {
                        if (componentType === 'series') return;
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        if (componentView && componentView.__alive) {
                            if (componentView.updateTransform) {
                                var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                                result && result.update && componentDirtyList.push(componentView);
                            } else componentDirtyList.push(componentView);
                        }
                    });
                    var seriesDirtyMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
                    ecModel.eachSeries(function(seriesModel) {
                        var chartView = _this._chartsMap[seriesModel.__viewId];
                        if (chartView.updateTransform) {
                            var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                            result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                        } else seriesDirtyMap.set(seriesModel.uid, 1);
                    });
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    this._scheduler.performVisualTasks(ecModel, payload, {
                        setDirty: true,
                        dirtyMap: seriesDirtyMap
                    });
                    $61f525521022d020$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, api);
                },
                updateView: function(payload) {
                    var ecModel = this._model;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    (0, (0, parcelRequire("loerw")).default).markUpdateMethod(payload, 'updateView');
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    this._scheduler.performVisualTasks(ecModel, payload, {
                        setDirty: true
                    });
                    $61f525521022d020$var$render(this, ecModel, this._api, payload, {});
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, this._api);
                },
                updateVisual: function(payload) {
                    var _this = this;
                    var ecModel = this._model;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    ecModel.eachSeries(function(seriesModel) {
                        seriesModel.getData().clearAllVisual();
                    });
                    (0, (0, parcelRequire("loerw")).default).markUpdateMethod(payload, 'updateVisual');
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    this._scheduler.performVisualTasks(ecModel, payload, {
                        visualType: 'visual',
                        setDirty: true
                    });
                    ecModel.eachComponent(function(componentType, componentModel) {
                        if (componentType !== 'series') {
                            var componentView = _this.getViewOfComponentModel(componentModel);
                            componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                        }
                    });
                    ecModel.eachSeries(function(seriesModel) {
                        var chartView = _this._chartsMap[seriesModel.__viewId];
                        chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                    });
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, this._api);
                },
                updateLayout: function(payload) {
                    $61f525521022d020$var$updateMethods.update.call(this, payload);
                }
            };
            $61f525521022d020$var$doConvertPixel = function(ecIns, methodName, finder, value) {
                if (ecIns._disposed) {
                    $61f525521022d020$var$disposedWarning(ecIns.id);
                    return;
                }
                var ecModel = ecIns._model;
                var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
                var result;
                var parsedFinder = (0, parcelRequire("eaKsF")).parseFinder(ecModel, finder);
                for(var i = 0; i < coordSysList.length; i++){
                    var coordSys = coordSysList[i];
                    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
                }
            };
            $61f525521022d020$var$updateStreamModes = function(ecIns, ecModel) {
                var chartsMap = ecIns._chartsMap;
                var scheduler = ecIns._scheduler;
                ecModel.eachSeries(function(seriesModel) {
                    scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
                });
            };
            $61f525521022d020$var$doDispatchAction = function(payload, silent) {
                var _this = this;
                var ecModel = this.getModel();
                var payloadType = payload.type;
                var escapeConnect = payload.escapeConnect;
                var actionWrap = $61f525521022d020$var$actions[payloadType];
                var actionInfo = actionWrap.actionInfo;
                var cptTypeTmp = (actionInfo.update || 'update').split(':');
                var updateMethod = cptTypeTmp.pop();
                var cptType = cptTypeTmp[0] != null && (0, (0, parcelRequire("aLwh0")).parseClassType)(cptTypeTmp[0]);
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
                var payloads = [
                    payload
                ];
                var batched = false;
                if (payload.batch) {
                    batched = true;
                    payloads = (0, (0, parcelRequire("bahqM")).map)(payload.batch, function(item) {
                        item = (0, (0, parcelRequire("bahqM")).defaults)((0, (0, parcelRequire("bahqM")).extend)({}, item), payload);
                        item.batch = null;
                        return item;
                    });
                }
                var eventObjBatch = [];
                var eventObj;
                var isSelectChange = (0, (0, parcelRequire("fIXXx")).isSelectChangePayload)(payload);
                var isHighDown = (0, (0, parcelRequire("fIXXx")).isHighDownPayload)(payload);
                (0, (0, parcelRequire("bahqM")).each)(payloads, function(batchItem) {
                    eventObj = actionWrap.action(batchItem, _this._model, _this._api);
                    eventObj = eventObj || (0, (0, parcelRequire("bahqM")).extend)({}, batchItem);
                    eventObj.type = actionInfo.event || eventObj.type;
                    eventObjBatch.push(eventObj);
                    if (isHighDown) {
                        var _a = (0, parcelRequire("eaKsF")).preParseFinder(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                        var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                        $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                        $61f525521022d020$var$markStatusToUpdate(_this);
                    } else if (isSelectChange) {
                        $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                        $61f525521022d020$var$markStatusToUpdate(_this);
                    } else if (cptType) $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
                });
                if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) {
                    if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                        $61f525521022d020$var$prepare(this);
                        $61f525521022d020$var$updateMethods.update.call(this, payload);
                        this[$61f525521022d020$var$PENDING_UPDATE] = null;
                    } else $61f525521022d020$var$updateMethods[updateMethod].call(this, payload);
                }
                if (batched) eventObj = {
                    type: actionInfo.event || payloadType,
                    escapeConnect: escapeConnect,
                    batch: eventObjBatch
                };
                else eventObj = eventObjBatch[0];
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                if (!silent) {
                    var messageCenter = this._messageCenter;
                    messageCenter.trigger(eventObj.type, eventObj);
                    if (isSelectChange) {
                        var newObj = {
                            type: 'selectchanged',
                            escapeConnect: escapeConnect,
                            selected: (0, (0, parcelRequire("fIXXx")).getAllSelectedIndices)(ecModel),
                            isFromClick: payload.isFromClick || false,
                            fromAction: payload.type,
                            fromActionPayload: payload
                        };
                        messageCenter.trigger(newObj.type, newObj);
                    }
                }
            };
            $61f525521022d020$var$flushPendingActions = function(silent) {
                var pendingActions = this._pendingActions;
                while(pendingActions.length){
                    var payload = pendingActions.shift();
                    $61f525521022d020$var$doDispatchAction.call(this, payload, silent);
                }
            };
            $61f525521022d020$var$triggerUpdatedEvent = function(silent) {
                !silent && this.trigger('updated');
            };
            $61f525521022d020$var$bindRenderedEvent = function(zr, ecIns) {
                zr.on('rendered', function(params) {
                    ecIns.trigger('rendered', params);
                    if (zr.animation.isFinished() && !ecIns[$61f525521022d020$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
                });
            };
            $61f525521022d020$var$bindMouseEvent = function(zr, ecIns) {
                zr.on('mouseover', function(e) {
                    var el = e.target;
                    var dispatcher = (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, (0, (0, parcelRequire("fIXXx")).isHighDownDispatcher));
                    if (dispatcher) {
                        (0, (0, parcelRequire("fIXXx")).handleGlobalMouseOverForHighDown)(dispatcher, e, ecIns._api);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    }
                }).on('mouseout', function(e) {
                    var el = e.target;
                    var dispatcher = (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, (0, (0, parcelRequire("fIXXx")).isHighDownDispatcher));
                    if (dispatcher) {
                        (0, (0, parcelRequire("fIXXx")).handleGlboalMouseOutForHighDown)(dispatcher, e, ecIns._api);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    }
                }).on('click', function(e) {
                    var el = e.target;
                    var dispatcher = (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, function(target) {
                        return (0, (0, parcelRequire("7QjoM")).getECData)(target).dataIndex != null;
                    }, true);
                    if (dispatcher) {
                        var actionType = dispatcher.selected ? 'unselect' : 'select';
                        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
                        ecIns._api.dispatchAction({
                            type: actionType,
                            dataType: ecData.dataType,
                            dataIndexInside: ecData.dataIndex,
                            seriesIndex: ecData.seriesIndex,
                            isFromClick: true
                        });
                    }
                });
            };
            $61f525521022d020$var$clearColorPalette = function(ecModel) {
                ecModel.clearColorPalette();
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.clearColorPalette();
                });
            };
            $61f525521022d020$var$render = function(ecIns, ecModel, api, payload, updateParams) {
                $61f525521022d020$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
                (0, (0, parcelRequire("bahqM")).each)(ecIns._chartsViews, function(chart) {
                    chart.__alive = false;
                });
                $61f525521022d020$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
                (0, (0, parcelRequire("bahqM")).each)(ecIns._chartsViews, function(chart) {
                    if (!chart.__alive) chart.remove(ecModel, api);
                });
            };
            $61f525521022d020$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
                (0, (0, parcelRequire("bahqM")).each)(dirtyList || ecIns._componentsViews, function(componentView) {
                    var componentModel = componentView.__model;
                    clearStates(componentModel, componentView);
                    componentView.render(componentModel, ecModel, api, payload);
                    updateZ(componentModel, componentView);
                    updateStates(componentModel, componentView);
                });
            };
            $61f525521022d020$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
                var scheduler = ecIns._scheduler;
                updateParams = (0, (0, parcelRequire("bahqM")).extend)(updateParams || {}, {
                    updatedSeries: ecModel.getSeries()
                });
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:beforeupdate', ecModel, api, updateParams);
                var unfinished = false;
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    chartView.__alive = true;
                    var renderTask = chartView.renderTask;
                    scheduler.updatePayload(renderTask, payload);
                    clearStates(seriesModel, chartView);
                    if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                    if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                    chartView.group.silent = !!seriesModel.get('silent');
                    updateBlend(seriesModel, chartView);
                    (0, (0, parcelRequire("fIXXx")).updateSeriesElementSelection)(seriesModel);
                });
                scheduler.unfinished = unfinished || scheduler.unfinished;
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:layoutlabels', ecModel, api, updateParams);
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:transition', ecModel, api, updateParams);
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    updateZ(seriesModel, chartView);
                    updateStates(seriesModel, chartView);
                });
                updateHoverLayerStatus(ecIns, ecModel);
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:afterupdate', ecModel, api, updateParams);
            };
            $61f525521022d020$var$markStatusToUpdate = function(ecIns) {
                ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY] = true;
                ecIns.getZr().wakeUp();
            };
            $61f525521022d020$var$applyChangedStates = function(ecIns) {
                if (!ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY]) return;
                ecIns.getZr().storage.traverse(function(el) {
                    if ((0, parcelRequire("eYgMC")).isElementRemoved(el)) return;
                    applyElementStates(el);
                });
                ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY] = false;
            };
            function applyElementStates(el) {
                var newStates = [];
                var oldStates = el.currentStates;
                for(var i = 0; i < oldStates.length; i++){
                    var stateName = oldStates[i];
                    if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
                }
                if (el.selected && el.states.select) newStates.push('select');
                if (el.hoverState === (0, (0, parcelRequire("fIXXx")).HOVER_STATE_EMPHASIS) && el.states.emphasis) newStates.push('emphasis');
                else if (el.hoverState === (0, (0, parcelRequire("fIXXx")).HOVER_STATE_BLUR) && el.states.blur) newStates.push('blur');
                el.useStates(newStates);
            }
            function updateHoverLayerStatus(ecIns, ecModel) {
                var zr = ecIns._zr;
                var storage = zr.storage;
                var elCount = 0;
                storage.traverse(function(el) {
                    if (!el.isGroup) elCount++;
                });
                if (elCount > ecModel.get('hoverLayerThreshold') && !(0, (0, parcelRequire("hZfwb")).default).node && !(0, (0, parcelRequire("hZfwb")).default).worker) ecModel.eachSeries(function(seriesModel) {
                    if (seriesModel.preventUsingHoverLayer) return;
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    if (chartView.__alive) chartView.group.traverse(function(el) {
                        if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                    });
                });
            }
            function updateBlend(seriesModel, chartView) {
                var blendMode = seriesModel.get('blendMode') || null;
                chartView.group.traverse(function(el) {
                    if (!el.isGroup) el.style.blend = blendMode;
                    if (el.eachPendingDisplayable) el.eachPendingDisplayable(function(displayable) {
                        displayable.style.blend = blendMode;
                    });
                });
            }
            function updateZ(model, view) {
                if (model.preventAutoZ) return;
                _updateZ(view.group, model.get('z') || 0, model.get('zlevel') || 0, -Infinity);
            }
            function _updateZ(el, z, zlevel, maxZ2) {
                var label = el.getTextContent();
                var labelLine = el.getTextGuideLine();
                var isGroup = el.isGroup;
                if (isGroup) {
                    var children = el.childrenRef();
                    for(var i = 0; i < children.length; i++)maxZ2 = Math.max(_updateZ(children[i], z, zlevel, maxZ2), maxZ2);
                } else {
                    el.z = z;
                    el.zlevel = zlevel;
                    maxZ2 = Math.max(el.z2, maxZ2);
                }
                if (label) {
                    label.z = z;
                    label.zlevel = zlevel;
                    isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
                }
                if (labelLine) {
                    var textGuideLineConfig = el.textGuideLineConfig;
                    labelLine.z = z;
                    labelLine.zlevel = zlevel;
                    isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
                }
                return maxZ2;
            }
            function clearStates(model, view) {
                view.group.traverse(function(el) {
                    if ((0, parcelRequire("eYgMC")).isElementRemoved(el)) return;
                    var textContent = el.getTextContent();
                    var textGuide = el.getTextGuideLine();
                    if (el.stateTransition) el.stateTransition = null;
                    if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                    if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                    if (el.hasState()) {
                        el.prevStates = el.currentStates;
                        el.clearStates();
                    } else if (el.prevStates) el.prevStates = null;
                });
            }
            function updateStates(model, view) {
                var stateAnimationModel = model.getModel('stateAnimation');
                var enableAnimation = model.isAnimationEnabled();
                var duration = stateAnimationModel.get('duration');
                var stateTransition = duration > 0 ? {
                    duration: duration,
                    delay: stateAnimationModel.get('delay'),
                    easing: stateAnimationModel.get('easing')
                } : null;
                view.group.traverse(function(el) {
                    if (el.states && el.states.emphasis) {
                        if ((0, parcelRequire("eYgMC")).isElementRemoved(el)) return;
                        if (el instanceof (0, parcelRequire("ghQ8v")).default) (0, (0, parcelRequire("fIXXx")).savePathStates)(el);
                        if (el.__dirty) {
                            var prevStates = el.prevStates;
                            if (prevStates) el.useStates(prevStates);
                        }
                        if (enableAnimation) {
                            el.stateTransition = stateTransition;
                            var textContent = el.getTextContent();
                            var textGuide = el.getTextGuideLine();
                            if (textContent) textContent.stateTransition = stateTransition;
                            if (textGuide) textGuide.stateTransition = stateTransition;
                        }
                        if (el.__dirty) applyElementStates(el);
                    }
                });
            }
            $61f525521022d020$var$createExtensionAPI = function(ecIns) {
                return new (function(_super) {
                    (0, (0, parcelRequire("3VFsf")).__extends)(class_1, _super);
                    function class_1() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    class_1.prototype.getCoordinateSystems = function() {
                        return ecIns._coordSysMgr.getCoordinateSystems();
                    };
                    class_1.prototype.getComponentByElement = function(el) {
                        while(el){
                            var modelInfo = el.__ecComponentInfo;
                            if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                            el = el.parent;
                        }
                    };
                    class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                        (0, (0, parcelRequire("fIXXx")).enterEmphasis)(el, highlightDigit);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                        (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(el, highlightDigit);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.enterBlur = function(el) {
                        (0, (0, parcelRequire("fIXXx")).enterBlur)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.leaveBlur = function(el) {
                        (0, (0, parcelRequire("fIXXx")).leaveBlur)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.enterSelect = function(el) {
                        (0, (0, parcelRequire("fIXXx")).enterSelect)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.leaveSelect = function(el) {
                        (0, (0, parcelRequire("fIXXx")).leaveSelect)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.getModel = function() {
                        return ecIns.getModel();
                    };
                    class_1.prototype.getViewOfComponentModel = function(componentModel) {
                        return ecIns.getViewOfComponentModel(componentModel);
                    };
                    class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                        return ecIns.getViewOfSeriesModel(seriesModel);
                    };
                    return class_1;
                }((0, (0, parcelRequire("iEvqc")).default)))(ecIns);
            };
            $61f525521022d020$var$enableConnect = function(chart) {
                function updateConnectedChartsStatus(charts, status) {
                    for(var i = 0; i < charts.length; i++){
                        var otherChart = charts[i];
                        otherChart[$61f525521022d020$var$CONNECT_STATUS_KEY] = status;
                    }
                }
                (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$eventActionMap, function(actionType, eventType) {
                    chart._messageCenter.on(eventType, function(event) {
                        if ($61f525521022d020$var$connectedGroups[chart.group] && chart[$61f525521022d020$var$CONNECT_STATUS_KEY] !== $61f525521022d020$var$CONNECT_STATUS_PENDING) {
                            if (event && event.escapeConnect) return;
                            var action_1 = chart.makeActionFromEvent(event);
                            var otherCharts_1 = [];
                            (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$instances, function(otherChart) {
                                if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                            });
                            updateConnectedChartsStatus(otherCharts_1, $61f525521022d020$var$CONNECT_STATUS_PENDING);
                            (0, (0, parcelRequire("bahqM")).each)(otherCharts_1, function(otherChart) {
                                if (otherChart[$61f525521022d020$var$CONNECT_STATUS_KEY] !== $61f525521022d020$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                            });
                            updateConnectedChartsStatus(otherCharts_1, $61f525521022d020$var$CONNECT_STATUS_UPDATED);
                        }
                    });
                });
            };
        }();
        return ECharts;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $61f525521022d020$var$echartsProto = $61f525521022d020$var$ECharts.prototype;
    $61f525521022d020$var$echartsProto.on = $61f525521022d020$var$createRegisterEventWithLowercaseECharts('on');
    $61f525521022d020$var$echartsProto.off = $61f525521022d020$var$createRegisterEventWithLowercaseECharts('off');
    $61f525521022d020$var$echartsProto.one = function(eventName, cb, ctx) {
        var self = this;
        (0, (0, parcelRequire("2cFRc")).deprecateLog)('ECharts#one is deprecated.');
        function wrapped() {
            var args2 = [];
            for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
            cb && cb.apply && cb.apply(this, args2);
            self.off(eventName, wrapped);
        }
        this.on.call(this, eventName, wrapped, ctx);
    };
    var $61f525521022d020$var$MOUSE_EVENT_NAMES = [
        'click',
        'dblclick',
        'mouseover',
        'mouseout',
        'mousemove',
        'mousedown',
        'mouseup',
        'globalout',
        'contextmenu'
    ];
    function $61f525521022d020$var$disposedWarning(id) {}
    var $61f525521022d020$var$actions = {};
    var $61f525521022d020$var$eventActionMap = {};
    var $61f525521022d020$var$dataProcessorFuncs = [];
    var $61f525521022d020$var$optionPreprocessorFuncs = [];
    var $61f525521022d020$var$visualFuncs = [];
    var $61f525521022d020$var$themeStorage = {};
    var $61f525521022d020$var$loadingEffects = {};
    var $61f525521022d020$var$instances = {};
    var $61f525521022d020$var$connectedGroups = {};
    var $61f525521022d020$var$idBase = +new Date() - 0;
    var $61f525521022d020$var$groupIdBase = +new Date() - 0;
    var $61f525521022d020$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
    function $61f525521022d020$export$2cd8252107eb640b(dom, theme, opts) {
        var existInstance = $61f525521022d020$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
        var chart = new $61f525521022d020$var$ECharts(dom, theme, opts);
        chart.id = 'ec_' + $61f525521022d020$var$idBase++;
        $61f525521022d020$var$instances[chart.id] = chart;
        (0, parcelRequire("eaKsF")).setAttribute(dom, $61f525521022d020$var$DOM_ATTRIBUTE_KEY, chart.id);
        $61f525521022d020$var$enableConnect(chart);
        (0, (0, parcelRequire("8cCW2")).default).trigger('afterinit', chart);
        return chart;
    }
    function $61f525521022d020$export$64605811ab45167f(groupId) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(groupId)) {
            var charts = groupId;
            groupId = null;
            (0, (0, parcelRequire("bahqM")).each)(charts, function(chart) {
                if (chart.group != null) groupId = chart.group;
            });
            groupId = groupId || 'g_' + $61f525521022d020$var$groupIdBase++;
            (0, (0, parcelRequire("bahqM")).each)(charts, function(chart) {
                chart.group = groupId;
            });
        }
        $61f525521022d020$var$connectedGroups[groupId] = true;
        return groupId;
    }
    function $61f525521022d020$export$87cd6834112ecb52(groupId) {
        $61f525521022d020$var$connectedGroups[groupId] = false;
    }
    var $61f525521022d020$export$37dfea93db2e14ed = $61f525521022d020$export$87cd6834112ecb52;
    function $61f525521022d020$export$fcfbbcec2cb820d5(chart) {
        if (typeof chart === 'string') chart = $61f525521022d020$var$instances[chart];
        else if (!(chart instanceof $61f525521022d020$var$ECharts)) chart = $61f525521022d020$export$33b6fbccd4f643f8(chart);
        if (chart instanceof $61f525521022d020$var$ECharts && !chart.isDisposed()) chart.dispose();
    }
    function $61f525521022d020$export$33b6fbccd4f643f8(dom) {
        return $61f525521022d020$var$instances[(0, parcelRequire("eaKsF")).getAttribute(dom, $61f525521022d020$var$DOM_ATTRIBUTE_KEY)];
    }
    function $61f525521022d020$export$89b4be35062c4a3f(key) {
        return $61f525521022d020$var$instances[key];
    }
    function $61f525521022d020$export$f9c59eed5de5ff80(name, theme) {
        $61f525521022d020$var$themeStorage[name] = theme;
    }
    function $61f525521022d020$export$77095792a057b768(preprocessorFunc) {
        if ((0, (0, parcelRequire("bahqM")).indexOf)($61f525521022d020$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $61f525521022d020$var$optionPreprocessorFuncs.push(preprocessorFunc);
    }
    function $61f525521022d020$export$d575e6557ac1729f(priority, processor) {
        $61f525521022d020$var$normalizeRegister($61f525521022d020$var$dataProcessorFuncs, priority, processor, $61f525521022d020$var$PRIORITY_PROCESSOR_DEFAULT);
    }
    function $61f525521022d020$export$c8c249911ee8c1ed(postInitFunc) {
        $61f525521022d020$export$c9ec4b5faef04865('afterinit', postInitFunc);
    }
    function $61f525521022d020$export$99560909c18c76bb(postUpdateFunc) {
        $61f525521022d020$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
    }
    function $61f525521022d020$export$c9ec4b5faef04865(name, cb) {
        (0, (0, parcelRequire("8cCW2")).default).on(name, cb);
    }
    function $61f525521022d020$export$408c24786cd729c6(actionInfo, eventName, action) {
        if (typeof eventName === 'function') {
            action = eventName;
            eventName = '';
        }
        var actionType = (0, (0, parcelRequire("bahqM")).isObject)(actionInfo) ? actionInfo.type : [
            actionInfo,
            actionInfo = {
                event: eventName
            }
        ][0];
        actionInfo.event = (actionInfo.event || actionType).toLowerCase();
        eventName = actionInfo.event;
        if ($61f525521022d020$var$eventActionMap[eventName]) return;
        (0, (0, parcelRequire("bahqM")).assert)($61f525521022d020$var$ACTION_REG.test(actionType) && $61f525521022d020$var$ACTION_REG.test(eventName));
        if (!$61f525521022d020$var$actions[actionType]) $61f525521022d020$var$actions[actionType] = {
            action: action,
            actionInfo: actionInfo
        };
        $61f525521022d020$var$eventActionMap[eventName] = actionType;
    }
    function $61f525521022d020$export$1dd5e025a8a37dd(type, coordSysCreator) {
        (0, (0, parcelRequire("gyhNQ")).default).register(type, coordSysCreator);
    }
    function $61f525521022d020$export$fc2638719e4159b9(type) {
        var coordSysCreator = (0, (0, parcelRequire("gyhNQ")).default).get(type);
        if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
    }
    function $61f525521022d020$export$d768f97700ca6bea(priority, layoutTask) {
        $61f525521022d020$var$normalizeRegister($61f525521022d020$var$visualFuncs, priority, layoutTask, $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT, 'layout');
    }
    function $61f525521022d020$export$5f32c1eb94c381bb(priority, visualTask) {
        $61f525521022d020$var$normalizeRegister($61f525521022d020$var$visualFuncs, priority, visualTask, $61f525521022d020$var$PRIORITY_VISUAL_CHART, 'visual');
    }
    var $61f525521022d020$var$registeredTasks = [];
    function $61f525521022d020$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
        if ((0, (0, parcelRequire("bahqM")).isFunction)(priority) || (0, (0, parcelRequire("bahqM")).isObject)(priority)) {
            fn = priority;
            priority = defaultPriority;
        }
        if ((0, (0, parcelRequire("bahqM")).indexOf)($61f525521022d020$var$registeredTasks, fn) >= 0) return;
        $61f525521022d020$var$registeredTasks.push(fn);
        var stageHandler = (0, (0, parcelRequire("14WFd")).default).wrapStageHandler(fn, visualType);
        stageHandler.__prio = priority;
        stageHandler.__raw = fn;
        targetList.push(stageHandler);
    }
    function $61f525521022d020$export$e06b68a82007c015(name, loadingFx) {
        $61f525521022d020$var$loadingEffects[name] = loadingFx;
    }
    function $61f525521022d020$export$10425ea7a243b114(creator) {
        (0, (0, parcelRequire("bahqM")).$override)('createCanvas', creator);
    }
    function $61f525521022d020$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
        (0, (0, parcelRequire("fEzwg")).default).registerMap(mapName, geoJson, specialAreas);
    }
    function $61f525521022d020$export$b8586192aead8a7e(mapName) {
        return (0, (0, parcelRequire("fEzwg")).default).getMapForUser(mapName);
    }
    var $61f525521022d020$export$f01d71dd0389d7e4 = (0, (0, parcelRequire("05ab4")).registerExternalTransform);
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_GLOBAL, (0, (0, parcelRequire("cvEVp")).seriesStyleTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, (0, parcelRequire("cvEVp")).dataStyleTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, (0, parcelRequire("cvEVp")).dataColorPaletteTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_GLOBAL, (0, (0, parcelRequire("7wiHx")).seriesSymbolTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, (0, parcelRequire("7wiHx")).dataSymbolTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_DECAL, (0, (0, parcelRequire("g2DhS")).default));
    $61f525521022d020$export$77095792a057b768((0, (0, parcelRequire("driCQ")).default));
    $61f525521022d020$export$d575e6557ac1729f($61f525521022d020$var$PRIORITY_PROCESSOR_DATASTACK, (0, (0, parcelRequire("iMppY")).default));
    $61f525521022d020$export$e06b68a82007c015('default', (0, (0, parcelRequire("4G956")).default));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).DOWNPLAY_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).DOWNPLAY_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).DOWNPLAY_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).SELECT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).SELECT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).SELECT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).UNSELECT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).UNSELECT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).UNSELECT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).TOGGLE_SELECT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).TOGGLE_SELECT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).TOGGLE_SELECT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$f9c59eed5de5ff80('light', (0, (0, parcelRequire("31FQc")).default));
    $61f525521022d020$export$f9c59eed5de5ff80('dark', (0, (0, parcelRequire("dMJCs")).default));
    var $61f525521022d020$export$73cae5e090579589 = {};
});
parcelRegister("9Y5KT", function(module, exports) {
    $parcel$export(module.exports, "init", ()=>$741e2e865750343c$export$2cd8252107eb640b);
    $parcel$export(module.exports, "dispose", ()=>$741e2e865750343c$export$fcfbbcec2cb820d5);
    $parcel$export(module.exports, "disposeAll", ()=>$741e2e865750343c$export$825f692fb04800ef);
    $parcel$export(module.exports, "getInstance", ()=>$741e2e865750343c$export$8bedcca5bbd73999);
    $parcel$export(module.exports, "registerPainter", ()=>$741e2e865750343c$export$a3e793ccb11823a5);
    $parcel$export(module.exports, "version", ()=>$741e2e865750343c$export$83d89fbfd8236492);
    var $hZfwb;
    var $bahqM;
    var $jaJTK;
    var $66sfA;
    var $F44Dl;
    var $bHSYT;
    var $d6udH;
    var $7y1my;
    var $4KVOr;
    var $741e2e865750343c$var$useVML = !(0, (0, parcelRequire("hZfwb")).default).canvasSupported;
    var $741e2e865750343c$var$painterCtors = {};
    var $741e2e865750343c$var$instances = {};
    function $741e2e865750343c$var$delInstance(id) {
        delete $741e2e865750343c$var$instances[id];
    }
    function $741e2e865750343c$var$isDarkMode(backgroundColor) {
        if (!backgroundColor) return false;
        if (typeof backgroundColor === 'string') return (0, (0, parcelRequire("d6udH")).lum)(backgroundColor, 1) < (0, (0, parcelRequire("7y1my")).DARK_MODE_THRESHOLD);
        else if (backgroundColor.colorStops) {
            var colorStops = backgroundColor.colorStops;
            var totalLum = 0;
            var len = colorStops.length;
            for(var i = 0; i < len; i++)totalLum += (0, (0, parcelRequire("d6udH")).lum)(colorStops[i].color, 1);
            totalLum /= len;
            return totalLum < (0, (0, parcelRequire("7y1my")).DARK_MODE_THRESHOLD);
        }
        return false;
    }
    var $741e2e865750343c$var$ZRender = function() {
        function ZRender(id, dom, opts) {
            var _this = this;
            this._sleepAfterStill = 10;
            this._stillFrameAccum = 0;
            this._needsRefresh = true;
            this._needsRefreshHover = true;
            this._darkMode = false;
            opts = opts || {};
            this.dom = dom;
            this.id = id;
            var storage = new (0, (0, parcelRequire("66sfA")).default)();
            var rendererType = opts.renderer || 'canvas';
            if ($741e2e865750343c$var$useVML) throw new Error('IE8 support has been dropped since 5.0');
            if (!$741e2e865750343c$var$painterCtors[rendererType]) rendererType = (0, parcelRequire("bahqM")).keys($741e2e865750343c$var$painterCtors)[0];
            if (!$741e2e865750343c$var$painterCtors[rendererType]) throw new Error("Renderer '" + rendererType + "' is not imported. Please import it first.");
            opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
            var painter = new $741e2e865750343c$var$painterCtors[rendererType](dom, storage, opts, id);
            this.storage = storage;
            this.painter = painter;
            var handerProxy = !(0, (0, parcelRequire("hZfwb")).default).node && !(0, (0, parcelRequire("hZfwb")).default).worker ? new (0, (0, parcelRequire("bHSYT")).default)(painter.getViewportRoot(), painter.root) : null;
            this.handler = new (0, (0, parcelRequire("jaJTK")).default)(storage, painter, handerProxy, painter.root);
            this.animation = new (0, (0, parcelRequire("F44Dl")).default)({
                stage: {
                    update: function() {
                        return _this._flush(true);
                    }
                }
            });
            this.animation.start();
        }
        ZRender.prototype.add = function(el) {
            if (!el) return;
            this.storage.addRoot(el);
            el.addSelfToZr(this);
            this.refresh();
        };
        ZRender.prototype.remove = function(el) {
            if (!el) return;
            this.storage.delRoot(el);
            el.removeSelfFromZr(this);
            this.refresh();
        };
        ZRender.prototype.configLayer = function(zLevel, config) {
            if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
            this.refresh();
        };
        ZRender.prototype.setBackgroundColor = function(backgroundColor) {
            if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
            this.refresh();
            this._backgroundColor = backgroundColor;
            this._darkMode = $741e2e865750343c$var$isDarkMode(backgroundColor);
        };
        ZRender.prototype.getBackgroundColor = function() {
            return this._backgroundColor;
        };
        ZRender.prototype.setDarkMode = function(darkMode) {
            this._darkMode = darkMode;
        };
        ZRender.prototype.isDarkMode = function() {
            return this._darkMode;
        };
        ZRender.prototype.refreshImmediately = function(fromInside) {
            if (!fromInside) this.animation.update(true);
            this._needsRefresh = false;
            this.painter.refresh();
            this._needsRefresh = false;
        };
        ZRender.prototype.refresh = function() {
            this._needsRefresh = true;
            this.animation.start();
        };
        ZRender.prototype.flush = function() {
            this._flush(false);
        };
        ZRender.prototype._flush = function(fromInside) {
            var triggerRendered;
            var start = new Date().getTime();
            if (this._needsRefresh) {
                triggerRendered = true;
                this.refreshImmediately(fromInside);
            }
            if (this._needsRefreshHover) {
                triggerRendered = true;
                this.refreshHoverImmediately();
            }
            var end = new Date().getTime();
            if (triggerRendered) {
                this._stillFrameAccum = 0;
                this.trigger('rendered', {
                    elapsedTime: end - start
                });
            } else if (this._sleepAfterStill > 0) {
                this._stillFrameAccum++;
                if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
            }
        };
        ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
            this._sleepAfterStill = stillFramesCount;
        };
        ZRender.prototype.wakeUp = function() {
            this.animation.start();
            this._stillFrameAccum = 0;
        };
        ZRender.prototype.addHover = function(el) {};
        ZRender.prototype.removeHover = function(el) {};
        ZRender.prototype.clearHover = function() {};
        ZRender.prototype.refreshHover = function() {
            this._needsRefreshHover = true;
        };
        ZRender.prototype.refreshHoverImmediately = function() {
            this._needsRefreshHover = false;
            if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
        };
        ZRender.prototype.resize = function(opts) {
            opts = opts || {};
            this.painter.resize(opts.width, opts.height);
            this.handler.resize();
        };
        ZRender.prototype.clearAnimation = function() {
            this.animation.clear();
        };
        ZRender.prototype.getWidth = function() {
            return this.painter.getWidth();
        };
        ZRender.prototype.getHeight = function() {
            return this.painter.getHeight();
        };
        ZRender.prototype.pathToImage = function(e, dpr) {
            if (this.painter.pathToImage) return this.painter.pathToImage(e, dpr);
        };
        ZRender.prototype.setCursorStyle = function(cursorStyle) {
            this.handler.setCursorStyle(cursorStyle);
        };
        ZRender.prototype.findHover = function(x, y) {
            return this.handler.findHover(x, y);
        };
        ZRender.prototype.on = function(eventName, eventHandler, context) {
            this.handler.on(eventName, eventHandler, context);
            return this;
        };
        ZRender.prototype.off = function(eventName, eventHandler) {
            this.handler.off(eventName, eventHandler);
        };
        ZRender.prototype.trigger = function(eventName, event) {
            this.handler.trigger(eventName, event);
        };
        ZRender.prototype.clear = function() {
            var roots = this.storage.getRoots();
            for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, (0, parcelRequire("4KVOr")).default)) roots[i].removeSelfFromZr(this);
            this.storage.delAllRoots();
            this.painter.clear();
        };
        ZRender.prototype.dispose = function() {
            this.animation.stop();
            this.clear();
            this.storage.dispose();
            this.painter.dispose();
            this.handler.dispose();
            this.animation = this.storage = this.painter = this.handler = null;
            $741e2e865750343c$var$delInstance(this.id);
        };
        return ZRender;
    }();
    function $741e2e865750343c$export$2cd8252107eb640b(dom, opts) {
        var zr = new $741e2e865750343c$var$ZRender((0, parcelRequire("bahqM")).guid(), dom, opts);
        $741e2e865750343c$var$instances[zr.id] = zr;
        return zr;
    }
    function $741e2e865750343c$export$fcfbbcec2cb820d5(zr) {
        zr.dispose();
    }
    function $741e2e865750343c$export$825f692fb04800ef() {
        for(var key in $741e2e865750343c$var$instances)if ($741e2e865750343c$var$instances.hasOwnProperty(key)) $741e2e865750343c$var$instances[key].dispose();
        $741e2e865750343c$var$instances = {};
    }
    function $741e2e865750343c$export$8bedcca5bbd73999(id) {
        return $741e2e865750343c$var$instances[id];
    }
    function $741e2e865750343c$export$a3e793ccb11823a5(name, Ctor) {
        $741e2e865750343c$var$painterCtors[name] = Ctor;
    }
    var $741e2e865750343c$export$83d89fbfd8236492 = '5.2.1';
});
parcelRegister("jaJTK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df528de50090e0a1$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $eLEew;
    var $8qDpt;
    var $bRKv5;
    var $65X4x;
    var $jYjcX;
    var $df528de50090e0a1$var$SILENT = 'silent';
    function $df528de50090e0a1$var$makeEventPacket(eveType, targetInfo, event) {
        return {
            type: eveType,
            event: event,
            target: targetInfo.target,
            topTarget: targetInfo.topTarget,
            cancelBubble: false,
            offsetX: event.zrX,
            offsetY: event.zrY,
            gestureEvent: event.gestureEvent,
            pinchX: event.pinchX,
            pinchY: event.pinchY,
            pinchScale: event.pinchScale,
            wheelDelta: event.zrDelta,
            zrByTouch: event.zrByTouch,
            which: event.which,
            stop: $df528de50090e0a1$var$stopEvent
        };
    }
    function $df528de50090e0a1$var$stopEvent() {
        (0, parcelRequire("65X4x")).stop(this.event);
    }
    var $df528de50090e0a1$var$EmptyProxy = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(EmptyProxy, _super);
        function EmptyProxy() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handler = null;
            return _this;
        }
        EmptyProxy.prototype.dispose = function() {};
        EmptyProxy.prototype.setCursor = function() {};
        return EmptyProxy;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $df528de50090e0a1$var$HoveredResult = function() {
        function HoveredResult(x, y) {
            this.x = x;
            this.y = y;
        }
        return HoveredResult;
    }();
    var $df528de50090e0a1$var$handlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var $df528de50090e0a1$var$Handler = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Handler, _super);
        function Handler(storage, painter, proxy, painterRoot) {
            var _this = _super.call(this) || this;
            _this._hovered = new $df528de50090e0a1$var$HoveredResult(0, 0);
            _this.storage = storage;
            _this.painter = painter;
            _this.painterRoot = painterRoot;
            proxy = proxy || new $df528de50090e0a1$var$EmptyProxy();
            _this.proxy = null;
            _this.setHandlerProxy(proxy);
            _this._draggingMgr = new (0, (0, parcelRequire("8qDpt")).default)(_this);
            return _this;
        }
        Handler.prototype.setHandlerProxy = function(proxy) {
            if (this.proxy) this.proxy.dispose();
            if (proxy) {
                (0, parcelRequire("bahqM")).each($df528de50090e0a1$var$handlerNames, function(name) {
                    proxy.on && proxy.on(name, this[name], this);
                }, this);
                proxy.handler = this;
            }
            this.proxy = proxy;
        };
        Handler.prototype.mousemove = function(event) {
            var x = event.zrX;
            var y = event.zrY;
            var isOutside = $df528de50090e0a1$var$isOutsideBoundary(this, x, y);
            var lastHovered = this._hovered;
            var lastHoveredTarget = lastHovered.target;
            if (lastHoveredTarget && !lastHoveredTarget.__zr) {
                lastHovered = this.findHover(lastHovered.x, lastHovered.y);
                lastHoveredTarget = lastHovered.target;
            }
            var hovered = this._hovered = isOutside ? new $df528de50090e0a1$var$HoveredResult(x, y) : this.findHover(x, y);
            var hoveredTarget = hovered.target;
            var proxy = this.proxy;
            proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
            if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
            this.dispatchToElement(hovered, 'mousemove', event);
            if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
        };
        Handler.prototype.mouseout = function(event) {
            var eventControl = event.zrEventControl;
            if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
            if (eventControl !== 'no_globalout') this.trigger('globalout', {
                type: 'globalout',
                event: event
            });
        };
        Handler.prototype.resize = function() {
            this._hovered = new $df528de50090e0a1$var$HoveredResult(0, 0);
        };
        Handler.prototype.dispatch = function(eventName, eventArgs) {
            var handler = this[eventName];
            handler && handler.call(this, eventArgs);
        };
        Handler.prototype.dispose = function() {
            this.proxy.dispose();
            this.storage = null;
            this.proxy = null;
            this.painter = null;
        };
        Handler.prototype.setCursorStyle = function(cursorStyle) {
            var proxy = this.proxy;
            proxy.setCursor && proxy.setCursor(cursorStyle);
        };
        Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
            targetInfo = targetInfo || {};
            var el = targetInfo.target;
            if (el && el.silent) return;
            var eventKey = 'on' + eventName;
            var eventPacket = $df528de50090e0a1$var$makeEventPacket(eventName, targetInfo, event);
            while(el){
                el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
                el.trigger(eventName, eventPacket);
                el = el.__hostTarget ? el.__hostTarget : el.parent;
                if (eventPacket.cancelBubble) break;
            }
            if (!eventPacket.cancelBubble) {
                this.trigger(eventName, eventPacket);
                if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                    if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                    if (layer.trigger) layer.trigger(eventName, eventPacket);
                });
            }
        };
        Handler.prototype.findHover = function(x, y, exclude) {
            var list = this.storage.getDisplayList();
            var out = new $df528de50090e0a1$var$HoveredResult(x, y);
            for(var i = list.length - 1; i >= 0; i--){
                var hoverCheckResult = void 0;
                if (list[i] !== exclude && !list[i].ignore && (hoverCheckResult = $df528de50090e0a1$var$isHover(list[i], x, y))) {
                    !out.topTarget && (out.topTarget = list[i]);
                    if (hoverCheckResult !== $df528de50090e0a1$var$SILENT) {
                        out.target = list[i];
                        break;
                    }
                }
            }
            return out;
        };
        Handler.prototype.processGesture = function(event, stage) {
            if (!this._gestureMgr) this._gestureMgr = new (0, (0, parcelRequire("jYjcX")).GestureMgr)();
            var gestureMgr = this._gestureMgr;
            stage === 'start' && gestureMgr.clear();
            var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
            stage === 'end' && gestureMgr.clear();
            if (gestureInfo) {
                var type = gestureInfo.type;
                event.gestureEvent = type;
                var res = new $df528de50090e0a1$var$HoveredResult();
                res.target = gestureInfo.target;
                this.dispatchToElement(res, type, gestureInfo.event);
            }
        };
        return Handler;
    }((0, (0, parcelRequire("bRKv5")).default));
    (0, parcelRequire("bahqM")).each([
        'click',
        'mousedown',
        'mouseup',
        'mousewheel',
        'dblclick',
        'contextmenu'
    ], function(name) {
        $df528de50090e0a1$var$Handler.prototype[name] = function(event) {
            var x = event.zrX;
            var y = event.zrY;
            var isOutside = $df528de50090e0a1$var$isOutsideBoundary(this, x, y);
            var hovered;
            var hoveredTarget;
            if (name !== 'mouseup' || !isOutside) {
                hovered = this.findHover(x, y);
                hoveredTarget = hovered.target;
            }
            if (name === 'mousedown') {
                this._downEl = hoveredTarget;
                this._downPoint = [
                    event.zrX,
                    event.zrY
                ];
                this._upEl = hoveredTarget;
            } else if (name === 'mouseup') this._upEl = hoveredTarget;
            else if (name === 'click') {
                if (this._downEl !== this._upEl || !this._downPoint || (0, parcelRequire("eLEew")).dist(this._downPoint, [
                    event.zrX,
                    event.zrY
                ]) > 4) return;
                this._downPoint = null;
            }
            this.dispatchToElement(hovered, name, event);
        };
    });
    function $df528de50090e0a1$var$isHover(displayable, x, y) {
        if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
            var el = displayable;
            var isSilent = void 0;
            var ignoreClip = false;
            while(el){
                if (el.ignoreClip) ignoreClip = true;
                if (!ignoreClip) {
                    var clipPath = el.getClipPath();
                    if (clipPath && !clipPath.contain(x, y)) return false;
                    if (el.silent) isSilent = true;
                }
                var hostEl = el.__hostTarget;
                el = hostEl ? hostEl : el.parent;
            }
            return isSilent ? $df528de50090e0a1$var$SILENT : true;
        }
        return false;
    }
    function $df528de50090e0a1$var$isOutsideBoundary(handlerInstance, x, y) {
        var painter = handlerInstance.painter;
        return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
    }
    var $df528de50090e0a1$export$2e2bcd8739ae039 = $df528de50090e0a1$var$Handler;
});
parcelRegister("8qDpt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$622f526eb8ccffa3$export$2e2bcd8739ae039);
    var $622f526eb8ccffa3$var$Param = function() {
        function Param(target, e) {
            this.target = target;
            this.topTarget = e && e.topTarget;
        }
        return Param;
    }();
    var $622f526eb8ccffa3$var$Draggable = function() {
        function Draggable(handler) {
            this.handler = handler;
            handler.on('mousedown', this._dragStart, this);
            handler.on('mousemove', this._drag, this);
            handler.on('mouseup', this._dragEnd, this);
        }
        Draggable.prototype._dragStart = function(e) {
            var draggingTarget = e.target;
            while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent;
            if (draggingTarget) {
                this._draggingTarget = draggingTarget;
                draggingTarget.dragging = true;
                this._x = e.offsetX;
                this._y = e.offsetY;
                this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'dragstart', e.event);
            }
        };
        Draggable.prototype._drag = function(e) {
            var draggingTarget = this._draggingTarget;
            if (draggingTarget) {
                var x = e.offsetX;
                var y = e.offsetY;
                var dx = x - this._x;
                var dy = y - this._y;
                this._x = x;
                this._y = y;
                draggingTarget.drift(dx, dy, e);
                this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'drag', e.event);
                var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
                var lastDropTarget = this._dropTarget;
                this._dropTarget = dropTarget;
                if (draggingTarget !== dropTarget) {
                    if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(lastDropTarget, e), 'dragleave', e.event);
                    if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(dropTarget, e), 'dragenter', e.event);
                }
            }
        };
        Draggable.prototype._dragEnd = function(e) {
            var draggingTarget = this._draggingTarget;
            if (draggingTarget) draggingTarget.dragging = false;
            this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'dragend', e.event);
            if (this._dropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(this._dropTarget, e), 'drop', e.event);
            this._draggingTarget = null;
            this._dropTarget = null;
        };
        return Draggable;
    }();
    var $622f526eb8ccffa3$export$2e2bcd8739ae039 = $622f526eb8ccffa3$var$Draggable;
});
parcelRegister("65X4x", function(module, exports) {
    $parcel$export(module.exports, "clientToLocal", ()=>$47010835ddffd941$export$7d5fecde839eee88);
    $parcel$export(module.exports, "getNativeEvent", ()=>$47010835ddffd941$export$4abe0e945399ac1d);
    $parcel$export(module.exports, "normalizeEvent", ()=>$47010835ddffd941$export$40fadb093aebad71);
    $parcel$export(module.exports, "addEventListener", ()=>$47010835ddffd941$export$3f65cefe8380dbea);
    $parcel$export(module.exports, "removeEventListener", ()=>$47010835ddffd941$export$8ff9f68337b520c0);
    $parcel$export(module.exports, "stop", ()=>$47010835ddffd941$export$fa6813432f753b0d);
    $parcel$export(module.exports, "isMiddleOrRightButtonOnMouseUpDown", ()=>$47010835ddffd941$export$b7ae4cded3e71bd2);
    var $hZfwb;
    var $6AZf6;
    var $47010835ddffd941$var$isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
    var $47010835ddffd941$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
    var $47010835ddffd941$var$_calcOut = [];
    function $47010835ddffd941$export$7d5fecde839eee88(el, e, out, calculate) {
        out = out || {};
        if (calculate || !(0, (0, parcelRequire("hZfwb")).default).canvasSupported) $47010835ddffd941$var$calculateZrXY(el, e, out);
        else if ((0, (0, parcelRequire("hZfwb")).default).browser.firefox && (0, (0, parcelRequire("hZfwb")).default).browser.version < '39' && e.layerX != null && e.layerX !== e.offsetX) {
            out.zrX = e.layerX;
            out.zrY = e.layerY;
        } else if (e.offsetX != null) {
            out.zrX = e.offsetX;
            out.zrY = e.offsetY;
        } else $47010835ddffd941$var$calculateZrXY(el, e, out);
        return out;
    }
    function $47010835ddffd941$var$calculateZrXY(el, e, out) {
        if ((0, (0, parcelRequire("hZfwb")).default).domSupported && el.getBoundingClientRect) {
            var ex = e.clientX;
            var ey = e.clientY;
            if ((0, (0, parcelRequire("6AZf6")).isCanvasEl)(el)) {
                var box = el.getBoundingClientRect();
                out.zrX = ex - box.left;
                out.zrY = ey - box.top;
                return;
            } else if ((0, (0, parcelRequire("6AZf6")).transformCoordWithViewport)($47010835ddffd941$var$_calcOut, el, ex, ey)) {
                out.zrX = $47010835ddffd941$var$_calcOut[0];
                out.zrY = $47010835ddffd941$var$_calcOut[1];
                return;
            }
        }
        out.zrX = out.zrY = 0;
    }
    function $47010835ddffd941$export$4abe0e945399ac1d(e) {
        return e || window.event;
    }
    function $47010835ddffd941$export$40fadb093aebad71(el, e, calculate) {
        e = $47010835ddffd941$export$4abe0e945399ac1d(e);
        if (e.zrX != null) return e;
        var eventType = e.type;
        var isTouch = eventType && eventType.indexOf('touch') >= 0;
        if (!isTouch) {
            $47010835ddffd941$export$7d5fecde839eee88(el, e, e, calculate);
            var wheelDelta = $47010835ddffd941$var$getWheelDeltaMayPolyfill(e);
            e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
        } else {
            var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
            touch && $47010835ddffd941$export$7d5fecde839eee88(el, touch, e, calculate);
        }
        var button = e.button;
        if (e.which == null && button !== undefined && $47010835ddffd941$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
        return e;
    }
    function $47010835ddffd941$var$getWheelDeltaMayPolyfill(e) {
        var rawWheelDelta = e.wheelDelta;
        if (rawWheelDelta) return rawWheelDelta;
        var deltaX = e.deltaX;
        var deltaY = e.deltaY;
        if (deltaX == null || deltaY == null) return rawWheelDelta;
        var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
        var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
        return 3 * delta * sign;
    }
    function $47010835ddffd941$export$3f65cefe8380dbea(el, name, handler, opt) {
        if ($47010835ddffd941$var$isDomLevel2) el.addEventListener(name, handler, opt);
        else el.attachEvent('on' + name, handler);
    }
    function $47010835ddffd941$export$8ff9f68337b520c0(el, name, handler, opt) {
        if ($47010835ddffd941$var$isDomLevel2) el.removeEventListener(name, handler, opt);
        else el.detachEvent('on' + name, handler);
    }
    var $47010835ddffd941$export$fa6813432f753b0d = $47010835ddffd941$var$isDomLevel2 ? function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.cancelBubble = true;
    } : function(e) {
        e.returnValue = false;
        e.cancelBubble = true;
    };
    function $47010835ddffd941$export$b7ae4cded3e71bd2(e) {
        return e.which === 2 || e.which === 3;
    }
    function $47010835ddffd941$export$a564e1c0090572c3(e) {
        return e.which > 1;
    }
});
parcelRegister("6AZf6", function(module, exports) {
    $parcel$export(module.exports, "transformLocalCoord", ()=>$4cd59c60322a6a09$export$8c5c02e118307e20);
    $parcel$export(module.exports, "transformCoordWithViewport", ()=>$4cd59c60322a6a09$export$1219648acc517df4);
    $parcel$export(module.exports, "isCanvasEl", ()=>$4cd59c60322a6a09$export$1b92e4fe606eff6d);
    var $hZfwb;
    var $8QVDM;
    var $4cd59c60322a6a09$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
    var $4cd59c60322a6a09$var$_calcOut = [];
    function $4cd59c60322a6a09$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
        return $4cd59c60322a6a09$export$1219648acc517df4($4cd59c60322a6a09$var$_calcOut, elFrom, inX, inY, true) && $4cd59c60322a6a09$export$1219648acc517df4(out, elTarget, $4cd59c60322a6a09$var$_calcOut[0], $4cd59c60322a6a09$var$_calcOut[1]);
    }
    function $4cd59c60322a6a09$export$1219648acc517df4(out, el, inX, inY, inverse) {
        if (el.getBoundingClientRect && (0, (0, parcelRequire("hZfwb")).default).domSupported && !$4cd59c60322a6a09$export$1b92e4fe606eff6d(el)) {
            var saved = el[$4cd59c60322a6a09$var$EVENT_SAVED_PROP] || (el[$4cd59c60322a6a09$var$EVENT_SAVED_PROP] = {});
            var markers = $4cd59c60322a6a09$var$prepareCoordMarkers(el, saved);
            var transformer = $4cd59c60322a6a09$var$preparePointerTransformer(markers, saved, inverse);
            if (transformer) {
                transformer(out, inX, inY);
                return true;
            }
        }
        return false;
    }
    function $4cd59c60322a6a09$var$prepareCoordMarkers(el, saved) {
        var markers = saved.markers;
        if (markers) return markers;
        markers = saved.markers = [];
        var propLR = [
            'left',
            'right'
        ];
        var propTB = [
            'top',
            'bottom'
        ];
        for(var i = 0; i < 4; i++){
            var marker = document.createElement('div');
            var stl = marker.style;
            var idxLR = i % 2;
            var idxTB = (i >> 1) % 2;
            stl.cssText = [
                'position: absolute',
                'visibility: hidden',
                'padding: 0',
                'margin: 0',
                'border-width: 0',
                'user-select: none',
                'width:0',
                'height:0',
                propLR[idxLR] + ':0',
                propTB[idxTB] + ':0',
                propLR[1 - idxLR] + ':auto',
                propTB[1 - idxTB] + ':auto',
                ''
            ].join('!important;');
            el.appendChild(marker);
            markers.push(marker);
        }
        return markers;
    }
    function $4cd59c60322a6a09$var$preparePointerTransformer(markers, saved, inverse) {
        var transformerName = inverse ? 'invTrans' : 'trans';
        var transformer = saved[transformerName];
        var oldSrcCoords = saved.srcCoords;
        var srcCoords = [];
        var destCoords = [];
        var oldCoordTheSame = true;
        for(var i = 0; i < 4; i++){
            var rect = markers[i].getBoundingClientRect();
            var ii = 2 * i;
            var x = rect.left;
            var y = rect.top;
            srcCoords.push(x, y);
            oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
            destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
        }
        return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, (0, parcelRequire("8QVDM")).buildTransformer)(destCoords, srcCoords) : (0, (0, parcelRequire("8QVDM")).buildTransformer)(srcCoords, destCoords));
    }
    function $4cd59c60322a6a09$export$1b92e4fe606eff6d(el) {
        return el.nodeName.toUpperCase() === 'CANVAS';
    }
});
parcelRegister("8QVDM", function(module, exports) {
    $parcel$export(module.exports, "buildTransformer", ()=>$671fe44ca8a82f31$export$fbdb2748a8171a7e);
    var $671fe44ca8a82f31$var$LN2 = Math.log(2);
    function $671fe44ca8a82f31$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
        var cacheKey = rowMask + '-' + colMask;
        var fullRank = rows.length;
        if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
        if (rank === 1) {
            var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $671fe44ca8a82f31$var$LN2);
            return rows[rowStart][colStart];
        }
        var subRowMask = rowMask | 1 << rowStart;
        var subRowStart = rowStart + 1;
        while(rowMask & 1 << subRowStart)subRowStart++;
        var sum = 0;
        for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
            var colTag = 1 << j;
            if (!(colTag & colMask)) {
                sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $671fe44ca8a82f31$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
                colLocalIdx++;
            }
        }
        detCache[cacheKey] = sum;
        return sum;
    }
    function $671fe44ca8a82f31$export$fbdb2748a8171a7e(src, dest) {
        var mA = [
            [
                src[0],
                src[1],
                1,
                0,
                0,
                0,
                -dest[0] * src[0],
                -dest[0] * src[1]
            ],
            [
                0,
                0,
                0,
                src[0],
                src[1],
                1,
                -dest[1] * src[0],
                -dest[1] * src[1]
            ],
            [
                src[2],
                src[3],
                1,
                0,
                0,
                0,
                -dest[2] * src[2],
                -dest[2] * src[3]
            ],
            [
                0,
                0,
                0,
                src[2],
                src[3],
                1,
                -dest[3] * src[2],
                -dest[3] * src[3]
            ],
            [
                src[4],
                src[5],
                1,
                0,
                0,
                0,
                -dest[4] * src[4],
                -dest[4] * src[5]
            ],
            [
                0,
                0,
                0,
                src[4],
                src[5],
                1,
                -dest[5] * src[4],
                -dest[5] * src[5]
            ],
            [
                src[6],
                src[7],
                1,
                0,
                0,
                0,
                -dest[6] * src[6],
                -dest[6] * src[7]
            ],
            [
                0,
                0,
                0,
                src[6],
                src[7],
                1,
                -dest[7] * src[6],
                -dest[7] * src[7]
            ]
        ];
        var detCache = {};
        var det = $671fe44ca8a82f31$var$determinant(mA, 8, 0, 0, 0, detCache);
        if (det === 0) return;
        var vh = [];
        for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
            vh[j] == null && (vh[j] = 0);
            vh[j] += ((i + j) % 2 ? -1 : 1) * $671fe44ca8a82f31$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
        }
        return function(out, srcPointX, srcPointY) {
            var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
            out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
            out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
        };
    }
});
parcelRegister("jYjcX", function(module, exports) {
    $parcel$export(module.exports, "GestureMgr", ()=>$e8a28537c27906ba$export$f7557d6f27e9503);
    var $65X4x;
    var $e8a28537c27906ba$export$f7557d6f27e9503 = function() {
        function GestureMgr() {
            this._track = [];
        }
        GestureMgr.prototype.recognize = function(event, target, root) {
            this._doTrack(event, target, root);
            return this._recognize(event);
        };
        GestureMgr.prototype.clear = function() {
            this._track.length = 0;
            return this;
        };
        GestureMgr.prototype._doTrack = function(event, target, root) {
            var touches = event.touches;
            if (!touches) return;
            var trackItem = {
                points: [],
                touches: [],
                target: target,
                event: event
            };
            for(var i = 0, len = touches.length; i < len; i++){
                var touch = touches[i];
                var pos = (0, parcelRequire("65X4x")).clientToLocal(root, touch, {});
                trackItem.points.push([
                    pos.zrX,
                    pos.zrY
                ]);
                trackItem.touches.push(touch);
            }
            this._track.push(trackItem);
        };
        GestureMgr.prototype._recognize = function(event) {
            for(var eventName in $e8a28537c27906ba$var$recognizers)if ($e8a28537c27906ba$var$recognizers.hasOwnProperty(eventName)) {
                var gestureInfo = $e8a28537c27906ba$var$recognizers[eventName](this._track, event);
                if (gestureInfo) return gestureInfo;
            }
        };
        return GestureMgr;
    }();
    function $e8a28537c27906ba$var$dist(pointPair) {
        var dx = pointPair[1][0] - pointPair[0][0];
        var dy = pointPair[1][1] - pointPair[0][1];
        return Math.sqrt(dx * dx + dy * dy);
    }
    function $e8a28537c27906ba$var$center(pointPair) {
        return [
            (pointPair[0][0] + pointPair[1][0]) / 2,
            (pointPair[0][1] + pointPair[1][1]) / 2
        ];
    }
    var $e8a28537c27906ba$var$recognizers = {
        pinch: function(tracks, event) {
            var trackLen = tracks.length;
            if (!trackLen) return;
            var pinchEnd = (tracks[trackLen - 1] || {}).points;
            var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
            if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
                var pinchScale = $e8a28537c27906ba$var$dist(pinchEnd) / $e8a28537c27906ba$var$dist(pinchPre);
                !isFinite(pinchScale) && (pinchScale = 1);
                event.pinchScale = pinchScale;
                var pinchCenter = $e8a28537c27906ba$var$center(pinchEnd);
                event.pinchX = pinchCenter[0];
                event.pinchY = pinchCenter[1];
                return {
                    type: 'pinch',
                    target: tracks[0].target,
                    event: event
                };
            }
        }
    };
});
parcelRegister("66sfA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4719378990e09024$export$2e2bcd8739ae039);
    var $bahqM;
    var $hZfwb;
    var $aVBu2;
    var $aVawM;
    var $4719378990e09024$var$invalidZErrorLogged = false;
    function $4719378990e09024$var$logInvalidZError() {
        if ($4719378990e09024$var$invalidZErrorLogged) return;
        $4719378990e09024$var$invalidZErrorLogged = true;
        console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
    }
    function $4719378990e09024$var$shapeCompareFunc(a, b) {
        if (a.zlevel === b.zlevel) {
            if (a.z === b.z) return a.z2 - b.z2;
            return a.z - b.z;
        }
        return a.zlevel - b.zlevel;
    }
    var $4719378990e09024$var$Storage = function() {
        function Storage() {
            this._roots = [];
            this._displayList = [];
            this._displayListLen = 0;
            this.displayableSortFunc = $4719378990e09024$var$shapeCompareFunc;
        }
        Storage.prototype.traverse = function(cb, context) {
            for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
        };
        Storage.prototype.getDisplayList = function(update, includeIgnore) {
            includeIgnore = includeIgnore || false;
            var displayList = this._displayList;
            if (update || !displayList.length) this.updateDisplayList(includeIgnore);
            return displayList;
        };
        Storage.prototype.updateDisplayList = function(includeIgnore) {
            this._displayListLen = 0;
            var roots = this._roots;
            var displayList = this._displayList;
            for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
            displayList.length = this._displayListLen;
            (0, (0, parcelRequire("hZfwb")).default).canvasSupported && (0, (0, parcelRequire("aVBu2")).default)(displayList, $4719378990e09024$var$shapeCompareFunc);
        };
        Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
            if (el.ignore && !includeIgnore) return;
            el.beforeUpdate();
            el.update();
            el.afterUpdate();
            var userSetClipPath = el.getClipPath();
            if (el.ignoreClip) clipPaths = null;
            else if (userSetClipPath) {
                if (clipPaths) clipPaths = clipPaths.slice();
                else clipPaths = [];
                var currentClipPath = userSetClipPath;
                var parentClipPath = el;
                while(currentClipPath){
                    currentClipPath.parent = parentClipPath;
                    currentClipPath.updateTransform();
                    clipPaths.push(currentClipPath);
                    parentClipPath = currentClipPath;
                    currentClipPath = currentClipPath.getClipPath();
                }
            }
            if (el.childrenRef) {
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    if (el.__dirty) child.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
                    this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
                }
                el.__dirty = 0;
            } else {
                var disp = el;
                if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
                else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
                if (isNaN(disp.z)) {
                    $4719378990e09024$var$logInvalidZError();
                    disp.z = 0;
                }
                if (isNaN(disp.z2)) {
                    $4719378990e09024$var$logInvalidZError();
                    disp.z2 = 0;
                }
                if (isNaN(disp.zlevel)) {
                    $4719378990e09024$var$logInvalidZError();
                    disp.zlevel = 0;
                }
                this._displayList[this._displayListLen++] = disp;
            }
            var decalEl = el.getDecalElement && el.getDecalElement();
            if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
            var textGuide = el.getTextGuideLine();
            if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
            var textEl = el.getTextContent();
            if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
        };
        Storage.prototype.addRoot = function(el) {
            if (el.__zr && el.__zr.storage === this) return;
            this._roots.push(el);
        };
        Storage.prototype.delRoot = function(el) {
            if (el instanceof Array) {
                for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
                return;
            }
            var idx = (0, parcelRequire("bahqM")).indexOf(this._roots, el);
            if (idx >= 0) this._roots.splice(idx, 1);
        };
        Storage.prototype.delAllRoots = function() {
            this._roots = [];
            this._displayList = [];
            this._displayListLen = 0;
            return;
        };
        Storage.prototype.getRoots = function() {
            return this._roots;
        };
        Storage.prototype.dispose = function() {
            this._displayList = null;
            this._roots = null;
        };
        return Storage;
    }();
    var $4719378990e09024$export$2e2bcd8739ae039 = $4719378990e09024$var$Storage;
});
parcelRegister("aVBu2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f4c4daf73fbe3de$export$2e2bcd8739ae039);
    var $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE = 32;
    var $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING = 7;
    var $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH = 256;
    function $7f4c4daf73fbe3de$var$minRunLength(n) {
        var r = 0;
        while(n >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE){
            r |= n & 1;
            n >>= 1;
        }
        return n + r;
    }
    function $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare) {
        var runHi = lo + 1;
        if (runHi === hi) return 1;
        if (compare(array[runHi++], array[lo]) < 0) {
            while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
            $7f4c4daf73fbe3de$var$reverseRun(array, lo, runHi);
        } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
        return runHi - lo;
    }
    function $7f4c4daf73fbe3de$var$reverseRun(array, lo, hi) {
        hi--;
        while(lo < hi){
            var t = array[lo];
            array[lo++] = array[hi];
            array[hi--] = t;
        }
    }
    function $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, hi, start, compare) {
        if (start === lo) start++;
        for(; start < hi; start++){
            var pivot = array[start];
            var left = lo;
            var right = start;
            var mid;
            while(left < right){
                mid = left + right >>> 1;
                if (compare(pivot, array[mid]) < 0) right = mid;
                else left = mid + 1;
            }
            var n = start - left;
            switch(n){
                case 3:
                    array[left + 3] = array[left + 2];
                case 2:
                    array[left + 2] = array[left + 1];
                case 1:
                    array[left + 1] = array[left];
                    break;
                default:
                    while(n > 0){
                        array[left + n] = array[left + n - 1];
                        n--;
                    }
            }
            array[left] = pivot;
        }
    }
    function $7f4c4daf73fbe3de$var$gallopLeft(value, array, start, length, hint, compare) {
        var lastOffset = 0;
        var maxOffset = 0;
        var offset = 1;
        if (compare(value, array[start + hint]) > 0) {
            maxOffset = length - hint;
            while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            lastOffset += hint;
            offset += hint;
        } else {
            maxOffset = hint + 1;
            while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            var tmp = lastOffset;
            lastOffset = hint - offset;
            offset = hint - tmp;
        }
        lastOffset++;
        while(lastOffset < offset){
            var m = lastOffset + (offset - lastOffset >>> 1);
            if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
            else offset = m;
        }
        return offset;
    }
    function $7f4c4daf73fbe3de$var$gallopRight(value, array, start, length, hint, compare) {
        var lastOffset = 0;
        var maxOffset = 0;
        var offset = 1;
        if (compare(value, array[start + hint]) < 0) {
            maxOffset = hint + 1;
            while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            var tmp = lastOffset;
            lastOffset = hint - offset;
            offset = hint - tmp;
        } else {
            maxOffset = length - hint;
            while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            lastOffset += hint;
            offset += hint;
        }
        lastOffset++;
        while(lastOffset < offset){
            var m = lastOffset + (offset - lastOffset >>> 1);
            if (compare(value, array[start + m]) < 0) offset = m;
            else lastOffset = m + 1;
        }
        return offset;
    }
    function $7f4c4daf73fbe3de$var$TimSort(array, compare) {
        var minGallop = $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING;
        var length = 0;
        var tmpStorageLength = $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH;
        var stackLength = 0;
        var runStart;
        var runLength;
        var stackSize = 0;
        length = array.length;
        if (length < 2 * $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH) tmpStorageLength = length >>> 1;
        var tmp = [];
        stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
        runStart = [];
        runLength = [];
        function pushRun(_runStart, _runLength) {
            runStart[stackSize] = _runStart;
            runLength[stackSize] = _runLength;
            stackSize += 1;
        }
        function mergeRuns() {
            while(stackSize > 1){
                var n = stackSize - 2;
                if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                    if (runLength[n - 1] < runLength[n + 1]) n--;
                } else if (runLength[n] > runLength[n + 1]) break;
                mergeAt(n);
            }
        }
        function forceMergeRuns() {
            while(stackSize > 1){
                var n = stackSize - 2;
                if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
                mergeAt(n);
            }
        }
        function mergeAt(i) {
            var start1 = runStart[i];
            var length1 = runLength[i];
            var start2 = runStart[i + 1];
            var length2 = runLength[i + 1];
            runLength[i] = length1 + length2;
            if (i === stackSize - 3) {
                runStart[i + 1] = runStart[i + 2];
                runLength[i + 1] = runLength[i + 2];
            }
            stackSize--;
            var k = $7f4c4daf73fbe3de$var$gallopRight(array[start2], array, start1, length1, 0, compare);
            start1 += k;
            length1 -= k;
            if (length1 === 0) return;
            length2 = $7f4c4daf73fbe3de$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
            if (length2 === 0) return;
            if (length1 <= length2) mergeLow(start1, length1, start2, length2);
            else mergeHigh(start1, length1, start2, length2);
        }
        function mergeLow(start1, length1, start2, length2) {
            var i = 0;
            for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
            var cursor1 = 0;
            var cursor2 = start2;
            var dest = start1;
            array[dest++] = array[cursor2++];
            if (--length2 === 0) {
                for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
                return;
            }
            if (length1 === 1) {
                for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
                array[dest + length2] = tmp[cursor1];
                return;
            }
            var _minGallop = minGallop;
            var count1;
            var count2;
            var exit;
            while(true){
                count1 = 0;
                count2 = 0;
                exit = false;
                do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                    array[dest++] = array[cursor2++];
                    count2++;
                    count1 = 0;
                    if (--length2 === 0) {
                        exit = true;
                        break;
                    }
                } else {
                    array[dest++] = tmp[cursor1++];
                    count1++;
                    count2 = 0;
                    if (--length1 === 1) {
                        exit = true;
                        break;
                    }
                }
                while ((count1 | count2) < _minGallop)
                if (exit) break;
                do {
                    count1 = $7f4c4daf73fbe3de$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                    if (count1 !== 0) {
                        for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                        dest += count1;
                        cursor1 += count1;
                        length1 -= count1;
                        if (length1 <= 1) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest++] = array[cursor2++];
                    if (--length2 === 0) {
                        exit = true;
                        break;
                    }
                    count2 = $7f4c4daf73fbe3de$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                    if (count2 !== 0) {
                        for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                        dest += count2;
                        cursor2 += count2;
                        length2 -= count2;
                        if (length2 === 0) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest++] = tmp[cursor1++];
                    if (--length1 === 1) {
                        exit = true;
                        break;
                    }
                    _minGallop--;
                }while (count1 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING || count2 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING)
                if (exit) break;
                if (_minGallop < 0) _minGallop = 0;
                _minGallop += 2;
            }
            minGallop = _minGallop;
            minGallop < 1 && (minGallop = 1);
            if (length1 === 1) {
                for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
                array[dest + length2] = tmp[cursor1];
            } else if (length1 === 0) throw new Error();
            else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
        }
        function mergeHigh(start1, length1, start2, length2) {
            var i = 0;
            for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
            var cursor1 = start1 + length1 - 1;
            var cursor2 = length2 - 1;
            var dest = start2 + length2 - 1;
            var customCursor = 0;
            var customDest = 0;
            array[dest--] = array[cursor1--];
            if (--length1 === 0) {
                customCursor = dest - (length2 - 1);
                for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
                return;
            }
            if (length2 === 1) {
                dest -= length1;
                cursor1 -= length1;
                customDest = dest + 1;
                customCursor = cursor1 + 1;
                for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                array[dest] = tmp[cursor2];
                return;
            }
            var _minGallop = minGallop;
            while(true){
                var count1 = 0;
                var count2 = 0;
                var exit = false;
                do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                    array[dest--] = array[cursor1--];
                    count1++;
                    count2 = 0;
                    if (--length1 === 0) {
                        exit = true;
                        break;
                    }
                } else {
                    array[dest--] = tmp[cursor2--];
                    count2++;
                    count1 = 0;
                    if (--length2 === 1) {
                        exit = true;
                        break;
                    }
                }
                while ((count1 | count2) < _minGallop)
                if (exit) break;
                do {
                    count1 = length1 - $7f4c4daf73fbe3de$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                    if (count1 !== 0) {
                        dest -= count1;
                        cursor1 -= count1;
                        length1 -= count1;
                        customDest = dest + 1;
                        customCursor = cursor1 + 1;
                        for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                        if (length1 === 0) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest--] = tmp[cursor2--];
                    if (--length2 === 1) {
                        exit = true;
                        break;
                    }
                    count2 = length2 - $7f4c4daf73fbe3de$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                    if (count2 !== 0) {
                        dest -= count2;
                        cursor2 -= count2;
                        length2 -= count2;
                        customDest = dest + 1;
                        customCursor = cursor2 + 1;
                        for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                        if (length2 <= 1) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest--] = array[cursor1--];
                    if (--length1 === 0) {
                        exit = true;
                        break;
                    }
                    _minGallop--;
                }while (count1 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING || count2 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING)
                if (exit) break;
                if (_minGallop < 0) _minGallop = 0;
                _minGallop += 2;
            }
            minGallop = _minGallop;
            if (minGallop < 1) minGallop = 1;
            if (length2 === 1) {
                dest -= length1;
                cursor1 -= length1;
                customDest = dest + 1;
                customCursor = cursor1 + 1;
                for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                array[dest] = tmp[cursor2];
            } else if (length2 === 0) throw new Error();
            else {
                customCursor = dest - (length2 - 1);
                for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            }
        }
        return {
            mergeRuns: mergeRuns,
            forceMergeRuns: forceMergeRuns,
            pushRun: pushRun
        };
    }
    function $7f4c4daf73fbe3de$export$2e2bcd8739ae039(array, compare, lo, hi) {
        if (!lo) lo = 0;
        if (!hi) hi = array.length;
        var remaining = hi - lo;
        if (remaining < 2) return;
        var runLength = 0;
        if (remaining < $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE) {
            runLength = $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare);
            $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
            return;
        }
        var ts = $7f4c4daf73fbe3de$var$TimSort(array, compare);
        var minRun = $7f4c4daf73fbe3de$var$minRunLength(remaining);
        do {
            runLength = $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare);
            if (runLength < minRun) {
                var force = remaining;
                if (force > minRun) force = minRun;
                $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
                runLength = force;
            }
            ts.pushRun(lo, runLength);
            ts.mergeRuns();
            remaining -= runLength;
            lo += runLength;
        }while (remaining !== 0)
        ts.forceMergeRuns();
    }
});
parcelRegister("F44Dl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07b6fd689a4caf84$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bRKv5;
    var $04xko;
    var $hb2y5;
    var $07b6fd689a4caf84$var$Animation = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Animation, _super);
        function Animation(opts) {
            var _this = _super.call(this) || this;
            _this._running = false;
            _this._time = 0;
            _this._pausedTime = 0;
            _this._pauseStart = 0;
            _this._paused = false;
            opts = opts || {};
            _this.stage = opts.stage || {};
            _this.onframe = opts.onframe || function() {};
            return _this;
        }
        Animation.prototype.addClip = function(clip) {
            if (clip.animation) this.removeClip(clip);
            if (!this._clipsHead) this._clipsHead = this._clipsTail = clip;
            else {
                this._clipsTail.next = clip;
                clip.prev = this._clipsTail;
                clip.next = null;
                this._clipsTail = clip;
            }
            clip.animation = this;
        };
        Animation.prototype.addAnimator = function(animator) {
            animator.animation = this;
            var clip = animator.getClip();
            if (clip) this.addClip(clip);
        };
        Animation.prototype.removeClip = function(clip) {
            if (!clip.animation) return;
            var prev = clip.prev;
            var next = clip.next;
            if (prev) prev.next = next;
            else this._clipsHead = next;
            if (next) next.prev = prev;
            else this._clipsTail = prev;
            clip.next = clip.prev = clip.animation = null;
        };
        Animation.prototype.removeAnimator = function(animator) {
            var clip = animator.getClip();
            if (clip) this.removeClip(clip);
            animator.animation = null;
        };
        Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
            var time = new Date().getTime() - this._pausedTime;
            var delta = time - this._time;
            var clip = this._clipsHead;
            while(clip){
                var nextClip = clip.next;
                var finished = clip.step(time, delta);
                if (finished) {
                    clip.ondestroy && clip.ondestroy();
                    this.removeClip(clip);
                    clip = nextClip;
                } else clip = nextClip;
            }
            this._time = time;
            if (!notTriggerFrameAndStageUpdate) {
                this.onframe(delta);
                this.trigger('frame', delta);
                this.stage.update && this.stage.update();
            }
        };
        Animation.prototype._startLoop = function() {
            var self = this;
            this._running = true;
            function step() {
                if (self._running) {
                    (0, (0, parcelRequire("04xko")).default)(step);
                    !self._paused && self.update();
                }
            }
            (0, (0, parcelRequire("04xko")).default)(step);
        };
        Animation.prototype.start = function() {
            if (this._running) return;
            this._time = new Date().getTime();
            this._pausedTime = 0;
            this._startLoop();
        };
        Animation.prototype.stop = function() {
            this._running = false;
        };
        Animation.prototype.pause = function() {
            if (!this._paused) {
                this._pauseStart = new Date().getTime();
                this._paused = true;
            }
        };
        Animation.prototype.resume = function() {
            if (this._paused) {
                this._pausedTime += new Date().getTime() - this._pauseStart;
                this._paused = false;
            }
        };
        Animation.prototype.clear = function() {
            var clip = this._clipsHead;
            while(clip){
                var nextClip = clip.next;
                clip.prev = clip.next = clip.animation = null;
                clip = nextClip;
            }
            this._clipsHead = this._clipsTail = null;
        };
        Animation.prototype.isFinished = function() {
            return this._clipsHead == null;
        };
        Animation.prototype.animate = function(target, options) {
            options = options || {};
            this.start();
            var animator = new (0, (0, parcelRequire("hb2y5")).default)(target, options.loop);
            this.addAnimator(animator);
            return animator;
        };
        return Animation;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $07b6fd689a4caf84$export$2e2bcd8739ae039 = $07b6fd689a4caf84$var$Animation;
});
parcelRegister("04xko", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00da3a149d316342$export$2e2bcd8739ae039);
    var $00da3a149d316342$var$requestAnimationFrame;
    $00da3a149d316342$var$requestAnimationFrame = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
        return setTimeout(func, 16);
    };
    var $00da3a149d316342$export$2e2bcd8739ae039 = $00da3a149d316342$var$requestAnimationFrame;
});
parcelRegister("bHSYT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$885e5bfc09439923$export$2e2bcd8739ae039);
    var $3VFsf;
    var $65X4x;
    var $bahqM;
    var $bRKv5;
    var $hZfwb;
    var $885e5bfc09439923$var$TOUCH_CLICK_DELAY = 300;
    var $885e5bfc09439923$var$globalEventSupported = (0, (0, parcelRequire("hZfwb")).default).domSupported;
    var $885e5bfc09439923$var$localNativeListenerNames = function() {
        var mouseHandlerNames = [
            'click',
            'dblclick',
            'mousewheel',
            'wheel',
            'mouseout',
            'mouseup',
            'mousedown',
            'mousemove',
            'contextmenu'
        ];
        var touchHandlerNames = [
            'touchstart',
            'touchend',
            'touchmove'
        ];
        var pointerEventNameMap = {
            pointerdown: 1,
            pointerup: 1,
            pointermove: 1,
            pointerout: 1
        };
        var pointerHandlerNames = (0, parcelRequire("bahqM")).map(mouseHandlerNames, function(name) {
            var nm = name.replace('mouse', 'pointer');
            return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
        });
        return {
            mouse: mouseHandlerNames,
            touch: touchHandlerNames,
            pointer: pointerHandlerNames
        };
    }();
    var $885e5bfc09439923$var$globalNativeListenerNames = {
        mouse: [
            'mousemove',
            'mouseup'
        ],
        pointer: [
            'pointermove',
            'pointerup'
        ]
    };
    var $885e5bfc09439923$var$wheelEventSupported = false;
    function $885e5bfc09439923$var$isPointerFromTouch(event) {
        var pointerType = event.pointerType;
        return pointerType === 'pen' || pointerType === 'touch';
    }
    function $885e5bfc09439923$var$setTouchTimer(scope) {
        scope.touching = true;
        if (scope.touchTimer != null) {
            clearTimeout(scope.touchTimer);
            scope.touchTimer = null;
        }
        scope.touchTimer = setTimeout(function() {
            scope.touching = false;
            scope.touchTimer = null;
        }, 700);
    }
    function $885e5bfc09439923$var$markTouch(event) {
        event && (event.zrByTouch = true);
    }
    function $885e5bfc09439923$var$normalizeGlobalEvent(instance, event) {
        return (0, (0, parcelRequire("65X4x")).normalizeEvent)(instance.dom, new $885e5bfc09439923$var$FakeGlobalEvent(instance, event), true);
    }
    function $885e5bfc09439923$var$isLocalEl(instance, el) {
        var elTmp = el;
        var isLocal = false;
        while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
        return isLocal;
    }
    var $885e5bfc09439923$var$FakeGlobalEvent = function() {
        function FakeGlobalEvent(instance, event) {
            this.stopPropagation = (0, parcelRequire("bahqM")).noop;
            this.stopImmediatePropagation = (0, parcelRequire("bahqM")).noop;
            this.preventDefault = (0, parcelRequire("bahqM")).noop;
            this.type = event.type;
            this.target = this.currentTarget = instance.dom;
            this.pointerType = event.pointerType;
            this.clientX = event.clientX;
            this.clientY = event.clientY;
        }
        return FakeGlobalEvent;
    }();
    var $885e5bfc09439923$var$localDOMHandlers = {
        mousedown: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.__mayPointerCapture = [
                event.zrX,
                event.zrY
            ];
            this.trigger('mousedown', event);
        },
        mousemove: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            var downPoint = this.__mayPointerCapture;
            if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
            this.trigger('mousemove', event);
        },
        mouseup: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.__togglePointerCapture(false);
            this.trigger('mouseup', event);
        },
        mouseout: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            var element = event.toElement || event.relatedTarget;
            if (!$885e5bfc09439923$var$isLocalEl(this, element)) {
                if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
                this.trigger('mouseout', event);
            }
        },
        wheel: function(event) {
            $885e5bfc09439923$var$wheelEventSupported = true;
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.trigger('mousewheel', event);
        },
        mousewheel: function(event) {
            if ($885e5bfc09439923$var$wheelEventSupported) return;
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.trigger('mousewheel', event);
        },
        touchstart: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            $885e5bfc09439923$var$markTouch(event);
            this.__lastTouchMoment = new Date();
            this.handler.processGesture(event, 'start');
            $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
            $885e5bfc09439923$var$localDOMHandlers.mousedown.call(this, event);
        },
        touchmove: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            $885e5bfc09439923$var$markTouch(event);
            this.handler.processGesture(event, 'change');
            $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
        },
        touchend: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            $885e5bfc09439923$var$markTouch(event);
            this.handler.processGesture(event, 'end');
            $885e5bfc09439923$var$localDOMHandlers.mouseup.call(this, event);
            if (+new Date() - +this.__lastTouchMoment < $885e5bfc09439923$var$TOUCH_CLICK_DELAY) $885e5bfc09439923$var$localDOMHandlers.click.call(this, event);
        },
        pointerdown: function(event) {
            $885e5bfc09439923$var$localDOMHandlers.mousedown.call(this, event);
        },
        pointermove: function(event) {
            if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
        },
        pointerup: function(event) {
            $885e5bfc09439923$var$localDOMHandlers.mouseup.call(this, event);
        },
        pointerout: function(event) {
            if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$localDOMHandlers.mouseout.call(this, event);
        }
    };
    (0, parcelRequire("bahqM")).each([
        'click',
        'dblclick',
        'contextmenu'
    ], function(name) {
        $885e5bfc09439923$var$localDOMHandlers[name] = function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.trigger(name, event);
        };
    });
    var $885e5bfc09439923$var$globalDOMHandlers = {
        pointermove: function(event) {
            if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$globalDOMHandlers.mousemove.call(this, event);
        },
        pointerup: function(event) {
            $885e5bfc09439923$var$globalDOMHandlers.mouseup.call(this, event);
        },
        mousemove: function(event) {
            this.trigger('mousemove', event);
        },
        mouseup: function(event) {
            var pointerCaptureReleasing = this.__pointerCapturing;
            this.__togglePointerCapture(false);
            this.trigger('mouseup', event);
            if (pointerCaptureReleasing) {
                event.zrEventControl = 'only_globalout';
                this.trigger('mouseout', event);
            }
        }
    };
    function $885e5bfc09439923$var$mountLocalDOMEventListeners(instance, scope) {
        var domHandlers = scope.domHandlers;
        if ((0, (0, parcelRequire("hZfwb")).default).pointerEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$localNativeListenerNames.pointer, function(nativeEventName) {
            $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
            });
        });
        else {
            if ((0, (0, parcelRequire("hZfwb")).default).touchEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$localNativeListenerNames.touch, function(nativeEventName) {
                $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                    domHandlers[nativeEventName].call(instance, event);
                    $885e5bfc09439923$var$setTouchTimer(scope);
                });
            });
            (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$localNativeListenerNames.mouse, function(nativeEventName) {
                $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                    event = (0, (0, parcelRequire("65X4x")).getNativeEvent)(event);
                    if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
                });
            });
        }
    }
    function $885e5bfc09439923$var$mountGlobalDOMEventListeners(instance, scope) {
        if ((0, (0, parcelRequire("hZfwb")).default).pointerEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$globalNativeListenerNames.pointer, mount);
        else if (!(0, (0, parcelRequire("hZfwb")).default).touchEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$globalNativeListenerNames.mouse, mount);
        function mount(nativeEventName) {
            function nativeEventListener(event) {
                event = (0, (0, parcelRequire("65X4x")).getNativeEvent)(event);
                if (!$885e5bfc09439923$var$isLocalEl(instance, event.target)) {
                    event = $885e5bfc09439923$var$normalizeGlobalEvent(instance, event);
                    scope.domHandlers[nativeEventName].call(instance, event);
                }
            }
            $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
                capture: true
            });
        }
    }
    function $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
        scope.mounted[nativeEventName] = listener;
        scope.listenerOpts[nativeEventName] = opt;
        (0, (0, parcelRequire("65X4x")).addEventListener)(scope.domTarget, nativeEventName, listener, opt);
    }
    function $885e5bfc09439923$var$unmountDOMEventListeners(scope) {
        var mounted = scope.mounted;
        for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, (0, parcelRequire("65X4x")).removeEventListener)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
        scope.mounted = {};
    }
    var $885e5bfc09439923$var$DOMHandlerScope = function() {
        function DOMHandlerScope(domTarget, domHandlers) {
            this.mounted = {};
            this.listenerOpts = {};
            this.touching = false;
            this.domTarget = domTarget;
            this.domHandlers = domHandlers;
        }
        return DOMHandlerScope;
    }();
    var $885e5bfc09439923$var$HandlerDomProxy = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(HandlerDomProxy, _super);
        function HandlerDomProxy(dom, painterRoot) {
            var _this = _super.call(this) || this;
            _this.__pointerCapturing = false;
            _this.dom = dom;
            _this.painterRoot = painterRoot;
            _this._localHandlerScope = new $885e5bfc09439923$var$DOMHandlerScope(dom, $885e5bfc09439923$var$localDOMHandlers);
            if ($885e5bfc09439923$var$globalEventSupported) _this._globalHandlerScope = new $885e5bfc09439923$var$DOMHandlerScope(document, $885e5bfc09439923$var$globalDOMHandlers);
            $885e5bfc09439923$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
            return _this;
        }
        HandlerDomProxy.prototype.dispose = function() {
            $885e5bfc09439923$var$unmountDOMEventListeners(this._localHandlerScope);
            if ($885e5bfc09439923$var$globalEventSupported) $885e5bfc09439923$var$unmountDOMEventListeners(this._globalHandlerScope);
        };
        HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
            this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
        };
        HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
            this.__mayPointerCapture = null;
            if ($885e5bfc09439923$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
                this.__pointerCapturing = isPointerCapturing;
                var globalHandlerScope = this._globalHandlerScope;
                isPointerCapturing ? $885e5bfc09439923$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $885e5bfc09439923$var$unmountDOMEventListeners(globalHandlerScope);
            }
        };
        return HandlerDomProxy;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $885e5bfc09439923$export$2e2bcd8739ae039 = $885e5bfc09439923$var$HandlerDomProxy;
});
parcelRegister("74g78", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$525568051e570380$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $eaKsF;
    var $gaMkj;
    var $h4UlH;
    var $34Vzq;
    var $cNGs8;
    var $iSVvO;
    var $aCu4v;
    var $2cFRc;
    var $525568051e570380$var$reCreateSeriesIndices;
    var $525568051e570380$var$assertSeriesInitialized;
    var $525568051e570380$var$initBase;
    var $525568051e570380$var$OPTION_INNER_KEY = '\0_ec_inner';
    var $525568051e570380$var$OPTION_INNER_VALUE = 1;
    var $525568051e570380$var$BUITIN_COMPONENTS_MAP = {
        grid: 'GridComponent',
        polar: 'PolarComponent',
        geo: 'GeoComponent',
        singleAxis: 'SingleAxisComponent',
        parallel: 'ParallelComponent',
        calendar: 'CalendarComponent',
        graphic: 'GraphicComponent',
        toolbox: 'ToolboxComponent',
        tooltip: 'TooltipComponent',
        axisPointer: 'AxisPointerComponent',
        brush: 'BrushComponent',
        title: 'TitleComponent',
        timeline: 'TimelineComponent',
        markPoint: 'MarkPointComponent',
        markLine: 'MarkLineComponent',
        markArea: 'MarkAreaComponent',
        legend: 'LegendComponent',
        dataZoom: 'DataZoomComponent',
        visualMap: 'VisualMapComponent',
        xAxis: 'GridComponent',
        yAxis: 'GridComponent',
        angleAxis: 'PolarComponent',
        radiusAxis: 'PolarComponent'
    };
    var $525568051e570380$var$BUILTIN_CHARTS_MAP = {
        line: 'LineChart',
        bar: 'BarChart',
        pie: 'PieChart',
        scatter: 'ScatterChart',
        radar: 'RadarChart',
        map: 'MapChart',
        tree: 'TreeChart',
        treemap: 'TreemapChart',
        graph: 'GraphChart',
        gauge: 'GaugeChart',
        funnel: 'FunnelChart',
        parallel: 'ParallelChart',
        sankey: 'SankeyChart',
        boxplot: 'BoxplotChart',
        candlestick: 'CandlestickChart',
        effectScatter: 'EffectScatterChart',
        lines: 'LinesChart',
        heatmap: 'HeatmapChart',
        pictorialBar: 'PictorialBarChart',
        themeRiver: 'ThemeRiverChart',
        sunburst: 'SunburstChart',
        custom: 'CustomChart'
    };
    var $525568051e570380$var$componetsMissingLogPrinted = {};
    function $525568051e570380$var$checkMissingComponents(option) {
        (0, (0, parcelRequire("bahqM")).each)(option, function(componentOption, mainType) {
            if (!(0, (0, parcelRequire("h4UlH")).default).hasClass(mainType)) {
                var componentImportName = $525568051e570380$var$BUITIN_COMPONENTS_MAP[mainType];
                if (componentImportName && !$525568051e570380$var$componetsMissingLogPrinted[componentImportName]) {
                    (0, (0, parcelRequire("2cFRc")).error)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                    $525568051e570380$var$componetsMissingLogPrinted[componentImportName] = true;
                }
            }
        });
    }
    var $525568051e570380$var$GlobalModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GlobalModel, _super);
        function GlobalModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
            theme = theme || {};
            this.option = null;
            this._theme = new (0, (0, parcelRequire("gaMkj")).default)(theme);
            this._locale = new (0, (0, parcelRequire("gaMkj")).default)(locale);
            this._optionManager = optionManager;
        };
        GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
            var innerOpt = $525568051e570380$var$normalizeSetOptionInput(opts);
            this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
            this._resetOption(null, innerOpt);
        };
        GlobalModel.prototype.resetOption = function(type, opt) {
            return this._resetOption(type, $525568051e570380$var$normalizeSetOptionInput(opt));
        };
        GlobalModel.prototype._resetOption = function(type, opt) {
            var optionChanged = false;
            var optionManager = this._optionManager;
            if (!type || type === 'recreate') {
                var baseOption = optionManager.mountOption(type === 'recreate');
                if (!this.option || type === 'recreate') $525568051e570380$var$initBase(this, baseOption);
                else {
                    this.restoreData();
                    this._mergeOption(baseOption, opt);
                }
                optionChanged = true;
            }
            if (type === 'timeline' || type === 'media') this.restoreData();
            if (!type || type === 'recreate' || type === 'timeline') {
                var timelineOption = optionManager.getTimelineOption(this);
                if (timelineOption) {
                    optionChanged = true;
                    this._mergeOption(timelineOption, opt);
                }
            }
            if (!type || type === 'recreate' || type === 'media') {
                var mediaOptions = optionManager.getMediaOption(this);
                if (mediaOptions.length) (0, (0, parcelRequire("bahqM")).each)(mediaOptions, function(mediaOption) {
                    optionChanged = true;
                    this._mergeOption(mediaOption, opt);
                }, this);
            }
            return optionChanged;
        };
        GlobalModel.prototype.mergeOption = function(option) {
            this._mergeOption(option, null);
        };
        GlobalModel.prototype._mergeOption = function(newOption, opt) {
            var option = this.option;
            var componentsMap = this._componentsMap;
            var componentsCount = this._componentsCount;
            var newCmptTypes = [];
            var newCmptTypeMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
            (0, (0, parcelRequire("cNGs8")).resetSourceDefaulter)(this);
            (0, (0, parcelRequire("bahqM")).each)(newOption, function(componentOption, mainType) {
                if (componentOption == null) return;
                if (!(0, (0, parcelRequire("h4UlH")).default).hasClass(mainType)) option[mainType] = option[mainType] == null ? (0, (0, parcelRequire("bahqM")).clone)(componentOption) : (0, (0, parcelRequire("bahqM")).merge)(option[mainType], componentOption, true);
                else if (mainType) {
                    newCmptTypes.push(mainType);
                    newCmptTypeMap.set(mainType, true);
                }
            });
            if (replaceMergeMainTypeMap) replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
                if ((0, (0, parcelRequire("h4UlH")).default).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                    newCmptTypes.push(mainTypeInReplaceMerge);
                    newCmptTypeMap.set(mainTypeInReplaceMerge, true);
                }
            });
            (0, (0, parcelRequire("h4UlH")).default).topologicalTravel(newCmptTypes, (0, (0, parcelRequire("h4UlH")).default).getAllClassMainTypes(), visitComponent, this);
            function visitComponent(mainType) {
                var newCmptOptionList = (0, (0, parcelRequire("iSVvO")).concatInternalOptions)(this, mainType, (0, parcelRequire("eaKsF")).normalizeToArray(newOption[mainType]));
                var oldCmptList = componentsMap.get(mainType);
                var mergeMode = !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
                var mappingResult = (0, parcelRequire("eaKsF")).mappingToExists(oldCmptList, newCmptOptionList, mergeMode);
                (0, parcelRequire("eaKsF")).setComponentTypeToKeyInfo(mappingResult, mainType, (0, (0, parcelRequire("h4UlH")).default));
                option[mainType] = null;
                componentsMap.set(mainType, null);
                componentsCount.set(mainType, 0);
                var optionsByMainType = [];
                var cmptsByMainType = [];
                var cmptsCountByMainType = 0;
                (0, (0, parcelRequire("bahqM")).each)(mappingResult, function(resultItem, index) {
                    var componentModel = resultItem.existing;
                    var newCmptOption = resultItem.newOption;
                    if (!newCmptOption) {
                        if (componentModel) {
                            componentModel.mergeOption({}, this);
                            componentModel.optionUpdated({}, false);
                        }
                    } else {
                        var isSeriesType = mainType === 'series';
                        var ComponentModelClass = (0, (0, parcelRequire("h4UlH")).default).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType);
                        if (!ComponentModelClass) {
                            var subType, seriesImportName;
                            return;
                        }
                        if (componentModel && componentModel.constructor === ComponentModelClass) {
                            componentModel.name = resultItem.keyInfo.name;
                            componentModel.mergeOption(newCmptOption, this);
                            componentModel.optionUpdated(newCmptOption, false);
                        } else {
                            var extraOpt = (0, (0, parcelRequire("bahqM")).extend)({
                                componentIndex: index
                            }, resultItem.keyInfo);
                            componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                            (0, (0, parcelRequire("bahqM")).extend)(componentModel, extraOpt);
                            if (resultItem.brandNew) componentModel.__requireNewView = true;
                            componentModel.init(newCmptOption, this, this);
                            componentModel.optionUpdated(null, true);
                        }
                    }
                    if (componentModel) {
                        optionsByMainType.push(componentModel.option);
                        cmptsByMainType.push(componentModel);
                        cmptsCountByMainType++;
                    } else {
                        optionsByMainType.push(void 0);
                        cmptsByMainType.push(void 0);
                    }
                }, this);
                option[mainType] = optionsByMainType;
                componentsMap.set(mainType, cmptsByMainType);
                componentsCount.set(mainType, cmptsCountByMainType);
                if (mainType === 'series') $525568051e570380$var$reCreateSeriesIndices(this);
            }
            if (!this._seriesIndices) $525568051e570380$var$reCreateSeriesIndices(this);
        };
        GlobalModel.prototype.getOption = function() {
            var option = (0, (0, parcelRequire("bahqM")).clone)(this.option);
            (0, (0, parcelRequire("bahqM")).each)(option, function(optInMainType, mainType) {
                if ((0, (0, parcelRequire("h4UlH")).default).hasClass(mainType)) {
                    var opts = (0, parcelRequire("eaKsF")).normalizeToArray(optInMainType);
                    var realLen = opts.length;
                    var metNonInner = false;
                    for(var i = realLen - 1; i >= 0; i--)if (opts[i] && !(0, parcelRequire("eaKsF")).isComponentIdInternal(opts[i])) metNonInner = true;
                    else {
                        opts[i] = null;
                        !metNonInner && realLen--;
                    }
                    opts.length = realLen;
                    option[mainType] = opts;
                }
            });
            delete option[$525568051e570380$var$OPTION_INNER_KEY];
            return option;
        };
        GlobalModel.prototype.getTheme = function() {
            return this._theme;
        };
        GlobalModel.prototype.getLocaleModel = function() {
            return this._locale;
        };
        GlobalModel.prototype.setUpdatePayload = function(payload) {
            this._payload = payload;
        };
        GlobalModel.prototype.getUpdatePayload = function() {
            return this._payload;
        };
        GlobalModel.prototype.getComponent = function(mainType, idx) {
            var list = this._componentsMap.get(mainType);
            if (list) {
                var cmpt = list[idx || 0];
                if (cmpt) return cmpt;
                else if (idx == null) for(var i = 0; i < list.length; i++){
                    if (list[i]) return list[i];
                }
            }
        };
        GlobalModel.prototype.queryComponents = function(condition) {
            var mainType = condition.mainType;
            if (!mainType) return [];
            var index = condition.index;
            var id = condition.id;
            var name = condition.name;
            var cmpts = this._componentsMap.get(mainType);
            if (!cmpts || !cmpts.length) return [];
            var result;
            if (index != null) {
                result = [];
                (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(index), function(idx) {
                    cmpts[idx] && result.push(cmpts[idx]);
                });
            } else if (id != null) result = $525568051e570380$var$queryByIdOrName('id', id, cmpts);
            else if (name != null) result = $525568051e570380$var$queryByIdOrName('name', name, cmpts);
            else result = (0, (0, parcelRequire("bahqM")).filter)(cmpts, function(cmpt) {
                return !!cmpt;
            });
            return $525568051e570380$var$filterBySubType(result, condition);
        };
        GlobalModel.prototype.findComponents = function(condition) {
            var query = condition.query;
            var mainType = condition.mainType;
            var queryCond = getQueryCond(query);
            var result = queryCond ? this.queryComponents(queryCond) : (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get(mainType), function(cmpt) {
                return !!cmpt;
            });
            return doFilter($525568051e570380$var$filterBySubType(result, condition));
            function getQueryCond(q) {
                var indexAttr = mainType + 'Index';
                var idAttr = mainType + 'Id';
                var nameAttr = mainType + 'Name';
                return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                    mainType: mainType,
                    index: q[indexAttr],
                    id: q[idAttr],
                    name: q[nameAttr]
                } : null;
            }
            function doFilter(res) {
                return condition.filter ? (0, (0, parcelRequire("bahqM")).filter)(res, condition.filter) : res;
            }
        };
        GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
            var componentsMap = this._componentsMap;
            if ((0, (0, parcelRequire("bahqM")).isFunction)(mainType)) {
                var ctxForAll_1 = cb;
                var cbForAll_1 = mainType;
                componentsMap.each(function(cmpts, componentType) {
                    for(var i = 0; cmpts && i < cmpts.length; i++){
                        var cmpt = cmpts[i];
                        cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                    }
                });
            } else {
                var cmpts = (0, (0, parcelRequire("bahqM")).isString)(mainType) ? componentsMap.get(mainType) : (0, (0, parcelRequire("bahqM")).isObject)(mainType) ? this.findComponents(mainType) : null;
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cb.call(context, cmpt, cmpt.componentIndex);
                }
            }
        };
        GlobalModel.prototype.getSeriesByName = function(name) {
            var nameStr = (0, parcelRequire("eaKsF")).convertOptionIdName(name, null);
            return (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get('series'), function(oneSeries) {
                return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
            });
        };
        GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
            return this._componentsMap.get('series')[seriesIndex];
        };
        GlobalModel.prototype.getSeriesByType = function(subType) {
            return (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get('series'), function(oneSeries) {
                return !!oneSeries && oneSeries.subType === subType;
            });
        };
        GlobalModel.prototype.getSeries = function() {
            return (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get('series'), function(oneSeries) {
                return !!oneSeries;
            });
        };
        GlobalModel.prototype.getSeriesCount = function() {
            return this._componentsCount.get('series');
        };
        GlobalModel.prototype.eachSeries = function(cb, context) {
            $525568051e570380$var$assertSeriesInitialized(this);
            (0, (0, parcelRequire("bahqM")).each)(this._seriesIndices, function(rawSeriesIndex) {
                var series = this._componentsMap.get('series')[rawSeriesIndex];
                cb.call(context, series, rawSeriesIndex);
            }, this);
        };
        GlobalModel.prototype.eachRawSeries = function(cb, context) {
            (0, (0, parcelRequire("bahqM")).each)(this._componentsMap.get('series'), function(series) {
                series && cb.call(context, series, series.componentIndex);
            });
        };
        GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
            $525568051e570380$var$assertSeriesInitialized(this);
            (0, (0, parcelRequire("bahqM")).each)(this._seriesIndices, function(rawSeriesIndex) {
                var series = this._componentsMap.get('series')[rawSeriesIndex];
                if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
            }, this);
        };
        GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
            return (0, (0, parcelRequire("bahqM")).each)(this.getSeriesByType(subType), cb, context);
        };
        GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
            $525568051e570380$var$assertSeriesInitialized(this);
            return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
        };
        GlobalModel.prototype.getCurrentSeriesIndices = function() {
            return (this._seriesIndices || []).slice();
        };
        GlobalModel.prototype.filterSeries = function(cb, context) {
            $525568051e570380$var$assertSeriesInitialized(this);
            var newSeriesIndices = [];
            (0, (0, parcelRequire("bahqM")).each)(this._seriesIndices, function(seriesRawIdx) {
                var series = this._componentsMap.get('series')[seriesRawIdx];
                cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
            }, this);
            this._seriesIndices = newSeriesIndices;
            this._seriesIndicesMap = (0, (0, parcelRequire("bahqM")).createHashMap)(newSeriesIndices);
        };
        GlobalModel.prototype.restoreData = function(payload) {
            $525568051e570380$var$reCreateSeriesIndices(this);
            var componentsMap = this._componentsMap;
            var componentTypes = [];
            componentsMap.each(function(components, componentType) {
                if ((0, (0, parcelRequire("h4UlH")).default).hasClass(componentType)) componentTypes.push(componentType);
            });
            (0, (0, parcelRequire("h4UlH")).default).topologicalTravel(componentTypes, (0, (0, parcelRequire("h4UlH")).default).getAllClassMainTypes(), function(componentType) {
                (0, (0, parcelRequire("bahqM")).each)(componentsMap.get(componentType), function(component) {
                    if (component && (componentType !== 'series' || !$525568051e570380$var$isNotTargetSeries(component, payload))) component.restoreData();
                });
            });
        };
        GlobalModel.internalField = function() {
            $525568051e570380$var$reCreateSeriesIndices = function(ecModel) {
                var seriesIndices = ecModel._seriesIndices = [];
                (0, (0, parcelRequire("bahqM")).each)(ecModel._componentsMap.get('series'), function(series) {
                    series && seriesIndices.push(series.componentIndex);
                });
                ecModel._seriesIndicesMap = (0, (0, parcelRequire("bahqM")).createHashMap)(seriesIndices);
            };
            $525568051e570380$var$assertSeriesInitialized = function(ecModel) {};
            $525568051e570380$var$initBase = function(ecModel, baseOption) {
                ecModel.option = {};
                ecModel.option[$525568051e570380$var$OPTION_INNER_KEY] = $525568051e570380$var$OPTION_INNER_VALUE;
                ecModel._componentsMap = (0, (0, parcelRequire("bahqM")).createHashMap)({
                    series: []
                });
                ecModel._componentsCount = (0, (0, parcelRequire("bahqM")).createHashMap)();
                var airaOption = baseOption.aria;
                if ((0, (0, parcelRequire("bahqM")).isObject)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
                $525568051e570380$var$mergeTheme(baseOption, ecModel._theme.option);
                (0, (0, parcelRequire("bahqM")).merge)(baseOption, (0, (0, parcelRequire("34Vzq")).default), false);
                ecModel._mergeOption(baseOption, null);
            };
        }();
        return GlobalModel;
    }((0, (0, parcelRequire("gaMkj")).default));
    function $525568051e570380$var$isNotTargetSeries(seriesModel, payload) {
        if (payload) {
            var index = payload.seriesIndex;
            var id = payload.seriesId;
            var name_1 = payload.seriesName;
            return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
        }
    }
    function $525568051e570380$var$mergeTheme(option, theme) {
        var notMergeColorLayer = option.color && !option.colorLayer;
        (0, (0, parcelRequire("bahqM")).each)(theme, function(themeItem, name) {
            if (name === 'colorLayer' && notMergeColorLayer) return;
            if (!(0, (0, parcelRequire("h4UlH")).default).hasClass(name)) {
                if (typeof themeItem === 'object') option[name] = !option[name] ? (0, (0, parcelRequire("bahqM")).clone)(themeItem) : (0, (0, parcelRequire("bahqM")).merge)(option[name], themeItem, false);
                else if (option[name] == null) option[name] = themeItem;
            }
        });
    }
    function $525568051e570380$var$queryByIdOrName(attr, idOrName, cmpts) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(idOrName)) {
            var keyMap_1 = (0, (0, parcelRequire("bahqM")).createHashMap)();
            (0, (0, parcelRequire("bahqM")).each)(idOrName, function(idOrNameItem) {
                if (idOrNameItem != null) {
                    var idName = (0, parcelRequire("eaKsF")).convertOptionIdName(idOrNameItem, null);
                    idName != null && keyMap_1.set(idOrNameItem, true);
                }
            });
            return (0, (0, parcelRequire("bahqM")).filter)(cmpts, function(cmpt) {
                return cmpt && keyMap_1.get(cmpt[attr]);
            });
        } else {
            var idName_1 = (0, parcelRequire("eaKsF")).convertOptionIdName(idOrName, null);
            return (0, (0, parcelRequire("bahqM")).filter)(cmpts, function(cmpt) {
                return cmpt && idName_1 != null && cmpt[attr] === idName_1;
            });
        }
    }
    function $525568051e570380$var$filterBySubType(components, condition) {
        return condition.hasOwnProperty('subType') ? (0, (0, parcelRequire("bahqM")).filter)(components, function(cmpt) {
            return cmpt && cmpt.subType === condition.subType;
        }) : components;
    }
    function $525568051e570380$var$normalizeSetOptionInput(opts) {
        var replaceMergeMainTypeMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        opts && (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(opts.replaceMerge), function(mainType) {
            replaceMergeMainTypeMap.set(mainType, true);
        });
        return {
            replaceMergeMainTypeMap: replaceMergeMainTypeMap
        };
    }
    (0, (0, parcelRequire("bahqM")).mixin)($525568051e570380$var$GlobalModel, (0, (0, parcelRequire("aCu4v")).PaletteMixin));
    var $525568051e570380$export$2e2bcd8739ae039 = $525568051e570380$var$GlobalModel;
});
parcelRegister("34Vzq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23de6718d94f8f53$export$2e2bcd8739ae039);
    var $23de6718d94f8f53$var$platform = '';
    if (typeof navigator !== 'undefined') $23de6718d94f8f53$var$platform = navigator.platform || '';
    var $23de6718d94f8f53$var$decalColor = 'rgba(0, 0, 0, 0.2)';
    var $23de6718d94f8f53$export$2e2bcd8739ae039 = {
        darkMode: 'auto',
        colorBy: 'series',
        color: [
            '#5470c6',
            '#91cc75',
            '#fac858',
            '#ee6666',
            '#73c0de',
            '#3ba272',
            '#fc8452',
            '#9a60b4',
            '#ea7ccc'
        ],
        gradientColor: [
            '#f6efa6',
            '#d88273',
            '#bf444c'
        ],
        aria: {
            decal: {
                decals: [
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            1,
                            0
                        ],
                        dashArrayY: [
                            2,
                            5
                        ],
                        symbolSize: 1,
                        rotation: Math.PI / 6
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        symbol: 'circle',
                        dashArrayX: [
                            [
                                8,
                                8
                            ],
                            [
                                0,
                                8,
                                8,
                                0
                            ]
                        ],
                        dashArrayY: [
                            6,
                            0
                        ],
                        symbolSize: 0.8
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            1,
                            0
                        ],
                        dashArrayY: [
                            4,
                            3
                        ],
                        rotation: -Math.PI / 4
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            [
                                6,
                                6
                            ],
                            [
                                0,
                                6,
                                6,
                                0
                            ]
                        ],
                        dashArrayY: [
                            6,
                            0
                        ]
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            [
                                1,
                                0
                            ],
                            [
                                1,
                                6
                            ]
                        ],
                        dashArrayY: [
                            1,
                            0,
                            6,
                            0
                        ],
                        rotation: Math.PI / 4
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        symbol: 'triangle',
                        dashArrayX: [
                            [
                                9,
                                9
                            ],
                            [
                                0,
                                9,
                                9,
                                0
                            ]
                        ],
                        dashArrayY: [
                            7,
                            2
                        ],
                        symbolSize: 0.75
                    }
                ]
            }
        },
        textStyle: {
            fontFamily: $23de6718d94f8f53$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
            fontSize: 12,
            fontStyle: 'normal',
            fontWeight: 'normal'
        },
        blendMode: null,
        stateAnimation: {
            duration: 300,
            easing: 'cubicOut'
        },
        animation: 'auto',
        animationDuration: 1000,
        animationDurationUpdate: 500,
        animationEasing: 'cubicInOut',
        animationEasingUpdate: 'cubicInOut',
        animationThreshold: 2000,
        progressiveThreshold: 3000,
        progressive: 400,
        hoverLayerThreshold: 3000,
        useUTC: false
    };
});
parcelRegister("iSVvO", function(module, exports) {
    $parcel$export(module.exports, "registerInternalOptionCreator", ()=>$dbf9e1d336044ced$export$5a90be4668898d38);
    $parcel$export(module.exports, "concatInternalOptions", ()=>$dbf9e1d336044ced$export$c713a6a3b43f401d);
    var $bahqM;
    var $dbf9e1d336044ced$var$internalOptionCreatorMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
    function $dbf9e1d336044ced$export$5a90be4668898d38(mainType, creator) {
        (0, (0, parcelRequire("bahqM")).assert)($dbf9e1d336044ced$var$internalOptionCreatorMap.get(mainType) == null && creator);
        $dbf9e1d336044ced$var$internalOptionCreatorMap.set(mainType, creator);
    }
    function $dbf9e1d336044ced$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
        var internalOptionCreator = $dbf9e1d336044ced$var$internalOptionCreatorMap.get(mainType);
        if (!internalOptionCreator) return newCmptOptionList;
        var internalOptions = internalOptionCreator(ecModel);
        if (!internalOptions) return newCmptOptionList;
        var i;
        return newCmptOptionList.concat(internalOptions);
    }
});
parcelRegister("iEvqc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9445617d131115d$export$2e2bcd8739ae039);
    var $bahqM;
    var $d9445617d131115d$var$availableMethods = [
        'getDom',
        'getZr',
        'getWidth',
        'getHeight',
        'getDevicePixelRatio',
        'dispatchAction',
        'isDisposed',
        'on',
        'off',
        'getDataURL',
        'getConnectedDataURL',
        'getOption',
        'getId',
        'updateLabelLayout'
    ];
    var $d9445617d131115d$var$ExtensionAPI = function() {
        function ExtensionAPI(ecInstance) {
            (0, parcelRequire("bahqM")).each($d9445617d131115d$var$availableMethods, function(methodName) {
                this[methodName] = (0, parcelRequire("bahqM")).bind(ecInstance[methodName], ecInstance);
            }, this);
        }
        return ExtensionAPI;
    }();
    var $d9445617d131115d$export$2e2bcd8739ae039 = $d9445617d131115d$var$ExtensionAPI;
});
parcelRegister("6LzFt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ed2ccc95e9b6d0d$export$2e2bcd8739ae039);
    var $eaKsF;
    var $bahqM;
    var $4ed2ccc95e9b6d0d$var$QUERY_REG = /^(min|max)?(.+)$/;
    var $4ed2ccc95e9b6d0d$var$OptionManager = function() {
        function OptionManager(api) {
            this._timelineOptions = [];
            this._mediaList = [];
            this._currentMediaIndices = [];
            this._api = api;
        }
        OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
            if (rawOption) {
                (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("eaKsF")).normalizeToArray)(rawOption.series), function(series) {
                    series && series.data && (0, (0, parcelRequire("bahqM")).isTypedArray)(series.data) && (0, (0, parcelRequire("bahqM")).setAsPrimitive)(series.data);
                });
                (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("eaKsF")).normalizeToArray)(rawOption.dataset), function(dataset) {
                    dataset && dataset.source && (0, (0, parcelRequire("bahqM")).isTypedArray)(dataset.source) && (0, (0, parcelRequire("bahqM")).setAsPrimitive)(dataset.source);
                });
            }
            rawOption = (0, (0, parcelRequire("bahqM")).clone)(rawOption);
            var optionBackup = this._optionBackup;
            var newParsedOption = $4ed2ccc95e9b6d0d$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
            this._newBaseOption = newParsedOption.baseOption;
            if (optionBackup) {
                if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
                if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
                if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
            } else this._optionBackup = newParsedOption;
        };
        OptionManager.prototype.mountOption = function(isRecreate) {
            var optionBackup = this._optionBackup;
            this._timelineOptions = optionBackup.timelineOptions;
            this._mediaList = optionBackup.mediaList;
            this._mediaDefault = optionBackup.mediaDefault;
            this._currentMediaIndices = [];
            return (0, (0, parcelRequire("bahqM")).clone)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
        };
        OptionManager.prototype.getTimelineOption = function(ecModel) {
            var option;
            var timelineOptions = this._timelineOptions;
            if (timelineOptions.length) {
                var timelineModel = ecModel.getComponent('timeline');
                if (timelineModel) option = (0, (0, parcelRequire("bahqM")).clone)(timelineOptions[timelineModel.getCurrentIndex()]);
            }
            return option;
        };
        OptionManager.prototype.getMediaOption = function(ecModel) {
            var ecWidth = this._api.getWidth();
            var ecHeight = this._api.getHeight();
            var mediaList = this._mediaList;
            var mediaDefault = this._mediaDefault;
            var indices = [];
            var result = [];
            if (!mediaList.length && !mediaDefault) return result;
            for(var i = 0, len = mediaList.length; i < len; i++)if ($4ed2ccc95e9b6d0d$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
            if (!indices.length && mediaDefault) indices = [
                -1
            ];
            if (indices.length && !$4ed2ccc95e9b6d0d$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, (0, parcelRequire("bahqM")).map)(indices, function(index) {
                return (0, (0, parcelRequire("bahqM")).clone)(index === -1 ? mediaDefault.option : mediaList[index].option);
            });
            this._currentMediaIndices = indices;
            return result;
        };
        return OptionManager;
    }();
    function $4ed2ccc95e9b6d0d$var$parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
        var mediaList = [];
        var mediaDefault;
        var baseOption;
        var declaredBaseOption = rawOption.baseOption;
        var timelineOnRoot = rawOption.timeline;
        var timelineOptionsOnRoot = rawOption.options;
        var mediaOnRoot = rawOption.media;
        var hasMedia = !!rawOption.media;
        var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
        if (declaredBaseOption) {
            baseOption = declaredBaseOption;
            if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
        } else {
            if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
            baseOption = rawOption;
        }
        if (hasMedia) {
            if ((0, (0, parcelRequire("bahqM")).isArray)(mediaOnRoot)) (0, (0, parcelRequire("bahqM")).each)(mediaOnRoot, function(singleMedia) {
                if (singleMedia && singleMedia.option) {
                    if (singleMedia.query) mediaList.push(singleMedia);
                    else if (!mediaDefault) mediaDefault = singleMedia;
                }
            });
        }
        doPreprocess(baseOption);
        (0, (0, parcelRequire("bahqM")).each)(timelineOptionsOnRoot, function(option) {
            return doPreprocess(option);
        });
        (0, (0, parcelRequire("bahqM")).each)(mediaList, function(media) {
            return doPreprocess(media.option);
        });
        function doPreprocess(option) {
            (0, (0, parcelRequire("bahqM")).each)(optionPreprocessorFuncs, function(preProcess) {
                preProcess(option, isNew);
            });
        }
        return {
            baseOption: baseOption,
            timelineOptions: timelineOptionsOnRoot || [],
            mediaDefault: mediaDefault,
            mediaList: mediaList
        };
    }
    function $4ed2ccc95e9b6d0d$var$applyMediaQuery(query, ecWidth, ecHeight) {
        var realMap = {
            width: ecWidth,
            height: ecHeight,
            aspectratio: ecWidth / ecHeight
        };
        var applicatable = true;
        (0, (0, parcelRequire("bahqM")).each)(query, function(value, attr) {
            var matched = attr.match($4ed2ccc95e9b6d0d$var$QUERY_REG);
            if (!matched || !matched[1] || !matched[2]) return;
            var operator = matched[1];
            var realAttr = matched[2].toLowerCase();
            if (!$4ed2ccc95e9b6d0d$var$compare(realMap[realAttr], value, operator)) applicatable = false;
        });
        return applicatable;
    }
    function $4ed2ccc95e9b6d0d$var$compare(real, expect, operator) {
        if (operator === 'min') return real >= expect;
        else if (operator === 'max') return real <= expect;
        else return real === expect;
    }
    function $4ed2ccc95e9b6d0d$var$indicesEquals(indices1, indices2) {
        return indices1.join(',') === indices2.join(',');
    }
    var $4ed2ccc95e9b6d0d$export$2e2bcd8739ae039 = $4ed2ccc95e9b6d0d$var$OptionManager;
});
parcelRegister("driCQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c8c3e9bb43407b9$export$2e2bcd8739ae039);
    var $bahqM;
    var $9rY8k;
    var $eaKsF;
    function $9c8c3e9bb43407b9$var$get(opt, path) {
        var pathArr = path.split(',');
        var obj = opt;
        for(var i = 0; i < pathArr.length; i++){
            obj = obj && obj[pathArr[i]];
            if (obj == null) break;
        }
        return obj;
    }
    function $9c8c3e9bb43407b9$var$set(opt, path, val, overwrite) {
        var pathArr = path.split(',');
        var obj = opt;
        var key;
        var i = 0;
        for(; i < pathArr.length - 1; i++){
            key = pathArr[i];
            if (obj[key] == null) obj[key] = {};
            obj = obj[key];
        }
        if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
    }
    function $9c8c3e9bb43407b9$var$compatLayoutProperties(option) {
        option && (0, (0, parcelRequire("bahqM")).each)($9c8c3e9bb43407b9$var$LAYOUT_PROPERTIES, function(prop) {
            if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
        });
    }
    var $9c8c3e9bb43407b9$var$LAYOUT_PROPERTIES = [
        [
            'x',
            'left'
        ],
        [
            'y',
            'top'
        ],
        [
            'x2',
            'right'
        ],
        [
            'y2',
            'bottom'
        ]
    ];
    var $9c8c3e9bb43407b9$var$COMPATITABLE_COMPONENTS = [
        'grid',
        'geo',
        'parallel',
        'legend',
        'toolbox',
        'title',
        'visualMap',
        'dataZoom',
        'timeline'
    ];
    var $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP = [
        [
            'borderRadius',
            'barBorderRadius'
        ],
        [
            'borderColor',
            'barBorderColor'
        ],
        [
            'borderWidth',
            'barBorderWidth'
        ]
    ];
    function $9c8c3e9bb43407b9$var$compatBarItemStyle(option) {
        var itemStyle = option && option.itemStyle;
        if (itemStyle) for(var i = 0; i < $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP.length; i++){
            var oldName = $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP[i][1];
            var newName = $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP[i][0];
            if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
        }
    }
    function $9c8c3e9bb43407b9$var$compatPieLabel(option) {
        if (!option) return;
        if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
    }
    function $9c8c3e9bb43407b9$var$compatSunburstState(option) {
        if (!option) return;
        if (option.downplay && !option.blur) option.blur = option.downplay;
    }
    function $9c8c3e9bb43407b9$var$compatGraphFocus(option) {
        if (!option) return;
        if (option.focusNodeAdjacency != null) {
            option.emphasis = option.emphasis || {};
            if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
        }
    }
    function $9c8c3e9bb43407b9$var$traverseTree(data, cb) {
        if (data) for(var i = 0; i < data.length; i++){
            cb(data[i]);
            data[i] && $9c8c3e9bb43407b9$var$traverseTree(data[i].children, cb);
        }
    }
    function $9c8c3e9bb43407b9$export$2e2bcd8739ae039(option, isTheme) {
        (0, (0, parcelRequire("9rY8k")).default)(option, isTheme);
        option.series = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(option.series);
        (0, (0, parcelRequire("bahqM")).each)(option.series, function(seriesOpt) {
            if (!(0, (0, parcelRequire("bahqM")).isObject)(seriesOpt)) return;
            var seriesType = seriesOpt.type;
            if (seriesType === 'line') {
                if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
            } else if (seriesType === 'pie' || seriesType === 'gauge') {
                if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
                $9c8c3e9bb43407b9$var$compatPieLabel(seriesOpt.label);
                var data = seriesOpt.data;
                if (data && !(0, (0, parcelRequire("bahqM")).isTypedArray)(data)) for(var i = 0; i < data.length; i++)$9c8c3e9bb43407b9$var$compatPieLabel(data[i]);
                if (seriesOpt.hoverOffset != null) {
                    seriesOpt.emphasis = seriesOpt.emphasis || {};
                    seriesOpt.emphasis.scaleSize = null;
                }
            } else if (seriesType === 'gauge') {
                var pointerColor = $9c8c3e9bb43407b9$var$get(seriesOpt, 'pointer.color');
                pointerColor != null && $9c8c3e9bb43407b9$var$set(seriesOpt, 'itemStyle.color', pointerColor);
            } else if (seriesType === 'bar') {
                $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt);
                $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt.backgroundStyle);
                $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt.emphasis);
                var data = seriesOpt.data;
                if (data && !(0, (0, parcelRequire("bahqM")).isTypedArray)(data)) {
                    for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                        $9c8c3e9bb43407b9$var$compatBarItemStyle(data[i]);
                        $9c8c3e9bb43407b9$var$compatBarItemStyle(data[i] && data[i].emphasis);
                    }
                }
            } else if (seriesType === 'sunburst') {
                var highlightPolicy = seriesOpt.highlightPolicy;
                if (highlightPolicy) {
                    seriesOpt.emphasis = seriesOpt.emphasis || {};
                    if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
                }
                $9c8c3e9bb43407b9$var$compatSunburstState(seriesOpt);
                $9c8c3e9bb43407b9$var$traverseTree(seriesOpt.data, $9c8c3e9bb43407b9$var$compatSunburstState);
            } else if (seriesType === 'graph' || seriesType === 'sankey') $9c8c3e9bb43407b9$var$compatGraphFocus(seriesOpt);
            else if (seriesType === 'map') {
                if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
                if (seriesOpt.mapLocation) (0, (0, parcelRequire("bahqM")).defaults)(seriesOpt, seriesOpt.mapLocation);
            }
            if (seriesOpt.hoverAnimation != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
            }
            $9c8c3e9bb43407b9$var$compatLayoutProperties(seriesOpt);
        });
        if (option.dataRange) option.visualMap = option.dataRange;
        (0, (0, parcelRequire("bahqM")).each)($9c8c3e9bb43407b9$var$COMPATITABLE_COMPONENTS, function(componentName) {
            var options = option[componentName];
            if (options) {
                if (!(0, (0, parcelRequire("bahqM")).isArray)(options)) options = [
                    options
                ];
                (0, (0, parcelRequire("bahqM")).each)(options, function(option) {
                    $9c8c3e9bb43407b9$var$compatLayoutProperties(option);
                });
            }
        });
    }
});
parcelRegister("9rY8k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e1547e334933782$export$2e2bcd8739ae039);
    var $bahqM;
    var $eaKsF;
    var $6e1547e334933782$var$each = (0, parcelRequire("bahqM")).each;
    var $6e1547e334933782$var$isObject = (0, parcelRequire("bahqM")).isObject;
    var $6e1547e334933782$var$POSSIBLE_STYLES = [
        'areaStyle',
        'lineStyle',
        'nodeStyle',
        'linkStyle',
        'chordStyle',
        'label',
        'labelLine'
    ];
    function $6e1547e334933782$var$compatEC2ItemStyle(opt) {
        var itemStyleOpt = opt && opt.itemStyle;
        if (!itemStyleOpt) return;
        for(var i = 0, len = $6e1547e334933782$var$POSSIBLE_STYLES.length; i < len; i++){
            var styleName = $6e1547e334933782$var$POSSIBLE_STYLES[i];
            var normalItemStyleOpt = itemStyleOpt.normal;
            var emphasisItemStyleOpt = itemStyleOpt.emphasis;
            if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
                opt[styleName] = opt[styleName] || {};
                if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
                else (0, parcelRequire("bahqM")).merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
                normalItemStyleOpt[styleName] = null;
            }
            if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
                opt[styleName] = opt[styleName] || {};
                if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
                else (0, parcelRequire("bahqM")).merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
                emphasisItemStyleOpt[styleName] = null;
            }
        }
    }
    function $6e1547e334933782$var$convertNormalEmphasis(opt, optType, useExtend) {
        if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
            var normalOpt = opt[optType].normal;
            var emphasisOpt = opt[optType].emphasis;
            if (normalOpt) {
                if (useExtend) {
                    opt[optType].normal = opt[optType].emphasis = null;
                    (0, parcelRequire("bahqM")).defaults(opt[optType], normalOpt);
                } else opt[optType] = normalOpt;
            }
            if (emphasisOpt) {
                opt.emphasis = opt.emphasis || {};
                opt.emphasis[optType] = emphasisOpt;
                if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
                if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
            }
        }
    }
    function $6e1547e334933782$var$removeEC3NormalStatus(opt) {
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'itemStyle');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'lineStyle');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'areaStyle');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'label');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'labelLine');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'upperLabel');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'edgeLabel');
    }
    function $6e1547e334933782$var$compatTextStyle(opt, propName) {
        var labelOptSingle = $6e1547e334933782$var$isObject(opt) && opt[propName];
        var textStyle = $6e1547e334933782$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
        if (textStyle) for(var i = 0, len = (0, parcelRequire("eaKsF")).TEXT_STYLE_OPTIONS.length; i < len; i++){
            var textPropName = (0, parcelRequire("eaKsF")).TEXT_STYLE_OPTIONS[i];
            if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
        }
    }
    function $6e1547e334933782$var$compatEC3CommonStyles(opt) {
        if (opt) {
            $6e1547e334933782$var$removeEC3NormalStatus(opt);
            $6e1547e334933782$var$compatTextStyle(opt, 'label');
            opt.emphasis && $6e1547e334933782$var$compatTextStyle(opt.emphasis, 'label');
        }
    }
    function $6e1547e334933782$var$processSeries(seriesOpt) {
        if (!$6e1547e334933782$var$isObject(seriesOpt)) return;
        $6e1547e334933782$var$compatEC2ItemStyle(seriesOpt);
        $6e1547e334933782$var$removeEC3NormalStatus(seriesOpt);
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'label');
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'upperLabel');
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'edgeLabel');
        if (seriesOpt.emphasis) {
            $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'label');
            $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel');
            $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
        }
        var markPoint = seriesOpt.markPoint;
        if (markPoint) {
            $6e1547e334933782$var$compatEC2ItemStyle(markPoint);
            $6e1547e334933782$var$compatEC3CommonStyles(markPoint);
        }
        var markLine = seriesOpt.markLine;
        if (markLine) {
            $6e1547e334933782$var$compatEC2ItemStyle(markLine);
            $6e1547e334933782$var$compatEC3CommonStyles(markLine);
        }
        var markArea = seriesOpt.markArea;
        if (markArea) $6e1547e334933782$var$compatEC3CommonStyles(markArea);
        var data = seriesOpt.data;
        if (seriesOpt.type === 'graph') {
            data = data || seriesOpt.nodes;
            var edgeData = seriesOpt.links || seriesOpt.edges;
            if (edgeData && !(0, parcelRequire("bahqM")).isTypedArray(edgeData)) for(var i = 0; i < edgeData.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(edgeData[i]);
            (0, parcelRequire("bahqM")).each(seriesOpt.categories, function(opt) {
                $6e1547e334933782$var$removeEC3NormalStatus(opt);
            });
        }
        if (data && !(0, parcelRequire("bahqM")).isTypedArray(data)) for(var i = 0; i < data.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(data[i]);
        markPoint = seriesOpt.markPoint;
        if (markPoint && markPoint.data) {
            var mpData = markPoint.data;
            for(var i = 0; i < mpData.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(mpData[i]);
        }
        markLine = seriesOpt.markLine;
        if (markLine && markLine.data) {
            var mlData = markLine.data;
            for(var i = 0; i < mlData.length; i++)if ((0, parcelRequire("bahqM")).isArray(mlData[i])) {
                $6e1547e334933782$var$compatEC3CommonStyles(mlData[i][0]);
                $6e1547e334933782$var$compatEC3CommonStyles(mlData[i][1]);
            } else $6e1547e334933782$var$compatEC3CommonStyles(mlData[i]);
        }
        if (seriesOpt.type === 'gauge') {
            $6e1547e334933782$var$compatTextStyle(seriesOpt, 'axisLabel');
            $6e1547e334933782$var$compatTextStyle(seriesOpt, 'title');
            $6e1547e334933782$var$compatTextStyle(seriesOpt, 'detail');
        } else if (seriesOpt.type === 'treemap') {
            $6e1547e334933782$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
            (0, parcelRequire("bahqM")).each(seriesOpt.levels, function(opt) {
                $6e1547e334933782$var$removeEC3NormalStatus(opt);
            });
        } else if (seriesOpt.type === 'tree') $6e1547e334933782$var$removeEC3NormalStatus(seriesOpt.leaves);
    }
    function $6e1547e334933782$var$toArr(o) {
        return (0, parcelRequire("bahqM")).isArray(o) ? o : o ? [
            o
        ] : [];
    }
    function $6e1547e334933782$var$toObj(o) {
        return ((0, parcelRequire("bahqM")).isArray(o) ? o[0] : o) || {};
    }
    function $6e1547e334933782$export$2e2bcd8739ae039(option, isTheme) {
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.series), function(seriesOpt) {
            $6e1547e334933782$var$isObject(seriesOpt) && $6e1547e334933782$var$processSeries(seriesOpt);
        });
        var axes = [
            'xAxis',
            'yAxis',
            'radiusAxis',
            'angleAxis',
            'singleAxis',
            'parallelAxis',
            'radar'
        ];
        isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
        $6e1547e334933782$var$each(axes, function(axisName) {
            $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option[axisName]), function(axisOpt) {
                if (axisOpt) {
                    $6e1547e334933782$var$compatTextStyle(axisOpt, 'axisLabel');
                    $6e1547e334933782$var$compatTextStyle(axisOpt.axisPointer, 'label');
                }
            });
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.parallel), function(parallelOpt) {
            var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
            $6e1547e334933782$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
            $6e1547e334933782$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.calendar), function(calendarOpt) {
            $6e1547e334933782$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
            $6e1547e334933782$var$compatTextStyle(calendarOpt, 'dayLabel');
            $6e1547e334933782$var$compatTextStyle(calendarOpt, 'monthLabel');
            $6e1547e334933782$var$compatTextStyle(calendarOpt, 'yearLabel');
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.radar), function(radarOpt) {
            $6e1547e334933782$var$compatTextStyle(radarOpt, 'name');
            if (radarOpt.name && radarOpt.axisName == null) {
                radarOpt.axisName = radarOpt.name;
                delete radarOpt.name;
            }
            if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
                radarOpt.axisNameGap = radarOpt.nameGap;
                delete radarOpt.nameGap;
            }
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.geo), function(geoOpt) {
            if ($6e1547e334933782$var$isObject(geoOpt)) {
                $6e1547e334933782$var$compatEC3CommonStyles(geoOpt);
                $6e1547e334933782$var$each($6e1547e334933782$var$toArr(geoOpt.regions), function(regionObj) {
                    $6e1547e334933782$var$compatEC3CommonStyles(regionObj);
                });
            }
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.timeline), function(timelineOpt) {
            $6e1547e334933782$var$compatEC3CommonStyles(timelineOpt);
            $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'label');
            $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
            $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
            var data = timelineOpt.data;
            (0, parcelRequire("bahqM")).isArray(data) && (0, parcelRequire("bahqM")).each(data, function(item) {
                if ((0, parcelRequire("bahqM")).isObject(item)) {
                    $6e1547e334933782$var$convertNormalEmphasis(item, 'label');
                    $6e1547e334933782$var$convertNormalEmphasis(item, 'itemStyle');
                }
            });
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.toolbox), function(toolboxOpt) {
            $6e1547e334933782$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
            $6e1547e334933782$var$each(toolboxOpt.feature, function(featureOpt) {
                $6e1547e334933782$var$convertNormalEmphasis(featureOpt, 'iconStyle');
            });
        });
        $6e1547e334933782$var$compatTextStyle($6e1547e334933782$var$toObj(option.axisPointer), 'label');
        $6e1547e334933782$var$compatTextStyle($6e1547e334933782$var$toObj(option.tooltip).axisPointer, 'label');
    }
});
parcelRegister("iMppY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dac06d23d0856818$export$2e2bcd8739ae039);
    var $bahqM;
    var $jmSNG;
    function $dac06d23d0856818$export$2e2bcd8739ae039(ecModel) {
        var stackInfoMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var stack = seriesModel.get('stack');
            if (stack) {
                var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
                var data = seriesModel.getData();
                var stackInfo = {
                    stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                    stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                    stackedDimension: data.getCalculationInfo('stackedDimension'),
                    stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                    isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                    data: data,
                    seriesModel: seriesModel
                };
                if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
                stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
                stackInfoList.push(stackInfo);
            }
        });
        stackInfoMap.each($dac06d23d0856818$var$calculateStack);
    }
    function $dac06d23d0856818$var$calculateStack(stackInfoList) {
        (0, (0, parcelRequire("bahqM")).each)(stackInfoList, function(targetStackInfo, idxInStack) {
            var resultVal = [];
            var resultNaN = [
                NaN,
                NaN
            ];
            var dims = [
                targetStackInfo.stackResultDimension,
                targetStackInfo.stackedOverDimension
            ];
            var targetData = targetStackInfo.data;
            var isStackedByIndex = targetStackInfo.isStackedByIndex;
            targetData.modify(dims, function(v0, v1, dataIndex) {
                var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
                if (isNaN(sum)) return resultNaN;
                var byValue;
                var stackedDataRawIndex;
                if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
                else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
                var stackedOver = NaN;
                for(var j = idxInStack - 1; j >= 0; j--){
                    var stackInfo = stackInfoList[j];
                    if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                    if (stackedDataRawIndex >= 0) {
                        var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                        if (sum >= 0 && val > 0 || sum <= 0 && val < 0) {
                            sum = (0, (0, parcelRequire("jmSNG")).addSafe)(sum, val);
                            stackedOver = val;
                            break;
                        }
                    }
                }
                resultVal[0] = sum;
                resultVal[1] = stackedOver;
                return resultVal;
            });
        });
    }
});
parcelRegister("fkskt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b28eb2e2a247a7d9$export$2e2bcd8739ae039);
    var $4KVOr;
    var $jvo6O;
    var $aLwh0;
    var $b28eb2e2a247a7d9$var$ComponentView = function() {
        function ComponentView() {
            this.group = new (0, (0, parcelRequire("4KVOr")).default)();
            this.uid = (0, parcelRequire("jvo6O")).getUID('viewComponent');
        }
        ComponentView.prototype.init = function(ecModel, api) {};
        ComponentView.prototype.render = function(model, ecModel, api, payload) {};
        ComponentView.prototype.dispose = function(ecModel, api) {};
        ComponentView.prototype.updateView = function(model, ecModel, api, payload) {};
        ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {};
        ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {};
        ComponentView.prototype.blurSeries = function(seriesModels, ecModel) {};
        return ComponentView;
    }();
    (0, parcelRequire("aLwh0")).enableClassExtend($b28eb2e2a247a7d9$var$ComponentView);
    (0, parcelRequire("aLwh0")).enableClassManagement($b28eb2e2a247a7d9$var$ComponentView);
    var $b28eb2e2a247a7d9$export$2e2bcd8739ae039 = $b28eb2e2a247a7d9$var$ComponentView;
});
parcelRegister("ljaBy", function(module, exports) {
    $parcel$export(module.exports, "throttle", ()=>$f833992c62ea3b89$export$de363e709c412c8a);
    $parcel$export(module.exports, "createOrUpdate", ()=>$f833992c62ea3b89$export$958e3e1a02eac4b6);
    $parcel$export(module.exports, "clear", ()=>$f833992c62ea3b89$export$42ffd38884aecdac);
    var $f833992c62ea3b89$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
    var $f833992c62ea3b89$var$RATE = '\0__throttleRate';
    var $f833992c62ea3b89$var$THROTTLE_TYPE = '\0__throttleType';
    function $f833992c62ea3b89$export$de363e709c412c8a(fn, delay, debounce) {
        var currCall;
        var lastCall = 0;
        var lastExec = 0;
        var timer = null;
        var diff;
        var scope;
        var args;
        var debounceNextCall;
        delay = delay || 0;
        function exec() {
            lastExec = new Date().getTime();
            timer = null;
            fn.apply(scope, args || []);
        }
        var cb = function() {
            var cbArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
            currCall = new Date().getTime();
            scope = this;
            args = cbArgs;
            var thisDelay = debounceNextCall || delay;
            var thisDebounce = debounceNextCall || debounce;
            debounceNextCall = null;
            diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
            clearTimeout(timer);
            if (thisDebounce) timer = setTimeout(exec, thisDelay);
            else if (diff >= 0) exec();
            else timer = setTimeout(exec, -diff);
            lastCall = currCall;
        };
        cb.clear = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        };
        cb.debounceNextCall = function(debounceDelay) {
            debounceNextCall = debounceDelay;
        };
        return cb;
    }
    function $f833992c62ea3b89$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
        var fn = obj[fnAttr];
        if (!fn) return;
        var originFn = fn[$f833992c62ea3b89$var$ORIGIN_METHOD] || fn;
        var lastThrottleType = fn[$f833992c62ea3b89$var$THROTTLE_TYPE];
        var lastRate = fn[$f833992c62ea3b89$var$RATE];
        if (lastRate !== rate || lastThrottleType !== throttleType) {
            if (rate == null || !throttleType) return obj[fnAttr] = originFn;
            fn = obj[fnAttr] = $f833992c62ea3b89$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
            fn[$f833992c62ea3b89$var$ORIGIN_METHOD] = originFn;
            fn[$f833992c62ea3b89$var$THROTTLE_TYPE] = throttleType;
            fn[$f833992c62ea3b89$var$RATE] = rate;
        }
        return fn;
    }
    function $f833992c62ea3b89$export$42ffd38884aecdac(obj, fnAttr) {
        var fn = obj[fnAttr];
        if (fn && fn[$f833992c62ea3b89$var$ORIGIN_METHOD]) obj[fnAttr] = fn[$f833992c62ea3b89$var$ORIGIN_METHOD];
    }
});
parcelRegister("cvEVp", function(module, exports) {
    $parcel$export(module.exports, "seriesStyleTask", ()=>$91b820231b41a759$export$7ce4d65f9b69240);
    $parcel$export(module.exports, "dataStyleTask", ()=>$91b820231b41a759$export$f7dcb66a065003d1);
    $parcel$export(module.exports, "dataColorPaletteTask", ()=>$91b820231b41a759$export$cf9758b0d6dc0aa9);
    var $bahqM;
    var $1BJbl;
    var $4rldO;
    var $46U6E;
    var $gaMkj;
    var $eaKsF;
    var $91b820231b41a759$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $91b820231b41a759$var$defaultStyleMappers = {
        itemStyle: (0, (0, parcelRequire("1BJbl")).default)((0, (0, parcelRequire("4rldO")).ITEM_STYLE_KEY_MAP), true),
        lineStyle: (0, (0, parcelRequire("1BJbl")).default)((0, (0, parcelRequire("46U6E")).LINE_STYLE_KEY_MAP), true)
    };
    var $91b820231b41a759$var$defaultColorKey = {
        lineStyle: 'stroke',
        itemStyle: 'fill'
    };
    function $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath) {
        var styleMapper = seriesModel.visualStyleMapper || $91b820231b41a759$var$defaultStyleMappers[stylePath];
        if (!styleMapper) {
            console.warn("Unkown style type '" + stylePath + "'.");
            return $91b820231b41a759$var$defaultStyleMappers.itemStyle;
        }
        return styleMapper;
    }
    function $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath) {
        var colorKey = seriesModel.visualDrawType || $91b820231b41a759$var$defaultColorKey[stylePath];
        if (!colorKey) {
            console.warn("Unkown style type '" + stylePath + "'.");
            return 'fill';
        }
        return colorKey;
    }
    var $91b820231b41a759$export$7ce4d65f9b69240 = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var styleModel = seriesModel.getModel(stylePath);
            var getStyle = $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath);
            var globalStyle = getStyle(styleModel);
            var decalOption = styleModel.getShallow('decal');
            if (decalOption) {
                data.setVisual('decal', decalOption);
                decalOption.dirty = true;
            }
            var colorKey = $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath);
            var color = globalStyle[colorKey];
            var colorCallback = (0, (0, parcelRequire("bahqM")).isFunction)(color) ? color : null;
            var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto';
            if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
                var colorPalette = seriesModel.getColorFromPalette(seriesModel.name, null, ecModel.getSeriesCount());
                if (!globalStyle[colorKey]) {
                    globalStyle[colorKey] = colorPalette;
                    data.setVisual('colorFromPalette', true);
                }
                globalStyle.fill = globalStyle.fill === 'auto' || typeof globalStyle.fill === 'function' ? colorPalette : globalStyle.fill;
                globalStyle.stroke = globalStyle.stroke === 'auto' || typeof globalStyle.stroke === 'function' ? colorPalette : globalStyle.stroke;
            }
            data.setVisual('style', globalStyle);
            data.setVisual('drawType', colorKey);
            if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
                data.setVisual('colorFromPalette', false);
                return {
                    dataEach: function(data, idx) {
                        var dataParams = seriesModel.getDataParams(idx);
                        var itemStyle = (0, (0, parcelRequire("bahqM")).extend)({}, globalStyle);
                        itemStyle[colorKey] = colorCallback(dataParams);
                        data.setItemVisual(idx, 'style', itemStyle);
                    }
                };
            }
        }
    };
    var $91b820231b41a759$var$sharedModel = new (0, (0, parcelRequire("gaMkj")).default)();
    var $91b820231b41a759$export$f7dcb66a065003d1 = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
            var data = seriesModel.getData();
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var getStyle = $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath);
            var colorKey = data.getVisual('drawType');
            return {
                dataEach: data.hasItemOption ? function(data, idx) {
                    var rawItem = data.getRawDataItem(idx);
                    if (rawItem && rawItem[stylePath]) {
                        $91b820231b41a759$var$sharedModel.option = rawItem[stylePath];
                        var style = getStyle($91b820231b41a759$var$sharedModel);
                        var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                        (0, (0, parcelRequire("bahqM")).extend)(existsStyle, style);
                        if ($91b820231b41a759$var$sharedModel.option.decal) {
                            data.setItemVisual(idx, 'decal', $91b820231b41a759$var$sharedModel.option.decal);
                            $91b820231b41a759$var$sharedModel.option.decal.dirty = true;
                        }
                        if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                    }
                } : null
            };
        }
    };
    var $91b820231b41a759$export$cf9758b0d6dc0aa9 = {
        performRawSeries: true,
        overallReset: function(ecModel) {
            var paletteScopeGroupByType = (0, (0, parcelRequire("bahqM")).createHashMap)();
            ecModel.eachSeries(function(seriesModel) {
                var colorBy = seriesModel.getColorBy();
                if (seriesModel.isColorBySeries()) return;
                var key = seriesModel.type + '-' + colorBy;
                var colorScope = paletteScopeGroupByType.get(key);
                if (!colorScope) {
                    colorScope = {};
                    paletteScopeGroupByType.set(key, colorScope);
                }
                $91b820231b41a759$var$inner(seriesModel).scope = colorScope;
            });
            ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
                var dataAll = seriesModel.getRawData();
                var idxMap = {};
                var data = seriesModel.getData();
                var colorScope = $91b820231b41a759$var$inner(seriesModel).scope;
                var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
                var colorKey = $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath);
                data.each(function(idx) {
                    var rawIdx = data.getRawIndex(idx);
                    idxMap[rawIdx] = idx;
                });
                dataAll.each(function(rawIdx) {
                    var idx = idxMap[rawIdx];
                    var fromPalette = data.getItemVisual(idx, 'colorFromPalette');
                    if (fromPalette) {
                        var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                        var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                        var dataCount = dataAll.count();
                        itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                    }
                });
            });
        }
    };
});
parcelRegister("4G956", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3682210406d5dc21$export$2e2bcd8739ae039);
    var $bahqM;
    parcelRequire("fHITF");
    var $ixXaU;
    var $7Tw7u;
    var $4KVOr;
    var $4gEFv;
    var $3682210406d5dc21$var$PI = Math.PI;
    function $3682210406d5dc21$export$2e2bcd8739ae039(api, opts) {
        opts = opts || {};
        (0, parcelRequire("bahqM")).defaults(opts, {
            text: 'loading',
            textColor: '#000',
            fontSize: 12,
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontFamily: 'sans-serif',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            showSpinner: true,
            color: '#5470c6',
            spinnerRadius: 10,
            lineWidth: 5,
            zlevel: 0
        });
        var group = new (0, parcelRequire("4KVOr")).default();
        var mask = new (0, parcelRequire("7Tw7u")).default({
            style: {
                fill: opts.maskColor
            },
            zlevel: opts.zlevel,
            z: 10000
        });
        group.add(mask);
        var textContent = new (0, parcelRequire("4gEFv")).default({
            style: {
                text: opts.text,
                fill: opts.textColor,
                fontSize: opts.fontSize,
                fontWeight: opts.fontWeight,
                fontStyle: opts.fontStyle,
                fontFamily: opts.fontFamily
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        var labelRect = new (0, parcelRequire("7Tw7u")).default({
            style: {
                fill: 'none'
            },
            textContent: textContent,
            textConfig: {
                position: 'right',
                distance: 10
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        group.add(labelRect);
        var arc;
        if (opts.showSpinner) {
            arc = new (0, parcelRequire("ixXaU")).default({
                shape: {
                    startAngle: -$3682210406d5dc21$var$PI / 2,
                    endAngle: -$3682210406d5dc21$var$PI / 2 + 0.1,
                    r: opts.spinnerRadius
                },
                style: {
                    stroke: opts.color,
                    lineCap: 'round',
                    lineWidth: opts.lineWidth
                },
                zlevel: opts.zlevel,
                z: 10001
            });
            arc.animateShape(true).when(1000, {
                endAngle: $3682210406d5dc21$var$PI * 3 / 2
            }).start('circularInOut');
            arc.animateShape(true).when(1000, {
                startAngle: $3682210406d5dc21$var$PI * 3 / 2
            }).delay(300).start('circularInOut');
            group.add(arc);
        }
        group.resize = function() {
            var textWidth = textContent.getBoundingRect().width;
            var r = opts.showSpinner ? opts.spinnerRadius : 0;
            var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
            var cy = api.getHeight() / 2;
            opts.showSpinner && arc.setShape({
                cx: cx,
                cy: cy
            });
            labelRect.setShape({
                x: cx - r,
                y: cy - r,
                width: r * 2,
                height: r * 2
            });
            mask.setShape({
                x: 0,
                y: 0,
                width: api.getWidth(),
                height: api.getHeight()
            });
        };
        group.resize();
        return group;
    }
});
parcelRegister("14WFd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c93ab8c51628eb2$export$2e2bcd8739ae039);
    var $bahqM;
    var $92IK1;
    var $jvo6O;
    var $74g78;
    var $iEvqc;
    var $eaKsF;
    var $0c93ab8c51628eb2$var$Scheduler = function() {
        function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
            this._stageTaskMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this.ecInstance = ecInstance;
            this.api = api;
            dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
            visualHandlers = this._visualHandlers = visualHandlers.slice();
            this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
        }
        Scheduler.prototype.restoreData = function(ecModel, payload) {
            ecModel.restoreData(payload);
            this._stageTaskMap.each(function(taskRecord) {
                var overallTask = taskRecord.overallTask;
                overallTask && overallTask.dirty();
            });
        };
        Scheduler.prototype.getPerformArgs = function(task, isBlock) {
            if (!task.__pipeline) return;
            var pipeline = this._pipelineMap.get(task.__pipeline.id);
            var pCtx = pipeline.context;
            var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
            var step = incremental ? pipeline.step : null;
            var modDataCount = pCtx && pCtx.modDataCount;
            var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
            return {
                step: step,
                modBy: modBy,
                modDataCount: modDataCount
            };
        };
        Scheduler.prototype.getPipeline = function(pipelineId) {
            return this._pipelineMap.get(pipelineId);
        };
        Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
            var pipeline = this._pipelineMap.get(seriesModel.uid);
            var data = seriesModel.getData();
            var dataLen = data.count();
            var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
            var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold');
            var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
            seriesModel.pipelineContext = pipeline.context = {
                progressiveRender: progressiveRender,
                modDataCount: modDataCount,
                large: large
            };
        };
        Scheduler.prototype.restorePipelines = function(ecModel) {
            var scheduler = this;
            var pipelineMap = scheduler._pipelineMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            ecModel.eachSeries(function(seriesModel) {
                var progressive = seriesModel.getProgressive();
                var pipelineId = seriesModel.uid;
                pipelineMap.set(pipelineId, {
                    id: pipelineId,
                    head: null,
                    tail: null,
                    threshold: seriesModel.getProgressiveThreshold(),
                    progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                    blockIndex: -1,
                    step: Math.round(progressive || 700),
                    count: 0
                });
                scheduler._pipe(seriesModel, seriesModel.dataTask);
            });
        };
        Scheduler.prototype.prepareStageTasks = function() {
            var stageTaskMap = this._stageTaskMap;
            var ecModel = this.api.getModel();
            var api = this.api;
            (0, (0, parcelRequire("bahqM")).each)(this._allHandlers, function(handler) {
                var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
                var errMsg = '';
                (0, (0, parcelRequire("bahqM")).assert)(!(handler.reset && handler.overallReset), errMsg);
                handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
                handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
            }, this);
        };
        Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
            var renderTask = view.renderTask;
            var context = renderTask.context;
            context.model = model;
            context.ecModel = ecModel;
            context.api = api;
            renderTask.__block = !view.incrementalPrepareRender;
            this._pipe(model, renderTask);
        };
        Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
            this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
                block: true
            });
        };
        Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
            this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
        };
        Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
            opt = opt || {};
            var unfinished = false;
            var scheduler = this;
            (0, (0, parcelRequire("bahqM")).each)(stageHandlers, function(stageHandler, idx) {
                if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
                var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
                var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
                var overallTask = stageHandlerRecord.overallTask;
                if (overallTask) {
                    var overallNeedDirty_1;
                    var agentStubMap = overallTask.agentStubMap;
                    agentStubMap.each(function(stub) {
                        if (needSetDirty(opt, stub)) {
                            stub.dirty();
                            overallNeedDirty_1 = true;
                        }
                    });
                    overallNeedDirty_1 && overallTask.dirty();
                    scheduler.updatePayload(overallTask, payload);
                    var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                    agentStubMap.each(function(stub) {
                        stub.perform(performArgs_1);
                    });
                    if (overallTask.perform(performArgs_1)) unfinished = true;
                } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                    if (needSetDirty(opt, task)) task.dirty();
                    var performArgs = scheduler.getPerformArgs(task, opt.block);
                    performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                    scheduler.updatePayload(task, payload);
                    if (task.perform(performArgs)) unfinished = true;
                });
            });
            function needSetDirty(opt, task) {
                return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
            }
            this.unfinished = unfinished || this.unfinished;
        };
        Scheduler.prototype.performSeriesTasks = function(ecModel) {
            var unfinished;
            ecModel.eachSeries(function(seriesModel) {
                unfinished = seriesModel.dataTask.perform() || unfinished;
            });
            this.unfinished = unfinished || this.unfinished;
        };
        Scheduler.prototype.plan = function() {
            this._pipelineMap.each(function(pipeline) {
                var task = pipeline.tail;
                do {
                    if (task.__block) {
                        pipeline.blockIndex = task.__idxInPipeline;
                        break;
                    }
                    task = task.getUpstream();
                }while (task)
            });
        };
        Scheduler.prototype.updatePayload = function(task, payload) {
            payload !== 'remain' && (task.context.payload = payload);
        };
        Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
            var scheduler = this;
            var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var seriesType = stageHandler.seriesType;
            var getTargetSeries = stageHandler.getTargetSeries;
            if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
            else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
            else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
            function create(seriesModel) {
                var pipelineId = seriesModel.uid;
                var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, (0, parcelRequire("92IK1")).createTask)({
                    plan: $0c93ab8c51628eb2$var$seriesTaskPlan,
                    reset: $0c93ab8c51628eb2$var$seriesTaskReset,
                    count: $0c93ab8c51628eb2$var$seriesTaskCount
                }));
                task.context = {
                    model: seriesModel,
                    ecModel: ecModel,
                    api: api,
                    useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                    plan: stageHandler.plan,
                    reset: stageHandler.reset,
                    scheduler: scheduler
                };
                scheduler._pipe(seriesModel, task);
            }
        };
        Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
            var scheduler = this;
            var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, (0, parcelRequire("92IK1")).createTask)({
                reset: $0c93ab8c51628eb2$var$overallTaskReset
            });
            overallTask.context = {
                ecModel: ecModel,
                api: api,
                overallReset: stageHandler.overallReset,
                scheduler: scheduler
            };
            var oldAgentStubMap = overallTask.agentStubMap;
            var newAgentStubMap = overallTask.agentStubMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var seriesType = stageHandler.seriesType;
            var getTargetSeries = stageHandler.getTargetSeries;
            var overallProgress = true;
            var shouldOverallTaskDirty = false;
            var errMsg = '';
            (0, (0, parcelRequire("bahqM")).assert)(!stageHandler.createOnAllSeries, errMsg);
            if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
            else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
            else {
                overallProgress = false;
                (0, (0, parcelRequire("bahqM")).each)(ecModel.getSeries(), createStub);
            }
            function createStub(seriesModel) {
                var pipelineId = seriesModel.uid;
                var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || (shouldOverallTaskDirty = true, (0, (0, parcelRequire("92IK1")).createTask)({
                    reset: $0c93ab8c51628eb2$var$stubReset,
                    onDirty: $0c93ab8c51628eb2$var$stubOnDirty
                })));
                stub.context = {
                    model: seriesModel,
                    overallProgress: overallProgress
                };
                stub.agent = overallTask;
                stub.__block = overallProgress;
                scheduler._pipe(seriesModel, stub);
            }
            if (shouldOverallTaskDirty) overallTask.dirty();
        };
        Scheduler.prototype._pipe = function(seriesModel, task) {
            var pipelineId = seriesModel.uid;
            var pipeline = this._pipelineMap.get(pipelineId);
            !pipeline.head && (pipeline.head = task);
            pipeline.tail && pipeline.tail.pipe(task);
            pipeline.tail = task;
            task.__idxInPipeline = pipeline.count++;
            task.__pipeline = pipeline;
        };
        Scheduler.wrapStageHandler = function(stageHandler, visualType) {
            if ((0, (0, parcelRequire("bahqM")).isFunction)(stageHandler)) stageHandler = {
                overallReset: stageHandler,
                seriesType: $0c93ab8c51628eb2$var$detectSeriseType(stageHandler)
            };
            stageHandler.uid = (0, (0, parcelRequire("jvo6O")).getUID)('stageHandler');
            visualType && (stageHandler.visualType = visualType);
            return stageHandler;
        };
        return Scheduler;
    }();
    function $0c93ab8c51628eb2$var$overallTaskReset(context) {
        context.overallReset(context.ecModel, context.api, context.payload);
    }
    function $0c93ab8c51628eb2$var$stubReset(context) {
        return context.overallProgress && $0c93ab8c51628eb2$var$stubProgress;
    }
    function $0c93ab8c51628eb2$var$stubProgress() {
        this.agent.dirty();
        this.getDownstream().dirty();
    }
    function $0c93ab8c51628eb2$var$stubOnDirty() {
        this.agent && this.agent.dirty();
    }
    function $0c93ab8c51628eb2$var$seriesTaskPlan(context) {
        return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
    }
    function $0c93ab8c51628eb2$var$seriesTaskReset(context) {
        if (context.useClearVisual) context.data.clearAllVisual();
        var resetDefines = context.resetDefines = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(context.reset(context.model, context.ecModel, context.api, context.payload));
        return resetDefines.length > 1 ? (0, (0, parcelRequire("bahqM")).map)(resetDefines, function(v, idx) {
            return $0c93ab8c51628eb2$var$makeSeriesTaskProgress(idx);
        }) : $0c93ab8c51628eb2$var$singleSeriesTaskProgress;
    }
    var $0c93ab8c51628eb2$var$singleSeriesTaskProgress = $0c93ab8c51628eb2$var$makeSeriesTaskProgress(0);
    function $0c93ab8c51628eb2$var$makeSeriesTaskProgress(resetDefineIdx) {
        return function(params, context) {
            var data = context.data;
            var resetDefine = context.resetDefines[resetDefineIdx];
            if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
            else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
        };
    }
    function $0c93ab8c51628eb2$var$seriesTaskCount(context) {
        return context.data.count();
    }
    function $0c93ab8c51628eb2$var$detectSeriseType(legacyFunc) {
        $0c93ab8c51628eb2$var$seriesType = null;
        try {
            legacyFunc($0c93ab8c51628eb2$var$ecModelMock, $0c93ab8c51628eb2$var$apiMock);
        } catch (e) {}
        return $0c93ab8c51628eb2$var$seriesType;
    }
    var $0c93ab8c51628eb2$var$ecModelMock = {};
    var $0c93ab8c51628eb2$var$apiMock = {};
    var $0c93ab8c51628eb2$var$seriesType;
    $0c93ab8c51628eb2$var$mockMethods($0c93ab8c51628eb2$var$ecModelMock, (0, (0, parcelRequire("74g78")).default));
    $0c93ab8c51628eb2$var$mockMethods($0c93ab8c51628eb2$var$apiMock, (0, (0, parcelRequire("iEvqc")).default));
    $0c93ab8c51628eb2$var$ecModelMock.eachSeriesByType = $0c93ab8c51628eb2$var$ecModelMock.eachRawSeriesByType = function(type) {
        $0c93ab8c51628eb2$var$seriesType = type;
    };
    $0c93ab8c51628eb2$var$ecModelMock.eachComponent = function(cond) {
        if (cond.mainType === 'series' && cond.subType) $0c93ab8c51628eb2$var$seriesType = cond.subType;
    };
    function $0c93ab8c51628eb2$var$mockMethods(target, Clz) {
        for(var name_1 in Clz.prototype)target[name_1] = (0, (0, parcelRequire("bahqM")).noop);
    }
    var $0c93ab8c51628eb2$export$2e2bcd8739ae039 = $0c93ab8c51628eb2$var$Scheduler;
});
parcelRegister("31FQc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2341ebce6d7d92ac$export$2e2bcd8739ae039);
    var $2341ebce6d7d92ac$var$colorAll = [
        '#37A2DA',
        '#32C5E9',
        '#67E0E3',
        '#9FE6B8',
        '#FFDB5C',
        '#ff9f7f',
        '#fb7293',
        '#E062AE',
        '#E690D1',
        '#e7bcf3',
        '#9d96f5',
        '#8378EA',
        '#96BFFF'
    ];
    var $2341ebce6d7d92ac$export$2e2bcd8739ae039 = {
        color: $2341ebce6d7d92ac$var$colorAll,
        colorLayer: [
            [
                '#37A2DA',
                '#ffd85c',
                '#fd7b5f'
            ],
            [
                '#37A2DA',
                '#67E0E3',
                '#FFDB5C',
                '#ff9f7f',
                '#E062AE',
                '#9d96f5'
            ],
            [
                '#37A2DA',
                '#32C5E9',
                '#9FE6B8',
                '#FFDB5C',
                '#ff9f7f',
                '#fb7293',
                '#e7bcf3',
                '#8378EA',
                '#96BFFF'
            ],
            $2341ebce6d7d92ac$var$colorAll
        ]
    };
});
parcelRegister("dMJCs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a093251ea09c66fc$export$2e2bcd8739ae039);
    var $a093251ea09c66fc$var$contrastColor = '#B9B8CE';
    var $a093251ea09c66fc$var$backgroundColor = '#100C2A';
    var $a093251ea09c66fc$var$axisCommon = function() {
        return {
            axisLine: {
                lineStyle: {
                    color: $a093251ea09c66fc$var$contrastColor
                }
            },
            splitLine: {
                lineStyle: {
                    color: '#484753'
                }
            },
            splitArea: {
                areaStyle: {
                    color: [
                        'rgba(255,255,255,0.02)',
                        'rgba(255,255,255,0.05)'
                    ]
                }
            },
            minorSplitLine: {
                lineStyle: {
                    color: '#20203B'
                }
            }
        };
    };
    var $a093251ea09c66fc$var$colorPalette = [
        '#4992ff',
        '#7cffb2',
        '#fddd60',
        '#ff6e76',
        '#58d9f9',
        '#05c091',
        '#ff8a45',
        '#8d48e3',
        '#dd79ff'
    ];
    var $a093251ea09c66fc$var$theme = {
        darkMode: true,
        color: $a093251ea09c66fc$var$colorPalette,
        backgroundColor: $a093251ea09c66fc$var$backgroundColor,
        axisPointer: {
            lineStyle: {
                color: '#817f91'
            },
            crossStyle: {
                color: '#817f91'
            },
            label: {
                color: '#fff'
            }
        },
        legend: {
            textStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        textStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        title: {
            textStyle: {
                color: '#EEF1FA'
            },
            subtextStyle: {
                color: '#B9B8CE'
            }
        },
        toolbox: {
            iconStyle: {
                borderColor: $a093251ea09c66fc$var$contrastColor
            }
        },
        dataZoom: {
            borderColor: '#71708A',
            textStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            brushStyle: {
                color: 'rgba(135,163,206,0.3)'
            },
            handleStyle: {
                color: '#353450',
                borderColor: '#C5CBE3'
            },
            moveHandleStyle: {
                color: '#B0B6C3',
                opacity: 0.3
            },
            fillerColor: 'rgba(135,163,206,0.2)',
            emphasis: {
                handleStyle: {
                    borderColor: '#91B7F2',
                    color: '#4D587D'
                },
                moveHandleStyle: {
                    color: '#636D9A',
                    opacity: 0.7
                }
            },
            dataBackground: {
                lineStyle: {
                    color: '#71708A',
                    width: 1
                },
                areaStyle: {
                    color: '#71708A'
                }
            },
            selectedDataBackground: {
                lineStyle: {
                    color: '#87A3CE'
                },
                areaStyle: {
                    color: '#87A3CE'
                }
            }
        },
        visualMap: {
            textStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        timeline: {
            lineStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            label: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            controlStyle: {
                color: $a093251ea09c66fc$var$contrastColor,
                borderColor: $a093251ea09c66fc$var$contrastColor
            }
        },
        calendar: {
            itemStyle: {
                color: $a093251ea09c66fc$var$backgroundColor
            },
            dayLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            monthLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            yearLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        timeAxis: $a093251ea09c66fc$var$axisCommon(),
        logAxis: $a093251ea09c66fc$var$axisCommon(),
        valueAxis: $a093251ea09c66fc$var$axisCommon(),
        categoryAxis: $a093251ea09c66fc$var$axisCommon(),
        line: {
            symbol: 'circle'
        },
        graph: {
            color: $a093251ea09c66fc$var$colorPalette
        },
        gauge: {
            title: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            axisLine: {
                lineStyle: {
                    color: [
                        [
                            1,
                            'rgba(207,212,219,0.2)'
                        ]
                    ]
                }
            },
            axisLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            detail: {
                color: '#EEF1FA'
            }
        },
        candlestick: {
            itemStyle: {
                color: '#f64e56',
                color0: '#54ea92',
                borderColor: '#f64e56',
                borderColor0: '#54ea92'
            }
        }
    };
    $a093251ea09c66fc$var$theme.categoryAxis.splitLine.show = false;
    var $a093251ea09c66fc$export$2e2bcd8739ae039 = $a093251ea09c66fc$var$theme;
});
parcelRegister("cbv5T", function(module, exports) {
    $parcel$export(module.exports, "ECEventProcessor", ()=>$8deea1bcfc845e61$export$d0fd09f950257b52);
    var $bahqM;
    var $aLwh0;
    var $8deea1bcfc845e61$export$d0fd09f950257b52 = function() {
        function ECEventProcessor() {}
        ECEventProcessor.prototype.normalizeQuery = function(query) {
            var cptQuery = {};
            var dataQuery = {};
            var otherQuery = {};
            if ((0, parcelRequire("bahqM")).isString(query)) {
                var condCptType = (0, (0, parcelRequire("aLwh0")).parseClassType)(query);
                cptQuery.mainType = condCptType.main || null;
                cptQuery.subType = condCptType.sub || null;
            } else {
                var suffixes_1 = [
                    'Index',
                    'Name',
                    'Id'
                ];
                var dataKeys_1 = {
                    name: 1,
                    dataIndex: 1,
                    dataType: 1
                };
                (0, parcelRequire("bahqM")).each(query, function(val, key) {
                    var reserved = false;
                    for(var i = 0; i < suffixes_1.length; i++){
                        var propSuffix = suffixes_1[i];
                        var suffixPos = key.lastIndexOf(propSuffix);
                        if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                            var mainType = key.slice(0, suffixPos);
                            if (mainType !== 'data') {
                                cptQuery.mainType = mainType;
                                cptQuery[propSuffix.toLowerCase()] = val;
                                reserved = true;
                            }
                        }
                    }
                    if (dataKeys_1.hasOwnProperty(key)) {
                        dataQuery[key] = val;
                        reserved = true;
                    }
                    if (!reserved) otherQuery[key] = val;
                });
            }
            return {
                cptQuery: cptQuery,
                dataQuery: dataQuery,
                otherQuery: otherQuery
            };
        };
        ECEventProcessor.prototype.filter = function(eventType, query) {
            var eventInfo = this.eventInfo;
            if (!eventInfo) return true;
            var targetEl = eventInfo.targetEl;
            var packedEvent = eventInfo.packedEvent;
            var model = eventInfo.model;
            var view = eventInfo.view;
            if (!model || !view) return true;
            var cptQuery = query.cptQuery;
            var dataQuery = query.dataQuery;
            return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
            function check(query, host, prop, propOnHost) {
                return query[prop] == null || host[propOnHost || prop] === query[prop];
            }
        };
        ECEventProcessor.prototype.afterTrigger = function() {
            this.eventInfo = null;
        };
        return ECEventProcessor;
    }();
});
parcelRegister("7wiHx", function(module, exports) {
    $parcel$export(module.exports, "seriesSymbolTask", ()=>$579a0738784e30ca$export$144ac3beded415d9);
    $parcel$export(module.exports, "dataSymbolTask", ()=>$579a0738784e30ca$export$435b956f7f1071fb);
    var $bahqM;
    var $579a0738784e30ca$export$144ac3beded415d9 = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
            if (!seriesModel.hasSymbolVisual) return;
            var symbolType = seriesModel.get('symbol');
            var symbolSize = seriesModel.get('symbolSize');
            var keepAspect = seriesModel.get('symbolKeepAspect');
            var symbolRotate = seriesModel.get('symbolRotate');
            var symbolOffset = seriesModel.get('symbolOffset');
            var hasSymbolTypeCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolType);
            var hasSymbolSizeCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolSize);
            var hasSymbolRotateCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolRotate);
            var hasSymbolOffsetCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolOffset);
            var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback || hasSymbolOffsetCallback;
            var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : seriesModel.defaultSymbol;
            var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
            var seriesSymbolRotate = !hasSymbolRotateCallback ? symbolRotate : null;
            var seriesSymbolOffset = !hasSymbolOffsetCallback ? symbolOffset : null;
            data.setVisual({
                legendIcon: seriesModel.legendIcon || seriesSymbol,
                symbol: seriesSymbol,
                symbolSize: seriesSymbolSize,
                symbolKeepAspect: keepAspect,
                symbolRotate: seriesSymbolRotate,
                symbolOffset: seriesSymbolOffset
            });
            if (ecModel.isSeriesFiltered(seriesModel)) return;
            function dataEach(data, idx) {
                var rawValue = seriesModel.getRawValue(idx);
                var params = seriesModel.getDataParams(idx);
                hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
                hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
                hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
                hasSymbolOffsetCallback && data.setItemVisual(idx, 'symbolOffset', symbolOffset(rawValue, params));
            }
            return {
                dataEach: hasCallback ? dataEach : null
            };
        }
    };
    var $579a0738784e30ca$export$435b956f7f1071fb = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            if (!seriesModel.hasSymbolVisual) return;
            if (ecModel.isSeriesFiltered(seriesModel)) return;
            var data = seriesModel.getData();
            function dataEach(data, idx) {
                var itemModel = data.getItemModel(idx);
                var itemSymbolType = itemModel.getShallow('symbol', true);
                var itemSymbolSize = itemModel.getShallow('symbolSize', true);
                var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
                var itemSymbolOffset = itemModel.getShallow('symbolOffset', true);
                var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true);
                if (itemSymbolType != null) data.setItemVisual(idx, 'symbol', itemSymbolType);
                if (itemSymbolSize != null) data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
                if (itemSymbolRotate != null) data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
                if (itemSymbolOffset != null) data.setItemVisual(idx, 'symbolOffset', itemSymbolOffset);
                if (itemSymbolKeepAspect != null) data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
            }
            return {
                dataEach: data.hasItemOption ? dataEach : null
            };
        }
    };
});
parcelRegister("fk5Gm", function(module, exports) {
    $parcel$export(module.exports, "getItemVisualFromData", ()=>$b27d21a8d98c0d1c$export$91d919a86b2df624);
    $parcel$export(module.exports, "getVisualFromData", ()=>$b27d21a8d98c0d1c$export$d76e333a86ea1a2);
    $parcel$export(module.exports, "setItemVisualFromData", ()=>$b27d21a8d98c0d1c$export$3aab879e9d0e7c75);
    function $b27d21a8d98c0d1c$export$91d919a86b2df624(data, dataIndex, key) {
        switch(key){
            case 'color':
                var style = data.getItemVisual(dataIndex, 'style');
                return style[data.getVisual('drawType')];
            case 'opacity':
                return data.getItemVisual(dataIndex, 'style').opacity;
            case 'symbol':
            case 'symbolSize':
            case 'liftZ':
                return data.getItemVisual(dataIndex, key);
            default:
        }
    }
    function $b27d21a8d98c0d1c$export$d76e333a86ea1a2(data, key) {
        switch(key){
            case 'color':
                var style = data.getVisual('style');
                return style[data.getVisual('drawType')];
            case 'opacity':
                return data.getVisual('style').opacity;
            case 'symbol':
            case 'symbolSize':
            case 'liftZ':
                return data.getVisual(key);
            default:
        }
    }
    function $b27d21a8d98c0d1c$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
        switch(key){
            case 'color':
                var style = data.ensureUniqueItemVisual(dataIndex, 'style');
                style[data.getVisual('drawType')] = value;
                data.setItemVisual(dataIndex, 'colorFromPalette', false);
                break;
            case 'opacity':
                data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
                break;
            case 'symbol':
            case 'symbolSize':
            case 'liftZ':
                data.setItemVisual(dataIndex, key, value);
                break;
            default:
        }
    }
});
parcelRegister("1nKsD", function(module, exports) {
    $parcel$export(module.exports, "createLegacyDataSelectAction", ()=>$101bfa9c2a38d115$export$62942ba95693dbfc);
    $parcel$export(module.exports, "handleLegacySelectEvents", ()=>$101bfa9c2a38d115$export$2575c83262e49d0c);
    var $bahqM;
    var $eaKsF;
    function $101bfa9c2a38d115$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
        function getSeriesIndices(ecModel, payload) {
            var seriesIndices = [];
            ecModel.eachComponent({
                mainType: 'series',
                subType: seriesType,
                query: payload
            }, function(seriesModel) {
                seriesIndices.push(seriesModel.seriesIndex);
            });
            return seriesIndices;
        }
        (0, (0, parcelRequire("bahqM")).each)([
            [
                seriesType + 'ToggleSelect',
                'toggleSelect'
            ],
            [
                seriesType + 'Select',
                'select'
            ],
            [
                seriesType + 'UnSelect',
                'unselect'
            ]
        ], function(eventsMap) {
            ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
                payload = (0, (0, parcelRequire("bahqM")).extend)({}, payload);
                api.dispatchAction((0, (0, parcelRequire("bahqM")).extend)(payload, {
                    type: eventsMap[1],
                    seriesIndex: getSeriesIndices(ecModel, payload)
                }));
            });
        });
    }
    function $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
        var legacyEventName = type + eventPostfix;
        if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
            mainType: 'series',
            subType: 'pie'
        }, function(seriesModel) {
            var seriesIndex = seriesModel.seriesIndex;
            var selected = payload.selected;
            for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
                var data = seriesModel.getData();
                var dataIndex = (0, (0, parcelRequire("eaKsF")).queryDataIndex)(data, payload.fromActionPayload);
                ecIns.trigger(legacyEventName, {
                    type: legacyEventName,
                    seriesId: seriesModel.id,
                    name: (0, (0, parcelRequire("bahqM")).isArray)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                    selected: (0, (0, parcelRequire("bahqM")).extend)({}, seriesModel.option.selectedMap)
                });
            }
        });
    }
    function $101bfa9c2a38d115$export$2575c83262e49d0c(messageCenter, ecIns, api) {
        messageCenter.on('selectchanged', function(params) {
            var ecModel = api.getModel();
            if (params.isFromClick) {
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
            } else if (params.fromAction === 'select') {
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
            } else if (params.fromAction === 'unselect') {
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
            }
        });
    }
});
parcelRegister("6IsbX", function(module, exports) {
    $parcel$export(module.exports, "findEventDispatcher", ()=>$4e3cb87918e3df6d$export$8a4fca9e04eb4df6);
    function $4e3cb87918e3df6d$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
        var found;
        while(target){
            if (det(target)) {
                found = target;
                if (returnFirstMatch) break;
            }
            target = target.__hostTarget || target.parent;
        }
        return found;
    }
});
parcelRegister("g2DhS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$badb4ee06d190426$export$2e2bcd8739ae039);
    var $9LEsz;
    function $badb4ee06d190426$export$2e2bcd8739ae039(ecModel, api) {
        ecModel.eachRawSeries(function(seriesModel) {
            if (ecModel.isSeriesFiltered(seriesModel)) return;
            var data = seriesModel.getData();
            if (data.hasItemVisual()) data.each(function(idx) {
                var decal = data.getItemVisual(idx, 'decal');
                if (decal) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    itemStyle.decal = (0, (0, parcelRequire("9LEsz")).createOrUpdatePatternFromDecal)(decal, api);
                }
            });
            var decal = data.getVisual('decal');
            if (decal) {
                var style = data.getVisual('style');
                style.decal = (0, (0, parcelRequire("9LEsz")).createOrUpdatePatternFromDecal)(decal, api);
            }
        });
    }
});
parcelRegister("9LEsz", function(module, exports) {
    $parcel$export(module.exports, "createOrUpdatePatternFromDecal", ()=>$71c7e35019979000$export$a3ba048e1a648972);
    var $822uQ;
    var $h4RuA;
    var $bahqM;
    var $jmSNG;
    var $7yklO;
    var $aSzOj;
    var $71c7e35019979000$var$decalMap = new (0, (0, parcelRequire("822uQ")).default)();
    var $71c7e35019979000$var$decalCache = new (0, (0, parcelRequire("h4RuA")).default)(100);
    var $71c7e35019979000$var$decalKeys = [
        'symbol',
        'symbolSize',
        'symbolKeepAspect',
        'color',
        'backgroundColor',
        'dashArrayX',
        'dashArrayY',
        'maxTileWidth',
        'maxTileHeight'
    ];
    function $71c7e35019979000$export$a3ba048e1a648972(decalObject, api) {
        if (decalObject === 'none') return null;
        var dpr = api.getDevicePixelRatio();
        var zr = api.getZr();
        var isSVG = zr.painter.type === 'svg';
        if (decalObject.dirty) $71c7e35019979000$var$decalMap["delete"](decalObject);
        var oldPattern = $71c7e35019979000$var$decalMap.get(decalObject);
        if (oldPattern) return oldPattern;
        var decalOpt = (0, (0, parcelRequire("bahqM")).defaults)(decalObject, {
            symbol: 'rect',
            symbolSize: 1,
            symbolKeepAspect: true,
            color: 'rgba(0, 0, 0, 0.2)',
            backgroundColor: null,
            dashArrayX: 5,
            dashArrayY: 5,
            rotation: 0,
            maxTileWidth: 512,
            maxTileHeight: 512
        });
        if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
        var pattern = {
            repeat: 'repeat'
        };
        setPatternnSource(pattern);
        pattern.rotation = decalOpt.rotation;
        pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
        $71c7e35019979000$var$decalMap.set(decalObject, pattern);
        decalObject.dirty = false;
        return pattern;
        function setPatternnSource(pattern) {
            var keys = [
                dpr
            ];
            var isValidKey = true;
            for(var i = 0; i < $71c7e35019979000$var$decalKeys.length; ++i){
                var value = decalOpt[$71c7e35019979000$var$decalKeys[i]];
                var valueType = typeof value;
                if (value != null && !(0, (0, parcelRequire("bahqM")).isArray)(value) && valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') {
                    isValidKey = false;
                    break;
                }
                keys.push(value);
            }
            var cacheKey;
            if (isValidKey) {
                cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
                var cache = $71c7e35019979000$var$decalCache.get(cacheKey);
                if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
            }
            var dashArrayX = $71c7e35019979000$var$normalizeDashArrayX(decalOpt.dashArrayX);
            var dashArrayY = $71c7e35019979000$var$normalizeDashArrayY(decalOpt.dashArrayY);
            var symbolArray = $71c7e35019979000$var$normalizeSymbolArray(decalOpt.symbol);
            var lineBlockLengthsX = $71c7e35019979000$var$getLineBlockLengthX(dashArrayX);
            var lineBlockLengthY = $71c7e35019979000$var$getLineBlockLengthY(dashArrayY);
            var canvas = !isSVG && (0, (0, parcelRequire("bahqM")).createCanvas)();
            var svgRoot = isSVG && zr.painter.createSVGElement('g');
            var pSize = getPatternSize();
            var ctx;
            if (canvas) {
                canvas.width = pSize.width * dpr;
                canvas.height = pSize.height * dpr;
                ctx = canvas.getContext('2d');
            }
            brushDecal();
            if (isValidKey) $71c7e35019979000$var$decalCache.put(cacheKey, canvas || svgRoot);
            pattern.image = canvas;
            pattern.svgElement = svgRoot;
            pattern.svgWidth = pSize.width;
            pattern.svgHeight = pSize.height;
            function getPatternSize() {
                var width = 1;
                for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, (0, parcelRequire("jmSNG")).getLeastCommonMultiple)(width, lineBlockLengthsX[i]);
                var symbolRepeats = 1;
                for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, (0, parcelRequire("jmSNG")).getLeastCommonMultiple)(symbolRepeats, symbolArray[i].length);
                width *= symbolRepeats;
                var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
                var warn;
                return {
                    width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                    height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
                };
            }
            function brushDecal() {
                if (ctx) {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    if (decalOpt.backgroundColor) {
                        ctx.fillStyle = decalOpt.backgroundColor;
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                    }
                }
                var ySum = 0;
                for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
                if (ySum <= 0) return;
                var y = -lineBlockLengthY;
                var yId = 0;
                var yIdTotal = 0;
                var xId0 = 0;
                while(y < pSize.height){
                    if (yId % 2 === 0) {
                        var symbolYId = yIdTotal / 2 % symbolArray.length;
                        var x = 0;
                        var xId1 = 0;
                        var xId1Total = 0;
                        while(x < pSize.width * 2){
                            var xSum = 0;
                            for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                            if (xSum <= 0) break;
                            if (xId1 % 2 === 0) {
                                var size = (1 - decalOpt.symbolSize) * 0.5;
                                var left = x + dashArrayX[xId0][xId1] * size;
                                var top_1 = y + dashArrayY[yId] * size;
                                var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                                var height = dashArrayY[yId] * decalOpt.symbolSize;
                                var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                                brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                            }
                            x += dashArrayX[xId0][xId1];
                            ++xId1Total;
                            ++xId1;
                            if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                        }
                        ++xId0;
                        if (xId0 === dashArrayX.length) xId0 = 0;
                    }
                    y += dashArrayY[yId];
                    ++yIdTotal;
                    ++yId;
                    if (yId === dashArrayY.length) yId = 0;
                }
                function brushSymbol(x, y, width, height, symbolType) {
                    var scale = isSVG ? 1 : dpr;
                    var symbol = (0, (0, parcelRequire("7yklO")).createSymbol)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                    if (isSVG) svgRoot.appendChild(zr.painter.paintOne(symbol));
                    else (0, (0, parcelRequire("aSzOj")).brushSingle)(ctx, symbol);
                }
            }
        }
    }
    function $71c7e35019979000$var$normalizeSymbolArray(symbol) {
        if (!symbol || symbol.length === 0) return [
            [
                'rect'
            ]
        ];
        if (typeof symbol === 'string') return [
            [
                symbol
            ]
        ];
        var isAllString = true;
        for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] !== 'string') {
            isAllString = false;
            break;
        }
        if (isAllString) return $71c7e35019979000$var$normalizeSymbolArray([
            symbol
        ]);
        var result = [];
        for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] === 'string') result.push([
            symbol[i]
        ]);
        else result.push(symbol[i]);
        return result;
    }
    function $71c7e35019979000$var$normalizeDashArrayX(dash) {
        if (!dash || dash.length === 0) return [
            [
                0,
                0
            ]
        ];
        if (typeof dash === 'number') {
            var dashValue = Math.ceil(dash);
            return [
                [
                    dashValue,
                    dashValue
                ]
            ];
        }
        var isAllNumber = true;
        for(var i = 0; i < dash.length; ++i)if (typeof dash[i] !== 'number') {
            isAllNumber = false;
            break;
        }
        if (isAllNumber) return $71c7e35019979000$var$normalizeDashArrayX([
            dash
        ]);
        var result = [];
        for(var i = 0; i < dash.length; ++i)if (typeof dash[i] === 'number') {
            var dashValue = Math.ceil(dash[i]);
            result.push([
                dashValue,
                dashValue
            ]);
        } else {
            var dashValue = (0, (0, parcelRequire("bahqM")).map)(dash[i], function(n) {
                return Math.ceil(n);
            });
            if (dashValue.length % 2 === 1) result.push(dashValue.concat(dashValue));
            else result.push(dashValue);
        }
        return result;
    }
    function $71c7e35019979000$var$normalizeDashArrayY(dash) {
        if (!dash || typeof dash === 'object' && dash.length === 0) return [
            0,
            0
        ];
        if (typeof dash === 'number') {
            var dashValue_1 = Math.ceil(dash);
            return [
                dashValue_1,
                dashValue_1
            ];
        }
        var dashValue = (0, (0, parcelRequire("bahqM")).map)(dash, function(n) {
            return Math.ceil(n);
        });
        return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
    }
    function $71c7e35019979000$var$getLineBlockLengthX(dash) {
        return (0, (0, parcelRequire("bahqM")).map)(dash, function(line) {
            return $71c7e35019979000$var$getLineBlockLengthY(line);
        });
    }
    function $71c7e35019979000$var$getLineBlockLengthY(dash) {
        var blockLength = 0;
        for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
        if (dash.length % 2 === 1) return blockLength * 2;
        return blockLength;
    }
});
parcelRegister("822uQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d9072624d2c732b$export$2e2bcd8739ae039);
    var $5d9072624d2c732b$var$wmUniqueIndex = Math.round(Math.random() * 9);
    var $5d9072624d2c732b$var$supportDefineProperty = typeof Object.defineProperty === 'function';
    var $5d9072624d2c732b$var$WeakMap = function() {
        function WeakMap() {
            this._id = '__ec_inner_' + $5d9072624d2c732b$var$wmUniqueIndex++;
        }
        WeakMap.prototype.get = function(key) {
            return this._guard(key)[this._id];
        };
        WeakMap.prototype.set = function(key, value) {
            var target = this._guard(key);
            if ($5d9072624d2c732b$var$supportDefineProperty) Object.defineProperty(target, this._id, {
                value: value,
                enumerable: false,
                configurable: true
            });
            else target[this._id] = value;
            return this;
        };
        WeakMap.prototype["delete"] = function(key) {
            if (this.has(key)) {
                delete this._guard(key)[this._id];
                return true;
            }
            return false;
        };
        WeakMap.prototype.has = function(key) {
            return !!this._guard(key)[this._id];
        };
        WeakMap.prototype._guard = function(key) {
            if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
            return key;
        };
        return WeakMap;
    }();
    var $5d9072624d2c732b$export$2e2bcd8739ae039 = $5d9072624d2c732b$var$WeakMap;
});
parcelRegister("aSzOj", function(module, exports) {
    $parcel$export(module.exports, "createCanvasPattern", ()=>$7ebab9bfc20d8461$export$8eb5db6b7bc27903);
    $parcel$export(module.exports, "brushSingle", ()=>$7ebab9bfc20d8461$export$567881adfc3eb7f3);
    $parcel$export(module.exports, "brush", ()=>$7ebab9bfc20d8461$export$da5d6544e8c27bc1);
    var $lBQ88;
    var $aA4Ws;
    var $63nvx;
    var $dPYp9;
    var $ghQ8v;
    var $gcbBH;
    var $45jlh;
    var $b7ZX8;
    var $bahqM;
    var $cpB91;
    var $6sllV;
    var $aVawM;
    var $7ebab9bfc20d8461$var$pathProxyForDraw = new (0, (0, parcelRequire("aA4Ws")).default)(true);
    function $7ebab9bfc20d8461$var$styleHasStroke(style) {
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    }
    function $7ebab9bfc20d8461$var$isValidStrokeFillStyle(strokeOrFill) {
        return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
    }
    function $7ebab9bfc20d8461$var$styleHasFill(style) {
        var fill = style.fill;
        return fill != null && fill !== 'none';
    }
    function $7ebab9bfc20d8461$var$doFillPath(ctx, style) {
        if (style.fillOpacity != null && style.fillOpacity !== 1) {
            var originalGlobalAlpha = ctx.globalAlpha;
            ctx.globalAlpha = style.fillOpacity * style.opacity;
            ctx.fill();
            ctx.globalAlpha = originalGlobalAlpha;
        } else ctx.fill();
    }
    function $7ebab9bfc20d8461$var$doStrokePath(ctx, style) {
        if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
            var originalGlobalAlpha = ctx.globalAlpha;
            ctx.globalAlpha = style.strokeOpacity * style.opacity;
            ctx.stroke();
            ctx.globalAlpha = originalGlobalAlpha;
        } else ctx.stroke();
    }
    function $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, pattern, el) {
        var image = (0, (0, parcelRequire("63nvx")).createOrUpdateImage)(pattern.image, pattern.__image, el);
        if ((0, (0, parcelRequire("63nvx")).isImageReady)(image)) {
            var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
            if (typeof DOMMatrix === 'function' && canvasPattern.setTransform) {
                var matrix = new DOMMatrix();
                matrix.rotateSelf(0, 0, (pattern.rotation || 0) / Math.PI * 180);
                matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
                matrix.translateSelf(pattern.x || 0, pattern.y || 0);
                canvasPattern.setTransform(matrix);
            }
            return canvasPattern;
        }
    }
    function $7ebab9bfc20d8461$var$brushPath(ctx, el, style, inBatch) {
        var hasStroke = $7ebab9bfc20d8461$var$styleHasStroke(style);
        var hasFill = $7ebab9bfc20d8461$var$styleHasFill(style);
        var strokePercent = style.strokePercent;
        var strokePart = strokePercent < 1;
        var firstDraw = !el.path;
        if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
        var path = el.path || $7ebab9bfc20d8461$var$pathProxyForDraw;
        if (!inBatch) {
            var fill = style.fill;
            var stroke = style.stroke;
            var hasFillGradient = hasFill && !!fill.colorStops;
            var hasStrokeGradient = hasStroke && !!stroke.colorStops;
            var hasFillPattern = hasFill && !!fill.image;
            var hasStrokePattern = hasStroke && !!stroke.image;
            var fillGradient = void 0;
            var strokeGradient = void 0;
            var fillPattern = void 0;
            var strokePattern = void 0;
            var rect = void 0;
            if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
            if (hasFillGradient) {
                fillGradient = el.__dirty ? (0, (0, parcelRequire("dPYp9")).getCanvasGradient)(ctx, fill, rect) : el.__canvasFillGradient;
                el.__canvasFillGradient = fillGradient;
            }
            if (hasStrokeGradient) {
                strokeGradient = el.__dirty ? (0, (0, parcelRequire("dPYp9")).getCanvasGradient)(ctx, stroke, rect) : el.__canvasStrokeGradient;
                el.__canvasStrokeGradient = strokeGradient;
            }
            if (hasFillPattern) {
                fillPattern = el.__dirty || !el.__canvasFillPattern ? $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
                el.__canvasFillPattern = fillPattern;
            }
            if (hasStrokePattern) {
                strokePattern = el.__dirty || !el.__canvasStrokePattern ? $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
                el.__canvasStrokePattern = fillPattern;
            }
            if (hasFillGradient) ctx.fillStyle = fillGradient;
            else if (hasFillPattern) {
                if (fillPattern) ctx.fillStyle = fillPattern;
                else hasFill = false;
            }
            if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
            else if (hasStrokePattern) {
                if (strokePattern) ctx.strokeStyle = strokePattern;
                else hasStroke = false;
            }
        }
        var lineDash = style.lineDash && style.lineWidth > 0 && (0, (0, parcelRequire("cpB91")).normalizeLineDash)(style.lineDash, style.lineWidth);
        var lineDashOffset = style.lineDashOffset;
        var ctxLineDash = !!ctx.setLineDash;
        var scale = el.getGlobalScale();
        path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
        if (lineDash) {
            var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
            if (lineScale_1 && lineScale_1 !== 1) {
                lineDash = (0, (0, parcelRequire("bahqM")).map)(lineDash, function(rawVal) {
                    return rawVal / lineScale_1;
                });
                lineDashOffset /= lineScale_1;
            }
        }
        var needsRebuild = true;
        if (firstDraw || el.__dirty & (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT) || lineDash && !ctxLineDash && hasStroke) {
            path.setDPR(ctx.dpr);
            if (strokePart) path.setContext(null);
            else {
                path.setContext(ctx);
                needsRebuild = false;
            }
            path.reset();
            if (lineDash && !ctxLineDash) {
                path.setLineDash(lineDash);
                path.setLineDashOffset(lineDashOffset);
            }
            el.buildPath(path, el.shape, inBatch);
            path.toStatic();
            el.pathUpdated();
        }
        if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
        if (lineDash && ctxLineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (!inBatch) {
            if (style.strokeFirst) {
                if (hasStroke) $7ebab9bfc20d8461$var$doStrokePath(ctx, style);
                if (hasFill) $7ebab9bfc20d8461$var$doFillPath(ctx, style);
            } else {
                if (hasFill) $7ebab9bfc20d8461$var$doFillPath(ctx, style);
                if (hasStroke) $7ebab9bfc20d8461$var$doStrokePath(ctx, style);
            }
        }
        if (lineDash && ctxLineDash) ctx.setLineDash([]);
    }
    function $7ebab9bfc20d8461$var$brushImage(ctx, el, style) {
        var image = el.__image = (0, (0, parcelRequire("63nvx")).createOrUpdateImage)(style.image, el.__image, el, el.onload);
        if (!image || !(0, (0, parcelRequire("63nvx")).isImageReady)(image)) return;
        var x = style.x || 0;
        var y = style.y || 0;
        var width = el.getWidth();
        var height = el.getHeight();
        var aspect = image.width / image.height;
        if (width == null && height != null) width = height * aspect;
        else if (height == null && width != null) height = width / aspect;
        else if (width == null && height == null) {
            width = image.width;
            height = image.height;
        }
        if (style.sWidth && style.sHeight) {
            var sx = style.sx || 0;
            var sy = style.sy || 0;
            ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
        } else if (style.sx && style.sy) {
            var sx = style.sx;
            var sy = style.sy;
            var sWidth = width - sx;
            var sHeight = height - sy;
            ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
        } else ctx.drawImage(image, x, y, width, height);
    }
    function $7ebab9bfc20d8461$var$brushText(ctx, el, style) {
        var text = style.text;
        text != null && (text += '');
        if (text) {
            ctx.font = style.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            ctx.textAlign = style.textAlign;
            ctx.textBaseline = style.textBaseline;
            var hasLineDash = void 0;
            if (ctx.setLineDash) {
                var lineDash = style.lineDash && style.lineWidth > 0 && (0, (0, parcelRequire("cpB91")).normalizeLineDash)(style.lineDash, style.lineWidth);
                var lineDashOffset = style.lineDashOffset;
                if (lineDash) {
                    var lineScale_2 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
                    if (lineScale_2 && lineScale_2 !== 1) {
                        lineDash = (0, (0, parcelRequire("bahqM")).map)(lineDash, function(rawVal) {
                            return rawVal / lineScale_2;
                        });
                        lineDashOffset /= lineScale_2;
                    }
                    ctx.setLineDash(lineDash);
                    ctx.lineDashOffset = lineDashOffset;
                    hasLineDash = true;
                }
            }
            if (style.strokeFirst) {
                if ($7ebab9bfc20d8461$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
                if ($7ebab9bfc20d8461$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            } else {
                if ($7ebab9bfc20d8461$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
                if ($7ebab9bfc20d8461$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            }
            if (hasLineDash) ctx.setLineDash([]);
        }
    }
    var $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS = [
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY'
    ];
    var $7ebab9bfc20d8461$var$STROKE_PROPS = [
        [
            'lineCap',
            'butt'
        ],
        [
            'lineJoin',
            'miter'
        ],
        [
            'miterLimit',
            10
        ]
    ];
    function $7ebab9bfc20d8461$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
        var styleChanged = false;
        if (!forceSetAll) {
            prevStyle = prevStyle || {};
            if (style === prevStyle) return false;
        }
        if (forceSetAll || style.opacity !== prevStyle.opacity) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            var opacity = Math.max(Math.min(style.opacity, 1), 0);
            ctx.globalAlpha = isNaN(opacity) ? (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE).opacity : opacity;
        }
        if (forceSetAll || style.blend !== prevStyle.blend) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.globalCompositeOperation = style.blend || (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE).blend;
        }
        for(var i = 0; i < $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS.length; i++){
            var propName = $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS[i];
            if (forceSetAll || style[propName] !== prevStyle[propName]) {
                if (!styleChanged) {
                    $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                    styleChanged = true;
                }
                ctx[propName] = ctx.dpr * (style[propName] || 0);
            }
        }
        if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.shadowColor = style.shadowColor || (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE).shadowColor;
        }
        return styleChanged;
    }
    function $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
        var style = $7ebab9bfc20d8461$var$getStyle(el, scope.inHover);
        var prevStyle = forceSetAll ? null : prevEl && $7ebab9bfc20d8461$var$getStyle(prevEl, scope.inHover) || {};
        if (style === prevStyle) return false;
        var styleChanged = $7ebab9bfc20d8461$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
        if (forceSetAll || style.fill !== prevStyle.fill) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            $7ebab9bfc20d8461$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
        }
        if (forceSetAll || style.stroke !== prevStyle.stroke) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            $7ebab9bfc20d8461$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
        }
        if (forceSetAll || style.opacity !== prevStyle.opacity) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
        }
        if (el.hasStroke()) {
            var lineWidth = style.lineWidth;
            var newLineWidth = lineWidth / (style.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
            if (ctx.lineWidth !== newLineWidth) {
                if (!styleChanged) {
                    $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                    styleChanged = true;
                }
                ctx.lineWidth = newLineWidth;
            }
        }
        for(var i = 0; i < $7ebab9bfc20d8461$var$STROKE_PROPS.length; i++){
            var prop = $7ebab9bfc20d8461$var$STROKE_PROPS[i];
            var propName = prop[0];
            if (forceSetAll || style[propName] !== prevStyle[propName]) {
                if (!styleChanged) {
                    $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                    styleChanged = true;
                }
                ctx[propName] = style[propName] || prop[1];
            }
        }
        return styleChanged;
    }
    function $7ebab9bfc20d8461$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
        return $7ebab9bfc20d8461$var$bindCommonProps(ctx, $7ebab9bfc20d8461$var$getStyle(el, scope.inHover), prevEl && $7ebab9bfc20d8461$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
    }
    function $7ebab9bfc20d8461$var$setContextTransform(ctx, el) {
        var m = el.transform;
        var dpr = ctx.dpr || 1;
        if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
        else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function $7ebab9bfc20d8461$var$updateClipStatus(clipPaths, ctx, scope) {
        var allClipped = false;
        for(var i = 0; i < clipPaths.length; i++){
            var clipPath = clipPaths[i];
            allClipped = allClipped || clipPath.isZeroArea();
            $7ebab9bfc20d8461$var$setContextTransform(ctx, clipPath);
            ctx.beginPath();
            clipPath.buildPath(ctx, clipPath.shape);
            ctx.clip();
        }
        scope.allClipped = allClipped;
    }
    function $7ebab9bfc20d8461$var$isTransformChanged(m0, m1) {
        if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
        else if (!m0 && !m1) return false;
        return true;
    }
    var $7ebab9bfc20d8461$var$DRAW_TYPE_PATH = 1;
    var $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE = 2;
    var $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT = 3;
    var $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL = 4;
    function $7ebab9bfc20d8461$var$canPathBatch(style) {
        var hasFill = $7ebab9bfc20d8461$var$styleHasFill(style);
        var hasStroke = $7ebab9bfc20d8461$var$styleHasStroke(style);
        return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
    }
    function $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope) {
        scope.batchFill && ctx.fill();
        scope.batchStroke && ctx.stroke();
        scope.batchFill = '';
        scope.batchStroke = '';
    }
    function $7ebab9bfc20d8461$var$getStyle(el, inHover) {
        return inHover ? el.__hoverStyle || el.style : el.style;
    }
    function $7ebab9bfc20d8461$export$567881adfc3eb7f3(ctx, el) {
        $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, el, {
            inHover: false,
            viewWidth: 0,
            viewHeight: 0
        }, true);
    }
    function $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
        var m = el.transform;
        if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
            el.__dirty &= ~(0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            el.__isRendered = false;
            return;
        }
        var clipPaths = el.__clipPaths;
        var prevElClipPaths = scope.prevElClipPaths;
        var forceSetTransform = false;
        var forceSetStyle = false;
        if (!prevElClipPaths || (0, (0, parcelRequire("dPYp9")).isClipPathChanged)(clipPaths, prevElClipPaths)) {
            if (prevElClipPaths && prevElClipPaths.length) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                ctx.restore();
                forceSetStyle = forceSetTransform = true;
                scope.prevElClipPaths = null;
                scope.allClipped = false;
                scope.prevEl = null;
            }
            if (clipPaths && clipPaths.length) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                ctx.save();
                $7ebab9bfc20d8461$var$updateClipStatus(clipPaths, ctx, scope);
                forceSetTransform = true;
            }
            scope.prevElClipPaths = clipPaths;
        }
        if (scope.allClipped) {
            el.__isRendered = false;
            return;
        }
        el.beforeBrush && el.beforeBrush();
        el.innerBeforeBrush();
        var prevEl = scope.prevEl;
        if (!prevEl) forceSetStyle = forceSetTransform = true;
        var canBatchPath = el instanceof (0, (0, parcelRequire("ghQ8v")).default) && el.autoBatch && $7ebab9bfc20d8461$var$canPathBatch(el.style);
        if (forceSetTransform || $7ebab9bfc20d8461$var$isTransformChanged(m, prevEl.transform)) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            $7ebab9bfc20d8461$var$setContextTransform(ctx, el);
        } else if (!canBatchPath) $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
        var style = $7ebab9bfc20d8461$var$getStyle(el, scope.inHover);
        if (el instanceof (0, (0, parcelRequire("ghQ8v")).default)) {
            if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_PATH) {
                forceSetStyle = true;
                scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_PATH;
            }
            $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
            $7ebab9bfc20d8461$var$brushPath(ctx, el, style, canBatchPath);
            if (canBatchPath) {
                scope.batchFill = style.fill || '';
                scope.batchStroke = style.stroke || '';
            }
        } else {
            if (el instanceof (0, (0, parcelRequire("45jlh")).default)) {
                if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT) {
                    forceSetStyle = true;
                    scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT;
                }
                $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
                $7ebab9bfc20d8461$var$brushText(ctx, el, style);
            } else if (el instanceof (0, (0, parcelRequire("gcbBH")).default)) {
                if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE) {
                    forceSetStyle = true;
                    scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE;
                }
                $7ebab9bfc20d8461$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
                $7ebab9bfc20d8461$var$brushImage(ctx, el, style);
            } else if (el instanceof (0, (0, parcelRequire("6sllV")).default)) {
                if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL) {
                    forceSetStyle = true;
                    scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL;
                }
                $7ebab9bfc20d8461$var$brushIncremental(ctx, el, scope);
            }
        }
        if (canBatchPath && isLast) $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
        el.innerAfterBrush();
        el.afterBrush && el.afterBrush();
        scope.prevEl = el;
        el.__dirty = 0;
        el.__isRendered = true;
    }
    function $7ebab9bfc20d8461$var$brushIncremental(ctx, el, scope) {
        var displayables = el.getDisplayables();
        var temporalDisplayables = el.getTemporalDisplayables();
        ctx.save();
        var innerScope = {
            prevElClipPaths: null,
            prevEl: null,
            allClipped: false,
            viewWidth: scope.viewWidth,
            viewHeight: scope.viewHeight,
            inHover: scope.inHover
        };
        var i;
        var len;
        for(i = el.getCursor(), len = displayables.length; i < len; i++){
            var displayable = displayables[i];
            displayable.beforeBrush && displayable.beforeBrush();
            displayable.innerBeforeBrush();
            $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
            displayable.innerAfterBrush();
            displayable.afterBrush && displayable.afterBrush();
            innerScope.prevEl = displayable;
        }
        for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
            var displayable = temporalDisplayables[i_1];
            displayable.beforeBrush && displayable.beforeBrush();
            displayable.innerBeforeBrush();
            $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
            displayable.innerAfterBrush();
            displayable.afterBrush && displayable.afterBrush();
            innerScope.prevEl = displayable;
        }
        el.clearTemporalDisplayables();
        el.notClear = true;
        ctx.restore();
    }
});
parcelRegister("dPYp9", function(module, exports) {
    $parcel$export(module.exports, "getCanvasGradient", ()=>$a12ee4e4c244a026$export$3dab6afd018d48c7);
    $parcel$export(module.exports, "isClipPathChanged", ()=>$a12ee4e4c244a026$export$beeddc5150cb2e83);
    function $a12ee4e4c244a026$export$235c7ac50fe1db0a(ctx, obj, rect) {
        var x = obj.x == null ? 0 : obj.x;
        var x2 = obj.x2 == null ? 1 : obj.x2;
        var y = obj.y == null ? 0 : obj.y;
        var y2 = obj.y2 == null ? 0 : obj.y2;
        if (!obj.global) {
            x = x * rect.width + rect.x;
            x2 = x2 * rect.width + rect.x;
            y = y * rect.height + rect.y;
            y2 = y2 * rect.height + rect.y;
        }
        x = isNaN(x) ? 0 : x;
        x2 = isNaN(x2) ? 1 : x2;
        y = isNaN(y) ? 0 : y;
        y2 = isNaN(y2) ? 0 : y2;
        var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
        return canvasGradient;
    }
    function $a12ee4e4c244a026$export$57f098206d57a443(ctx, obj, rect) {
        var width = rect.width;
        var height = rect.height;
        var min = Math.min(width, height);
        var x = obj.x == null ? 0.5 : obj.x;
        var y = obj.y == null ? 0.5 : obj.y;
        var r = obj.r == null ? 0.5 : obj.r;
        if (!obj.global) {
            x = x * width + rect.x;
            y = y * height + rect.y;
            r = r * min;
        }
        var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
        return canvasGradient;
    }
    function $a12ee4e4c244a026$export$3dab6afd018d48c7(ctx, obj, rect) {
        var canvasGradient = obj.type === 'radial' ? $a12ee4e4c244a026$export$57f098206d57a443(ctx, obj, rect) : $a12ee4e4c244a026$export$235c7ac50fe1db0a(ctx, obj, rect);
        var colorStops = obj.colorStops;
        for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
        return canvasGradient;
    }
    function $a12ee4e4c244a026$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
        if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
        if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
        for(var i = 0; i < clipPaths.length; i++){
            if (clipPaths[i] !== prevClipPaths[i]) return true;
        }
        return false;
    }
});
parcelRegister("cpB91", function(module, exports) {
    $parcel$export(module.exports, "normalizeLineDash", ()=>$9094a1fa7d97ce08$export$9efb2ae8a603855d);
    var $bahqM;
    function $9094a1fa7d97ce08$export$9efb2ae8a603855d(lineType, lineWidth) {
        if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
        lineWidth = lineWidth || 1;
        return lineType === 'dashed' ? [
            4 * lineWidth,
            2 * lineWidth
        ] : lineType === 'dotted' ? [
            lineWidth
        ] : (0, (0, parcelRequire("bahqM")).isNumber)(lineType) ? [
            lineType
        ] : (0, (0, parcelRequire("bahqM")).isArray)(lineType) ? lineType : null;
    }
});
parcelRegister("fEzwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b65624d7bef03239$export$2e2bcd8739ae039);
    var $bahqM;
    var $fBEGW;
    var $2iWFB;
    var $b65624d7bef03239$var$storage = (0, (0, parcelRequire("bahqM")).createHashMap)();
    var $b65624d7bef03239$export$2e2bcd8739ae039 = {
        registerMap: function(mapName, rawDef, rawSpecialAreas) {
            if (rawDef.svg) {
                var resource = new (0, (0, parcelRequire("fBEGW")).GeoSVGResource)(mapName, rawDef.svg);
                $b65624d7bef03239$var$storage.set(mapName, resource);
            } else {
                var geoJSON = rawDef.geoJson || rawDef.geoJSON;
                if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
                else geoJSON = rawDef;
                var resource = new (0, (0, parcelRequire("2iWFB")).GeoJSONResource)(mapName, geoJSON, rawSpecialAreas);
                $b65624d7bef03239$var$storage.set(mapName, resource);
            }
        },
        getGeoResource: function(mapName) {
            return $b65624d7bef03239$var$storage.get(mapName);
        },
        getMapForUser: function(mapName) {
            var resource = $b65624d7bef03239$var$storage.get(mapName);
            return resource && resource.type === 'geoJSON' && resource.getMapForUser();
        },
        load: function(mapName, nameMap, nameProperty) {
            var resource = $b65624d7bef03239$var$storage.get(mapName);
            if (!resource) return;
            return resource.load(nameMap, nameProperty);
        }
    };
});
parcelRegister("fBEGW", function(module, exports) {
    $parcel$export(module.exports, "GeoSVGResource", ()=>$b5c9e032bcec003b$export$be52c950efae1f84);
    var $KN3aA;
    var $4KVOr;
    var $7Tw7u;
    var $bahqM;
    var $1E3E8;
    var $bsT8u;
    var $b8QyH;
    var $b5c9e032bcec003b$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, (0, parcelRequire("bahqM")).createHashMap)([
        'rect',
        'circle',
        'line',
        'ellipse',
        'polygon',
        'polyline',
        'path',
        'text',
        'tspan',
        'g'
    ]);
    var $b5c9e032bcec003b$export$be52c950efae1f84 = function() {
        function GeoSVGResource(mapName, svg) {
            this.type = 'geoSVG';
            this._usedGraphicMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this._freedGraphics = [];
            this._mapName = mapName;
            this._parsedXML = (0, (0, parcelRequire("bsT8u")).parseXML)(svg);
        }
        GeoSVGResource.prototype.load = function() {
            var firstGraphic = this._firstGraphic;
            if (!firstGraphic) {
                firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
                this._freedGraphics.push(firstGraphic);
                this._boundingRect = this._firstGraphic.boundingRect.clone();
                var _a = $b5c9e032bcec003b$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
                this._regions = regions;
                this._regionsMap = regionsMap;
            }
            return {
                boundingRect: this._boundingRect,
                regions: this._regions,
                regionsMap: this._regionsMap
            };
        };
        GeoSVGResource.prototype._buildGraphic = function(svgXML) {
            var result;
            var rootFromParse;
            try {
                result = svgXML && (0, (0, parcelRequire("KN3aA")).parseSVG)(svgXML, {
                    ignoreViewBox: true,
                    ignoreRootClip: true
                }) || {};
                rootFromParse = result.root;
                (0, (0, parcelRequire("bahqM")).assert)(rootFromParse != null);
            } catch (e) {
                throw new Error('Invalid svg format\n' + e.message);
            }
            var root = new (0, (0, parcelRequire("4KVOr")).default)();
            root.add(rootFromParse);
            root.isGeoSVGGraphicRoot = true;
            var svgWidth = result.width;
            var svgHeight = result.height;
            var viewBoxRect = result.viewBoxRect;
            var boundingRect = this._boundingRect;
            if (!boundingRect) {
                var bRectX = void 0;
                var bRectY = void 0;
                var bRectWidth = void 0;
                var bRectHeight = void 0;
                if (svgWidth != null) {
                    bRectX = 0;
                    bRectWidth = svgWidth;
                } else if (viewBoxRect) {
                    bRectX = viewBoxRect.x;
                    bRectWidth = viewBoxRect.width;
                }
                if (svgHeight != null) {
                    bRectY = 0;
                    bRectHeight = svgHeight;
                } else if (viewBoxRect) {
                    bRectY = viewBoxRect.y;
                    bRectHeight = viewBoxRect.height;
                }
                if (bRectX == null || bRectY == null) {
                    var calculatedBoundingRect = rootFromParse.getBoundingRect();
                    if (bRectX == null) {
                        bRectX = calculatedBoundingRect.x;
                        bRectWidth = calculatedBoundingRect.width;
                    }
                    if (bRectY == null) {
                        bRectY = calculatedBoundingRect.y;
                        bRectHeight = calculatedBoundingRect.height;
                    }
                }
                boundingRect = this._boundingRect = new (0, (0, parcelRequire("1E3E8")).default)(bRectX, bRectY, bRectWidth, bRectHeight);
            }
            if (viewBoxRect) {
                var viewBoxTransform = (0, (0, parcelRequire("KN3aA")).makeViewBoxTransform)(viewBoxRect, boundingRect);
                rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
                rootFromParse.x = viewBoxTransform.x;
                rootFromParse.y = viewBoxTransform.y;
            }
            root.setClipPath(new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: boundingRect.plain()
            }));
            var named = [];
            (0, (0, parcelRequire("bahqM")).each)(result.named, function(namedItem) {
                if ($b5c9e032bcec003b$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                    named.push(namedItem);
                    $b5c9e032bcec003b$var$setSilent(namedItem.el);
                }
            });
            return {
                root: root,
                boundingRect: boundingRect,
                named: named
            };
        };
        GeoSVGResource.prototype.useGraphic = function(hostKey) {
            var usedRootMap = this._usedGraphicMap;
            var svgGraphic = usedRootMap.get(hostKey);
            if (svgGraphic) return svgGraphic;
            svgGraphic = this._freedGraphics.pop() || this._buildGraphic(this._parsedXML);
            usedRootMap.set(hostKey, svgGraphic);
            return svgGraphic;
        };
        GeoSVGResource.prototype.freeGraphic = function(hostKey) {
            var usedRootMap = this._usedGraphicMap;
            var svgGraphic = usedRootMap.get(hostKey);
            if (svgGraphic) {
                usedRootMap.removeKey(hostKey);
                this._freedGraphics.push(svgGraphic);
            }
        };
        return GeoSVGResource;
    }();
    function $b5c9e032bcec003b$var$setSilent(el) {
        el.silent = false;
        if (el.isGroup) el.traverse(function(child) {
            child.silent = false;
        });
    }
    function $b5c9e032bcec003b$var$createRegions(named) {
        var regions = [];
        var regionsMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        (0, (0, parcelRequire("bahqM")).each)(named, function(namedItem) {
            if (namedItem.namedFrom != null) return;
            var region = new (0, (0, parcelRequire("b8QyH")).GeoSVGRegion)(namedItem.name, namedItem.el);
            regions.push(region);
            regionsMap.set(namedItem.name, region);
        });
        return {
            regions: regions,
            regionsMap: regionsMap
        };
    }
});
parcelRegister("KN3aA", function(module, exports) {
    $parcel$export(module.exports, "makeViewBoxTransform", ()=>$08ca58536684a52b$export$3e2db4420f14f50f);
    $parcel$export(module.exports, "parseSVG", ()=>$08ca58536684a52b$export$1919f5101c220601);
    var $4KVOr;
    var $gcbBH;
    var $jjfok;
    var $7Tw7u;
    var $kVeV8;
    var $cZb1F;
    var $lQwBc;
    var $32bXc;
    var $izqgC;
    var $id1Rd;
    var $bahqM;
    var $9J7f8;
    var $faICo;
    var $45jlh;
    var $bsT8u;
    var $08ca58536684a52b$var$nodeParsers;
    var $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
        'fill': 'fill',
        'stroke': 'stroke',
        'stroke-width': 'lineWidth',
        'opacity': 'opacity',
        'fill-opacity': 'fillOpacity',
        'stroke-opacity': 'strokeOpacity',
        'stroke-dasharray': 'lineDash',
        'stroke-dashoffset': 'lineDashOffset',
        'stroke-linecap': 'lineCap',
        'stroke-linejoin': 'lineJoin',
        'stroke-miterlimit': 'miterLimit',
        'font-family': 'fontFamily',
        'font-size': 'fontSize',
        'font-style': 'fontStyle',
        'font-weight': 'fontWeight',
        'text-anchor': 'textAlign',
        'visibility': 'visibility',
        'display': 'display'
    };
    var $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, (0, parcelRequire("bahqM")).keys)($08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
    var $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP = {
        'alignment-baseline': 'textBaseline',
        'stop-color': 'stopColor'
    };
    var $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, (0, parcelRequire("bahqM")).keys)($08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP);
    var $08ca58536684a52b$var$SVGParser = function() {
        function SVGParser() {
            this._defs = {};
            this._root = null;
        }
        SVGParser.prototype.parse = function(xml, opt) {
            opt = opt || {};
            var svg = (0, (0, parcelRequire("bsT8u")).parseXML)(xml);
            if (!svg) throw new Error('Illegal svg');
            this._defsUsePending = [];
            var root = new (0, (0, parcelRequire("4KVOr")).default)();
            this._root = root;
            var named = [];
            var viewBox = svg.getAttribute('viewBox') || '';
            var width = parseFloat(svg.getAttribute('width') || opt.width);
            var height = parseFloat(svg.getAttribute('height') || opt.height);
            isNaN(width) && (width = null);
            isNaN(height) && (height = null);
            $08ca58536684a52b$var$parseAttributes(svg, root, null, true, false);
            var child = svg.firstChild;
            while(child){
                this._parseNode(child, root, named, null, false, false);
                child = child.nextSibling;
            }
            $08ca58536684a52b$var$applyDefs(this._defs, this._defsUsePending);
            this._defsUsePending = [];
            var viewBoxRect;
            var viewBoxTransform;
            if (viewBox) {
                var viewBoxArr = $08ca58536684a52b$var$splitNumberSequence(viewBox);
                if (viewBoxArr.length >= 4) viewBoxRect = {
                    x: parseFloat(viewBoxArr[0] || 0),
                    y: parseFloat(viewBoxArr[1] || 0),
                    width: parseFloat(viewBoxArr[2]),
                    height: parseFloat(viewBoxArr[3])
                };
            }
            if (viewBoxRect && width != null && height != null) {
                viewBoxTransform = $08ca58536684a52b$export$3e2db4420f14f50f(viewBoxRect, {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                });
                if (!opt.ignoreViewBox) {
                    var elRoot = root;
                    root = new (0, (0, parcelRequire("4KVOr")).default)();
                    root.add(elRoot);
                    elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                    elRoot.x = viewBoxTransform.x;
                    elRoot.y = viewBoxTransform.y;
                }
            }
            if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                }
            }));
            return {
                root: root,
                width: width,
                height: height,
                viewBoxRect: viewBoxRect,
                viewBoxTransform: viewBoxTransform,
                named: named
            };
        };
        SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
            var nodeName = xmlNode.nodeName.toLowerCase();
            var el;
            var namedFromForSub = namedFrom;
            if (nodeName === 'defs') isInDefs = true;
            if (nodeName === 'text') isInText = true;
            if (nodeName === 'defs' || nodeName === 'switch') el = parentGroup;
            else {
                if (!isInDefs) {
                    var parser_1 = $08ca58536684a52b$var$nodeParsers[nodeName];
                    if (parser_1 && (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$nodeParsers, nodeName)) {
                        el = parser_1.call(this, xmlNode, parentGroup);
                        var nameAttr = xmlNode.getAttribute('name');
                        if (nameAttr) {
                            var newNamed = {
                                name: nameAttr,
                                namedFrom: null,
                                svgNodeTagLower: nodeName,
                                el: el
                            };
                            named.push(newNamed);
                            if (nodeName === 'g') namedFromForSub = newNamed;
                        } else if (namedFrom) named.push({
                            name: namedFrom.name,
                            namedFrom: namedFrom,
                            svgNodeTagLower: nodeName,
                            el: el
                        });
                        parentGroup.add(el);
                    }
                }
                var parser = $08ca58536684a52b$var$paintServerParsers[nodeName];
                if (parser && (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$paintServerParsers, nodeName)) {
                    var def = parser.call(this, xmlNode);
                    var id = xmlNode.getAttribute('id');
                    if (id) this._defs[id] = def;
                }
            }
            if (el && el.isGroup) {
                var child = xmlNode.firstChild;
                while(child){
                    if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                    else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                    child = child.nextSibling;
                }
            }
        };
        SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
            var text = new (0, (0, parcelRequire("45jlh")).default)({
                style: {
                    text: xmlNode.textContent
                },
                silent: true,
                x: this._textX || 0,
                y: this._textY || 0
            });
            $08ca58536684a52b$var$inheritStyle(parentGroup, text);
            $08ca58536684a52b$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
            $08ca58536684a52b$var$applyTextAlignment(text, parentGroup);
            var textStyle = text.style;
            var fontSize = textStyle.fontSize;
            if (fontSize && fontSize < 9) {
                textStyle.fontSize = 9;
                text.scaleX *= fontSize / 9;
                text.scaleY *= fontSize / 9;
            }
            var font = (textStyle.fontSize || textStyle.fontFamily) && [
                textStyle.fontStyle,
                textStyle.fontWeight,
                (textStyle.fontSize || 12) + 'px',
                textStyle.fontFamily || 'sans-serif'
            ].join(' ');
            textStyle.font = font;
            var rect = text.getBoundingRect();
            this._textX += rect.width;
            parentGroup.add(text);
            return text;
        };
        SVGParser.internalField = function() {
            $08ca58536684a52b$var$nodeParsers = {
                'g': function(xmlNode, parentGroup) {
                    var g = new (0, (0, parcelRequire("4KVOr")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                    return g;
                },
                'rect': function(xmlNode, parentGroup) {
                    var rect = new (0, (0, parcelRequire("7Tw7u")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, rect);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                    rect.setShape({
                        x: parseFloat(xmlNode.getAttribute('x') || '0'),
                        y: parseFloat(xmlNode.getAttribute('y') || '0'),
                        width: parseFloat(xmlNode.getAttribute('width') || '0'),
                        height: parseFloat(xmlNode.getAttribute('height') || '0')
                    });
                    rect.silent = true;
                    return rect;
                },
                'circle': function(xmlNode, parentGroup) {
                    var circle = new (0, (0, parcelRequire("jjfok")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, circle);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                    circle.setShape({
                        cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                        cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                        r: parseFloat(xmlNode.getAttribute('r') || '0')
                    });
                    circle.silent = true;
                    return circle;
                },
                'line': function(xmlNode, parentGroup) {
                    var line = new (0, (0, parcelRequire("cZb1F")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, line);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                    line.setShape({
                        x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                        y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                        x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                        y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                    });
                    line.silent = true;
                    return line;
                },
                'ellipse': function(xmlNode, parentGroup) {
                    var ellipse = new (0, (0, parcelRequire("kVeV8")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, ellipse);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                    ellipse.setShape({
                        cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                        cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                        rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                        ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                    });
                    ellipse.silent = true;
                    return ellipse;
                },
                'polygon': function(xmlNode, parentGroup) {
                    var pointsStr = xmlNode.getAttribute('points');
                    var pointsArr;
                    if (pointsStr) pointsArr = $08ca58536684a52b$var$parsePoints(pointsStr);
                    var polygon = new (0, (0, parcelRequire("lQwBc")).default)({
                        shape: {
                            points: pointsArr || []
                        },
                        silent: true
                    });
                    $08ca58536684a52b$var$inheritStyle(parentGroup, polygon);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                    return polygon;
                },
                'polyline': function(xmlNode, parentGroup) {
                    var pointsStr = xmlNode.getAttribute('points');
                    var pointsArr;
                    if (pointsStr) pointsArr = $08ca58536684a52b$var$parsePoints(pointsStr);
                    var polyline = new (0, (0, parcelRequire("32bXc")).default)({
                        shape: {
                            points: pointsArr || []
                        },
                        silent: true
                    });
                    $08ca58536684a52b$var$inheritStyle(parentGroup, polyline);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                    return polyline;
                },
                'image': function(xmlNode, parentGroup) {
                    var img = new (0, (0, parcelRequire("gcbBH")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, img);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                    img.setStyle({
                        image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                        x: +xmlNode.getAttribute('x'),
                        y: +xmlNode.getAttribute('y'),
                        width: +xmlNode.getAttribute('width'),
                        height: +xmlNode.getAttribute('height')
                    });
                    img.silent = true;
                    return img;
                },
                'text': function(xmlNode, parentGroup) {
                    var x = xmlNode.getAttribute('x') || '0';
                    var y = xmlNode.getAttribute('y') || '0';
                    var dx = xmlNode.getAttribute('dx') || '0';
                    var dy = xmlNode.getAttribute('dy') || '0';
                    this._textX = parseFloat(x) + parseFloat(dx);
                    this._textY = parseFloat(y) + parseFloat(dy);
                    var g = new (0, (0, parcelRequire("4KVOr")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                    return g;
                },
                'tspan': function(xmlNode, parentGroup) {
                    var x = xmlNode.getAttribute('x');
                    var y = xmlNode.getAttribute('y');
                    if (x != null) this._textX = parseFloat(x);
                    if (y != null) this._textY = parseFloat(y);
                    var dx = xmlNode.getAttribute('dx') || '0';
                    var dy = xmlNode.getAttribute('dy') || '0';
                    var g = new (0, (0, parcelRequire("4KVOr")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                    this._textX += parseFloat(dx);
                    this._textY += parseFloat(dy);
                    return g;
                },
                'path': function(xmlNode, parentGroup) {
                    var d = xmlNode.getAttribute('d') || '';
                    var path = (0, (0, parcelRequire("id1Rd")).createFromString)(d);
                    $08ca58536684a52b$var$inheritStyle(parentGroup, path);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                    path.silent = true;
                    return path;
                }
            };
        }();
        return SVGParser;
    }();
    var $08ca58536684a52b$var$paintServerParsers = {
        'lineargradient': function(xmlNode) {
            var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
            var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
            var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
            var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
            var gradient = new (0, (0, parcelRequire("9J7f8")).default)(x1, y1, x2, y2);
            $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient);
            $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient);
            return gradient;
        },
        'radialgradient': function(xmlNode) {
            var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
            var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
            var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
            var gradient = new (0, (0, parcelRequire("faICo")).default)(cx, cy, r);
            $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient);
            $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient);
            return gradient;
        }
    };
    function $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient) {
        var gradientUnits = xmlNode.getAttribute('gradientUnits');
        if (gradientUnits === 'userSpaceOnUse') gradient.global = true;
    }
    function $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient) {
        var stop = xmlNode.firstChild;
        while(stop){
            if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === 'stop') {
                var offsetStr = stop.getAttribute('offset');
                var offset = void 0;
                if (offsetStr && offsetStr.indexOf('%') > 0) offset = parseInt(offsetStr, 10) / 100;
                else if (offsetStr) offset = parseFloat(offsetStr);
                else offset = 0;
                var styleVals = {};
                $08ca58536684a52b$var$parseInlineStyle(stop, styleVals, styleVals);
                var stopColor = styleVals.stopColor || stop.getAttribute('stop-color') || '#000000';
                gradient.colorStops.push({
                    offset: offset,
                    color: stopColor
                });
            }
            stop = stop.nextSibling;
        }
    }
    function $08ca58536684a52b$var$inheritStyle(parent, child) {
        if (parent && parent.__inheritedStyle) {
            if (!child.__inheritedStyle) child.__inheritedStyle = {};
            (0, (0, parcelRequire("bahqM")).defaults)(child.__inheritedStyle, parent.__inheritedStyle);
        }
    }
    function $08ca58536684a52b$var$parsePoints(pointsString) {
        var list = $08ca58536684a52b$var$splitNumberSequence(pointsString);
        var points = [];
        for(var i = 0; i < list.length; i += 2){
            var x = parseFloat(list[i]);
            var y = parseFloat(list[i + 1]);
            points.push([
                x,
                y
            ]);
        }
        return points;
    }
    function $08ca58536684a52b$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
        var disp = el;
        var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
        var selfStyle = {};
        if (xmlNode.nodeType === 1) {
            $08ca58536684a52b$var$parseTransformAttribute(xmlNode, el);
            $08ca58536684a52b$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
            if (!onlyInlineStyle) $08ca58536684a52b$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
        }
        disp.style = disp.style || {};
        if (inheritedStyle.fill != null) disp.style.fill = $08ca58536684a52b$var$getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
        if (inheritedStyle.stroke != null) disp.style.stroke = $08ca58536684a52b$var$getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
        (0, (0, parcelRequire("bahqM")).each)([
            'lineWidth',
            'opacity',
            'fillOpacity',
            'strokeOpacity',
            'miterLimit',
            'fontSize'
        ], function(propName) {
            if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
        });
        (0, (0, parcelRequire("bahqM")).each)([
            'lineDashOffset',
            'lineCap',
            'lineJoin',
            'fontWeight',
            'fontFamily',
            'fontStyle',
            'textAlign'
        ], function(propName) {
            if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
        });
        if (isTextGroup) disp.__selfStyle = selfStyle;
        if (inheritedStyle.lineDash) disp.style.lineDash = (0, (0, parcelRequire("bahqM")).map)($08ca58536684a52b$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
            return parseFloat(str);
        });
        if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') disp.invisible = true;
        if (inheritedStyle.display === 'none') disp.ignore = true;
    }
    function $08ca58536684a52b$var$applyTextAlignment(text, parentGroup) {
        var parentSelfStyle = parentGroup.__selfStyle;
        if (parentSelfStyle) {
            var textBaseline = parentSelfStyle.textBaseline;
            var zrTextBaseline = textBaseline;
            if (!textBaseline || textBaseline === 'auto') zrTextBaseline = 'alphabetic';
            else if (textBaseline === 'baseline') zrTextBaseline = 'alphabetic';
            else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') zrTextBaseline = 'top';
            else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') zrTextBaseline = 'bottom';
            else if (textBaseline === 'central' || textBaseline === 'mathematical') zrTextBaseline = 'middle';
            text.style.textBaseline = zrTextBaseline;
        }
        var parentInheritedStyle = parentGroup.__inheritedStyle;
        if (parentInheritedStyle) {
            var textAlign = parentInheritedStyle.textAlign;
            var zrTextAlign = textAlign;
            if (textAlign) {
                if (textAlign === 'middle') zrTextAlign = 'center';
                text.style.textAlign = zrTextAlign;
            }
        }
    }
    var $08ca58536684a52b$var$urlRegex = /^url\(\s*#(.*?)\)/;
    function $08ca58536684a52b$var$getFillStrokeStyle(el, method, str, defsUsePending) {
        var urlMatch = str && str.match($08ca58536684a52b$var$urlRegex);
        if (urlMatch) {
            var url = (0, (0, parcelRequire("bahqM")).trim)(urlMatch[1]);
            defsUsePending.push([
                el,
                method,
                url
            ]);
            return;
        }
        if (str === 'none') str = null;
        return str;
    }
    function $08ca58536684a52b$var$applyDefs(defs, defsUsePending) {
        for(var i = 0; i < defsUsePending.length; i++){
            var item = defsUsePending[i];
            item[0].style[item[1]] = defs[item[2]];
        }
    }
    var $08ca58536684a52b$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
    function $08ca58536684a52b$var$splitNumberSequence(rawStr) {
        return rawStr.match($08ca58536684a52b$var$numberReg) || [];
    }
    var $08ca58536684a52b$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
    var $08ca58536684a52b$var$DEGREE_TO_ANGLE = Math.PI / 180;
    function $08ca58536684a52b$var$parseTransformAttribute(xmlNode, node) {
        var transform = xmlNode.getAttribute('transform');
        if (transform) {
            transform = transform.replace(/,/g, ' ');
            var transformOps_1 = [];
            var mt = null;
            transform.replace($08ca58536684a52b$var$transformRegex, function(str, type, value) {
                transformOps_1.push(type, value);
                return '';
            });
            for(var i = transformOps_1.length - 1; i > 0; i -= 2){
                var value = transformOps_1[i];
                var type = transformOps_1[i - 1];
                var valueArr = $08ca58536684a52b$var$splitNumberSequence(value);
                mt = mt || (0, parcelRequire("izqgC")).create();
                switch(type){
                    case 'translate':
                        (0, parcelRequire("izqgC")).translate(mt, mt, [
                            parseFloat(valueArr[0]),
                            parseFloat(valueArr[1] || '0')
                        ]);
                        break;
                    case 'scale':
                        (0, parcelRequire("izqgC")).scale(mt, mt, [
                            parseFloat(valueArr[0]),
                            parseFloat(valueArr[1] || valueArr[0])
                        ]);
                        break;
                    case 'rotate':
                        (0, parcelRequire("izqgC")).rotate(mt, mt, -parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                        break;
                    case 'skewX':
                        var sx = Math.tan(parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                        (0, parcelRequire("izqgC")).mul(mt, [
                            1,
                            0,
                            sx,
                            1,
                            0,
                            0
                        ], mt);
                        break;
                    case 'skewY':
                        var sy = Math.tan(parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                        (0, parcelRequire("izqgC")).mul(mt, [
                            1,
                            sy,
                            0,
                            1,
                            0,
                            0
                        ], mt);
                        break;
                    case 'matrix':
                        mt[0] = parseFloat(valueArr[0]);
                        mt[1] = parseFloat(valueArr[1]);
                        mt[2] = parseFloat(valueArr[2]);
                        mt[3] = parseFloat(valueArr[3]);
                        mt[4] = parseFloat(valueArr[4]);
                        mt[5] = parseFloat(valueArr[5]);
                        break;
                }
            }
            node.setLocalTransform(mt);
        }
    }
    var $08ca58536684a52b$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
    function $08ca58536684a52b$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
        var style = xmlNode.getAttribute('style');
        if (!style) return;
        $08ca58536684a52b$var$styleRegex.lastIndex = 0;
        var styleRegResult;
        while((styleRegResult = $08ca58536684a52b$var$styleRegex.exec(style)) != null){
            var svgStlAttr = styleRegResult[1];
            var zrInheritableStlAttr = (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
            if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
            var zrSelfStlAttr = (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
            if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
        }
    }
    function $08ca58536684a52b$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
        for(var i = 0; i < $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
            var svgAttrName = $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
            var attrValue = xmlNode.getAttribute(svgAttrName);
            if (attrValue != null) inheritableStyleResult[$08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
        }
        for(var i = 0; i < $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
            var svgAttrName = $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
            var attrValue = xmlNode.getAttribute(svgAttrName);
            if (attrValue != null) selfStyleResult[$08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
        }
    }
    function $08ca58536684a52b$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
        var scaleX = boundingRect.width / viewBoxRect.width;
        var scaleY = boundingRect.height / viewBoxRect.height;
        var scale = Math.min(scaleX, scaleY);
        return {
            scale: scale,
            x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
            y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
        };
    }
    function $08ca58536684a52b$export$1919f5101c220601(xml, opt) {
        var parser = new $08ca58536684a52b$var$SVGParser();
        return parser.parse(xml, opt);
    }
});
parcelRegister("bsT8u", function(module, exports) {
    $parcel$export(module.exports, "parseXML", ()=>$858d140ea42b55af$export$eacefc55fad2867e);
    var $bahqM;
    function $858d140ea42b55af$export$eacefc55fad2867e(svg) {
        if ((0, (0, parcelRequire("bahqM")).isString)(svg)) {
            var parser = new DOMParser();
            svg = parser.parseFromString(svg, 'text/xml');
        }
        var svgNode = svg;
        if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
        while(svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
        return svgNode;
    }
});
parcelRegister("b8QyH", function(module, exports) {
    $parcel$export(module.exports, "GeoJSONRegion", ()=>$81c9361a69c93c5f$export$ee84fcb463f24b3d);
    $parcel$export(module.exports, "GeoSVGRegion", ()=>$81c9361a69c93c5f$export$5f3d89e7254f3e69);
    var $3VFsf;
    var $1E3E8;
    var $13I82;
    var $eLEew;
    var $hjZ9y;
    var $izqgC;
    var $81c9361a69c93c5f$var$TMP_TRANSFORM = [];
    var $81c9361a69c93c5f$export$b1f97c3099fc6872 = function() {
        function Region(name) {
            this.name = name;
        }
        Region.prototype.getCenter = function() {
            return;
        };
        return Region;
    }();
    var $81c9361a69c93c5f$export$ee84fcb463f24b3d = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GeoJSONRegion, _super);
        function GeoJSONRegion(name, geometries, cp) {
            var _this = _super.call(this, name) || this;
            _this.type = 'geoJSON';
            _this.geometries = geometries;
            if (!cp) {
                var rect = _this.getBoundingRect();
                cp = [
                    rect.x + rect.width / 2,
                    rect.y + rect.height / 2
                ];
            } else cp = [
                cp[0],
                cp[1]
            ];
            _this._center = cp;
            return _this;
        }
        GeoJSONRegion.prototype.getBoundingRect = function() {
            var rect = this._rect;
            if (rect) return rect;
            var MAX_NUMBER = Number.MAX_VALUE;
            var min = [
                MAX_NUMBER,
                MAX_NUMBER
            ];
            var max = [
                -MAX_NUMBER,
                -MAX_NUMBER
            ];
            var min2 = [];
            var max2 = [];
            var geometries = this.geometries;
            var i = 0;
            for(; i < geometries.length; i++){
                if (geometries[i].type !== 'polygon') continue;
                var exterior = geometries[i].exterior;
                (0, parcelRequire("13I82")).fromPoints(exterior, min2, max2);
                (0, parcelRequire("eLEew")).min(min, min, min2);
                (0, parcelRequire("eLEew")).max(max, max, max2);
            }
            if (i === 0) min[0] = min[1] = max[0] = max[1] = 0;
            return this._rect = new (0, (0, parcelRequire("1E3E8")).default)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        };
        GeoJSONRegion.prototype.contain = function(coord) {
            var rect = this.getBoundingRect();
            var geometries = this.geometries;
            if (!rect.contain(coord[0], coord[1])) return false;
            loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
                if (geometries[i].type !== 'polygon') continue;
                var exterior = geometries[i].exterior;
                var interiors = geometries[i].interiors;
                if ((0, parcelRequire("hjZ9y")).contain(exterior, coord[0], coord[1])) {
                    for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                        if ((0, parcelRequire("hjZ9y")).contain(interiors[k], coord[0], coord[1])) continue loopGeo;
                    }
                    return true;
                }
            }
            return false;
        };
        GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
            var rect = this.getBoundingRect();
            var aspect = rect.width / rect.height;
            if (!width) width = aspect * height;
            else if (!height) height = width / aspect;
            var target = new (0, (0, parcelRequire("1E3E8")).default)(x, y, width, height);
            var transform = rect.calculateTransform(target);
            var geometries = this.geometries;
            for(var i = 0; i < geometries.length; i++){
                if (geometries[i].type !== 'polygon') continue;
                var exterior = geometries[i].exterior;
                var interiors = geometries[i].interiors;
                for(var p = 0; p < exterior.length; p++)(0, parcelRequire("eLEew")).applyTransform(exterior[p], exterior[p], transform);
                for(var h = 0; h < (interiors ? interiors.length : 0); h++)for(var p = 0; p < interiors[h].length; p++)(0, parcelRequire("eLEew")).applyTransform(interiors[h][p], interiors[h][p], transform);
            }
            rect = this._rect;
            rect.copy(target);
            this._center = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
        };
        GeoJSONRegion.prototype.cloneShallow = function(name) {
            name == null && (name = this.name);
            var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
            newRegion._rect = this._rect;
            newRegion.transformTo = null;
            return newRegion;
        };
        GeoJSONRegion.prototype.getCenter = function() {
            return this._center;
        };
        GeoJSONRegion.prototype.setCenter = function(center) {
            this._center = center;
        };
        return GeoJSONRegion;
    }($81c9361a69c93c5f$export$b1f97c3099fc6872);
    var $81c9361a69c93c5f$export$5f3d89e7254f3e69 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GeoSVGRegion, _super);
        function GeoSVGRegion(name, elOnlyForCalculate) {
            var _this = _super.call(this, name) || this;
            _this.type = 'geoSVG';
            _this._elOnlyForCalculate = elOnlyForCalculate;
            return _this;
        }
        GeoSVGRegion.prototype.getCenter = function() {
            var center = this._center;
            if (!center) center = this._center = this._calculateCenter();
            return center;
        };
        GeoSVGRegion.prototype._calculateCenter = function() {
            var el = this._elOnlyForCalculate;
            var rect = el.getBoundingRect();
            var center = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
            var mat = (0, parcelRequire("izqgC")).identity($81c9361a69c93c5f$var$TMP_TRANSFORM);
            var target = el;
            while(target && !target.isGeoSVGGraphicRoot){
                (0, parcelRequire("izqgC")).mul(mat, target.getLocalTransform(), mat);
                target = target.parent;
            }
            (0, parcelRequire("izqgC")).invert(mat, mat);
            (0, parcelRequire("eLEew")).applyTransform(center, center, mat);
            return center;
        };
        return GeoSVGRegion;
    }($81c9361a69c93c5f$export$b1f97c3099fc6872);
});
parcelRegister("hjZ9y", function(module, exports) {
    $parcel$export(module.exports, "contain", ()=>$c9c3a5bccc65a1b5$export$8893e2b90ba10d92);
    var $3Ytji;
    var $c9c3a5bccc65a1b5$var$EPSILON = 1e-8;
    function $c9c3a5bccc65a1b5$var$isAroundEqual(a, b) {
        return Math.abs(a - b) < $c9c3a5bccc65a1b5$var$EPSILON;
    }
    function $c9c3a5bccc65a1b5$export$8893e2b90ba10d92(points, x, y) {
        var w = 0;
        var p = points[0];
        if (!p) return false;
        for(var i = 1; i < points.length; i++){
            var p2 = points[i];
            w += (0, (0, parcelRequire("3Ytji")).default)(p[0], p[1], p2[0], p2[1], x, y);
            p = p2;
        }
        var p0 = points[0];
        if (!$c9c3a5bccc65a1b5$var$isAroundEqual(p[0], p0[0]) || !$c9c3a5bccc65a1b5$var$isAroundEqual(p[1], p0[1])) w += (0, (0, parcelRequire("3Ytji")).default)(p[0], p[1], p0[0], p0[1], x, y);
        return w !== 0;
    }
});
parcelRegister("2iWFB", function(module, exports) {
    $parcel$export(module.exports, "GeoJSONResource", ()=>$1adac5d85fe37b79$export$859cf85c67f2df51);
    var $bahqM;
    var $gyzY7;
    var $eEvpA;
    var $5i7yG;
    var $huNXv;
    var $ducHh;
    var $1E3E8;
    var $1adac5d85fe37b79$var$DEFAULT_NAME_PROPERTY = 'name';
    var $1adac5d85fe37b79$export$859cf85c67f2df51 = function() {
        function GeoJSONResource(mapName, geoJSON, specialAreas) {
            this.type = 'geoJSON';
            this._parsedMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this._mapName = mapName;
            this._specialAreas = specialAreas;
            this._geoJSON = $1adac5d85fe37b79$var$parseInput(geoJSON);
        }
        GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
            nameProperty = nameProperty || $1adac5d85fe37b79$var$DEFAULT_NAME_PROPERTY;
            var parsed = this._parsedMap.get(nameProperty);
            if (!parsed) {
                var rawRegions = this._parseToRegions(nameProperty);
                parsed = this._parsedMap.set(nameProperty, {
                    regions: rawRegions,
                    boundingRect: $1adac5d85fe37b79$var$calculateBoundingRect(rawRegions)
                });
            }
            var regionsMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var finalRegions = [];
            (0, (0, parcelRequire("bahqM")).each)(parsed.regions, function(region) {
                var regionName = region.name;
                if (nameMap && nameMap.hasOwnProperty(regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
                finalRegions.push(region);
                regionsMap.set(regionName, region);
            });
            return {
                regions: finalRegions,
                boundingRect: parsed.boundingRect || new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0),
                regionsMap: regionsMap
            };
        };
        GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
            var mapName = this._mapName;
            var geoJSON = this._geoJSON;
            var rawRegions;
            try {
                rawRegions = geoJSON ? (0, (0, parcelRequire("gyzY7")).default)(geoJSON, nameProperty) : [];
            } catch (e) {
                throw new Error('Invalid geoJson format\n' + e.message);
            }
            (0, (0, parcelRequire("eEvpA")).default)(mapName, rawRegions);
            (0, (0, parcelRequire("bahqM")).each)(rawRegions, function(region) {
                var regionName = region.name;
                (0, (0, parcelRequire("5i7yG")).default)(mapName, region);
                (0, (0, parcelRequire("huNXv")).default)(mapName, region);
                (0, (0, parcelRequire("ducHh")).default)(mapName, region);
                var specialArea = this._specialAreas && this._specialAreas[regionName];
                if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
            }, this);
            return rawRegions;
        };
        GeoJSONResource.prototype.getMapForUser = function() {
            return {
                geoJson: this._geoJSON,
                geoJSON: this._geoJSON,
                specialAreas: this._specialAreas
            };
        };
        return GeoJSONResource;
    }();
    function $1adac5d85fe37b79$var$calculateBoundingRect(regions) {
        var rect;
        for(var i = 0; i < regions.length; i++){
            var regionRect = regions[i].getBoundingRect();
            rect = rect || regionRect.clone();
            rect.union(regionRect);
        }
        return rect;
    }
    function $1adac5d85fe37b79$var$parseInput(source) {
        return !(0, (0, parcelRequire("bahqM")).isString)(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
    }
});
parcelRegister("gyzY7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0dbb8f34f2c3106$export$2e2bcd8739ae039);
    var $bahqM;
    var $b8QyH;
    function $c0dbb8f34f2c3106$var$decode(json) {
        if (!json.UTF8Encoding) return json;
        var jsonCompressed = json;
        var encodeScale = jsonCompressed.UTF8Scale;
        if (encodeScale == null) encodeScale = 1024;
        var features = jsonCompressed.features;
        for(var f = 0; f < features.length; f++){
            var feature = features[f];
            var geometry = feature.geometry;
            if (geometry.type === 'Polygon') {
                var coordinates = geometry.coordinates;
                for(var c = 0; c < coordinates.length; c++)coordinates[c] = $c0dbb8f34f2c3106$var$decodePolygon(coordinates[c], geometry.encodeOffsets[c], encodeScale);
            } else if (geometry.type === 'MultiPolygon') {
                var coordinates = geometry.coordinates;
                for(var c = 0; c < coordinates.length; c++){
                    var coordinate = coordinates[c];
                    for(var c2 = 0; c2 < coordinate.length; c2++)coordinate[c2] = $c0dbb8f34f2c3106$var$decodePolygon(coordinate[c2], geometry.encodeOffsets[c][c2], encodeScale);
                }
            }
        }
        jsonCompressed.UTF8Encoding = false;
        return jsonCompressed;
    }
    function $c0dbb8f34f2c3106$var$decodePolygon(coordinate, encodeOffsets, encodeScale) {
        var result = [];
        var prevX = encodeOffsets[0];
        var prevY = encodeOffsets[1];
        for(var i = 0; i < coordinate.length; i += 2){
            var x = coordinate.charCodeAt(i) - 64;
            var y = coordinate.charCodeAt(i + 1) - 64;
            x = x >> 1 ^ -(x & 1);
            y = y >> 1 ^ -(y & 1);
            x += prevX;
            y += prevY;
            prevX = x;
            prevY = y;
            result.push([
                x / encodeScale,
                y / encodeScale
            ]);
        }
        return result;
    }
    function $c0dbb8f34f2c3106$export$2e2bcd8739ae039(geoJson, nameProperty) {
        geoJson = $c0dbb8f34f2c3106$var$decode(geoJson);
        return (0, parcelRequire("bahqM")).map((0, parcelRequire("bahqM")).filter(geoJson.features, function(featureObj) {
            return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
        }), function(featureObj) {
            var properties = featureObj.properties;
            var geo = featureObj.geometry;
            var geometries = [];
            if (geo.type === 'Polygon') {
                var coordinates = geo.coordinates;
                geometries.push({
                    type: 'polygon',
                    exterior: coordinates[0],
                    interiors: coordinates.slice(1)
                });
            }
            if (geo.type === 'MultiPolygon') {
                var coordinates = geo.coordinates;
                (0, parcelRequire("bahqM")).each(coordinates, function(item) {
                    if (item[0]) geometries.push({
                        type: 'polygon',
                        exterior: item[0],
                        interiors: item.slice(1)
                    });
                });
            }
            var region = new (0, (0, parcelRequire("b8QyH")).GeoJSONRegion)(properties[nameProperty || 'name'], geometries, properties.cp);
            region.properties = properties;
            return region;
        });
    }
});
parcelRegister("eEvpA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aaad2ad12dd4ec6c$export$2e2bcd8739ae039);
    var $bahqM;
    var $b8QyH;
    var $aaad2ad12dd4ec6c$var$geoCoord = [
        126,
        25
    ];
    var $aaad2ad12dd4ec6c$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
    var $aaad2ad12dd4ec6c$var$points = [
        [
            [
                0,
                3.5
            ],
            [
                7,
                11.2
            ],
            [
                15,
                11.9
            ],
            [
                30,
                7
            ],
            [
                42,
                0.7
            ],
            [
                52,
                0.7
            ],
            [
                56,
                7.7
            ],
            [
                59,
                0.7
            ],
            [
                64,
                0.7
            ],
            [
                64,
                0
            ],
            [
                5,
                0
            ],
            [
                0,
                3.5
            ]
        ],
        [
            [
                13,
                16.1
            ],
            [
                19,
                14.7
            ],
            [
                16,
                21.7
            ],
            [
                11,
                23.1
            ],
            [
                13,
                16.1
            ]
        ],
        [
            [
                12,
                32.2
            ],
            [
                14,
                38.5
            ],
            [
                15,
                38.5
            ],
            [
                13,
                32.2
            ],
            [
                12,
                32.2
            ]
        ],
        [
            [
                16,
                47.6
            ],
            [
                12,
                53.2
            ],
            [
                13,
                53.2
            ],
            [
                18,
                47.6
            ],
            [
                16,
                47.6
            ]
        ],
        [
            [
                6,
                64.4
            ],
            [
                8,
                70
            ],
            [
                9,
                70
            ],
            [
                8,
                64.4
            ],
            [
                6,
                64.4
            ]
        ],
        [
            [
                23,
                82.6
            ],
            [
                29,
                79.8
            ],
            [
                30,
                79.8
            ],
            [
                25,
                82.6
            ],
            [
                23,
                82.6
            ]
        ],
        [
            [
                37,
                70.7
            ],
            [
                43,
                62.3
            ],
            [
                44,
                62.3
            ],
            [
                39,
                70.7
            ],
            [
                37,
                70.7
            ]
        ],
        [
            [
                48,
                51.1
            ],
            [
                51,
                45.5
            ],
            [
                53,
                45.5
            ],
            [
                50,
                51.1
            ],
            [
                48,
                51.1
            ]
        ],
        [
            [
                51,
                35
            ],
            [
                51,
                28.7
            ],
            [
                53,
                28.7
            ],
            [
                53,
                35
            ],
            [
                51,
                35
            ]
        ],
        [
            [
                52,
                22.4
            ],
            [
                55,
                17.5
            ],
            [
                56,
                17.5
            ],
            [
                53,
                22.4
            ],
            [
                52,
                22.4
            ]
        ],
        [
            [
                58,
                12.6
            ],
            [
                62,
                7
            ],
            [
                63,
                7
            ],
            [
                60,
                12.6
            ],
            [
                58,
                12.6
            ]
        ],
        [
            [
                0,
                3.5
            ],
            [
                0,
                93.1
            ],
            [
                64,
                93.1
            ],
            [
                64,
                0
            ],
            [
                63,
                0
            ],
            [
                63,
                92.4
            ],
            [
                1,
                92.4
            ],
            [
                1,
                3.5
            ],
            [
                0,
                3.5
            ]
        ]
    ];
    for(var $aaad2ad12dd4ec6c$var$i = 0; $aaad2ad12dd4ec6c$var$i < $aaad2ad12dd4ec6c$var$points.length; $aaad2ad12dd4ec6c$var$i++)for(var $aaad2ad12dd4ec6c$var$k = 0; $aaad2ad12dd4ec6c$var$k < $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i].length; $aaad2ad12dd4ec6c$var$k++){
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][0] /= 10.5;
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][1] /= -14;
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][0] += $aaad2ad12dd4ec6c$var$geoCoord[0];
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][1] += $aaad2ad12dd4ec6c$var$geoCoord[1];
    }
    function $aaad2ad12dd4ec6c$export$2e2bcd8739ae039(mapType, regions) {
        if (mapType === 'china') {
            for(var i = 0; i < regions.length; i++){
                if (regions[i].name === $aaad2ad12dd4ec6c$var$nanhaiName) return;
            }
            regions.push(new (0, (0, parcelRequire("b8QyH")).GeoJSONRegion)($aaad2ad12dd4ec6c$var$nanhaiName, (0, parcelRequire("bahqM")).map($aaad2ad12dd4ec6c$var$points, function(exterior) {
                return {
                    type: 'polygon',
                    exterior: exterior
                };
            }), $aaad2ad12dd4ec6c$var$geoCoord));
        }
    }
});
parcelRegister("5i7yG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3da47f1dbbeac6bc$export$2e2bcd8739ae039);
    var $3da47f1dbbeac6bc$var$coordsOffsetMap = {
        "\u5357\u6D77\u8BF8\u5C9B": [
            32,
            80
        ],
        "\u5E7F\u4E1C": [
            0,
            -10
        ],
        "\u9999\u6E2F": [
            10,
            5
        ],
        "\u6FB3\u95E8": [
            -10,
            10
        ],
        "\u5929\u6D25": [
            5,
            5
        ]
    };
    function $3da47f1dbbeac6bc$export$2e2bcd8739ae039(mapType, region) {
        if (mapType === 'china') {
            var coordFix = $3da47f1dbbeac6bc$var$coordsOffsetMap[region.name];
            if (coordFix) {
                var cp = region.getCenter();
                cp[0] += coordFix[0] / 10.5;
                cp[1] += -coordFix[1] / 14;
                region.setCenter(cp);
            }
        }
    }
});
parcelRegister("huNXv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbcbfdc69414efb9$export$2e2bcd8739ae039);
    var $cbcbfdc69414efb9$var$geoCoordMap = {
        'Russia': [
            100,
            60
        ],
        'United States': [
            -99,
            38
        ],
        'United States of America': [
            -99,
            38
        ]
    };
    function $cbcbfdc69414efb9$export$2e2bcd8739ae039(mapType, region) {
        if (mapType === 'world') {
            var geoCoord = $cbcbfdc69414efb9$var$geoCoordMap[region.name];
            if (geoCoord) {
                var cp = [
                    geoCoord[0],
                    geoCoord[1]
                ];
                region.setCenter(cp);
            }
        }
    }
});
parcelRegister("ducHh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d17ed1a4c54aaef$export$2e2bcd8739ae039);
    var $9d17ed1a4c54aaef$var$points = [
        [
            [
                123.45165252685547,
                25.73527164402261
            ],
            [
                123.49731445312499,
                25.73527164402261
            ],
            [
                123.49731445312499,
                25.750734064600884
            ],
            [
                123.45165252685547,
                25.750734064600884
            ],
            [
                123.45165252685547,
                25.73527164402261
            ]
        ]
    ];
    function $9d17ed1a4c54aaef$export$2e2bcd8739ae039(mapType, region) {
        if (mapType === 'china' && region.name === "\u53F0\u6E7E") region.geometries.push({
            type: 'polygon',
            exterior: $9d17ed1a4c54aaef$var$points[0]
        });
    }
});
parcelRegister("8cCW2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f8da56db6246248$export$2e2bcd8739ae039);
    var $bRKv5;
    var $5f8da56db6246248$var$lifecycle = new (0, (0, parcelRequire("bRKv5")).default)();
    var $5f8da56db6246248$export$2e2bcd8739ae039 = $5f8da56db6246248$var$lifecycle;
});
parcelRegister("eQgZJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ace31acda01d4651$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bAY5l;
    var $1O7Ua;
    var $ace31acda01d4651$var$ScatterSeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ScatterSeriesModel, _super);
        function ScatterSeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = ScatterSeriesModel.type;
            _this.hasSymbolVisual = true;
            return _this;
        }
        ScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
            return (0, (0, parcelRequire("bAY5l")).default)(null, this, {
                useEncodeDefaulter: true
            });
        };
        ScatterSeriesModel.prototype.getProgressive = function() {
            var progressive = this.option.progressive;
            if (progressive == null) return this.option.large ? 5e3 : this.get('progressive');
            return progressive;
        };
        ScatterSeriesModel.prototype.getProgressiveThreshold = function() {
            var progressiveThreshold = this.option.progressiveThreshold;
            if (progressiveThreshold == null) return this.option.large ? 1e4 : this.get('progressiveThreshold');
            return progressiveThreshold;
        };
        ScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
            return selectors.point(data.getItemLayout(dataIndex));
        };
        ScatterSeriesModel.type = 'series.scatter';
        ScatterSeriesModel.dependencies = [
            'grid',
            'polar',
            'geo',
            'singleAxis',
            'calendar'
        ];
        ScatterSeriesModel.defaultOption = {
            coordinateSystem: 'cartesian2d',
            zlevel: 0,
            z: 2,
            legendHoverLink: true,
            symbolSize: 10,
            large: false,
            largeThreshold: 2000,
            itemStyle: {
                opacity: 0.8
            },
            emphasis: {
                scale: true
            },
            clip: true,
            select: {
                itemStyle: {
                    borderColor: '#212121'
                }
            },
            universalTransition: {
                divideShape: 'clone'
            }
        };
        return ScatterSeriesModel;
    }((0, (0, parcelRequire("1O7Ua")).default));
    var $ace31acda01d4651$export$2e2bcd8739ae039 = $ace31acda01d4651$var$ScatterSeriesModel;
});
parcelRegister("jBLJn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4667f5e3d4c581e$export$2e2bcd8739ae039);
    var $3VFsf;
    var $5DXGq;
    var $7tGln;
    var $5xgWc;
    var $loerw;
    var $e4667f5e3d4c581e$var$ScatterView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ScatterView, _super);
        function ScatterView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = ScatterView.type;
            return _this;
        }
        ScatterView.prototype.render = function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var symbolDraw = this._updateSymbolDraw(data, seriesModel);
            symbolDraw.updateData(data, {
                clipShape: this._getClipShape(seriesModel)
            });
            this._finished = true;
        };
        ScatterView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var symbolDraw = this._updateSymbolDraw(data, seriesModel);
            symbolDraw.incrementalPrepareUpdate(data);
            this._finished = false;
        };
        ScatterView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
            this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
                clipShape: this._getClipShape(seriesModel)
            });
            this._finished = taskParams.end === seriesModel.getData().count();
        };
        ScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            this.group.dirty();
            if (!this._finished || data.count() > 1e4 || !this._symbolDraw.isPersistent()) return {
                update: true
            };
            else {
                var res = (0, (0, parcelRequire("5xgWc")).default)('').reset(seriesModel, ecModel, api);
                if (res.progress) res.progress({
                    start: 0,
                    end: data.count(),
                    count: data.count()
                }, data);
                this._symbolDraw.updateLayout(data);
            }
        };
        ScatterView.prototype._getClipShape = function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
            return seriesModel.get('clip', true) ? clipArea : null;
        };
        ScatterView.prototype._updateSymbolDraw = function(data, seriesModel) {
            var symbolDraw = this._symbolDraw;
            var pipelineContext = seriesModel.pipelineContext;
            var isLargeDraw = pipelineContext.large;
            if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
                symbolDraw && symbolDraw.remove();
                symbolDraw = this._symbolDraw = isLargeDraw ? new (0, (0, parcelRequire("7tGln")).default)() : new (0, (0, parcelRequire("5DXGq")).default)();
                this._isLargeDraw = isLargeDraw;
                this.group.removeAll();
            }
            this.group.add(symbolDraw.group);
            return symbolDraw;
        };
        ScatterView.prototype.remove = function(ecModel, api) {
            this._symbolDraw && this._symbolDraw.remove(true);
            this._symbolDraw = null;
        };
        ScatterView.prototype.dispose = function() {};
        ScatterView.type = 'scatter';
        return ScatterView;
    }((0, (0, parcelRequire("loerw")).default));
    var $e4667f5e3d4c581e$export$2e2bcd8739ae039 = $e4667f5e3d4c581e$var$ScatterView;
});
parcelRegister("7tGln", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$571c16701c52f758$export$2e2bcd8739ae039);
    var $3VFsf;
    var $4KVOr;
    parcelRequire("fHITF");
    var $ghQ8v;
    var $7yklO;
    var $6sllV;
    var $7QjoM;
    var $571c16701c52f758$var$BOOST_SIZE_THRESHOLD = 4;
    var $571c16701c52f758$var$LargeSymbolPathShape = function() {
        function LargeSymbolPathShape() {}
        return LargeSymbolPathShape;
    }();
    var $571c16701c52f758$var$LargeSymbolPath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LargeSymbolPath, _super);
        function LargeSymbolPath(opts) {
            return _super.call(this, opts) || this;
        }
        LargeSymbolPath.prototype.getDefaultShape = function() {
            return new $571c16701c52f758$var$LargeSymbolPathShape();
        };
        LargeSymbolPath.prototype.buildPath = function(path, shape) {
            var points = shape.points;
            var size = shape.size;
            var symbolProxy = this.symbolProxy;
            var symbolProxyShape = symbolProxy.shape;
            var ctx = path.getContext ? path.getContext() : path;
            var canBoost = ctx && size[0] < $571c16701c52f758$var$BOOST_SIZE_THRESHOLD;
            if (canBoost) {
                this._ctx = ctx;
                return;
            }
            this._ctx = null;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                if (isNaN(x) || isNaN(y)) continue;
                if (this.softClipShape && !this.softClipShape.contain(x, y)) continue;
                symbolProxyShape.x = x - size[0] / 2;
                symbolProxyShape.y = y - size[1] / 2;
                symbolProxyShape.width = size[0];
                symbolProxyShape.height = size[1];
                symbolProxy.buildPath(path, symbolProxyShape, true);
            }
        };
        LargeSymbolPath.prototype.afterBrush = function() {
            var shape = this.shape;
            var points = shape.points;
            var size = shape.size;
            var ctx = this._ctx;
            if (!ctx) return;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                if (isNaN(x) || isNaN(y)) continue;
                if (this.softClipShape && !this.softClipShape.contain(x, y)) continue;
                ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
            }
        };
        LargeSymbolPath.prototype.findDataIndex = function(x, y) {
            var shape = this.shape;
            var points = shape.points;
            var size = shape.size;
            var w = Math.max(size[0], 4);
            var h = Math.max(size[1], 4);
            for(var idx = points.length / 2 - 1; idx >= 0; idx--){
                var i = idx * 2;
                var x0 = points[i] - w / 2;
                var y0 = points[i + 1] - h / 2;
                if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) return idx;
            }
            return -1;
        };
        return LargeSymbolPath;
    }((0, parcelRequire("ghQ8v")).default);
    var $571c16701c52f758$var$LargeSymbolDraw = function() {
        function LargeSymbolDraw() {
            this.group = new (0, parcelRequire("4KVOr")).default();
        }
        LargeSymbolDraw.prototype.isPersistent = function() {
            return !this._incremental;
        };
        LargeSymbolDraw.prototype.updateData = function(data, opt) {
            this.group.removeAll();
            var symbolEl = new $571c16701c52f758$var$LargeSymbolPath({
                rectHover: true,
                cursor: 'default'
            });
            symbolEl.setShape({
                points: data.getLayout('points')
            });
            this._setCommon(symbolEl, data, false, opt);
            this.group.add(symbolEl);
            this._incremental = null;
        };
        LargeSymbolDraw.prototype.updateLayout = function(data) {
            if (this._incremental) return;
            var points = data.getLayout('points');
            this.group.eachChild(function(child) {
                if (child.startIndex != null) {
                    var len = (child.endIndex - child.startIndex) * 2;
                    var byteOffset = child.startIndex * 8;
                    points = new Float32Array(points.buffer, byteOffset, len);
                }
                child.setShape('points', points);
            });
        };
        LargeSymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
            this.group.removeAll();
            this._clearIncremental();
            if (data.count() > 2e6) {
                if (!this._incremental) this._incremental = new (0, (0, parcelRequire("6sllV")).default)({
                    silent: true
                });
                this.group.add(this._incremental);
            } else this._incremental = null;
        };
        LargeSymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
            var symbolEl;
            if (this._incremental) {
                symbolEl = new $571c16701c52f758$var$LargeSymbolPath();
                this._incremental.addDisplayable(symbolEl, true);
            } else {
                symbolEl = new $571c16701c52f758$var$LargeSymbolPath({
                    rectHover: true,
                    cursor: 'default',
                    startIndex: taskParams.start,
                    endIndex: taskParams.end
                });
                symbolEl.incremental = true;
                this.group.add(symbolEl);
            }
            symbolEl.setShape({
                points: data.getLayout('points')
            });
            this._setCommon(symbolEl, data, !!this._incremental, opt);
        };
        LargeSymbolDraw.prototype._setCommon = function(symbolEl, data, isIncremental, opt) {
            var hostModel = data.hostModel;
            opt = opt || {};
            var size = data.getVisual('symbolSize');
            symbolEl.setShape('size', size instanceof Array ? size : [
                size,
                size
            ]);
            symbolEl.softClipShape = opt.clipShape || null;
            symbolEl.symbolProxy = (0, (0, parcelRequire("7yklO")).createSymbol)(data.getVisual('symbol'), 0, 0, 0, 0);
            symbolEl.setColor = symbolEl.symbolProxy.setColor;
            var extrudeShadow = symbolEl.shape.size[0] < $571c16701c52f758$var$BOOST_SIZE_THRESHOLD;
            symbolEl.useStyle(hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? [
                'color',
                'shadowBlur',
                'shadowColor'
            ] : [
                'color'
            ]));
            var globalStyle = data.getVisual('style');
            var visualColor = globalStyle && globalStyle.fill;
            if (visualColor) symbolEl.setColor(visualColor);
            if (!isIncremental) {
                var ecData_1 = (0, (0, parcelRequire("7QjoM")).getECData)(symbolEl);
                ecData_1.seriesIndex = hostModel.seriesIndex;
                symbolEl.on('mousemove', function(e) {
                    ecData_1.dataIndex = null;
                    var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);
                    if (dataIndex >= 0) ecData_1.dataIndex = dataIndex + (symbolEl.startIndex || 0);
                });
            }
        };
        LargeSymbolDraw.prototype.remove = function() {
            this._clearIncremental();
            this._incremental = null;
            this.group.removeAll();
        };
        LargeSymbolDraw.prototype._clearIncremental = function() {
            var incremental = this._incremental;
            if (incremental) incremental.clearDisplaybles();
        };
        return LargeSymbolDraw;
    }();
    var $571c16701c52f758$export$2e2bcd8739ae039 = $571c16701c52f758$var$LargeSymbolDraw;
});
parcelRegister("iWOYl", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$dcb52eca8f57248f$export$4b3e715f166fdd78);
    var $3VFsf;
    var $fkskt;
    var $9sf2Q;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $bahqM;
    var $1UrP6;
    var $aLiaH;
    var $1xCHp;
    var $2rHnA;
    var $dcb52eca8f57248f$var$GridView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GridView, _super);
        function GridView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'grid';
            return _this;
        }
        GridView.prototype.render = function(gridModel, ecModel) {
            this.group.removeAll();
            if (gridModel.get('show')) this.group.add(new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: gridModel.coordinateSystem.getRect(),
                style: (0, (0, parcelRequire("bahqM")).defaults)({
                    fill: gridModel.get('backgroundColor')
                }, gridModel.getItemStyle()),
                silent: true,
                z2: -1
            }));
        };
        GridView.type = 'grid';
        return GridView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $dcb52eca8f57248f$var$extraOption = {
        offset: 0
    };
    function $dcb52eca8f57248f$export$4b3e715f166fdd78(registers) {
        registers.registerComponentView($dcb52eca8f57248f$var$GridView);
        registers.registerComponentModel((0, (0, parcelRequire("9sf2Q")).default));
        registers.registerCoordinateSystem('cartesian2d', (0, (0, parcelRequire("1xCHp")).default));
        (0, (0, parcelRequire("aLiaH")).default)(registers, 'x', (0, (0, parcelRequire("1UrP6")).CartesianAxisModel), $dcb52eca8f57248f$var$extraOption);
        (0, (0, parcelRequire("aLiaH")).default)(registers, 'y', (0, (0, parcelRequire("1UrP6")).CartesianAxisModel), $dcb52eca8f57248f$var$extraOption);
        registers.registerComponentView((0, (0, parcelRequire("2rHnA")).CartesianXAxisView));
        registers.registerComponentView((0, (0, parcelRequire("2rHnA")).CartesianYAxisView));
        registers.registerPreprocessor(function(option) {
            if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
        });
    }
});
parcelRegister("9sf2Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e226630804759b0$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h4UlH;
    var $6e226630804759b0$var$GridModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GridModel, _super);
        function GridModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GridModel.type = 'grid';
        GridModel.dependencies = [
            'xAxis',
            'yAxis'
        ];
        GridModel.layoutMode = 'box';
        GridModel.defaultOption = {
            show: false,
            zlevel: 0,
            z: 0,
            left: '10%',
            top: 60,
            right: '10%',
            bottom: 70,
            containLabel: false,
            backgroundColor: 'rgba(0,0,0,0)',
            borderWidth: 1,
            borderColor: '#ccc'
        };
        return GridModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    var $6e226630804759b0$export$2e2bcd8739ae039 = $6e226630804759b0$var$GridModel;
});
parcelRegister("1UrP6", function(module, exports) {
    $parcel$export(module.exports, "CartesianAxisModel", ()=>$16409a80acd4e1a4$export$483dc37e6ad83a3c);
    var $3VFsf;
    var $bahqM;
    var $h4UlH;
    var $5pBRm;
    var $eaKsF;
    var $16409a80acd4e1a4$export$483dc37e6ad83a3c = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianAxisModel, _super);
        function CartesianAxisModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CartesianAxisModel.prototype.getCoordSysModel = function() {
            return this.getReferringComponents('grid', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
        };
        CartesianAxisModel.type = 'cartesian2dAxis';
        return CartesianAxisModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    (0, parcelRequire("bahqM")).mixin($16409a80acd4e1a4$export$483dc37e6ad83a3c, (0, (0, parcelRequire("5pBRm")).AxisModelCommonMixin));
    var $16409a80acd4e1a4$export$2e2bcd8739ae039 = $16409a80acd4e1a4$export$483dc37e6ad83a3c;
});
parcelRegister("5pBRm", function(module, exports) {
    $parcel$export(module.exports, "AxisModelCommonMixin", ()=>$3f0ca7b2a67ba541$export$5c54b224726edb5a);
    var $3f0ca7b2a67ba541$export$5c54b224726edb5a = function() {
        function AxisModelCommonMixin() {}
        AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
            var option = this.option;
            return !option.scale;
        };
        AxisModelCommonMixin.prototype.getCoordSysModel = function() {
            return;
        };
        return AxisModelCommonMixin;
    }();
});
parcelRegister("aLiaH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d5c63a9e257cb04$export$2e2bcd8739ae039);
    var $3VFsf;
    var $erX9x;
    var $65MS1;
    var $6Vrdy;
    var $7vTvv;
    var $bahqM;
    function $7d5c63a9e257cb04$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
        (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("7vTvv")).AXIS_TYPES), function(v, axisType) {
            var defaultOption = (0, (0, parcelRequire("bahqM")).merge)((0, (0, parcelRequire("bahqM")).merge)({}, (0, (0, parcelRequire("erX9x")).default)[axisType], true), extraDefaultOption, true);
            var AxisModel = function(_super) {
                (0, (0, parcelRequire("3VFsf")).__extends)(AxisModel, _super);
                function AxisModel() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.type = axisName + 'Axis.' + axisType;
                    return _this;
                }
                AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                    var layoutMode = (0, (0, parcelRequire("65MS1")).fetchLayoutMode)(this);
                    var inputPositionParams = layoutMode ? (0, (0, parcelRequire("65MS1")).getLayoutParams)(option) : {};
                    var themeModel = ecModel.getTheme();
                    (0, (0, parcelRequire("bahqM")).merge)(option, themeModel.get(axisType + 'Axis'));
                    (0, (0, parcelRequire("bahqM")).merge)(option, this.getDefaultOption());
                    option.type = $7d5c63a9e257cb04$var$getAxisType(option);
                    if (layoutMode) (0, (0, parcelRequire("65MS1")).mergeLayoutParam)(option, inputPositionParams, layoutMode);
                };
                AxisModel.prototype.optionUpdated = function() {
                    var thisOption = this.option;
                    if (thisOption.type === 'category') this.__ordinalMeta = (0, (0, parcelRequire("6Vrdy")).default).createByAxisModel(this);
                };
                AxisModel.prototype.getCategories = function(rawData) {
                    var option = this.option;
                    if (option.type === 'category') {
                        if (rawData) return option.data;
                        return this.__ordinalMeta.categories;
                    }
                };
                AxisModel.prototype.getOrdinalMeta = function() {
                    return this.__ordinalMeta;
                };
                AxisModel.type = axisName + 'Axis.' + axisType;
                AxisModel.defaultOption = defaultOption;
                return AxisModel;
            }(BaseAxisModelClass);
            registers.registerComponentModel(AxisModel);
        });
        registers.registerSubTypeDefaulter(axisName + 'Axis', $7d5c63a9e257cb04$var$getAxisType);
    }
    function $7d5c63a9e257cb04$var$getAxisType(option) {
        return option.type || (option.data ? 'category' : 'value');
    }
});
parcelRegister("erX9x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a85178cf0b0fc4bc$export$2e2bcd8739ae039);
    var $bahqM;
    var $a85178cf0b0fc4bc$var$defaultOption = {
        show: true,
        zlevel: 0,
        z: 0,
        inverse: false,
        name: '',
        nameLocation: 'end',
        nameRotate: null,
        nameTruncate: {
            maxWidth: null,
            ellipsis: '...',
            placeholder: '.'
        },
        nameTextStyle: {},
        nameGap: 15,
        silent: false,
        triggerEvent: false,
        tooltip: {
            show: false
        },
        axisPointer: {},
        axisLine: {
            show: true,
            onZero: true,
            onZeroAxisIndex: null,
            lineStyle: {
                color: '#6E7079',
                width: 1,
                type: 'solid'
            },
            symbol: [
                'none',
                'none'
            ],
            symbolSize: [
                10,
                15
            ]
        },
        axisTick: {
            show: true,
            inside: false,
            length: 5,
            lineStyle: {
                width: 1
            }
        },
        axisLabel: {
            show: true,
            inside: false,
            rotate: 0,
            showMinLabel: null,
            showMaxLabel: null,
            margin: 8,
            fontSize: 12
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: [
                    '#E0E6F1'
                ],
                width: 1,
                type: 'solid'
            }
        },
        splitArea: {
            show: false,
            areaStyle: {
                color: [
                    'rgba(250,250,250,0.2)',
                    'rgba(210,219,238,0.2)'
                ]
            }
        }
    };
    var $a85178cf0b0fc4bc$var$categoryAxis = (0, parcelRequire("bahqM")).merge({
        boundaryGap: true,
        deduplication: null,
        splitLine: {
            show: false
        },
        axisTick: {
            alignWithLabel: false,
            interval: 'auto'
        },
        axisLabel: {
            interval: 'auto'
        }
    }, $a85178cf0b0fc4bc$var$defaultOption);
    var $a85178cf0b0fc4bc$var$valueAxis = (0, parcelRequire("bahqM")).merge({
        boundaryGap: [
            0,
            0
        ],
        axisLine: {
            show: 'auto'
        },
        axisTick: {
            show: 'auto'
        },
        splitNumber: 5,
        minorTick: {
            show: false,
            splitNumber: 5,
            length: 3,
            lineStyle: {}
        },
        minorSplitLine: {
            show: false,
            lineStyle: {
                color: '#F4F7FD',
                width: 1
            }
        }
    }, $a85178cf0b0fc4bc$var$defaultOption);
    var $a85178cf0b0fc4bc$var$timeAxis = (0, parcelRequire("bahqM")).merge({
        scale: true,
        splitNumber: 6,
        axisLabel: {
            showMinLabel: false,
            showMaxLabel: false,
            rich: {
                primary: {
                    fontWeight: 'bold'
                }
            }
        },
        splitLine: {
            show: false
        }
    }, $a85178cf0b0fc4bc$var$valueAxis);
    var $a85178cf0b0fc4bc$var$logAxis = (0, parcelRequire("bahqM")).defaults({
        scale: true,
        logBase: 10
    }, $a85178cf0b0fc4bc$var$valueAxis);
    var $a85178cf0b0fc4bc$export$2e2bcd8739ae039 = {
        category: $a85178cf0b0fc4bc$var$categoryAxis,
        value: $a85178cf0b0fc4bc$var$valueAxis,
        time: $a85178cf0b0fc4bc$var$timeAxis,
        log: $a85178cf0b0fc4bc$var$logAxis
    };
});
parcelRegister("6Vrdy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50ad2dcdb048637a$export$2e2bcd8739ae039);
    var $bahqM;
    var $50ad2dcdb048637a$var$uidBase = 0;
    var $50ad2dcdb048637a$var$OrdinalMeta = function() {
        function OrdinalMeta(opt) {
            this.categories = opt.categories || [];
            this._needCollect = opt.needCollect;
            this._deduplication = opt.deduplication;
            this.uid = ++$50ad2dcdb048637a$var$uidBase;
        }
        OrdinalMeta.createByAxisModel = function(axisModel) {
            var option = axisModel.option;
            var data = option.data;
            var categories = data && (0, (0, parcelRequire("bahqM")).map)(data, $50ad2dcdb048637a$var$getName);
            return new OrdinalMeta({
                categories: categories,
                needCollect: !categories,
                deduplication: option.dedplication !== false
            });
        };
        OrdinalMeta.prototype.getOrdinal = function(category) {
            return this._getOrCreateMap().get(category);
        };
        OrdinalMeta.prototype.parseAndCollect = function(category) {
            var index;
            var needCollect = this._needCollect;
            if (typeof category !== 'string' && !needCollect) return category;
            if (needCollect && !this._deduplication) {
                index = this.categories.length;
                this.categories[index] = category;
                return index;
            }
            var map = this._getOrCreateMap();
            index = map.get(category);
            if (index == null) {
                if (needCollect) {
                    index = this.categories.length;
                    this.categories[index] = category;
                    map.set(category, index);
                } else index = NaN;
            }
            return index;
        };
        OrdinalMeta.prototype._getOrCreateMap = function() {
            return this._map || (this._map = (0, (0, parcelRequire("bahqM")).createHashMap)(this.categories));
        };
        return OrdinalMeta;
    }();
    function $50ad2dcdb048637a$var$getName(obj) {
        if ((0, (0, parcelRequire("bahqM")).isObject)(obj) && obj.value != null) return obj.value;
        else return obj + '';
    }
    var $50ad2dcdb048637a$export$2e2bcd8739ae039 = $50ad2dcdb048637a$var$OrdinalMeta;
});
parcelRegister("7vTvv", function(module, exports) {
    $parcel$export(module.exports, "AXIS_TYPES", ()=>$57867c39181fdac2$export$2e0057d176d6f690);
    var $57867c39181fdac2$export$2e0057d176d6f690 = {
        value: 1,
        category: 1,
        time: 1,
        log: 1
    };
});
parcelRegister("1xCHp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$11f6e45ff2a10529$export$2e2bcd8739ae039);
    var $bahqM;
    var $65MS1;
    var $3GIoT;
    var $SsPct;
    var $kBKMx;
    var $eaKsF;
    var $dBIJY;
    var $11f6e45ff2a10529$var$Grid = function() {
        function Grid(gridModel, ecModel, api) {
            this.type = 'grid';
            this._coordsMap = {};
            this._coordsList = [];
            this._axesMap = {};
            this._axesList = [];
            this.axisPointerEnabled = true;
            this.dimensions = (0, (0, parcelRequire("SsPct")).cartesian2DDimensions);
            this._initCartesian(gridModel, ecModel, api);
            this.model = gridModel;
        }
        Grid.prototype.getRect = function() {
            return this._rect;
        };
        Grid.prototype.update = function(ecModel, api) {
            var axesMap = this._axesMap;
            this._updateScale(ecModel, this.model);
            (0, (0, parcelRequire("bahqM")).each)(axesMap.x, function(xAxis) {
                (0, (0, parcelRequire("3GIoT")).niceScaleExtent)(xAxis.scale, xAxis.model);
            });
            (0, (0, parcelRequire("bahqM")).each)(axesMap.y, function(yAxis) {
                (0, (0, parcelRequire("3GIoT")).niceScaleExtent)(yAxis.scale, yAxis.model);
            });
            var onZeroRecords = {};
            (0, (0, parcelRequire("bahqM")).each)(axesMap.x, function(xAxis) {
                $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
            });
            (0, (0, parcelRequire("bahqM")).each)(axesMap.y, function(yAxis) {
                $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
            });
            this.resize(this.model, api);
        };
        Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
            var boxLayoutParams = gridModel.getBoxLayoutParams();
            var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
            var gridRect = (0, (0, parcelRequire("65MS1")).getLayoutRect)(boxLayoutParams, {
                width: api.getWidth(),
                height: api.getHeight()
            });
            this._rect = gridRect;
            var axesList = this._axesList;
            adjustAxes();
            if (isContainLabel) {
                (0, (0, parcelRequire("bahqM")).each)(axesList, function(axis) {
                    if (!axis.model.get([
                        'axisLabel',
                        'inside'
                    ])) {
                        var labelUnionRect = (0, (0, parcelRequire("3GIoT")).estimateLabelUnionRect)(axis);
                        if (labelUnionRect) {
                            var dim = axis.isHorizontal() ? 'height' : 'width';
                            var margin = axis.model.get([
                                'axisLabel',
                                'margin'
                            ]);
                            gridRect[dim] -= labelUnionRect[dim] + margin;
                            if (axis.position === 'top') gridRect.y += labelUnionRect.height + margin;
                            else if (axis.position === 'left') gridRect.x += labelUnionRect.width + margin;
                        }
                    }
                });
                adjustAxes();
            }
            (0, (0, parcelRequire("bahqM")).each)(this._coordsList, function(coord) {
                coord.calcAffineTransform();
            });
            function adjustAxes() {
                (0, (0, parcelRequire("bahqM")).each)(axesList, function(axis) {
                    var isHorizontal = axis.isHorizontal();
                    var extent = isHorizontal ? [
                        0,
                        gridRect.width
                    ] : [
                        0,
                        gridRect.height
                    ];
                    var idx = axis.inverse ? 1 : 0;
                    axis.setExtent(extent[idx], extent[1 - idx]);
                    $11f6e45ff2a10529$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
                });
            }
        };
        Grid.prototype.getAxis = function(dim, axisIndex) {
            var axesMapOnDim = this._axesMap[dim];
            if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
        };
        Grid.prototype.getAxes = function() {
            return this._axesList.slice();
        };
        Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
            if (xAxisIndex != null && yAxisIndex != null) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                return this._coordsMap[key];
            }
            if ((0, (0, parcelRequire("bahqM")).isObject)(xAxisIndex)) {
                yAxisIndex = xAxisIndex.yAxisIndex;
                xAxisIndex = xAxisIndex.xAxisIndex;
            }
            for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
                if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
            }
        };
        Grid.prototype.getCartesians = function() {
            return this._coordsList.slice();
        };
        Grid.prototype.convertToPixel = function(ecModel, finder, value) {
            var target = this._findConvertTarget(finder);
            return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
        };
        Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
            var target = this._findConvertTarget(finder);
            return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
        };
        Grid.prototype._findConvertTarget = function(finder) {
            var seriesModel = finder.seriesModel;
            var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var gridModel = finder.gridModel;
            var coordsList = this._coordsList;
            var cartesian;
            var axis;
            if (seriesModel) {
                cartesian = seriesModel.coordinateSystem;
                (0, (0, parcelRequire("bahqM")).indexOf)(coordsList, cartesian) < 0 && (cartesian = null);
            } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
            else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
            else if (gridModel) {
                var grid = gridModel.coordinateSystem;
                if (grid === this) cartesian = this._coordsList[0];
            }
            return {
                cartesian: cartesian,
                axis: axis
            };
        };
        Grid.prototype.containPoint = function(point) {
            var coord = this._coordsList[0];
            if (coord) return coord.containPoint(point);
        };
        Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
            var _this = this;
            var grid = this;
            var axisPositionUsed = {
                left: false,
                right: false,
                top: false,
                bottom: false
            };
            var axesMap = {
                x: {},
                y: {}
            };
            var axesCount = {
                x: 0,
                y: 0
            };
            ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
            ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
            if (!axesCount.x || !axesCount.y) {
                this._axesMap = {};
                this._axesList = [];
                return;
            }
            this._axesMap = axesMap;
            (0, (0, parcelRequire("bahqM")).each)(axesMap.x, function(xAxis, xAxisIndex) {
                (0, (0, parcelRequire("bahqM")).each)(axesMap.y, function(yAxis, yAxisIndex) {
                    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                    var cartesian = new (0, (0, parcelRequire("SsPct")).default)(key);
                    cartesian.master = _this;
                    cartesian.model = gridModel;
                    _this._coordsMap[key] = cartesian;
                    _this._coordsList.push(cartesian);
                    cartesian.addAxis(xAxis);
                    cartesian.addAxis(yAxis);
                });
            });
            function createAxisCreator(dimName) {
                return function(axisModel, idx) {
                    if (!$11f6e45ff2a10529$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                    var axisPosition = axisModel.get('position');
                    if (dimName === 'x') {
                        if (axisPosition !== 'top' && axisPosition !== 'bottom') axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                    } else if (axisPosition !== 'left' && axisPosition !== 'right') axisPosition = axisPositionUsed.left ? 'right' : 'left';
                    axisPositionUsed[axisPosition] = true;
                    var axis = new (0, (0, parcelRequire("kBKMx")).default)(dimName, (0, (0, parcelRequire("3GIoT")).createScaleByModel)(axisModel), [
                        0,
                        0
                    ], axisModel.get('type'), axisPosition);
                    var isCategory = axis.type === 'category';
                    axis.onBand = isCategory && axisModel.get('boundaryGap');
                    axis.inverse = axisModel.get('inverse');
                    axisModel.axis = axis;
                    axis.model = axisModel;
                    axis.grid = grid;
                    axis.index = idx;
                    grid._axesList.push(axis);
                    axesMap[dimName][idx] = axis;
                    axesCount[dimName]++;
                };
            }
        };
        Grid.prototype._updateScale = function(ecModel, gridModel) {
            (0, (0, parcelRequire("bahqM")).each)(this._axesList, function(axis) {
                axis.scale.setExtent(Infinity, -Infinity);
                if (axis.type === 'category') {
                    var categorySortInfo = axis.model.get('categorySortInfo');
                    axis.scale.setSortInfo(categorySortInfo);
                }
            });
            ecModel.eachSeries(function(seriesModel) {
                if ((0, (0, parcelRequire("dBIJY")).isCartesian2DSeries)(seriesModel)) {
                    var axesModelMap = (0, (0, parcelRequire("dBIJY")).findAxisModels)(seriesModel);
                    var xAxisModel = axesModelMap.xAxisModel;
                    var yAxisModel = axesModelMap.yAxisModel;
                    if (!$11f6e45ff2a10529$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$11f6e45ff2a10529$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                    var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                    var data = seriesModel.getData();
                    var xAxis = cartesian.getAxis('x');
                    var yAxis = cartesian.getAxis('y');
                    if (data.type === 'list') {
                        unionExtent(data, xAxis);
                        unionExtent(data, yAxis);
                    }
                }
            }, this);
            function unionExtent(data, axis) {
                (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("3GIoT")).getDataDimensionsOnAxis)(data, axis.dim), function(dim) {
                    axis.scale.unionExtentFromData(data, dim);
                });
            }
        };
        Grid.prototype.getTooltipAxes = function(dim) {
            var baseAxes = [];
            var otherAxes = [];
            (0, (0, parcelRequire("bahqM")).each)(this.getCartesians(), function(cartesian) {
                var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
                var otherAxis = cartesian.getOtherAxis(baseAxis);
                (0, (0, parcelRequire("bahqM")).indexOf)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
                (0, (0, parcelRequire("bahqM")).indexOf)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
            });
            return {
                baseAxes: baseAxes,
                otherAxes: otherAxes
            };
        };
        Grid.create = function(ecModel, api) {
            var grids = [];
            ecModel.eachComponent('grid', function(gridModel, idx) {
                var grid = new Grid(gridModel, ecModel, api);
                grid.name = 'grid_' + idx;
                grid.resize(gridModel, api, true);
                gridModel.coordinateSystem = grid;
                grids.push(grid);
            });
            ecModel.eachSeries(function(seriesModel) {
                if (!(0, (0, parcelRequire("dBIJY")).isCartesian2DSeries)(seriesModel)) return;
                var axesModelMap = (0, (0, parcelRequire("dBIJY")).findAxisModels)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                var gridModel = xAxisModel.getCoordSysModel();
                var grid = gridModel.coordinateSystem;
                seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            });
            return grids;
        };
        Grid.dimensions = (0, (0, parcelRequire("SsPct")).cartesian2DDimensions);
        return Grid;
    }();
    function $11f6e45ff2a10529$var$isAxisUsedInTheGrid(axisModel, gridModel) {
        return axisModel.getCoordSysModel() === gridModel;
    }
    function $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
        axis.getAxesOnZeroOf = function() {
            return otherAxisOnZeroOf ? [
                otherAxisOnZeroOf
            ] : [];
        };
        var otherAxes = axesMap[otherAxisDim];
        var otherAxisOnZeroOf;
        var axisModel = axis.model;
        var onZero = axisModel.get([
            'axisLine',
            'onZero'
        ]);
        var onZeroAxisIndex = axisModel.get([
            'axisLine',
            'onZeroAxisIndex'
        ]);
        if (!onZero) return;
        if (onZeroAxisIndex != null) {
            if ($11f6e45ff2a10529$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
        } else {
            for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $11f6e45ff2a10529$var$canOnZeroToAxis(otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
                otherAxisOnZeroOf = otherAxes[idx];
                break;
            }
        }
        if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
        function getOnZeroRecordKey(axis) {
            return axis.dim + '_' + axis.index;
        }
    }
    function $11f6e45ff2a10529$var$canOnZeroToAxis(axis) {
        return axis && axis.type !== 'category' && axis.type !== 'time' && (0, (0, parcelRequire("3GIoT")).ifAxisCrossZero)(axis);
    }
    function $11f6e45ff2a10529$var$updateAxisTransform(axis, coordBase) {
        var axisExtent = axis.getExtent();
        var axisExtentSum = axisExtent[0] + axisExtent[1];
        axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
            return coord + coordBase;
        } : function(coord) {
            return axisExtentSum - coord + coordBase;
        };
        axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
            return coord - coordBase;
        } : function(coord) {
            return axisExtentSum - coord + coordBase;
        };
    }
    var $11f6e45ff2a10529$export$2e2bcd8739ae039 = $11f6e45ff2a10529$var$Grid;
});
parcelRegister("3GIoT", function(module, exports) {
    $parcel$export(module.exports, "getScaleExtent", ()=>$2af7bc5b57211b12$export$9c0ba8df7eb7b328);
    $parcel$export(module.exports, "niceScaleExtent", ()=>$2af7bc5b57211b12$export$51f3e70a54405d5a);
    $parcel$export(module.exports, "createScaleByModel", ()=>$2af7bc5b57211b12$export$8941c4cacdc8f5a5);
    $parcel$export(module.exports, "ifAxisCrossZero", ()=>$2af7bc5b57211b12$export$3eac36a69f37d52);
    $parcel$export(module.exports, "makeLabelFormatter", ()=>$2af7bc5b57211b12$export$742f19a75415b2ae);
    $parcel$export(module.exports, "getAxisRawValue", ()=>$2af7bc5b57211b12$export$a5a32f324c1fa457);
    $parcel$export(module.exports, "estimateLabelUnionRect", ()=>$2af7bc5b57211b12$export$fef1c7f0af0b48d);
    $parcel$export(module.exports, "getOptionCategoryInterval", ()=>$2af7bc5b57211b12$export$6d0bc2429155c088);
    $parcel$export(module.exports, "shouldShowAllLabels", ()=>$2af7bc5b57211b12$export$c2911c025243d6a6);
    $parcel$export(module.exports, "getDataDimensionsOnAxis", ()=>$2af7bc5b57211b12$export$e4cf30b1e74cd69d);
    $parcel$export(module.exports, "unionAxisExtentFromData", ()=>$2af7bc5b57211b12$export$635fe7f20d0f4c70);
    var $bahqM;
    var $acOy6;
    var $6kObD;
    var $fEgWg;
    var $eL4bi;
    var $1E3E8;
    var $1MU9l;
    var $73kgw;
    var $5R8Hi;
    var $lo2Vo;
    function $2af7bc5b57211b12$export$9c0ba8df7eb7b328(scale, model) {
        var scaleType = scale.type;
        var rawExtentResult = (0, (0, parcelRequire("lo2Vo")).ensureScaleRawExtentInfo)(scale, model, scale.getExtent()).calculate();
        scale.setBlank(rawExtentResult.isBlank);
        var min = rawExtentResult.min;
        var max = rawExtentResult.max;
        var ecModel = model.ecModel;
        if (ecModel && scaleType === 'time') {
            var barSeriesModels = (0, (0, parcelRequire("eL4bi")).prepareLayoutBarSeries)('bar', ecModel);
            var isBaseAxisAndHasBarSeries_1 = false;
            (0, parcelRequire("bahqM")).each(barSeriesModels, function(seriesModel) {
                isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
            });
            if (isBaseAxisAndHasBarSeries_1) {
                var barWidthAndOffset = (0, (0, parcelRequire("eL4bi")).makeColumnLayout)(barSeriesModels);
                var adjustedScale = $2af7bc5b57211b12$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
                min = adjustedScale.min;
                max = adjustedScale.max;
            }
        }
        return {
            extent: [
                min,
                max
            ],
            fixMin: rawExtentResult.minFixed,
            fixMax: rawExtentResult.maxFixed
        };
    }
    function $2af7bc5b57211b12$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
        var axisExtent = model.axis.getExtent();
        var axisLength = axisExtent[1] - axisExtent[0];
        var barsOnCurrentAxis = (0, (0, parcelRequire("eL4bi")).retrieveColumnLayout)(barWidthAndOffset, model.axis);
        if (barsOnCurrentAxis === undefined) return {
            min: min,
            max: max
        };
        var minOverflow = Infinity;
        (0, parcelRequire("bahqM")).each(barsOnCurrentAxis, function(item) {
            minOverflow = Math.min(item.offset, minOverflow);
        });
        var maxOverflow = -Infinity;
        (0, parcelRequire("bahqM")).each(barsOnCurrentAxis, function(item) {
            maxOverflow = Math.max(item.offset + item.width, maxOverflow);
        });
        minOverflow = Math.abs(minOverflow);
        maxOverflow = Math.abs(maxOverflow);
        var totalOverFlow = minOverflow + maxOverflow;
        var oldRange = max - min;
        var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
        var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
        max += overflowBuffer * (maxOverflow / totalOverFlow);
        min -= overflowBuffer * (minOverflow / totalOverFlow);
        return {
            min: min,
            max: max
        };
    }
    function $2af7bc5b57211b12$export$51f3e70a54405d5a(scale, inModel) {
        var model = inModel;
        var extentInfo = $2af7bc5b57211b12$export$9c0ba8df7eb7b328(scale, model);
        var extent = extentInfo.extent;
        var splitNumber = model.get('splitNumber');
        if (scale instanceof (0, (0, parcelRequire("73kgw")).default)) scale.base = model.get('logBase');
        var scaleType = scale.type;
        scale.setExtent(extent[0], extent[1]);
        scale.niceExtent({
            splitNumber: splitNumber,
            fixMin: extentInfo.fixMin,
            fixMax: extentInfo.fixMax,
            minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
            maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
        });
        var interval = model.get('interval');
        if (interval != null) scale.setInterval && scale.setInterval(interval);
    }
    function $2af7bc5b57211b12$export$8941c4cacdc8f5a5(model, axisType) {
        axisType = axisType || model.get('type');
        if (axisType) switch(axisType){
            case 'category':
                return new (0, (0, parcelRequire("acOy6")).default)({
                    ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                    extent: [
                        Infinity,
                        -Infinity
                    ]
                });
            case 'time':
                return new (0, (0, parcelRequire("1MU9l")).default)({
                    locale: model.ecModel.getLocaleModel(),
                    useUTC: model.ecModel.get('useUTC')
                });
            default:
                return new ((0, (0, parcelRequire("fEgWg")).default).getClass(axisType) || (0, (0, parcelRequire("6kObD")).default))();
        }
    }
    function $2af7bc5b57211b12$export$3eac36a69f37d52(axis) {
        var dataExtent = axis.scale.getExtent();
        var min = dataExtent[0];
        var max = dataExtent[1];
        return !(min > 0 && max > 0 || min < 0 && max < 0);
    }
    function $2af7bc5b57211b12$export$742f19a75415b2ae(axis) {
        var labelFormatter = axis.getLabelModel().get('formatter');
        var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
        if (axis.scale.type === 'time') return function(tpl) {
            return function(tick, idx) {
                return axis.scale.getFormattedLabel(tick, idx, tpl);
            };
        }(labelFormatter);
        else if (typeof labelFormatter === 'string') return function(tpl) {
            return function(tick) {
                var label = axis.scale.getLabel(tick);
                var text = tpl.replace('{value}', label != null ? label : '');
                return text;
            };
        }(labelFormatter);
        else if (typeof labelFormatter === 'function') return function(cb) {
            return function(tick, idx) {
                if (categoryTickStart != null) idx = tick.value - categoryTickStart;
                return cb($2af7bc5b57211b12$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                    level: tick.level
                } : null);
            };
        }(labelFormatter);
        else return function(tick) {
            return axis.scale.getLabel(tick);
        };
    }
    function $2af7bc5b57211b12$export$a5a32f324c1fa457(axis, tick) {
        return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
    }
    function $2af7bc5b57211b12$export$fef1c7f0af0b48d(axis) {
        var axisModel = axis.model;
        var scale = axis.scale;
        if (!axisModel.get([
            'axisLabel',
            'show'
        ]) || scale.isBlank()) return;
        var realNumberScaleTicks;
        var tickCount;
        var categoryScaleExtent = scale.getExtent();
        if (scale instanceof (0, (0, parcelRequire("acOy6")).default)) tickCount = scale.count();
        else {
            realNumberScaleTicks = scale.getTicks();
            tickCount = realNumberScaleTicks.length;
        }
        var axisLabelModel = axis.getLabelModel();
        var labelFormatter = $2af7bc5b57211b12$export$742f19a75415b2ae(axis);
        var rect;
        var step = 1;
        if (tickCount > 40) step = Math.ceil(tickCount / 40);
        for(var i = 0; i < tickCount; i += step){
            var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
                value: categoryScaleExtent[0] + i
            };
            var label = labelFormatter(tick, i);
            var unrotatedSingleRect = axisLabelModel.getTextRect(label);
            var singleRect = $2af7bc5b57211b12$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
            rect ? rect.union(singleRect) : rect = singleRect;
        }
        return rect;
    }
    function $2af7bc5b57211b12$var$rotateTextRect(textRect, rotate) {
        var rotateRadians = rotate * Math.PI / 180;
        var beforeWidth = textRect.width;
        var beforeHeight = textRect.height;
        var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
        var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
        var rotatedRect = new (0, (0, parcelRequire("1E3E8")).default)(textRect.x, textRect.y, afterWidth, afterHeight);
        return rotatedRect;
    }
    function $2af7bc5b57211b12$export$6d0bc2429155c088(model) {
        var interval = model.get('interval');
        return interval == null ? 'auto' : interval;
    }
    function $2af7bc5b57211b12$export$c2911c025243d6a6(axis) {
        return axis.type === 'category' && $2af7bc5b57211b12$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
    }
    function $2af7bc5b57211b12$export$e4cf30b1e74cd69d(data, axisDim) {
        var dataDimMap = {};
        (0, parcelRequire("bahqM")).each(data.mapDimensionsAll(axisDim), function(dataDim) {
            dataDimMap[(0, (0, parcelRequire("5R8Hi")).getStackedDimension)(data, dataDim)] = true;
        });
        return (0, parcelRequire("bahqM")).keys(dataDimMap);
    }
    function $2af7bc5b57211b12$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
        if (data) (0, parcelRequire("bahqM")).each($2af7bc5b57211b12$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
            var seriesExtent = data.getApproximateExtent(dim);
            seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
            seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
        });
    }
});
parcelRegister("acOy6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76e23c609ca21282$export$2e2bcd8739ae039);
    var $3VFsf;
    var $fEgWg;
    var $6Vrdy;
    var $32MHg;
    var $bahqM;
    var $76e23c609ca21282$var$OrdinalScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(OrdinalScale, _super);
        function OrdinalScale(setting) {
            var _this = _super.call(this, setting) || this;
            _this.type = 'ordinal';
            var ordinalMeta = _this.getSetting('ordinalMeta');
            if (!ordinalMeta) ordinalMeta = new (0, (0, parcelRequire("6Vrdy")).default)({});
            if ((0, (0, parcelRequire("bahqM")).isArray)(ordinalMeta)) ordinalMeta = new (0, (0, parcelRequire("6Vrdy")).default)({
                categories: (0, (0, parcelRequire("bahqM")).map)(ordinalMeta, function(item) {
                    return (0, (0, parcelRequire("bahqM")).isObject)(item) ? item.value : item;
                })
            });
            _this._ordinalMeta = ordinalMeta;
            _this._extent = _this.getSetting('extent') || [
                0,
                ordinalMeta.categories.length - 1
            ];
            return _this;
        }
        OrdinalScale.prototype.parse = function(val) {
            return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) : Math.round(val);
        };
        OrdinalScale.prototype.contain = function(rank) {
            rank = this.parse(rank);
            return (0, parcelRequire("32MHg")).contain(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
        };
        OrdinalScale.prototype.normalize = function(val) {
            val = this._getTickNumber(this.parse(val));
            return (0, parcelRequire("32MHg")).normalize(val, this._extent);
        };
        OrdinalScale.prototype.scale = function(val) {
            val = Math.round((0, parcelRequire("32MHg")).scale(val, this._extent));
            return this.getRawOrdinalNumber(val);
        };
        OrdinalScale.prototype.getTicks = function() {
            var ticks = [];
            var extent = this._extent;
            var rank = extent[0];
            while(rank <= extent[1]){
                ticks.push({
                    value: rank
                });
                rank++;
            }
            return ticks;
        };
        OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
            return;
        };
        OrdinalScale.prototype.setSortInfo = function(info) {
            if (info == null) {
                this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
                return;
            }
            var infoOrdinalNumbers = info.ordinalNumbers;
            var ordinalsByTick = this._ordinalNumbersByTick = [];
            var ticksByOrdinal = this._ticksByOrdinalNumber = [];
            var tickNum = 0;
            var allCategoryLen = this._ordinalMeta.categories.length;
            for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
                var ordinalNumber = infoOrdinalNumbers[tickNum];
                ordinalsByTick[tickNum] = ordinalNumber;
                ticksByOrdinal[ordinalNumber] = tickNum;
            }
            var unusedOrdinal = 0;
            for(; tickNum < allCategoryLen; ++tickNum){
                while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
                ordinalsByTick.push(unusedOrdinal);
                ticksByOrdinal[unusedOrdinal] = tickNum;
            }
        };
        OrdinalScale.prototype._getTickNumber = function(ordinal) {
            var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
            return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
        };
        OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
            var ordinalNumbersByTick = this._ordinalNumbersByTick;
            return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
        };
        OrdinalScale.prototype.getLabel = function(tick) {
            if (!this.isBlank()) {
                var ordinalNumber = this.getRawOrdinalNumber(tick.value);
                var cateogry = this._ordinalMeta.categories[ordinalNumber];
                return cateogry == null ? '' : cateogry + '';
            }
        };
        OrdinalScale.prototype.count = function() {
            return this._extent[1] - this._extent[0] + 1;
        };
        OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
            this.unionExtent(data.getApproximateExtent(dim));
        };
        OrdinalScale.prototype.isInExtentRange = function(value) {
            value = this._getTickNumber(value);
            return this._extent[0] <= value && this._extent[1] >= value;
        };
        OrdinalScale.prototype.getOrdinalMeta = function() {
            return this._ordinalMeta;
        };
        OrdinalScale.prototype.niceTicks = function() {};
        OrdinalScale.prototype.niceExtent = function() {};
        OrdinalScale.type = 'ordinal';
        return OrdinalScale;
    }((0, (0, parcelRequire("fEgWg")).default));
    (0, (0, parcelRequire("fEgWg")).default).registerClass($76e23c609ca21282$var$OrdinalScale);
    var $76e23c609ca21282$export$2e2bcd8739ae039 = $76e23c609ca21282$var$OrdinalScale;
});
parcelRegister("fEgWg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b647bb1e30834d31$export$2e2bcd8739ae039);
    var $aLwh0;
    var $b647bb1e30834d31$var$Scale = function() {
        function Scale(setting) {
            this._setting = setting || {};
            this._extent = [
                Infinity,
                -Infinity
            ];
        }
        Scale.prototype.getSetting = function(name) {
            return this._setting[name];
        };
        Scale.prototype.unionExtent = function(other) {
            var extent = this._extent;
            other[0] < extent[0] && (extent[0] = other[0]);
            other[1] > extent[1] && (extent[1] = other[1]);
        };
        Scale.prototype.unionExtentFromData = function(data, dim) {
            this.unionExtent(data.getApproximateExtent(dim));
        };
        Scale.prototype.getExtent = function() {
            return this._extent.slice();
        };
        Scale.prototype.setExtent = function(start, end) {
            var thisExtent = this._extent;
            if (!isNaN(start)) thisExtent[0] = start;
            if (!isNaN(end)) thisExtent[1] = end;
        };
        Scale.prototype.isInExtentRange = function(value) {
            return this._extent[0] <= value && this._extent[1] >= value;
        };
        Scale.prototype.isBlank = function() {
            return this._isBlank;
        };
        Scale.prototype.setBlank = function(isBlank) {
            this._isBlank = isBlank;
        };
        return Scale;
    }();
    (0, parcelRequire("aLwh0")).enableClassManagement($b647bb1e30834d31$var$Scale);
    var $b647bb1e30834d31$export$2e2bcd8739ae039 = $b647bb1e30834d31$var$Scale;
});
parcelRegister("32MHg", function(module, exports) {
    $parcel$export(module.exports, "intervalScaleNiceTicks", ()=>$2377552e030bbd2b$export$eeea879a611eb991);
    $parcel$export(module.exports, "getIntervalPrecision", ()=>$2377552e030bbd2b$export$86a060b060d3d31a);
    $parcel$export(module.exports, "contain", ()=>$2377552e030bbd2b$export$8893e2b90ba10d92);
    $parcel$export(module.exports, "normalize", ()=>$2377552e030bbd2b$export$a3295358bff77e);
    $parcel$export(module.exports, "scale", ()=>$2377552e030bbd2b$export$dcdf75081b88279d);
    var $jmSNG;
    var $2377552e030bbd2b$var$roundNumber = (0, parcelRequire("jmSNG")).round;
    function $2377552e030bbd2b$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
        var result = {};
        var span = extent[1] - extent[0];
        var interval = result.interval = (0, parcelRequire("jmSNG")).nice(span / splitNumber, true);
        if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
        if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
        var precision = result.intervalPrecision = $2377552e030bbd2b$export$86a060b060d3d31a(interval);
        var niceTickExtent = result.niceTickExtent = [
            $2377552e030bbd2b$var$roundNumber(Math.ceil(extent[0] / interval) * interval, precision),
            $2377552e030bbd2b$var$roundNumber(Math.floor(extent[1] / interval) * interval, precision)
        ];
        $2377552e030bbd2b$export$624b8c8c438031ad(niceTickExtent, extent);
        return result;
    }
    function $2377552e030bbd2b$export$86a060b060d3d31a(interval) {
        return (0, parcelRequire("jmSNG")).getPrecision(interval) + 2;
    }
    function $2377552e030bbd2b$var$clamp(niceTickExtent, idx, extent) {
        niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
    }
    function $2377552e030bbd2b$export$624b8c8c438031ad(niceTickExtent, extent) {
        !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
        !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
        $2377552e030bbd2b$var$clamp(niceTickExtent, 0, extent);
        $2377552e030bbd2b$var$clamp(niceTickExtent, 1, extent);
        if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
    }
    function $2377552e030bbd2b$export$8893e2b90ba10d92(val, extent) {
        return val >= extent[0] && val <= extent[1];
    }
    function $2377552e030bbd2b$export$a3295358bff77e(val, extent) {
        if (extent[1] === extent[0]) return 0.5;
        return (val - extent[0]) / (extent[1] - extent[0]);
    }
    function $2377552e030bbd2b$export$dcdf75081b88279d(val, extent) {
        return val * (extent[1] - extent[0]) + extent[0];
    }
});
parcelRegister("6kObD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49cb8a61b3174199$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jmSNG;
    var $dCJrM;
    var $fEgWg;
    var $32MHg;
    var $49cb8a61b3174199$var$roundNumber = (0, parcelRequire("jmSNG")).round;
    var $49cb8a61b3174199$var$IntervalScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(IntervalScale, _super);
        function IntervalScale() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'interval';
            _this._interval = 0;
            _this._intervalPrecision = 2;
            return _this;
        }
        IntervalScale.prototype.parse = function(val) {
            return val;
        };
        IntervalScale.prototype.contain = function(val) {
            return (0, parcelRequire("32MHg")).contain(val, this._extent);
        };
        IntervalScale.prototype.normalize = function(val) {
            return (0, parcelRequire("32MHg")).normalize(val, this._extent);
        };
        IntervalScale.prototype.scale = function(val) {
            return (0, parcelRequire("32MHg")).scale(val, this._extent);
        };
        IntervalScale.prototype.setExtent = function(start, end) {
            var thisExtent = this._extent;
            if (!isNaN(start)) thisExtent[0] = parseFloat(start);
            if (!isNaN(end)) thisExtent[1] = parseFloat(end);
        };
        IntervalScale.prototype.unionExtent = function(other) {
            var extent = this._extent;
            other[0] < extent[0] && (extent[0] = other[0]);
            other[1] > extent[1] && (extent[1] = other[1]);
            this.setExtent(extent[0], extent[1]);
        };
        IntervalScale.prototype.getInterval = function() {
            return this._interval;
        };
        IntervalScale.prototype.setInterval = function(interval) {
            this._interval = interval;
            this._niceExtent = this._extent.slice();
            this._intervalPrecision = (0, parcelRequire("32MHg")).getIntervalPrecision(interval);
        };
        IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
            var interval = this._interval;
            var extent = this._extent;
            var niceTickExtent = this._niceExtent;
            var intervalPrecision = this._intervalPrecision;
            var ticks = [];
            if (!interval) return ticks;
            var safeLimit = 10000;
            if (extent[0] < niceTickExtent[0]) {
                if (expandToNicedExtent) ticks.push({
                    value: $49cb8a61b3174199$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
                });
                else ticks.push({
                    value: extent[0]
                });
            }
            var tick = niceTickExtent[0];
            while(tick <= niceTickExtent[1]){
                ticks.push({
                    value: tick
                });
                tick = $49cb8a61b3174199$var$roundNumber(tick + interval, intervalPrecision);
                if (tick === ticks[ticks.length - 1].value) break;
                if (ticks.length > safeLimit) return [];
            }
            var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
            if (extent[1] > lastNiceTick) {
                if (expandToNicedExtent) ticks.push({
                    value: $49cb8a61b3174199$var$roundNumber(lastNiceTick + interval, intervalPrecision)
                });
                else ticks.push({
                    value: extent[1]
                });
            }
            return ticks;
        };
        IntervalScale.prototype.getMinorTicks = function(splitNumber) {
            var ticks = this.getTicks(true);
            var minorTicks = [];
            var extent = this.getExtent();
            for(var i = 1; i < ticks.length; i++){
                var nextTick = ticks[i];
                var prevTick = ticks[i - 1];
                var count = 0;
                var minorTicksGroup = [];
                var interval = nextTick.value - prevTick.value;
                var minorInterval = interval / splitNumber;
                while(count < splitNumber - 1){
                    var minorTick = $49cb8a61b3174199$var$roundNumber(prevTick.value + (count + 1) * minorInterval);
                    if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                    count++;
                }
                minorTicks.push(minorTicksGroup);
            }
            return minorTicks;
        };
        IntervalScale.prototype.getLabel = function(data, opt) {
            if (data == null) return '';
            var precision = opt && opt.precision;
            if (precision == null) precision = (0, parcelRequire("jmSNG")).getPrecision(data.value) || 0;
            else if (precision === 'auto') precision = this._intervalPrecision;
            var dataNum = $49cb8a61b3174199$var$roundNumber(data.value, precision, true);
            return (0, parcelRequire("dCJrM")).addCommas(dataNum);
        };
        IntervalScale.prototype.niceTicks = function(splitNumber, minInterval, maxInterval) {
            splitNumber = splitNumber || 5;
            var extent = this._extent;
            var span = extent[1] - extent[0];
            if (!isFinite(span)) return;
            if (span < 0) {
                span = -span;
                extent.reverse();
            }
            var result = (0, parcelRequire("32MHg")).intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
            this._intervalPrecision = result.intervalPrecision;
            this._interval = result.interval;
            this._niceExtent = result.niceTickExtent;
        };
        IntervalScale.prototype.niceExtent = function(opt) {
            var extent = this._extent;
            if (extent[0] === extent[1]) {
                if (extent[0] !== 0) {
                    var expandSize = extent[0];
                    if (!opt.fixMax) {
                        extent[1] += expandSize / 2;
                        extent[0] -= expandSize / 2;
                    } else extent[0] -= expandSize / 2;
                } else extent[1] = 1;
            }
            var span = extent[1] - extent[0];
            if (!isFinite(span)) {
                extent[0] = 0;
                extent[1] = 1;
            }
            this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
            var interval = this._interval;
            if (!opt.fixMin) extent[0] = $49cb8a61b3174199$var$roundNumber(Math.floor(extent[0] / interval) * interval);
            if (!opt.fixMax) extent[1] = $49cb8a61b3174199$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
        };
        IntervalScale.type = 'interval';
        return IntervalScale;
    }((0, (0, parcelRequire("fEgWg")).default));
    (0, (0, parcelRequire("fEgWg")).default).registerClass($49cb8a61b3174199$var$IntervalScale);
    var $49cb8a61b3174199$export$2e2bcd8739ae039 = $49cb8a61b3174199$var$IntervalScale;
});
parcelRegister("eL4bi", function(module, exports) {
    $parcel$export(module.exports, "getLayoutOnAxis", ()=>$abe8b2c5f70c8df4$export$658df087977b9e84);
    $parcel$export(module.exports, "prepareLayoutBarSeries", ()=>$abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4);
    $parcel$export(module.exports, "makeColumnLayout", ()=>$abe8b2c5f70c8df4$export$20769dafc84e0299);
    $parcel$export(module.exports, "retrieveColumnLayout", ()=>$abe8b2c5f70c8df4$export$35920bb6556da1c2);
    $parcel$export(module.exports, "layout", ()=>$abe8b2c5f70c8df4$export$b3219800bda33a1f);
    $parcel$export(module.exports, "largeLayout", ()=>$abe8b2c5f70c8df4$export$1fcd87ee6628f095);
    var $bahqM;
    var $jmSNG;
    var $5R8Hi;
    var $9irlK;
    var $abe8b2c5f70c8df4$var$STACK_PREFIX = '__ec_stack_';
    var $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH = 0.5;
    var $abe8b2c5f70c8df4$var$LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
    function $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel) {
        return seriesModel.get('stack') || $abe8b2c5f70c8df4$var$STACK_PREFIX + seriesModel.seriesIndex;
    }
    function $abe8b2c5f70c8df4$var$getAxisKey(axis) {
        return axis.dim + axis.index;
    }
    function $abe8b2c5f70c8df4$export$658df087977b9e84(opt) {
        var params = [];
        var baseAxis = opt.axis;
        var axisKey = 'axis0';
        if (baseAxis.type !== 'category') return;
        var bandWidth = baseAxis.getBandWidth();
        for(var i = 0; i < opt.count || 0; i++)params.push((0, parcelRequire("bahqM")).defaults({
            bandWidth: bandWidth,
            axisKey: axisKey,
            stackId: $abe8b2c5f70c8df4$var$STACK_PREFIX + i
        }, opt));
        var widthAndOffsets = $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(params);
        var result = [];
        for(var i = 0; i < opt.count; i++){
            var item = widthAndOffsets[axisKey][$abe8b2c5f70c8df4$var$STACK_PREFIX + i];
            item.offsetCenter = item.offset + item.width / 2;
            result.push(item);
        }
        return result;
    }
    function $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
        var seriesModels = [];
        ecModel.eachSeriesByType(seriesType, function(seriesModel) {
            if ($abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) && !$abe8b2c5f70c8df4$var$isInLargeMode(seriesModel)) seriesModels.push(seriesModel);
        });
        return seriesModels;
    }
    function $abe8b2c5f70c8df4$var$getValueAxesMinGaps(barSeries) {
        var axisValues = {};
        (0, parcelRequire("bahqM")).each(barSeries, function(seriesModel) {
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
            var data = seriesModel.getData();
            var key = baseAxis.dim + '_' + baseAxis.index;
            var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var store = data.getStore();
            for(var i = 0, cnt = store.count(); i < cnt; ++i){
                var value = store.get(dimIdx, i);
                if (!axisValues[key]) axisValues[key] = [
                    value
                ];
                else axisValues[key].push(value);
            }
        });
        var axisMinGaps = {};
        for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
            var valuesInAxis = axisValues[key];
            if (valuesInAxis) {
                valuesInAxis.sort(function(a, b) {
                    return a - b;
                });
                var min = null;
                for(var j = 1; j < valuesInAxis.length; ++j){
                    var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                    if (delta > 0) min = min === null ? delta : Math.min(min, delta);
                }
                axisMinGaps[key] = min;
            }
        }
        return axisMinGaps;
    }
    function $abe8b2c5f70c8df4$export$20769dafc84e0299(barSeries) {
        var axisMinGaps = $abe8b2c5f70c8df4$var$getValueAxesMinGaps(barSeries);
        var seriesInfoList = [];
        (0, parcelRequire("bahqM")).each(barSeries, function(seriesModel) {
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var axisExtent = baseAxis.getExtent();
            var bandWidth;
            if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
            else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
                var key = baseAxis.dim + '_' + baseAxis.index;
                var minGap = axisMinGaps[key];
                var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
                var scale = baseAxis.scale.getExtent();
                var scaleSpan = Math.abs(scale[1] - scale[0]);
                bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan;
            } else {
                var data = seriesModel.getData();
                bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
            }
            var barWidth = (0, (0, parcelRequire("jmSNG")).parsePercent)(seriesModel.get('barWidth'), bandWidth);
            var barMaxWidth = (0, (0, parcelRequire("jmSNG")).parsePercent)(seriesModel.get('barMaxWidth'), bandWidth);
            var barMinWidth = (0, (0, parcelRequire("jmSNG")).parsePercent)(seriesModel.get('barMinWidth') || 1, bandWidth);
            var barGap = seriesModel.get('barGap');
            var barCategoryGap = seriesModel.get('barCategoryGap');
            seriesInfoList.push({
                bandWidth: bandWidth,
                barWidth: barWidth,
                barMaxWidth: barMaxWidth,
                barMinWidth: barMinWidth,
                barGap: barGap,
                barCategoryGap: barCategoryGap,
                axisKey: $abe8b2c5f70c8df4$var$getAxisKey(baseAxis),
                stackId: $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel)
            });
        });
        return $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(seriesInfoList);
    }
    function $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(seriesInfoList) {
        var columnsMap = {};
        (0, parcelRequire("bahqM")).each(seriesInfoList, function(seriesInfo, idx) {
            var axisKey = seriesInfo.axisKey;
            var bandWidth = seriesInfo.bandWidth;
            var columnsOnAxis = columnsMap[axisKey] || {
                bandWidth: bandWidth,
                remainedWidth: bandWidth,
                autoWidthCount: 0,
                categoryGap: null,
                gap: '20%',
                stacks: {}
            };
            var stacks = columnsOnAxis.stacks;
            columnsMap[axisKey] = columnsOnAxis;
            var stackId = seriesInfo.stackId;
            if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
            stacks[stackId] = stacks[stackId] || {
                width: 0,
                maxWidth: 0
            };
            var barWidth = seriesInfo.barWidth;
            if (barWidth && !stacks[stackId].width) {
                stacks[stackId].width = barWidth;
                barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
                columnsOnAxis.remainedWidth -= barWidth;
            }
            var barMaxWidth = seriesInfo.barMaxWidth;
            barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
            var barMinWidth = seriesInfo.barMinWidth;
            barMinWidth && (stacks[stackId].minWidth = barMinWidth);
            var barGap = seriesInfo.barGap;
            barGap != null && (columnsOnAxis.gap = barGap);
            var barCategoryGap = seriesInfo.barCategoryGap;
            barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
        });
        var result = {};
        (0, parcelRequire("bahqM")).each(columnsMap, function(columnsOnAxis, coordSysName) {
            result[coordSysName] = {};
            var stacks = columnsOnAxis.stacks;
            var bandWidth = columnsOnAxis.bandWidth;
            var categoryGapPercent = columnsOnAxis.categoryGap;
            if (categoryGapPercent == null) {
                var columnCount = (0, parcelRequire("bahqM")).keys(stacks).length;
                categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
            }
            var categoryGap = (0, (0, parcelRequire("jmSNG")).parsePercent)(categoryGapPercent, bandWidth);
            var barGapPercent = (0, (0, parcelRequire("jmSNG")).parsePercent)(columnsOnAxis.gap, 1);
            var remainedWidth = columnsOnAxis.remainedWidth;
            var autoWidthCount = columnsOnAxis.autoWidthCount;
            var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
            autoWidth = Math.max(autoWidth, 0);
            (0, parcelRequire("bahqM")).each(stacks, function(column) {
                var maxWidth = column.maxWidth;
                var minWidth = column.minWidth;
                if (!column.width) {
                    var finalWidth = autoWidth;
                    if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                    if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                    if (finalWidth !== autoWidth) {
                        column.width = finalWidth;
                        remainedWidth -= finalWidth + barGapPercent * finalWidth;
                        autoWidthCount--;
                    }
                } else {
                    var finalWidth = column.width;
                    if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                    if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            });
            autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
            autoWidth = Math.max(autoWidth, 0);
            var widthSum = 0;
            var lastColumn;
            (0, parcelRequire("bahqM")).each(stacks, function(column, idx) {
                if (!column.width) column.width = autoWidth;
                lastColumn = column;
                widthSum += column.width * (1 + barGapPercent);
            });
            if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
            var offset = -widthSum / 2;
            (0, parcelRequire("bahqM")).each(stacks, function(column, stackId) {
                result[coordSysName][stackId] = result[coordSysName][stackId] || {
                    bandWidth: bandWidth,
                    offset: offset,
                    width: column.width
                };
                offset += column.width * (1 + barGapPercent);
            });
        });
        return result;
    }
    function $abe8b2c5f70c8df4$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
        if (barWidthAndOffset && axis) {
            var result = barWidthAndOffset[$abe8b2c5f70c8df4$var$getAxisKey(axis)];
            if (result != null && seriesModel != null) return result[$abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel)];
            return result;
        }
    }
    function $abe8b2c5f70c8df4$export$b3219800bda33a1f(seriesType, ecModel) {
        var seriesModels = $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
        var barWidthAndOffset = $abe8b2c5f70c8df4$export$20769dafc84e0299(seriesModels);
        var lastStackCoords = {};
        (0, parcelRequire("bahqM")).each(seriesModels, function(seriesModel) {
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var stackId = $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel);
            var columnLayoutInfo = barWidthAndOffset[$abe8b2c5f70c8df4$var$getAxisKey(baseAxis)][stackId];
            var columnOffset = columnLayoutInfo.offset;
            var columnWidth = columnLayoutInfo.width;
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var barMinHeight = seriesModel.get('barMinHeight') || 0;
            lastStackCoords[stackId] = lastStackCoords[stackId] || [];
            data.setLayout({
                bandWidth: columnLayoutInfo.bandWidth,
                offset: columnOffset,
                size: columnWidth
            });
            var valueDim = data.mapDimension(valueAxis.dim);
            var baseDim = data.mapDimension(baseAxis.dim);
            var stacked = (0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, valueDim);
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, stacked);
            var store = data.getStore();
            var valueDimIdx = data.getDimensionIndex(valueDim);
            var baseDimIdx = data.getDimensionIndex(baseDim);
            for(var idx = 0, len = store.count(); idx < len; idx++){
                var value = store.get(valueDimIdx, idx);
                var baseValue = store.get(baseDimIdx, idx);
                var sign = value >= 0 ? 'p' : 'n';
                var baseCoord = valueAxisStart;
                if (stacked) {
                    if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                        p: valueAxisStart,
                        n: valueAxisStart
                    };
                    baseCoord = lastStackCoords[stackId][baseValue][sign];
                }
                var x = void 0;
                var y = void 0;
                var width = void 0;
                var height = void 0;
                if (isValueAxisH) {
                    var coord = cartesian.dataToPoint([
                        value,
                        baseValue
                    ]);
                    x = baseCoord;
                    y = coord[1] + columnOffset;
                    width = coord[0] - valueAxisStart;
                    height = columnWidth;
                    if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                    if (!isNaN(width)) stacked && (lastStackCoords[stackId][baseValue][sign] += width);
                } else {
                    var coord = cartesian.dataToPoint([
                        baseValue,
                        value
                    ]);
                    x = coord[0] + columnOffset;
                    y = baseCoord;
                    width = columnWidth;
                    height = coord[1] - valueAxisStart;
                    if (Math.abs(height) < barMinHeight) height = (height <= 0 ? -1 : 1) * barMinHeight;
                    if (!isNaN(height)) stacked && (lastStackCoords[stackId][baseValue][sign] += height);
                }
                data.setItemLayout(idx, {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        });
    }
    var $abe8b2c5f70c8df4$export$1fcd87ee6628f095 = {
        seriesType: 'bar',
        plan: (0, (0, parcelRequire("9irlK")).default)(),
        reset: function(seriesModel) {
            if (!$abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) || !$abe8b2c5f70c8df4$var$isInLargeMode(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var coordLayout = cartesian.master.getRect();
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimI = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimI = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var valueAxisHorizontal = valueAxis.isHorizontal();
            var valueDimIdx = valueAxisHorizontal ? 0 : 1;
            var barWidth = $abe8b2c5f70c8df4$export$35920bb6556da1c2($abe8b2c5f70c8df4$export$20769dafc84e0299([
                seriesModel
            ]), baseAxis, seriesModel).width;
            if (!(barWidth > $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH)) barWidth = $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH;
            return {
                progress: function(params, data) {
                    var count = params.count;
                    var largePoints = new $abe8b2c5f70c8df4$var$LargeArr(count * 2);
                    var largeBackgroundPoints = new $abe8b2c5f70c8df4$var$LargeArr(count * 2);
                    var largeDataIndices = new $abe8b2c5f70c8df4$var$LargeArr(count);
                    var dataIndex;
                    var coord = [];
                    var valuePair = [];
                    var pointsOffset = 0;
                    var idxOffset = 0;
                    var store = data.getStore();
                    while((dataIndex = params.next()) != null){
                        valuePair[valueDimIdx] = store.get(valueDimI, dataIndex);
                        valuePair[1 - valueDimIdx] = store.get(baseDimI, dataIndex);
                        coord = cartesian.dataToPoint(valuePair, null);
                        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
                        largePoints[pointsOffset++] = coord[0];
                        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
                        largePoints[pointsOffset++] = coord[1];
                        largeDataIndices[idxOffset++] = dataIndex;
                    }
                    data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        barWidth: barWidth,
                        valueAxisStart: $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, false),
                        backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
                        valueAxisHorizontal: valueAxisHorizontal
                    });
                }
            };
        }
    };
    function $abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) {
        return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
    }
    function $abe8b2c5f70c8df4$var$isInLargeMode(seriesModel) {
        return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
    }
    function $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, stacked) {
        return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
    }
});
parcelRegister("1MU9l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14d5d447dd592e99$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jmSNG;
    var $bc1Ad;
    var $32MHg;
    var $6kObD;
    var $fEgWg;
    var $bahqM;
    var $14d5d447dd592e99$var$bisect = function(a, x, lo, hi) {
        while(lo < hi){
            var mid = lo + hi >>> 1;
            if (a[mid][1] < x) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    };
    var $14d5d447dd592e99$var$TimeScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(TimeScale, _super);
        function TimeScale(settings) {
            var _this = _super.call(this, settings) || this;
            _this.type = 'time';
            return _this;
        }
        TimeScale.prototype.getLabel = function(tick) {
            var useUTC = this.getSetting('useUTC');
            return (0, (0, parcelRequire("bc1Ad")).format)(tick.value, (0, (0, parcelRequire("bc1Ad")).fullLeveledFormatter)[(0, (0, parcelRequire("bc1Ad")).getDefaultFormatPrecisionOfInterval)((0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(this._minLevelUnit))] || (0, (0, parcelRequire("bc1Ad")).fullLeveledFormatter).second, useUTC, this.getSetting('locale'));
        };
        TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
            var isUTC = this.getSetting('useUTC');
            var lang = this.getSetting('locale');
            return (0, (0, parcelRequire("bc1Ad")).leveledFormat)(tick, idx, labelFormatter, lang, isUTC);
        };
        TimeScale.prototype.getTicks = function(expandToNicedExtent) {
            var interval = this._interval;
            var extent = this._extent;
            var ticks = [];
            if (!interval) return ticks;
            ticks.push({
                value: extent[0],
                level: 0
            });
            var useUTC = this.getSetting('useUTC');
            var innerTicks = $14d5d447dd592e99$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
            ticks = ticks.concat(innerTicks);
            ticks.push({
                value: extent[1],
                level: 0
            });
            return ticks;
        };
        TimeScale.prototype.niceExtent = function(opt) {
            var extent = this._extent;
            if (extent[0] === extent[1]) {
                extent[0] -= (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
                extent[1] += (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
            }
            if (extent[1] === -Infinity && extent[0] === Infinity) {
                var d = new Date();
                extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
                extent[0] = extent[1] - (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
            }
            this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
        };
        TimeScale.prototype.niceTicks = function(approxTickNum, minInterval, maxInterval) {
            approxTickNum = approxTickNum || 10;
            var extent = this._extent;
            var span = extent[1] - extent[0];
            this._approxInterval = span / approxTickNum;
            if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
            if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
            var scaleIntervalsLen = $14d5d447dd592e99$var$scaleIntervals.length;
            var idx = Math.min($14d5d447dd592e99$var$bisect($14d5d447dd592e99$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
            this._interval = $14d5d447dd592e99$var$scaleIntervals[idx][1];
            this._minLevelUnit = $14d5d447dd592e99$var$scaleIntervals[Math.max(idx - 1, 0)][0];
        };
        TimeScale.prototype.parse = function(val) {
            return typeof val === 'number' ? val : +(0, parcelRequire("jmSNG")).parseDate(val);
        };
        TimeScale.prototype.contain = function(val) {
            return (0, parcelRequire("32MHg")).contain(this.parse(val), this._extent);
        };
        TimeScale.prototype.normalize = function(val) {
            return (0, parcelRequire("32MHg")).normalize(this.parse(val), this._extent);
        };
        TimeScale.prototype.scale = function(val) {
            return (0, parcelRequire("32MHg")).scale(val, this._extent);
        };
        TimeScale.type = 'time';
        return TimeScale;
    }((0, (0, parcelRequire("6kObD")).default));
    var $14d5d447dd592e99$var$scaleIntervals = [
        [
            'second',
            (0, (0, parcelRequire("bc1Ad")).ONE_SECOND)
        ],
        [
            'minute',
            (0, (0, parcelRequire("bc1Ad")).ONE_MINUTE)
        ],
        [
            'hour',
            (0, (0, parcelRequire("bc1Ad")).ONE_HOUR)
        ],
        [
            'quarter-day',
            (0, (0, parcelRequire("bc1Ad")).ONE_HOUR) * 6
        ],
        [
            'half-day',
            (0, (0, parcelRequire("bc1Ad")).ONE_HOUR) * 12
        ],
        [
            'day',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 1.2
        ],
        [
            'half-week',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 3.5
        ],
        [
            'week',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 7
        ],
        [
            'month',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 31
        ],
        [
            'quarter',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 95
        ],
        [
            'half-year',
            (0, (0, parcelRequire("bc1Ad")).ONE_YEAR) / 2
        ],
        [
            'year',
            (0, (0, parcelRequire("bc1Ad")).ONE_YEAR)
        ]
    ];
    function $14d5d447dd592e99$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
        var dateA = (0, parcelRequire("jmSNG")).parseDate(valueA);
        var dateB = (0, parcelRequire("jmSNG")).parseDate(valueB);
        var isSame = function(unit) {
            return (0, (0, parcelRequire("bc1Ad")).getUnitValue)(dateA, unit, isUTC) === (0, (0, parcelRequire("bc1Ad")).getUnitValue)(dateB, unit, isUTC);
        };
        var isSameYear = function() {
            return isSame('year');
        };
        var isSameMonth = function() {
            return isSameYear() && isSame('month');
        };
        var isSameDay = function() {
            return isSameMonth() && isSame('day');
        };
        var isSameHour = function() {
            return isSameDay() && isSame('hour');
        };
        var isSameMinute = function() {
            return isSameHour() && isSame('minute');
        };
        var isSameSecond = function() {
            return isSameMinute() && isSame('second');
        };
        var isSameMilliSecond = function() {
            return isSameSecond() && isSame('millisecond');
        };
        switch(unit){
            case 'year':
                return isSameYear();
            case 'month':
                return isSameMonth();
            case 'day':
                return isSameDay();
            case 'hour':
                return isSameHour();
            case 'minute':
                return isSameMinute();
            case 'second':
                return isSameSecond();
            case 'millisecond':
                return isSameMilliSecond();
        }
    }
    function $14d5d447dd592e99$var$getDateInterval(approxInterval, daysInMonth) {
        approxInterval /= (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
        return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getMonthInterval(approxInterval) {
        var APPROX_ONE_MONTH = 30 * (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
        approxInterval /= APPROX_ONE_MONTH;
        return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getHourInterval(approxInterval) {
        approxInterval /= (0, (0, parcelRequire("bc1Ad")).ONE_HOUR);
        return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
        approxInterval /= isMinutes ? (0, (0, parcelRequire("bc1Ad")).ONE_MINUTE) : (0, (0, parcelRequire("bc1Ad")).ONE_SECOND);
        return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getMillisecondsInterval(approxInterval) {
        return (0, parcelRequire("jmSNG")).nice(approxInterval, true);
    }
    function $14d5d447dd592e99$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
        var outDate = new Date(date);
        switch((0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitName)){
            case 'year':
            case 'month':
                outDate[(0, (0, parcelRequire("bc1Ad")).monthSetterName)(isUTC)](0);
            case 'day':
                outDate[(0, (0, parcelRequire("bc1Ad")).dateSetterName)(isUTC)](1);
            case 'hour':
                outDate[(0, (0, parcelRequire("bc1Ad")).hoursSetterName)(isUTC)](0);
            case 'minute':
                outDate[(0, (0, parcelRequire("bc1Ad")).minutesSetterName)(isUTC)](0);
            case 'second':
                outDate[(0, (0, parcelRequire("bc1Ad")).secondsSetterName)(isUTC)](0);
                outDate[(0, (0, parcelRequire("bc1Ad")).millisecondsSetterName)(isUTC)](0);
        }
        return outDate.getTime();
    }
    function $14d5d447dd592e99$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
        var safeLimit = 10000;
        var unitNames = (0, (0, parcelRequire("bc1Ad")).timeUnits);
        var iter = 0;
        function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
            var date = new Date(minTimestamp);
            var dateTime = minTimestamp;
            var d = date[getMethodName]();
            while(dateTime < maxTimestamp && dateTime <= extent[1]){
                out.push({
                    value: dateTime
                });
                d += interval;
                date[setMethodName](d);
                dateTime = date.getTime();
            }
            out.push({
                value: dateTime,
                notAdd: true
            });
        }
        function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
            var newAddedTicks = [];
            var isFirstLevel = !lastLevelTicks.length;
            if ($14d5d447dd592e99$var$isUnitValueSame((0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitName), extent[0], extent[1], isUTC)) return;
            if (isFirstLevel) lastLevelTicks = [
                {
                    value: $14d5d447dd592e99$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
                },
                {
                    value: extent[1]
                }
            ];
            for(var i = 0; i < lastLevelTicks.length - 1; i++){
                var startTick = lastLevelTicks[i].value;
                var endTick = lastLevelTicks[i + 1].value;
                if (startTick === endTick) continue;
                var interval = void 0;
                var getterName = void 0;
                var setterName = void 0;
                var isDate = false;
                switch(unitName){
                    case 'year':
                        interval = Math.max(1, Math.round(approxInterval / (0, (0, parcelRequire("bc1Ad")).ONE_DAY) / 365));
                        getterName = (0, (0, parcelRequire("bc1Ad")).fullYearGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).fullYearSetterName)(isUTC);
                        break;
                    case 'half-year':
                    case 'quarter':
                    case 'month':
                        interval = $14d5d447dd592e99$var$getMonthInterval(approxInterval);
                        getterName = (0, (0, parcelRequire("bc1Ad")).monthGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).monthSetterName)(isUTC);
                        break;
                    case 'week':
                    case 'half-week':
                    case 'day':
                        interval = $14d5d447dd592e99$var$getDateInterval(approxInterval, 31);
                        getterName = (0, (0, parcelRequire("bc1Ad")).dateGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).dateSetterName)(isUTC);
                        isDate = true;
                        break;
                    case 'half-day':
                    case 'quarter-day':
                    case 'hour':
                        interval = $14d5d447dd592e99$var$getHourInterval(approxInterval);
                        getterName = (0, (0, parcelRequire("bc1Ad")).hoursGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).hoursSetterName)(isUTC);
                        break;
                    case 'minute':
                        interval = $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, true);
                        getterName = (0, (0, parcelRequire("bc1Ad")).minutesGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).minutesSetterName)(isUTC);
                        break;
                    case 'second':
                        interval = $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, false);
                        getterName = (0, (0, parcelRequire("bc1Ad")).secondsGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).secondsSetterName)(isUTC);
                        break;
                    case 'millisecond':
                        interval = $14d5d447dd592e99$var$getMillisecondsInterval(approxInterval);
                        getterName = (0, (0, parcelRequire("bc1Ad")).millisecondsGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).millisecondsSetterName)(isUTC);
                        break;
                }
                addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
                if (unitName === 'year' && levelTicks.length > 1 && i === 0) levelTicks.unshift({
                    value: levelTicks[0].value - interval
                });
            }
            for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
            return newAddedTicks;
        }
        var levelsTicks = [];
        var currentLevelTicks = [];
        var tickCount = 0;
        var lastLevelTickCount = 0;
        for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
            var primaryTimeUnit = (0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitNames[i]);
            if (!(0, (0, parcelRequire("bc1Ad")).isPrimaryTimeUnit)(unitNames[i])) continue;
            addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
            var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitNames[i + 1]) : null;
            if (primaryTimeUnit !== nextPrimaryTimeUnit) {
                if (currentLevelTicks.length) {
                    lastLevelTickCount = tickCount;
                    currentLevelTicks.sort(function(a, b) {
                        return a.value - b.value;
                    });
                    var levelTicksRemoveDuplicated = [];
                    for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                        var tickValue = currentLevelTicks[i_1].value;
                        if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                            levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                            if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                        }
                    }
                    var targetTickNum = (extent[1] - extent[0]) / approxInterval;
                    if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                    levelsTicks.push(levelTicksRemoveDuplicated);
                    if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
                }
                currentLevelTicks = [];
            }
        }
        var levelsTicksInExtent = (0, (0, parcelRequire("bahqM")).filter)((0, (0, parcelRequire("bahqM")).map)(levelsTicks, function(levelTicks) {
            return (0, (0, parcelRequire("bahqM")).filter)(levelTicks, function(tick) {
                return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
            });
        }), function(levelTicks) {
            return levelTicks.length > 0;
        });
        var ticks = [];
        var maxLevel = levelsTicksInExtent.length - 1;
        for(var i = 0; i < levelsTicksInExtent.length; ++i){
            var levelTicks = levelsTicksInExtent[i];
            for(var k = 0; k < levelTicks.length; ++k)ticks.push({
                value: levelTicks[k].value,
                level: maxLevel - i
            });
        }
        ticks.sort(function(a, b) {
            return a.value - b.value;
        });
        var result = [];
        for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
        return result;
    }
    (0, (0, parcelRequire("fEgWg")).default).registerClass($14d5d447dd592e99$var$TimeScale);
    var $14d5d447dd592e99$export$2e2bcd8739ae039 = $14d5d447dd592e99$var$TimeScale;
});
parcelRegister("73kgw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5228888966b0d10c$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $fEgWg;
    var $jmSNG;
    var $32MHg;
    var $6kObD;
    var $5228888966b0d10c$var$scaleProto = (0, (0, parcelRequire("fEgWg")).default).prototype;
    var $5228888966b0d10c$var$intervalScaleProto = (0, (0, parcelRequire("6kObD")).default).prototype;
    var $5228888966b0d10c$var$roundingErrorFix = (0, parcelRequire("jmSNG")).round;
    var $5228888966b0d10c$var$mathFloor = Math.floor;
    var $5228888966b0d10c$var$mathCeil = Math.ceil;
    var $5228888966b0d10c$var$mathPow = Math.pow;
    var $5228888966b0d10c$var$mathLog = Math.log;
    var $5228888966b0d10c$var$LogScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LogScale, _super);
        function LogScale() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'log';
            _this.base = 10;
            _this._originalScale = new (0, (0, parcelRequire("6kObD")).default)();
            _this._interval = 0;
            return _this;
        }
        LogScale.prototype.getTicks = function(expandToNicedExtent) {
            var originalScale = this._originalScale;
            var extent = this._extent;
            var originalExtent = originalScale.getExtent();
            var ticks = $5228888966b0d10c$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
            return (0, parcelRequire("bahqM")).map(ticks, function(tick) {
                var val = tick.value;
                var powVal = (0, parcelRequire("jmSNG")).round($5228888966b0d10c$var$mathPow(this.base, val));
                powVal = val === extent[0] && this._fixMin ? $5228888966b0d10c$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
                powVal = val === extent[1] && this._fixMax ? $5228888966b0d10c$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
                return {
                    value: powVal
                };
            }, this);
        };
        LogScale.prototype.setExtent = function(start, end) {
            var base = this.base;
            start = $5228888966b0d10c$var$mathLog(start) / $5228888966b0d10c$var$mathLog(base);
            end = $5228888966b0d10c$var$mathLog(end) / $5228888966b0d10c$var$mathLog(base);
            $5228888966b0d10c$var$intervalScaleProto.setExtent.call(this, start, end);
        };
        LogScale.prototype.getExtent = function() {
            var base = this.base;
            var extent = $5228888966b0d10c$var$scaleProto.getExtent.call(this);
            extent[0] = $5228888966b0d10c$var$mathPow(base, extent[0]);
            extent[1] = $5228888966b0d10c$var$mathPow(base, extent[1]);
            var originalScale = this._originalScale;
            var originalExtent = originalScale.getExtent();
            this._fixMin && (extent[0] = $5228888966b0d10c$var$fixRoundingError(extent[0], originalExtent[0]));
            this._fixMax && (extent[1] = $5228888966b0d10c$var$fixRoundingError(extent[1], originalExtent[1]));
            return extent;
        };
        LogScale.prototype.unionExtent = function(extent) {
            this._originalScale.unionExtent(extent);
            var base = this.base;
            extent[0] = $5228888966b0d10c$var$mathLog(extent[0]) / $5228888966b0d10c$var$mathLog(base);
            extent[1] = $5228888966b0d10c$var$mathLog(extent[1]) / $5228888966b0d10c$var$mathLog(base);
            $5228888966b0d10c$var$scaleProto.unionExtent.call(this, extent);
        };
        LogScale.prototype.unionExtentFromData = function(data, dim) {
            this.unionExtent(data.getApproximateExtent(dim));
        };
        LogScale.prototype.niceTicks = function(approxTickNum) {
            approxTickNum = approxTickNum || 10;
            var extent = this._extent;
            var span = extent[1] - extent[0];
            if (span === Infinity || span <= 0) return;
            var interval = (0, parcelRequire("jmSNG")).quantity(span);
            var err = approxTickNum / span * interval;
            if (err <= 0.5) interval *= 10;
            while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
            var niceExtent = [
                (0, parcelRequire("jmSNG")).round($5228888966b0d10c$var$mathCeil(extent[0] / interval) * interval),
                (0, parcelRequire("jmSNG")).round($5228888966b0d10c$var$mathFloor(extent[1] / interval) * interval)
            ];
            this._interval = interval;
            this._niceExtent = niceExtent;
        };
        LogScale.prototype.niceExtent = function(opt) {
            $5228888966b0d10c$var$intervalScaleProto.niceExtent.call(this, opt);
            this._fixMin = opt.fixMin;
            this._fixMax = opt.fixMax;
        };
        LogScale.prototype.parse = function(val) {
            return val;
        };
        LogScale.prototype.contain = function(val) {
            val = $5228888966b0d10c$var$mathLog(val) / $5228888966b0d10c$var$mathLog(this.base);
            return (0, parcelRequire("32MHg")).contain(val, this._extent);
        };
        LogScale.prototype.normalize = function(val) {
            val = $5228888966b0d10c$var$mathLog(val) / $5228888966b0d10c$var$mathLog(this.base);
            return (0, parcelRequire("32MHg")).normalize(val, this._extent);
        };
        LogScale.prototype.scale = function(val) {
            val = (0, parcelRequire("32MHg")).scale(val, this._extent);
            return $5228888966b0d10c$var$mathPow(this.base, val);
        };
        LogScale.type = 'log';
        return LogScale;
    }((0, (0, parcelRequire("fEgWg")).default));
    var $5228888966b0d10c$var$proto = $5228888966b0d10c$var$LogScale.prototype;
    $5228888966b0d10c$var$proto.getMinorTicks = $5228888966b0d10c$var$intervalScaleProto.getMinorTicks;
    $5228888966b0d10c$var$proto.getLabel = $5228888966b0d10c$var$intervalScaleProto.getLabel;
    function $5228888966b0d10c$var$fixRoundingError(val, originalVal) {
        return $5228888966b0d10c$var$roundingErrorFix(val, (0, parcelRequire("jmSNG")).getPrecision(originalVal));
    }
    (0, (0, parcelRequire("fEgWg")).default).registerClass($5228888966b0d10c$var$LogScale);
    var $5228888966b0d10c$export$2e2bcd8739ae039 = $5228888966b0d10c$var$LogScale;
});
parcelRegister("lo2Vo", function(module, exports) {
    $parcel$export(module.exports, "parseAxisModelMinMax", ()=>$f91e1bac53937426$export$d02f2e65dfc3c2b);
    $parcel$export(module.exports, "ensureScaleRawExtentInfo", ()=>$f91e1bac53937426$export$5c3dbcbeb9ce7f5a);
    var $bahqM;
    var $b7ZX8;
    var $f91e1bac53937426$export$c35454f678e99c82 = function() {
        function ScaleRawExtentInfo(scale, model, originalExtent) {
            this._prepareParams(scale, model, originalExtent);
        }
        ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, dataExtent) {
            if (dataExtent[1] < dataExtent[0]) dataExtent = [
                NaN,
                NaN
            ];
            this._dataMin = dataExtent[0];
            this._dataMax = dataExtent[1];
            var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
            this._needCrossZero = model.getNeedCrossZero && model.getNeedCrossZero();
            var modelMinRaw = this._modelMinRaw = model.get('min', true);
            if ((0, (0, parcelRequire("bahqM")).isFunction)(modelMinRaw)) this._modelMinNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMinRaw({
                min: dataExtent[0],
                max: dataExtent[1]
            }));
            else if (modelMinRaw !== 'dataMin') this._modelMinNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMinRaw);
            var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
            if ((0, (0, parcelRequire("bahqM")).isFunction)(modelMaxRaw)) this._modelMaxNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
                min: dataExtent[0],
                max: dataExtent[1]
            }));
            else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
            if (isOrdinal) this._axisDataLen = model.getCategories().length;
            else {
                var boundaryGap = model.get('boundaryGap');
                var boundaryGapArr = (0, (0, parcelRequire("bahqM")).isArray)(boundaryGap) ? boundaryGap : [
                    boundaryGap || 0,
                    boundaryGap || 0
                ];
                if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                    0,
                    0
                ];
                else this._boundaryGapInner = [
                    (0, (0, parcelRequire("b7ZX8")).parsePercent)(boundaryGapArr[0], 1),
                    (0, (0, parcelRequire("b7ZX8")).parsePercent)(boundaryGapArr[1], 1)
                ];
            }
        };
        ScaleRawExtentInfo.prototype.calculate = function() {
            var isOrdinal = this._isOrdinal;
            var dataMin = this._dataMin;
            var dataMax = this._dataMax;
            var axisDataLen = this._axisDataLen;
            var boundaryGapInner = this._boundaryGapInner;
            var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null;
            var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
            var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum;
            var minFixed = min != null;
            var maxFixed = max != null;
            if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
            if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
            (min == null || !isFinite(min)) && (min = NaN);
            (max == null || !isFinite(max)) && (max = NaN);
            if (min > max) {
                min = NaN;
                max = NaN;
            }
            var isBlank = (0, (0, parcelRequire("bahqM")).eqNaN)(min) || (0, (0, parcelRequire("bahqM")).eqNaN)(max) || isOrdinal && !axisDataLen;
            if (this._needCrossZero) {
                if (min > 0 && max > 0 && !minFixed) min = 0;
                if (min < 0 && max < 0 && !maxFixed) max = 0;
            }
            var determinedMin = this._determinedMin;
            var determinedMax = this._determinedMax;
            if (determinedMin != null) {
                min = determinedMin;
                minFixed = true;
            }
            if (determinedMax != null) {
                max = determinedMax;
                maxFixed = true;
            }
            return {
                min: min,
                max: max,
                minFixed: minFixed,
                maxFixed: maxFixed,
                isBlank: isBlank
            };
        };
        ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
            this[$f91e1bac53937426$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
        };
        ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
            var attr = $f91e1bac53937426$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
            this[attr] = val;
        };
        ScaleRawExtentInfo.prototype.freeze = function() {
            this.frozen = true;
        };
        return ScaleRawExtentInfo;
    }();
    var $f91e1bac53937426$var$DETERMINED_MIN_MAX_ATTR = {
        min: '_determinedMin',
        max: '_determinedMax'
    };
    var $f91e1bac53937426$var$DATA_MIN_MAX_ATTR = {
        min: '_dataMin',
        max: '_dataMax'
    };
    function $f91e1bac53937426$export$5c3dbcbeb9ce7f5a(scale, model, originalExtent) {
        var rawExtentInfo = scale.rawExtentInfo;
        if (rawExtentInfo) return rawExtentInfo;
        rawExtentInfo = new $f91e1bac53937426$export$c35454f678e99c82(scale, model, originalExtent);
        scale.rawExtentInfo = rawExtentInfo;
        return rawExtentInfo;
    }
    function $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, minMax) {
        return minMax == null ? null : (0, (0, parcelRequire("bahqM")).eqNaN)(minMax) ? NaN : scale.parse(minMax);
    }
});
parcelRegister("SsPct", function(module, exports) {
    $parcel$export(module.exports, "cartesian2DDimensions", ()=>$0a3b6744500b73ac$export$988a008d2b9120f4);
    $parcel$export(module.exports, "default", ()=>$0a3b6744500b73ac$export$2e2bcd8739ae039);
    var $3VFsf;
    var $1E3E8;
    var $7j9L9;
    var $izqgC;
    var $eLEew;
    var $0a3b6744500b73ac$export$988a008d2b9120f4 = [
        'x',
        'y'
    ];
    function $0a3b6744500b73ac$var$canCalculateAffineTransform(scale) {
        return scale.type === 'interval' || scale.type === 'time';
    }
    var $0a3b6744500b73ac$var$Cartesian2D = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Cartesian2D, _super);
        function Cartesian2D() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'cartesian2d';
            _this.dimensions = $0a3b6744500b73ac$export$988a008d2b9120f4;
            return _this;
        }
        Cartesian2D.prototype.calcAffineTransform = function() {
            this._transform = this._invTransform = null;
            var xAxisScale = this.getAxis('x').scale;
            var yAxisScale = this.getAxis('y').scale;
            if (!$0a3b6744500b73ac$var$canCalculateAffineTransform(xAxisScale) || !$0a3b6744500b73ac$var$canCalculateAffineTransform(yAxisScale)) return;
            var xScaleExtent = xAxisScale.getExtent();
            var yScaleExtent = yAxisScale.getExtent();
            var start = this.dataToPoint([
                xScaleExtent[0],
                yScaleExtent[0]
            ]);
            var end = this.dataToPoint([
                xScaleExtent[1],
                yScaleExtent[1]
            ]);
            var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
            var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
            if (!xScaleSpan || !yScaleSpan) return;
            var scaleX = (end[0] - start[0]) / xScaleSpan;
            var scaleY = (end[1] - start[1]) / yScaleSpan;
            var translateX = start[0] - xScaleExtent[0] * scaleX;
            var translateY = start[1] - yScaleExtent[0] * scaleY;
            var m = this._transform = [
                scaleX,
                0,
                0,
                scaleY,
                translateX,
                translateY
            ];
            this._invTransform = (0, (0, parcelRequire("izqgC")).invert)([], m);
        };
        Cartesian2D.prototype.getBaseAxis = function() {
            return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
        };
        Cartesian2D.prototype.containPoint = function(point) {
            var axisX = this.getAxis('x');
            var axisY = this.getAxis('y');
            return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
        };
        Cartesian2D.prototype.containData = function(data) {
            return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
        };
        Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
            out = out || [];
            var xVal = data[0];
            var yVal = data[1];
            if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, (0, parcelRequire("eLEew")).applyTransform)(out, data, this._transform);
            var xAxis = this.getAxis('x');
            var yAxis = this.getAxis('y');
            out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
            out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
            return out;
        };
        Cartesian2D.prototype.clampData = function(data, out) {
            var xScale = this.getAxis('x').scale;
            var yScale = this.getAxis('y').scale;
            var xAxisExtent = xScale.getExtent();
            var yAxisExtent = yScale.getExtent();
            var x = xScale.parse(data[0]);
            var y = yScale.parse(data[1]);
            out = out || [];
            out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
            out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
            return out;
        };
        Cartesian2D.prototype.pointToData = function(point, clamp) {
            var out = [];
            if (this._invTransform) return (0, (0, parcelRequire("eLEew")).applyTransform)(out, point, this._invTransform);
            var xAxis = this.getAxis('x');
            var yAxis = this.getAxis('y');
            out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
            out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
            return out;
        };
        Cartesian2D.prototype.getOtherAxis = function(axis) {
            return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
        };
        Cartesian2D.prototype.getArea = function() {
            var xExtent = this.getAxis('x').getGlobalExtent();
            var yExtent = this.getAxis('y').getGlobalExtent();
            var x = Math.min(xExtent[0], xExtent[1]);
            var y = Math.min(yExtent[0], yExtent[1]);
            var width = Math.max(xExtent[0], xExtent[1]) - x;
            var height = Math.max(yExtent[0], yExtent[1]) - y;
            return new (0, (0, parcelRequire("1E3E8")).default)(x, y, width, height);
        };
        return Cartesian2D;
    }((0, (0, parcelRequire("7j9L9")).default));
    var $0a3b6744500b73ac$export$2e2bcd8739ae039 = $0a3b6744500b73ac$var$Cartesian2D;
});
parcelRegister("7j9L9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5521e0c9b22643f8$export$2e2bcd8739ae039);
    var $bahqM;
    var $5521e0c9b22643f8$var$Cartesian = function() {
        function Cartesian(name) {
            this.type = 'cartesian';
            this._dimList = [];
            this._axes = {};
            this.name = name || '';
        }
        Cartesian.prototype.getAxis = function(dim) {
            return this._axes[dim];
        };
        Cartesian.prototype.getAxes = function() {
            return (0, parcelRequire("bahqM")).map(this._dimList, function(dim) {
                return this._axes[dim];
            }, this);
        };
        Cartesian.prototype.getAxesByScale = function(scaleType) {
            scaleType = scaleType.toLowerCase();
            return (0, parcelRequire("bahqM")).filter(this.getAxes(), function(axis) {
                return axis.scale.type === scaleType;
            });
        };
        Cartesian.prototype.addAxis = function(axis) {
            var dim = axis.dim;
            this._axes[dim] = axis;
            this._dimList.push(dim);
        };
        return Cartesian;
    }();
    var $5521e0c9b22643f8$export$2e2bcd8739ae039 = $5521e0c9b22643f8$var$Cartesian;
});
parcelRegister("kBKMx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f00b8d3b69958a3f$export$2e2bcd8739ae039);
    var $3VFsf;
    var $g6Gq1;
    var $f00b8d3b69958a3f$var$Axis2D = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Axis2D, _super);
        function Axis2D(dim, scale, coordExtent, axisType, position) {
            var _this = _super.call(this, dim, scale, coordExtent) || this;
            _this.index = 0;
            _this.type = axisType || 'value';
            _this.position = position || 'bottom';
            return _this;
        }
        Axis2D.prototype.isHorizontal = function() {
            var position = this.position;
            return position === 'top' || position === 'bottom';
        };
        Axis2D.prototype.getGlobalExtent = function(asc) {
            var ret = this.getExtent();
            ret[0] = this.toGlobalCoord(ret[0]);
            ret[1] = this.toGlobalCoord(ret[1]);
            asc && ret[0] > ret[1] && ret.reverse();
            return ret;
        };
        Axis2D.prototype.pointToData = function(point, clamp) {
            return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
        };
        Axis2D.prototype.setCategorySortInfo = function(info) {
            if (this.type !== 'category') return false;
            this.model.option.categorySortInfo = info;
            this.scale.setSortInfo(info);
        };
        return Axis2D;
    }((0, (0, parcelRequire("g6Gq1")).default));
    var $f00b8d3b69958a3f$export$2e2bcd8739ae039 = $f00b8d3b69958a3f$var$Axis2D;
});
parcelRegister("g6Gq1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb9e1c59fe00c8ac$export$2e2bcd8739ae039);
    var $bahqM;
    var $jmSNG;
    var $ftAX6;
    var $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT = [
        0,
        1
    ];
    var $bb9e1c59fe00c8ac$var$Axis = function() {
        function Axis(dim, scale, extent) {
            this.onBand = false;
            this.inverse = false;
            this.dim = dim;
            this.scale = scale;
            this._extent = extent || [
                0,
                0
            ];
        }
        Axis.prototype.contain = function(coord) {
            var extent = this._extent;
            var min = Math.min(extent[0], extent[1]);
            var max = Math.max(extent[0], extent[1]);
            return coord >= min && coord <= max;
        };
        Axis.prototype.containData = function(data) {
            return this.scale.contain(data);
        };
        Axis.prototype.getExtent = function() {
            return this._extent.slice();
        };
        Axis.prototype.getPixelPrecision = function(dataExtent) {
            return (0, (0, parcelRequire("jmSNG")).getPixelPrecision)(dataExtent || this.scale.getExtent(), this._extent);
        };
        Axis.prototype.setExtent = function(start, end) {
            var extent = this._extent;
            extent[0] = start;
            extent[1] = end;
        };
        Axis.prototype.dataToCoord = function(data, clamp) {
            var extent = this._extent;
            var scale = this.scale;
            data = scale.normalize(data);
            if (this.onBand && scale.type === 'ordinal') {
                extent = extent.slice();
                $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, scale.count());
            }
            return (0, (0, parcelRequire("jmSNG")).linearMap)(data, $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT, extent, clamp);
        };
        Axis.prototype.coordToData = function(coord, clamp) {
            var extent = this._extent;
            var scale = this.scale;
            if (this.onBand && scale.type === 'ordinal') {
                extent = extent.slice();
                $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, scale.count());
            }
            var t = (0, (0, parcelRequire("jmSNG")).linearMap)(coord, extent, $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT, clamp);
            return this.scale.scale(t);
        };
        Axis.prototype.pointToData = function(point, clamp) {
            return;
        };
        Axis.prototype.getTicksCoords = function(opt) {
            opt = opt || {};
            var tickModel = opt.tickModel || this.getTickModel();
            var result = (0, (0, parcelRequire("ftAX6")).createAxisTicks)(this, tickModel);
            var ticks = result.ticks;
            var ticksCoords = (0, (0, parcelRequire("bahqM")).map)(ticks, function(tickVal) {
                return {
                    coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                    tickValue: tickVal
                };
            }, this);
            var alignWithLabel = tickModel.get('alignWithLabel');
            $bb9e1c59fe00c8ac$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
            return ticksCoords;
        };
        Axis.prototype.getMinorTicksCoords = function() {
            if (this.scale.type === 'ordinal') return [];
            var minorTickModel = this.model.getModel('minorTick');
            var splitNumber = minorTickModel.get('splitNumber');
            if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
            var minorTicks = this.scale.getMinorTicks(splitNumber);
            var minorTicksCoords = (0, (0, parcelRequire("bahqM")).map)(minorTicks, function(minorTicksGroup) {
                return (0, (0, parcelRequire("bahqM")).map)(minorTicksGroup, function(minorTick) {
                    return {
                        coord: this.dataToCoord(minorTick),
                        tickValue: minorTick
                    };
                }, this);
            }, this);
            return minorTicksCoords;
        };
        Axis.prototype.getViewLabels = function() {
            return (0, (0, parcelRequire("ftAX6")).createAxisLabels)(this).labels;
        };
        Axis.prototype.getLabelModel = function() {
            return this.model.getModel('axisLabel');
        };
        Axis.prototype.getTickModel = function() {
            return this.model.getModel('axisTick');
        };
        Axis.prototype.getBandWidth = function() {
            var axisExtent = this._extent;
            var dataExtent = this.scale.getExtent();
            var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0);
            len === 0 && (len = 1);
            var size = Math.abs(axisExtent[1] - axisExtent[0]);
            return Math.abs(size) / len;
        };
        Axis.prototype.calculateCategoryInterval = function() {
            return (0, (0, parcelRequire("ftAX6")).calculateCategoryInterval)(this);
        };
        return Axis;
    }();
    function $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, nTick) {
        var size = extent[1] - extent[0];
        var len = nTick;
        var margin = size / len / 2;
        extent[0] += margin;
        extent[1] -= margin;
    }
    function $bb9e1c59fe00c8ac$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
        var ticksLen = ticksCoords.length;
        if (!axis.onBand || alignWithLabel || !ticksLen) return;
        var axisExtent = axis.getExtent();
        var last;
        var diffSize;
        if (ticksLen === 1) {
            ticksCoords[0].coord = axisExtent[0];
            last = ticksCoords[1] = {
                coord: axisExtent[0]
            };
        } else {
            var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
            var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
            (0, (0, parcelRequire("bahqM")).each)(ticksCoords, function(ticksItem) {
                ticksItem.coord -= shift_1 / 2;
            });
            var dataExtent = axis.scale.getExtent();
            diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
            last = {
                coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
            };
            ticksCoords.push(last);
        }
        var inverse = axisExtent[0] > axisExtent[1];
        if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
        if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
            coord: axisExtent[0]
        });
        if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
        if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
            coord: axisExtent[1]
        });
        function littleThan(a, b) {
            a = (0, (0, parcelRequire("jmSNG")).round)(a);
            b = (0, (0, parcelRequire("jmSNG")).round)(b);
            return inverse ? a > b : a < b;
        }
    }
    var $bb9e1c59fe00c8ac$export$2e2bcd8739ae039 = $bb9e1c59fe00c8ac$var$Axis;
});
parcelRegister("ftAX6", function(module, exports) {
    $parcel$export(module.exports, "createAxisLabels", ()=>$b4463a620840f7ae$export$10216ebd3e3e485e);
    $parcel$export(module.exports, "createAxisTicks", ()=>$b4463a620840f7ae$export$7cccf6836ae8323c);
    $parcel$export(module.exports, "calculateCategoryInterval", ()=>$b4463a620840f7ae$export$9ea1d3f146a5a65f);
    var $bahqM;
    var $b7ZX8;
    var $eaKsF;
    var $3GIoT;
    var $b4463a620840f7ae$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $b4463a620840f7ae$export$10216ebd3e3e485e(axis) {
        return axis.type === 'category' ? $b4463a620840f7ae$var$makeCategoryLabels(axis) : $b4463a620840f7ae$var$makeRealNumberLabels(axis);
    }
    function $b4463a620840f7ae$export$7cccf6836ae8323c(axis, tickModel) {
        return axis.type === 'category' ? $b4463a620840f7ae$var$makeCategoryTicks(axis, tickModel) : {
            ticks: (0, parcelRequire("bahqM")).map(axis.scale.getTicks(), function(tick) {
                return tick.value;
            })
        };
    }
    function $b4463a620840f7ae$var$makeCategoryLabels(axis) {
        var labelModel = axis.getLabelModel();
        var result = $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, labelModel);
        return !labelModel.get('show') || axis.scale.isBlank() ? {
            labels: [],
            labelCategoryInterval: result.labelCategoryInterval
        } : result;
    }
    function $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, labelModel) {
        var labelsCache = $b4463a620840f7ae$var$getListCache(axis, 'labels');
        var optionLabelInterval = (0, (0, parcelRequire("3GIoT")).getOptionCategoryInterval)(labelModel);
        var result = $b4463a620840f7ae$var$listCacheGet(labelsCache, optionLabelInterval);
        if (result) return result;
        var labels;
        var numericLabelInterval;
        if ((0, parcelRequire("bahqM")).isFunction(optionLabelInterval)) labels = $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
        else {
            numericLabelInterval = optionLabelInterval === 'auto' ? $b4463a620840f7ae$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
            labels = $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
        }
        return $b4463a620840f7ae$var$listCacheSet(labelsCache, optionLabelInterval, {
            labels: labels,
            labelCategoryInterval: numericLabelInterval
        });
    }
    function $b4463a620840f7ae$var$makeCategoryTicks(axis, tickModel) {
        var ticksCache = $b4463a620840f7ae$var$getListCache(axis, 'ticks');
        var optionTickInterval = (0, (0, parcelRequire("3GIoT")).getOptionCategoryInterval)(tickModel);
        var result = $b4463a620840f7ae$var$listCacheGet(ticksCache, optionTickInterval);
        if (result) return result;
        var ticks;
        var tickCategoryInterval;
        if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
        if ((0, parcelRequire("bahqM")).isFunction(optionTickInterval)) ticks = $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
        else if (optionTickInterval === 'auto') {
            var labelsResult = $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
            tickCategoryInterval = labelsResult.labelCategoryInterval;
            ticks = (0, parcelRequire("bahqM")).map(labelsResult.labels, function(labelItem) {
                return labelItem.tickValue;
            });
        } else {
            tickCategoryInterval = optionTickInterval;
            ticks = $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
        }
        return $b4463a620840f7ae$var$listCacheSet(ticksCache, optionTickInterval, {
            ticks: ticks,
            tickCategoryInterval: tickCategoryInterval
        });
    }
    function $b4463a620840f7ae$var$makeRealNumberLabels(axis) {
        var ticks = axis.scale.getTicks();
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        return {
            labels: (0, parcelRequire("bahqM")).map(ticks, function(tick, idx) {
                return {
                    level: tick.level,
                    formattedLabel: labelFormatter(tick, idx),
                    rawLabel: axis.scale.getLabel(tick),
                    tickValue: tick.value
                };
            })
        };
    }
    function $b4463a620840f7ae$var$getListCache(axis, prop) {
        return $b4463a620840f7ae$var$inner(axis)[prop] || ($b4463a620840f7ae$var$inner(axis)[prop] = []);
    }
    function $b4463a620840f7ae$var$listCacheGet(cache, key) {
        for(var i = 0; i < cache.length; i++){
            if (cache[i].key === key) return cache[i].value;
        }
    }
    function $b4463a620840f7ae$var$listCacheSet(cache, key, value) {
        cache.push({
            key: key,
            value: value
        });
        return value;
    }
    function $b4463a620840f7ae$var$makeAutoCategoryInterval(axis) {
        var result = $b4463a620840f7ae$var$inner(axis).autoInterval;
        return result != null ? result : $b4463a620840f7ae$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
    }
    function $b4463a620840f7ae$export$9ea1d3f146a5a65f(axis) {
        var params = $b4463a620840f7ae$var$fetchAutoCategoryIntervalCalculationParams(axis);
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        var tickCount = ordinalScale.count();
        if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
        var step = 1;
        if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
        var tickValue = ordinalExtent[0];
        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
        var unitW = Math.abs(unitSpan * Math.cos(rotation));
        var unitH = Math.abs(unitSpan * Math.sin(rotation));
        var maxW = 0;
        var maxH = 0;
        for(; tickValue <= ordinalExtent[1]; tickValue += step){
            var width = 0;
            var height = 0;
            var rect = (0, parcelRequire("b7ZX8")).getBoundingRect(labelFormatter({
                value: tickValue
            }), params.font, 'center', 'top');
            width = rect.width * 1.3;
            height = rect.height * 1.3;
            maxW = Math.max(maxW, width, 7);
            maxH = Math.max(maxH, height, 7);
        }
        var dw = maxW / unitW;
        var dh = maxH / unitH;
        isNaN(dw) && (dw = Infinity);
        isNaN(dh) && (dh = Infinity);
        var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
        var cache = $b4463a620840f7ae$var$inner(axis.model);
        var axisExtent = axis.getExtent();
        var lastAutoInterval = cache.lastAutoInterval;
        var lastTickCount = cache.lastTickCount;
        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
        else {
            cache.lastTickCount = tickCount;
            cache.lastAutoInterval = interval;
            cache.axisExtent0 = axisExtent[0];
            cache.axisExtent1 = axisExtent[1];
        }
        return interval;
    }
    function $b4463a620840f7ae$var$fetchAutoCategoryIntervalCalculationParams(axis) {
        var labelModel = axis.getLabelModel();
        return {
            axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
            labelRotate: labelModel.get('rotate') || 0,
            font: labelModel.getFont()
        };
    }
    function $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        var labelModel = axis.getLabelModel();
        var result = [];
        var step = Math.max((categoryInterval || 0) + 1, 1);
        var startTick = ordinalExtent[0];
        var tickCount = ordinalScale.count();
        if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
        var showAllLabel = (0, (0, parcelRequire("3GIoT")).shouldShowAllLabels)(axis);
        var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
        var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
        if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
        var tickValue = startTick;
        for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
        if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
        function addItem(tickValue) {
            var tickObj = {
                value: tickValue
            };
            result.push(onlyTick ? tickValue : {
                formattedLabel: labelFormatter(tickObj),
                rawLabel: ordinalScale.getLabel(tickObj),
                tickValue: tickValue
            });
        }
        return result;
    }
    function $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
        var ordinalScale = axis.scale;
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        var result = [];
        (0, parcelRequire("bahqM")).each(ordinalScale.getTicks(), function(tick) {
            var rawLabel = ordinalScale.getLabel(tick);
            var tickValue = tick.value;
            if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
                formattedLabel: labelFormatter(tick),
                rawLabel: rawLabel,
                tickValue: tickValue
            });
        });
        return result;
    }
});
parcelRegister("dBIJY", function(module, exports) {
    $parcel$export(module.exports, "layout", ()=>$9e816f987642cbea$export$b3219800bda33a1f);
    $parcel$export(module.exports, "isCartesian2DSeries", ()=>$9e816f987642cbea$export$c2a0b77974c5e35d);
    $parcel$export(module.exports, "findAxisModels", ()=>$9e816f987642cbea$export$8220131ac1d61d28);
    var $bahqM;
    var $eaKsF;
    function $9e816f987642cbea$export$b3219800bda33a1f(gridModel, axisModel, opt) {
        opt = opt || {};
        var grid = gridModel.coordinateSystem;
        var axis = axisModel.axis;
        var layout = {};
        var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
        var rawAxisPosition = axis.position;
        var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
        var axisDim = axis.dim;
        var rect = grid.getRect();
        var rectBound = [
            rect.x,
            rect.x + rect.width,
            rect.y,
            rect.y + rect.height
        ];
        var idx = {
            left: 0,
            right: 1,
            top: 0,
            bottom: 1,
            onZero: 2
        };
        var axisOffset = axisModel.get('offset') || 0;
        var posBound = axisDim === 'x' ? [
            rectBound[2] - axisOffset,
            rectBound[3] + axisOffset
        ] : [
            rectBound[0] - axisOffset,
            rectBound[1] + axisOffset
        ];
        if (otherAxisOnZeroOf) {
            var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
            posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
        }
        layout.position = [
            axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
            axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
        ];
        layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1);
        var dirMap = {
            top: -1,
            bottom: 1,
            left: -1,
            right: 1
        };
        layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
        layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
        if (axisModel.get([
            'axisTick',
            'inside'
        ])) layout.tickDirection = -layout.tickDirection;
        if ((0, parcelRequire("bahqM")).retrieve(opt.labelInside, axisModel.get([
            'axisLabel',
            'inside'
        ]))) layout.labelDirection = -layout.labelDirection;
        var labelRotate = axisModel.get([
            'axisLabel',
            'rotate'
        ]);
        layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate;
        layout.z2 = 1;
        return layout;
    }
    function $9e816f987642cbea$export$c2a0b77974c5e35d(seriesModel) {
        return seriesModel.get('coordinateSystem') === 'cartesian2d';
    }
    function $9e816f987642cbea$export$8220131ac1d61d28(seriesModel) {
        var axisModelMap = {
            xAxisModel: null,
            yAxisModel: null
        };
        (0, parcelRequire("bahqM")).each(axisModelMap, function(v, key) {
            var axisType = key.replace(/Model$/, '');
            var axisModel = seriesModel.getReferringComponents(axisType, (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            axisModelMap[key] = axisModel;
        });
        return axisModelMap;
    }
});
parcelRegister("2rHnA", function(module, exports) {
    $parcel$export(module.exports, "CartesianXAxisView", ()=>$1c7fc0a7283d68cb$export$b6d40cd875b8a1c8);
    $parcel$export(module.exports, "CartesianYAxisView", ()=>$1c7fc0a7283d68cb$export$417e1bdd0616e0dc);
    var $3VFsf;
    var $bahqM;
    var $4KVOr;
    var $fHITF;
    var $cZb1F;
    var $asa08;
    var $atJL7;
    var $dBIJY;
    var $6dLRi;
    var $1c7fc0a7283d68cb$var$axisBuilderAttrs = [
        'axisLine',
        'axisTickLabel',
        'axisName'
    ];
    var $1c7fc0a7283d68cb$var$selfBuilderAttrs = [
        'splitArea',
        'splitLine',
        'minorSplitLine'
    ];
    var $1c7fc0a7283d68cb$var$CartesianAxisView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianAxisView, _super);
        function CartesianAxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = CartesianAxisView.type;
            _this.axisPointerClass = 'CartesianAxisPointer';
            return _this;
        }
        CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
            this.group.removeAll();
            var oldAxisGroup = this._axisGroup;
            this._axisGroup = new (0, parcelRequire("4KVOr")).default();
            this.group.add(this._axisGroup);
            if (!axisModel.get('show')) return;
            var gridModel = axisModel.getCoordSysModel();
            var layout = (0, parcelRequire("dBIJY")).layout(gridModel, axisModel);
            var axisBuilder = new (0, (0, parcelRequire("asa08")).default)(axisModel, (0, parcelRequire("bahqM")).extend({
                handleAutoShown: function(elementType) {
                    var cartesians = gridModel.coordinateSystem.getCartesians();
                    for(var i = 0; i < cartesians.length; i++){
                        var otherAxisType = cartesians[i].getOtherAxis(axisModel.axis).type;
                        if (otherAxisType === 'value' || otherAxisType === 'log') return true;
                    }
                    return false;
                }
            }, layout));
            (0, parcelRequire("bahqM")).each($1c7fc0a7283d68cb$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
            this._axisGroup.add(axisBuilder.getGroup());
            (0, parcelRequire("bahqM")).each($1c7fc0a7283d68cb$var$selfBuilderAttrs, function(name) {
                if (axisModel.get([
                    name,
                    'show'
                ])) $1c7fc0a7283d68cb$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
            }, this);
            var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
            if (!isInitialSortFromBarRacing) (0, parcelRequire("fHITF")).groupTransition(oldAxisGroup, this._axisGroup, axisModel);
            _super.prototype.render.call(this, axisModel, ecModel, api, payload);
        };
        CartesianAxisView.prototype.remove = function() {
            (0, (0, parcelRequire("6dLRi")).rectCoordAxisHandleRemove)(this);
        };
        CartesianAxisView.type = 'cartesianAxis';
        return CartesianAxisView;
    }((0, (0, parcelRequire("atJL7")).default));
    var $1c7fc0a7283d68cb$var$axisElementBuilders = {
        splitLine: function(axisView, axisGroup, axisModel, gridModel) {
            var axis = axisModel.axis;
            if (axis.scale.isBlank()) return;
            var splitLineModel = axisModel.getModel('splitLine');
            var lineStyleModel = splitLineModel.getModel('lineStyle');
            var lineColors = lineStyleModel.get('color');
            lineColors = (0, parcelRequire("bahqM")).isArray(lineColors) ? lineColors : [
                lineColors
            ];
            var gridRect = gridModel.coordinateSystem.getRect();
            var isHorizontal = axis.isHorizontal();
            var lineCount = 0;
            var ticksCoords = axis.getTicksCoords({
                tickModel: splitLineModel
            });
            var p1 = [];
            var p2 = [];
            var lineStyle = lineStyleModel.getLineStyle();
            for(var i = 0; i < ticksCoords.length; i++){
                var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
                if (isHorizontal) {
                    p1[0] = tickCoord;
                    p1[1] = gridRect.y;
                    p2[0] = tickCoord;
                    p2[1] = gridRect.y + gridRect.height;
                } else {
                    p1[0] = gridRect.x;
                    p1[1] = tickCoord;
                    p2[0] = gridRect.x + gridRect.width;
                    p2[1] = tickCoord;
                }
                var colorIndex = lineCount++ % lineColors.length;
                var tickValue = ticksCoords[i].tickValue;
                axisGroup.add(new (0, parcelRequire("cZb1F")).default({
                    anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
                    subPixelOptimize: true,
                    autoBatch: true,
                    shape: {
                        x1: p1[0],
                        y1: p1[1],
                        x2: p2[0],
                        y2: p2[1]
                    },
                    style: (0, parcelRequire("bahqM")).defaults({
                        stroke: lineColors[colorIndex]
                    }, lineStyle),
                    silent: true
                }));
            }
        },
        minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
            var axis = axisModel.axis;
            var minorSplitLineModel = axisModel.getModel('minorSplitLine');
            var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
            var gridRect = gridModel.coordinateSystem.getRect();
            var isHorizontal = axis.isHorizontal();
            var minorTicksCoords = axis.getMinorTicksCoords();
            if (!minorTicksCoords.length) return;
            var p1 = [];
            var p2 = [];
            var lineStyle = lineStyleModel.getLineStyle();
            for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
                var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
                if (isHorizontal) {
                    p1[0] = tickCoord;
                    p1[1] = gridRect.y;
                    p2[0] = tickCoord;
                    p2[1] = gridRect.y + gridRect.height;
                } else {
                    p1[0] = gridRect.x;
                    p1[1] = tickCoord;
                    p2[0] = gridRect.x + gridRect.width;
                    p2[1] = tickCoord;
                }
                axisGroup.add(new (0, parcelRequire("cZb1F")).default({
                    anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                    subPixelOptimize: true,
                    autoBatch: true,
                    shape: {
                        x1: p1[0],
                        y1: p1[1],
                        x2: p2[0],
                        y2: p2[1]
                    },
                    style: lineStyle,
                    silent: true
                }));
            }
        },
        splitArea: function(axisView, axisGroup, axisModel, gridModel) {
            (0, (0, parcelRequire("6dLRi")).rectCoordAxisBuildSplitArea)(axisView, axisGroup, axisModel, gridModel);
        }
    };
    var $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianXAxisView, _super);
        function CartesianXAxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = CartesianXAxisView.type;
            return _this;
        }
        CartesianXAxisView.type = 'xAxis';
        return CartesianXAxisView;
    }($1c7fc0a7283d68cb$var$CartesianAxisView);
    var $1c7fc0a7283d68cb$export$417e1bdd0616e0dc = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianYAxisView, _super);
        function CartesianYAxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8.type;
            return _this;
        }
        CartesianYAxisView.type = 'yAxis';
        return CartesianYAxisView;
    }($1c7fc0a7283d68cb$var$CartesianAxisView);
    var $1c7fc0a7283d68cb$export$2e2bcd8739ae039 = $1c7fc0a7283d68cb$var$CartesianAxisView;
});
parcelRegister("asa08", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c446f32aef3809$export$2e2bcd8739ae039);
    var $bahqM;
    var $4KVOr;
    parcelRequire("fHITF");
    var $cZb1F;
    var $fHITF;
    var $4gEFv;
    var $7QjoM;
    var $gvLUt;
    var $gaMkj;
    var $jmSNG;
    var $7yklO;
    var $izqgC;
    var $eLEew;
    var $3GIoT;
    var $3LB2b;
    var $79c446f32aef3809$var$PI = Math.PI;
    var $79c446f32aef3809$var$AxisBuilder = function() {
        function AxisBuilder(axisModel, opt) {
            this.group = new (0, parcelRequire("4KVOr")).default();
            this.opt = opt;
            this.axisModel = axisModel;
            (0, (0, parcelRequire("bahqM")).defaults)(opt, {
                labelOffset: 0,
                nameDirection: 1,
                tickDirection: 1,
                labelDirection: 1,
                silent: true,
                handleAutoShown: function() {
                    return true;
                }
            });
            var transformGroup = new (0, parcelRequire("4KVOr")).default({
                x: opt.position[0],
                y: opt.position[1],
                rotation: opt.rotation
            });
            transformGroup.updateTransform();
            this._transformGroup = transformGroup;
        }
        AxisBuilder.prototype.hasBuilder = function(name) {
            return !!$79c446f32aef3809$var$builders[name];
        };
        AxisBuilder.prototype.add = function(name) {
            $79c446f32aef3809$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
        };
        AxisBuilder.prototype.getGroup = function() {
            return this.group;
        };
        AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
            var rotationDiff = (0, (0, parcelRequire("jmSNG")).remRadian)(textRotation - axisRotation);
            var textAlign;
            var textVerticalAlign;
            if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff)) {
                textVerticalAlign = direction > 0 ? 'top' : 'bottom';
                textAlign = 'center';
            } else if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI)) {
                textVerticalAlign = direction > 0 ? 'bottom' : 'top';
                textAlign = 'center';
            } else {
                textVerticalAlign = 'middle';
                if (rotationDiff > 0 && rotationDiff < $79c446f32aef3809$var$PI) textAlign = direction > 0 ? 'right' : 'left';
                else textAlign = direction > 0 ? 'left' : 'right';
            }
            return {
                rotation: rotationDiff,
                textAlign: textAlign,
                textVerticalAlign: textVerticalAlign
            };
        };
        AxisBuilder.makeAxisEventDataBase = function(axisModel) {
            var eventData = {
                componentType: axisModel.mainType,
                componentIndex: axisModel.componentIndex
            };
            eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
            return eventData;
        };
        AxisBuilder.isLabelSilent = function(axisModel) {
            var tooltipOpt = axisModel.get('tooltip');
            return axisModel.get('silent') || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
        };
        return AxisBuilder;
    }();
    var $79c446f32aef3809$var$builders = {
        axisLine: function(opt, axisModel, group, transformGroup) {
            var shown = axisModel.get([
                'axisLine',
                'show'
            ]);
            if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisLine');
            if (!shown) return;
            var extent = axisModel.axis.getExtent();
            var matrix = transformGroup.transform;
            var pt1 = [
                extent[0],
                0
            ];
            var pt2 = [
                extent[1],
                0
            ];
            if (matrix) {
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt1, pt1, matrix);
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt2, pt2, matrix);
            }
            var lineStyle = (0, (0, parcelRequire("bahqM")).extend)({
                lineCap: 'round'
            }, axisModel.getModel([
                'axisLine',
                'lineStyle'
            ]).getLineStyle());
            var line = new (0, parcelRequire("cZb1F")).default({
                subPixelOptimize: true,
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                },
                style: lineStyle,
                strokeContainThreshold: opt.strokeContainThreshold || 5,
                silent: true,
                z2: 1
            });
            line.anid = 'line';
            group.add(line);
            var arrows = axisModel.get([
                'axisLine',
                'symbol'
            ]);
            if (arrows != null) {
                var arrowSize = axisModel.get([
                    'axisLine',
                    'symbolSize'
                ]);
                if (typeof arrows === 'string') arrows = [
                    arrows,
                    arrows
                ];
                if (typeof arrowSize === 'string' || typeof arrowSize === 'number') arrowSize = [
                    arrowSize,
                    arrowSize
                ];
                var arrowOffset = (0, (0, parcelRequire("7yklO")).normalizeSymbolOffset)(axisModel.get([
                    'axisLine',
                    'symbolOffset'
                ]) || 0, arrowSize);
                var symbolWidth_1 = arrowSize[0];
                var symbolHeight_1 = arrowSize[1];
                (0, (0, parcelRequire("bahqM")).each)([
                    {
                        rotate: opt.rotation + Math.PI / 2,
                        offset: arrowOffset[0],
                        r: 0
                    },
                    {
                        rotate: opt.rotation - Math.PI / 2,
                        offset: arrowOffset[1],
                        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                    }
                ], function(point, index) {
                    if (arrows[index] !== 'none' && arrows[index] != null) {
                        var symbol = (0, (0, parcelRequire("7yklO")).createSymbol)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                        var r = point.r + point.offset;
                        symbol.attr({
                            rotation: point.rotate,
                            x: pt1[0] + r * Math.cos(opt.rotation),
                            y: pt1[1] - r * Math.sin(opt.rotation),
                            silent: true,
                            z2: 11
                        });
                        group.add(symbol);
                    }
                });
            }
        },
        axisTickLabel: function(opt, axisModel, group, transformGroup) {
            var ticksEls = $79c446f32aef3809$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
            var labelEls = $79c446f32aef3809$var$buildAxisLabel(group, transformGroup, axisModel, opt);
            $79c446f32aef3809$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
            $79c446f32aef3809$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection);
            if (axisModel.get([
                'axisLabel',
                'hideOverlap'
            ])) {
                var labelList = (0, (0, parcelRequire("3LB2b")).prepareLayoutList)((0, (0, parcelRequire("bahqM")).map)(labelEls, function(label) {
                    return {
                        label: label,
                        priority: label.z2,
                        defaultAttr: {
                            ignore: label.ignore
                        }
                    };
                }));
                (0, (0, parcelRequire("3LB2b")).hideOverlap)(labelList);
            }
        },
        axisName: function(opt, axisModel, group, transformGroup) {
            var name = (0, (0, parcelRequire("bahqM")).retrieve)(opt.axisName, axisModel.get('name'));
            if (!name) return;
            var nameLocation = axisModel.get('nameLocation');
            var nameDirection = opt.nameDirection;
            var textStyleModel = axisModel.getModel('nameTextStyle');
            var gap = axisModel.get('nameGap') || 0;
            var extent = axisModel.axis.getExtent();
            var gapSignal = extent[0] > extent[1] ? -1 : 1;
            var pos = [
                nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
                $79c446f32aef3809$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
            ];
            var labelLayout;
            var nameRotation = axisModel.get('nameRotate');
            if (nameRotation != null) nameRotation = nameRotation * $79c446f32aef3809$var$PI / 180;
            var axisNameAvailableWidth;
            if ($79c446f32aef3809$var$isNameLocationCenter(nameLocation)) labelLayout = $79c446f32aef3809$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, nameDirection);
            else {
                labelLayout = $79c446f32aef3809$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
                axisNameAvailableWidth = opt.axisNameAvailableWidth;
                if (axisNameAvailableWidth != null) {
                    axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                    !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
                }
            }
            var textFont = textStyleModel.getFont();
            var truncateOpt = axisModel.get('nameTruncate', true) || {};
            var ellipsis = truncateOpt.ellipsis;
            var maxWidth = (0, (0, parcelRequire("bahqM")).retrieve)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
            var textEl = new (0, parcelRequire("4gEFv")).default({
                x: pos[0],
                y: pos[1],
                rotation: labelLayout.rotation,
                silent: $79c446f32aef3809$var$AxisBuilder.isLabelSilent(axisModel),
                style: (0, (0, parcelRequire("gvLUt")).createTextStyle)(textStyleModel, {
                    text: name,
                    font: textFont,
                    overflow: 'truncate',
                    width: maxWidth,
                    ellipsis: ellipsis,
                    fill: textStyleModel.getTextColor() || axisModel.get([
                        'axisLine',
                        'lineStyle',
                        'color'
                    ]),
                    align: textStyleModel.get('align') || labelLayout.textAlign,
                    verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
                }),
                z2: 1
            });
            (0, parcelRequire("fHITF")).setTooltipConfig({
                el: textEl,
                componentModel: axisModel,
                itemName: name
            });
            textEl.__fullText = name;
            textEl.anid = 'name';
            if (axisModel.get('triggerEvent')) {
                var eventData = $79c446f32aef3809$var$AxisBuilder.makeAxisEventDataBase(axisModel);
                eventData.targetType = 'axisName';
                eventData.name = name;
                (0, (0, parcelRequire("7QjoM")).getECData)(textEl).eventData = eventData;
            }
            transformGroup.add(textEl);
            textEl.updateTransform();
            group.add(textEl);
            textEl.decomposeTransform();
        }
    };
    function $79c446f32aef3809$var$endTextLayout(rotation, textPosition, textRotate, extent) {
        var rotationDiff = (0, (0, parcelRequire("jmSNG")).remRadian)(textRotate - rotation);
        var textAlign;
        var textVerticalAlign;
        var inverse = extent[0] > extent[1];
        var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
        if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI / 2)) {
            textVerticalAlign = onLeft ? 'bottom' : 'top';
            textAlign = 'center';
        } else if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI * 1.5)) {
            textVerticalAlign = onLeft ? 'top' : 'bottom';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff < $79c446f32aef3809$var$PI * 1.5 && rotationDiff > $79c446f32aef3809$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
            else textAlign = onLeft ? 'right' : 'left';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    }
    function $79c446f32aef3809$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
        if ((0, (0, parcelRequire("3GIoT")).shouldShowAllLabels)(axisModel.axis)) return;
        var showMinLabel = axisModel.get([
            'axisLabel',
            'showMinLabel'
        ]);
        var showMaxLabel = axisModel.get([
            'axisLabel',
            'showMaxLabel'
        ]);
        labelEls = labelEls || [];
        tickEls = tickEls || [];
        var firstLabel = labelEls[0];
        var nextLabel = labelEls[1];
        var lastLabel = labelEls[labelEls.length - 1];
        var prevLabel = labelEls[labelEls.length - 2];
        var firstTick = tickEls[0];
        var nextTick = tickEls[1];
        var lastTick = tickEls[tickEls.length - 1];
        var prevTick = tickEls[tickEls.length - 2];
        if (showMinLabel === false) {
            $79c446f32aef3809$var$ignoreEl(firstLabel);
            $79c446f32aef3809$var$ignoreEl(firstTick);
        } else if ($79c446f32aef3809$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
            if (showMinLabel) {
                $79c446f32aef3809$var$ignoreEl(nextLabel);
                $79c446f32aef3809$var$ignoreEl(nextTick);
            } else {
                $79c446f32aef3809$var$ignoreEl(firstLabel);
                $79c446f32aef3809$var$ignoreEl(firstTick);
            }
        }
        if (showMaxLabel === false) {
            $79c446f32aef3809$var$ignoreEl(lastLabel);
            $79c446f32aef3809$var$ignoreEl(lastTick);
        } else if ($79c446f32aef3809$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
            if (showMaxLabel) {
                $79c446f32aef3809$var$ignoreEl(prevLabel);
                $79c446f32aef3809$var$ignoreEl(prevTick);
            } else {
                $79c446f32aef3809$var$ignoreEl(lastLabel);
                $79c446f32aef3809$var$ignoreEl(lastTick);
            }
        }
    }
    function $79c446f32aef3809$var$ignoreEl(el) {
        el && (el.ignore = true);
    }
    function $79c446f32aef3809$var$isTwoLabelOverlapped(current, next) {
        var firstRect = current && current.getBoundingRect().clone();
        var nextRect = next && next.getBoundingRect().clone();
        if (!firstRect || !nextRect) return;
        var mRotationBack = (0, parcelRequire("izqgC")).identity([]);
        (0, parcelRequire("izqgC")).rotate(mRotationBack, mRotationBack, -current.rotation);
        firstRect.applyTransform((0, parcelRequire("izqgC")).mul([], mRotationBack, current.getLocalTransform()));
        nextRect.applyTransform((0, parcelRequire("izqgC")).mul([], mRotationBack, next.getLocalTransform()));
        return firstRect.intersect(nextRect);
    }
    function $79c446f32aef3809$var$isNameLocationCenter(nameLocation) {
        return nameLocation === 'middle' || nameLocation === 'center';
    }
    function $79c446f32aef3809$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
        var tickEls = [];
        var pt1 = [];
        var pt2 = [];
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = ticksCoords[i].coord;
            pt1[0] = tickCoord;
            pt1[1] = 0;
            pt2[0] = tickCoord;
            pt2[1] = tickEndCoord;
            if (tickTransform) {
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt1, pt1, tickTransform);
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt2, pt2, tickTransform);
            }
            var tickEl = new (0, parcelRequire("cZb1F")).default({
                subPixelOptimize: true,
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                },
                style: tickLineStyle,
                z2: 2,
                autoBatch: true,
                silent: true
            });
            tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
            tickEls.push(tickEl);
        }
        return tickEls;
    }
    function $79c446f32aef3809$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
        var axis = axisModel.axis;
        var tickModel = axisModel.getModel('axisTick');
        var shown = tickModel.get('show');
        if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisTick');
        if (!shown || axis.scale.isBlank()) return;
        var lineStyleModel = tickModel.getModel('lineStyle');
        var tickEndCoord = opt.tickDirection * tickModel.get('length');
        var ticksCoords = axis.getTicksCoords();
        var ticksEls = $79c446f32aef3809$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, (0, parcelRequire("bahqM")).defaults)(lineStyleModel.getLineStyle(), {
            stroke: axisModel.get([
                'axisLine',
                'lineStyle',
                'color'
            ])
        }), 'ticks');
        for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
        return ticksEls;
    }
    function $79c446f32aef3809$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
        var axis = axisModel.axis;
        var minorTickModel = axisModel.getModel('minorTick');
        if (!minorTickModel.get('show') || axis.scale.isBlank()) return;
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var lineStyleModel = minorTickModel.getModel('lineStyle');
        var tickEndCoord = tickDirection * minorTickModel.get('length');
        var minorTickLineStyle = (0, (0, parcelRequire("bahqM")).defaults)(lineStyleModel.getLineStyle(), (0, (0, parcelRequire("bahqM")).defaults)(axisModel.getModel('axisTick').getLineStyle(), {
            stroke: axisModel.get([
                'axisLine',
                'lineStyle',
                'color'
            ])
        }));
        for(var i = 0; i < minorTicksCoords.length; i++){
            var minorTicksEls = $79c446f32aef3809$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
            for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
        }
    }
    function $79c446f32aef3809$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
        var axis = axisModel.axis;
        var show = (0, (0, parcelRequire("bahqM")).retrieve)(opt.axisLabelShow, axisModel.get([
            'axisLabel',
            'show'
        ]));
        if (!show || axis.scale.isBlank()) return;
        var labelModel = axisModel.getModel('axisLabel');
        var labelMargin = labelModel.get('margin');
        var labels = axis.getViewLabels();
        var labelRotation = ((0, (0, parcelRequire("bahqM")).retrieve)(opt.labelRotate, labelModel.get('rotate')) || 0) * $79c446f32aef3809$var$PI / 180;
        var labelLayout = $79c446f32aef3809$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
        var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
        var labelEls = [];
        var silent = $79c446f32aef3809$var$AxisBuilder.isLabelSilent(axisModel);
        var triggerEvent = axisModel.get('triggerEvent');
        (0, (0, parcelRequire("bahqM")).each)(labels, function(labelItem, index) {
            var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
            var formattedLabel = labelItem.formattedLabel;
            var rawLabel = labelItem.rawLabel;
            var itemLabelModel = labelModel;
            if (rawCategoryData && rawCategoryData[tickValue]) {
                var rawCategoryItem = rawCategoryData[tickValue];
                if ((0, (0, parcelRequire("bahqM")).isObject)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, (0, parcelRequire("gaMkj")).default)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
            }
            var textColor = itemLabelModel.getTextColor() || axisModel.get([
                'axisLine',
                'lineStyle',
                'color'
            ]);
            var tickCoord = axis.dataToCoord(tickValue);
            var textEl = new (0, parcelRequire("4gEFv")).default({
                x: tickCoord,
                y: opt.labelOffset + opt.labelDirection * labelMargin,
                rotation: labelLayout.rotation,
                silent: silent,
                z2: 10 + (labelItem.level || 0),
                style: (0, (0, parcelRequire("gvLUt")).createTextStyle)(itemLabelModel, {
                    text: formattedLabel,
                    align: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
                    verticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
                    fill: typeof textColor === 'function' ? textColor(axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
                })
            });
            textEl.anid = 'label_' + tickValue;
            if (triggerEvent) {
                var eventData = $79c446f32aef3809$var$AxisBuilder.makeAxisEventDataBase(axisModel);
                eventData.targetType = 'axisLabel';
                eventData.value = rawLabel;
                (0, (0, parcelRequire("7QjoM")).getECData)(textEl).eventData = eventData;
            }
            transformGroup.add(textEl);
            textEl.updateTransform();
            labelEls.push(textEl);
            group.add(textEl);
            textEl.decomposeTransform();
        });
        return labelEls;
    }
    var $79c446f32aef3809$export$2e2bcd8739ae039 = $79c446f32aef3809$var$AxisBuilder;
});
parcelRegister("3LB2b", function(module, exports) {
    $parcel$export(module.exports, "prepareLayoutList", ()=>$2be27d213439fed1$export$6c403cad1ae3e239);
    $parcel$export(module.exports, "shiftLayoutOnX", ()=>$2be27d213439fed1$export$b6b2b07f8ed32bd6);
    $parcel$export(module.exports, "shiftLayoutOnY", ()=>$2be27d213439fed1$export$118c25e0932528e4);
    $parcel$export(module.exports, "hideOverlap", ()=>$2be27d213439fed1$export$8ce774e164a49410);
    var $1E3E8;
    var $lM5Gp;
    function $2be27d213439fed1$export$6c403cad1ae3e239(input) {
        var list = [];
        for(var i = 0; i < input.length; i++){
            var rawItem = input[i];
            if (rawItem.defaultAttr.ignore) continue;
            var label = rawItem.label;
            var transform = label.getComputedTransform();
            var localRect = label.getBoundingRect();
            var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
            var minMargin = label.style.margin || 0;
            var globalRect = localRect.clone();
            globalRect.applyTransform(transform);
            globalRect.x -= minMargin / 2;
            globalRect.y -= minMargin / 2;
            globalRect.width += minMargin;
            globalRect.height += minMargin;
            var obb = isAxisAligned ? new (0, (0, parcelRequire("lM5Gp")).default)(localRect, transform) : null;
            list.push({
                label: label,
                labelLine: rawItem.labelLine,
                rect: globalRect,
                localRect: localRect,
                obb: obb,
                priority: rawItem.priority,
                defaultAttr: rawItem.defaultAttr,
                layoutOption: rawItem.computedLayoutOption,
                axisAligned: isAxisAligned,
                transform: transform
            });
        }
        return list;
    }
    function $2be27d213439fed1$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
        var len = list.length;
        if (len < 2) return;
        list.sort(function(a, b) {
            return a.rect[xyDim] - b.rect[xyDim];
        });
        var lastPos = 0;
        var delta;
        var adjusted = false;
        var shifts = [];
        var totalShifts = 0;
        for(var i = 0; i < len; i++){
            var item = list[i];
            var rect = item.rect;
            delta = rect[xyDim] - lastPos;
            if (delta < 0) {
                rect[xyDim] -= delta;
                item.label[xyDim] -= delta;
                adjusted = true;
            }
            var shift = Math.max(-delta, 0);
            shifts.push(shift);
            totalShifts += shift;
            lastPos = rect[xyDim] + rect[sizeDim];
        }
        if (totalShifts > 0 && balanceShift) shiftList(-totalShifts / len, 0, len);
        var first = list[0];
        var last = list[len - 1];
        var minGap;
        var maxGap;
        updateMinMaxGap();
        minGap < 0 && squeezeGaps(-minGap, 0.8);
        maxGap < 0 && squeezeGaps(maxGap, 0.8);
        updateMinMaxGap();
        takeBoundsGap(minGap, maxGap, 1);
        takeBoundsGap(maxGap, minGap, -1);
        updateMinMaxGap();
        if (minGap < 0) squeezeWhenBailout(-minGap);
        if (maxGap < 0) squeezeWhenBailout(maxGap);
        function updateMinMaxGap() {
            minGap = first.rect[xyDim] - minBound;
            maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
        }
        function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
            if (gapThisBound < 0) {
                var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
                if (moveFromMaxGap > 0) {
                    shiftList(moveFromMaxGap * moveDir, 0, len);
                    var remained = moveFromMaxGap + gapThisBound;
                    if (remained < 0) squeezeGaps(-remained * moveDir, 1);
                } else squeezeGaps(-gapThisBound * moveDir, 1);
            }
        }
        function shiftList(delta, start, end) {
            if (delta !== 0) adjusted = true;
            for(var i = start; i < end; i++){
                var item = list[i];
                var rect = item.rect;
                rect[xyDim] += delta;
                item.label[xyDim] += delta;
            }
        }
        function squeezeGaps(delta, maxSqeezePercent) {
            var gaps = [];
            var totalGaps = 0;
            for(var i = 1; i < len; i++){
                var prevItemRect = list[i - 1].rect;
                var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
                gaps.push(gap);
                totalGaps += gap;
            }
            if (!totalGaps) return;
            var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
            if (delta > 0) for(var i = 0; i < len - 1; i++){
                var movement = gaps[i] * squeezePercent;
                shiftList(movement, 0, i + 1);
            }
            else for(var i = len - 1; i > 0; i--){
                var movement = gaps[i - 1] * squeezePercent;
                shiftList(-movement, i, len);
            }
        }
        function squeezeWhenBailout(delta) {
            var dir = delta < 0 ? -1 : 1;
            delta = Math.abs(delta);
            var moveForEachLabel = Math.ceil(delta / (len - 1));
            for(var i = 0; i < len - 1; i++){
                if (dir > 0) shiftList(moveForEachLabel, 0, i + 1);
                else shiftList(-moveForEachLabel, len - i - 1, len);
                delta -= moveForEachLabel;
                if (delta <= 0) return;
            }
        }
        return adjusted;
    }
    function $2be27d213439fed1$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, balanceShift) {
        return $2be27d213439fed1$var$shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
    }
    function $2be27d213439fed1$export$118c25e0932528e4(list, topBound, bottomBound, balanceShift) {
        return $2be27d213439fed1$var$shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
    }
    function $2be27d213439fed1$export$8ce774e164a49410(labelList) {
        var displayedLabels = [];
        labelList.sort(function(a, b) {
            return b.priority - a.priority;
        });
        var globalRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
        function hideEl(el) {
            if (!el.ignore) {
                var emphasisState = el.ensureState('emphasis');
                if (emphasisState.ignore == null) emphasisState.ignore = false;
            }
            el.ignore = true;
        }
        for(var i = 0; i < labelList.length; i++){
            var labelItem = labelList[i];
            var isAxisAligned = labelItem.axisAligned;
            var localRect = labelItem.localRect;
            var transform = labelItem.transform;
            var label = labelItem.label;
            var labelLine = labelItem.labelLine;
            globalRect.copy(labelItem.rect);
            globalRect.width -= 0.1;
            globalRect.height -= 0.1;
            globalRect.x += 0.05;
            globalRect.y += 0.05;
            var obb = labelItem.obb;
            var overlapped = false;
            for(var j = 0; j < displayedLabels.length; j++){
                var existsTextCfg = displayedLabels[j];
                if (!globalRect.intersect(existsTextCfg.rect)) continue;
                if (isAxisAligned && existsTextCfg.axisAligned) {
                    overlapped = true;
                    break;
                }
                if (!existsTextCfg.obb) existsTextCfg.obb = new (0, (0, parcelRequire("lM5Gp")).default)(existsTextCfg.localRect, existsTextCfg.transform);
                if (!obb) obb = new (0, (0, parcelRequire("lM5Gp")).default)(localRect, transform);
                if (obb.intersect(existsTextCfg.obb)) {
                    overlapped = true;
                    break;
                }
            }
            if (overlapped) {
                hideEl(label);
                labelLine && hideEl(labelLine);
            } else {
                label.attr('ignore', labelItem.defaultAttr.ignore);
                labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
                displayedLabels.push(labelItem);
            }
        }
    }
});
parcelRegister("atJL7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a101b97b7710a5f$export$2e2bcd8739ae039);
    var $3VFsf;
    var $8QSpd;
    var $fkskt;
    var $7a101b97b7710a5f$var$axisPointerClazz = {};
    var $7a101b97b7710a5f$var$AxisView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(AxisView, _super);
        function AxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = AxisView.type;
            return _this;
        }
        AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
            this.axisPointerClass && (0, parcelRequire("8QSpd")).fixValue(axisModel);
            _super.prototype.render.apply(this, arguments);
            this._doUpdateAxisPointerClass(axisModel, api, true);
        };
        AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
            this._doUpdateAxisPointerClass(axisModel, api, false);
        };
        AxisView.prototype.remove = function(ecModel, api) {
            var axisPointer = this._axisPointer;
            axisPointer && axisPointer.remove(api);
        };
        AxisView.prototype.dispose = function(ecModel, api) {
            this._disposeAxisPointer(api);
            _super.prototype.dispose.apply(this, arguments);
        };
        AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
            var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
            if (!Clazz) return;
            var axisPointerModel = (0, parcelRequire("8QSpd")).getAxisPointerModel(axisModel);
            axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
        };
        AxisView.prototype._disposeAxisPointer = function(api) {
            this._axisPointer && this._axisPointer.dispose(api);
            this._axisPointer = null;
        };
        AxisView.registerAxisPointerClass = function(type, clazz) {
            $7a101b97b7710a5f$var$axisPointerClazz[type] = clazz;
        };
        AxisView.getAxisPointerClass = function(type) {
            return type && $7a101b97b7710a5f$var$axisPointerClazz[type];
        };
        AxisView.type = 'axis';
        return AxisView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $7a101b97b7710a5f$export$2e2bcd8739ae039 = $7a101b97b7710a5f$var$AxisView;
});
parcelRegister("8QSpd", function(module, exports) {
    $parcel$export(module.exports, "collect", ()=>$671d61e645e8595c$export$bb44f104e3c54dae);
    $parcel$export(module.exports, "makeKey", ()=>$671d61e645e8595c$export$d01b444bafb1a792);
    $parcel$export(module.exports, "fixValue", ()=>$671d61e645e8595c$export$f5ea32e3629d8043);
    $parcel$export(module.exports, "getAxisInfo", ()=>$671d61e645e8595c$export$bd39458db76002ab);
    $parcel$export(module.exports, "getAxisPointerModel", ()=>$671d61e645e8595c$export$3b06fce3f68b734);
    var $gaMkj;
    var $bahqM;
    function $671d61e645e8595c$export$bb44f104e3c54dae(ecModel, api) {
        var result = {
            axesInfo: {},
            seriesInvolved: false,
            coordSysAxesInfo: {},
            coordSysMap: {}
        };
        $671d61e645e8595c$var$collectAxesInfo(result, ecModel, api);
        result.seriesInvolved && $671d61e645e8595c$var$collectSeriesInfo(result, ecModel);
        return result;
    }
    function $671d61e645e8595c$var$collectAxesInfo(result, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var globalAxisPointerModel = ecModel.getComponent('axisPointer');
        var linksOption = globalAxisPointerModel.get('link', true) || [];
        var linkGroups = [];
        (0, (0, parcelRequire("bahqM")).each)(api.getCoordinateSystems(), function(coordSys) {
            if (!coordSys.axisPointerEnabled) return;
            var coordSysKey = $671d61e645e8595c$export$d01b444bafb1a792(coordSys.model);
            var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
            result.coordSysMap[coordSysKey] = coordSys;
            var coordSysModel = coordSys.model;
            var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
            (0, (0, parcelRequire("bahqM")).each)(coordSys.getAxes(), (0, (0, parcelRequire("bahqM")).curry)(saveTooltipAxisInfo, false, null));
            if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get('show')) {
                var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
                var cross = baseTooltipModel.get([
                    'axisPointer',
                    'type'
                ]) === 'cross';
                var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                    'axisPointer',
                    'axis'
                ]));
                if (triggerAxis || cross) (0, (0, parcelRequire("bahqM")).each)(tooltipAxes.baseAxes, (0, (0, parcelRequire("bahqM")).curry)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
                if (cross) (0, (0, parcelRequire("bahqM")).each)(tooltipAxes.otherAxes, (0, (0, parcelRequire("bahqM")).curry)(saveTooltipAxisInfo, 'cross', false));
            }
            function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
                var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
                var axisPointerShow = axisPointerModel.get('show');
                if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$671d61e645e8595c$var$isHandleTrigger(axisPointerModel)) return;
                if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
                axisPointerModel = fromTooltip ? $671d61e645e8595c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
                var snap = axisPointerModel.get('snap');
                var axisKey = $671d61e645e8595c$export$d01b444bafb1a792(axis.model);
                var involveSeries = triggerTooltip || snap || axis.type === 'category';
                var axisInfo = result.axesInfo[axisKey] = {
                    key: axisKey,
                    axis: axis,
                    coordSys: coordSys,
                    axisPointerModel: axisPointerModel,
                    triggerTooltip: triggerTooltip,
                    involveSeries: involveSeries,
                    snap: snap,
                    useHandle: $671d61e645e8595c$var$isHandleTrigger(axisPointerModel),
                    seriesModels: [],
                    linkGroup: null
                };
                axesInfoInCoordSys[axisKey] = axisInfo;
                result.seriesInvolved = result.seriesInvolved || involveSeries;
                var groupIndex = $671d61e645e8595c$var$getLinkGroupIndex(linksOption, axis);
                if (groupIndex != null) {
                    var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                        axesInfo: {}
                    });
                    linkGroup.axesInfo[axisKey] = axisInfo;
                    linkGroup.mapper = linksOption[groupIndex].mapper;
                    axisInfo.linkGroup = linkGroup;
                }
            }
        });
    }
    function $671d61e645e8595c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
        var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
        var fields = [
            'type',
            'snap',
            'lineStyle',
            'shadowStyle',
            'label',
            'animation',
            'animationDurationUpdate',
            'animationEasingUpdate',
            'z'
        ];
        var volatileOption = {};
        (0, (0, parcelRequire("bahqM")).each)(fields, function(field) {
            volatileOption[field] = (0, (0, parcelRequire("bahqM")).clone)(tooltipAxisPointerModel.get(field));
        });
        volatileOption.snap = axis.type !== 'category' && !!triggerTooltip;
        if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
        var labelOption = volatileOption.label || (volatileOption.label = {});
        labelOption.show == null && (labelOption.show = false);
        if (fromTooltip === 'cross') {
            var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
                'label',
                'show'
            ]);
            labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
            if (!triggerTooltip) {
                var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
                crossStyle && (0, (0, parcelRequire("bahqM")).defaults)(labelOption, crossStyle.textStyle);
            }
        }
        return axis.model.getModel('axisPointer', new (0, (0, parcelRequire("gaMkj")).default)(volatileOption, globalAxisPointerModel, ecModel));
    }
    function $671d61e645e8595c$var$collectSeriesInfo(result, ecModel) {
        ecModel.eachSeries(function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var seriesTooltipTrigger = seriesModel.get([
                'tooltip',
                'trigger'
            ], true);
            var seriesTooltipShow = seriesModel.get([
                'tooltip',
                'show'
            ], true);
            if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
                'axisPointer',
                'show'
            ], true) === false) return;
            (0, (0, parcelRequire("bahqM")).each)(result.coordSysAxesInfo[$671d61e645e8595c$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
                var axis = axisInfo.axis;
                if (coordSys.getAxis(axis.dim) === axis) {
                    axisInfo.seriesModels.push(seriesModel);
                    axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                    axisInfo.seriesDataCount += seriesModel.getData().count();
                }
            });
        });
    }
    function $671d61e645e8595c$var$getLinkGroupIndex(linksOption, axis) {
        var axisModel = axis.model;
        var dim = axis.dim;
        for(var i = 0; i < linksOption.length; i++){
            var linkOption = linksOption[i] || {};
            if ($671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
        }
    }
    function $671d61e645e8595c$var$checkPropInLink(linkPropValue, axisPropValue) {
        return linkPropValue === 'all' || (0, (0, parcelRequire("bahqM")).isArray)(linkPropValue) && (0, (0, parcelRequire("bahqM")).indexOf)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
    }
    function $671d61e645e8595c$export$f5ea32e3629d8043(axisModel) {
        var axisInfo = $671d61e645e8595c$export$bd39458db76002ab(axisModel);
        if (!axisInfo) return;
        var axisPointerModel = axisInfo.axisPointerModel;
        var scale = axisInfo.axis.scale;
        var option = axisPointerModel.option;
        var status = axisPointerModel.get('status');
        var value = axisPointerModel.get('value');
        if (value != null) value = scale.parse(value);
        var useHandle = $671d61e645e8595c$var$isHandleTrigger(axisPointerModel);
        if (status == null) option.status = useHandle ? 'show' : 'hide';
        var extent = scale.getExtent().slice();
        extent[0] > extent[1] && extent.reverse();
        if (value == null || value > extent[1]) value = extent[1];
        if (value < extent[0]) value = extent[0];
        option.value = value;
        if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
    }
    function $671d61e645e8595c$export$bd39458db76002ab(axisModel) {
        var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
        return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$671d61e645e8595c$export$d01b444bafb1a792(axisModel)];
    }
    function $671d61e645e8595c$export$3b06fce3f68b734(axisModel) {
        var axisInfo = $671d61e645e8595c$export$bd39458db76002ab(axisModel);
        return axisInfo && axisInfo.axisPointerModel;
    }
    function $671d61e645e8595c$var$isHandleTrigger(axisPointerModel) {
        return !!axisPointerModel.get([
            'handle',
            'show'
        ]);
    }
    function $671d61e645e8595c$export$d01b444bafb1a792(model) {
        return model.type + '||' + model.id;
    }
});
parcelRegister("6dLRi", function(module, exports) {
    $parcel$export(module.exports, "rectCoordAxisBuildSplitArea", ()=>$487914b46b0b3c46$export$c80b7ef1527ec8c9);
    $parcel$export(module.exports, "rectCoordAxisHandleRemove", ()=>$487914b46b0b3c46$export$48ebf2d6ce8ad076);
    var $bahqM;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $eaKsF;
    var $487914b46b0b3c46$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $487914b46b0b3c46$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitAreaModel = axisModel.getModel('splitArea');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var areaColors = areaStyleModel.get('color');
        var gridRect = gridModel.coordinateSystem.getRect();
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitAreaModel,
            clamp: true
        });
        if (!ticksCoords.length) return;
        var areaColorsLen = areaColors.length;
        var lastSplitAreaColors = $487914b46b0b3c46$var$inner(axisView).splitAreaColors;
        var newSplitAreaColors = (0, parcelRequire("bahqM")).createHashMap();
        var colorIndex = 0;
        if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
            var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
            if (cIndex != null) {
                colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
                break;
            }
        }
        var prev = axis.toGlobalCoord(ticksCoords[0].coord);
        var areaStyle = areaStyleModel.getAreaStyle();
        areaColors = (0, parcelRequire("bahqM")).isArray(areaColors) ? areaColors : [
            areaColors
        ];
        for(var i = 1; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            var x = void 0;
            var y = void 0;
            var width = void 0;
            var height = void 0;
            if (axis.isHorizontal()) {
                x = prev;
                y = gridRect.y;
                width = tickCoord - x;
                height = gridRect.height;
                prev = x + width;
            } else {
                x = gridRect.x;
                y = prev;
                width = gridRect.width;
                height = tickCoord - y;
                prev = y + height;
            }
            var tickValue = ticksCoords[i - 1].tickValue;
            tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
            axisGroup.add(new (0, parcelRequire("7Tw7u")).default({
                anid: tickValue != null ? 'area_' + tickValue : null,
                shape: {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                },
                style: (0, parcelRequire("bahqM")).defaults({
                    fill: areaColors[colorIndex]
                }, areaStyle),
                autoBatch: true,
                silent: true
            }));
            colorIndex = (colorIndex + 1) % areaColorsLen;
        }
        $487914b46b0b3c46$var$inner(axisView).splitAreaColors = newSplitAreaColors;
    }
    function $487914b46b0b3c46$export$48ebf2d6ce8ad076(axisView) {
        $487914b46b0b3c46$var$inner(axisView).splitAreaColors = null;
    }
});
parcelRegister("48mDj", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$3029774200831710$export$4b3e715f166fdd78);
    var $hpWan;
    var $9wang;
    var $ce402;
    function $3029774200831710$export$4b3e715f166fdd78(registers) {
        registers.registerComponentModel((0, (0, parcelRequire("9wang")).default));
        registers.registerComponentView((0, (0, parcelRequire("ce402")).default));
        registers.registerPreprocessor(function(opt) {
            if ((0, (0, parcelRequire("hpWan")).default)(opt.series, 'markLine')) opt.markLine = opt.markLine || {};
        });
    }
});
parcelRegister("hpWan", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cae1e41edf2dca89$export$2e2bcd8739ae039);
    var $bahqM;
    function $cae1e41edf2dca89$export$2e2bcd8739ae039(seriesOpts, markerType) {
        if (!seriesOpts) return false;
        var seriesOptArr = (0, (0, parcelRequire("bahqM")).isArray)(seriesOpts) ? seriesOpts : [
            seriesOpts
        ];
        for(var idx = 0; idx < seriesOptArr.length; idx++){
            if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
        }
        return false;
    }
});
parcelRegister("9wang", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6edf264d439d7d08$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h8Fle;
    var $6edf264d439d7d08$var$MarkLineModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MarkLineModel, _super);
        function MarkLineModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = MarkLineModel.type;
            return _this;
        }
        MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
            return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
        };
        MarkLineModel.type = 'markLine';
        MarkLineModel.defaultOption = {
            zlevel: 0,
            z: 5,
            symbol: [
                'circle',
                'arrow'
            ],
            symbolSize: [
                8,
                16
            ],
            symbolOffset: 0,
            precision: 2,
            tooltip: {
                trigger: 'item'
            },
            label: {
                show: true,
                position: 'end',
                distance: 5
            },
            lineStyle: {
                type: 'dashed'
            },
            emphasis: {
                label: {
                    show: true
                },
                lineStyle: {
                    width: 3
                }
            },
            animationEasing: 'linear'
        };
        return MarkLineModel;
    }((0, (0, parcelRequire("h8Fle")).default));
    var $6edf264d439d7d08$export$2e2bcd8739ae039 = $6edf264d439d7d08$var$MarkLineModel;
});
parcelRegister("h8Fle", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7a34092fe996af9$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $hZfwb;
    var $guzSc;
    var $h4UlH;
    var $eaKsF;
    var $j5lKL;
    function $c7a34092fe996af9$var$fillLabel(opt) {
        (0, (0, parcelRequire("eaKsF")).defaultEmphasis)(opt, 'label', [
            'show'
        ]);
    }
    var $c7a34092fe996af9$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $c7a34092fe996af9$var$MarkerModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MarkerModel, _super);
        function MarkerModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = MarkerModel.type;
            _this.createdBySelf = false;
            return _this;
        }
        MarkerModel.prototype.init = function(option, parentModel, ecModel) {
            this.mergeDefaultAndTheme(option, ecModel);
            this._mergeOption(option, ecModel, false, true);
        };
        MarkerModel.prototype.isAnimationEnabled = function() {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return false;
            var hostSeries = this.__hostSeries;
            return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
        };
        MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
            this._mergeOption(newOpt, ecModel, false, false);
        };
        MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
            var componentType = this.mainType;
            if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
                var markerOpt = seriesModel.get(this.mainType, true);
                var markerModel = $c7a34092fe996af9$var$inner(seriesModel)[componentType];
                if (!markerOpt || !markerOpt.data) {
                    $c7a34092fe996af9$var$inner(seriesModel)[componentType] = null;
                    return;
                }
                if (!markerModel) {
                    if (isInit) $c7a34092fe996af9$var$fillLabel(markerOpt);
                    (0, parcelRequire("bahqM")).each(markerOpt.data, function(item) {
                        if (item instanceof Array) {
                            $c7a34092fe996af9$var$fillLabel(item[0]);
                            $c7a34092fe996af9$var$fillLabel(item[1]);
                        } else $c7a34092fe996af9$var$fillLabel(item);
                    });
                    markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel);
                    (0, parcelRequire("bahqM")).extend(markerModel, {
                        mainType: this.mainType,
                        seriesIndex: seriesModel.seriesIndex,
                        name: seriesModel.name,
                        createdBySelf: true
                    });
                    markerModel.__hostSeries = seriesModel;
                } else markerModel._mergeOption(markerOpt, ecModel, true);
                $c7a34092fe996af9$var$inner(seriesModel)[componentType] = markerModel;
            }, this);
        };
        MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
            var data = this.getData();
            var value = this.getRawValue(dataIndex);
            var itemName = data.getName(dataIndex);
            return (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('section', {
                header: this.name,
                blocks: [
                    (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('nameValue', {
                        name: itemName,
                        value: value,
                        noName: !itemName,
                        noValue: value == null
                    })
                ]
            });
        };
        MarkerModel.prototype.getData = function() {
            return this._data;
        };
        MarkerModel.prototype.setData = function(data) {
            this._data = data;
        };
        MarkerModel.getMarkerModelFromSeries = function(seriesModel, componentType) {
            return $c7a34092fe996af9$var$inner(seriesModel)[componentType];
        };
        MarkerModel.type = 'marker';
        MarkerModel.dependencies = [
            'series',
            'grid',
            'polar',
            'geo'
        ];
        return MarkerModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    (0, parcelRequire("bahqM")).mixin($c7a34092fe996af9$var$MarkerModel, (0, (0, parcelRequire("guzSc")).DataFormatMixin).prototype);
    var $c7a34092fe996af9$export$2e2bcd8739ae039 = $c7a34092fe996af9$var$MarkerModel;
});
parcelRegister("ce402", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e69e51972a54af1$export$2e2bcd8739ae039);
    var $3VFsf;
    var $liBXN;
    var $jmSNG;
    var $gjRnj;
    var $2JPY0;
    var $k3pUt;
    var $5R8Hi;
    var $40dMe;
    var $7QjoM;
    var $h8Fle;
    var $bahqM;
    var $eaKsF;
    var $fk5Gm;
    var $8e69e51972a54af1$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $8e69e51972a54af1$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
        var data = seriesModel.getData();
        var itemArray;
        if (!(0, (0, parcelRequire("bahqM")).isArray)(item)) {
            var mlType = item.type;
            if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' || item.xAxis != null || item.yAxis != null) {
                var valueAxis = void 0;
                var value = void 0;
                if (item.yAxis != null || item.xAxis != null) {
                    valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
                    value = (0, (0, parcelRequire("bahqM")).retrieve)(item.yAxis, item.xAxis);
                } else {
                    var axisInfo = (0, parcelRequire("gjRnj")).getAxisInfo(item, data, coordSys, seriesModel);
                    valueAxis = axisInfo.valueAxis;
                    var valueDataDim = (0, (0, parcelRequire("5R8Hi")).getStackedDimension)(data, axisInfo.valueDataDim);
                    value = (0, parcelRequire("gjRnj")).numCalculate(data, valueDataDim, mlType);
                }
                var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
                var baseIndex = 1 - valueIndex;
                var mlFrom = (0, (0, parcelRequire("bahqM")).clone)(item);
                var mlTo = {
                    coord: []
                };
                mlFrom.type = null;
                mlFrom.coord = [];
                mlFrom.coord[baseIndex] = -Infinity;
                mlTo.coord[baseIndex] = Infinity;
                var precision = mlModel.get('precision');
                if (precision >= 0 && typeof value === 'number') value = +value.toFixed(Math.min(precision, 20));
                mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
                itemArray = [
                    mlFrom,
                    mlTo,
                    {
                        type: mlType,
                        valueIndex: item.valueIndex,
                        value: value
                    }
                ];
            } else itemArray = [];
        } else itemArray = item;
        var normalizedItem = [
            (0, parcelRequire("gjRnj")).dataTransform(seriesModel, itemArray[0]),
            (0, parcelRequire("gjRnj")).dataTransform(seriesModel, itemArray[1]),
            (0, (0, parcelRequire("bahqM")).extend)({}, itemArray[2])
        ];
        normalizedItem[2].type = normalizedItem[2].type || null;
        (0, (0, parcelRequire("bahqM")).merge)(normalizedItem[2], normalizedItem[0]);
        (0, (0, parcelRequire("bahqM")).merge)(normalizedItem[2], normalizedItem[1]);
        return normalizedItem;
    };
    function $8e69e51972a54af1$var$isInifinity(val) {
        return !isNaN(val) && !isFinite(val);
    }
    function $8e69e51972a54af1$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
        var otherDimIndex = 1 - dimIndex;
        var dimName = coordSys.dimensions[dimIndex];
        return $8e69e51972a54af1$var$isInifinity(fromCoord[otherDimIndex]) && $8e69e51972a54af1$var$isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
    }
    function $8e69e51972a54af1$var$markLineFilter(coordSys, item) {
        if (coordSys.type === 'cartesian2d') {
            var fromCoord = item[0].coord;
            var toCoord = item[1].coord;
            if (fromCoord && toCoord && ($8e69e51972a54af1$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $8e69e51972a54af1$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
        }
        return (0, parcelRequire("gjRnj")).dataFilter(coordSys, item[0]) && (0, parcelRequire("gjRnj")).dataFilter(coordSys, item[1]);
    }
    function $8e69e51972a54af1$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var itemModel = data.getItemModel(idx);
        var point;
        var xPx = (0, parcelRequire("jmSNG")).parsePercent(itemModel.get('x'), api.getWidth());
        var yPx = (0, parcelRequire("jmSNG")).parsePercent(itemModel.get('y'), api.getHeight());
        if (!isNaN(xPx) && !isNaN(yPx)) point = [
            xPx,
            yPx
        ];
        else {
            if (seriesModel.getMarkerPosition) point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
            else {
                var dims = coordSys.dimensions;
                var x = data.get(dims[0], idx);
                var y = data.get(dims[1], idx);
                point = coordSys.dataToPoint([
                    x,
                    y
                ]);
            }
            if ((0, (0, parcelRequire("40dMe")).isCoordinateSystemType)(coordSys, 'cartesian2d')) {
                var xAxis = coordSys.getAxis('x');
                var yAxis = coordSys.getAxis('y');
                var dims = coordSys.dimensions;
                if ($8e69e51972a54af1$var$isInifinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
                else if ($8e69e51972a54af1$var$isInifinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
            }
            if (!isNaN(xPx)) point[0] = xPx;
            if (!isNaN(yPx)) point[1] = yPx;
        }
        data.setItemLayout(idx, point);
    }
    var $8e69e51972a54af1$var$MarkLineView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MarkLineView, _super);
        function MarkLineView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = MarkLineView.type;
            return _this;
        }
        MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
            ecModel.eachSeries(function(seriesModel) {
                var mlModel = (0, (0, parcelRequire("h8Fle")).default).getMarkerModelFromSeries(seriesModel, 'markLine');
                if (mlModel) {
                    var mlData_1 = mlModel.getData();
                    var fromData_1 = $8e69e51972a54af1$var$inner(mlModel).from;
                    var toData_1 = $8e69e51972a54af1$var$inner(mlModel).to;
                    fromData_1.each(function(idx) {
                        $8e69e51972a54af1$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                        $8e69e51972a54af1$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                    });
                    mlData_1.each(function(idx) {
                        mlData_1.setItemLayout(idx, [
                            fromData_1.getItemLayout(idx),
                            toData_1.getItemLayout(idx)
                        ]);
                    });
                    this.markerGroupMap.get(seriesModel.id).updateLayout();
                }
            }, this);
        };
        MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
            var coordSys = seriesModel.coordinateSystem;
            var seriesId = seriesModel.id;
            var seriesData = seriesModel.getData();
            var lineDrawMap = this.markerGroupMap;
            var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, (0, parcelRequire("2JPY0")).default)());
            this.group.add(lineDraw.group);
            var mlData = $8e69e51972a54af1$var$createList(coordSys, seriesModel, mlModel);
            var fromData = mlData.from;
            var toData = mlData.to;
            var lineData = mlData.line;
            $8e69e51972a54af1$var$inner(mlModel).from = fromData;
            $8e69e51972a54af1$var$inner(mlModel).to = toData;
            mlModel.setData(lineData);
            var symbolType = mlModel.get('symbol');
            var symbolSize = mlModel.get('symbolSize');
            var symbolRotate = mlModel.get('symbolRotate');
            var symbolOffset = mlModel.get('symbolOffset');
            if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolType)) symbolType = [
                symbolType,
                symbolType
            ];
            if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolSize)) symbolSize = [
                symbolSize,
                symbolSize
            ];
            if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolRotate)) symbolRotate = [
                symbolRotate,
                symbolRotate
            ];
            if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolOffset)) symbolOffset = [
                symbolOffset,
                symbolOffset
            ];
            mlData.from.each(function(idx) {
                updateDataVisualAndLayout(fromData, idx, true);
                updateDataVisualAndLayout(toData, idx, false);
            });
            lineData.each(function(idx) {
                var lineStyle = lineData.getItemModel(idx).getModel('lineStyle').getLineStyle();
                lineData.setItemLayout(idx, [
                    fromData.getItemLayout(idx),
                    toData.getItemLayout(idx)
                ]);
                if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
                lineData.setItemVisual(idx, {
                    fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
                    fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
                    fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
                    fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
                    fromSymbol: fromData.getItemVisual(idx, 'symbol'),
                    toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
                    toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
                    toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
                    toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
                    toSymbol: toData.getItemVisual(idx, 'symbol'),
                    style: lineStyle
                });
            });
            lineDraw.updateData(lineData);
            mlData.line.eachItemGraphicEl(function(el, idx) {
                el.traverse(function(child) {
                    (0, (0, parcelRequire("7QjoM")).getECData)(child).dataModel = mlModel;
                });
            });
            function updateDataVisualAndLayout(data, idx, isFrom) {
                var itemModel = data.getItemModel(idx);
                $8e69e51972a54af1$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
                var style = itemModel.getModel('itemStyle').getItemStyle();
                if (style.fill == null) style.fill = (0, (0, parcelRequire("fk5Gm")).getVisualFromData)(seriesData, 'color');
                data.setItemVisual(idx, {
                    symbolKeepAspect: itemModel.get('symbolKeepAspect'),
                    symbolOffset: (0, (0, parcelRequire("bahqM")).retrieve2)(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
                    symbolRotate: (0, (0, parcelRequire("bahqM")).retrieve2)(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
                    symbolSize: (0, (0, parcelRequire("bahqM")).retrieve2)(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
                    symbol: (0, (0, parcelRequire("bahqM")).retrieve2)(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
                    style: style
                });
            }
            this.markKeep(lineDraw);
            lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
        };
        MarkLineView.type = 'markLine';
        return MarkLineView;
    }((0, (0, parcelRequire("k3pUt")).default));
    function $8e69e51972a54af1$var$createList(coordSys, seriesModel, mlModel) {
        var coordDimsInfos;
        if (coordSys) coordDimsInfos = (0, (0, parcelRequire("bahqM")).map)(coordSys && coordSys.dimensions, function(coordDim) {
            var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
            return (0, (0, parcelRequire("bahqM")).extend)((0, (0, parcelRequire("bahqM")).extend)({}, info), {
                name: coordDim,
                ordinalMeta: null
            });
        });
        else coordDimsInfos = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        var fromData = new (0, (0, parcelRequire("liBXN")).default)(coordDimsInfos, mlModel);
        var toData = new (0, (0, parcelRequire("liBXN")).default)(coordDimsInfos, mlModel);
        var lineData = new (0, (0, parcelRequire("liBXN")).default)([], mlModel);
        var optData = (0, (0, parcelRequire("bahqM")).map)(mlModel.get('data'), (0, (0, parcelRequire("bahqM")).curry)($8e69e51972a54af1$var$markLineTransform, seriesModel, coordSys, mlModel));
        if (coordSys) optData = (0, (0, parcelRequire("bahqM")).filter)(optData, (0, (0, parcelRequire("bahqM")).curry)($8e69e51972a54af1$var$markLineFilter, coordSys));
        var dimValueGetter = (0, parcelRequire("gjRnj")).createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
        fromData.initData((0, (0, parcelRequire("bahqM")).map)(optData, function(item) {
            return item[0];
        }), null, dimValueGetter);
        toData.initData((0, (0, parcelRequire("bahqM")).map)(optData, function(item) {
            return item[1];
        }), null, dimValueGetter);
        lineData.initData((0, (0, parcelRequire("bahqM")).map)(optData, function(item) {
            return item[2];
        }));
        lineData.hasItemOption = true;
        return {
            from: fromData,
            to: toData,
            line: lineData
        };
    }
    var $8e69e51972a54af1$export$2e2bcd8739ae039 = $8e69e51972a54af1$var$MarkLineView;
});
parcelRegister("gjRnj", function(module, exports) {
    $parcel$export(module.exports, "numCalculate", ()=>$be17d2d7c679ee45$export$18ddefb55c03640b);
    $parcel$export(module.exports, "dataTransform", ()=>$be17d2d7c679ee45$export$3eebd2d54b98c04f);
    $parcel$export(module.exports, "getAxisInfo", ()=>$be17d2d7c679ee45$export$bd39458db76002ab);
    $parcel$export(module.exports, "dataFilter", ()=>$be17d2d7c679ee45$export$179695f4a9040f73);
    $parcel$export(module.exports, "createMarkerDimValueGetter", ()=>$be17d2d7c679ee45$export$a53767c3c8f69cf7);
    var $jmSNG;
    var $5R8Hi;
    var $bahqM;
    var $2G90t;
    function $be17d2d7c679ee45$var$hasXOrY(item) {
        return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
    }
    function $be17d2d7c679ee45$var$hasXAndY(item) {
        return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
    }
    function $be17d2d7c679ee45$var$markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
        var coordArr = [];
        var stacked = (0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, targetDataDim);
        var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
        var value = $be17d2d7c679ee45$export$18ddefb55c03640b(data, calcDataDim, markerType);
        var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
        coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
        coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
        var coordArrValue = data.get(targetDataDim, dataIndex);
        var precision = (0, parcelRequire("jmSNG")).getPrecision(data.get(targetDataDim, dataIndex));
        precision = Math.min(precision, 20);
        if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
        return [
            coordArr,
            coordArrValue
        ];
    }
    var $be17d2d7c679ee45$var$markerTypeCalculator = {
        min: (0, (0, parcelRequire("bahqM")).curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'min'),
        max: (0, (0, parcelRequire("bahqM")).curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'max'),
        average: (0, (0, parcelRequire("bahqM")).curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'average'),
        median: (0, (0, parcelRequire("bahqM")).curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'median')
    };
    function $be17d2d7c679ee45$export$3eebd2d54b98c04f(seriesModel, item) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        if (item && !$be17d2d7c679ee45$var$hasXAndY(item) && !(0, (0, parcelRequire("bahqM")).isArray)(item.coord) && coordSys) {
            var dims = coordSys.dimensions;
            var axisInfo = $be17d2d7c679ee45$export$bd39458db76002ab(item, data, coordSys, seriesModel);
            item = (0, (0, parcelRequire("bahqM")).clone)(item);
            if (item.type && $be17d2d7c679ee45$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
                var otherCoordIndex = (0, (0, parcelRequire("bahqM")).indexOf)(dims, axisInfo.baseAxis.dim);
                var targetCoordIndex = (0, (0, parcelRequire("bahqM")).indexOf)(dims, axisInfo.valueAxis.dim);
                var coordInfo = $be17d2d7c679ee45$var$markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
                item.coord = coordInfo[0];
                item.value = coordInfo[1];
            } else {
                var coord = [
                    item.xAxis != null ? item.xAxis : item.radiusAxis,
                    item.yAxis != null ? item.yAxis : item.angleAxis
                ];
                for(var i = 0; i < 2; i++)if ($be17d2d7c679ee45$var$markerTypeCalculator[coord[i]]) coord[i] = $be17d2d7c679ee45$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
                item.coord = coord;
            }
        }
        return item;
    }
    function $be17d2d7c679ee45$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
        var ret = {};
        if (item.valueIndex != null || item.valueDim != null) {
            ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
            ret.valueAxis = coordSys.getAxis($be17d2d7c679ee45$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
            ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
            ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        } else {
            ret.baseAxis = seriesModel.getBaseAxis();
            ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
            ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
            ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
        }
        return ret;
    }
    function $be17d2d7c679ee45$var$dataDimToCoordDim(seriesModel, dataDim) {
        var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
        return dimItem && dimItem.coordDim;
    }
    function $be17d2d7c679ee45$export$179695f4a9040f73(coordSys, item) {
        return coordSys && coordSys.containData && item.coord && !$be17d2d7c679ee45$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
    }
    function $be17d2d7c679ee45$export$a53767c3c8f69cf7(inCoordSys, dims) {
        return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
            var rawVal = dimIndex < 2 ? item.coord && item.coord[dimIndex] : item.value;
            return (0, (0, parcelRequire("2G90t")).parseDataValue)(rawVal, dims[dimIndex]);
        } : function(item, dimName, dataIndex, dimIndex) {
            return (0, (0, parcelRequire("2G90t")).parseDataValue)(item.value, dims[dimIndex]);
        };
    }
    function $be17d2d7c679ee45$export$18ddefb55c03640b(data, valueDataDim, type) {
        if (type === 'average') {
            var sum_1 = 0;
            var count_1 = 0;
            data.each(valueDataDim, function(val, idx) {
                if (!isNaN(val)) {
                    sum_1 += val;
                    count_1++;
                }
            });
            return sum_1 / count_1;
        } else if (type === 'median') return data.getMedian(valueDataDim);
        else return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
    }
});
parcelRegister("2JPY0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1fe8183fc890aada$export$2e2bcd8739ae039);
    var $4KVOr;
    var $hKTLM;
    var $gvLUt;
    var $1fe8183fc890aada$var$LineDraw = function() {
        function LineDraw(LineCtor) {
            this.group = new (0, parcelRequire("4KVOr")).default();
            this._LineCtor = LineCtor || (0, (0, parcelRequire("hKTLM")).default);
        }
        LineDraw.prototype.isPersistent = function() {
            return true;
        };
        LineDraw.prototype.updateData = function(lineData) {
            var _this = this;
            var lineDraw = this;
            var group = lineDraw.group;
            var oldLineData = lineDraw._lineData;
            lineDraw._lineData = lineData;
            if (!oldLineData) group.removeAll();
            var seriesScope = $1fe8183fc890aada$var$makeSeriesScope(lineData);
            lineData.diff(oldLineData).add(function(idx) {
                _this._doAdd(lineData, idx, seriesScope);
            }).update(function(newIdx, oldIdx) {
                _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
            }).remove(function(idx) {
                group.remove(oldLineData.getItemGraphicEl(idx));
            }).execute();
        };
        LineDraw.prototype.updateLayout = function() {
            var lineData = this._lineData;
            if (!lineData) return;
            lineData.eachItemGraphicEl(function(el, idx) {
                el.updateLayout(lineData, idx);
            }, this);
        };
        LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
            this._seriesScope = $1fe8183fc890aada$var$makeSeriesScope(lineData);
            this._lineData = null;
            this.group.removeAll();
        };
        LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
            function updateIncrementalAndHover(el) {
                if (!el.isGroup && !$1fe8183fc890aada$var$isEffectObject(el)) {
                    el.incremental = true;
                    el.ensureState('emphasis').hoverLayer = true;
                }
            }
            for(var idx = taskParams.start; idx < taskParams.end; idx++){
                var itemLayout = lineData.getItemLayout(idx);
                if ($1fe8183fc890aada$var$lineNeedsDraw(itemLayout)) {
                    var el = new this._LineCtor(lineData, idx, this._seriesScope);
                    el.traverse(updateIncrementalAndHover);
                    this.group.add(el);
                    lineData.setItemGraphicEl(idx, el);
                }
            }
        };
        LineDraw.prototype.remove = function() {
            this.group.removeAll();
        };
        LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
            var itemLayout = lineData.getItemLayout(idx);
            if (!$1fe8183fc890aada$var$lineNeedsDraw(itemLayout)) return;
            var el = new this._LineCtor(lineData, idx, seriesScope);
            lineData.setItemGraphicEl(idx, el);
            this.group.add(el);
        };
        LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
            var itemEl = oldLineData.getItemGraphicEl(oldIdx);
            if (!$1fe8183fc890aada$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
                this.group.remove(itemEl);
                return;
            }
            if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
            else itemEl.updateData(newLineData, newIdx, seriesScope);
            newLineData.setItemGraphicEl(newIdx, itemEl);
            this.group.add(itemEl);
        };
        return LineDraw;
    }();
    function $1fe8183fc890aada$var$isEffectObject(el) {
        return el.animators && el.animators.length > 0;
    }
    function $1fe8183fc890aada$var$makeSeriesScope(lineData) {
        var hostModel = lineData.hostModel;
        return {
            lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
            emphasisLineStyle: hostModel.getModel([
                'emphasis',
                'lineStyle'
            ]).getLineStyle(),
            blurLineStyle: hostModel.getModel([
                'blur',
                'lineStyle'
            ]).getLineStyle(),
            selectLineStyle: hostModel.getModel([
                'select',
                'lineStyle'
            ]).getLineStyle(),
            labelStatesModels: (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(hostModel)
        };
    }
    function $1fe8183fc890aada$var$isPointNaN(pt) {
        return isNaN(pt[0]) || isNaN(pt[1]);
    }
    function $1fe8183fc890aada$var$lineNeedsDraw(pts) {
        return !$1fe8183fc890aada$var$isPointNaN(pts[0]) && !$1fe8183fc890aada$var$isPointNaN(pts[1]);
    }
    var $1fe8183fc890aada$export$2e2bcd8739ae039 = $1fe8183fc890aada$var$LineDraw;
});
parcelRegister("hKTLM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ced1fe40d771d409$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $eLEew;
    var $7yklO;
    var $iUQRt;
    var $4KVOr;
    var $eYgMC;
    parcelRequire("fHITF");
    var $eYgMC;
    var $fIXXx;
    var $gvLUt;
    var $jmSNG;
    var $ced1fe40d771d409$var$SYMBOL_CATEGORIES = [
        'fromSymbol',
        'toSymbol'
    ];
    function $ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory) {
        return '_' + symbolCategory + 'Type';
    }
    function $ced1fe40d771d409$var$createSymbol(name, lineData, idx) {
        var symbolType = lineData.getItemVisual(idx, name);
        if (!symbolType || symbolType === 'none') return;
        var symbolSize = lineData.getItemVisual(idx, name + 'Size');
        var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
        var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
        var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
        var symbolSizeArr = (0, parcelRequire("7yklO")).normalizeSymbolSize(symbolSize);
        var symbolOffsetArr = (0, parcelRequire("7yklO")).normalizeSymbolOffset(symbolOffset || 0, symbolSizeArr);
        var symbolPath = (0, parcelRequire("7yklO")).createSymbol(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
        symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
        symbolPath.name = name;
        return symbolPath;
    }
    function $ced1fe40d771d409$var$createLine(points) {
        var line = new (0, (0, parcelRequire("iUQRt")).default)({
            name: 'line',
            subPixelOptimize: true
        });
        $ced1fe40d771d409$var$setLinePoints(line.shape, points);
        return line;
    }
    function $ced1fe40d771d409$var$setLinePoints(targetShape, points) {
        targetShape.x1 = points[0][0];
        targetShape.y1 = points[0][1];
        targetShape.x2 = points[1][0];
        targetShape.y2 = points[1][1];
        targetShape.percent = 1;
        var cp1 = points[2];
        if (cp1) {
            targetShape.cpx1 = cp1[0];
            targetShape.cpy1 = cp1[1];
        } else {
            targetShape.cpx1 = NaN;
            targetShape.cpy1 = NaN;
        }
    }
    var $ced1fe40d771d409$var$Line = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Line, _super);
        function Line(lineData, idx, seriesScope) {
            var _this = _super.call(this) || this;
            _this._createLine(lineData, idx, seriesScope);
            return _this;
        }
        Line.prototype._createLine = function(lineData, idx, seriesScope) {
            var seriesModel = lineData.hostModel;
            var linePoints = lineData.getItemLayout(idx);
            var line = $ced1fe40d771d409$var$createLine(linePoints);
            line.shape.percent = 0;
            (0, parcelRequire("eYgMC")).initProps(line, {
                shape: {
                    percent: 1
                }
            }, seriesModel, idx);
            this.add(line);
            (0, (0, parcelRequire("bahqM")).each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
                var symbol = $ced1fe40d771d409$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
                this[$ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
            }, this);
            this._updateCommonStl(lineData, idx, seriesScope);
        };
        Line.prototype.updateData = function(lineData, idx, seriesScope) {
            var seriesModel = lineData.hostModel;
            var line = this.childOfName('line');
            var linePoints = lineData.getItemLayout(idx);
            var target = {
                shape: {}
            };
            $ced1fe40d771d409$var$setLinePoints(target.shape, linePoints);
            (0, parcelRequire("eYgMC")).updateProps(line, target, seriesModel, idx);
            (0, (0, parcelRequire("bahqM")).each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
                var symbolType = lineData.getItemVisual(idx, symbolCategory);
                var key = $ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory);
                if (this[key] !== symbolType) {
                    this.remove(this.childOfName(symbolCategory));
                    var symbol = $ced1fe40d771d409$var$createSymbol(symbolCategory, lineData, idx);
                    this.add(symbol);
                }
                this[key] = symbolType;
            }, this);
            this._updateCommonStl(lineData, idx, seriesScope);
        };
        Line.prototype.getLinePath = function() {
            return this.childAt(0);
        };
        Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
            var seriesModel = lineData.hostModel;
            var line = this.childOfName('line');
            var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
            var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
            var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
            var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
            if (!seriesScope || lineData.hasItemOption) {
                var itemModel = lineData.getItemModel(idx);
                emphasisLineStyle = itemModel.getModel([
                    'emphasis',
                    'lineStyle'
                ]).getLineStyle();
                blurLineStyle = itemModel.getModel([
                    'blur',
                    'lineStyle'
                ]).getLineStyle();
                selectLineStyle = itemModel.getModel([
                    'select',
                    'lineStyle'
                ]).getLineStyle();
                labelStatesModels = (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(itemModel);
            }
            var lineStyle = lineData.getItemVisual(idx, 'style');
            var visualColor = lineStyle.stroke;
            line.useStyle(lineStyle);
            line.style.fill = null;
            line.style.strokeNoScale = true;
            line.ensureState('emphasis').style = emphasisLineStyle;
            line.ensureState('blur').style = blurLineStyle;
            line.ensureState('select').style = selectLineStyle;
            (0, (0, parcelRequire("bahqM")).each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
                var symbol = this.childOfName(symbolCategory);
                if (symbol) {
                    symbol.setColor(visualColor);
                    symbol.style.opacity = lineStyle.opacity;
                    for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
                        var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
                        var lineState = line.getState(stateName);
                        if (lineState) {
                            var lineStateStyle = lineState.style || {};
                            var state = symbol.ensureState(stateName);
                            var stateStyle = state.style || (state.style = {});
                            if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
                            if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                        }
                    }
                    symbol.markRedraw();
                }
            }, this);
            var rawVal = seriesModel.getRawValue(idx);
            (0, (0, parcelRequire("gvLUt")).setLabelStyle)(this, labelStatesModels, {
                labelDataIndex: idx,
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                    }
                },
                inheritColor: visualColor || '#000',
                defaultOpacity: lineStyle.opacity,
                defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, (0, parcelRequire("jmSNG")).round)(rawVal) : rawVal) + ''
            });
            var label = this.getTextContent();
            if (label) {
                var labelNormalModel = labelStatesModels.normal;
                label.__align = label.style.align;
                label.__verticalAlign = label.style.verticalAlign;
                label.__position = labelNormalModel.get('position') || 'middle';
                var distance = labelNormalModel.get('distance');
                if (!(0, (0, parcelRequire("bahqM")).isArray)(distance)) distance = [
                    distance,
                    distance
                ];
                label.__labelDistance = distance;
            }
            this.setTextConfig({
                position: null,
                local: true,
                inside: false
            });
            (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(this);
        };
        Line.prototype.highlight = function() {
            (0, (0, parcelRequire("fIXXx")).enterEmphasis)(this);
        };
        Line.prototype.downplay = function() {
            (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(this);
        };
        Line.prototype.updateLayout = function(lineData, idx) {
            this.setLinePoints(lineData.getItemLayout(idx));
        };
        Line.prototype.setLinePoints = function(points) {
            var linePath = this.childOfName('line');
            $ced1fe40d771d409$var$setLinePoints(linePath.shape, points);
            linePath.dirty();
        };
        Line.prototype.beforeUpdate = function() {
            var lineGroup = this;
            var symbolFrom = lineGroup.childOfName('fromSymbol');
            var symbolTo = lineGroup.childOfName('toSymbol');
            var label = lineGroup.getTextContent();
            if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
            var invScale = 1;
            var parentNode = this.parent;
            while(parentNode){
                if (parentNode.scaleX) invScale /= parentNode.scaleX;
                parentNode = parentNode.parent;
            }
            var line = lineGroup.childOfName('line');
            if (!this.__dirty && !line.__dirty) return;
            var percent = line.shape.percent;
            var fromPos = line.pointAt(0);
            var toPos = line.pointAt(percent);
            var d = (0, parcelRequire("eLEew")).sub([], toPos, fromPos);
            (0, parcelRequire("eLEew")).normalize(d, d);
            function setSymbolRotation(symbol, percent) {
                var specifiedRotation = symbol.__specifiedRotation;
                if (specifiedRotation == null) {
                    var tangent = line.tangentAt(percent);
                    symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
                } else symbol.attr('rotation', specifiedRotation);
            }
            if (symbolFrom) {
                symbolFrom.setPosition(fromPos);
                setSymbolRotation(symbolFrom, 0);
                symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
                symbolFrom.markRedraw();
            }
            if (symbolTo) {
                symbolTo.setPosition(toPos);
                setSymbolRotation(symbolTo, 1);
                symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
                symbolTo.markRedraw();
            }
            if (label && !label.ignore) {
                label.x = label.y = 0;
                label.originX = label.originY = 0;
                var textAlign = void 0;
                var textVerticalAlign = void 0;
                var distance = label.__labelDistance;
                var distanceX = distance[0] * invScale;
                var distanceY = distance[1] * invScale;
                var halfPercent = percent / 2;
                var tangent = line.tangentAt(halfPercent);
                var n = [
                    tangent[1],
                    -tangent[0]
                ];
                var cp = line.pointAt(halfPercent);
                if (n[1] > 0) {
                    n[0] = -n[0];
                    n[1] = -n[1];
                }
                var dir = tangent[0] < 0 ? -1 : 1;
                if (label.__position !== 'start' && label.__position !== 'end') {
                    var rotation = -Math.atan2(tangent[1], tangent[0]);
                    if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                    label.rotation = rotation;
                }
                var dy = void 0;
                switch(label.__position){
                    case 'insideStartTop':
                    case 'insideMiddleTop':
                    case 'insideEndTop':
                    case 'middle':
                        dy = -distanceY;
                        textVerticalAlign = 'bottom';
                        break;
                    case 'insideStartBottom':
                    case 'insideMiddleBottom':
                    case 'insideEndBottom':
                        dy = distanceY;
                        textVerticalAlign = 'top';
                        break;
                    default:
                        dy = 0;
                        textVerticalAlign = 'middle';
                }
                switch(label.__position){
                    case 'end':
                        label.x = d[0] * distanceX + toPos[0];
                        label.y = d[1] * distanceY + toPos[1];
                        textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
                        textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
                        break;
                    case 'start':
                        label.x = -d[0] * distanceX + fromPos[0];
                        label.y = -d[1] * distanceY + fromPos[1];
                        textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
                        textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
                        break;
                    case 'insideStartTop':
                    case 'insideStart':
                    case 'insideStartBottom':
                        label.x = distanceX * dir + fromPos[0];
                        label.y = fromPos[1] + dy;
                        textAlign = tangent[0] < 0 ? 'right' : 'left';
                        label.originX = -distanceX * dir;
                        label.originY = -dy;
                        break;
                    case 'insideMiddleTop':
                    case 'insideMiddle':
                    case 'insideMiddleBottom':
                    case 'middle':
                        label.x = cp[0];
                        label.y = cp[1] + dy;
                        textAlign = 'center';
                        label.originY = -dy;
                        break;
                    case 'insideEndTop':
                    case 'insideEnd':
                    case 'insideEndBottom':
                        label.x = -distanceX * dir + toPos[0];
                        label.y = toPos[1] + dy;
                        textAlign = tangent[0] >= 0 ? 'right' : 'left';
                        label.originX = distanceX * dir;
                        label.originY = -dy;
                        break;
                }
                label.scaleX = label.scaleY = invScale;
                label.setStyle({
                    verticalAlign: label.__verticalAlign || textVerticalAlign,
                    align: label.__align || textAlign
                });
            }
        };
        return Line;
    }((0, parcelRequire("4KVOr")).default);
    var $ced1fe40d771d409$export$2e2bcd8739ae039 = $ced1fe40d771d409$var$Line;
});
parcelRegister("iUQRt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc56761fbff4269e$export$2e2bcd8739ae039);
    var $3VFsf;
    parcelRequire("fHITF");
    var $04gw0;
    var $cZb1F;
    var $ghQ8v;
    var $eLEew;
    var $dc56761fbff4269e$var$straightLineProto = (0, parcelRequire("cZb1F")).default.prototype;
    var $dc56761fbff4269e$var$bezierCurveProto = (0, parcelRequire("04gw0")).default.prototype;
    var $dc56761fbff4269e$var$StraightLineShape = function() {
        function StraightLineShape() {
            this.x1 = 0;
            this.y1 = 0;
            this.x2 = 0;
            this.y2 = 0;
            this.percent = 1;
        }
        return StraightLineShape;
    }();
    var $dc56761fbff4269e$var$CurveShape = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CurveShape, _super);
        function CurveShape() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return CurveShape;
    }($dc56761fbff4269e$var$StraightLineShape);
    function $dc56761fbff4269e$var$isStraightLine(shape) {
        return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
    }
    var $dc56761fbff4269e$var$ECLinePath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECLinePath, _super);
        function ECLinePath(opts) {
            var _this = _super.call(this, opts) || this;
            _this.type = 'ec-line';
            return _this;
        }
        ECLinePath.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        ECLinePath.prototype.getDefaultShape = function() {
            return new $dc56761fbff4269e$var$StraightLineShape();
        };
        ECLinePath.prototype.buildPath = function(ctx, shape) {
            if ($dc56761fbff4269e$var$isStraightLine(shape)) $dc56761fbff4269e$var$straightLineProto.buildPath.call(this, ctx, shape);
            else $dc56761fbff4269e$var$bezierCurveProto.buildPath.call(this, ctx, shape);
        };
        ECLinePath.prototype.pointAt = function(t) {
            if ($dc56761fbff4269e$var$isStraightLine(this.shape)) return $dc56761fbff4269e$var$straightLineProto.pointAt.call(this, t);
            else return $dc56761fbff4269e$var$bezierCurveProto.pointAt.call(this, t);
        };
        ECLinePath.prototype.tangentAt = function(t) {
            var shape = this.shape;
            var p = $dc56761fbff4269e$var$isStraightLine(shape) ? [
                shape.x2 - shape.x1,
                shape.y2 - shape.y1
            ] : $dc56761fbff4269e$var$bezierCurveProto.tangentAt.call(this, t);
            return (0, parcelRequire("eLEew")).normalize(p, p);
        };
        return ECLinePath;
    }((0, parcelRequire("ghQ8v")).default);
    var $dc56761fbff4269e$export$2e2bcd8739ae039 = $dc56761fbff4269e$var$ECLinePath;
});
parcelRegister("k3pUt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9982f98742e3477$export$2e2bcd8739ae039);
    var $3VFsf;
    var $fkskt;
    var $bahqM;
    var $h8Fle;
    var $eaKsF;
    var $fIXXx;
    var $e9982f98742e3477$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $e9982f98742e3477$var$MarkerView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MarkerView, _super);
        function MarkerView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = MarkerView.type;
            return _this;
        }
        MarkerView.prototype.init = function() {
            this.markerGroupMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        };
        MarkerView.prototype.render = function(markerModel, ecModel, api) {
            var _this = this;
            var markerGroupMap = this.markerGroupMap;
            markerGroupMap.each(function(item) {
                $e9982f98742e3477$var$inner(item).keep = false;
            });
            ecModel.eachSeries(function(seriesModel) {
                var markerModel = (0, (0, parcelRequire("h8Fle")).default).getMarkerModelFromSeries(seriesModel, _this.type);
                markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
            });
            markerGroupMap.each(function(item) {
                !$e9982f98742e3477$var$inner(item).keep && _this.group.remove(item.group);
            });
        };
        MarkerView.prototype.markKeep = function(drawGroup) {
            $e9982f98742e3477$var$inner(drawGroup).keep = true;
        };
        MarkerView.prototype.blurSeries = function(seriesModelList) {
            var _this = this;
            (0, (0, parcelRequire("bahqM")).each)(seriesModelList, function(seriesModel) {
                var markerModel = (0, (0, parcelRequire("h8Fle")).default).getMarkerModelFromSeries(seriesModel, _this.type);
                if (markerModel) {
                    var data = markerModel.getData();
                    data.eachItemGraphicEl(function(el) {
                        if (el) (0, (0, parcelRequire("fIXXx")).enterBlur)(el);
                    });
                }
            });
        };
        MarkerView.type = 'marker';
        return MarkerView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $e9982f98742e3477$export$2e2bcd8739ae039 = $e9982f98742e3477$var$MarkerView;
});
parcelRegister("gLj36", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$c33fcfdcc4592871$export$4b3e715f166fdd78);
    var $hi3Y7;
    var $alpND;
    var $ixwqj;
    var $kfWc4;
    function $c33fcfdcc4592871$export$4b3e715f166fdd78(registers) {
        (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("hi3Y7")).install));
        registers.registerComponentModel((0, (0, parcelRequire("ixwqj")).default));
        registers.registerComponentView((0, (0, parcelRequire("kfWc4")).default));
        registers.registerAction({
            type: 'showTip',
            event: 'showTip',
            update: 'tooltip:manuallyShowTip'
        }, function() {});
        registers.registerAction({
            type: 'hideTip',
            event: 'hideTip',
            update: 'tooltip:manuallyHideTip'
        }, function() {});
    }
});
parcelRegister("hi3Y7", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$c9673230869c3336$export$4b3e715f166fdd78);
    var $atJL7;
    var $4SGoL;
    var $5UrR7;
    var $gPvBV;
    var $bahqM;
    var $8QSpd;
    var $5TxwA;
    function $c9673230869c3336$export$4b3e715f166fdd78(registers) {
        (0, (0, parcelRequire("atJL7")).default).registerAxisPointerClass('CartesianAxisPointer', (0, (0, parcelRequire("4SGoL")).default));
        registers.registerComponentModel((0, (0, parcelRequire("5UrR7")).default));
        registers.registerComponentView((0, (0, parcelRequire("gPvBV")).default));
        registers.registerPreprocessor(function(option) {
            if (option) {
                (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
                var link = option.axisPointer.link;
                if (link && !(0, (0, parcelRequire("bahqM")).isArray)(link)) option.axisPointer.link = [
                    link
                ];
            }
        });
        registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
            ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, (0, parcelRequire("8QSpd")).collect)(ecModel, api);
        });
        registers.registerAction({
            type: 'updateAxisPointer',
            event: 'updateAxisPointer',
            update: ':updateAxisPointer'
        }, (0, (0, parcelRequire("5TxwA")).default));
    }
});
parcelRegister("4SGoL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38dd17fca85a901b$export$2e2bcd8739ae039);
    var $3VFsf;
    var $fOZs6;
    var $eSE0c;
    var $dBIJY;
    var $38dd17fca85a901b$var$CartesianAxisPointer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianAxisPointer, _super);
        function CartesianAxisPointer() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
            var axis = axisModel.axis;
            var grid = axis.grid;
            var axisPointerType = axisPointerModel.get('type');
            var otherExtent = $38dd17fca85a901b$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
            var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
            if (axisPointerType && axisPointerType !== 'none') {
                var elStyle = (0, parcelRequire("eSE0c")).buildElStyle(axisPointerModel);
                var pointerOption = $38dd17fca85a901b$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
                pointerOption.style = elStyle;
                elOption.graphicKey = pointerOption.type;
                elOption.pointer = pointerOption;
            }
            var layoutInfo = (0, parcelRequire("dBIJY")).layout(grid.model, axisModel);
            (0, parcelRequire("eSE0c")).buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
        };
        CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
            var layoutInfo = (0, parcelRequire("dBIJY")).layout(axisModel.axis.grid.model, axisModel, {
                labelInside: false
            });
            layoutInfo.labelMargin = axisPointerModel.get([
                'handle',
                'margin'
            ]);
            var pos = (0, parcelRequire("eSE0c")).getTransformedPosition(axisModel.axis, value, layoutInfo);
            return {
                x: pos[0],
                y: pos[1],
                rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
            };
        };
        CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
            var axis = axisModel.axis;
            var grid = axis.grid;
            var axisExtent = axis.getGlobalExtent(true);
            var otherExtent = $38dd17fca85a901b$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
            var dimIndex = axis.dim === 'x' ? 0 : 1;
            var currPosition = [
                transform.x,
                transform.y
            ];
            currPosition[dimIndex] += delta[dimIndex];
            currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
            currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
            var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
            var cursorPoint = [
                cursorOtherValue,
                cursorOtherValue
            ];
            cursorPoint[dimIndex] = currPosition[dimIndex];
            var tooltipOptions = [
                {
                    verticalAlign: 'middle'
                },
                {
                    align: 'center'
                }
            ];
            return {
                x: currPosition[0],
                y: currPosition[1],
                rotation: transform.rotation,
                cursorPoint: cursorPoint,
                tooltipOption: tooltipOptions[dimIndex]
            };
        };
        return CartesianAxisPointer;
    }((0, (0, parcelRequire("fOZs6")).default));
    function $38dd17fca85a901b$var$getCartesian(grid, axis) {
        var opt = {};
        opt[axis.dim + 'AxisIndex'] = axis.index;
        return grid.getCartesian(opt);
    }
    var $38dd17fca85a901b$var$pointerShapeBuilder = {
        line: function(axis, pixelValue, otherExtent) {
            var targetShape = (0, parcelRequire("eSE0c")).makeLineShape([
                pixelValue,
                otherExtent[0]
            ], [
                pixelValue,
                otherExtent[1]
            ], $38dd17fca85a901b$var$getAxisDimIndex(axis));
            return {
                type: 'Line',
                subPixelOptimize: true,
                shape: targetShape
            };
        },
        shadow: function(axis, pixelValue, otherExtent) {
            var bandWidth = Math.max(1, axis.getBandWidth());
            var span = otherExtent[1] - otherExtent[0];
            return {
                type: 'Rect',
                shape: (0, parcelRequire("eSE0c")).makeRectShape([
                    pixelValue - bandWidth / 2,
                    otherExtent[0]
                ], [
                    bandWidth,
                    span
                ], $38dd17fca85a901b$var$getAxisDimIndex(axis))
            };
        }
    };
    function $38dd17fca85a901b$var$getAxisDimIndex(axis) {
        return axis.dim === 'x' ? 0 : 1;
    }
    var $38dd17fca85a901b$export$2e2bcd8739ae039 = $38dd17fca85a901b$var$CartesianAxisPointer;
});
parcelRegister("fOZs6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b84b31aa9defeeb8$export$2e2bcd8739ae039);
    var $bahqM;
    var $fHITF;
    var $8QSpd;
    var $65X4x;
    var $ljaBy;
    var $eaKsF;
    var $b84b31aa9defeeb8$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $b84b31aa9defeeb8$var$clone = (0, parcelRequire("bahqM")).clone;
    var $b84b31aa9defeeb8$var$bind = (0, parcelRequire("bahqM")).bind;
    var $b84b31aa9defeeb8$var$BaseAxisPointer = function() {
        function BaseAxisPointer() {
            this._dragging = false;
            this.animationThreshold = 15;
        }
        BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
            var value = axisPointerModel.get('value');
            var status = axisPointerModel.get('status');
            this._axisModel = axisModel;
            this._axisPointerModel = axisPointerModel;
            this._api = api;
            if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
            this._lastValue = value;
            this._lastStatus = status;
            var group = this._group;
            var handle = this._handle;
            if (!status || status === 'hide') {
                group && group.hide();
                handle && handle.hide();
                return;
            }
            group && group.show();
            handle && handle.show();
            var elOption = {};
            this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
            var graphicKey = elOption.graphicKey;
            if (graphicKey !== this._lastGraphicKey) this.clear(api);
            this._lastGraphicKey = graphicKey;
            var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
            if (!group) {
                group = this._group = new (0, parcelRequire("fHITF")).Group();
                this.createPointerEl(group, elOption, axisModel, axisPointerModel);
                this.createLabelEl(group, elOption, axisModel, axisPointerModel);
                api.getZr().add(group);
            } else {
                var doUpdateProps = (0, parcelRequire("bahqM")).curry($b84b31aa9defeeb8$var$updateProps, axisPointerModel, moveAnimation);
                this.updatePointerEl(group, elOption, doUpdateProps);
                this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
            }
            $b84b31aa9defeeb8$var$updateMandatoryProps(group, axisPointerModel, true);
            this._renderHandle(value);
        };
        BaseAxisPointer.prototype.remove = function(api) {
            this.clear(api);
        };
        BaseAxisPointer.prototype.dispose = function(api) {
            this.clear(api);
        };
        BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
            var animation = axisPointerModel.get('animation');
            var axis = axisModel.axis;
            var isCategoryAxis = axis.type === 'category';
            var useSnap = axisPointerModel.get('snap');
            if (!useSnap && !isCategoryAxis) return false;
            if (animation === 'auto' || animation == null) {
                var animationThreshold = this.animationThreshold;
                if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
                if (useSnap) {
                    var seriesDataCount = (0, parcelRequire("8QSpd")).getAxisInfo(axisModel).seriesDataCount;
                    var axisExtent = axis.getExtent();
                    return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
                }
                return false;
            }
            return animation === true;
        };
        BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {};
        BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
            var pointerOption = elOption.pointer;
            if (pointerOption) {
                var pointerEl = $b84b31aa9defeeb8$var$inner(group).pointerEl = new (0, parcelRequire("fHITF"))[pointerOption.type]($b84b31aa9defeeb8$var$clone(elOption.pointer));
                group.add(pointerEl);
            }
        };
        BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
            if (elOption.label) {
                var labelEl = $b84b31aa9defeeb8$var$inner(group).labelEl = new (0, parcelRequire("fHITF")).Text($b84b31aa9defeeb8$var$clone(elOption.label));
                group.add(labelEl);
                $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel);
            }
        };
        BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
            var pointerEl = $b84b31aa9defeeb8$var$inner(group).pointerEl;
            if (pointerEl && elOption.pointer) {
                pointerEl.setStyle(elOption.pointer.style);
                updateProps(pointerEl, {
                    shape: elOption.pointer.shape
                });
            }
        };
        BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
            var labelEl = $b84b31aa9defeeb8$var$inner(group).labelEl;
            if (labelEl) {
                labelEl.setStyle(elOption.label.style);
                updateProps(labelEl, {
                    x: elOption.label.x,
                    y: elOption.label.y
                });
                $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel);
            }
        };
        BaseAxisPointer.prototype._renderHandle = function(value) {
            if (this._dragging || !this.updateHandleTransform) return;
            var axisPointerModel = this._axisPointerModel;
            var zr = this._api.getZr();
            var handle = this._handle;
            var handleModel = axisPointerModel.getModel('handle');
            var status = axisPointerModel.get('status');
            if (!handleModel.get('show') || !status || status === 'hide') {
                handle && zr.remove(handle);
                this._handle = null;
                return;
            }
            var isInit;
            if (!this._handle) {
                isInit = true;
                handle = this._handle = (0, parcelRequire("fHITF")).createIcon(handleModel.get('icon'), {
                    cursor: 'move',
                    draggable: true,
                    onmousemove: function(e) {
                        (0, parcelRequire("65X4x")).stop(e.event);
                    },
                    onmousedown: $b84b31aa9defeeb8$var$bind(this._onHandleDragMove, this, 0, 0),
                    drift: $b84b31aa9defeeb8$var$bind(this._onHandleDragMove, this),
                    ondragend: $b84b31aa9defeeb8$var$bind(this._onHandleDragEnd, this)
                });
                zr.add(handle);
            }
            $b84b31aa9defeeb8$var$updateMandatoryProps(handle, axisPointerModel, false);
            handle.setStyle(handleModel.getItemStyle(null, [
                'color',
                'borderColor',
                'borderWidth',
                'opacity',
                'shadowColor',
                'shadowBlur',
                'shadowOffsetX',
                'shadowOffsetY'
            ]));
            var handleSize = handleModel.get('size');
            if (!(0, parcelRequire("bahqM")).isArray(handleSize)) handleSize = [
                handleSize,
                handleSize
            ];
            handle.scaleX = handleSize[0] / 2;
            handle.scaleY = handleSize[1] / 2;
            (0, parcelRequire("ljaBy")).createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
            this._moveHandleToValue(value, isInit);
        };
        BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
            $b84b31aa9defeeb8$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $b84b31aa9defeeb8$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
        };
        BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
            var handle = this._handle;
            if (!handle) return;
            this._dragging = true;
            var trans = this.updateHandleTransform($b84b31aa9defeeb8$var$getHandleTransProps(handle), [
                dx,
                dy
            ], this._axisModel, this._axisPointerModel);
            this._payloadInfo = trans;
            handle.stopAnimation();
            handle.attr($b84b31aa9defeeb8$var$getHandleTransProps(trans));
            $b84b31aa9defeeb8$var$inner(handle).lastProp = null;
            this._doDispatchAxisPointer();
        };
        BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
            var handle = this._handle;
            if (!handle) return;
            var payloadInfo = this._payloadInfo;
            var axisModel = this._axisModel;
            this._api.dispatchAction({
                type: 'updateAxisPointer',
                x: payloadInfo.cursorPoint[0],
                y: payloadInfo.cursorPoint[1],
                tooltipOption: payloadInfo.tooltipOption,
                axesInfo: [
                    {
                        axisDim: axisModel.axis.dim,
                        axisIndex: axisModel.componentIndex
                    }
                ]
            });
        };
        BaseAxisPointer.prototype._onHandleDragEnd = function() {
            this._dragging = false;
            var handle = this._handle;
            if (!handle) return;
            var value = this._axisPointerModel.get('value');
            this._moveHandleToValue(value);
            this._api.dispatchAction({
                type: 'hideTip'
            });
        };
        BaseAxisPointer.prototype.clear = function(api) {
            this._lastValue = null;
            this._lastStatus = null;
            var zr = api.getZr();
            var group = this._group;
            var handle = this._handle;
            if (zr && group) {
                this._lastGraphicKey = null;
                group && zr.remove(group);
                handle && zr.remove(handle);
                this._group = null;
                this._handle = null;
                this._payloadInfo = null;
            }
        };
        BaseAxisPointer.prototype.doClear = function() {};
        BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
            xDimIndex = xDimIndex || 0;
            return {
                x: xy[xDimIndex],
                y: xy[1 - xDimIndex],
                width: wh[xDimIndex],
                height: wh[1 - xDimIndex]
            };
        };
        return BaseAxisPointer;
    }();
    function $b84b31aa9defeeb8$var$updateProps(animationModel, moveAnimation, el, props) {
        if (!$b84b31aa9defeeb8$var$propsEqual($b84b31aa9defeeb8$var$inner(el).lastProp, props)) {
            $b84b31aa9defeeb8$var$inner(el).lastProp = props;
            moveAnimation ? (0, parcelRequire("fHITF")).updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
        }
    }
    function $b84b31aa9defeeb8$var$propsEqual(lastProps, newProps) {
        if ((0, parcelRequire("bahqM")).isObject(lastProps) && (0, parcelRequire("bahqM")).isObject(newProps)) {
            var equals_1 = true;
            (0, parcelRequire("bahqM")).each(newProps, function(item, key) {
                equals_1 = equals_1 && $b84b31aa9defeeb8$var$propsEqual(lastProps[key], item);
            });
            return !!equals_1;
        } else return lastProps === newProps;
    }
    function $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel) {
        labelEl[axisPointerModel.get([
            'label',
            'show'
        ]) ? 'show' : 'hide']();
    }
    function $b84b31aa9defeeb8$var$getHandleTransProps(trans) {
        return {
            x: trans.x || 0,
            y: trans.y || 0,
            rotation: trans.rotation || 0
        };
    }
    function $b84b31aa9defeeb8$var$updateMandatoryProps(group, axisPointerModel, silent) {
        var z = axisPointerModel.get('z');
        var zlevel = axisPointerModel.get('zlevel');
        group && group.traverse(function(el) {
            if (el.type !== 'group') {
                z != null && (el.z = z);
                zlevel != null && (el.zlevel = zlevel);
                el.silent = silent;
            }
        });
    }
    var $b84b31aa9defeeb8$export$2e2bcd8739ae039 = $b84b31aa9defeeb8$var$BaseAxisPointer;
});
parcelRegister("eSE0c", function(module, exports) {
    $parcel$export(module.exports, "buildElStyle", ()=>$ad552373bbd775da$export$b7fe459c7cc50060);
    $parcel$export(module.exports, "buildLabelElOption", ()=>$ad552373bbd775da$export$8206a9937c45910f);
    $parcel$export(module.exports, "getValueLabel", ()=>$ad552373bbd775da$export$7cffee0f9aed39d0);
    $parcel$export(module.exports, "getTransformedPosition", ()=>$ad552373bbd775da$export$4bb66440324c3a3d);
    $parcel$export(module.exports, "buildCartesianSingleLabelElOption", ()=>$ad552373bbd775da$export$fd3eb3812211a173);
    $parcel$export(module.exports, "makeLineShape", ()=>$ad552373bbd775da$export$885fa0ad5a826207);
    $parcel$export(module.exports, "makeRectShape", ()=>$ad552373bbd775da$export$a8b35248bcc02756);
    $parcel$export(module.exports, "makeSectorShape", ()=>$ad552373bbd775da$export$b0cf82e7ebc0d7d0);
    var $bahqM;
    var $fHITF;
    var $b7ZX8;
    var $dCJrM;
    var $izqgC;
    var $3GIoT;
    var $asa08;
    var $gvLUt;
    function $ad552373bbd775da$export$b7fe459c7cc50060(axisPointerModel) {
        var axisPointerType = axisPointerModel.get('type');
        var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
        var style;
        if (axisPointerType === 'line') {
            style = styleModel.getLineStyle();
            style.fill = null;
        } else if (axisPointerType === 'shadow') {
            style = styleModel.getAreaStyle();
            style.stroke = null;
        }
        return style;
    }
    function $ad552373bbd775da$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
        var value = axisPointerModel.get('value');
        var text = $ad552373bbd775da$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        });
        var labelModel = axisPointerModel.getModel('label');
        var paddings = (0, parcelRequire("dCJrM")).normalizeCssArray(labelModel.get('padding') || 0);
        var font = labelModel.getFont();
        var textRect = (0, parcelRequire("b7ZX8")).getBoundingRect(text, font);
        var position = labelPos.position;
        var width = textRect.width + paddings[1] + paddings[3];
        var height = textRect.height + paddings[0] + paddings[2];
        var align = labelPos.align;
        align === 'right' && (position[0] -= width);
        align === 'center' && (position[0] -= width / 2);
        var verticalAlign = labelPos.verticalAlign;
        verticalAlign === 'bottom' && (position[1] -= height);
        verticalAlign === 'middle' && (position[1] -= height / 2);
        $ad552373bbd775da$var$confineInContainer(position, width, height, api);
        var bgColor = labelModel.get('backgroundColor');
        if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        elOption.label = {
            x: position[0],
            y: position[1],
            style: (0, (0, parcelRequire("gvLUt")).createTextStyle)(labelModel, {
                text: text,
                font: font,
                fill: labelModel.getTextColor(),
                padding: paddings,
                backgroundColor: bgColor
            }),
            z2: 10
        };
    }
    function $ad552373bbd775da$var$confineInContainer(position, width, height, api) {
        var viewWidth = api.getWidth();
        var viewHeight = api.getHeight();
        position[0] = Math.min(position[0] + width, viewWidth) - width;
        position[1] = Math.min(position[1] + height, viewHeight) - height;
        position[0] = Math.max(position[0], 0);
        position[1] = Math.max(position[1], 0);
    }
    function $ad552373bbd775da$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
        value = axis.scale.parse(value);
        var text = axis.scale.getLabel({
            value: value
        }, {
            precision: opt.precision
        });
        var formatter = opt.formatter;
        if (formatter) {
            var params_1 = {
                value: (0, parcelRequire("3GIoT")).getAxisRawValue(axis, {
                    value: value
                }),
                axisDimension: axis.dim,
                axisIndex: axis.index,
                seriesData: []
            };
            (0, parcelRequire("bahqM")).each(seriesDataIndices, function(idxItem) {
                var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                var dataIndex = idxItem.dataIndexInside;
                var dataParams = series && series.getDataParams(dataIndex);
                dataParams && params_1.seriesData.push(dataParams);
            });
            if ((0, parcelRequire("bahqM")).isString(formatter)) text = formatter.replace('{value}', text);
            else if ((0, parcelRequire("bahqM")).isFunction(formatter)) text = formatter(params_1);
        }
        return text;
    }
    function $ad552373bbd775da$export$4bb66440324c3a3d(axis, value, layoutInfo) {
        var transform = (0, parcelRequire("izqgC")).create();
        (0, parcelRequire("izqgC")).rotate(transform, transform, layoutInfo.rotation);
        (0, parcelRequire("izqgC")).translate(transform, transform, layoutInfo.position);
        return (0, parcelRequire("fHITF")).applyTransform([
            axis.dataToCoord(value),
            (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
        ], transform);
    }
    function $ad552373bbd775da$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
        var textLayout = (0, (0, parcelRequire("asa08")).default).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
        layoutInfo.labelMargin = axisPointerModel.get([
            'label',
            'margin'
        ]);
        $ad552373bbd775da$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
            position: $ad552373bbd775da$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
            align: textLayout.textAlign,
            verticalAlign: textLayout.textVerticalAlign
        });
    }
    function $ad552373bbd775da$export$885fa0ad5a826207(p1, p2, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x1: p1[xDimIndex],
            y1: p1[1 - xDimIndex],
            x2: p2[xDimIndex],
            y2: p2[1 - xDimIndex]
        };
    }
    function $ad552373bbd775da$export$a8b35248bcc02756(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    }
    function $ad552373bbd775da$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
        return {
            cx: cx,
            cy: cy,
            r0: r0,
            r: r,
            startAngle: startAngle,
            endAngle: endAngle,
            clockwise: true
        };
    }
});
parcelRegister("5UrR7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44d7ca4f96167e1d$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h4UlH;
    var $44d7ca4f96167e1d$var$AxisPointerModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(AxisPointerModel, _super);
        function AxisPointerModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = AxisPointerModel.type;
            return _this;
        }
        AxisPointerModel.type = 'axisPointer';
        AxisPointerModel.defaultOption = {
            show: 'auto',
            zlevel: 0,
            z: 50,
            type: 'line',
            snap: false,
            triggerTooltip: true,
            value: null,
            status: null,
            link: [],
            animation: null,
            animationDurationUpdate: 200,
            lineStyle: {
                color: '#B9BEC9',
                width: 1,
                type: 'dashed'
            },
            shadowStyle: {
                color: 'rgba(210,219,238,0.2)'
            },
            label: {
                show: true,
                formatter: null,
                precision: 'auto',
                margin: 3,
                color: '#fff',
                padding: [
                    5,
                    7,
                    5,
                    7
                ],
                backgroundColor: 'auto',
                borderColor: null,
                borderWidth: 0,
                borderRadius: 3
            },
            handle: {
                show: false,
                icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
                size: 45,
                margin: 50,
                color: '#333',
                shadowBlur: 3,
                shadowColor: '#aaa',
                shadowOffsetX: 0,
                shadowOffsetY: 2,
                throttle: 40
            }
        };
        return AxisPointerModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    var $44d7ca4f96167e1d$export$2e2bcd8739ae039 = $44d7ca4f96167e1d$var$AxisPointerModel;
});
parcelRegister("gPvBV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c409edfe4aa8d133$export$2e2bcd8739ae039);
    var $3VFsf;
    var $iNebh;
    var $fkskt;
    var $c409edfe4aa8d133$var$AxisPointerView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(AxisPointerView, _super);
        function AxisPointerView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = AxisPointerView.type;
            return _this;
        }
        AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
            var globalTooltipModel = ecModel.getComponent('tooltip');
            var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click';
            (0, parcelRequire("iNebh")).register('axisPointer', api, function(currTrigger, e, dispatchAction) {
                if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                    type: 'updateAxisPointer',
                    currTrigger: currTrigger,
                    x: e && e.offsetX,
                    y: e && e.offsetY
                });
            });
        };
        AxisPointerView.prototype.remove = function(ecModel, api) {
            (0, parcelRequire("iNebh")).unregister('axisPointer', api);
        };
        AxisPointerView.prototype.dispose = function(ecModel, api) {
            (0, parcelRequire("iNebh")).unregister('axisPointer', api);
        };
        AxisPointerView.type = 'axisPointer';
        return AxisPointerView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $c409edfe4aa8d133$export$2e2bcd8739ae039 = $c409edfe4aa8d133$var$AxisPointerView;
});
parcelRegister("iNebh", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$dae7cd9e0e79e4d2$export$6503ec6e8aabbaf);
    $parcel$export(module.exports, "unregister", ()=>$dae7cd9e0e79e4d2$export$d07f55d4c15c0440);
    var $bahqM;
    var $hZfwb;
    var $eaKsF;
    var $dae7cd9e0e79e4d2$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $dae7cd9e0e79e4d2$var$each = (0, parcelRequire("bahqM")).each;
    function $dae7cd9e0e79e4d2$export$6503ec6e8aabbaf(key, api, handler) {
        if ((0, (0, parcelRequire("hZfwb")).default).node) return;
        var zr = api.getZr();
        $dae7cd9e0e79e4d2$var$inner(zr).records || ($dae7cd9e0e79e4d2$var$inner(zr).records = {});
        $dae7cd9e0e79e4d2$var$initGlobalListeners(zr, api);
        var record = $dae7cd9e0e79e4d2$var$inner(zr).records[key] || ($dae7cd9e0e79e4d2$var$inner(zr).records[key] = {});
        record.handler = handler;
    }
    function $dae7cd9e0e79e4d2$var$initGlobalListeners(zr, api) {
        if ($dae7cd9e0e79e4d2$var$inner(zr).initialized) return;
        $dae7cd9e0e79e4d2$var$inner(zr).initialized = true;
        useHandler('click', (0, parcelRequire("bahqM")).curry($dae7cd9e0e79e4d2$var$doEnter, 'click'));
        useHandler('mousemove', (0, parcelRequire("bahqM")).curry($dae7cd9e0e79e4d2$var$doEnter, 'mousemove'));
        useHandler('globalout', $dae7cd9e0e79e4d2$var$onLeave);
        function useHandler(eventType, cb) {
            zr.on(eventType, function(e) {
                var dis = $dae7cd9e0e79e4d2$var$makeDispatchAction(api);
                $dae7cd9e0e79e4d2$var$each($dae7cd9e0e79e4d2$var$inner(zr).records, function(record) {
                    record && cb(record, e, dis.dispatchAction);
                });
                $dae7cd9e0e79e4d2$var$dispatchTooltipFinally(dis.pendings, api);
            });
        }
    }
    function $dae7cd9e0e79e4d2$var$dispatchTooltipFinally(pendings, api) {
        var showLen = pendings.showTip.length;
        var hideLen = pendings.hideTip.length;
        var actuallyPayload;
        if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
        else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
        if (actuallyPayload) {
            actuallyPayload.dispatchAction = null;
            api.dispatchAction(actuallyPayload);
        }
    }
    function $dae7cd9e0e79e4d2$var$onLeave(record, e, dispatchAction) {
        record.handler('leave', null, dispatchAction);
    }
    function $dae7cd9e0e79e4d2$var$doEnter(currTrigger, record, e, dispatchAction) {
        record.handler(currTrigger, e, dispatchAction);
    }
    function $dae7cd9e0e79e4d2$var$makeDispatchAction(api) {
        var pendings = {
            showTip: [],
            hideTip: []
        };
        var dispatchAction = function(payload) {
            var pendingList = pendings[payload.type];
            if (pendingList) pendingList.push(payload);
            else {
                payload.dispatchAction = dispatchAction;
                api.dispatchAction(payload);
            }
        };
        return {
            dispatchAction: dispatchAction,
            pendings: pendings
        };
    }
    function $dae7cd9e0e79e4d2$export$d07f55d4c15c0440(key, api) {
        if ((0, (0, parcelRequire("hZfwb")).default).node) return;
        var zr = api.getZr();
        var record = ($dae7cd9e0e79e4d2$var$inner(zr).records || {})[key];
        if (record) $dae7cd9e0e79e4d2$var$inner(zr).records[key] = null;
    }
});
parcelRegister("5TxwA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44ac1811f8c8020d$export$2e2bcd8739ae039);
    var $eaKsF;
    var $8QSpd;
    var $4LkI5;
    var $bahqM;
    var $44ac1811f8c8020d$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $44ac1811f8c8020d$export$2e2bcd8739ae039(payload, ecModel, api) {
        var currTrigger = payload.currTrigger;
        var point = [
            payload.x,
            payload.y
        ];
        var finder = payload;
        var dispatchAction = payload.dispatchAction || (0, (0, parcelRequire("bahqM")).bind)(api.dispatchAction, api);
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (!coordSysAxesInfo) return;
        if ($44ac1811f8c8020d$var$illegalPoint(point)) point = (0, (0, parcelRequire("4LkI5")).default)({
            seriesIndex: finder.seriesIndex,
            dataIndex: finder.dataIndex
        }, ecModel).point;
        var isIllegalPoint = $44ac1811f8c8020d$var$illegalPoint(point);
        var inputAxesInfo = finder.axesInfo;
        var axesInfo = coordSysAxesInfo.axesInfo;
        var shouldHide = currTrigger === 'leave' || $44ac1811f8c8020d$var$illegalPoint(point);
        var outputPayload = {};
        var showValueMap = {};
        var dataByCoordSys = {
            list: [],
            map: {}
        };
        var updaters = {
            showPointer: (0, (0, parcelRequire("bahqM")).curry)($44ac1811f8c8020d$var$showPointer, showValueMap),
            showTooltip: (0, (0, parcelRequire("bahqM")).curry)($44ac1811f8c8020d$var$showTooltip, dataByCoordSys)
        };
        (0, (0, parcelRequire("bahqM")).each)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
            var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
            (0, (0, parcelRequire("bahqM")).each)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
                var axis = axisInfo.axis;
                var inputAxisInfo = $44ac1811f8c8020d$var$findInputAxisInfo(inputAxesInfo, axisInfo);
                if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                    var val = inputAxisInfo && inputAxisInfo.value;
                    if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                    val != null && $44ac1811f8c8020d$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
                }
            });
        });
        var linkTriggers = {};
        (0, (0, parcelRequire("bahqM")).each)(axesInfo, function(tarAxisInfo, tarKey) {
            var linkGroup = tarAxisInfo.linkGroup;
            if (linkGroup && !showValueMap[tarKey]) (0, (0, parcelRequire("bahqM")).each)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
                var srcValItem = showValueMap[srcKey];
                if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                    var val = srcValItem.value;
                    linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $44ac1811f8c8020d$var$makeMapperParam(srcAxisInfo), $44ac1811f8c8020d$var$makeMapperParam(tarAxisInfo))));
                    linkTriggers[tarAxisInfo.key] = val;
                }
            });
        });
        (0, (0, parcelRequire("bahqM")).each)(linkTriggers, function(val, tarKey) {
            $44ac1811f8c8020d$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
        });
        $44ac1811f8c8020d$var$updateModelActually(showValueMap, axesInfo, outputPayload);
        $44ac1811f8c8020d$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
        $44ac1811f8c8020d$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
        return outputPayload;
    }
    function $44ac1811f8c8020d$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
        var axis = axisInfo.axis;
        if (axis.scale.isBlank() || !axis.containData(newValue)) return;
        if (!axisInfo.involveSeries) {
            updaters.showPointer(axisInfo, newValue);
            return;
        }
        var payloadInfo = $44ac1811f8c8020d$var$buildPayloadsBySeries(newValue, axisInfo);
        var payloadBatch = payloadInfo.payloadBatch;
        var snapToValue = payloadInfo.snapToValue;
        if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, (0, parcelRequire("bahqM")).extend)(outputFinder, payloadBatch[0]);
        if (!noSnap && axisInfo.snap) {
            if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
        }
        updaters.showPointer(axisInfo, newValue, payloadBatch);
        updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
    }
    function $44ac1811f8c8020d$var$buildPayloadsBySeries(value, axisInfo) {
        var axis = axisInfo.axis;
        var dim = axis.dim;
        var snapToValue = value;
        var payloadBatch = [];
        var minDist = Number.MAX_VALUE;
        var minDiff = -1;
        (0, (0, parcelRequire("bahqM")).each)(axisInfo.seriesModels, function(series, idx) {
            var dataDim = series.getData().mapDimensionsAll(dim);
            var seriesNestestValue;
            var dataIndices;
            if (series.getAxisTooltipData) {
                var result = series.getAxisTooltipData(dataDim, value, axis);
                dataIndices = result.dataIndices;
                seriesNestestValue = result.nestestValue;
            } else {
                dataIndices = series.getData().indicesOfNearest(dataDim[0], value, axis.type === 'category' ? 0.5 : null);
                if (!dataIndices.length) return;
                seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
            }
            if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
            var diff = value - seriesNestestValue;
            var dist = Math.abs(diff);
            if (dist <= minDist) {
                if (dist < minDist || diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    snapToValue = seriesNestestValue;
                    payloadBatch.length = 0;
                }
                (0, (0, parcelRequire("bahqM")).each)(dataIndices, function(dataIndex) {
                    payloadBatch.push({
                        seriesIndex: series.seriesIndex,
                        dataIndexInside: dataIndex,
                        dataIndex: series.getData().getRawIndex(dataIndex)
                    });
                });
            }
        });
        return {
            payloadBatch: payloadBatch,
            snapToValue: snapToValue
        };
    }
    function $44ac1811f8c8020d$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
        showValueMap[axisInfo.key] = {
            value: value,
            payloadBatch: payloadBatch
        };
    }
    function $44ac1811f8c8020d$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
        var payloadBatch = payloadInfo.payloadBatch;
        var axis = axisInfo.axis;
        var axisModel = axis.model;
        var axisPointerModel = axisInfo.axisPointerModel;
        if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
        var coordSysModel = axisInfo.coordSys.model;
        var coordSysKey = (0, parcelRequire("8QSpd")).makeKey(coordSysModel);
        var coordSysItem = dataByCoordSys.map[coordSysKey];
        if (!coordSysItem) {
            coordSysItem = dataByCoordSys.map[coordSysKey] = {
                coordSysId: coordSysModel.id,
                coordSysIndex: coordSysModel.componentIndex,
                coordSysType: coordSysModel.type,
                coordSysMainType: coordSysModel.mainType,
                dataByAxis: []
            };
            dataByCoordSys.list.push(coordSysItem);
        }
        coordSysItem.dataByAxis.push({
            axisDim: axis.dim,
            axisIndex: axisModel.componentIndex,
            axisType: axisModel.type,
            axisId: axisModel.id,
            value: value,
            valueLabelOpt: {
                precision: axisPointerModel.get([
                    'label',
                    'precision'
                ]),
                formatter: axisPointerModel.get([
                    'label',
                    'formatter'
                ])
            },
            seriesDataIndices: payloadBatch.slice()
        });
    }
    function $44ac1811f8c8020d$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
        var outputAxesInfo = outputPayload.axesInfo = [];
        (0, (0, parcelRequire("bahqM")).each)(axesInfo, function(axisInfo, key) {
            var option = axisInfo.axisPointerModel.option;
            var valItem = showValueMap[key];
            if (valItem) {
                !axisInfo.useHandle && (option.status = 'show');
                option.value = valItem.value;
                option.seriesDataIndices = (valItem.payloadBatch || []).slice();
            } else !axisInfo.useHandle && (option.status = 'hide');
            option.status === 'show' && outputAxesInfo.push({
                axisDim: axisInfo.axis.dim,
                axisIndex: axisInfo.axis.model.componentIndex,
                value: option.value
            });
        });
    }
    function $44ac1811f8c8020d$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
        if ($44ac1811f8c8020d$var$illegalPoint(point) || !dataByCoordSys.list.length) {
            dispatchAction({
                type: 'hideTip'
            });
            return;
        }
        var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
        dispatchAction({
            type: 'showTip',
            escapeConnect: true,
            x: point[0],
            y: point[1],
            tooltipOption: payload.tooltipOption,
            position: payload.position,
            dataIndexInside: sampleItem.dataIndexInside,
            dataIndex: sampleItem.dataIndex,
            seriesIndex: sampleItem.seriesIndex,
            dataByCoordSys: dataByCoordSys.list
        });
    }
    function $44ac1811f8c8020d$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
        var zr = api.getZr();
        var highDownKey = 'axisPointerLastHighlights';
        var lastHighlights = $44ac1811f8c8020d$var$inner(zr)[highDownKey] || {};
        var newHighlights = $44ac1811f8c8020d$var$inner(zr)[highDownKey] = {};
        (0, (0, parcelRequire("bahqM")).each)(axesInfo, function(axisInfo, key) {
            var option = axisInfo.axisPointerModel.option;
            option.status === 'show' && (0, (0, parcelRequire("bahqM")).each)(option.seriesDataIndices, function(batchItem) {
                var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
                newHighlights[key] = batchItem;
            });
        });
        var toHighlight = [];
        var toDownplay = [];
        (0, (0, parcelRequire("bahqM")).each)(lastHighlights, function(batchItem, key) {
            !newHighlights[key] && toDownplay.push(batchItem);
        });
        (0, (0, parcelRequire("bahqM")).each)(newHighlights, function(batchItem, key) {
            !lastHighlights[key] && toHighlight.push(batchItem);
        });
        toDownplay.length && api.dispatchAction({
            type: 'downplay',
            escapeConnect: true,
            notBlur: true,
            batch: toDownplay
        });
        toHighlight.length && api.dispatchAction({
            type: 'highlight',
            escapeConnect: true,
            notBlur: true,
            batch: toHighlight
        });
    }
    function $44ac1811f8c8020d$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
        for(var i = 0; i < (inputAxesInfo || []).length; i++){
            var inputAxisInfo = inputAxesInfo[i];
            if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
        }
    }
    function $44ac1811f8c8020d$var$makeMapperParam(axisInfo) {
        var axisModel = axisInfo.axis.model;
        var item = {};
        var dim = item.axisDim = axisInfo.axis.dim;
        item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
        item.axisName = item[dim + 'AxisName'] = axisModel.name;
        item.axisId = item[dim + 'AxisId'] = axisModel.id;
        return item;
    }
    function $44ac1811f8c8020d$var$illegalPoint(point) {
        return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
    }
});
parcelRegister("4LkI5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$377b9dcb49ed57dc$export$2e2bcd8739ae039);
    var $bahqM;
    var $eaKsF;
    function $377b9dcb49ed57dc$export$2e2bcd8739ae039(finder, ecModel) {
        var point = [];
        var seriesIndex = finder.seriesIndex;
        var seriesModel;
        if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
            point: []
        };
        var data = seriesModel.getData();
        var dataIndex = (0, parcelRequire("eaKsF")).queryDataIndex(data, finder);
        if (dataIndex == null || dataIndex < 0 || (0, parcelRequire("bahqM")).isArray(dataIndex)) return {
            point: []
        };
        var el = data.getItemGraphicEl(dataIndex);
        var coordSys = seriesModel.coordinateSystem;
        if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
        else if (coordSys && coordSys.dataToPoint) {
            if (finder.isStacked) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var valueAxisDim = valueAxis.dim;
                var baseAxisDim = baseAxis.dim;
                var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
                var baseDim = data.mapDimension(baseAxisDim);
                var stackedData = [];
                stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
                stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
                point = coordSys.dataToPoint(stackedData) || [];
            } else point = coordSys.dataToPoint(data.getValues((0, parcelRequire("bahqM")).map(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }), dataIndex)) || [];
        } else if (el) {
            var rect = el.getBoundingRect().clone();
            rect.applyTransform(el.transform);
            point = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
        }
        return {
            point: point,
            el: el
        };
    }
});
parcelRegister("ixwqj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d7f475abbf81e4fb$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h4UlH;
    var $d7f475abbf81e4fb$var$TooltipModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(TooltipModel, _super);
        function TooltipModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = TooltipModel.type;
            return _this;
        }
        TooltipModel.type = 'tooltip';
        TooltipModel.dependencies = [
            'axisPointer'
        ];
        TooltipModel.defaultOption = {
            zlevel: 0,
            z: 60,
            show: true,
            showContent: true,
            trigger: 'item',
            triggerOn: 'mousemove|click',
            alwaysShowContent: false,
            displayMode: 'single',
            renderMode: 'auto',
            confine: null,
            showDelay: 0,
            hideDelay: 100,
            transitionDuration: 0.4,
            enterable: false,
            backgroundColor: '#fff',
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, .2)',
            shadowOffsetX: 1,
            shadowOffsetY: 2,
            borderRadius: 4,
            borderWidth: 1,
            padding: null,
            extraCssText: '',
            axisPointer: {
                type: 'line',
                axis: 'auto',
                animation: 'auto',
                animationDurationUpdate: 200,
                animationEasingUpdate: 'exponentialOut',
                crossStyle: {
                    color: '#999',
                    width: 1,
                    type: 'dashed',
                    textStyle: {}
                }
            },
            textStyle: {
                color: '#666',
                fontSize: 14
            }
        };
        return TooltipModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    var $d7f475abbf81e4fb$export$2e2bcd8739ae039 = $d7f475abbf81e4fb$var$TooltipModel;
});
parcelRegister("kfWc4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebf2596432d1aebb$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $hZfwb;
    var $lh5Tz;
    var $bf1zw;
    var $dCJrM;
    var $jmSNG;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $4LkI5;
    var $65MS1;
    var $gaMkj;
    var $iNebh;
    var $3GIoT;
    var $eSE0c;
    var $eaKsF;
    var $fkskt;
    var $bc1Ad;
    var $7QjoM;
    var $l3AHA;
    var $guzSc;
    var $j5lKL;
    var $6IsbX;
    var $ljaBy;
    var $ebf2596432d1aebb$var$bind = (0, parcelRequire("bahqM")).bind;
    var $ebf2596432d1aebb$var$each = (0, parcelRequire("bahqM")).each;
    var $ebf2596432d1aebb$var$parsePercent = (0, parcelRequire("jmSNG")).parsePercent;
    var $ebf2596432d1aebb$var$proxyRect = new (0, parcelRequire("7Tw7u")).default({
        shape: {
            x: -1,
            y: -1,
            width: 2,
            height: 2
        }
    });
    var $ebf2596432d1aebb$var$TooltipView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(TooltipView, _super);
        function TooltipView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = TooltipView.type;
            return _this;
        }
        TooltipView.prototype.init = function(ecModel, api) {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return;
            var tooltipModel = ecModel.getComponent('tooltip');
            var renderMode = tooltipModel.get('renderMode');
            this._renderMode = (0, (0, parcelRequire("eaKsF")).getTooltipRenderMode)(renderMode);
            this._tooltipContent = this._renderMode === 'richText' ? new (0, (0, parcelRequire("bf1zw")).default)(api) : new (0, (0, parcelRequire("lh5Tz")).default)(api.getDom(), api, {
                appendToBody: tooltipModel.get('appendToBody', true)
            });
        };
        TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return;
            this.group.removeAll();
            this._tooltipModel = tooltipModel;
            this._ecModel = ecModel;
            this._api = api;
            this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
            var tooltipContent = this._tooltipContent;
            tooltipContent.update(tooltipModel);
            tooltipContent.setEnterable(tooltipModel.get('enterable'));
            this._initGlobalListener();
            this._keepShow();
            this._updatePosition = this._renderMode === 'html' ? (0, (0, parcelRequire("ljaBy")).throttle)($ebf2596432d1aebb$var$bind(this._doUpdatePosition, this), 50) : this._doUpdatePosition;
        };
        TooltipView.prototype._initGlobalListener = function() {
            var tooltipModel = this._tooltipModel;
            var triggerOn = tooltipModel.get('triggerOn');
            (0, parcelRequire("iNebh")).register('itemTooltip', this._api, $ebf2596432d1aebb$var$bind(function(currTrigger, e, dispatchAction) {
                if (triggerOn !== 'none') {
                    if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                    else if (currTrigger === 'leave') this._hide(dispatchAction);
                }
            }, this));
        };
        TooltipView.prototype._keepShow = function() {
            var tooltipModel = this._tooltipModel;
            var ecModel = this._ecModel;
            var api = this._api;
            if (this._lastX != null && this._lastY != null && tooltipModel.get('triggerOn') !== 'none') {
                var self_1 = this;
                clearTimeout(this._refreshUpdateTimeout);
                this._refreshUpdateTimeout = setTimeout(function() {
                    !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                        x: self_1._lastX,
                        y: self_1._lastY,
                        dataByCoordSys: self_1._lastDataByCoordSys
                    });
                });
            }
        };
        TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
            if (payload.from === this.uid || (0, (0, parcelRequire("hZfwb")).default).node) return;
            var dispatchAction = $ebf2596432d1aebb$var$makeDispatchAction(payload, api);
            this._ticket = '';
            var dataByCoordSys = payload.dataByCoordSys;
            var cmptRef = $ebf2596432d1aebb$var$findComponentReference(payload, ecModel, api);
            if (cmptRef) {
                var rect = cmptRef.el.getBoundingRect().clone();
                rect.applyTransform(cmptRef.el.transform);
                this._tryShow({
                    offsetX: rect.x + rect.width / 2,
                    offsetY: rect.y + rect.height / 2,
                    target: cmptRef.el,
                    position: payload.position,
                    positionDefault: 'bottom'
                }, dispatchAction);
            } else if (payload.tooltip && payload.x != null && payload.y != null) {
                var el = $ebf2596432d1aebb$var$proxyRect;
                el.x = payload.x;
                el.y = payload.y;
                el.update();
                (0, (0, parcelRequire("7QjoM")).getECData)(el).tooltipConfig = {
                    name: null,
                    option: payload.tooltip
                };
                this._tryShow({
                    offsetX: payload.x,
                    offsetY: payload.y,
                    target: el
                }, dispatchAction);
            } else if (dataByCoordSys) this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                dataByCoordSys: dataByCoordSys,
                tooltipOption: payload.tooltipOption
            }, dispatchAction);
            else if (payload.seriesIndex != null) {
                if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
                var pointInfo = (0, (0, parcelRequire("4LkI5")).default)(payload, ecModel);
                var cx = pointInfo.point[0];
                var cy = pointInfo.point[1];
                if (cx != null && cy != null) this._tryShow({
                    offsetX: cx,
                    offsetY: cy,
                    target: pointInfo.el,
                    position: payload.position,
                    positionDefault: 'bottom'
                }, dispatchAction);
            } else if (payload.x != null && payload.y != null) {
                api.dispatchAction({
                    type: 'updateAxisPointer',
                    x: payload.x,
                    y: payload.y
                });
                this._tryShow({
                    offsetX: payload.x,
                    offsetY: payload.y,
                    position: payload.position,
                    target: api.getZr().findHover(payload.x, payload.y).target
                }, dispatchAction);
            }
        };
        TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
            var tooltipContent = this._tooltipContent;
            if (!this._alwaysShowContent && this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
            this._lastX = this._lastY = this._lastDataByCoordSys = null;
            if (payload.from !== this.uid) this._hide($ebf2596432d1aebb$var$makeDispatchAction(payload, api));
        };
        TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
            var seriesIndex = payload.seriesIndex;
            var dataIndex = payload.dataIndex;
            var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
            if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
            var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
            if (!seriesModel) return;
            var data = seriesModel.getData();
            var tooltipCascadedModel = $ebf2596432d1aebb$var$buildTooltipModel([
                data.getItemModel(dataIndex),
                seriesModel,
                (seriesModel.coordinateSystem || {}).model
            ], this._tooltipModel);
            if (tooltipCascadedModel.get('trigger') !== 'axis') return;
            api.dispatchAction({
                type: 'updateAxisPointer',
                seriesIndex: seriesIndex,
                dataIndex: dataIndex,
                position: payload.position
            });
            return true;
        };
        TooltipView.prototype._tryShow = function(e, dispatchAction) {
            var el = e.target;
            var tooltipModel = this._tooltipModel;
            if (!tooltipModel) return;
            this._lastX = e.offsetX;
            this._lastY = e.offsetY;
            var dataByCoordSys = e.dataByCoordSys;
            if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
            else if (el) {
                this._lastDataByCoordSys = null;
                var seriesDispatcher_1;
                var cmptDispatcher_1;
                (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, function(target) {
                    if ((0, (0, parcelRequire("7QjoM")).getECData)(target).dataIndex != null) {
                        seriesDispatcher_1 = target;
                        return true;
                    }
                    if ((0, (0, parcelRequire("7QjoM")).getECData)(target).tooltipConfig != null) {
                        cmptDispatcher_1 = target;
                        return true;
                    }
                }, true);
                if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
                else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
                else this._hide(dispatchAction);
            } else {
                this._lastDataByCoordSys = null;
                this._hide(dispatchAction);
            }
        };
        TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
            var delay = tooltipModel.get('showDelay');
            cb = (0, parcelRequire("bahqM")).bind(cb, this);
            clearTimeout(this._showTimout);
            delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
        };
        TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
            var ecModel = this._ecModel;
            var globalTooltipModel = this._tooltipModel;
            var point = [
                e.offsetX,
                e.offsetY
            ];
            var singleTooltipModel = $ebf2596432d1aebb$var$buildTooltipModel([
                e.tooltipOption
            ], globalTooltipModel);
            var renderMode = this._renderMode;
            var cbParamsList = [];
            var articleMarkup = (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('section', {
                blocks: [],
                noHeader: true
            });
            var markupTextArrLegacy = [];
            var markupStyleCreator = new (0, (0, parcelRequire("j5lKL")).TooltipMarkupStyleCreator)();
            $ebf2596432d1aebb$var$each(dataByCoordSys, function(itemCoordSys) {
                $ebf2596432d1aebb$var$each(itemCoordSys.dataByAxis, function(axisItem) {
                    var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                    var axisValue = axisItem.value;
                    if (!axisModel || axisValue == null) return;
                    var axisValueLabel = (0, parcelRequire("eSE0c")).getValueLabel(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                    var axisSectionMarkup = (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('section', {
                        header: axisValueLabel,
                        noHeader: !(0, parcelRequire("bahqM")).trim(axisValueLabel),
                        sortBlocks: true,
                        blocks: []
                    });
                    articleMarkup.blocks.push(axisSectionMarkup);
                    (0, parcelRequire("bahqM")).each(axisItem.seriesDataIndices, function(idxItem) {
                        var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                        var dataIndex = idxItem.dataIndexInside;
                        var cbParams = series.getDataParams(dataIndex);
                        if (cbParams.dataIndex < 0) return;
                        cbParams.axisDim = axisItem.axisDim;
                        cbParams.axisIndex = axisItem.axisIndex;
                        cbParams.axisType = axisItem.axisType;
                        cbParams.axisId = axisItem.axisId;
                        cbParams.axisValue = (0, parcelRequire("3GIoT")).getAxisRawValue(axisModel.axis, {
                            value: axisValue
                        });
                        cbParams.axisValueLabel = axisValueLabel;
                        cbParams.marker = markupStyleCreator.makeTooltipMarker('item', (0, parcelRequire("dCJrM")).convertToColorString(cbParams.color), renderMode);
                        var seriesTooltipResult = (0, (0, parcelRequire("guzSc")).normalizeTooltipFormatResult)(series.formatTooltip(dataIndex, true, null));
                        if (seriesTooltipResult.markupFragment) axisSectionMarkup.blocks.push(seriesTooltipResult.markupFragment);
                        if (seriesTooltipResult.markupText) markupTextArrLegacy.push(seriesTooltipResult.markupText);
                        cbParamsList.push(cbParams);
                    });
                });
            });
            articleMarkup.blocks.reverse();
            markupTextArrLegacy.reverse();
            var positionExpr = e.position;
            var orderMode = singleTooltipModel.get('order');
            var builtMarkupText = (0, (0, parcelRequire("j5lKL")).buildTooltipMarkup)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
            builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
            var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
            var allMarkupText = markupTextArrLegacy.join(blockBreak);
            this._showOrMove(singleTooltipModel, function() {
                if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
                else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
            });
        };
        TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
            var ecModel = this._ecModel;
            var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
            var seriesIndex = ecData.seriesIndex;
            var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
            var dataModel = ecData.dataModel || seriesModel;
            var dataIndex = ecData.dataIndex;
            var dataType = ecData.dataType;
            var data = dataModel.getData(dataType);
            var renderMode = this._renderMode;
            var positionDefault = e.positionDefault;
            var tooltipModel = $ebf2596432d1aebb$var$buildTooltipModel([
                data.getItemModel(dataIndex),
                dataModel,
                seriesModel && (seriesModel.coordinateSystem || {}).model
            ], this._tooltipModel, positionDefault ? {
                position: positionDefault
            } : null);
            var tooltipTrigger = tooltipModel.get('trigger');
            if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
            var params = dataModel.getDataParams(dataIndex, dataType);
            var markupStyleCreator = new (0, (0, parcelRequire("j5lKL")).TooltipMarkupStyleCreator)();
            params.marker = markupStyleCreator.makeTooltipMarker('item', (0, parcelRequire("dCJrM")).convertToColorString(params.color), renderMode);
            var seriesTooltipResult = (0, (0, parcelRequire("guzSc")).normalizeTooltipFormatResult)(dataModel.formatTooltip(dataIndex, false, dataType));
            var orderMode = tooltipModel.get('order');
            var markupText = seriesTooltipResult.markupFragment ? (0, (0, parcelRequire("j5lKL")).buildTooltipMarkup)(seriesTooltipResult.markupFragment, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.markupText;
            var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
            this._showOrMove(tooltipModel, function() {
                this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
            });
            dispatchAction({
                type: 'showTip',
                dataIndexInside: dataIndex,
                dataIndex: data.getRawIndex(dataIndex),
                seriesIndex: seriesIndex,
                from: this.uid
            });
        };
        TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
            var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
            var tooltipConfig = ecData.tooltipConfig;
            var tooltipOpt = tooltipConfig.option || {};
            if ((0, parcelRequire("bahqM")).isString(tooltipOpt)) {
                var content = tooltipOpt;
                tooltipOpt = {
                    content: content,
                    formatter: content
                };
            }
            var tooltipModelCascade = [
                tooltipOpt
            ];
            var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
            if (cmpt) tooltipModelCascade.push(cmpt);
            tooltipModelCascade.push({
                formatter: tooltipOpt.content
            });
            var positionDefault = e.positionDefault;
            var subTooltipModel = $ebf2596432d1aebb$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
                position: positionDefault
            } : null);
            var defaultHtml = subTooltipModel.get('content');
            var asyncTicket = Math.random() + '';
            var markupStyleCreator = new (0, (0, parcelRequire("j5lKL")).TooltipMarkupStyleCreator)();
            this._showOrMove(subTooltipModel, function() {
                var formatterParams = (0, parcelRequire("bahqM")).clone(subTooltipModel.get('formatterParams') || {});
                this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
            });
            dispatchAction({
                type: 'showTip',
                from: this.uid
            });
        };
        TooltipView.prototype._showTooltipContent = function(tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
            this._ticket = '';
            if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
            var tooltipContent = this._tooltipContent;
            var formatter = tooltipModel.get('formatter');
            positionExpr = positionExpr || tooltipModel.get('position');
            var html = defaultHtml;
            var nearPoint = this._getNearestPoint([
                x,
                y
            ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'));
            var nearPointColor = nearPoint.color;
            if (formatter) {
                if ((0, parcelRequire("bahqM")).isString(formatter)) {
                    var useUTC = tooltipModel.ecModel.get('useUTC');
                    var params0 = (0, parcelRequire("bahqM")).isArray(params) ? params[0] : params;
                    var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                    html = formatter;
                    if (isTimeAxis) html = (0, (0, parcelRequire("bc1Ad")).format)(params0.axisValue, html, useUTC);
                    html = (0, parcelRequire("dCJrM")).formatTpl(html, params, true);
                } else if ((0, parcelRequire("bahqM")).isFunction(formatter)) {
                    var callback = $ebf2596432d1aebb$var$bind(function(cbTicket, html) {
                        if (cbTicket === this._ticket) {
                            tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                            this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                        }
                    }, this);
                    this._ticket = asyncTicket;
                    html = formatter(params, asyncTicket, callback);
                } else html = formatter;
            }
            tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
            tooltipContent.show(tooltipModel, nearPointColor);
            this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
        };
        TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor) {
            if (trigger === 'axis' || (0, parcelRequire("bahqM")).isArray(tooltipDataParams)) return {
                color: borderColor || (this._renderMode === 'html' ? '#fff' : 'none')
            };
            if (!(0, parcelRequire("bahqM")).isArray(tooltipDataParams)) return {
                color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
            };
        };
        TooltipView.prototype._doUpdatePosition = function(tooltipModel, positionExpr, x, y, content, params, el) {
            var viewWidth = this._api.getWidth();
            var viewHeight = this._api.getHeight();
            positionExpr = positionExpr || tooltipModel.get('position');
            var contentSize = content.getSize();
            var align = tooltipModel.get('align');
            var vAlign = tooltipModel.get('verticalAlign');
            var rect = el && el.getBoundingRect().clone();
            el && rect.applyTransform(el.transform);
            if ((0, parcelRequire("bahqM")).isFunction(positionExpr)) positionExpr = positionExpr([
                x,
                y
            ], params, content.el, rect, {
                viewSize: [
                    viewWidth,
                    viewHeight
                ],
                contentSize: contentSize.slice()
            });
            if ((0, parcelRequire("bahqM")).isArray(positionExpr)) {
                x = $ebf2596432d1aebb$var$parsePercent(positionExpr[0], viewWidth);
                y = $ebf2596432d1aebb$var$parsePercent(positionExpr[1], viewHeight);
            } else if ((0, parcelRequire("bahqM")).isObject(positionExpr)) {
                var boxLayoutPosition = positionExpr;
                boxLayoutPosition.width = contentSize[0];
                boxLayoutPosition.height = contentSize[1];
                var layoutRect = (0, parcelRequire("65MS1")).getLayoutRect(boxLayoutPosition, {
                    width: viewWidth,
                    height: viewHeight
                });
                x = layoutRect.x;
                y = layoutRect.y;
                align = null;
                vAlign = null;
            } else if ((0, parcelRequire("bahqM")).isString(positionExpr) && el) {
                var pos = $ebf2596432d1aebb$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
                x = pos[0];
                y = pos[1];
            } else {
                var pos = $ebf2596432d1aebb$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
                x = pos[0];
                y = pos[1];
            }
            align && (x -= $ebf2596432d1aebb$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
            vAlign && (y -= $ebf2596432d1aebb$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
            if ((0, (0, parcelRequire("l3AHA")).shouldTooltipConfine)(tooltipModel)) {
                var pos = $ebf2596432d1aebb$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
                x = pos[0];
                y = pos[1];
            }
            content.moveTo(x, y);
        };
        TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
            var lastCoordSys = this._lastDataByCoordSys;
            var lastCbParamsList = this._cbParamsList;
            var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
            contentNotChanged && $ebf2596432d1aebb$var$each(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
                var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
                var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
                var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
                contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
                contentNotChanged && $ebf2596432d1aebb$var$each(lastDataByAxis, function(lastItem, indexAxis) {
                    var thisItem = thisDataByAxis[indexAxis] || {};
                    var lastIndices = lastItem.seriesDataIndices || [];
                    var newIndices = thisItem.seriesDataIndices || [];
                    contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                    contentNotChanged && $ebf2596432d1aebb$var$each(lastIndices, function(lastIdxItem, j) {
                        var newIdxItem = newIndices[j];
                        contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                    });
                    lastCbParamsList && (0, parcelRequire("bahqM")).each(lastItem.seriesDataIndices, function(idxItem) {
                        var seriesIdx = idxItem.seriesIndex;
                        var cbParams = cbParamsList[seriesIdx];
                        var lastCbParams = lastCbParamsList[seriesIdx];
                        if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                    });
                });
            });
            this._lastDataByCoordSys = dataByCoordSys;
            this._cbParamsList = cbParamsList;
            return !!contentNotChanged;
        };
        TooltipView.prototype._hide = function(dispatchAction) {
            this._lastDataByCoordSys = null;
            dispatchAction({
                type: 'hideTip',
                from: this.uid
            });
        };
        TooltipView.prototype.dispose = function(ecModel, api) {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return;
            this._tooltipContent.dispose();
            (0, parcelRequire("iNebh")).unregister('itemTooltip', api);
        };
        TooltipView.type = 'tooltip';
        return TooltipView;
    }((0, (0, parcelRequire("fkskt")).default));
    function $ebf2596432d1aebb$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
        var ecModel = globalTooltipModel.ecModel;
        var resultModel;
        if (defaultTooltipOption) {
            resultModel = new (0, (0, parcelRequire("gaMkj")).default)(defaultTooltipOption, ecModel, ecModel);
            resultModel = new (0, (0, parcelRequire("gaMkj")).default)(globalTooltipModel.option, resultModel, ecModel);
        } else resultModel = globalTooltipModel;
        for(var i = modelCascade.length - 1; i >= 0; i--){
            var tooltipOpt = modelCascade[i];
            if (tooltipOpt) {
                if (tooltipOpt instanceof (0, (0, parcelRequire("gaMkj")).default)) tooltipOpt = tooltipOpt.get('tooltip', true);
                if ((0, parcelRequire("bahqM")).isString(tooltipOpt)) tooltipOpt = {
                    formatter: tooltipOpt
                };
                if (tooltipOpt) resultModel = new (0, (0, parcelRequire("gaMkj")).default)(tooltipOpt, resultModel, ecModel);
            }
        }
        return resultModel;
    }
    function $ebf2596432d1aebb$var$makeDispatchAction(payload, api) {
        return payload.dispatchAction || (0, parcelRequire("bahqM")).bind(api.dispatchAction, api);
    }
    function $ebf2596432d1aebb$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
        var size = content.getSize();
        var width = size[0];
        var height = size[1];
        if (gapH != null) {
            if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
            else x += gapH;
        }
        if (gapV != null) {
            if (y + height + gapV > viewHeight) y -= height + gapV;
            else y += gapV;
        }
        return [
            x,
            y
        ];
    }
    function $ebf2596432d1aebb$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
        var size = content.getSize();
        var width = size[0];
        var height = size[1];
        x = Math.min(x + width, viewWidth) - width;
        y = Math.min(y + height, viewHeight) - height;
        x = Math.max(x, 0);
        y = Math.max(y, 0);
        return [
            x,
            y
        ];
    }
    function $ebf2596432d1aebb$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
        var domWidth = contentSize[0];
        var domHeight = contentSize[1];
        var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
        var x = 0;
        var y = 0;
        var rectWidth = rect.width;
        var rectHeight = rect.height;
        switch(position){
            case 'inside':
                x = rect.x + rectWidth / 2 - domWidth / 2;
                y = rect.y + rectHeight / 2 - domHeight / 2;
                break;
            case 'top':
                x = rect.x + rectWidth / 2 - domWidth / 2;
                y = rect.y - domHeight - offset;
                break;
            case 'bottom':
                x = rect.x + rectWidth / 2 - domWidth / 2;
                y = rect.y + rectHeight + offset;
                break;
            case 'left':
                x = rect.x - domWidth - offset;
                y = rect.y + rectHeight / 2 - domHeight / 2;
                break;
            case 'right':
                x = rect.x + rectWidth + offset;
                y = rect.y + rectHeight / 2 - domHeight / 2;
        }
        return [
            x,
            y
        ];
    }
    function $ebf2596432d1aebb$var$isCenterAlign(align) {
        return align === 'center' || align === 'middle';
    }
    function $ebf2596432d1aebb$var$findComponentReference(payload, ecModel, api) {
        var queryOptionMap = (0, (0, parcelRequire("eaKsF")).preParseFinder)(payload).queryOptionMap;
        var componentMainType = queryOptionMap.keys()[0];
        if (!componentMainType || componentMainType === 'series') return;
        var queryResult = (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
            useDefault: false,
            enableAll: false,
            enableNone: false
        });
        var model = queryResult.models[0];
        if (!model) return;
        var view = api.getViewOfComponentModel(model);
        var el;
        view.group.traverse(function(subEl) {
            var tooltipConfig = (0, (0, parcelRequire("7QjoM")).getECData)(subEl).tooltipConfig;
            if (tooltipConfig && tooltipConfig.name === payload.name) {
                el = subEl;
                return true;
            }
        });
        if (el) return {
            componentMainType: componentMainType,
            componentIndex: model.componentIndex,
            el: el
        };
    }
    var $ebf2596432d1aebb$export$2e2bcd8739ae039 = $ebf2596432d1aebb$var$TooltipView;
});
parcelRegister("lh5Tz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7cfc2302c12dfb3$export$2e2bcd8739ae039);
    var $bahqM;
    var $d6udH;
    var $65X4x;
    var $6AZf6;
    var $hZfwb;
    var $dCJrM;
    var $l3AHA;
    var $j5lKL;
    var $f7cfc2302c12dfb3$var$CSS_TRANSITION_VENDOR = (0, (0, parcelRequire("l3AHA")).toCSSVendorPrefix)((0, (0, parcelRequire("l3AHA")).TRANSITION_VENDOR), 'transition');
    var $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR = (0, (0, parcelRequire("l3AHA")).toCSSVendorPrefix)((0, (0, parcelRequire("l3AHA")).TRANSFORM_VENDOR), 'transform');
    var $f7cfc2302c12dfb3$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, (0, parcelRequire("hZfwb")).default).transform3dSupported ? 'will-change:transform;' : '');
    function $f7cfc2302c12dfb3$var$mirrorPos(pos) {
        pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
        return pos;
    }
    function $f7cfc2302c12dfb3$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
        if (!(0, (0, parcelRequire("bahqM")).isString)(arrowPosition) || arrowPosition === 'inside') return '';
        var backgroundColor = tooltipModel.get('backgroundColor');
        var borderWidth = tooltipModel.get('borderWidth');
        borderColor = (0, (0, parcelRequire("dCJrM")).convertToColorString)(borderColor);
        var arrowPos = $f7cfc2302c12dfb3$var$mirrorPos(arrowPosition);
        var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
        var positionStyle = '';
        var transformStyle = $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + ':';
        var rotateDeg;
        if ((0, (0, parcelRequire("bahqM")).indexOf)([
            'left',
            'right'
        ], arrowPos) > -1) {
            positionStyle += 'top:50%';
            transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
        } else {
            positionStyle += 'left:50%';
            transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
        }
        var rotateRadian = rotateDeg * Math.PI / 180;
        var arrowWH = arrowSize + borderWidth;
        var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
        var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
        positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
        var borderStyle = borderColor + " solid " + borderWidth + "px;";
        var styleCss = [
            "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;",
            positionStyle + ";" + transformStyle + ";",
            "border-bottom:" + borderStyle,
            "border-right:" + borderStyle,
            "background-color:" + backgroundColor + ";"
        ];
        return "<div style=\"" + styleCss.join('') + "\"></div>";
    }
    function $f7cfc2302c12dfb3$var$assembleTransition(duration, onlyFade) {
        var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
        var transitionOption = " " + duration / 2 + "s " + transitionCurve;
        var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
        if (!onlyFade) {
            transitionOption = " " + duration + "s " + transitionCurve;
            transitionText += (0, (0, parcelRequire("hZfwb")).default).transformSupported ? "," + $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
        }
        return $f7cfc2302c12dfb3$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
    }
    function $f7cfc2302c12dfb3$var$assembleTransform(x, y, toString) {
        var x0 = x.toFixed(0) + 'px';
        var y0 = y.toFixed(0) + 'px';
        if (!(0, (0, parcelRequire("hZfwb")).default).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
            [
                'top',
                y0
            ],
            [
                'left',
                x0
            ]
        ];
        var is3d = (0, (0, parcelRequire("hZfwb")).default).transform3dSupported;
        var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
        return toString ? 'top:0;left:0;' + $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
            [
                'top',
                0
            ],
            [
                'left',
                0
            ],
            [
                (0, (0, parcelRequire("l3AHA")).TRANSFORM_VENDOR),
                translate
            ]
        ];
    }
    function $f7cfc2302c12dfb3$var$assembleFont(textStyleModel) {
        var cssText = [];
        var fontSize = textStyleModel.get('fontSize');
        var color = textStyleModel.getTextColor();
        color && cssText.push('color:' + color);
        cssText.push('font:' + textStyleModel.getFont());
        fontSize && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
        var shadowColor = textStyleModel.get('textShadowColor');
        var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
        var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
        var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
        shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
        (0, (0, parcelRequire("bahqM")).each)([
            'decoration',
            'align'
        ], function(name) {
            var val = textStyleModel.get(name);
            val && cssText.push('text-' + name + ':' + val);
        });
        return cssText.join(';');
    }
    function $f7cfc2302c12dfb3$var$assembleCssText(tooltipModel, enableTransition, onlyFade) {
        var cssText = [];
        var transitionDuration = tooltipModel.get('transitionDuration');
        var backgroundColor = tooltipModel.get('backgroundColor');
        var shadowBlur = tooltipModel.get('shadowBlur');
        var shadowColor = tooltipModel.get('shadowColor');
        var shadowOffsetX = tooltipModel.get('shadowOffsetX');
        var shadowOffsetY = tooltipModel.get('shadowOffsetY');
        var textStyleModel = tooltipModel.getModel('textStyle');
        var padding = (0, (0, parcelRequire("j5lKL")).getPaddingFromTooltipModel)(tooltipModel, 'html');
        var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
        cssText.push('box-shadow:' + boxShadow);
        enableTransition && transitionDuration && cssText.push($f7cfc2302c12dfb3$var$assembleTransition(transitionDuration, onlyFade));
        if (backgroundColor) {
            if ((0, (0, parcelRequire("hZfwb")).default).canvasSupported) cssText.push('background-color:' + backgroundColor);
            else {
                cssText.push('background-color:#' + (0, (0, parcelRequire("d6udH")).toHex)(backgroundColor));
                cssText.push('filter:alpha(opacity=70)');
            }
        }
        (0, (0, parcelRequire("bahqM")).each)([
            'width',
            'color',
            'radius'
        ], function(name) {
            var borderName = 'border-' + name;
            var camelCase = (0, (0, parcelRequire("dCJrM")).toCamelCase)(borderName);
            var val = tooltipModel.get(camelCase);
            val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
        });
        cssText.push($f7cfc2302c12dfb3$var$assembleFont(textStyleModel));
        if (padding != null) cssText.push('padding:' + (0, (0, parcelRequire("dCJrM")).normalizeCssArray)(padding).join('px ') + 'px');
        return cssText.join(';') + ';';
    }
    function $f7cfc2302c12dfb3$var$makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
        var zrPainter = zr && zr.painter;
        if (appendToBody) {
            var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
            if (zrViewportRoot) (0, (0, parcelRequire("6AZf6")).transformLocalCoord)(out, zrViewportRoot, document.body, zrX, zrY);
        } else {
            out[0] = zrX;
            out[1] = zrY;
            var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
            if (viewportRootOffset) {
                out[0] += viewportRootOffset.offsetLeft;
                out[1] += viewportRootOffset.offsetTop;
            }
        }
        out[2] = out[0] / zr.getWidth();
        out[3] = out[1] / zr.getHeight();
    }
    var $f7cfc2302c12dfb3$var$TooltipHTMLContent = function() {
        function TooltipHTMLContent(container, api, opt) {
            this._show = false;
            this._styleCoord = [
                0,
                0,
                0,
                0
            ];
            this._enterable = true;
            this._firstShow = true;
            this._longHide = true;
            if ((0, (0, parcelRequire("hZfwb")).default).wxa) return null;
            var el = document.createElement('div');
            el.domBelongToZr = true;
            this.el = el;
            var zr = this._zr = api.getZr();
            var appendToBody = this._appendToBody = opt && opt.appendToBody;
            $f7cfc2302c12dfb3$var$makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
            if (appendToBody) document.body.appendChild(el);
            else container.appendChild(el);
            this._container = container;
            var self = this;
            el.onmouseenter = function() {
                if (self._enterable) {
                    clearTimeout(self._hideTimeout);
                    self._show = true;
                }
                self._inContent = true;
            };
            el.onmousemove = function(e) {
                e = e || window.event;
                if (!self._enterable) {
                    var handler = zr.handler;
                    var zrViewportRoot = zr.painter.getViewportRoot();
                    (0, (0, parcelRequire("65X4x")).normalizeEvent)(zrViewportRoot, e, true);
                    handler.dispatch('mousemove', e);
                }
            };
            el.onmouseleave = function() {
                self._inContent = false;
                if (self._enterable) {
                    if (self._show) self.hideLater(self._hideDelay);
                }
            };
        }
        TooltipHTMLContent.prototype.update = function(tooltipModel) {
            var container = this._container;
            var position = (0, (0, parcelRequire("l3AHA")).getComputedStyle)(container, 'position');
            var domStyle = container.style;
            if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
            var alwaysShowContent = tooltipModel.get('alwaysShowContent');
            alwaysShowContent && this._moveIfResized();
            this.el.className = tooltipModel.get('className') || '';
        };
        TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
            clearTimeout(this._hideTimeout);
            clearTimeout(this._longHideTimeout);
            var el = this.el;
            var style = el.style;
            var styleCoord = this._styleCoord;
            if (!el.innerHTML) style.display = 'none';
            else style.cssText = $f7cfc2302c12dfb3$var$gCssText + $f7cfc2302c12dfb3$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide) + $f7cfc2302c12dfb3$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, (0, parcelRequire("dCJrM")).convertToColorString)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
            this._show = true;
            this._firstShow = false;
            this._longHide = false;
        };
        TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
            var el = this.el;
            if (content == null) {
                el.innerHTML = '';
                return;
            }
            var arrow = '';
            if ((0, (0, parcelRequire("bahqM")).isString)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, (0, parcelRequire("l3AHA")).shouldTooltipConfine)(tooltipModel)) arrow = $f7cfc2302c12dfb3$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
            if ((0, (0, parcelRequire("bahqM")).isString)(content)) el.innerHTML = content + arrow;
            else if (content) {
                el.innerHTML = '';
                if (!(0, (0, parcelRequire("bahqM")).isArray)(content)) content = [
                    content
                ];
                for(var i = 0; i < content.length; i++)if ((0, (0, parcelRequire("bahqM")).isDom)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
                if (arrow && el.childNodes.length) {
                    var arrowEl = document.createElement('div');
                    arrowEl.innerHTML = arrow;
                    el.appendChild(arrowEl);
                }
            }
        };
        TooltipHTMLContent.prototype.setEnterable = function(enterable) {
            this._enterable = enterable;
        };
        TooltipHTMLContent.prototype.getSize = function() {
            var el = this.el;
            return [
                el.offsetWidth,
                el.offsetHeight
            ];
        };
        TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
            var styleCoord = this._styleCoord;
            $f7cfc2302c12dfb3$var$makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
            if (styleCoord[0] != null && styleCoord[1] != null) {
                var style_1 = this.el.style;
                var transforms = $f7cfc2302c12dfb3$var$assembleTransform(styleCoord[0], styleCoord[1]);
                (0, (0, parcelRequire("bahqM")).each)(transforms, function(transform) {
                    style_1[transform[0]] = transform[1];
                });
            }
        };
        TooltipHTMLContent.prototype._moveIfResized = function() {
            var ratioX = this._styleCoord[2];
            var ratioY = this._styleCoord[3];
            this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
        };
        TooltipHTMLContent.prototype.hide = function() {
            var _this = this;
            var style = this.el.style;
            style.visibility = 'hidden';
            style.opacity = '0';
            (0, (0, parcelRequire("hZfwb")).default).transform3dSupported && (style.willChange = '');
            this._show = false;
            this._longHideTimeout = setTimeout(function() {
                return _this._longHide = true;
            }, 500);
        };
        TooltipHTMLContent.prototype.hideLater = function(time) {
            if (this._show && !(this._inContent && this._enterable)) {
                if (time) {
                    this._hideDelay = time;
                    this._show = false;
                    this._hideTimeout = setTimeout((0, (0, parcelRequire("bahqM")).bind)(this.hide, this), time);
                } else this.hide();
            }
        };
        TooltipHTMLContent.prototype.isShow = function() {
            return this._show;
        };
        TooltipHTMLContent.prototype.dispose = function() {
            this.el.parentNode.removeChild(this.el);
        };
        return TooltipHTMLContent;
    }();
    var $f7cfc2302c12dfb3$export$2e2bcd8739ae039 = $f7cfc2302c12dfb3$var$TooltipHTMLContent;
});
parcelRegister("l3AHA", function(module, exports) {
    $parcel$export(module.exports, "shouldTooltipConfine", ()=>$f54659081207367d$export$a309528050824ba4);
    $parcel$export(module.exports, "TRANSFORM_VENDOR", ()=>$f54659081207367d$export$7b4286b1e4a23439);
    $parcel$export(module.exports, "TRANSITION_VENDOR", ()=>$f54659081207367d$export$70a631ae991b5e76);
    $parcel$export(module.exports, "toCSSVendorPrefix", ()=>$f54659081207367d$export$5886acafe29a08d1);
    $parcel$export(module.exports, "getComputedStyle", ()=>$f54659081207367d$export$3735103072e4a80);
    var $dCJrM;
    var $hZfwb;
    function $f54659081207367d$export$a309528050824ba4(tooltipModel) {
        var confineOption = tooltipModel.get('confine');
        return confineOption != null ? !!confineOption : tooltipModel.get('renderMode') === 'richText';
    }
    function $f54659081207367d$var$testStyle(styleProps) {
        if (!(0, (0, parcelRequire("hZfwb")).default).domSupported) return;
        var style = document.documentElement.style;
        for(var i = 0, len = styleProps.length; i < len; i++){
            if (styleProps[i] in style) return styleProps[i];
        }
    }
    var $f54659081207367d$export$7b4286b1e4a23439 = $f54659081207367d$var$testStyle([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    var $f54659081207367d$export$70a631ae991b5e76 = $f54659081207367d$var$testStyle([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    function $f54659081207367d$export$5886acafe29a08d1(styleVendor, styleProp) {
        if (!styleVendor) return styleProp;
        styleProp = (0, (0, parcelRequire("dCJrM")).toCamelCase)(styleProp, true);
        var idx = styleVendor.indexOf(styleProp);
        styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
        return styleVendor.toLowerCase();
    }
    function $f54659081207367d$export$3735103072e4a80(el, style) {
        var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
        return stl ? style ? stl[style] : stl : null;
    }
});
parcelRegister("bf1zw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82f2508e80aaa8db$export$2e2bcd8739ae039);
    var $bahqM;
    var $4gEFv;
    var $j5lKL;
    var $2cFRc;
    var $82f2508e80aaa8db$var$TooltipRichContent = function() {
        function TooltipRichContent(api) {
            this._show = false;
            this._styleCoord = [
                0,
                0,
                0,
                0
            ];
            this._enterable = true;
            this._zr = api.getZr();
            $82f2508e80aaa8db$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
        }
        TooltipRichContent.prototype.update = function(tooltipModel) {
            var alwaysShowContent = tooltipModel.get('alwaysShowContent');
            alwaysShowContent && this._moveIfResized();
        };
        TooltipRichContent.prototype.show = function() {
            if (this._hideTimeout) clearTimeout(this._hideTimeout);
            this.el.show();
            this._show = true;
        };
        TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
            if ((0, parcelRequire("bahqM")).isObject(content)) (0, (0, parcelRequire("2cFRc")).throwError)('');
            if (this.el) this._zr.remove(this.el);
            var textStyleModel = tooltipModel.getModel('textStyle');
            this.el = new (0, (0, parcelRequire("4gEFv")).default)({
                style: {
                    rich: markupStyleCreator.richTextStyles,
                    text: content,
                    lineHeight: 22,
                    backgroundColor: tooltipModel.get('backgroundColor'),
                    borderRadius: tooltipModel.get('borderRadius'),
                    borderWidth: 1,
                    borderColor: borderColor,
                    shadowColor: tooltipModel.get('shadowColor'),
                    shadowBlur: tooltipModel.get('shadowBlur'),
                    shadowOffsetX: tooltipModel.get('shadowOffsetX'),
                    shadowOffsetY: tooltipModel.get('shadowOffsetY'),
                    textShadowColor: textStyleModel.get('textShadowColor'),
                    textShadowBlur: textStyleModel.get('textShadowBlur') || 0,
                    textShadowOffsetX: textStyleModel.get('textShadowOffsetX') || 0,
                    textShadowOffsetY: textStyleModel.get('textShadowOffsetY') || 0,
                    fill: tooltipModel.get([
                        'textStyle',
                        'color'
                    ]),
                    padding: (0, (0, parcelRequire("j5lKL")).getPaddingFromTooltipModel)(tooltipModel, 'richText'),
                    verticalAlign: 'top',
                    align: 'left'
                },
                z: tooltipModel.get('z')
            });
            this._zr.add(this.el);
            var self = this;
            this.el.on('mouseover', function() {
                if (self._enterable) {
                    clearTimeout(self._hideTimeout);
                    self._show = true;
                }
                self._inContent = true;
            });
            this.el.on('mouseout', function() {
                if (self._enterable) {
                    if (self._show) self.hideLater(self._hideDelay);
                }
                self._inContent = false;
            });
        };
        TooltipRichContent.prototype.setEnterable = function(enterable) {
            this._enterable = enterable;
        };
        TooltipRichContent.prototype.getSize = function() {
            var el = this.el;
            var bounding = this.el.getBoundingRect();
            var shadowOuterSize = $82f2508e80aaa8db$var$calcShadowOuterSize(el.style);
            return [
                bounding.width + shadowOuterSize.left + shadowOuterSize.right,
                bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
            ];
        };
        TooltipRichContent.prototype.moveTo = function(x, y) {
            var el = this.el;
            if (el) {
                var styleCoord = this._styleCoord;
                $82f2508e80aaa8db$var$makeStyleCoord(styleCoord, this._zr, x, y);
                x = styleCoord[0];
                y = styleCoord[1];
                var style = el.style;
                var borderWidth = $82f2508e80aaa8db$var$mathMaxWith0(style.borderWidth || 0);
                var shadowOuterSize = $82f2508e80aaa8db$var$calcShadowOuterSize(style);
                el.x = x + borderWidth + shadowOuterSize.left;
                el.y = y + borderWidth + shadowOuterSize.top;
                el.markRedraw();
            }
        };
        TooltipRichContent.prototype._moveIfResized = function() {
            var ratioX = this._styleCoord[2];
            var ratioY = this._styleCoord[3];
            this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
        };
        TooltipRichContent.prototype.hide = function() {
            if (this.el) this.el.hide();
            this._show = false;
        };
        TooltipRichContent.prototype.hideLater = function(time) {
            if (this._show && !(this._inContent && this._enterable)) {
                if (time) {
                    this._hideDelay = time;
                    this._show = false;
                    this._hideTimeout = setTimeout((0, parcelRequire("bahqM")).bind(this.hide, this), time);
                } else this.hide();
            }
        };
        TooltipRichContent.prototype.isShow = function() {
            return this._show;
        };
        TooltipRichContent.prototype.dispose = function() {
            this._zr.remove(this.el);
        };
        return TooltipRichContent;
    }();
    function $82f2508e80aaa8db$var$mathMaxWith0(val) {
        return Math.max(0, val);
    }
    function $82f2508e80aaa8db$var$calcShadowOuterSize(style) {
        var shadowBlur = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowBlur || 0);
        var shadowOffsetX = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowOffsetX || 0);
        var shadowOffsetY = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowOffsetY || 0);
        return {
            left: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur - shadowOffsetX),
            right: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur + shadowOffsetX),
            top: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur - shadowOffsetY),
            bottom: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur + shadowOffsetY)
        };
    }
    function $82f2508e80aaa8db$var$makeStyleCoord(out, zr, zrX, zrY) {
        out[0] = zrX;
        out[1] = zrY;
        out[2] = out[0] / zr.getWidth();
        out[3] = out[1] / zr.getHeight();
    }
    var $82f2508e80aaa8db$export$2e2bcd8739ae039 = $82f2508e80aaa8db$var$TooltipRichContent;
});
parcelRegister("ixV1I", function(module, exports) {
    var $jtdCU;
    $parcel$exportWildcard(module.exports, (0, parcelRequire("jtdCU")));
});
parcelRegister("jtdCU", function(module, exports) {
    var $8pqpA;
    var $a7GWb;
    var $alpND;
    var $fKViU;
    (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("fKViU")).installLabelLayout));
    $parcel$exportWildcard(module.exports, (0, parcelRequire("8pqpA")));
    $parcel$exportWildcard(module.exports, (0, parcelRequire("a7GWb")));
});
parcelRegister("a7GWb", function(module, exports) {
    $parcel$export(module.exports, "extendComponentModel", ()=>$75ebdd55a0204a2b$export$4dd01020bb736662);
    $parcel$export(module.exports, "extendComponentView", ()=>$75ebdd55a0204a2b$export$a4336148da8ef02);
    $parcel$export(module.exports, "extendSeriesModel", ()=>$75ebdd55a0204a2b$export$fe6d3114e3fc260c);
    $parcel$export(module.exports, "extendChartView", ()=>$75ebdd55a0204a2b$export$c750883d1b603e83);
    $parcel$export(module.exports, "zrender", ()=>(parcelRequire("9Y5KT")));
    $parcel$export(module.exports, "matrix", ()=>(parcelRequire("izqgC")));
    $parcel$export(module.exports, "vector", ()=>(parcelRequire("eLEew")));
    $parcel$export(module.exports, "zrUtil", ()=>(parcelRequire("bahqM")));
    $parcel$export(module.exports, "color", ()=>(parcelRequire("d6udH")));
    $parcel$export(module.exports, "throttle", ()=>(parcelRequire("ljaBy")).throttle);
    $parcel$export(module.exports, "helper", ()=>(parcelRequire("anaTl")));
    $parcel$export(module.exports, "use", ()=>(parcelRequire("alpND")).use);
    $parcel$export(module.exports, "parseGeoJSON", ()=>(parcelRequire("gyzY7")).default);
    $parcel$export(module.exports, "parseGeoJson", ()=>(parcelRequire("gyzY7")).default);
    $parcel$export(module.exports, "number", ()=>(parcelRequire("hJg2M")));
    $parcel$export(module.exports, "time", ()=>(parcelRequire("ats4w")));
    $parcel$export(module.exports, "graphic", ()=>(parcelRequire("fwli1")));
    $parcel$export(module.exports, "format", ()=>(parcelRequire("byxPd")));
    $parcel$export(module.exports, "util", ()=>(parcelRequire("fvUv7")));
    $parcel$export(module.exports, "env", ()=>(parcelRequire("hZfwb")).default);
    $parcel$export(module.exports, "List", ()=>(parcelRequire("liBXN")).default);
    $parcel$export(module.exports, "Model", ()=>(parcelRequire("gaMkj")).default);
    $parcel$export(module.exports, "Axis", ()=>(parcelRequire("g6Gq1")).default);
    $parcel$export(module.exports, "ComponentModel", ()=>(parcelRequire("h4UlH")).default);
    $parcel$export(module.exports, "ComponentView", ()=>(parcelRequire("fkskt")).default);
    $parcel$export(module.exports, "SeriesModel", ()=>(parcelRequire("1O7Ua")).default);
    $parcel$export(module.exports, "ChartView", ()=>(parcelRequire("loerw")).default);
    $parcel$export(module.exports, "innerDrawElementOnCanvas", ()=>(parcelRequire("aSzOj")).brushSingle);
    var $h4UlH;
    var $fkskt;
    var $1O7Ua;
    var $loerw;
    var $liBXN;
    var $9Y5KT;
    var $izqgC;
    var $eLEew;
    var $bahqM;
    var $d6udH;
    var $ljaBy;
    var $anaTl;
    var $alpND;
    var $gyzY7;
    var $hJg2M;
    var $ats4w;
    var $fwli1;
    var $byxPd;
    var $fvUv7;
    var $hZfwb;
    var $gaMkj;
    var $g6Gq1;
    var $aSzOj;
    function $75ebdd55a0204a2b$export$4dd01020bb736662(proto) {
        var Model = (0, (0, parcelRequire("h4UlH")).default).extend(proto);
        (0, (0, parcelRequire("h4UlH")).default).registerClass(Model);
        return Model;
    }
    function $75ebdd55a0204a2b$export$a4336148da8ef02(proto) {
        var View = (0, (0, parcelRequire("fkskt")).default).extend(proto);
        (0, (0, parcelRequire("fkskt")).default).registerClass(View);
        return View;
    }
    function $75ebdd55a0204a2b$export$fe6d3114e3fc260c(proto) {
        var Model = (0, (0, parcelRequire("1O7Ua")).default).extend(proto);
        (0, (0, parcelRequire("1O7Ua")).default).registerClass(Model);
        return Model;
    }
    function $75ebdd55a0204a2b$export$c750883d1b603e83(proto) {
        var View = (0, (0, parcelRequire("loerw")).default).extend(proto);
        (0, (0, parcelRequire("loerw")).default).registerClass(View);
        return View;
    }
});
parcelRegister("anaTl", function(module, exports) {
    $parcel$export(module.exports, "createList", ()=>$78d480381111bb0c$export$5897d8d7c7a3d871);
    $parcel$export(module.exports, "dataStack", ()=>$78d480381111bb0c$export$d6100971d5a3a0a7);
    $parcel$export(module.exports, "createScale", ()=>$78d480381111bb0c$export$587d9c3c553380c6);
    $parcel$export(module.exports, "mixinAxisModelCommonMethods", ()=>$78d480381111bb0c$export$4665cbe3470e4d57);
    $parcel$export(module.exports, "createTextStyle", ()=>$78d480381111bb0c$export$f8998c3d0a13de59);
    $parcel$export(module.exports, "getLayoutRect", ()=>(parcelRequire("65MS1")).getLayoutRect);
    $parcel$export(module.exports, "createDimensions", ()=>(parcelRequire("h9jiS")).createDimensions);
    $parcel$export(module.exports, "createSymbol", ()=>(parcelRequire("7yklO")).createSymbol);
    $parcel$export(module.exports, "getECData", ()=>(parcelRequire("7QjoM")).getECData);
    $parcel$export(module.exports, "enableHoverEmphasis", ()=>(parcelRequire("fIXXx")).enableHoverEmphasis);
    var $bahqM;
    var $bAY5l;
    var $3GIoT;
    var $5pBRm;
    var $gaMkj;
    var $65MS1;
    var $5R8Hi;
    var $7QjoM;
    var $gvLUt;
    var $h9jiS;
    var $7yklO;
    var $fIXXx;
    function $78d480381111bb0c$export$5897d8d7c7a3d871(seriesModel) {
        return (0, (0, parcelRequire("bAY5l")).default)(null, seriesModel);
    }
    var $78d480381111bb0c$export$d6100971d5a3a0a7 = {
        isDimensionStacked: (0, (0, parcelRequire("5R8Hi")).isDimensionStacked),
        enableDataStack: (0, (0, parcelRequire("5R8Hi")).enableDataStack),
        getStackedDimension: (0, (0, parcelRequire("5R8Hi")).getStackedDimension)
    };
    function $78d480381111bb0c$export$587d9c3c553380c6(dataExtent, option) {
        var axisModel = option;
        if (!(option instanceof (0, (0, parcelRequire("gaMkj")).default))) axisModel = new (0, (0, parcelRequire("gaMkj")).default)(option);
        var scale = (0, parcelRequire("3GIoT")).createScaleByModel(axisModel);
        scale.setExtent(dataExtent[0], dataExtent[1]);
        (0, parcelRequire("3GIoT")).niceScaleExtent(scale, axisModel);
        return scale;
    }
    function $78d480381111bb0c$export$4665cbe3470e4d57(Model) {
        (0, parcelRequire("bahqM")).mixin(Model, (0, (0, parcelRequire("5pBRm")).AxisModelCommonMixin));
    }
    function $78d480381111bb0c$export$f8998c3d0a13de59(textStyleModel, opts) {
        opts = opts || {};
        return (0, (0, parcelRequire("gvLUt")).createTextStyle)(textStyleModel, null, null, opts.state !== 'normal');
    }
});
parcelRegister("hJg2M", function(module, exports) {
    $parcel$export(module.exports, "linearMap", ()=>(parcelRequire("jmSNG")).linearMap);
    $parcel$export(module.exports, "round", ()=>(parcelRequire("jmSNG")).round);
    $parcel$export(module.exports, "asc", ()=>(parcelRequire("jmSNG")).asc);
    $parcel$export(module.exports, "getPrecision", ()=>(parcelRequire("jmSNG")).getPrecision);
    $parcel$export(module.exports, "getPrecisionSafe", ()=>(parcelRequire("jmSNG")).getPrecisionSafe);
    $parcel$export(module.exports, "getPixelPrecision", ()=>(parcelRequire("jmSNG")).getPixelPrecision);
    $parcel$export(module.exports, "getPercentWithPrecision", ()=>(parcelRequire("jmSNG")).getPercentWithPrecision);
    $parcel$export(module.exports, "MAX_SAFE_INTEGER", ()=>(parcelRequire("jmSNG")).MAX_SAFE_INTEGER);
    $parcel$export(module.exports, "remRadian", ()=>(parcelRequire("jmSNG")).remRadian);
    $parcel$export(module.exports, "isRadianAroundZero", ()=>(parcelRequire("jmSNG")).isRadianAroundZero);
    $parcel$export(module.exports, "parseDate", ()=>(parcelRequire("jmSNG")).parseDate);
    $parcel$export(module.exports, "quantity", ()=>(parcelRequire("jmSNG")).quantity);
    $parcel$export(module.exports, "quantityExponent", ()=>(parcelRequire("jmSNG")).quantityExponent);
    $parcel$export(module.exports, "nice", ()=>(parcelRequire("jmSNG")).nice);
    $parcel$export(module.exports, "quantile", ()=>(parcelRequire("jmSNG")).quantile);
    $parcel$export(module.exports, "reformIntervals", ()=>(parcelRequire("jmSNG")).reformIntervals);
    $parcel$export(module.exports, "isNumeric", ()=>(parcelRequire("jmSNG")).isNumeric);
    $parcel$export(module.exports, "numericToNumber", ()=>(parcelRequire("jmSNG")).numericToNumber);
    var $jmSNG;
});
parcelRegister("ats4w", function(module, exports) {
    $parcel$export(module.exports, "parse", ()=>(parcelRequire("jmSNG")).parseDate);
    $parcel$export(module.exports, "format", ()=>(parcelRequire("bc1Ad")).format);
    var $jmSNG;
    var $bc1Ad;
});
parcelRegister("fwli1", function(module, exports) {
    $parcel$export(module.exports, "extendShape", ()=>(parcelRequire("fHITF")).extendShape);
    $parcel$export(module.exports, "extendPath", ()=>(parcelRequire("fHITF")).extendPath);
    $parcel$export(module.exports, "makePath", ()=>(parcelRequire("fHITF")).makePath);
    $parcel$export(module.exports, "makeImage", ()=>(parcelRequire("fHITF")).makeImage);
    $parcel$export(module.exports, "mergePath", ()=>(parcelRequire("fHITF")).mergePath);
    $parcel$export(module.exports, "resizePath", ()=>(parcelRequire("fHITF")).resizePath);
    $parcel$export(module.exports, "createIcon", ()=>(parcelRequire("fHITF")).createIcon);
    $parcel$export(module.exports, "updateProps", ()=>(parcelRequire("eYgMC")).updateProps);
    $parcel$export(module.exports, "initProps", ()=>(parcelRequire("eYgMC")).initProps);
    $parcel$export(module.exports, "getTransform", ()=>(parcelRequire("fHITF")).getTransform);
    $parcel$export(module.exports, "clipPointsByRect", ()=>(parcelRequire("fHITF")).clipPointsByRect);
    $parcel$export(module.exports, "clipRectByRect", ()=>(parcelRequire("fHITF")).clipRectByRect);
    $parcel$export(module.exports, "registerShape", ()=>(parcelRequire("fHITF")).registerShape);
    $parcel$export(module.exports, "getShapeClass", ()=>(parcelRequire("fHITF")).getShapeClass);
    $parcel$export(module.exports, "Group", ()=>(parcelRequire("4KVOr")).default);
    $parcel$export(module.exports, "Image", ()=>(parcelRequire("gcbBH")).default);
    $parcel$export(module.exports, "Text", ()=>(parcelRequire("4gEFv")).default);
    $parcel$export(module.exports, "Circle", ()=>(parcelRequire("jjfok")).default);
    $parcel$export(module.exports, "Ellipse", ()=>(parcelRequire("kVeV8")).default);
    $parcel$export(module.exports, "Sector", ()=>(parcelRequire("elGBV")).default);
    $parcel$export(module.exports, "Ring", ()=>(parcelRequire("LCHOw")).default);
    $parcel$export(module.exports, "Polygon", ()=>(parcelRequire("lQwBc")).default);
    $parcel$export(module.exports, "Polyline", ()=>(parcelRequire("32bXc")).default);
    $parcel$export(module.exports, "Rect", ()=>(parcelRequire("7Tw7u")).default);
    $parcel$export(module.exports, "Line", ()=>(parcelRequire("cZb1F")).default);
    $parcel$export(module.exports, "BezierCurve", ()=>(parcelRequire("04gw0")).default);
    $parcel$export(module.exports, "Arc", ()=>(parcelRequire("ixXaU")).default);
    $parcel$export(module.exports, "IncrementalDisplayable", ()=>(parcelRequire("6sllV")).default);
    $parcel$export(module.exports, "CompoundPath", ()=>(parcelRequire("eGltS")).default);
    $parcel$export(module.exports, "LinearGradient", ()=>(parcelRequire("9J7f8")).default);
    $parcel$export(module.exports, "RadialGradient", ()=>(parcelRequire("faICo")).default);
    $parcel$export(module.exports, "BoundingRect", ()=>(parcelRequire("1E3E8")).default);
    parcelRequire("fHITF");
    var $ixXaU;
    var $04gw0;
    var $jjfok;
    var $fHITF;
    var $kVeV8;
    var $gcbBH;
    var $cZb1F;
    var $lQwBc;
    var $32bXc;
    var $7Tw7u;
    var $LCHOw;
    var $elGBV;
    var $eYgMC;
    var $1E3E8;
    var $eGltS;
    var $4KVOr;
    var $6sllV;
    var $eYgMC;
    var $9J7f8;
    var $faICo;
    var $4gEFv;
});
parcelRegister("byxPd", function(module, exports) {
    $parcel$export(module.exports, "addCommas", ()=>(parcelRequire("dCJrM")).addCommas);
    $parcel$export(module.exports, "toCamelCase", ()=>(parcelRequire("dCJrM")).toCamelCase);
    $parcel$export(module.exports, "normalizeCssArray", ()=>(parcelRequire("dCJrM")).normalizeCssArray);
    $parcel$export(module.exports, "encodeHTML", ()=>(parcelRequire("dCJrM")).encodeHTML);
    $parcel$export(module.exports, "formatTpl", ()=>(parcelRequire("dCJrM")).formatTpl);
    $parcel$export(module.exports, "getTooltipMarker", ()=>(parcelRequire("dCJrM")).getTooltipMarker);
    $parcel$export(module.exports, "formatTime", ()=>(parcelRequire("dCJrM")).formatTime);
    $parcel$export(module.exports, "capitalFirst", ()=>(parcelRequire("dCJrM")).capitalFirst);
    $parcel$export(module.exports, "truncateText", ()=>(parcelRequire("h6fMM")).truncateText);
    $parcel$export(module.exports, "getTextRect", ()=>(parcelRequire("2emZ2")).getTextRect);
    var $dCJrM;
    var $2emZ2;
    var $h6fMM;
});
parcelRegister("fvUv7", function(module, exports) {
    $parcel$export(module.exports, "map", ()=>(parcelRequire("bahqM")).map);
    $parcel$export(module.exports, "each", ()=>(parcelRequire("bahqM")).each);
    $parcel$export(module.exports, "indexOf", ()=>(parcelRequire("bahqM")).indexOf);
    $parcel$export(module.exports, "inherits", ()=>(parcelRequire("bahqM")).inherits);
    $parcel$export(module.exports, "reduce", ()=>(parcelRequire("bahqM")).reduce);
    $parcel$export(module.exports, "filter", ()=>(parcelRequire("bahqM")).filter);
    $parcel$export(module.exports, "bind", ()=>(parcelRequire("bahqM")).bind);
    $parcel$export(module.exports, "curry", ()=>(parcelRequire("bahqM")).curry);
    $parcel$export(module.exports, "isArray", ()=>(parcelRequire("bahqM")).isArray);
    $parcel$export(module.exports, "isString", ()=>(parcelRequire("bahqM")).isString);
    $parcel$export(module.exports, "isObject", ()=>(parcelRequire("bahqM")).isObject);
    $parcel$export(module.exports, "isFunction", ()=>(parcelRequire("bahqM")).isFunction);
    $parcel$export(module.exports, "extend", ()=>(parcelRequire("bahqM")).extend);
    $parcel$export(module.exports, "defaults", ()=>(parcelRequire("bahqM")).defaults);
    $parcel$export(module.exports, "clone", ()=>(parcelRequire("bahqM")).clone);
    $parcel$export(module.exports, "merge", ()=>(parcelRequire("bahqM")).merge);
    var $bahqM;
});
parcelRegister("fKViU", function(module, exports) {
    $parcel$export(module.exports, "installLabelLayout", ()=>$b7879a416965ee89$export$5320d1b3745c02a5);
    var $eaKsF;
    var $JIQqQ;
    var $b7879a416965ee89$var$getLabelManager = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $b7879a416965ee89$export$5320d1b3745c02a5(registers) {
        registers.registerUpdateLifecycle('series:beforeupdate', function(ecModel, api, params) {
            var labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager;
            if (!labelManager) labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager = new (0, (0, parcelRequire("JIQqQ")).default)();
            labelManager.clearLabels();
        });
        registers.registerUpdateLifecycle('series:layoutlabels', function(ecModel, api, params) {
            var labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager;
            params.updatedSeries.forEach(function(series) {
                labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
            });
            labelManager.updateLayoutConfig(api);
            labelManager.layout(api);
            labelManager.processLabelsOverall();
        });
    }
});
parcelRegister("JIQqQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0896fd4d6c482b72$export$2e2bcd8739ae039);
    var $1E3E8;
    var $eYgMC;
    parcelRequire("fHITF");
    var $eYgMC;
    var $7QjoM;
    var $jmSNG;
    var $e6gef;
    var $fxCHE;
    var $eaKsF;
    var $bahqM;
    var $3LB2b;
    var $gvLUt;
    function $0896fd4d6c482b72$var$cloneArr(points) {
        if (points) {
            var newPoints = [];
            for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
            return newPoints;
        }
    }
    function $0896fd4d6c482b72$var$prepareLayoutCallbackParams(labelItem, hostEl) {
        var label = labelItem.label;
        var labelLine = hostEl && hostEl.getTextGuideLine();
        return {
            dataIndex: labelItem.dataIndex,
            dataType: labelItem.dataType,
            seriesIndex: labelItem.seriesModel.seriesIndex,
            text: labelItem.label.style.text,
            rect: labelItem.hostRect,
            labelRect: labelItem.rect,
            align: label.style.align,
            verticalAlign: label.style.verticalAlign,
            labelLinePoints: $0896fd4d6c482b72$var$cloneArr(labelLine && labelLine.shape.points)
        };
    }
    var $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS = [
        'align',
        'verticalAlign',
        'width',
        'height',
        'fontSize'
    ];
    var $0896fd4d6c482b72$var$dummyTransformable = new (0, (0, parcelRequire("e6gef")).default)();
    var $0896fd4d6c482b72$var$labelLayoutInnerStore = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $0896fd4d6c482b72$var$labelLineAnimationStore = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $0896fd4d6c482b72$var$extendWithKeys(target, source, keys) {
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (source[key] != null) target[key] = source[key];
        }
    }
    var $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS = [
        'x',
        'y',
        'rotation'
    ];
    var $0896fd4d6c482b72$var$LabelManager = function() {
        function LabelManager() {
            this._labelList = [];
            this._chartViewList = [];
        }
        LabelManager.prototype.clearLabels = function() {
            this._labelList = [];
            this._chartViewList = [];
        };
        LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
            var labelStyle = label.style;
            var hostEl = label.__hostTarget;
            var textConfig = hostEl.textConfig || {};
            var labelTransform = label.getComputedTransform();
            var labelRect = label.getBoundingRect().plain();
            (0, (0, parcelRequire("1E3E8")).default).applyTransform(labelRect, labelRect, labelTransform);
            if (labelTransform) $0896fd4d6c482b72$var$dummyTransformable.setLocalTransform(labelTransform);
            else {
                $0896fd4d6c482b72$var$dummyTransformable.x = $0896fd4d6c482b72$var$dummyTransformable.y = $0896fd4d6c482b72$var$dummyTransformable.rotation = $0896fd4d6c482b72$var$dummyTransformable.originX = $0896fd4d6c482b72$var$dummyTransformable.originY = 0;
                $0896fd4d6c482b72$var$dummyTransformable.scaleX = $0896fd4d6c482b72$var$dummyTransformable.scaleY = 1;
            }
            var host = label.__hostTarget;
            var hostRect;
            if (host) {
                hostRect = host.getBoundingRect().plain();
                var transform = host.getComputedTransform();
                (0, (0, parcelRequire("1E3E8")).default).applyTransform(hostRect, hostRect, transform);
            }
            var labelGuide = hostRect && host.getTextGuideLine();
            this._labelList.push({
                label: label,
                labelLine: labelGuide,
                seriesModel: seriesModel,
                dataIndex: dataIndex,
                dataType: dataType,
                layoutOption: layoutOption,
                computedLayoutOption: null,
                rect: labelRect,
                hostRect: hostRect,
                priority: hostRect ? hostRect.width * hostRect.height : 0,
                defaultAttr: {
                    ignore: label.ignore,
                    labelGuideIgnore: labelGuide && labelGuide.ignore,
                    x: $0896fd4d6c482b72$var$dummyTransformable.x,
                    y: $0896fd4d6c482b72$var$dummyTransformable.y,
                    scaleX: $0896fd4d6c482b72$var$dummyTransformable.scaleX,
                    scaleY: $0896fd4d6c482b72$var$dummyTransformable.scaleY,
                    rotation: $0896fd4d6c482b72$var$dummyTransformable.rotation,
                    style: {
                        x: labelStyle.x,
                        y: labelStyle.y,
                        align: labelStyle.align,
                        verticalAlign: labelStyle.verticalAlign,
                        width: labelStyle.width,
                        height: labelStyle.height,
                        fontSize: labelStyle.fontSize
                    },
                    cursor: label.cursor,
                    attachedPos: textConfig.position,
                    attachedRot: textConfig.rotation
                }
            });
        };
        LabelManager.prototype.addLabelsOfSeries = function(chartView) {
            var _this = this;
            this._chartViewList.push(chartView);
            var seriesModel = chartView.__model;
            var layoutOption = seriesModel.get('labelLayout');
            if (!((0, (0, parcelRequire("bahqM")).isFunction)(layoutOption) || (0, (0, parcelRequire("bahqM")).keys)(layoutOption).length)) return;
            chartView.group.traverse(function(child) {
                if (child.ignore) return true;
                var textEl = child.getTextContent();
                var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(child);
                if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
            });
        };
        LabelManager.prototype.updateLayoutConfig = function(api) {
            var width = api.getWidth();
            var height = api.getHeight();
            function createDragHandler(el, labelLineModel) {
                return function() {
                    (0, (0, parcelRequire("fxCHE")).updateLabelLinePoints)(el, labelLineModel);
                };
            }
            for(var i = 0; i < this._labelList.length; i++){
                var labelItem = this._labelList[i];
                var label = labelItem.label;
                var hostEl = label.__hostTarget;
                var defaultLabelAttr = labelItem.defaultAttr;
                var layoutOption = void 0;
                if (typeof labelItem.layoutOption === 'function') layoutOption = labelItem.layoutOption($0896fd4d6c482b72$var$prepareLayoutCallbackParams(labelItem, hostEl));
                else layoutOption = labelItem.layoutOption;
                layoutOption = layoutOption || {};
                labelItem.computedLayoutOption = layoutOption;
                var degreeToRadian = Math.PI / 180;
                if (hostEl) hostEl.setTextConfig({
                    local: false,
                    position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                    rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                    offset: [
                        layoutOption.dx || 0,
                        layoutOption.dy || 0
                    ]
                });
                var needsUpdateLabelLine = false;
                if (layoutOption.x != null) {
                    label.x = (0, (0, parcelRequire("jmSNG")).parsePercent)(layoutOption.x, width);
                    label.setStyle('x', 0);
                    needsUpdateLabelLine = true;
                } else {
                    label.x = defaultLabelAttr.x;
                    label.setStyle('x', defaultLabelAttr.style.x);
                }
                if (layoutOption.y != null) {
                    label.y = (0, (0, parcelRequire("jmSNG")).parsePercent)(layoutOption.y, height);
                    label.setStyle('y', 0);
                    needsUpdateLabelLine = true;
                } else {
                    label.y = defaultLabelAttr.y;
                    label.setStyle('y', defaultLabelAttr.style.y);
                }
                if (layoutOption.labelLinePoints) {
                    var guideLine = hostEl.getTextGuideLine();
                    if (guideLine) {
                        guideLine.setShape({
                            points: layoutOption.labelLinePoints
                        });
                        needsUpdateLabelLine = false;
                    }
                }
                var labelLayoutStore = $0896fd4d6c482b72$var$labelLayoutInnerStore(label);
                labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
                label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
                label.scaleX = defaultLabelAttr.scaleX;
                label.scaleY = defaultLabelAttr.scaleY;
                for(var k = 0; k < $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                    var key = $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                    label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
                }
                if (layoutOption.draggable) {
                    label.draggable = true;
                    label.cursor = 'move';
                    if (hostEl) {
                        var hostModel = labelItem.seriesModel;
                        if (labelItem.dataIndex != null) {
                            var data = labelItem.seriesModel.getData(labelItem.dataType);
                            hostModel = data.getItemModel(labelItem.dataIndex);
                        }
                        label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
                    }
                } else {
                    label.off('drag');
                    label.cursor = defaultLabelAttr.cursor;
                }
            }
        };
        LabelManager.prototype.layout = function(api) {
            var width = api.getWidth();
            var height = api.getHeight();
            var labelList = (0, (0, parcelRequire("3LB2b")).prepareLayoutList)(this._labelList);
            var labelsNeedsAdjustOnX = (0, (0, parcelRequire("bahqM")).filter)(labelList, function(item) {
                return item.layoutOption.moveOverlap === 'shiftX';
            });
            var labelsNeedsAdjustOnY = (0, (0, parcelRequire("bahqM")).filter)(labelList, function(item) {
                return item.layoutOption.moveOverlap === 'shiftY';
            });
            (0, (0, parcelRequire("3LB2b")).shiftLayoutOnX)(labelsNeedsAdjustOnX, 0, width);
            (0, (0, parcelRequire("3LB2b")).shiftLayoutOnY)(labelsNeedsAdjustOnY, 0, height);
            var labelsNeedsHideOverlap = (0, (0, parcelRequire("bahqM")).filter)(labelList, function(item) {
                return item.layoutOption.hideOverlap;
            });
            (0, (0, parcelRequire("3LB2b")).hideOverlap)(labelsNeedsHideOverlap);
        };
        LabelManager.prototype.processLabelsOverall = function() {
            var _this = this;
            (0, (0, parcelRequire("bahqM")).each)(this._chartViewList, function(chartView) {
                var seriesModel = chartView.__model;
                var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
                var animationEnabled = seriesModel.isAnimationEnabled();
                chartView.group.traverse(function(child) {
                    if (child.ignore) return true;
                    var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                    var label = child.getTextContent();
                    if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $0896fd4d6c482b72$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                    if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                    if (animationEnabled) _this._animateLabels(child, seriesModel);
                });
            });
        };
        LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
            var textEl = el.getTextContent();
            var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
            var dataIndex = ecData.dataIndex;
            if (textEl && dataIndex != null) {
                var data = seriesModel.getData(ecData.dataType);
                var itemModel = data.getItemModel(dataIndex);
                var defaultStyle = {};
                var visualStyle = data.getItemVisual(dataIndex, 'style');
                var visualType = data.getVisual('drawType');
                defaultStyle.stroke = visualStyle[visualType];
                var labelLineModel = itemModel.getModel('labelLine');
                (0, (0, parcelRequire("fxCHE")).setLabelLineStyle)(el, (0, (0, parcelRequire("fxCHE")).getLabelLineStatesModels)(itemModel), defaultStyle);
                (0, (0, parcelRequire("fxCHE")).updateLabelLinePoints)(el, labelLineModel);
            }
        };
        LabelManager.prototype._animateLabels = function(el, seriesModel) {
            var textEl = el.getTextContent();
            var guideLine = el.getTextGuideLine();
            if (textEl && !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, (0, parcelRequire("eYgMC")).isElementRemoved)(el)) {
                var layoutStore = $0896fd4d6c482b72$var$labelLayoutInnerStore(textEl);
                var oldLayout = layoutStore.oldLayout;
                var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
                var dataIndex = ecData.dataIndex;
                var newProps = {
                    x: textEl.x,
                    y: textEl.y,
                    rotation: textEl.rotation
                };
                var data = seriesModel.getData(ecData.dataType);
                if (!oldLayout) {
                    textEl.attr(newProps);
                    if (!(0, (0, parcelRequire("gvLUt")).labelInner)(textEl).valueAnimation) {
                        var oldOpacity = (0, (0, parcelRequire("bahqM")).retrieve2)(textEl.style.opacity, 1);
                        textEl.style.opacity = 0;
                        (0, (0, parcelRequire("eYgMC")).initProps)(textEl, {
                            style: {
                                opacity: oldOpacity
                            }
                        }, seriesModel, dataIndex);
                    }
                } else {
                    textEl.attr(oldLayout);
                    var prevStates = el.prevStates;
                    if (prevStates) {
                        if ((0, (0, parcelRequire("bahqM")).indexOf)(prevStates, 'select') >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                        if ((0, (0, parcelRequire("bahqM")).indexOf)(prevStates, 'emphasis') >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                    }
                    (0, (0, parcelRequire("eYgMC")).updateProps)(textEl, newProps, seriesModel, dataIndex);
                }
                layoutStore.oldLayout = newProps;
                if (textEl.states.select) {
                    var layoutSelect = layoutStore.oldLayoutSelect = {};
                    $0896fd4d6c482b72$var$extendWithKeys(layoutSelect, newProps, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                    $0896fd4d6c482b72$var$extendWithKeys(layoutSelect, textEl.states.select, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                }
                if (textEl.states.emphasis) {
                    var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                    $0896fd4d6c482b72$var$extendWithKeys(layoutEmphasis, newProps, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                    $0896fd4d6c482b72$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                }
                (0, (0, parcelRequire("gvLUt")).animateLabelValue)(textEl, dataIndex, data, seriesModel, seriesModel);
            }
            if (guideLine && !guideLine.ignore && !guideLine.invisible) {
                var layoutStore = $0896fd4d6c482b72$var$labelLineAnimationStore(guideLine);
                var oldLayout = layoutStore.oldLayout;
                var newLayout = {
                    points: guideLine.shape.points
                };
                if (!oldLayout) {
                    guideLine.setShape(newLayout);
                    guideLine.style.strokePercent = 0;
                    (0, (0, parcelRequire("eYgMC")).initProps)(guideLine, {
                        style: {
                            strokePercent: 1
                        }
                    }, seriesModel);
                } else {
                    guideLine.attr({
                        shape: oldLayout
                    });
                    (0, (0, parcelRequire("eYgMC")).updateProps)(guideLine, {
                        shape: newLayout
                    }, seriesModel);
                }
                layoutStore.oldLayout = newLayout;
            }
        };
        return LabelManager;
    }();
    var $0896fd4d6c482b72$export$2e2bcd8739ae039 = $0896fd4d6c482b72$var$LabelManager;
});
parcelRegister("fxCHE", function(module, exports) {
    $parcel$export(module.exports, "updateLabelLinePoints", ()=>$02eb7bb47d256bbb$export$cc93ba643cd97d83);
    $parcel$export(module.exports, "limitTurnAngle", ()=>$02eb7bb47d256bbb$export$ac52062003fbe6a);
    $parcel$export(module.exports, "limitSurfaceAngle", ()=>$02eb7bb47d256bbb$export$973e1fdb2708f71b);
    $parcel$export(module.exports, "setLabelLineStyle", ()=>$02eb7bb47d256bbb$export$c09e0b0574bdd2dc);
    $parcel$export(module.exports, "getLabelLineStatesModels", ()=>$02eb7bb47d256bbb$export$2979fdbf5ebce521);
    parcelRequire("fHITF");
    var $ghQ8v;
    var $32bXc;
    var $bMDnR;
    var $aA4Ws;
    var $kvt3T;
    var $dr1jo;
    var $bahqM;
    var $izqgC;
    var $eLEew;
    var $fIXXx;
    var $02eb7bb47d256bbb$var$PI2 = Math.PI * 2;
    var $02eb7bb47d256bbb$var$CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
    var $02eb7bb47d256bbb$var$DEFAULT_SEARCH_SPACE = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    function $02eb7bb47d256bbb$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
        var width = rect.width;
        var height = rect.height;
        switch(pos){
            case 'top':
                outPt.set(rect.x + width / 2, rect.y - distance);
                outDir.set(0, -1);
                break;
            case 'bottom':
                outPt.set(rect.x + width / 2, rect.y + height + distance);
                outDir.set(0, 1);
                break;
            case 'left':
                outPt.set(rect.x - distance, rect.y + height / 2);
                outDir.set(-1, 0);
                break;
            case 'right':
                outPt.set(rect.x + width + distance, rect.y + height / 2);
                outDir.set(1, 0);
                break;
        }
    }
    function $02eb7bb47d256bbb$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
        x -= cx;
        y -= cy;
        var d = Math.sqrt(x * x + y * y);
        x /= d;
        y /= d;
        var ox = x * r + cx;
        var oy = y * r + cy;
        if (Math.abs(startAngle - endAngle) % $02eb7bb47d256bbb$var$PI2 < 1e-4) {
            out[0] = ox;
            out[1] = oy;
            return d - r;
        }
        if (anticlockwise) {
            var tmp = startAngle;
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(tmp);
        } else {
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(startAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
        }
        if (startAngle > endAngle) endAngle += $02eb7bb47d256bbb$var$PI2;
        var angle = Math.atan2(y, x);
        if (angle < 0) angle += $02eb7bb47d256bbb$var$PI2;
        if (angle >= startAngle && angle <= endAngle || angle + $02eb7bb47d256bbb$var$PI2 >= startAngle && angle + $02eb7bb47d256bbb$var$PI2 <= endAngle) {
            out[0] = ox;
            out[1] = oy;
            return d - r;
        }
        var x1 = r * Math.cos(startAngle) + cx;
        var y1 = r * Math.sin(startAngle) + cy;
        var x2 = r * Math.cos(endAngle) + cx;
        var y2 = r * Math.sin(endAngle) + cy;
        var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
        var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
        if (d1 < d2) {
            out[0] = x1;
            out[1] = y1;
            return Math.sqrt(d1);
        } else {
            out[0] = x2;
            out[1] = y2;
            return Math.sqrt(d2);
        }
    }
    function $02eb7bb47d256bbb$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
        var dx = x - x1;
        var dy = y - y1;
        var dx1 = x2 - x1;
        var dy1 = y2 - y1;
        var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
        dx1 /= lineLen;
        dy1 /= lineLen;
        var projectedLen = dx * dx1 + dy * dy1;
        var t = projectedLen / lineLen;
        if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
        t *= lineLen;
        var ox = out[0] = x1 + t * dx1;
        var oy = out[1] = y1 + t * dy1;
        return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
    }
    function $02eb7bb47d256bbb$var$projectPointToRect(x1, y1, width, height, x, y, out) {
        if (width < 0) {
            x1 = x1 + width;
            width = -width;
        }
        if (height < 0) {
            y1 = y1 + height;
            height = -height;
        }
        var x2 = x1 + width;
        var y2 = y1 + height;
        var ox = out[0] = Math.min(Math.max(x, x1), x2);
        var oy = out[1] = Math.min(Math.max(y, y1), y2);
        return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
    }
    var $02eb7bb47d256bbb$var$tmpPt = [];
    function $02eb7bb47d256bbb$var$nearestPointOnRect(pt, rect, out) {
        var dist = $02eb7bb47d256bbb$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $02eb7bb47d256bbb$var$tmpPt);
        out.set($02eb7bb47d256bbb$var$tmpPt[0], $02eb7bb47d256bbb$var$tmpPt[1]);
        return dist;
    }
    function $02eb7bb47d256bbb$var$nearestPointOnPath(pt, path, out) {
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var x1;
        var y1;
        var minDist = Infinity;
        var data = path.data;
        var x = pt.x;
        var y = pt.y;
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            if (i === 1) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var d = minDist;
            switch(cmd){
                case $02eb7bb47d256bbb$var$CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    xi = x0;
                    yi = y0;
                    break;
                case $02eb7bb47d256bbb$var$CMD.L:
                    d = $02eb7bb47d256bbb$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt, true);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $02eb7bb47d256bbb$var$CMD.C:
                    d = (0, (0, parcelRequire("dr1jo")).cubicProjectPoint)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $02eb7bb47d256bbb$var$CMD.Q:
                    d = (0, (0, parcelRequire("dr1jo")).quadraticProjectPoint)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $02eb7bb47d256bbb$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var theta = data[i++];
                    var dTheta = data[i++];
                    i += 1;
                    var anticlockwise = !!(1 - data[i++]);
                    x1 = Math.cos(theta) * rx + cx;
                    y1 = Math.sin(theta) * ry + cy;
                    if (i <= 1) {
                        x0 = x1;
                        y0 = y1;
                    }
                    var _x = (x - cx) * ry / rx + cx;
                    d = $02eb7bb47d256bbb$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $02eb7bb47d256bbb$var$tmpPt);
                    xi = Math.cos(theta + dTheta) * rx + cx;
                    yi = Math.sin(theta + dTheta) * ry + cy;
                    break;
                case $02eb7bb47d256bbb$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    d = $02eb7bb47d256bbb$var$projectPointToRect(x0, y0, width, height, x, y, $02eb7bb47d256bbb$var$tmpPt);
                    break;
                case $02eb7bb47d256bbb$var$CMD.Z:
                    d = $02eb7bb47d256bbb$var$projectPointToLine(xi, yi, x0, y0, x, y, $02eb7bb47d256bbb$var$tmpPt, true);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (d < minDist) {
                minDist = d;
                out.set($02eb7bb47d256bbb$var$tmpPt[0], $02eb7bb47d256bbb$var$tmpPt[1]);
            }
        }
        return minDist;
    }
    var $02eb7bb47d256bbb$var$pt0 = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$pt1 = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$pt2 = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$dir = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$dir2 = new (0, (0, parcelRequire("bMDnR")).default)();
    function $02eb7bb47d256bbb$export$cc93ba643cd97d83(target, labelLineModel) {
        if (!target) return;
        var labelLine = target.getTextGuideLine();
        var label = target.getTextContent();
        if (!(label && labelLine)) return;
        var labelGuideConfig = target.textGuideLineConfig || {};
        var points = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        var searchSpace = labelGuideConfig.candidates || $02eb7bb47d256bbb$var$DEFAULT_SEARCH_SPACE;
        var labelRect = label.getBoundingRect().clone();
        labelRect.applyTransform(label.getComputedTransform());
        var minDist = Infinity;
        var anchorPoint = labelGuideConfig.anchor;
        var targetTransform = target.getComputedTransform();
        var targetInversedTransform = targetTransform && (0, (0, parcelRequire("izqgC")).invert)([], targetTransform);
        var len = labelLineModel.get('length2') || 0;
        if (anchorPoint) $02eb7bb47d256bbb$var$pt2.copy(anchorPoint);
        for(var i = 0; i < searchSpace.length; i++){
            var candidate = searchSpace[i];
            $02eb7bb47d256bbb$var$getCandidateAnchor(candidate, 0, labelRect, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$dir);
            (0, (0, parcelRequire("bMDnR")).default).scaleAndAdd($02eb7bb47d256bbb$var$pt1, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$dir, len);
            $02eb7bb47d256bbb$var$pt1.transform(targetInversedTransform);
            var boundingRect = target.getBoundingRect();
            var dist = anchorPoint ? anchorPoint.distance($02eb7bb47d256bbb$var$pt1) : target instanceof (0, (0, parcelRequire("ghQ8v")).default) ? $02eb7bb47d256bbb$var$nearestPointOnPath($02eb7bb47d256bbb$var$pt1, target.path, $02eb7bb47d256bbb$var$pt2) : $02eb7bb47d256bbb$var$nearestPointOnRect($02eb7bb47d256bbb$var$pt1, boundingRect, $02eb7bb47d256bbb$var$pt2);
            if (dist < minDist) {
                minDist = dist;
                $02eb7bb47d256bbb$var$pt1.transform(targetTransform);
                $02eb7bb47d256bbb$var$pt2.transform(targetTransform);
                $02eb7bb47d256bbb$var$pt2.toArray(points[0]);
                $02eb7bb47d256bbb$var$pt1.toArray(points[1]);
                $02eb7bb47d256bbb$var$pt0.toArray(points[2]);
            }
        }
        $02eb7bb47d256bbb$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
        labelLine.setShape({
            points: points
        });
    }
    var $02eb7bb47d256bbb$var$tmpArr = [];
    var $02eb7bb47d256bbb$var$tmpProjPoint = new (0, (0, parcelRequire("bMDnR")).default)();
    function $02eb7bb47d256bbb$export$ac52062003fbe6a(linePoints, minTurnAngle) {
        if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
        minTurnAngle = minTurnAngle / 180 * Math.PI;
        $02eb7bb47d256bbb$var$pt0.fromArray(linePoints[0]);
        $02eb7bb47d256bbb$var$pt1.fromArray(linePoints[1]);
        $02eb7bb47d256bbb$var$pt2.fromArray(linePoints[2]);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$pt1);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir2, $02eb7bb47d256bbb$var$pt2, $02eb7bb47d256bbb$var$pt1);
        var len1 = $02eb7bb47d256bbb$var$dir.len();
        var len2 = $02eb7bb47d256bbb$var$dir2.len();
        if (len1 < 1e-3 || len2 < 1e-3) return;
        $02eb7bb47d256bbb$var$dir.scale(1 / len1);
        $02eb7bb47d256bbb$var$dir2.scale(1 / len2);
        var angleCos = $02eb7bb47d256bbb$var$dir.dot($02eb7bb47d256bbb$var$dir2);
        var minTurnAngleCos = Math.cos(minTurnAngle);
        if (minTurnAngleCos < angleCos) {
            var d = $02eb7bb47d256bbb$var$projectPointToLine($02eb7bb47d256bbb$var$pt1.x, $02eb7bb47d256bbb$var$pt1.y, $02eb7bb47d256bbb$var$pt2.x, $02eb7bb47d256bbb$var$pt2.y, $02eb7bb47d256bbb$var$pt0.x, $02eb7bb47d256bbb$var$pt0.y, $02eb7bb47d256bbb$var$tmpArr, false);
            $02eb7bb47d256bbb$var$tmpProjPoint.fromArray($02eb7bb47d256bbb$var$tmpArr);
            $02eb7bb47d256bbb$var$tmpProjPoint.scaleAndAdd($02eb7bb47d256bbb$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
            var t = $02eb7bb47d256bbb$var$pt2.x !== $02eb7bb47d256bbb$var$pt1.x ? ($02eb7bb47d256bbb$var$tmpProjPoint.x - $02eb7bb47d256bbb$var$pt1.x) / ($02eb7bb47d256bbb$var$pt2.x - $02eb7bb47d256bbb$var$pt1.x) : ($02eb7bb47d256bbb$var$tmpProjPoint.y - $02eb7bb47d256bbb$var$pt1.y) / ($02eb7bb47d256bbb$var$pt2.y - $02eb7bb47d256bbb$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt1);
            else if (t > 1) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
            $02eb7bb47d256bbb$var$tmpProjPoint.toArray(linePoints[1]);
        }
    }
    function $02eb7bb47d256bbb$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
        if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
        maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
        $02eb7bb47d256bbb$var$pt0.fromArray(linePoints[0]);
        $02eb7bb47d256bbb$var$pt1.fromArray(linePoints[1]);
        $02eb7bb47d256bbb$var$pt2.fromArray(linePoints[2]);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir, $02eb7bb47d256bbb$var$pt1, $02eb7bb47d256bbb$var$pt0);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir2, $02eb7bb47d256bbb$var$pt2, $02eb7bb47d256bbb$var$pt1);
        var len1 = $02eb7bb47d256bbb$var$dir.len();
        var len2 = $02eb7bb47d256bbb$var$dir2.len();
        if (len1 < 1e-3 || len2 < 1e-3) return;
        $02eb7bb47d256bbb$var$dir.scale(1 / len1);
        $02eb7bb47d256bbb$var$dir2.scale(1 / len2);
        var angleCos = $02eb7bb47d256bbb$var$dir.dot(surfaceNormal);
        var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
        if (angleCos < maxSurfaceAngleCos) {
            var d = $02eb7bb47d256bbb$var$projectPointToLine($02eb7bb47d256bbb$var$pt1.x, $02eb7bb47d256bbb$var$pt1.y, $02eb7bb47d256bbb$var$pt2.x, $02eb7bb47d256bbb$var$pt2.y, $02eb7bb47d256bbb$var$pt0.x, $02eb7bb47d256bbb$var$pt0.y, $02eb7bb47d256bbb$var$tmpArr, false);
            $02eb7bb47d256bbb$var$tmpProjPoint.fromArray($02eb7bb47d256bbb$var$tmpArr);
            var HALF_PI = Math.PI / 2;
            var angle2 = Math.acos($02eb7bb47d256bbb$var$dir2.dot(surfaceNormal));
            var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
            if (newAngle >= HALF_PI) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
            else {
                $02eb7bb47d256bbb$var$tmpProjPoint.scaleAndAdd($02eb7bb47d256bbb$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
                var t = $02eb7bb47d256bbb$var$pt2.x !== $02eb7bb47d256bbb$var$pt1.x ? ($02eb7bb47d256bbb$var$tmpProjPoint.x - $02eb7bb47d256bbb$var$pt1.x) / ($02eb7bb47d256bbb$var$pt2.x - $02eb7bb47d256bbb$var$pt1.x) : ($02eb7bb47d256bbb$var$tmpProjPoint.y - $02eb7bb47d256bbb$var$pt1.y) / ($02eb7bb47d256bbb$var$pt2.y - $02eb7bb47d256bbb$var$pt1.y);
                if (isNaN(t)) return;
                if (t < 0) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt1);
                else if (t > 1) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
            }
            $02eb7bb47d256bbb$var$tmpProjPoint.toArray(linePoints[1]);
        }
    }
    function $02eb7bb47d256bbb$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
        var isNormal = stateName === 'normal';
        var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
        stateObj.ignore = ignore;
        var smooth = stateModel.get('smooth');
        if (smooth && smooth === true) smooth = 0.3;
        stateObj.shape = stateObj.shape || {};
        if (smooth > 0) stateObj.shape.smooth = smooth;
        var styleObj = stateModel.getModel('lineStyle').getLineStyle();
        isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
    }
    function $02eb7bb47d256bbb$var$buildLabelLinePath(path, shape) {
        var smooth = shape.smooth;
        var points = shape.points;
        if (!points) return;
        path.moveTo(points[0][0], points[0][1]);
        if (smooth > 0 && points.length >= 3) {
            var len1 = (0, parcelRequire("eLEew")).dist(points[0], points[1]);
            var len2 = (0, parcelRequire("eLEew")).dist(points[1], points[2]);
            if (!len1 || !len2) {
                path.lineTo(points[1][0], points[1][1]);
                path.lineTo(points[2][0], points[2][1]);
                return;
            }
            var moveLen = Math.min(len1, len2) * smooth;
            var midPoint0 = (0, parcelRequire("eLEew")).lerp([], points[1], points[0], moveLen / len1);
            var midPoint2 = (0, parcelRequire("eLEew")).lerp([], points[1], points[2], moveLen / len2);
            var midPoint1 = (0, parcelRequire("eLEew")).lerp([], midPoint0, midPoint2, 0.5);
            path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
            path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
        } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
    }
    function $02eb7bb47d256bbb$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
        var labelLine = targetEl.getTextGuideLine();
        var label = targetEl.getTextContent();
        if (!label) {
            if (labelLine) targetEl.removeTextGuideLine();
            return;
        }
        var normalModel = statesModels.normal;
        var showNormal = normalModel.get('show');
        var labelIgnoreNormal = label.ignore;
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).DISPLAY_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).DISPLAY_STATES)[i];
            var stateModel = statesModels[stateName];
            var isNormal = stateName === 'normal';
            if (stateModel) {
                var stateShow = stateModel.get('show');
                var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, (0, parcelRequire("bahqM")).retrieve2)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
                if (isLabelIgnored || !(0, (0, parcelRequire("bahqM")).retrieve2)(stateShow, showNormal)) {
                    var stateObj = isNormal ? labelLine : labelLine && labelLine.states.normal;
                    if (stateObj) stateObj.ignore = true;
                    continue;
                }
                if (!labelLine) {
                    labelLine = new (0, (0, parcelRequire("32bXc")).default)();
                    targetEl.setTextGuideLine(labelLine);
                    if (!isNormal && (labelIgnoreNormal || !showNormal)) $02eb7bb47d256bbb$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                    if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
                }
                $02eb7bb47d256bbb$var$setLabelLineState(labelLine, false, stateName, stateModel);
            }
        }
        if (labelLine) {
            (0, (0, parcelRequire("bahqM")).defaults)(labelLine.style, defaultStyle);
            labelLine.style.fill = null;
            var showAbove = normalModel.get('showAbove');
            var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
            labelLineConfig.showAbove = showAbove || false;
            labelLine.buildPath = $02eb7bb47d256bbb$var$buildLabelLinePath;
        }
    }
    function $02eb7bb47d256bbb$export$2979fdbf5ebce521(itemModel, labelLineName) {
        labelLineName = labelLineName || 'labelLine';
        var statesModels = {
            normal: itemModel.getModel(labelLineName)
        };
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            statesModels[stateName] = itemModel.getModel([
                stateName,
                labelLineName
            ]);
        }
        return statesModels;
    }
});
parcelRegister("lWgYs", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$ff8c2e783e169ee8$export$4b3e715f166fdd78);
    var $e0x7p;
    function $ff8c2e783e169ee8$export$4b3e715f166fdd78(registers) {
        registers.registerPainter('canvas', (0, (0, parcelRequire("e0x7p")).default));
    }
});
parcelRegister("e0x7p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a32ac17084074784$export$2e2bcd8739ae039);
    var $7y1my;
    var $bahqM;
    var $kNXN5;
    var $04xko;
    var $gcbBH;
    var $hZfwb;
    var $aSzOj;
    var $aVawM;
    var $a32ac17084074784$var$HOVER_LAYER_ZLEVEL = 1e5;
    var $a32ac17084074784$var$CANVAS_ZLEVEL = 314159;
    var $a32ac17084074784$var$EL_AFTER_INCREMENTAL_INC = 0.01;
    var $a32ac17084074784$var$INCREMENTAL_INC = 0.001;
    function $a32ac17084074784$var$parseInt10(val) {
        return parseInt(val, 10);
    }
    function $a32ac17084074784$var$isLayerValid(layer) {
        if (!layer) return false;
        if (layer.__builtin__) return true;
        if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') return false;
        return true;
    }
    function $a32ac17084074784$var$createRoot(width, height) {
        var domRoot = document.createElement('div');
        domRoot.style.cssText = [
            'position:relative',
            'width:' + width + 'px',
            'height:' + height + 'px',
            'padding:0',
            'margin:0',
            'border-width:0'
        ].join(';') + ';';
        return domRoot;
    }
    var $a32ac17084074784$var$CanvasPainter = function() {
        function CanvasPainter(root, storage, opts, id) {
            this.type = 'canvas';
            this._zlevelList = [];
            this._prevDisplayList = [];
            this._layers = {};
            this._layerConfig = {};
            this._needsManuallyCompositing = false;
            this.type = 'canvas';
            var singleCanvas = !root.nodeName || root.nodeName.toUpperCase() === 'CANVAS';
            this._opts = opts = (0, parcelRequire("bahqM")).extend({}, opts || {});
            this.dpr = opts.devicePixelRatio || (0, (0, parcelRequire("7y1my")).devicePixelRatio);
            this._singleCanvas = singleCanvas;
            this.root = root;
            var rootStyle = root.style;
            if (rootStyle) {
                rootStyle.webkitTapHighlightColor = 'transparent';
                rootStyle.webkitUserSelect = 'none';
                rootStyle.userSelect = 'none';
                rootStyle['-webkit-touch-callout'] = 'none';
                root.innerHTML = '';
            }
            this.storage = storage;
            var zlevelList = this._zlevelList;
            this._prevDisplayList = [];
            var layers = this._layers;
            if (!singleCanvas) {
                this._width = this._getSize(0);
                this._height = this._getSize(1);
                var domRoot = this._domRoot = $a32ac17084074784$var$createRoot(this._width, this._height);
                root.appendChild(domRoot);
            } else {
                var rootCanvas = root;
                var width = rootCanvas.width;
                var height = rootCanvas.height;
                if (opts.width != null) width = opts.width;
                if (opts.height != null) height = opts.height;
                this.dpr = opts.devicePixelRatio || 1;
                rootCanvas.width = width * this.dpr;
                rootCanvas.height = height * this.dpr;
                this._width = width;
                this._height = height;
                var mainLayer = new (0, (0, parcelRequire("kNXN5")).default)(rootCanvas, this, this.dpr);
                mainLayer.__builtin__ = true;
                mainLayer.initContext();
                layers[$a32ac17084074784$var$CANVAS_ZLEVEL] = mainLayer;
                mainLayer.zlevel = $a32ac17084074784$var$CANVAS_ZLEVEL;
                zlevelList.push($a32ac17084074784$var$CANVAS_ZLEVEL);
                this._domRoot = root;
            }
        }
        CanvasPainter.prototype.getType = function() {
            return 'canvas';
        };
        CanvasPainter.prototype.isSingleCanvas = function() {
            return this._singleCanvas;
        };
        CanvasPainter.prototype.getViewportRoot = function() {
            return this._domRoot;
        };
        CanvasPainter.prototype.getViewportRootOffset = function() {
            var viewportRoot = this.getViewportRoot();
            if (viewportRoot) return {
                offsetLeft: viewportRoot.offsetLeft || 0,
                offsetTop: viewportRoot.offsetTop || 0
            };
        };
        CanvasPainter.prototype.refresh = function(paintAll) {
            var list = this.storage.getDisplayList(true);
            var prevList = this._prevDisplayList;
            var zlevelList = this._zlevelList;
            this._redrawId = Math.random();
            this._paintList(list, prevList, paintAll, this._redrawId);
            for(var i = 0; i < zlevelList.length; i++){
                var z = zlevelList[i];
                var layer = this._layers[z];
                if (!layer.__builtin__ && layer.refresh) {
                    var clearColor = i === 0 ? this._backgroundColor : null;
                    layer.refresh(clearColor);
                }
            }
            if (this._opts.useDirtyRect) this._prevDisplayList = list.slice();
            return this;
        };
        CanvasPainter.prototype.refreshHover = function() {
            this._paintHoverList(this.storage.getDisplayList(false));
        };
        CanvasPainter.prototype._paintHoverList = function(list) {
            var len = list.length;
            var hoverLayer = this._hoverlayer;
            hoverLayer && hoverLayer.clear();
            if (!len) return;
            var scope = {
                inHover: true,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var ctx;
            for(var i = 0; i < len; i++){
                var el = list[i];
                if (el.__inHover) {
                    if (!hoverLayer) hoverLayer = this._hoverlayer = this.getLayer($a32ac17084074784$var$HOVER_LAYER_ZLEVEL);
                    if (!ctx) {
                        ctx = hoverLayer.ctx;
                        ctx.save();
                    }
                    (0, (0, parcelRequire("aSzOj")).brush)(ctx, el, scope, i === len - 1);
                }
            }
            if (ctx) ctx.restore();
        };
        CanvasPainter.prototype.getHoverLayer = function() {
            return this.getLayer($a32ac17084074784$var$HOVER_LAYER_ZLEVEL);
        };
        CanvasPainter.prototype.paintOne = function(ctx, el) {
            (0, (0, parcelRequire("aSzOj")).brushSingle)(ctx, el);
        };
        CanvasPainter.prototype._paintList = function(list, prevList, paintAll, redrawId) {
            if (this._redrawId !== redrawId) return;
            paintAll = paintAll || false;
            this._updateLayerStatus(list);
            var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
            if (this._needsManuallyCompositing) this._compositeManually();
            if (needsRefreshHover) this._paintHoverList(list);
            if (!finished) {
                var self_1 = this;
                (0, (0, parcelRequire("04xko")).default)(function() {
                    self_1._paintList(list, prevList, paintAll, redrawId);
                });
            } else this.eachLayer(function(layer) {
                layer.afterBrush && layer.afterBrush();
            });
        };
        CanvasPainter.prototype._compositeManually = function() {
            var ctx = this.getLayer($a32ac17084074784$var$CANVAS_ZLEVEL).ctx;
            var width = this._domRoot.width;
            var height = this._domRoot.height;
            ctx.clearRect(0, 0, width, height);
            this.eachBuiltinLayer(function(layer) {
                if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
            });
        };
        CanvasPainter.prototype._doPaintList = function(list, prevList, paintAll) {
            var _this = this;
            var layerList = [];
            var useDirtyRect = this._opts.useDirtyRect;
            for(var zi = 0; zi < this._zlevelList.length; zi++){
                var zlevel = this._zlevelList[zi];
                var layer = this._layers[zlevel];
                if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) layerList.push(layer);
            }
            var finished = true;
            var needsRefreshHover = false;
            var _loop_1 = function(k) {
                var layer = layerList[k];
                var ctx = layer.ctx;
                var repaintRects = useDirtyRect && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
                var start = paintAll ? layer.__startIndex : layer.__drawIndex;
                var useTimer = !paintAll && layer.incremental && Date.now;
                var startTime = useTimer && Date.now();
                var clearColor = layer.zlevel === this_1._zlevelList[0] ? this_1._backgroundColor : null;
                if (layer.__startIndex === layer.__endIndex) layer.clear(false, clearColor, repaintRects);
                else if (start === layer.__startIndex) {
                    var firstEl = list[start];
                    if (!firstEl.incremental || !firstEl.notClear || paintAll) layer.clear(false, clearColor, repaintRects);
                }
                if (start === -1) {
                    console.error('For some unknown reason. drawIndex is -1');
                    start = layer.__startIndex;
                }
                var i;
                var repaint = function(repaintRect) {
                    var scope = {
                        inHover: false,
                        allClipped: false,
                        prevEl: null,
                        viewWidth: _this._width,
                        viewHeight: _this._height
                    };
                    for(i = start; i < layer.__endIndex; i++){
                        var el = list[i];
                        if (el.__inHover) needsRefreshHover = true;
                        _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                        if (useTimer) {
                            var dTime = Date.now() - startTime;
                            if (dTime > 15) break;
                        }
                    }
                    if (scope.prevElClipPaths) ctx.restore();
                };
                if (repaintRects) {
                    if (repaintRects.length === 0) i = layer.__endIndex;
                    else {
                        var dpr = this_1.dpr;
                        for(var r = 0; r < repaintRects.length; ++r){
                            var rect = repaintRects[r];
                            ctx.save();
                            ctx.beginPath();
                            ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                            ctx.clip();
                            repaint(rect);
                            ctx.restore();
                        }
                    }
                } else {
                    ctx.save();
                    repaint();
                    ctx.restore();
                }
                layer.__drawIndex = i;
                if (layer.__drawIndex < layer.__endIndex) finished = false;
            };
            var this_1 = this;
            for(var k = 0; k < layerList.length; k++)_loop_1(k);
            if ((0, (0, parcelRequire("hZfwb")).default).wxa) (0, parcelRequire("bahqM")).each(this._layers, function(layer) {
                if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
            });
            return {
                finished: finished,
                needsRefreshHover: needsRefreshHover
            };
        };
        CanvasPainter.prototype._doPaintEl = function(el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
            var ctx = currentLayer.ctx;
            if (useDirtyRect) {
                var paintRect = el.getPaintRect();
                if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                    (0, (0, parcelRequire("aSzOj")).brush)(ctx, el, scope, isLast);
                    el.setPrevPaintRect(paintRect);
                }
            } else (0, (0, parcelRequire("aSzOj")).brush)(ctx, el, scope, isLast);
        };
        CanvasPainter.prototype.getLayer = function(zlevel, virtual) {
            if (this._singleCanvas && !this._needsManuallyCompositing) zlevel = $a32ac17084074784$var$CANVAS_ZLEVEL;
            var layer = this._layers[zlevel];
            if (!layer) {
                layer = new (0, (0, parcelRequire("kNXN5")).default)('zr_' + zlevel, this, this.dpr);
                layer.zlevel = zlevel;
                layer.__builtin__ = true;
                if (this._layerConfig[zlevel]) (0, parcelRequire("bahqM")).merge(layer, this._layerConfig[zlevel], true);
                else if (this._layerConfig[zlevel - $a32ac17084074784$var$EL_AFTER_INCREMENTAL_INC]) (0, parcelRequire("bahqM")).merge(layer, this._layerConfig[zlevel - $a32ac17084074784$var$EL_AFTER_INCREMENTAL_INC], true);
                if (virtual) layer.virtual = virtual;
                this.insertLayer(zlevel, layer);
                layer.initContext();
            }
            return layer;
        };
        CanvasPainter.prototype.insertLayer = function(zlevel, layer) {
            var layersMap = this._layers;
            var zlevelList = this._zlevelList;
            var len = zlevelList.length;
            var domRoot = this._domRoot;
            var prevLayer = null;
            var i = -1;
            if (layersMap[zlevel]) {
                (0, parcelRequire("bahqM")).logError('ZLevel ' + zlevel + ' has been used already');
                return;
            }
            if (!$a32ac17084074784$var$isLayerValid(layer)) {
                (0, parcelRequire("bahqM")).logError('Layer of zlevel ' + zlevel + ' is not valid');
                return;
            }
            if (len > 0 && zlevel > zlevelList[0]) {
                for(i = 0; i < len - 1; i++){
                    if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) break;
                }
                prevLayer = layersMap[zlevelList[i]];
            }
            zlevelList.splice(i + 1, 0, zlevel);
            layersMap[zlevel] = layer;
            if (!layer.virtual) {
                if (prevLayer) {
                    var prevDom = prevLayer.dom;
                    if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                    else domRoot.appendChild(layer.dom);
                } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
                else domRoot.appendChild(layer.dom);
            }
            layer.__painter = this;
        };
        CanvasPainter.prototype.eachLayer = function(cb, context) {
            var zlevelList = this._zlevelList;
            for(var i = 0; i < zlevelList.length; i++){
                var z = zlevelList[i];
                cb.call(context, this._layers[z], z);
            }
        };
        CanvasPainter.prototype.eachBuiltinLayer = function(cb, context) {
            var zlevelList = this._zlevelList;
            for(var i = 0; i < zlevelList.length; i++){
                var z = zlevelList[i];
                var layer = this._layers[z];
                if (layer.__builtin__) cb.call(context, layer, z);
            }
        };
        CanvasPainter.prototype.eachOtherLayer = function(cb, context) {
            var zlevelList = this._zlevelList;
            for(var i = 0; i < zlevelList.length; i++){
                var z = zlevelList[i];
                var layer = this._layers[z];
                if (!layer.__builtin__) cb.call(context, layer, z);
            }
        };
        CanvasPainter.prototype.getLayers = function() {
            return this._layers;
        };
        CanvasPainter.prototype._updateLayerStatus = function(list) {
            this.eachBuiltinLayer(function(layer, z) {
                layer.__dirty = layer.__used = false;
            });
            function updatePrevLayer(idx) {
                if (prevLayer) {
                    if (prevLayer.__endIndex !== idx) prevLayer.__dirty = true;
                    prevLayer.__endIndex = idx;
                }
            }
            if (this._singleCanvas) for(var i_1 = 1; i_1 < list.length; i_1++){
                var el = list[i_1];
                if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                    this._needsManuallyCompositing = true;
                    break;
                }
            }
            var prevLayer = null;
            var incrementalLayerCount = 0;
            var prevZlevel;
            var i;
            for(i = 0; i < list.length; i++){
                var el = list[i];
                var zlevel = el.zlevel;
                var layer = void 0;
                if (prevZlevel !== zlevel) {
                    prevZlevel = zlevel;
                    incrementalLayerCount = 0;
                }
                if (el.incremental) {
                    layer = this.getLayer(zlevel + $a32ac17084074784$var$INCREMENTAL_INC, this._needsManuallyCompositing);
                    layer.incremental = true;
                    incrementalLayerCount = 1;
                } else layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? $a32ac17084074784$var$EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
                if (!layer.__builtin__) (0, parcelRequire("bahqM")).logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
                if (layer !== prevLayer) {
                    layer.__used = true;
                    if (layer.__startIndex !== i) layer.__dirty = true;
                    layer.__startIndex = i;
                    if (!layer.incremental) layer.__drawIndex = i;
                    else layer.__drawIndex = -1;
                    updatePrevLayer(i);
                    prevLayer = layer;
                }
                if (el.__dirty & (0, (0, parcelRequire("aVawM")).REDRAW_BIT) && !el.__inHover) {
                    layer.__dirty = true;
                    if (layer.incremental && layer.__drawIndex < 0) layer.__drawIndex = i;
                }
            }
            updatePrevLayer(i);
            this.eachBuiltinLayer(function(layer, z) {
                if (!layer.__used && layer.getElementCount() > 0) {
                    layer.__dirty = true;
                    layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
                }
                if (layer.__dirty && layer.__drawIndex < 0) layer.__drawIndex = layer.__startIndex;
            });
        };
        CanvasPainter.prototype.clear = function() {
            this.eachBuiltinLayer(this._clearLayer);
            return this;
        };
        CanvasPainter.prototype._clearLayer = function(layer) {
            layer.clear();
        };
        CanvasPainter.prototype.setBackgroundColor = function(backgroundColor) {
            this._backgroundColor = backgroundColor;
            (0, parcelRequire("bahqM")).each(this._layers, function(layer) {
                layer.setUnpainted();
            });
        };
        CanvasPainter.prototype.configLayer = function(zlevel, config) {
            if (config) {
                var layerConfig = this._layerConfig;
                if (!layerConfig[zlevel]) layerConfig[zlevel] = config;
                else (0, parcelRequire("bahqM")).merge(layerConfig[zlevel], config, true);
                for(var i = 0; i < this._zlevelList.length; i++){
                    var _zlevel = this._zlevelList[i];
                    if (_zlevel === zlevel || _zlevel === zlevel + $a32ac17084074784$var$EL_AFTER_INCREMENTAL_INC) {
                        var layer = this._layers[_zlevel];
                        (0, parcelRequire("bahqM")).merge(layer, layerConfig[zlevel], true);
                    }
                }
            }
        };
        CanvasPainter.prototype.delLayer = function(zlevel) {
            var layers = this._layers;
            var zlevelList = this._zlevelList;
            var layer = layers[zlevel];
            if (!layer) return;
            layer.dom.parentNode.removeChild(layer.dom);
            delete layers[zlevel];
            zlevelList.splice((0, parcelRequire("bahqM")).indexOf(zlevelList, zlevel), 1);
        };
        CanvasPainter.prototype.resize = function(width, height) {
            if (!this._domRoot.style) {
                if (width == null || height == null) return;
                this._width = width;
                this._height = height;
                this.getLayer($a32ac17084074784$var$CANVAS_ZLEVEL).resize(width, height);
            } else {
                var domRoot = this._domRoot;
                domRoot.style.display = 'none';
                var opts = this._opts;
                width != null && (opts.width = width);
                height != null && (opts.height = height);
                width = this._getSize(0);
                height = this._getSize(1);
                domRoot.style.display = '';
                if (this._width !== width || height !== this._height) {
                    domRoot.style.width = width + 'px';
                    domRoot.style.height = height + 'px';
                    for(var id in this._layers)if (this._layers.hasOwnProperty(id)) this._layers[id].resize(width, height);
                    this.refresh(true);
                }
                this._width = width;
                this._height = height;
            }
            return this;
        };
        CanvasPainter.prototype.clearLayer = function(zlevel) {
            var layer = this._layers[zlevel];
            if (layer) layer.clear();
        };
        CanvasPainter.prototype.dispose = function() {
            this.root.innerHTML = '';
            this.root = this.storage = this._domRoot = this._layers = null;
        };
        CanvasPainter.prototype.getRenderedCanvas = function(opts) {
            opts = opts || {};
            if (this._singleCanvas && !this._compositeManually) return this._layers[$a32ac17084074784$var$CANVAS_ZLEVEL].dom;
            var imageLayer = new (0, (0, parcelRequire("kNXN5")).default)('image', this, opts.pixelRatio || this.dpr);
            imageLayer.initContext();
            imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
            var ctx = imageLayer.ctx;
            if (opts.pixelRatio <= this.dpr) {
                this.refresh();
                var width_1 = imageLayer.dom.width;
                var height_1 = imageLayer.dom.height;
                this.eachLayer(function(layer) {
                    if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                    else if (layer.renderToCanvas) {
                        ctx.save();
                        layer.renderToCanvas(ctx);
                        ctx.restore();
                    }
                });
            } else {
                var scope = {
                    inHover: false,
                    viewWidth: this._width,
                    viewHeight: this._height
                };
                var displayList = this.storage.getDisplayList(true);
                for(var i = 0, len = displayList.length; i < len; i++){
                    var el = displayList[i];
                    (0, (0, parcelRequire("aSzOj")).brush)(ctx, el, scope, i === len - 1);
                }
            }
            return imageLayer.dom;
        };
        CanvasPainter.prototype.getWidth = function() {
            return this._width;
        };
        CanvasPainter.prototype.getHeight = function() {
            return this._height;
        };
        CanvasPainter.prototype._getSize = function(whIdx) {
            var opts = this._opts;
            var wh = [
                'width',
                'height'
            ][whIdx];
            var cwh = [
                'clientWidth',
                'clientHeight'
            ][whIdx];
            var plt = [
                'paddingLeft',
                'paddingTop'
            ][whIdx];
            var prb = [
                'paddingRight',
                'paddingBottom'
            ][whIdx];
            if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
            var root = this.root;
            var stl = document.defaultView.getComputedStyle(root);
            return (root[cwh] || $a32ac17084074784$var$parseInt10(stl[wh]) || $a32ac17084074784$var$parseInt10(root.style[wh])) - ($a32ac17084074784$var$parseInt10(stl[plt]) || 0) - ($a32ac17084074784$var$parseInt10(stl[prb]) || 0) | 0;
        };
        CanvasPainter.prototype.pathToImage = function(path, dpr) {
            dpr = dpr || this.dpr;
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var rect = path.getBoundingRect();
            var style = path.style;
            var shadowBlurSize = style.shadowBlur * dpr;
            var shadowOffsetX = style.shadowOffsetX * dpr;
            var shadowOffsetY = style.shadowOffsetY * dpr;
            var lineWidth = path.hasStroke() ? style.lineWidth : 0;
            var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
            var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
            var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
            var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
            var width = rect.width + leftMargin + rightMargin;
            var height = rect.height + topMargin + bottomMargin;
            canvas.width = width * dpr;
            canvas.height = height * dpr;
            ctx.scale(dpr, dpr);
            ctx.clearRect(0, 0, width, height);
            ctx.dpr = dpr;
            var pathTransform = {
                x: path.x,
                y: path.y,
                scaleX: path.scaleX,
                scaleY: path.scaleY,
                rotation: path.rotation,
                originX: path.originX,
                originY: path.originY
            };
            path.x = leftMargin - rect.x;
            path.y = topMargin - rect.y;
            path.rotation = 0;
            path.scaleX = 1;
            path.scaleY = 1;
            path.updateTransform();
            if (path) (0, (0, parcelRequire("aSzOj")).brush)(ctx, path, {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            }, true);
            var imgShape = new (0, (0, parcelRequire("gcbBH")).default)({
                style: {
                    x: 0,
                    y: 0,
                    image: canvas
                }
            });
            (0, parcelRequire("bahqM")).extend(path, pathTransform);
            return imgShape;
        };
        return CanvasPainter;
    }();
    var $a32ac17084074784$export$2e2bcd8739ae039 = $a32ac17084074784$var$CanvasPainter;
});
parcelRegister("kNXN5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f256c37231bc47c1$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $7y1my;
    var $bRKv5;
    var $dPYp9;
    var $aSzOj;
    var $1E3E8;
    var $aVawM;
    function $f256c37231bc47c1$var$returnFalse() {
        return false;
    }
    function $f256c37231bc47c1$var$createDom(id, painter, dpr) {
        var newDom = (0, parcelRequire("bahqM")).createCanvas();
        var width = painter.getWidth();
        var height = painter.getHeight();
        var newDomStyle = newDom.style;
        if (newDomStyle) {
            newDomStyle.position = 'absolute';
            newDomStyle.left = '0';
            newDomStyle.top = '0';
            newDomStyle.width = width + 'px';
            newDomStyle.height = height + 'px';
            newDom.setAttribute('data-zr-dom-id', id);
        }
        newDom.width = width * dpr;
        newDom.height = height * dpr;
        return newDom;
    }
    var $f256c37231bc47c1$var$Layer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Layer, _super);
        function Layer(id, painter, dpr) {
            var _this = _super.call(this) || this;
            _this.motionBlur = false;
            _this.lastFrameAlpha = 0.7;
            _this.dpr = 1;
            _this.virtual = false;
            _this.config = {};
            _this.incremental = false;
            _this.zlevel = 0;
            _this.maxRepaintRectCount = 5;
            _this.__dirty = true;
            _this.__firstTimePaint = true;
            _this.__used = false;
            _this.__drawIndex = 0;
            _this.__startIndex = 0;
            _this.__endIndex = 0;
            _this.__prevStartIndex = null;
            _this.__prevEndIndex = null;
            var dom;
            dpr = dpr || (0, (0, parcelRequire("7y1my")).devicePixelRatio);
            if (typeof id === 'string') dom = $f256c37231bc47c1$var$createDom(id, painter, dpr);
            else if ((0, parcelRequire("bahqM")).isObject(id)) {
                dom = id;
                id = dom.id;
            }
            _this.id = id;
            _this.dom = dom;
            var domStyle = dom.style;
            if (domStyle) {
                dom.onselectstart = $f256c37231bc47c1$var$returnFalse;
                domStyle.webkitUserSelect = 'none';
                domStyle.userSelect = 'none';
                domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
                domStyle['-webkit-touch-callout'] = 'none';
                domStyle.padding = '0';
                domStyle.margin = '0';
                domStyle.borderWidth = '0';
            }
            _this.domBack = null;
            _this.ctxBack = null;
            _this.painter = painter;
            _this.config = null;
            _this.dpr = dpr;
            return _this;
        }
        Layer.prototype.getElementCount = function() {
            return this.__endIndex - this.__startIndex;
        };
        Layer.prototype.afterBrush = function() {
            this.__prevStartIndex = this.__startIndex;
            this.__prevEndIndex = this.__endIndex;
        };
        Layer.prototype.initContext = function() {
            this.ctx = this.dom.getContext('2d');
            this.ctx.dpr = this.dpr;
        };
        Layer.prototype.setUnpainted = function() {
            this.__firstTimePaint = true;
        };
        Layer.prototype.createBackBuffer = function() {
            var dpr = this.dpr;
            this.domBack = $f256c37231bc47c1$var$createDom('back-' + this.id, this.painter, dpr);
            this.ctxBack = this.domBack.getContext('2d');
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        };
        Layer.prototype.createRepaintRects = function(displayList, prevList, viewWidth, viewHeight) {
            if (this.__firstTimePaint) {
                this.__firstTimePaint = false;
                return null;
            }
            var mergedRepaintRects = [];
            var maxRepaintRectCount = this.maxRepaintRectCount;
            var full = false;
            var pendingRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
            function addRectToMergePool(rect) {
                if (!rect.isFinite() || rect.isZero()) return;
                if (mergedRepaintRects.length === 0) {
                    var boundingRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                } else {
                    var isMerged = false;
                    var minDeltaArea = Infinity;
                    var bestRectToMergeIdx = 0;
                    for(var i = 0; i < mergedRepaintRects.length; ++i){
                        var mergedRect = mergedRepaintRects[i];
                        if (mergedRect.intersect(rect)) {
                            var pendingRect_1 = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
                            pendingRect_1.copy(mergedRect);
                            pendingRect_1.union(rect);
                            mergedRepaintRects[i] = pendingRect_1;
                            isMerged = true;
                            break;
                        } else if (full) {
                            pendingRect.copy(rect);
                            pendingRect.union(mergedRect);
                            var aArea = rect.width * rect.height;
                            var bArea = mergedRect.width * mergedRect.height;
                            var pendingArea = pendingRect.width * pendingRect.height;
                            var deltaArea = pendingArea - aArea - bArea;
                            if (deltaArea < minDeltaArea) {
                                minDeltaArea = deltaArea;
                                bestRectToMergeIdx = i;
                            }
                        }
                    }
                    if (full) {
                        mergedRepaintRects[bestRectToMergeIdx].union(rect);
                        isMerged = true;
                    }
                    if (!isMerged) {
                        var boundingRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
                        boundingRect.copy(rect);
                        mergedRepaintRects.push(boundingRect);
                    }
                    if (!full) full = mergedRepaintRects.length >= maxRepaintRectCount;
                }
            }
            for(var i = this.__startIndex; i < this.__endIndex; ++i){
                var el = displayList[i];
                if (el) {
                    var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                    var prevRect = el.__isRendered && (el.__dirty & (0, (0, parcelRequire("aVawM")).REDRAW_BIT) || !shouldPaint) ? el.getPrevPaintRect() : null;
                    if (prevRect) addRectToMergePool(prevRect);
                    var curRect = shouldPaint && (el.__dirty & (0, (0, parcelRequire("aVawM")).REDRAW_BIT) || !el.__isRendered) ? el.getPaintRect() : null;
                    if (curRect) addRectToMergePool(curRect);
                }
            }
            for(var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i){
                var el = prevList[i];
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                    var prevRect = el.getPrevPaintRect();
                    if (prevRect) addRectToMergePool(prevRect);
                }
            }
            var hasIntersections;
            do {
                hasIntersections = false;
                for(var i = 0; i < mergedRepaintRects.length;){
                    if (mergedRepaintRects[i].isZero()) {
                        mergedRepaintRects.splice(i, 1);
                        continue;
                    }
                    for(var j = i + 1; j < mergedRepaintRects.length;)if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                        hasIntersections = true;
                        mergedRepaintRects[i].union(mergedRepaintRects[j]);
                        mergedRepaintRects.splice(j, 1);
                    } else j++;
                    i++;
                }
            }while (hasIntersections)
            this._paintRects = mergedRepaintRects;
            return mergedRepaintRects;
        };
        Layer.prototype.debugGetPaintRects = function() {
            return (this._paintRects || []).slice();
        };
        Layer.prototype.resize = function(width, height) {
            var dpr = this.dpr;
            var dom = this.dom;
            var domStyle = dom.style;
            var domBack = this.domBack;
            if (domStyle) {
                domStyle.width = width + 'px';
                domStyle.height = height + 'px';
            }
            dom.width = width * dpr;
            dom.height = height * dpr;
            if (domBack) {
                domBack.width = width * dpr;
                domBack.height = height * dpr;
                if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
            }
        };
        Layer.prototype.clear = function(clearAll, clearColor, repaintRects) {
            var dom = this.dom;
            var ctx = this.ctx;
            var width = dom.width;
            var height = dom.height;
            clearColor = clearColor || this.clearColor;
            var haveMotionBLur = this.motionBlur && !clearAll;
            var lastFrameAlpha = this.lastFrameAlpha;
            var dpr = this.dpr;
            var self = this;
            if (haveMotionBLur) {
                if (!this.domBack) this.createBackBuffer();
                this.ctxBack.globalCompositeOperation = 'copy';
                this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
            }
            var domBack = this.domBack;
            function doClear(x, y, width, height) {
                ctx.clearRect(x, y, width, height);
                if (clearColor && clearColor !== 'transparent') {
                    var clearColorGradientOrPattern = void 0;
                    if ((0, parcelRequire("bahqM")).isGradientObject(clearColor)) {
                        clearColorGradientOrPattern = clearColor.__canvasGradient || (0, (0, parcelRequire("dPYp9")).getCanvasGradient)(ctx, clearColor, {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        });
                        clearColor.__canvasGradient = clearColorGradientOrPattern;
                    } else if ((0, parcelRequire("bahqM")).isImagePatternObject(clearColor)) clearColorGradientOrPattern = (0, (0, parcelRequire("aSzOj")).createCanvasPattern)(ctx, clearColor, {
                        dirty: function() {
                            self.setUnpainted();
                            self.__painter.refresh();
                        }
                    });
                    ctx.save();
                    ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                    ctx.fillRect(x, y, width, height);
                    ctx.restore();
                }
                if (haveMotionBLur) {
                    ctx.save();
                    ctx.globalAlpha = lastFrameAlpha;
                    ctx.drawImage(domBack, x, y, width, height);
                    ctx.restore();
                }
            }
            if (!repaintRects || haveMotionBLur) doClear(0, 0, width, height);
            else if (repaintRects.length) (0, parcelRequire("bahqM")).each(repaintRects, function(rect) {
                doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
            });
        };
        return Layer;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $f256c37231bc47c1$export$2e2bcd8739ae039 = $f256c37231bc47c1$var$Layer;
});
parcelRegister("fNWkd", function(module, exports) {
    $parcel$export(module.exports, "CHART_SPACE_LEFT", ()=>$b95ac19a479554c0$export$ffe1d6b5e0d7a6e5);
    $parcel$export(module.exports, "CHART_SPACE_BOTTOM", ()=>$b95ac19a479554c0$export$bc204b53394e9283);
    var $gwIPs;
    const $b95ac19a479554c0$export$ffe1d6b5e0d7a6e5 = (0, (0, parcelRequire("gwIPs")).gridSize) * 10;
    const $b95ac19a479554c0$export$bc204b53394e9283 = (0, (0, parcelRequire("gwIPs")).gridSize) * 7.5;
});
parcelRegister("d5cn8", function(module, exports) {
    $parcel$export(module.exports, "useHoveredDeployment", ()=>$4bd2cac2596c5544$export$83b9a91e43f24aaa);
    var $3sQ5x;
    var $iXqE5;
    const $4bd2cac2596c5544$export$d4c72bab9d6cc13a = {
        hoveredDeployment: null
    };
    const $4bd2cac2596c5544$export$e324594224ef24da = {
        setHoveredDeployment: (deploymentId)=>({ setState: setState })=>setState({
                    hoveredDeployment: deploymentId
                })
    };
    const $4bd2cac2596c5544$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'hoveredDeployment',
        initialState: $4bd2cac2596c5544$export$d4c72bab9d6cc13a,
        actions: $4bd2cac2596c5544$export$e324594224ef24da
    });
    const $4bd2cac2596c5544$export$83b9a91e43f24aaa = (0, (0, parcelRequire("3sQ5x")).createHook)($4bd2cac2596c5544$var$Store, {
        selector: (state)=>state.hoveredDeployment
    });
});
parcelRegister("gFaMO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2c46eb38aef0ec8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d2c46eb38aef0ec8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        yAxis: {
            "id": "software-deployment-frequency-report.batch-size-chart.chart.y-axis",
            "defaultMessage": "Batch size (issues per deployment)"
        }
    });
});
parcelRegister("ayFdV", function(module, exports) {
    $parcel$export(module.exports, "useTooltipFormatter", ()=>$89cb3114dbae05b3$export$8d71e8328e9bd59b);
    var $6JUGo = parcelRequire("6JUGo");
    var $k5uoT;
    var $gwIPs;
    var $aWse0;
    var $7Ra8A;
    const $89cb3114dbae05b3$export$8d71e8328e9bd59b = ()=>{
        const { formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        return ({ data: data })=>{
            const { value: [dateTimeInMilliSeconds], customInfo: { issueCount: issueCount, environment: { displayName: environmentName }, pipeline: { url: pipelineUrl, displayName: pipelineName } } } = data;
            const formattedLastUpdated = formatDate(new Date(dateTimeInMilliSeconds), {
                day: 'numeric',
                month: 'short'
            });
            const issuePerDeploymentTranslated = formatMessage((0, (0, parcelRequire("7Ra8A")).default).issuesPerDeployment, {
                numIssues: formatNumber(issueCount)
            });
            return `<div style="${$89cb3114dbae05b3$var$container}">
            <div style="${$89cb3114dbae05b3$var$header}">
                <span style="${$89cb3114dbae05b3$var$uploadIconStyled}">${0, $5496c072511293de$export$e789e90053a546bb}</span>
                <a href="${(0, ($parcel$interopDefault($6JUGo)))(pipelineUrl)}" target="_blank" style="${$89cb3114dbae05b3$var$pipelineNameStyled}">${(0, ($parcel$interopDefault($6JUGo)))(pipelineName)}</a>
                <span>${formattedLastUpdated}</span>
            </div>
            <p style="${$89cb3114dbae05b3$var$issuesPerDeployment}">${issuePerDeploymentTranslated}</p>
            <p style="${$89cb3114dbae05b3$var$environmentNameStyled}">${(0, ($parcel$interopDefault($6JUGo)))(environmentName)}</p>
        </div>`;
        };
    };
    const $89cb3114dbae05b3$var$container = `
    padding: 0 ${(0, (0, parcelRequire("gwIPs")).gridSize) / 2}px;
    background-color: ${(0, $829f609a65d26a98$exports).N900};
    border-radius: ${(0, (0, parcelRequire("gwIPs")).borderRadius)};
    color: ${(0, $829f609a65d26a98$exports).N0};
    font-size: ${(0, (0, parcelRequire("k5uoT")).fontSizeSmall)()}px;
    max-width: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 26}px;
`;
    const $89cb3114dbae05b3$var$header = `
    display: flex;
    align-items: center;
    height: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px;
    margin: 0 0 ${(0, (0, parcelRequire("gwIPs")).gridSize)}px -2px;
`;
    const $89cb3114dbae05b3$var$pipelineNameStyled = `
    color: ${(0, $829f609a65d26a98$exports).N0};
    text-decoration-line: underline;
    margin: 0 ${(0, (0, parcelRequire("gwIPs")).gridSize) * 0.5}px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex: 1;
`;
    const $89cb3114dbae05b3$var$iconBase = `
    margin-top: -1px;
    height: 16px;
    width: 16px;
`;
    const $89cb3114dbae05b3$var$uploadIconStyled = `
    ${$89cb3114dbae05b3$var$iconBase}
`;
    const $89cb3114dbae05b3$var$issuesPerDeployment = `
    color: ${(0, $829f609a65d26a98$exports).N0};
    margin: 0;
`;
    const $89cb3114dbae05b3$var$environmentNameStyled = `
    margin: 0;
`;
});
parcelRegister("6JUGo", function(module, exports) {
    var $8SMZJ = parcelRequire("8SMZJ");
    var $jJVtR = parcelRequire("jJVtR");
    var $4e82ea10714905a8$var$reUnescapedHtml = /[&<>"']/g, $4e82ea10714905a8$var$reHasUnescapedHtml = RegExp($4e82ea10714905a8$var$reUnescapedHtml.source);
    function $4e82ea10714905a8$var$escape(string) {
        string = $jJVtR(string);
        return string && $4e82ea10714905a8$var$reHasUnescapedHtml.test(string) ? string.replace($4e82ea10714905a8$var$reUnescapedHtml, $8SMZJ) : string;
    }
    module.exports = $4e82ea10714905a8$var$escape;
});
parcelRegister("8SMZJ", function(module, exports) {
    var $h2dNA = parcelRequire("h2dNA");
    var $67795f32b2638007$var$htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    var $67795f32b2638007$var$escapeHtmlChar = $h2dNA($67795f32b2638007$var$htmlEscapes);
    module.exports = $67795f32b2638007$var$escapeHtmlChar;
});
const $5496c072511293de$export$e789e90053a546bb = '<svg width="16" height="16" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11.208 9.32L9.29 11.253a1 1 0 000 1.409.982.982 0 001.397 0l1.29-1.301 1.336 1.347a.982.982 0 001.397.001 1.002 1.002 0 00.001-1.408l-1.965-1.98a1.08 1.08 0 00-1.538-.001z"></path><path d="M11 10.007l.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007z"></path><path d="M7.938 5.481a4.8 4.8 0 00-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 014.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481z"></path></g></svg>';
parcelRegister("7Ra8A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad953448d7fcca83$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ad953448d7fcca83$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issuesPerDeployment: {
            "id": "software-deployment-frequency-report.batch-size-chart.chart.tooltip.issues-per-deployment",
            "defaultMessage": "{numIssues} {numIssues, plural, one {issue} other {issues}} per deployment"
        }
    });
});
parcelRegister("17PUx", function(module, exports) {
    $parcel$export(module.exports, "convertToDataPoints", ()=>$db5597352cd6a469$export$46e7be3ed3c4cb4b);
    const $db5597352cd6a469$export$46e7be3ed3c4cb4b = (data)=>data.map((deployment)=>({
                name: deployment.id,
                value: [
                    deployment.lastUpdated.getTime(),
                    deployment.issueCount
                ],
                customInfo: {
                    issueCount: deployment.issueCount,
                    pipeline: deployment.pipeline,
                    environment: deployment.environment
                }
            }));
});
parcelRegister("kkZmj", function(module, exports) {
    $parcel$export(module.exports, "LoadingSkeleton", ()=>$89be1a510e31b7be$export$44c18d210d5de37b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $8CUq3;
    var $4McSe;
    const $89be1a510e31b7be$export$44c18d210d5de37b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$ChartWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $89be1a510e31b7be$var$weekBreakdownTitleStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "168px",
            height: "16px",
            margin: "0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$TitleWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "248px",
            height: "20px",
            margin: `0 ${"var(--ds-space-100, 8px)"} 0 0`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "192px",
            height: "var(--ds-space-100, 8px)",
            margin: "0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$SubTitleWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "192px",
            height: "var(--ds-space-100, 8px)",
            margin: "0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "208px",
            height: "var(--ds-space-100, 8px)",
            margin: "0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$GraphWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$GraphYLabelArea, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "var(--ds-space-100, 8px)",
            height: "144px",
            margin: "0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$GraphAreaWithXLabelArea, null, (0, ($parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$GraphArea, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThin), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThin), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThin), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThin), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThick), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$GraphXLabel, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "36px",
            height: "12px",
            margin: "0"
        })))));
    const $89be1a510e31b7be$var$graphBaseStyles = null;
    const $89be1a510e31b7be$var$chartWrapperBaseStyles = null;
    const $89be1a510e31b7be$var$ChartWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                __cmplp.className
            ])
        });
    });
    const $89be1a510e31b7be$var$weekBreakdownTitleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: 'space.300',
        marginBottom: 'space.400'
    });
    const $89be1a510e31b7be$var$TitleWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _4t3i1tcg",
                __cmplp.className
            ])
        });
    });
    const $89be1a510e31b7be$var$SubTitleWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o _4t3i1tcg _u5f3v47k",
                __cmplp.className
            ])
        });
    });
    const $89be1a510e31b7be$var$GraphWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3iclpc _1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $89be1a510e31b7be$var$GraphYLabelArea = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbys9h _n3td1wqb _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qxncg",
                __cmplp.className
            ])
        });
    });
    const $89be1a510e31b7be$var$GraphAreaWithXLabelArea = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
    const $89be1a510e31b7be$var$GraphArea = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1yb4 _4cvr1fhb _ca0qxncg _u5f3v47k",
                __cmplp.className
            ])
        });
    });
    const $89be1a510e31b7be$var$GraphXLabel = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1wqb _1e0c1txw _1bah1h6o _4cvresu3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4McSe", function(module, exports) {
    $parcel$export(module.exports, "SkeletonItem", ()=>$946e5acbe6dc1a80$export$fbc0ea7debdb77e);
    $parcel$export(module.exports, "LineThin", ()=>$946e5acbe6dc1a80$export$ca55a3be779efc57);
    $parcel$export(module.exports, "LineThick", ()=>$946e5acbe6dc1a80$export$611028b9a8d16761);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $946e5acbe6dc1a80$var$shimmerN20A = null;
    const $946e5acbe6dc1a80$var$shimmerN30 = null;
    const $946e5acbe6dc1a80$var$shimmerN40 = null;
    const $946e5acbe6dc1a80$var$animationOptionStyles = null;
    const $946e5acbe6dc1a80$export$fbc0ea7debdb77e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { margin: margin, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_146ducd": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.margin}`),
                "--_dfjz0w": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.height}`),
                "--_1icprf0": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk1pnw _18s8j3fp _4t3i16wa _1bsbb8e1 _2rko1crf _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8 _j7hq1gb8",
                __cmplp.className
            ])
        });
    });
    const $946e5acbe6dc1a80$export$ca55a3be779efc57 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1icprf0": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkqrzy _4t3it94y _1bsbb8e1 _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8 _j7hqy1jw",
                __cmplp.className
            ])
        });
    });
    const $946e5acbe6dc1a80$export$611028b9a8d16761 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1icprf0": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk1gvq _4t3iyh40 _1bsbb8e1 _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8 _j7hq1rel",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("HHUOQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$860e2a495503fa1a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $860e2a495503fa1a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        weeklyProdDeployments: {
            "id": "software-deployment-frequency-report.batch-size-chart.weekly-prod-deployments",
            "defaultMessage": "{weeklyProdDeployments, plural, =0 {No weekly production deployments} one {1 weekly production deployment} other {# weekly production deployments}}"
        },
        issuesPerDeployment: {
            "id": "software-deployment-frequency-report.batch-size-chart.issues-per-deployment",
            "defaultMessage": "{periodProdIssuesPerDeployment} {periodProdIssuesPerDeployment, plural, one {median issue per deployment} other {median issues per deployment}}"
        },
        weekTitle: {
            "id": "software-deployment-frequency-report.batch-size-chart.week-title",
            "defaultMessage": "week of {date}"
        },
        moreDataRequired: {
            "id": "software-deployment-frequency-report.batch-size-chart.more-data-required",
            "defaultMessage": "more data required"
        },
        deployment: {
            "id": "software-deployment-frequency-report.batch-size-chart.deployment",
            "defaultMessage": "Deployment"
        },
        twelveWeekMedian: {
            "id": "software-deployment-frequency-report.batch-size-chart.twelve-week-median",
            "defaultMessage": "12-week median"
        },
        weekBreakDownTitle: {
            "id": "software-deployment-frequency-report.batch-size-chart.week-break-down-title",
            "defaultMessage": "Week breakdown"
        },
        weekBreakDownTitleTooltip: {
            "id": "software-deployment-frequency-report.batch-size-chart.week-break-down-title-tooltip",
            "defaultMessage": "Identify the risk of your deployments by analyzing their batch sizes. Deployments with many changes tend to be riskier."
        }
    });
});
parcelRegister("gxsp4", function(module, exports) {
    $parcel$export(module.exports, "DeploymentFrequencyBarChart", ()=>$881ef776211735a3$export$494b0cc8adc03bd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1dJ6S;
    var $eJS47;
    var $3bDjY;
    var $jcw0u;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $44gpy;
    var $6wHbz;
    var $gilhC;
    var $l8ekP;
    var $3Ws3s;
    var $claG0;
    var $caivO;
    var $baXtj;
    var $fg7Dg;
    var $gabu1;
    var $bHI5p;
    var $c7V0L;
    var $aD53o;
    var $iitmC;
    const $881ef776211735a3$var$Title = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "h2",
            size: "xsmall"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$ChartTitle, null, formatMessage((0, (0, parcelRequire("c7V0L")).default).chartTitle), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("c7V0L")).default).titleHelpTooltip),
            position: "right"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$QuestionIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
            size: "small",
            label: ""
        })))));
    };
    const $881ef776211735a3$export$494b0cc8adc03bd4 = ()=>{
        const onViewDeploymentFrequencyReportExperienceFail = (0, (0, parcelRequire("caivO")).useViewDeploymentFrequencyReportExperienceFail)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { data: data, loading: loading, error: error, fetch: fetch } = (0, (0, parcelRequire("3Ws3s")).useReportCoreData)();
        const [{ selectedWeekStart: selectedWeekStart }, { setSelectedWeekStart: setSelectedWeekStart }] = (0, (0, parcelRequire("gilhC")).useSelectedWeekStore)();
        const onChartClicked = (0, $5uXOq.useCallback)(({ data: eventData })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'deploymentFrequencyBar',
                actionSubjectId: 'deploymentFrequencyReport'
            }));
            setSelectedWeekStart(eventData.customInfo.startDateInclusive);
        }, [
            createAnalyticsEvent,
            setSelectedWeekStart
        ]);
        const events = (0, $5uXOq.useMemo)(()=>({
                click: onChartClicked
            }), [
            onChartClicked
        ]);
        (0, (0, parcelRequire("l8ekP")).useSmartWeekSelect)(data, selectedWeekStart, setSelectedWeekStart);
        (0, $5uXOq.useEffect)(()=>{
            if (error && data == null) {
                onViewDeploymentFrequencyReportExperienceFail('BarChart', error);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'BarChartDataFailed',
                        packageName: 'jiraSoftwareDeploymentFrequencyReport',
                        teamName: 'fusion-solaris'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            data,
            error,
            onViewDeploymentFrequencyReportExperienceFail
        ]);
        if (error && data == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$Title, null), (0, ($parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$ErrorUIWrapper, {
            "data-test-id": "software-deployment-frequency-report.ui.deployment-frequency-bar-chart.error-ui"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("44gpy")).default), {
            onRetry: fetch
        })));
        if (loading || data == null || selectedWeekStart === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bHI5p")).LoadingSkeleton), null);
        error;
        const { averageDeploymentCount: averageDeploymentCountWholePeriod, hasDeploymentProvider: hasDeploymentProvider } = data;
        if (hasDeploymentProvider === false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aD53o")).NoProvider), null);
        const prodDataState = (0, (0, parcelRequire("claG0")).getProdDataState)(data);
        const dataPoints = (0, (0, parcelRequire("fg7Dg")).convertReportCoreToChartDataPoints)(data, selectedWeekStart);
        const selectedWeekData = (0, (0, parcelRequire("l8ekP")).getSelectedWeekData)(data.weeksData, selectedWeekStart);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6wHbz")).PerformanceTracker), null), (0, ($parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$Title, null), prodDataState === 'COMPLETELY_EMPTY' ? (0, ($parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$EmptyMessageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gabu1")).EmptyDataMessage), null)) : null, (0, ($parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$ChartContainer, {
            "data-test-id": "software-deployment-frequency-report.ui.deployment-frequency-bar-chart"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$ChartItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("baXtj")).Chart), {
            dataPoints: dataPoints,
            averageDeploymentsWholePeriod: averageDeploymentCountWholePeriod,
            onEvents: events,
            shouldDisplayAverageLine: prodDataState === 'SUFFICIENT_FOR_TREND'
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$SelectionDetailItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iitmC")).SelectionDetail), {
            weekCount: selectedWeekData.deploymentCount.prod,
            weekStartDate: selectedWeekData.startDateInclusive,
            wholePeriodAverage: averageDeploymentCountWholePeriod,
            prodDataState: prodDataState
        }))));
    };
    const $881ef776211735a3$var$ErrorUIWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1dup _1e0c1txw _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $881ef776211735a3$var$ChartTitle = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1e0c1txw _4cvr1h6o _19pkidpf _2hwxidpf _otyrftgi _18u0idpf _19bvv47k",
                __cmplp.className
            ])
        });
    });
    const $881ef776211735a3$var$QuestionIcon = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _lswu12xz _syazs6h6 _80omtlke _ca0qv77o",
                __cmplp.className
            ])
        });
    });
    const $881ef776211735a3$var$EmptyMessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8zu5n _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $881ef776211735a3$var$ChartContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4t3iko4j",
                __cmplp.className
            ])
        });
    });
    const $881ef776211735a3$var$ChartItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbqrhd",
                __cmplp.className
            ])
        });
    });
    const $881ef776211735a3$var$SelectionDetailItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb194s _1ul9194s _19bv1ylp _1e0c1txw _2lx21bp4 _1bah1h6o _n3tdvbgk",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6wHbz", function(module, exports) {
    $parcel$export(module.exports, "PerformanceTracker", ()=>$cc795357cc224acb$export$57a2c9a4973f6a35);
    var $5uXOq = parcelRequire("5uXOq");
    var $dGrdR;
    var $5rqex;
    var $j1sSt;
    const $cc795357cc224acb$var$deploymentFrequencyReportPageLoad = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'software.deployment.frequency.report',
        slo: {
            fmp: {
                initial: {
                    threshold: 1000
                },
                transition: {
                    threshold: 1000
                }
            },
            tti: {
                initial: {
                    threshold: 4000
                },
                transition: {
                    threshold: 4000
                }
            }
        }
    });
    const $cc795357cc224acb$export$57a2c9a4973f6a35 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j1sSt")).NonCriticalErrorBoundary), {
            fallback: "unmount",
            eventLocation: "performanceTracker"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            appName: "jira-software-deployment-frequency-report",
            ttrSlo: 1000,
            ttiSlo: 4000,
            metric: $cc795357cc224acb$var$deploymentFrequencyReportPageLoad
        }));
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("l8ekP", function(module, exports) {
    $parcel$export(module.exports, "getSelectedWeekData", ()=>$e92b654218278618$export$47a56b6f44681bf3);
    $parcel$export(module.exports, "useSmartWeekSelect", ()=>$e92b654218278618$export$84b064975722115b);
    var $5uXOq = parcelRequire("5uXOq");
    var $hIkqU = parcelRequire("hIkqU");
    var $hYfgW = parcelRequire("hYfgW");
    const $e92b654218278618$export$47a56b6f44681bf3 = (weeksData, selectedWeekStartDate)=>{
        const foundWeekData = weeksData.find((weekData)=>weekData.startDateInclusive.getTime() === selectedWeekStartDate.getTime());
        if (foundWeekData === undefined) throw new Error('Could not find the selected week data for the given selected date range');
        return foundWeekData;
    };
    const $e92b654218278618$export$84b064975722115b = (data, selectedWeekStart, setSelectedWeekStart)=>{
        (0, $5uXOq.useEffect)(()=>{
            if (data != null) {
                const selectLatestWeekWithDataNotCurrentWeek = ()=>{
                    const selectedWeekData = (0, ($parcel$interopDefault($hIkqU)))(data.weeksData, (weekData)=>weekData.deploymentCount.prod, data.weeksData.length - 2);
                    if (selectedWeekData) setSelectedWeekStart(selectedWeekData.startDateInclusive);
                    else setSelectedWeekStart((0, ($parcel$interopDefault($hYfgW)))(data.weeksData).startDateInclusive);
                };
                if (selectedWeekStart === null || $e92b654218278618$export$47a56b6f44681bf3(data.weeksData, selectedWeekStart).deploymentCount.prod === 0) selectLatestWeekWithDataNotCurrentWeek();
            }
        }, [
            data,
            selectedWeekStart,
            setSelectedWeekStart
        ]);
    };
});
parcelRegister("hIkqU", function(module, exports) {
    var $bptzf = parcelRequire("bptzf");
    var $apUNl = parcelRequire("apUNl");
    var $0353f9604956038c$var$findLast = $bptzf($apUNl);
    module.exports = $0353f9604956038c$var$findLast;
});
parcelRegister("bptzf", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $hTJwX = parcelRequire("hTJwX");
    var $66FNL = parcelRequire("66FNL");
    function $84e8f705a13e859f$var$createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
            var iterable = Object(collection);
            if (!$hTJwX(collection)) {
                var iteratee = $bxDef(predicate, 3);
                collection = $66FNL(collection);
                predicate = function(key) {
                    return iteratee(iterable[key], key, iterable);
                };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
        };
    }
    module.exports = $84e8f705a13e859f$var$createFind;
});
parcelRegister("apUNl", function(module, exports) {
    var $b5dwA = parcelRequire("b5dwA");
    var $bxDef = parcelRequire("bxDef");
    var $kPZpS = parcelRequire("kPZpS");
    var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
    function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) return -1;
        var index = length - 1;
        if (fromIndex !== undefined) {
            index = $kPZpS(fromIndex);
            index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
        }
        return $b5dwA(array, $bxDef(predicate, 3), index, true);
    }
    module.exports = $79584b713e0c6354$var$findLastIndex;
});
parcelRegister("baXtj", function(module, exports) {
    $parcel$export(module.exports, "Chart", ()=>$315a4060370e985e$export$acaa6426d77a227e);
    var $5uXOq = parcelRequire("5uXOq");
    var $gJBT6 = parcelRequire("gJBT6");
    var $lXVui = parcelRequire("lXVui");
    var $bkcQi;
    var $47isN;
    var $6OGL8;
    var $48mDj;
    var $gLj36;
    var $ixV1I;
    var $lWgYs;
    var $dWt6p;
    var $k5uoT;
    var $gwIPs;
    var $aWse0;
    var $hyYD4;
    var $lz0GT;
    var $9zuj3;
    (0, parcelRequire("ixV1I")).use([
        (0, (0, parcelRequire("47isN")).install),
        (0, (0, parcelRequire("bkcQi")).install),
        (0, (0, parcelRequire("48mDj")).install),
        (0, (0, parcelRequire("gLj36")).install),
        (0, (0, parcelRequire("6OGL8")).install),
        (0, (0, parcelRequire("lWgYs")).install)
    ]);
    const $315a4060370e985e$export$acaa6426d77a227e = ({ dataPoints: dataPoints, averageDeploymentsWholePeriod: averageDeploymentsWholePeriod, shouldDisplayAverageLine: shouldDisplayAverageLine, onEvents: onEvents })=>{
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const tooltipFormatter = (0, (0, parcelRequire("9zuj3")).useTooltipFormatter)(averageDeploymentsWholePeriod);
        const prefersReducedMotion = (0, (0, parcelRequire("dWt6p")).useIsReducedMotion)();
        const axisCommonStyle = {
            nameGap: (0, (0, parcelRequire("gwIPs")).gridSize) * 4,
            nameLocation: 'middle',
            nameTextStyle: {
                color: (0, $829f609a65d26a98$exports).N400,
                fontSize: (0, (0, parcelRequire("k5uoT")).fontSizeSmall)()
            }
        };
        const TOOLTIP_ANIMATION = null;
        const TOOLTIP_APPEAR_TOP = {
            backgroundColor: (0, $829f609a65d26a98$exports).N900,
            borderWidth: 0,
            transitionDuration: 0,
            extraCssText: `animation: ${TOOLTIP_ANIMATION} 0.15s ease-out`,
            position: (0, ($parcel$interopDefault($gJBT6)))((pos, params, dom, rect, size)=>({
                    top: rect.y - size.contentSize[1] - (0, (0, parcelRequire("gwIPs")).gridSize),
                    left: rect.x + 10 - size.contentSize[0] / 2
                }), (pos, params)=>`${params.componentSubType}-${params.name}-${params.dataIndex}`)
        };
        const chartOptions = {
            animation: !prefersReducedMotion,
            tooltip: {
                ...TOOLTIP_APPEAR_TOP,
                formatter: tooltipFormatter
            },
            itemStyle: {
                borderRadius: [
                    2,
                    2,
                    0,
                    0
                ]
            },
            grid: {
                left: (0, (0, parcelRequire("hyYD4")).CHART_SPACE_LEFT),
                right: (0, (0, parcelRequire("hyYD4")).CHART_SPACE_RIGHT),
                top: (0, (0, parcelRequire("gwIPs")).gridSize) * 2,
                bottom: (0, (0, parcelRequire("gwIPs")).gridSize) * 8
            },
            xAxis: {
                data: dataPoints.map((data)=>{
                    const weekStartDateTranslated = formatDate(data.customInfo.startDateInclusive, {
                        month: 'short',
                        day: 'numeric'
                    });
                    return data.customInfo.emphasisColor !== null ? {
                        value: weekStartDateTranslated,
                        textStyle: {
                            color: data.customInfo.emphasisColor
                        }
                    } : weekStartDateTranslated;
                }),
                axisLine: {
                    lineStyle: {
                        color: (0, $829f609a65d26a98$exports).N40,
                        width: 2
                    }
                },
                axisTick: {
                    alignWithLabel: true
                },
                offset: (0, (0, parcelRequire("gwIPs")).gridSize) * 2,
                ...axisCommonStyle
            },
            yAxis: {
                name: formatMessage((0, (0, parcelRequire("lz0GT")).default).yAxisLabel),
                ...axisCommonStyle,
                axisLine: {
                    show: false
                },
                splitNumber: 4,
                axisTick: false,
                splitLine: {
                    lineStyle: {
                        color: (0, $829f609a65d26a98$exports).N30
                    }
                }
            },
            textStyle: {
                color: (0, $829f609a65d26a98$exports).N400
            },
            backgroundColor: 'transparent',
            series: [
                {
                    type: 'bar',
                    data: dataPoints,
                    color: (0, $829f609a65d26a98$exports).B100,
                    barWidth: (0, $b41c313de361af34$export$5b067f596a486882),
                    ...averageDeploymentsWholePeriod !== null && shouldDisplayAverageLine ? {
                        markLine: {
                            data: [
                                {
                                    yAxis: averageDeploymentsWholePeriod
                                }
                            ],
                            silent: true,
                            lineStyle: {
                                color: (0, $829f609a65d26a98$exports).N300,
                                width: 1
                            },
                            symbol: 'none',
                            label: {
                                show: false
                            }
                        }
                    } : {}
                }
            ]
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($lXVui))), {
            echarts: (0, parcelRequire("ixV1I")),
            option: chartOptions,
            style: {
                height: '100%'
            },
            onEvents: onEvents
        });
    };
});
parcelRegister("bkcQi", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$83eb863ca14abd03$export$4b3e715f166fdd78);
    var $bahqM;
    var $eL4bi;
    var $7jcIW;
    var $1b1Ai;
    var $hrdVR;
    function $83eb863ca14abd03$export$4b3e715f166fdd78(registers) {
        registers.registerChartView((0, (0, parcelRequire("hrdVR")).default));
        registers.registerSeriesModel((0, (0, parcelRequire("1b1Ai")).default));
        registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, (0, parcelRequire("bahqM")).curry((0, (0, parcelRequire("eL4bi")).layout), 'bar'));
        registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, (0, parcelRequire("eL4bi")).largeLayout));
        registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, (0, parcelRequire("7jcIW")).default)('bar'));
        registers.registerAction({
            type: 'changeAxisOrder',
            event: 'changeAxisOrder',
            update: 'update'
        }, function(payload, ecModel) {
            var componentType = payload.componentType || 'series';
            ecModel.eachComponent({
                mainType: componentType,
                query: payload
            }, function(componentModel) {
                if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
            });
        });
    }
});
parcelRegister("1b1Ai", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0db80c291205dc61$export$2e2bcd8739ae039);
    var $3VFsf;
    var $6GWLU;
    var $bAY5l;
    var $jvo6O;
    var $0db80c291205dc61$var$BarSeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BarSeriesModel, _super);
        function BarSeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = BarSeriesModel.type;
            return _this;
        }
        BarSeriesModel.prototype.getInitialData = function() {
            return (0, (0, parcelRequire("bAY5l")).default)(null, this, {
                useEncodeDefaulter: true,
                createInvertedIndices: !!this.get('realtimeSort', true) || null
            });
        };
        BarSeriesModel.prototype.getProgressive = function() {
            return this.get('large') ? this.get('progressive') : false;
        };
        BarSeriesModel.prototype.getProgressiveThreshold = function() {
            var progressiveThreshold = this.get('progressiveThreshold');
            var largeThreshold = this.get('largeThreshold');
            if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
            return progressiveThreshold;
        };
        BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
            return selectors.rect(data.getItemLayout(dataIndex));
        };
        BarSeriesModel.type = 'series.bar';
        BarSeriesModel.dependencies = [
            'grid',
            'polar'
        ];
        BarSeriesModel.defaultOption = (0, (0, parcelRequire("jvo6O")).inheritDefaultOption)((0, (0, parcelRequire("6GWLU")).default).defaultOption, {
            clip: true,
            roundCap: false,
            showBackground: false,
            backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)',
                borderColor: null,
                borderWidth: 0,
                borderType: 'solid',
                borderRadius: 0,
                shadowBlur: 0,
                shadowColor: null,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                opacity: 1
            },
            select: {
                itemStyle: {
                    borderColor: '#212121'
                }
            },
            realtimeSort: false
        });
        return BarSeriesModel;
    }((0, (0, parcelRequire("6GWLU")).default));
    var $0db80c291205dc61$export$2e2bcd8739ae039 = $0db80c291205dc61$var$BarSeriesModel;
});
parcelRegister("6GWLU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4df4412f90ffd718$export$2e2bcd8739ae039);
    var $3VFsf;
    var $1O7Ua;
    var $bAY5l;
    var $4df4412f90ffd718$var$BaseBarSeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BaseBarSeriesModel, _super);
        function BaseBarSeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = BaseBarSeriesModel.type;
            return _this;
        }
        BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
            return (0, (0, parcelRequire("bAY5l")).default)(null, this, {
                useEncodeDefaulter: true
            });
        };
        BaseBarSeriesModel.prototype.getMarkerPosition = function(value) {
            var coordSys = this.coordinateSystem;
            if (coordSys && coordSys.clampData) {
                var pt = coordSys.dataToPoint(coordSys.clampData(value));
                var data = this.getData();
                var offset = data.getLayout('offset');
                var size = data.getLayout('size');
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt[offsetIndex] += offset + size / 2;
                return pt;
            }
            return [
                NaN,
                NaN
            ];
        };
        BaseBarSeriesModel.type = 'series.__base_bar__';
        BaseBarSeriesModel.defaultOption = {
            zlevel: 0,
            z: 2,
            coordinateSystem: 'cartesian2d',
            legendHoverLink: true,
            barMinHeight: 0,
            barMinAngle: 0,
            large: false,
            largeThreshold: 400,
            progressive: 3e3,
            progressiveChunkMode: 'mod'
        };
        return BaseBarSeriesModel;
    }((0, (0, parcelRequire("1O7Ua")).default));
    (0, (0, parcelRequire("1O7Ua")).default).registerClass($4df4412f90ffd718$var$BaseBarSeriesModel);
    var $4df4412f90ffd718$export$2e2bcd8739ae039 = $4df4412f90ffd718$var$BaseBarSeriesModel;
});
parcelRegister("hrdVR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb1fc3f08c69a560$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $4KVOr;
    var $bahqM;
    var $eYgMC;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $elGBV;
    var $eYgMC;
    var $7QjoM;
    var $fIXXx;
    var $gvLUt;
    var $ljaBy;
    var $5fMzf;
    var $eaQLm;
    var $loerw;
    var $40dMe;
    var $5MLZz;
    var $9dNYG;
    var $eYgMC;
    var $cb1fc3f08c69a560$var$_eventPos = [
        0,
        0
    ];
    var $cb1fc3f08c69a560$var$mathMax = Math.max;
    var $cb1fc3f08c69a560$var$mathMin = Math.min;
    function $cb1fc3f08c69a560$var$getClipArea(coord, data) {
        var coordSysClipArea = coord.getArea && coord.getArea();
        if ((0, (0, parcelRequire("40dMe")).isCoordinateSystemType)(coord, 'cartesian2d')) {
            var baseAxis = coord.getBaseAxis();
            if (baseAxis.type !== 'category' || !baseAxis.onBand) {
                var expandWidth = data.getLayout('bandWidth');
                if (baseAxis.isHorizontal()) {
                    coordSysClipArea.x -= expandWidth;
                    coordSysClipArea.width += expandWidth * 2;
                } else {
                    coordSysClipArea.y -= expandWidth;
                    coordSysClipArea.height += expandWidth * 2;
                }
            }
        }
        return coordSysClipArea;
    }
    var $cb1fc3f08c69a560$var$BarView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BarView, _super);
        function BarView() {
            var _this = _super.call(this) || this;
            _this.type = BarView.type;
            _this._isFirstFrame = true;
            return _this;
        }
        BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
            this._model = seriesModel;
            this._removeOnRenderedListener(api);
            this._updateDrawMode(seriesModel);
            var coordinateSystemType = seriesModel.get('coordinateSystem');
            if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        };
        BarView.prototype.incrementalPrepareRender = function(seriesModel) {
            this._clear();
            this._updateDrawMode(seriesModel);
            this._updateLargeClip(seriesModel);
        };
        BarView.prototype.incrementalRender = function(params, seriesModel) {
            this._incrementalRenderLarge(params, seriesModel);
        };
        BarView.prototype._updateDrawMode = function(seriesModel) {
            var isLargeDraw = seriesModel.pipelineContext.large;
            if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
                this._isLargeDraw = isLargeDraw;
                this._clear();
            }
        };
        BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
            var group = this.group;
            var data = seriesModel.getData();
            var oldData = this._data;
            var coord = seriesModel.coordinateSystem;
            var baseAxis = coord.getBaseAxis();
            var isHorizontalOrRadial;
            if (coord.type === 'cartesian2d') isHorizontalOrRadial = baseAxis.isHorizontal();
            else if (coord.type === 'polar') isHorizontalOrRadial = baseAxis.dim === 'angle';
            var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
            var realtimeSortCfg = $cb1fc3f08c69a560$var$shouldRealtimeSort(seriesModel, coord);
            if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
            var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
            var coordSysClipArea = $cb1fc3f08c69a560$var$getClipArea(coord, data);
            group.removeClipPath();
            var roundCap = seriesModel.get('roundCap', true);
            var drawBackground = seriesModel.get('showBackground', true);
            var backgroundModel = seriesModel.getModel('backgroundStyle');
            var barBorderRadius = backgroundModel.get('borderRadius') || 0;
            var bgEls = [];
            var oldBgEls = this._backgroundEls;
            var isInitSort = payload && payload.isInitSort;
            var isChangeOrder = payload && payload.type === 'changeAxisOrder';
            function createBackground(dataIndex) {
                var bgLayout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, dataIndex);
                var bgEl = $cb1fc3f08c69a560$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
                bgEl.useStyle(backgroundModel.getItemStyle());
                if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                bgEls[dataIndex] = bgEl;
                return bgEl;
            }
            data.diff(oldData).add(function(dataIndex) {
                var itemModel = data.getItemModel(dataIndex);
                var layout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, dataIndex, itemModel);
                if (drawBackground) createBackground(dataIndex);
                if (!data.hasValue(dataIndex) || !$cb1fc3f08c69a560$var$isValidLayout[coord.type](layout)) return;
                var isClipped = false;
                if (needsClip) isClipped = $cb1fc3f08c69a560$var$clip[coord.type](coordSysClipArea, layout);
                var el = $cb1fc3f08c69a560$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
                $cb1fc3f08c69a560$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
                if (isInitSort) el.attr({
                    shape: layout
                });
                else if (realtimeSortCfg) $cb1fc3f08c69a560$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
                else (0, (0, parcelRequire("eYgMC")).initProps)(el, {
                    shape: layout
                }, seriesModel, dataIndex);
                data.setItemGraphicEl(dataIndex, el);
                group.add(el);
                el.ignore = isClipped;
            }).update(function(newIndex, oldIndex) {
                var itemModel = data.getItemModel(newIndex);
                var layout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, newIndex, itemModel);
                if (drawBackground) {
                    var bgEl = void 0;
                    if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                    else {
                        bgEl = oldBgEls[oldIndex];
                        bgEl.useStyle(backgroundModel.getItemStyle());
                        if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                        bgEls[newIndex] = bgEl;
                    }
                    var bgLayout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, newIndex);
                    var shape = $cb1fc3f08c69a560$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                    (0, (0, parcelRequire("eYgMC")).updateProps)(bgEl, {
                        shape: shape
                    }, animationModel, newIndex);
                }
                var el = oldData.getItemGraphicEl(oldIndex);
                if (!data.hasValue(newIndex) || !$cb1fc3f08c69a560$var$isValidLayout[coord.type](layout)) {
                    group.remove(el);
                    return;
                }
                var isClipped = false;
                if (needsClip) {
                    isClipped = $cb1fc3f08c69a560$var$clip[coord.type](coordSysClipArea, layout);
                    if (isClipped) group.remove(el);
                }
                if (!el) el = $cb1fc3f08c69a560$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
                else (0, (0, parcelRequire("eYgMC")).saveOldStyle)(el);
                if (!isChangeOrder) $cb1fc3f08c69a560$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
                if (isInitSort) el.attr({
                    shape: layout
                });
                else if (realtimeSortCfg) $cb1fc3f08c69a560$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
                else (0, (0, parcelRequire("eYgMC")).updateProps)(el, {
                    shape: layout
                }, seriesModel, newIndex, null);
                data.setItemGraphicEl(newIndex, el);
                el.ignore = isClipped;
                group.add(el);
            }).remove(function(dataIndex) {
                var el = oldData.getItemGraphicEl(dataIndex);
                el && (0, (0, parcelRequire("eYgMC")).removeElementWithFadeOut)(el, seriesModel, dataIndex);
            }).execute();
            var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, (0, parcelRequire("4KVOr")).default)());
            bgGroup.removeAll();
            for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
            group.add(bgGroup);
            this._backgroundEls = bgEls;
            this._data = data;
        };
        BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
            this._clear();
            $cb1fc3f08c69a560$var$createLarge(seriesModel, this.group);
            this._updateLargeClip(seriesModel);
        };
        BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
            this._removeBackground();
            $cb1fc3f08c69a560$var$createLarge(seriesModel, this.group, true);
        };
        BarView.prototype._updateLargeClip = function(seriesModel) {
            var clipPath = seriesModel.get('clip', true) ? (0, (0, parcelRequire("5fMzf")).createClipPath)(seriesModel.coordinateSystem, false, seriesModel) : null;
            if (clipPath) this.group.setClipPath(clipPath);
            else this.group.removeClipPath();
        };
        BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
            var _this = this;
            if (!data.count()) return;
            var baseAxis = realtimeSortCfg.baseAxis;
            if (this._isFirstFrame) {
                this._dispatchInitSort(data, realtimeSortCfg, api);
                this._isFirstFrame = false;
            } else {
                var orderMapping_1 = function(idx) {
                    var el = data.getItemGraphicEl(idx);
                    if (el) {
                        var shape = el.shape;
                        return (baseAxis.isHorizontal() ? Math.abs(shape.height) : Math.abs(shape.width)) || 0;
                    } else return 0;
                };
                this._onRendered = function() {
                    _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
                };
                api.getZr().on('rendered', this._onRendered);
            }
        };
        BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
            var info = [];
            data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
                var mappedValue = orderMapping(dataIdx);
                mappedValue = mappedValue == null ? NaN : mappedValue;
                info.push({
                    dataIndex: dataIdx,
                    mappedValue: mappedValue,
                    ordinalNumber: ordinalNumber
                });
            });
            info.sort(function(a, b) {
                return b.mappedValue - a.mappedValue;
            });
            return {
                ordinalNumbers: (0, (0, parcelRequire("bahqM")).map)(info, function(item) {
                    return item.ordinalNumber;
                })
            };
        };
        BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
            var scale = baseAxis.scale;
            var ordinalDataDim = data.mapDimension(baseAxis.dim);
            var lastValue = Number.MAX_VALUE;
            for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
                var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
                var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
                if (value > lastValue) return true;
                lastValue = value;
            }
            return false;
        };
        BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
            var scale = baseAxis.scale;
            var extent = scale.getExtent();
            var tickNum = Math.max(0, extent[0]);
            var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
            for(; tickNum <= tickMax; ++tickNum){
                if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
            }
        };
        BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
            if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
            var sortInfo = this._dataSort(data, baseAxis, orderMapping);
            if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
                this._removeOnRenderedListener(api);
                api.dispatchAction({
                    type: 'changeAxisOrder',
                    componentType: baseAxis.dim + 'Axis',
                    axisId: baseAxis.index,
                    sortInfo: sortInfo
                });
            }
        };
        BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
            var baseAxis = realtimeSortCfg.baseAxis;
            var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
                return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
            });
            api.dispatchAction({
                type: 'changeAxisOrder',
                componentType: baseAxis.dim + 'Axis',
                isInitSort: true,
                axisId: baseAxis.index,
                sortInfo: sortResult
            });
        };
        BarView.prototype.remove = function(ecModel, api) {
            this._clear(this._model);
            this._removeOnRenderedListener(api);
        };
        BarView.prototype.dispose = function(ecModel, api) {
            this._removeOnRenderedListener(api);
        };
        BarView.prototype._removeOnRenderedListener = function(api) {
            if (this._onRendered) {
                api.getZr().off('rendered', this._onRendered);
                this._onRendered = null;
            }
        };
        BarView.prototype._clear = function(model) {
            var group = this.group;
            var data = this._data;
            if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
                this._removeBackground();
                this._backgroundEls = [];
                data.eachItemGraphicEl(function(el) {
                    (0, (0, parcelRequire("eYgMC")).removeElementWithFadeOut)(el, model, (0, (0, parcelRequire("7QjoM")).getECData)(el).dataIndex);
                });
            } else group.removeAll();
            this._data = null;
            this._isFirstFrame = true;
        };
        BarView.prototype._removeBackground = function() {
            this.group.remove(this._backgroundGroup);
            this._backgroundGroup = null;
        };
        BarView.type = 'bar';
        return BarView;
    }((0, (0, parcelRequire("loerw")).default));
    var $cb1fc3f08c69a560$var$clip = {
        cartesian2d: function(coordSysBoundingRect, layout) {
            var signWidth = layout.width < 0 ? -1 : 1;
            var signHeight = layout.height < 0 ? -1 : 1;
            if (signWidth < 0) {
                layout.x += layout.width;
                layout.width = -layout.width;
            }
            if (signHeight < 0) {
                layout.y += layout.height;
                layout.height = -layout.height;
            }
            var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
            var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
            var x = $cb1fc3f08c69a560$var$mathMax(layout.x, coordSysBoundingRect.x);
            var x2 = $cb1fc3f08c69a560$var$mathMin(layout.x + layout.width, coordSysX2);
            var y = $cb1fc3f08c69a560$var$mathMax(layout.y, coordSysBoundingRect.y);
            var y2 = $cb1fc3f08c69a560$var$mathMin(layout.y + layout.height, coordSysY2);
            var xClipped = x2 < x;
            var yClipped = y2 < y;
            layout.x = xClipped && x > coordSysX2 ? x2 : x;
            layout.y = yClipped && y > coordSysY2 ? y2 : y;
            layout.width = xClipped ? 0 : x2 - x;
            layout.height = yClipped ? 0 : y2 - y;
            if (signWidth < 0) {
                layout.x += layout.width;
                layout.width = -layout.width;
            }
            if (signHeight < 0) {
                layout.y += layout.height;
                layout.height = -layout.height;
            }
            return xClipped || yClipped;
        },
        polar: function(coordSysClipArea, layout) {
            var signR = layout.r0 <= layout.r ? 1 : -1;
            if (signR < 0) {
                var tmp = layout.r;
                layout.r = layout.r0;
                layout.r0 = tmp;
            }
            var r = $cb1fc3f08c69a560$var$mathMin(layout.r, coordSysClipArea.r);
            var r0 = $cb1fc3f08c69a560$var$mathMax(layout.r0, coordSysClipArea.r0);
            layout.r = r;
            layout.r0 = r0;
            var clipped = r - r0 < 0;
            if (signR < 0) {
                var tmp = layout.r;
                layout.r = layout.r0;
                layout.r0 = tmp;
            }
            return clipped;
        }
    };
    var $cb1fc3f08c69a560$var$elementCreator = {
        cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
            var rect = new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: (0, (0, parcelRequire("bahqM")).extend)({}, layout),
                z2: 1
            });
            rect.__dataIndex = newIndex;
            rect.name = 'item';
            if (animationModel) {
                var rectShape = rect.shape;
                var animateProperty = isHorizontal ? 'height' : 'width';
                rectShape[animateProperty] = 0;
            }
            return rect;
        },
        polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
            var ShapeClass = !isRadial && roundCap ? (0, (0, parcelRequire("eaQLm")).default) : (0, (0, parcelRequire("elGBV")).default);
            var sector = new ShapeClass({
                shape: layout,
                z2: 1
            });
            sector.name = 'item';
            var positionMap = $cb1fc3f08c69a560$var$createPolarPositionMapping(isRadial);
            sector.calculateTextPosition = (0, (0, parcelRequire("9dNYG")).createSectorCalculateTextPosition)(positionMap, {
                isRoundCap: ShapeClass === (0, (0, parcelRequire("eaQLm")).default)
            });
            if (animationModel) {
                var sectorShape = sector.shape;
                var animateProperty = isRadial ? 'r' : 'endAngle';
                var animateTarget = {};
                sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
                animateTarget[animateProperty] = layout[animateProperty];
                (isUpdate ? (0, (0, parcelRequire("eYgMC")).updateProps) : (0, (0, parcelRequire("eYgMC")).initProps))(sector, {
                    shape: animateTarget
                }, animationModel);
            }
            return sector;
        }
    };
    function $cb1fc3f08c69a560$var$shouldRealtimeSort(seriesModel, coordSys) {
        var realtimeSortOption = seriesModel.get('realtimeSort', true);
        var baseAxis = coordSys.getBaseAxis();
        if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') return {
            baseAxis: baseAxis,
            otherAxis: coordSys.getOtherAxis(baseAxis)
        };
    }
    function $cb1fc3f08c69a560$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
        var seriesTarget;
        var axisTarget;
        if (isHorizontal) {
            axisTarget = {
                x: layout.x,
                width: layout.width
            };
            seriesTarget = {
                y: layout.y,
                height: layout.height
            };
        } else {
            axisTarget = {
                y: layout.y,
                height: layout.height
            };
            seriesTarget = {
                x: layout.x,
                width: layout.width
            };
        }
        if (!isChangeOrder) (isUpdate ? (0, (0, parcelRequire("eYgMC")).updateProps) : (0, (0, parcelRequire("eYgMC")).initProps))(el, {
            shape: seriesTarget
        }, seriesAnimationModel, newIndex, null);
        var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
        (isUpdate ? (0, (0, parcelRequire("eYgMC")).updateProps) : (0, (0, parcelRequire("eYgMC")).initProps))(el, {
            shape: axisTarget
        }, axisAnimationModel, newIndex);
    }
    function $cb1fc3f08c69a560$var$checkPropertiesNotValid(obj, props) {
        for(var i = 0; i < props.length; i++){
            if (!isFinite(obj[props[i]])) return true;
        }
        return false;
    }
    var $cb1fc3f08c69a560$var$rectPropties = [
        'x',
        'y',
        'width',
        'height'
    ];
    var $cb1fc3f08c69a560$var$polarPropties = [
        'cx',
        'cy',
        'r',
        'startAngle',
        'endAngle'
    ];
    var $cb1fc3f08c69a560$var$isValidLayout = {
        cartesian2d: function(layout) {
            return !$cb1fc3f08c69a560$var$checkPropertiesNotValid(layout, $cb1fc3f08c69a560$var$rectPropties);
        },
        polar: function(layout) {
            return !$cb1fc3f08c69a560$var$checkPropertiesNotValid(layout, $cb1fc3f08c69a560$var$polarPropties);
        }
    };
    var $cb1fc3f08c69a560$var$getLayout = {
        cartesian2d: function(data, dataIndex, itemModel) {
            var layout = data.getItemLayout(dataIndex);
            var fixedLineWidth = itemModel ? $cb1fc3f08c69a560$var$getLineWidth(itemModel, layout) : 0;
            var signX = layout.width > 0 ? 1 : -1;
            var signY = layout.height > 0 ? 1 : -1;
            return {
                x: layout.x + signX * fixedLineWidth / 2,
                y: layout.y + signY * fixedLineWidth / 2,
                width: layout.width - signX * fixedLineWidth,
                height: layout.height - signY * fixedLineWidth
            };
        },
        polar: function(data, dataIndex, itemModel) {
            var layout = data.getItemLayout(dataIndex);
            return {
                cx: layout.cx,
                cy: layout.cy,
                r0: layout.r0,
                r: layout.r,
                startAngle: layout.startAngle,
                endAngle: layout.endAngle,
                clockwise: layout.clockwise
            };
        }
    };
    function $cb1fc3f08c69a560$var$isZeroOnPolar(layout) {
        return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
    }
    function $cb1fc3f08c69a560$var$createPolarPositionMapping(isRadial) {
        return function(isRadial) {
            var arcOrAngle = isRadial ? 'Arc' : 'Angle';
            return function(position) {
                switch(position){
                    case 'start':
                    case 'insideStart':
                    case 'end':
                    case 'insideEnd':
                        return position + arcOrAngle;
                    default:
                        return position;
                }
            };
        }(isRadial);
    }
    function $cb1fc3f08c69a560$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
        var style = data.getItemVisual(dataIndex, 'style');
        if (!isPolar) el.setShape('r', itemModel.get([
            'itemStyle',
            'borderRadius'
        ]) || 0);
        el.useStyle(style);
        var cursorStyle = itemModel.getShallow('cursor');
        cursorStyle && el.attr('cursor', cursorStyle);
        var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
        var labelStatesModels = (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(itemModel);
        (0, (0, parcelRequire("gvLUt")).setLabelStyle)(el, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: dataIndex,
            defaultText: (0, (0, parcelRequire("5MLZz")).getDefaultLabel)(seriesModel.getData(), dataIndex),
            inheritColor: style.fill,
            defaultOpacity: style.opacity,
            defaultOutsidePosition: labelPositionOutside
        });
        var label = el.getTextContent();
        if (isPolar && label) {
            var position = itemModel.get([
                'label',
                'position'
            ]);
            el.textConfig.inside = position === 'middle' ? true : null;
            (0, (0, parcelRequire("9dNYG")).setSectorTextRotation)(el, position === 'outside' ? labelPositionOutside : position, $cb1fc3f08c69a560$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
                'label',
                'rotate'
            ]));
        }
        (0, (0, parcelRequire("gvLUt")).setLabelValueAnimation)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
            return (0, (0, parcelRequire("5MLZz")).getDefaultInterpolatedLabel)(data, value);
        });
        var emphasisModel = itemModel.getModel([
            'emphasis'
        ]);
        (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'));
        (0, (0, parcelRequire("fIXXx")).setStatesStylesFromModel)(el, itemModel);
        if ($cb1fc3f08c69a560$var$isZeroOnPolar(layout)) {
            el.style.fill = 'none';
            el.style.stroke = 'none';
            (0, (0, parcelRequire("bahqM")).each)(el.states, function(state) {
                if (state.style) state.style.fill = state.style.stroke = 'none';
            });
        }
    }
    function $cb1fc3f08c69a560$var$getLineWidth(itemModel, rawLayout) {
        var borderColor = itemModel.get([
            'itemStyle',
            'borderColor'
        ]);
        if (!borderColor || borderColor === 'none') return 0;
        var lineWidth = itemModel.get([
            'itemStyle',
            'borderWidth'
        ]) || 0;
        var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
        var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
        return Math.min(lineWidth, width, height);
    }
    var $cb1fc3f08c69a560$var$LagePathShape = function() {
        function LagePathShape() {}
        return LagePathShape;
    }();
    var $cb1fc3f08c69a560$var$LargePath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LargePath, _super);
        function LargePath(opts) {
            var _this = _super.call(this, opts) || this;
            _this.type = 'largeBar';
            return _this;
        }
        LargePath.prototype.getDefaultShape = function() {
            return new $cb1fc3f08c69a560$var$LagePathShape();
        };
        LargePath.prototype.buildPath = function(ctx, shape) {
            var points = shape.points;
            var startPoint = this.__startPoint;
            var baseDimIdx = this.__baseDimIdx;
            for(var i = 0; i < points.length; i += 2){
                startPoint[baseDimIdx] = points[i + baseDimIdx];
                ctx.moveTo(startPoint[0], startPoint[1]);
                ctx.lineTo(points[i], points[i + 1]);
            }
        };
        return LargePath;
    }((0, (0, parcelRequire("ghQ8v")).default));
    function $cb1fc3f08c69a560$var$createLarge(seriesModel, group, incremental) {
        var data = seriesModel.getData();
        var startPoint = [];
        var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
        startPoint[1 - baseDimIdx] = data.getLayout('valueAxisStart');
        var largeDataIndices = data.getLayout('largeDataIndices');
        var barWidth = data.getLayout('barWidth');
        var backgroundModel = seriesModel.getModel('backgroundStyle');
        var drawBackground = seriesModel.get('showBackground', true);
        if (drawBackground) {
            var points = data.getLayout('largeBackgroundPoints');
            var backgroundStartPoint = [];
            backgroundStartPoint[1 - baseDimIdx] = data.getLayout('backgroundStart');
            var bgEl = new $cb1fc3f08c69a560$var$LargePath({
                shape: {
                    points: points
                },
                incremental: !!incremental,
                silent: true,
                z2: 0
            });
            bgEl.__startPoint = backgroundStartPoint;
            bgEl.__baseDimIdx = baseDimIdx;
            bgEl.__largeDataIndices = largeDataIndices;
            bgEl.__barWidth = barWidth;
            $cb1fc3f08c69a560$var$setLargeBackgroundStyle(bgEl, backgroundModel, data);
            group.add(bgEl);
        }
        var el = new $cb1fc3f08c69a560$var$LargePath({
            shape: {
                points: data.getLayout('largePoints')
            },
            incremental: !!incremental
        });
        el.__startPoint = startPoint;
        el.__baseDimIdx = baseDimIdx;
        el.__largeDataIndices = largeDataIndices;
        el.__barWidth = barWidth;
        group.add(el);
        $cb1fc3f08c69a560$var$setLargeStyle(el, seriesModel, data);
        (0, (0, parcelRequire("7QjoM")).getECData)(el).seriesIndex = seriesModel.seriesIndex;
        if (!seriesModel.get('silent')) {
            el.on('mousedown', $cb1fc3f08c69a560$var$largePathUpdateDataIndex);
            el.on('mousemove', $cb1fc3f08c69a560$var$largePathUpdateDataIndex);
        }
    }
    var $cb1fc3f08c69a560$var$largePathUpdateDataIndex = (0, (0, parcelRequire("ljaBy")).throttle)(function(event) {
        var largePath = this;
        var dataIndex = $cb1fc3f08c69a560$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
        (0, (0, parcelRequire("7QjoM")).getECData)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
    }, 30, false);
    function $cb1fc3f08c69a560$var$largePathFindDataIndex(largePath, x, y) {
        var baseDimIdx = largePath.__baseDimIdx;
        var valueDimIdx = 1 - baseDimIdx;
        var points = largePath.shape.points;
        var largeDataIndices = largePath.__largeDataIndices;
        var barWidthHalf = Math.abs(largePath.__barWidth / 2);
        var startValueVal = largePath.__startPoint[valueDimIdx];
        $cb1fc3f08c69a560$var$_eventPos[0] = x;
        $cb1fc3f08c69a560$var$_eventPos[1] = y;
        var pointerBaseVal = $cb1fc3f08c69a560$var$_eventPos[baseDimIdx];
        var pointerValueVal = $cb1fc3f08c69a560$var$_eventPos[1 - baseDimIdx];
        var baseLowerBound = pointerBaseVal - barWidthHalf;
        var baseUpperBound = pointerBaseVal + barWidthHalf;
        for(var i = 0, len = points.length / 2; i < len; i++){
            var ii = i * 2;
            var barBaseVal = points[ii + baseDimIdx];
            var barValueVal = points[ii + valueDimIdx];
            if (barBaseVal >= baseLowerBound && barBaseVal <= baseUpperBound && (startValueVal <= barValueVal ? pointerValueVal >= startValueVal && pointerValueVal <= barValueVal : pointerValueVal >= barValueVal && pointerValueVal <= startValueVal)) return largeDataIndices[i];
        }
        return -1;
    }
    function $cb1fc3f08c69a560$var$setLargeStyle(el, seriesModel, data) {
        var globalStyle = data.getVisual('style');
        el.useStyle((0, (0, parcelRequire("bahqM")).extend)({}, globalStyle));
        el.style.fill = null;
        el.style.stroke = globalStyle.fill;
        el.style.lineWidth = data.getLayout('barWidth');
    }
    function $cb1fc3f08c69a560$var$setLargeBackgroundStyle(el, backgroundModel, data) {
        var borderColor = backgroundModel.get('borderColor') || backgroundModel.get('color');
        var itemStyle = backgroundModel.getItemStyle();
        el.useStyle(itemStyle);
        el.style.fill = null;
        el.style.stroke = borderColor;
        el.style.lineWidth = data.getLayout('barWidth');
    }
    function $cb1fc3f08c69a560$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
        if ((0, (0, parcelRequire("40dMe")).isCoordinateSystemType)(coord, 'cartesian2d')) {
            var rectShape = layout;
            var coordLayout = coord.getArea();
            return {
                x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
                y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
                width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
                height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
            };
        } else {
            var coordLayout = coord.getArea();
            var sectorShape = layout;
            return {
                cx: coordLayout.cx,
                cy: coordLayout.cy,
                r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
                r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
                startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
                endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
            };
        }
    }
    function $cb1fc3f08c69a560$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
        var ElementClz = coord.type === 'polar' ? (0, (0, parcelRequire("elGBV")).default) : (0, (0, parcelRequire("7Tw7u")).default);
        return new ElementClz({
            shape: $cb1fc3f08c69a560$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
            silent: true,
            z2: 0
        });
    }
    var $cb1fc3f08c69a560$export$2e2bcd8739ae039 = $cb1fc3f08c69a560$var$BarView;
});
parcelRegister("eaQLm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a51aed73fd415b38$export$2e2bcd8739ae039);
    var $3VFsf;
    parcelRequire("fHITF");
    var $ghQ8v;
    var $a51aed73fd415b38$var$SausageShape = function() {
        function SausageShape() {
            this.cx = 0;
            this.cy = 0;
            this.r0 = 0;
            this.r = 0;
            this.startAngle = 0;
            this.endAngle = Math.PI * 2;
            this.clockwise = true;
        }
        return SausageShape;
    }();
    var $a51aed73fd415b38$var$SausagePath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SausagePath, _super);
        function SausagePath(opts) {
            var _this = _super.call(this, opts) || this;
            _this.type = 'sausage';
            return _this;
        }
        SausagePath.prototype.getDefaultShape = function() {
            return new $a51aed73fd415b38$var$SausageShape();
        };
        SausagePath.prototype.buildPath = function(ctx, shape) {
            var x = shape.cx;
            var y = shape.cy;
            var r0 = Math.max(shape.r0 || 0, 0);
            var r = Math.max(shape.r, 0);
            var dr = (r - r0) * 0.5;
            var rCenter = r0 + dr;
            var startAngle = shape.startAngle;
            var endAngle = shape.endAngle;
            var clockwise = shape.clockwise;
            var unitStartX = Math.cos(startAngle);
            var unitStartY = Math.sin(startAngle);
            var unitEndX = Math.cos(endAngle);
            var unitEndY = Math.sin(endAngle);
            var lessThanCircle = clockwise ? endAngle - startAngle < Math.PI * 2 : startAngle - endAngle < Math.PI * 2;
            if (lessThanCircle) {
                ctx.moveTo(unitStartX * r0 + x, unitStartY * r0 + y);
                ctx.arc(unitStartX * rCenter + x, unitStartY * rCenter + y, dr, -Math.PI + startAngle, startAngle, !clockwise);
            }
            ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
            ctx.moveTo(unitEndX * r + x, unitEndY * r + y);
            ctx.arc(unitEndX * rCenter + x, unitEndY * rCenter + y, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
            if (r0 !== 0) {
                ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
                ctx.moveTo(unitStartX * r0 + x, unitEndY * r0 + y);
            }
            ctx.closePath();
        };
        return SausagePath;
    }((0, (0, parcelRequire("ghQ8v")).default));
    var $a51aed73fd415b38$export$2e2bcd8739ae039 = $a51aed73fd415b38$var$SausagePath;
});
parcelRegister("9dNYG", function(module, exports) {
    $parcel$export(module.exports, "createSectorCalculateTextPosition", ()=>$6b6c187953b9d25e$export$359a1e2d210ed734);
    $parcel$export(module.exports, "setSectorTextRotation", ()=>$6b6c187953b9d25e$export$672ce504c0db395a);
    var $b7ZX8;
    var $bahqM;
    function $6b6c187953b9d25e$export$359a1e2d210ed734(positionMapping, opts) {
        opts = opts || {};
        var isRoundCap = opts.isRoundCap;
        return function(out, opts, boundingRect) {
            var textPosition = opts.position;
            if (!textPosition || textPosition instanceof Array) return (0, (0, parcelRequire("b7ZX8")).calculateTextPosition)(out, opts, boundingRect);
            var mappedSectorPosition = positionMapping(textPosition);
            var distance = opts.distance != null ? opts.distance : 5;
            var sector = this.shape;
            var cx = sector.cx;
            var cy = sector.cy;
            var r = sector.r;
            var r0 = sector.r0;
            var middleR = (r + r0) / 2;
            var startAngle = sector.startAngle;
            var endAngle = sector.endAngle;
            var middleAngle = (startAngle + endAngle) / 2;
            var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
            var mathCos = Math.cos;
            var mathSin = Math.sin;
            var x = cx + r * mathCos(startAngle);
            var y = cy + r * mathSin(startAngle);
            var textAlign = 'left';
            var textVerticalAlign = 'top';
            switch(mappedSectorPosition){
                case 'startArc':
                    x = cx + (r0 - distance) * mathCos(middleAngle);
                    y = cy + (r0 - distance) * mathSin(middleAngle);
                    textAlign = 'center';
                    textVerticalAlign = 'top';
                    break;
                case 'insideStartArc':
                    x = cx + (r0 + distance) * mathCos(middleAngle);
                    y = cy + (r0 + distance) * mathSin(middleAngle);
                    textAlign = 'center';
                    textVerticalAlign = 'bottom';
                    break;
                case 'startAngle':
                    x = cx + middleR * mathCos(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                    y = cy + middleR * mathSin(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                    textAlign = 'right';
                    textVerticalAlign = 'middle';
                    break;
                case 'insideStartAngle':
                    x = cx + middleR * mathCos(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                    y = cy + middleR * mathSin(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                    textAlign = 'left';
                    textVerticalAlign = 'middle';
                    break;
                case 'middle':
                    x = cx + middleR * mathCos(middleAngle);
                    y = cy + middleR * mathSin(middleAngle);
                    textAlign = 'center';
                    textVerticalAlign = 'middle';
                    break;
                case 'endArc':
                    x = cx + (r + distance) * mathCos(middleAngle);
                    y = cy + (r + distance) * mathSin(middleAngle);
                    textAlign = 'center';
                    textVerticalAlign = 'bottom';
                    break;
                case 'insideEndArc':
                    x = cx + (r - distance) * mathCos(middleAngle);
                    y = cy + (r - distance) * mathSin(middleAngle);
                    textAlign = 'center';
                    textVerticalAlign = 'top';
                    break;
                case 'endAngle':
                    x = cx + middleR * mathCos(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                    y = cy + middleR * mathSin(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                    textAlign = 'left';
                    textVerticalAlign = 'middle';
                    break;
                case 'insideEndAngle':
                    x = cx + middleR * mathCos(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                    y = cy + middleR * mathSin(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                    textAlign = 'right';
                    textVerticalAlign = 'middle';
                    break;
                default:
                    return (0, (0, parcelRequire("b7ZX8")).calculateTextPosition)(out, opts, boundingRect);
            }
            out = out || {};
            out.x = x;
            out.y = y;
            out.align = textAlign;
            out.verticalAlign = textVerticalAlign;
            return out;
        };
    }
    function $6b6c187953b9d25e$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
        if (typeof rotateType === 'number') {
            sector.setTextConfig({
                rotation: rotateType
            });
            return;
        } else if ((0, (0, parcelRequire("bahqM")).isArray)(textPosition)) {
            sector.setTextConfig({
                rotation: 0
            });
            return;
        }
        var shape = sector.shape;
        var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
        var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var anchorAngle;
        var mappedSectorPosition = positionMapping(textPosition);
        switch(mappedSectorPosition){
            case 'startArc':
            case 'insideStartArc':
            case 'middle':
            case 'insideEndArc':
            case 'endArc':
                anchorAngle = middleAngle;
                break;
            case 'startAngle':
            case 'insideStartAngle':
                anchorAngle = startAngle;
                break;
            case 'endAngle':
            case 'insideEndAngle':
                anchorAngle = endAngle;
                break;
            default:
                sector.setTextConfig({
                    rotation: 0
                });
                return;
        }
        var rotate = Math.PI * 1.5 - anchorAngle;
        if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
        sector.setTextConfig({
            rotation: rotate
        });
    }
    function $6b6c187953b9d25e$var$adjustAngleDistanceX(angle, distance, isEnd) {
        return distance * Math.sin(angle) * (isEnd ? -1 : 1);
    }
    function $6b6c187953b9d25e$var$adjustAngleDistanceY(angle, distance, isEnd) {
        return distance * Math.cos(angle) * (isEnd ? 1 : -1);
    }
});
parcelRegister("6OGL8", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$4f6894ac64afab25$export$4b3e715f166fdd78);
    var $iWOYl;
    var $hi3Y7;
    var $alpND;
    function $4f6894ac64afab25$export$4b3e715f166fdd78(registers) {
        (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("iWOYl")).install));
        (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("hi3Y7")).install));
    }
});
parcelRegister("hyYD4", function(module, exports) {
    $parcel$export(module.exports, "CHART_SPACE_LEFT", ()=>$91e77936c1049368$export$ffe1d6b5e0d7a6e5);
    $parcel$export(module.exports, "CHART_SPACE_RIGHT", ()=>$91e77936c1049368$export$990d773ada9107e0);
    var $gwIPs;
    const $91e77936c1049368$export$ffe1d6b5e0d7a6e5 = (0, (0, parcelRequire("gwIPs")).gridSize) * 8;
    const $91e77936c1049368$export$990d773ada9107e0 = (0, (0, parcelRequire("gwIPs")).gridSize) * 4;
    const $91e77936c1049368$export$ad3c2ee386592d19 = (0, (0, parcelRequire("gwIPs")).gridSize) * 38;
    const $91e77936c1049368$export$304a9c3520780858 = (0, (0, parcelRequire("gwIPs")).gridSize) * 8;
    const $91e77936c1049368$export$3d957908be204f46 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $91e77936c1049368$export$45a30b115b114e0f = (0, (0, parcelRequire("gwIPs")).gridSize);
});
const $b41c313de361af34$export$5b067f596a486882 = 18;
parcelRegister("lz0GT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d873bf2f897cf375$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d873bf2f897cf375$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        yAxisLabel: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart.y-axis-label",
            "defaultMessage": "Deployment frequency"
        }
    });
});
parcelRegister("9zuj3", function(module, exports) {
    $parcel$export(module.exports, "useTooltipFormatter", ()=>$c15ef68f5cb15c93$export$8d71e8328e9bd59b);
    var $k5uoT;
    var $gwIPs;
    var $aWse0;
    var $9LRCK;
    const $c15ef68f5cb15c93$var$getIconInfo = (value, deploymentsComparisonTarget)=>{
        let iconHtml = '';
        let style = '';
        if (deploymentsComparisonTarget === null) return {
            style: style,
            iconHtml: iconHtml
        };
        if (value < deploymentsComparisonTarget) {
            iconHtml = (0, $7b9f1098797f5d28$export$f97d6df82c759e48);
            style = $c15ef68f5cb15c93$var$iconWarn;
        }
        if (value > deploymentsComparisonTarget) {
            iconHtml = (0, $7b9f1098797f5d28$export$ae6cac6e77684f0f);
            style = $c15ef68f5cb15c93$var$iconGood;
        }
        return {
            style: style,
            iconHtml: iconHtml
        };
    };
    const $c15ef68f5cb15c93$export$8d71e8328e9bd59b = (deploymentsComparisonTarget)=>{
        const { formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        return ({ data: data })=>{
            const { value: numDeployments, customInfo: { medianIssuesPerDeployment: medianIssuesPerDeployment, startDateInclusive: startDateInclusive } } = data;
            const weekStartDateText = formatMessage((0, (0, parcelRequire("9LRCK")).default).weekStartDate, {
                date: formatDate(startDateInclusive, {
                    day: 'numeric',
                    month: 'short'
                })
            });
            const numIssuesText = formatMessage((0, (0, parcelRequire("9LRCK")).default).medianIssuesPerDeployments, {
                numIssues: formatNumber(medianIssuesPerDeployment ?? 0)
            });
            const numProdDeploymentsText = formatMessage((0, (0, parcelRequire("9LRCK")).default).numProdDeployments, {
                numDeployments: numDeployments
            });
            const { style: comparisonIconStyle, iconHtml: iconHtml } = $c15ef68f5cb15c93$var$getIconInfo(numDeployments, deploymentsComparisonTarget);
            return `
            <div style="${$c15ef68f5cb15c93$var$container}">
                <div style="${$c15ef68f5cb15c93$var$headerWeekStartText}">
                    ${weekStartDateText}
                </div>
                <div style="${$c15ef68f5cb15c93$var$deploymentCountTextContainer}${iconHtml !== '' ? $c15ef68f5cb15c93$var$deploymentCountIconPositioner : ''}">
                    <span style="${comparisonIconStyle}">${iconHtml}</span>
                    ${numProdDeploymentsText}
                </div>
                <div style="${$c15ef68f5cb15c93$var$medianIssuesPerDeploymentTextContainer}">
                    <span style="${$c15ef68f5cb15c93$var$issuesIconStyled}">${0, $7b9f1098797f5d28$export$51f43fae9c774cb5}</span>
                    ${numIssuesText}
                </div>
            </div>
        `;
        };
    };
    const $c15ef68f5cb15c93$var$container = `
    height: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 9}px;
    padding: 0 ${(0, (0, parcelRequire("gwIPs")).gridSize) / 2}px;
    background-color: ${(0, $829f609a65d26a98$exports).N900};
    border-radius: ${(0, (0, parcelRequire("gwIPs")).borderRadius)};
    font-size: ${(0, (0, parcelRequire("k5uoT")).fontSizeSmall)()}px;
    color: ${(0, $829f609a65d26a98$exports).N0};
`;
    const $c15ef68f5cb15c93$var$headerWeekStartText = `
    display: flex;
    align-items: center;
    height: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px;
    margin-bottom: ${(0, (0, parcelRequire("gwIPs")).gridSize)}px;
    text-decoration-line: underline;
`;
    const $c15ef68f5cb15c93$var$iconBase = `
    transform: scale(0.666);
    margin-top: 2px;
`;
    const $c15ef68f5cb15c93$var$iconGood = `
    ${$c15ef68f5cb15c93$var$iconBase}
    fill: ${(0, $829f609a65d26a98$exports).N800};
    color: ${(0, $829f609a65d26a98$exports).G300}
`;
    const $c15ef68f5cb15c93$var$iconWarn = `
    ${$c15ef68f5cb15c93$var$iconBase}
    fill: ${(0, $829f609a65d26a98$exports).N800};
    color: ${(0, $829f609a65d26a98$exports).Y400}
`;
    const $c15ef68f5cb15c93$var$issuesIconStyled = `
    ${$c15ef68f5cb15c93$var$iconBase}
    margin-left: -5px;
`;
    const $c15ef68f5cb15c93$var$deploymentCountTextContainer = `
    display: flex;
    align-items: center;
    height: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px;
    margin-bottom: ${(0, (0, parcelRequire("gwIPs")).gridSize)}px;
`;
    const $c15ef68f5cb15c93$var$deploymentCountIconPositioner = `
    margin-left: -5px;
`;
    const $c15ef68f5cb15c93$var$medianIssuesPerDeploymentTextContainer = `
    display: flex;
    align-items: center;
    height: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px;
`;
});
const $7b9f1098797f5d28$export$ae6cac6e77684f0f = '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" fill-rule="nonzero" cx="12" cy="12" r="10"></circle><path d="M11.288 7.293L8.294 10.27a1.002 1.002 0 000 1.416 1.01 1.01 0 001.421 0l1.279-1.272V16c0 .552.451 1 1.006 1 .555 0 1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 001.421 0 .998.998 0 000-1.416l-2.994-2.977a1.01 1.01 0 00-1.423 0z" fill="inherit"></path></g></svg>';
const $7b9f1098797f5d28$export$f97d6df82c759e48 = '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" fill-rule="nonzero" cx="12" cy="12" r="10"></circle><path d="M10.994 8v5.586l-1.279-1.272a1.01 1.01 0 00-1.421 0 .998.998 0 000 1.416l2.994 2.977a1.01 1.01 0 001.423 0l2.994-2.977a.998.998 0 000-1.416 1.01 1.01 0 00-1.421 0l-1.279 1.272V8c0-.552-.45-1-1.005-1-.555 0-1.006.448-1.006 1z" fill="inherit"></path></g></svg>';
const $7b9f1098797f5d28$export$51f43fae9c774cb5 = '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 12.991c0 .007 14.005.009 14.005.009C18.999 13 19 5.009 19 5.009 19 5.002 4.995 5 4.995 5 5.001 5 5 12.991 5 12.991zM3 5.01C3 3.899 3.893 3 4.995 3h14.01C20.107 3 21 3.902 21 5.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 12.991V5.01zM19 19c-.005 1.105-.9 2-2.006 2H7.006A2.009 2.009 0 015 19h14zm1-3a2.002 2.002 0 01-1.994 2H5.994A2.003 2.003 0 014 16h16z" fill-rule="nonzero"></path><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 00-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 00-1.3 1.3l1.406 1.405z"></path></g></svg>';
parcelRegister("9LRCK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe6ae3ba996a3d80$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fe6ae3ba996a3d80$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        numProdDeployments: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart.tooltip.num-prod-deployments",
            "defaultMessage": "{numDeployments} production {numDeployments, plural, one {deployment} other {deployments}}"
        },
        medianIssuesPerDeployments: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart.tooltip.median-issues-per-deployments",
            "defaultMessage": "{numIssues} median {numIssues, plural, one {issue} other {issues}} per deployment"
        },
        weekStartDate: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart.tooltip.week-start-date",
            "defaultMessage": "Week of {date}"
        }
    });
});
parcelRegister("fg7Dg", function(module, exports) {
    $parcel$export(module.exports, "convertReportCoreToChartDataPoints", ()=>$8a79902ec6236f8b$export$5050f1e61745475);
    var $ecd0S;
    var $claG0;
    const $8a79902ec6236f8b$var$getEmphasisColor = (prodDeploymentsCount, wholePeriodStatistic)=>prodDeploymentsCount >= wholePeriodStatistic ? (0, $829f609a65d26a98$exports).G300 : (0, $829f609a65d26a98$exports).Y300;
    const $8a79902ec6236f8b$export$5050f1e61745475 = (deploymentFrequencyReportData, selectedStartDateInclusive)=>{
        const isProdDataEmpty = (0, (0, parcelRequire("claG0")).isProdDataEmpty)(deploymentFrequencyReportData);
        return deploymentFrequencyReportData.weeksData.map((weekData, i)=>{
            const prodDeploymentsCount = weekData.deploymentCount.prod;
            const isSelectedData = !isProdDataEmpty && selectedStartDateInclusive.getTime() === weekData.startDateInclusive.getTime();
            const emphasisColor = $8a79902ec6236f8b$var$getEmphasisColor(prodDeploymentsCount, deploymentFrequencyReportData.averageDeploymentCount);
            const isCurrentWeekData = i === (0, (0, parcelRequire("ecd0S")).WEEKS_IN_REPORT) - 1;
            const isCurrentWeekEmpty = prodDeploymentsCount === 0;
            const barColor = isCurrentWeekData ? (0, $829f609a65d26a98$exports).N60 : (0, $829f609a65d26a98$exports).N100;
            return {
                value: prodDeploymentsCount,
                itemStyle: {
                    color: isSelectedData ? emphasisColor : barColor,
                    borderType: isCurrentWeekData && !isCurrentWeekEmpty ? 'dashed' : undefined,
                    borderColor: isCurrentWeekData && !isCurrentWeekEmpty ? (0, $829f609a65d26a98$exports).N300 : undefined
                },
                emphasis: {
                    itemStyle: {
                        color: emphasisColor
                    }
                },
                customInfo: {
                    startDateInclusive: weekData.startDateInclusive,
                    medianIssuesPerDeployment: weekData.medianIssuesPerDeployment.prod,
                    emphasisColor: isSelectedData ? emphasisColor : null
                }
            };
        });
    };
});
parcelRegister("gabu1", function(module, exports) {
    $parcel$export(module.exports, "EmptyDataMessage", ()=>$b06fdae3b98cfd3a$export$11485e91fe85c41b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $ecd0S;
    var $f70oV;
    var $ilLj2;
    var $5j2ly = parcelRequire("5j2ly");
    var $epPK7;
    const $b06fdae3b98cfd3a$export$11485e91fe85c41b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isSimplified = (0, (0, parcelRequire("ilLj2")).useProjectSimplified)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b06fdae3b98cfd3a$var$Wrapper, {
            "data-test-id": "software-deployment-frequency-report.ui.deployment-frequency-bar-chart.empty-data-message"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b06fdae3b98cfd3a$var$IconContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($5j2ly))),
            alt: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement($b06fdae3b98cfd3a$var$TopMessage, null, formatMessage((0, (0, parcelRequire("epPK7")).default).emptyDataMessageTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement($b06fdae3b98cfd3a$var$BottomMessage, null, formatMessage((0, (0, parcelRequire("epPK7")).default).emptyDataMessageDescription), (0, ($parcel$interopDefault($5uXOq))).createElement($b06fdae3b98cfd3a$var$LearnMore, {
            target: "_blank",
            href: isSimplified === true ? (0, (0, parcelRequire("ecd0S")).DEPLOYMENT_FREQUENCY_LEARN_MORE_TEAM_MANAGED) : (0, (0, parcelRequire("ecd0S")).DEPLOYMENT_FREQUENCY_LEARN_MORE_COMPANY_MANAGED)
        }, formatMessage((0, (0, parcelRequire("f70oV")).default).learnMore)))));
    };
    const $b06fdae3b98cfd3a$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1n8h _1e0c1txw _4cvr1fhb",
                __cmplp.className
            ])
        });
    });
    const $b06fdae3b98cfd3a$var$IconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbzwfg _2hwxutpp",
                __cmplp.className
            ])
        });
    });
    const $b06fdae3b98cfd3a$var$TopMessage = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1fxt _1wybgktf",
                __cmplp.className
            ])
        });
    });
    const $b06fdae3b98cfd3a$var$BottomMessage = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1fxt _11c81oud _19pk1b66",
                __cmplp.className
            ])
        });
    });
    const $b06fdae3b98cfd3a$var$LearnMore = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1y58 _18u0u2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("f70oV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de2f42315e6c3dae$export$2e2bcd8739ae039);
    var $7VHMR;
    var $de2f42315e6c3dae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        learnMore: {
            "id": "software-deployment-frequency-report.common.learn-more",
            "defaultMessage": "Learn more"
        },
        development: {
            "id": "software-deployment-frequency-report.common.development",
            "defaultMessage": "Development"
        },
        testing: {
            "id": "software-deployment-frequency-report.common.testing",
            "defaultMessage": "Testing"
        },
        staging: {
            "id": "software-deployment-frequency-report.common.staging",
            "defaultMessage": "Staging"
        },
        production: {
            "id": "software-deployment-frequency-report.common.production",
            "defaultMessage": "Production"
        },
        unmapped: {
            "id": "software-deployment-frequency-report.common.unmapped",
            "defaultMessage": "Unmapped"
        }
    });
});
parcelRegister("5j2ly", function(module, exports) {
    module.exports = new URL("magnifying_glass.f802f9ab.svg", import.meta.url).toString();
});
parcelRegister("epPK7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7302e4cd782e16b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b7302e4cd782e16b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyDataMessageTitle: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.empty-data-message.empty-data-message-title",
            "defaultMessage": "Get the last 12 weeks' data from your deployment tools"
        },
        emptyDataMessageDescription: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.empty-data-message.empty-data-message-description",
            "defaultMessage": "To view this report, you need deployment events from your CI/CD tool and commit events from your source code management tool."
        }
    });
});
parcelRegister("bHI5p", function(module, exports) {
    $parcel$export(module.exports, "LoadingSkeleton", ()=>$637286eb13198c47$export$44c18d210d5de37b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $8CUq3;
    var $gwIPs;
    var $4McSe;
    const $637286eb13198c47$export$44c18d210d5de37b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $637286eb13198c47$var$chartTitleStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 21}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px`,
            margin: "0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($637286eb13198c47$var$ChartContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($637286eb13198c47$var$ChartLeft, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 1.5}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 16}px`,
            margin: "0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($637286eb13198c47$var$Chart, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThin), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThin), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThin), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThin), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThick), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($637286eb13198c47$var$SelectionDetail, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 14}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 1.5}px`,
            margin: `0 0 ${(0, (0, parcelRequire("gwIPs")).gridSize) * 1.5}px 0`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 6.5}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2.5}px`,
            margin: `0 0 ${(0, (0, parcelRequire("gwIPs")).gridSize) * 1.5}px 0`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 26.5}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 1.5}px`,
            margin: `0 0 ${(0, (0, parcelRequire("gwIPs")).gridSize) * 1.5}px 0`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 26.5}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize)}px`,
            margin: "0"
        }))));
    const $637286eb13198c47$var$chartTitleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.200',
        height: 'space.300',
        paddingLeft: 'space.250'
    });
    const $637286eb13198c47$var$ChartContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4t3iko4j",
                __cmplp.className
            ])
        });
    });
    const $637286eb13198c47$var$ChartLeft = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1jfw _1e0c1txw _4cvr1h6o _1yt4g9oa",
                __cmplp.className
            ])
        });
    });
    const $637286eb13198c47$var$Chart = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1yb4 _1yt4c4ro",
                __cmplp.className
            ])
        });
    });
    const $637286eb13198c47$var$SelectionDetail = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb194s _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qidpf _u5f3idpf _n3tdvbgk _19bv1ylp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("c7V0L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57906f48a3afc873$export$2e2bcd8739ae039);
    var $7VHMR;
    var $57906f48a3afc873$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chartTitle: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart-title",
            "defaultMessage": "Deployment frequency"
        },
        titleHelpTooltip: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.title-help-tooltip",
            "defaultMessage": "Use the 12-week average to see how your team is performing and what corrective actions you need to make based on the deployment frequency comparisons."
        }
    });
});
parcelRegister("aD53o", function(module, exports) {
    $parcel$export(module.exports, "NoProvider", ()=>$b6c470d76524dae4$export$1834160caae1409b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $1dJ6S;
    var $iMzG0;
    var $koVbs;
    var $8zOmE;
    var $f70oV;
    var $4qoT7 = parcelRequire("4qoT7");
    var $58EYw = parcelRequire("58EYw");
    var $lee6Q = parcelRequire("lee6Q");
    var $bxTEa;
    const $b6c470d76524dae4$export$1834160caae1409b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$Wrapper, {
            "data-test-id": "software-deployment-frequency-report.ui.deployment-frequency-bar-chart.no-provider"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$Title, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "medium"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$TitleText, null, formatMessage((0, (0, parcelRequire("bxTEa")).default).noProviderTitle))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iMzG0")).BitbucketIcon), {
            size: "xlarge"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($4qoT7))),
            alt: "GitHub"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($58EYw))),
            alt: "GitLab"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$JenkinsIconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($lee6Q))),
            alt: "Jenkins",
            height: "50"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$Description, null, formatMessage((0, (0, parcelRequire("bxTEa")).default).noProviderDescription)), (0, ($parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$LearnMoreWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: (e, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'emptyStateLearnMore');
            },
            target: "_blank",
            href: "https://www.atlassian.com/software/jira/guides/developers/ci-cd#get-started"
        }, formatMessage((0, (0, parcelRequire("f70oV")).default).learnMore)))));
    };
    const $b6c470d76524dae4$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3iy1l4 _1e0c1txw _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $b6c470d76524dae4$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12fzreg",
                __cmplp.className
            ])
        });
    });
    const $b6c470d76524dae4$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyr1ejb _4t3ickbl _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $b6c470d76524dae4$var$TitleText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s81c8u",
                __cmplp.className
            ])
        });
    });
    const $b6c470d76524dae4$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _18u0pxbi",
                __cmplp.className
            ])
        });
    });
    const $b6c470d76524dae4$var$JenkinsIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $b6c470d76524dae4$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1fxt _11c81oud",
                __cmplp.className
            ])
        });
    });
    const $b6c470d76524dae4$var$LearnMoreWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkpxbi _1e0c1txw _1bsb1osq _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iMzG0", function(module, exports) {
    $parcel$export(module.exports, "BitbucketIcon", ()=>$0af9b15279bc8ff1$export$5fc1066e677788d4);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $0af9b15279bc8ff1$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
    };
    const $0af9b15279bc8ff1$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $0af9b15279bc8ff1$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("4qoT7", function(module, exports) {
    module.exports = new URL("github.d9710574.svg", import.meta.url).toString();
});
parcelRegister("58EYw", function(module, exports) {
    module.exports = new URL("gitlab.411423f1.svg", import.meta.url).toString();
});
parcelRegister("lee6Q", function(module, exports) {
    module.exports = new URL("jenkins.77ef5ed5.svg", import.meta.url).toString();
});
parcelRegister("bxTEa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f06570c467f701f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3f06570c467f701f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chartTitle: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.chart-title",
            "defaultMessage": "Weekly comparison"
        },
        titleHelpTooltip: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.title-help-tooltip",
            "defaultMessage": "A 12-week data feed that helps you compare your deployment frequencies to your batch size. This helps you analyze and evaluate the risk to your deployments."
        },
        noProviderTitle: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.no-provider-title",
            "defaultMessage": "Connect your source code management and CI/CD tools"
        },
        noProviderDescription: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.no-provider-description",
            "defaultMessage": "Based on the data from your tools, you'll see the comparison between batch sizes and production deployments, and much more."
        }
    });
});
parcelRegister("iitmC", function(module, exports) {
    $parcel$export(module.exports, "SelectionDetail", ()=>$a382008e3e771548$export$e4886591ccee2d0c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1dJ6S;
    var $koVbs;
    var $6RYAp;
    var $jD6af;
    const $a382008e3e771548$export$e4886591ccee2d0c = ({ weekCount: weekCount, weekStartDate: weekStartDate, wholePeriodAverage: wholePeriodAverage, prodDataState: prodDataState })=>{
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        const weekStartDateText = formatMessage((0, (0, parcelRequire("jD6af")).default).weekStartDate, {
            date: formatDate(weekStartDate, {
                day: 'numeric',
                month: 'short'
            })
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$WeekStartDate, null, weekStartDateText), (0, ($parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$DeploymentCount, null, weekCount), (0, ($parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$WeeklyProductionDeployments, null, formatMessage((0, (0, parcelRequire("jD6af")).default).weeklyProductionDeployment, {
            deploymentCount: weekCount
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6RYAp")).DeploymentsTrendSummary), {
            weekCount: weekCount,
            wholePeriodStatistic: wholePeriodAverage,
            prodDataState: prodDataState
        }));
    };
    const $a382008e3e771548$var$WeekStartDate = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "medium",
            as: "div"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$WeekStartDateComponent, props));
    const $a382008e3e771548$var$DeploymentCount = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xlarge",
            as: "div"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$DeploymentCountComponent, props));
    const $a382008e3e771548$var$WeeklyProductionDeployments = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xxsmall",
            as: "div"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$WeeklyProductionDeploymentsComponent, props));
    const $a382008e3e771548$var$WeekStartDateComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz10s3 _19pk1nde _otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $a382008e3e771548$var$DeploymentCountComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz10s3 _19pkze3t",
                __cmplp.className
            ])
        });
    });
    const $a382008e3e771548$var$WeeklyProductionDeploymentsComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazjjyb _19pkze3t _otyru2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jD6af", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$17669a6cebcc714b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $17669a6cebcc714b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        weeklyProductionDeployment: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.selection-detail.weekly-production-deployment",
            "defaultMessage": "Weekly production {deploymentCount, plural, one {deployment} other {deployments}}"
        },
        weekStartDate: {
            "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.selection-detail.week-start-date",
            "defaultMessage": "Week of {date}"
        }
    });
});
parcelRegister("6vgP1", function(module, exports) {
    $parcel$export(module.exports, "DeploymentModal", ()=>$6fd9816f90cd9c52$export$223e94cc0d2e1af8);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $l4U91;
    var $kBSee;
    var $j1sSt;
    var $gilhC;
    var $mEdYv;
    var $jKTxB;
    var $aJIPS;
    const $6fd9816f90cd9c52$export$223e94cc0d2e1af8 = ()=>{
        const [{ selectedWeekStart: selectedWeekStart }] = (0, (0, parcelRequire("gilhC")).useSelectedWeekStore)();
        const selectedDateRange = selectedWeekStart ? (0, (0, parcelRequire("kBSee")).getWeekRangeFromWeekStartDate)(selectedWeekStart) : null;
        const { loading: loading, error: error, data: data } = (0, (0, parcelRequire("jKTxB")).usePeriodBreakdownMetrics)(selectedDateRange);
        const [selectedDeploymentId, { setSelectedDeploymentId: setSelectedDeploymentId }] = (0, (0, parcelRequire("mEdYv")).useSelectedDeploymentId)();
        if (loading || error || data == null) return null;
        const selectedDeployment = data.perDeploymentMetrics.find((deployment)=>deployment.id === selectedDeploymentId);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j1sSt")).NonCriticalErrorBoundary), {
            eventLocation: "deploymentDetailsDialog",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, selectedDeployment && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l4U91")).default), {
            issueIds: selectedDeployment.issueIds,
            hasPermissionForAllIssues: (0, (0, parcelRequire("aJIPS")).hasPermissionForAllIssues)(selectedDeployment),
            deploymentDisplayName: selectedDeployment.displayName,
            deploymentUrl: selectedDeployment.url,
            onClose: ()=>{
                setSelectedDeploymentId(null);
            }
        })));
    };
});
parcelRegister("l4U91", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd4d34dade2db561$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aXhsp;
    var $AeWM3;
    var $7Dl4r;
    const $cd4d34dade2db561$var$DeploymentDetailsDialog = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AeWM3")).ApolloClientProvider), {
            client: (0, (0, parcelRequire("aXhsp")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Dl4r")).default), props));
    var $cd4d34dade2db561$export$2e2bcd8739ae039 = $cd4d34dade2db561$var$DeploymentDetailsDialog;
});
parcelRegister("aXhsp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d88f4e626c9babc0$export$2e2bcd8739ae039);
    var $9XE6b = parcelRequire("9XE6b");
    var $ivfDv;
    var $e3a3O;
    var $clSzL;
    var $h4ppL;
    var $JPsIz;
    var $lC4FX;
    var $cuKXc = parcelRequire("cuKXc");
    var $dJl1T;
    var $dxpxC;
    var $l0T7c;
    var $9g713;
    const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
    const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
    const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
    const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
    const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
    const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, (0, parcelRequire("ivfDv")).IntrospectionFragmentMatcher)({
        introspectionQueryResultData: ($parcel$interopDefault((0, parcelRequire("l0T7c"))))
    });
    const $d88f4e626c9babc0$var$errorLink = (0, (0, parcelRequire("h4ppL")).onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        (0, (0, parcelRequire("9g713")).reportErrors)({
            graphQLErrors: graphQLErrors,
            operation: operation
        });
        const errorAnalytics = (0, (0, parcelRequire("9g713")).getErrorAnalyticsContext)(operation.getContext());
        if (errorAnalytics !== undefined) return;
        if (graphQLErrors) {
            if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                    message: JSON.stringify(message),
                    path: JSON.stringify(path),
                    locations: JSON.stringify(locations)
                }));
            else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
                message: JSON.stringify(graphQLErrors)
            });
        }
        if (networkError) {
            const occuredNetworkErrorsBefore = (0, ($parcel$interopDefault($9XE6b)))(operation.getContext(), [
                $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
            ], 0);
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
            operation.setContext({
                [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
            });
        }
    });
    const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, (0, parcelRequire("lC4FX")).RetryLink)({
        delay: {
            initial: 300,
            max: 120000,
            jitter: true
        },
        attempts: (count, operation, networkError)=>{
            const retry = count < 5 && networkError && !networkError.statusCode;
            if (!retry) (0, (0, parcelRequire("9g713")).reportErrors)({
                networkError: networkError,
                operation: operation
            });
            return retry;
        }
    });
    class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, (0, parcelRequire("clSzL")).ApolloLink) {
        constructor(){
            super();
            this.inFlightRequestControllers = {};
        }
        request(operation, forward) {
            const context = operation.getContext();
            if (!context.cancelable) return forward(operation);
            const key = JSON.stringify([
                operation.operationName,
                operation.query
            ]);
            this.inFlightRequestControllers[key]?.abort();
            const abortController = new AbortController();
            operation.setContext({
                ...context,
                fetchOptions: {
                    signal: abortController.signal
                }
            });
            this.inFlightRequestControllers[key] = abortController;
            const cleanup = ()=>{
                if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
            };
            return new (0, (0, parcelRequire("clSzL")).Observable)((observer)=>{
                const subscription = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: (error)=>{
                        observer.error(error);
                        cleanup();
                    },
                    complete: observer.complete.bind(observer)
                });
                return ()=>{
                    subscription?.unsubscribe();
                    cleanup();
                };
            });
        }
    }
    const $d88f4e626c9babc0$var$cache = new (0, (0, parcelRequire("ivfDv")).InMemoryCache)({
        cacheRedirects: {
            Query: {
                ...(0, $cuKXc.fragmentCacheRedirect)()
            }
        },
        fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
        dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
    }).restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
    const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, (0, parcelRequire("e3a3O")).ApolloClient)({
            name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
            ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
            addTypename: true,
            link: (0, (0, parcelRequire("clSzL")).ApolloLink).from([
                $d88f4e626c9babc0$var$retryLinkWithFama,
                $d88f4e626c9babc0$var$errorLink,
                (0, (0, parcelRequire("dxpxC")).UFOLoggerLink),
                (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
                ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                    new $d88f4e626c9babc0$var$CancelableRequestLink()
                ] : [],
                new (0, (0, parcelRequire("JPsIz")).HttpLink)({
                    uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                    credentials: 'same-origin',
                    abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
                })
            ].filter(Boolean)),
            cache: $d88f4e626c9babc0$var$cache,
            connectToDevTools: false
        });
    var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
        clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
    };
});
parcelRegister("ivfDv", function(module, exports) {
    $parcel$export(module.exports, "IntrospectionFragmentMatcher", ()=>$d7874048ca668ecb$export$3b71c6b829c99d21);
    $parcel$export(module.exports, "defaultDataIdFromObject", ()=>$d7874048ca668ecb$export$bd03c5a9c99d6bce);
    $parcel$export(module.exports, "InMemoryCache", ()=>$d7874048ca668ecb$export$467265324939f47f);
    var $3VFsf;
    var $hzuXv;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $gLy2H = parcelRequire("gLy2H");
    var $1DiV8 = parcelRequire("1DiV8");
    var $d7874048ca668ecb$var$haveWarned = false;
    function $d7874048ca668ecb$var$shouldWarn() {
        var answer = !$d7874048ca668ecb$var$haveWarned;
        if (!(0, (0, parcelRequire("jojW6")).isTest)()) $d7874048ca668ecb$var$haveWarned = true;
        return answer;
    }
    var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
        function HeuristicFragmentMatcher() {}
        HeuristicFragmentMatcher.prototype.ensureReady = function() {
            return Promise.resolve();
        };
        HeuristicFragmentMatcher.prototype.canBypassInit = function() {
            return true;
        };
        HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            if (!__typename) {
                $d7874048ca668ecb$var$shouldWarn();
                return 'heuristic';
            }
            if (__typename === typeCondition) return true;
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        };
        return HeuristicFragmentMatcher;
    }();
    var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
        function IntrospectionFragmentMatcher(options) {
            if (options && options.introspectionQueryResultData) {
                this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
                this.isReady = true;
            } else this.isReady = false;
            this.match = this.match.bind(this);
        }
        IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            (0, $1DiV8.invariant)(this.isReady, 1);
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            (0, $1DiV8.invariant)(__typename, 2);
            if (__typename === typeCondition) return true;
            var implementingTypes = this.possibleTypesMap[typeCondition];
            if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
            return false;
        };
        IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
            var typeMap = {};
            introspectionResultData.__schema.types.forEach(function(type) {
                if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                    return implementingType.name;
                });
            });
            return typeMap;
        };
        return IntrospectionFragmentMatcher;
    }();
    var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$DepTrackingCache = function() {
        function DepTrackingCache(data) {
            var _this = this;
            if (data === void 0) data = Object.create(null);
            this.data = data;
            this.depend = (0, $gLy2H.wrap)(function(dataId) {
                return _this.data[dataId];
            }, {
                disposable: true,
                makeCacheKey: function(dataId) {
                    return dataId;
                }
            });
        }
        DepTrackingCache.prototype.toObject = function() {
            return this.data;
        };
        DepTrackingCache.prototype.get = function(dataId) {
            this.depend(dataId);
            return this.data[dataId];
        };
        DepTrackingCache.prototype.set = function(dataId, value) {
            var oldValue = this.data[dataId];
            if (value !== oldValue) {
                this.data[dataId] = value;
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.delete = function(dataId) {
            if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
                delete this.data[dataId];
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.clear = function() {
            this.replace(null);
        };
        DepTrackingCache.prototype.replace = function(newData) {
            var _this = this;
            if (newData) {
                Object.keys(newData).forEach(function(dataId) {
                    _this.set(dataId, newData[dataId]);
                });
                Object.keys(this.data).forEach(function(dataId) {
                    if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
                });
            } else Object.keys(this.data).forEach(function(dataId) {
                _this.delete(dataId);
            });
        };
        return DepTrackingCache;
    }();
    function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
        return new $d7874048ca668ecb$var$DepTrackingCache(seed);
    }
    var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
        function StoreReader(_a) {
            var _this = this;
            var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
            var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
            this.freezeResults = freezeResults;
            this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
                return executeStoreQuery.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                    if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            });
            this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
                return executeSelectionSet.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            });
            this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
                return executeSubSelectedArray.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var field = _a.field, array = _a.array, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            });
        }
        StoreReader.prototype.readQueryFromStore = function(options) {
            return this.diffQueryAgainstStore((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                returnPartialData: false
            })).result;
        };
        StoreReader.prototype.diffQueryAgainstStore = function(_a) {
            var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
            var queryDefinition = (0, (0, parcelRequire("jojW6")).getQueryDefinition)(query);
            variables = (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(queryDefinition), variables);
            var context = {
                store: store,
                dataIdFromObject: config && config.dataIdFromObject,
                cacheRedirects: config && config.cacheRedirects || {}
            };
            var execResult = this.executeStoreQuery({
                query: query,
                rootValue: {
                    type: 'id',
                    id: rootId,
                    generated: true,
                    typename: 'Query'
                },
                contextValue: context,
                variableValues: variables,
                fragmentMatcher: fragmentMatcherFunction
            });
            var hasMissingFields = execResult.missing && execResult.missing.length > 0;
            if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
                if (info.tolerable) return;
                throw new (0, $1DiV8.InvariantError)(8);
            });
            if (previousResult) {
                if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
            }
            return {
                result: execResult.result,
                complete: !hasMissingFields
            };
        };
        StoreReader.prototype.executeStoreQuery = function(_a) {
            var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
            var mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(query);
            var fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(query);
            var fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
            var execContext = {
                query: query,
                fragmentMap: fragmentMap,
                contextValue: contextValue,
                variableValues: variableValues,
                fragmentMatcher: fragmentMatcher
            };
            return this.executeSelectionSet({
                selectionSet: mainDefinition.selectionSet,
                rootValue: rootValue,
                execContext: execContext
            });
        };
        StoreReader.prototype.executeSelectionSet = function(_a) {
            var _this = this;
            var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
            var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
            var finalResult = {
                result: null
            };
            var objectsToMerge = [];
            var object = contextValue.store.get(rootValue.id);
            var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
            function handleMissing(result) {
                var _a;
                if (result.missing) {
                    finalResult.missing = finalResult.missing || [];
                    (_a = finalResult.missing).push.apply(_a, result.missing);
                }
                return result.result;
            }
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                    if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = fragmentMap[selection.name.value];
                        if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                    }
                    var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                    var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                    if (match) {
                        var fragmentExecResult = _this.executeSelectionSet({
                            selectionSet: fragment.selectionSet,
                            rootValue: rootValue,
                            execContext: execContext
                        });
                        if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fragmentExecResult), {
                            missing: fragmentExecResult.missing.map(function(info) {
                                return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, info), {
                                    tolerable: true
                                });
                            })
                        });
                        objectsToMerge.push(handleMissing(fragmentExecResult));
                    }
                }
            });
            finalResult.result = (0, (0, parcelRequire("jojW6")).mergeDeepArray)(objectsToMerge);
            this.freezeResults;
            return finalResult;
        };
        StoreReader.prototype.executeField = function(object, typename, field, execContext) {
            var variables = execContext.variableValues, contextValue = execContext.contextValue;
            var fieldName = field.name.value;
            var args = (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables);
            var info = {
                resultKey: (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field),
                directives: (0, (0, parcelRequire("jojW6")).getDirectiveInfoFromField)(field, variables)
            };
            var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
            if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext
            }));
            if (!field.selectionSet) {
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
                this.freezeResults;
                return readStoreResult;
            }
            if (readStoreResult.result == null) return readStoreResult;
            return this.combineExecResults(readStoreResult, this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: readStoreResult.result,
                execContext: execContext
            }));
        };
        StoreReader.prototype.combineExecResults = function() {
            var execResults = [];
            for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
            var missing;
            execResults.forEach(function(execResult) {
                if (execResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, execResult.missing);
                }
            });
            return {
                result: execResults.pop().result,
                missing: missing
            };
        };
        StoreReader.prototype.executeSubSelectedArray = function(_a) {
            var _this = this;
            var field = _a.field, array = _a.array, execContext = _a.execContext;
            var missing;
            function handleMissing(childResult) {
                if (childResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, childResult.missing);
                }
                return childResult.result;
            }
            array = array.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext
                }));
                if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext
                }));
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
                return item;
            });
            this.freezeResults;
            return {
                result: array,
                missing: missing
            };
        };
        return StoreReader;
    }();
    function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
        if (!field.selectionSet && (0, (0, parcelRequire("jojW6")).isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
    }
    function $d7874048ca668ecb$var$defaultFragmentMatcher() {
        return true;
    }
    function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
        (0, $1DiV8.invariant)((0, (0, parcelRequire("jojW6")).isIdValue)(idValue), 11);
    }
    function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
        var resultKey = _a.resultKey, directives = _a.directives;
        var storeKeyName = fieldName;
        if (args || directives) storeKeyName = (0, (0, parcelRequire("jojW6")).getStoreKeyName)(storeKeyName, args, directives);
        var fieldValue = void 0;
        if (object) {
            fieldValue = object[storeKeyName];
            if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
                var type = context.cacheRedirects[typename];
                if (type) {
                    var resolver = type[fieldName];
                    if (resolver) fieldValue = resolver(object, args, {
                        getCacheKey: function(storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && (0, (0, parcelRequire("jojW6")).toIdValue)({
                                id: id,
                                typename: storeObj.__typename
                            });
                        }
                    });
                }
            }
        }
        if (typeof fieldValue === 'undefined') return {
            result: fieldValue,
            missing: [
                {
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false
                }
            ]
        };
        if ((0, (0, parcelRequire("jojW6")).isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
        return {
            result: fieldValue
        };
    }
    var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
        function ObjectCache(data) {
            if (data === void 0) data = Object.create(null);
            this.data = data;
        }
        ObjectCache.prototype.toObject = function() {
            return this.data;
        };
        ObjectCache.prototype.get = function(dataId) {
            return this.data[dataId];
        };
        ObjectCache.prototype.set = function(dataId, value) {
            this.data[dataId] = value;
        };
        ObjectCache.prototype.delete = function(dataId) {
            this.data[dataId] = void 0;
        };
        ObjectCache.prototype.clear = function() {
            this.data = Object.create(null);
        };
        ObjectCache.prototype.replace = function(newData) {
            this.data = newData || Object.create(null);
        };
        return ObjectCache;
    }();
    function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
        return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
    }
    var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(WriteError, _super);
        function WriteError() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'WriteError';
            return _this;
        }
        return WriteError;
    }(Error);
    function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
        var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
        enhancedError.message += '\n' + error.message;
        enhancedError.stack = error.stack;
        return enhancedError;
    }
    var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
        function StoreWriter() {}
        StoreWriter.prototype.writeQueryToStore = function(_a) {
            var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            return this.writeResultToStore({
                dataId: 'ROOT_QUERY',
                result: result,
                document: query,
                store: store,
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
        };
        StoreWriter.prototype.writeResultToStore = function(_a) {
            var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            var operationDefinition = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(document);
            try {
                return this.writeSelectionSetToStore({
                    result: result,
                    dataId: dataId,
                    selectionSet: operationDefinition.selectionSet,
                    context: {
                        store: store,
                        processedData: {},
                        variables: (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(operationDefinition), variables),
                        dataIdFromObject: dataIdFromObject,
                        fragmentMap: (0, (0, parcelRequire("jojW6")).createFragmentMap)((0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document)),
                        fragmentMatcherFunction: fragmentMatcherFunction
                    }
                });
            } catch (e) {
                throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
            }
        };
        StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
            var _this = this;
            var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
            var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var resultFieldKey = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection);
                    var value = result[resultFieldKey];
                    if (typeof value !== 'undefined') _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context
                    });
                    else {
                        var isDefered = false;
                        var isClient = false;
                        if (selection.directives && selection.directives.length) {
                            isDefered = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'defer';
                            });
                            isClient = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'client';
                            });
                        }
                        !isDefered && !isClient && context.fragmentMatcherFunction;
                    }
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = (fragmentMap || {})[selection.name.value];
                        (0, $1DiV8.invariant)(fragment, 3);
                    }
                    var matches = true;
                    if (context.fragmentMatcherFunction && fragment.typeCondition) {
                        var id = dataId || 'self';
                        var idValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                            id: id,
                            typename: undefined
                        });
                        var fakeContext = {
                            store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                            cacheRedirects: {}
                        };
                        var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                        !(0, (0, parcelRequire("jojW6")).isProduction)() && match;
                        matches = !!match;
                    }
                    if (matches) _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context
                    });
                }
            });
            return store;
        };
        StoreWriter.prototype.writeFieldToStore = function(_a) {
            var _b;
            var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
            var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
            var storeValue;
            var storeObject;
            var storeFieldName = (0, (0, parcelRequire("jojW6")).storeKeyNameFromField)(field, variables);
            if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
                type: 'json',
                json: value
            } : value;
            else if (Array.isArray(value)) {
                var generatedId = dataId + "." + storeFieldName;
                storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
            } else {
                var valueDataId = dataId + "." + storeFieldName;
                var generated = true;
                if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
                if (dataIdFromObject) {
                    var semanticId = dataIdFromObject(value);
                    (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                    if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                        valueDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context
                });
                var typename = value.__typename;
                storeValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: valueDataId,
                    typename: typename
                }, generated);
                storeObject = store.get(dataId);
                var escapedId = storeObject && storeObject[storeFieldName];
                if (escapedId !== storeValue && (0, (0, parcelRequire("jojW6")).isIdValue)(escapedId)) {
                    var hadTypename = escapedId.typename !== undefined;
                    var hasTypename = typename !== undefined;
                    var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                    (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                    (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                    if (escapedId.generated) {
                        if (typenameChanged) {
                            if (!generated) store.delete(escapedId.id);
                        } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
            storeObject = store.get(dataId);
            if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
        };
        StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
            var _this = this;
            return value.map(function(item, index) {
                if (item === null) return null;
                var itemDataId = generatedId + "." + index;
                if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
                var generated = true;
                if (context.dataIdFromObject) {
                    var semanticId = context.dataIdFromObject(item);
                    if (semanticId) {
                        itemDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context
                });
                return (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: itemDataId,
                    typename: item.__typename
                }, generated);
            });
        };
        return StoreWriter;
    }();
    function $d7874048ca668ecb$var$isGeneratedId(id) {
        return id[0] === '$';
    }
    function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
        if (generatedKey === realKey) return false;
        var generated = cache.get(generatedKey);
        var real = cache.get(realKey);
        var madeChanges = false;
        Object.keys(generated).forEach(function(key) {
            var value = generated[key];
            var realValue = real[key];
            if ((0, (0, parcelRequire("jojW6")).isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, (0, parcelRequire("jojW6")).isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
        });
        cache.delete(generatedKey);
        var newRealValue = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, generated), real);
        if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
        cache.set(realKey, newRealValue);
        return true;
    }
    function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
        if (!processedData) return false;
        if (processedData[dataId]) {
            if (processedData[dataId].indexOf(field) >= 0) return true;
            else processedData[dataId].push(field);
        } else processedData[dataId] = [
            field
        ];
        return false;
    }
    var $d7874048ca668ecb$var$defaultConfig = {
        fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
        dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
        addTypename: true,
        resultCaching: true,
        freezeResults: false
    };
    function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
        if (result.__typename) {
            if (result.id !== undefined) return result.__typename + ":" + result.id;
            if (result._id !== undefined) return result.__typename + ":" + result._id;
        }
        return null;
    }
    var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(OptimisticCacheLayer, _super);
        function OptimisticCacheLayer(optimisticId, parent, transaction) {
            var _this = _super.call(this, Object.create(null)) || this;
            _this.optimisticId = optimisticId;
            _this.parent = parent;
            _this.transaction = transaction;
            return _this;
        }
        OptimisticCacheLayer.prototype.toObject = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.parent.toObject()), this.data);
        };
        OptimisticCacheLayer.prototype.get = function(dataId) {
            return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
        };
        return OptimisticCacheLayer;
    }($d7874048ca668ecb$export$ee7258b8691956a3);
    var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InMemoryCache, _super);
        function InMemoryCache(config) {
            if (config === void 0) config = {};
            var _this = _super.call(this) || this;
            _this.watches = new Set();
            _this.typenameDocumentCache = new Map();
            _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap));
            _this.silenceBroadcast = false;
            _this.config = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
            if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
            if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
            _this.addTypename = !!_this.config.addTypename;
            _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
            _this.optimisticData = _this.data;
            _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
            _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
                cacheKeyRoot: _this.cacheKeyRoot,
                freezeResults: config.freezeResults
            });
            var cache = _this;
            var maybeBroadcastWatch = cache.maybeBroadcastWatch;
            _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
                return maybeBroadcastWatch.call(_this, c);
            }, {
                makeCacheKey: function(c) {
                    if (c.optimistic) return;
                    if (c.previousResult) return;
                    if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            });
            return _this;
        }
        InMemoryCache.prototype.restore = function(data) {
            if (data) this.data.replace(data);
            return this;
        };
        InMemoryCache.prototype.extract = function(optimistic) {
            if (optimistic === void 0) optimistic = false;
            return (optimistic ? this.optimisticData : this.data).toObject();
        };
        InMemoryCache.prototype.read = function(options) {
            if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.readQueryFromStore({
                store: options.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(options.query),
                variables: options.variables,
                rootId: options.rootId,
                fragmentMatcherFunction: fragmentMatcherFunction,
                previousResult: options.previousResult,
                config: this.config
            }) || null;
        };
        InMemoryCache.prototype.write = function(write) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            this.storeWriter.writeResultToStore({
                dataId: write.dataId,
                result: write.result,
                variables: write.variables,
                document: this.transformDocument(write.query),
                store: this.data,
                dataIdFromObject: this.config.dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
            this.broadcastWatches();
        };
        InMemoryCache.prototype.diff = function(query) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.diffQueryAgainstStore({
                store: query.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(query.query),
                variables: query.variables,
                returnPartialData: query.returnPartialData,
                previousResult: query.previousResult,
                fragmentMatcherFunction: fragmentMatcherFunction,
                config: this.config
            });
        };
        InMemoryCache.prototype.watch = function(watch) {
            var _this = this;
            this.watches.add(watch);
            return function() {
                _this.watches.delete(watch);
            };
        };
        InMemoryCache.prototype.evict = function(query) {
            throw new (0, $1DiV8.InvariantError)(7);
        };
        InMemoryCache.prototype.reset = function() {
            this.data.clear();
            this.broadcastWatches();
            return Promise.resolve();
        };
        InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
            var toReapply = [];
            var removedCount = 0;
            var layer = this.optimisticData;
            while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
                if (layer.optimisticId === idToRemove) ++removedCount;
                else toReapply.push(layer);
                layer = layer.parent;
            }
            if (removedCount > 0) {
                this.optimisticData = layer;
                while(toReapply.length > 0){
                    var layer_1 = toReapply.pop();
                    this.performTransaction(layer_1.transaction, layer_1.optimisticId);
                }
                this.broadcastWatches();
            }
        };
        InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
            var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
            this.silenceBroadcast = true;
            if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
            try {
                transaction(this);
            } finally{
                this.silenceBroadcast = silenceBroadcast;
                this.data = data;
            }
            this.broadcastWatches();
        };
        InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
            return this.performTransaction(transaction, id);
        };
        InMemoryCache.prototype.transformDocument = function(document) {
            if (this.addTypename) {
                var result = this.typenameDocumentCache.get(document);
                if (!result) {
                    result = (0, (0, parcelRequire("jojW6")).addTypenameToDocument)(document);
                    this.typenameDocumentCache.set(document, result);
                    this.typenameDocumentCache.set(result, result);
                }
                return result;
            }
            return document;
        };
        InMemoryCache.prototype.broadcastWatches = function() {
            var _this = this;
            if (!this.silenceBroadcast) this.watches.forEach(function(c) {
                return _this.maybeBroadcastWatch(c);
            });
        };
        InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
            c.callback(this.diff({
                query: c.query,
                variables: c.variables,
                previousResult: c.previousResult && c.previousResult(),
                optimistic: c.optimistic
            }));
        };
        return InMemoryCache;
    }((0, (0, parcelRequire("hzuXv")).ApolloCache));
});
parcelRegister("hzuXv", function(module, exports) {
    $parcel$export(module.exports, "ApolloCache", ()=>$ccadb856bf057658$export$5fc74f25506aa9c);
    var $jojW6;
    function $ccadb856bf057658$var$queryFromPojo(obj) {
        var op = {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                op
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
        var frag = {
            kind: 'FragmentDefinition',
            typeCondition: {
                kind: 'NamedType',
                name: {
                    kind: 'Name',
                    value: typename || '__FakeType'
                }
            },
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                frag
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$selectionSetFromObj(obj) {
        if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
        if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
        var selections = [];
        Object.keys(obj).forEach(function(key) {
            var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
            var field = {
                kind: 'Field',
                name: {
                    kind: 'Name',
                    value: key
                },
                selectionSet: nestedSelSet || undefined
            };
            selections.push(field);
        });
        var selectionSet = {
            kind: 'SelectionSet',
            selections: selections
        };
        return selectionSet;
    }
    var $ccadb856bf057658$var$justTypenameQuery = {
        kind: 'Document',
        definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                name: null,
                variableDefinitions: null,
                directives: [],
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'Field',
                            alias: null,
                            name: {
                                kind: 'Name',
                                value: '__typename'
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: null
                        }
                    ]
                }
            }
        ]
    };
    var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
        function ApolloCache() {}
        ApolloCache.prototype.transformDocument = function(document) {
            return document;
        };
        ApolloCache.prototype.transformForLink = function(document) {
            return document;
        };
        ApolloCache.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: options.query,
                variables: options.variables,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName),
                variables: options.variables,
                rootId: options.id,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.writeQuery = function(options) {
            this.write({
                dataId: 'ROOT_QUERY',
                result: options.data,
                query: options.query,
                variables: options.variables
            });
        };
        ApolloCache.prototype.writeFragment = function(options) {
            this.write({
                dataId: options.id,
                result: options.data,
                variables: options.variables,
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName)
            });
        };
        ApolloCache.prototype.writeData = function(_a) {
            var id = _a.id, data = _a.data;
            if (typeof id !== 'undefined') {
                var typenameResult = null;
                try {
                    typenameResult = this.read({
                        rootId: id,
                        optimistic: false,
                        query: $ccadb856bf057658$var$justTypenameQuery
                    });
                } catch (e) {}
                var __typename = typenameResult && typenameResult.__typename || '__ClientData';
                var dataToWrite = Object.assign({
                    __typename: __typename
                }, data);
                this.writeFragment({
                    id: id,
                    fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                    data: dataToWrite
                });
            } else this.writeQuery({
                query: $ccadb856bf057658$var$queryFromPojo(data),
                data: data
            });
        };
        return ApolloCache;
    }();
    var $ccadb856bf057658$export$94affb487e701bf2;
    $ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});
});
parcelRegister("gLy2H", function(module, exports) {
    $parcel$export(module.exports, "KeyTrie", ()=>$c34b71496108423e$export$6bd8d8299be3ac82);
    $parcel$export(module.exports, "wrap", ()=>$c34b71496108423e$export$4997ffc0176396a6);
    var $jFbNy = parcelRequire("jFbNy");
    function $c34b71496108423e$var$defaultDispose() {}
    var $c34b71496108423e$var$Cache = function() {
        function Cache(max, dispose) {
            if (max === void 0) max = Infinity;
            if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
            this.max = max;
            this.dispose = dispose;
            this.map = new Map();
            this.newest = null;
            this.oldest = null;
        }
        Cache.prototype.has = function(key) {
            return this.map.has(key);
        };
        Cache.prototype.get = function(key) {
            var entry = this.getEntry(key);
            return entry && entry.value;
        };
        Cache.prototype.getEntry = function(key) {
            var entry = this.map.get(key);
            if (entry && entry !== this.newest) {
                var older = entry.older, newer = entry.newer;
                if (newer) newer.older = older;
                if (older) older.newer = newer;
                entry.older = this.newest;
                entry.older.newer = entry;
                entry.newer = null;
                this.newest = entry;
                if (entry === this.oldest) this.oldest = newer;
            }
            return entry;
        };
        Cache.prototype.set = function(key, value) {
            var entry = this.getEntry(key);
            if (entry) return entry.value = value;
            entry = {
                key: key,
                value: value,
                newer: null,
                older: this.newest
            };
            if (this.newest) this.newest.newer = entry;
            this.newest = entry;
            this.oldest = this.oldest || entry;
            this.map.set(key, entry);
            return entry.value;
        };
        Cache.prototype.clean = function() {
            while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
        };
        Cache.prototype.delete = function(key) {
            var entry = this.map.get(key);
            if (entry) {
                if (entry === this.newest) this.newest = entry.older;
                if (entry === this.oldest) this.oldest = entry.newer;
                if (entry.newer) entry.newer.older = entry.older;
                if (entry.older) entry.older.newer = entry.newer;
                this.map.delete(key);
                this.dispose(entry.value, key);
                return true;
            }
            return false;
        };
        return Cache;
    }();
    var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
    var $c34b71496108423e$var$reusableEmptyArray = [];
    var $c34b71496108423e$var$emptySetPool = [];
    var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
    function $c34b71496108423e$var$assert(condition, optionalMessage) {
        if (!condition) throw new Error(optionalMessage || "assertion failure");
    }
    function $c34b71496108423e$var$valueIs(a, b) {
        var len = a.length;
        return (len > 0 && len === b.length && a[len - 1] === b[len - 1]);
    }
    function $c34b71496108423e$var$valueGet(value) {
        switch(value.length){
            case 0:
                throw new Error("unknown value");
            case 1:
                return value[0];
            case 2:
                throw value[1];
        }
    }
    function $c34b71496108423e$var$valueCopy(value) {
        return value.slice(0);
    }
    var $c34b71496108423e$var$Entry = function() {
        function Entry(fn, args) {
            this.fn = fn;
            this.args = args;
            this.parents = new Set();
            this.childValues = new Map();
            this.dirtyChildren = null;
            this.dirty = true;
            this.recomputing = false;
            this.value = [];
            ++Entry.count;
        }
        Entry.prototype.recompute = function() {
            $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
            if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) return void 0;
            return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
        };
        Entry.prototype.setDirty = function() {
            if (this.dirty) return;
            this.dirty = true;
            this.value.length = 0;
            $c34b71496108423e$var$reportDirty(this);
            $c34b71496108423e$var$maybeUnsubscribe(this);
        };
        Entry.prototype.dispose = function() {
            var _this = this;
            $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
            $c34b71496108423e$var$maybeUnsubscribe(this);
            this.parents.forEach(function(parent) {
                parent.setDirty();
                $c34b71496108423e$var$forgetChild(parent, _this);
            });
        };
        Entry.count = 0;
        return Entry;
    }();
    function $c34b71496108423e$var$rememberParent(child) {
        var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
        if (parent) {
            child.parents.add(parent);
            if (!parent.childValues.has(child)) parent.childValues.set(child, []);
            if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
            else $c34b71496108423e$var$reportCleanChild(parent, child);
            return parent;
        }
    }
    function $c34b71496108423e$var$reallyRecompute(entry) {
        var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
        $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
            entry
        ]);
        if ($c34b71496108423e$var$maybeSubscribe(entry)) $c34b71496108423e$var$setClean(entry);
        originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
        return $c34b71496108423e$var$valueGet(entry.value);
    }
    function $c34b71496108423e$var$recomputeNewValue(entry) {
        entry.recomputing = true;
        entry.value.length = 0;
        try {
            entry.value[0] = entry.fn.apply(null, entry.args);
        } catch (e) {
            entry.value[1] = e;
        }
        entry.recomputing = false;
    }
    function $c34b71496108423e$var$mightBeDirty(entry) {
        return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
    }
    function $c34b71496108423e$var$setClean(entry) {
        entry.dirty = false;
        if ($c34b71496108423e$var$mightBeDirty(entry)) return;
        $c34b71496108423e$var$reportClean(entry);
    }
    function $c34b71496108423e$var$reportDirty(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportDirtyChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportClean(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportCleanChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportDirtyChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
        if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
        else if (parent.dirtyChildren.has(child)) return;
        parent.dirtyChildren.add(child);
        $c34b71496108423e$var$reportDirty(parent);
    }
    function $c34b71496108423e$var$reportCleanChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
        var childValue = parent.childValues.get(child);
        if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
        else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
        $c34b71496108423e$var$removeDirtyChild(parent, child);
        if ($c34b71496108423e$var$mightBeDirty(parent)) return;
        $c34b71496108423e$var$reportClean(parent);
    }
    function $c34b71496108423e$var$removeDirtyChild(parent, child) {
        var dc = parent.dirtyChildren;
        if (dc) {
            dc.delete(child);
            if (dc.size === 0) {
                if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
                parent.dirtyChildren = null;
            }
        }
    }
    function $c34b71496108423e$var$maybeReportOrphan(entry) {
        return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
    }
    function $c34b71496108423e$var$forgetChildren(parent) {
        var children = $c34b71496108423e$var$reusableEmptyArray;
        if (parent.childValues.size > 0) {
            children = [];
            parent.childValues.forEach(function(_value, child) {
                $c34b71496108423e$var$forgetChild(parent, child);
                children.push(child);
            });
        }
        $c34b71496108423e$var$assert(parent.dirtyChildren === null);
        return children;
    }
    function $c34b71496108423e$var$forgetChild(parent, child) {
        child.parents.delete(parent);
        parent.childValues.delete(child);
        $c34b71496108423e$var$removeDirtyChild(parent, child);
    }
    function $c34b71496108423e$var$maybeSubscribe(entry) {
        if (typeof entry.subscribe === "function") try {
            $c34b71496108423e$var$maybeUnsubscribe(entry);
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        } catch (e) {
            entry.setDirty();
            return false;
        }
        return true;
    }
    function $c34b71496108423e$var$maybeUnsubscribe(entry) {
        var unsubscribe = entry.unsubscribe;
        if (typeof unsubscribe === "function") {
            entry.unsubscribe = void 0;
            unsubscribe();
        }
    }
    var $c34b71496108423e$export$6bd8d8299be3ac82 = function() {
        function KeyTrie(weakness) {
            this.weakness = weakness;
        }
        KeyTrie.prototype.lookup = function() {
            var array = [];
            for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
            return this.lookupArray(array);
        };
        KeyTrie.prototype.lookupArray = function(array) {
            var node = this;
            array.forEach(function(key) {
                return node = node.getChildTrie(key);
            });
            return node.data || (node.data = Object.create(null));
        };
        KeyTrie.prototype.getChildTrie = function(key) {
            var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
            var child = map.get(key);
            if (!child) map.set(key, child = new KeyTrie(this.weakness));
            return child;
        };
        return KeyTrie;
    }();
    function $c34b71496108423e$var$isObjRef(value) {
        switch(typeof value){
            case "object":
                if (value === null) break;
            case "function":
                return true;
        }
        return false;
    }
    var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
    function $c34b71496108423e$export$cd3144f8dd136006() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $c34b71496108423e$var$keyTrie.lookupArray(args);
    }
    var $c34b71496108423e$var$caches = new Set();
    function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
        if (options === void 0) options = Object.create(null);
        var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
            return entry.dispose();
        });
        var disposable = !!options.disposable;
        var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
        function optimistic() {
            if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) return void 0;
            var key = makeCacheKey.apply(null, arguments);
            if (key === void 0) return originalFunction.apply(null, arguments);
            var args = Array.prototype.slice.call(arguments);
            var entry = cache.get(key);
            if (entry) entry.args = args;
            else {
                entry = new $c34b71496108423e$var$Entry(originalFunction, args);
                cache.set(key, entry);
                entry.subscribe = options.subscribe;
                if (disposable) entry.reportOrphan = function() {
                    return cache.delete(key);
                };
            }
            var value = entry.recompute();
            cache.set(key, entry);
            $c34b71496108423e$var$caches.add(cache);
            if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
                $c34b71496108423e$var$caches.forEach(function(cache) {
                    return cache.clean();
                });
                $c34b71496108423e$var$caches.clear();
            }
            return disposable ? void 0 : value;
        }
        optimistic.dirty = function() {
            var key = makeCacheKey.apply(null, arguments);
            var child = key !== void 0 && cache.get(key);
            if (child) child.setDirty();
        };
        return optimistic;
    }
});
parcelRegister("jFbNy", function(module, exports) {
    $parcel$export(module.exports, "Slot", ()=>$e50aff8f879ebe36$export$8c6ed5c666ac1360);
    var $e50aff8f879ebe36$var$currentContext = null;
    var $e50aff8f879ebe36$var$MISSING_VALUE = {};
    var $e50aff8f879ebe36$var$idCounter = 1;
    var $e50aff8f879ebe36$var$makeSlotClass = function() {
        return function() {
            function Slot() {
                this.id = [
                    "slot",
                    $e50aff8f879ebe36$var$idCounter++,
                    Date.now(),
                    Math.random().toString(36).slice(2)
                ].join(":");
            }
            Slot.prototype.hasValue = function() {
                for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)if (this.id in context_1.slots) {
                    var value = context_1.slots[this.id];
                    if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                    if (context_1 !== $e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                    return true;
                }
                if ($e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
                return false;
            };
            Slot.prototype.getValue = function() {
                if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
            };
            Slot.prototype.withValue = function(value, callback, args, thisArg) {
                var _a;
                var slots = (_a = {
                    __proto__: null
                }, _a[this.id] = value, _a);
                var parent = $e50aff8f879ebe36$var$currentContext;
                $e50aff8f879ebe36$var$currentContext = {
                    parent: parent,
                    slots: slots
                };
                try {
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = parent;
                }
            };
            Slot.bind = function(callback) {
                var context = $e50aff8f879ebe36$var$currentContext;
                return function() {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = context;
                        return callback.apply(this, arguments);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                };
            };
            Slot.noContext = function(callback, args, thisArg) {
                if ($e50aff8f879ebe36$var$currentContext) {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = null;
                        return callback.apply(thisArg, args);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                } else return callback.apply(thisArg, args);
            };
            return Slot;
        }();
    };
    var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
    var $e50aff8f879ebe36$var$host = Array;
    var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
        var Slot = $e50aff8f879ebe36$var$makeSlotClass();
        try {
            Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
                value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
                enumerable: false,
                writable: false,
                configurable: false
            });
        } finally{
            return Slot;
        }
    }();
    var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
    function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
        return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
    }
    function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
        return function() {
            var gen = genFn.apply(this, arguments);
            var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
            var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
            return new Promise(function(resolve, reject) {
                function invoke(method, argument) {
                    try {
                        var result = method.call(gen, argument);
                    } catch (error) {
                        return reject(error);
                    }
                    var next = result.done ? resolve : invokeNext;
                    if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                    else next(result.value);
                }
                var invokeNext = function(value) {
                    return invoke(boundNext, value);
                };
                var invokeThrow = function(error) {
                    return invoke(boundThrow, error);
                };
                invokeNext();
            });
        };
    }
    function $e50aff8f879ebe36$var$isPromiseLike(value) {
        return value && typeof value.then === "function";
    }
    var $e50aff8f879ebe36$var$wrappedFibers = [];
    function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
        if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
            var wrap = function(obj, method) {
                var fn = obj[method];
                obj[method] = function() {
                    return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
                };
            };
            wrap(Fiber, "yield");
            wrap(Fiber.prototype, "run");
            wrap(Fiber.prototype, "throwInto");
            $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
        }
        return Fiber;
    }
});
parcelRegister("h4ppL", function(module, exports) {
    $parcel$export(module.exports, "onError", ()=>$c6d6862dd229df53$export$2288787135a8f66e);
    var $3VFsf;
    var $clSzL;
    function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation, forward) {
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                var sub;
                var retriedSub;
                var retriedResult;
                try {
                    sub = forward(operation).subscribe({
                        next: function(result) {
                            if (result.errors) {
                                retriedResult = errorHandler({
                                    graphQLErrors: result.errors,
                                    response: result,
                                    operation: operation,
                                    forward: forward
                                });
                                if (retriedResult) {
                                    retriedSub = retriedResult.subscribe({
                                        next: observer.next.bind(observer),
                                        error: observer.error.bind(observer),
                                        complete: observer.complete.bind(observer)
                                    });
                                    return;
                                }
                            }
                            observer.next(result);
                        },
                        error: function(networkError) {
                            retriedResult = errorHandler({
                                operation: operation,
                                networkError: networkError,
                                graphQLErrors: networkError && networkError.result && networkError.result.errors,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                            observer.error(networkError);
                        },
                        complete: function() {
                            if (!retriedResult) observer.complete.bind(observer)();
                        }
                    });
                } catch (e) {
                    errorHandler({
                        networkError: e,
                        operation: operation,
                        forward: forward
                    });
                    observer.error(e);
                }
                return function() {
                    if (sub) sub.unsubscribe();
                    if (retriedSub) sub.unsubscribe();
                };
            });
        });
    }
    var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ErrorLink, _super);
        function ErrorLink(errorHandler) {
            var _this = _super.call(this) || this;
            _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
            return _this;
        }
        ErrorLink.prototype.request = function(operation, forward) {
            return this.link.request(operation, forward);
        };
        return ErrorLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("JPsIz", function(module, exports) {
    $parcel$export(module.exports, "HttpLink", ()=>$089c1f6736cf7295$export$f4bbf1aec241cc1);
    var $3VFsf;
    var $clSzL;
    var $f0Elb;
    var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
        if (linkOptions === void 0) linkOptions = {};
        var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, (0, parcelRequire("3VFsf")).__rest)(linkOptions, [
            "uri",
            "fetch",
            "includeExtensions",
            "useGETForQueries",
            "abortErrorDoesNotCauseError"
        ]);
        (0, (0, parcelRequire("f0Elb")).checkFetcher)(fetcher);
        if (!fetcher) fetcher = fetch;
        var linkConfig = {
            http: {
                includeExtensions: includeExtensions
            },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
        };
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation) {
            var chosenURI = (0, (0, parcelRequire("f0Elb")).selectURI)(operation, uri);
            var context = operation.getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
                if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
            }
            var contextHeaders = (0, (0, parcelRequire("3VFsf")).__assign)({}, clientAwarenessHeaders, context.headers);
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: contextHeaders
            };
            var _b = (0, (0, parcelRequire("f0Elb")).selectHttpOptionsAndBody)(operation, (0, (0, parcelRequire("f0Elb")).fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
            var controller;
            if (!options.signal) {
                var _c = (0, (0, parcelRequire("f0Elb")).createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
                controller = _controller;
                if (controller) options.signal = signal;
            }
            var definitionIsMutation = function(d) {
                return d.kind === 'OperationDefinition' && d.operation === 'mutation';
            };
            if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
            if (options.method === 'GET') {
                var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
                if (parseError) return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
                chosenURI = newURI;
            } else try {
                options.body = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body, 'Payload');
            } catch (parseError) {
                return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
            }
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                fetcher(chosenURI, options).then(function(response) {
                    operation.setContext({
                        response: response
                    });
                    return response;
                }).then((0, (0, parcelRequire("f0Elb")).parseAndCheckHttpResponse)(operation)).then(function(result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                }).catch(function(err) {
                    if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                    if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                    observer.error(err);
                });
                return function() {
                    if (controller) controller.abort();
                };
            });
        });
    };
    function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
        var queryParams = [];
        var addQueryParam = function(key, value) {
            queryParams.push(key + "=" + encodeURIComponent(value));
        };
        if ('query' in body) addQueryParam('query', body.query);
        if (body.operationName) addQueryParam('operationName', body.operationName);
        if (body.variables) {
            var serializedVariables = void 0;
            try {
                serializedVariables = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.variables, 'Variables map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('variables', serializedVariables);
        }
        if (body.extensions) {
            var serializedExtensions = void 0;
            try {
                serializedExtensions = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.extensions, 'Extensions map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('extensions', serializedExtensions);
        }
        var fragment = '', preFragment = chosenURI;
        var fragmentStart = chosenURI.indexOf('#');
        if (fragmentStart !== -1) {
            fragment = chosenURI.substr(fragmentStart);
            preFragment = chosenURI.substr(0, fragmentStart);
        }
        var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
        var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
        return {
            newURI: newURI
        };
    }
    var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(HttpLink, _super);
        function HttpLink(opts) {
            return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
        }
        return HttpLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("f0Elb", function(module, exports) {
    $parcel$export(module.exports, "fallbackHttpConfig", ()=>$aed625edf13c57eb$export$dd86f00dc866e75d);
    $parcel$export(module.exports, "parseAndCheckHttpResponse", ()=>$aed625edf13c57eb$export$d4051215bea0639f);
    $parcel$export(module.exports, "checkFetcher", ()=>$aed625edf13c57eb$export$8423f0cd3773115e);
    $parcel$export(module.exports, "createSignalIfSupported", ()=>$aed625edf13c57eb$export$f5853cd1fc39aea6);
    $parcel$export(module.exports, "selectHttpOptionsAndBody", ()=>$aed625edf13c57eb$export$a00ebfd5f1eebfb1);
    $parcel$export(module.exports, "serializeFetchParameter", ()=>$aed625edf13c57eb$export$5f8e80ac52052e28);
    $parcel$export(module.exports, "selectURI", ()=>$aed625edf13c57eb$export$63ccc2571850f81a);
    var $3VFsf;
    var $1c8Um;
    var $1DiV8 = parcelRequire("1DiV8");
    var $aed625edf13c57eb$var$defaultHttpOptions = {
        includeQuery: true,
        includeExtensions: false
    };
    var $aed625edf13c57eb$var$defaultHeaders = {
        accept: '*/*',
        'content-type': 'application/json'
    };
    var $aed625edf13c57eb$var$defaultOptions = {
        method: 'POST'
    };
    var $aed625edf13c57eb$export$dd86f00dc866e75d = {
        http: $aed625edf13c57eb$var$defaultHttpOptions,
        headers: $aed625edf13c57eb$var$defaultHeaders,
        options: $aed625edf13c57eb$var$defaultOptions
    };
    var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
        var error = new Error(message);
        error.name = 'ServerError';
        error.response = response;
        error.statusCode = response.status;
        error.result = result;
        throw error;
    };
    var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
        return function(response) {
            return response.text().then(function(bodyText) {
                try {
                    return JSON.parse(bodyText);
                } catch (err) {
                    var parseError = err;
                    parseError.name = 'ServerParseError';
                    parseError.response = response;
                    parseError.statusCode = response.status;
                    parseError.bodyText = bodyText;
                    return Promise.reject(parseError);
                }
            }).then(function(result) {
                if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
                if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                    return op.operationName;
                }) : operations.operationName) + "'.");
                return result;
            });
        };
    };
    var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
        if (!fetcher && typeof fetch === 'undefined') {
            var library = 'unfetch';
            if (typeof window === 'undefined') library = 'node-fetch';
            throw new (0, $1DiV8.InvariantError)(1);
        }
    };
    var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
        if (typeof AbortController === 'undefined') return {
            controller: false,
            signal: false
        };
        var controller = new AbortController();
        var signal = controller.signal;
        return {
            controller: controller,
            signal: signal
        };
    };
    var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
        var configs = [];
        for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
        var options = (0, (0, parcelRequire("3VFsf")).__assign)({}, fallbackConfig.options, {
            headers: fallbackConfig.headers,
            credentials: fallbackConfig.credentials
        });
        var http = fallbackConfig.http;
        configs.forEach(function(config) {
            options = (0, (0, parcelRequire("3VFsf")).__assign)({}, options, config.options, {
                headers: (0, (0, parcelRequire("3VFsf")).__assign)({}, options.headers, config.headers)
            });
            if (config.credentials) options.credentials = config.credentials;
            http = (0, (0, parcelRequire("3VFsf")).__assign)({}, http, config.http);
        });
        var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
        var body = {
            operationName: operationName,
            variables: variables
        };
        if (http.includeExtensions) body.extensions = extensions;
        if (http.includeQuery) body.query = (0, (0, parcelRequire("1c8Um")).print)(query);
        return {
            options: options,
            body: body
        };
    };
    var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
        var serialized;
        try {
            serialized = JSON.stringify(p);
        } catch (e) {
            var parseError = new (0, $1DiV8.InvariantError)(2);
            parseError.parseError = e;
            throw parseError;
        }
        return serialized;
    };
    var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
        var context = operation.getContext();
        var contextURI = context.uri;
        if (contextURI) return contextURI;
        else if (typeof fallbackURI === 'function') return fallbackURI(operation);
        else return fallbackURI || '/graphql';
    };
});
parcelRegister("lC4FX", function(module, exports) {
    $parcel$export(module.exports, "RetryLink", ()=>$fbc0c610016bf5c5$export$943d544ad120494a);
    var $3VFsf;
    var $clSzL;
    function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
        var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
        var baseDelay = jitter ? initial : initial / 2;
        return function delayFunction(count) {
            var delay = Math.min(max, baseDelay * Math.pow(2, count));
            if (jitter) delay = Math.random() * delay;
            return delay;
        };
    }
    function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
        var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
        return function retryFunction(count, operation, error) {
            if (count >= max) return false;
            return retryIf ? retryIf(error, operation) : !!error;
        };
    }
    var $fbc0c610016bf5c5$var$RetryableOperation = function() {
        function RetryableOperation(operation, nextLink, delayFor, retryIf) {
            var _this = this;
            this.operation = operation;
            this.nextLink = nextLink;
            this.delayFor = delayFor;
            this.retryIf = retryIf;
            this.retryCount = 0;
            this.values = [];
            this.complete = false;
            this.canceled = false;
            this.observers = [];
            this.currentSubscription = null;
            this.onNext = function(value) {
                _this.values.push(value);
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.next(value);
                }
            };
            this.onComplete = function() {
                _this.complete = true;
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.complete();
                }
            };
            this.onError = function(error) {
                return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                    var shouldRetry, _i, _a, observer;
                    return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                this.retryCount += 1;
                                return [
                                    4,
                                    this.retryIf(this.retryCount, this.operation, error)
                                ];
                            case 1:
                                shouldRetry = _b.sent();
                                if (shouldRetry) {
                                    this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                    return [
                                        2
                                    ];
                                }
                                this.error = error;
                                for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                    observer = _a[_i];
                                    if (!observer) continue;
                                    observer.error(error);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            };
        }
        RetryableOperation.prototype.subscribe = function(observer) {
            if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
            this.observers.push(observer);
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var value = _a[_i];
                observer.next(value);
            }
            if (this.complete) observer.complete();
            else if (this.error) observer.error(this.error);
        };
        RetryableOperation.prototype.unsubscribe = function(observer) {
            var index = this.observers.indexOf(observer);
            if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
            this.observers[index] = null;
            if (this.observers.every(function(o) {
                return o === null;
            })) this.cancel();
        };
        RetryableOperation.prototype.start = function() {
            if (this.currentSubscription) return;
            this.try();
        };
        RetryableOperation.prototype.cancel = function() {
            if (this.currentSubscription) this.currentSubscription.unsubscribe();
            clearTimeout(this.timerId);
            this.timerId = null;
            this.currentSubscription = null;
            this.canceled = true;
        };
        RetryableOperation.prototype.try = function() {
            this.currentSubscription = this.nextLink(this.operation).subscribe({
                next: this.onNext,
                error: this.onError,
                complete: this.onComplete
            });
        };
        RetryableOperation.prototype.scheduleRetry = function(delay) {
            var _this = this;
            if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
            this.timerId = setTimeout(function() {
                _this.timerId = null;
                _this.try();
            }, delay);
        };
        return RetryableOperation;
    }();
    var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(RetryLink, _super);
        function RetryLink(options) {
            var _this = _super.call(this) || this;
            var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
            _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
            _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
            return _this;
        }
        RetryLink.prototype.request = function(operation, nextLink) {
            var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
            retryable.start();
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                retryable.subscribe(observer);
                return function() {
                    retryable.unsubscribe(observer);
                };
            });
        };
        return RetryLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("cuKXc", function(module, exports) {
    $parcel$export(module.exports, "fragmentCacheRedirect", ()=>$918cb5692ff82562$export$5133c88128301697);
    $parcel$export(module.exports, "fragmentLinkState", ()=>$918cb5692ff82562$export$3f9ecfb4d42ab23d);
    var $jojW6;
    var $9HlP2 = parcelRequire("9HlP2");
    var $ivfDv;
    function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
        if (dataIdFromObject === void 0) dataIdFromObject = (0, (0, parcelRequire("ivfDv")).defaultDataIdFromObject);
        return {
            getFragment: function(_, _a) {
                var id = _a.id, __typename = _a.__typename;
                return (0, (0, parcelRequire("jojW6")).toIdValue)(dataIdFromObject({
                    __typename: __typename,
                    id: id
                }));
            }
        };
    }
    function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
        return (0, $9HlP2.withClientState)({
            cache: apolloCache,
            resolvers: {
                Query: {
                    getFragment: function(_, _a, _b) {
                        var __typename = _a.__typename, id = _a.id;
                        var cache = _b.cache;
                        var fragmentId = cache.config.dataIdFromObject({
                            __typename: __typename,
                            id: id
                        });
                        return cache.data.data[fragmentId];
                    }
                }
            }
        });
    }
});
parcelRegister("9HlP2", function(module, exports) {
    $parcel$export(module.exports, "withClientState", ()=>$70f90ea50d538958$export$a13f755900e15d9e);
    var $clSzL;
    var $jojW6;
    var $jWd7i;
    var $b2p88 = parcelRequire("b2p88");
    var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
        var extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $70f90ea50d538958$var$graphql = (0, parcelRequire("jWd7i")).graphql;
    var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
        if (clientStateConfig === void 0) clientStateConfig = {
            resolvers: {},
            defaults: {}
        };
        var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
        if (cache && defaults) cache.writeData({
            data: defaults
        });
        return new (function(_super) {
            $70f90ea50d538958$var$__extends(StateLink, _super);
            function StateLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            StateLink.prototype.writeDefaults = function() {
                if (cache && defaults) cache.writeData({
                    data: defaults
                });
            };
            StateLink.prototype.request = function(operation, forward) {
                if (forward === void 0) forward = function() {
                    return (0, (0, parcelRequire("clSzL")).Observable).of({
                        data: {}
                    });
                };
                if (typeDefs) {
                    var directives_1 = 'directive @client on FIELD';
                    var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                    operation.setContext(function(_a) {
                        var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                        return {
                            schemas: schemas.concat([
                                {
                                    definition: definition_1,
                                    directives: directives_1
                                }
                            ])
                        };
                    });
                }
                var isClient = (0, (0, parcelRequire("jojW6")).hasDirectives)([
                    'client'
                ], operation.query);
                if (!isClient) return forward(operation);
                var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
                var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
                var query = operation.query;
                var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, (0, parcelRequire("jojW6")).getMainDefinition)(query) || {}).operation) || 'Query';
                var resolver = function(fieldName, rootValue, args, context, info) {
                    if (rootValue === void 0) rootValue = {};
                    var resultKey = info.resultKey;
                    var aliasedNode = rootValue[resultKey];
                    var preAliasingNode = rootValue[fieldName];
                    var aliasNeeded = resultKey !== fieldName;
                    if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                    var resolverMap = resolvers[rootValue.__typename || type];
                    if (resolverMap) {
                        var resolve = resolverMap[fieldName];
                        if (resolve) return resolve(rootValue, args, context, info);
                    }
                    return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
                };
                if (server) operation.query = server;
                var obs = server && forward ? forward(operation) : (0, (0, parcelRequire("clSzL")).Observable).of({
                    data: {}
                });
                return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                    var complete = false;
                    var handlingNext = false;
                    obs.subscribe({
                        next: function(_a) {
                            var data = _a.data, errors = _a.errors;
                            var observerErrorHandler = observer.error.bind(observer);
                            var context = operation.getContext();
                            handlingNext = true;
                            $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                                fragmentMatcher: fragmentMatcher
                            }).then(function(nextData) {
                                observer.next({
                                    data: nextData,
                                    errors: errors
                                });
                                if (complete) observer.complete();
                                handlingNext = false;
                            }).catch(observerErrorHandler);
                        },
                        error: observer.error.bind(observer),
                        complete: function() {
                            if (!handlingNext) observer.complete();
                            complete = true;
                        }
                    });
                });
            };
            return StateLink;
        }((0, (0, parcelRequire("clSzL")).ApolloLink)))();
    };
});
parcelRegister("jWd7i", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3VFsf;
    var $jojW6;
    var $jDjTr;
    function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
    function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var fragmentMap, contextValue, variables, result, execute;
            var _this = this;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                        result = {};
                        execute = function(selection) {
                            return (0, parcelRequire("3VFsf")).__awaiter(_this, void 0, void 0, function() {
                                var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                                return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return [
                                                2
                                            ];
                                            if (!(0, parcelRequire("jojW6")).isField(selection)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                            ];
                                        case 1:
                                            fieldResult = _a.sent();
                                            resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                                            if (fieldResult !== undefined) {
                                                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                                else (0, parcelRequire("jDjTr")).merge(result[resultFieldKey], fieldResult);
                                            }
                                            return [
                                                2
                                            ];
                                        case 2:
                                            if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                                            else {
                                                fragment = fragmentMap[selection.name.value];
                                                if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                            }
                                            typeCondition = fragment.typeCondition.name.value;
                                            if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                            ];
                                        case 3:
                                            fragmentResult = _a.sent();
                                            (0, parcelRequire("jDjTr")).merge(result, fragmentResult);
                                            _a.label = 4;
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            4,
                            Promise.all(selectionSet.selections.map(execute))
                        ];
                    case 1:
                        _a.sent();
                        if (execContext.resultMapper) return [
                            2,
                            execContext.resultMapper(result, rootValue)
                        ];
                        return [
                            2,
                            result
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var variables, contextValue, resolver, fieldName, args, info, result;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                        fieldName = field.name.value;
                        args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
                        info = {
                            isLeaf: !field.selectionSet,
                            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
                            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
                            field: field
                        };
                        return [
                            4,
                            resolver(fieldName, rootValue, args, contextValue, info)
                        ];
                    case 1:
                        result = _a.sent();
                        if (!field.selectionSet) return [
                            2,
                            result
                        ];
                        if (result == null) return [
                            2,
                            result
                        ];
                        if (Array.isArray(result)) return [
                            2,
                            $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                        ];
                        return [
                            2,
                            $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
            return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
        }));
    }
});
parcelRegister("jDjTr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $jojW6;
    function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (variableValues === void 0) variableValues = {};
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e4b11739b667b187$var$graphql;
    function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var result = {};
        selectionSet.selections.forEach(function(selection) {
            if (variables && !(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return;
            if ((0, parcelRequire("jojW6")).isField(selection)) {
                var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
                var resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                if (fieldResult !== undefined) {
                    if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                    else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
                }
            } else {
                var fragment = void 0;
                if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new Error("No fragment named " + selection.name.value);
                }
                var typeCondition = fragment.typeCondition.name.value;
                if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                    var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                    $e4b11739b667b187$var$merge(result, fragmentResult);
                }
            }
        });
        if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
        return result;
    }
    function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
        var fieldName = field.name.value;
        var args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
        var info = {
            isLeaf: !field.selectionSet,
            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
            field: field
        };
        var result = resolver(fieldName, rootValue, args, contextValue, info);
        if (!field.selectionSet) return result;
        if (result == null) return result;
        if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
    }
    function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
        return result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
            return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
        });
    }
    var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
    function $e4b11739b667b187$var$merge(dest, src) {
        if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
            var srcVal = src[key];
            if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
            else $e4b11739b667b187$var$merge(dest[key], srcVal);
        });
    }
    module.exports.merge = $e4b11739b667b187$var$merge;
});
parcelRegister("b2p88", function(module, exports) {
    $parcel$export(module.exports, "removeClientSetsFromDocument", ()=>$80935fed9657b3c7$export$8eae69e876ee321e);
    $parcel$export(module.exports, "normalizeTypeDefs", ()=>$80935fed9657b3c7$export$467f9c465e4ace4e);
    var $1c8Um;
    var $jojW6;
    var $80935fed9657b3c7$var$connectionRemoveConfig = {
        test: function(directive) {
            return directive.name.value === 'client';
        },
        remove: true
    };
    var $80935fed9657b3c7$var$removed = new Map();
    function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
        var cached = $80935fed9657b3c7$var$removed.get(query);
        if (cached) return cached;
        (0, (0, parcelRequire("jojW6")).checkDocument)(query);
        var docClone = (0, (0, parcelRequire("jojW6")).removeDirectivesFromDocument)([
            $80935fed9657b3c7$var$connectionRemoveConfig
        ], query);
        $80935fed9657b3c7$var$removed.set(query, docClone);
        return docClone;
    }
    function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
        var defs = Array.isArray(typeDefs) ? typeDefs : [
            typeDefs
        ];
        return defs.map(function(typeDef) {
            return typeof typeDef === 'string' ? typeDef : (0, (0, parcelRequire("1c8Um")).print)(typeDef);
        }).map(function(str) {
            return str.trim();
        }).join('\n');
    }
});
parcelRegister("dxpxC", function(module, exports) {
    $parcel$export(module.exports, "UFOLoggerLink", ()=>$4350c2bcf1320fcf$export$fb326ed954631f3f);
    var $clSzL;
    var $bFU4G;
    const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, (0, parcelRequire("clSzL")).ApolloLink)((operation, forward)=>{
        const networkStart = performance.now();
        return forward(operation).map((response)=>{
            const networkComplete = performance.now();
            const operationName = operation.operationName ?? 'unnamed';
            (0, (0, parcelRequire("bFU4G")).addSpanToAll)('graphql', operationName, [
                {
                    name: 'network'
                }
            ], networkStart, networkComplete);
            return response;
        });
    });
});
parcelRegister("l0T7c", function(module, exports) {
    module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");
});
parcelRegister("9g713", function(module, exports) {
    $parcel$export(module.exports, "getErrorAnalyticsContext", ()=>$a87e716199660ede$export$bd030713895ed5e2);
    $parcel$export(module.exports, "reportErrors", ()=>$a87e716199660ede$export$a78ebe1911f50d41);
    var $9XE6b = parcelRequire("9XE6b");
    var $e3a3O;
    var $jcw0u;
    const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
    const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
            ...context,
            [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
        });
    const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
        const errorAnalytics = (0, ($parcel$interopDefault($9XE6b)))(context, [
            $a87e716199660ede$export$15d632fe38832073
        ], undefined);
        if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
            id: errorAnalytics.id,
            packageName: errorAnalytics.packageName,
            teamName: errorAnalytics.teamName,
            attributes: errorAnalytics.attributes,
            sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
        };
        return undefined;
    };
    const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
        if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
        const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
        const hasNetworkError = networkError !== undefined;
        if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
        const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
        const error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
            graphQLErrors: graphQLErrors ? [
                ...graphQLErrors
            ] : undefined,
            networkError: networkError
        });
        const attributesWithOperationName = {
            ...attributes,
            operationName: operation.operationName,
            hasGraphQLError: hasGraphQLError,
            hasNetworkError: hasNetworkError
        };
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: attributesWithOperationName,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
        });
    };
});
parcelRegister("AeWM3", function(module, exports) {
    $parcel$export(module.exports, "resetCache", ()=>$63ae5caf575c2d55$export$6e5dca841bdf93e3);
    $parcel$export(module.exports, "getClient", ()=>$63ae5caf575c2d55$export$6bb76d6eba7e258c);
    $parcel$export(module.exports, "ApolloClientProvider", ()=>$63ae5caf575c2d55$export$8e363dbef886ff17);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $bvsgq;
    var $9OXo1;
    const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
    const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
        delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    };
    const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
                [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
            }), {});
    const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
        let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
        if (!client) {
            client = clientCreator(baseUrl, xsrfToken);
            $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
        }
        return client;
    };
    class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
        getClient(baseUrl, xsrfToken) {
            return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
        }
        render() {
            const { children: children } = this.props;
            if (!(0, ($parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
                const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvsgq")).ApolloProvider), {
                    client: client
                }, children);
            });
        }
    }
});
parcelRegister("bvsgq", function(module, exports) {
    $parcel$export(module.exports, "getApolloContext", ()=>$02296d7a3662bd2d$export$a47505d961ee3a1);
    $parcel$export(module.exports, "ApolloProvider", ()=>$02296d7a3662bd2d$export$c16b04c8a9956446);
    $parcel$export(module.exports, "DocumentType", ()=>$02296d7a3662bd2d$export$d1d99cf900472499);
    $parcel$export(module.exports, "operationName", ()=>$02296d7a3662bd2d$export$5db520940cf00715);
    $parcel$export(module.exports, "parser", ()=>$02296d7a3662bd2d$export$8f49e4af10703ce3);
    var $5uXOq = parcelRequire("5uXOq");
    var $1DiV8 = parcelRequire("1DiV8");
    var $02296d7a3662bd2d$var$apolloContext;
    function $02296d7a3662bd2d$export$a47505d961ee3a1() {
        if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
        return $02296d7a3662bd2d$var$apolloContext;
    }
    function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
        $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    }
    var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
        var client = _a.client, children = _a.children;
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            if (context === void 0) context = {};
            if (client && context.client !== client) context = Object.assign({}, context, {
                client: client
            });
            (0, $1DiV8.invariant)(context.client, 5);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
                value: context
            }, children);
        });
    };
    var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            (0, $1DiV8.invariant)(context && context.client, 6);
            return props.children(context.client);
        });
    };
    var $02296d7a3662bd2d$export$d1d99cf900472499;
    (function(DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
    var $02296d7a3662bd2d$var$cache = new Map();
    function $02296d7a3662bd2d$export$5db520940cf00715(type) {
        var name;
        switch(type){
            case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
                name = 'Query';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
                name = 'Mutation';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
                name = 'Subscription';
                break;
        }
        return name;
    }
    function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
        var cached = $02296d7a3662bd2d$var$cache.get(document);
        if (cached) return cached;
        var variables, type, name;
        (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
        var fragments = document.definitions.filter(function(x) {
            return x.kind === 'FragmentDefinition';
        });
        var queries = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'query';
        });
        var mutations = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'mutation';
        });
        var subscriptions = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'subscription';
        });
        (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
        (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
        type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
        if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        (0, $1DiV8.invariant)(definitions.length === 1, 4);
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
        else name = 'data';
        var payload = {
            name: name,
            type: type,
            variables: variables
        };
        $02296d7a3662bd2d$var$cache.set(document, payload);
        return payload;
    }
});
parcelRegister("7Dl4r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0216752b3c8170d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $9fuVs;
    var $gwIPs;
    var $iXVV6;
    var $7LHuW;
    var $2uWzn;
    const $c0216752b3c8170d$var$DeploymentDetailsModal = ({ issueIds: issueIds, deploymentDisplayName: deploymentDisplayName, deploymentUrl: deploymentUrl, hasPermissionForAllIssues: hasPermissionForAllIssues, onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "deploymentNavigator"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: (0, (0, parcelRequire("gwIPs")).gridSize) * 116,
            height: (0, (0, parcelRequire("gwIPs")).gridSize) * 67,
            autoFocus: false,
            onClose: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2uWzn")).default), {
            onClose: onClose
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LHuW")).default), {
            issueIds: issueIds,
            deploymentUrl: deploymentUrl,
            deploymentDisplayName: deploymentDisplayName,
            hasPermissionForAllIssues: hasPermissionForAllIssues
        }))));
    var $c0216752b3c8170d$export$2e2bcd8739ae039 = $c0216752b3c8170d$var$DeploymentDetailsModal;
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("7LHuW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5356d4eb94a5d9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7QSqG;
    var $5oFIy;
    var $gUDZO;
    var $aEwe3;
    var $3h2r6;
    var $3lx3f;
    const $b5356d4eb94a5d9a$var$Body = ({ issueIds: issueIds, deploymentDisplayName: deploymentDisplayName, deploymentUrl: deploymentUrl, hasPermissionForAllIssues: hasPermissionForAllIssues })=>{
        const { loading: loading, error: error, data: issues } = (0, (0, parcelRequire("gUDZO")).useIssues)(issueIds);
        if (!loading && issues === undefined) throw error ?? Error('Unknown error');
        if (issueIds.length === 0 && !hasPermissionForAllIssues) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3lx3f")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aEwe3")).default), {
            issueCount: issueIds.length,
            deploymentDisplayName: deploymentDisplayName,
            deploymentUrl: deploymentUrl,
            hasPermissionForAllIssues: hasPermissionForAllIssues
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3h2r6")).default), {
            issues: issues ?? 'loading'
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                noPermissionForAnyIssues: false
            }
        }));
    };
    var $b5356d4eb94a5d9a$export$2e2bcd8739ae039 = $b5356d4eb94a5d9a$var$Body;
});
parcelRegister("gUDZO", function(module, exports) {
    $parcel$export(module.exports, "useIssues", ()=>$542ab43d37a86178$export$fdf0b908e72b6bef);
    var $5tTFS;
    var $b7zL1;
    var $ii9iW;
    const $542ab43d37a86178$export$fdf0b908e72b6bef = (issueIds)=>{
        const queryResult = (0, (0, parcelRequire("5tTFS")).useQuery)((0, (0, parcelRequire("b7zL1")).ISSUE_DETAILS_QUERY), {
            variables: {
                ...(0, (0, parcelRequire("ii9iW")).buildQueryVariables)(issueIds)
            },
            errorPolicy: 'all'
        });
        return (0, (0, parcelRequire("ii9iW")).transformResult)(queryResult);
    };
});
parcelRegister("5tTFS", function(module, exports) {
    $parcel$export(module.exports, "useQuery", ()=>$3fdad8fd02cd9507$export$dd0a697e1782aedd);
    $parcel$export(module.exports, "useLazyQuery", ()=>$3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
    $parcel$export(module.exports, "useMutation", ()=>$3fdad8fd02cd9507$export$609860bf8b0084c);
    $parcel$export(module.exports, "useApolloClient", ()=>$3fdad8fd02cd9507$export$eb9a56e7a29e494);
    var $bvsgq;
    var $3VFsf;
    var $5uXOq = parcelRequire("5uXOq");
    var $e3a3O;
    var $bqMzA = parcelRequire("bqMzA");
    var $1DiV8 = parcelRequire("1DiV8");
    var $3fdad8fd02cd9507$var$OperationData = function() {
        function OperationData(options, context) {
            this.isMounted = false;
            this.previousOptions = {};
            this.context = {};
            this.options = {};
            this.options = options || {};
            this.context = context || {};
        }
        OperationData.prototype.getOptions = function() {
            return this.options;
        };
        OperationData.prototype.setOptions = function(newOptions, storePrevious) {
            if (storePrevious === void 0) storePrevious = false;
            if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
            this.options = newOptions;
        };
        OperationData.prototype.unmount = function() {
            this.isMounted = false;
        };
        OperationData.prototype.refreshClient = function() {
            var client = this.options && this.options.client || this.context && this.context.client;
            (0, $1DiV8.invariant)(!!client, 2);
            var isNew = false;
            if (client !== this.client) {
                isNew = true;
                this.client = client;
                this.cleanup();
            }
            return {
                client: this.client,
                isNew: isNew
            };
        };
        OperationData.prototype.verifyDocumentType = function(document, type) {
            var operation = (0, (0, parcelRequire("bvsgq")).parser)(document);
            var requiredOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(type);
            var usedOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(operation.type);
            (0, $1DiV8.invariant)(operation.type === type, 3);
        };
        return OperationData;
    }();
    var $3fdad8fd02cd9507$var$QueryData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(QueryData, _super);
        function QueryData(_a) {
            var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
            var _this = _super.call(this, options, context) || this;
            _this.previousData = {};
            _this.currentObservable = {};
            _this.runLazy = false;
            _this.runLazyQuery = function(options) {
                _this.cleanup();
                _this.runLazy = true;
                _this.lazyOptions = options;
                _this.forceUpdate();
            };
            _this.getExecuteResult = function() {
                var result = _this.getQueryResult();
                _this.startQuerySubscription();
                return result;
            };
            _this.obsRefetch = function(variables) {
                return _this.currentObservable.query.refetch(variables);
            };
            _this.obsFetchMore = function(fetchMoreOptions) {
                return _this.currentObservable.query.fetchMore(fetchMoreOptions);
            };
            _this.obsUpdateQuery = function(mapFn) {
                return _this.currentObservable.query.updateQuery(mapFn);
            };
            _this.obsStartPolling = function(pollInterval) {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
            };
            _this.obsStopPolling = function() {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
            };
            _this.obsSubscribeToMore = function(options) {
                return _this.currentObservable.query.subscribeToMore(options);
            };
            _this.forceUpdate = forceUpdate;
            return _this;
        }
        QueryData.prototype.execute = function() {
            this.refreshClient();
            var _a = this.getOptions(), skip = _a.skip, query = _a.query;
            if (skip || query !== this.previousData.query) {
                this.removeQuerySubscription();
                this.previousData.query = query;
            }
            this.updateObservableQuery();
            if (this.isMounted) this.startQuerySubscription();
            return this.getExecuteSsrResult() || this.getExecuteResult();
        };
        QueryData.prototype.executeLazy = function() {
            return !this.runLazy ? [
                this.runLazyQuery,
                {
                    loading: false,
                    networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).ready,
                    called: false,
                    data: undefined
                }
            ] : [
                this.runLazyQuery,
                this.execute()
            ];
        };
        QueryData.prototype.fetchData = function() {
            var options = this.getOptions();
            if (options.skip || options.ssr === false) return false;
            var obs = this.currentObservable.query;
            var currentResult = obs.getCurrentResult();
            return currentResult.loading ? obs.result() : false;
        };
        QueryData.prototype.afterExecute = function(_a) {
            var _this = this;
            var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
            this.isMounted = true;
            if (!lazy || this.runLazy) {
                this.handleErrorOrCompleted();
                setTimeout(function() {
                    _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
                });
            }
            this.previousOptions = this.getOptions();
            return this.unmount.bind(this);
        };
        QueryData.prototype.cleanup = function() {
            this.removeQuerySubscription();
            delete this.currentObservable.query;
            delete this.previousData.result;
        };
        QueryData.prototype.getOptions = function() {
            var options = _super.prototype.getOptions.call(this);
            if (this.lazyOptions) {
                options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.variables), this.lazyOptions.variables);
                options.context = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.context), this.lazyOptions.context);
            }
            if (this.runLazy) delete options.skip;
            return options;
        };
        QueryData.prototype.getExecuteSsrResult = function() {
            var treeRenderingInitiated = this.context && this.context.renderPromises;
            var ssrDisabled = this.getOptions().ssr === false;
            var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
            var ssrLoading = {
                loading: true,
                networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading,
                called: true,
                data: undefined
            };
            if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
            var result;
            if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
            return result;
        };
        QueryData.prototype.prepareObservableQueryOptions = function() {
            var options = this.getOptions();
            this.verifyDocumentType(options.query, (0, (0, parcelRequire("bvsgq")).DocumentType).Query);
            var displayName = options.displayName || 'Query';
            if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                displayName: displayName,
                context: options.context,
                metadata: {
                    reactComponent: {
                        displayName: displayName
                    }
                }
            });
        };
        QueryData.prototype.initializeObservableQuery = function() {
            if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
            if (!this.currentObservable.query) {
                var observableQueryOptions = this.prepareObservableQueryOptions();
                this.previousData.observableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions), {
                    children: null
                });
                this.currentObservable.query = this.refreshClient().client.watchQuery((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions));
                if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
            }
        };
        QueryData.prototype.updateObservableQuery = function() {
            if (!this.currentObservable.query) {
                this.initializeObservableQuery();
                return;
            }
            var newObservableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.prepareObservableQueryOptions()), {
                children: null
            });
            if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
                this.previousData.observableQueryOptions = newObservableQueryOptions;
                this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
            }
        };
        QueryData.prototype.startQuerySubscription = function() {
            var _this = this;
            if (this.currentObservable.subscription || this.getOptions().skip) return;
            var obsQuery = this.currentObservable.query;
            this.currentObservable.subscription = obsQuery.subscribe({
                next: function(_a) {
                    var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                    _this.forceUpdate();
                },
                error: function(error) {
                    _this.resubscribeToQuery();
                    if (!error.hasOwnProperty('graphQLErrors')) throw error;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                        _this.previousData.error = error;
                        _this.forceUpdate();
                    }
                }
            });
        };
        QueryData.prototype.resubscribeToQuery = function() {
            this.removeQuerySubscription();
            var lastError = this.currentObservable.query.getLastError();
            var lastResult = this.currentObservable.query.getLastResult();
            this.currentObservable.query.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.currentObservable.query, {
                lastError: lastError,
                lastResult: lastResult
            });
        };
        QueryData.prototype.getQueryResult = function() {
            var result = this.observableQueryFields();
            var options = this.getOptions();
            if (options.skip) result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                data: undefined,
                error: undefined,
                loading: false,
                called: true
            });
            else {
                var currentResult = this.currentObservable.query.getCurrentResult();
                var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error, data = currentResult.data;
                if (errors && errors.length > 0) error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                    graphQLErrors: errors
                });
                result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                    loading: loading,
                    networkStatus: networkStatus,
                    error: error,
                    called: true
                });
                if (loading) {
                    var previousData = this.previousData.result && this.previousData.result.data;
                    result.data = previousData && data ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, previousData), data) : previousData || data;
                } else if (error) Object.assign(result, {
                    data: (this.currentObservable.query.getLastResult() || {}).data
                });
                else {
                    var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                    var partialRefetch = options.partialRefetch;
                    if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                        Object.assign(result, {
                            loading: true,
                            networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading
                        });
                        result.refetch();
                        return result;
                    }
                    result.data = data;
                }
            }
            result.client = this.client;
            this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
            this.previousData.result = result;
            return result;
        };
        QueryData.prototype.handleErrorOrCompleted = function() {
            var obsQuery = this.currentObservable.query;
            if (!obsQuery) return;
            var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
            if (!loading) {
                var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
                if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
                if (onCompleted && !error) onCompleted(data);
                else if (onError && error) onError(error);
            }
        };
        QueryData.prototype.removeQuerySubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        QueryData.prototype.observableQueryFields = function() {
            var observable = this.currentObservable.query;
            return {
                variables: observable.variables,
                refetch: this.obsRefetch,
                fetchMore: this.obsFetchMore,
                updateQuery: this.obsUpdateQuery,
                startPolling: this.obsStartPolling,
                stopPolling: this.obsStopPolling,
                subscribeToMore: this.obsSubscribeToMore
            };
        };
        return QueryData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
        var ref = (0, $5uXOq.useRef)();
        if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
            key: key,
            value: memoFn()
        };
        return ref.current.value;
    }
    function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
        if (lazy === void 0) lazy = false;
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useReducer)(function(x) {
            return x + 1;
        }, 0), tick = _a[0], forceUpdate = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            query: query
        }) : {
            query: query
        };
        var queryDataRef = (0, $5uXOq.useRef)();
        if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
            options: updatedOptions,
            context: context,
            forceUpdate: forceUpdate
        });
        var queryData = queryDataRef.current;
        queryData.setOptions(updatedOptions);
        queryData.context = context;
        var memo = {
            options: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, updatedOptions), {
                onError: undefined,
                onCompleted: undefined
            }),
            context: context,
            tick: tick
        };
        var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
            return lazy ? queryData.executeLazy() : queryData.execute();
        }, memo);
        var queryResult = lazy ? result[1] : result;
        (0, $5uXOq.useEffect)(function() {
            return queryData.afterExecute({
                lazy: lazy
            });
        }, [
            queryResult.loading,
            queryResult.networkStatus,
            queryResult.error,
            queryResult.data
        ]);
        (0, $5uXOq.useEffect)(function() {
            return function() {
                return queryData.cleanup();
            };
        }, []);
        return result;
    }
    function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
    }
    function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
    }
    var $3fdad8fd02cd9507$var$MutationData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MutationData, _super);
        function MutationData(_a) {
            var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.runMutation = function(mutationFunctionOptions) {
                if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
                _this.onMutationStart();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(mutationFunctionOptions).then(function(response) {
                    _this.onMutationCompleted(response, mutationId);
                    return response;
                }).catch(function(error) {
                    _this.onMutationError(error, mutationId);
                    if (!_this.getOptions().onError) throw error;
                });
            };
            _this.verifyDocumentType(options.mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            _this.result = result;
            _this.setResult = setResult;
            _this.mostRecentMutationId = 0;
            return _this;
        }
        MutationData.prototype.execute = function(result) {
            this.isMounted = true;
            this.verifyDocumentType(this.getOptions().mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            result.client = this.refreshClient().client;
            return [
                this.runMutation,
                result
            ];
        };
        MutationData.prototype.afterExecute = function() {
            this.isMounted = true;
            return this.unmount.bind(this);
        };
        MutationData.prototype.cleanup = function() {};
        MutationData.prototype.mutate = function(mutationFunctionOptions) {
            var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
            var mutateOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, mutationFunctionOptions);
            var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
            delete mutateOptions.variables;
            return this.refreshClient().client.mutate((0, (0, parcelRequire("3VFsf")).__assign)({
                mutation: mutation,
                optimisticResponse: optimisticResponse,
                refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
                awaitRefetchQueries: awaitRefetchQueries,
                update: update,
                context: mutationContext,
                fetchPolicy: fetchPolicy,
                variables: mutateVariables
            }, mutateOptions));
        };
        MutationData.prototype.onMutationStart = function() {
            if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
                loading: true,
                error: undefined,
                data: undefined,
                called: true
            });
        };
        MutationData.prototype.onMutationCompleted = function(response, mutationId) {
            var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                graphQLErrors: errors
            }) : undefined;
            var callOncomplete = function() {
                return onCompleted ? onCompleted(data) : null;
            };
            if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
                called: true,
                loading: false,
                data: data,
                error: error
            });
            callOncomplete();
        };
        MutationData.prototype.onMutationError = function(error, mutationId) {
            var onError = this.getOptions().onError;
            if (this.isMostRecentMutation(mutationId)) this.updateResult({
                loading: false,
                error: error,
                data: undefined,
                called: true
            });
            if (onError) onError(error);
        };
        MutationData.prototype.generateNewMutationId = function() {
            return ++this.mostRecentMutationId;
        };
        MutationData.prototype.isMostRecentMutation = function(mutationId) {
            return this.mostRecentMutationId === mutationId;
        };
        MutationData.prototype.updateResult = function(result) {
            if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
                this.setResult(result);
                this.previousResult = result;
            }
        };
        return MutationData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useState)({
            called: false,
            loading: false
        }), result = _a[0], setResult = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            mutation: mutation
        }) : {
            mutation: mutation
        };
        var mutationDataRef = (0, $5uXOq.useRef)();
        function getMutationDataRef() {
            if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
                options: updatedOptions,
                context: context,
                result: result,
                setResult: setResult
            });
            return mutationDataRef.current;
        }
        var mutationData = getMutationDataRef();
        mutationData.setOptions(updatedOptions);
        mutationData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return mutationData.afterExecute();
        });
        return mutationData.execute(result);
    }
    var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SubscriptionData, _super);
        function SubscriptionData(_a) {
            var options = _a.options, context = _a.context, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.currentObservable = {};
            _this.setResult = setResult;
            _this.initialize(options);
            return _this;
        }
        SubscriptionData.prototype.execute = function(result) {
            if (this.getOptions().skip === true) {
                this.cleanup();
                return {
                    loading: false,
                    error: undefined,
                    data: undefined,
                    variables: this.getOptions().variables
                };
            }
            var currentResult = result;
            if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
            var shouldResubscribe = this.getOptions().shouldResubscribe;
            if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
            if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
                this.cleanup();
                currentResult = this.getLoadingResult();
            }
            this.initialize(this.getOptions());
            this.startSubscription();
            this.previousOptions = this.getOptions();
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, currentResult), {
                variables: this.getOptions().variables
            });
        };
        SubscriptionData.prototype.afterExecute = function() {
            this.isMounted = true;
        };
        SubscriptionData.prototype.cleanup = function() {
            this.endSubscription();
            delete this.currentObservable.query;
        };
        SubscriptionData.prototype.initialize = function(options) {
            if (this.currentObservable.query || this.getOptions().skip === true) return;
            this.currentObservable.query = this.refreshClient().client.subscribe({
                query: options.subscription,
                variables: options.variables,
                fetchPolicy: options.fetchPolicy
            });
        };
        SubscriptionData.prototype.startSubscription = function() {
            if (this.currentObservable.subscription) return;
            this.currentObservable.subscription = this.currentObservable.query.subscribe({
                next: this.updateCurrentData.bind(this),
                error: this.updateError.bind(this),
                complete: this.completeSubscription.bind(this)
            });
        };
        SubscriptionData.prototype.getLoadingResult = function() {
            return {
                loading: true,
                error: undefined,
                data: undefined
            };
        };
        SubscriptionData.prototype.updateResult = function(result) {
            if (this.isMounted) this.setResult(result);
        };
        SubscriptionData.prototype.updateCurrentData = function(result) {
            var onSubscriptionData = this.getOptions().onSubscriptionData;
            this.updateResult({
                data: result.data,
                loading: false,
                error: undefined
            });
            if (onSubscriptionData) onSubscriptionData({
                client: this.refreshClient().client,
                subscriptionData: result
            });
        };
        SubscriptionData.prototype.updateError = function(error) {
            this.updateResult({
                error: error,
                loading: false
            });
        };
        SubscriptionData.prototype.completeSubscription = function() {
            var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
            if (onSubscriptionComplete) onSubscriptionComplete();
            this.endSubscription();
        };
        SubscriptionData.prototype.endSubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        return SubscriptionData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            subscription: subscription
        }) : {
            subscription: subscription
        };
        var _a = (0, $5uXOq.useState)({
            loading: !updatedOptions.skip,
            error: undefined,
            data: undefined
        }), result = _a[0], setResult = _a[1];
        var subscriptionDataRef = (0, $5uXOq.useRef)();
        function getSubscriptionDataRef() {
            if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
                options: updatedOptions,
                context: context,
                setResult: setResult
            });
            return subscriptionDataRef.current;
        }
        var subscriptionData = getSubscriptionDataRef();
        subscriptionData.setOptions(updatedOptions, true);
        subscriptionData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.afterExecute();
        });
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.cleanup.bind(subscriptionData);
        }, []);
        return subscriptionData.execute(result);
    }
    function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
        var client = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("bvsgq")).getApolloContext)()).client;
        (0, $1DiV8.invariant)(client, 1);
        return client;
    }
    function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
        return {
            seen: false,
            observable: null
        };
    }
    var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
        function RenderPromises() {
            this.queryPromises = new Map();
            this.queryInfoTrie = new Map();
        }
        RenderPromises.prototype.registerSSRObservable = function(observable, props) {
            this.lookupQueryInfo(props).observable = observable;
        };
        RenderPromises.prototype.getSSRObservable = function(props) {
            return this.lookupQueryInfo(props).observable;
        };
        RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
            var info = this.lookupQueryInfo(queryInstance.getOptions());
            if (!info.seen) {
                this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                    resolve(queryInstance.fetchData());
                }));
                return null;
            }
            return finish();
        };
        RenderPromises.prototype.hasPromises = function() {
            return this.queryPromises.size > 0;
        };
        RenderPromises.prototype.consumeAndAwaitPromises = function() {
            var _this = this;
            var promises = [];
            this.queryPromises.forEach(function(promise, queryInstance) {
                _this.lookupQueryInfo(queryInstance).seen = true;
                promises.push(promise);
            });
            this.queryPromises.clear();
            return Promise.all(promises);
        };
        RenderPromises.prototype.lookupQueryInfo = function(props) {
            var queryInfoTrie = this.queryInfoTrie;
            var query = props.query, variables = props.variables;
            var varMap = queryInfoTrie.get(query) || new Map();
            if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
            var variablesString = JSON.stringify(variables);
            var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
            if (!varMap.has(variablesString)) varMap.set(variablesString, info);
            return info;
        };
        return RenderPromises;
    }();
});
parcelRegister("b7zL1", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_DETAILS_QUERY", ()=>$81cab6d627586083$export$b7ad3811e7929cf8);
    var $5cllN;
    const $81cab6d627586083$export$b7ad3811e7929cf8 = (0, (0, parcelRequire("5cllN")).default)`
    query jira_deploymentFrequencyReportDeploymentDetails_issueDetails_Query($jql: String, $first: Int!) {
        issues(first: $first, jql: $jql) {
            nodes {
                id
                issuekey {
                    stringValue
                }
                issuetype {
                    iconUrl
                }
                issuekey {
                    stringValue
                }
                summary {
                    textValue
                }
                assignee {
                    userValue {
                        displayName
                        avatarUrl
                    }
                }
                status {
                    name
                    statusCategoryId
                }
            }
        }
    }
`;
});
parcelRegister("ii9iW", function(module, exports) {
    $parcel$export(module.exports, "buildQueryVariables", ()=>$f60040039dab7dde$export$9a3cee82e7cc08ff);
    $parcel$export(module.exports, "transformResult", ()=>$f60040039dab7dde$export$f13b29f9ed0c5a03);
    var $gULOk;
    var $g5X3G;
    const $f60040039dab7dde$var$PAGE_SIZE = 100;
    const $f60040039dab7dde$var$buildJql = (issueIds)=>issueIds.length > 0 ? `id IN (${issueIds.join(',')})` : '';
    const $f60040039dab7dde$export$9a3cee82e7cc08ff = (issueIds)=>({
            first: $f60040039dab7dde$var$PAGE_SIZE,
            jql: $f60040039dab7dde$var$buildJql(issueIds)
        });
    const $f60040039dab7dde$var$transformNode = (node)=>{
        const key = node?.issuekey?.stringValue;
        const summary = node?.summary?.textValue;
        const issueTypeIconUrl = node?.issuetype?.iconUrl;
        const assigneeDisplayName = node?.assignee?.userValue?.displayName;
        const assigneeAvatarUrl = node?.assignee?.userValue?.avatarUrl;
        const statusName = node?.status?.name;
        const statusCategory = (0, (0, parcelRequire("gULOk")).statusCategoryForId)(node?.status?.statusCategoryId ?? undefined);
        if (key == null || summary == null || statusName == null || issueTypeIconUrl == null) throw Error('Invalid issue node');
        const assignee = assigneeDisplayName == null || assigneeAvatarUrl == null ? 'unassigned' : {
            displayName: assigneeDisplayName,
            avatarUrl: assigneeAvatarUrl
        };
        return {
            key: (0, (0, parcelRequire("g5X3G")).toIssueKey)(key),
            summary: summary,
            issueType: {
                iconUrl: issueTypeIconUrl
            },
            assignee: assignee,
            status: {
                name: statusName,
                category: statusCategory
            }
        };
    };
    const $f60040039dab7dde$export$f13b29f9ed0c5a03 = (queryResult)=>{
        const resultBase = {
            loading: queryResult.loading,
            error: queryResult.error
        };
        const nodes = queryResult.data?.issues?.nodes;
        if (queryResult.loading || nodes == null) return resultBase;
        try {
            return {
                ...resultBase,
                data: nodes.map($f60040039dab7dde$var$transformNode)
            };
        } catch (error) {
            return {
                ...resultBase,
                error: queryResult.error ?? error
            };
        }
    };
});
parcelRegister("aEwe3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b20ef06f611c1394$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1dJ6S;
    var $8sgpE;
    var $koVbs;
    var $gIl2t;
    var $3u3yu;
    const $b20ef06f611c1394$var$DeploymentSummary = ({ deploymentDisplayName: deploymentDisplayName, deploymentUrl: deploymentUrl, issueCount: issueCount, hasPermissionForAllIssues: hasPermissionForAllIssues })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const issuesShippedMessage = hasPermissionForAllIssues ? (0, (0, parcelRequire("3u3yu")).default).issuesShipped : (0, (0, parcelRequire("3u3yu")).default).issuesShippedLimitedPermissions;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b20ef06f611c1394$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "large"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b20ef06f611c1394$var$DeploymentLink, {
            href: deploymentUrl,
            target: "_blank"
        }, deploymentDisplayName)), (0, ($parcel$interopDefault($5uXOq))).createElement($b20ef06f611c1394$var$IssuesShippedContainer, {
            "data-test-id": "software-deployment-frequency-report-deployment-details-dialog.ui.body.deployment-summary.issues-shipped-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8sgpE"))))), {
            size: "small",
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66"
            ])
        }, formatMessage(issuesShippedMessage, {
            issueCount: issueCount
        })), !hasPermissionForAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gIl2t")).default), {
            message: formatMessage((0, (0, parcelRequire("3u3yu")).default).issuesShippedLimitedPermissionsTooltip),
            testId: "software-deployment-frequency-report-deployment-details-dialog.ui.body.deployment-summary.help-icon",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66"
            ])
        })));
    };
    var $b20ef06f611c1394$export$2e2bcd8739ae039 = $b20ef06f611c1394$var$DeploymentSummary;
    const $b20ef06f611c1394$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _1e0c1txw _2lx21bp4 _n3tdu2gc",
                __cmplp.className
            ])
        });
    });
    const $b20ef06f611c1394$var$DeploymentLink = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _syaz1y58",
                __cmplp.className
            ])
        });
    });
    const $b20ef06f611c1394$var$IssuesShippedContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qu2gc _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $b20ef06f611c1394$var$marginLeftStyles = null;
});
parcelRegister("gIl2t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$539d60c3ccd9e923$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eJS47;
    var $3bDjY;
    const $539d60c3ccd9e923$var$HelpIcon = ({ message: message, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: message,
            position: "right"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($539d60c3ccd9e923$var$HelpIconContainer, {
            "data-test-id": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
            primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N80})`,
            size: "small",
            label: ""
        })));
    var $539d60c3ccd9e923$export$2e2bcd8739ae039 = $539d60c3ccd9e923$var$HelpIcon;
    const $539d60c3ccd9e923$var$HelpIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb7vkz _4t3i7vkz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3u3yu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf1793fbf4098740$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bf1793fbf4098740$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issuesShipped: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped",
            "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}} shipped to production"
        },
        issuesShippedLimitedPermissions: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-limited-permissions",
            "defaultMessage": "Showing {issueCount} {issueCount, plural, one {issue} other {issues}} shipped to production"
        },
        issuesShippedLimitedPermissionsTooltip: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-limited-permissions-tooltip",
            "defaultMessage": "You are viewing the issues based on the permissions. Contact admin for details."
        }
    });
});
parcelRegister("3h2r6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$485323c55f5a9010$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k3qRI;
    var $iy3HT;
    const $485323c55f5a9010$var$ROWS_PER_PAGE = 7;
    const $485323c55f5a9010$var$IssueTable = ({ issues: issues })=>{
        const head = (0, (0, parcelRequire("iy3HT")).useTableHead)();
        const rows = (0, (0, parcelRequire("iy3HT")).useTableRows)(issues === 'loading' ? [] : issues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3qRI")).default), {
            rowsPerPage: issues !== 'loading' && issues.length > $485323c55f5a9010$var$ROWS_PER_PAGE ? $485323c55f5a9010$var$ROWS_PER_PAGE : undefined,
            isLoading: issues === 'loading',
            isFixedSize: true,
            head: head,
            rows: rows
        });
    };
    var $485323c55f5a9010$export$2e2bcd8739ae039 = $485323c55f5a9010$var$IssueTable;
});
parcelRegister("k3qRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60e4f0159aa1c87c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $gS5Cm;
    var $dHbUn;
    class $60e4f0159aa1c87c$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                defaultPage: 1,
                isLoading: false,
                isFixedSize: false,
                isRankable: false,
                onSetPage: (0, (0, parcelRequire("eGmKJ")).default),
                onSort: (0, (0, parcelRequire("eGmKJ")).default),
                rowsPerPage: Infinity
            };
        }
        UNSAFE_componentWillReceiveProps(newProps) {
            const sortKey = newProps.sortKey || this.state.sortKey;
            const sortOrder = newProps.sortOrder || this.state.sortOrder;
            const page = newProps.page || this.state.page;
            this.setState({
                page: page,
                sortKey: sortKey,
                sortOrder: sortOrder,
                rows: newProps.rows
            });
        }
        render() {
            const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
            const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dHbUn")).default), {
                paginationi18n: paginationi18n,
                caption: caption,
                emptyView: emptyView,
                head: head,
                highlightedRowIndex: highlightedRowIndex,
                loadingSpinnerSize: loadingSpinnerSize,
                isLoading: isLoading,
                loadingLabel: loadingLabel,
                isFixedSize: isFixedSize,
                onSetPage: this.onSetPageHandler,
                onSort: this.onSortHandler,
                page: page,
                rows: rows,
                rowsPerPage: rowsPerPage,
                sortKey: sortKey,
                sortOrder: sortOrder,
                isRankable: isRankable,
                isRankingDisabled: isRankingDisabled,
                onRankEnd: this.onRankEndHandler,
                onRankStart: onRankStart,
                onPageRowsUpdate: onPageRowsUpdate,
                testId: testId,
                label: label
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                page: this.props.defaultPage,
                sortKey: this.props.defaultSortKey,
                sortOrder: this.props.defaultSortOrder,
                rows: this.props.rows
            };
            this.onSetPageHandler = (page, analyticsEvent)=>{
                const { onSetPage: onSetPage } = this.props;
                if (onSetPage) {
                    onSetPage(page, analyticsEvent);
                    this.setState({
                        page: page
                    });
                }
            };
            this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
                const { onSort: onSort } = this.props;
                if (onSort) {
                    onSort({
                        key: key,
                        item: item,
                        sortOrder: sortOrder
                    }, analyticsEvent);
                    this.setState({
                        sortKey: key,
                        sortOrder: sortOrder
                    });
                }
            };
            this.onRankEndIfExistsHandler = (params)=>{
                if (this.props.onRankEnd) this.props.onRankEnd(params);
            };
            this.onRankEndHandler = (params)=>{
                const { destination: destination } = params;
                const { rows: rows, page: page } = this.state;
                const { rowsPerPage: rowsPerPage } = this.props;
                if (!destination || !rows) {
                    this.onRankEndIfExistsHandler(params);
                    return;
                }
                const reordered = (0, (0, parcelRequire("gS5Cm")).reorderRows)(params, rows, page, rowsPerPage);
                this.setState({
                    rows: reordered
                });
                this.onRankEndIfExistsHandler(params);
            };
        }
    }
});
parcelRegister("gS5Cm", function(module, exports) {
    $parcel$export(module.exports, "getPageRows", ()=>$7f55105045703159$export$3987dc24b734dcab);
    $parcel$export(module.exports, "assertIsSortable", ()=>$7f55105045703159$export$5eb35a4771ec4090);
    $parcel$export(module.exports, "validateSortKey", ()=>$7f55105045703159$export$9133f5a8bfe8a200);
    $parcel$export(module.exports, "inlineStylesIfRanking", ()=>$7f55105045703159$export$a601f1775e10043f);
    $parcel$export(module.exports, "reorderRows", ()=>$7f55105045703159$export$c476bbe5da59992d);
    const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
        if (!pageNumber || !rowsPerPage || !allRows.length) return [];
        return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
    };
    const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
        if (!head || !head.cells) return;
        head.cells.forEach((cell)=>{
            if (cell.isSortable && !cell.key) try {
                throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
            } catch (e) {
                console.error(e);
            }
        });
    };
    const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
        if (!sortKey) return;
        const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
        if (!headHasKey) try {
            throw Error(`Cell with ${sortKey} key not found in head.`);
        } catch (e) {
            console.error(e);
        }
    };
    const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
        if (!isRanking) return {};
        if (height) return {
            width: width,
            height: height
        };
        return {
            width: width
        };
    };
    const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
        const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
        return index + itemOnPreviousPages;
    };
    const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
        const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
        if (!destination) return rows;
        const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
        const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
        const reordered = rows.slice();
        const [removed] = reordered.splice(fromIndex, 1);
        reordered.splice(toIndex, 0, removed);
        return reordered;
    };
});
parcelRegister("dHbUn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb6422faa785b221$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $gS5Cm;
    var $hiWL0;
    var $kF3yx;
    var $fkvnY;
    var $hK8cd;
    var $dDBI6;
    var $dk72m;
    var $50Tma;
    var $jlnvO;
    function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
                return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
            case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
                return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
            default:
                return currentSortOrder;
        }
    }
    const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, (0, parcelRequire("eGmKJ")).default), onSort: providedOnSort = (0, (0, parcelRequire("eGmKJ")).default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, (0, parcelRequire("eGmKJ")).default), onRankEnd: providedOnRankEnd = (0, (0, parcelRequire("eGmKJ")).default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    } })=>{
        const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
        const tableBodyRef = (0, $5uXOq.useRef)(null);
        const onSort = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnSort,
            action: 'sorted',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onRankEnd = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnRankEnd,
            action: 'ranked',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
            (0, (0, parcelRequire("gS5Cm")).assertIsSortable)(head);
        }, [
            sortKey,
            head
        ]);
        const onSortHandler = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        const onSetPageHandler = (page, event)=>{
            onSetPage(page, event);
        };
        const onRankStartHandler = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        const onRankEndHandler = (params)=>{
            setIsRanking(false);
            onRankEnd(params);
        };
        const getSpinnerSize = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, (0, parcelRequire("gS5Cm")).getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
        };
        const renderEmptyBody = ()=>{
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
        const rowsLength = rows && rows.length;
        let totalPages;
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page;
        const rowsExist = !!rowsLength;
        const spinnerSize = getSpinnerSize();
        const emptyBody = renderEmptyBody();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dk72m")).default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>tableBodyRef.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Caption), null, caption), head && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jlnvO")).default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).PaginationWrapper), {
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("50Tma")).default), {
            value: getPageNumber,
            onChange: onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dDBI6")).default), {
            isLoading: isLoading,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    };
    const $cb6422faa785b221$var$RankableTableBody = (0, $5uXOq.lazy)(()=>(parcelRequire("f9SMa")));
    const $cb6422faa785b221$var$TableBody = (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
        const canRank = isRankable && !bodyProps.sortKey;
        const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (canRank) setCanRenderRankable(true);
        }, [
            canRank
        ]);
        const nonRankableBody = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkvnY")).default), {
            ref: ref,
            ...bodyProps
        });
        return canRank && canRenderRankable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hK8cd")).ErrorBoundary), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$RankableTableBody, {
            ref: ref,
            ...bodyProps,
            isRanking: isRanking,
            onRankStart: onRankStart,
            onRankEnd: onRankEnd,
            isRankingDisabled: isRankingDisabled
        }))) : nonRankableBody;
    });
    var $cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;
});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;
parcelRegister("hiWL0", function(module, exports) {
    $parcel$export(module.exports, "tableRowCSSVars", ()=>$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb);
    $parcel$export(module.exports, "Table", ()=>$3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "Caption", ()=>$3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
    $parcel$export(module.exports, "PaginationWrapper", ()=>$3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    function $3b29b0d00cd7b5c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb = {
        CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
        CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
        CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
        CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
    };
    const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = {
        name: "wgb42e",
        styles: "table-layout:fixed"
    };
    const $3b29b0d00cd7b5c6$var$tableStyles = {
        name: "mul4pg",
        styles: "width:100%;border-collapse:separate;border-spacing:0px"
    };
    const $3b29b0d00cd7b5c6$var$bodyBorder = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`
    });
    const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("table", {
            inert: isLoading ? '' : undefined,
            style: {
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).highlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverHighlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, (0, parcelRequire("54lmm")).row).focusOutline
            },
            css: [
                $3b29b0d00cd7b5c6$var$tableStyles,
                isFixedSize && $3b29b0d00cd7b5c6$var$fixedSizeTableStyles,
                hasDataRow && $3b29b0d00cd7b5c6$var$bodyBorder
            ],
            ref: ref,
            ...rest,
            "data-testid": testId && `${testId}--table`
        }, children);
    });
    const $3b29b0d00cd7b5c6$var$captionStyles = {
        name: "h9a27i",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
    };
    const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("caption", {
            css: $3b29b0d00cd7b5c6$var$captionStyles
        }, children);
    const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = {
        name: "zl1inp",
        styles: "display:flex;justify-content:center"
    };
    const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3b29b0d00cd7b5c6$var$paginationWrapperStyles,
            "data-testid": testId && `${testId}--pagination--container`
        }, children);
});
parcelRegister("54lmm", function(module, exports) {
    $parcel$export(module.exports, "MSThemeColors", ()=>$b728acac6d8ee4bc$export$34af08ce45c78352);
    $parcel$export(module.exports, "arrow", ()=>$b728acac6d8ee4bc$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "row", ()=>$b728acac6d8ee4bc$export$120ff0929b202a6d);
    $parcel$export(module.exports, "head", ()=>$b728acac6d8ee4bc$export$5fd5031fecdacec3);
    $parcel$export(module.exports, "tableBorder", ()=>$b728acac6d8ee4bc$export$38d703b73e2cf64d);
    const $b728acac6d8ee4bc$export$34af08ce45c78352 = {
        Background: 'Canvas',
        Text: 'CanvasText',
        SelectedBackground: 'Highlight',
        SelectedText: 'HighlightText'
    };
    const $b728acac6d8ee4bc$export$f2120bbfa5450bd2 = {
        defaultColor: `var(--ds-icon-disabled, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`,
        selectedColor: `var(--ds-icon-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$120ff0929b202a6d = {
        focusOutline: `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        highlightedBackground: `var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$e655ef011c4aa1a2})`,
        hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
    };
    const $b728acac6d8ee4bc$export$5fd5031fecdacec3 = {
        textColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$38d703b73e2cf64d = {
        borderColor: `var(--ds-border, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
});
parcelRegister("kF3yx", function(module, exports) {
    $parcel$export(module.exports, "EmptyViewWithFixedHeight", ()=>$0852c529eaab7231$export$8f45b9407d4090d7);
    $parcel$export(module.exports, "EmptyViewContainer", ()=>$0852c529eaab7231$export$381ea436de119582);
    var $f8Sb3;
    function $0852c529eaab7231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0852c529eaab7231$var$fixedHeightStyles = {
        name: "50gc26",
        styles: "height:9rem"
    };
    const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$fixedHeightStyles,
            "data-testid": testId && `${testId}--empty-view-with-fixed-height`
        }, children);
    const $0852c529eaab7231$var$emptyViewContainerStyles = {
        name: "1yld51o",
        styles: "width:50%;margin:auto;padding:10px;text-align:center"
    };
    const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$emptyViewContainerStyles,
            "data-testid": testId && `${testId}--empty-view-container`
        }, children);
    };
});
parcelRegister("fkvnY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32bba7afdbc8736a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7bJDt;
    var $ggqAE;
    class $32bba7afdbc8736a$var$BodyComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", {
                "data-testid": testId && `${testId}--body`,
                ref: forwardedRef
            }, pageRows.map((row, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ggqAE")).default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    key: row.key || rowIndex,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                })));
        }
    }
    const $32bba7afdbc8736a$var$Body = (0, (0, parcelRequire("7bJDt")).default)((0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($32bba7afdbc8736a$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
    }));
    var $32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;
});
parcelRegister("7bJDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc6eeecb3dc05edd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
        for(let i = 0; i < cells.length; i++){
            if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
        }
        return undefined;
    };
    const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
        if (!sortKey || !head) return rows;
        if (!rows) return [];
        const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'accent'
        });
        const sortableRows = Array.from(rows);
        return sortableRows.sort((a, b)=>{
            const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
            const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
            if (valA === undefined || valB === undefined) return modifier;
            if (typeof valA !== typeof valB) {
                if (typeof valA === 'number') return -1;
                if (typeof valB === 'number') return 1;
                if (typeof valA === 'string') return -1;
                if (typeof valB === 'string') return 1;
            }
            if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
            if (!valA && valA !== 0 || valA < valB) return -modifier;
            if (!valB && valB !== 0 || valA > valB) return modifier;
            if (valA === valB) return 0;
            return 1;
        });
    };
    function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
        class WithSortedPageRows extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static getDerivedStateFromProps(props, state) {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
                (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
                let sortedRows;
                let pageRows;
                if (isTotalPagesControlledExternally) {
                    sortedRows = rows;
                    pageRows = rows;
                } else {
                    sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                    pageRows = (0, (0, parcelRequire("gS5Cm")).getPageRows)(sortedRows, page, rowsPerPage);
                }
                return {
                    ...state,
                    pageRows: pageRows
                };
            }
            componentDidMount() {
                this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
            }
            componentDidUpdate(_prevProps, prevState) {
                if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
            }
            render() {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    pageRows: this.state.pageRows,
                    head: head,
                    ...restProps,
                    ref: forwardedRef
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    pageRows: []
                };
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
        });
    }
});
parcelRegister("ggqAE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$136b57fea50cecd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1g0dL;
    var $d9WgS;
    const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
        const { cells: cells, ...restRowProps } = row;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9WgS")).TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...isHighlighted ? {
                'data-ts--dynamic-table--table-row--highlighted': true
            } : null,
            testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
        }, cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1g0dL")).TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        }));
    };
    var $136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;
});
parcelRegister("1g0dL", function(module, exports) {
    $parcel$export(module.exports, "TableBodyCell", ()=>$11c3ea74eda01ab8$export$948e91fcef170792);
    var $f8Sb3;
    var $9GQPi;
    const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("td", {
            style: (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            css: [
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                (0, (0, parcelRequire("9GQPi")).cellStyles)
            ],
            ref: innerRef,
            ...props
        });
});
parcelRegister("9GQPi", function(module, exports) {
    $parcel$export(module.exports, "truncationWidthStyles", ()=>$99c9652c1fab2b08$export$708a733455f59a29);
    $parcel$export(module.exports, "fixedSizeTruncateStyles", ()=>$99c9652c1fab2b08$export$616c93ee022c8812);
    $parcel$export(module.exports, "overflowTruncateStyles", ()=>$99c9652c1fab2b08$export$7f2cd17defa265d8);
    $parcel$export(module.exports, "getTruncationStyleVars", ()=>$99c9652c1fab2b08$export$5e6497a652ae30b5);
    $parcel$export(module.exports, "cellStyles", ()=>$99c9652c1fab2b08$export$f7913df521f684e2);
    var $f8Sb3;
    function $99c9652c1fab2b08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
    const $99c9652c1fab2b08$export$708a733455f59a29 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `var(${$99c9652c1fab2b08$var$CSS_VAR_WIDTH})`
    });
    const $99c9652c1fab2b08$export$616c93ee022c8812 = {
        name: "1s7jr4j",
        styles: "text-overflow:ellipsis;white-space:nowrap"
    };
    const $99c9652c1fab2b08$export$7f2cd17defa265d8 = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
            [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
        } : undefined;
    const $99c9652c1fab2b08$export$f7913df521f684e2 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        border: 'none',
        textAlign: 'left',
        '&:first-of-type': {
            paddingInlineStart: "var(--ds-space-0, 0px)"
        },
        '&:last-child': {
            paddingInlineEnd: "var(--ds-space-0, 0px)"
        }
    });
});
parcelRegister("d9WgS", function(module, exports) {
    $parcel$export(module.exports, "TableBodyRow", ()=>$ba9cb59faf06ce7f$export$45f39d9c38b886d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hiWL0;
    const $ba9cb59faf06ce7f$var$rowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        '&:focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
            outlineOffset: `-2px`
        }
    });
    const $ba9cb59faf06ce7f$var$rowBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("tr", {
            style: style,
            css: [
                $ba9cb59faf06ce7f$var$rowStyles,
                isHighlighted ? $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles : $ba9cb59faf06ce7f$var$rowBackgroundStyles
            ],
            ...rest,
            ref: ref,
            "data-testid": testId
        }, children);
    });
});
parcelRegister("hK8cd", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$883137116243a6a0$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $883137116243a6a0$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        render() {
            if (this.state.hasError) return this.props.fallback;
            return this.props.children;
        }
    }
});
parcelRegister("dDBI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4b90b361173610$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $lLAKY;
    class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
                loadingLabel: 'Loading table'
            };
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).Container), {
                testId: testId
            }, !isLoading ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).ContentsContainer), {
                contentsOpacity: contentsOpacity,
                testId: testId
            }, children), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).SpinnerContainer), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            })));
        }
    }
});
parcelRegister("lLAKY", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$d0e2766ad96d94ad$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ContentsContainer", ()=>$d0e2766ad96d94ad$export$67c29eae8ae2137a);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$d0e2766ad96d94ad$export$a5e06607a5ac6158);
    var $f8Sb3;
    function $d0e2766ad96d94ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
    const $d0e2766ad96d94ad$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$containerStyles,
            "data-testid": testId && `${testId}--container`
        }, children);
    const $d0e2766ad96d94ad$var$contentsContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: `var(${$d0e2766ad96d94ad$export$c335a80381ec61f5})`,
        pointerEvents: 'none'
    });
    const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
            },
            css: [
                $d0e2766ad96d94ad$var$contentsContainerStyles
            ],
            "data-testid": testId && `${testId}--contents--container`
        }, children);
    const $d0e2766ad96d94ad$var$spinnerContainerStyles = {
        name: "su4u96",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
    };
    const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$spinnerContainerStyles,
            "data-testid": testId && `${testId}--spinner--container`
        }, children);
});
parcelRegister("dk72m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba39c903b39a83b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $4xXH4;
    class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
                loadingLabel: 'Loading table'
            };
        }
        attachListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
        }
        detachListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
        updateSpinnerPosition() {
            const viewportHeight = window.innerHeight;
            const targetNode = this.getTargetNode();
            const spinnerNode = this.spinnerRef?.current;
            if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
            const targetRect = targetNode.getBoundingClientRect();
            const spinnerRect = spinnerNode.getBoundingClientRect();
            const spinnerHeight = spinnerRect.height;
            const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
            const { top: top, bottom: bottom, height: height } = targetRect;
            if (isInViewport) {
                const canFollow = height >= spinnerHeight * 3;
                if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                    if (top >= 0) {
                        const viewportSpaceTakenByElement = viewportHeight - top;
                        const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                        const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    } else if (top < 0 && bottom > viewportHeight) {
                        const y = viewportHeight / 2 - spinnerHeight / 2;
                        this.translateSpinner(spinnerNode, y, true);
                    } else {
                        const diff = bottom / 2 - spinnerHeight / 2;
                        const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    }
                    return;
                }
            } else {
                if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
            }
            const containerNode = this.containerRef?.current;
            if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                const thisTop = containerNode.getBoundingClientRect().top;
                const y = (top - thisTop) / 2;
                this.translateSpinner(spinnerNode, y, false);
            }
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).Container), {
                testId: testId && `${testId}--loading--container--advanced`,
                ref: this.containerRef
            }, children, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerBackdrop), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerContainer), {
                ref: this.spinnerRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            }))));
        }
        constructor(...args){
            super(...args);
            this.spinnerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.componentDidMount = ()=>{
                if (this.props.isLoading && this.hasTargetNode()) {
                    this.attachListeners();
                    this.updateTargetAppearance();
                    this.updateSpinnerPosition();
                }
            };
            this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
                if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
                else if (!this.props.isLoading) this.attachListeners();
            };
            this.componentDidUpdate = ()=>{
                if (this.hasTargetNode()) {
                    this.updateTargetAppearance();
                    if (this.props.isLoading) this.updateSpinnerPosition();
                }
            };
            this.componentWillUnmount = ()=>{
                this.detachListeners();
            };
            this.getTargetNode = (nextProps = this.props)=>{
                const { targetRef: targetRef } = nextProps;
                const target = targetRef?.();
                return target || this.containerRef.current;
            };
            this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
            this.isVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                if (bottom <= 0) return false;
                return top < viewportHeight;
            };
            this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                return top >= 0 && bottom <= viewportHeight;
            };
            this.handleResize = ()=>{
                this.updateSpinnerPosition();
            };
            this.handleScroll = ()=>{
                this.updateSpinnerPosition();
            };
            this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
                spinnerNode.style.position = isFixed ? 'fixed' : '';
                spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
            };
            this.updateTargetAppearance = ()=>{
                const targetNode = this.getTargetNode();
                const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
                if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                    targetNode.style.pointerEvents = isLoading ? 'none' : '';
                    targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
                }
            };
        }
    }
});
parcelRegister("4xXH4", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$48301faf1109874f$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SpinnerBackdrop", ()=>$48301faf1109874f$export$aa207050321b0c53);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$48301faf1109874f$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $48301faf1109874f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48301faf1109874f$var$containerStyles = {
        name: "17fhw1k",
        styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
    };
    const $48301faf1109874f$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$containerStyles,
            ...rest,
            "data-testid": testId,
            ref: ref
        }, children));
    });
    const $48301faf1109874f$var$spinnerBackdropStyles = {
        name: "1yy6mjk",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
    };
    const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerBackdropStyles,
            "data-testid": testId && `${testId}--spinner-backdrop`
        }, children);
    const $48301faf1109874f$var$spinnerContainerStyles = {
        name: "vi3nlf",
        styles: "position:relative;inset-block-start:0"
    };
    const $48301faf1109874f$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ children: children }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerContainerStyles,
            ref: ref
        }, children));
});
parcelRegister("50Tma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21d5ee5c6331aeb9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $xBgAj;
    class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
            const pages = [
                ...Array(total)
            ].map((_, index)=>index + 1);
            const selectedIndex = value - 1;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xBgAj")).default), {
                selectedIndex: selectedIndex,
                isDisabled: isDisabled,
                label: i18n?.label,
                nextLabel: i18n?.next,
                previousLabel: i18n?.prev,
                pageLabel: i18n?.pageLabel,
                onChange: this.onChange,
                pages: pages,
                testId: testId && `${testId}--pagination`
            });
        }
        constructor(...args){
            super(...args);
            this.onChange = (_event, newValue, analyticsEvent)=>{
                this.props.onChange(newValue, analyticsEvent);
            };
        }
    }
});
parcelRegister("xBgAj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8aaadfaafd170b3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $33etG;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $5HBW9;
    var $15F6T;
    var $lmPue;
    var $fc5SA;
    var $gRWrA;
    const $8aaadfaafd170b3c$var$analyticsAttributes = {
        componentName: 'pagination',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $8aaadfaafd170b3c$var$paginationMenuStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0',
        margin: 'space.0'
    });
    const $8aaadfaafd170b3c$var$paginationMenuItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.0'
    });
    const $8aaadfaafd170b3c$var$navigatorIconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.075'
    });
    function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
        const Chevron = chevronDirection === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))) : (0, ($parcel$interopDefault((0, parcelRequire("6s76W")))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $8aaadfaafd170b3c$var$navigatorIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        }));
    }
    function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, (0, parcelRequire("fc5SA")).emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, (0, parcelRequire("fc5SA")).emptyObject), max: max = 7, onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, (0, parcelRequire("lmPue")).default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
        const [selectedIndexValue, setSelectedIndexValue] = (0, (0, parcelRequire("33etG")).default)(selectedIndex, ()=>defaultSelectedIndex || 0);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                const { event: event, selectedPageIndex: selectedPageIndex } = value;
                if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
                if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
            },
            action: 'changed',
            actionSubject: 'pageNumber',
            analyticsData: analyticsContext,
            ...$8aaadfaafd170b3c$var$analyticsAttributes
        });
        const transform = (page, currPageIndex, testId)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                as: "li",
                xcss: $8aaadfaafd170b3c$var$paginationMenuItemStyles,
                key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("15F6T")).default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
            }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "left-navigator",
            component: components.Previous,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue - 1
                }),
            isDisabled: isDisabled || selectedIndexValue === 0,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "left"
            }),
            "aria-label": previousLabel,
            testId: testId && `${testId}--left-navigator`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $8aaadfaafd170b3c$var$paginationMenuStyles
        }, (0, (0, parcelRequire("gRWrA")).default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "right-navigator",
            component: components.Next,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue + 1
                }),
            isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "right"
            }),
            "aria-label": nextLabel,
            testId: testId && `${testId}--right-navigator`
        }))));
    }
    const $8aaadfaafd170b3c$var$Pagination = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
    var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("5HBW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63acbbc2953d9b5a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-label": props['aria-label'],
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
    }
});
parcelRegister("15F6T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097dd42f19f41562$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            appearance: "subtle"
        });
    }
});
parcelRegister("lmPue", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d144cd0d91a90ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $jldZL;
    const $3d144cd0d91a90ab$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        position: 'relative'
    });
    function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "li",
            testId: testId,
            key: key,
            xcss: $3d144cd0d91a90ab$var$containerStyles,
            paddingInline: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            testId: testId && `${testId}-text`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
    }
});
parcelRegister("fc5SA", function(module, exports) {
    $parcel$export(module.exports, "emptyObject", ()=>$cbef1c2cfb373aca$export$3f860eba1218f8d3);
    const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};
});
parcelRegister("gRWrA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48fbac64848b775a$export$2e2bcd8739ae039);
    var $8QpSo;
    const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
        const total = pages.length;
        const needEllipsis = total > max;
        const hasStartEllipsis = needEllipsis && max - 4 < current;
        const hasEndEllipsis = needEllipsis && current < total - max + 3;
        const getPageComponents = (0, (0, parcelRequire("8QpSo")).default)((startIndex = 0, lastIndex = total)=>{
            return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
        });
        if (!needEllipsis) return getPageComponents(0, total);
        if (hasStartEllipsis && !hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, 1),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: 2,
                    to: total - pageCount
                }),
                ...getPageComponents(total - pageCount)
            ];
        }
        if (!hasStartEllipsis && hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, pageCount),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: pageCount + 1,
                    to: total - 1
                }),
                ...getPageComponents(total - 1)
            ];
        }
        const pageCount = max - 4;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: current - Math.floor(pageCount / 2)
            }),
            ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
            ellipsis({
                key: 'ellipsis-2',
                testId: testId && `${testId}-ellipsis`,
                from: current + 3,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    };
    var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;
});
parcelRegister("jlnvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097ee65829e33b82$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    var $9Ooyy;
    var $a41RA;
    var $dpXLF;
    class $097ee65829e33b82$var$TableHead extends (0, ($parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillMount() {
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(this.props.sortKey, this.props.head);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, (0, parcelRequire("gS5Cm")).validateSortKey)(nextProps.sortKey, nextProps.head);
        }
        render() {
            const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
            if (!head) return null;
            const HeadCellComponent = isRankable ? (0, (0, parcelRequire("a41RA")).default) : (0, (0, parcelRequire("dpXLF")).default);
            const { cells: cells, ...rest } = head;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).Head), {
                ...rest,
                isRanking: isRanking,
                testId: testId && `${testId}--head`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
                const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, ...restCellProps } = cell;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                    colSpan: colSpan,
                    content: content,
                    isFixedSize: isFixedSize,
                    isSortable: !!isSortable,
                    isRanking: isRanking,
                    key: key || index,
                    onClick: isSortable ? onSort(cell) : undefined,
                    testId: cellTestId || testId,
                    shouldTruncate: shouldTruncate,
                    sortOrder: key === sortKey ? sortOrder : undefined,
                    width: width,
                    ...restCellProps
                });
            })));
        }
    }
    var $097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;
});
parcelRegister("9Ooyy", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$e002e0403dc403bb$export$e93312b7773dfcac);
    $parcel$export(module.exports, "HeadCell", ()=>$e002e0403dc403bb$export$4e8024263ace498b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    var $9GQPi;
    function $e002e0403dc403bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
    const $e002e0403dc403bb$var$rankingStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $e002e0403dc403bb$var$headStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `none`
    });
    const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("thead", {
            css: [
                $e002e0403dc403bb$var$headStyles,
                isRanking && $e002e0403dc403bb$var$rankingStyles
            ],
            "data-testid": testId,
            ...props
        });
    };
    const $e002e0403dc403bb$var$headCellBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        position: 'relative',
        border: 'none',
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`,
        color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textAlign: 'left',
        verticalAlign: 'top',
        '&:focus-visible': {
            outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $e002e0403dc403bb$var$onClickStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            cursor: 'pointer'
        }
    });
    const $e002e0403dc403bb$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            padding: "var(--ds-space-0, 0)",
            position: 'relative',
            appearance: 'none',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            '&::before, &::after': {
                display: 'block',
                width: 0,
                height: 0,
                position: 'absolute',
                border: '3px solid transparent',
                content: '""',
                insetInlineEnd: "var(--ds-space-negative-100, -8px)"
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: "var(--ds-space-100, 8px)"
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: 0
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before, &::after': {
                    border: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Background}`
                },
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                },
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$ascendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$descendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$export$4e8024263ace498b = (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
        const mergedStyles = {
            ...style,
            ...width && (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: (0, (0, parcelRequire("54lmm")).head).textColor
        };
        const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
        const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
        const getFormattedSortOrder = ()=>{
            if (isASC) return 'ascending';
            else if (isDESC) return 'descending';
        };
        const Component = children ? 'th' : 'td';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            "aria-sort": getFormattedSortOrder(),
            style: mergedStyles,
            css: [
                (0, (0, parcelRequire("9GQPi")).cellStyles),
                $e002e0403dc403bb$var$headCellBaseStyles,
                onClick && $e002e0403dc403bb$var$onClickStyles,
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                isSortable && $e002e0403dc403bb$var$baseStyles,
                isASC && $e002e0403dc403bb$var$ascendingStyles,
                isDESC && $e002e0403dc403bb$var$descendingStyles
            ],
            onClick: onClick,
            ref: ref,
            "data-testid": testId,
            ...rest
        }, children);
    });
});
parcelRegister("a41RA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$669a06e89a9827f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cVljL;
    var $gS5Cm;
    var $dpXLF;
    class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
            const inlineStyles = (0, (0, parcelRequire("gS5Cm")).inlineStylesIfRanking)(isRanking, refWidth);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dpXLF")).default), {
                inlineStyles: inlineStyles,
                ...restProps
            });
        }
    }
    const $669a06e89a9827f7$var$RankableTableHeadCell = (0, (0, parcelRequire("cVljL")).default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
    var $669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;
});
parcelRegister("cVljL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3e49a9b167764eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
        return class WithDimensions extends (0, ($parcel$interopDefault($5uXOq))).Component {
            UNSAFE_componentWillReceiveProps(nextProps) {
                const wasRanking = this.props.isRanking;
                const willRanking = nextProps.isRanking;
                if (willRanking && !wasRanking) this.updateDimensions();
            }
            render() {
                const { refWidth: refWidth, refHeight: refHeight } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    refWidth: refWidth,
                    refHeight: refHeight,
                    innerRef: this.innerRef,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    refWidth: 0,
                    refHeight: 0
                };
                this.innerRef = (ref)=>{
                    if (ref && !this.props.isRanking) this.ref = ref;
                };
                this.updateDimensions = ()=>{
                    if (!this.ref) return;
                    const clientRect = this.ref.getBoundingClientRect();
                    const { width: width } = clientRect;
                    const { height: height } = clientRect;
                    if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                        refWidth: width,
                        refHeight: height
                    });
                };
            }
        };
    }
});
parcelRegister("dpXLF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9c80f4a483cfd6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Ooyy;
    const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).HeadCell), {
            style: inlineStyles,
            testId: testId && `${testId}--head--cell`,
            ref: typeof innerRef !== 'string' ? innerRef : null,
            ...rest,
            onClick: onClick,
            isSortable: isSortable
        }, isSortable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            type: "button",
            "aria-roledescription": "Sort button"
        }, content) : content);
    };
    var $d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;
});
parcelRegister("f9SMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("bz1jP")
    ]).then(()=>parcelRequire('4THp8'));
});
parcelRegister("iy3HT", function(module, exports) {
    $parcel$export(module.exports, "useTableHead", ()=>$1dcad16b66d94292$export$c1593f9fc5eec62b);
    $parcel$export(module.exports, "useTableRows", ()=>$1dcad16b66d94292$export$a190e1af00082b41);
    var $5uXOq = parcelRequire("5uXOq");
    var $2EwJD;
    var $koVbs;
    var $difD3;
    var $kun5c;
    var $eUfvr;
    const $1dcad16b66d94292$export$c1593f9fc5eec62b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return {
            cells: [
                {
                    width: 55,
                    key: 'issue',
                    content: formatMessage((0, (0, parcelRequire("kun5c")).default).issue)
                },
                {
                    width: 25,
                    key: 'assignee',
                    content: formatMessage((0, (0, parcelRequire("kun5c")).default).assignee)
                },
                {
                    width: 20,
                    key: 'status',
                    content: formatMessage((0, (0, parcelRequire("kun5c")).default).status)
                }
            ]
        };
    };
    const $1dcad16b66d94292$export$a190e1af00082b41 = (issues)=>issues.map(({ key: key, summary: summary, issueType: issueType, assignee: assignee, status: status })=>({
                cells: [
                    {
                        key: key,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eUfvr")).default), {
                            issueKey: key,
                            issueTypeIconUrl: issueType.iconUrl,
                            summary: summary
                        })
                    },
                    {
                        key: key,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("difD3")).default), {
                            assignee: assignee
                        })
                    },
                    {
                        key: key,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2EwJD")).default), {
                            name: status.name,
                            category: status.category
                        })
                    }
                ]
            }));
});
parcelRegister("2EwJD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd41c6095391bfc6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $gULOk;
    const $cd41c6095391bfc6$var$statusCategoryToAppearenceMap = {
        [(0, (0, parcelRequire("gULOk")).UNDEFINED)]: 'default',
        [(0, (0, parcelRequire("gULOk")).TODO)]: 'default',
        [(0, (0, parcelRequire("gULOk")).DONE)]: 'success',
        [(0, (0, parcelRequire("gULOk")).IN_PROGRESS)]: 'inprogress'
    };
    class $cd41c6095391bfc6$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isActive: false
            };
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                testId: "common-components-status-lozenge.status-lozenge",
                isBold: this.props.isActive,
                appearance: $cd41c6095391bfc6$var$statusCategoryToAppearenceMap[this.props.category],
                maxWidth: this.props.isFullWidth ? '100%' : undefined
            }, this.props.name);
        }
    }
});
parcelRegister("difD3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fdaceead66c5adeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    const $fdaceead66c5adeb$var$AssigneeCell = ({ assignee: assignee })=>(0, ($parcel$interopDefault($5uXOq))).createElement($fdaceead66c5adeb$var$Container, null, assignee === 'unassigned' ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "circle",
            src: assignee.avatarUrl,
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($fdaceead66c5adeb$var$Name, null, assignee.displayName)));
    var $fdaceead66c5adeb$export$2e2bcd8739ae039 = $fdaceead66c5adeb$var$AssigneeCell;
    const $fdaceead66c5adeb$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _4t3izwfg _8mocu2gc",
                __cmplp.className
            ])
        });
    });
    const $fdaceead66c5adeb$var$Name = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kun5c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a94a439d5d7d0921$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a94a439d5d7d0921$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issue: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.body.issue-table.issue",
            "defaultMessage": "Issue"
        },
        assignee: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.body.issue-table.assignee",
            "defaultMessage": "Assignee"
        },
        status: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.body.issue-table.status",
            "defaultMessage": "Status"
        }
    });
});
parcelRegister("eUfvr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f27e549efb4b13e4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hDzhb;
    const $f27e549efb4b13e4$var$SummaryCell = ({ issueKey: issueKey, summary: summary, issueTypeIconUrl: issueTypeIconUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement($f27e549efb4b13e4$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($f27e549efb4b13e4$var$IssueTypeIcon, {
            src: issueTypeIconUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($f27e549efb4b13e4$var$IssueKeyLink, {
            href: `/browse/${issueKey}`,
            target: "_blank"
        }, issueKey), (0, ($parcel$interopDefault($5uXOq))).createElement($f27e549efb4b13e4$var$IssueSummary, null, summary));
    var $f27e549efb4b13e4$export$2e2bcd8739ae039 = $f27e549efb4b13e4$var$SummaryCell;
    const $f27e549efb4b13e4$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $f27e549efb4b13e4$var$IssueTypeIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i7vkz _1bsb7vkz _18s8m31d _2rkoyh40 _16jlidpf _1o9zidpf _i0dl1wug _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
    const $f27e549efb4b13e4$var$IssueSummary = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $f27e549efb4b13e4$var$IssueKeyLink = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3lx3f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d57e97d7d913613$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1dJ6S;
    var $gwIPs;
    var $koVbs;
    var $5oFIy;
    var $3Uttp;
    var $6HxlU = parcelRequire("6HxlU");
    var $jUO7W;
    const $6d57e97d7d913613$var$useHelpLink = ()=>{
        const isSimplified = (0, (0, parcelRequire("3Uttp")).useProjectSimplified)();
        if (isSimplified === null) return undefined;
        return isSimplified ? 'https://support.atlassian.com/jira-software-cloud/docs/next-gen-permissions/#Overviewofpermissionsinnextgenprojects-Projectpermissions' : 'https://support.atlassian.com/jira-cloud-administration/docs/permissions-for-company-managed-projects';
    };
    const $6d57e97d7d913613$var$NoPermissionForAnyIssues = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const helpLink = $6d57e97d7d913613$var$useHelpLink();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6d57e97d7d913613$var$Container, {
            "data-test-id": "software-deployment-frequency-report-deployment-details-dialog.ui.body.no-permission.container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                noPermissionForAnyIssues: true
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($6HxlU))),
            alt: "",
            width: 14 * (0, (0, parcelRequire("gwIPs")).gridSize)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($6d57e97d7d913613$var$Explanation, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "large"
        }, formatMessage((0, (0, parcelRequire("jUO7W")).default).title)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("jUO7W")).default).description), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: helpLink,
            target: "_blank"
        }, formatMessage((0, (0, parcelRequire("jUO7W")).default).learnMore)))));
    };
    var $6d57e97d7d913613$export$2e2bcd8739ae039 = $6d57e97d7d913613$var$NoPermissionForAnyIssues;
    const $6d57e97d7d913613$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ixilx _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $6d57e97d7d913613$var$Explanation = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1pna _18u0xncg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3Uttp", function(module, exports) {
    $parcel$export(module.exports, "useProjectSimplified", ()=>$f12a03f526c05746$export$9f0c70b531288073);
    $parcel$export(module.exports, "useProjectAnalyticsAttributes", ()=>$f12a03f526c05746$export$b6a91b2d78273787);
    var $dAfqg;
    var $g5X3G;
    var $bmKPg;
    const $f12a03f526c05746$export$f87be37f8e8be65 = ()=>{
        const [projectKey] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        if (projectKey == null) throw new Error('Project key missing');
        return (0, (0, parcelRequire("g5X3G")).toProjectKey)(projectKey);
    };
    const $f12a03f526c05746$export$16d1475ed6c26568 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        return data === null ? null : (0, (0, parcelRequire("g5X3G")).toProjectId)(`${data.projectId}`);
    };
    const $f12a03f526c05746$export$4d975d76445a6650 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        if (data === null) return null;
        const { isProjectAdmin: isProjectAdmin } = data;
        return isProjectAdmin === undefined ? null : isProjectAdmin;
    };
    const $f12a03f526c05746$export$9f0c70b531288073 = ()=>{
        const { data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        return data === null ? null : data.simplified;
    };
    const $f12a03f526c05746$export$b6a91b2d78273787 = ()=>{
        const projectId = $f12a03f526c05746$export$16d1475ed6c26568();
        const isProjectAdmin = $f12a03f526c05746$export$4d975d76445a6650();
        const isProjectSimplified = $f12a03f526c05746$export$9f0c70b531288073();
        if (projectId === null || isProjectAdmin === null || isProjectSimplified === null) return null;
        return {
            isSimplified: isProjectSimplified,
            isProjectAdmin: isProjectAdmin,
            projectId: projectId
        };
    };
});
parcelRegister("6HxlU", function(module, exports) {
    module.exports = new URL("lock-closed.123c4a2f.svg", import.meta.url).toString();
});
parcelRegister("jUO7W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c49dd5f0e1b6e809$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c49dd5f0e1b6e809$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.body.no-permission.title",
            "defaultMessage": "Limited issue permissions"
        },
        description: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.body.no-permission.description",
            "defaultMessage": "You don't have permission to view the issues included in this deployment. Contact project admin for details."
        },
        learnMore: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.body.no-permission.learn-more",
            "defaultMessage": "Learn more."
        }
    });
});
parcelRegister("2uWzn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03a64c4135f12f24$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $lLLkM;
    var $jgVsb;
    var $gofOI;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $gIl2t;
    var $lmtHl;
    var $3VYpx;
    const $03a64c4135f12f24$var$CloseButton = ({ onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onClose,
            spacing: "none",
            appearance: "subtle"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($03a64c4135f12f24$var$CloseIconContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
            label: formatMessage((0, (0, parcelRequire("3VYpx")).default).closeButtonLabel)
        })));
    };
    const $03a64c4135f12f24$var$Header = ({ onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($03a64c4135f12f24$var$LeftSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, (0, parcelRequire("3VYpx")).default).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $03a64c4135f12f24$var$helpIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gIl2t")).default), {
            message: formatMessage((0, (0, parcelRequire("3VYpx")).default).helpTooltip)
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement($03a64c4135f12f24$var$RightSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $03a64c4135f12f24$var$feedbackButtonWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lmtHl")).FeedbackButton), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($03a64c4135f12f24$var$CloseButton, {
            onClose: onClose
        })));
    };
    var $03a64c4135f12f24$export$2e2bcd8739ae039 = $03a64c4135f12f24$var$Header;
    const $03a64c4135f12f24$var$LeftSection = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $03a64c4135f12f24$var$helpIconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
    const $03a64c4135f12f24$var$RightSection = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $03a64c4135f12f24$var$feedbackButtonWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.100'
    });
    const $03a64c4135f12f24$var$CloseIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lmtHl", function(module, exports) {
    $parcel$export(module.exports, "FeedbackButton", ()=>$bf37f71af7cf7cad$export$116fedbe5e2e2bd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $7iULw;
    var $coTzA;
    var $fMtXj;
    var $fPB66;
    var $3Uttp;
    const $bf37f71af7cf7cad$var$FEEDBACK_COLLECTOR_LOCATION = 'reports.deployment-frequency.deployment-details-dialog';
    const $bf37f71af7cf7cad$export$116fedbe5e2e2bd8 = ()=>{
        const { data: deploymentProviders, error: errorDeploymentProviders } = (0, (0, parcelRequire("fMtXj")).useDeploymentProviders)();
        const projectAttributes = (0, (0, parcelRequire("3Uttp")).useProjectAnalyticsAttributes)();
        if (projectAttributes === null) return null;
        if (errorDeploymentProviders) throw new Error(`Getting deployment providers failed when using useDeploymentProviders while attempting to display Deployment Frequency Report feedback button. Details: ${errorDeploymentProviders.message}`);
        const additionalFeedbackEntries = [
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                value: $bf37f71af7cf7cad$var$FEEDBACK_COLLECTOR_LOCATION
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: projectAttributes.isSimplified.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                value: projectAttributes.isProjectAdmin.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).DEPLOYMENT_PROVIDERS,
                value: deploymentProviders ? (0, (0, parcelRequire("fPB66")).hideUGCProviderName)(deploymentProviders).map((deploymentProvider)=>deploymentProvider.name).join(', ') : ''
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("coTzA")).FeedbackCollectorButton), {
            entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
            feedbackContext: additionalFeedbackEntries
        });
    };
});
parcelRegister("coTzA", function(module, exports) {
    $parcel$export(module.exports, "FeedbackCollectorButton", ()=>$85f5e51eda76fbac$export$b39479f42d974760);
    var $5uXOq = parcelRequire("5uXOq");
    var $aEHvW;
    var $3bDjY;
    var $koVbs;
    var $koeKL;
    var $7iULw;
    var $dseDh;
    var $4uMrp;
    var $78EsV;
    const $85f5e51eda76fbac$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (appearance === 'icon') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: customLabel || formatMessage((0, (0, parcelRequire("4uMrp")).messages).leaveFeedback),
            position: "top"
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $85f5e51eda76fbac$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, ($parcel$interopDefault((0, parcelRequire("aEHvW"))))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const buttonRef = (0, $5uXOq.useRef)(null);
        const onOpen = (0, $5uXOq.useCallback)(()=>{
            const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, (0, parcelRequire("7iULw")).EntryKeys).CLOUD_ID);
            const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
                ...feedbackCollectorProps.feedbackContext || [],
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).CLOUD_ID,
                    value: cloudId
                }
            ];
            openFeedbackCollector({
                ...feedbackCollectorProps,
                feedbackContext: updatedFeedbackContext,
                triggerRef: buttonRef
            });
        }, [
            cloudId,
            feedbackCollectorProps,
            openFeedbackCollector
        ]);
        const displayAsLink = buttonAppearance === 'link';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$TooltipWrapper, {
            appearance: buttonAppearance,
            customLabel: feedbackButtonCustomLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("78EsV")).StyledButton), {
            testId: testId,
            ref: buttonRef,
            appearance: displayAsLink ? 'link' : 'subtle',
            isHighlight: buttonAppearance === 'highlight',
            spacing: displayAsLink ? 'none' : 'default',
            onClick: onOpen,
            iconBefore: displayAsLink ? undefined : (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
                label: ""
            }),
            "aria-label": feedbackButtonCustomLabel || formatMessage((0, (0, parcelRequire("4uMrp")).messages).leaveFeedback)
        }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, (0, parcelRequire("4uMrp")).messages).leaveFeedback))));
    };
});
parcelRegister("aEHvW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));
    var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
    function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>$7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
            LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
        }, props));
    $7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
    var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;
});
parcelRegister("5dqGX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3cc2df171aca9493$var$_UNSAFE_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3cc2df171aca9493$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3cc2df171aca9493$var$FeedbackIcon = (props)=>$3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
        }, props));
    $3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;
});
parcelRegister("3g1Fk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
    function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>$25f4287f17f73dc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
        }, props, {
            newIcon: $25f4287f17f73dc4$var$_feedback.default
        }));
    $25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;
});
parcelRegister("4uMrp", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$0c42512912e196d1$export$defe85febe8b728c);
    var $7VHMR;
    const $0c42512912e196d1$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        leaveFeedback: {
            "id": "platform.feedback.feedback-collector.button.leave-feedback",
            "defaultMessage": "Give feedback"
        }
    });
});
parcelRegister("78EsV", function(module, exports) {
    $parcel$export(module.exports, "StyledButton", ()=>$7dd11fab8c31bfcb$export$2d5d2ba3c7c8c40b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    const $7dd11fab8c31bfcb$export$2d5d2ba3c7c8c40b = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isHighlight && "_1w901gqr _16hg1y1p _1fh11gqr _u1mb1hhp _1l5a1gfe _r7sm8kjj",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3VYpx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27866dc30ad89711$export$2e2bcd8739ae039);
    var $7VHMR;
    var $27866dc30ad89711$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.header.title",
            "defaultMessage": "Deployment navigator"
        },
        helpTooltip: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.header.help-tooltip",
            "defaultMessage": "Drill-down to your deployment to understand what issues were included with it."
        },
        closeButtonLabel: {
            "id": "software-deployment-frequency-report-deployment-details-dialog.header.close-button-label",
            "defaultMessage": "Close"
        }
    });
});
parcelRegister("aJIPS", function(module, exports) {
    $parcel$export(module.exports, "hasPermissionForAllIssues", ()=>$ecdd2e247f4b9faa$export$3bc7b8d402ccf8a);
    const $ecdd2e247f4b9faa$export$3bc7b8d402ccf8a = (deployment)=>deployment.issueCount === deployment.issueIds.length;
});
parcelRegister("lVXtL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c55c6a1238404e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1dJ6S;
    var $dC5iT;
    var $kgoHi;
    var $jS4lj;
    var $41j30;
    var $cS37j;
    var $koVbs;
    var $auDmG;
    var $8zOmE;
    var $2NMNM;
    var $9F5Tv;
    var $doZTA;
    var $ecd0S;
    var $j1sSt;
    var $ilLj2;
    var $1yYqj;
    var $kk2bk;
    const $7c55c6a1238404e7$var$Header = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isSimplified = (0, (0, parcelRequire("ilLj2")).useProjectSimplified)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const breadcrumbs = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null);
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const boardId = match.params.boardId ?? '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            breadcrumbs: breadcrumbs,
            truncateTitle: true,
            disableTitleStyles: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c55c6a1238404e7$var$HeaderTopContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($7c55c6a1238404e7$var$TitleContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "large"
        }, formatMessage((0, (0, parcelRequire("kk2bk")).default).title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j1sSt")).NonCriticalErrorBoundary), {
            fallback: "unmount",
            eventLocation: "feedbackButton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1yYqj")).FeedbackButton), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingInlineStart: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9F5Tv")).JswShareButton), {
            boardId: boardId
        }))))), (0, ($parcel$interopDefault($5uXOq))).createElement($7c55c6a1238404e7$var$HeaderContent, null, (0, ($parcel$interopDefault($5uXOq))).createElement($7c55c6a1238404e7$var$PageDescription, null, formatMessage((0, (0, parcelRequire("kk2bk")).default).description), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("auDmG")).HelpPanelButton), {
            articleId: (0, (0, parcelRequire("ecd0S")).IN_PRODUCT_HELP_ARTICLE_ID),
            appearance: "link",
            spacing: "none",
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'deploymentFrequencyLearnMore'
                }));
            },
            fallbackComponent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41j30")).default), {
                href: isSimplified === true ? (0, (0, parcelRequire("ecd0S")).DEPLOYMENT_FREQUENCY_LEARN_MORE_TEAM_MANAGED) : (0, (0, parcelRequire("ecd0S")).DEPLOYMENT_FREQUENCY_LEARN_MORE_COMPANY_MANAGED),
                target: "_blank",
                onClick: ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'deploymentFrequencyLearnMore'
                    }));
                }
            }, formatMessage((0, (0, parcelRequire("kk2bk")).default).learnMore))
        }, formatMessage((0, (0, parcelRequire("kk2bk")).default).learnMore)))));
    };
    var $7c55c6a1238404e7$export$2e2bcd8739ae039 = $7c55c6a1238404e7$var$Header;
    const $7c55c6a1238404e7$var$HeaderTopContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1yb4 _4t3izwfg",
                __cmplp.className
            ])
        });
    });
    const $7c55c6a1238404e7$var$TitleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $7c55c6a1238404e7$var$PageDescription = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz2l1e",
                __cmplp.className
            ])
        });
    });
    const $7c55c6a1238404e7$var$HeaderContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pkpxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("41j30", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c2f3c33a6194375$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8oe80;
    var $hDzhb;
    function $7c2f3c33a6194375$var$Link(props) {
        const { children: children, ...rest } = props;
        delete rest.createAnalyticsEvent;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), rest, children);
    }
    var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('link', {
        onClick: 'clicked'
    })($7c2f3c33a6194375$var$Link);
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $57MwZ;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("57MwZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9694e728fd1ea060$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eeGIy;
    const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;
});
parcelRegister("eeGIy", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$0c196d37a4e8266c$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$0c196d37a4e8266c$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$0c196d37a4e8266c$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$0c196d37a4e8266c$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$0c196d37a4e8266c$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$0c196d37a4e8266c$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c196d37a4e8266c$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0c196d37a4e8266c$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $0c196d37a4e8266c$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $0c196d37a4e8266c$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $0c196d37a4e8266c$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $0c196d37a4e8266c$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $0c196d37a4e8266c$var$bottomBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$outerStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $0c196d37a4e8266c$var$titleStyles,
                truncateTitle && $0c196d37a4e8266c$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleWrapperStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleContainerStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$actionStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0c196d37a4e8266c$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("auDmG", function(module, exports) {
    $parcel$export(module.exports, "HelpPanelButton", ()=>$c4b9c1de653fb6b2$export$4b6bbd2e0136b372);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Zxxp;
    var $8zOmE;
    var $2NMNM;
    const $c4b9c1de653fb6b2$export$4b6bbd2e0136b372 = ({ HelpButtonLink: HelpButtonLink = (0, (0, parcelRequire("5Zxxp")).default), articleId: articleId, fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents), useCallback: useCallback = (0, $5uXOq.useCallback), ...rest })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const onClick = useCallback(()=>fireUIAnalytics(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'navigationItem'
            }), 'sidebar', {
                helpArticleId: articleId,
                itemId: 'learnMore'
            }), [
            articleId,
            createAnalyticsEvent,
            fireUIAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(HelpButtonLink, {
            articleId: articleId,
            type: "HELP_ARTICLE",
            appearance: "subtle-link",
            spacing: "none",
            onClick: onClick,
            ...rest
        });
    };
});
parcelRegister("5Zxxp", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanelLink", ()=>$b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
    $parcel$export(module.exports, "default", ()=>$b0d1b3c2fea05784$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bHDKL;
    var $e4yMr;
    var $jpY8v;
    var $4R6GH;
    var $6BNJk;
    var $kspz4;
    var $hsmeR;
    const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const [, { setNavigationData: setNavigationData }] = (0, (0, parcelRequire("kspz4")).useHelpPanelActions)();
        const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
            openRightSidebar((0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID), (0, (0, parcelRequire("6BNJk")).HELP_PANEL_WIDTH), false, true);
            if (resetHistory) setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                },
                history: []
            });
            else setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                }
            });
        };
        return !(0, (0, parcelRequire("jpY8v")).isIE11)() ? handleOnClick : undefined;
    };
    const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, href: href, ...props })=>{
        const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
        const handleOnClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) event.preventDefault();
            onClick?.(event, analyticsEvent);
            onOpenInProductHelpArticle?.(articleId, (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]);
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) return onOpenInProductHelpArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            ...props,
            onClick: handleOnClick,
            href: href ?? 'https://support.atlassian.com',
            appearance: "default",
            testId: props.testId
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
        return onOpenInProductHelpArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            onClick: handleOnClick,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
            ])
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
    };
    var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
    const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
});
parcelRegister("9F5Tv", function(module, exports) {
    $parcel$export(module.exports, "JswShareButton", ()=>$71a62af6dae27b53$export$54c54e47ce207cc8);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dXq4S;
    var $5GqLe;
    var $iL8EU;
    var $koeKL;
    var $lwYh5;
    const $71a62af6dae27b53$var$REPORT_SHARE_CONTENT_TYPE = 'report';
    const $71a62af6dae27b53$export$54c54e47ce207cc8 = ({ boardId: boardId })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iL8EU")).default), {
            integrationType: (0, (0, parcelRequire("5GqLe")).integrationTypes).CLASSIC_BOARD,
            triggerButtonStyle: "icon-only",
            productId: "jira",
            subProductId: "jira-software",
            shareTitle: formatMessage((0, (0, parcelRequire("lwYh5")).default).shareTitle),
            shareFormTitle: formatMessage((0, (0, parcelRequire("lwYh5")).default).shareFormTitle),
            shareContentType: $71a62af6dae27b53$var$REPORT_SHARE_CONTENT_TYPE,
            objectAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                resourceOwner: 'jira-software',
                cloudId: cloudId,
                resourceType: 'board',
                resourceId: String(boardId)
            }),
            copyTooltipText: formatMessage((0, (0, parcelRequire("lwYh5")).default).shareTooltipText),
            shareFormHelperMessage: formatMessage((0, (0, parcelRequire("lwYh5")).default).shareHelperMessage)
        });
    };
});
parcelRegister("5GqLe", function(module, exports) {
    $parcel$export(module.exports, "integrationTypes", ()=>$0970fea694a8095f$export$a7359bcfb0ca8e98);
    const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
        BENTO_ISSUE: 'bentoIssue',
        CLASSIC_BOARD: 'classicBoard',
        NEXTGEN_BOARD: 'nextGenBoard',
        ROADMAP: 'roadmap',
        TIMELINE: 'timeline',
        LIST: 'list',
        CALENDAR: 'calendar',
        BOARD: 'board',
        FORM: 'form',
        SUMMARY: 'summary',
        ATTACHMENTS: 'attachments',
        DEPENDENCIES: 'dependencies',
        INCREMENT: 'increment'
    };
});
parcelRegister("iL8EU", function(module, exports) {
    $parcel$export(module.exports, "ShareLoadingPlaceholder", ()=>$4e5335f44d688bbf$export$5619d05bf511476b);
    $parcel$export(module.exports, "default", ()=>$4e5335f44d688bbf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $jZX0t;
    var $heNNl;
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $Kpokz;
    const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jZX0t"))))), {
                size: "medium",
                label: formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText),
                primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N30})`
            }),
            isDisabled: true
        }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText) : null));
    };
    const $4e5335f44d688bbf$var$ShareButton = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("jHQiG")), {
        ssr: false,
        moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
    });
    var $4e5335f44d688bbf$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.share.button",
            packageName: "share-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "share-button",
            fallback: props.renderCustomTriggerButton === undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
                triggerButtonStyle: props.triggerButtonStyle
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
                isDisabled: true,
                onClick: (0, ($parcel$interopDefault($8Rkzz)))
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButton, props)));
});
parcelRegister("jZX0t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
    function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e8f17c524b03e26b$var$ShareIcon = (props)=>$e8f17c524b03e26b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
        }, props, {
            newIcon: $e8f17c524b03e26b$var$_share.default
        }));
    $e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
    var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;
});
parcelRegister("empdx", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a746ae65a0e1944c$var$_react = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a746ae65a0e1944c$var$_UNSAFE_baseNew = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a746ae65a0e1944c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a746ae65a0e1944c$var$ShareIcon = (props)=>$a746ae65a0e1944c$var$_react.default.createElement($a746ae65a0e1944c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
        }, props));
    $a746ae65a0e1944c$var$ShareIcon.displayName = 'ShareIcon';
    var $a746ae65a0e1944c$var$_default = module.exports.default = $a746ae65a0e1944c$var$ShareIcon;
});
parcelRegister("Kpokz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$026d1258a1c95d57$export$defe85febe8b728c);
    var $7VHMR;
    const $026d1258a1c95d57$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareTriggerButtonText: {
            "id": "share-button.share-trigger-button-text",
            "defaultMessage": "Share"
        }
    });
});
parcelRegister("jHQiG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bfk3F")
    ]).then(()=>parcelRequire('7aU9g'));
});
parcelRegister("lwYh5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff1e0b1d39c1a6b7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ff1e0b1d39c1a6b7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareTitle: {
            "id": "software-report-header-common.share-button.share-title",
            "defaultMessage": "Report"
        },
        shareFormTitle: {
            "id": "software-report-header-common.share-button.share-form-title",
            "defaultMessage": "Share"
        },
        shareTooltipText: {
            "id": "software-report-header-common.share-button.share-tooltip-text",
            "defaultMessage": "Embed this link in other Atlassian products such as Confluence"
        },
        shareHelperMessage: {
            "id": "software-report-header-common.share-button.share-helper-message",
            "defaultMessage": "This view, along with any applied groups and filters are shared"
        }
    });
});
parcelRegister("1yYqj", function(module, exports) {
    $parcel$export(module.exports, "FeedbackButton", ()=>$7681f5fa49600865$export$116fedbe5e2e2bd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $7iULw;
    var $coTzA;
    var $fPB66;
    var $3Uttp;
    var $auW2i;
    const $7681f5fa49600865$var$FEEDBACK_COLLECTOR_LOCATION = 'reports.deployment-frequency';
    const $7681f5fa49600865$export$116fedbe5e2e2bd8 = ()=>{
        const { data: deploymentProviders, error: errorDeploymentProviders } = (0, (0, parcelRequire("auW2i")).useDeploymentProviders)();
        const projectAttributes = (0, (0, parcelRequire("3Uttp")).useProjectAnalyticsAttributes)();
        if (projectAttributes === null) return null;
        if (errorDeploymentProviders) throw new Error(`Getting deployment providers failed when using useDeploymentProviders while attempting to display Deployment Frequency Report feedback button. Details: ${errorDeploymentProviders.message}`);
        const additionalFeedbackEntries = [
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                value: $7681f5fa49600865$var$FEEDBACK_COLLECTOR_LOCATION
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: projectAttributes.isSimplified.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                value: projectAttributes.isProjectAdmin.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).DEPLOYMENT_PROVIDERS,
                value: deploymentProviders ? (0, (0, parcelRequire("fPB66")).hideUGCProviderName)(deploymentProviders).map((deploymentProvider)=>deploymentProvider.name).join(', ') : ''
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("coTzA")).FeedbackCollectorButton), {
            entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
            feedbackContext: additionalFeedbackEntries
        });
    };
});
parcelRegister("kk2bk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$224cbb6e7085777e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $224cbb6e7085777e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "software-deployment-frequency-report.header.title",
            "defaultMessage": "Deployment frequency"
        },
        description: {
            "id": "software-deployment-frequency-report.header.description",
            "defaultMessage": "Understand your project\u2019s deployment frequency to see how often you are shipping value to your customers. Using data from your deployment provider, correlate your batch size to how often your team deploys."
        },
        learnMore: {
            "id": "software-deployment-frequency-report.header.learn-more",
            "defaultMessage": "Learn more"
        }
    });
});
parcelRegister("ufiFS", function(module, exports) {
    $parcel$export(module.exports, "IssuesPerDeploymentChart", ()=>$fba6654212593696$export$b2095980f919734e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1dJ6S;
    var $eJS47;
    var $3bDjY;
    var $koVbs;
    var $gilhC;
    var $l8ekP;
    var $3Ws3s;
    var $claG0;
    var $cwqx0;
    var $7fqGi;
    var $JMEgp;
    var $e0ycG;
    var $baXQH;
    const $fba6654212593696$var$Title = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$ChartTitleContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("e0ycG")).default).chartTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("e0ycG")).default).titleHelpTooltip),
            position: "right"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$QuestionIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
            size: "small",
            label: ""
        }))));
    };
    const $fba6654212593696$export$b2095980f919734e = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("3Ws3s")).useReportCoreData)();
        const [{ selectedWeekStart: selectedWeekStart }, { setSelectedWeekStart: setSelectedWeekStart }] = (0, (0, parcelRequire("gilhC")).useSelectedWeekStore)();
        const onChartClicked = (0, $5uXOq.useCallback)(({ data: eventData })=>{
            setSelectedWeekStart(eventData.customInfo.startDateInclusive);
        }, [
            setSelectedWeekStart
        ]);
        const events = (0, $5uXOq.useMemo)(()=>({
                click: onChartClicked
            }), [
            onChartClicked
        ]);
        (0, (0, parcelRequire("l8ekP")).useSmartWeekSelect)(data, selectedWeekStart, setSelectedWeekStart);
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("JMEgp")).LoadingSkeleton), null);
        if (error && data == null) return null;
        if (data == null || selectedWeekStart === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("JMEgp")).LoadingSkeleton), null);
        error;
        if (data.hasDeploymentProvider === false) return null;
        const prodDataState = (0, (0, parcelRequire("claG0")).getProdDataState)(data);
        const dataPoints = (0, (0, parcelRequire("7fqGi")).convertReportCoreToChartDataPoints)(data, selectedWeekStart);
        const selectedWeekData = (0, (0, parcelRequire("l8ekP")).getSelectedWeekData)(data.weeksData, selectedWeekStart);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$Title, null), (0, ($parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$ChartContainer, {
            "data-test-id": "software-deployment-frequency-report.ui.issues-per-deployment-chart"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$ChartItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwqx0")).default), {
            dataPoints: dataPoints,
            medianIssues: prodDataState === 'SUFFICIENT_FOR_TREND' ? data.medianIssuesPerDeployment : null,
            onEvents: events
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$SelectionDetailItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("baXQH")).SelectionDetail), {
            medianIssuesPerDeployment: selectedWeekData.medianIssuesPerDeployment.prod,
            wholePeriodMedian: data.medianIssuesPerDeployment,
            prodDataState: prodDataState
        }))));
    };
    const $fba6654212593696$var$ChartTitleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ejb _1e0c1txw _4cvr1h6o _18s819a1 _19bvv47k _otyrpxbi",
                __cmplp.className
            ])
        });
    });
    const $fba6654212593696$var$QuestionIcon = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _lswu12xz _syazs6h6 _80omtlke _ca0qv77o",
                __cmplp.className
            ])
        });
    });
    const $fba6654212593696$var$ChartContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4t3i68cl _otyrpxbi",
                __cmplp.className
            ])
        });
    });
    const $fba6654212593696$var$ChartItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbqrhd",
                __cmplp.className
            ])
        });
    });
    const $fba6654212593696$var$SelectionDetailItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb194s _1ul9194s _1e0c1txw _2lx21bp4 _1bah1h6o _19bv1ylp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cwqx0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44f5195bd43b375a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $apUNl = parcelRequire("apUNl");
    var $gJBT6 = parcelRequire("gJBT6");
    var $e4v2N = parcelRequire("e4v2N");
    var $lXVui = parcelRequire("lXVui");
    var $bkcQi;
    var $47isN;
    var $6OGL8;
    var $48mDj;
    var $hnoNV;
    var $gLj36;
    var $ixV1I;
    var $lWgYs;
    var $dWt6p;
    var $k5uoT;
    var $gwIPs;
    var $aWse0;
    var $dUmnn;
    var $lNwCK = parcelRequire("lNwCK");
    var $hRdGh = parcelRequire("hRdGh");
    var $ghL9R;
    var $4ghCC;
    (0, parcelRequire("ixV1I")).use([
        (0, (0, parcelRequire("47isN")).install),
        (0, (0, parcelRequire("bkcQi")).install),
        (0, (0, parcelRequire("hnoNV")).install),
        (0, (0, parcelRequire("48mDj")).install),
        (0, (0, parcelRequire("gLj36")).install),
        (0, (0, parcelRequire("6OGL8")).install),
        (0, (0, parcelRequire("lWgYs")).install)
    ]);
    const $44f5195bd43b375a$var$Chart = ({ dataPoints: dataPoints, medianIssues: medianIssues, onEvents: onEvents })=>{
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const tooltipFormatter = (0, (0, parcelRequire("4ghCC")).useTooltipFormatter)();
        const prefersReducedMotion = (0, (0, parcelRequire("dWt6p")).useIsReducedMotion)();
        const selectedIndex = dataPoints.findIndex((dataPoint)=>dataPoint.customInfo.isSelectedData);
        const lastCompleteWeekIndexWithData = (0, ($parcel$interopDefault($apUNl)))(dataPoints, (dataPoint)=>dataPoint.value !== null, dataPoints.length - 2);
        const selectedPoint = selectedIndex === -1 ? null : dataPoints[selectedIndex];
        const axisCommonStyle = {
            nameGap: (0, (0, parcelRequire("gwIPs")).gridSize) * 4,
            nameLocation: 'middle',
            nameTextStyle: {
                color: (0, $829f609a65d26a98$exports).N400,
                fontSize: (0, (0, parcelRequire("k5uoT")).fontSizeSmall)()
            }
        };
        const TOOLTIP_ANIMATION = null;
        const TOOLTIP_APPEAR_TOP = {
            backgroundColor: (0, $829f609a65d26a98$exports).N900,
            borderWidth: 0,
            transitionDuration: 0,
            extraCssText: `animation: ${TOOLTIP_ANIMATION} 0.15s ease-out`,
            position: (0, ($parcel$interopDefault($gJBT6)))((pos, params, dom, rect, size)=>({
                    top: rect.y - size.contentSize[1] - (0, (0, parcelRequire("gwIPs")).gridSize),
                    left: rect.x + 10 - size.contentSize[0] / 2
                }), (pos, params)=>`${params.componentSubType}-${params.name}-${params.dataIndex}`)
        };
        const chartOptions = {
            animation: !prefersReducedMotion,
            tooltip: {
                ...TOOLTIP_APPEAR_TOP,
                formatter: tooltipFormatter
            },
            grid: {
                left: (0, (0, parcelRequire("dUmnn")).CHART_SPACE_LEFT),
                right: (0, (0, parcelRequire("dUmnn")).CHART_SPACE_RIGHT),
                top: (0, (0, parcelRequire("gwIPs")).gridSize) * 2,
                bottom: (0, (0, parcelRequire("gwIPs")).gridSize) * 3
            },
            xAxis: {
                data: dataPoints.map((data)=>{
                    const { startDateInclusive: startDateInclusive } = data.customInfo;
                    return formatDate(startDateInclusive, {
                        month: 'short',
                        day: 'numeric'
                    });
                }),
                axisLine: {
                    lineStyle: {
                        color: (0, $829f609a65d26a98$exports).N40,
                        width: 1
                    }
                },
                axisTick: {
                    alignWithLabel: true
                },
                ...axisCommonStyle
            },
            yAxis: {
                name: formatMessage((0, (0, parcelRequire("ghL9R")).default).yAxisLabel),
                ...axisCommonStyle,
                axisLine: {
                    show: false
                },
                splitNumber: 2,
                axisTick: false,
                splitLine: {
                    lineStyle: {
                        color: (0, $829f609a65d26a98$exports).N30
                    }
                }
            },
            textStyle: {
                color: (0, $829f609a65d26a98$exports).N400
            },
            series: [
                {
                    type: 'line',
                    connectNulls: true,
                    data: (0, ($parcel$interopDefault($e4v2N)))(dataPoints, dataPoints.length - 1),
                    color: (0, $829f609a65d26a98$exports).B100,
                    lineStyle: {
                        width: 1
                    },
                    symbol: `image://${(0, ($parcel$interopDefault($hRdGh)))}`,
                    symbolSize: 9,
                    ...selectedPoint && selectedPoint.value !== null ? {
                        markPoint: {
                            symbol: `image://${0, ($parcel$interopDefault($lNwCK))}`,
                            silent: true,
                            symbolSize: 22,
                            data: [
                                {
                                    coord: [
                                        selectedIndex,
                                        `${selectedPoint.value}`
                                    ]
                                }
                            ]
                        }
                    } : {},
                    ...medianIssues !== null ? {
                        markLine: {
                            data: [
                                {
                                    yAxis: medianIssues
                                }
                            ],
                            silent: true,
                            lineStyle: {
                                color: (0, $829f609a65d26a98$exports).N300,
                                width: 1
                            },
                            symbol: 'none',
                            label: {
                                show: false
                            }
                        }
                    } : {}
                },
                {
                    type: 'line',
                    connectNulls: true,
                    data: dataPoints.map((dataPoint, i)=>i < lastCompleteWeekIndexWithData ? null : dataPoint),
                    color: (0, $829f609a65d26a98$exports).B100,
                    symbol: `image://${(0, ($parcel$interopDefault($hRdGh)))}`,
                    symbolSize: 9,
                    lineStyle: {
                        width: 1,
                        type: 'dashed',
                        color: (0, $829f609a65d26a98$exports).B100
                    }
                }
            ]
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($lXVui))), {
            echarts: (0, parcelRequire("ixV1I")),
            option: chartOptions,
            onEvents: onEvents,
            style: {
                height: '100%'
            }
        });
    };
    var $44f5195bd43b375a$export$2e2bcd8739ae039 = $44f5195bd43b375a$var$Chart;
});
parcelRegister("e4v2N", function(module, exports) {
    var $dM3Z8 = parcelRequire("dM3Z8");
    var $kPZpS = parcelRequire("kPZpS");
    function $a3e985251d714418$var$take(array, n, guard) {
        if (!(array && array.length)) return [];
        n = guard || n === undefined ? 1 : $kPZpS(n);
        return $dM3Z8(array, 0, n < 0 ? 0 : n);
    }
    module.exports = $a3e985251d714418$var$take;
});
parcelRegister("hnoNV", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$ca67d33ebd24fc06$export$4b3e715f166fdd78);
    var $hpWan;
    var $9CmBI;
    var $btF6F;
    function $ca67d33ebd24fc06$export$4b3e715f166fdd78(registers) {
        registers.registerComponentModel((0, (0, parcelRequire("9CmBI")).default));
        registers.registerComponentView((0, (0, parcelRequire("btF6F")).default));
        registers.registerPreprocessor(function(opt) {
            if ((0, (0, parcelRequire("hpWan")).default)(opt.series, 'markPoint')) opt.markPoint = opt.markPoint || {};
        });
    }
});
parcelRegister("9CmBI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$700932fc8326c357$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h8Fle;
    var $700932fc8326c357$var$MarkPointModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MarkPointModel, _super);
        function MarkPointModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = MarkPointModel.type;
            return _this;
        }
        MarkPointModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
            return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
        };
        MarkPointModel.type = 'markPoint';
        MarkPointModel.defaultOption = {
            zlevel: 0,
            z: 5,
            symbol: 'pin',
            symbolSize: 50,
            tooltip: {
                trigger: 'item'
            },
            label: {
                show: true,
                position: 'inside'
            },
            itemStyle: {
                borderWidth: 2
            },
            emphasis: {
                label: {
                    show: true
                }
            }
        };
        return MarkPointModel;
    }((0, (0, parcelRequire("h8Fle")).default));
    var $700932fc8326c357$export$2e2bcd8739ae039 = $700932fc8326c357$var$MarkPointModel;
});
parcelRegister("btF6F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85b24a0e23bf3142$export$2e2bcd8739ae039);
    var $3VFsf;
    var $5DXGq;
    var $jmSNG;
    var $liBXN;
    var $gjRnj;
    var $k3pUt;
    var $h8Fle;
    var $bahqM;
    var $7QjoM;
    var $fk5Gm;
    function $85b24a0e23bf3142$var$updateMarkerLayout(mpData, seriesModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        mpData.each(function(idx) {
            var itemModel = mpData.getItemModel(idx);
            var point;
            var xPx = (0, parcelRequire("jmSNG")).parsePercent(itemModel.get('x'), api.getWidth());
            var yPx = (0, parcelRequire("jmSNG")).parsePercent(itemModel.get('y'), api.getHeight());
            if (!isNaN(xPx) && !isNaN(yPx)) point = [
                xPx,
                yPx
            ];
            else if (seriesModel.getMarkerPosition) point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
            else if (coordSys) {
                var x = mpData.get(coordSys.dimensions[0], idx);
                var y = mpData.get(coordSys.dimensions[1], idx);
                point = coordSys.dataToPoint([
                    x,
                    y
                ]);
            }
            if (!isNaN(xPx)) point[0] = xPx;
            if (!isNaN(yPx)) point[1] = yPx;
            mpData.setItemLayout(idx, point);
        });
    }
    var $85b24a0e23bf3142$var$MarkPointView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MarkPointView, _super);
        function MarkPointView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = MarkPointView.type;
            return _this;
        }
        MarkPointView.prototype.updateTransform = function(markPointModel, ecModel, api) {
            ecModel.eachSeries(function(seriesModel) {
                var mpModel = (0, (0, parcelRequire("h8Fle")).default).getMarkerModelFromSeries(seriesModel, 'markPoint');
                if (mpModel) {
                    $85b24a0e23bf3142$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
                    this.markerGroupMap.get(seriesModel.id).updateLayout();
                }
            }, this);
        };
        MarkPointView.prototype.renderSeries = function(seriesModel, mpModel, ecModel, api) {
            var coordSys = seriesModel.coordinateSystem;
            var seriesId = seriesModel.id;
            var seriesData = seriesModel.getData();
            var symbolDrawMap = this.markerGroupMap;
            var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new (0, (0, parcelRequire("5DXGq")).default)());
            var mpData = $85b24a0e23bf3142$var$createData(coordSys, seriesModel, mpModel);
            mpModel.setData(mpData);
            $85b24a0e23bf3142$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
            mpData.each(function(idx) {
                var itemModel = mpData.getItemModel(idx);
                var symbol = itemModel.getShallow('symbol');
                var symbolSize = itemModel.getShallow('symbolSize');
                var symbolRotate = itemModel.getShallow('symbolRotate');
                var symbolOffset = itemModel.getShallow('symbolOffset');
                var symbolKeepAspect = itemModel.getShallow('symbolKeepAspect');
                if ((0, (0, parcelRequire("bahqM")).isFunction)(symbol) || (0, (0, parcelRequire("bahqM")).isFunction)(symbolSize) || (0, (0, parcelRequire("bahqM")).isFunction)(symbolRotate) || (0, (0, parcelRequire("bahqM")).isFunction)(symbolOffset)) {
                    var rawIdx = mpModel.getRawValue(idx);
                    var dataParams = mpModel.getDataParams(idx);
                    if ((0, (0, parcelRequire("bahqM")).isFunction)(symbol)) symbol = symbol(rawIdx, dataParams);
                    if ((0, (0, parcelRequire("bahqM")).isFunction)(symbolSize)) symbolSize = symbolSize(rawIdx, dataParams);
                    if ((0, (0, parcelRequire("bahqM")).isFunction)(symbolRotate)) symbolRotate = symbolRotate(rawIdx, dataParams);
                    if ((0, (0, parcelRequire("bahqM")).isFunction)(symbolOffset)) symbolOffset = symbolOffset(rawIdx, dataParams);
                }
                var style = itemModel.getModel('itemStyle').getItemStyle();
                var color = (0, (0, parcelRequire("fk5Gm")).getVisualFromData)(seriesData, 'color');
                if (!style.fill) style.fill = color;
                mpData.setItemVisual(idx, {
                    symbol: symbol,
                    symbolSize: symbolSize,
                    symbolRotate: symbolRotate,
                    symbolOffset: symbolOffset,
                    symbolKeepAspect: symbolKeepAspect,
                    style: style
                });
            });
            symbolDraw.updateData(mpData);
            this.group.add(symbolDraw.group);
            mpData.eachItemGraphicEl(function(el) {
                el.traverse(function(child) {
                    (0, (0, parcelRequire("7QjoM")).getECData)(child).dataModel = mpModel;
                });
            });
            this.markKeep(symbolDraw);
            symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
        };
        MarkPointView.type = 'markPoint';
        return MarkPointView;
    }((0, (0, parcelRequire("k3pUt")).default));
    function $85b24a0e23bf3142$var$createData(coordSys, seriesModel, mpModel) {
        var coordDimsInfos;
        if (coordSys) coordDimsInfos = (0, (0, parcelRequire("bahqM")).map)(coordSys && coordSys.dimensions, function(coordDim) {
            var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
            return (0, (0, parcelRequire("bahqM")).extend)((0, (0, parcelRequire("bahqM")).extend)({}, info), {
                name: coordDim,
                ordinalMeta: null
            });
        });
        else coordDimsInfos = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        var mpData = new (0, (0, parcelRequire("liBXN")).default)(coordDimsInfos, mpModel);
        var dataOpt = (0, (0, parcelRequire("bahqM")).map)(mpModel.get('data'), (0, (0, parcelRequire("bahqM")).curry)((0, parcelRequire("gjRnj")).dataTransform, seriesModel));
        if (coordSys) dataOpt = (0, (0, parcelRequire("bahqM")).filter)(dataOpt, (0, (0, parcelRequire("bahqM")).curry)((0, parcelRequire("gjRnj")).dataFilter, coordSys));
        var dimValueGetter = (0, parcelRequire("gjRnj")).createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
        mpData.initData(dataOpt, null, dimValueGetter);
        return mpData;
    }
    var $85b24a0e23bf3142$export$2e2bcd8739ae039 = $85b24a0e23bf3142$var$MarkPointView;
});
parcelRegister("dUmnn", function(module, exports) {
    $parcel$export(module.exports, "CHART_SPACE_LEFT", ()=>$90b64bc8f4f4e83e$export$ffe1d6b5e0d7a6e5);
    $parcel$export(module.exports, "CHART_SPACE_RIGHT", ()=>$90b64bc8f4f4e83e$export$990d773ada9107e0);
    var $gwIPs;
    const $90b64bc8f4f4e83e$export$ffe1d6b5e0d7a6e5 = (0, (0, parcelRequire("gwIPs")).gridSize) * 8;
    const $90b64bc8f4f4e83e$export$990d773ada9107e0 = (0, (0, parcelRequire("gwIPs")).gridSize) * 4;
    const $90b64bc8f4f4e83e$export$ad3c2ee386592d19 = (0, (0, parcelRequire("gwIPs")).gridSize) * 15;
});
parcelRegister("lNwCK", function(module, exports) {
    module.exports = new URL("circle-selected.bac10034.svg", import.meta.url).toString();
});
parcelRegister("hRdGh", function(module, exports) {
    module.exports = new URL("circle.d95eea97.svg", import.meta.url).toString();
});
parcelRegister("ghL9R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7b948ad41186897$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c7b948ad41186897$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        yAxisLabel: {
            "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.y-axis-label",
            "defaultMessage": "Median issues"
        },
        xAxisLabel: {
            "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.x-axis-label",
            "defaultMessage": "Week commencing"
        }
    });
});
parcelRegister("4ghCC", function(module, exports) {
    $parcel$export(module.exports, "useTooltipFormatter", ()=>$c909316caf7163ff$export$8d71e8328e9bd59b);
    var $k5uoT;
    var $gwIPs;
    var $aWse0;
    var $lpLgi;
    const $c909316caf7163ff$var$getIconInfo = (value, deploymentsComparisonTarget)=>{
        if (deploymentsComparisonTarget === null) return {
            style: $c909316caf7163ff$var$iconBase,
            iconHtml: ''
        };
        if (value < deploymentsComparisonTarget) return {
            style: $c909316caf7163ff$var$iconWarn,
            iconHtml: (0, $d0cd9e09b6d842bf$export$f97d6df82c759e48)
        };
        if (value > deploymentsComparisonTarget) return {
            style: $c909316caf7163ff$var$iconGood,
            iconHtml: (0, $d0cd9e09b6d842bf$export$ae6cac6e77684f0f)
        };
        return {
            style: $c909316caf7163ff$var$iconBase,
            iconHtml: ''
        };
    };
    const $c909316caf7163ff$export$8d71e8328e9bd59b = ()=>{
        const { formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        return ({ data: data })=>{
            const { value: value, customInfo: { numProdDeployments: numProdDeployments, medianProdDeployments: medianProdDeployments, startDateInclusive: startDateInclusive } } = data;
            const weekStartDateText = formatMessage((0, (0, parcelRequire("lpLgi")).default).weekStartDate, {
                date: formatDate(startDateInclusive, {
                    day: 'numeric',
                    month: 'short'
                })
            });
            const statisticsText = formatMessage((0, (0, parcelRequire("lpLgi")).default).medianIssuesPerDeployment, {
                medianIssuesPerDeployment: formatNumber(value ?? 0)
            });
            const numProductionDeploymentsText = formatMessage((0, (0, parcelRequire("lpLgi")).default).numProductionDeployments, {
                numProdDeployments: numProdDeployments
            });
            const { style: comparisonIconStyle, iconHtml: iconHtml } = $c909316caf7163ff$var$getIconInfo(numProdDeployments, medianProdDeployments);
            return `
            <div style="${$c909316caf7163ff$var$container}">
                <div style="${$c909316caf7163ff$var$header}">
                    <span style="${$c909316caf7163ff$var$weekStart}">${weekStartDateText}</span>
                </div>
                <div>
                    <div style="${$c909316caf7163ff$var$stack}">
                        <span style="${$c909316caf7163ff$var$issuesIconStyled}">${0, $d0cd9e09b6d842bf$export$51f43fae9c774cb5}</span>
                        <span style="${$c909316caf7163ff$var$statistics}">${statisticsText}</span>
                    </div>
                    <div style="${$c909316caf7163ff$var$stack}">
                        <span style="${comparisonIconStyle}">${iconHtml}</span>
                        <span style="${$c909316caf7163ff$var$statistics}">${numProductionDeploymentsText}</span>
                    </div>
                </div>
            </div>
        `;
        };
    };
    const $c909316caf7163ff$var$container = `
    height: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 9}px;
    padding: 0 ${(0, (0, parcelRequire("gwIPs")).gridSize) / 2}px;
    background-color: ${`var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$exports).N900})`};
    border-radius: ${(0, (0, parcelRequire("gwIPs")).borderRadius)};
    font-size: ${(0, (0, parcelRequire("k5uoT")).fontSizeSmall)()}px;
    color: ${`var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`};
`;
    const $c909316caf7163ff$var$header = `
    display: flex;
    justify-content: space-between;
    height: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px;
    margin-bottom: ${(0, (0, parcelRequire("gwIPs")).gridSize)}px;
`;
    const $c909316caf7163ff$var$iconBase = `
    margin-top: -1px;
    height: 16px;
    width: 16px;
`;
    const $c909316caf7163ff$var$iconGood = `
    ${$c909316caf7163ff$var$iconBase}
    fill: ${`var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`};
    color: ${`var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`}
`;
    const $c909316caf7163ff$var$iconWarn = `
    ${$c909316caf7163ff$var$iconBase}
    fill: ${`var(--ds-surface, ${(0, $829f609a65d26a98$exports).N10})`};
    color: ${`var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y400})`}
`;
    const $c909316caf7163ff$var$weekStart = `
    text-decoration-line: underline;
    margin-right: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2.5}px;
`;
    const $c909316caf7163ff$var$issuesIconStyled = `
    ${$c909316caf7163ff$var$iconBase}
`;
    const $c909316caf7163ff$var$statistics = `
  margin-left: ${(0, (0, parcelRequire("gwIPs")).gridSize) / 2}px;
`;
    const $c909316caf7163ff$var$stack = `
    display: flex;
    align-items: center;
`;
});
const $d0cd9e09b6d842bf$export$ae6cac6e77684f0f = '<svg width="16" height="16" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" fill-rule="nonzero" cx="12" cy="12" r="10"></circle><path d="M11.288 7.293L8.294 10.27a1.002 1.002 0 000 1.416 1.01 1.01 0 001.421 0l1.279-1.272V16c0 .552.451 1 1.006 1 .555 0 1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 001.421 0 .998.998 0 000-1.416l-2.994-2.977a1.01 1.01 0 00-1.423 0z" fill="inherit"></path></g></svg>';
const $d0cd9e09b6d842bf$export$f97d6df82c759e48 = '<svg width="16" height="16" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" fill-rule="nonzero" cx="12" cy="12" r="10"></circle><path d="M10.994 8v5.586l-1.279-1.272a1.01 1.01 0 00-1.421 0 .998.998 0 000 1.416l2.994 2.977a1.01 1.01 0 001.423 0l2.994-2.977a.998.998 0 000-1.416 1.01 1.01 0 00-1.421 0l-1.279 1.272V8c0-.552-.45-1-1.005-1-.555 0-1.006.448-1.006 1z" fill="inherit"></path></g></svg>';
const $d0cd9e09b6d842bf$export$51f43fae9c774cb5 = '<svg width="16" height="16" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 12.991c0 .007 14.005.009 14.005.009C18.999 13 19 5.009 19 5.009 19 5.002 4.995 5 4.995 5 5.001 5 5 12.991 5 12.991zM3 5.01C3 3.899 3.893 3 4.995 3h14.01C20.107 3 21 3.902 21 5.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 12.991V5.01zM19 19c-.005 1.105-.9 2-2.006 2H7.006A2.009 2.009 0 015 19h14zm1-3a2.002 2.002 0 01-1.994 2H5.994A2.003 2.003 0 014 16h16z" fill-rule="nonzero"></path><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 00-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 00-1.3 1.3l1.406 1.405z"></path></g></svg>';
parcelRegister("lpLgi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a3b8da66f92651b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6a3b8da66f92651b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        medianIssuesPerDeployment: {
            "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.tooltip.median-issues-per-deployment",
            "defaultMessage": "{medianIssuesPerDeployment} {medianIssuesPerDeployment, plural, one {median issue} other {median issues}} per deployment"
        },
        numProductionDeployments: {
            "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.tooltip.num-production-deployments",
            "defaultMessage": "{numProdDeployments} {numProdDeployments, plural, one {production deployment} other {production deployments}}"
        },
        weekStartDate: {
            "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.tooltip.week-start-date",
            "defaultMessage": "Week of {date}"
        }
    });
});
parcelRegister("7fqGi", function(module, exports) {
    $parcel$export(module.exports, "convertReportCoreToChartDataPoints", ()=>$a631b5560540b504$export$5050f1e61745475);
    const $a631b5560540b504$export$5050f1e61745475 = (deploymentFrequencyReportData, selectedWeekStart)=>deploymentFrequencyReportData.weeksData.map((weekData)=>{
            const isSelectedData = selectedWeekStart ? selectedWeekStart?.getTime() === weekData.startDateInclusive.getTime() : false;
            return {
                value: weekData.medianIssuesPerDeployment.prod,
                itemStyle: {
                    color: (0, $829f609a65d26a98$exports).N80
                },
                customInfo: {
                    startDateInclusive: weekData.startDateInclusive,
                    numProdDeployments: weekData.deploymentCount.prod,
                    medianProdDeployments: deploymentFrequencyReportData.averageDeploymentCount,
                    isSelectedData: isSelectedData
                }
            };
        });
});
parcelRegister("JMEgp", function(module, exports) {
    $parcel$export(module.exports, "LoadingSkeleton", ()=>$42ab6fb23a17515f$export$44c18d210d5de37b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gwIPs;
    var $4McSe;
    const $42ab6fb23a17515f$export$44c18d210d5de37b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($42ab6fb23a17515f$var$ChartTitle, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 14}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px`,
            margin: "0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($42ab6fb23a17515f$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($42ab6fb23a17515f$var$ChartLeft, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 1.5}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 8.5}px`,
            margin: "0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($42ab6fb23a17515f$var$Chart, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThin), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThin), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThick), null)), (0, ($parcel$interopDefault($5uXOq))).createElement($42ab6fb23a17515f$var$SelectionDetail, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 6.5}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2.5}px`,
            margin: `0 0 ${(0, (0, parcelRequire("gwIPs")).gridSize) * 1.5}px 0`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 26.5}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 1.5}px`,
            margin: `0 0 ${(0, (0, parcelRequire("gwIPs")).gridSize) * 1.5}px 0`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 26.5}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize)}px`,
            margin: "0"
        }))));
    const $42ab6fb23a17515f$var$ChartTitle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkpxbi _4t3i1tcg _19bvv47k",
                __cmplp.className
            ])
        });
    });
    const $42ab6fb23a17515f$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4t3i68cl",
                __cmplp.className
            ])
        });
    });
    const $42ab6fb23a17515f$var$ChartLeft = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1ady _1e0c1txw _4cvr1h6o _19bvv47k _n3tdutpp",
                __cmplp.className
            ])
        });
    });
    const $42ab6fb23a17515f$var$Chart = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1yb4 _ca0qu2gc _u5f3zwfg _n3td1ejb",
                __cmplp.className
            ])
        });
    });
    const $42ab6fb23a17515f$var$SelectionDetail = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb194s _19bv1ylp _1e0c1txw _2lx21bp4 _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("e0ycG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af165b8da18b0f2d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $af165b8da18b0f2d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chartTitle: {
            "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart-title",
            "defaultMessage": "Batch Size"
        },
        titleHelpTooltip: {
            "id": "software-deployment-frequency-report.issues-per-deployment-chart.title-help-tooltip",
            "defaultMessage": "Analyze your issues per deployment over the 12-week median and how it impacts your team's deployment frequency."
        }
    });
});
parcelRegister("baXQH", function(module, exports) {
    $parcel$export(module.exports, "SelectionDetail", ()=>$914f8cc71c001855$export$e4886591ccee2d0c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1dJ6S;
    var $aWse0;
    var $6RYAp;
    var $FGQEy;
    const $914f8cc71c001855$export$e4886591ccee2d0c = ({ medianIssuesPerDeployment: medianIssuesPerDeployment, wholePeriodMedian: wholePeriodMedian, prodDataState: prodDataState })=>{
        const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, medianIssuesPerDeployment !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($914f8cc71c001855$var$PrimaryValue, null, formatNumber(medianIssuesPerDeployment)), (0, ($parcel$interopDefault($5uXOq))).createElement($914f8cc71c001855$var$WeeklyProductionDeployments, null, formatMessage((0, (0, parcelRequire("FGQEy")).default).medianIssuesPerProductionDeployment))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6RYAp")).IssuesTrendSummary), {
            weekCount: medianIssuesPerDeployment ?? 0,
            wholePeriodStatistic: wholePeriodMedian ?? 0,
            prodDataState: prodDataState
        }));
    };
    const $914f8cc71c001855$var$PrimaryValue = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "medium"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($914f8cc71c001855$var$PrimaryValueComponent, props));
    const $914f8cc71c001855$var$WeeklyProductionDeployments = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xxsmall",
            as: "div"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($914f8cc71c001855$var$WeeklyProductionDeploymentsComponent, props));
    const $914f8cc71c001855$var$PrimaryValueComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz10s3 _19pkidpf",
                __cmplp.className
            ])
        });
    });
    const $914f8cc71c001855$var$WeeklyProductionDeploymentsComponent = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1n3s _otyru2gc _19pkidpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("FGQEy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0fedcb350dd6083$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a0fedcb350dd6083$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        medianIssuesPerProductionDeployment: {
            "id": "software-deployment-frequency-report.issues-per-deployment-chart.selection-detail.median-issues-per-production-deployment",
            "defaultMessage": "Median issues per production deployment"
        },
        weekStartDate: {
            "id": "software-deployment-frequency-report.issues-per-deployment-chart.selection-detail.week-start-date",
            "defaultMessage": "Week of {date}"
        }
    });
});
parcelRegister("awynr", function(module, exports) {
    $parcel$export(module.exports, "LineChartByEnvironment", ()=>$0b508310b680e794$export$4a838fde7591e9ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $1dJ6S;
    var $6Ingq;
    var $6Pmud;
    var $eJS47;
    var $dC5iT;
    var $8CUq3;
    var $92Z2l;
    var $3bDjY;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $gilhC;
    var $3Ws3s;
    var $claG0;
    var $fc3EB;
    var $7psL7;
    var $kRE16;
    var $8PdvU;
    var $hoNfM;
    const $0b508310b680e794$var$Title = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$ChartTitleContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("hoNfM")).default).chartTitle), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("hoNfM")).default).titleHelpTooltip),
            position: "right"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$QuestionIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
            size: "small",
            label: ""
        })))));
    };
    const $0b508310b680e794$var$ExpandableContainer = ({ children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isOpen ? children : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            iconAfter: isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Pmud"))))), {
                label: ""
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                label: ""
            }),
            onClick: ()=>{
                setIsOpen(!isOpen);
            }
        }, isOpen ? formatMessage((0, (0, parcelRequire("hoNfM")).default).dropDownButtonOpenDescription) : formatMessage((0, (0, parcelRequire("hoNfM")).default).dropDownButtonDescription)));
    };
    const $0b508310b680e794$export$4a838fde7591e9ca = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("3Ws3s")).useReportCoreData)();
        const [{ selectedWeekStart: selectedWeekStart }] = (0, (0, parcelRequire("gilhC")).useSelectedWeekStore)();
        if (error && data == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8PdvU")).LoadingSkeleton), null);
        if (loading || data == null || selectedWeekStart === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8PdvU")).LoadingSkeleton), null);
        error;
        const lineSeries = (0, (0, parcelRequire("7psL7")).convertReportCoreToChartDataPoints)(data);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$ExpandableContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$Title, null), ((0, (0, parcelRequire("claG0")).isDataAllUnmapped)(data) || (0, (0, parcelRequire("claG0")).isDataUnmappedFoundWithMissingProd)(data)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
            sourceName: "unmappedDeploymentsMessage"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0b508310b680e794$var$noProdContainerStyles
        }, (0, (0, parcelRequire("claG0")).isDataAllUnmapped)(data) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            title: formatMessage((0, (0, parcelRequire("hoNfM")).default).noMappedWarningTitle),
            appearance: "discovery"
        }, formatMessage((0, (0, parcelRequire("hoNfM")).default).noMappedWarningDescription)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            title: formatMessage((0, (0, parcelRequire("hoNfM")).default).nonProdWarningTitle),
            appearance: "discovery"
        }, formatMessage((0, (0, parcelRequire("hoNfM")).default).nonProdWarningDescription)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null))), (0, ($parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$ChartContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$ChartItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fc3EB")).Chart), {
            series: lineSeries
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$ChartLegend, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kRE16")).Legend), {
            deploymentReportData: data,
            selectedWeekStart: selectedWeekStart
        }))));
    };
    const $0b508310b680e794$var$ChartTitleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ejb _1e0c1txw _4cvr1h6o _18s819a1 _19bvv47k _otyrpxbi",
                __cmplp.className
            ])
        });
    });
    const $0b508310b680e794$var$QuestionIcon = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _lswu12xz _syazs6h6 _80omtlke _ca0qv77o",
                __cmplp.className
            ])
        });
    });
    const $0b508310b680e794$var$ChartContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4t3i1lit",
                __cmplp.className
            ])
        });
    });
    const $0b508310b680e794$var$ChartItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbqrhd",
                __cmplp.className
            ])
        });
    });
    const $0b508310b680e794$var$ChartLegend = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb194s _1ul9194s _19bv1ylp _1e0c1txw _2lx21bp4 _1bahv2br",
                __cmplp.className
            ])
        });
    });
    const $0b508310b680e794$var$noProdContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.200',
        paddingLeft: 'space.200'
    });
});
parcelRegister("6Pmud", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4f88f2d3e506ed12$var$_react = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4f88f2d3e506ed12$var$_chevronUp = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("jj3Gi")));
    function $4f88f2d3e506ed12$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4f88f2d3e506ed12$var$ChevronUpIcon = (props)=>$4f88f2d3e506ed12$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
        }, props, {
            newIcon: $4f88f2d3e506ed12$var$_chevronUp.default,
            iconType: "utility"
        }));
    $4f88f2d3e506ed12$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
    var $4f88f2d3e506ed12$var$_default = module.exports.default = $4f88f2d3e506ed12$var$ChevronUpIcon;
});
parcelRegister("fc3EB", function(module, exports) {
    $parcel$export(module.exports, "Chart", ()=>$b7a20d98b2b1bb0c$export$acaa6426d77a227e);
    var $5uXOq = parcelRequire("5uXOq");
    var $hYfgW = parcelRequire("hYfgW");
    var $lXVui = parcelRequire("lXVui");
    var $bkcQi;
    var $47isN;
    var $6OGL8;
    var $48mDj;
    var $gLj36;
    var $ixV1I;
    var $lWgYs;
    var $dWt6p;
    var $k5uoT;
    var $gwIPs;
    var $aWse0;
    var $4snLl;
    var $7h73N;
    var $hwC24;
    (0, parcelRequire("ixV1I")).use([
        (0, (0, parcelRequire("47isN")).install),
        (0, (0, parcelRequire("bkcQi")).install),
        (0, (0, parcelRequire("48mDj")).install),
        (0, (0, parcelRequire("gLj36")).install),
        (0, (0, parcelRequire("6OGL8")).install),
        (0, (0, parcelRequire("lWgYs")).install)
    ]);
    const $b7a20d98b2b1bb0c$export$acaa6426d77a227e = ({ series: series })=>{
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const tooltipFormatter = (0, (0, parcelRequire("hwC24")).useTooltipFormatter)();
        const prefersReducedMotion = (0, (0, parcelRequire("dWt6p")).useIsReducedMotion)();
        const axisCommonStyle = {
            nameGap: (0, (0, parcelRequire("gwIPs")).gridSize) * 4,
            nameLocation: 'middle',
            nameTextStyle: {
                color: (0, $829f609a65d26a98$exports).N400,
                fontSize: (0, (0, parcelRequire("k5uoT")).fontSizeSmall)()
            }
        };
        const chartOptions = {
            animation: !prefersReducedMotion,
            tooltip: {
                backgroundColor: (0, $829f609a65d26a98$exports).N900,
                formatter: tooltipFormatter,
                transitionDuration: 0,
                trigger: 'axis',
                axisPointer: {
                    type: 'line',
                    lineStyle: {
                        type: 'dashed',
                        color: (0, $829f609a65d26a98$exports).B100,
                        width: 0.5
                    }
                },
                confine: true
            },
            grid: {
                left: (0, (0, parcelRequire("4snLl")).CHART_SPACE_LEFT),
                right: (0, (0, parcelRequire("4snLl")).CHART_SPACE_RIGHT),
                top: (0, (0, parcelRequire("gwIPs")).gridSize) * 2,
                bottom: (0, (0, parcelRequire("gwIPs")).gridSize) * 8
            },
            xAxis: {
                data: (0, ($parcel$interopDefault($hYfgW)))(series).data.map(({ customInfo: { startDateInclusive: startDateInclusive } })=>formatDate(startDateInclusive, {
                        month: 'short',
                        day: 'numeric'
                    })),
                axisLine: {
                    lineStyle: {
                        color: (0, $829f609a65d26a98$exports).N40,
                        width: 2
                    }
                },
                axisTick: {
                    alignWithLabel: true
                },
                offset: (0, (0, parcelRequire("gwIPs")).gridSize) * 2,
                ...axisCommonStyle
            },
            yAxis: {
                name: formatMessage((0, (0, parcelRequire("7h73N")).default).yAxisLabel),
                ...axisCommonStyle,
                axisLine: {
                    show: false
                },
                minInterval: 1,
                splitNumber: 4,
                axisTick: false,
                splitLine: {
                    lineStyle: {
                        color: (0, $829f609a65d26a98$exports).N30
                    }
                }
            },
            textStyle: {
                color: (0, $829f609a65d26a98$exports).N400
            },
            backgroundColor: 'transparent',
            series: series
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($lXVui))), {
            echarts: (0, parcelRequire("ixV1I")),
            option: chartOptions,
            style: {
                height: '100%'
            }
        });
    };
});
parcelRegister("4snLl", function(module, exports) {
    $parcel$export(module.exports, "CHART_SPACE_LEFT", ()=>$ffbbb531ca1515a3$export$ffe1d6b5e0d7a6e5);
    $parcel$export(module.exports, "CHART_SPACE_RIGHT", ()=>$ffbbb531ca1515a3$export$990d773ada9107e0);
    var $gwIPs;
    const $ffbbb531ca1515a3$export$ffe1d6b5e0d7a6e5 = (0, (0, parcelRequire("gwIPs")).gridSize) * 8;
    const $ffbbb531ca1515a3$export$990d773ada9107e0 = (0, (0, parcelRequire("gwIPs")).gridSize) * 4;
    const $ffbbb531ca1515a3$export$ad3c2ee386592d19 = (0, (0, parcelRequire("gwIPs")).gridSize) * 20;
});
parcelRegister("7h73N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9c57e1dbcc6d489$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c9c57e1dbcc6d489$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        yAxisLabel: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.chart.y-axis-label",
            "defaultMessage": "Deployment frequency"
        }
    });
});
parcelRegister("hwC24", function(module, exports) {
    $parcel$export(module.exports, "useTooltipFormatter", ()=>$9711af028c55d997$export$8d71e8328e9bd59b);
    var $hYfgW = parcelRequire("hYfgW");
    var $k5uoT;
    var $gwIPs;
    var $aWse0;
    var $fuOE9;
    const $9711af028c55d997$var$getCountsByEnvironment = (series)=>{
        const developmentSeries = series.find((chartSeries)=>chartSeries.data.customInfo.environment === 'development' && chartSeries.data.value !== null);
        const testingSeries = series.find((chartSeries)=>chartSeries.data.customInfo.environment === 'testing' && chartSeries.data.value !== null);
        const stagingSeries = series.find((chartSeries)=>chartSeries.data.customInfo.environment === 'staging' && chartSeries.data.value !== null);
        const productionSeries = series.find((chartSeries)=>chartSeries.data.customInfo.environment === 'production' && chartSeries.data.value !== null);
        const unmappedSeries = series.find((chartSeries)=>chartSeries.data.customInfo.environment === 'unmapped' && chartSeries.data.value !== null);
        return {
            developmentCount: developmentSeries ? developmentSeries.data.value : null,
            testingCount: testingSeries ? testingSeries.data.value : null,
            stagingCount: stagingSeries ? stagingSeries.data.value : null,
            productionCount: productionSeries ? productionSeries.data.value : null,
            unmappedCount: unmappedSeries ? unmappedSeries.data.value : null
        };
    };
    const $9711af028c55d997$export$8d71e8328e9bd59b = ()=>{
        const { formatDate: formatDate, formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        return (series)=>{
            const weekStartDateText = formatMessage((0, (0, parcelRequire("fuOE9")).default).weekStartDate, {
                date: formatDate((0, ($parcel$interopDefault($hYfgW)))(series).data.customInfo.startDateInclusive, {
                    day: 'numeric',
                    month: 'short'
                })
            });
            const { developmentCount: developmentCount, testingCount: testingCount, stagingCount: stagingCount, productionCount: productionCount, unmappedCount: unmappedCount } = $9711af028c55d997$var$getCountsByEnvironment(series);
            if (developmentCount === null && testingCount === null && stagingCount === null && productionCount === null && unmappedCount === null) return null;
            let resultHTML = `<div style="${$9711af028c55d997$var$container}"><div style="${$9711af028c55d997$var$headerWeekStartText}">${weekStartDateText}</div>`;
            if (developmentCount !== null) {
                const message = formatMessage((0, (0, parcelRequire("fuOE9")).default).numDevelopmentDeployments, {
                    numDeployments: developmentCount
                });
                resultHTML += `<p style="${$9711af028c55d997$var$countRow}">${message}</p>`;
            }
            if (testingCount !== null) {
                const message = formatMessage((0, (0, parcelRequire("fuOE9")).default).numTestingDeployments, {
                    numDeployments: testingCount
                });
                resultHTML += `<p style="${$9711af028c55d997$var$countRow}">${message}</p>`;
            }
            if (stagingCount !== null) {
                const message = formatMessage((0, (0, parcelRequire("fuOE9")).default).numStagingDeployments, {
                    numDeployments: stagingCount
                });
                resultHTML += `<p style="${$9711af028c55d997$var$countRow}">${message}</p>`;
            }
            if (productionCount !== null) {
                const message = formatMessage((0, (0, parcelRequire("fuOE9")).default).numProductionDeployments, {
                    numDeployments: productionCount
                });
                resultHTML += `<p style="${$9711af028c55d997$var$countRow}">${message}</p>`;
            }
            if (unmappedCount !== null) {
                const message = formatMessage((0, (0, parcelRequire("fuOE9")).default).numUnmappedDeployments, {
                    numDeployments: unmappedCount
                });
                resultHTML += `<p style="${$9711af028c55d997$var$countRow}">${message}</p>`;
            }
            resultHTML += '</div>';
            return resultHTML;
        };
    };
    const $9711af028c55d997$var$container = `
    padding: 0 ${(0, (0, parcelRequire("gwIPs")).gridSize) / 2}px;
    background-color: ${(0, $829f609a65d26a98$exports).N900};
    border-radius: ${(0, (0, parcelRequire("gwIPs")).borderRadius)};
    font-size: ${(0, (0, parcelRequire("k5uoT")).fontSizeSmall)()}px;
`;
    const $9711af028c55d997$var$headerWeekStartText = `
    height: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px;
    margin-bottom: ${(0, (0, parcelRequire("gwIPs")).gridSize)}px;
    text-decoration-line: underline;
    color: ${(0, $829f609a65d26a98$exports).N0};
    line-height: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px;
`;
    const $9711af028c55d997$var$countRow = `
    margin: 0px;
    padding: 0px;
`;
});
parcelRegister("fuOE9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfe5c2270eedaa0a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bfe5c2270eedaa0a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        numDevelopmentDeployments: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-development-deployments",
            "defaultMessage": "{numDeployments} development {numDeployments, plural, one {deployment} other {deployments}}"
        },
        numTestingDeployments: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-testing-deployments",
            "defaultMessage": "{numDeployments} testing {numDeployments, plural, one {deployment} other {deployments}}"
        },
        numStagingDeployments: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-staging-deployments",
            "defaultMessage": "{numDeployments} staging {numDeployments, plural, one {deployment} other {deployments}}"
        },
        numProductionDeployments: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-production-deployments",
            "defaultMessage": "{numDeployments} production {numDeployments, plural, one {deployment} other {deployments}}"
        },
        numUnmappedDeployments: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-unmapped-deployments",
            "defaultMessage": "{numDeployments} unmapped {numDeployments, plural, one {deployment} other {deployments}}"
        },
        weekStartDate: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.week-start-date",
            "defaultMessage": "Week of {date}"
        }
    });
});
parcelRegister("7psL7", function(module, exports) {
    $parcel$export(module.exports, "convertReportCoreToChartDataPoints", ()=>$8c6613932f8c18c1$export$5050f1e61745475);
    var $ekrfX = parcelRequire("ekrfX");
    var $cNCnq = parcelRequire("cNCnq");
    var $53yth = parcelRequire("53yth");
    var $9Bnm7 = parcelRequire("9Bnm7");
    var $k33L7 = parcelRequire("k33L7");
    var $eZlou;
    const $8c6613932f8c18c1$var$getEnvironmentSeries = (startDatesAndCounts, lineColor, baseLineType, icon, symbolSize)=>{
        const commonProps = {
            type: 'line',
            color: lineColor,
            symbol: `image://${icon}`,
            symbolSize: symbolSize,
            symbolKeepAspect: false
        };
        const isCompletelyEmpty = startDatesAndCounts.every(({ count: count })=>count === 0);
        return [
            {
                ...commonProps,
                data: startDatesAndCounts.map(({ startDateInclusive: startDateInclusive, count: count, environment: environment }, i)=>{
                    const isCurrentWeek = i === startDatesAndCounts.length - 1;
                    const value = isCompletelyEmpty || isCurrentWeek ? null : count;
                    return {
                        value: value,
                        customInfo: {
                            startDateInclusive: startDateInclusive,
                            environment: environment
                        }
                    };
                }),
                lineStyle: {
                    type: baseLineType,
                    width: 2
                }
            },
            {
                ...commonProps,
                data: startDatesAndCounts.map(({ startDateInclusive: startDateInclusive, count: count, environment: environment }, i)=>{
                    const isNotLastTwoWeeks = i < startDatesAndCounts.length - 2;
                    const value = isCompletelyEmpty || isNotLastTwoWeeks ? null : count;
                    return {
                        value: value,
                        customInfo: {
                            startDateInclusive: startDateInclusive,
                            environment: environment
                        }
                    };
                }),
                lineStyle: {
                    type: 'dashed',
                    width: 2
                }
            }
        ];
    };
    const $8c6613932f8c18c1$export$5050f1e61745475 = (reportData)=>[
            ...$8c6613932f8c18c1$var$getEnvironmentSeries(reportData.weeksData.map((weekData)=>({
                    count: weekData.deploymentCount.development,
                    startDateInclusive: weekData.startDateInclusive,
                    environment: 'development'
                })), (0, (0, parcelRequire("eZlou")).LINE_COLOR_MAP).development, 'solid', (0, ($parcel$interopDefault($ekrfX))), 8),
            ...$8c6613932f8c18c1$var$getEnvironmentSeries(reportData.weeksData.map((weekData)=>({
                    count: weekData.deploymentCount.testing,
                    startDateInclusive: weekData.startDateInclusive,
                    environment: 'testing'
                })), (0, (0, parcelRequire("eZlou")).LINE_COLOR_MAP).testing, 'solid', (0, ($parcel$interopDefault($9Bnm7))), 6),
            ...$8c6613932f8c18c1$var$getEnvironmentSeries(reportData.weeksData.map((weekData)=>({
                    count: weekData.deploymentCount.staging,
                    startDateInclusive: weekData.startDateInclusive,
                    environment: 'staging'
                })), (0, (0, parcelRequire("eZlou")).LINE_COLOR_MAP).staging, 'solid', (0, ($parcel$interopDefault($53yth))), 6),
            ...$8c6613932f8c18c1$var$getEnvironmentSeries(reportData.weeksData.map((weekData)=>({
                    count: weekData.deploymentCount.prod,
                    startDateInclusive: weekData.startDateInclusive,
                    environment: 'production'
                })), (0, (0, parcelRequire("eZlou")).LINE_COLOR_MAP).prod, 'solid', (0, ($parcel$interopDefault($cNCnq))), 6),
            ...$8c6613932f8c18c1$var$getEnvironmentSeries(reportData.weeksData.map((weekData)=>({
                    count: weekData.deploymentCount.unmapped,
                    startDateInclusive: weekData.startDateInclusive,
                    environment: 'unmapped'
                })), (0, (0, parcelRequire("eZlou")).LINE_COLOR_MAP).unmapped, 'dashed', (0, ($parcel$interopDefault($k33L7))), 6)
        ];
});
parcelRegister("ekrfX", function(module, exports) {
    module.exports = new URL("line-chart-development.6278a877.svg", import.meta.url).toString();
});
parcelRegister("cNCnq", function(module, exports) {
    module.exports = new URL("line-chart-production.cf5ea457.svg", import.meta.url).toString();
});
parcelRegister("53yth", function(module, exports) {
    module.exports = new URL("line-chart-staging.0cc32c4b.svg", import.meta.url).toString();
});
parcelRegister("9Bnm7", function(module, exports) {
    module.exports = new URL("line-chart-testing.75b26c7f.svg", import.meta.url).toString();
});
parcelRegister("k33L7", function(module, exports) {
    module.exports = new URL("line-chart-unmapped.3a47f8c5.svg", import.meta.url).toString();
});
parcelRegister("eZlou", function(module, exports) {
    $parcel$export(module.exports, "LINE_COLOR_MAP", ()=>$c44f581d396673db$export$7aa99c2d78620887);
    const $c44f581d396673db$export$7aa99c2d78620887 = {
        development: (0, $829f609a65d26a98$exports).B200,
        testing: (0, $829f609a65d26a98$exports).T300,
        staging: (0, $829f609a65d26a98$exports).T500,
        prod: (0, $829f609a65d26a98$exports).B400,
        unmapped: (0, $829f609a65d26a98$exports).P200
    };
});
parcelRegister("kRE16", function(module, exports) {
    $parcel$export(module.exports, "Legend", ()=>$37f589fb03b6c0b6$export$ed247974535929c7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eJS47;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $koVbs;
    var $f70oV;
    var $claG0;
    var $9zf9q = parcelRequire("9zf9q");
    var $hKk4Y = parcelRequire("hKk4Y");
    var $lB6Hu = parcelRequire("lB6Hu");
    var $9Ncxd = parcelRequire("9Ncxd");
    var $fTAlu = parcelRequire("fTAlu");
    var $g7PDF;
    var $2jMxH;
    const $37f589fb03b6c0b6$var$EnvironmentLegend = ({ iconSrc: iconSrc, environment: environment, shouldDisplayTooltipForUnmappedLegend: shouldDisplayTooltipForUnmappedLegend })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$LegendRow, null, (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$LegendIcon, {
            src: iconSrc,
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$LegendLabel, null, formatMessage((0, (0, parcelRequire("f70oV")).default)[environment])), shouldDisplayTooltipForUnmappedLegend && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $37f589fb03b6c0b6$var$tooltipContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("g7PDF")).default).unmappedTooltip),
            position: "right"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$QuestionIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
            size: "small",
            label: ""
        })))));
    };
    const $37f589fb03b6c0b6$var$LeftContent = ({ developmentCount: developmentCount, testingCount: testingCount, stagingCount: stagingCount, productionCount: productionCount, unmappedCount: unmappedCount, shouldDisplayTooltipForUnmappedLegend: shouldDisplayTooltipForUnmappedLegend })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, developmentCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$EnvironmentLegend, {
            iconSrc: (0, ($parcel$interopDefault($9zf9q))),
            environment: "development",
            shouldDisplayTooltipForUnmappedLegend: false
        }), testingCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$EnvironmentLegend, {
            iconSrc: (0, ($parcel$interopDefault($9Ncxd))),
            environment: "testing",
            shouldDisplayTooltipForUnmappedLegend: false
        }), stagingCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$EnvironmentLegend, {
            iconSrc: (0, ($parcel$interopDefault($lB6Hu))),
            environment: "staging",
            shouldDisplayTooltipForUnmappedLegend: false
        }), productionCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$EnvironmentLegend, {
            iconSrc: (0, ($parcel$interopDefault($hKk4Y))),
            environment: "production",
            shouldDisplayTooltipForUnmappedLegend: false
        }), unmappedCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$EnvironmentLegend, {
            iconSrc: (0, ($parcel$interopDefault($fTAlu))),
            environment: "unmapped",
            shouldDisplayTooltipForUnmappedLegend: shouldDisplayTooltipForUnmappedLegend
        })));
    const $37f589fb03b6c0b6$var$RightContent = ({ developmentCount: developmentCount, testingCount: testingCount, stagingCount: stagingCount, productionCount: productionCount, unmappedCount: unmappedCount })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, developmentCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$WeekDeploymentCountRow, null, developmentCount), testingCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$WeekDeploymentCountRow, null, testingCount), stagingCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$WeekDeploymentCountRow, null, stagingCount), productionCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$WeekDeploymentCountRow, null, productionCount), unmappedCount !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$WeekDeploymentCountRow, null, unmappedCount));
    const $37f589fb03b6c0b6$export$ed247974535929c7 = ({ deploymentReportData: deploymentReportData, selectedWeekStart: selectedWeekStart })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { developmentCount: developmentCount, testingCount: testingCount, stagingCount: stagingCount, productionCount: productionCount, unmappedCount: unmappedCount } = (0, (0, parcelRequire("2jMxH")).getPotentialCounts)(deploymentReportData, selectedWeekStart);
        const shouldDisplayTooltipForUnmappedLegend = (0, (0, parcelRequire("claG0")).isDataUnmappedFoundWithMissingPreProdButWithProd)(deploymentReportData);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$LeftContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$TitleLeftContainer, null, formatMessage((0, (0, parcelRequire("g7PDF")).default).environmentTypeTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$LeftContent, {
            developmentCount: developmentCount,
            testingCount: testingCount,
            stagingCount: stagingCount,
            productionCount: productionCount,
            unmappedCount: unmappedCount,
            shouldDisplayTooltipForUnmappedLegend: shouldDisplayTooltipForUnmappedLegend
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$RightContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$TitleRightContainer, null, formatMessage((0, (0, parcelRequire("g7PDF")).default).weeklyDeploymentTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$RightContent, {
            developmentCount: developmentCount,
            testingCount: testingCount,
            stagingCount: stagingCount,
            productionCount: productionCount,
            unmappedCount: unmappedCount
        })));
    };
    const $37f589fb03b6c0b6$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $37f589fb03b6c0b6$var$LeftContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $37f589fb03b6c0b6$var$RightContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1fhb _16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $37f589fb03b6c0b6$var$rowCommonStyles = null;
    const $37f589fb03b6c0b6$var$titleCommonStyles = null;
    const $37f589fb03b6c0b6$var$TitleLeftContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1a45 _11c81vlj _k48pmoej _4t3ipxbi _otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $37f589fb03b6c0b6$var$TitleRightContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1a45 _11c81vlj _k48pmoej _4t3ipxbi _otyru2gc _y3gn1h6o",
                __cmplp.className
            ])
        });
    });
    const $37f589fb03b6c0b6$var$LegendRow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _otyru2gc _4t3ipxbi",
                __cmplp.className
            ])
        });
    });
    const $37f589fb03b6c0b6$var$LegendIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbpxbi",
                __cmplp.className
            ])
        });
    });
    const $37f589fb03b6c0b6$var$LegendLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66 _11c81vlj",
                __cmplp.className
            ])
        });
    });
    const $37f589fb03b6c0b6$var$WeekDeploymentCountRow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyru2gc _4t3ipxbi _y3gn1h6o _11c81vlj",
                __cmplp.className
            ])
        });
    });
    const $37f589fb03b6c0b6$var$QuestionIcon = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _lswu12xz _syazs6h6 _80omtlke",
                __cmplp.className
            ])
        });
    });
    const $37f589fb03b6c0b6$var$tooltipContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.negative.050'
    });
});
parcelRegister("9zf9q", function(module, exports) {
    module.exports = new URL("development.ce6d1083.svg", import.meta.url).toString();
});
parcelRegister("hKk4Y", function(module, exports) {
    module.exports = new URL("production.a13364ef.svg", import.meta.url).toString();
});
parcelRegister("lB6Hu", function(module, exports) {
    module.exports = new URL("staging.daa5274a.svg", import.meta.url).toString();
});
parcelRegister("9Ncxd", function(module, exports) {
    module.exports = new URL("testing.d27e57ac.svg", import.meta.url).toString();
});
parcelRegister("fTAlu", function(module, exports) {
    module.exports = new URL("unmapped.d0b998cd.png", import.meta.url).toString();
});
parcelRegister("g7PDF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1a93bbe05943003$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e1a93bbe05943003$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        environmentTypeTitle: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.legend.environment-type-title",
            "defaultMessage": "Environment type"
        },
        weeklyDeploymentTitle: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.legend.weekly-deployment-title",
            "defaultMessage": "Week Deployments"
        },
        unmappedTooltip: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.legend.unmapped-tooltip",
            "defaultMessage": "Unmapped or missing environments. Configure your deployment tool to map your deployment to the environment type."
        }
    });
});
parcelRegister("2jMxH", function(module, exports) {
    $parcel$export(module.exports, "getPotentialCounts", ()=>$070d4d1aa5386367$export$847b2a18518cd2fc);
    var $l8ekP;
    var $claG0;
    const $070d4d1aa5386367$var$getPotentialCount = (isDataAbsolutelyEmpty, isEnvironmentDataEmpty, isDataUnmappedFoundWithMissingProd, count)=>{
        if (isDataAbsolutelyEmpty) return 0;
        if (isDataUnmappedFoundWithMissingProd && isEnvironmentDataEmpty) return '-';
        return isEnvironmentDataEmpty ? undefined : count;
    };
    const $070d4d1aa5386367$export$847b2a18518cd2fc = (reportData, selectedWeekStart)=>{
        const isDataAbsolutelyEmpty = (0, (0, parcelRequire("claG0")).isDataAbsolutelyEmpty)(reportData);
        const isDevelopmentDataEmpty = (0, (0, parcelRequire("claG0")).isDevelopmentDataEmpty)(reportData);
        const isTestingDataEmpty = (0, (0, parcelRequire("claG0")).isTestingDataEmpty)(reportData);
        const isStagingDataEmpty = (0, (0, parcelRequire("claG0")).isStagingDataEmpty)(reportData);
        const isProdDataEmpty = (0, (0, parcelRequire("claG0")).isProdDataEmpty)(reportData);
        const isUnmappedDataEmpty = (0, (0, parcelRequire("claG0")).isUnmappedDataEmpty)(reportData);
        const isDataUnmappedFoundWithMissingProd = (0, (0, parcelRequire("claG0")).isDataUnmappedFoundWithMissingProd)(reportData);
        const selectedWeekData = (0, (0, parcelRequire("l8ekP")).getSelectedWeekData)(reportData.weeksData, selectedWeekStart);
        return {
            developmentCount: $070d4d1aa5386367$var$getPotentialCount(isDataAbsolutelyEmpty, isDevelopmentDataEmpty, isDataUnmappedFoundWithMissingProd, selectedWeekData.deploymentCount.development),
            testingCount: $070d4d1aa5386367$var$getPotentialCount(isDataAbsolutelyEmpty, isTestingDataEmpty, isDataUnmappedFoundWithMissingProd, selectedWeekData.deploymentCount.testing),
            stagingCount: $070d4d1aa5386367$var$getPotentialCount(isDataAbsolutelyEmpty, isStagingDataEmpty, isDataUnmappedFoundWithMissingProd, selectedWeekData.deploymentCount.staging),
            productionCount: $070d4d1aa5386367$var$getPotentialCount(isDataAbsolutelyEmpty, isProdDataEmpty, isDataUnmappedFoundWithMissingProd, selectedWeekData.deploymentCount.prod),
            unmappedCount: $070d4d1aa5386367$var$getPotentialCount(isDataAbsolutelyEmpty, isUnmappedDataEmpty, isDataUnmappedFoundWithMissingProd, selectedWeekData.deploymentCount.unmapped)
        };
    };
});
parcelRegister("8PdvU", function(module, exports) {
    $parcel$export(module.exports, "LoadingSkeleton", ()=>$92961529bda703e4$export$44c18d210d5de37b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gwIPs;
    var $4McSe;
    const $92961529bda703e4$export$44c18d210d5de37b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($92961529bda703e4$var$ChartTitle, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 30}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px`,
            margin: "0"
        }));
    const $92961529bda703e4$var$ChartTitle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkpxbi _4t3i1tcg _19bvv47k",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hoNfM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$337c5ca2b1e7dcd9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $337c5ca2b1e7dcd9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chartTitle: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.chart-title",
            "defaultMessage": "All deployment environment types"
        },
        titleHelpTooltip: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.title-help-tooltip",
            "defaultMessage": "Compare your deployment frequency for all environment types. To avoid risky deployments, try to deploy to production more often, or equally to other environments."
        },
        noMappedWarningTitle: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.no-mapped-warning-title",
            "defaultMessage": "No mapped deployment data"
        },
        noMappedWarningDescription: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.no-mapped-warning-description",
            "defaultMessage": "To make full use of this report, configure your deployment tool to map your deployments to environment types."
        },
        nonProdWarningTitle: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.non-prod-warning-title",
            "defaultMessage": "No production deployment data"
        },
        nonProdWarningDescription: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.non-prod-warning-description",
            "defaultMessage": "To make full use of this report, configure your deployment tool to map your production deployments to the production environment."
        },
        dropDownButtonDescription: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.drop-down-button-description",
            "defaultMessage": "Show all deployment environment types"
        },
        dropDownButtonOpenDescription: {
            "id": "software-deployment-frequency-report.line-chart-by-environment.drop-down-button-open-description",
            "defaultMessage": "Hide all deployment environment types"
        }
    });
});
parcelRegister("1kopK", function(module, exports) {
    $parcel$export(module.exports, "PerDeploymentDetailTable", ()=>$0c7ef676cf134889$export$a4efc4887401308e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $k3qRI;
    var $1dJ6S;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $kBSee;
    var $gilhC;
    var $mEdYv;
    var $caivO;
    var $jKTxB;
    var $krJkJ;
    var $lvKVW;
    var $8FGd5;
    const $0c7ef676cf134889$var$Title = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0c7ef676cf134889$var$TableTitleContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("lvKVW")).default).chartTitle)));
    };
    const $0c7ef676cf134889$export$a4efc4887401308e = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ selectedWeekStart: selectedWeekStart }] = (0, (0, parcelRequire("gilhC")).useSelectedWeekStore)();
        const [, { setSelectedDeploymentId: setSelectedDeploymentId }] = (0, (0, parcelRequire("mEdYv")).useSelectedDeploymentId)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("jKTxB")).usePeriodBreakdownMetrics)(selectedWeekStart !== null ? (0, (0, parcelRequire("kBSee")).getWeekRangeFromWeekStartDate)(selectedWeekStart) : null);
        const selectDeployment = (deployment)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'issuesPerDeploymentCell'
            }));
            setSelectedDeploymentId(deployment.id);
        };
        const rows = (0, (0, parcelRequire("8FGd5")).useTableRows)(data?.perDeploymentMetrics, data?.medianIssuesPerDeployment, selectDeployment);
        const header = (0, (0, parcelRequire("8FGd5")).useTableHeader)();
        if (error && rows === null || loading || rows === null || selectedWeekStart === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("krJkJ")).LoadingSkeleton), null);
        error;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0c7ef676cf134889$var$IssueTableContainer, {
            "data-test-id": "software-deployment-frequency-report.ui.per-deployment-detail-table"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caivO")).ViewDeploymentFrequencyReportExperienceSuccessTracker), null), (0, ($parcel$interopDefault($5uXOq))).createElement($0c7ef676cf134889$var$Title, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3qRI")).default), {
            key: JSON.stringify(selectedWeekStart),
            head: header,
            rows: rows,
            rowsPerPage: !loading && rows.length > 10 ? 10 : undefined,
            defaultPage: 1,
            loadingSpinnerSize: "large",
            isLoading: loading,
            isFixedSize: true,
            defaultSortKey: "jiraIssuesPerDeployment",
            defaultSortOrder: "DESC"
        }));
    };
    const $0c7ef676cf134889$var$TableTitleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i7vkz _18s810cz",
                __cmplp.className
            ])
        });
    });
    const $0c7ef676cf134889$var$IssueTableContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { faded: faded, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4h8dc _4t3isby8",
                __cmplp.faded ? "_tzy4105o" : "_tzy4kb7n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("krJkJ", function(module, exports) {
    $parcel$export(module.exports, "LoadingSkeleton", ()=>$3c5215eff0dfb8ae$export$44c18d210d5de37b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $8CUq3;
    var $4McSe;
    const $3c5215eff0dfb8ae$export$44c18d210d5de37b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $3c5215eff0dfb8ae$var$tableTitleStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "120px",
            height: "16px",
            margin: "0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($3c5215eff0dfb8ae$var$TableContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($3c5215eff0dfb8ae$var$TableHeader, null, (0, ($parcel$interopDefault($5uXOq))).createElement($3c5215eff0dfb8ae$var$TableHeaderLeft, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "76px",
            height: "12px",
            margin: "0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "76px",
            height: "12px",
            margin: `0 0 0 ${"var(--ds-space-500, 40px)"}px`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "32px",
            height: "12px",
            margin: `0 0 0 ${"var(--ds-space-500, 40px)"}px`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($3c5215eff0dfb8ae$var$TableHeaderRight, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "76px",
            height: "12px",
            margin: "0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "56px",
            height: "12px",
            margin: `0 0 0 ${"var(--ds-space-400, 40px)"}px`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: "84px",
            height: "12px",
            margin: `0 0 0 ${"var(--ds-space-800, 64px)"}px`
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).LineThick), null)));
    const $3c5215eff0dfb8ae$var$tableTitleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.200',
        height: 'space.300'
    });
    const $3c5215eff0dfb8ae$var$TableContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3isby8",
                __cmplp.className
            ])
        });
    });
    const $3c5215eff0dfb8ae$var$TableHeader = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3ixy5q _1e0c1txw _1bah1yb4",
                __cmplp.className
            ])
        });
    });
    const $3c5215eff0dfb8ae$var$TableHeaderLeft = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2hwx1ber _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $3c5215eff0dfb8ae$var$TableHeaderRight = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lvKVW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93315d73ef3acb1e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $93315d73ef3acb1e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chartTitle: {
            "id": "software-deployment-frequency-report.per-deployment-detail-table.chart-title",
            "defaultMessage": "Deployments"
        },
        jiraIssuePerDeploymentColumnHead: {
            "id": "software-deployment-frequency-report.per-deployment-detail-table.jira-issue-per-deployment-column-head",
            "defaultMessage": "Jira issues per deployments"
        },
        deploymentColumnHead: {
            "id": "software-deployment-frequency-report.per-deployment-detail-table.deployment-column-head",
            "defaultMessage": "Deployment"
        },
        environmentNameColumnHead: {
            "id": "software-deployment-frequency-report.per-deployment-detail-table.environment-name-column-head",
            "defaultMessage": "Environment name"
        },
        pipelineColumnHead: {
            "id": "software-deployment-frequency-report.per-deployment-detail-table.pipeline-column-head",
            "defaultMessage": "Pipeline"
        },
        dateDeployedColumnHead: {
            "id": "software-deployment-frequency-report.per-deployment-detail-table.date-deployed-column-head",
            "defaultMessage": "Date deployed"
        }
    });
});
parcelRegister("8FGd5", function(module, exports) {
    $parcel$export(module.exports, "useTableHeader", ()=>$5124ddaec0d6668d$export$7fbbd6f6958548dc);
    $parcel$export(module.exports, "useTableRows", ()=>$5124ddaec0d6668d$export$a190e1af00082b41);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3bDjY;
    var $aWse0;
    var $d5cn8;
    var $bgPrG;
    var $lvKVW;
    const $5124ddaec0d6668d$export$7fbbd6f6958548dc = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        return {
            cells: [
                {
                    key: 'jiraIssuesPerDeployment',
                    content: formatMessage((0, (0, parcelRequire("lvKVW")).default).jiraIssuePerDeploymentColumnHead),
                    isSortable: true,
                    width: 180
                },
                {
                    key: 'deployment',
                    content: formatMessage((0, (0, parcelRequire("lvKVW")).default).deploymentColumnHead),
                    isSortable: true,
                    width: 140
                },
                {
                    key: 'environmentName',
                    content: formatMessage((0, (0, parcelRequire("lvKVW")).default).environmentNameColumnHead),
                    isSortable: true,
                    width: 200
                },
                {
                    key: 'pipeline',
                    content: formatMessage((0, (0, parcelRequire("lvKVW")).default).pipelineColumnHead),
                    isSortable: true,
                    width: 360
                },
                {
                    key: 'dateDeployed',
                    content: formatMessage((0, (0, parcelRequire("lvKVW")).default).dateDeployedColumnHead),
                    isSortable: true,
                    width: 100
                }
            ]
        };
    };
    const $5124ddaec0d6668d$export$a190e1af00082b41 = (data, medianIssuesPerDeployment, selectDeployment)=>{
        const { formatDate: formatDate } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const [, actions] = (0, (0, parcelRequire("d5cn8")).useHoveredDeployment)();
        if (data == null || medianIssuesPerDeployment === undefined) return null;
        if (medianIssuesPerDeployment === null) return [];
        return data.map((deployment)=>{
            const { id: id, issueCount: issueCount, displayName: deploymentName, url: deploymentUrl, environment: { displayName: environmentName }, lastUpdated: dateDeployed, pipeline: { url: pipelineUrl, displayName: pipelineName } } = deployment;
            return {
                'data-deployment-id': id,
                onMouseEnter: (evt)=>{
                    actions.setHoveredDeployment(evt.currentTarget.dataset.deploymentId);
                },
                onMouseLeave: ()=>{
                    actions.setHoveredDeployment(null);
                },
                cells: [
                    {
                        key: `${issueCount} ${id}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bgPrG")).JiraIssuesPerDeploymentCellContent), {
                            medianIssuesPerDeployment: medianIssuesPerDeployment,
                            issueCount: issueCount,
                            onClick: ()=>selectDeployment(deployment)
                        })
                    },
                    {
                        key: `${deploymentName} ${id}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement($5124ddaec0d6668d$var$CellContentLink, {
                            href: deploymentUrl,
                            target: "_blank"
                        }, deploymentName)
                    },
                    {
                        key: `${environmentName} ${id}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement($5124ddaec0d6668d$var$CellContent, null, environmentName)
                    },
                    {
                        key: `${pipelineName} ${id}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement($5124ddaec0d6668d$var$CellContentLink, {
                            href: pipelineUrl,
                            target: "_blank"
                        }, pipelineName)
                    },
                    {
                        key: `${dateDeployed.getTime()} ${id}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                            content: formatDate(dateDeployed, {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                hour: 'numeric',
                                minute: 'numeric'
                            }),
                            position: "top-start"
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5124ddaec0d6668d$var$CellContent, null, formatDate(dateDeployed, {
                            month: 'short',
                            day: 'numeric'
                        })))
                    }
                ]
            };
        });
    };
    const $5124ddaec0d6668d$var$contentCommonCssStyles = null;
    const $5124ddaec0d6668d$var$CellContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _4t3izwfg _1e0c1txw _2lx21bp4 _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $5124ddaec0d6668d$var$CellContentLink = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _4t3izwfg _1e0c1txw _2lx21bp4 _1bah1h6o _4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1y58 _80omtlke _9oik18uv _1bnxglyw _jf4cnqa1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bgPrG", function(module, exports) {
    $parcel$export(module.exports, "JiraIssuesPerDeploymentCellContent", ()=>$0fe50fc915321385$export$cfadf0aa0c81a4ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3bDjY;
    var $koVbs;
    var $dW099;
    var $29lcr;
    var $fDJCJ;
    const $0fe50fc915321385$var$getIconTooltipTranslatedMessage = (trend, formatMessage)=>{
        switch(trend){
            case 'under':
                return formatMessage((0, (0, parcelRequire("fDJCJ")).default).underTwelveWeekMedian);
            case 'over':
                return formatMessage((0, (0, parcelRequire("fDJCJ")).default).overTwelveWeekMedian);
            case 'equal':
                return '';
            default:
                trend;
                throw new Error('Unknown trend is given to getIconTooltipTranslatedMessage');
        }
    };
    const $0fe50fc915321385$export$cfadf0aa0c81a4ad = ({ medianIssuesPerDeployment: medianIssuesPerDeployment, issueCount: issueCount, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const trend = (0, (0, parcelRequire("29lcr")).getTrend)(issueCount, medianIssuesPerDeployment);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0fe50fc915321385$var$Wrapper, {
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: $0fe50fc915321385$var$getIconTooltipTranslatedMessage(trend, formatMessage),
            position: "right"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0fe50fc915321385$var$TrendIconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dW099")).TrendIcon), {
            trend: trend,
            colorScheme: "UP_IS_BAD"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement($0fe50fc915321385$var$IssueCount, null, formatMessage((0, (0, parcelRequire("fDJCJ")).default).numIssues, {
            numIssues: issueCount
        })));
    };
    const $0fe50fc915321385$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _1e0c1txw _4cvr1h6o _4t3izwfg",
                __cmplp.className
            ])
        });
    });
    const $0fe50fc915321385$var$TrendIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb7vkz",
                __cmplp.className
            ])
        });
    });
    const $0fe50fc915321385$var$IssueCount = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk18uv _18u01b66 _4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1y58 _11c81oud _80omtlke _9oik18uv _1bnxglyw _jf4cnqa1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fDJCJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f2b5ec44b18633c4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f2b5ec44b18633c4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        numIssues: {
            "id": "software-deployment-frequency-report.per-deployment-detail-table.jira-issues-per-deployment-cell-content.num-issues",
            "defaultMessage": "{numIssues} {numIssues, plural, one {issue} other {issues}}"
        },
        overTwelveWeekMedian: {
            "id": "software-deployment-frequency-report.per-deployment-detail-table.jira-issues-per-deployment-cell-content.over-twelve-week-median",
            "defaultMessage": "Over 12-week median"
        },
        underTwelveWeekMedian: {
            "id": "software-deployment-frequency-report.per-deployment-detail-table.jira-issues-per-deployment-cell-content.under-twelve-week-median",
            "defaultMessage": "Under 12-week median"
        }
    });
});
parcelRegister("3MLtm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae7e66be432feacc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $6Ingq;
    var $b9dFI;
    var $jcw0u;
    var $aWse0;
    var $8zOmE;
    var $2NMNM;
    var $gilhC;
    var $3Ws3s;
    var $claG0;
    var $82EMK;
    var $7moEc;
    var $jDAXZ;
    const $ae7e66be432feacc$var$PeriodFilter = ()=>{
        const [{ selectedWeekStart: selectedWeekStart }, { setSelectedWeekStart: setSelectedWeekStart }] = (0, (0, parcelRequire("gilhC")).useSelectedWeekStore)();
        const { data: coreData, loading: coreDataLoading, error: coreDataError } = (0, (0, parcelRequire("3Ws3s")).useReportCoreData)();
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const hasReportedError = (0, $5uXOq.useRef)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const weekStartDates = (0, $5uXOq.useMemo)(()=>coreData ? (0, (0, parcelRequire("jDAXZ")).getDateOptionsFromCoreData)(coreData) : [], [
            coreData
        ]);
        const options = (0, $5uXOq.useMemo)(()=>coreData ? [
                {
                    label: formatMessage((0, (0, parcelRequire("7moEc")).default).weekCommencing),
                    options: weekStartDates.map((singleBarData)=>({
                            label: formatDate(singleBarData.startDateInclusive, {
                                month: 'short',
                                day: 'numeric'
                            }),
                            value: singleBarData.startDateInclusive
                        }))
                }
            ] : [], [
            coreData,
            weekStartDates,
            formatDate,
            formatMessage
        ]);
        if (coreDataError && !hasReportedError.current) {
            hasReportedError.current = true;
            (0, (0, parcelRequire("jcw0u")).default)({
                error: coreDataError,
                meta: {
                    id: 'periodFilterAGGError',
                    packageName: 'jiraSoftwareDeploymentFrequencyReport',
                    teamName: 'fusion-solaris'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        if (coreDataLoading || selectedWeekStart === null || coreData == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("82EMK")).LoadingSkeleton), null);
        const prodDataState = (0, (0, parcelRequire("claG0")).getProdDataState)(coreData);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ae7e66be432feacc$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-test-id": "software-deployment-frequency-report.ui.period-filter.div"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9dFI")).default), {
            classNamePrefix: "period-filter-popup-select",
            searchThreshold: 100,
            options: options,
            value: options[0].options.find((o)=>o.value.getTime() === selectedWeekStart.getTime()),
            onChange: ({ label: label, value: value }, { action: action })=>{
                if (action === 'select-option') {
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'selectedWeek',
                        actionSubjectId: 'deploymentFrequencyReport'
                    }));
                    const singleBarData = weekStartDates.find((x)=>x.startDateInclusive === value);
                    if (!singleBarData) throw new Error(`cannot find dateRange from ${label}`);
                    setSelectedWeekStart(singleBarData.startDateInclusive);
                }
            },
            target: ({ isOpen: isOpen, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: ""
                    }),
                    isDisabled: prodDataState === 'COMPLETELY_EMPTY'
                }, formatMessage((0, (0, parcelRequire("7moEc")).default).weekOf, {
                    date: formatDate(selectedWeekStart, {
                        month: 'short',
                        day: 'numeric'
                    })
                }))
        })));
    };
    var $ae7e66be432feacc$export$2e2bcd8739ae039 = $ae7e66be432feacc$var$PeriodFilter;
    const $ae7e66be432feacc$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("b9dFI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$768d8504b373d7ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $9ZKDH = parcelRequire("9ZKDH");
    var $dI393 = parcelRequire("dI393");
    var $5n5w4;
    var $283js;
    var $iGDLS;
    var $4wJSY = parcelRequire("4wJSY");
    var $9KnKW;
    var $VSDnB;
    var $7VXAu;
    var $7K5PP;
    var $eaXSR;
    var $1DATb;
    var $hT6ku;
    const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $768d8504b373d7ff$var$FocusLock = (0, (0, parcelRequire("VSDnB")).fg)('platform_dst_select-bump-react-focus-lock') ? (0, $9ZKDH.default) : (0, $ao4Ml.default);
    const $768d8504b373d7ff$var$modifiers = [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 5,
                boundary: 'clippingParents',
                altAxis: true,
                altBoundary: true
            }
        }
    ];
    const $768d8504b373d7ff$var$defaultPopperProps = {
        modifiers: $768d8504b373d7ff$var$modifiers,
        placement: 'bottom-start'
    };
    const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
    class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                closeMenuOnSelect: true,
                shouldCloseMenuOnTab: true,
                components: {},
                maxMenuHeight: 300,
                maxMenuWidth: 440,
                minMenuWidth: 220,
                popperProps: {},
                isSearchable: true,
                searchThreshold: 5,
                styles: {},
                options: []
            };
        }
        static getDerivedStateFromProps(props, state) {
            const newState = {};
            const mergedPopperProps = {
                ...$768d8504b373d7ff$var$defaultPopperProps,
                ...props.popperProps
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
            const mergedComponents = {
                ...(0, (0, parcelRequire("hT6ku")).defaultComponents),
                ...props.components
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
            if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
            return null;
        }
        componentDidMount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: this.handleClick,
                options: {
                    capture: true
                }
            });
        }
        componentWillUnmount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick?.();
            this.unbindWindowClick = null;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }
        componentDidUpdate(prevProps) {
            const { isOpen: isOpen } = this.props;
            if (prevProps.isOpen !== isOpen) {
                if (isOpen === true) this.open({
                    controlOverride: true
                });
                else if (isOpen === false) this.close({
                    controlOverride: true
                });
            }
        }
        render() {
            const { target: target } = this.props;
            const { isOpen: isOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5n5w4")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9KnKW")).IdProvider), {
                postfix: "-popup-select"
            }, ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iGDLS")).Reference), null, ({ ref: ref })=>target && target({
                        isOpen: isOpen,
                        onKeyDown: this.handleTargetKeyDown,
                        ref: this.resolveTargetRef(ref),
                        'aria-haspopup': 'true',
                        'aria-expanded': isOpen,
                        'aria-controls': isOpen ? id : undefined
                    })), this.renderSelect(id))));
        }
        constructor(...args){
            super(...args);
            this.menuRef = null;
            this.selectRef = null;
            this.targetRef = null;
            this.unbindWindowClick = null;
            this.unbindWindowKeydown = null;
            this.defaultStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
                groupHeading: (provided)=>({
                        ...provided,
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                    })
            });
            this.isOpenControlled = this.props.isOpen !== undefined;
            this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
            this.state = {
                focusLockEnabled: false,
                isOpen: this.defaultOpenState ?? false,
                mergedComponents: (0, (0, parcelRequire("hT6ku")).defaultComponents),
                mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
            };
            this.handleTargetKeyDown = (event)=>{
                switch(event.key){
                    case 'ArrowDown':
                        this.open();
                        break;
                    default:
                }
            };
            this.handleKeyDown = (event)=>{
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
                switch(event.key){
                    case 'Escape':
                    case 'Esc':
                        this.close();
                        break;
                    default:
                }
                if (this.props.onKeyDown) this.props.onKeyDown(event);
            };
            this.handleClick = ({ target: target })=>{
                const { isOpen: isOpen } = this.state;
                if (!(target instanceof Element)) return;
                if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
                if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
            };
            this.handleSelectChange = (value, actionMeta)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
                if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
                if (onChange) onChange(value, actionMeta);
            };
            this.handleFirstPopperUpdate = ()=>{
                this.setState({
                    focusLockEnabled: true
                });
            };
            this.open = (options)=>{
                const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onOpen) onOpen();
                if (onMenuOpen && (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
                this.setState({
                    isOpen: true
                }, ()=>{
                    if (this.selectRef) this.selectRef.select?.openMenu('first');
                });
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: this.handleKeyDown,
                    options: {
                        capture: true
                    }
                });
            };
            this.close = (options)=>{
                const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onClose) onClose();
                if (onMenuClose && (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
                this.setState({
                    isOpen: false
                });
                this.setState({
                    focusLockEnabled: false
                });
                if (this.targetRef != null) this.targetRef.focus();
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown?.();
                this.unbindWindowKeydown = null;
            };
            this.resolveTargetRef = (popperRef)=>(ref)=>{
                    if (!this.targetRef && popperRef && ref) {
                        this.targetRef = ref;
                        if (typeof popperRef === 'function') popperRef(ref);
                        else popperRef.current = ref;
                    }
                };
            this.resolveMenuRef = (popperRef)=>(ref)=>{
                    this.menuRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                };
            this.getSelectRef = (ref)=>{
                this.selectRef = ref;
            };
            this.getItemCount = ()=>{
                const { options: options } = this.props;
                let count = 0;
                options.forEach((groupOrOption)=>{
                    if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                    else count++;
                });
                return count;
            };
            this.getMaxHeight = ()=>{
                const { maxMenuHeight: maxMenuHeight } = this.props;
                if (!this.selectRef) return maxMenuHeight;
                const showSearchControl = this.showSearchControl();
                const controlRef = this.selectRef.select?.controlRef;
                const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
                const maxHeight = maxMenuHeight - offsetHeight;
                return maxHeight;
            };
            this.showSearchControl = ()=>{
                const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
                return isSearchable && this.getItemCount() > searchThreshold;
            };
            this.renderSelect = (id)=>{
                const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
                const menuHandlers = !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver') ? {
                    onMenuOpen: onMenuOpen,
                    onMenuClose: onMenuClose
                } : {};
                const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
                const showSearchControl = this.showSearchControl();
                const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
                if (!portalDestination || !isOpen) return null;
                const selectComponents = {
                    ...mergedComponents,
                    Control: showSearchControl ? mergedComponents.Control : (0, (0, parcelRequire("hT6ku")).DummyControl)
                };
                const getLabel = ()=>{
                    if (label) return label;
                    else if (typeof placeholder === 'string') return placeholder;
                };
                const providedAriaLabel = getLabel();
                const updateInputAriaLabel = (ariaLabelText)=>{
                    if (this.selectRef?.select?.inputRef) {
                        if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                        this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                    }
                };
                const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                    const { focused: focused } = onFocusProps;
                    const options = props?.options || [];
                    const totalLength = options?.length;
                    const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                    const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                    const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                    return ariaLabelText;
                };
                const onReactSelectFocus = (onFocusProps)=>{
                    const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                    let ariaLabelText = '';
                    let ariaLiveMessage = '';
                    if (props.options?.length) {
                        if ((0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options)) {
                            const totalLength = (0, (0, parcelRequire("1DATb")).countAllOptions)(props.options);
                            ariaLiveMessage = (0, (0, parcelRequire("1DATb")).onFocus)(onFocusProps, props.options);
                            ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                        } else {
                            ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                            ariaLiveMessage = ariaLabelText;
                        }
                        updateInputAriaLabel(ariaLabelText);
                        return ariaLiveMessage;
                    }
                    return ariaLiveMessage;
                };
                const popper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("283js")).Popper), {
                    ...mergedPopperProps,
                    onFirstUpdate: (state)=>{
                        this.handleFirstPopperUpdate();
                        mergedPopperProps.onFirstUpdate?.(state);
                    }
                }, ({ placement: placement, ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement($768d8504b373d7ff$var$ConditionalNodeResolverWrapper, {
                        hasNodeResolver: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver'),
                        innerRef: this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hT6ku")).MenuDialog), {
                        style: style,
                        "data-placement": placement,
                        minWidth: minMenuWidth,
                        maxWidth: maxMenuWidth,
                        id: id,
                        testId: testId,
                        ref: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement($768d8504b373d7ff$var$FocusLock, {
                        disabled: !focusLockEnabled,
                        returnFocus: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        "aria-label": providedAriaLabel,
                        backspaceRemovesValue: false,
                        controlShouldRenderValue: false,
                        isClearable: false,
                        tabSelectsValue: false,
                        menuIsOpen: true,
                        placeholder: placeholder,
                        ref: this.getSelectRef,
                        ...props,
                        ...menuHandlers,
                        isSearchable: showSearchControl,
                        styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)(this.defaultStyles, props.styles || {}),
                        maxMenuHeight: this.getMaxHeight(),
                        components: selectComponents,
                        onChange: this.handleSelectChange,
                        ariaLiveMessages: !showSearchControl ? {
                            onFocus: onReactSelectFocus,
                            ...props.ariaLiveMessages
                        } : props.ariaLiveMessages
                    }), footer))));
                return mergedPopperProps.strategy === 'fixed' ? popper : (0, $7nsd3.createPortal)(popper, portalDestination);
            };
        }
    }
    const $768d8504b373d7ff$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
        if (hasNodeResolver) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($dI393))), {
            innerRef: innerRef
        }, children);
        return children;
    };
});
parcelRegister("5n5w4", function(module, exports) {
    $parcel$export(module.exports, "ManagerReferenceNodeContext", ()=>$3e93612641040812$export$3dbd3405086fec7b);
    $parcel$export(module.exports, "ManagerReferenceNodeSetterContext", ()=>$3e93612641040812$export$cbabb21c2529b130);
    $parcel$export(module.exports, "Manager", ()=>$3e93612641040812$export$d0d38e7dec7a1a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
    var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
    function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
        var children = _ref.children;
        var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
        var hasUnmounted = $5uXOq.useRef(false);
        $5uXOq.useEffect(function() {
            return function() {
                hasUnmounted.current = true;
            };
        }, []);
        var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
            if (!hasUnmounted.current) setReferenceNode(node);
        }, []);
        return $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
            value: referenceNode
        }, $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
            value: handleSetReferenceNode
        }, children));
    }
});
parcelRegister("283js", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$18cee5f949ac4034$export$badac9ada3a0bdf9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5n5w4;
    var $eclLw;
    var $fNOWl;
    var $18cee5f949ac4034$var$NOOP = function NOOP() {
        return void 0;
    };
    var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
        return Promise.resolve(null);
    };
    var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
    function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
        var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
        var referenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeContext));
        var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
        var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
        $5uXOq.useEffect(function() {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, popperElement);
        }, [
            innerRef,
            popperElement
        ]);
        var options = $5uXOq.useMemo(function() {
            return {
                placement: placement,
                strategy: strategy,
                onFirstUpdate: onFirstUpdate,
                modifiers: [].concat(modifiers, [
                    {
                        name: 'arrow',
                        enabled: arrowElement != null,
                        options: {
                            element: arrowElement
                        }
                    }
                ])
            };
        }, [
            placement,
            strategy,
            onFirstUpdate,
            modifiers,
            arrowElement
        ]);
        var _usePopper = (0, (0, parcelRequire("fNOWl")).usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
        var childrenProps = $5uXOq.useMemo(function() {
            return {
                ref: setPopperElement,
                style: styles.popper,
                placement: state ? state.placement : placement,
                hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
                isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
                arrowProps: {
                    style: styles.arrow,
                    ref: setArrowElement
                },
                forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
                update: update || $18cee5f949ac4034$var$NOOP_PROMISE
            };
        }, [
            setPopperElement,
            setArrowElement,
            placement,
            state,
            styles,
            update,
            forceUpdate
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)(childrenProps);
    }
});
parcelRegister("eclLw", function(module, exports) {
    $parcel$export(module.exports, "unwrapArray", ()=>$a56311d537d20f47$export$f52c55943429c8b6);
    $parcel$export(module.exports, "safeInvoke", ()=>$a56311d537d20f47$export$3dfa7c28635fe028);
    $parcel$export(module.exports, "setRef", ()=>$a56311d537d20f47$export$4bb192c7cacf928f);
    $parcel$export(module.exports, "fromEntries", ()=>$a56311d537d20f47$export$5150077fc2e7c662);
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$a56311d537d20f47$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
        return Array.isArray(arg) ? arg[0] : arg;
    };
    var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
        if (typeof fn === 'function') {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return fn.apply(void 0, args);
        }
    };
    var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
        if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
        else if (ref != null) ref.current = node;
    };
    var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
        return entries.reduce(function(acc, _ref) {
            var key = _ref[0], value = _ref[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
});
parcelRegister("fNOWl", function(module, exports) {
    $parcel$export(module.exports, "usePopper", ()=>$b812f23d0bbb9e85$export$f4d5bf230a36dd6e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $8Pv9O;
    var $lHrkK = parcelRequire("lHrkK");
    var $eclLw;
    var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
    var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
        if (options === void 0) options = {};
        var prevOptions = $5uXOq.useRef(null);
        var optionsWithDefaults = {
            onFirstUpdate: options.onFirstUpdate,
            placement: options.placement || 'bottom',
            strategy: options.strategy || 'absolute',
            modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
        };
        var _React$useState = $5uXOq.useState({
            styles: {
                popper: {
                    position: optionsWithDefaults.strategy,
                    left: '0',
                    top: '0'
                },
                arrow: {
                    position: 'absolute'
                }
            },
            attributes: {}
        }), state = _React$useState[0], setState = _React$useState[1];
        var updateStateModifier = $5uXOq.useMemo(function() {
            return {
                name: 'updateState',
                enabled: true,
                phase: 'write',
                fn: function fn(_ref) {
                    var state = _ref.state;
                    var elements = Object.keys(state.elements);
                    $7nsd3.flushSync(function() {
                        setState({
                            styles: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.styles[element] || {}
                                ];
                            })),
                            attributes: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.attributes[element]
                                ];
                            }))
                        });
                    });
                },
                requires: [
                    'computeStyles'
                ]
            };
        }, []);
        var popperOptions = $5uXOq.useMemo(function() {
            var newOptions = {
                onFirstUpdate: optionsWithDefaults.onFirstUpdate,
                placement: optionsWithDefaults.placement,
                strategy: optionsWithDefaults.strategy,
                modifiers: [].concat(optionsWithDefaults.modifiers, [
                    updateStateModifier,
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ])
            };
            if ((0, ($parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
            else {
                prevOptions.current = newOptions;
                return newOptions;
            }
        }, [
            optionsWithDefaults.onFirstUpdate,
            optionsWithDefaults.placement,
            optionsWithDefaults.strategy,
            optionsWithDefaults.modifiers,
            updateStateModifier
        ]);
        var popperInstanceRef = $5uXOq.useRef();
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
        }, [
            popperOptions
        ]);
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (referenceElement == null || popperElement == null) return;
            var createPopper = options.createPopper || (0, (0, parcelRequire("8Pv9O")).createPopper);
            var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
            popperInstanceRef.current = popperInstance;
            return function() {
                popperInstance.destroy();
                popperInstanceRef.current = null;
            };
        }, [
            referenceElement,
            popperElement,
            options.createPopper
        ]);
        return {
            state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
            styles: state.styles,
            attributes: state.attributes,
            update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
            forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
        };
    };
});
parcelRegister("8Pv9O", function(module, exports) {
    $parcel$export(module.exports, "createPopper", ()=>$66db415bc009fd50$export$8f7491d57c8f97a9);
    var $dsn8Y;
    var $4TVC8;
    var $j8nKB;
    var $baic6;
    var $1AoLg;
    var $gy4Xr;
    var $3dDWl;
    var $1DdSC;
    var $gzAfz;
    var $6iLAT;
    var $66db415bc009fd50$export$d34966752335dd47 = [
        (0, (0, parcelRequire("4TVC8")).default),
        (0, (0, parcelRequire("j8nKB")).default),
        (0, (0, parcelRequire("baic6")).default),
        (0, (0, parcelRequire("1AoLg")).default),
        (0, (0, parcelRequire("gy4Xr")).default),
        (0, (0, parcelRequire("3dDWl")).default),
        (0, (0, parcelRequire("1DdSC")).default),
        (0, (0, parcelRequire("gzAfz")).default),
        (0, (0, parcelRequire("6iLAT")).default)
    ];
    var $66db415bc009fd50$export$8f7491d57c8f97a9 = (0, (0, parcelRequire("dsn8Y")).popperGenerator)({
        defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
    });
});
parcelRegister("dsn8Y", function(module, exports) {
    $parcel$export(module.exports, "popperGenerator", ()=>$9cbfd7bdb6a4f3f1$export$ed5e13716264f202);
    var $gvlia;
    var $jkGDj;
    var $2r6BH;
    var $gbHJy;
    var $kcmIg;
    var $a8clb;
    var $i9xH7;
    var $gmkfg;
    var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function $9cbfd7bdb6a4f3f1$var$areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: (0, (0, parcelRequire("gmkfg")).isElement)(reference) ? (0, (0, parcelRequire("2r6BH")).default)(reference) : reference.contextElement ? (0, (0, parcelRequire("2r6BH")).default)(reference.contextElement) : [],
                        popper: (0, (0, parcelRequire("2r6BH")).default)(popper)
                    };
                    var orderedModifiers = (0, (0, parcelRequire("kcmIg")).default)((0, (0, parcelRequire("i9xH7")).default)([].concat(defaultModifiers, state.options.modifiers)));
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
                    if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                    state.rects = {
                        reference: (0, (0, parcelRequire("gvlia")).default)(reference, (0, (0, parcelRequire("gbHJy")).default)(popper), state.options.strategy === 'fixed'),
                        popper: (0, (0, parcelRequire("jkGDj")).default)(popper)
                    };
                    state.reset = false;
                    state.placement = state.options.placement;
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                update: (0, (0, parcelRequire("a8clb")).default)(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            });
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = $9cbfd7bdb6a4f3f1$export$ed5e13716264f202();
});
parcelRegister("gvlia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0400ebb908e52cb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $9FFjG;
    var $f5IBt;
    var $gmkfg;
    var $imzt5;
    var $eVELE;
    var $c6EdA;
    var $90xPK;
    function $c0400ebb908e52cb$var$isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = (0, (0, parcelRequire("90xPK")).round)(rect.width) / element.offsetWidth || 1;
        var scaleY = (0, (0, parcelRequire("90xPK")).round)(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    }
    function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent);
        var offsetParentIsScaled = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
        var documentElement = (0, (0, parcelRequire("eVELE")).default)(offsetParent);
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) !== 'body' || (0, (0, parcelRequire("c6EdA")).default)(documentElement)) scroll = (0, (0, parcelRequire("9FFjG")).default)(offsetParent);
            if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent)) {
                offsets = (0, (0, parcelRequire("g2O7Z")).default)(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = (0, (0, parcelRequire("imzt5")).default)(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
});
parcelRegister("g2O7Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bae3b796a534b2cf$export$2e2bcd8739ae039);
    var $gmkfg;
    var $90xPK;
    var $1Prpe;
    var $d8bsQ;
    function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            scaleX = element.offsetWidth > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = (0, (0, parcelRequire("gmkfg")).isElement)(element) ? (0, (0, parcelRequire("1Prpe")).default)(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !(0, (0, parcelRequire("d8bsQ")).default)() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
});
parcelRegister("gmkfg", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$be8e67adfa808002$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$be8e67adfa808002$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isShadowRoot", ()=>$be8e67adfa808002$export$af51f0f06c0f328a);
    var $1Prpe;
    function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
});
parcelRegister("1Prpe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$154fd01b154b825f$export$2e2bcd8739ae039);
    function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
});
parcelRegister("90xPK", function(module, exports) {
    $parcel$export(module.exports, "max", ()=>$68ee5bce69e9df7e$export$8960430cfd85939f);
    $parcel$export(module.exports, "min", ()=>$68ee5bce69e9df7e$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "round", ()=>$68ee5bce69e9df7e$export$2077e0241d6afd3c);
    var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
    var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
    var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;
});
parcelRegister("d8bsQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98f4ea48bb7f7060$export$2e2bcd8739ae039);
    var $j5Xhq;
    function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
        return !/^((?!chrome|android).)*safari/i.test((0, (0, parcelRequire("j5Xhq")).default)());
    }
});
parcelRegister("j5Xhq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de6c77c242bcf4cf$export$2e2bcd8739ae039);
    function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
});
parcelRegister("9FFjG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70a7fdf85bb2e8b8$export$2e2bcd8739ae039);
    var $8YTLN;
    var $1Prpe;
    var $gmkfg;
    var $i1ad3;
    function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
        if (node === (0, (0, parcelRequire("1Prpe")).default)(node) || !(0, (0, parcelRequire("gmkfg")).isHTMLElement)(node)) return (0, (0, parcelRequire("8YTLN")).default)(node);
        else return (0, (0, parcelRequire("i1ad3")).default)(node);
    }
});
parcelRegister("8YTLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$689f300ec0defb42$export$2e2bcd8739ae039);
    var $1Prpe;
    function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
});
parcelRegister("i1ad3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1e03d69dfb9832f$export$2e2bcd8739ae039);
    function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
});
parcelRegister("f5IBt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afc9ebf0aa1487e4$export$2e2bcd8739ae039);
    function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
});
parcelRegister("imzt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5e5cb506db8cdcb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $eVELE;
    var $8YTLN;
    function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("g2O7Z")).default)((0, (0, parcelRequire("eVELE")).default)(element)).left + (0, (0, parcelRequire("8YTLN")).default)(element).scrollLeft;
    }
});
parcelRegister("eVELE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ade6032ba4b824fe$export$2e2bcd8739ae039);
    var $gmkfg;
    function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
        return (((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
});
parcelRegister("c6EdA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d053e13cecc73ee$export$2e2bcd8739ae039);
    var $1ix2F;
    function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
        var _getComputedStyle = (0, (0, parcelRequire("1ix2F")).default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
});
parcelRegister("1ix2F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f211a5db2cb1d1b$export$2e2bcd8739ae039);
    var $1Prpe;
    function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("1Prpe")).default)(element).getComputedStyle(element);
    }
});
parcelRegister("jkGDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e130f49f6e9ebcb4$export$2e2bcd8739ae039);
    var $g2O7Z;
    function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
        var clientRect = (0, (0, parcelRequire("g2O7Z")).default)(element);
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
});
parcelRegister("2r6BH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c633a6ac170841a$export$2e2bcd8739ae039);
    var $k82dT;
    var $eTUzl;
    var $1Prpe;
    var $c6EdA;
    function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = (0, (0, parcelRequire("k82dT")).default)(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = (0, (0, parcelRequire("1Prpe")).default)(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], (0, (0, parcelRequire("c6EdA")).default)(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(target)));
    }
});
parcelRegister("k82dT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea7647704a508683$export$2e2bcd8739ae039);
    var $eTUzl;
    var $c6EdA;
    var $f5IBt;
    var $gmkfg;
    function $ea7647704a508683$export$2e2bcd8739ae039(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(node)) >= 0) return node.ownerDocument.body;
        if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(node) && (0, (0, parcelRequire("c6EdA")).default)(node)) return node;
        return $ea7647704a508683$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(node));
    }
});
parcelRegister("eTUzl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad921528f26834dd$export$2e2bcd8739ae039);
    var $f5IBt;
    var $eVELE;
    var $gmkfg;
    function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
        if ((0, (0, parcelRequire("f5IBt")).default)(element) === 'html') return element;
        return (element.assignedSlot || element.parentNode || ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(element) ? element.host : null) || (0, (0, parcelRequire("eVELE")).default)(element));
    }
});
parcelRegister("gbHJy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8f9908a1e4106f$export$2e2bcd8739ae039);
    var $1Prpe;
    var $f5IBt;
    var $1ix2F;
    var $gmkfg;
    var $6hs9X;
    var $eTUzl;
    var $j5Xhq;
    function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
        if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || (0, (0, parcelRequire("1ix2F")).default)(element).position === 'fixed') return null;
        return element.offsetParent;
    }
    function $bc8f9908a1e4106f$var$getContainingBlock(element) {
        var isFirefox = /firefox/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        var isIE = /Trident/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        if (isIE && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            var elementCss = (0, (0, parcelRequire("1ix2F")).default)(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = (0, (0, parcelRequire("eTUzl")).default)(element);
        if ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(currentNode)) currentNode = currentNode.host;
        while((0, (0, parcelRequire("gmkfg")).isHTMLElement)(currentNode) && [
            'html',
            'body'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(currentNode)) < 0){
            var css = (0, (0, parcelRequire("1ix2F")).default)(currentNode);
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    }
    function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
        var window = (0, (0, parcelRequire("1Prpe")).default)(element);
        var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
        while(offsetParent && (0, (0, parcelRequire("6hs9X")).default)(offsetParent) && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
        if (offsetParent && ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'html' || (0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'body' && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')) return window;
        return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
    }
});
parcelRegister("6hs9X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$492a2c861940c94d$export$2e2bcd8739ae039);
    var $f5IBt;
    function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(element)) >= 0;
    }
});
parcelRegister("kcmIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb468bf0752088cc$export$2e2bcd8739ae039);
    var $kJPed;
    function $eb468bf0752088cc$var$order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        });
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) sort(modifier);
        });
        return result;
    }
    function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
        var orderedModifiers = $eb468bf0752088cc$var$order(modifiers);
        return (0, (0, parcelRequire("kJPed")).modifierPhases).reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
});
parcelRegister("kJPed", function(module, exports) {
    $parcel$export(module.exports, "top", ()=>$f18fbf7b212a7c8e$export$1e95b668f3b82d);
    $parcel$export(module.exports, "bottom", ()=>$f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
    $parcel$export(module.exports, "right", ()=>$f18fbf7b212a7c8e$export$79ffe56a765070d2);
    $parcel$export(module.exports, "left", ()=>$f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
    $parcel$export(module.exports, "auto", ()=>$f18fbf7b212a7c8e$export$dfb5619354ba860);
    $parcel$export(module.exports, "basePlacements", ()=>$f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
    $parcel$export(module.exports, "start", ()=>$f18fbf7b212a7c8e$export$b3571188c770cc5a);
    $parcel$export(module.exports, "end", ()=>$f18fbf7b212a7c8e$export$bd5df0f255a350f8);
    $parcel$export(module.exports, "clippingParents", ()=>$f18fbf7b212a7c8e$export$390fd549c5303b4d);
    $parcel$export(module.exports, "viewport", ()=>$f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
    $parcel$export(module.exports, "popper", ()=>$f18fbf7b212a7c8e$export$ae5ab1c730825774);
    $parcel$export(module.exports, "reference", ()=>$f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
    $parcel$export(module.exports, "variationPlacements", ()=>$f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
    $parcel$export(module.exports, "placements", ()=>$f18fbf7b212a7c8e$export$803cd8101b6c182b);
    $parcel$export(module.exports, "modifierPhases", ()=>$f18fbf7b212a7c8e$export$d087d3878fdf71d5);
    var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
    var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
    var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
    var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
    var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
    var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
        $f18fbf7b212a7c8e$export$1e95b668f3b82d,
        $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
        $f18fbf7b212a7c8e$export$79ffe56a765070d2,
        $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
    ];
    var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
    var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
    var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
    var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
    var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
    var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
    var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$803cd8101b6c182b = [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
        $f18fbf7b212a7c8e$export$dfb5619354ba860
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
    var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
    var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead';
    var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
    var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
    var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain';
    var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
    var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
    var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
    var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
        $f18fbf7b212a7c8e$export$421679a7c3d56e,
        $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
        $f18fbf7b212a7c8e$export$6964f6c886723980,
        $f18fbf7b212a7c8e$export$c65e99957a05207c,
        $f18fbf7b212a7c8e$export$f22da7240b7add18,
        $f18fbf7b212a7c8e$export$bab79516f2d662fe,
        $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
        $f18fbf7b212a7c8e$export$68d8715fc104d294,
        $f18fbf7b212a7c8e$export$70a6e5159acce2e6
    ];
});
parcelRegister("a8clb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7604395822cc5d61$export$2e2bcd8739ae039);
    function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
});
parcelRegister("i9xH7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3733441fcf2e882$export$2e2bcd8739ae039);
    function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {});
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
});
parcelRegister("4TVC8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3918fd6b815bcf57$export$2e2bcd8739ae039);
    var $1Prpe;
    var $3918fd6b815bcf57$var$passive = {
        passive: true
    };
    function $3918fd6b815bcf57$var$effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window = (0, (0, parcelRequire("1Prpe")).default)(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
            });
            if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        };
    }
    var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: $3918fd6b815bcf57$var$effect,
        data: {}
    };
});
parcelRegister("j8nKB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dee1300a39219bb5$export$2e2bcd8739ae039);
    var $dJ0Jl;
    function $dee1300a39219bb5$var$popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        state.modifiersData[name] = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    }
    var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: $dee1300a39219bb5$var$popperOffsets,
        data: {}
    };
});
parcelRegister("dJ0Jl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fe00b5c334118ac$export$2e2bcd8739ae039);
    var $QXpw1;
    var $cGRJ4;
    var $9GF9F;
    var $kJPed;
    function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? (0, (0, parcelRequire("QXpw1")).default)(placement) : null;
        var variation = placement ? (0, (0, parcelRequire("cGRJ4")).default)(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case 0, (0, parcelRequire("kJPed")).top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 0, (0, parcelRequire("kJPed")).left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? (0, (0, parcelRequire("9GF9F")).default)(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case 0, (0, parcelRequire("kJPed")).start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case 0, (0, parcelRequire("kJPed")).end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
                default:
            }
        }
        return offsets;
    }
});
parcelRegister("QXpw1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f2f123ac4a9fdf$export$2e2bcd8739ae039);
    function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[0];
    }
});
parcelRegister("cGRJ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93d315208040ceed$export$2e2bcd8739ae039);
    function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[1];
    }
});
parcelRegister("9GF9F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70d7f5cda4210aa3$export$2e2bcd8739ae039);
    function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
});
parcelRegister("baic6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$820ebddbe0682e4f$export$2e2bcd8739ae039);
    var $kJPed;
    var $gbHJy;
    var $1Prpe;
    var $eVELE;
    var $1ix2F;
    var $QXpw1;
    var $cGRJ4;
    var $90xPK;
    var $820ebddbe0682e4f$var$unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    };
    function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: (0, (0, parcelRequire("90xPK")).round)(x * dpr) / dpr || 0,
            y: (0, (0, parcelRequire("90xPK")).round)(y * dpr) / dpr || 0
        };
    }
    function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = (0, (0, parcelRequire("kJPed")).left);
        var sideY = (0, (0, parcelRequire("kJPed")).top);
        var win = window;
        if (adaptive) {
            var offsetParent = (0, (0, parcelRequire("gbHJy")).default)(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === (0, (0, parcelRequire("1Prpe")).default)(popper)) {
                offsetParent = (0, (0, parcelRequire("eVELE")).default)(popper);
                if ((0, (0, parcelRequire("1ix2F")).default)(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            }
            offsetParent;
            if (placement === (0, (0, parcelRequire("kJPed")).top) || (placement === (0, (0, parcelRequire("kJPed")).left) || placement === (0, (0, parcelRequire("kJPed")).right)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideY = (0, (0, parcelRequire("kJPed")).bottom);
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === (0, (0, parcelRequire("kJPed")).left) || (placement === (0, (0, parcelRequire("kJPed")).top) || placement === (0, (0, parcelRequire("kJPed")).bottom)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideX = (0, (0, parcelRequire("kJPed")).right);
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && $820ebddbe0682e4f$var$unsetSides);
        var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
            x: x,
            y: y
        }, (0, (0, parcelRequire("1Prpe")).default)(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function $820ebddbe0682e4f$var$computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: (0, (0, parcelRequire("QXpw1")).default)(state.placement),
            variation: (0, (0, parcelRequire("cGRJ4")).default)(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    }
    var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: $820ebddbe0682e4f$var$computeStyles,
        data: {}
    };
});
parcelRegister("1AoLg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$127c5c56b9511f5f$export$2e2bcd8739ae039);
    var $f5IBt;
    var $gmkfg;
    function $127c5c56b9511f5f$var$applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name];
            if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function $127c5c56b9511f5f$var$effect(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {});
                if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    }
    var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: $127c5c56b9511f5f$var$applyStyles,
        effect: $127c5c56b9511f5f$var$effect,
        requires: [
            'computeStyles'
        ]
    };
});
parcelRegister("gy4Xr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0c3aad300d72ee1$export$2e2bcd8739ae039);
    var $QXpw1;
    var $kJPed;
    function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
        var invertDistance = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).top)
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function $c0c3aad300d72ee1$var$offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = (0, (0, parcelRequire("kJPed")).placements).reduce(function(acc, placement) {
            acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    }
    var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: $c0c3aad300d72ee1$var$offset
    };
});
parcelRegister("3dDWl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$258191447a7022df$export$2e2bcd8739ae039);
    var $jwSgb;
    var $QXpw1;
    var $4tIVJ;
    var $kgkit;
    var $cqF2x;
    var $kJPed;
    var $cGRJ4;
    function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
        if ((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto)) return [];
        var oppositePlacement = (0, (0, parcelRequire("jwSgb")).default)(placement);
        return [
            (0, (0, parcelRequire("4tIVJ")).default)(placement),
            oppositePlacement,
            (0, (0, parcelRequire("4tIVJ")).default)(oppositePlacement)
        ];
    }
    function $258191447a7022df$var$flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            (0, (0, parcelRequire("jwSgb")).default)(preferredPlacement)
        ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto) ? (0, (0, parcelRequire("cqF2x")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
            var isStartVariation = (0, (0, parcelRequire("cGRJ4")).default)(placement) === (0, (0, parcelRequire("kJPed")).start);
            var isVertical = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).bottom)
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? (0, (0, parcelRequire("kJPed")).right) : (0, (0, parcelRequire("kJPed")).left) : isStartVariation ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).top);
            if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var altVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    }
    var $258191447a7022df$export$2e2bcd8739ae039 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: $258191447a7022df$var$flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
});
parcelRegister("jwSgb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37b1862c86f39c4$export$2e2bcd8739ae039);
    var $e37b1862c86f39c4$var$hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return $e37b1862c86f39c4$var$hash[matched];
        });
    }
});
parcelRegister("4tIVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342cb90cb2622617$export$2e2bcd8739ae039);
    var $342cb90cb2622617$var$hash = {
        start: 'end',
        end: 'start'
    };
    function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return $342cb90cb2622617$var$hash[matched];
        });
    }
});
parcelRegister("kgkit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec050bcf5e349283$export$2e2bcd8739ae039);
    var $dknpr;
    var $eVELE;
    var $g2O7Z;
    var $dJ0Jl;
    var $h8W1z;
    var $kJPed;
    var $gmkfg;
    var $gIXWB;
    var $50KfK;
    function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, (0, parcelRequire("kJPed")).clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, (0, parcelRequire("kJPed")).viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, (0, parcelRequire("kJPed")).popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
        var altContext = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? (0, (0, parcelRequire("kJPed")).reference) : (0, (0, parcelRequire("kJPed")).popper);
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = (0, (0, parcelRequire("dknpr")).default)((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element : element.contextElement || (0, (0, parcelRequire("eVELE")).default)(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = (0, (0, parcelRequire("g2O7Z")).default)(state.elements.reference);
        var popperOffsets = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = (0, (0, parcelRequire("h8W1z")).default)(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? popperClientRect : referenceClientRect;
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset;
        if (elementContext === (0, (0, parcelRequire("kJPed")).popper) && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    (0, (0, parcelRequire("kJPed")).right),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    (0, (0, parcelRequire("kJPed")).top),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
});
parcelRegister("dknpr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3f4d3932acb3b2$export$2e2bcd8739ae039);
    var $kJPed;
    var $3V2hG;
    var $9NXD7;
    var $2r6BH;
    var $gbHJy;
    var $eVELE;
    var $1ix2F;
    var $gmkfg;
    var $g2O7Z;
    var $eTUzl;
    var $j6yPg;
    var $f5IBt;
    var $h8W1z;
    var $90xPK;
    function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === (0, (0, parcelRequire("kJPed")).viewport) ? (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("3V2hG")).default)(element, strategy)) : (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("9NXD7")).default)((0, (0, parcelRequire("eVELE")).default)(element)));
    }
    function $9b3f4d3932acb3b2$var$getClippingParents(element) {
        var clippingParents = (0, (0, parcelRequire("2r6BH")).default)((0, (0, parcelRequire("eTUzl")).default)(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf((0, (0, parcelRequire("1ix2F")).default)(element).position) >= 0;
        var clipperElement = canEscapeClipping && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) ? (0, (0, parcelRequire("gbHJy")).default)(element) : element;
        if (!(0, (0, parcelRequire("gmkfg")).isElement)(clipperElement)) return [];
        return clippingParents.filter(function(clippingParent) {
            return (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) && (0, (0, parcelRequire("j6yPg")).default)(clippingParent, clipperElement) && (0, (0, parcelRequire("f5IBt")).default)(clippingParent) !== 'body';
        });
    }
    function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = (0, (0, parcelRequire("90xPK")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("90xPK")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("90xPK")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("90xPK")).max)(rect.left, accRect.left);
            return accRect;
        }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
});
parcelRegister("3V2hG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2da877912142c34b$export$2e2bcd8739ae039);
    var $1Prpe;
    var $eVELE;
    var $imzt5;
    var $d8bsQ;
    function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(element);
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0, (0, parcelRequire("d8bsQ")).default)();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + (0, (0, parcelRequire("imzt5")).default)(element),
            y: y
        };
    }
});
parcelRegister("9NXD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7236f1f1532b7fe8$export$2e2bcd8739ae039);
    var $eVELE;
    var $1ix2F;
    var $imzt5;
    var $8YTLN;
    var $90xPK;
    function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
        var _element$ownerDocumen;
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var winScroll = (0, (0, parcelRequire("8YTLN")).default)(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = (0, (0, parcelRequire("90xPK")).max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = (0, (0, parcelRequire("90xPK")).max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + (0, (0, parcelRequire("imzt5")).default)(element);
        var y = -winScroll.scrollTop;
        if ((0, (0, parcelRequire("1ix2F")).default)(body || html).direction === 'rtl') x += (0, (0, parcelRequire("90xPK")).max)(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
});
parcelRegister("j6yPg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de89978be23479c4$export$2e2bcd8739ae039);
    var $gmkfg;
    function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode();
        if (parent.contains(child)) return true;
        else if (rootNode && (0, (0, parcelRequire("gmkfg")).isShadowRoot)(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                next = next.parentNode || next.host;
            }while (next)
        }
        return false;
    }
});
parcelRegister("h8W1z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7b0316bb2f8fd97$export$2e2bcd8739ae039);
    function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
});
parcelRegister("gIXWB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2cf410c4fe133f4$export$2e2bcd8739ae039);
    var $1ANH0;
    function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
        return Object.assign({}, (0, (0, parcelRequire("1ANH0")).default)(), paddingObject);
    }
});
parcelRegister("1ANH0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128fb32b18b92ffa$export$2e2bcd8739ae039);
    function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
});
parcelRegister("50KfK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
    function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
});
parcelRegister("cqF2x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c7bf65fbdbec33$export$2e2bcd8739ae039);
    var $cGRJ4;
    var $kJPed;
    var $kgkit;
    var $QXpw1;
    function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, (0, parcelRequire("kJPed")).placements) : _options$allowedAutoP;
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(placement);
        var placements = variation ? flipVariations ? (0, (0, parcelRequire("kJPed")).variationPlacements) : (0, (0, parcelRequire("kJPed")).variationPlacements).filter(function(placement) {
            return (0, (0, parcelRequire("cGRJ4")).default)(placement) === variation;
        }) : (0, (0, parcelRequire("kJPed")).basePlacements);
        var allowedPlacements = placements.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements;
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[(0, (0, parcelRequire("QXpw1")).default)(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
});
parcelRegister("1DdSC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13043339457d5bc5$export$2e2bcd8739ae039);
    var $kJPed;
    var $QXpw1;
    var $9GF9F;
    var $dNtrn;
    var $4WpIh;
    var $jkGDj;
    var $gbHJy;
    var $kgkit;
    var $cGRJ4;
    var $1ANH0;
    var $90xPK;
    function $13043339457d5bc5$var$preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var altAxis = (0, (0, parcelRequire("dNtrn")).default)(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var altSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === (0, (0, parcelRequire("kJPed")).start) ? referenceRect[len] : popperRect[len];
            var maxLen = variation === (0, (0, parcelRequire("kJPed")).start) ? -popperRect[len] : -referenceRect[len];
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? (0, (0, parcelRequire("jkGDj")).default)(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, (0, parcelRequire("1ANH0")).default)();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide];
            var arrowLen = (0, (0, parcelRequire("4WpIh")).within)(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && (0, (0, parcelRequire("gbHJy")).default)(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0, (0, parcelRequire("4WpIh")).within)(tether ? (0, (0, parcelRequire("90xPK")).min)(min, tetherMin) : min, offset, tether ? (0, (0, parcelRequire("90xPK")).max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var _altSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).left)
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? (0, (0, parcelRequire("4WpIh")).withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, (0, parcelRequire("4WpIh")).within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
    var $13043339457d5bc5$export$2e2bcd8739ae039 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: $13043339457d5bc5$var$preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
});
parcelRegister("dNtrn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
    function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
});
parcelRegister("4WpIh", function(module, exports) {
    $parcel$export(module.exports, "within", ()=>$3990864f59117d05$export$f28d906d67a997f3);
    $parcel$export(module.exports, "withinMaxClamp", ()=>$3990864f59117d05$export$86c8af6d3ef0b4a);
    var $90xPK;
    function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
        return (0, (0, parcelRequire("90xPK")).max)(min, (0, (0, parcelRequire("90xPK")).min)(value, max));
    }
    function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
        var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
        return v > max ? max : v;
    }
});
parcelRegister("gzAfz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c10c08bd5e0ed9fb$export$2e2bcd8739ae039);
    var $QXpw1;
    var $jkGDj;
    var $j6yPg;
    var $gbHJy;
    var $9GF9F;
    var $4WpIh;
    var $gIXWB;
    var $50KfK;
    var $kJPed;
    var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
    };
    function $c10c08bd5e0ed9fb$var$arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var axis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var isVertical = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
        var arrowRect = (0, (0, parcelRequire("jkGDj")).default)(arrowElement);
        var minProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
        var maxProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = (0, (0, parcelRequire("gbHJy")).default)(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2;
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = (0, (0, parcelRequire("4WpIh")).within)(min, center, max);
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function $c10c08bd5e0ed9fb$var$effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!(0, (0, parcelRequire("j6yPg")).default)(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    }
    var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: $c10c08bd5e0ed9fb$var$arrow,
        effect: $c10c08bd5e0ed9fb$var$effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
});
parcelRegister("6iLAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$496957b0c691a0ed$export$2e2bcd8739ae039);
    var $kJPed;
    var $kgkit;
    function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
        return [
            (0, (0, parcelRequire("kJPed")).top),
            (0, (0, parcelRequire("kJPed")).right),
            (0, (0, parcelRequire("kJPed")).bottom),
            (0, (0, parcelRequire("kJPed")).left)
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function $496957b0c691a0ed$var$hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    }
    var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: $496957b0c691a0ed$var$hide
    };
});
parcelRegister("iGDLS", function(module, exports) {
    $parcel$export(module.exports, "Reference", ()=>$d9aafffd117cbcc1$export$e0be378c32fb70a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBYjV = parcelRequire("hBYjV");
    var $5n5w4;
    var $eclLw;
    function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
        var children = _ref.children, innerRef = _ref.innerRef;
        var setReferenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeSetterContext));
        var refHandler = $5uXOq.useCallback(function(node) {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, node);
            (0, (0, parcelRequire("eclLw")).safeInvoke)(setReferenceNode, node);
        }, [
            innerRef,
            setReferenceNode
        ]);
        $5uXOq.useEffect(function() {
            return function() {
                return (0, (0, parcelRequire("eclLw")).setRef)(innerRef, null);
            };
        }, []);
        $5uXOq.useEffect(function() {
            (0, ($parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        }, [
            setReferenceNode
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)({
            ref: refHandler
        });
    }
});
parcelRegister("4wJSY", function(module, exports) {
    $parcel$export(module.exports, "shallowEqualObjects", ()=>$34bdbe885d924a05$export$3e67810a3f0e9f1c);
    function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
        if (arrA === arrB) return true;
        if (!arrA || !arrB) return false;
        const len = arrA.length;
        if (arrB.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (arrA[i] !== arrB[i]) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
        if (objA === objB) return true;
        if (!objA || !objB) return false;
        const aKeys = Object.keys(objA);
        const bKeys = Object.keys(objB);
        const len = aKeys.length;
        if (bKeys.length !== len) return false;
        for(let i = 0; i < len; i++){
            const key = aKeys[i];
            if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
        const aIsArr = Array.isArray(a);
        const bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;
        if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
        return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
    }
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            ...unstyled ? {} : {
                padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
            }
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
                borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
                borderRadius: borderRadius,
                borderStyle: 'solid',
                borderWidth: 1,
                boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
                '&:hover': {
                    borderColor: isFocused ? colors.primary : colors.neutral30
                }
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        };
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            ...unstyled ? {} : {
                color: colors.neutral40,
                fontSize: '75%',
                fontWeight: 500,
                marginBottom: '0.25em',
                paddingLeft: spacing.baseUnit * 3,
                paddingRight: spacing.baseUnit * 3,
                textTransform: 'uppercase'
            }
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2,
                ':hover': {
                    color: isFocused ? colors.neutral80 : colors.neutral40
                }
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
                marginBottom: baseUnit * 2,
                marginTop: baseUnit * 2
            }
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2
            }
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            ...unstyled ? {} : {
                margin: spacing.baseUnit / 2,
                paddingBottom: spacing.baseUnit / 2,
                paddingTop: spacing.baseUnit / 2,
                color: colors.neutral80
            }
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral0,
                borderRadius: borderRadius,
                boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
                marginBottom: spacing.menuGutter,
                marginTop: spacing.menuGutter
            }
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            ...unstyled ? {} : {
                paddingBottom: baseUnit,
                paddingTop: baseUnit
            }
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            textAlign: 'center',
            ...unstyled ? {} : {
                color: colors.neutral40,
                padding: `${baseUnit * 2}px ${baseUnit * 3}px`
            }
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral10,
                borderRadius: borderRadius / 2,
                margin: spacing.baseUnit / 2
            }
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                color: colors.neutral80,
                fontSize: '85%',
                padding: 3,
                paddingLeft: 6
            }
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
            alignItems: 'center',
            display: 'flex',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                backgroundColor: isFocused ? colors.dangerLight : undefined,
                paddingLeft: spacing.baseUnit,
                paddingRight: spacing.baseUnit,
                ':hover': {
                    backgroundColor: colors.dangerLight,
                    color: colors.danger
                }
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            ...unstyled ? {} : {
                backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
                color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
                padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
                }
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            ...unstyled ? {} : {
                color: colors.neutral50,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                color: isDisabled ? colors.neutral40 : colors.neutral80,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true,
        unstyled: false
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props);
            this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            };
            this.blockOptionHover = false;
            this.isComposing = false;
            this.initialTouchX = 0;
            this.initialTouchY = 0;
            this.openAfterFocus = false;
            this.scrollToFocusedOptionOnUpdate = false;
            this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)();
            this.controlRef = null;
            this.getControlRef = (ref)=>{
                this.controlRef = ref;
            };
            this.focusedOptionRef = null;
            this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            };
            this.menuListRef = null;
            this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            };
            this.inputRef = null;
            this.getInputRef = (ref)=>{
                this.inputRef = ref;
            };
            this.focus = this.focusInput;
            this.blur = this.blurInput;
            this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            };
            this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            };
            this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            };
            this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            };
            this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            };
            this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            };
            this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            };
            this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            };
            this.getValue = ()=>this.state.selectValue;
            this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args);
            this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            };
            this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            };
            this.getStyles = (key, props)=>{
                const { unstyled: unstyled } = this.props;
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props, unstyled);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            };
            this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
            this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            };
            this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            };
            this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue);
            this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
            this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
            this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
            this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            };
            this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            };
            this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            };
            this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            };
            this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            };
            this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            };
            this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            };
            this.onCompositionStart = ()=>{
                this.isComposing = true;
            };
            this.onCompositionEnd = ()=>{
                this.isComposing = false;
            };
            this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            };
            this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            };
            this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            };
            this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            };
            this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            };
            this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            };
            this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            };
            this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            };
            this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            };
            this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            };
            this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            };
            this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            };
            this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("hT6ku", function(module, exports) {
    $parcel$export(module.exports, "MenuDialog", ()=>$3f79b132df1e01ff$export$c94219dad7c0e37d);
    $parcel$export(module.exports, "DummyControl", ()=>$3f79b132df1e01ff$export$87ce933b7fc29b8c);
    $parcel$export(module.exports, "defaultComponents", ()=>$3f79b132df1e01ff$export$71abc632aa29e6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gMMNe;
    var $bChGW;
    var $k5uoT;
    var $jldZL;
    function $3f79b132df1e01ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3f79b132df1e01ff$var$menuDialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`
    });
    const $3f79b132df1e01ff$export$c94219dad7c0e37d = (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: [
                $3f79b132df1e01ff$var$menuDialogStyles,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ],
            style: style,
            id: id,
            "data-testid": testId && `${testId}--menu`
        }, children));
    const $3f79b132df1e01ff$var$dropdownStyles = {
        name: "7693z9",
        styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
    };
    const $3f79b132df1e01ff$var$DropdownIndicator = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3f79b132df1e01ff$var$dropdownStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("gMMNe"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "open"
        }));
    const $3f79b132df1e01ff$var$controlStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            css: $3f79b132df1e01ff$var$controlStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, {
            ...props,
            innerProps: innerProps
        }));
    const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, props));
    const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $3f79b132df1e01ff$var$IndicatorSeparator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorSeparator, props);
    const $3f79b132df1e01ff$var$ClearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, props);
    const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props);
    const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
        Control: $3f79b132df1e01ff$var$Control,
        DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
        Menu: $3f79b132df1e01ff$var$Menu,
        IndicatorSeparator: $3f79b132df1e01ff$var$IndicatorSeparator,
        ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
        MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
    };
});
parcelRegister("gMMNe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));
    var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
    function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c386fa4cb21167b0$var$SearchIcon = (props)=>$c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
        }, props));
    $c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
    var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;
});
parcelRegister("77ZoC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>$5308cfd5e45a5605$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $5308cfd5e45a5605$var$_search.default
        }));
    $5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;
});
parcelRegister("82EMK", function(module, exports) {
    $parcel$export(module.exports, "LoadingSkeleton", ()=>$f5c6ed9fd949cc8e$export$44c18d210d5de37b);
    var $5uXOq = parcelRequire("5uXOq");
    var $gwIPs;
    var $4McSe;
    const $f5c6ed9fd949cc8e$export$44c18d210d5de37b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4McSe")).SkeletonItem), {
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 20}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 4}px`,
            margin: "0"
        });
});
parcelRegister("7moEc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cdf92a315d14a0d0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cdf92a315d14a0d0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        weekOf: {
            "id": "software-deployment-frequency-report.period-filter.week-of",
            "defaultMessage": "Week of {date}"
        },
        weekCommencing: {
            "id": "software-deployment-frequency-report.period-filter.week-commencing",
            "defaultMessage": "Week Commencing"
        }
    });
});
parcelRegister("jDAXZ", function(module, exports) {
    $parcel$export(module.exports, "getDateOptionsFromCoreData", ()=>$7dcd82cda3e5b584$export$e97b09724433dfb3);
    const $7dcd82cda3e5b584$var$mostRecentDateComparator = (a, b)=>b.startDateInclusive.getTime() - a.startDateInclusive.getTime();
    const $7dcd82cda3e5b584$export$e97b09724433dfb3 = (coreData)=>coreData.weeksData.filter((weekData)=>weekData.deploymentCount.prod > 0).map((weekData)=>({
                startDateInclusive: weekData.startDateInclusive
            })).sort($7dcd82cda3e5b584$var$mostRecentDateComparator);
});
parcelRegister("2e0gq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$36c0b5cadf066765$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $evqT3;
    var $koVbs;
    var $4CzOU;
    var $4hYPa = parcelRequire("4hYPa");
    var $hHPkh;
    const $36c0b5cadf066765$var$WelcomeMessage = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [hasSeenReport, setHasSeenReportToTrue] = (0, (0, parcelRequire("4CzOU")).useHasSeenReport)();
        if (hasSeenReport) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("evqT3")).default), {
            actions: [
                {
                    onClick: ()=>{
                        setHasSeenReportToTrue();
                    },
                    text: formatMessage((0, (0, parcelRequire("hHPkh")).default).gotIt)
                }
            ],
            heading: formatMessage((0, (0, parcelRequire("hHPkh")).default).heading),
            image: (0, ($parcel$interopDefault($4hYPa)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("hHPkh")).default).firstParagraph)), (0, ($parcel$interopDefault($5uXOq))).createElement($36c0b5cadf066765$var$List, null, (0, ($parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, (0, parcelRequire("hHPkh")).default).point1)), (0, ($parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, (0, parcelRequire("hHPkh")).default).point2))), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("hHPkh")).default).lastParagraph)));
    };
    var $36c0b5cadf066765$export$2e2bcd8739ae039 = $36c0b5cadf066765$var$WelcomeMessage;
    const $36c0b5cadf066765$var$List = (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0pxbi _y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("evqT3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44afc303b109e730$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9yOBd;
    var $dkK4L;
    var $1R1Ge;
    var $7QSqG;
    var $kdO7l;
    var $jSZUh;
    var $lPfex;
    class $44afc303b109e730$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { actions: actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
            const Header = this.headerComponent(this.props);
            const Footer = this.footerComponent(this.props);
            const CustomHeader = ()=>{
                const { titleId: titleId } = (0, (0, parcelRequire("kdO7l")).useModal)();
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalHeading), {
                    id: titleId
                }, heading);
            };
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                shouldCloseOnEscapePress: false,
                shouldCloseOnOverlayClick: false,
                shouldScrollInViewport: true,
                experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
                footer: footer,
                header: header,
                heading: heading,
                image: image,
                ...rest
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Header, null), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7QSqG")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalBody), null, heading && (0, (0, parcelRequire("f8Sb3")).jsx)(CustomHeader, null), children)), (0, (0, parcelRequire("f8Sb3")).jsx)(Footer, null));
        }
        constructor(...args){
            super(...args);
            this.headerComponent = (props)=>{
                const { header: HeaderElement, image: src } = props;
                const ImageElement = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalImage), {
                        src: src,
                        alt: ""
                    });
                return HeaderElement || ImageElement;
            };
            this.footerComponent = (props)=>{
                const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
                const ActionsElement = ()=>actionList ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dkK4L")).default).Provider, {
                        value: (0, (0, parcelRequire("lPfex")).modalButtonTheme)
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalActionContainer), {
                        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight
                    }, actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                        const variant = idx ? 'subtle-link' : 'primary';
                        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jSZUh")).ModalActionItem), {
                            key: key || (typeof text === 'string' ? text : `${idx}`)
                        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9yOBd")).default), {
                            appearance: variant,
                            autoFocus: !idx,
                            ...rest
                        }, text));
                    }))) : null;
                return FooterElement || ActionsElement;
            };
        }
    }
});
parcelRegister("jSZUh", function(module, exports) {
    $parcel$export(module.exports, "ModalBody", ()=>$1c1428422690040b$export$cb540d8b0ef7906c);
    $parcel$export(module.exports, "ModalHeading", ()=>$1c1428422690040b$export$9af27c346834c182);
    $parcel$export(module.exports, "ModalImage", ()=>$1c1428422690040b$export$1355685fd5f8d257);
    $parcel$export(module.exports, "ModalActionContainer", ()=>$1c1428422690040b$export$633dda6b40ac1ac3);
    $parcel$export(module.exports, "ModalActionItem", ()=>$1c1428422690040b$export$c245e9f76e3299b1);
    var $f8Sb3;
    var $3RZIb;
    function $1c1428422690040b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1c1428422690040b$var$modalBodyStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-500, 40px)"} ${"var(--ds-space-200, 16px)"}`,
        textAlign: 'center'
    });
    const $1c1428422690040b$var$modalHeadingStyles = (0, (0, parcelRequire("f8Sb3")).css)([
        (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("3RZIb")).h600)({
            theme: {
                mode: 'light'
            }
        })),
        {
            marginBottom: "var(--ds-space-100, 8px)",
            color: 'inherit'
        }
    ]);
    const $1c1428422690040b$var$modalImageStyles = {
        name: "1e6i37z",
        styles: "width:100%;height:auto;border-start-end-radius:var(--ds-border-radius, 3px);border-start-start-radius:var(--ds-border-radius, 3px);@media (min-width: 320px) and (max-width: 480px){border-radius:0;}"
    };
    const $1c1428422690040b$var$modalActionContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-500, 40px)"} 36px`,
        justifyContent: 'center',
        flexDirection: 'row',
        flexFlow: 'wrap'
    });
    const $1c1428422690040b$var$modalActionContainerReversedStyles = {
        name: "2b8jyz",
        styles: "flex-direction:row-reverse"
    };
    const $1c1428422690040b$var$modalActionItemStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $1c1428422690040b$export$cb540d8b0ef7906c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1c1428422690040b$var$modalBodyStyles
        }, children);
    const $1c1428422690040b$export$9af27c346834c182 = ({ children: children, id: id })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: $1c1428422690040b$var$modalHeadingStyles,
            id: id
        }, children);
    };
    const $1c1428422690040b$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>(0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            css: $1c1428422690040b$var$modalImageStyles,
            alt: alt,
            src: src
        });
    const $1c1428422690040b$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $1c1428422690040b$var$modalActionContainerStyles,
                shouldReverseButtonOrder && $1c1428422690040b$var$modalActionContainerReversedStyles
            ]
        }, children);
    const $1c1428422690040b$export$c245e9f76e3299b1 = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1c1428422690040b$var$modalActionItemStyles
        }, children);
});
parcelRegister("4CzOU", function(module, exports) {
    $parcel$export(module.exports, "useHasSeenReport", ()=>$404627c6e1526f46$export$cda1c287b31cf7d3);
    var $5uXOq = parcelRequire("5uXOq");
    var $89SaW;
    var $90yGq;
    const $404627c6e1526f46$var$PROPERTY_KEY = 'hasSeenDeploymentFrequencyReport';
    const $404627c6e1526f46$export$cda1c287b31cf7d3 = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [hasSeen, setHasSeen] = (0, $5uXOq.useState)(true);
        (0, $5uXOq.useEffect)(()=>{
            const fetchHasSeenDeploymentFrequencyReport = async ()=>{
                if (accountId == null) return;
                try {
                    const res = await (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, $404627c6e1526f46$var$PROPERTY_KEY);
                    setHasSeen(res);
                } catch (err) {
                    if (err.statusCode === 404) setHasSeen(false);
                    else throw err;
                }
            };
            fetchHasSeenDeploymentFrequencyReport();
        }, [
            accountId
        ]);
        return [
            hasSeen,
            ()=>{
                if (accountId == null) return;
                setHasSeen(true);
                (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, $404627c6e1526f46$var$PROPERTY_KEY, 'true');
            }
        ];
    };
});
parcelRegister("4hYPa", function(module, exports) {
    module.exports = new URL("deployment-frequency-welcome.4b7bb70b.svg", import.meta.url).toString();
});
parcelRegister("hHPkh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00613e984fcb72b4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $00613e984fcb72b4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "software-deployment-frequency-report.welcome-message.heading",
            "defaultMessage": "View and improve your deployment frequency"
        },
        firstParagraph: {
            "id": "software-deployment-frequency-report.welcome-message.first-paragraph",
            "defaultMessage": "The Deployment frequency report leverages your deployments data to get you visibility into:"
        },
        point1: {
            "id": "software-deployment-frequency-report.welcome-message.point-1",
            "defaultMessage": "How often your team is deploying to production"
        },
        point2: {
            "id": "software-deployment-frequency-report.welcome-message.point-2",
            "defaultMessage": "Whether your deployment frequency is effective in managing risk"
        },
        lastParagraph: {
            "id": "software-deployment-frequency-report.welcome-message.last-paragraph",
            "defaultMessage": "Take it for a spin and let us know what you think."
        },
        gotIt: {
            "id": "software-deployment-frequency-report.welcome-message.got-it",
            "defaultMessage": "Got it"
        }
    });
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("d31Su", function(module, exports) {
    $parcel$export(module.exports, "AsyncNoSoftwareLicense", ()=>$dcd2c1aef082694d$export$52d8964299339cae);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $kxZPA;
    const $dcd2c1aef082694d$var$LazyNoSoftwareLicense = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("1qjZt")), {
        moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
    });
    const $dcd2c1aef082694d$export$52d8964299339cae = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "no-software-license",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($dcd2c1aef082694d$var$LazyNoSoftwareLicense, null));
});
parcelRegister("1qjZt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lzKF1").then(()=>parcelRequire('eX102'));
});
parcelRegister("3RV1W", function(module, exports) {
    $parcel$export(module.exports, "checkLicense", ()=>$6334356fa938c5d8$export$fe2591be8b7e59ce);
    $parcel$export(module.exports, "LicenseCheck", ()=>$6334356fa938c5d8$export$944be0b3bf2a6feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    const $6334356fa938c5d8$var$appPermissionMapper = {
        software: 'hasSoftwareAccess',
        servicedesk: 'hasServiceDeskAccess'
    };
    const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
    const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
            return children({
                result: result
            });
        });
});
parcelRegister("2O3HP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b027e3a953156ed$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8b027e3a953156ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        reports: {
            "id": "spa-apps-software-reports-deployment-frequency-report.reports",
            "defaultMessage": "Reports"
        },
        browserTitle: {
            "id": "spa-apps-software-reports-deployment-frequency-report.browser-title",
            "defaultMessage": "Deployment frequency"
        }
    });
});
parcelRegister("fGFTb", function(module, exports) {
    $parcel$export(module.exports, "PreconditionCheck", ()=>$a346006ab91bf465$export$ef543003424a5eae);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    var $4Bwc0;
    var $caivO;
    var $2YP9W;
    var $7rdrV;
    const $a346006ab91bf465$export$669f6ea7d267feaf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($a346006ab91bf465$var$LoadingWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large"
        }));
    const $a346006ab91bf465$var$isConditionSatisfied = ({ hasViewDevToolsPermission: hasViewDevToolsPermission, hasViewAggregateDataPermission: hasViewAggregateDataPermission })=>hasViewDevToolsPermission && hasViewAggregateDataPermission;
    const $a346006ab91bf465$export$ef543003424a5eae = ({ children: children, projectKey: projectKey })=>{
        const { data: preconditionData, error: preconditionError, loading: preconditionLoading } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource));
        if (preconditionError) throw preconditionError;
        if (preconditionLoading || preconditionData == null) return (0, ($parcel$interopDefault($5uXOq))).createElement($a346006ab91bf465$export$669f6ea7d267feaf, null);
        if ($a346006ab91bf465$var$isConditionSatisfied(preconditionData)) return children;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caivO")).ViewDeploymentFrequencyReportExpectedErrorExperienceSuccessTracker), {
            reason: "User does not have permission to view the page"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7rdrV")).NoPermissionPage), {
            projectKey: projectKey
        }));
    };
    const $a346006ab91bf465$var$LoadingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7rdrV", function(module, exports) {
    $parcel$export(module.exports, "NoPermissionPage", ()=>$63cc104529566fec$export$4032ea5637bc0ae3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $1dJ6S;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $44Ege = parcelRequire("44Ege");
    var $1iZKm;
    const $63cc104529566fec$var$getProjectUrl = (projectKey)=>`/browse/${projectKey}`;
    const $63cc104529566fec$export$4032ea5637bc0ae3 = ({ projectKey: projectKey })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($63cc104529566fec$var$PageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($63cc104529566fec$var$BodyWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($63cc104529566fec$var$DescriptionWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $63cc104529566fec$var$titleWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "large"
        }, formatMessage((0, (0, parcelRequire("1iZKm")).default).title))), (0, ($parcel$interopDefault($5uXOq))).createElement($63cc104529566fec$var$Description, null, formatMessage((0, (0, parcelRequire("1iZKm")).default).description)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            href: $63cc104529566fec$var$getProjectUrl(projectKey)
        }, formatMessage((0, (0, parcelRequire("1iZKm")).default).goBackToProject))), (0, ($parcel$interopDefault($5uXOq))).createElement($63cc104529566fec$var$IllustrationWrapper, {
            src: (0, ($parcel$interopDefault($44Ege))),
            "aria-hidden": true
        })));
    };
    const $63cc104529566fec$var$PageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $63cc104529566fec$var$BodyWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsbweo2",
                __cmplp.className
            ])
        });
    });
    const $63cc104529566fec$var$DescriptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _u5f3xncg",
                __cmplp.className
            ])
        });
    });
    const $63cc104529566fec$var$IllustrationWrapper = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1obz",
                __cmplp.className
            ])
        });
    });
    const $63cc104529566fec$var$titleWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.200'
    });
    const $63cc104529566fec$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazaj1x _otyrpxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("44Ege", function(module, exports) {
    module.exports = new URL("lock_closed.80a15025.svg", import.meta.url).toString();
});
parcelRegister("1iZKm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c80056132f38396$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3c80056132f38396$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "spa-apps-software-reports-deployment-frequency-report.precondition.not-available-page.title",
            "defaultMessage": "Limited project permissions"
        },
        description: {
            "id": "spa-apps-software-reports-deployment-frequency-report.precondition.not-available-page.description",
            "defaultMessage": "You do not have permission to view this report. Contact admin for details."
        },
        goBackToProject: {
            "id": "spa-apps-software-reports-deployment-frequency-report.precondition.not-available-page.go-back-to-project",
            "defaultMessage": "Go back to project"
        }
    });
});
parcelRegister("8Gk6V", function(module, exports) {
    $parcel$export(module.exports, "isNetworkError", ()=>$c3d84cde46071772$export$476aa014e2fd89d5);
    const $c3d84cde46071772$var$ERROR_MESSAGE_CHROME = 'Failed to fetch';
    const $c3d84cde46071772$var$ERROR_MESSAGE_FIREFOX = 'NetworkError when attempting to fetch resource.';
    const $c3d84cde46071772$var$ERROR_MESSAGE_OTHER = 'Network request failed';
    const $c3d84cde46071772$var$NetworkErrorMessages = new Set([
        $c3d84cde46071772$var$ERROR_MESSAGE_CHROME,
        $c3d84cde46071772$var$ERROR_MESSAGE_FIREFOX,
        $c3d84cde46071772$var$ERROR_MESSAGE_OTHER
    ]);
    const $c3d84cde46071772$export$476aa014e2fd89d5 = (error)=>typeof error === 'object' && $c3d84cde46071772$var$NetworkErrorMessages.has(error.message.replace(/^Network error: (.*)/, '$1'));
});
